import { defineComponent as ke, inject as na, ref as R, computed as m, onMounted as kt, onBeforeUnmount as Tt, reactive as Bn, provide as wa, openBlock as u, createElementBlock as b, normalizeClass as C, renderSlot as Me, useId as Ye, toValue as Xt, watch as $e, readonly as l0, shallowRef as ko, onUpdated as Er, nextTick as Ze, Fragment as ie, createBlock as P, resolveDynamicComponent as gt, mergeProps as Ve, withKeys as St, withCtx as me, Teleport as Fa, unref as L, toDisplayString as H, createCommentVNode as w, createVNode as U, Transition as Wt, createTextVNode as st, createElementVNode as x, useSlots as Na, withModifiers as _e, normalizeStyle as Ge, useAttrs as rn, normalizeProps as ga, guardReactiveProps as ka, renderList as Oe, mergeDefaults as Lg, toHandlers as nl, h as gn, onUnmounted as zt, shallowReactive as o0, createStaticVNode as Ar, Comment as oc, Text as r0, getCurrentInstance as rc, watchEffect as Tg, markRaw as i0, customRef as s0, toRef as Ua, createSlots as Xa, withDirectives as wo, vModelText as Eg, onBeforeUpdate as d0, useModel as Ag, mergeModels as ou, vModelDynamic as u0, vShow as ic, useTemplateRef as hn, TransitionGroup as cr, isRef as vi, toRefs as Af, resolveComponent as c0 } from "vue";
const Rg = Symbol("AccordionContext"), zg = Symbol("AccordionItemContext"), f0 = ["data-accordion-root"], OU = /* @__PURE__ */ ke({
  __name: "Accordion",
  props: {
    variant: { default: "default" },
    size: { default: void 0 },
    multiple: { type: Boolean, default: void 0 },
    headingLevel: { default: void 0 }
  },
  setup(e) {
    const a = e, t = na(zg, null), n = R(), l = R(!!t), o = m(() => l.value && (t == null ? void 0 : t.variant.value) === "multi-level");
    let r;
    kt(() => {
      var p, y;
      l.value = !!t && !!((y = (p = n.value) == null ? void 0 : p.parentElement) != null && y.closest("[data-accordion-item]")), l.value && (r = t == null ? void 0 : t.registerChildAccordion());
    }), Tt(() => r == null ? void 0 : r());
    const i = m(() => o.value ? "multi-level" : a.variant), s = m(() => a.size ?? (o.value && t ? t.size.value : "md")), d = m(() => a.headingLevel ? a.headingLevel : l.value && t ? Math.min(t.headingLevel.value + 1, 6) : 3), c = m(
      () => a.multiple ?? !["separate-cards", "multi-level"].includes(i.value)
    ), f = Bn(/* @__PURE__ */ new Set());
    function g(p) {
      f.has(p) ? f.delete(p) : (c.value || f.clear(), f.add(p));
    }
    function h(p) {
      f.add(p);
    }
    wa(Rg, {
      variant: i,
      size: s,
      headingLevel: d,
      isChildLevel: o,
      openItems: f,
      toggleItem: g,
      openItem: h
    });
    const v = m(() => {
      if (o.value) return "";
      switch (i.value) {
        case "flush":
          return "";
        case "separate-cards":
          return "flex flex-col gap-3";
        default:
          return "border border-(--colors-border-base-soft) rounded-(--border-border-radius-rounded-l) overflow-hidden";
      }
    });
    return (p, y) => (u(), b("div", {
      ref_key: "rootEl",
      ref: n,
      class: C(v.value),
      "data-accordion-root": o.value ? void 0 : "",
      "data-testid": "accordion"
    }, [
      Me(p.$slots, "default")
    ], 10, f0));
  }
});
function Dg(e = {}) {
  const a = e.id ?? Ye(), t = `${a}-trigger`, n = `${a}-content`, l = R(!1), o = m(() => Xt(e.open) !== void 0), r = m(() => o.value ? Xt(e.open) : e.store ? e.store.isOpen() : l.value);
  kt(() => {
    o.value || !Xt(e.defaultOpen) || r.value || (e.store ? e.store.open() : l.value = !0);
  });
  const i = () => {
    var y;
    const p = !r.value;
    return o.value || (e.store ? e.store.toggle() : l.value = p), (y = e.onOpenChange) == null || y.call(e, p), p;
  }, s = R(!1), d = () => {
    var p;
    return typeof window < "u" && !!((p = window.matchMedia) != null && p.call(window, "(prefers-reduced-motion: reduce)").matches);
  };
  let c = !1;
  kt(() => requestAnimationFrame(() => c = !0)), $e(
    r,
    (p) => {
      s.value = p && (!c || d());
    },
    { immediate: !0 }
  );
  const f = (p) => {
    p.target === p.currentTarget && p.propertyName === "grid-template-rows" && r.value && (s.value = !0);
  }, g = m(() => ({
    id: t,
    "aria-expanded": r.value,
    "aria-controls": n
  })), h = m(() => ({
    id: n,
    role: "region",
    "aria-labelledby": t,
    "aria-hidden": !r.value,
    inert: !r.value || void 0
  })), v = m(() => [
    "accordion-content",
    { "accordion-content--expanded": r.value, "accordion-content--open": s.value }
  ]);
  return {
    id: a,
    triggerId: t,
    panelId: n,
    isOpen: r,
    isControlled: o,
    isFullyOpen: l0(s),
    toggle: i,
    onTransitionEnd: f,
    triggerProps: g,
    panelProps: h,
    panelClasses: v
  };
}
var Ta = "top", Za = "bottom", Qa = "right", Ea = "left", sc = "auto", Rr = [Ta, Za, Qa, Ea], io = "start", fr = "end", h0 = "clippingParents", Bg = "viewport", Eo = "popper", b0 = "reference", Rf = /* @__PURE__ */ Rr.reduce(function(e, a) {
  return e.concat([a + "-" + io, a + "-" + fr]);
}, []), Mg = /* @__PURE__ */ [].concat(Rr, [sc]).reduce(function(e, a) {
  return e.concat([a, a + "-" + io, a + "-" + fr]);
}, []), g0 = "beforeRead", m0 = "read", v0 = "afterRead", p0 = "beforeMain", x0 = "main", y0 = "afterMain", k0 = "beforeWrite", w0 = "write", C0 = "afterWrite", S0 = [g0, m0, v0, p0, x0, y0, k0, w0, C0];
function pn(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Oa(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var a = e.ownerDocument;
    return a && a.defaultView || window;
  }
  return e;
}
function zl(e) {
  var a = Oa(e).Element;
  return e instanceof a || e instanceof Element;
}
function Ka(e) {
  var a = Oa(e).HTMLElement;
  return e instanceof a || e instanceof HTMLElement;
}
function dc(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var a = Oa(e).ShadowRoot;
  return e instanceof a || e instanceof ShadowRoot;
}
function $0(e) {
  var a = e.state;
  Object.keys(a.elements).forEach(function(t) {
    var n = a.styles[t] || {}, l = a.attributes[t] || {}, o = a.elements[t];
    !Ka(o) || !pn(o) || (Object.assign(o.style, n), Object.keys(l).forEach(function(r) {
      var i = l[r];
      i === !1 ? o.removeAttribute(r) : o.setAttribute(r, i === !0 ? "" : i);
    }));
  });
}
function I0(e) {
  var a = e.state, t = {
    popper: {
      position: a.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(a.elements.popper.style, t.popper), a.styles = t, a.elements.arrow && Object.assign(a.elements.arrow.style, t.arrow), function() {
    Object.keys(a.elements).forEach(function(n) {
      var l = a.elements[n], o = a.attributes[n] || {}, r = Object.keys(a.styles.hasOwnProperty(n) ? a.styles[n] : t[n]), i = r.reduce(function(s, d) {
        return s[d] = "", s;
      }, {});
      !Ka(l) || !pn(l) || (Object.assign(l.style, i), Object.keys(o).forEach(function(s) {
        l.removeAttribute(s);
      }));
    });
  };
}
const L0 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: $0,
  effect: I0,
  requires: ["computeStyles"]
};
function mn(e) {
  return e.split("-")[0];
}
var Il = Math.max, Ti = Math.min, so = Math.round;
function ru() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(a) {
    return a.brand + "/" + a.version;
  }).join(" ") : navigator.userAgent;
}
function Og() {
  return !/^((?!chrome|android).)*safari/i.test(ru());
}
function uo(e, a, t) {
  a === void 0 && (a = !1), t === void 0 && (t = !1);
  var n = e.getBoundingClientRect(), l = 1, o = 1;
  a && Ka(e) && (l = e.offsetWidth > 0 && so(n.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && so(n.height) / e.offsetHeight || 1);
  var r = zl(e) ? Oa(e) : window, i = r.visualViewport, s = !Og() && t, d = (n.left + (s && i ? i.offsetLeft : 0)) / l, c = (n.top + (s && i ? i.offsetTop : 0)) / o, f = n.width / l, g = n.height / o;
  return {
    width: f,
    height: g,
    top: c,
    right: d + f,
    bottom: c + g,
    left: d,
    x: d,
    y: c
  };
}
function uc(e) {
  var a = uo(e), t = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(a.width - t) <= 1 && (t = a.width), Math.abs(a.height - n) <= 1 && (n = a.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: t,
    height: n
  };
}
function Pg(e, a) {
  var t = a.getRootNode && a.getRootNode();
  if (e.contains(a))
    return !0;
  if (t && dc(t)) {
    var n = a;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Mn(e) {
  return Oa(e).getComputedStyle(e);
}
function T0(e) {
  return ["table", "td", "th"].indexOf(pn(e)) >= 0;
}
function cl(e) {
  return ((zl(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function $s(e) {
  return pn(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (dc(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    cl(e)
  );
}
function zf(e) {
  return !Ka(e) || // https://github.com/popperjs/popper-core/issues/837
  Mn(e).position === "fixed" ? null : e.offsetParent;
}
function E0(e) {
  var a = /firefox/i.test(ru()), t = /Trident/i.test(ru());
  if (t && Ka(e)) {
    var n = Mn(e);
    if (n.position === "fixed")
      return null;
  }
  var l = $s(e);
  for (dc(l) && (l = l.host); Ka(l) && ["html", "body"].indexOf(pn(l)) < 0; ) {
    var o = Mn(l);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || a && o.willChange === "filter" || a && o.filter && o.filter !== "none")
      return l;
    l = l.parentNode;
  }
  return null;
}
function zr(e) {
  for (var a = Oa(e), t = zf(e); t && T0(t) && Mn(t).position === "static"; )
    t = zf(t);
  return t && (pn(t) === "html" || pn(t) === "body" && Mn(t).position === "static") ? a : t || E0(e) || a;
}
function cc(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Yo(e, a, t) {
  return Il(e, Ti(a, t));
}
function A0(e, a, t) {
  var n = Yo(e, a, t);
  return n > t ? t : n;
}
function Fg() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Ng(e) {
  return Object.assign({}, Fg(), e);
}
function Vg(e, a) {
  return a.reduce(function(t, n) {
    return t[n] = e, t;
  }, {});
}
var R0 = function(a, t) {
  return a = typeof a == "function" ? a(Object.assign({}, t.rects, {
    placement: t.placement
  })) : a, Ng(typeof a != "number" ? a : Vg(a, Rr));
};
function z0(e) {
  var a, t = e.state, n = e.name, l = e.options, o = t.elements.arrow, r = t.modifiersData.popperOffsets, i = mn(t.placement), s = cc(i), d = [Ea, Qa].indexOf(i) >= 0, c = d ? "height" : "width";
  if (!(!o || !r)) {
    var f = R0(l.padding, t), g = uc(o), h = s === "y" ? Ta : Ea, v = s === "y" ? Za : Qa, p = t.rects.reference[c] + t.rects.reference[s] - r[s] - t.rects.popper[c], y = r[s] - t.rects.reference[s], k = zr(o), $ = k ? s === "y" ? k.clientHeight || 0 : k.clientWidth || 0 : 0, S = p / 2 - y / 2, I = f[h], T = $ - g[c] - f[v], A = $ / 2 - g[c] / 2 + S, E = Yo(I, A, T), z = s;
    t.modifiersData[n] = (a = {}, a[z] = E, a.centerOffset = E - A, a);
  }
}
function D0(e) {
  var a = e.state, t = e.options, n = t.element, l = n === void 0 ? "[data-popper-arrow]" : n;
  l != null && (typeof l == "string" && (l = a.elements.popper.querySelector(l), !l) || Pg(a.elements.popper, l) && (a.elements.arrow = l));
}
const B0 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: z0,
  effect: D0,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function co(e) {
  return e.split("-")[1];
}
var M0 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function O0(e, a) {
  var t = e.x, n = e.y, l = a.devicePixelRatio || 1;
  return {
    x: so(t * l) / l || 0,
    y: so(n * l) / l || 0
  };
}
function Df(e) {
  var a, t = e.popper, n = e.popperRect, l = e.placement, o = e.variation, r = e.offsets, i = e.position, s = e.gpuAcceleration, d = e.adaptive, c = e.roundOffsets, f = e.isFixed, g = r.x, h = g === void 0 ? 0 : g, v = r.y, p = v === void 0 ? 0 : v, y = typeof c == "function" ? c({
    x: h,
    y: p
  }) : {
    x: h,
    y: p
  };
  h = y.x, p = y.y;
  var k = r.hasOwnProperty("x"), $ = r.hasOwnProperty("y"), S = Ea, I = Ta, T = window;
  if (d) {
    var A = zr(t), E = "clientHeight", z = "clientWidth";
    if (A === Oa(t) && (A = cl(t), Mn(A).position !== "static" && i === "absolute" && (E = "scrollHeight", z = "scrollWidth")), A = A, l === Ta || (l === Ea || l === Qa) && o === fr) {
      I = Za;
      var B = f && A === T && T.visualViewport ? T.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        A[E]
      );
      p -= B - n.height, p *= s ? 1 : -1;
    }
    if (l === Ea || (l === Ta || l === Za) && o === fr) {
      S = Qa;
      var W = f && A === T && T.visualViewport ? T.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        A[z]
      );
      h -= W - n.width, h *= s ? 1 : -1;
    }
  }
  var _ = Object.assign({
    position: i
  }, d && M0), Z = c === !0 ? O0({
    x: h,
    y: p
  }, Oa(t)) : {
    x: h,
    y: p
  };
  if (h = Z.x, p = Z.y, s) {
    var le;
    return Object.assign({}, _, (le = {}, le[I] = $ ? "0" : "", le[S] = k ? "0" : "", le.transform = (T.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + p + "px)" : "translate3d(" + h + "px, " + p + "px, 0)", le));
  }
  return Object.assign({}, _, (a = {}, a[I] = $ ? p + "px" : "", a[S] = k ? h + "px" : "", a.transform = "", a));
}
function P0(e) {
  var a = e.state, t = e.options, n = t.gpuAcceleration, l = n === void 0 ? !0 : n, o = t.adaptive, r = o === void 0 ? !0 : o, i = t.roundOffsets, s = i === void 0 ? !0 : i, d = {
    placement: mn(a.placement),
    variation: co(a.placement),
    popper: a.elements.popper,
    popperRect: a.rects.popper,
    gpuAcceleration: l,
    isFixed: a.options.strategy === "fixed"
  };
  a.modifiersData.popperOffsets != null && (a.styles.popper = Object.assign({}, a.styles.popper, Df(Object.assign({}, d, {
    offsets: a.modifiersData.popperOffsets,
    position: a.options.strategy,
    adaptive: r,
    roundOffsets: s
  })))), a.modifiersData.arrow != null && (a.styles.arrow = Object.assign({}, a.styles.arrow, Df(Object.assign({}, d, {
    offsets: a.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), a.attributes.popper = Object.assign({}, a.attributes.popper, {
    "data-popper-placement": a.placement
  });
}
const F0 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: P0,
  data: {}
};
var Hr = {
  passive: !0
};
function N0(e) {
  var a = e.state, t = e.instance, n = e.options, l = n.scroll, o = l === void 0 ? !0 : l, r = n.resize, i = r === void 0 ? !0 : r, s = Oa(a.elements.popper), d = [].concat(a.scrollParents.reference, a.scrollParents.popper);
  return o && d.forEach(function(c) {
    c.addEventListener("scroll", t.update, Hr);
  }), i && s.addEventListener("resize", t.update, Hr), function() {
    o && d.forEach(function(c) {
      c.removeEventListener("scroll", t.update, Hr);
    }), i && s.removeEventListener("resize", t.update, Hr);
  };
}
const V0 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: N0,
  data: {}
};
var H0 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function pi(e) {
  return e.replace(/left|right|bottom|top/g, function(a) {
    return H0[a];
  });
}
var j0 = {
  start: "end",
  end: "start"
};
function Bf(e) {
  return e.replace(/start|end/g, function(a) {
    return j0[a];
  });
}
function fc(e) {
  var a = Oa(e), t = a.pageXOffset, n = a.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: n
  };
}
function hc(e) {
  return uo(cl(e)).left + fc(e).scrollLeft;
}
function W0(e, a) {
  var t = Oa(e), n = cl(e), l = t.visualViewport, o = n.clientWidth, r = n.clientHeight, i = 0, s = 0;
  if (l) {
    o = l.width, r = l.height;
    var d = Og();
    (d || !d && a === "fixed") && (i = l.offsetLeft, s = l.offsetTop);
  }
  return {
    width: o,
    height: r,
    x: i + hc(e),
    y: s
  };
}
function q0(e) {
  var a, t = cl(e), n = fc(e), l = (a = e.ownerDocument) == null ? void 0 : a.body, o = Il(t.scrollWidth, t.clientWidth, l ? l.scrollWidth : 0, l ? l.clientWidth : 0), r = Il(t.scrollHeight, t.clientHeight, l ? l.scrollHeight : 0, l ? l.clientHeight : 0), i = -n.scrollLeft + hc(e), s = -n.scrollTop;
  return Mn(l || t).direction === "rtl" && (i += Il(t.clientWidth, l ? l.clientWidth : 0) - o), {
    width: o,
    height: r,
    x: i,
    y: s
  };
}
function bc(e) {
  var a = Mn(e), t = a.overflow, n = a.overflowX, l = a.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + l + n);
}
function Hg(e) {
  return ["html", "body", "#document"].indexOf(pn(e)) >= 0 ? e.ownerDocument.body : Ka(e) && bc(e) ? e : Hg($s(e));
}
function Jo(e, a) {
  var t;
  a === void 0 && (a = []);
  var n = Hg(e), l = n === ((t = e.ownerDocument) == null ? void 0 : t.body), o = Oa(n), r = l ? [o].concat(o.visualViewport || [], bc(n) ? n : []) : n, i = a.concat(r);
  return l ? i : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    i.concat(Jo($s(r)))
  );
}
function iu(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function U0(e, a) {
  var t = uo(e, !1, a === "fixed");
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Mf(e, a, t) {
  return a === Bg ? iu(W0(e, t)) : zl(a) ? U0(a, t) : iu(q0(cl(e)));
}
function G0(e) {
  var a = Jo($s(e)), t = ["absolute", "fixed"].indexOf(Mn(e).position) >= 0, n = t && Ka(e) ? zr(e) : e;
  return zl(n) ? a.filter(function(l) {
    return zl(l) && Pg(l, n) && pn(l) !== "body";
  }) : [];
}
function K0(e, a, t, n) {
  var l = a === "clippingParents" ? G0(e) : [].concat(a), o = [].concat(l, [t]), r = o[0], i = o.reduce(function(s, d) {
    var c = Mf(e, d, n);
    return s.top = Il(c.top, s.top), s.right = Ti(c.right, s.right), s.bottom = Ti(c.bottom, s.bottom), s.left = Il(c.left, s.left), s;
  }, Mf(e, r, n));
  return i.width = i.right - i.left, i.height = i.bottom - i.top, i.x = i.left, i.y = i.top, i;
}
function jg(e) {
  var a = e.reference, t = e.element, n = e.placement, l = n ? mn(n) : null, o = n ? co(n) : null, r = a.x + a.width / 2 - t.width / 2, i = a.y + a.height / 2 - t.height / 2, s;
  switch (l) {
    case Ta:
      s = {
        x: r,
        y: a.y - t.height
      };
      break;
    case Za:
      s = {
        x: r,
        y: a.y + a.height
      };
      break;
    case Qa:
      s = {
        x: a.x + a.width,
        y: i
      };
      break;
    case Ea:
      s = {
        x: a.x - t.width,
        y: i
      };
      break;
    default:
      s = {
        x: a.x,
        y: a.y
      };
  }
  var d = l ? cc(l) : null;
  if (d != null) {
    var c = d === "y" ? "height" : "width";
    switch (o) {
      case io:
        s[d] = s[d] - (a[c] / 2 - t[c] / 2);
        break;
      case fr:
        s[d] = s[d] + (a[c] / 2 - t[c] / 2);
        break;
    }
  }
  return s;
}
function hr(e, a) {
  a === void 0 && (a = {});
  var t = a, n = t.placement, l = n === void 0 ? e.placement : n, o = t.strategy, r = o === void 0 ? e.strategy : o, i = t.boundary, s = i === void 0 ? h0 : i, d = t.rootBoundary, c = d === void 0 ? Bg : d, f = t.elementContext, g = f === void 0 ? Eo : f, h = t.altBoundary, v = h === void 0 ? !1 : h, p = t.padding, y = p === void 0 ? 0 : p, k = Ng(typeof y != "number" ? y : Vg(y, Rr)), $ = g === Eo ? b0 : Eo, S = e.rects.popper, I = e.elements[v ? $ : g], T = K0(zl(I) ? I : I.contextElement || cl(e.elements.popper), s, c, r), A = uo(e.elements.reference), E = jg({
    reference: A,
    element: S,
    placement: l
  }), z = iu(Object.assign({}, S, E)), B = g === Eo ? z : A, W = {
    top: T.top - B.top + k.top,
    bottom: B.bottom - T.bottom + k.bottom,
    left: T.left - B.left + k.left,
    right: B.right - T.right + k.right
  }, _ = e.modifiersData.offset;
  if (g === Eo && _) {
    var Z = _[l];
    Object.keys(W).forEach(function(le) {
      var D = [Qa, Za].indexOf(le) >= 0 ? 1 : -1, O = [Ta, Za].indexOf(le) >= 0 ? "y" : "x";
      W[le] += Z[O] * D;
    });
  }
  return W;
}
function Y0(e, a) {
  a === void 0 && (a = {});
  var t = a, n = t.placement, l = t.boundary, o = t.rootBoundary, r = t.padding, i = t.flipVariations, s = t.allowedAutoPlacements, d = s === void 0 ? Mg : s, c = co(n), f = c ? i ? Rf : Rf.filter(function(v) {
    return co(v) === c;
  }) : Rr, g = f.filter(function(v) {
    return d.indexOf(v) >= 0;
  });
  g.length === 0 && (g = f);
  var h = g.reduce(function(v, p) {
    return v[p] = hr(e, {
      placement: p,
      boundary: l,
      rootBoundary: o,
      padding: r
    })[mn(p)], v;
  }, {});
  return Object.keys(h).sort(function(v, p) {
    return h[v] - h[p];
  });
}
function J0(e) {
  if (mn(e) === sc)
    return [];
  var a = pi(e);
  return [Bf(e), a, Bf(a)];
}
function X0(e) {
  var a = e.state, t = e.options, n = e.name;
  if (!a.modifiersData[n]._skip) {
    for (var l = t.mainAxis, o = l === void 0 ? !0 : l, r = t.altAxis, i = r === void 0 ? !0 : r, s = t.fallbackPlacements, d = t.padding, c = t.boundary, f = t.rootBoundary, g = t.altBoundary, h = t.flipVariations, v = h === void 0 ? !0 : h, p = t.allowedAutoPlacements, y = a.options.placement, k = mn(y), $ = k === y, S = s || ($ || !v ? [pi(y)] : J0(y)), I = [y].concat(S).reduce(function(ve, Se) {
      return ve.concat(mn(Se) === sc ? Y0(a, {
        placement: Se,
        boundary: c,
        rootBoundary: f,
        padding: d,
        flipVariations: v,
        allowedAutoPlacements: p
      }) : Se);
    }, []), T = a.rects.reference, A = a.rects.popper, E = /* @__PURE__ */ new Map(), z = !0, B = I[0], W = 0; W < I.length; W++) {
      var _ = I[W], Z = mn(_), le = co(_) === io, D = [Ta, Za].indexOf(Z) >= 0, O = D ? "width" : "height", N = hr(a, {
        placement: _,
        boundary: c,
        rootBoundary: f,
        altBoundary: g,
        padding: d
      }), V = D ? le ? Qa : Ea : le ? Za : Ta;
      T[O] > A[O] && (V = pi(V));
      var M = pi(V), Q = [];
      if (o && Q.push(N[Z] <= 0), i && Q.push(N[V] <= 0, N[M] <= 0), Q.every(function(ve) {
        return ve;
      })) {
        B = _, z = !1;
        break;
      }
      E.set(_, Q);
    }
    if (z)
      for (var q = v ? 3 : 1, K = function(Se) {
        var oe = I.find(function(re) {
          var ge = E.get(re);
          if (ge)
            return ge.slice(0, Se).every(function(de) {
              return de;
            });
        });
        if (oe)
          return B = oe, "break";
      }, G = q; G > 0; G--) {
        var te = K(G);
        if (te === "break") break;
      }
    a.placement !== B && (a.modifiersData[n]._skip = !0, a.placement = B, a.reset = !0);
  }
}
const Z0 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: X0,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Of(e, a, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: e.top - a.height - t.y,
    right: e.right - a.width + t.x,
    bottom: e.bottom - a.height + t.y,
    left: e.left - a.width - t.x
  };
}
function Pf(e) {
  return [Ta, Qa, Za, Ea].some(function(a) {
    return e[a] >= 0;
  });
}
function Q0(e) {
  var a = e.state, t = e.name, n = a.rects.reference, l = a.rects.popper, o = a.modifiersData.preventOverflow, r = hr(a, {
    elementContext: "reference"
  }), i = hr(a, {
    altBoundary: !0
  }), s = Of(r, n), d = Of(i, l, o), c = Pf(s), f = Pf(d);
  a.modifiersData[t] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: d,
    isReferenceHidden: c,
    hasPopperEscaped: f
  }, a.attributes.popper = Object.assign({}, a.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": f
  });
}
const _0 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Q0
};
function ey(e, a, t) {
  var n = mn(e), l = [Ea, Ta].indexOf(n) >= 0 ? -1 : 1, o = typeof t == "function" ? t(Object.assign({}, a, {
    placement: e
  })) : t, r = o[0], i = o[1];
  return r = r || 0, i = (i || 0) * l, [Ea, Qa].indexOf(n) >= 0 ? {
    x: i,
    y: r
  } : {
    x: r,
    y: i
  };
}
function ty(e) {
  var a = e.state, t = e.options, n = e.name, l = t.offset, o = l === void 0 ? [0, 0] : l, r = Mg.reduce(function(c, f) {
    return c[f] = ey(f, a.rects, o), c;
  }, {}), i = r[a.placement], s = i.x, d = i.y;
  a.modifiersData.popperOffsets != null && (a.modifiersData.popperOffsets.x += s, a.modifiersData.popperOffsets.y += d), a.modifiersData[n] = r;
}
const ay = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: ty
};
function ny(e) {
  var a = e.state, t = e.name;
  a.modifiersData[t] = jg({
    reference: a.rects.reference,
    element: a.rects.popper,
    placement: a.placement
  });
}
const ly = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: ny,
  data: {}
};
function oy(e) {
  return e === "x" ? "y" : "x";
}
function ry(e) {
  var a = e.state, t = e.options, n = e.name, l = t.mainAxis, o = l === void 0 ? !0 : l, r = t.altAxis, i = r === void 0 ? !1 : r, s = t.boundary, d = t.rootBoundary, c = t.altBoundary, f = t.padding, g = t.tether, h = g === void 0 ? !0 : g, v = t.tetherOffset, p = v === void 0 ? 0 : v, y = hr(a, {
    boundary: s,
    rootBoundary: d,
    padding: f,
    altBoundary: c
  }), k = mn(a.placement), $ = co(a.placement), S = !$, I = cc(k), T = oy(I), A = a.modifiersData.popperOffsets, E = a.rects.reference, z = a.rects.popper, B = typeof p == "function" ? p(Object.assign({}, a.rects, {
    placement: a.placement
  })) : p, W = typeof B == "number" ? {
    mainAxis: B,
    altAxis: B
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, B), _ = a.modifiersData.offset ? a.modifiersData.offset[a.placement] : null, Z = {
    x: 0,
    y: 0
  };
  if (A) {
    if (o) {
      var le, D = I === "y" ? Ta : Ea, O = I === "y" ? Za : Qa, N = I === "y" ? "height" : "width", V = A[I], M = V + y[D], Q = V - y[O], q = h ? -z[N] / 2 : 0, K = $ === io ? E[N] : z[N], G = $ === io ? -z[N] : -E[N], te = a.elements.arrow, ve = h && te ? uc(te) : {
        width: 0,
        height: 0
      }, Se = a.modifiersData["arrow#persistent"] ? a.modifiersData["arrow#persistent"].padding : Fg(), oe = Se[D], re = Se[O], ge = Yo(0, E[N], ve[N]), de = S ? E[N] / 2 - q - ge - oe - W.mainAxis : K - ge - oe - W.mainAxis, Ee = S ? -E[N] / 2 + q + ge + re + W.mainAxis : G + ge + re + W.mainAxis, j = a.elements.arrow && zr(a.elements.arrow), J = j ? I === "y" ? j.clientTop || 0 : j.clientLeft || 0 : 0, ne = (le = _ == null ? void 0 : _[I]) != null ? le : 0, Y = V + de - ne - J, F = V + Ee - ne, ee = Yo(h ? Ti(M, Y) : M, V, h ? Il(Q, F) : Q);
      A[I] = ee, Z[I] = ee - V;
    }
    if (i) {
      var ue, se = I === "x" ? Ta : Ea, X = I === "x" ? Za : Qa, ae = A[T], Re = T === "y" ? "height" : "width", Ae = ae + y[se], xe = ae - y[X], we = [Ta, Ea].indexOf(k) !== -1, fe = (ue = _ == null ? void 0 : _[T]) != null ? ue : 0, Ne = we ? Ae : ae - E[Re] - z[Re] - fe + W.altAxis, De = we ? ae + E[Re] + z[Re] - fe - W.altAxis : xe, qe = h && we ? A0(Ne, ae, De) : Yo(h ? Ne : Ae, ae, h ? De : xe);
      A[T] = qe, Z[T] = qe - ae;
    }
    a.modifiersData[n] = Z;
  }
}
const iy = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: ry,
  requiresIfExists: ["offset"]
};
function sy(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function dy(e) {
  return e === Oa(e) || !Ka(e) ? fc(e) : sy(e);
}
function uy(e) {
  var a = e.getBoundingClientRect(), t = so(a.width) / e.offsetWidth || 1, n = so(a.height) / e.offsetHeight || 1;
  return t !== 1 || n !== 1;
}
function cy(e, a, t) {
  t === void 0 && (t = !1);
  var n = Ka(a), l = Ka(a) && uy(a), o = cl(a), r = uo(e, l, t), i = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (n || !n && !t) && ((pn(a) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  bc(o)) && (i = dy(a)), Ka(a) ? (s = uo(a, !0), s.x += a.clientLeft, s.y += a.clientTop) : o && (s.x = hc(o))), {
    x: r.left + i.scrollLeft - s.x,
    y: r.top + i.scrollTop - s.y,
    width: r.width,
    height: r.height
  };
}
function fy(e) {
  var a = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(o) {
    a.set(o.name, o);
  });
  function l(o) {
    t.add(o.name);
    var r = [].concat(o.requires || [], o.requiresIfExists || []);
    r.forEach(function(i) {
      if (!t.has(i)) {
        var s = a.get(i);
        s && l(s);
      }
    }), n.push(o);
  }
  return e.forEach(function(o) {
    t.has(o.name) || l(o);
  }), n;
}
function hy(e) {
  var a = fy(e);
  return S0.reduce(function(t, n) {
    return t.concat(a.filter(function(l) {
      return l.phase === n;
    }));
  }, []);
}
function by(e) {
  var a;
  return function() {
    return a || (a = new Promise(function(t) {
      Promise.resolve().then(function() {
        a = void 0, t(e());
      });
    })), a;
  };
}
function gy(e) {
  var a = e.reduce(function(t, n) {
    var l = t[n.name];
    return t[n.name] = l ? Object.assign({}, l, n, {
      options: Object.assign({}, l.options, n.options),
      data: Object.assign({}, l.data, n.data)
    }) : n, t;
  }, {});
  return Object.keys(a).map(function(t) {
    return a[t];
  });
}
var Ff = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Nf() {
  for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++)
    a[t] = arguments[t];
  return !a.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function my(e) {
  e === void 0 && (e = {});
  var a = e, t = a.defaultModifiers, n = t === void 0 ? [] : t, l = a.defaultOptions, o = l === void 0 ? Ff : l;
  return function(i, s, d) {
    d === void 0 && (d = o);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ff, o),
      modifiersData: {},
      elements: {
        reference: i,
        popper: s
      },
      attributes: {},
      styles: {}
    }, f = [], g = !1, h = {
      state: c,
      setOptions: function(k) {
        var $ = typeof k == "function" ? k(c.options) : k;
        p(), c.options = Object.assign({}, o, c.options, $), c.scrollParents = {
          reference: zl(i) ? Jo(i) : i.contextElement ? Jo(i.contextElement) : [],
          popper: Jo(s)
        };
        var S = hy(gy([].concat(n, c.options.modifiers)));
        return c.orderedModifiers = S.filter(function(I) {
          return I.enabled;
        }), v(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var k = c.elements, $ = k.reference, S = k.popper;
          if (Nf($, S)) {
            c.rects = {
              reference: cy($, zr(S), c.options.strategy === "fixed"),
              popper: uc(S)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(W) {
              return c.modifiersData[W.name] = Object.assign({}, W.data);
            });
            for (var I = 0; I < c.orderedModifiers.length; I++) {
              if (c.reset === !0) {
                c.reset = !1, I = -1;
                continue;
              }
              var T = c.orderedModifiers[I], A = T.fn, E = T.options, z = E === void 0 ? {} : E, B = T.name;
              typeof A == "function" && (c = A({
                state: c,
                options: z,
                name: B,
                instance: h
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: by(function() {
        return new Promise(function(y) {
          h.forceUpdate(), y(c);
        });
      }),
      destroy: function() {
        p(), g = !0;
      }
    };
    if (!Nf(i, s))
      return h;
    h.setOptions(d).then(function(y) {
      !g && d.onFirstUpdate && d.onFirstUpdate(y);
    });
    function v() {
      c.orderedModifiers.forEach(function(y) {
        var k = y.name, $ = y.options, S = $ === void 0 ? {} : $, I = y.effect;
        if (typeof I == "function") {
          var T = I({
            state: c,
            name: k,
            instance: h,
            options: S
          }), A = function() {
          };
          f.push(T || A);
        }
      });
    }
    function p() {
      f.forEach(function(y) {
        return y();
      }), f = [];
    }
    return h;
  };
}
var vy = [V0, ly, F0, L0, ay, Z0, iy, B0, _0], fl = /* @__PURE__ */ my({
  defaultModifiers: vy
});
const fo = [];
function xn(e) {
  fo.includes(e) || fo.push(e);
}
function _a(e) {
  const a = fo.indexOf(e);
  a !== -1 && fo.splice(a, 1);
}
function On(e) {
  return fo[fo.length - 1] === e;
}
const nn = ko([]);
let Wg = "";
function py(e) {
  nn.value.includes(e) || (nn.value.length === 0 && (Wg = document.body.style.overflow, document.body.style.overflow = "hidden"), nn.value = [...nn.value, e]);
}
function Vf(e) {
  nn.value.includes(e) && (nn.value = nn.value.filter((a) => a !== e), nn.value.length === 0 && (document.body.style.overflow = Wg));
}
const qg = {
  top: ["bottom"],
  bottom: ["top"],
  left: ["right", "top", "bottom"],
  right: ["left", "top", "bottom"]
}, Ug = 8, yn = [
  "a[href]",
  "area[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "iframe",
  "object",
  "embed",
  "[contenteditable]",
  "[tabindex]:not([tabindex^='-'])"
].join(",");
function qn(e) {
  const a = Array.from(e.querySelectorAll(yn)).filter(
    (n) => n.offsetParent !== null && Gg(n)
  ), t = xy(a);
  return a.filter((n) => !Ei(n) || t.has(n));
}
function Ei(e) {
  return e instanceof HTMLInputElement && e.type === "radio" && e.name !== "";
}
function su(e) {
  return e.form ?? e.getRootNode();
}
function Hf(e, a) {
  return e === a ? !0 : !e || !Ei(e) || !Ei(a) ? !1 : e.name === a.name && su(e) === su(a);
}
function xy(e) {
  const a = /* @__PURE__ */ new Map();
  for (const n of e) {
    if (!Ei(n)) continue;
    const l = su(n), o = a.get(l) ?? /* @__PURE__ */ new Map();
    o.set(n.name, [...o.get(n.name) ?? [], n]), a.set(l, o);
  }
  const t = /* @__PURE__ */ new Set();
  for (const n of a.values())
    for (const l of n.values()) t.add(l.find((o) => o.checked) ?? l[0]);
  return t;
}
function Gg(e) {
  if (e.hasAttribute("disabled")) return !1;
  const a = e.getAttribute("tabindex");
  return a === null || !a.startsWith("-");
}
function yy(e) {
  return Array.from(e.querySelectorAll(yn)).filter(
    (a) => {
      var t;
      return (((t = a.checkVisibility) == null ? void 0 : t.call(a)) ?? !0) && Gg(a);
    }
  );
}
const du = "[data-focus-trap-allow-outside]", ky = "data-focus-trap-return";
function jf(e) {
  return e instanceof Element && e.closest(du) !== null;
}
const Ao = [];
function Is(e) {
  const {
    active: a,
    container: t,
    autoFocus: n = !0,
    restoreFocus: l = !0,
    restoreFocusTo: o,
    containFocus: r = !1,
    allowOutsideElements: i
  } = e, s = Symbol("focus-trap");
  let d = null, c = null, f = null;
  const g = () => Ao[Ao.length - 1] === s;
  function h(A) {
    if (!g() || A.key !== "Tab" || !t.value) return;
    if (!t.value.contains(document.activeElement) && jf(document.activeElement)) {
      if (A.shiftKey) return;
      const _ = document.activeElement.closest(
        du
      ), Z = _ ? qn(_) : [];
      if (!(Z.length === 0 || document.activeElement === Z[Z.length - 1])) return;
      const D = qn(t.value);
      if (D.length === 0) {
        A.preventDefault();
        return;
      }
      const O = f ? D.indexOf(f) : -1;
      A.preventDefault(), D[O === -1 ? 0 : (O + 1) % D.length].focus();
      return;
    }
    const E = qn(t.value);
    if (E.length === 0) {
      A.preventDefault();
      return;
    }
    const z = E[0], B = E[E.length - 1], W = document.activeElement;
    A.shiftKey ? (Hf(W, z) || !t.value.contains(W)) && (A.preventDefault(), B.focus()) : Hf(W, B) && (A.preventDefault(), z.focus());
  }
  function v() {
    var A;
    t.value && ((A = qn(t.value)[0]) == null || A.focus({ preventScroll: !0 }));
  }
  function p(A) {
    if (!g() || !t.value) return;
    const E = A.target;
    E && t.value.contains(E) && (f = E);
  }
  function y(A) {
    return jf(A) ? !0 : i ? i().some((E) => E && A && E.contains(A)) : !1;
  }
  function k(A) {
    if (!g() || !t.value) return;
    const E = A.target;
    E && t.value.contains(E) || y(E) || v();
  }
  function $(A) {
    !g() || A.relatedTarget !== null || requestAnimationFrame(() => {
      !a.value || !g() || !t.value || t.value.contains(document.activeElement) || y(document.activeElement) || v();
    });
  }
  function S() {
    r && (document.addEventListener("focusin", k), document.addEventListener("focusout", $));
  }
  function I() {
    document.removeEventListener("focusin", k), document.removeEventListener("focusout", $);
  }
  function T() {
    const A = Ao.indexOf(s);
    A !== -1 && Ao.splice(A, 1);
  }
  $e(a, (A) => {
    var E;
    if (A)
      Ao.push(s), d = document.activeElement, c = ((E = d == null ? void 0 : d.closest(du)) == null ? void 0 : E.getAttribute(ky)) ?? null, document.addEventListener("keydown", h), document.addEventListener("focusin", p), S(), n && requestAnimationFrame(() => {
        var B;
        if (!t.value || t.value.contains(document.activeElement) || y(document.activeElement)) return;
        (B = qn(t.value)[0]) == null || B.focus();
      });
    else if (T(), document.removeEventListener("keydown", h), I(), document.removeEventListener("focusin", p), f = null, l) {
      const z = (d == null ? void 0 : d.isConnected) === !1 && c ? document.getElementById(c) : null, B = (o == null ? void 0 : o()) ?? z ?? d;
      B == null || B.focus(), d = null, c = null;
    }
  }, { immediate: !0 }), Tt(() => {
    T(), document.removeEventListener("keydown", h), I(), document.removeEventListener("focusin", p);
  });
}
const wy = ["id"], Cy = 100, Sy = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "Tooltip",
  props: {
    text: {},
    position: { default: "top" },
    delay: { default: 300 },
    disabled: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    as: { default: "div" },
    labelsTrigger: { type: Boolean, default: !1 }
  },
  setup(e, { expose: a }) {
    const t = e, n = Ye(), l = R(null), o = R(null), r = R(null), i = R(!1), s = m(() => t.disabled ? !1 : t.open !== void 0 ? t.open : i.value);
    let d = null, c = null, f = null, g = null;
    const h = (le) => {
      if (le.nodeType === Node.TEXT_NODE) return le.textContent ?? "";
      if (!(le instanceof Element) || le.getAttribute("aria-hidden") === "true") return "";
      const D = le.getAttribute("aria-label");
      return D !== null ? D : [...le.childNodes].map(h).join(" ");
    }, v = () => {
      const le = l.value;
      if (!le) return null;
      const O = le.hasAttribute("tabindex") && le.getAttribute("tabindex") !== "-1" ? le : le.querySelector(yn) ?? le, N = (M) => M.trim().replace(/\s+/g, " ").toLowerCase(), V = O.getAttribute("aria-label") ?? [...O.childNodes].map(h).join(" ");
      return N(V) === N(t.text) ? null : O;
    }, p = (le) => {
      const D = (le.getAttribute("aria-describedby") ?? "").split(/\s+/).filter(Boolean);
      D.includes(n) || le.setAttribute("aria-describedby", [...D, n].join(" ")), g = le;
    }, y = () => {
      if (!g) return;
      const le = (g.getAttribute("aria-describedby") ?? "").split(/\s+/).filter((D) => D && D !== n);
      le.length ? g.setAttribute("aria-describedby", le.join(" ")) : g.removeAttribute("aria-describedby"), g = null;
    }, k = m(
      () => !t.labelsTrigger && !t.disabled && (t.open === void 0 || t.open)
    ), $ = () => {
      const le = k.value ? v() : null;
      le !== g && y(), le && p(le);
    };
    kt($), Er($), $e(k, $, { flush: "post" });
    const S = Symbol("tooltip"), I = (le) => {
      le.key !== "Escape" || le.defaultPrevented || On(S) && Z(le);
    }, T = () => {
      document.removeEventListener("keydown", I), _a(S);
    }, A = m(() => s.value && t.open === void 0);
    $e(A, (le) => {
      le ? (xn(S), document.addEventListener("keydown", I)) : T();
    });
    const E = () => {
      d == null || d.destroy(), d = null;
    };
    $e(s, async (le) => {
      le && (await Ze(), l.value && o.value && (E(), d = fl(l.value, o.value, {
        // Fixed keeps the tooltip in the viewport layer so it does not expand
        // document scroll width/height (avoids double scrollbars with nested overflow:auto regions).
        strategy: "fixed",
        placement: t.position,
        modifiers: [
          {
            name: "offset",
            options: { offset: [0, 8] }
          },
          {
            name: "arrow",
            // Own class and an element ref, not the conventional `[data-popper-arrow]` /
            // `.tooltip-arrow` hooks: no global stylesheet aimed at those names can hide or redraw it.
            // Padding keeps the arrow off the corners when the bubble is shifted. At most
            // (36px one-line height - 16px arrow) / 2, or Popper pushes a left/right arrow off-centre.
            options: { element: r.value, padding: 10 }
          },
          {
            // Reflow at 320px (RGAA 10.11): when neither side has room, a left/right bubble moves
            // above or below instead of leaving the viewport.
            name: "flip",
            options: { fallbackPlacements: qg[t.position] }
          },
          {
            name: "preventOverflow",
            options: { padding: Ug }
          }
        ]
      })));
    }, { immediate: !0 });
    const z = () => {
      f && (clearTimeout(f), f = null);
    }, B = () => {
      t.disabled || (z(), !(c || i.value) && (c = setTimeout(() => {
        i.value = !0, c = null;
      }, t.delay)));
    }, W = () => {
      c && (clearTimeout(c), c = null), z(), i.value = !1;
    };
    $e(
      () => t.disabled,
      (le) => {
        var D;
        le ? W() : (D = l.value) != null && D.contains(document.activeElement) && B();
      }
    );
    const _ = () => {
      c && (clearTimeout(c), c = null), i.value && (z(), f = setTimeout(() => {
        i.value = !1, f = null;
      }, Cy));
    }, Z = (le) => {
      t.open !== void 0 || !s.value || (le.stopPropagation(), le.preventDefault(), W());
    };
    return a({ isVisible: s, hide: W }), Tt(() => {
      c && clearTimeout(c), f && clearTimeout(f), T(), y(), E();
    }), (le, D) => (u(), b(ie, null, [
      (u(), P(gt(e.as), Ve({
        ref_key: "triggerRef",
        ref: l,
        class: "inline-flex"
      }, le.$attrs, {
        onMouseenter: B,
        onMouseleave: _,
        onFocusin: B,
        onFocusout: W,
        onKeydown: St(Z, ["escape"])
      }), {
        default: me(() => [
          Me(le.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 16)),
      (u(), P(Fa, { to: "body" }, [
        e.labelsTrigger ? w("", !0) : (u(), b("span", {
          key: 0,
          id: L(n),
          hidden: ""
        }, H(e.text), 9, wy)),
        U(Wt, {
          name: "tooltip",
          onAfterLeave: E
        }, {
          default: me(() => [
            s.value ? (u(), b("div", {
              key: 0,
              ref_key: "bubbleRef",
              ref: o,
              role: "tooltip",
              class: "tooltip-bubble fixed z-9999 rounded-(--border-border-radius-rounded-l) shadow-(--shadow-m) min-w-33.5 max-w-50 py-2 px-3 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) wrap-break-word",
              onMouseenter: z,
              onMouseleave: _
            }, [
              st(H(e.text) + " ", 1),
              x("div", {
                ref_key: "arrowRef",
                ref: r,
                class: "tooltip-pointer",
                "aria-hidden": "true"
              }, [...D[0] || (D[0] = [
                x("svg", {
                  width: "16",
                  height: "8",
                  viewBox: "0 0 16 8"
                }, [
                  x("path", { d: "M0 0L6.59 6.59A2 2 0 0 0 9.41 6.59L16 0Z" })
                ], -1)
              ])], 512)
            ], 544)) : w("", !0)
          ]),
          _: 1
        })
      ]))
    ], 64));
  }
}), Ct = (e, a) => {
  const t = e.__vccOpts || e;
  for (const [n, l] of a)
    t[n] = l;
  return t;
}, $t = /* @__PURE__ */ Ct(Sy, [["__scopeId", "data-v-82534dc2"]]);
function $y(e, a, t = "horizontal") {
  const n = R(!1);
  let l = null;
  function o() {
    const r = e.value;
    n.value = !!r && (t === "vertical" ? r.scrollHeight > r.clientHeight : r.scrollWidth > r.offsetWidth);
  }
  return $e(
    e,
    (r) => {
      if (l == null || l.disconnect(), l = null, !r) {
        n.value = !1;
        return;
      }
      typeof ResizeObserver < "u" && (l = new ResizeObserver(o), l.observe(r)), o();
    },
    { flush: "post" }
  ), $e(a, o, { flush: "post" }), Tt(() => {
    l == null || l.disconnect(), l = null;
  }), { isTruncated: n };
}
const Iy = ["id", "aria-hidden"], Ly = ["id", "aria-hidden"], it = /* @__PURE__ */ ke({
  __name: "TruncatedText",
  props: {
    text: {},
    lines: { default: 1 },
    textClass: { default: "" },
    position: { default: "top" },
    focusable: { type: Boolean, default: !0 },
    open: { type: Boolean, default: void 0 }
  },
  setup(e, { expose: a }) {
    const t = e, n = R(null), { isTruncated: l } = $y(
      n,
      () => t.text,
      t.lines > 1 ? "vertical" : "horizontal"
    ), o = t.lines > 1 ? "line-clamp-2 break-words" : "truncate", r = R(!1), i = m(() => t.focusable && (l.value || r.value)), s = Ye(), d = Ye(), c = Na();
    return a({ isTruncated: l, isTabStop: i }), (f, g) => (u(), P($t, {
      as: "span",
      class: "w-full min-w-0 rounded-xs focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-accent)",
      text: e.text,
      position: e.position,
      disabled: !L(l),
      open: e.open,
      "labels-trigger": "",
      tabindex: i.value ? 0 : void 0,
      role: i.value ? "group" : void 0,
      "aria-labelledby": i.value ? L(c).default ? `${L(s)} ${L(d)}` : L(s) : void 0,
      onFocusin: g[0] || (g[0] = (h) => r.value = !0),
      onFocusout: g[1] || (g[1] = (h) => r.value = !1)
    }, {
      default: me(() => [
        x("span", {
          id: L(s),
          ref_key: "textEl",
          ref: n,
          "data-testid": "truncated-text",
          "aria-hidden": i.value ? "true" : void 0,
          class: C(["w-full min-w-0", L(o), e.textClass])
        }, H(e.text), 11, Iy),
        L(c).default ? (u(), b("span", {
          key: 0,
          id: L(d),
          "aria-hidden": i.value ? "true" : void 0
        }, [
          Me(f.$slots, "default")
        ], 8, Ly)) : w("", !0)
      ]),
      _: 3
    }, 8, ["text", "position", "disabled", "open", "tabindex", "role", "aria-labelledby"]));
  }
}), Ty = ["src"], Wf = /* @__PURE__ */ ke({
  __name: "AvatarCircle",
  props: {
    img: {},
    name: {},
    label: {},
    size: {},
    entity: {},
    avatarStyle: {},
    logo: { type: Boolean },
    presentational: { type: Boolean },
    as: {},
    imageError: { type: Boolean }
  },
  emits: ["image-error"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = {
      // 3xs / 2xs: Badge only. Figma shows them with a picture; initials and square radius keep the xs values.
      "3xs": { container: "h-3 w-3", text: "text-(length:--size-2xs) leading-(--line-height-xs)" },
      "2xs": { container: "h-3.5 w-3.5", text: "text-(length:--size-2xs) leading-(--line-height-xs)" },
      xs: { container: "h-[18px] w-[18px]", text: "text-(length:--size-2xs) leading-(--line-height-s)" },
      sm: { container: "h-6 w-6", text: "text-(length:--size-sm) leading-(--line-height-l)" },
      md: { container: "h-9 w-9", text: "text-(length:--size-m) leading-(--line-height-l)" },
      lg: { container: "h-11 w-11", text: "text-(length:--size-xl) leading-(--line-height-xxl)" },
      xl: { container: "h-14 w-14", text: "text-(length:--size-xxl) leading-(--line-height-xxl)" },
      "2xl": { container: "h-16 w-16", text: "text-(length:--size-4xl) leading-(--line-height-xxl)" }
    }, o = m(() => l[t.size]), r = {
      "3xs": "rounded-(--border-border-radius-rounded-xs)",
      "2xs": "rounded-(--border-border-radius-rounded-xs)",
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-xs)",
      md: "rounded-(--border-border-radius-rounded-sm)",
      lg: "rounded-(--border-border-radius-rounded-sm)",
      xl: "rounded-(--border-border-radius-rounded-l)",
      "2xl": "rounded-(--border-border-radius-rounded-l)"
    }, i = m(() => t.logo && !!t.img && !t.imageError), s = m(
      () => i.value ? "avatar-container--logo bg-(--background-background-white)" : (
        // Figma "Avatar gradient" (4230:55188) as CSS: its gradientTransform is skewed, so the
        // colour runs at 85deg with stops at 10.83 % / 86.95 % (the 138deg handle line is not it).
        "bg-[linear-gradient(85deg,var(--colors-avatar-gradient-start)_10.83%,var(--colors-avatar-gradient-end)_86.95%)]"
      )
    ), d = m(
      () => t.avatarStyle === "square" ? r[t.size] : "rounded-full"
    ), c = (g) => g.normalize("NFD").replace(/[\u0300-\u036f]/g, "").charAt(0).toUpperCase(), f = m(() => {
      var p;
      const g = (p = t.name) == null ? void 0 : p.trim();
      if (!g)
        return "?";
      const h = g.split(/\s+/), v = t.entity === "organisation" ? 1 : 2;
      return h.slice(0, v).map(c).join("");
    });
    return (g, h) => (u(), P(gt(t.as), {
      class: C(["avatar-container flex shrink-0 items-center justify-center overflow-hidden", [o.value.container, d.value, s.value]]),
      role: e.presentational ? void 0 : "img",
      "aria-hidden": e.presentational ? "true" : void 0,
      "aria-label": e.presentational ? void 0 : t.label
    }, {
      default: me(() => [
        t.img && !t.imageError ? (u(), b("img", {
          key: 0,
          src: t.img,
          alt: "",
          class: C(["h-full w-full", t.logo ? "object-contain" : "object-cover"]),
          loading: "lazy",
          onError: h[0] || (h[0] = (v) => n("image-error"))
        }, null, 42, Ty)) : (u(), b("span", {
          key: 1,
          "aria-hidden": "true",
          class: C(["font-(--weight-medium) text-(--text-text-body-subtle)", o.value.text])
        }, H(f.value), 3))
      ]),
      _: 1
    }, 8, ["class", "role", "aria-hidden", "aria-label"]));
  }
}), Ey = ["aria-label"], Ay = ["aria-label", "aria-disabled"], qf = "text-(length:--icon-size-xs)", _s = "text-(length:--size-sm)", Uf = "text-(length:--icon-size-2xs)", Ry = "text-(length:--size-2xs)", Gf = "absolute flex cursor-pointer items-center justify-center rounded-full focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l) before:absolute before:left-1/2 before:top-1/2 before:size-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']", Jt = /* @__PURE__ */ ke({
  __name: "Avatar",
  props: {
    img: { default: void 0 },
    name: {},
    email: { default: void 0 },
    size: { default: "md" },
    entity: { default: "contact" },
    avatarStyle: { default: "circle" },
    logo: { type: Boolean, default: !1 },
    presentational: { type: Boolean, default: !1 },
    as: { default: "div" },
    status: { default: void 0 },
    statusLabel: { default: void 0 },
    removable: { type: Boolean, default: !1 },
    removeLabel: { default: void 0 },
    editable: { type: Boolean, default: !1 },
    editLabel: { default: void 0 },
    editDisabled: { type: Boolean, default: !1 }
  },
  emits: ["remove", "edit"],
  setup(e, { emit: a }) {
    var k;
    const t = ($) => $ !== "3xs" && $ !== "2xs", n = e, l = a, o = R(!1);
    $e(
      () => n.img,
      () => {
        o.value = !1;
      }
    );
    const r = m(() => !t(n.size)), i = m(
      () => !r.value && (!!n.status || n.removable || n.editable)
    ), s = m(() => t(n.size) ? n.size : "xs"), d = m(
      () => {
        var $;
        return n.status && !r.value ? ($ = n.statusLabel) == null ? void 0 : $.trim() : void 0;
      }
    ), c = m(
      () => {
        var $;
        return [($ = n.name) == null ? void 0 : $.trim(), d.value].filter(Boolean).join(", ") || n.name;
      }
    ), f = m(() => ({
      img: n.img,
      name: n.name,
      label: c.value,
      size: n.size,
      entity: n.entity,
      avatarStyle: n.avatarStyle,
      logo: n.logo,
      presentational: n.presentational,
      imageError: o.value
    })), g = {
      online: "bg-(--icons-icon-success-subtle)",
      offline: "bg-(--icons-icon-error)",
      alternative: "bg-(--icons-icon-disabled-strong)"
    }, h = {
      xs: "size-1.5 top-[1px] -right-[2px]",
      sm: "size-2 top-[1px] -right-[2px]",
      md: "size-3 top-[1px] right-[1px]",
      lg: "size-3 top-[4px] -right-[3px]",
      xl: "size-4 top-[2px] -right-[2px]",
      "2xl": "size-4 top-[4px] -right-[1px]"
    }, v = {
      xs: { button: "size-3.5 -top-[2px] -right-[8px]", icon: Uf },
      sm: { button: "size-3.5 -top-[2px] -right-[6px]", icon: Uf },
      md: { button: "size-4 top-0 -right-[4px]", icon: _s },
      lg: { button: "size-4 top-[3px] -right-[6px]", icon: _s },
      xl: { button: "size-5 top-[1px] -right-[6px]", icon: qf },
      "2xl": { button: "size-5 top-[3px] -right-[5px]", icon: qf }
    }, p = {
      ...v,
      xs: { button: "size-3 -top-[2px] -right-[6px]", icon: Ry },
      md: { button: "size-4 top-0 -right-[2px]", icon: _s }
    };
    return typeof process < "u" && ((k = process.env) == null ? void 0 : k.NODE_ENV) !== "production" && $e(
      () => [
        n.status,
        n.statusLabel,
        n.removable,
        n.removeLabel,
        n.editable,
        n.editLabel,
        n.presentational,
        n.as,
        n.size
      ],
      () => {
        var S, I, T;
        const $ = (A) => console.warn(`[OPAL Avatar] ${A}`);
        n.status && !((S = n.statusLabel) != null && S.trim()) && $("`status` is set without `statusLabel`: assistive tech gets no presence text (WCAG 1.1.1 / 4.1.2)."), n.removable && !((I = n.removeLabel) != null && I.trim()) && $("`removable` is set without `removeLabel`: the remove button has no accessible name."), n.editable && !((T = n.editLabel) != null && T.trim()) && $("`editable` is set without `editLabel`: the edit button has no accessible name."), r.value && (n.status || n.removable || n.editable) && $(`size "${n.size}" shows no status dot, remove or edit button.`), n.removable && n.editable && $("`removable` and `editable` are both set; they share the same corner. Use one."), (n.removable || n.editable) && (n.presentational || n.as === "span") && $(
          '`removable`/`editable` with `presentational` or `as="span"` means the avatar sits inside another control: its buttons would be nested inside that control.'
        );
      },
      { immediate: !0 }
    ), ($, S) => i.value ? (u(), P(gt(e.as), {
      key: 1,
      class: "relative flex w-fit shrink-0"
    }, {
      default: me(() => [
        U(Wf, Ve(f.value, {
          as: e.as === "span" ? "span" : "div",
          onImageError: S[1] || (S[1] = (I) => o.value = !0)
        }), null, 16, ["as"]),
        e.status ? (u(), b("span", {
          key: 0,
          class: C(["absolute rounded-full", [g[e.status], h[s.value]]]),
          "aria-hidden": "true",
          "data-testid": "avatar-status"
        }, null, 2)) : w("", !0),
        e.removable ? (u(), b("button", {
          key: 1,
          type: "button",
          class: C([
            Gf,
            v[s.value].button,
            "bg-(--background-background-gray) text-(--icons-icon-dark-default)"
          ]),
          "aria-label": e.removeLabel,
          "data-testid": "avatar-remove",
          onClick: S[2] || (S[2] = _e((I) => l("remove"), ["stop"]))
        }, [
          x("i", {
            class: C(["ri-close-fill", v[s.value].icon]),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, Ey)) : w("", !0),
        e.editable ? (u(), b("button", {
          key: 2,
          type: "button",
          class: C([
            Gf,
            p[s.value].button,
            "border border-(--border-border-white-full) bg-(--background-background-white)",
            e.editDisabled ? "cursor-not-allowed text-(--icons-icon-disabled-strong)" : "text-(--icons-icon-dark-default) hover:border-transparent hover:text-(--icons-icon-hover)"
          ]),
          "aria-label": e.editLabel,
          "aria-disabled": e.editDisabled || void 0,
          "data-testid": "avatar-edit",
          onClick: S[3] || (S[3] = _e((I) => !e.editDisabled && l("edit"), ["stop"]))
        }, [
          x("i", {
            class: C(["ri-pencil-line", p[s.value].icon]),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, Ay)) : w("", !0)
      ]),
      _: 1
    })) : (u(), P(Wf, Ve({ key: 0 }, f.value, {
      as: e.as,
      onImageError: S[0] || (S[0] = (I) => o.value = !0)
    }), null, 16, ["as"]));
  }
}), zy = ["role", "aria-hidden"], Dy = {
  class: "opal-spinner-rotate size-full",
  viewBox: "0 0 100 100",
  fill: "none",
  "aria-hidden": "true",
  focusable: "false"
}, By = { key: 0 }, My = ["x1", "y1", "x2", "y2"], Oy = ["r", "stroke-width"], Py = ["d", "stroke", "stroke-width"], Fy = {
  key: 0,
  class: "sr-only"
}, Ny = { value: 0 }, Vy = /* @__PURE__ */ ke({
  __name: "Spinner",
  props: {
    size: { default: "sm" },
    color: { default: "sky" },
    track: { type: Boolean, default: !0 },
    label: { default: void 0 }
  },
  setup(e) {
    const a = e, t = {
      xs: "size-(--spacing-3)",
      sm: "size-(--spacing-6)",
      md: "size-[50px]",
      base: "size-[75px]",
      lg: "size-[100px]",
      inherit: "size-[1em]"
    }, n = { r: 42.5, width: 15, arc: "M 49.834 7.5 A 42.5 42.5 0 0 1 92.458 48.107" }, l = { r: 45.459, width: 9.081, arc: "M 42.9 5.099 A 45.459 45.459 0 0 1 92.594 34.116" }, o = m(
      () => a.size === "md" || a.size === "base" || a.size === "lg" ? l : n
    ), r = {
      sky: {
        x1: 3.01,
        y1: 0,
        x2: 85.17,
        y2: -7.21,
        start: "--colors-spinner-sky-start",
        end: "--colors-spinner-sky-end"
      },
      primary: {
        x1: 0,
        y1: 50,
        x2: 100,
        y2: 50,
        start: "--colors-spinner-primary-start",
        end: "--colors-spinner-primary-end"
      }
    }, i = {
      sky: { x1: 42.76, y1: 0, x2: 91.22, y2: -4.43 },
      primary: { x1: 40.98, y1: 28.31, x2: 100, y2: 28.31 }
    }, s = `opal-spinner-${++Ny.value}`, d = m(() => {
      if (a.color === "current") return;
      const y = r[a.color];
      return a.size === "xs" ? { ...y, ...i[a.color] } : y;
    }), c = m(() => d.value ? `url(#${s})` : "currentColor"), f = m(
      () => a.color === "current" ? "var(--spinner-track, transparent)" : "var(--colors-spinner-track)"
    ), g = 100, h = R("");
    let v;
    const p = m(() => {
      var y;
      return ((y = a.label) == null ? void 0 : y.trim()) || void 0;
    });
    return $e(
      p,
      (y) => {
        clearTimeout(v), h.value = "", y && (v = setTimeout(() => h.value = y, g));
      },
      { immediate: !0 }
    ), Tt(() => clearTimeout(v)), (y, k) => (u(), b("span", {
      class: C(["inline-flex shrink-0 align-middle", t[e.size]]),
      role: p.value ? "status" : void 0,
      "aria-hidden": p.value ? void 0 : "true",
      "data-testid": "spinner"
    }, [
      (u(), b("svg", Dy, [
        d.value ? (u(), b("defs", By, [
          x("linearGradient", {
            id: s,
            gradientUnits: "userSpaceOnUse",
            x1: d.value.x1,
            y1: d.value.y1,
            x2: d.value.x2,
            y2: d.value.y2
          }, [
            x("stop", {
              offset: "0",
              style: Ge({ stopColor: `var(${d.value.start})` })
            }, null, 4),
            x("stop", {
              offset: "1",
              style: Ge({ stopColor: `var(${d.value.end})` })
            }, null, 4)
          ], 8, My)
        ])) : w("", !0),
        e.track ? (u(), b("circle", {
          key: 1,
          cx: "50",
          cy: "50",
          r: o.value.r,
          "stroke-width": o.value.width,
          style: Ge({ stroke: f.value }),
          "data-testid": "spinner-track"
        }, null, 12, Oy)) : w("", !0),
        x("path", {
          d: o.value.arc,
          stroke: c.value,
          "stroke-width": o.value.width,
          "stroke-linecap": "round",
          "data-testid": "spinner-arc"
        }, null, 8, Py)
      ])),
      p.value ? (u(), b("span", Fy, H(h.value), 1)) : w("", !0)
    ], 10, zy));
  }
}), gc = /* @__PURE__ */ Ct(Vy, [["__scopeId", "data-v-1ef84c80"]]);
function ho(e) {
  return e.startsWith("ri-");
}
const Hy = /^ri-[a-z0-9-]+$/, jy = new RegExp("^(?:\\p{Extended_Pictographic}[\\p{Emoji_Modifier}️]*(?:‍\\p{Extended_Pictographic}[\\p{Emoji_Modifier}️]*)*|\\p{Regional_Indicator}{2})$", "u");
function jr(e) {
  return Hy.test(e) || jy.test(e);
}
const Kg = {
  label: "",
  theme: "neutral",
  size: "sm",
  type: "default",
  badgeStyle: "rounded",
  leftIcon: void 0,
  rightIcon: void 0,
  showLeftIcon: !0,
  showCloseIcon: !1,
  removeLabel: void 0,
  closeIconInactive: !1,
  showText: !0,
  dropdownIcon: !1,
  secondaryText: "",
  avatarSrc: void 0,
  avatarAlt: void 0,
  iconOnly: !1,
  textOnly: !1,
  value: void 0,
  truncate: !1,
  truncationFocusable: !0,
  tooltipText: void 0
}, Wy = {
  // Figma component `eudonet` 4728:62829.
  eudonet: [
    "M24.0709 0C23.1879 0 22.3161 0.0495821 21.4578 0.141985C33.4426 1.44915 42.7738 11.6315 42.7738 24C42.7738 36.3685 33.4448 46.5531 21.4578 47.858C22.3161 47.9527 23.1879 48 24.0709 48C37.287 48 48 37.2542 48 23.9977C48 10.7413 37.2847 0 24.0709 0Z",
    "M23.0574 8.97662C22.5046 8.97662 21.9586 9.00818 21.4216 9.06677C28.9239 9.88488 34.7636 16.2584 34.7636 24.0023C34.7636 31.7461 28.9239 38.1196 21.4216 38.9377C21.9586 38.9963 22.5046 39.0279 23.0574 39.0279C31.3303 39.0279 38.035 32.3005 38.035 24.0045C38.035 15.7085 31.3281 8.98113 23.0574 8.98113V8.97662Z",
    "M22.525 16.4297C22.2464 16.4297 21.9723 16.4455 21.7004 16.4748C25.4819 16.8872 28.4253 20.0988 28.4253 24.0022C28.4253 27.9057 25.4819 31.1173 21.7004 31.5297C21.9723 31.559 22.2464 31.5748 22.525 31.5748C26.6952 31.5748 30.0745 28.1852 30.0745 24.0022C30.0745 19.8193 26.6952 16.4297 22.525 16.4297Z",
    "M17.2874 41.3424C17.9255 41.3424 18.5547 41.3064 19.1748 41.2388C10.5154 40.2944 3.77474 32.9383 3.77474 24.0022C3.77474 15.0662 10.5154 7.70772 19.1748 6.76566C18.5547 6.69805 17.9255 6.66199 17.2874 6.66199C7.74047 6.66199 0 14.4261 0 24.0022C0 33.5783 7.74047 41.3424 17.2874 41.3424Z",
    "M19.4895 35.0478C19.8962 35.0478 20.2961 35.0252 20.6916 34.9824C15.1755 34.3806 10.8817 29.6951 10.8817 24.0022C10.8817 18.3093 15.1755 13.6215 20.6916 13.022C20.2961 12.9792 19.8962 12.9567 19.4895 12.9567C13.4072 12.9567 8.47534 17.9036 8.47534 24.0045C8.47534 30.1053 13.4072 35.0523 19.4895 35.0523V35.0478Z"
  ]
}, qy = {
  class: "size-full",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  "aria-hidden": "true",
  focusable: "false",
  "data-testid": "badge-brand-icon"
}, Uy = ["d"], Gy = {
  key: 5,
  class: "sr-only"
}, Ky = ["aria-hidden"], Yy = { "aria-hidden": "true" }, Jy = ["id", "aria-hidden"], Xy = ["id", "aria-hidden"], Zy = ["aria-label"], Qy = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "BadgeBase",
  props: /* @__PURE__ */ Lg({
    brandIcon: {},
    fitWidth: { type: Boolean },
    label: {},
    theme: {},
    size: {},
    type: {},
    badgeStyle: {},
    leftIcon: {},
    showLeftIcon: { type: Boolean },
    rightIcon: {},
    showCloseIcon: { type: Boolean },
    removeLabel: {},
    closeIconInactive: { type: Boolean },
    showText: { type: Boolean },
    dropdownIcon: { type: Boolean },
    secondaryText: {},
    avatarSrc: {},
    avatarAlt: {},
    iconOnly: { type: Boolean },
    textOnly: { type: Boolean },
    value: {},
    truncate: { type: Boolean },
    truncationFocusable: { type: Boolean },
    tooltipText: {}
  }, { ...Kg, brandIcon: void 0, fitWidth: !1 }),
  emits: ["close"],
  setup(e, { emit: a }) {
    var q;
    const t = rn(), n = m(() => {
      const { class: K, ...G } = t;
      return G;
    }), l = e, o = a, r = {
      disabled: {
        bg: "bg-(--components-badge-background-badge-disabled-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-disabled-strong-text)",
        icon: "text-(--components-badge-icon-badge-disabled-icon)",
        separator: "bg-(--components-badge-border-badge-white-default-border)",
        secondaryText: "text-(--components-badge-text-badge-disabled-strong-text)",
        dot: "bg-(--components-badge-background-badge-gray-bg)",
        dotText: "text-(--components-badge-text-badge-disabled-strong-text)",
        dotIcon: "text-(--components-badge-icon-badge-disabled-icon)",
        spinner: "text-(--components-badge-spinner-disabled-arc) [--spinner-track:var(--components-badge-spinner-disabled-track)]"
      },
      red: {
        bg: "bg-(--components-badge-background-badge-error-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-black-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-error-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-red-arc) [--spinner-track:var(--components-badge-spinner-red-track)]"
      },
      orange: {
        bg: "bg-(--components-badge-background-badge-orange-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--border-border-black-default)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-orange-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-icon)",
        spinner: "text-(--components-badge-spinner-orange-arc) [--spinner-track:var(--components-badge-spinner-orange-track)]"
      },
      yellow: {
        bg: "bg-(--components-badge-background-badge-yellow-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-yellow-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-yellow-arc) [--spinner-track:var(--components-badge-spinner-yellow-track)]"
      },
      green: {
        bg: "bg-(--components-badge-background-badge-green-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-green-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-green-arc) [--spinner-track:var(--components-badge-spinner-green-track)]"
      },
      indigo: {
        bg: "bg-(--components-badge-background-badge-indigo-soft-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-indigo-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-indigo-arc) [--spinner-track:var(--components-badge-spinner-indigo-track)]"
      },
      // OPAL-only (no Figma variant): accent fill with indigo text, Indigo's dot and spinner.
      active: {
        bg: "bg-(--components-badge-background-badge-accent-bg)",
        border: "",
        text: "text-(--components-badge-background-badge-indigo-strong-bg)",
        icon: "text-(--components-badge-background-badge-indigo-strong-bg)",
        separator: "bg-(--components-badge-background-badge-indigo-strong-bg)",
        secondaryText: "text-(--components-badge-background-badge-indigo-strong-bg)",
        dot: "bg-(--components-badge-background-badge-indigo-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-indigo-arc) [--spinner-track:var(--components-badge-spinner-indigo-track)]"
      },
      violet: {
        bg: "bg-(--components-badge-background-badge-violet-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-violet-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-violet-arc) [--spinner-track:var(--components-badge-spinner-violet-track)]"
      },
      purple: {
        bg: "bg-(--components-badge-background-badge-purple-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-body-text)",
        dot: "bg-(--components-badge-background-badge-purple-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-purple-arc) [--spinner-track:var(--components-badge-spinner-purple-track)]"
      },
      neutral: {
        bg: "bg-(--components-badge-background-badge-neutral-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "bg-(--components-badge-background-badge-neutral-strong-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-neutral-arc) [--spinner-track:var(--components-badge-spinner-neutral-track)]"
      },
      // Only theme with a dark fill: light text and icon on the fill, dark text once `with-dot` drops it.
      dark: {
        bg: "bg-(--components-badge-background-badge-dark-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-white-default-text)",
        icon: "text-(--components-badge-icon-badge-white-default-icon)",
        separator: "bg-(--components-badge-border-badge-base-soft-border)",
        secondaryText: "text-(--components-badge-text-badge-white-default-text)",
        dot: "bg-(--components-badge-background-badge-dark-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-dark-icon)",
        spinner: "text-(--components-badge-spinner-dark-arc) [--spinner-track:var(--components-badge-spinner-dark-track)]"
      },
      cyan: {
        bg: "bg-(--components-badge-background-badge-cyan-bg)",
        border: "",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "bg-(--components-badge-background-badge-cyan-strong-bg)",
        dotText: "text-(--text-text-black-default)",
        dotIcon: "text-(--icons-icon-dark-default)",
        spinner: "text-(--components-badge-spinner-cyan-arc) [--spinner-track:var(--components-badge-spinner-cyan-track)]"
      },
      white: {
        bg: "bg-(--components-badge-background-badge-white-bg)",
        border: "border-(--components-badge-border-badge-base-soft-border)",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-base-soft-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "bg-(--components-badge-background-badge-neutral-bg)",
        dotText: "text-(--components-badge-text-badge-black-default-text)",
        dotIcon: "text-(--components-badge-icon-badge-black-default-icon)",
        spinner: "text-(--components-badge-spinner-white-arc) [--spinner-track:var(--components-badge-spinner-white-track)]"
      },
      "gradient-light": {
        bg: "badge-gradient-light",
        border: "border-transparent",
        text: "text-(--components-badge-text-badge-black-default-text)",
        icon: "text-(--components-badge-icon-badge-black-default-icon)",
        separator: "bg-(--components-badge-border-badge-dark-default-border)",
        secondaryText: "text-(--components-badge-text-badge-black-default-text)",
        dot: "badge-dot-gradient",
        dotText: "text-(--text-text-black-default)",
        dotIcon: "text-(--icons-icon-dark-default)",
        spinner: "text-(--components-badge-spinner-gradient-light-arc) [--spinner-track:var(--components-badge-spinner-gradient-light-track)]"
      }
    }, i = m(() => r[l.theme]), s = {
      xs: {
        padding: "gap-1 px-1 h-[18px]",
        withDot: "gap-1 px-1 min-h-5",
        compact: "px-1 min-w-5 h-[18px]",
        compactCircle: "px-1 min-w-[18px] h-[18px]",
        text: "text-(length:--size-xs) leading-(--line-height-s)",
        countText: "text-(length:--size-xs) leading-(--line-height-s)",
        icon: "size-2.5",
        glyph: "text-(length:--icon-size-2xs)",
        secondaryGap: "gap-1",
        separator: "h-2.5",
        avatar: "3xs"
      },
      sm: {
        padding: "gap-1 px-1 min-h-6",
        withDot: "gap-1 px-1 min-h-5",
        compact: "px-1 min-w-[22px] h-5",
        compactCircle: "px-1 min-w-[22px] h-[22px]",
        text: "text-(length:--size-sm) leading-(--line-height-l)",
        countText: "text-(length:--size-sm) leading-(--line-height-l)",
        icon: "size-3",
        glyph: "text-(length:--size-sm)",
        secondaryGap: "gap-1.5",
        separator: "h-3",
        avatar: "2xs"
      },
      lg: {
        padding: "gap-1.5 px-1.5 min-h-7",
        withDot: "gap-1.5 px-1.5 min-h-[22px]",
        compact: "px-1 min-w-[22px] h-6",
        compactCircle: "px-1 min-w-6 h-6",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        countText: "text-(length:--size-sm) leading-(--line-height-l)",
        icon: "size-3.5",
        glyph: "text-(length:--icon-size-xs)",
        secondaryGap: "gap-2",
        separator: "h-3",
        avatar: "2xs"
      }
    }, d = m(() => l.iconOnly || l.textOnly), c = m(() => l.type === "with-dot" && !d.value), f = m(() => s[c.value && l.size === "xs" ? "sm" : l.size]), g = m(
      () => l.badgeStyle === "circle" ? "rounded-(--border-border-radius-rounded-full)" : "rounded-(--border-border-radius-rounded-xs)"
    ), h = m(() => {
      const K = i.value, G = f.value;
      let te = c.value ? G.withDot : G.padding;
      return d.value && (te = l.badgeStyle === "circle" ? G.compactCircle : G.compact), [
        "opal-badge inline-flex items-center justify-center font-inter whitespace-nowrap",
        g.value,
        c.value ? "bg-transparent" : [K.bg, K.border && ["border-solid border-[1px]", K.border]],
        c.value ? K.dotText : K.text,
        te
      ];
    }), v = m(() => [f.value.text, "font-(--weight-medium)", l.fitWidth && "min-w-0"]), p = m(() => [f.value.countText, "font-(--weight-medium)"]), y = m(() => [
      ...v.value,
      l.size === "xs" ? i.value.text : i.value.secondaryText
    ]), k = m(() => c.value ? i.value.dotIcon : i.value.icon), $ = m(() => !!l.leftIcon && ho(l.leftIcon)), S = m(() => l.brandIcon ? Wy[l.brandIcon] : void 0), I = m(
      () => (
        // Not a glyph (typo, extra classes): render nothing rather than the raw string as text.
        (!!S.value || !!l.leftIcon && jr(l.leftIcon)) && !l.textOnly && (l.iconOnly || l.showLeftIcon && ["default", "with-secondary-text", "with-dot"].includes(l.type))
      )
    ), T = m(() => !!l.rightIcon && ho(l.rightIcon)), A = m(
      () => !!l.rightIcon && jr(l.rightIcon) && !d.value && ["default", "with-secondary-text", "with-dot"].includes(l.type)
    ), E = m(
      () => !d.value && l.showText && (!!l.label || l.type === "with-secondary-text" && !!l.secondaryText)
    ), z = m(() => l.showCloseIcon && !d.value && l.type !== "with-dot"), B = m(() => Array.from(l.label ?? "")), W = m(() => l.truncate && !l.textOnly && B.value.length > 14), _ = m(
      () => W.value ? `${B.value.slice(0, 14).join("")}…` : l.label ?? ""
    ), Z = m(() => !!l.tooltipText || W.value), le = (K, { slots: G }) => {
      var te;
      return (te = G.default) == null ? void 0 : te.call(G);
    }, D = m(() => l.truncationFocusable && W.value), O = m(() => D.value && E.value), N = Ye(), V = Ye(), M = m(
      () => Z.value ? {
        text: l.tooltipText || l.label,
        labelsTrigger: O.value && !l.tooltipText,
        tabindex: D.value ? 0 : void 0,
        role: O.value ? "group" : void 0,
        "aria-labelledby": O.value ? l.type === "with-secondary-text" && l.secondaryText ? `${N} ${V}` : N : void 0,
        position: "top",
        as: "span"
      } : {}
    );
    return typeof process < "u" && ((q = process.env) == null ? void 0 : q.NODE_ENV) !== "production" && $e(
      () => [l.iconOnly, l.leftIcon, l.rightIcon, l.brandIcon, l.label, z.value, l.closeIconInactive, l.removeLabel],
      () => {
        var G, te;
        const K = (ve) => console.warn(`[OPAL Badge] ${ve}`);
        l.iconOnly && !l.leftIcon && !l.brandIcon && K("`iconOnly` is set without `leftIcon`: the badge renders empty."), l.leftIcon && !jr(l.leftIcon) && K(`\`leftIcon\` "${l.leftIcon}" is neither a single \`ri-*\` class nor an emoji: no icon is rendered.`), l.rightIcon && !jr(l.rightIcon) && K(`\`rightIcon\` "${l.rightIcon}" is neither a single \`ri-*\` class nor an emoji: no icon is rendered.`), l.iconOnly && !((G = l.label) != null && G.trim()) && K("`iconOnly` is set without `label`: the badge has no accessible name (WCAG 4.1.2)."), z.value && !l.closeIconInactive && !((te = l.removeLabel) != null && te.trim()) && K("`showCloseIcon` is set without `removeLabel`: the remove button has no accessible name.");
      },
      { immediate: !0 }
    ), (K, G) => (u(), P(gt(Z.value ? $t : le), ga(ka(M.value)), {
      default: me(() => [
        x("span", Ve(n.value, {
          class: [h.value, L(t).class]
        }), [
          c.value ? (u(), b("span", {
            key: 0,
            class: C(["size-1.5 shrink-0 rounded-(--border-border-radius-rounded-full)", i.value.dot]),
            "aria-hidden": "true",
            "data-testid": "badge-dot"
          }, null, 2)) : w("", !0),
          e.type === "with-avatar" && !d.value ? (u(), P(Jt, {
            key: 1,
            img: e.avatarSrc,
            name: e.avatarAlt || e.label,
            size: f.value.avatar,
            presentational: !e.avatarAlt,
            as: "span",
            class: C({ "opacity-60": e.theme === "disabled" })
          }, null, 8, ["img", "name", "size", "presentational", "class"])) : w("", !0),
          e.type === "with-loader" && !d.value ? (u(), P(gc, {
            key: 2,
            size: "xs",
            color: "current",
            class: C(i.value.spinner)
          }, null, 8, ["class"])) : w("", !0),
          I.value && S.value ? (u(), b("span", {
            key: 3,
            class: C([f.value.icon, "text-(--icons-icon-dark-default) shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-left-icon"
          }, [
            (u(), b("svg", qy, [
              (u(!0), b(ie, null, Oe(S.value, (te, ve) => (u(), b("path", {
                key: ve,
                d: te
              }, null, 8, Uy))), 128))
            ]))
          ], 2)) : I.value ? (u(), b("span", {
            key: 4,
            class: C([f.value.icon, f.value.glyph, k.value, "shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-left-icon"
          }, [
            $.value ? (u(), b("i", {
              key: 0,
              class: C(e.leftIcon)
            }, null, 2)) : (u(), b(ie, { key: 1 }, [
              st(H(e.leftIcon), 1)
            ], 64))
          ], 2)) : w("", !0),
          e.iconOnly && e.label ? (u(), b("span", Gy, H(e.label), 1)) : w("", !0),
          e.textOnly ? (u(), b("span", {
            key: 6,
            class: C(p.value)
          }, H(e.value ?? e.label), 3)) : w("", !0),
          E.value ? (u(), b("span", {
            key: 7,
            class: C(e.type === "with-secondary-text" ? ["inline-flex items-center", f.value.secondaryGap] : "contents")
          }, [
            x("span", {
              class: C(v.value),
              "aria-hidden": O.value ? "true" : void 0
            }, [
              W.value ? (u(), b(ie, { key: 0 }, [
                x("span", Yy, H(_.value), 1),
                x("span", {
                  id: L(N),
                  class: "sr-only",
                  "aria-hidden": O.value ? "true" : void 0
                }, H(e.label), 9, Jy)
              ], 64)) : e.fitWidth ? (u(), P(it, {
                key: 1,
                text: e.label ?? "",
                focusable: !1
              }, null, 8, ["text"])) : (u(), b(ie, { key: 2 }, [
                st(H(e.label), 1)
              ], 64))
            ], 10, Ky),
            e.type === "with-secondary-text" ? (u(), b(ie, { key: 0 }, [
              x("span", {
                class: C(["w-px shrink-0", f.value.separator, i.value.separator]),
                "aria-hidden": "true",
                "data-testid": "badge-separator"
              }, null, 2),
              x("span", {
                id: L(V),
                class: C(y.value),
                "aria-hidden": O.value ? "true" : void 0
              }, H(e.secondaryText), 11, Xy)
            ], 64)) : w("", !0)
          ], 2)) : w("", !0),
          A.value ? (u(), b("span", {
            key: 8,
            class: C([f.value.icon, f.value.glyph, k.value, "shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-right-icon"
          }, [
            T.value ? (u(), b("i", {
              key: 0,
              class: C(e.rightIcon)
            }, null, 2)) : (u(), b(ie, { key: 1 }, [
              st(H(e.rightIcon), 1)
            ], 64))
          ], 2)) : w("", !0),
          z.value && e.closeIconInactive ? (u(), b("span", {
            key: 9,
            class: C([f.value.icon, f.value.glyph, k.value, "shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            "data-testid": "badge-close-icon"
          }, [...G[3] || (G[3] = [
            x("i", { class: "ri-close-fill" }, null, -1)
          ])], 2)) : z.value ? (u(), b("button", {
            key: 10,
            type: "button",
            class: C([
              f.value.icon,
              f.value.glyph,
              k.value,
              "relative shrink-0 inline-flex items-center justify-center cursor-pointer bg-transparent border-none p-0",
              "rounded-(--border-border-radius-rounded-xs) hover:opacity-70 transition-opacity",
              "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
              "before:absolute before:left-1/2 before:top-1/2 before:size-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']"
            ]),
            "aria-label": e.removeLabel,
            onClick: G[0] || (G[0] = _e((te) => o("close"), ["stop"])),
            onKeydown: [
              G[1] || (G[1] = St(_e(() => {
              }, ["stop"]), ["enter"])),
              G[2] || (G[2] = St(_e(() => {
              }, ["stop"]), ["space"]))
            ]
          }, [...G[4] || (G[4] = [
            x("i", {
              class: "ri-close-fill",
              "aria-hidden": "true"
            }, null, -1)
          ])], 42, Zy)) : w("", !0),
          e.dropdownIcon && !d.value ? (u(), b("span", {
            key: 11,
            class: C([k.value, "size-3 shrink-0 inline-flex items-center justify-center text-(length:--size-sm)"]),
            "aria-hidden": "true",
            "data-testid": "badge-chevron"
          }, [...G[5] || (G[5] = [
            x("i", { class: "ri-arrow-down-s-line" }, null, -1)
          ])], 2)) : w("", !0),
          G[6] || (G[6] = x("span", { class: "sr-only" }, " ", -1))
        ], 16)
      ]),
      _: 1
    }, 16));
  }
}), mc = /* @__PURE__ */ Ct(Qy, [["__scopeId", "data-v-05eecf91"]]), yt = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "Badge",
  props: /* @__PURE__ */ Lg({
    label: {},
    theme: {},
    size: {},
    type: {},
    badgeStyle: {},
    leftIcon: {},
    showLeftIcon: { type: Boolean },
    rightIcon: {},
    showCloseIcon: { type: Boolean },
    removeLabel: {},
    closeIconInactive: { type: Boolean },
    showText: { type: Boolean },
    dropdownIcon: { type: Boolean },
    secondaryText: {},
    avatarSrc: {},
    avatarAlt: {},
    iconOnly: { type: Boolean },
    textOnly: { type: Boolean },
    value: {},
    truncate: { type: Boolean },
    truncationFocusable: { type: Boolean },
    tooltipText: {}
  }, Kg),
  emits: ["close"],
  setup(e, { emit: a }) {
    const t = rn(), n = m(() => {
      const { brandIcon: r, "brand-icon": i, ...s } = t;
      return s;
    }), l = e, o = a;
    return (r, i) => (u(), P(mc, Ve({ ...n.value, ...l }, {
      onClose: i[0] || (i[0] = (s) => o("close"))
    }), null, 16));
  }
}), _y = ["id"], ek = {
  key: 1,
  class: "sr-only",
  "data-testid": "badge-overflow-names"
}, Ls = /* @__PURE__ */ ke({
  __name: "BadgeOverflow",
  props: {
    label: {},
    hiddenLabels: {},
    theme: { default: "neutral" },
    size: { default: "sm" },
    focusable: { type: Boolean, default: !0 }
  },
  setup(e) {
    const a = e, t = Ye();
    return (n, l) => (u(), P($t, {
      text: a.hiddenLabels.join(", "),
      as: "span",
      position: "top",
      tabindex: e.focusable ? 0 : void 0,
      role: e.focusable ? "group" : void 0,
      "aria-labelledby": e.focusable ? L(t) : void 0,
      "data-testid": "badge-overflow"
    }, {
      default: me(() => [
        e.focusable ? (u(), b("span", {
          key: 0,
          id: L(t),
          hidden: ""
        }, H(e.label), 9, _y)) : w("", !0),
        U(yt, {
          label: e.label,
          theme: e.theme,
          size: e.size,
          "show-left-icon": !1,
          "show-close-icon": !1,
          "aria-hidden": e.focusable ? "true" : void 0
        }, null, 8, ["label", "theme", "size", "aria-hidden"]),
        e.focusable ? w("", !0) : (u(), b("span", ek, ": " + H(a.hiddenLabels.join(", ")), 1))
      ]),
      _: 1
    }, 8, ["text", "tabindex", "role", "aria-labelledby"]));
  }
});
function Ts(e) {
  return "hiddenLabels" in e;
}
function Es(e, a) {
  const t = Number.isFinite(a) ? Math.max(0, Math.floor(a)) : e.length, n = e.slice(0, t), l = e.slice(n.length);
  return l.length > 0 ? [...n, { label: `+${l.length}`, hiddenLabels: l.map((o) => o.label) }] : n;
}
const tk = /* @__PURE__ */ ke({
  __name: "IconShape",
  props: {
    color: {},
    size: { default: "md" },
    type: { default: "square" },
    variant: { default: "filled" },
    icon: { default: void 0 },
    label: { default: void 0 },
    as: { default: "div" }
  },
  setup(e) {
    const a = e, t = {
      xs: "h-4 w-4",
      sm: "h-6 w-6",
      md: "h-9 w-9",
      lg: "h-12 w-12",
      xl: "h-16 w-16",
      "2xl": "h-24 w-24"
    }, n = {
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-xs)",
      md: "rounded-(--border-border-radius-rounded-sm)",
      lg: "rounded-(--border-border-radius-rounded-sm)",
      xl: "rounded-(--border-border-radius-rounded-l)",
      "2xl": "rounded-(--border-border-radius-rounded-l)"
    }, l = {
      xs: "border-(length:--border-border-width-border)",
      sm: "border-(length:--border-border-width-border)",
      md: "border-(length:--border-border-width-border-sm)",
      lg: "border-(length:--border-border-width-border-sm)",
      xl: "border-(length:--border-border-width-border-sm)",
      "2xl": "border-(length:--border-border-width-border-sm)"
    }, o = {
      xs: "text-(length:--icon-size-2xs)",
      sm: "text-(length:--icon-size-sm)",
      md: "text-(length:--icon-size-md)",
      lg: "text-(length:--icon-size-xl)",
      xl: "text-(length:--icon-size-2xl)",
      "2xl": "text-(length:--icon-size-3xl)"
    }, r = {
      xs: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)",
      sm: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
      md: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
      lg: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold)",
      xl: "text-(length:--size-xxl) leading-(--line-height-xxl) font-(--weight-bold)",
      "2xl": "text-(length:--size-6xl) leading-(--line-height-6xl) font-(--weight-bold)"
    }, i = {
      red: { bg: "bg-(--components-icon-shape-background-iconshape-red-bg)", icon: "text-(--components-icon-shape-icon-iconshape-red-icon)" },
      orange: { bg: "bg-(--components-icon-shape-background-iconshape-orange-bg)", icon: "text-(--components-icon-shape-icon-iconshape-orange-icon)" },
      yellow: { bg: "bg-(--components-icon-shape-background-iconshape-yellow-bg)", icon: "text-(--components-icon-shape-icon-iconshape-yellow-icon)" },
      green: { bg: "bg-(--components-icon-shape-background-iconshape-green-bg)", icon: "text-(--components-icon-shape-icon-iconshape-success-icon)" },
      purple: { bg: "bg-(--components-icon-shape-background-iconshape-purple-bg)", icon: "text-(--components-icon-shape-icon-iconshape-purple-icon)" },
      violet: { bg: "bg-(--components-icon-shape-background-iconshape-violet-bg)", icon: "text-(--components-icon-shape-icon-iconshape-violet-icon)" },
      indigo: { bg: "bg-(--components-icon-shape-background-iconshape-indigo-bg)", icon: "text-(--components-icon-shape-icon-iconshape-indigo-icon)" },
      dark: { bg: "bg-(--components-icon-shape-background-iconshape-black-bg)", icon: "text-(--components-icon-shape-icon-iconshape-white-icon)" },
      white: { bg: "bg-(--components-icon-shape-background-iconshape-white-bg)", icon: "text-(--components-icon-shape-icon-iconshape-black-icon)" },
      default: { bg: "bg-(--components-icon-shape-background-iconshape-cyan-bg)", icon: "text-(--components-icon-shape-icon-iconshape-default-icon)", text: "text-(--components-icon-shape-text-iconshape-default-text)" },
      success: { bg: "bg-(--components-icon-shape-background-iconshape-success-bg)", icon: "text-(--components-icon-shape-icon-iconshape-white-default-icon)" },
      error: { bg: "bg-(--components-icon-shape-background-iconshape-error-bg)", icon: "text-(--components-icon-shape-icon-iconshape-white-default-icon)" },
      text: {
        bg: "bg-(--components-icon-shape-background-iconshape-black-default-bg)",
        icon: "text-(--components-icon-shape-text-iconshape-white-default-text)",
        text: "text-(--components-icon-shape-text-iconshape-white-default-text)"
      },
      disabled: {
        bg: "bg-(--components-icon-shape-background-iconshape-disabled-bg)",
        border: "border-(--components-icon-shape-border-iconshape-disabled-border)",
        icon: "text-(--components-icon-shape-icon-iconshape-disabled-strong-icon)",
        text: "text-(--components-icon-shape-text-iconshape-disabled-text)"
      },
      gradient: { icon: "text-(--components-icon-shape-icon-iconshape-white-icon)", text: "text-(--components-icon-shape-text-iconshape-white-default-text)" },
      "sunny-gradient": {
        icon: "text-(--components-icon-shape-icon-iconshape-accent-gradient-icon)",
        text: "text-(--components-icon-shape-text-iconshape-accent-gradient-text)"
      }
    }, s = {
      ...i,
      red: { icon: "text-(--components-icon-shape-icon-iconshape-red-icon)" },
      orange: { icon: "text-(--components-icon-shape-icon-iconshape-orange-icon)" },
      yellow: { icon: "text-(--components-icon-shape-icon-iconshape-yellow-icon)" },
      green: { icon: "text-(--components-icon-shape-icon-iconshape-green-icon)" },
      purple: { icon: "text-(--components-icon-shape-icon-iconshape-purple-icon)" },
      violet: { icon: "text-(--components-icon-shape-icon-iconshape-violet-icon)" },
      indigo: { icon: "text-(--components-icon-shape-icon-iconshape-indigo-icon)" },
      white: { icon: "text-(--components-icon-shape-icon-iconshape-black-icon)" },
      default: { icon: "text-(--components-icon-shape-icon-iconshape-default-icon)", text: "text-(--components-icon-shape-text-iconshape-default-text)" },
      success: { border: "border-(--components-icon-shape-border-iconshape-success-border)", icon: "text-(--components-icon-shape-icon-iconshape-success-icon)" },
      error: { border: "border-(--components-icon-shape-border-iconshape-error-border)", icon: "text-(--components-icon-shape-icon-iconshape-error-icon)" },
      text: { icon: "text-(--components-icon-shape-text-iconshape-black-default-text)", text: "text-(--components-icon-shape-text-iconshape-black-default-text)" },
      disabled: {
        border: "border-(--components-icon-shape-border-iconshape-disabled-border)",
        icon: "text-(--components-icon-shape-icon-iconshape-disabled-strong-icon)",
        text: "text-(--components-icon-shape-text-iconshape-disabled-text)"
      },
      gradient: { icon: "text-(--components-icon-shape-icon-iconshape-brand-icon)", text: "text-(--components-icon-shape-text-iconshape-black-default-text)" }
    }, d = m(
      () => a.color === "white" || a.variant === "outlined" && a.color !== "dark"
    ), c = m(() => (d.value ? s : i)[a.color]), f = m(() => !a.icon && a.label !== void 0), g = m(() => !!a.icon && ho(a.icon)), h = m(() => {
      if (a.color === "gradient") return "var(--gradient-brand-border)";
      if (a.color === "sunny-gradient" && d.value) return "var(--gradient-sunny)";
    }), v = m(() => {
      if (h.value) {
        const y = d.value ? "var(--components-icon-shape-background-iconshape-white-bg)" : "var(--components-icon-shape-background-iconshape-black-default-bg)";
        return { backgroundImage: `linear-gradient(${y}, ${y}), ${h.value}` };
      }
      if (a.color === "sunny-gradient") return { backgroundImage: "var(--gradient-sunny)" };
    }), p = m(() => {
      const y = c.value;
      return [
        t[a.size],
        a.type === "circle" ? "rounded-(--border-border-radius-rounded-full)" : n[a.size],
        "border-solid",
        l[a.size],
        h.value ? "icon-shape-gradient-ring border-transparent" : y.border ?? "border-(--components-icon-shape-border-iconshape-default-border)",
        h.value || a.color === "sunny-gradient" ? void 0 : y.bg ?? "bg-(--components-icon-shape-background-iconshape-white-bg)",
        f.value && y.text ? y.text : y.icon
      ];
    });
    return (y, k) => (u(), P(gt(e.as), {
      class: C(["flex shrink-0 items-center justify-center", p.value]),
      style: Ge(v.value),
      "aria-hidden": "true",
      "data-testid": "icon-shape"
    }, {
      default: me(() => [
        g.value ? (u(), b("i", {
          key: 0,
          class: C([e.icon, o[e.size], "leading-none"])
        }, null, 2)) : e.icon ? (u(), b("span", {
          key: 1,
          class: C([o[e.size], "leading-none", e.color === "disabled" && "opacity-50"])
        }, H(e.icon), 3)) : e.label !== void 0 ? (u(), b("span", {
          key: 2,
          class: C(["font-inter whitespace-nowrap", r[e.size]])
        }, H(e.label), 3)) : w("", !0)
      ]),
      _: 1
    }, 8, ["class", "style"]));
  }
}), aa = /* @__PURE__ */ Ct(tk, [["__scopeId", "data-v-3fd4680f"]]), vc = Symbol("CheckboxGroupErrorId");
function Yg(e) {
  const a = na(vc, void 0);
  return m(() => {
    const t = [...e(), a == null ? void 0 : a.value].filter(Boolean);
    return t.length > 0 ? t.join(" ") : void 0;
  });
}
function ak() {
  wa(vc, m(() => {
  }));
}
const ed = "opal:checked-resync";
function nk(e) {
  if (e.type !== "radio" || e.name === "") return [e];
  const a = e.getRootNode();
  return Array.from(a.querySelectorAll('input[type="radio"]')).filter(
    (t) => t.name === e.name && t.form === e.form
  );
}
function As(e, a, t = () => !1) {
  const n = () => {
    e.value && (e.value.checked = a(), e.value.indeterminate = t());
  };
  $e(
    e,
    (o, r, i) => {
      o && (o.addEventListener(ed, n), i(() => o.removeEventListener(ed, n)));
    },
    { immediate: !0, flush: "post" }
  );
  function l() {
    const o = e.value;
    o && Ze(() => {
      for (const r of nk(o)) r.dispatchEvent(new Event(ed));
    });
  }
  return { resync: l };
}
const Jg = "mb-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) dark:text-(--colors-text-white-default)", Xg = "flex items-center gap-1 text-(length:--size-sm) leading-(--line-height-m) text-(--text-text-error-strong) dark:text-(--text-text-error)", Zg = "ri-error-warning-fill text-(--text-text-error-strong) dark:text-(--text-text-error)", lk = ["id", "name", "checked", "disabled", "indeterminate", "value", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-disabled"], ok = ["for"], rk = ["for"], ik = {
  key: 0,
  class: "absolute left-1/2 top-1/2 size-6 -translate-x-1/2 -translate-y-1/2",
  "data-testid": "checkbox-hit-area"
}, sk = ["for"], dk = ["for"], uk = ["id"], va = /* @__PURE__ */ ke({
  __name: "Checkbox",
  props: {
    label: { default: void 0 },
    modelValue: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    labelPosition: { default: "right" },
    variant: { default: "default" },
    labelWrap: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    value: { type: [String, Number, Boolean], default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    error: { default: void 0 },
    presentational: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: a }) {
    const t = e, n = m(() => t.disabled || t.ariaDisabled), l = Ye(), o = m(() => t.id ?? l), r = m(() => `${o.value}-error`), i = m(() => !!t.error && !t.presentational), s = m(() => t.presentational ? "span" : "div"), d = Yg(() => [
      t.ariaDescribedby,
      i.value ? r.value : void 0
    ]), c = a, f = R(null), { resync: g } = As(
      f,
      () => t.modelValue,
      () => t.indeterminate
    ), h = m(() => t.modelValue || t.indeterminate), v = m(
      () => !t.presentational && !!t.label && (t.labelPosition === "left" || t.labelPosition === "right")
    ), p = m(() => {
      const E = "relative size-4 shrink-0 box-border flex items-center justify-center rounded-(--border-border-radius-rounded-xs) border border-solid transition-all duration-200 motion-reduce:transition-none peer-focus-visible:shadow-(--shadow-focus-l) peer-focus-visible:outline-2 peer-focus-visible:outline-transparent" + (v.value ? " mt-0.5" : ""), z = h.value ? "" : " peer-focus-visible:border-(--border-border-hover)";
      if (n.value)
        return `${E} bg-(--background-background-disabled-strong) border-(--border-border-disabled) cursor-not-allowed`;
      if (t.variant === "dark") {
        const B = h.value ? "bg-(--background-background-black-default)" : "bg-transparent";
        return `${E} ${B} border-(--border-border-white-full) cursor-pointer${z}`;
      }
      return h.value ? t.variant === "light" ? `${E} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-white-default) dark:border-(--border-border-base) cursor-pointer` : `${E} bg-(--background-background-black-default) border-(--border-border-base) cursor-pointer` : `${E} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) cursor-pointer${z}`;
    }), y = m(() => {
      const A = `${t.indeterminate ? "ri-subtract-fill" : "ri-check-fill"} text-(length:--size-l) leading-none forced-colors:forced-color-adjust-none`;
      return n.value ? `${A} text-(--icons-icon-disabled-strong) forced-colors:text-[GrayText]` : t.variant === "light" ? `${A} text-(--icons-icon-black) dark:text-(--icons-icon-white-default) forced-colors:text-[CanvasText]` : `${A} text-(--icons-icon-white-default) forced-colors:text-[CanvasText]`;
    }), k = m(() => {
      let A = "relative flex text-left font-inter text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) select-none";
      return t.labelPosition === "top" || t.labelPosition === "bottom" ? A += " flex-col items-center gap-2 w-auto" : A += v.value ? " flex-row items-start gap-2 w-full min-w-0" : " flex-row items-center gap-2 w-full min-w-0", v.value && (A += " min-h-6 px-px py-0.5"), i.value && (A += " flex-wrap"), t.presentational && (A += " pointer-events-none"), n.value ? `${A} text-(--text-text-disabled-strong) dark:text-(--colors-text-disabled)` : t.variant === "dark" ? `${A} text-(--text-text-white-default)` : `${A} text-(--text-text-heading) dark:text-(--text-text-white-default)`;
    }), $ = m(() => {
      const A = "relative cursor-pointer flex-1 min-w-0";
      return t.labelWrap ? `${A} break-words` : A;
    }), S = (A) => {
      A.stopPropagation(), t.ariaDisabled && A.preventDefault();
    }, I = (A) => {
      if (A.preventDefault(), A.stopPropagation(), n.value) return;
      const E = !t.modelValue;
      c("update:modelValue", E), c("change", A);
    }, T = (A) => {
      if (n.value) return;
      const E = A.target;
      c("update:modelValue", E.checked), c("change", A), g();
    };
    return (A, E) => (u(), P(gt(s.value), Ve({
      class: k.value,
      "data-testid": "checkbox-container"
    }, nl(e.presentational ? {} : { click: I })), {
      default: me(() => [
        e.presentational ? w("", !0) : (u(), b("input", {
          key: 0,
          id: o.value,
          ref_key: "inputRef",
          ref: f,
          name: e.name,
          type: "checkbox",
          checked: e.modelValue,
          disabled: e.disabled,
          indeterminate: e.indeterminate || void 0,
          value: e.value,
          "aria-label": e.ariaLabel,
          "aria-labelledby": e.ariaLabelledby,
          "aria-describedby": L(d),
          "aria-invalid": i.value ? "true" : void 0,
          "aria-disabled": e.ariaDisabled && !e.disabled ? "true" : void 0,
          class: "peer sr-only pointer-events-none",
          onChange: T,
          onClick: S
        }, null, 40, lk)),
        e.label && e.labelPosition === "top" ? (u(), b("label", {
          key: 1,
          for: o.value,
          class: "relative cursor-pointer text-center"
        }, H(e.label), 9, ok)) : w("", !0),
        e.label && e.labelPosition === "left" ? (u(), b("label", {
          key: 2,
          for: o.value,
          class: C($.value)
        }, [
          e.labelWrap ? (u(), b(ie, { key: 0 }, [
            st(H(e.label), 1)
          ], 64)) : (u(), P(it, {
            key: 1,
            text: e.label,
            focusable: !1
          }, null, 8, ["text"]))
        ], 10, rk)) : w("", !0),
        (u(), P(gt(s.value), {
          class: C(p.value),
          "data-testid": "checkbox-box",
          "aria-hidden": "true"
        }, {
          default: me(() => [
            e.presentational ? w("", !0) : (u(), b("span", ik)),
            e.indeterminate || e.modelValue ? (u(), b("i", {
              key: 1,
              class: C(y.value),
              "aria-hidden": "true"
            }, null, 2)) : w("", !0)
          ]),
          _: 1
        }, 8, ["class"])),
        e.label && e.labelPosition === "right" ? (u(), b("label", {
          key: 3,
          for: o.value,
          class: C($.value)
        }, [
          e.labelWrap ? (u(), b(ie, { key: 0 }, [
            st(H(e.label), 1)
          ], 64)) : (u(), P(it, {
            key: 1,
            text: e.label,
            focusable: !1
          }, null, 8, ["text"]))
        ], 10, sk)) : w("", !0),
        e.label && e.labelPosition === "bottom" ? (u(), b("label", {
          key: 4,
          for: o.value,
          class: "relative cursor-pointer text-center"
        }, H(e.label), 9, dk)) : w("", !0),
        i.value ? (u(), b("div", {
          key: 5,
          id: r.value,
          "data-testid": "checkbox-error",
          class: C(["basis-full self-stretch", L(Xg)]),
          role: "alert",
          onClick: E[0] || (E[0] = _e(() => {
          }, ["stop"]))
        }, [
          x("i", {
            class: C(L(Zg)),
            "aria-hidden": "true"
          }, null, 2),
          x("span", null, H(e.error), 1)
        ], 10, uk)) : w("", !0)
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), ck = {
  key: 0,
  class: "absolute left-5 top-1/2 z-[1] flex -translate-y-1/2"
}, fk = ["id", "aria-expanded", "aria-controls", "aria-pressed", "aria-disabled", "disabled"], hk = {
  key: 0,
  class: "flex-shrink-0",
  "aria-hidden": "true"
}, bk = {
  key: 1,
  class: "flex flex-1 min-w-0 items-center gap-2"
}, gk = {
  key: 0,
  class: "flex shrink-0",
  "aria-hidden": "true"
}, mk = {
  key: 4,
  class: "flex shrink-0",
  "aria-hidden": "true"
}, vk = ["id"], pk = {
  key: 0,
  class: "sr-only"
}, xk = {
  key: 0,
  class: "flex max-w-full shrink-0 flex-wrap items-center gap-1",
  "data-testid": "accordion-item-badges"
}, yk = ["id", "aria-labelledby", "aria-hidden", "inert"], kk = { class: "accordion-content-inner" }, wk = /* @__PURE__ */ ke({
  __name: "AccordionItem",
  props: {
    title: {},
    subtitle: { default: void 0 },
    icon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    defaultOpen: { type: Boolean, default: !1 },
    type: { default: "default" },
    badgeLabel: { default: void 0 },
    badgeTheme: { default: "active" },
    expandable: { type: Boolean, default: !0 },
    selected: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    size: { default: void 0 },
    headingLevel: { default: void 0 },
    avatarSrc: { default: void 0 },
    avatarAlt: { default: void 0 },
    completed: { type: Boolean, default: !1 },
    completedLabel: { default: void 0 },
    badges: { default: () => [] },
    maxBadges: { default: 3 },
    selectable: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 }
  },
  emits: ["toggle", "select", "update:open", "update:checked"],
  setup(e, { emit: a }) {
    var X;
    const t = e, n = a, l = {
      variant: R("default"),
      size: R("md"),
      headingLevel: R(3),
      isChildLevel: R(!1),
      openItems: /* @__PURE__ */ new Set(),
      toggleItem: () => {
      },
      openItem: () => {
      }
    }, o = na(Rg, l), r = Ye(), i = m(() => t.headingLevel ?? o.headingLevel.value), s = R(0);
    wa(zg, {
      variant: o.variant,
      headingLevel: i,
      size: m(() => I.value),
      registerChildAccordion: () => (s.value++, () => s.value--)
    });
    const d = o === l, {
      triggerId: c,
      panelId: f,
      isOpen: g,
      isControlled: h,
      onTransitionEnd: v,
      panelClasses: p,
      toggle: y
    } = Dg({
      id: r,
      open: () => t.open,
      defaultOpen: () => t.defaultOpen && t.expandable,
      onOpenChange: (ae) => {
        h.value && n("update:open", ae);
      },
      store: d ? void 0 : {
        isOpen: () => o.openItems.has(r),
        toggle: () => o.toggleItem(r),
        open: () => o.openItem(r)
      }
    }), k = () => {
      if (!t.disabled) {
        if (!A.value) {
          n("select");
          return;
        }
        n("toggle", y());
      }
    }, $ = (ae) => {
      var fe, Ne, De, qe;
      if (!A.value && ["Enter", " "].includes(ae.key)) {
        ae.preventDefault(), k();
        return;
      }
      if (!["ArrowUp", "ArrowDown", "Home", "End"].includes(ae.key)) return;
      const Re = ae.currentTarget, Ae = Re.closest("[data-accordion-root]");
      if (!Ae) return;
      const xe = Array.from(
        Ae.querySelectorAll(
          '[data-testid="accordion-item-trigger"]:not([disabled])'
        )
      ).filter((Qe) => {
        if (Qe.closest("[data-accordion-root]") !== Ae) return !1;
        const lt = Qe.closest('[inert], [aria-hidden="true"]');
        return !lt || !Ae.contains(lt);
      }), we = xe.indexOf(Re);
      switch (ae.preventDefault(), ae.key) {
        case "ArrowDown":
          (fe = xe[(we + 1) % xe.length]) == null || fe.focus();
          break;
        case "ArrowUp":
          (Ne = xe[(we - 1 + xe.length) % xe.length]) == null || Ne.focus();
          break;
        case "Home":
          (De = xe[0]) == null || De.focus();
          break;
        case "End":
          (qe = xe[xe.length - 1]) == null || qe.focus();
          break;
      }
    }, S = o.variant, I = m(() => t.size ?? o.size.value), T = m(() => t.type === "time-slot"), A = m(() => t.expandable), E = m(() => o.isChildLevel.value), z = m(() => S.value === "flush"), B = m(() => S.value === "with-sub-header"), W = m(() => !!(t.avatarSrc || t.avatarAlt)), _ = m(() => t.completed && B.value), Z = m(() => t.selectable && !T.value && !E.value), le = m(() => `${r}-title`);
    typeof process < "u" && ((X = process.env) == null ? void 0 : X.NODE_ENV) !== "production" && $e(
      () => [_.value, t.completedLabel],
      ([ae, Re]) => {
        ae && !(Re != null && Re.trim()) && console.warn("[OPAL AccordionItem] `completed` is set without `completedLabel`: the done state is visual only (WCAG 1.1.1 / 1.3.1).");
      },
      { immediate: !0 }
    );
    const O = m(() => T.value ? "div" : `h${i.value}`), N = m(() => T.value ? [`[&:not(:last-child)]:mb-4 ${Y.value ? "overflow-visible" : "overflow-hidden"} rounded-xl`, F.value].join(" ") : S.value === "separate-cards" ? "border border-(--colors-border-base-soft) rounded-(--border-border-radius-rounded-l) overflow-hidden shadow-(--blur-shadow-sm)" : z.value ? A.value && g.value ? "last:[&>.accordion-content>*>*]:border-b-0" : `last:[&>*>*>button]:border-b-0 ${Q.value.restoreLast}` : E.value ? "" : [
      `[&:not(:first-child)>*>*>button]:border-t [&:not(:first-child)>*>*>button]:border-solid [&:not(:first-child)>*>*>button]:border-(--colors-border-base-soft) ${Q.value.nonFirst}`,
      "first:[&>*>*>button]:rounded-t-(--border-border-radius-rounded-l)",
      A.value && g.value ? "" : "last:[&>*>*>button]:rounded-b-(--border-border-radius-rounded-l)"
    ].join(" ").trim()), V = m(() => T.value ? A.value && g.value ? "rounded-t-xl" : "rounded-xl" : S.value === "separate-cards" ? A.value && g.value ? "rounded-t-(--border-border-radius-rounded-l)" : "rounded-(--border-border-radius-rounded-l)" : ""), M = {
      1: {
        both: "py-1",
        lessBottom: "pt-1 pb-[calc(var(--spacing-1)-1px)]",
        restoreLast: "last:[&>*>*>button]:pb-1",
        nonFirst: "[&:not(:first-child)>*>*>button]:pt-[calc(var(--spacing-1)-1px)]"
      },
      3: {
        both: "py-3",
        lessBottom: "pt-3 pb-[calc(var(--spacing-3)-1px)]",
        restoreLast: "last:[&>*>*>button]:pb-3",
        nonFirst: "[&:not(:first-child)>*>*>button]:pt-[calc(var(--spacing-3)-1px)]"
      },
      5: {
        both: "py-5",
        lessBottom: "pt-5 pb-[calc(var(--spacing-5)-1px)]",
        restoreLast: "last:[&>*>*>button]:pb-5",
        nonFirst: "[&:not(:first-child)>*>*>button]:pt-[calc(var(--spacing-5)-1px)]"
      }
    }, Q = m(
      () => M[I.value === "sm" ? 1 : B.value || W.value || Z.value ? 5 : 3]
    ), q = m(() => {
      if (T.value) return "p-3";
      if (E.value) return "pt-[calc(var(--spacing-5)-1px)] pr-6 pb-5 pl-12";
      const ae = z.value ? Q.value.lessBottom : Q.value.both, Re = Z.value ? "pr-5 pl-[calc(var(--spacing-5)_+_var(--spacing-4)_+_var(--spacing-6))]" : "px-5";
      return `${ae} ${Re}`;
    }), K = m(() => T.value ? "gap-2.5" : B.value ? "gap-3.5" : "gap-6"), G = m(() => [
      K.value,
      "@max-[40rem]/row:flex-col @max-[40rem]/row:items-stretch @max-[40rem]/row:gap-2"
    ]), te = m(() => T.value || S.value === "separate-cards" ? "" : z.value ? "border-b border-solid border-(--colors-border-base-soft)" : E.value ? "border-t border-solid border-(--colors-border-base-soft)" : ""), ve = m(() => T.value ? "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-info-strong)" : "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-accent)"), Se = m(() => T.value ? t.disabled ? "cursor-not-allowed" : "cursor-pointer" : z.value ? t.disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer" : t.disabled ? "cursor-not-allowed opacity-60 bg-(--background-background-white)" : [
      "cursor-pointer",
      g.value ? "bg-(--colors-background-selected)" : `bg-(--background-background-white) ${Z.value ? "group-hover/header:" : "hover:"}bg-(--colors-background-hover)`
    ].join(" ")), oe = m(() => z.value && !t.disabled && !g.value), re = m(() => oe.value ? "group-hover/trigger:text-(--text-text-hover)" : ""), ge = m(() => [
      "text-(--icons-icon-dark-default)",
      oe.value ? "group-hover/trigger:text-(--icons-icon-hover)" : ""
    ]), de = m(() => [
      "text-(length:--size-l) leading-(--line-height-xxl) text-(--colors-text-heading)",
      E.value ? "font-(--weight-medium)" : "font-(--weight-bold)",
      re.value
    ]), Ee = m(() => [
      "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-body)",
      re.value
    ]), j = m(() => I.value === "sm" ? "sm" : "md"), J = m(() => S.value !== "separate-cards" || E.value ? "text-(length:--icon-size-lg)" : I.value === "sm" ? "text-(length:--icon-size-sm)" : "text-(length:--icon-size-md)"), ne = m(
      () => Es(t.badges, t.maxBadges).map((ae) => ({
        ...ae,
        theme: ae.theme ?? "gradient-light"
      }))
    ), Y = m(() => !t.disabled && A.value && g.value), F = m(() => T.value ? t.disabled || !A.value && t.selected ? "border border-(--border-border-base-medium)" : Y.value ? "relative border border-transparent accordion-time-slot-gradient-border" : "border border-(--border-border-info) hover:border-(--border-border-info-strong)" : ""), ee = m(() => T.value ? t.disabled ? "bg-(--background-background-disabled-subtle)" : !A.value && t.selected ? "bg-(--components-badge-background-badge-indigo-strong-bg)" : "bg-(--background-background-info)" : ""), ue = m(() => T.value ? t.disabled ? "font-medium text-(--text-text-disabled-strong) line-through" : !A.value && t.selected ? "font-bold text-(--colors-text-white-default)" : "font-medium text-(--text-text-link)" : ""), se = m(() => T.value ? "flex flex-col gap-1 px-2 py-1.5 rounded-b-xl bg-(--background-background-white) dark:bg-(--colors-background-black-default)" : S.value === "multi-level" && !E.value && s.value > 0 ? "flex flex-col" : [
      "flex flex-col gap-3 bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--colors-border-base-soft)",
      z.value ? "border-b" : "border-t",
      I.value === "sm" ? "py-3 px-5" : "p-5"
    ].join(" "));
    return (ae, Re) => (u(), b("div", {
      class: C(N.value),
      "data-accordion-item": "",
      "data-testid": "accordion-item"
    }, [
      x("div", {
        class: C(T.value ? "contents" : ["relative group/header", ne.value.length ? "@container/row" : ""]),
        "data-testid": "accordion-item-header"
      }, [
        Z.value ? (u(), b("div", ck, [
          U(va, {
            "model-value": e.checked,
            disabled: e.disabled,
            "aria-labelledby": le.value,
            "data-testid": "accordion-item-checkbox",
            "onUpdate:modelValue": Re[0] || (Re[0] = (Ae) => n("update:checked", Ae))
          }, null, 8, ["model-value", "disabled", "aria-labelledby"])
        ])) : w("", !0),
        (u(), P(gt(O.value), {
          class: C(T.value ? "contents" : "m-0")
        }, {
          default: me(() => [
            x("button", {
              id: T.value ? void 0 : L(c),
              type: "button",
              class: C(["flex w-full items-center text-left transition-colors", [
                V.value,
                K.value,
                te.value,
                q.value,
                Se.value,
                ee.value,
                ve.value,
                T.value ? "" : "group/trigger",
                T.value && !A.value ? "justify-center" : ""
              ]]),
              "aria-expanded": A.value ? L(g) : void 0,
              "aria-controls": A.value ? L(f) : void 0,
              "aria-pressed": T.value && !A.value ? e.selected : void 0,
              "aria-disabled": T.value && e.disabled ? "true" : void 0,
              disabled: T.value ? !1 : e.disabled,
              "data-testid": "accordion-item-trigger",
              onClick: k,
              onKeydown: $
            }, [
              T.value ? (u(), b(ie, { key: 0 }, [
                e.icon && A.value ? (u(), b("div", hk, [
                  x("i", {
                    class: C([
                      e.icon,
                      "text-[16px]",
                      e.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-link)"
                    ])
                  }, null, 2)
                ])) : w("", !0),
                x("div", {
                  class: C(["flex flex-1 min-w-0 flex-wrap items-center gap-2", A.value ? "" : "justify-center"]),
                  "data-testid": "accordion-item-time-wrapper"
                }, [
                  x("span", {
                    "data-testid": "accordion-item-time",
                    class: C(["text-base leading-6", ue.value])
                  }, H(e.title), 3),
                  e.badgeLabel && A.value ? (u(), P(yt, {
                    key: 0,
                    "data-testid": "accordion-item-badge",
                    label: e.badgeLabel,
                    theme: e.disabled ? "disabled" : e.badgeTheme,
                    size: "sm",
                    "show-left-icon": !1,
                    "show-close-icon": !1
                  }, null, 8, ["label", "theme"])) : w("", !0)
                ], 2)
              ], 64)) : (u(), b("span", bk, [
                E.value && A.value ? (u(), b("span", gk, [
                  x("i", {
                    class: C(["ri-arrow-down-s-line text-(length:--icon-size-lg) leading-none transition-transform duration-300 ease-in-out motion-reduce:transition-none", [ge.value, L(g) ? "rotate-180" : ""]])
                  }, null, 2)
                ])) : W.value ? (u(), P(Jt, {
                  key: 1,
                  as: "span",
                  img: e.avatarSrc,
                  name: e.avatarAlt || e.title,
                  presentational: !e.avatarAlt,
                  size: I.value === "sm" ? "sm" : "md"
                }, null, 8, ["img", "name", "presentational", "size"])) : _.value ? (u(), P(aa, {
                  key: 2,
                  as: "span",
                  color: "success",
                  variant: "filled",
                  type: "circle",
                  icon: "ri-check-fill",
                  size: j.value
                }, null, 8, ["size"])) : B.value && e.icon ? (u(), P(aa, {
                  key: 3,
                  as: "span",
                  color: "white",
                  variant: "outlined",
                  type: "circle",
                  icon: e.icon,
                  size: j.value
                }, null, 8, ["icon", "size"])) : e.icon && !E.value ? (u(), b("span", mk, [
                  x("i", {
                    class: C([e.icon, "text-(length:--icon-size-md) leading-none", ge.value])
                  }, null, 2)
                ])) : w("", !0),
                x("span", {
                  class: C(["flex min-w-0 flex-1 items-center", G.value])
                }, [
                  x("span", {
                    class: C(["flex min-w-0 flex-1 flex-col", B.value || W.value ? "gap-px" : ""])
                  }, [
                    x("span", {
                      id: le.value,
                      class: C(de.value),
                      "data-testid": "accordion-item-title"
                    }, [
                      st(H(e.title), 1),
                      _.value && e.completedLabel ? (u(), b("span", pk, ", " + H(e.completedLabel), 1)) : w("", !0)
                    ], 10, vk),
                    e.subtitle ? (u(), b("span", {
                      key: 0,
                      class: C(Ee.value),
                      "data-testid": "accordion-item-subtitle"
                    }, H(e.subtitle), 3)) : w("", !0)
                  ], 2),
                  ne.value.length ? (u(), b("span", xk, [
                    (u(!0), b(ie, null, Oe(ne.value, (Ae, xe) => (u(), b(ie, { key: xe }, [
                      L(Ts)(Ae) ? (u(), P(Ls, {
                        key: 0,
                        label: Ae.label,
                        "hidden-labels": Ae.hiddenLabels,
                        theme: Ae.theme,
                        size: "xs",
                        focusable: !1
                      }, null, 8, ["label", "hidden-labels", "theme"])) : (u(), P(yt, {
                        key: 1,
                        label: Ae.label,
                        theme: Ae.theme,
                        size: "xs",
                        truncate: Ae.truncate ?? !1,
                        "truncation-focusable": !1,
                        "show-left-icon": !1,
                        "show-close-icon": !1
                      }, null, 8, ["label", "theme", "truncate"]))
                    ], 64))), 128))
                  ])) : w("", !0)
                ], 2)
              ])),
              A.value && !E.value ? (u(), P(gt(T.value ? "div" : "span"), {
                key: 2,
                class: C(T.value ? "flex-shrink-0 ml-auto" : "flex shrink-0 ml-auto"),
                "aria-hidden": "true"
              }, {
                default: me(() => [
                  T.value ? (u(), b("i", {
                    key: 0,
                    class: C(["ri-arrow-down-s-line text-2xl transition-transform duration-300", [
                      e.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-link)",
                      L(g) ? "rotate-180" : ""
                    ]])
                  }, null, 2)) : (u(), b("i", {
                    key: 1,
                    class: C(["ri-arrow-down-s-line block leading-none transition-transform duration-300 ease-in-out motion-reduce:transition-none", [J.value, ge.value, L(g) ? "rotate-180" : ""]])
                  }, null, 2))
                ]),
                _: 1
              }, 8, ["class"])) : w("", !0)
            ], 42, fk)
          ]),
          _: 1
        }, 8, ["class"]))
      ], 2),
      A.value ? (u(), b("div", {
        key: 0,
        id: L(f),
        class: C(L(p)),
        role: "region",
        "aria-labelledby": T.value ? void 0 : L(c),
        "aria-hidden": !L(g),
        inert: !L(g) || void 0,
        onTransitionend: Re[1] || (Re[1] = //@ts-ignore
        (...Ae) => L(v) && L(v)(...Ae))
      }, [
        x("div", kk, [
          x("div", {
            class: C(se.value)
          }, [
            Me(ae.$slots, "default", {}, void 0, !0)
          ], 2)
        ])
      ], 42, yk)) : w("", !0)
    ], 2));
  }
}), PU = /* @__PURE__ */ Ct(wk, [["__scopeId", "data-v-281355d5"]]);
function pc(e, a) {
  return `${e}-tab-${String(a).replace(/\s+/g, "-")}`;
}
const Qg = Symbol("ButtonGroupContext"), td = "bg-(--components-button-button-disabled) border-(--border-border-disabled) text-(--text-text-disabled-strong)", Ql = "border-transparent text-(--text-text-disabled-strong) dark:text-(--components-button-button-disabled)", Ck = "border-transparent [background:var(--btn-fill-image,linear-gradient(var(--btn-fill),var(--btn-fill)))_padding-box,linear-gradient(var(--btn-stroke),var(--btn-stroke))_border-box]", Kf = "border-(--border-border-disabled) text-(--text-text-disabled-strong) dark:text-(--components-button-button-disabled)", Yf = "before:-inset-px before:[background:linear-gradient(var(--btn-ring-angle,85deg),var(--gradient-brand-start)_10.83%,var(--gradient-brand-end)_86.95%)] after:bg-(--background-background-white)", Sk = {
  tertiary: { label: "[--btn-ring-angle:69deg]", iconOnly: "[--btn-ring-angle:85deg]" },
  tab: { label: "[--btn-ring-angle:72deg]", iconOnly: "[--btn-ring-angle:85deg]" }
}, Jf = "focus-visible:overflow-visible focus-visible:border-transparent focus-visible:before:opacity-100 focus-visible:after:opacity-100", $k = {
  primary: {
    shape: `rounded-full ${Ck}`,
    rest: "[--btn-fill:var(--components-button-primary-button-primary)] [--btn-stroke:var(--border-border-primary-button)] text-(--text-text-white-secondary) dark:text-(--text-text-white-default)",
    interactive: "hover:[--btn-fill-image:var(--gradient-button-primary-hover)] hover:[--btn-stroke:var(--border-border-primary-button-hover)] focus-visible:[--btn-stroke:var(--border-border-accent)]",
    labelInteractive: "dark:hover:[--btn-fill-image:linear-gradient(90deg,_var(--text-text-white-default),_var(--colors-indigo-100))] dark:hover:text-(--text-text-black-default)",
    disabled: "[--btn-fill:var(--components-button-button-disabled)] [--btn-stroke:var(--border-border-disabled)] text-(--text-text-disabled-strong)",
    icon: "text-(--icons-icon-white-default)",
    iconInteractive: ""
  },
  // Figma fades the Secondary hover in (Dissolve), hence the `before` layer.
  secondary: {
    shape: "rounded-full before:inset-0 before:[background:var(--gradient-button-secondary-hover)]",
    rest: "bg-(--components-button-secondary-button-secondary) border-(--border-border-secondary-button) text-(--text-text-black-default)",
    interactive: "hover:border-(--border-border-secondary-button-hover) hover:before:opacity-100 dark:hover:bg-(--components-button-secondary-button-secondary-hover) dark:hover:text-(--text-text-white-secondary) focus-visible:text-(--text-text-accent) focus-visible:border-(--border-border-accent)",
    disabled: td,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: "group-focus-visible/button:text-(--icons-icon-accent)"
  },
  // background-hover has no dark value; the Tertiary hover token carries the dark one.
  tertiary: {
    shape: `${Yf} after:inset-[calc(var(--border-border-width-border-sm)-1px)] dark:after:bg-(--components-button-tertiary-button-tertiary-focused)`,
    rest: "border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-secondary)",
    interactive: `hover:bg-(--background-background-hover) dark:hover:bg-(--components-button-tertiary-button-tertiary-hover) dark:hover:text-(--text-text-black-default) hover:border-(--border-border-tertiary-hover) dark:hover:border-(--components-button-tertiary-button-tertiary-hover) ${Jf}`,
    disabled: Ql,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  ghost: {
    shape: "",
    rest: "bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:bg-(--components-button-ghost-button-ghost-hover) dark:hover:text-(--text-text-black-default)",
    disabled: Ql,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  text: {
    shape: "",
    rest: "bg-transparent border-transparent text-(--components-button-text-button-text) dark:text-(--text-text-white-default)",
    interactive: "hover:text-(--components-button-text-button-text-hover) dark:hover:text-(--text-text-hover)",
    disabled: Ql,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: "group-hover/button:text-(--icons-icon-hover)"
  },
  // Stroke on top and sides only; the bottom edge joins the content below. Figma rounds Initial to
  // rounded-sm and every other state to rounded-l; OPAL keeps rounded-l in all states so hover doesn't reshape the tab.
  tab: {
    shape: `rounded-t-(--border-border-radius-rounded-l) rounded-b-none border-b-0 before:[clip-path:inset(0_0_1px_0)] dark:after:bg-(--components-button-tab-button-tab-active) after:inset-0 ${Yf}`,
    rest: "bg-(--components-button-tab-button-tab-default) border-(--border-border-tab) text-(--text-text-black-default)",
    interactive: `hover:bg-(--components-button-tab-button-tab) hover:border-(--border-border-hover) ${Jf}`,
    disabled: "bg-(--colors-white-50-opacity-light) dark:bg-(--components-button-button-disabled) border-(--border-border-disabled-subtle) dark:border-(--border-border-disabled) text-(--text-text-disabled-strong)",
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  success: {
    shape: "rounded-full",
    rest: "bg-(--components-button-functional-success-button-success) border-transparent text-(--text-text-white-secondary) dark:text-(--text-text-black-default)",
    interactive: "hover:bg-(--components-button-functional-success-button-success-hover) focus-visible:[--btn-fill:var(--components-button-functional-success-button-success-focused)] focus-visible:[--btn-stroke:var(--border-border-success)] dark:focus-visible:[--btn-stroke:var(--colors-border-success-sublte)] focus-visible:[background:linear-gradient(var(--btn-fill),var(--btn-fill))_padding-box,linear-gradient(var(--btn-stroke),var(--btn-stroke))_border-box]",
    disabled: td,
    icon: "text-(--icons-icon-white-default)",
    iconInteractive: ""
  },
  "success-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-(--components-button-functional-success-button-success) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:border-(--components-button-functional-success-button-success-hover) focus-visible:border-(--components-button-functional-success-button-success-focused)",
    disabled: Kf,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  error: {
    shape: "rounded-full",
    // CONSTRAINT: white-default, not white-secondary like the other filled variants: #f2f0f0 on the
    // error red #d92d20 is 4.26:1 and fails WCAG AA (4.5:1); #fafafa reaches 4.63:1.
    rest: "bg-(--components-button-functional-desctructive-error-background-button-error) border-transparent text-(--text-text-white-default) dark:text-(--text-text-black-default)",
    interactive: "hover:bg-(--components-button-functional-desctructive-error-background-button-error-hover) focus-visible:[--btn-fill:var(--components-button-functional-desctructive-error-background-button-error-focused)] focus-visible:[--btn-stroke:var(--border-border-error)] dark:focus-visible:[--btn-stroke:var(--border-border-error-subtle)] focus-visible:[background:linear-gradient(var(--btn-fill),var(--btn-fill))_padding-box,linear-gradient(var(--btn-stroke),var(--btn-stroke))_border-box]",
    disabled: td,
    icon: "text-(--icons-icon-white-default)",
    iconInteractive: ""
  },
  "error-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-(--components-button-functional-desctructive-error-background-button-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:border-(--components-button-functional-desctructive-error-background-button-error-hover) focus-visible:border-(--components-button-functional-desctructive-error-background-button-error-focused)",
    disabled: Kf,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  // Red at rest; icons follow the text colour through every state.
  "error-text": {
    shape: "",
    rest: "bg-transparent border-transparent text-(--components-button-functional-desctructive-error-background-button-error)",
    interactive: "hover:text-(--components-button-functional-desctructive-error-background-button-error-hover) focus-visible:text-(--components-button-functional-desctructive-error-background-button-error-focused) focus-visible:border-(--components-button-functional-desctructive-error-icons-button-error-focused-icon)",
    iconOnlyInteractive: "hover:bg-(--background-background-error) dark:hover:bg-transparent",
    disabled: Ql,
    icon: "",
    iconInteractive: ""
  }
}, Ik = {
  "success-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:bg-(--background-background-success) dark:hover:bg-transparent",
    disabled: Ql,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: ""
  },
  "error-secondary": {
    shape: "rounded-full",
    rest: "bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default)",
    interactive: "hover:bg-(--background-background-error) dark:hover:bg-transparent",
    disabled: Ql,
    icon: "text-(--icons-icon-dark-default)",
    iconInteractive: "group-hover/button:text-(--components-button-functional-desctructive-error-icons-button-error-icon)"
  }
}, Lk = /* @__PURE__ */ new Set(["primary", "secondary", "ghost"]), Tk = /* @__PURE__ */ new Set(["tertiary", "ghost", "text", "error-text"]);
function _g(e) {
  return Object.fromEntries(Object.entries(e).filter(([a]) => !/^onClick(?:Once|Capture|Passive)*$/.test(a)));
}
const Ek = ["src"], Ak = ["src"], Rk = {
  key: 1,
  class: "relative z-10 min-w-0 whitespace-nowrap *:align-top"
}, zk = ["src"], Dk = "group/button relative inline-flex max-w-full items-center justify-center gap-1.5 overflow-hidden border border-solid font-inter font-(--weight-medium) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden before:content-[''] before:absolute before:rounded-[inherit] before:opacity-0 before:transition-opacity before:duration-150 before:z-0 motion-reduce:before:transition-none after:content-[''] after:absolute after:rounded-[inherit] after:opacity-0 after:transition-opacity after:duration-150 after:z-[1] motion-reduce:after:transition-none", Bk = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "Button",
  props: {
    as: { default: "button" },
    variant: { default: "primary" },
    outline: { type: Boolean, default: !0 },
    label: { default: "" },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    dropdownIcon: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    shrink: { type: Boolean, default: !1 },
    iconOnly: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: void 0 },
    active: { type: Boolean, default: !1 },
    value: { default: void 0 },
    type: { default: "button" }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    var G;
    const t = e, n = a, l = rn(), o = Na(), r = na(Qg, null), i = R(null), s = m(() => t.value === void 0 || r == null ? void 0 : r.mode.value), d = m(
      () => s.value && t.value !== void 0 ? r.isSelected(t.value) : t.active
    ), c = {
      xs: {
        button: "py-[calc(--spacing(1.5)-1px)] px-[calc(--spacing(3)-1px)] text-(length:--size-sm) leading-(--line-height-l)",
        tabBottom: "pb-1.5",
        iconOnly: "size-8 p-0"
      },
      sm: {
        button: "py-[calc(--spacing(2)-1px)] px-[calc(--spacing(3)-1px)] text-(length:--size-m) leading-(--line-height-l)",
        tabBottom: "pb-2",
        iconOnly: "size-9 p-0"
      },
      md: {
        button: "py-[calc(--spacing(2.5)-1px)] px-[calc(--spacing(4)-1px)] text-(length:--size-m) leading-(--line-height-l)",
        tabBottom: "pb-2.5",
        iconOnly: "size-10 p-0"
      },
      lg: {
        button: "py-[calc(--spacing(3)-1px)] px-[calc(--spacing(5)-1px)] text-(length:--size-l) leading-(--line-height-xxl)",
        tabBottom: "pb-3",
        iconOnly: "size-12 p-0"
      },
      xl: {
        button: "py-[calc(--spacing(3.5)-1px)] px-[calc(--spacing(6)-1px)] text-(length:--size-l) leading-(--line-height-xxl)",
        tabBottom: "pb-3.5",
        iconOnly: "size-13 p-0"
      }
    }, f = { font: "text-(length:--icon-size-xs) leading-(--icon-size-xs)", box: "size-(--icon-size-xs)" }, g = { font: "text-(length:--icon-size-sm) leading-(--icon-size-sm)", box: "size-(--icon-size-sm)" }, h = { font: "text-(length:--icon-size-md) leading-(--icon-size-md)", box: "size-(--icon-size-md)" }, v = { xs: f, sm: g, md: g, lg: g, xl: h }, p = { xs: f, sm: g, md: h, lg: h, xl: h }, y = m(() => (t.iconOnly ? p : v)[t.size]), k = m(
      () => !t.outline && (t.variant === "success-secondary" || t.variant === "error-secondary") ? Ik[t.variant] : $k[t.variant]
    ), $ = m(() => t.disabled && !t.loading && t.as === "button"), S = m(() => t.disabled || t.ariaDisabled || t.loading), I = m(() => (t.disabled || t.ariaDisabled) && !t.loading), T = m(() => !d.value || I.value ? "" : t.variant === "tertiary" ? "active bg-(--background-background-white) dark:bg-[var(--colors-background-black-default)] overflow-visible before:opacity-100 after:opacity-100" : t.variant === "tab" ? "bg-(--background-background-white) dark:bg-[var(--colors-background-black-default)] border-transparent text-(--text-text-black-default) overflow-visible before:opacity-100 after:opacity-100" : ""), A = m(() => {
      var ve;
      const te = c[t.size];
      return [
        Dk,
        k.value.shape,
        (ve = Sk[t.variant]) == null ? void 0 : ve[t.iconOnly ? "iconOnly" : "label"],
        I.value ? ["cursor-not-allowed", k.value.disabled] : t.loading ? ["cursor-progress", !(d.value && t.variant === "tab") && k.value.rest] : [
          "cursor-pointer",
          // An active Tab replaces its rest colours instead of competing with them.
          !(d.value && t.variant === "tab") && k.value.rest,
          k.value.interactive,
          t.iconOnly ? k.value.iconOnlyInteractive : k.value.labelInteractive
        ],
        // The OPAL focus ring on every variant, also while `ariaDisabled`/`loading` keep the button
        // focusable: the Figma focus of Ghost and Text is too faint to see (RGAA 10.7).
        Lk.has(t.variant) && !I.value ? "focus-visible:shadow-[var(--shadow-focus-l),var(--shadow-focus-s)]" : "focus-visible:shadow-(--shadow-focus-l)",
        Tk.has(t.variant) && (t.iconOnly ? "rounded-full" : "rounded-(--border-border-radius-rounded-base)"),
        t.iconOnly ? te.iconOnly : te.button,
        t.variant === "tab" && !t.iconOnly && te.tabBottom,
        t.fullWidth && !t.iconOnly && "w-full",
        t.shrink && !t.iconOnly ? "min-w-0" : "shrink-0",
        T.value
      ];
    }), E = m(() => [
      "relative z-10 inline-flex shrink-0 items-center justify-center dark:text-current",
      y.value.font,
      I.value ? "text-(--icons-icon-disabled-strong)" : [k.value.icon, !t.loading && k.value.iconInteractive]
    ]), z = m(() => {
      const te = I.value, ve = t.variant === "error" || t.variant === "success" || t.variant === "error-text";
      return [
        "relative z-10 shrink-0",
        y.value.box,
        !te && !ve && "dark:invert",
        te && "grayscale opacity-60"
      ];
    });
    function B(te) {
      return !!te && !te.includes("/");
    }
    const W = m(() => t.iconOnly ? `${t.variant}-icon-button` : `${t.variant}-button`);
    function _() {
      const te = S.value ? _g(l) : l;
      return {
        ...t.as === "button" ? { type: t.type, disabled: $.value || void 0 } : {},
        ...te,
        ...t.ariaLabel ? { "aria-label": t.ariaLabel } : {},
        ...S.value && !$.value ? { "aria-disabled": "true" } : {},
        ...Z()
      };
    }
    if (r) {
      const te = r.register({
        value: () => t.value,
        unreachable: () => t.disabled || t.loading,
        blocked: () => S.value,
        el: () => i.value
      });
      kt(r.sort), Tt(te);
    }
    function Z() {
      if (!s.value || t.value === void 0) return {};
      const te = r.isTabStop(t.value), ve = r.panelId();
      return {
        "data-button-group-item": "",
        tabindex: te ? 0 : -1,
        ...s.value === "tabs" ? { role: "tab", "aria-selected": String(d.value) } : { role: "radio", "aria-checked": String(d.value) },
        ...ve && {
          id: l.id ?? pc(ve, t.value),
          "aria-controls": l["aria-controls"] ?? ve
        }
      };
    }
    function le(te) {
      if (S.value) {
        te.preventDefault();
        return;
      }
      s.value && t.value !== void 0 && r.select(t.value), n("click", te);
    }
    const D = R(null), O = R(!1), N = R(!1), V = m(() => N.value ? !1 : O.value ? !0 : void 0);
    function M(te) {
      try {
        O.value = te.target.matches(":focus-visible");
      } catch {
        O.value = !0;
      }
    }
    function Q() {
      O.value = !1, N.value = !1;
    }
    $e(
      () => t.disabled,
      (te) => {
        te && Q();
      }
    );
    function q(te) {
      var ve;
      s.value && r.onItemKeydown(te), !(te.key !== "Escape" || N.value) && (!O.value || !((ve = D.value) != null && ve.isTruncated) || (te.stopPropagation(), te.preventDefault(), N.value = !0));
    }
    const K = typeof process < "u" && ((G = process.env) == null ? void 0 : G.NODE_ENV) !== "production";
    return $e(
      () => t.iconOnly && !t.ariaLabel,
      (te) => {
        K && te && !l["aria-label"] && !l["aria-labelledby"] && console.warn("[OPAL Button] `iconOnly` without `ariaLabel` or `aria-labelledby`: the button has no accessible name (WCAG 1.1.1 / 4.1.2).");
      },
      { immediate: !0 }
    ), (te, ve) => (u(), P(gt(e.as), Ve({
      ref_key: "rootRef",
      ref: i,
      "data-testid": W.value
    }, _(), {
      class: A.value,
      onClick: le,
      onFocus: M,
      onBlur: Q,
      onKeydown: q
    }), {
      default: me(() => [
        e.loading ? (u(), P(gc, {
          key: 0,
          size: "inherit",
          color: "current",
          label: e.loadingLabel,
          class: C(E.value)
        }, null, 8, ["label", "class"])) : w("", !0),
        !e.loading && e.iconOnly && (e.iconLeft || e.iconRight) ? (u(), b(ie, { key: 1 }, [
          B(e.iconLeft || e.iconRight) ? (u(), b("i", {
            key: 0,
            class: C([e.iconLeft || e.iconRight, E.value]),
            "aria-hidden": "true"
          }, null, 2)) : (u(), b("img", {
            key: 1,
            src: e.iconLeft || e.iconRight,
            class: C(z.value),
            alt: ""
          }, null, 10, Ek))
        ], 64)) : w("", !0),
        e.iconOnly ? w("", !0) : (u(), b(ie, { key: 2 }, [
          !e.loading && e.iconLeft ? (u(), b(ie, { key: 0 }, [
            B(e.iconLeft) ? (u(), b("i", {
              key: 0,
              class: C([e.iconLeft, E.value]),
              "aria-hidden": "true"
            }, null, 2)) : (u(), b("img", {
              key: 1,
              src: e.iconLeft,
              class: C(z.value),
              alt: ""
            }, null, 10, Ak))
          ], 64)) : w("", !0),
          o.default ? (u(), b("span", Rk, [
            Me(te.$slots, "default", {}, void 0, !0)
          ])) : e.label ? (u(), b("span", {
            key: 2,
            class: C(["relative z-10 flex min-w-0", e.variant === "tab" && "max-w-(--tab-label-max-width)"])
          }, [
            U(it, {
              ref_key: "labelRef",
              ref: D,
              as: "span",
              text: e.label,
              focusable: !1,
              open: V.value
            }, null, 8, ["text", "open"])
          ], 2)) : w("", !0),
          !e.loading && e.iconRight ? (u(), b(ie, { key: 3 }, [
            B(e.iconRight) ? (u(), b("i", {
              key: 0,
              class: C([e.iconRight, E.value]),
              "aria-hidden": "true"
            }, null, 2)) : (u(), b("img", {
              key: 1,
              src: e.iconRight,
              class: C(z.value),
              alt: ""
            }, null, 10, zk))
          ], 64)) : w("", !0),
          e.dropdownIcon ? (u(), b("i", {
            key: 4,
            class: C(["ri-arrow-down-s-line transition-transform duration-200 ease-in-out motion-reduce:transition-none group-aria-expanded/button:rotate-180", E.value]),
            "aria-hidden": "true"
          }, null, 2)) : w("", !0)
        ], 64))
      ]),
      _: 3
    }, 16, ["data-testid", "class"]));
  }
}), Be = /* @__PURE__ */ Ct(Bk, [["__scopeId", "data-v-793b8637"]]), Rs = (e, a) => typeof e == "function" ? e(a) : e.replace("{count}", String(a)), Un = /* @__PURE__ */ ke({
  __name: "ToggleSwitch",
  props: {
    modelValue: { type: Boolean, default: !1 },
    type: { default: "boolean" },
    size: { default: "base" },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    presentational: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => t.disabled || t.ariaDisabled), o = m(() => t.size === "lg"), r = m(() => t.type === "default"), i = m(() => r.value ? !t.modelValue : t.modelValue), s = m(() => {
      const v = `relative box-border inline-block ${o.value ? "h-6.5 w-11.5" : "h-5.5 w-9.5"} shrink-0 rounded-(--border-border-radius-rounded-full) border transition-[color,background-color,border-color] duration-100 ease-in-out motion-reduce:transition-none`, p = t.presentational ? "" : " focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent";
      if (l.value)
        return `${v}${p} cursor-not-allowed border-(--components-toggle-border-toggle-disabled-border) bg-(--components-toggle-background-toggle-disabled)`;
      const y = t.presentational ? "" : " cursor-pointer";
      return t.modelValue || r.value ? `${v}${p}${y} border-(--components-toggle-border-toggle-active-border) bg-(--components-toggle-background-toggle-active)` : `${v}${p}${y} border-(--components-toggle-border-toggle-unactive-border) bg-(--components-toggle-background-toggle-unactive)`;
    }), d = m(() => {
      const v = `absolute top-0.5 box-border flex ${o.value ? "size-5" : "size-4"} border items-center justify-center rounded-(--border-border-radius-rounded-full) shadow-(--blur-shadow-xs) transition-[inset-inline-start] duration-150 ease-in-out motion-reduce:transition-none`, p = o.value ? "start-5.25" : "start-4.5", y = t.modelValue ? p : "start-0.5";
      return l.value ? `${v} ${y} border-transparent bg-(--components-toggle-background-toggle-disabled-switch)` : r.value ? `${v} ${y} border-transparent bg-(--components-toggle-background-toggle-active-switch)` : t.modelValue ? `${v} ${y} border-transparent bg-(--colors-background-white-secondary-soft)` : `${v} ${y} border-(--components-toggle-border-toggle-unactive-border) bg-(--components-toggle-background-toggle-active-switch)`;
    }), c = m(() => {
      const h = o.value ? "text-(length:--icon-size-md)" : "text-(length:--icon-size-sm)";
      return l.value ? `ri-check-fill ${h} leading-none text-(--components-toggle-icon-toggle-icon-disabled)` : `ri-check-fill ${h} leading-none text-(--icons-icon-accent)`;
    }), f = m(
      () => t.presentational ? {} : {
        type: "button",
        role: "switch",
        "aria-checked": t.modelValue,
        "aria-disabled": t.ariaDisabled ? "true" : void 0,
        disabled: t.disabled
      }
    ), g = () => {
      t.presentational || l.value || n("update:modelValue", !t.modelValue);
    };
    return (h, v) => (u(), P(gt(e.presentational ? "span" : "button"), Ve(f.value, {
      class: s.value,
      onClick: g
    }), {
      default: me(() => [
        x("span", {
          class: C(d.value)
        }, [
          U(Wt, {
            "enter-active-class": "transition-opacity duration-150 ease-in-out motion-reduce:transition-none",
            "enter-from-class": "opacity-0"
          }, {
            default: me(() => [
              i.value ? (u(), b("i", {
                key: 0,
                class: C(c.value),
                "aria-hidden": "true"
              }, null, 2)) : w("", !0)
            ]),
            _: 1
          })
        ], 2)
      ]),
      _: 1
    }, 16, ["class"]));
  }
});
function em(e, a) {
  const t = a.trim(), n = t ? new RegExp(t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i").exec(e) : null;
  if (!n) return { before: e, match: "", after: "" };
  const l = n.index;
  return {
    before: e.slice(0, l),
    match: n[0],
    after: e.slice(l + n[0].length)
  };
}
const tm = "rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) [backdrop-filter:blur(4px)] dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)", hl = `${tm} shadow-(--blur-shadow-m)`, Mk = `${tm} shadow-(--shadow-l)`, xc = "text-(--text-text-black-default) dark:text-(--colors-text-white-default)", am = "box-border flex flex-col gap-1.5 p-[calc(--spacing(2)-1px)]", Ai = `${hl} ${xc} ${am}`, yc = "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", Ok = `flex min-h-8 w-full cursor-pointer items-center rounded-(--border-border-radius-rounded-sm) px-2 py-1.5 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) transition-colors hover:bg-(--background-background-hover) ${yc} dark:text-(--colors-text-white-default) dark:hover:bg-white/8`, Pk = "bg-(--background-background-hover) dark:bg-white/8", nm = {
  success: "text-(--icons-icon-success)",
  base: "text-(--icons-icon-base)",
  error: "text-(--icons-icon-error)"
}, Fk = {
  key: 0,
  class: "flex shrink-0",
  "data-testid": "dropdown-list-item-checkbox"
}, Nk = {
  key: 0,
  class: "h-5.5 w-9.5 shrink-0",
  "aria-hidden": "true",
  "data-testid": "dropdown-list-item-toggle-placeholder"
}, Vk = ["src"], Hk = ["id"], jk = ["id"], Wk = {
  key: 1,
  class: "min-w-0 break-words"
}, qk = {
  class: "text-(--text-text-link)",
  "data-testid": "dropdown-list-item-highlight"
}, Uk = {
  key: 1,
  class: "flex min-w-0",
  "data-testid": "dropdown-list-item-secondary-label"
}, Gk = {
  class: "flex min-w-0",
  "data-testid": "dropdown-list-item-secondary-label"
}, Kk = {
  key: 1,
  class: "flex shrink-0"
}, Yk = {
  key: 4,
  class: "flex shrink-0",
  "data-testid": "dropdown-list-item-more-actions"
}, Jk = "inline-flex size-(--icon-size-sm) shrink-0 items-center justify-center", Wr = "text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center shrink-0", fa = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "DropdownListItem",
  props: {
    as: { default: "div" },
    type: { default: "default" },
    label: { default: void 0 },
    icon: { default: void 0 },
    iconColor: { default: void 0 },
    trailingIcon: { default: "ri-arrow-right-s-line" },
    secondaryLabel: { default: void 0 },
    secondaryIcon: { default: void 0 },
    flag: { default: void 0 },
    description: { default: void 0 },
    count: { default: void 0 },
    badge: { default: void 0 },
    checked: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    highlighted: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    danger: { type: Boolean, default: !1 },
    header: { type: Boolean, default: !1 },
    moreActions: { default: void 0 },
    moreActionsLabel: { default: void 0 },
    moreActionsTabindex: { default: void 0 },
    labelWrap: { type: Boolean, default: !1 },
    avatar: { default: void 0 },
    highlight: { default: void 0 },
    keyboardActive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = e, t = Ye(), n = Ye(), l = m(() => a.disabled || a.ariaDisabled || a.loading), o = m(() => a.selected && ["default", "two-icons", "two-labels", "flag", "secondary-text"].includes(a.type)), r = m(() => !!a.description), i = m(() => ["checkbox", "badge-checkbox", "checkbox-badge"].includes(a.type)), s = m(() => a.type === "badge" || a.type === "badge-checkbox"), d = m(() => ["default", "two-icons", "two-labels", "switch", "autocomplete", "secondary-text"].includes(a.type)), c = m(() => a.type === "flag"), f = m(() => a.type === "secondary-text"), g = m(() => a.type === "autocomplete"), h = m(() => !!a.badge && (a.type === "checkbox-badge" || g.value)), v = m(() => {
      if (!g.value || !a.highlight) return null;
      const de = em(a.label ?? "", a.highlight);
      return de.match ? de : null;
    }), p = m(() => {
      var de;
      return a.type === "toggle" && !!((de = a.moreActions) != null && de.length);
    }), y = m(() => a.type === "checkbox" && l.value), k = m(() => {
      var de;
      return l.value ? "disabled" : ((de = a.badge) == null ? void 0 : de.theme) ?? "neutral";
    }), $ = m(() => a.as === "button" ? { type: "button", disabled: a.disabled || void 0, "aria-disabled": a.ariaDisabled ? "true" : void 0 } : { "aria-disabled": a.disabled || a.ariaDisabled ? "true" : void 0 }), S = R(!1), I = R(null), T = m(() => S.value || a.keyboardActive), A = m(() => T.value ? !0 : void 0), E = m(() => {
      var de;
      return T.value && !((de = I.value) != null && de.isTruncated) ? !0 : void 0;
    });
    function z(de) {
      if (de.target === de.currentTarget)
        try {
          S.value = de.target.matches(":focus-visible");
        } catch {
          S.value = !0;
        }
    }
    function B(de) {
      de.target === de.currentTarget && (S.value = !1);
    }
    const W = rn(), _ = m(() => {
      const de = { ...$.value, onFocusin: z, onFocusout: B };
      r.value && Object.assign(de, { "aria-labelledby": t, "aria-describedby": n });
      for (const Ee of Object.keys(de)) de[Ee] === void 0 && delete de[Ee];
      return Ve(W, de);
    }), Z = ({ badge: de, theme: Ee }) => [
      de && gn(mc, {
        label: de.label,
        theme: Ee,
        leftIcon: de.icon,
        rightIcon: de.rightIcon,
        brandIcon: de.brandIcon,
        size: "sm",
        fitWidth: !0,
        class: "min-w-0 max-w-full",
        "aria-hidden": "true",
        "data-testid": "dropdown-list-item-badge"
      }),
      gn("span", { class: "sr-only", "data-testid": "dropdown-list-item-badge-name" }, de == null ? void 0 : de.label)
    ];
    Z.props = ["badge", "theme"];
    const le = m(() => r.value ? "py-2" : g.value ? a.badge ? "py-1.5" : "py-2" : a.type === "switch" || a.type === "toggle" ? "py-[calc(--spacing(1.5)-1px)]" : a.type === "badge" || a.type === "badge-checkbox" || a.type === "checkbox-badge" ? "py-1" : "py-1.5"), D = m(() => l.value ? a.type === "two-labels" ? "text-(--text-text-disabled-strong) dark:text-(--colors-text-disabled)" : "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : o.value ? "text-(--colors-text-accent-strong)" : g.value ? "text-(--text-text-body) dark:text-(--colors-text-white-secondary)" : c.value ? a.highlighted ? "text-(--text-text-black-default) dark:text-(--colors-text-white-default)" : "text-(--text-text-body) group-hover:text-(--text-text-black-default) dark:text-(--colors-text-white-secondary) dark:group-hover:text-(--colors-text-white-default)" : a.type === "toggle" || a.type === "switch" ? "text-(--text-text-heading) dark:text-(--colors-text-white-default)" : "text-(--text-text-black-default) group-hover:text-text-black-default dark:group-hover:text-text-black-default dark:text-(--colors-text-white-default)"), O = yc, N = m(() => l.value ? "cursor-not-allowed" : "cursor-pointer"), V = m(() => [
      "group flex w-full min-w-0 min-h-8 items-center gap-1.5 text-left rounded-(--border-border-radius-rounded-sm) transition-colors",
      // With more actions the item element inside takes the start padding, the focus ring and the cursor.
      p.value ? "pe-2" : ["px-2", le.value, O, N.value],
      D.value,
      !l.value && "hover:bg-background-hover dark:hover:bg-white/8",
      a.highlighted && !l.value && "bg-background-hover dark:bg-white/8",
      a.type === "toggle" && l.value && "bg-(--background-background-white)"
    ]), M = m(() => [
      "self-stretch ps-2 rounded-(--border-border-radius-rounded-sm)",
      le.value,
      O,
      N.value
    ]), Q = m(() => [
      "flex min-w-0 flex-1 items-center text-(length:--size-m) leading-(--line-height-l)",
      a.type === "checkbox-badge" ? "font-(--weight-regular)" : "font-(--weight-medium)",
      a.type === "toggle" ? "gap-2" : "gap-1.5"
    ]), q = m(() => {
      const de = "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)";
      return l.value ? "text-(--icons-icon-disabled-strong) dark:text-(--colors-text-disabled)" : a.danger ? de : o.value ? "text-(--icons-icon-accent-strong) dark:text-(--colors-text-accent-strong)" : "text-(--icons-icon-dark-default) dark:text-(--colors-text-white-default)";
    }), K = m(
      () => a.iconColor && !l.value && !a.danger && !o.value ? nm[a.iconColor] : q.value
    ), G = m(
      () => a.type === "two-labels" && o.value && !l.value ? "text-(--icons-icon-dark-default) dark:text-(--colors-text-white-default)" : q.value
    ), te = m(() => {
      if (a.type === "two-icons") return o.value ? "ri-check-fill" : a.trailingIcon;
      if (a.type === "two-labels") return a.trailingIcon;
      if ((a.type === "default" || c.value || f.value) && o.value) return "ri-check-fill";
    }), ve = m(() => [
      "min-w-0",
      a.labelWrap ? "break-words" : "flex",
      (a.type === "two-labels" || f.value) && "flex-1",
      !a.icon && a.danger && !l.value && "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)"
    ]), Se = m(() => [
      "shrink-0 text-(length:--size-sm) leading-(--line-height-xs) font-(--weight-regular)",
      // Figma Left form Hover/Active turns the count to the label's black.
      l.value ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : a.highlighted ? "text-(--text-text-black-default) dark:text-(--colors-text-white-default)" : "text-(--colors-text-body) dark:text-(--colors-text-white-secondary) group-hover:text-(--text-text-black-default) dark:group-hover:text-(--colors-text-white-default)"
    ]), oe = m(() => l.value ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : a.highlighted ? "text-(--text-text-black-default) dark:text-(--colors-text-white-default)" : "text-(--text-text-body) group-hover:text-(--text-text-black-default) dark:text-(--colors-text-white-secondary) dark:group-hover:text-(--colors-text-white-default)"), re = m(() => l.value ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : o.value ? "text-(--icons-icon-accent-strong) dark:text-(--colors-text-accent-strong)" : "text-(--icons-icon-dark-default) dark:text-(--colors-text-white-default)");
    function ge(de) {
      return de.startsWith("ri-");
    }
    return (de, Ee) => (u(), P(gt(p.value ? "div" : e.as), Ve(p.value ? void 0 : _.value, { class: V.value }), {
      default: me(() => [
        (u(), P(gt(p.value ? e.as : "div"), Ve({ "data-testid": "dropdown-list-item-content" }, p.value ? _.value : void 0, {
          class: p.value ? [Q.value, M.value] : Q.value
        }), {
          default: me(() => [
            i.value ? (u(), b("span", Fk, [
              U(va, {
                presentational: "",
                "model-value": e.checked,
                indeterminate: e.indeterminate,
                disabled: y.value
              }, null, 8, ["model-value", "indeterminate", "disabled"])
            ])) : w("", !0),
            e.type === "toggle" ? (u(), b(ie, { key: 1 }, [
              e.header ? (u(), b("span", Nk)) : (u(), P(Un, {
                key: 1,
                presentational: "",
                class: "shrink-0",
                "data-testid": "dropdown-list-item-toggle",
                "model-value": e.checked,
                disabled: l.value
              }, null, 8, ["model-value", "disabled"]))
            ], 64)) : w("", !0),
            c.value ? (u(), b("span", {
              key: 2,
              class: C(Jk),
              "aria-hidden": "true",
              "data-testid": "dropdown-list-item-flag-box"
            }, [
              e.flag ? (u(), b("span", {
                key: 0,
                class: C(["fi", `fi-${e.flag.toLowerCase()}`, "fis", "rounded-full", "text-[13.33px]"]),
                "data-testid": "dropdown-list-item-flag"
              }, null, 2)) : w("", !0)
            ])) : w("", !0),
            d.value ? (u(), b(ie, { key: 3 }, [
              e.loading ? (u(), b("i", {
                key: 0,
                class: C(["dropdown-icon ri-loader-4-line animate-spin", Wr, q.value]),
                "aria-hidden": "true",
                "data-testid": "dropdown-list-item-icon"
              }, null, 2)) : g.value && e.avatar ? (u(), P(Jt, {
                key: 1,
                name: e.avatar.name,
                img: e.avatar.img,
                logo: e.avatar.logo ?? !1,
                size: "xs",
                presentational: "",
                class: "shrink-0",
                "data-testid": "dropdown-list-item-avatar"
              }, null, 8, ["name", "img", "logo"])) : e.icon ? (u(), b(ie, { key: 2 }, [
                ge(e.icon) ? (u(), b("i", {
                  key: 0,
                  class: C([e.icon, "dropdown-icon", Wr, K.value]),
                  "aria-hidden": "true",
                  "data-testid": "dropdown-list-item-icon"
                }, null, 2)) : (u(), b("img", {
                  key: 1,
                  class: C(["dropdown-icon relative h-4 w-4 shrink-0 transition dark:invert dark:filter", [e.highlighted && "dark:invert-0", l.value ? "opacity-50" : "dark:group-hover:invert-0"]]),
                  src: e.icon,
                  alt: "",
                  "data-testid": "dropdown-list-item-icon"
                }, null, 10, Vk))
              ], 64)) : w("", !0)
            ], 64)) : w("", !0),
            r.value ? (u(), b("span", {
              key: 4,
              class: C(["flex min-w-0 flex-col gap-px", (e.type === "two-labels" || f.value) && "flex-1"])
            }, [
              x("span", {
                id: L(t),
                class: C(ve.value),
                "data-testid": "dropdown-list-item-label"
              }, [
                s.value ? (u(), P(Z, {
                  key: 0,
                  badge: e.badge,
                  theme: k.value
                }, null, 8, ["badge", "theme"])) : e.labelWrap ? (u(), b(ie, { key: 1 }, [
                  st(H(e.label), 1)
                ], 64)) : (u(), P(it, {
                  key: 2,
                  ref_key: "labelRef",
                  ref: I,
                  text: e.label ?? "",
                  focusable: !1,
                  open: A.value
                }, null, 8, ["text", "open"]))
              ], 10, Hk),
              x("span", {
                id: L(n),
                "data-testid": "dropdown-item-description",
                class: C(["text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", !l.value && "text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"])
              }, H(e.description), 11, jk)
            ], 2)) : (u(), b("span", {
              key: 5,
              class: C(ve.value),
              "data-testid": "dropdown-list-item-label"
            }, [
              s.value ? (u(), P(Z, {
                key: 0,
                badge: e.badge,
                theme: k.value
              }, null, 8, ["badge", "theme"])) : v.value ? (u(), b("span", Wk, [
                st(H(v.value.before), 1),
                x("span", qk, H(v.value.match), 1),
                st(H(v.value.after), 1)
              ])) : e.labelWrap ? (u(), b(ie, { key: 2 }, [
                st(H(e.label), 1)
              ], 64)) : (u(), P(it, {
                key: 3,
                ref_key: "labelRef",
                ref: I,
                text: e.label ?? "",
                focusable: !1,
                open: A.value
              }, null, 8, ["text", "open"]))
            ], 2)),
            g.value && e.secondaryLabel ? (u(), b("span", {
              key: 6,
              class: C(["flex min-w-0 text-(length:--size-sm) leading-(--line-height-xs) font-(--weight-regular)", !l.value && "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"]),
              "data-testid": "dropdown-list-item-secondary-label"
            }, [
              U(it, {
                text: e.secondaryLabel,
                focusable: !1,
                open: E.value
              }, null, 8, ["text", "open"])
            ], 2)) : w("", !0),
            f.value && (e.secondaryLabel || e.secondaryIcon) ? (u(), b("span", {
              key: 7,
              class: C(["flex min-w-0 max-w-1/2 shrink items-center justify-end gap-0.5 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", oe.value]),
              "data-testid": "dropdown-list-item-secondary"
            }, [
              e.secondaryIcon ? (u(), b("i", {
                key: 0,
                class: C([e.secondaryIcon, "size-3 shrink-0 text-(length:--size-sm) leading-(--size-sm) inline-flex items-center justify-center", re.value]),
                "aria-hidden": "true",
                "data-testid": "dropdown-list-item-secondary-icon"
              }, null, 2)) : w("", !0),
              e.secondaryLabel ? (u(), b("span", Uk, [
                U(it, {
                  text: e.secondaryLabel,
                  focusable: !1,
                  open: E.value
                }, null, 8, ["text", "open"])
              ])) : w("", !0)
            ], 2)) : w("", !0),
            e.type === "two-labels" && e.secondaryLabel ? (u(), b(ie, { key: 8 }, [
              e.secondaryIcon ? (u(), b("i", {
                key: 0,
                class: C([e.secondaryIcon, Wr, q.value]),
                "aria-hidden": "true",
                "data-testid": "dropdown-list-item-secondary-icon"
              }, null, 2)) : w("", !0),
              x("span", Gk, [
                U(it, {
                  text: e.secondaryLabel,
                  focusable: !1,
                  open: E.value
                }, null, 8, ["text", "open"])
              ])
            ], 64)) : w("", !0)
          ]),
          _: 1
        }, 16, ["class"])),
        e.type === "checkbox" && e.count !== void 0 && e.count !== "" ? (u(), b("span", {
          key: 0,
          class: C(Se.value),
          "data-testid": "dropdown-list-item-count"
        }, H(e.count), 3)) : w("", !0),
        h.value && e.badge ? (u(), b("span", Kk, [
          U(Z, {
            badge: e.badge,
            theme: k.value
          }, null, 8, ["badge", "theme"])
        ])) : w("", !0),
        e.type === "switch" ? (u(), P(Un, {
          key: 2,
          presentational: "",
          class: "ms-auto shrink-0",
          "data-testid": "dropdown-list-item-toggle",
          "model-value": e.checked,
          disabled: l.value
        }, null, 8, ["model-value", "disabled"])) : w("", !0),
        te.value ? (u(), b("i", {
          key: 3,
          class: C([te.value, "ms-auto", Wr, G.value]),
          "aria-hidden": "true",
          "data-testid": "dropdown-list-item-trailing"
        }, null, 2)) : w("", !0),
        p.value ? (u(), b("span", Yk, [
          U(Ra, {
            items: e.moreActions,
            "menu-align": "right"
          }, {
            trigger: me(({ triggerProps: j }) => [
              U(Be, Ve(j, {
                variant: "ghost",
                size: "xs",
                "icon-only": "",
                "icon-left": "ri-more-fill",
                "aria-label": e.moreActionsLabel,
                tabindex: e.moreActionsTabindex,
                "aria-disabled": l.value,
                "data-testid": "dropdown-list-item-more-actions-trigger"
              }), null, 16, ["aria-label", "tabindex", "aria-disabled"])
            ]),
            _: 1
          }, 8, ["items"])
        ])) : w("", !0)
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), Xk = ["role", "data-testid", "data-menu-label", "disabled", "aria-disabled", "aria-current", "aria-describedby"], Zk = { class: "me-auto flex min-w-0 flex-col" }, Qk = ["src"], _k = ["id"], Xf = /* @__PURE__ */ ke({
  __name: "DropdownItemButton",
  props: {
    item: {},
    variant: { default: "default" },
    fallbackTestId: { default: "dropdown-item" },
    selectionStyle: { default: "highlight" }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => !!(t.item.disabled || t.item.loading)), o = m(() => !!t.item.description), r = m(
      () => l.value && (!!t.item.tooltip || o.value)
    ), i = m(() => t.variant === "default" && !t.item.hasSwitch && t.item.active === !0), s = m(() => t.variant === "nav" ? "menuitem" : t.item.hasSwitch ? "menuitemcheckbox" : typeof t.item.active == "boolean" ? "menuitemradio" : "menuitem"), d = m(() => {
      if (s.value === "menuitemcheckbox") return !!t.item.switchChecked;
      if (s.value === "menuitemradio") return t.item.active === !0;
    }), c = m(
      () => t.item.danger && !l.value ? "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)" : void 0
    ), f = m(() => [
      yc,
      // No vertical padding: a Figma Nav link is 20 high, rows 12 apart (pitch 32).
      "min-w-0 p-0",
      l.value ? "cursor-not-allowed text-(--text-text-disabled-strong)" : [
        "cursor-pointer hover:text-(--text-text-hover)",
        t.item.active ? "text-(--text-text-link)" : "text-(--text-text-black-default)"
      ]
    ]), g = m(() => [
      "flex min-w-0 items-center gap-1.5 text-(length:--size-m) leading-(--line-height-l)",
      t.item.active ? "font-(--weight-semi-bold) underline" : "font-(--weight-semi-bold)",
      !l.value && "group-hover:font-(--weight-bold) group-hover:underline"
    ]), h = Ye(), v = m(() => t.variant === "nav" ? t.item.description : void 0), p = R(!1);
    function y(S) {
      try {
        p.value = S.target.matches(":focus-visible");
      } catch {
        p.value = !0;
      }
    }
    function k() {
      l.value || n("click", t.item);
    }
    function $(S) {
      return S.startsWith("ri-");
    }
    return (S, I) => e.variant === "default" ? (u(), P(fa, {
      key: 0,
      as: "button",
      type: e.item.hasSwitch ? "switch" : "default",
      role: s.value,
      "data-testid": e.item.testId || e.fallbackTestId,
      "data-menu-label": e.item.label,
      label: e.item.label,
      icon: e.item.icon,
      description: e.item.description,
      checked: !!e.item.switchChecked,
      selected: i.value && e.selectionStyle === "check",
      highlighted: i.value && e.selectionStyle === "highlight",
      disabled: l.value && !r.value,
      "aria-disabled": r.value,
      loading: e.item.loading,
      danger: e.item.danger,
      "aria-checked": d.value,
      "label-wrap": "",
      onClick: k
    }, null, 8, ["type", "role", "data-testid", "data-menu-label", "label", "icon", "description", "checked", "selected", "highlighted", "disabled", "aria-disabled", "loading", "danger", "aria-checked"])) : (u(), b("button", {
      key: 1,
      type: "button",
      role: s.value,
      "data-testid": e.item.testId || e.fallbackTestId,
      "data-menu-label": e.item.label,
      disabled: r.value ? void 0 : l.value,
      "aria-disabled": r.value ? "true" : void 0,
      "aria-current": e.item.active ? "true" : void 0,
      "aria-describedby": v.value ? L(h) : void 0,
      class: C(["group inline-flex w-full items-center text-left rounded-(--border-border-radius-rounded-sm) transition-colors", f.value]),
      onFocusin: y,
      onFocusout: I[0] || (I[0] = (T) => p.value = !1),
      onClick: k
    }, [
      x("div", Zk, [
        x("div", {
          "data-testid": "dropdown-item-label-row",
          class: C(g.value)
        }, [
          e.item.loading ? (u(), b("i", {
            key: 0,
            class: C(["dropdown-icon ri-loader-4-line animate-spin text-(length:--size-xl) leading-(--line-height-m) size-4.5 inline-flex items-center justify-center shrink-0", c.value]),
            "aria-hidden": "true"
          }, null, 2)) : e.item.icon ? (u(), b(ie, { key: 1 }, [
            $(e.item.icon) ? (u(), b("i", {
              key: 0,
              class: C([e.item.icon, "dropdown-icon text-(length:--size-xl) leading-(--line-height-m) size-4.5 inline-flex items-center justify-center shrink-0", c.value]),
              "aria-hidden": "true"
            }, null, 2)) : (u(), b("img", {
              key: 1,
              class: C(["dropdown-icon relative size-4.5 shrink-0 transition dark:invert dark:filter dark:group-hover:invert-0", e.item.active && "dark:invert-0"]),
              src: e.item.icon,
              alt: ""
            }, null, 10, Qk))
          ], 64)) : w("", !0),
          U(it, {
            text: e.item.label,
            focusable: !1,
            open: p.value || void 0,
            "text-class": e.item.icon ? void 0 : c.value
          }, null, 8, ["text", "open", "text-class"])
        ], 2),
        v.value ? (u(), b("span", {
          key: 0,
          id: L(h),
          "data-testid": "dropdown-item-helper",
          "aria-hidden": "true",
          class: "min-w-0 text-(length:--size-sm) leading-(--line-height-m) font-(--weight-regular) text-(--text-text-body-subtle)"
        }, H(v.value), 9, _k)) : w("", !0)
      ])
    ], 42, Xk));
  }
}), qr = /* @__PURE__ */ ke({
  __name: "DropdownMenuItem",
  props: {
    item: {},
    variant: {},
    fallbackTestId: {},
    selectionStyle: {},
    tooltipRef: { type: Function }
  },
  emits: ["click"],
  setup(e) {
    return (a, t) => e.item.tooltip ? (u(), P($t, {
      key: 0,
      ref: e.tooltipRef,
      text: e.item.tooltip,
      class: "w-full"
    }, {
      default: me(() => [
        U(Xf, {
          item: e.item,
          variant: e.variant,
          "fallback-test-id": e.fallbackTestId,
          "selection-style": e.selectionStyle,
          onClick: t[0] || (t[0] = (n) => a.$emit("click", e.item))
        }, null, 8, ["item", "variant", "fallback-test-id", "selection-style"])
      ]),
      _: 1
    }, 8, ["text"])) : (u(), P(Xf, {
      key: 1,
      item: e.item,
      variant: e.variant,
      "fallback-test-id": e.fallbackTestId,
      "selection-style": e.selectionStyle,
      onClick: t[1] || (t[1] = (n) => a.$emit("click", e.item))
    }, null, 8, ["item", "variant", "fallback-test-id", "selection-style"]));
  }
}), ew = {}, tw = {
  class: "w-full py-1",
  "data-testid": "dropdown-separator",
  "aria-hidden": "true"
};
function aw(e, a) {
  return u(), b("div", tw, [...a[0] || (a[0] = [
    x("div", { class: "border-t border-(--border-border-base-soft) dark:border-(--colors-border-base)" }, null, -1)
  ])]);
}
const Zf = /* @__PURE__ */ Ct(ew, [["render", aw]]);
function ll(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").toLowerCase();
}
function kc(e, a) {
  return ll(e).includes(ll(a.trim()));
}
function nw(e) {
  return typeof e.getModifierState == "function" && e.getModifierState("AltGraph") ? !0 : e.ctrlKey && e.altKey;
}
function wc(e = 500) {
  const a = R("");
  let t = null;
  function n() {
    a.value = "", t && (clearTimeout(t), t = null);
  }
  function l() {
    t && clearTimeout(t), t = setTimeout(n, e);
  }
  zt(() => {
    t && clearTimeout(t);
  });
  function o(r) {
    if (r.repeat) return !1;
    if (r.key === "Backspace")
      return a.value ? (a.value = a.value.slice(0, -1), a.value ? l() : n(), !0) : !1;
    if (r.isComposing) return !1;
    const i = nw(r);
    return r.key.length !== 1 || r.metaKey || r.ctrlKey && !i || r.altKey && !i ? !1 : (a.value += r.key, l(), !0);
  }
  return { query: a, handleKey: o, reset: n };
}
const lw = {
  key: 0,
  class: "flex items-center"
}, ow = { class: "flex items-center gap-0.5" }, rw = { class: "relative leading-(--line-height-l) font-(--weight-medium) dark:text-(--colors-text-white-default)" }, iw = {
  key: 0,
  class: "relative leading-(--line-height-l) font-(--weight-medium) dark:text-(--colors-text-white-default)"
}, sw = ["id", "aria-expanded", "aria-label"], dw = {
  key: 1,
  class: "flex items-center gap-1.5 px-3 py-1 text-(length:--size-sm) leading-(--line-height-l)"
}, uw = ["src"], cw = {
  key: 1,
  class: "relative leading-(--line-height-l) font-(--weight-medium) dark:text-(--colors-text-white-default)"
}, fw = ["title"], hw = ["src"], bw = ["src"], gw = ["role", "aria-labelledby", "aria-label", "data-focus-trap-return"], mw = {
  key: 0,
  class: "flex w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) bg-(--colors-background-white-secondary) p-2 px-3"
}, vw = { class: "flex min-w-0 flex-1 flex-col gap-0.5 text-(length:--size-m) leading-(--line-height-l)" }, pw = { class: "truncate font-(--weight-semi-bold) text-(--colors-text-heading)" }, xw = { class: "truncate font-(--weight-regular) text-(--colors-text-body)" }, yw = {
  key: 1,
  class: "absolute top-3 right-3"
}, kw = {
  key: 2,
  role: "presentation",
  "data-testid": "dropdown-menu-header",
  class: "flex h-4 w-full items-end px-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, ww = ["id"], Cw = { class: "overflow-y-auto flex-1 min-h-0 pr-[calc(var(--spacing-6)-1px)] -my-0.5 -ml-0.5 py-0.5 pl-0.5" }, Sw = {
  key: 0,
  "data-testid": "dropdown-megamenu-col-header",
  role: "presentation",
  class: "leading-(--line-height-l) font-(--weight-semi-bold) text-(length:--size-sm) text-(--colors-text-body-subtle)"
}, $w = {
  key: 1,
  class: "flex flex-col gap-3 sm:flex-row sm:items-start sm:gap-5"
}, Iw = ["role", "aria-label"], Lw = { class: "w-full" }, ad = 5, Ra = /* @__PURE__ */ ke({
  __name: "Dropdown",
  props: {
    label: { default: "Dropdown" },
    triggerIconLeft: { default: void 0 },
    triggerIcon: { default: void 0 },
    triggerIconInfo: { default: void 0 },
    triggerIconInfoTooltip: { default: void 0 },
    items: { default: () => [] },
    groups: { default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    menuWidth: { default: "auto" },
    fullWidth: { type: Boolean, default: !1 },
    menuAlign: { default: "left" },
    fieldLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    avatar: { default: void 0 },
    ghost: { type: Boolean, default: !1 },
    tab: { type: Boolean, default: !1 },
    profileType: { default: void 0 },
    ariaLabel: { default: void 0 },
    menuHeader: { default: void 0 },
    bare: { type: Boolean, default: !1 },
    menuItemVariant: { default: "default" },
    selectionStyle: { default: "highlight" },
    columns: { default: void 0 },
    closeable: { type: Boolean, default: !1 },
    closeLabel: { default: void 0 },
    menuOffset: { default: 4 },
    menuReference: { default: null },
    menuSide: { default: "bottom" }
  },
  setup(e, { expose: a }) {
    const t = e, n = m(() => {
      var F;
      if (t.ariaLabel) return t.ariaLabel;
      if (t.avatar) {
        const ee = (F = t.avatar.name) == null ? void 0 : F.trim();
        return ee ? `Open account menu, ${ee}` : "Open account menu";
      }
    }), l = (F) => {
      var ee;
      ((ee = F.currentTarget) == null ? void 0 : ee.getAttribute("aria-disabled")) !== "true" && !o.value && (F.key === "ArrowDown" || F.key === "ArrowUp") && (F.preventDefault(), o.value = !0);
    }, o = R(t.defaultOpen), r = R(null), i = R(null), s = R(null), d = R(null), c = m(() => !t.tab && !t.avatar), f = () => {
      var F;
      return ((F = s.value) == null ? void 0 : F.$el) ?? i.value;
    }, g = Ye(), h = Ye(), v = R(void 0), p = () => {
      o.value = !o.value;
    }, y = () => {
      o.value = !1;
    }, k = m(() => ({
      id: h,
      "aria-haspopup": "menu",
      "aria-expanded": o.value,
      onClick: p,
      onKeydown: l
    })), $ = (F) => {
      var X, ae;
      const ee = F.target, ue = ((X = d.value) == null ? void 0 : X.contains(ee)) ?? !1, se = ((ae = r.value) == null ? void 0 : ae.contains(ee)) ?? !1;
      !ue && !se && y();
    };
    kt(() => document.addEventListener("mousedown", $)), zt(() => document.removeEventListener("mousedown", $));
    let S = null;
    const I = () => {
      const F = t.menuReference ?? f() ?? d.value;
      if (!F || !r.value) return;
      S == null || S.destroy();
      const ee = t.menuSide, ue = ee === "top" ? "bottom" : "top", se = t.menuAlign === "right" ? "end" : "start", X = t.menuAlign === "right" ? "start" : "end";
      S = fl(F, r.value, {
        strategy: "fixed",
        placement: `${ee}-${se}`,
        modifiers: [
          { name: "offset", options: { offset: [0, t.menuOffset] } },
          { name: "flip", options: { fallbackPlacements: [`${ee}-${X}`, `${ue}-${se}`, `${ue}-${X}`] } },
          { name: "preventOverflow", options: { padding: 8 } },
          // Disable GPU acceleration so Popper uses top/left instead of transform,
          // avoiding conflict with the Vue Transition's transform: scale(...)
          { name: "computeStyles", options: { gpuAcceleration: !1 } }
        ]
      });
    };
    let T = null;
    const A = () => {
      T == null || T.disconnect(), !(!t.menuReference || typeof ResizeObserver > "u") && (T ?? (T = new ResizeObserver(() => S == null ? void 0 : S.update())), T.observe(t.menuReference));
    }, E = () => {
      S == null || S.destroy(), S = null, T == null || T.disconnect();
    };
    $e(
      () => [t.menuReference, t.menuSide, t.menuAlign, t.menuOffset],
      () => {
        o.value && (I(), A());
      }
    ), $e(o, async (F) => {
      var ee;
      F ? (re = !1, v.value = ((ee = Ee()) == null ? void 0 : ee.id) || void 0, await Ze(), I(), A(), B()) : (W.reset(), E());
    }), kt(() => {
      var F;
      o.value && (v.value = ((F = Ee()) == null ? void 0 : F.id) || void 0, Ze(I));
    }), zt(() => E());
    const z = () => r.value ? Array.from(
      r.value.querySelectorAll(
        '[role="menuitem"]:not([disabled]), [role="menuitemradio"]:not([disabled]), [role="menuitemcheckbox"]:not([disabled])'
      )
    ) : [], B = () => {
      Ze(() => {
        var ee;
        const F = z();
        (ee = F.find((ue) => ue.getAttribute("role") === "menuitemradio" && ue.getAttribute("aria-checked") === "true") ?? F[0]) == null || ee.focus();
      });
    }, W = wc(), _ = (F, ee) => {
      const ue = ll(W.query.value), se = ue.length === 1 ? ee + 1 : ee;
      for (let X = 0; X < F.length; X++) {
        const ae = F[(se + X) % F.length];
        if (ll(ae.dataset.menuLabel ?? ae.textContent ?? "").trim().startsWith(ue)) {
          ae.focus();
          return;
        }
      }
    }, Z = (F) => {
      var ue;
      const ee = z();
      (ue = ee[Math.max(0, Math.min(F, ee.length - 1))]) == null || ue.focus();
    }, le = (F) => {
      if (!o.value) {
        F.key === "Tab" && j();
        return;
      }
      const ee = z(), ue = document.activeElement, se = ee.indexOf(ue);
      if (se !== -1 && !(F.key === " " && !W.query.value) && W.handleKey(F)) {
        F.preventDefault(), _(ee, se);
        return;
      }
      switch (F.key) {
        case "ArrowDown":
          F.preventDefault(), Z(se < ee.length - 1 ? se + 1 : 0);
          break;
        case "ArrowUp":
          F.preventDefault(), Z(se > 0 ? se - 1 : ee.length - 1);
          break;
        case "Home":
          F.preventDefault(), Z(0);
          break;
        case "End":
          F.preventDefault(), Z(ee.length - 1);
          break;
        case "Escape":
          V(F);
          break;
        case "Tab":
          j(), y();
          break;
      }
    }, D = /* @__PURE__ */ new Map(), O = (F) => (ee) => {
      ee ? D.set(F, ee) : D.delete(F);
    }, N = () => {
      for (const F of D.values())
        if (F.isVisible) return F;
    }, V = (F) => {
      F.stopPropagation(), F.preventDefault();
      const ee = N();
      if (ee) {
        ee.hide();
        return;
      }
      ge();
    }, M = (F) => {
      o.value && V(F);
    }, Q = m(() => {
      var ee;
      if (!t.columns || !((ee = t.groups) != null && ee.length)) return null;
      const F = t.groups.filter((ue) => ue.items.length > 0);
      return F.length > 0 ? F : null;
    }), q = m(
      () => Q.value ? Math.min(Q.value.length, t.columns ?? Q.value.length) : 0
    ), K = m(() => {
      var ee;
      if (t.columns || !((ee = t.groups) != null && ee.length)) return null;
      const F = t.groups.filter((ue) => ue.items.length > 0);
      return F.length > 0 ? F : null;
    }), G = m(() => {
      if (!t.columns || Q.value) return null;
      const F = Math.max(1, t.columns), ee = Math.min(F, Math.max(1, Math.ceil(t.items.length / ad))), ue = t.items.length > ad * F ? Math.ceil(t.items.length / F) : ad, se = Array.from({ length: ee }, () => []);
      return t.items.forEach((X, ae) => {
        var Re;
        (Re = se[Math.min(Math.floor(ae / ue), ee - 1)]) == null || Re.push(X);
      }), se.filter((X) => X.length > 0);
    }), te = m(() => {
      var F;
      return Q.value ? q.value : ((F = G.value) == null ? void 0 : F.length) ?? 0;
    }), ve = m(() => te.value > 2), Se = m(() => !!(Q.value || G.value)), oe = (F) => {
      F.disabled || F.loading || (F.onClick && F.onClick(), (!F.hasSwitch || t.menuItemVariant === "nav") && ge());
    };
    let re = !1;
    const ge = () => {
      re = !0, y();
    }, de = () => {
      if (!re) return;
      re = !1;
      const F = document.activeElement;
      F && F !== document.body || j();
    }, Ee = () => {
      var F;
      return f() ?? ((F = d.value) == null ? void 0 : F.querySelector('button, [tabindex="0"], [tabindex]:not([tabindex="-1"])'));
    }, j = () => {
      var F;
      return (F = Ee()) == null ? void 0 : F.focus();
    }, J = m(() => t.menuSide === "top" ? t.menuAlign === "right" ? "origin-bottom-right" : "origin-bottom-left" : t.menuAlign === "right" ? "origin-top-right" : "origin-top-left"), ne = m(() => {
      var F;
      return t.fullWidth ? { width: `${((F = d.value) == null ? void 0 : F.offsetWidth) ?? 0}px` } : t.menuWidth !== "auto" ? { width: t.menuWidth } : t.columns || t.bare ? {} : { minWidth: "208px", maxWidth: "320px" };
    }), Y = (F) => !!F && F.startsWith("ri-");
    return a({ isOpen: o, close: y }), (F, ee) => (u(), b("div", {
      class: C(["text-text-black-default relative text-left dark:text-(--colors-text-white-default)", [e.tab ? "flex h-full items-stretch" : "inline-block", { "w-full": e.fullWidth }]]),
      onKeydown: St(M, ["escape"])
    }, [
      e.fieldLabel ? (u(), b("div", lw, [
        x("div", ow, [
          x("div", rw, H(e.fieldLabel), 1),
          e.required ? (u(), b("div", iw, " * ")) : w("", !0)
        ])
      ])) : w("", !0),
      x("div", {
        class: C(["text-text-black-default relative flex flex-col items-start text-left dark:text-(--colors-text-white-default)", { "w-full": e.fullWidth, "h-full": e.tab }])
      }, [
        x("div", {
          ref_key: "triggerWrapperRef",
          ref: d,
          class: C({ "w-full": e.fullWidth, "h-full": e.tab })
        }, [
          Me(F.$slots, "trigger", {
            toggle: p,
            isOpen: o.value,
            triggerProps: k.value
          }, () => [
            c.value ? (u(), P(Be, Ve({
              key: 0,
              ref_key: "triggerButtonRef",
              ref: s,
              "data-testid": "dropdown-trigger",
              size: "xs",
              variant: e.ghost ? "ghost" : "secondary",
              label: e.label,
              "icon-left": e.triggerIconLeft,
              "icon-right": e.triggerIcon,
              "dropdown-icon": !!e.label && !e.triggerIcon,
              "icon-only": !e.label,
              "aria-label": e.ariaLabel,
              "full-width": e.fullWidth
            }, k.value), null, 16, ["variant", "label", "icon-left", "icon-right", "dropdown-icon", "icon-only", "aria-label", "full-width"])) : (u(), b("button", {
              key: 1,
              id: L(h),
              ref_key: "triggerRef",
              ref: i,
              type: "button",
              "data-testid": "dropdown-trigger",
              class: C(["focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue z-0 cursor-pointer transition-colors", [
                e.tab ? "focus-visible:ring-inset shrink-0 h-full flex items-center rounded-tl-(--border-border-radius-rounded-sm) rounded-tr-(--border-border-radius-rounded-sm) border-t border-r border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(--colors-text-black-default) hover:bg-whitesmoke dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10 duration-200" : [
                  "focus-visible:ring-offset-2 rounded-(--border-border-radius-rounded-full) border border-solid duration-300",
                  "border-border-secondary-button hover:border-royalblue bg-white dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)"
                ],
                {
                  "w-full justify-between": e.fullWidth,
                  "justify-center": !e.fullWidth && !e.tab
                }
              ]]),
              "aria-expanded": o.value,
              "aria-haspopup": "menu",
              "aria-label": n.value,
              onClick: p,
              onKeydown: l
            }, [
              t.avatar ? (u(), P(Jt, {
                key: 0,
                presentational: "",
                as: "span",
                name: t.avatar.name,
                img: t.avatar.img
              }, null, 8, ["name", "img"])) : (u(), b("div", dw, [
                e.triggerIconLeft ? (u(), b(ie, { key: 0 }, [
                  Y(e.triggerIconLeft) ? (u(), b("i", {
                    key: 0,
                    class: C([e.triggerIconLeft, "dropdown-icon text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center"])
                  }, null, 2)) : (u(), b("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4 w-4",
                    src: e.triggerIconLeft,
                    alt: ""
                  }, null, 8, uw))
                ], 64)) : w("", !0),
                e.label ? (u(), b("div", cw, H(e.label), 1)) : w("", !0),
                e.triggerIconInfo ? (u(), b("span", {
                  key: 2,
                  class: "inline-flex items-center",
                  title: e.triggerIconInfoTooltip,
                  onClick: ee[0] || (ee[0] = _e(() => {
                  }, ["stop"]))
                }, [
                  Y(e.triggerIconInfo) ? (u(), b("i", {
                    key: 0,
                    class: C([e.triggerIconInfo, "dropdown-icon text-(length:--size-xl) leading-(--size-xl) size-(--size-xl) inline-flex items-center justify-center"])
                  }, null, 2)) : (u(), b("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4.5 w-4.5",
                    src: e.triggerIconInfo,
                    alt: ""
                  }, null, 8, hw))
                ], 8, fw)) : w("", !0),
                e.triggerIcon ? (u(), b(ie, { key: 3 }, [
                  Y(e.triggerIcon) ? (u(), b("i", {
                    key: 0,
                    class: C([
                      e.triggerIcon,
                      "dropdown-icon text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center transition-transform duration-200 ease-in-out"
                    ]),
                    style: Ge({ transform: o.value ? "rotate(180deg)" : "rotate(0deg)" })
                  }, null, 6)) : (u(), b("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4 w-4 transition-transform duration-200 ease-in-out",
                    style: Ge({ transform: o.value ? "rotate(180deg)" : "rotate(0deg)" }),
                    src: e.triggerIcon,
                    alt: ""
                  }, null, 12, bw))
                ], 64)) : e.label ? (u(), b("svg", {
                  key: 4,
                  class: "relative h-4 w-4 transition-transform duration-200 ease-in-out",
                  style: Ge({ transform: o.value ? "rotate(180deg)" : "rotate(0deg)" }),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [...ee[1] || (ee[1] = [
                  x("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  }, null, -1)
                ])], 4)) : w("", !0)
              ]))
            ], 42, sw))
          ])
        ], 2),
        (u(), P(Fa, { to: "body" }, [
          U(Wt, {
            "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0",
            onAfterLeave: de
          }, {
            default: me(() => [
              o.value ? (u(), b("div", {
                key: 0,
                ref_key: "menuRef",
                ref: r,
                role: e.bare ? void 0 : "menu",
                "aria-labelledby": Se.value ? L(g) : e.bare ? void 0 : v.value,
                "aria-label": e.bare || Se.value ? void 0 : e.ariaLabel,
                "data-focus-trap-return": v.value,
                "data-testid": "dropdown-menu",
                "data-focus-trap-allow-outside": "",
                class: C(["fixed z-[350]", [
                  Se.value ? L(Mk) : L(hl),
                  L(xc),
                  J.value,
                  Se.value && "relative flex flex-col pt-[calc(var(--spacing-6)-1px)] pb-[calc(var(--spacing-6)-1px)] pl-[calc(var(--spacing-6)-1px)] max-h-[calc(100vh-90px)] max-w-[calc(100vw-32px)]",
                  !e.bare && !Se.value && [L(am), "max-h-[min(400px,calc(100vh-24px))] items-start overflow-y-auto"],
                  e.bare && "max-h-[calc(100vh-90px)] overflow-y-auto"
                ]]),
                style: Ge(ne.value),
                onKeydown: le
              }, [
                t.avatar ? (u(), b("div", mw, [
                  U(Jt, {
                    name: t.avatar.name,
                    img: t.avatar.img,
                    presentational: ""
                  }, null, 8, ["name", "img"]),
                  x("div", vw, [
                    x("div", pw, H(t.avatar.name), 1),
                    x("div", xw, H(t.avatar.email), 1)
                  ]),
                  t.profileType ? (u(), P(yt, {
                    key: 0,
                    class: "ms-auto",
                    theme: "white",
                    size: "sm",
                    label: t.profileType
                  }, null, 8, ["label"])) : w("", !0)
                ])) : w("", !0),
                e.closeable ? (u(), b("div", yw, [
                  U(Be, {
                    "data-testid": "dropdown-close",
                    variant: "ghost",
                    "icon-only": "",
                    size: "sm",
                    "icon-left": "ri-close-fill",
                    "aria-label": e.closeLabel,
                    onClick: y
                  }, null, 8, ["aria-label"])
                ])) : w("", !0),
                e.menuHeader && !t.avatar && !Se.value ? (u(), b("div", kw, H(e.menuHeader), 1)) : w("", !0),
                Me(F.$slots, "menu", { close: y }, () => [
                  Se.value ? (u(), b(ie, { key: 0 }, [
                    x("div", {
                      class: C(["mb-5", e.closeable ? "pr-[calc(var(--spacing-16)-1px)]" : "pr-[calc(var(--spacing-6)-1px)]"])
                    }, [
                      x("h5", {
                        id: L(g),
                        class: "text-(length:--size-xl) font-(--weight-semi-bold)",
                        style: { color: "var(--text-text-black-default)", "line-height": "var(--line-height-xl)" }
                      }, H(e.menuHeader), 9, ww)
                    ], 2),
                    x("div", Cw, [
                      Q.value ? (u(), b("div", {
                        key: 0,
                        "data-testid": "dropdown-megamenu-groups",
                        class: "grid grid-cols-1 gap-y-3 sm:grid-cols-[repeat(var(--dropdown-megamenu-cols),minmax(0,var(--dropdown-megamenu-col-w)))] sm:gap-x-5",
                        style: Ge({
                          "--dropdown-megamenu-cols": q.value,
                          "--dropdown-megamenu-col-w": ve.value ? "240px" : "275px"
                        })
                      }, [
                        (u(!0), b(ie, null, Oe(Q.value, (ue) => (u(), b("div", {
                          key: ue.key,
                          "data-testid": "dropdown-megamenu-col",
                          class: "flex flex-col items-start gap-3 min-w-0"
                        }, [
                          ue.label ? (u(), b("div", Sw, H(ue.label), 1)) : w("", !0),
                          (u(!0), b(ie, null, Oe(ue.items, (se, X) => (u(), P(qr, {
                            key: X,
                            item: se,
                            variant: e.menuItemVariant,
                            "selection-style": e.selectionStyle,
                            "tooltip-ref": O(`${ue.key}-${X}`),
                            "fallback-test-id": "dropdown-megamenu-item",
                            onClick: (ae) => oe(se)
                          }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"]))), 128))
                        ]))), 128))
                      ], 4)) : (u(), b("div", $w, [
                        (u(!0), b(ie, null, Oe(G.value, (ue, se) => (u(), b("div", {
                          key: se,
                          "data-testid": "dropdown-megamenu-col",
                          class: C(["flex flex-col items-start gap-3 w-full shrink-0 sm:shrink sm:min-w-0", ve.value ? "sm:w-60" : "sm:w-68.75"])
                        }, [
                          (u(!0), b(ie, null, Oe(ue, (X, ae) => (u(), P(qr, {
                            key: ae,
                            item: X,
                            variant: e.menuItemVariant,
                            "selection-style": e.selectionStyle,
                            "tooltip-ref": O(`col-${se}-${ae}`),
                            "fallback-test-id": "dropdown-megamenu-item",
                            onClick: (Re) => oe(X)
                          }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"]))), 128))
                        ], 2))), 128))
                      ]))
                    ])
                  ], 64)) : K.value ? (u(!0), b(ie, { key: 1 }, Oe(K.value, (ue, se) => (u(), b(ie, {
                    key: ue.key
                  }, [
                    se > 0 ? (u(), P(Zf, { key: 0 })) : w("", !0),
                    x("div", {
                      class: "flex w-full flex-col gap-1.5",
                      role: ue.items.length > 1 && ue.label ? "group" : void 0,
                      "aria-label": ue.items.length > 1 && ue.label ? ue.label : void 0
                    }, [
                      (u(!0), b(ie, null, Oe(ue.items, (X, ae) => (u(), P(qr, {
                        key: ae,
                        item: X,
                        variant: e.menuItemVariant,
                        "selection-style": e.selectionStyle,
                        "tooltip-ref": O(`group-${ue.key}-${ae}`),
                        "fallback-test-id": "dropdown-item",
                        onClick: (Re) => oe(X)
                      }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"]))), 128))
                    ], 8, Iw)
                  ], 64))), 128)) : (u(!0), b(ie, { key: 2 }, Oe(e.items, (ue, se) => (u(), b(ie, { key: se }, [
                    x("div", Lw, [
                      U(qr, {
                        item: ue,
                        variant: e.menuItemVariant,
                        "selection-style": e.selectionStyle,
                        "tooltip-ref": O(`flat-${se}`),
                        "fallback-test-id": "dropdown-item",
                        onClick: (X) => oe(ue)
                      }, null, 8, ["item", "variant", "selection-style", "tooltip-ref", "onClick"])
                    ]),
                    ue.hasDividerAfter && se < e.items.length - 1 ? (u(), P(Zf, { key: 0 })) : w("", !0)
                  ], 64))), 128))
                ])
              ], 46, gw)) : w("", !0)
            ]),
            _: 3
          })
        ]))
      ], 2)
    ], 34));
  }
}), lm = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LinkBase",
  props: {
    as: { default: "button" },
    iconLeft: {},
    iconRight: {},
    size: { default: "m" },
    ariaLabel: {},
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: [Boolean, String], default: !1 },
    underline: {}
  },
  setup(e) {
    const a = e, t = m(() => a.disabled && a.as === "button"), n = m(() => !!a.ariaDisabled && a.ariaDisabled !== "false"), l = m(() => a.disabled || n.value), o = rn();
    function r() {
      const g = l.value ? _g(o) : o;
      return { ...a.as === "button" ? { type: "button" } : {}, ...g };
    }
    const i = {
      s: "text-(length:--size-sm) leading-(--line-height-l)",
      m: "text-(length:--size-m) leading-(--line-height-l)",
      l: "text-(length:--size-l) leading-(--line-height-xxl)"
    }, s = m(() => [
      "group/link inline-flex items-center gap-1.5 py-0.5 font-(--weight-medium) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
      i[a.size],
      l.value ? "cursor-not-allowed text-(--text-text-disabled-strong)" : "cursor-pointer text-(--text-text-link) hover:text-(--text-text-hover)"
    ]), d = m(() => [
      "text-num-16",
      l.value ? "text-(--icons-icon-disabled-strong)" : "text-(--icons-icon-link) group-hover/link:text-(--icons-icon-hover)"
    ]), c = m(() => a.underline === "always" ? "underline" : l.value ? "" : "group-hover/link:underline group-focus-visible/link:underline");
    function f(g) {
      l.value && g.preventDefault();
    }
    return (g, h) => (u(), P(gt(e.as), Ve(r(), {
      "aria-label": e.ariaLabel,
      disabled: t.value || void 0,
      "aria-disabled": l.value && !t.value ? "true" : void 0,
      class: s.value,
      onClickCapture: f,
      onAuxclickCapture: f
    }), {
      default: me(() => [
        e.iconLeft ? (u(), b("i", {
          key: 0,
          class: C([e.iconLeft, d.value]),
          "aria-hidden": "true"
        }, null, 2)) : w("", !0),
        x("span", {
          class: C(["min-w-0", c.value])
        }, [
          Me(g.$slots, "default")
        ], 2),
        e.iconRight ? (u(), b("i", {
          key: 1,
          class: C([e.iconRight, d.value]),
          "aria-hidden": "true"
        }, null, 2)) : w("", !0)
      ]),
      _: 3
    }, 16, ["aria-label", "disabled", "aria-disabled", "class"]));
  }
}), pa = /* @__PURE__ */ ke({
  __name: "TextLink",
  props: {
    as: {},
    iconLeft: {},
    iconRight: {},
    size: {},
    ariaLabel: {},
    disabled: { type: Boolean },
    ariaDisabled: { type: [Boolean, String] }
  },
  setup(e) {
    const a = e;
    return (t, n) => (u(), P(lm, Ve(a, { underline: "hover" }), {
      default: me(() => [
        Me(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), om = /* @__PURE__ */ ke({
  __name: "FieldLabelTooltip",
  props: {
    text: {}
  },
  setup(e) {
    return (a, t) => (u(), P($t, {
      as: "span",
      text: e.text,
      class: "shrink-0",
      "data-field-label-tooltip": "",
      tabindex: "0",
      role: "group",
      "aria-label": e.text
    }, {
      default: me(() => [...t[0] || (t[0] = [
        x("i", {
          class: "ri-information-line inline-flex size-3.5 shrink-0 items-center justify-center cursor-help text-(length:--size-m) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
          "aria-hidden": "true"
        }, null, -1)
      ])]),
      _: 1
    }, 8, ["text", "aria-label"]));
  }
}), Tw = {
  key: 1,
  class: "sr-only"
}, Ft = /* @__PURE__ */ ke({
  __name: "FieldLabel",
  props: {
    text: {},
    inputId: { default: void 0 },
    id: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    tooltip: { default: void 0 },
    focused: { type: Boolean, default: !1 },
    inline: { type: Boolean, default: !1 },
    testId: { default: void 0 },
    secondaryText: { default: void 0 },
    secondaryPosition: { default: "right" },
    textClass: { default: void 0 },
    as: { default: "div" }
  },
  setup(e, { expose: a }) {
    const t = e, n = R(null), l = R(!1), o = m(() => l.value ? !1 : t.focused ? !0 : void 0);
    $e(
      () => t.focused,
      (d) => {
        d || (l.value = !1);
      }
    ), a({ handleFieldKeydown: (d) => {
      var c;
      d.key !== "Escape" || l.value || !t.focused || !((c = n.value) != null && c.isTruncated) || (d.stopPropagation(), d.preventDefault(), l.value = !0);
    } });
    const i = m(
      () => t.textClass ?? "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)"
    ), s = m(() => t.secondaryText && t.secondaryPosition === "below" ? [
      "grid min-w-0 max-w-full grid-cols-[minmax(0,auto)_auto] items-center justify-start gap-1",
      t.inline ? "shrink-0" : ""
    ] : [
      "flex min-w-0 max-w-full items-center gap-1",
      t.inline ? "shrink-0" : "",
      t.secondaryText && !t.inline ? "w-full" : ""
    ]);
    return (d, c) => (u(), P(gt(e.as), {
      class: C(s.value)
    }, {
      default: me(() => [
        (u(), P(gt(e.inputId ? "label" : "span"), {
          id: e.id,
          for: e.inputId,
          "data-testid": e.testId,
          class: "flex min-w-0 items-center text-(--text-text-black-default) dark:text-(--colors-text-white-default)"
        }, {
          default: me(() => [
            U(it, {
              ref_key: "labelRef",
              ref: n,
              text: e.text,
              lines: 1,
              "text-class": i.value,
              focusable: !1,
              open: o.value
            }, null, 8, ["text", "text-class", "open"]),
            e.required ? (u(), b("span", {
              key: 0,
              class: C(["shrink-0 whitespace-pre", i.value])
            }, H(` ${e.requiredIndicator}`), 3)) : w("", !0),
            e.secondaryText ? (u(), b("span", Tw, H(` ${e.secondaryText}`), 1)) : w("", !0)
          ]),
          _: 1
        }, 8, ["id", "for", "data-testid"])),
        e.tooltip ? (u(), P(om, {
          key: 0,
          text: e.tooltip
        }, null, 8, ["text"])) : w("", !0),
        e.secondaryText ? (u(), b("span", {
          key: 1,
          "aria-hidden": "true",
          class: C([
            "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--colors-text-white-default)",
            e.secondaryPosition === "below" ? "col-span-full min-w-0 break-words" : "ml-auto shrink-0 whitespace-nowrap"
          ])
        }, H(e.secondaryText), 3)) : w("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Ew = ["data-type"], Aw = ["id"], Dl = /* @__PURE__ */ ke({
  __name: "DropdownPanelFooter",
  props: {
    type: {},
    buttons: { default: () => {
    } },
    label: { default: () => {
    } },
    seeAllLabel: { default: () => {
    } },
    createLabel: { default: () => {
    } },
    createIcon: { default: "ri-add-line" },
    seeAllOption: { default: () => {
    } },
    createOption: { default: () => {
    } },
    description: { default: () => {
    } }
  },
  emits: ["button-click", "see-all", "create", "option-hover"],
  setup(e, { emit: a }) {
    const t = Ye(), n = (o, r) => o ? {
      id: o.id,
      role: "option",
      "aria-selected": !!o.active,
      "aria-label": r,
      "data-testid": o.testId,
      class: [
        "w-full rounded-(--border-border-radius-rounded-full)",
        o.active && "shadow-(--shadow-focus-l)"
      ]
    } : { class: "contents" }, l = a;
    return (o, r) => (u(), b("div", {
      "data-testid": "dropdown-panel-footer",
      "data-type": e.type,
      class: C([
        "relative flex flex-col gap-1.5 rounded-b-(--border-border-radius-rounded-l) bg-(--background-background-white) px-3 py-4 shadow-(--blur-shadow-m) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
        e.label ? "items-start" : ""
      ])
    }, [
      e.label ? (u(), P(Ft, {
        key: 0,
        text: e.label,
        "test-id": "dropdown-panel-footer-label"
      }, null, 8, ["text"])) : w("", !0),
      e.type === "see-all-create" ? (u(), b(ie, { key: 1 }, [
        e.seeAllLabel ? (u(), b("div", Ve({ key: 0 }, n(e.seeAllOption, e.seeAllLabel), {
          onMouseenter: r[1] || (r[1] = (i) => e.seeAllOption && l("option-hover", "see-all"))
        }), [
          U(Be, {
            variant: "secondary",
            size: "md",
            "icon-left": "ri-eye-line",
            label: e.seeAllLabel,
            "full-width": "",
            tabindex: e.seeAllOption ? -1 : void 0,
            "aria-hidden": e.seeAllOption ? "true" : void 0,
            "data-testid": "dropdown-panel-footer-see-all",
            onClick: r[0] || (r[0] = (i) => l("see-all"))
          }, null, 8, ["label", "tabindex", "aria-hidden"])
        ], 16)) : w("", !0),
        e.createLabel ? (u(), b("div", Ve({ key: 1 }, n(e.createOption, e.createLabel), {
          onMouseenter: r[3] || (r[3] = (i) => e.createOption && l("option-hover", "create"))
        }), [
          U(pa, {
            size: "m",
            "icon-left": e.createIcon,
            class: "w-full justify-center",
            tabindex: e.createOption ? -1 : void 0,
            "aria-hidden": e.createOption ? "true" : void 0,
            "data-testid": "dropdown-panel-footer-create",
            onClick: r[2] || (r[2] = (i) => l("create"))
          }, {
            default: me(() => [
              st(H(e.createLabel), 1)
            ]),
            _: 1
          }, 8, ["icon-left", "tabindex", "aria-hidden"])
        ], 16)) : w("", !0)
      ], 64)) : e.buttons ? (u(), b("div", {
        key: 2,
        "data-testid": "dropdown-panel-footer-buttons",
        class: C(e.type === "buttons-inline" ? "flex w-full gap-1.5" : "flex w-full flex-col gap-3")
      }, [
        (u(!0), b(ie, null, Oe(e.buttons, (i, s) => (u(), P(Be, {
          key: s,
          variant: i.variant ?? "secondary",
          size: "sm",
          label: i.label,
          "icon-left": i.icon,
          disabled: i.disabled,
          "aria-disabled": i.ariaDisabled,
          "aria-describedby": i.ariaDisabled && e.description ? L(t) : void 0,
          "full-width": "",
          shrink: e.type === "buttons-inline",
          class: C(e.type === "buttons-inline" ? "flex-1" : ""),
          "data-testid": i.testId ?? `dropdown-panel-footer-button-${s}`,
          onClick: (d) => l("button-click", s)
        }, null, 8, ["variant", "label", "icon-left", "disabled", "aria-disabled", "aria-describedby", "shrink", "class", "data-testid", "onClick"]))), 128))
      ], 2)) : w("", !0),
      e.description ? (u(), b("p", {
        key: 3,
        id: L(t),
        "data-testid": "dropdown-panel-footer-description",
        class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
      }, H(e.description), 9, Aw)) : w("", !0)
    ], 10, Ew));
  }
}), Rw = { class: "inline-flex min-w-0 max-w-full text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, zw = {
  "data-testid": "label-dropdown-label",
  class: "inline-flex min-w-0 items-center gap-1 px-px"
}, Dw = {
  "data-testid": "label-dropdown-text-frame",
  class: "inline-flex min-w-0 whitespace-nowrap"
}, Bw = ["id"], Mw = { class: "sr-only" }, br = /* @__PURE__ */ ke({
  __name: "LabelDropdown",
  props: {
    label: {},
    type: { default: "14px" },
    infoLeft: { default: () => {
    } },
    iconLeft: { default: () => {
    } },
    infoRight: { default: () => {
    } },
    required: { type: Boolean, default: !1 },
    requiredLabel: { default: () => {
    } },
    id: { default: () => {
    } }
  },
  setup(e) {
    const a = {
      "14px": {
        text: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
        icon: "text-(length:--icon-size-xs) leading-(--icon-size-xs)"
      },
      h6: {
        text: "font-(family-name:--family-heading) text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)",
        icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      h5: {
        text: "font-(family-name:--family-heading) text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold)",
        icon: "text-(length:--icon-size-md) leading-(--icon-size-md)"
      }
    }, t = m(() => a[e.type]);
    return (n, l) => (u(), b("span", Rw, [
      x("span", zw, [
        e.iconLeft ? (u(), b("i", {
          key: 0,
          class: C([e.iconLeft, "shrink-0 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", t.value.icon]),
          "aria-hidden": "true",
          "data-testid": "label-dropdown-icon-left"
        }, null, 2)) : w("", !0),
        e.infoLeft ? (u(), P($t, {
          key: 1,
          as: "span",
          text: e.infoLeft,
          tabindex: "0",
          role: "img",
          "aria-label": e.infoLeft,
          "data-testid": "label-dropdown-info-left",
          class: "shrink-0 rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
        }, {
          default: me(() => [
            x("i", {
              class: C(["ri-information-line text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", t.value.icon]),
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : w("", !0),
        x("span", Dw, [
          x("span", {
            "data-testid": "label-dropdown-text",
            class: C(["flex min-w-0", t.value.text])
          }, [
            Me(n.$slots, "default", {}, () => [
              U(it, { text: e.label }, null, 8, ["text"])
            ])
          ], 2),
          e.id ? (u(), b("span", {
            key: 0,
            id: e.id,
            hidden: "",
            "data-testid": "label-dropdown-name"
          }, H(e.label), 9, Bw)) : w("", !0),
          e.required ? (u(), b(ie, { key: 1 }, [
            l[0] || (l[0] = x("span", {
              "aria-hidden": "true",
              "data-testid": "label-dropdown-required",
              class: "w-(--spacing-2) text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
            }, "*", -1)),
            x("span", Mw, H(e.requiredLabel), 1)
          ], 64)) : w("", !0)
        ]),
        e.infoRight ? (u(), P($t, {
          key: 2,
          as: "span",
          text: e.infoRight,
          tabindex: "0",
          role: "img",
          "aria-label": e.infoRight,
          "data-testid": "label-dropdown-info-right",
          class: "shrink-0 rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
        }, {
          default: me(() => [
            x("i", {
              class: C(["ri-information-line text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", t.value.icon]),
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : w("", !0)
      ])
    ]));
  }
}), nd = 1;
function rm({ strip: e, arrow: a, backArrow: t, enabled: n, selection: l }) {
  const o = R(!1), r = R(!1), i = R(!1), s = m(() => o.value && r.value), d = m(() => o.value && i.value);
  function c() {
    const B = e.value;
    if (!B || !n()) {
      o.value = !1, r.value = !1, i.value = !1;
      return;
    }
    const W = B.scrollWidth - B.clientWidth;
    o.value = W > nd, r.value = o.value && B.scrollLeft < W - nd, i.value = o.value && B.scrollLeft > nd;
  }
  const f = () => {
    var B;
    return s.value ? ((B = a.value) == null ? void 0 : B.offsetWidth) ?? 0 : 0;
  }, g = () => {
    var B;
    return d.value ? ((B = t.value) == null ? void 0 : B.offsetWidth) ?? 0 : 0;
  }, h = (B) => f() || parseFloat(getComputedStyle(B).scrollPaddingInlineEnd) || 0, v = (B) => g() || parseFloat(getComputedStyle(B).scrollPaddingInlineStart) || 0;
  let p = !1;
  const y = () => (!s.value || !!a.value) && (!d.value || !!t.value);
  function k(B) {
    const W = B.querySelector(":scope > [aria-selected='true'], :scope > .active");
    if (W) return W;
    let _ = B.querySelector("[role='tab'][aria-selected='true']");
    for (; _ && _.parentElement !== B; ) _ = _.parentElement;
    return _;
  }
  function $() {
    p = !1;
    const B = e.value;
    if (!B || !o.value) return;
    const W = k(B);
    if (!W) return;
    const _ = B.getBoundingClientRect(), Z = W.getBoundingClientRect(), le = _.left + B.clientLeft, D = v(B), O = h(B), N = le + D, V = le + B.clientWidth - O;
    if (Z.left < N) {
      const M = B.scrollLeft - (N - Z.left);
      B.scrollLeft = W === B.firstElementChild || M < D ? 0 : M;
    } else if (Z.right > V) {
      const M = B.scrollWidth - B.clientWidth, Q = B.scrollLeft + Math.min(Z.right - V, Z.left - N);
      B.scrollLeft = W === B.lastElementChild || Q > M - O ? M : Q;
    }
    c(), p = !y();
  }
  $e(
    () => (s.value || d.value) && y(),
    (B) => {
      B && p && $();
    },
    { flush: "post" }
  );
  function S(B) {
    const W = e.value;
    if (!W) return;
    const _ = typeof window.matchMedia == "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches, Z = Math.max(W.clientWidth - f() - g(), 1);
    W.scrollBy({ left: B * Z, behavior: _ ? "auto" : "smooth" });
  }
  function I(B, W) {
    const _ = e.value;
    if (!_ || !B || document.activeElement !== B) return;
    const Z = _.querySelectorAll(":scope > [data-button-group-item]"), le = Z.length ? Z : _.querySelectorAll("[role='tab']"), D = W === "first" ? le[0] ?? _.firstElementChild : le[le.length - 1] ?? _.lastElementChild;
    D == null || D.focus({ preventScroll: !0 });
  }
  $e(s, (B) => B || I(a.value, "last")), $e(d, (B) => B || I(t.value, "first"));
  let T = null, A = 0;
  const E = () => {
    cancelAnimationFrame(A), A = requestAnimationFrame(c);
  };
  function z() {
    if (!T) return;
    T.disconnect();
    const B = e.value;
    !B || !n() || (T.observe(B), Array.from(B.children).forEach((W) => T.observe(W)));
  }
  return kt(async () => {
    var B;
    typeof ResizeObserver < "u" && (T = new ResizeObserver(E)), z(), c(), await Ze(), c(), $(), (B = document.fonts) == null || B.ready.then(() => {
      c(), $();
    });
  }), Er(() => {
    z(), c();
  }), $e(l, () => Ze($)), Tt(() => {
    T == null || T.disconnect(), T = null, cancelAnimationFrame(A);
  }), {
    overflowing: o,
    showArrow: s,
    showBackArrow: d,
    measure: c,
    scrollForward: () => S(1),
    scrollBack: () => S(-1)
  };
}
const Ow = {
  key: 0,
  class: "inline-flex flex-col gap-1"
}, Pw = { class: "flex items-center justify-between gap-2.5 px-2" }, Fw = ["role", "aria-labelledby"], Nw = ["aria-label"], Vw = ["role", "tabindex"], Hw = ["aria-label"], jw = ["role"], Ww = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "ButtonGroup",
  props: {
    variant: { default: "pill" },
    color: { default: () => {
    } },
    size: { default: "sm" },
    labelLeft: { default: () => {
    } },
    labelRight: { default: () => {
    } },
    labelLeftInfo: { default: () => {
    } },
    labelRightInfo: { default: () => {
    } },
    modelValue: { default: () => {
    } },
    panelId: { default: () => {
    } },
    overflowLabel: {},
    overflowPreviousLabel: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = a, n = Na();
    kt(() => {
      var Q;
      const N = ((Q = n.default) == null ? void 0 : Q.call(n, {})) ?? [], V = e.variant === "tab" ? "tab" : "tertiary";
      N.some((q) => {
        var G;
        const K = (G = q.props) == null ? void 0 : G.variant;
        return K !== void 0 && K !== V;
      }) && console.warn(
        `[ButtonGroup] variant="${e.variant}" expects <Button variant="${V}"> children. Other button variants will not render the active state correctly.`
      );
    });
    const l = m(
      () => e.variant === "group" || e.variant === "pill" && e.color === "dark"
    ), o = m(() => l.value && (e.color ?? "dark") === "dark"), r = m(() => e.variant !== "tab" && !!(e.labelLeft || e.labelRight)), i = R(!1);
    let s = 0;
    function d() {
      i.value = !0, cancelAnimationFrame(s), s = requestAnimationFrame(() => {
        s = requestAnimationFrame(() => {
          i.value = !1;
        });
      });
    }
    $e(() => e.modelValue, (N, V) => {
      V !== void 0 && N !== V && d();
    }), Tt(() => cancelAnimationFrame(s));
    const c = m(() => e.variant === "tab" ? ["inline-flex items-center gap-px shadow-(--blur-shadow-xs)", i.value && "button-group-strip--switching"] : [
      i.value && "button-group-strip--switching",
      "button-group-strip inline-flex items-center",
      "rounded-(--border-border-radius-rounded-base)",
      l.value ? ["border border-(--border-border-base-medium) -space-x-px bg-(--colors-white-50-opacity-light) shadow-(--blur-shadow-xs)", o.value && "button-group--dark"] : [
        "gap-0",
        // A scrolling strip clips its items at its padding box: the overflow wrapper's layer draws the surface instead.
        !E.overflowing.value && [
          "border border-(--border-border-base-medium) bg-(--colors-white-50-opacity-medium)",
          e.size !== "xs" && "shadow-(--blur-shadow-xs)"
        ]
      ]
    ]), f = m(() => e.variant === "pill" && !l.value && !r.value), g = R(null), h = R(null), v = {
      xs: { scroll: "scroll-px-8", arrow: "size-[calc(--spacing(8)-2px)]", icon: "text-(length:--icon-size-xs) leading-(--icon-size-xs)" },
      sm: { scroll: "scroll-px-9", arrow: "size-[calc(--spacing(9)-2px)]", icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)" },
      md: { scroll: "scroll-px-10", arrow: "size-[calc(--spacing(10)-2px)]", icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)" },
      lg: { scroll: "scroll-px-12", arrow: "size-[calc(--spacing(12)-2px)]", icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)" }
    }, p = m(() => {
      if (e.modelValue !== void 0)
        return l.value ? "radio" : "tabs";
    }), y = m(() => p.value === "radio" ? "radiogroup" : e.variant === "tab" || p.value === "tabs" ? "tablist" : "group"), k = rn(), $ = Ye(), S = Ye();
    function I() {
      if (!(!p.value || !r.value || k["aria-label"] || k["aria-labelledby"]))
        return [e.labelLeft && $, e.labelRight && S].filter(Boolean).join(" ");
    }
    const T = o0([]), A = R(null), E = rm({
      strip: A,
      arrow: g,
      backArrow: h,
      enabled: () => f.value,
      selection: () => e.modelValue
    }), z = m(
      () => E.overflowing.value ? [
        "relative isolate inline-flex min-w-0 max-w-full",
        "before:pointer-events-none before:absolute before:inset-0 before:-z-1",
        "before:border before:border-(--border-border-base-medium) before:rounded-(--border-border-radius-rounded-base)",
        "before:bg-(--colors-white-50-opacity-medium)",
        e.size !== "xs" && "before:shadow-(--blur-shadow-xs)"
      ] : "contents"
    ), B = m(() => [
      "max-w-full",
      E.overflowing.value && ["button-group-strip--scroll min-w-0 overflow-x-auto overflow-y-hidden", v[e.size].scroll],
      E.showBackArrow.value && "button-group-strip--clip-start",
      E.showArrow.value && "button-group-strip--clip-end"
    ]), W = (N) => [
      "absolute top-px z-20 inline-flex items-center justify-center cursor-pointer",
      N,
      "rounded-(--border-border-radius-rounded-base) bg-(--background-background-white) hover:bg-(--background-background-hover)",
      "text-(--icons-icon-dark-default) transition-colors duration-150 motion-reduce:transition-none",
      "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
      v[e.size].arrow
    ];
    function _() {
      T.sort((N, V) => {
        const M = N.el(), Q = V.el();
        return !M || !Q ? 0 : M.compareDocumentPosition(Q) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      });
    }
    Er(_);
    function Z(N) {
      N !== e.modelValue && (d(), t("update:modelValue", N));
    }
    function le(N) {
      const V = T.filter((Q) => !Q.unreachable() && Q.value() !== void 0), M = V.find((Q) => Q.value() === e.modelValue) ?? V[0];
      return M !== void 0 && M.value() === N;
    }
    const D = (N) => T.find((V) => V.el() === N);
    function O(N) {
      if (!p.value || N.altKey || N.ctrlKey || N.metaKey || !(p.value === "radio" ? ["ArrowRight", "ArrowLeft", "ArrowDown", "ArrowUp", "Home", "End"] : ["ArrowRight", "ArrowLeft", "Home", "End"]).includes(N.key)) return;
      const M = A.value, Q = N.currentTarget;
      if (!M || !Q) return;
      const q = Array.from(M.querySelectorAll("[data-button-group-item]")).filter(
        (Se) => Se.closest("[data-button-group-strip]") === M
      ), K = (Se) => {
        var oe;
        return ((oe = D(Se)) == null ? void 0 : oe.unreachable()) === !1;
      }, G = q.filter(K);
      if (!G.length) return;
      let te;
      if (N.key === "Home") te = G[0];
      else if (N.key === "End") te = G[G.length - 1];
      else {
        const Se = N.key === "ArrowRight" || N.key === "ArrowDown" ? 1 : -1, oe = q.indexOf(Q);
        for (let re = 1; re <= q.length && !te; re++) {
          const ge = q[((oe + Se * re) % q.length + q.length) % q.length];
          K(ge) && (te = ge);
        }
      }
      if (!te) return;
      N.preventDefault(), N.stopPropagation(), te.focus();
      const ve = D(te);
      if (p.value === "radio" && ve && !ve.blocked()) {
        const Se = ve.value();
        Se !== void 0 && Z(Se);
      }
    }
    return wa(Qg, {
      mode: p,
      isSelected: (N) => N === e.modelValue,
      select: Z,
      isTabStop: le,
      register(N) {
        return T.push(N), () => {
          const V = T.indexOf(N);
          V !== -1 && T.splice(V, 1);
        };
      },
      sort: _,
      onItemKeydown: O,
      panelId: () => p.value === "tabs" ? e.panelId : void 0
    }), (N, V) => r.value ? (u(), b("div", Ow, [
      x("div", Pw, [
        e.labelLeft ? (u(), P(br, {
          key: 0,
          id: L($),
          label: e.labelLeft,
          type: "14px",
          "info-right": e.labelLeftInfo,
          "data-testid": "button-group-label-left"
        }, null, 8, ["id", "label", "info-right"])) : w("", !0),
        e.labelRight ? (u(), P(br, {
          key: 1,
          id: L(S),
          label: e.labelRight,
          type: "14px",
          "info-right": e.labelRightInfo,
          "data-testid": "button-group-label-right"
        }, null, 8, ["id", "label", "info-right"])) : w("", !0)
      ]),
      x("div", Ve({
        ref_key: "stripRef",
        ref: A,
        role: y.value,
        "aria-labelledby": I(),
        "data-button-group-strip": ""
      }, N.$attrs, { class: c.value }), [
        Me(N.$slots, "default", {}, void 0, !0)
      ], 16, Fw)
    ])) : f.value ? (u(), b("div", {
      key: 1,
      class: C(z.value)
    }, [
      L(E).showBackArrow.value ? (u(), b("button", {
        key: 0,
        ref_key: "backArrowRef",
        ref: h,
        type: "button",
        "aria-label": e.overflowPreviousLabel,
        "data-testid": "button-group-overflow-back-arrow",
        class: C(W("left-px")),
        onClick: V[0] || (V[0] = //@ts-ignore
        (...M) => L(E).scrollBack && L(E).scrollBack(...M))
      }, [
        x("i", {
          class: C(["ri-arrow-left-line", v[e.size].icon]),
          "aria-hidden": "true"
        }, null, 2)
      ], 10, Nw)) : w("", !0),
      x("div", Ve({
        ref_key: "stripRef",
        ref: A,
        role: y.value,
        tabindex: L(E).overflowing.value ? -1 : void 0,
        "data-button-group-strip": ""
      }, N.$attrs, {
        class: [c.value, B.value],
        onScrollPassive: V[1] || (V[1] = //@ts-ignore
        (...M) => L(E).measure && L(E).measure(...M))
      }), [
        Me(N.$slots, "default", {}, void 0, !0)
      ], 16, Vw),
      L(E).showArrow.value ? (u(), b("button", {
        key: 1,
        ref_key: "arrowRef",
        ref: g,
        type: "button",
        "aria-label": e.overflowLabel,
        "data-testid": "button-group-overflow-arrow",
        class: C(W("right-px")),
        onClick: V[2] || (V[2] = //@ts-ignore
        (...M) => L(E).scrollForward && L(E).scrollForward(...M))
      }, [
        x("i", {
          class: C(["ri-arrow-right-line", v[e.size].icon]),
          "aria-hidden": "true"
        }, null, 2)
      ], 10, Hw)) : w("", !0)
    ], 2)) : (u(), b("div", Ve({
      key: 2,
      ref_key: "stripRef",
      ref: A,
      role: y.value,
      "data-button-group-strip": ""
    }, N.$attrs, { class: c.value }), [
      Me(N.$slots, "default", {}, void 0, !0)
    ], 16, jw));
  }
}), Ri = /* @__PURE__ */ Ct(Ww, [["__scopeId", "data-v-f3b2c0c4"]]), qw = ["id"], Uw = ["id"], Gw = ["aria-valuemax", "aria-valuenow", "aria-valuetext"], ld = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)", Dr = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "ProgressBar",
  props: {
    value: { default: 0 },
    max: { default: 100 },
    color: { default: "primary" },
    size: { default: "base" },
    labelPosition: { default: "top" },
    label: { default: void 0 },
    valueLabel: { default: void 0 },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    var A;
    const a = e, t = {
      base: "h-1.5",
      lg: "h-2.5"
    }, n = {
      primary: "bg-[linear-gradient(90deg,var(--gradient-brand-start)_7.4%,var(--gradient-brand-end)_90.2%)]",
      gray: "bg-(--border-border-accessibility)",
      dark: "bg-(--background-background-black-default)",
      success: "bg-(--border-border-success-strong)",
      danger: "bg-(--border-border-error-strong)",
      warning: "bg-(--border-border-warning)"
    }, l = {
      top: "flex-col",
      side: "flex-row items-center",
      bottom: "flex-col"
    }, o = rn(), r = m(() => ({ class: o.class, style: o.style })), i = m(() => {
      const { class: E, style: z, ...B } = o;
      return B;
    }), s = Ye(), d = m(() => {
      var E;
      return ((E = a.label) == null ? void 0 : E.trim()) || void 0;
    }), c = m(() => {
      var E;
      return ((E = a.valueLabel) == null ? void 0 : E.trim()) || void 0;
    }), f = () => c.value ?? o["aria-valuetext"], g = m(() => !!(d.value || c.value)), h = m(() => a.labelPosition === "side"), v = m(
      () => a.labelPosition === "bottom" ? ["track", "row"] : ["row", "track"]
    ), p = m(() => Number.isFinite(a.max) && a.max > 0 ? a.max : 0), y = m(() => {
      const E = Number.isFinite(a.value) ? a.value : 0;
      return Math.min(Math.max(E, 0), p.value);
    }), k = m(() => p.value > 0 ? y.value / p.value * 100 : 0), $ = R(null), S = (E) => {
      $.value = E ?? null;
    }, I = m(() => {
      var B, W;
      if (o["aria-labelledby"]) return {};
      const E = h.value && !!((B = $.value) != null && B.isTabStop);
      return d.value && !E ? { "aria-labelledby": s } : { "aria-label": (d.value ?? ((W = a.ariaLabel) == null ? void 0 : W.trim())) || void 0 };
    });
    return typeof process < "u" && ((A = process.env) == null ? void 0 : A.NODE_ENV) !== "production" && $e(
      () => {
        var E;
        return !d.value && !((E = a.ariaLabel) != null && E.trim()) && !o["aria-labelledby"];
      },
      (E) => {
        E && console.warn("[OPAL ProgressBar] No `label` and no `ariaLabel`: the progress bar has no accessible name.");
      },
      { immediate: !0 }
    ), (E, z) => (u(), b("div", Ve(r.value, {
      class: ["flex w-full min-w-0 gap-1.5", l[e.labelPosition]],
      "data-testid": "progress-bar"
    }), [
      (u(!0), b(ie, null, Oe(v.value, (B) => (u(), b(ie, { key: B }, [
        B === "row" && g.value ? (u(), b("div", {
          key: 0,
          class: C(h.value ? "contents" : "flex w-full min-w-0"),
          "data-testid": "progress-bar-label-row"
        }, [
          d.value && h.value ? (u(), b("span", {
            key: 0,
            id: L(s),
            class: "order-first flex min-w-0 max-w-1/2",
            "data-testid": "progress-bar-label"
          }, [
            U(it, {
              ref_for: !0,
              ref: S,
              text: d.value,
              "text-class": ld
            }, null, 8, ["text"])
          ], 8, qw)) : d.value ? (u(), b("span", {
            key: 1,
            id: L(s),
            class: C([ld, "min-w-0 flex-1 break-words"]),
            "data-testid": "progress-bar-label"
          }, H(d.value), 11, Uw)) : w("", !0),
          c.value ? (u(), b("span", {
            key: 2,
            class: C([ld, "text-right", h.value ? "order-last max-w-1/4 shrink-0 break-words" : "min-w-0 flex-1 break-words"]),
            "aria-hidden": "true",
            "data-testid": "progress-bar-value-label"
          }, H(c.value), 3)) : w("", !0)
        ], 2)) : B === "track" ? (u(), b("div", Ve({
          key: 1,
          ref_for: !0
        }, { ...i.value, ...I.value }, {
          class: ["overflow-hidden rounded-(--border-border-radius-rounded-l) bg-(--background-background-gray)", [t[e.size], h.value ? "min-w-0 flex-1" : "w-full"]],
          role: "progressbar",
          "aria-valuemin": "0",
          "aria-valuemax": p.value > 0 ? p.value : 100,
          "aria-valuenow": y.value,
          "aria-valuetext": f(),
          "data-testid": "progress-bar-track"
        }), [
          x("div", {
            class: C(["h-full rounded-(--border-border-radius-rounded-l) transition-[width] duration-300 motion-reduce:transition-none", n[e.color]]),
            style: Ge({ width: `${k.value}%` }),
            "data-testid": "progress-bar-fill"
          }, null, 6)
        ], 16, Gw)) : w("", !0)
      ], 64))), 128))
    ], 16));
  }
}), Kw = ["id"], Yw = ["id", "role"], Jw = ["data-testid"], Xw = {
  key: 3,
  class: "col-start-2 row-start-1 flex shrink-0 items-center"
}, Zw = ["data-testid"], Qw = ["data-testid"], _w = { class: "min-w-0 break-words" }, e1 = ["data-testid"], t1 = {
  key: 1,
  class: "flex min-w-0 flex-col gap-(--spacing-2-5)"
}, a1 = ["id"], n1 = ["aria-labelledby"], l1 = { class: "sr-only" }, o1 = ["data-testid"], r1 = ["data-testid"], i1 = {
  key: 0,
  class: "h-4.5 w-0 shrink-0 border-l-(length:--border-border-width-border) border-(--border-border-base-medium)",
  "aria-hidden": "true"
}, s1 = { class: "flex min-w-0 items-center gap-1.5" }, od = "text-(length:--size-m) leading-(--line-height-l)", Pt = /* @__PURE__ */ ke({
  __name: "FieldHelper",
  props: {
    hint: { default: void 0 },
    hintIcon: { default: void 0 },
    hintLines: { default: 1 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hintId: { default: void 0 },
    errorId: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    focused: { type: Boolean, default: !1 },
    testIdPrefix: { default: void 0 },
    endText: { default: void 0 },
    endIcon: { default: void 0 },
    progress: { default: void 0 },
    progressLabel: { default: void 0 },
    checklistTitle: { default: void 0 },
    checklist: { default: void 0 },
    features: { default: void 0 },
    tags: { default: void 0 },
    labels: { default: () => ({ met: "Met", unmet: "Not met", failed: "Failed", progress: "Progress" }) }
  },
  emits: ["endClick", "removeTag"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = m(() => !!n.endText), r = m(
      () => {
        var $;
        return n.progress !== void 0 || !!n.checklistTitle || !!(($ = n.checklist) != null && $.length);
      }
    ), i = Ye(), s = {
      met: { icon: "ri-checkbox-circle-fill text-(--icons-icon-success)", text: "text-(--text-text-success-strong)" },
      unmet: { icon: "ri-checkbox-blank-circle-line text-(--icons-icon-base)", text: "text-(--text-text-body-subtle)" },
      failed: { icon: "ri-close-circle-fill text-(--icons-icon-error)", text: "text-(--text-text-error-strong)" }
    }, d = m(
      () => o.value ? "min-h-5 grid min-w-0 self-stretch grid-cols-[minmax(0,1fr)_auto] items-center gap-x-(--spacing-2-5) gap-y-px" : "min-h-5 flex min-w-0 self-stretch flex-col gap-px"
    ), c = R(null), f = R(!1), g = m(() => f.value ? !1 : n.focused ? !0 : void 0);
    $e(
      () => n.focused,
      ($) => {
        $ || (f.value = !1);
      }
    );
    const h = ($) => {
      var S;
      $.key !== "Escape" || $.defaultPrevented || f.value || !n.focused || !n.hint || !((S = c.value) != null && S.isTruncated) || ($.stopPropagation(), $.preventDefault(), f.value = !0);
    }, v = R(null), p = R(null), y = R(null), k = ($) => {
      var S;
      y.value = { index: $, count: ((S = n.tags) == null ? void 0 : S.length) ?? 0 }, l("removeTag", $);
    };
    return $e(
      () => n.tags,
      ($) => {
        var A, E, z, B;
        const S = y.value;
        if (y.value = null, !S || (($ == null ? void 0 : $.length) ?? 0) >= S.count) return;
        const { index: I } = S, T = (A = p.value) == null ? void 0 : A.querySelectorAll(":scope > li button");
        if (T != null && T.length) {
          T[Math.min(Math.max(I - 1, 0), T.length - 1)].focus();
          return;
        }
        (B = (z = (E = v.value) == null ? void 0 : E.parentElement) == null ? void 0 : z.querySelector("input:not([type='hidden']), textarea, select")) == null || B.focus();
      },
      // deep: consumers also splice the array in place
      { flush: "post", deep: !0 }
    ), a({ handleFieldKeydown: h }), ($, S) => {
      var I, T, A, E;
      return u(), b("div", {
        ref_key: "rootRef",
        ref: v,
        "data-field-helper": "",
        class: C(d.value)
      }, [
        e.hint ? (u(), b("span", {
          key: 0,
          id: e.hintId,
          class: "sr-only"
        }, H(e.hint), 9, Kw)) : w("", !0),
        e.error ? (u(), b("span", {
          key: 1,
          id: e.errorId,
          role: e.errorLive ? "alert" : void 0,
          class: "sr-only"
        }, H(e.error), 9, Yw)) : w("", !0),
        e.hint ? (u(), b("div", {
          key: 2,
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-hint` : void 0,
          "aria-hidden": "true",
          class: C([
            "flex min-w-0 gap-1 text-(length:--size-sm) leading-(--line-height-l)",
            e.disabled ? "text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--colors-text-white-default)",
            e.hintLines === 2 ? "items-start" : "items-center"
          ])
        }, [
          !o.value || e.hintIcon ? (u(), b("i", {
            key: 0,
            class: C([
              e.hintIcon ?? "ri-error-warning-line",
              "inline-flex w-3 shrink-0 items-center justify-center text-(length:--size-sm)",
              e.disabled ? "text-(--icons-icon-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
              e.hintLines === 2 ? "h-(--line-height-l)" : "h-3"
            ]),
            "aria-hidden": "true"
          }, null, 2)) : w("", !0),
          (u(), P(it, {
            ref_key: "hintRef",
            ref: c,
            key: e.hintLines,
            text: e.hint,
            lines: e.hintLines,
            "text-class": e.hintLines === 2 ? "whitespace-pre-line" : "",
            focusable: !1,
            open: g.value,
            position: "bottom"
          }, null, 8, ["text", "lines", "text-class", "open"]))
        ], 10, Jw)) : w("", !0),
        o.value ? (u(), b("div", Xw, [
          x("button", {
            type: "button",
            class: "relative inline-flex cursor-pointer items-center gap-1 rounded-(--border-border-radius-rounded-xs) before:absolute before:left-1/2 before:top-1/2 before:h-6 before:w-full before:min-w-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-[''] text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-link) focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
            "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-end` : void 0,
            onClick: S[0] || (S[0] = (z) => l("endClick"))
          }, [
            e.endIcon ? (u(), b("i", {
              key: 0,
              class: C([e.endIcon, "inline-flex size-3 shrink-0 items-center justify-center text-(length:--size-sm) text-(--icons-icon-link)"]),
              "aria-hidden": "true"
            }, null, 2)) : w("", !0),
            x("span", null, H(e.endText), 1)
          ], 8, Zw)
        ])) : w("", !0),
        e.error ? (u(), b("div", {
          key: 4,
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-error` : void 0,
          "aria-hidden": "true",
          class: C([
            "flex min-w-0 items-start gap-1 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
            o.value ? "col-span-full" : ""
          ])
        }, [
          S[1] || (S[1] = x("span", { class: "inline-flex h-(--line-height-l) shrink-0 items-center" }, [
            x("i", {
              class: "ri-close-circle-line inline-flex size-3 items-center justify-center text-(length:--size-sm) text-(--icons-icon-error)",
              "aria-hidden": "true"
            })
          ], -1)),
          x("span", _w, H(e.error), 1)
        ], 10, Qw)) : w("", !0),
        r.value ? (u(), b("div", {
          key: 5,
          class: "col-span-full flex min-w-0 flex-col gap-(--spacing-2-5)",
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-progress` : void 0
        }, [
          e.progress !== void 0 ? (u(), P(Dr, {
            key: 0,
            value: e.progress,
            "aria-label": e.progressLabel ?? e.labels.progress
          }, null, 8, ["value", "aria-label"])) : w("", !0),
          e.checklistTitle || (I = e.checklist) != null && I.length ? (u(), b("div", t1, [
            e.checklistTitle ? (u(), b("span", {
              key: 0,
              id: L(i),
              class: C([od, "font-(--weight-medium) text-(--text-text-heading) dark:text-(--colors-text-white-default)"])
            }, H(e.checklistTitle), 11, a1)) : w("", !0),
            (T = e.checklist) != null && T.length ? (u(), b("ul", {
              key: 1,
              class: "flex min-w-0 flex-col gap-1.5",
              "aria-labelledby": e.checklistTitle ? L(i) : void 0
            }, [
              (u(!0), b(ie, null, Oe(e.checklist, (z, B) => (u(), b("li", {
                key: B,
                class: "flex min-w-0 items-center gap-1.5"
              }, [
                x("i", {
                  class: C([
                    s[z.status].icon,
                    "inline-flex size-3.5 shrink-0 items-center justify-center text-(length:--icon-size-xs)"
                  ]),
                  "aria-hidden": "true"
                }, null, 2),
                x("span", {
                  class: C([od, "min-w-0 flex-1 break-words font-(--weight-regular)", s[z.status].text])
                }, [
                  x("span", l1, H(`${z.statusLabel ?? e.labels[z.status]}: `), 1),
                  st(H(z.text), 1)
                ], 2)
              ]))), 128))
            ], 8, n1)) : w("", !0)
          ])) : w("", !0)
        ], 8, e1)) : w("", !0),
        (A = e.tags) != null && A.length ? (u(), b("ul", {
          key: 6,
          ref_key: "tagListRef",
          ref: p,
          class: "col-span-full flex min-w-0 flex-wrap items-center gap-(--spacing-2-5)",
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-tags` : void 0
        }, [
          (u(!0), b(ie, null, Oe(e.tags, (z, B) => (u(), b("li", {
            key: `${z.label}-${B}`,
            class: "flex min-w-0"
          }, [
            U(yt, {
              label: z.label,
              theme: "white",
              size: "sm",
              type: "with-avatar",
              "avatar-src": z.avatarSrc,
              "avatar-alt": z.avatarAlt,
              "show-close-icon": "",
              "remove-label": z.removeLabel,
              onClose: (W) => k(B)
            }, null, 8, ["label", "avatar-src", "avatar-alt", "remove-label", "onClose"])
          ]))), 128))
        ], 8, o1)) : w("", !0),
        (E = e.features) != null && E.length ? (u(), b("ul", {
          key: 7,
          class: "col-span-full flex min-w-0 flex-wrap items-center gap-3",
          "data-testid": e.testIdPrefix ? `${e.testIdPrefix}-features` : void 0
        }, [
          (u(!0), b(ie, null, Oe(e.features, (z, B) => (u(), b("li", {
            key: B,
            class: "flex min-w-0 items-center gap-3"
          }, [
            B > 0 ? (u(), b("span", i1)) : w("", !0),
            x("span", s1, [
              x("i", {
                class: C([
                  z.icon,
                  "inline-flex size-4 shrink-0 items-center justify-center text-(length:--icon-size-sm) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
                ]),
                "aria-hidden": "true"
              }, null, 2),
              x("span", {
                class: C([
                  od,
                  "min-w-0 break-words font-(--weight-regular) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
                ])
              }, H(z.text), 3)
            ])
          ]))), 128))
        ], 8, r1)) : w("", !0)
      ], 2);
    };
  }
}), en = /* @__PURE__ */ ke({
  __name: "FieldShell",
  props: {
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    focused: { type: Boolean, default: !1 },
    focusScope: { default: "control" },
    hasValue: { type: Boolean, default: !1 },
    rounded: { default: "l" },
    flush: { type: Boolean, default: !1 },
    innerButton: { type: Boolean, default: !1 },
    stacked: { type: Boolean, default: !1 },
    tags: { type: Boolean, default: !1 },
    multiline: { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = e, t = R(!1), n = R(null), l = R(!1), o = m(() => !a.disabled && (a.focused || l.value));
    function r(B) {
      var W;
      return !(B instanceof Element) || !((W = n.value) != null && W.contains(B)) ? !1 : a.focusScope === "any" || B === n.value || B.matches("input, textarea, select");
    }
    function i(B) {
      l.value = r(B.target);
    }
    function s(B) {
      l.value = r(B.relatedTarget);
    }
    $e(
      () => a.disabled,
      () => {
        l.value = r(document.activeElement);
      }
    );
    const d = {
      sm: {
        height: "h-[32px]",
        container: "h-[32px] px-[calc(--spacing(2)-1px)] py-[calc(--spacing(1.5)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)"
      },
      md: {
        height: "h-[36px]",
        container: "h-[36px] px-[calc(--spacing(3)-1px)] py-[calc(--spacing(2)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)"
      },
      lg: {
        height: "h-[48px]",
        container: "h-[48px] px-[calc(--spacing(3.5)-1px)] py-[calc(--spacing(3)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)"
      },
      xl: {
        height: "h-[52px]",
        container: "h-[52px] px-[calc(--spacing(4)-1px)] py-[calc(--spacing(3.5)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)"
      }
    }, c = {
      sm: {
        height: "h-[48px] pr-[calc(--spacing(2)-1px)]",
        container: "h-[48px] pl-[calc(--spacing(2.5)-1px)] pr-[calc(--spacing(2)-1px)] gap-2"
      },
      md: {
        height: "h-[52px] pr-[calc(--spacing(2.5)-1px)]",
        container: "h-[52px] pl-[calc(--spacing(3)-1px)] pr-[calc(--spacing(2.5)-1px)] gap-2"
      },
      lg: {
        height: "h-[56px] pr-[calc(--spacing(3)-1px)]",
        container: "h-[56px] pl-[calc(--spacing(3.5)-1px)] pr-[calc(--spacing(3)-1px)] gap-2"
      },
      xl: {
        height: "h-[60px] pr-[calc(--spacing(3.5)-1px)]",
        container: "h-[60px] pl-[calc(--spacing(4)-1px)] pr-[calc(--spacing(3.5)-1px)] gap-2"
      }
    }, f = {
      sm: {
        container: "h-[56px] p-[calc(--spacing(2)-1px)] flex-col justify-center",
        text: "text-(length:--size-sm) leading-(--line-height-l)",
        topText: "text-(length:--size-m) leading-(--line-height-l)"
      },
      md: {
        container: "h-[62px] p-[calc(--spacing(2.5)-1px)] flex-col justify-center gap-0.5",
        text: "text-(length:--size-sm) leading-(--line-height-l)",
        topText: "text-(length:--size-m) leading-(--line-height-l)"
      },
      lg: {
        container: "h-[70px] p-[calc(--spacing(3)-1px)] flex-col justify-center gap-0.5",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        topText: "text-(length:--size-l) leading-(--line-height-xxl)"
      },
      xl: {
        container: "h-[74px] p-[calc(--spacing(3.5)-1px)] flex-col justify-center gap-0.5",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        topText: "text-(length:--size-l) leading-(--line-height-xxl)"
      }
    }, g = {
      sm: "min-h-[32px] flex-wrap gap-2 py-[calc(--spacing(1)-1px)] px-[calc(--spacing(2)-1px)]",
      md: "min-h-[36px] flex-wrap gap-2 py-[calc(--spacing(1.5)-1px)] px-[calc(--spacing(2.5)-1px)]",
      lg: "min-h-[48px] flex-wrap gap-2 py-[calc(--spacing(2.5)-1px)] px-[calc(--spacing(3)-1px)]",
      xl: "min-h-[52px] flex-wrap gap-2 py-[calc(--spacing(3)-1px)] px-[calc(--spacing(3.5)-1px)]"
    }, h = m(() => d[a.size]), v = m(
      () => a.stacked ? f[a.size].text : h.value.text
    ), p = m(() => a.stacked ? f[a.size].topText : ""), y = m(() => {
      if (a.stacked) return f[a.size].container;
      if (a.tags) return g[a.size];
      if (a.multiline)
        return "h-[144px] overflow-hidden px-[calc(--spacing(3)-1px)] py-[calc(--spacing(2)-1px)]";
      if (a.innerButton) {
        const B = c[a.size];
        return a.flush ? B.height : B.container;
      }
      return a.flush ? `${h.value.height} overflow-hidden` : h.value.container;
    }), k = m(() => {
      const W = `relative ${a.rounded === "full" ? "rounded-full" : "rounded-(--border-border-radius-rounded-l)"} border-solid box-border flex items-center text-left font-inter border-[1px]`, _ = "shadow-[0_0_2px_2px_var(--background-background-hover)]", Z = o.value ? _ : "dark:shadow-(--blur-shadow-m-dark)";
      if (a.disabled)
        return `${W} dark:shadow-(--blur-shadow-m-dark) bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled) border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)`;
      if (a.readonly) {
        const D = o.value ? `${_} border-(--border-border-accent)` : "border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${W} dark:shadow-(--blur-shadow-m-dark) bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) ${D} text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      }
      if (a.error)
        return `${W} ${Z} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (a.success)
        return `${W} ${Z} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-success-strong) dark:border-(--border-border-success-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (o.value)
        return `${W} ${_} bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (t.value)
        return `${W} ${_} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      const le = a.hasValue ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)";
      return `${W} dark:shadow-(--blur-shadow-m-dark) bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${le} dark:text-(--text-text-white-default)`;
    }), $ = m(() => a.disabled ? "text-(--icons-icon-disabled-strong) dark:text-(--text-text-disabled-light)" : a.readonly ? "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)" : a.error ? "text-(--icons-icon-error)" : a.success ? "text-(--icons-icon-success)" : o.value ? "text-(--icons-icon-accent)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"), S = m(() => a.disabled ? "border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle)" : a.readonly ? o.value ? "border-(--border-border-accent)" : "border-(--border-border-base-soft) dark:border-(--border-border-base)" : a.error ? "border-(--border-border-error-strong) dark:border-(--border-border-error)" : a.success ? "border-(--border-border-success-strong)" : o.value || t.value ? "border-(--border-border-accent)" : "border-(--border-border-base-medium) dark:border-(--border-border-base)"), I = m(() => a.disabled ? "text-(--text-text-disabled-light)" : a.readonly ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : a.error ? "text-(--text-text-error-strong) dark:text-(--text-text-error)" : a.success ? "text-(--text-text-success-strong)" : o.value ? "text-(--text-text-accent)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"), T = m(
      () => a.stacked && (a.size === "sm" || a.size === "md") ? "inline-flex size-3.5 shrink-0 items-center justify-center text-(length:--icon-size-xs)" : "inline-flex size-4 shrink-0 items-center justify-center text-(length:--size-l)"
    ), A = m(
      () => !a.stacked && (a.size === "lg" || a.size === "xl") ? "inline-flex size-5 shrink-0 items-center justify-center text-(length:--icon-size-md)" : T.value
    ), E = () => {
      !a.disabled && !a.readonly && !a.tags && (t.value = !0);
    }, z = () => {
      t.value = !1;
    };
    return (B, W) => (u(), b("div", {
      ref_key: "rootRef",
      ref: n,
      class: C([k.value, y.value]),
      onFocusin: i,
      onFocusout: s,
      onMouseenter: E,
      onMouseleave: z
    }, [
      Me(B.$slots, "default", {
        hovered: t.value,
        borderColorClass: S.value,
        addonTextClass: I.value,
        iconBoxClass: T.value,
        leftIconBoxClass: A.value,
        iconColorClass: $.value,
        textClass: v.value,
        topTextClass: p.value
      })
    ], 34));
  }
});
function im(e, a) {
  return a === 1 ? "only" : e === 0 ? "first" : e === a - 1 ? "last" : "middle";
}
const d1 = { sm: "xs", md: "sm", lg: "lg", xl: "xl" }, u1 = { sm: "xs", md: "xs", lg: "sm", xl: "md" };
function ol(e, a) {
  return (a === "stacked" ? u1 : d1)[e];
}
const c1 = {
  l: { left: "rounded-l-(--border-border-radius-rounded-l)", right: "rounded-r-(--border-border-radius-rounded-l)" },
  full: { left: "rounded-l-full", right: "rounded-r-full" }
};
function sm(e, a) {
  const t = c1[a], n = e === "first" || e === "only" ? "" : "-ml-px ", l = {
    first: `${t.left} rounded-r-none`,
    middle: "rounded-l-none rounded-r-none",
    last: `rounded-l-none ${t.right}`,
    only: `${t.left} ${t.right}`
  }[e];
  return { part: `${n}relative hover:z-[1] focus-within:z-[1]`, corners: l };
}
function dm(e) {
  return `flex w-full items-stretch ${e === "full" ? "rounded-full" : "rounded-(--border-border-radius-rounded-l)"} shadow-(--blur-shadow-xs)`;
}
function vn(e, a) {
  return {
    variant: e.color ?? "secondary",
    label: e.iconOnly ? "" : e.label,
    iconLeft: e.icon,
    iconOnly: !!e.iconOnly,
    dropdownIcon: !!e.dropdown,
    ariaLabel: e.iconOnly ? e.label : e.ariaLabel,
    disabled: a || !!e.disabled,
    "data-field-button": e.id
  };
}
function Cc(e) {
  return { icon: "ri-delete-bin-line", ...e, iconOnly: !0 };
}
const Br = /* @__PURE__ */ ke({
  __name: "FieldButtons",
  props: {
    buttons: { default: () => [] },
    layout: { default: "attached" },
    size: { default: "md" },
    rounded: { default: "l" },
    disabled: { type: Boolean, default: !1 },
    buttonSize: { default: void 0 }
  },
  emits: ["button-click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = Na(), o = m(() => t.buttons.filter((S) => S.position === "start")), r = m(() => t.buttons.filter((S) => S.position !== "start")), i = m(
      () => t.layout === "stacked" ? [null, ...o.value, ...r.value] : [...o.value, null, ...r.value]
    ), s = m(
      () => t.buttonSize ?? ol(t.size, t.layout)
    ), d = m(() => t.layout === "attached"), c = m(() => t.layout === "stacked" ? "flex w-full flex-col gap-4" : t.layout === "spaced" ? "flex w-full items-center gap-4" : dm(t.rounded)), f = () => l.leading ? 1 : 0, g = () => f() + t.buttons.length > 0, h = () => f() + o.value.length + 1 + r.value.length, v = () => f() + o.value.length;
    function p(S) {
      return sm(im(S, h()), t.rounded);
    }
    function y() {
      return t.layout === "stacked" ? "w-full" : d.value ? `min-w-0 flex-1 ${p(v()).part}` : "min-w-0 flex-1";
    }
    function k() {
      return d.value ? p(v()).corners : "";
    }
    function $(S) {
      if (!d.value) return "";
      const { part: I, corners: T } = p(S);
      return `${I} ${T}`;
    }
    return (S, I) => g() ? (u(), b("div", {
      key: 1,
      class: C(c.value)
    }, [
      Me(S.$slots, "leading", {
        partClass: $(0),
        buttonSize: s.value
      }),
      (u(!0), b(ie, null, Oe(i.value, (T, A) => (u(), b(ie, {
        key: T ? `button-${T.id}` : "field"
      }, [
        T ? (u(), P(Be, Ve({
          key: 1,
          class: $(f() + A)
        }, { ref_for: !0 }, L(vn)(T, e.disabled), {
          size: s.value,
          "full-width": e.layout === "stacked",
          onClick: (E) => n("button-click", T.id)
        }), null, 16, ["class", "size", "full-width", "onClick"])) : (u(), b("div", {
          key: 0,
          class: C(y())
        }, [
          Me(S.$slots, "default", {
            fieldClass: k()
          })
        ], 2))
      ], 64))), 128))
    ], 2)) : Me(S.$slots, "default", {
      key: 0,
      fieldClass: ""
    });
  }
});
function Co(e, a, t) {
  return e && a ? {
    root: "grid grid-cols-[auto_minmax(0,1fr)] items-center gap-x-4 gap-y-0.5",
    label: "",
    field: "col-start-2",
    helper: "col-start-2",
    remove: "",
    removeInFieldRow: !0,
    reservesHelper: !1
  } : t ? {
    root: "grid grid-cols-[minmax(0,1fr)_auto] gap-x-3 gap-y-0.5",
    label: "col-start-1",
    field: "col-start-1",
    helper: "col-start-1",
    remove: `col-start-2 self-end ${a ? "row-start-2" : "row-start-1"}`,
    removeInFieldRow: !1,
    reservesHelper: !0
  } : {
    root: "flex flex-col items-start gap-0.5",
    label: "",
    field: "",
    helper: "",
    remove: "",
    removeInFieldRow: !1,
    reservesHelper: !0
  };
}
const f1 = ["src"], h1 = ["src"], b1 = ["id", "name", "value", "placeholder", "disabled", "aria-label", "aria-labelledby", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required", "role", "aria-controls", "aria-expanded", "aria-autocomplete", "aria-activedescendant"], g1 = ["aria-label", "onKeydown"], m1 = ["src"], v1 = /* @__PURE__ */ ke({
  __name: "SearchInput",
  props: {
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    helpIcon: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    showSearchIcon: { type: Boolean, default: !0 },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    rounded: { default: "full" },
    hint: { default: void 0 },
    error: { default: void 0 },
    labels: { default: () => ({ clear: "Clear search" }) },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    innerButton: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaControls: { default: void 0 },
    ariaExpanded: { type: Boolean, default: !1 },
    ariaActivedescendant: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "keydown", "search", "clear", "button-click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = Ye(), o = m(() => t.id || l), r = m(() => `${o.value}-hint`), i = m(() => `${o.value}-error`), s = R(!1), d = R(null), c = R(null), f = R(null), g = m(() => t.rounded === "full" ? "full" : "l"), h = m(() => !!t.modelValue && t.modelValue.trim() !== ""), v = m(() => !!t.hint || !!t.error), p = m(() => t.buttons.length > 0), y = m(() => {
      const D = [];
      return t.hint && D.push(r.value), t.error && D.push(i.value), D.length > 0 ? D.join(" ") : void 0;
    }), k = m(() => !!t.ariaControls), $ = m(() => s.value && h.value && !t.disabled), S = m(() => Co(t.labelInline, !!t.label, !1)), I = m(() => t.fullWidth || t.width === void 0), T = m(() => t.labelInline && !!t.label && !I.value), A = (D) => !!D && D.startsWith("ri-"), E = m(() => I.value ? {} : { width: t.width }), z = m(() => p.value ? { style: E.value } : {}), B = (D) => {
      const O = D.target;
      n("update:modelValue", O.value), n("input", D);
    }, W = (D) => {
      var V, M;
      n("keydown", D), D.key === "Enter" && !D.isComposing && n("search", D.target.value);
      const N = k.value && t.ariaExpanded || D.defaultPrevented;
      D.key === "Escape" && !D.isComposing && t.modelValue && !t.disabled && !N && (D.preventDefault(), D.stopPropagation(), le()), (V = c.value) == null || V.handleFieldKeydown(D), (M = f.value) == null || M.handleFieldKeydown(D);
    }, _ = (D) => {
      t.disabled || (s.value = !0), n("focus", D);
    }, Z = (D) => {
      s.value = !1, n("blur", D);
    }, le = () => {
      var D;
      n("update:modelValue", ""), n("clear"), (D = d.value) == null || D.focus();
    };
    return (D, O) => (u(), b("div", {
      class: C([
        "relative min-w-0 text-left text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default) font-inter",
        T.value ? "w-fit" : "w-full",
        S.value.root
      ])
    }, [
      e.label ? (u(), b("div", {
        key: 0,
        class: C(["flex min-w-0 max-w-full items-center gap-1", S.value.label])
      }, [
        U(Ft, {
          ref_key: "labelRef",
          ref: c,
          text: e.label,
          "input-id": o.value,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: s.value,
          inline: e.labelInline,
          "test-id": "search-input-label"
        }, null, 8, ["text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline"]),
        e.helpIcon && !e.labelTooltip ? (u(), b("img", {
          key: 0,
          src: e.helpIcon,
          class: "h-3 w-3 relative search-input-icon",
          alt: ""
        }, null, 8, f1)) : w("", !0)
      ], 2)) : w("", !0),
      x("div", {
        class: C(["flex w-full", S.value.field])
      }, [
        U(Br, Ve({
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          rounded: g.value,
          disabled: e.disabled,
          "button-size": e.buttonSize
        }, z.value, {
          onButtonClick: O[2] || (O[2] = (N) => n("button-click", N))
        }), {
          default: me(({ fieldClass: N }) => [
            U(en, {
              size: e.size,
              rounded: g.value,
              "inner-button": !!e.innerButton,
              disabled: e.disabled,
              error: !!e.error,
              "has-value": h.value,
              class: C([
                p.value || I.value ? "w-full" : "",
                p.value && e.buttonLayout === "attached" ? "min-h-full" : "",
                N
              ]),
              style: Ge(p.value ? {} : E.value)
            }, {
              default: me(({ iconBoxClass: V, leftIconBoxClass: M, iconColorClass: Q, textClass: q }) => [
                e.showSearchIcon ? (u(), b(ie, { key: 0 }, [
                  !e.iconLeft || A(e.iconLeft) ? (u(), b("i", {
                    key: 0,
                    class: C([e.iconLeft || "ri-search-line", M, Q]),
                    "aria-hidden": "true"
                  }, null, 2)) : (u(), b("img", {
                    key: 1,
                    src: e.iconLeft,
                    class: C([M, "search-input-icon"]),
                    alt: ""
                  }, null, 10, h1))
                ], 64)) : w("", !0),
                x("input", {
                  id: o.value,
                  ref_key: "inputRef",
                  ref: d,
                  name: e.name,
                  "data-testid": "search-input",
                  type: "search",
                  value: e.modelValue,
                  placeholder: e.placeholder,
                  disabled: e.disabled,
                  "aria-label": e.label || e.ariaLabelledby ? void 0 : e.ariaLabel ?? e.placeholder,
                  "aria-labelledby": e.label ? void 0 : e.ariaLabelledby,
                  "aria-disabled": e.disabled ? "true" : void 0,
                  "aria-invalid": e.error ? "true" : void 0,
                  "aria-describedby": y.value,
                  "aria-required": e.required ? "true" : void 0,
                  role: k.value ? "combobox" : void 0,
                  "aria-controls": e.ariaControls,
                  "aria-expanded": k.value ? e.ariaExpanded ? "true" : "false" : void 0,
                  "aria-autocomplete": k.value ? "list" : void 0,
                  "aria-activedescendant": k.value && e.ariaActivedescendant || void 0,
                  class: C([
                    "flex-1 min-w-0 text-ellipsis relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 p-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) [&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none",
                    q
                  ]),
                  onInput: B,
                  onFocus: _,
                  onBlur: Z,
                  onKeydown: W
                }, null, 42, b1),
                $.value ? (u(), b("i", {
                  key: 1,
                  class: C(["ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", V]),
                  role: "button",
                  tabindex: "-1",
                  "aria-label": e.labels.clear,
                  "data-testid": "search-input-clear",
                  onMousedown: O[0] || (O[0] = _e(() => {
                  }, ["prevent"])),
                  onClick: _e(le, ["stop"]),
                  onKeydown: [
                    St(le, ["enter"]),
                    St(_e(le, ["prevent"]), ["space"])
                  ]
                }, null, 42, g1)) : w("", !0),
                e.iconRight ? (u(), b("img", {
                  key: 2,
                  src: e.iconRight,
                  class: C([V, "search-input-icon"]),
                  alt: ""
                }, null, 10, m1)) : w("", !0),
                e.innerButton ? (u(), P(Be, Ve({ key: 3 }, L(vn)(e.innerButton, e.disabled), {
                  size: "xs",
                  onClick: O[1] || (O[1] = (K) => n("button-click", e.innerButton.id))
                }), null, 16)) : w("", !0)
              ]),
              _: 1
            }, 8, ["size", "rounded", "inner-button", "disabled", "error", "has-value", "class", "style"])
          ]),
          _: 1
        }, 16, ["buttons", "layout", "size", "rounded", "disabled", "button-size"])
      ], 2),
      v.value ? (u(), P(Pt, {
        key: 1,
        ref_key: "helperRef",
        ref: f,
        class: C(S.value.helper),
        focused: s.value,
        hint: e.hint,
        error: e.error,
        "hint-id": r.value,
        "error-id": i.value,
        disabled: e.disabled,
        "test-id-prefix": "search-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id", "disabled"])) : w("", !0)
    ], 2));
  }
}), zs = /* @__PURE__ */ Ct(v1, [["__scopeId", "data-v-a3d6bac2"]]), p1 = {
  key: 0,
  "data-testid": "dropdown-panel-header-labels",
  class: "flex items-center justify-between gap-2.5 px-2"
}, Bl = /* @__PURE__ */ ke({
  __name: "DropdownPanelHeader",
  props: {
    labelLeft: { default: void 0 },
    labelLeftInfo: { default: void 0 },
    labelRight: { default: void 0 },
    labelRightInfo: { default: void 0 },
    showSearch: { type: Boolean, default: !1 },
    searchQuery: { default: "" },
    searchPlaceholder: { default: void 0 },
    searchLabel: { default: void 0 },
    searchClearLabel: { default: "Clear search" },
    groupButtons: { default: () => [] },
    activeGroup: { default: void 0 },
    groupLabelLeft: { default: void 0 },
    groupLabelLeftInfo: { default: void 0 },
    groupLabelRight: { default: void 0 },
    groupLabelRightInfo: { default: void 0 },
    groupAriaLabel: { default: void 0 }
  },
  emits: ["update:searchQuery", "update:activeGroup"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = Ye(), r = Ye(), i = m(() => !!(n.labelLeft || n.labelRight)), s = m(() => {
      if (!(n.searchLabel || !i.value))
        return [n.labelLeft && o, n.labelRight && r].filter(Boolean).join(" ");
    }), d = m(() => !!(n.groupLabelLeft || n.groupLabelRight)), c = R(null);
    function f() {
      var h;
      const g = (h = c.value) == null ? void 0 : h.querySelector('[data-testid="search-input"]');
      return g == null || g.focus({ preventScroll: !0 }), !!g;
    }
    return a({ focusSearch: f }), (g, h) => (u(), b("div", {
      ref_key: "rootRef",
      ref: c,
      "data-testid": "dropdown-panel-header",
      class: "relative flex flex-col gap-3 border-b border-(--border-border-base-soft) bg-(--background-background-white) px-3 pt-4 pb-[calc(--spacing(4)-1px)] shadow-(--shadow-bottom-dropdown) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--shadow-bottom-dropdown-dark)"
    }, [
      i.value ? (u(), b("div", p1, [
        e.labelLeft ? (u(), P(br, {
          key: 0,
          id: L(o),
          label: e.labelLeft,
          "info-right": e.labelLeftInfo,
          "data-testid": "dropdown-panel-header-label-left"
        }, null, 8, ["id", "label", "info-right"])) : w("", !0),
        e.labelRight ? (u(), P(br, {
          key: 1,
          id: L(r),
          label: e.labelRight,
          "info-right": e.labelRightInfo,
          class: "ml-auto",
          "data-testid": "dropdown-panel-header-label-right"
        }, null, 8, ["id", "label", "info-right"])) : w("", !0)
      ])) : w("", !0),
      e.showSearch ? (u(), P(zs, {
        key: 1,
        "model-value": e.searchQuery,
        placeholder: e.searchPlaceholder,
        "aria-label": e.searchLabel,
        "aria-labelledby": s.value,
        labels: { clear: e.searchClearLabel },
        size: "sm",
        "full-width": "",
        "onUpdate:modelValue": h[0] || (h[0] = (v) => l("update:searchQuery", v))
      }, null, 8, ["model-value", "placeholder", "aria-label", "aria-labelledby", "labels"])) : w("", !0),
      e.groupButtons.length ? (u(), P(Ri, {
        key: 2,
        "model-value": e.activeGroup ?? "",
        variant: "group",
        color: "dark",
        size: "sm",
        "label-left": e.groupLabelLeft,
        "label-left-info": e.groupLabelLeftInfo,
        "label-right": e.groupLabelRight,
        "label-right-info": e.groupLabelRightInfo,
        "aria-label": d.value ? void 0 : e.groupAriaLabel,
        class: "w-full",
        "data-testid": "dropdown-panel-header-group",
        "onUpdate:modelValue": h[1] || (h[1] = (v) => l("update:activeGroup", String(v)))
      }, {
        default: me(() => [
          (u(!0), b(ie, null, Oe(e.groupButtons, (v) => (u(), P(Be, {
            key: v.value,
            variant: "tertiary",
            size: "sm",
            label: v.label,
            value: v.value,
            shrink: "",
            class: "flex-1"
          }, null, 8, ["label", "value"]))), 128))
        ]),
        _: 1
      }, 8, ["model-value", "label-left", "label-left-info", "label-right", "label-right-info", "aria-label"])) : w("", !0)
    ], 512));
  }
});
function Mr() {
  const e = R(0);
  function a(r, i) {
    var s;
    r && ((s = r.querySelector(`[data-listbox-index="${i}"]`)) == null || s.focus());
  }
  function t(r, i) {
    for (let s = 0; s < r; s++)
      if (!(i != null && i(s))) return s;
    return 0;
  }
  function n(r, i, s) {
    if (i === 0) return;
    let d;
    switch (r.key) {
      case "ArrowDown":
        d = (e.value + 1) % i;
        break;
      case "ArrowUp":
        d = (e.value - 1 + i) % i;
        break;
      case "Home":
        d = 0;
        break;
      case "End":
        d = i - 1;
        break;
      default:
        return;
    }
    r.preventDefault(), r.stopPropagation(), e.value = d, a(s, d);
  }
  function l(r, i, s, { downIndex: d = 0, upIndex: c = i - 1 } = {}) {
    if (r.key !== "ArrowDown" && r.key !== "ArrowUp" || i === 0) return !1;
    const f = r.key === "ArrowDown" ? d : c, g = s == null ? void 0 : s.querySelector(`[data-listbox-index="${f}"]`);
    return g ? (r.preventDefault(), e.value = f, g.focus({ preventScroll: !0 }), g.scrollIntoView({ block: "nearest" }), !0) : !1;
  }
  function o(r) {
    e.value = Math.min(e.value, Math.max(0, r - 1));
  }
  return {
    focusedIndex: e,
    focusListboxOption: a,
    handleRovingKeydown: n,
    handleSearchFieldKeydown: l,
    clampFocusedIndex: o,
    firstEnabledIndex: t
  };
}
const Sc = Symbol("FieldGroup"), x1 = { part: "", corners: "" };
function $c(e) {
  const a = na(Sc, null);
  let t = null;
  return kt(() => {
    t = e.value, a && t && a.register(t);
  }), Tt(() => {
    a && t && a.unregister(t);
  }), {
    inGroup: !!a,
    groupPart: m(() => a ? a.partOf(e.value) : x1)
  };
}
const y1 = ["src"], k1 = ["src"], w1 = ["name", "value"], C1 = ["id", "aria-expanded", "aria-haspopup", "aria-labelledby", "aria-label", "aria-describedby", "aria-disabled", "aria-readonly", "aria-required", "aria-invalid", "tabindex", "onClick", "onKeydown"], S1 = {
  key: 0,
  class: "inline-flex size-4 shrink-0 items-center justify-center",
  "aria-hidden": "true",
  "data-testid": "select-prefix-flag"
}, $1 = ["src"], I1 = {
  key: 2,
  class: "flex min-w-0 flex-1",
  "data-testid": "select-value"
}, L1 = ["src"], T1 = ["role", "aria-labelledby", "aria-label"], E1 = ["onKeydown"], A1 = {
  key: 1,
  "aria-live": "polite",
  role: "status",
  class: "sr-only",
  "data-testid": "select-status"
}, R1 = {
  key: 0,
  "data-testid": "select-results-heading",
  class: "flex shrink-0 px-2.5 pt-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
}, z1 = ["aria-labelledby", "aria-label"], D1 = ["aria-labelledby"], B1 = ["id"], M1 = {
  "data-testid": "select-no-results",
  class: "flex px-2.5 py-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
}, Ur = -1, yl = /* @__PURE__ */ ke({
  __name: "SelectInput",
  props: {
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    options: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    helpIcon: { default: void 0 },
    prefixIcon: { default: void 0 },
    prefixFlag: { default: void 0 },
    iconLeft: { default: void 0 },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    hint: { default: void 0 },
    noResultsLabel: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !1 },
    searchPlaceholder: { default: void 0 },
    searchLabel: { default: void 0 },
    searchClearLabel: { default: void 0 },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    resultsLabel: { default: void 0 },
    seeAllLabel: { default: void 0 },
    createLabel: { default: void 0 },
    createIcon: { default: "ri-add-line" },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "focus", "blur", "see-all", "create", "button-click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = Ye(), o = m(() => t.id || l), r = m(() => t.label ? `${o.value}-label` : void 0), i = m(() => `${o.value}-error`), s = m(() => `${o.value}-hint`), d = m(() => !!t.error), c = m(
      () => t.options.find((pe) => !pe.heading && pe.value === t.modelValue) ?? null
    ), f = m(() => {
      var Pe;
      const pe = (Pe = c.value) == null ? void 0 : Pe.iconColor;
      return pe && !t.disabled ? nm[pe] : void 0;
    }), g = m(() => {
      var pe;
      return ((pe = c.value) == null ? void 0 : pe.label) ?? "";
    }), h = m(() => {
      const pe = [];
      return t.hint && pe.push(s.value), d.value && pe.push(i.value), pe.length > 0 ? pe.join(" ") : void 0;
    }), v = R(!1), p = R(null), y = R(null), k = R(null), $ = (pe) => {
      var Pe, Xe;
      (Pe = y.value) == null || Pe.handleFieldKeydown(pe), (Xe = k.value) == null || Xe.handleFieldKeydown(pe);
    }, S = {
      sm: { container: "h-8 px-[calc(--spacing(2)-1px)] gap-2", text: "text-(length:--size-m) leading-(--line-height-l)", icon: "h-4 w-4" },
      md: { container: "h-9 px-3 py-2 gap-2", text: "text-(length:--size-m) leading-(--line-height-l)", icon: "h-4 w-4" },
      lg: { container: "h-12 px-3.5 gap-2", text: "text-(length:--size-l) leading-(--line-height-xxl)", icon: "h-5 w-5" },
      xl: { container: "h-13 px-4 gap-2", text: "text-(length:--size-l) leading-(--line-height-xxl)", icon: "h-5 w-5" }
    }, I = m(() => S[t.size]), T = (pe) => {
      const Pe = "relative flex items-center w-full rounded-xl border border-solid box-border text-left font-inter transition-colors select-none focus:outline-none";
      if (t.disabled)
        return `${Pe} bg-gainsboro-200 border-border-disabled-subtle text-text-disabled dark:bg-(--colors-background-disabled) dark:border-(--colors-border-disabled-subtle) dark:text-(--colors-text-disabled)`;
      if (t.readonly) {
        const Xe = v.value ? "border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)]" : "border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${Pe} cursor-default bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) ${Xe} text-text-black-default dark:text-(--colors-text-white-default)`;
      }
      if (d.value) {
        const Xe = v.value ? " shadow-[0px_0px_2px_var(--border-border-accent)]" : "";
        return `${Pe} cursor-pointer bg-white border-(--border-border-error-strong) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--border-border-error) dark:text-(--colors-text-white-default)${Xe}`;
      }
      return v.value || pe ? `${Pe} cursor-pointer bg-(--background-background-selected) border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)] text-text-black-default dark:bg-[rgba(255,255,255,0.05)] dark:text-(--colors-text-white-default)` : `${Pe} cursor-pointer bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-accent) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--colors-border-base) dark:text-(--colors-text-white-default)`;
    }, A = m(() => !!t.label || t.labelInline && !!t.iconLeft), E = m(() => t.labelInline && A.value), z = m(() => Co(t.labelInline, A.value, !1)), B = R(null), { inGroup: W, groupPart: _ } = $c(B), Z = m(() => t.fullWidth || W), le = m(() => {
      const pe = `relative ${W ? _.value.part : "pb-0.5"} text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter`, Pe = E.value ? z.value.root : "flex flex-col gap-0.5";
      return `${pe} ${Pe} ${Z.value ? "w-full" : ""}`;
    }), D = {
      xs: "min-h-8",
      sm: "min-h-9",
      md: "min-h-10",
      lg: "min-h-12",
      xl: "min-h-13"
    }, O = m(
      () => t.buttons.length > 0 && t.buttonLayout === "attached" ? D[t.buttonSize ?? ol(t.size, "attached")] : ""
    ), N = m(() => Z.value ? {} : { width: t.width }), V = m(() => t.labelInline && !Z.value ? { width: t.width } : Z.value ? {} : { width: t.width }), M = (pe) => !!pe && pe.startsWith("ri-"), Q = (pe) => {
      n("update:modelValue", pe), n("change", pe);
    }, q = (pe, Pe) => {
      pe.disabled || (Q(pe.value), ge.reset(), Pe(), Ze(() => {
        var Xe;
        return (Xe = p.value) == null ? void 0 : Xe.focus();
      }));
    }, K = (pe, Pe, Xe) => {
      ge.query.value.length > 0 || (Xe.preventDefault(), Xe.stopPropagation(), q(pe, Pe));
    }, G = R(null), { focusedIndex: te, focusListboxOption: ve, handleRovingKeydown: Se, handleSearchFieldKeydown: oe, firstEnabledIndex: re } = Mr(), ge = wc(), de = R(""), Ee = R(null), j = R(null), J = m(() => {
      const pe = ll(ge.query.value.trim()), Pe = [{ options: [] }];
      let Xe = 0;
      return t.options.forEach((nt, vt) => {
        if (nt.disabled, nt.label, nt.value, nt.heading) {
          Pe.push({ heading: nt, headingId: `${o.value}-group-${vt}`, options: [] });
          return;
        }
        (t.searchable ? kc(nt.label, de.value) : !pe || ll(nt.label).startsWith(pe)) && Pe[Pe.length - 1].options.push({ option: nt, index: Xe++ });
      }), Pe.filter((nt) => nt.options.length > 0);
    }), ne = m(
      () => J.value.flatMap((pe) => pe.options.map(({ option: Pe }) => Pe))
    ), Y = (pe) => {
      var Pe;
      return ((Pe = ne.value[pe]) == null ? void 0 : Pe.disabled) === !0;
    };
    function F() {
      if (ne.value.length === 0) return Ur;
      const pe = ne.value.findIndex((Pe) => Pe.value === t.modelValue);
      return pe >= 0 ? pe : re(ne.value.length, Y);
    }
    function ee(pe) {
      ve(G.value, pe);
    }
    $e(
      G,
      (pe) => {
        var Pe;
        if (!pe) {
          ge.reset(), de.value = "";
          return;
        }
        if (te.value = F(), t.searchable) {
          (Pe = j.value) == null || Pe.focusSearch();
          return;
        }
        te.value === Ur ? pe.focus() : ee(te.value);
      },
      { flush: "post" }
    ), $e(
      ne,
      () => {
        var Pe, Xe, nt;
        if (!G.value) return;
        if ((Pe = Ee.value) != null && Pe.contains(document.activeElement)) {
          te.value = F();
          return;
        }
        if (document.activeElement !== G.value && G.value.contains(document.activeElement)) {
          const vt = Number(
            (Xe = document.activeElement.closest("[data-listbox-index]")) == null ? void 0 : Xe.dataset.listboxIndex
          );
          if (!Number.isNaN(vt)) {
            te.value = vt;
            return;
          }
        }
        te.value = Math.min(Math.max(te.value, 0), ne.value.length - 1), te.value === Ur ? t.searchable ? (nt = j.value) == null || nt.focusSearch() : G.value.focus() : ee(te.value);
      },
      { flush: "post" }
    );
    const ue = (pe) => pe.key.length === 1 && !pe.ctrlKey && !pe.metaKey && !pe.altKey;
    function se(pe) {
      var Pe;
      if (t.searchable) {
        if (pe.key === "Tab" && (pe.shiftKey || xe.value)) {
          pe.stopPropagation();
          return;
        }
        const Xe = pe.key === "Backspace";
        if (Xe || ue(pe) && pe.key !== " ") {
          pe.preventDefault(), pe.stopPropagation(), de.value = Xe ? de.value.slice(0, -1) : de.value + pe.key, (Pe = j.value) == null || Pe.focusSearch();
          return;
        }
      } else if (ge.handleKey(pe)) {
        pe.preventDefault(), pe.stopPropagation();
        return;
      }
      Se(pe, ne.value.length, G.value);
    }
    const X = (pe, Pe) => ({
      ...{
        type: pe.badgeTheme ? "badge" : t.searchable ? "autocomplete" : "default",
        label: pe.label,
        icon: pe.badgeTheme ? void 0 : pe.icon,
        iconColor: pe.iconColor,
        badge: pe.badgeTheme ? { label: pe.label, theme: pe.badgeTheme, icon: pe.icon } : void 0,
        highlighted: pe.value === t.modelValue,
        ariaDisabled: !!pe.disabled,
        description: pe.disabled ? pe.disabledReason : void 0
      },
      role: "option",
      "aria-selected": pe.value === t.modelValue,
      tabindex: Pe === te.value ? 0 : -1,
      "data-listbox-index": Pe,
      "data-testid": `select-option-${pe.value}`,
      style: pe.fontFamily ? { fontFamily: pe.fontFamily } : void 0
    }), ae = (pe, Pe, Xe) => ({
      click: () => q(pe, Xe),
      focus: () => {
        te.value = Pe;
      },
      keydown: (nt) => {
        nt.key === "Enter" ? (nt.preventDefault(), q(pe, Xe)) : nt.key === " " && K(pe, Xe, nt);
      }
    }), Re = m(
      () => t.searchLabel ?? t.searchPlaceholder ?? t.label ?? t.ariaLabel
    ), Ae = m(() => {
      if (!(t.searchable ? de.value : ge.query.value)) return "";
      const Pe = ne.value.length;
      return t.searchable ? Pe === 0 && t.noResultsLabel ? t.noResultsLabel : Rs(t.resultsCountLabel, Pe) : String(Pe);
    }), xe = m(() => t.searchable && !!(t.seeAllLabel || t.createLabel)), we = (pe) => {
      pe(), Ze(() => {
        var Pe;
        return (Pe = p.value) == null ? void 0 : Pe.focus();
      });
    };
    function fe(pe, Pe) {
      we(Pe), n(pe === "see-all" ? "see-all" : "create");
    }
    function Ne(pe, Pe) {
      const Xe = ne.value.length;
      switch (pe.key) {
        case "ArrowDown":
        case "ArrowUp":
          pe.preventDefault(), pe.stopPropagation(), oe(pe, Xe, G.value, { downIndex: Math.max(te.value, 0) });
          break;
        case "Home":
        case "End":
          pe.stopPropagation();
          break;
        case "Tab":
          pe.shiftKey ? (pe.preventDefault(), pe.stopPropagation(), we(Pe)) : (te.value !== Ur || xe.value) && pe.stopPropagation();
          break;
      }
    }
    function De(pe) {
      if (pe.key !== "Tab") return;
      const Pe = pe.currentTarget.querySelectorAll("button, a[href]");
      (pe.shiftKey || pe.target !== Pe[Pe.length - 1]) && pe.stopPropagation();
    }
    let qe = !1;
    const Qe = (pe) => {
      var Pe;
      return ((Pe = pe.target) == null ? void 0 : Pe.closest("[data-field-label-tooltip]")) != null;
    }, lt = (pe) => {
      Qe(pe) || (qe = G.value !== null);
    }, Ie = (pe) => {
      var Xe, nt;
      if (Qe(pe)) return;
      const Pe = qe;
      if (qe = !1, !t.disabled) {
        if (Pe) {
          (Xe = p.value) == null || Xe.focus();
          return;
        }
        (nt = p.value) == null || nt.click();
      }
    };
    return (pe, Pe) => (u(), b("div", {
      ref_key: "rootRef",
      ref: B,
      class: C(le.value),
      style: Ge(e.labelInline ? {} : N.value)
    }, [
      A.value ? (u(), b("div", {
        key: 0,
        class: C([
          "flex min-w-0 max-w-full items-center gap-1",
          e.labelInline ? "shrink-0" : "",
          !e.disabled && !e.readonly ? "cursor-pointer" : ""
        ]),
        onMousedown: lt,
        onClick: Ie
      }, [
        e.iconLeft && e.labelInline ? (u(), b("img", {
          key: 0,
          src: e.iconLeft,
          class: "mr-1 h-6 w-6 rounded-full object-cover shrink-0",
          alt: ""
        }, null, 8, y1)) : w("", !0),
        e.label ? (u(), P(Ft, {
          key: 1,
          id: r.value,
          ref_key: "labelRef",
          ref: y,
          text: e.label,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: v.value,
          inline: e.labelInline,
          "test-id": "select-label"
        }, null, 8, ["id", "text", "required", "required-indicator", "tooltip", "focused", "inline"])) : w("", !0),
        e.helpIcon && !e.labelTooltip ? (u(), b(ie, { key: 2 }, [
          M(e.helpIcon) ? (u(), b("i", {
            key: 0,
            class: C([e.helpIcon, "text-(length:--size-m) leading-(--line-height-s) text-(--text-text-body-subtle) ml-0.5 cursor-help"])
          }, null, 2)) : (u(), b("img", {
            key: 1,
            src: e.helpIcon,
            class: "h-3.5 w-3.5 ml-0.5 cursor-help",
            alt: "Help"
          }, null, 8, k1))
        ], 64)) : w("", !0)
      ], 34)) : w("", !0),
      x("div", {
        style: Ge(V.value),
        class: C([{ "w-full": Z.value }, E.value ? z.value.field : ""])
      }, [
        x("input", {
          type: "hidden",
          name: e.name,
          value: e.modelValue
        }, null, 8, w1),
        U(Br, {
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          disabled: e.disabled,
          "button-size": e.buttonSize,
          onButtonClick: Pe[3] || (Pe[3] = (Xe) => n("button-click", Xe))
        }, {
          default: me(({ fieldClass: Xe }) => [
            U(Ra, {
              "full-width": !0,
              "menu-width": V.value.width ?? "100%",
              disabled: e.disabled,
              bare: ""
            }, {
              trigger: me(({ toggle: nt, isOpen: vt }) => {
                var Gt, Fe, je;
                return [
                  x("div", {
                    id: o.value,
                    ref_key: "triggerRef",
                    ref: p,
                    role: "combobox",
                    "aria-expanded": vt,
                    "aria-haspopup": e.searchable ? "dialog" : "listbox",
                    "aria-labelledby": r.value,
                    "aria-label": e.label ? void 0 : e.ariaLabel,
                    "aria-describedby": h.value,
                    "aria-disabled": e.disabled ? "true" : void 0,
                    "aria-readonly": e.readonly ? "true" : void 0,
                    "aria-required": e.required ? "true" : void 0,
                    "aria-invalid": d.value ? "true" : void 0,
                    tabindex: e.disabled ? -1 : 0,
                    "data-testid": "select-input",
                    class: C([T(vt), I.value.container, O.value, Xe || L(_).corners]),
                    onClick: (Ke) => !e.disabled && !e.readonly && nt(),
                    onKeydown: [
                      (Ke) => !vt && $(Ke),
                      St(_e((Ke) => !e.disabled && !e.readonly && nt(), ["prevent"]), ["enter"]),
                      St(_e((Ke) => !e.disabled && !e.readonly && nt(), ["prevent"]), ["space"])
                    ],
                    onFocus: Pe[0] || (Pe[0] = (Ke) => {
                      v.value = !0, pe.$emit("focus");
                    }),
                    onBlur: Pe[1] || (Pe[1] = (Ke) => {
                      v.value = !1, pe.$emit("blur");
                    })
                  }, [
                    e.prefixFlag ? (u(), b("span", S1, [
                      x("span", {
                        class: C(["fi fis size-[13.33px] rounded-full", `fi-${e.prefixFlag.toLowerCase()}`])
                      }, null, 2)
                    ])) : e.prefixIcon ? (u(), b(ie, { key: 1 }, [
                      M(e.prefixIcon) ? (u(), b("i", {
                        key: 0,
                        class: C([e.prefixIcon, "shrink-0 text-base leading-none", I.value.icon])
                      }, null, 2)) : (u(), b("img", {
                        key: 1,
                        src: e.prefixIcon,
                        class: C(["shrink-0 object-cover", I.value.icon]),
                        alt: ""
                      }, null, 10, $1))
                    ], 64)) : w("", !0),
                    (Gt = c.value) != null && Gt.badgeTheme ? (u(), b("span", I1, [
                      U(yt, {
                        label: c.value.label,
                        theme: c.value.badgeTheme,
                        "left-icon": c.value.icon,
                        size: "sm",
                        "data-testid": "select-value-badge"
                      }, null, 8, ["label", "theme", "left-icon"])
                    ])) : (u(), b(ie, { key: 3 }, [
                      (Fe = c.value) != null && Fe.icon && !e.prefixFlag && !e.prefixIcon ? (u(), b(ie, { key: 0 }, [
                        M(c.value.icon) ? (u(), b("i", {
                          key: 0,
                          class: C([c.value.icon, "shrink-0 text-(length:--icon-size-sm) leading-(--icon-size-sm)", I.value.icon, f.value]),
                          "aria-hidden": "true",
                          "data-testid": "select-value-icon"
                        }, null, 2)) : (u(), b("img", {
                          key: 1,
                          src: c.value.icon,
                          class: C(["shrink-0 object-cover", I.value.icon]),
                          alt: "",
                          "data-testid": "select-value-icon"
                        }, null, 10, L1))
                      ], 64)) : w("", !0),
                      x("span", {
                        class: C(["flex min-w-0 flex-1", [
                          I.value.text,
                          e.disabled ? "" : g.value ? "text-text-black-default dark:text-(--colors-text-white-default)" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
                        ]]),
                        style: Ge((je = c.value) != null && je.fontFamily ? { fontFamily: c.value.fontFamily } : void 0),
                        "data-testid": "select-value"
                      }, [
                        U(it, {
                          text: g.value || e.placeholder || "",
                          focusable: !1
                        }, null, 8, ["text"])
                      ], 6)
                    ], 64)),
                    x("i", {
                      class: C(["ri-arrow-down-s-line shrink-0 text-base leading-none transition-transform duration-200 ease-in-out", [I.value.icon, e.disabled ? "text-text-disabled" : "text-(--text-text-body-subtle)"]]),
                      style: Ge({ transform: vt ? "rotate(180deg)" : "rotate(0deg)" })
                    }, null, 6)
                  ], 42, C1)
                ];
              }),
              menu: me(({ close: nt }) => [
                x("div", {
                  role: e.searchable ? "dialog" : void 0,
                  "aria-labelledby": e.searchable ? r.value : void 0,
                  "aria-label": e.searchable && !e.label ? e.ariaLabel : void 0,
                  "data-testid": "select-panel",
                  class: C(
                    e.searchable ? "flex max-h-[calc(100vh-90px)] flex-col" : "box-border flex max-h-[min(400px,calc(100vh-24px))] flex-col gap-1.5 overflow-y-auto p-[calc(--spacing(2)-1px)]"
                  )
                }, [
                  e.searchable ? (u(), b("div", {
                    key: 0,
                    ref_key: "searchAreaRef",
                    ref: Ee,
                    class: "shrink-0",
                    onKeydown: (vt) => Ne(vt, nt)
                  }, [
                    U(Bl, {
                      ref_key: "headerRef",
                      ref: j,
                      "show-search": "",
                      "search-query": de.value,
                      "search-placeholder": e.searchPlaceholder,
                      "search-label": Re.value,
                      "search-clear-label": e.searchClearLabel,
                      "onUpdate:searchQuery": Pe[2] || (Pe[2] = (vt) => de.value = vt)
                    }, null, 8, ["search-query", "search-placeholder", "search-label", "search-clear-label"])
                  ], 40, E1)) : w("", !0),
                  e.searchable || L(ge).query.value ? (u(), b("span", A1, H(Ae.value), 1)) : w("", !0),
                  x("div", {
                    "data-testid": "select-list",
                    class: C(
                      e.searchable ? ["flex max-h-100 min-h-0 flex-col overflow-y-auto p-1", !ne.value.length && "hidden"] : "contents"
                    )
                  }, [
                    e.searchable && e.resultsLabel ? (u(), b("div", R1, H(e.resultsLabel), 1)) : w("", !0),
                    x("ul", {
                      ref_key: "listboxRef",
                      ref: G,
                      role: "listbox",
                      "aria-labelledby": r.value,
                      "aria-label": e.label ? void 0 : e.ariaLabel,
                      tabindex: "-1",
                      class: C(["flex w-full flex-col focus-visible:outline-none", !e.searchable && "gap-1.5"]),
                      onKeydown: se
                    }, [
                      (u(!0), b(ie, null, Oe(J.value, (vt) => (u(), b(ie, {
                        key: vt.headingId ?? "ungrouped"
                      }, [
                        vt.heading ? (u(), b("li", {
                          key: 0,
                          role: "group",
                          "aria-labelledby": vt.headingId,
                          class: C(["flex flex-col", !e.searchable && "gap-1.5"])
                        }, [
                          x("div", {
                            id: vt.headingId,
                            role: "presentation",
                            "data-testid": "select-group-heading",
                            class: "flex shrink-0 px-2.5 pt-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)"
                          }, H(vt.heading.label), 9, B1),
                          (u(!0), b(ie, null, Oe(vt.options, ({ option: Gt, index: Fe }) => (u(), P(fa, Ve({
                            key: Gt.value,
                            as: "div"
                          }, { ref_for: !0 }, X(Gt, Fe), nl(ae(Gt, Fe, nt))), null, 16))), 128))
                        ], 10, D1)) : (u(!0), b(ie, { key: 1 }, Oe(vt.options, ({ option: Gt, index: Fe }) => (u(), P(fa, Ve({
                          key: Gt.value,
                          as: "li"
                        }, { ref_for: !0 }, X(Gt, Fe), nl(ae(Gt, Fe, nt))), null, 16))), 128))
                      ], 64))), 128))
                    ], 42, z1)
                  ], 2),
                  ne.value.length === 0 && e.noResultsLabel ? (u(), b("div", {
                    key: 2,
                    class: C(e.searchable && "p-1")
                  }, [
                    x("div", M1, H(e.noResultsLabel), 1)
                  ], 2)) : w("", !0),
                  xe.value ? (u(), P(Dl, {
                    key: 3,
                    type: "see-all-create",
                    "see-all-label": e.seeAllLabel,
                    "create-label": e.createLabel,
                    "create-icon": e.createIcon,
                    class: "shrink-0",
                    onKeydown: De,
                    onSeeAll: (vt) => fe("see-all", nt),
                    onCreate: (vt) => fe("create", nt)
                  }, null, 8, ["see-all-label", "create-label", "create-icon", "onSeeAll", "onCreate"])) : w("", !0)
                ], 10, T1)
              ]),
              _: 2
            }, 1032, ["menu-width", "disabled"])
          ]),
          _: 1
        }, 8, ["buttons", "layout", "size", "disabled", "button-size"])
      ], 6),
      !L(W) && z.value.reservesHelper || e.hint || e.error ? (u(), P(Pt, {
        key: 1,
        ref_key: "helperRef",
        ref: k,
        class: C(E.value ? z.value.helper : ""),
        focused: v.value,
        hint: e.hint,
        error: e.error,
        "hint-id": s.value,
        "error-id": i.value,
        "error-live": e.errorLive,
        "test-id-prefix": "select"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id", "error-live"])) : w("", !0)
    ], 6));
  }
}), rd = "None", uu = /* @__PURE__ */ ke({
  __name: "AccessLevelSelect",
  props: {
    modelValue: {},
    label: {},
    levels: {},
    allowNone: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    disabledLevels: { default: () => [] },
    hint: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => [
      { value: "Edit", label: t.levels.edit, disabled: t.disabledLevels.includes("Edit") },
      { value: "View", label: t.levels.view, disabled: t.disabledLevels.includes("View") },
      ...t.allowNone ? [{ value: rd, label: t.levels.none }] : []
    ]), o = m(() => t.modelValue ?? rd), r = m(() => l.value.every((s) => s.disabled)), i = (s) => {
      n("update:modelValue", s === rd ? null : s);
    };
    return (s, d) => (u(), P(yl, {
      "model-value": o.value,
      options: l.value,
      label: e.label,
      disabled: e.disabled || r.value,
      hint: e.hint,
      "full-width": "",
      "onUpdate:modelValue": i
    }, null, 8, ["model-value", "options", "label", "disabled", "hint"]));
  }
});
function Ds(e, a, t = {}) {
  const { ignoreSelectors: n, ignoreElements: l, isActive: o } = t, r = (i) => {
    if (o && !o()) return;
    const s = e.value, d = i.target;
    if (!(!s || !d || s.contains(d)) && d.isConnected && !(l != null && l().some((c) => c && c.contains(d)))) {
      if (n != null && n.length) {
        const c = d instanceof Element ? d : d.parentElement;
        if (c && n.some((f) => c.closest(f))) return;
      }
      a();
    }
  };
  kt(() => {
    document.addEventListener("click", r, !0);
  }), zt(() => {
    document.removeEventListener("click", r, !0);
  });
}
function So(e = {}) {
  const { defaultOpen: a = !1, onClose: t, ignoreSelectors: n } = e, l = R(a), o = R(null), r = () => {
    l.value = !l.value;
  }, i = () => {
    l.value = !0;
  }, s = () => {
    l.value = !1, t == null || t();
  };
  return Ds(o, s, { ignoreSelectors: n }), {
    isOpen: l,
    dropdownRef: o,
    toggleDropdown: r,
    openDropdown: i,
    closeDropdown: s
  };
}
const O1 = /* @__PURE__ */ ke({
  __name: "ButtonLink",
  props: {
    as: {},
    iconLeft: {},
    iconRight: {},
    size: {},
    ariaLabel: {},
    disabled: { type: Boolean },
    ariaDisabled: { type: [Boolean, String] }
  },
  setup(e) {
    const a = e;
    return (t, n) => (u(), P(lm, Ve(a, { underline: "always" }), {
      default: me(() => [
        Me(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
function P1(e) {
  const a = R(null), t = R(null);
  function n(i) {
    a.value = i;
  }
  function l(i) {
    a.value !== i && (t.value = i);
  }
  function o(i) {
    const s = a.value;
    if (!s || s === i) return;
    const d = e.value.find((g) => g.id === s), c = e.value.find((g) => g.id === i);
    if (!d || !c || c.disabled) return;
    const f = d.order;
    d.order = c.order, c.order = f, a.value = null, t.value = null;
  }
  function r() {
    a.value = null, t.value = null;
  }
  return { draggedId: a, dragOverId: t, onDragStart: n, onDragOver: l, onDrop: o, onDragEnd: r };
}
const Ic = {
  m: "320px",
  l: "498px",
  xl: "768px"
}, F1 = ["aria-expanded"], N1 = ["src"], V1 = { class: "relative dark:text-(--colors-text-white-default)" }, H1 = ["src"], j1 = ["aria-label"], W1 = ["role", "aria-label", "aria-multiselectable"], q1 = ["role"], U1 = ["role", "onFocusin"], G1 = { key: 1 }, Gr = 4, Ro = 8, K1 = 240, Qf = '[data-testid="dropdown-list-item-more-actions-trigger"]', id = "text-(length:--icon-size-sm) leading-(--icon-size-sm)", Lc = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "FilterDropdown",
  props: {
    label: { default: "Filters" },
    triggerIconLeft: { default: void 0 },
    triggerIcon: { default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    size: { default: void 0 },
    menuWidth: { default: "auto" },
    menuAlign: { default: "left" },
    tab: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    headerLabelLeft: { default: void 0 },
    headerLabelRight: { default: void 0 },
    showSearch: { type: Boolean, default: !1 },
    searchQuery: { default: "" },
    searchPlaceholder: { default: "Search…" },
    searchClearLabel: { default: "Clear search" },
    groupButtons: { default: () => [] },
    groupButtonsLabel: { default: void 0 },
    activeGroupButton: { default: void 0 },
    items: { default: () => [] },
    maxListHeight: { default: void 0 },
    reserveListHeight: { type: Boolean, default: !1 },
    emptyLabel: { default: void 0 },
    emptyIcon: { default: void 0 },
    checkboxPosition: { default: void 0 },
    moreActionsLabel: { default: "More actions" },
    footerLabel: { default: void 0 },
    footerButtons: { default: () => [] },
    stickyItem: { default: void 0 },
    disableInternalSearchFilter: { type: Boolean, default: !1 },
    reorderable: { type: Boolean, default: !1 },
    freezeOnOpen: { type: Boolean, default: !1 }
  },
  emits: ["update:searchQuery", "update:activeGroupButton", "open", "close", "reorder"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, { isOpen: o, dropdownRef: r, toggleDropdown: i, openDropdown: s, closeDropdown: d } = So({
      defaultOpen: n.defaultOpen,
      ignoreSelectors: ['[data-testid="dropdown-menu"]']
    }), c = R(null), f = R(null), g = R(null), h = R(null), v = R(null), p = R(null);
    let y = null, k = -1;
    function $() {
      var et, pt;
      const Ce = ((et = f.value) == null ? void 0 : et.$el) ?? c.value;
      if (Ce) return Ce;
      const He = ((pt = r.value) == null ? void 0 : pt.querySelectorAll("[aria-expanded]")) ?? [];
      return Array.from(He).find((It) => !It.closest('[data-testid="filter-dropdown-menu"]')) ?? null;
    }
    function S() {
      return $() ?? r.value;
    }
    function I(Ce) {
      const He = Ce.style.maxHeight;
      Ce.style.maxHeight = "none";
      const et = Ce.offsetHeight, pt = Ce.querySelector('[data-testid="filter-dropdown-list"]'), It = pt == null ? void 0 : pt.querySelector(".filter-item-row");
      return Ce.style.maxHeight = He, { height: et, least: et - ((pt == null ? void 0 : pt.offsetHeight) ?? 0) + ((It == null ? void 0 : It.offsetHeight) ?? 0) };
    }
    function T(Ce, He) {
      return Math.min(Math.max(Ro, Ce), Math.max(Ro, window.innerWidth - He - Ro));
    }
    function A() {
      var Ce;
      n.freezeOnOpen && (y = ((Ce = S()) == null ? void 0 : Ce.getBoundingClientRect()) ?? null, E());
    }
    function E() {
      const Ce = g.value;
      if (!n.freezeOnOpen || !y || !Ce) return;
      const He = y, { height: et, least: pt } = I(Ce);
      k = et;
      const It = Math.max(et, K1), Ht = window.innerHeight - He.bottom - Gr - Ro, ha = He.top - Gr - Ro, Ot = p.value, ce = (Ot == null ? void 0 : Ot.bottom) !== void 0, Le = !!Ot && It <= (ce ? ha : Ht) ? ce : It > Ht && ha > Ht, Je = Math.max(0, Le ? ha : Ht), Bt = Le ? { bottom: window.innerHeight - He.top + Gr } : { top: He.bottom + Gr }, Va = Ce.offsetWidth, ml = n.menuAlign === "right" ? { right: T(window.innerWidth - He.right, Va) } : { left: T(He.left, Va) };
      p.value = { ...Bt, ...ml, maxHeight: Je, scrollsWhole: Je < pt };
    }
    Er(() => {
      const Ce = g.value;
      !p.value || !Ce || I(Ce).height === k || E();
    });
    let z = 0;
    const B = /* @__PURE__ */ new Set();
    function W(Ce, He) {
      return Ce.bottom >= He.top && Ce.top <= He.bottom && Ce.right >= He.left && Ce.left <= He.right;
    }
    function _(Ce) {
      const He = S(), et = Ce.target;
      !He || !(et === document || et instanceof Element && et.contains(He)) || (et instanceof Element && et !== document.documentElement && et !== document.body && B.add(et), z || (z = requestAnimationFrame(Z)));
    }
    function Z() {
      var It;
      z = 0;
      const Ce = S(), He = [...B];
      if (B.clear(), !o.value || !Ce) return;
      const et = Ce.getBoundingClientRect(), pt = { top: 0, bottom: window.innerHeight, left: 0, right: window.innerWidth };
      if (!W(et, pt) || He.some((Ht) => !W(et, Ht.getBoundingClientRect()))) {
        const Ht = !!((It = g.value) != null && It.contains(document.activeElement));
        d(), Ht && Ze(() => {
          var ha;
          return (ha = $()) == null ? void 0 : ha.focus();
        });
        return;
      }
      y = et, E();
    }
    function le() {
      window.removeEventListener("scroll", _, !0), z && cancelAnimationFrame(z), z = 0, B.clear();
    }
    Tt(le);
    function D() {
      d(), Ze(() => {
        var Ce;
        return (Ce = $()) == null ? void 0 : Ce.focus();
      });
    }
    const O = (Ce) => {
      o.value && (Ce.stopPropagation(), Ce.preventDefault(), D());
    }, N = (Ce) => {
      var et;
      const He = n.footerButtons[Ce];
      !He || He.disabled || ((et = He.onClick) == null || et.call(He), He.keepOpen || D());
    };
    function V() {
      var Ce, He;
      (Ce = v.value) != null && Ce.focusSearch() || (He = g.value) == null || He.focus();
    }
    a({ openDropdown: s, closeDropdown: d, isOpen: o }), $e(
      o,
      (Ce) => {
        Ce ? (A(), l("open"), V(), n.freezeOnOpen && window.addEventListener("scroll", _, !0)) : (le(), p.value = null, y = null, k = -1, l("close"));
      },
      { flush: "post" }
    );
    const M = m(() => {
      var et, pt;
      let Ce = n.items ?? [];
      n.activeGroupButton && ((et = n.groupButtons) != null && et.length) && (Ce = Ce.filter((It) => !It.group || It.group === n.activeGroupButton));
      const He = (pt = n.searchQuery) == null ? void 0 : pt.trim().toLowerCase();
      return He && !n.disableInternalSearchFilter && (Ce = Ce.filter((It) => It.label.toLowerCase().includes(He))), Ce;
    }), Q = R([]);
    $e(
      M,
      (Ce) => {
        Q.value = Ce.map((He, et) => ({ id: He.id, order: et, disabled: He.disabled }));
      },
      { immediate: !0, deep: !1 }
    );
    const { onDragStart: q, onDragOver: K, onDrop: G, onDragEnd: te } = P1(Q), ve = m(() => {
      if (!n.reorderable) return M.value;
      const Ce = new Map(M.value.map((He) => [He.id, He]));
      return [...Q.value].sort((He, et) => He.order - et.order).map((He) => Ce.get(He.id)).filter((He) => !!He);
    });
    function Se(Ce) {
      G(Ce), l("reorder", [...Q.value].sort((He, et) => He.order - et.order).map((He) => He.id));
    }
    const oe = m(
      () => {
        var Ce, He, et;
        return !!((Ce = n.headerLabelLeft) != null && Ce.text || (He = n.headerLabelRight) != null && He.text || n.showSearch || (et = n.groupButtons) != null && et.length);
      }
    ), re = m(() => !!n.stickyItem), ge = m(() => ve.value.length > 0), de = m(() => !ge.value && !!n.emptyLabel), Ee = m(
      () => de.value || !ge.value && n.reserveListHeight && !!n.maxListHeight
    ), j = m(() => re.value || ge.value), J = m(() => {
      var Ce;
      return n.ariaLabel || ((Ce = n.headerLabelLeft) == null ? void 0 : Ce.text) || n.label;
    }), ne = m(
      () => {
        var Ce, He, et;
        return !!((Ce = n.items) != null && Ce.some((pt) => pt.hasCheckbox || pt.hasSwitch)) || !!((He = n.stickyItem) != null && He.hasCheckbox) || !!((et = n.stickyItem) != null && et.hasSwitch);
      }
    ), Y = m(() => {
      var Ce;
      return !!((Ce = n.items) != null && Ce.some((He) => {
        var et;
        return (et = He.moreActions) == null ? void 0 : et.length;
      }));
    }), F = m(() => {
      var Ce, He;
      return !!((Ce = n.items) != null && Ce.some((et) => et.hasCheckbox)) || !!((He = n.stickyItem) != null && He.hasCheckbox);
    }), ee = m(() => [
      "flex flex-col px-2",
      F.value ? "gap-0.5" : "gap-0",
      re.value ? "py-0.5" : "py-1.5"
    ]), ue = m(
      () => n.maxListHeight ? { [n.reserveListHeight ? "height" : "maxHeight"]: n.maxListHeight } : {}
    );
    function se(Ce) {
      return Ce.hasSwitch ? "toggle" : Ce.hasCheckbox ? Ce.badgeTheme ? "badge-checkbox" : "checkbox" : Ce.badgeTheme ? "badge" : "default";
    }
    function X(Ce) {
      return Ce.map((He) => ({ label: He.label, icon: He.icon, danger: He.variant === "danger", onClick: He.onClick }));
    }
    const ae = m(() => {
      const Ce = /* @__PURE__ */ new Map();
      for (const He of [n.stickyItem, ...n.items ?? []])
        He != null && He.moreActions && Ce.set(He.id, X(He.moreActions));
      return Ce;
    });
    function Re(Ce) {
      return se(Ce) === "checkbox" && Ce.count !== void 0 ? `(${Ce.count})` : void 0;
    }
    function Ae(Ce, He) {
      var pt, It;
      const et = se(Ce);
      return {
        as: "div",
        type: et,
        label: Ce.label,
        icon: et === "default" ? Ce.icon : void 0,
        count: Re(Ce),
        badge: Ce.badgeTheme ? { label: Ce.label, theme: Ce.badgeTheme, rightIcon: Ce.badgeRightIcon } : void 0,
        checked: et === "toggle" ? !!Ce.switchChecked : !!Ce.checked,
        indeterminate: !!Ce.indeterminate,
        ariaDisabled: !!Ce.disabled,
        // The reason wins: it is what the user needs to know about a disabled option.
        description: Ce.disabled && Ce.disabledReason || Ce.secondaryText,
        moreActions: ae.value.get(Ce.id),
        moreActionsLabel: (pt = Ce.moreActions) != null && pt.length ? n.moreActionsLabel : void 0,
        moreActionsTabindex: (It = Ce.moreActions) != null && It.length ? Qe(He, 1) ? 0 : -1 : void 0
      };
    }
    function xe(Ce) {
      var He;
      Ce && !Ce.disabled && ((He = Ce.onClick) == null || He.call(Ce));
    }
    const { focusedIndex: we, handleRovingKeydown: fe, handleSearchFieldKeydown: Ne, clampFocusedIndex: De } = Mr(), qe = R(0);
    function Qe(Ce, He) {
      return we.value === Ce && (Y.value ? qe.value === He : He === 0);
    }
    function lt(Ce) {
      return re.value ? Ce + 1 : Ce;
    }
    const Ie = m(() => ve.value.length + (re.value ? 1 : 0));
    $e(Ie, (Ce) => De(Ce));
    function pe(Ce) {
      return Ce.hasSwitch ? "switch" : Ce.hasCheckbox ? "checkbox" : "button";
    }
    function Pe(Ce) {
      if (Ce.hasSwitch) return Ce.switchChecked ? "true" : "false";
      if (Ce.hasCheckbox) return Ce.indeterminate ? "mixed" : Ce.checked ? "true" : "false";
    }
    function Xe(Ce, He) {
      return {
        role: Y.value ? pe(Ce) : "option",
        "aria-selected": Y.value ? void 0 : !!(Ce.checked || Ce.switchChecked),
        "aria-checked": Y.value ? Pe(Ce) : void 0,
        "aria-label": [Ce.label, Re(Ce)].filter(Boolean).join(" "),
        tabindex: Qe(He, 0) ? 0 : -1,
        "data-listbox-index": He,
        onClick: () => xe(Ce),
        onKeydown: St(_e(() => xe(Ce), ["self", "prevent"]), ["enter", "space"]),
        onFocus: () => {
          we.value = He, qe.value = 0;
        }
      };
    }
    function nt(Ce, He) {
      var et;
      (et = Ce.target) != null && et.closest(Qf) && (we.value = He, qe.value = 1);
    }
    function vt(Ce) {
      if (Ce.key !== "ArrowRight" && Ce.key !== "ArrowLeft") return !1;
      const He = Ce.target, et = He.closest('[role="listitem"]');
      if (!et) return !1;
      const pt = et.querySelector("[data-listbox-index]"), It = et.querySelector(Qf), Ht = Ce.key === "ArrowRight" ? It : pt;
      return !Ht || Ht === He || !pt ? !1 : (Ce.preventDefault(), we.value = Number(pt.dataset.listboxIndex), qe.value = Ht === It ? 1 : 0, Ht.focus(), !0);
    }
    function Gt(Ce) {
      if (!Ce.defaultPrevented) {
        if (Y.value) {
          if (vt(Ce)) return;
          ["ArrowDown", "ArrowUp", "Home", "End"].includes(Ce.key) && (qe.value = 0);
        }
        fe(Ce, Ie.value, h.value);
      }
    }
    function Fe(Ce) {
      if (Ce.defaultPrevented) return;
      const He = Ce.target;
      !(He instanceof HTMLTextAreaElement || He instanceof HTMLInputElement && !["checkbox", "radio", "button", "submit", "reset"].includes(He.type)) && He !== g.value || Ne(Ce, Ie.value, h.value) && (qe.value = 0);
    }
    const je = m(() => {
      const [Ce, He] = n.footerButtons.slice(0, 2).map((pt) => ({ label: pt.label, variant: pt.variant, icon: pt.icon, disabled: pt.disabled }));
      if (!Ce) return null;
      const et = n.footerLabel;
      return He ? et ? { type: "buttons-column", buttons: [Ce, He], label: et } : { type: "buttons-inline", buttons: [Ce, He] } : et ? { type: "label-button", buttons: [Ce], label: et } : { type: "button", buttons: [Ce] };
    }), Ke = m(() => n.size ? { width: Ic[n.size] } : n.menuWidth && n.menuWidth !== "auto" ? { width: n.menuWidth, maxWidth: "594px" } : { maxWidth: "594px" }), bt = m(() => {
      if (!p.value && n.freezeOnOpen)
        return { position: "fixed", top: "0px", left: "0px", ...Ke.value };
      if (!p.value) return Ke.value;
      const Ce = { position: "fixed", maxHeight: `${p.value.maxHeight}px` };
      return p.value.top !== void 0 ? Ce.top = `${p.value.top}px` : p.value.bottom !== void 0 && (Ce.bottom = `${p.value.bottom}px`), p.value.left !== void 0 ? Ce.left = `${p.value.left}px` : p.value.right !== void 0 && (Ce.right = `${p.value.right}px`), { ...Ce, ...Ke.value };
    }), At = (Ce) => !!Ce && Ce.startsWith("ri-");
    return (Ce, He) => (u(), b("div", Ve({
      ref_key: "dropdownRef",
      ref: r
    }, Ce.$attrs, {
      class: ["relative dark:text-(--colors-text-white-default)", e.tab ? "flex h-full items-stretch" : "inline-block text-left"],
      onKeydown: St(O, ["escape"])
    }), [
      Me(Ce.$slots, "trigger", {
        toggle: L(i),
        isOpen: L(o)
      }, () => [
        e.tab ? (u(), b("button", {
          key: 0,
          ref_key: "triggerRef",
          ref: c,
          type: "button",
          "data-testid": "filter-dropdown-trigger",
          class: "inline-flex shrink-0 h-full cursor-pointer items-center gap-1.5 px-3 rounded-tl-(--border-border-radius-rounded-sm) rounded-tr-(--border-border-radius-rounded-sm) border-t border-r border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-black-default) transition-colors duration-200 hover:bg-whitesmoke focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-royalblue dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10",
          "aria-expanded": L(o),
          "aria-haspopup": "dialog",
          onClick: He[0] || (He[0] = //@ts-ignore
          (...et) => L(i) && L(i)(...et))
        }, [
          e.triggerIconLeft ? (u(), b(ie, { key: 0 }, [
            At(e.triggerIconLeft) ? (u(), b("i", {
              key: 0,
              class: C([e.triggerIconLeft, id]),
              "aria-hidden": "true"
            }, null, 2)) : (u(), b("img", {
              key: 1,
              class: "h-4 w-4",
              src: e.triggerIconLeft,
              alt: ""
            }, null, 8, N1))
          ], 64)) : w("", !0),
          x("span", V1, H(e.label), 1),
          e.triggerIcon ? (u(), b(ie, { key: 1 }, [
            At(e.triggerIcon) ? (u(), b("i", {
              key: 0,
              class: C([e.triggerIcon, id, "transition-transform duration-200 ease-in-out"]),
              style: Ge({ transform: L(o) ? "rotate(180deg)" : "rotate(0deg)" }),
              "aria-hidden": "true"
            }, null, 6)) : (u(), b("img", {
              key: 1,
              class: "h-4 w-4 transition-transform duration-200 ease-in-out",
              style: Ge({ transform: L(o) ? "rotate(180deg)" : "rotate(0deg)" }),
              src: e.triggerIcon,
              alt: ""
            }, null, 12, H1))
          ], 64)) : (u(), b("i", {
            key: 2,
            class: C(["ri-arrow-down-s-line", id, "transition-transform duration-200 ease-in-out"]),
            style: Ge({ transform: L(o) ? "rotate(180deg)" : "rotate(0deg)" }),
            "aria-hidden": "true"
          }, null, 6))
        ], 8, F1)) : (u(), P(L(Be), {
          key: 1,
          ref_key: "triggerButtonRef",
          ref: f,
          "data-testid": "filter-dropdown-trigger",
          size: "xs",
          variant: "secondary",
          label: e.label,
          "icon-left": e.triggerIconLeft,
          "icon-right": e.triggerIcon,
          "dropdown-icon": !e.triggerIcon,
          "aria-expanded": L(o),
          "aria-haspopup": "dialog",
          onClick: L(i)
        }, null, 8, ["label", "icon-left", "icon-right", "dropdown-icon", "aria-expanded", "onClick"]))
      ]),
      U(Wt, {
        "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
        "enter-from-class": "transform scale-95 opacity-0",
        "enter-to-class": "transform scale-100 opacity-100",
        "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
        "leave-from-class": "transform scale-100 opacity-100",
        "leave-to-class": "transform scale-95 opacity-0"
      }, {
        default: me(() => {
          var et, pt, It, Ht, ha;
          return [
            L(o) ? (u(), b("div", {
              key: 0,
              ref_key: "menuRef",
              ref: g,
              role: "dialog",
              "aria-label": J.value,
              "data-testid": "filter-dropdown-menu",
              tabindex: "-1",
              class: C([
                L(hl),
                "z-50 flex min-w-[220px] flex-col focus-visible:outline-none",
                (et = p.value) != null && et.scrollsWhole ? "overflow-y-auto overscroll-contain" : "overflow-hidden",
                e.freezeOnOpen ? "" : ["absolute top-full mt-1", e.menuAlign === "right" ? "right-0" : "left-0"]
              ]),
              style: Ge(bt.value),
              onKeydown: Fe
            }, [
              oe.value ? (u(), P(Bl, {
                key: 0,
                ref_key: "headerRef",
                ref: v,
                "label-left": (pt = e.headerLabelLeft) == null ? void 0 : pt.text,
                "label-right": (It = e.headerLabelRight) == null ? void 0 : It.text,
                "show-search": e.showSearch,
                "search-query": e.searchQuery,
                "search-placeholder": e.searchPlaceholder,
                "search-clear-label": e.searchClearLabel,
                "group-buttons": e.groupButtons,
                "active-group": e.activeGroupButton,
                "group-label-left": e.groupButtonsLabel,
                "group-aria-label": ((Ht = e.headerLabelLeft) == null ? void 0 : Ht.text) || e.label,
                class: "shrink-0",
                "onUpdate:searchQuery": He[1] || (He[1] = (Ot) => l("update:searchQuery", Ot)),
                "onUpdate:activeGroup": He[2] || (He[2] = (Ot) => l("update:activeGroupButton", Ot))
              }, null, 8, ["label-left", "label-right", "show-search", "search-query", "search-placeholder", "search-clear-label", "group-buttons", "active-group", "group-label-left", "group-aria-label"])) : w("", !0),
              j.value || Ee.value ? (u(), b("div", {
                key: 1,
                "data-testid": "filter-dropdown-content",
                class: C(["flex min-h-0 flex-col gap-1.5 pb-2", { "shrink-0": (ha = p.value) == null ? void 0 : ha.scrollsWhole }])
              }, [
                j.value ? (u(), b("div", {
                  key: 0,
                  ref_key: "listboxRef",
                  ref: h,
                  role: Y.value ? "list" : "listbox",
                  "aria-label": J.value,
                  "aria-multiselectable": ne.value && !Y.value ? "true" : void 0,
                  class: "flex min-h-0 flex-col",
                  onKeydown: Gt
                }, [
                  e.stickyItem ? (u(), b("div", {
                    key: 0,
                    "data-testid": "filter-dropdown-select-all",
                    role: Y.value ? "listitem" : void 0,
                    class: "shrink-0 border-b border-(--border-border-base-soft) px-2 pt-2 pb-[calc(--spacing(2)-1px)] dark:border-(--colors-border-base)"
                  }, [
                    U(fa, Ve({ ...Ae(e.stickyItem, 0), ...Xe(e.stickyItem, 0) }, { "data-testid": "filter-dropdown-sticky-item" }), null, 16)
                  ], 8, q1)) : w("", !0),
                  ge.value ? (u(), b("div", {
                    key: 1,
                    "data-testid": "filter-dropdown-list",
                    class: C(["min-h-0", {
                      "overflow-y-auto": !!e.maxListHeight || !!p.value && !p.value.scrollsWhole,
                      "overscroll-contain": e.freezeOnOpen
                    }]),
                    style: Ge(ue.value)
                  }, [
                    x("div", {
                      class: C(ee.value)
                    }, [
                      (u(!0), b(ie, null, Oe(ve.value, (Ot, ce) => (u(), b("div", {
                        key: Ot.id,
                        role: Y.value ? "listitem" : void 0,
                        class: "flex",
                        onFocusin: (he) => nt(he, lt(ce))
                      }, [
                        U(fa, Ve({ ref_for: !0 }, { ...Ae(Ot, lt(ce)), ...Xe(Ot, lt(ce)) }, {
                          class: "filter-item-row",
                          "data-testid": `filter-dropdown-item-${Ot.id}`,
                          draggable: e.reorderable && !Ot.disabled,
                          onDragstart: (he) => e.reorderable && L(q)(Ot.id),
                          onDragover: _e((he) => e.reorderable && L(K)(Ot.id), ["prevent"]),
                          onDrop: (he) => e.reorderable && Se(Ot.id),
                          onDragend: He[3] || (He[3] = (he) => e.reorderable && L(te)())
                        }), null, 16, ["data-testid", "draggable", "onDragstart", "onDragover", "onDrop"])
                      ], 40, U1))), 128))
                    ], 2)
                  ], 6)) : w("", !0)
                ], 40, W1)) : w("", !0),
                Ee.value ? (u(), b("div", {
                  key: 1,
                  "data-testid": "filter-dropdown-empty",
                  class: C([{ "overflow-y-auto": e.reserveListHeight && !!e.maxListHeight }, "flex flex-col items-center justify-center gap-1.5 px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"]),
                  style: Ge(e.reserveListHeight ? ue.value : void 0)
                }, [
                  e.emptyIcon && e.emptyLabel ? (u(), b("i", {
                    key: 0,
                    class: C([e.emptyIcon, "text-(length:--icon-size-md) leading-(--icon-size-md)"]),
                    "aria-hidden": "true",
                    "data-testid": "filter-dropdown-empty-icon"
                  }, null, 2)) : w("", !0),
                  e.emptyLabel ? (u(), b("span", G1, H(e.emptyLabel), 1)) : w("", !0)
                ], 6)) : w("", !0)
              ], 2)) : w("", !0),
              je.value ? (u(), P(Dl, Ve({ key: 2 }, je.value, {
                class: "shrink-0",
                onButtonClick: N
              }), null, 16)) : w("", !0)
            ], 46, j1)) : w("", !0)
          ];
        }),
        _: 1
      })
    ], 16));
  }
}), Y1 = ["aria-label", "data-step"], J1 = { class: "flex min-h-0 flex-col pb-2" }, X1 = ["aria-label"], Z1 = ["aria-label"], Q1 = { class: "flex min-h-0 flex-col pb-2" }, _1 = ["aria-label"], e2 = ["aria-labelledby"], t2 = ["id"], a2 = {
  key: 1,
  role: "none",
  class: "flex min-h-0 flex-col overflow-y-auto px-2 py-1.5",
  "data-testid": "sort-dropdown-field-list"
}, n2 = ["aria-label"], l2 = ["src"], o2 = { class: "leading-(--line-height-l) font-(--weight-medium)" }, FU = /* @__PURE__ */ ke({
  __name: "SortDropdown",
  props: {
    modelValue: { default: "" },
    options: { default: () => [] },
    fields: { default: void 0 },
    sort: { default: null },
    ariaLabel: { default: void 0 },
    align: { default: "right" },
    triggerIconLeft: { default: "ri-filter-3-fill" },
    headerLabel: { default: void 0 },
    searchPlaceholder: { default: "Search a field" },
    searchLabel: { default: void 0 },
    noResultsLabel: { default: void 0 },
    appliedSortLabel: { default: void 0 },
    directionsLabel: { default: "Sort direction" },
    backLabel: { default: "Back" },
    defaultOpen: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:sort"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(
      () => {
        var j;
        return ((j = t.options.find((J) => J.value === t.modelValue)) == null ? void 0 : j.label) ?? "";
      }
    ), o = m(() => t.options.length === 1), r = m(
      () => t.options.map((j) => ({
        label: j.label,
        active: j.value === t.modelValue,
        testId: `sort-option-${j.value}`,
        onClick: () => n("update:modelValue", j.value)
      }))
    ), i = (j) => !!j && j.startsWith("ri-"), s = m(() => t.fields !== void 0), { isOpen: d, dropdownRef: c, toggleDropdown: f, closeDropdown: g } = So({ defaultOpen: t.defaultOpen }), h = R(null), v = R(null), p = R(null), y = R(null), k = R(null), $ = Ye(), S = R(""), I = R(null), T = { asc: "ri-sort-asc", desc: "ri-sort-desc" }, A = ["asc", "desc"], E = m(() => {
      var j;
      return (j = t.fields) == null ? void 0 : j.find((J) => {
        var ne;
        return J.key === ((ne = t.sort) == null ? void 0 : ne.field);
      });
    }), z = m(() => {
      var j;
      return (j = t.fields) == null ? void 0 : j.find((J) => J.key === I.value);
    }), B = m(() => S.value.trim() ? void 0 : E.value), W = m(
      () => (t.fields ?? []).filter((j) => j !== B.value && kc(j.label, S.value))
    ), _ = m(() => B.value ? [B.value, ...W.value] : W.value), Z = m(() => {
      var j;
      return ((j = E.value) == null ? void 0 : j.label) ?? t.headerLabel ?? "";
    }), { focusedIndex: le, handleRovingKeydown: D, handleSearchFieldKeydown: O, clampFocusedIndex: N } = Mr();
    $e(
      () => _.value.length,
      (j) => N(j)
    );
    function V() {
      var j;
      return ((j = h.value) == null ? void 0 : j.$el) ?? null;
    }
    function M(j, J) {
      const ne = j == null ? void 0 : j.querySelector(`[data-listbox-index="${J}"]`);
      return ne ? (le.value = J, ne.focus({ preventScroll: !0 }), ne.scrollIntoView({ block: "nearest" }), !0) : !1;
    }
    function Q() {
      var j, J;
      (J = (j = v.value) == null ? void 0 : j.querySelector('[data-testid="sort-dropdown-back"]')) == null || J.focus();
    }
    function q() {
      g(), Ze(() => {
        var j;
        return (j = V()) == null ? void 0 : j.focus();
      });
    }
    $e(
      d,
      (j) => {
        var J;
        j && (I.value = null, S.value = "", le.value = 0, (J = k.value) == null || J.focusSearch());
      },
      { flush: "post" }
    );
    function K(j) {
      var ne;
      if (j.disabled) return;
      I.value = j.key;
      const J = ((ne = t.sort) == null ? void 0 : ne.field) === j.key ? A.indexOf(t.sort.direction) : 0;
      le.value = Math.max(0, J), Ze(Q);
    }
    function G() {
      const j = I.value;
      I.value = null, Ze(() => {
        var ne;
        const J = _.value.findIndex((Y) => Y.key === j);
        M(p.value, Math.max(0, J)) || (ne = k.value) == null || ne.focusSearch();
      });
    }
    function te(j) {
      I.value && (n("update:sort", { field: I.value, direction: j }), q());
    }
    function ve(j) {
      d.value && (j.stopPropagation(), j.preventDefault(), q());
    }
    function Se(j) {
      j.target instanceof HTMLInputElement && O(j, _.value.length, p.value);
    }
    function oe(j) {
      D(j, _.value.length, p.value);
    }
    function re(j) {
      if (j.key === "ArrowLeft") {
        j.preventDefault(), G();
        return;
      }
      D(j, A.length, y.value);
    }
    const ge = m(() => [
      { label: t.backLabel, icon: "ri-arrow-left-line", variant: "secondary", testId: "sort-dropdown-back" }
    ]);
    function de(j) {
      return {
        tabindex: j === le.value ? 0 : -1,
        "data-listbox-index": j,
        onFocus: () => {
          le.value = j;
        }
      };
    }
    function Ee(j) {
      return {
        as: "button",
        role: "menuitem",
        label: j.label,
        icon: j.icon,
        ariaDisabled: !!j.disabled,
        description: j.disabled ? j.disabledReason : void 0,
        onClick: () => K(j)
      };
    }
    return (j, J) => s.value ? (u(), b("div", {
      key: 0,
      ref_key: "dropdownRef",
      ref: c,
      class: "relative inline-block text-left dark:text-(--colors-text-white-default)",
      "data-testid": "sort-dropdown",
      onKeydown: St(ve, ["escape"])
    }, [
      U(Be, {
        ref_key: "triggerRef",
        ref: h,
        "data-testid": "sort-dropdown-trigger",
        size: "xs",
        variant: "ghost",
        label: Z.value,
        "icon-left": e.triggerIconLeft,
        "dropdown-icon": !!Z.value,
        "icon-only": !Z.value,
        "aria-label": e.ariaLabel,
        "aria-expanded": L(d),
        "aria-haspopup": "dialog",
        onClick: L(f)
      }, null, 8, ["label", "icon-left", "dropdown-icon", "icon-only", "aria-label", "aria-expanded", "onClick"]),
      U(Wt, {
        "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
        "enter-from-class": "transform scale-95 opacity-0",
        "enter-to-class": "transform scale-100 opacity-100",
        "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
        "leave-from-class": "transform scale-100 opacity-100",
        "leave-to-class": "transform scale-95 opacity-0"
      }, {
        default: me(() => [
          L(d) ? (u(), b("div", {
            key: 0,
            ref_key: "panelRef",
            ref: v,
            role: "dialog",
            "aria-label": e.headerLabel ?? e.ariaLabel,
            "data-testid": "sort-dropdown-panel",
            "data-step": z.value ? "directions" : "fields",
            class: C(["absolute top-full z-50 mt-1 flex max-h-105 w-80 max-w-[calc(100vw-32px)] flex-col overflow-hidden", [L(hl), e.align === "right" ? "right-0 origin-top-right" : "left-0 origin-top-left"]])
          }, [
            z.value ? (u(), b(ie, { key: 0 }, [
              U(Bl, {
                "label-left": z.value.label,
                class: "shrink-0"
              }, null, 8, ["label-left"]),
              x("div", J1, [
                x("div", {
                  ref_key: "directionMenuRef",
                  ref: y,
                  role: "menu",
                  "aria-label": e.directionsLabel,
                  class: "flex flex-col px-2 py-1.5",
                  "data-testid": "sort-dropdown-directions",
                  onKeydown: re
                }, [
                  x("div", {
                    role: "group",
                    "aria-label": z.value.label,
                    class: "flex flex-col"
                  }, [
                    (u(), b(ie, null, Oe(A, (ne, Y) => {
                      var F, ee;
                      return U(fa, Ve({ key: ne }, { ref_for: !0 }, de(Y), {
                        as: "button",
                        role: "menuitemradio",
                        "aria-checked": ((F = e.sort) == null ? void 0 : F.field) === z.value.key && e.sort.direction === ne,
                        "aria-label": z.value.directions[ne].ariaLabel,
                        label: z.value.directions[ne].label,
                        icon: T[ne],
                        selected: ((ee = e.sort) == null ? void 0 : ee.field) === z.value.key && e.sort.direction === ne,
                        class: "shrink-0",
                        "data-testid": `sort-direction-${ne}`,
                        onClick: (ue) => te(ne)
                      }), null, 16, ["aria-checked", "aria-label", "label", "icon", "selected", "data-testid", "onClick"]);
                    }), 64))
                  ], 8, Z1)
                ], 40, X1)
              ]),
              U(Dl, {
                type: "button",
                buttons: ge.value,
                class: "shrink-0",
                onButtonClick: G
              }, null, 8, ["buttons"])
            ], 64)) : (u(), b(ie, { key: 1 }, [
              U(Bl, {
                ref_key: "headerRef",
                ref: k,
                class: "shrink-0",
                "label-left": e.headerLabel,
                "show-search": "",
                "search-query": S.value,
                "search-placeholder": e.searchPlaceholder,
                "search-label": e.searchLabel ?? e.searchPlaceholder,
                onKeydown: Se,
                "onUpdate:searchQuery": J[0] || (J[0] = (ne) => S.value = ne)
              }, null, 8, ["label-left", "search-query", "search-placeholder", "search-label"]),
              x("div", Q1, [
                _.value.length ? (u(), b("div", {
                  key: 0,
                  ref_key: "fieldMenuRef",
                  ref: p,
                  role: "menu",
                  "aria-label": e.headerLabel,
                  class: "flex min-h-0 flex-col",
                  "data-testid": "sort-dropdown-fields",
                  onKeydown: oe
                }, [
                  B.value && e.sort ? (u(), b("div", {
                    key: 0,
                    role: "group",
                    "aria-labelledby": e.appliedSortLabel ? L($) : void 0,
                    class: "flex shrink-0 flex-col border-b border-(--border-border-base-soft) pt-2 pe-3 ps-2 pb-[calc(--spacing(2)-1px)] dark:border-(--colors-border-base)",
                    "data-testid": "sort-dropdown-applied"
                  }, [
                    e.appliedSortLabel ? (u(), b("span", {
                      key: 0,
                      id: L($),
                      class: "px-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)",
                      "data-testid": "sort-dropdown-applied-heading"
                    }, H(e.appliedSortLabel), 9, t2)) : w("", !0),
                    U(fa, Ve({ ...Ee(B.value), ...de(0) }, {
                      type: "two-labels",
                      selected: "",
                      "secondary-icon": T[e.sort.direction],
                      "secondary-label": B.value.directions[e.sort.direction].label,
                      class: "shrink-0",
                      "data-testid": `sort-field-${B.value.key}`
                    }), null, 16, ["secondary-icon", "secondary-label", "data-testid"])
                  ], 8, e2)) : w("", !0),
                  W.value.length ? (u(), b("div", a2, [
                    (u(!0), b(ie, null, Oe(W.value, (ne, Y) => (u(), P(fa, Ve({
                      key: ne.key
                    }, { ref_for: !0 }, { ...Ee(ne), ...de(B.value ? Y + 1 : Y) }, {
                      type: "two-icons",
                      class: "shrink-0",
                      "data-testid": `sort-field-${ne.key}`
                    }), null, 16, ["data-testid"]))), 128))
                  ])) : w("", !0)
                ], 40, _1)) : w("", !0),
                x("div", {
                  role: "status",
                  "aria-live": "polite",
                  class: C(_.value.length || !e.noResultsLabel ? "sr-only" : "px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"),
                  "data-testid": "sort-dropdown-status"
                }, H(_.value.length ? "" : e.noResultsLabel), 3)
              ])
            ], 64))
          ], 10, Y1)) : w("", !0)
        ]),
        _: 1
      })
    ], 544)) : o.value ? (u(), b("div", {
      key: 1,
      class: "inline-flex items-center gap-1.5 px-3 py-2 text-(length:--size-m) text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
      "aria-label": e.ariaLabel,
      "data-testid": "sort-dropdown-static"
    }, [
      e.triggerIconLeft ? (u(), b(ie, { key: 0 }, [
        i(e.triggerIconLeft) ? (u(), b("i", {
          key: 0,
          class: C([e.triggerIconLeft, "text-(length:--icon-size-sm) leading-(--icon-size-sm) size-(--icon-size-sm) inline-flex items-center justify-center"]),
          "aria-hidden": "true"
        }, null, 2)) : (u(), b("img", {
          key: 1,
          class: "relative h-4 w-4",
          src: e.triggerIconLeft,
          alt: ""
        }, null, 8, l2))
      ], 64)) : w("", !0),
      x("span", o2, H(l.value), 1)
    ], 8, n2)) : (u(), P(Ra, {
      key: 2,
      label: l.value,
      "trigger-icon-left": e.triggerIconLeft,
      items: r.value,
      "menu-align": e.align,
      "selection-style": "check",
      "menu-header": e.headerLabel,
      "aria-label": e.ariaLabel,
      ghost: "",
      "data-testid": "sort-dropdown"
    }, null, 8, ["label", "trigger-icon-left", "items", "menu-align", "menu-header", "aria-label"]));
  }
}), r2 = { class: "flex flex-col gap-0.5 pb-0.5" }, i2 = {
  key: 0,
  class: "flex min-w-0 flex-1"
}, s2 = {
  key: 1,
  class: "inline-flex shrink-0"
}, d2 = {
  "data-field-controls": "",
  class: "ms-auto flex shrink-0 items-center gap-2"
}, u2 = ["aria-label"], um = /* @__PURE__ */ ke({
  __name: "MultipleSelect",
  props: {
    options: {},
    modelValue: { default: () => [] },
    draft: { default: void 0 },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    helpTooltip: { default: void 0 },
    placeholder: {},
    confirmLabel: {},
    seeAllLabel: { default: void 0 },
    seeAllThreshold: { default: 20 },
    searchPlaceholder: {},
    searchClearLabel: { default: "Clear search" },
    selectAllLabel: {},
    showSelectAll: { type: Boolean, default: !0 },
    clearAllLabel: {},
    removeChipLabel: {},
    emptyLabel: {},
    error: { default: void 0 },
    hint: { default: void 0 },
    success: { type: Boolean, default: !1 },
    size: { default: "md" },
    async: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: void 0 },
    selectAllResolver: { type: Function, default: void 0 },
    chipTheme: { default: "neutral" },
    totalCount: { default: void 0 },
    maxListHeight: { default: "252px" },
    footerLabel: { default: void 0 },
    freezeOnOpen: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    removeOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:draft", "see-all", "search"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => t.async), o = Ye(), r = m(() => `${o}-input`), i = m(() => t.label ? `${o}-label` : void 0), s = `${o}-error`, d = `${o}-hint`, c = m(() => !!t.error), f = m(() => {
      const X = [];
      return t.hint && X.push(d), c.value && X.push(s), X.length > 0 ? X.join(" ") : void 0;
    }), g = m(
      () => t.options.filter((X) => (t.modelValue ?? []).includes(X.id))
    ), h = R([...t.modelValue ?? []]), v = R(!1), p = R(!1), y = (X, ae) => X.length === ae.length && X.every((Re, Ae) => Re === ae[Ae]);
    $e(
      () => t.draft,
      (X) => {
        X && !y(X, h.value) && (h.value = [...X]);
      }
    ), $e(h, (X) => {
      (!t.draft || !y(t.draft, X)) && n("update:draft", [...X]);
    });
    const k = () => {
      v.value = !0, h.value = [...t.modelValue ?? []];
    }, $ = () => {
      v.value = !1, h.value = [...t.modelValue ?? []];
    }, S = () => {
      n("update:modelValue", [...h.value]);
    }, I = R(null), T = R(null), A = m(() => t.size === "lg" || t.size === "xl" ? "lg" : "sm"), E = m(() => t.disabled || t.readonly), z = m(
      () => t.disabled ? "text-(--icons-icon-disabled-strong) dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
    );
    function B(X) {
      X.currentTarget.contains(X.relatedTarget) || (p.value = !1);
    }
    const W = R(null), _ = () => {
      var X;
      return ((X = W.value) == null ? void 0 : X.$el) ?? null;
    }, Z = R(1 / 0), le = R(void 0);
    let D = null;
    const O = m(() => {
      const X = Z.value === 1 / 0 ? g.value.length : Math.min(Z.value, g.value.length);
      return g.value.slice(0, X);
    }), N = m(
      () => Math.max(0, g.value.length - O.value.length)
    ), V = async () => {
      Z.value = 1 / 0, await Ze();
      const X = _();
      if (!X || g.value.length === 0) {
        Z.value = g.value.length;
        return;
      }
      const ae = Array.from(X.querySelectorAll("[data-badge-chip]"));
      if (!ae.length) {
        Z.value = g.value.length;
        return;
      }
      const Re = X.getBoundingClientRect(), Ae = getComputedStyle(X), xe = parseFloat(Ae.columnGap) || 0, we = X.querySelector("[data-field-controls]"), fe = (parseFloat(Ae.paddingRight) || 0) + (we ? we.getBoundingClientRect().width + xe : 0), Ne = 56, De = Re.right - fe;
      let qe = ae.length;
      for (let Qe = 0; Qe < ae.length; Qe++) {
        const lt = ae[Qe].getBoundingClientRect().right;
        if ((Qe === ae.length - 1 ? lt : lt + Ne) > De) {
          qe = Qe;
          break;
        }
      }
      Z.value = Math.max(qe, 1);
    }, M = () => {
      const X = _();
      X && (le.value = `${X.offsetWidth}px`);
    };
    kt(() => {
      D = new ResizeObserver(() => {
        M(), V();
      });
      const X = _();
      X && D.observe(X), M(), V();
    }), zt(() => {
      D == null || D.disconnect(), clearTimeout(q);
    }), $e(
      () => t.modelValue,
      (X) => {
        Z.value = 1 / 0, V(), v.value || (h.value = [...X ?? []]);
      }
    );
    const Q = R("");
    let q;
    $e(Q, (X) => {
      t.async && (clearTimeout(q), q = setTimeout(() => n("search", X), 300));
    });
    const K = R(!1), G = m(() => t.loading || K.value), te = m(
      () => t.loading ? t.loadingLabel ?? t.emptyLabel : t.emptyLabel
    ), ve = m(() => t.options.filter((X) => !X.disabled)), Se = m(
      () => ve.value.length > 0 && ve.value.every((X) => h.value.includes(X.id))
    ), oe = m(
      () => !Se.value && ve.value.some((X) => h.value.includes(X.id))
    ), re = async () => {
      if (t.selectAllResolver) {
        K.value = !0;
        try {
          const X = await t.selectAllResolver(), ae = new Set(X);
          if (X.length > 0 && X.every((Ae) => h.value.includes(Ae)))
            h.value = h.value.filter((Ae) => !ae.has(Ae));
          else {
            const Ae = new Set(h.value);
            X.forEach((xe) => Ae.add(xe)), h.value = Array.from(Ae);
          }
        } catch {
        } finally {
          K.value = !1;
        }
        return;
      }
      if (Se.value)
        h.value = h.value.filter(
          (X) => !ve.value.some((ae) => ae.id === X)
        );
      else {
        const X = new Set(h.value);
        ve.value.forEach((ae) => X.add(ae.id)), h.value = Array.from(X);
      }
    }, ge = (X) => {
      h.value.includes(X) ? h.value = h.value.filter((ae) => ae !== X) : h.value = [...h.value, X];
    }, de = () => {
      const X = _();
      X && X !== document.activeElement && X.contains(document.activeElement) && X.focus();
    }, Ee = (X) => {
      de(), h.value = h.value.filter((ae) => ae !== X), n(
        "update:modelValue",
        (t.modelValue ?? []).filter((ae) => ae !== X)
      );
    }, j = (X) => {
      X.stopPropagation(), de(), h.value = [], n("update:modelValue", []);
    }, J = m(() => ({
      id: "__select-all__",
      label: t.selectAllLabel,
      hasCheckbox: !0,
      checked: Se.value,
      indeterminate: oe.value,
      onClick: re
    })), ne = m(() => [
      ...t.options.map((X) => ({
        id: X.id,
        label: X.label,
        hasCheckbox: !0,
        checked: h.value.includes(X.id),
        badgeTheme: X.badgeTheme ?? t.chipTheme,
        badgeRightIcon: X.badgeRightIcon,
        secondaryText: X.secondaryText,
        disabled: X.disabled,
        onClick: () => ge(X.id)
      }))
    ]), Y = m(() => {
      const X = [], ae = t.totalCount ?? t.options.length;
      return t.seeAllLabel && ae > (t.seeAllThreshold ?? 20) && X.push({
        label: t.seeAllLabel,
        variant: "secondary",
        keepOpen: !0,
        onClick: () => n("see-all")
      }), X.push({ label: t.confirmLabel, variant: "primary", onClick: S }), X;
    }), F = (X, ae, Re) => {
      var Ae, xe;
      if (X.key === "Escape" && Re) {
        X.stopPropagation(), X.preventDefault(), ae();
        return;
      }
      if (Re || ((Ae = I.value) == null || Ae.handleFieldKeydown(X), (xe = T.value) == null || xe.handleFieldKeydown(X)), X.key === "Backspace" && X.target === X.currentTarget && !t.disabled && !t.readonly && g.value.length > 0) {
        const we = g.value[g.value.length - 1];
        h.value = h.value.filter((fe) => fe !== we.id), n(
          "update:modelValue",
          (t.modelValue ?? []).filter((fe) => fe !== we.id)
        );
      }
    };
    let ee = !1;
    const ue = () => {
      ee = v.value;
    }, se = () => {
      var ae, Re;
      const X = ee;
      if (ee = !1, !t.disabled) {
        if (X || t.removeOnly) {
          (ae = _()) == null || ae.focus();
          return;
        }
        (Re = _()) == null || Re.click();
      }
    };
    return (X, ae) => (u(), b("div", r2, [
      e.label ? (u(), P(Ft, {
        key: 0,
        id: i.value,
        ref_key: "labelRef",
        ref: I,
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.helpTooltip,
        focused: p.value,
        "test-id": "multiple-select-label",
        class: C(!e.disabled && !e.readonly && !e.removeOnly && "cursor-pointer"),
        onMousedown: ue,
        onClick: _e(se, ["stop"])
      }, null, 8, ["id", "text", "required", "required-indicator", "tooltip", "focused", "class"])) : w("", !0),
      U(L(Lc), {
        "search-query": Q.value,
        "onUpdate:searchQuery": ae[1] || (ae[1] = (Re) => Q.value = Re),
        "aria-label": e.label || e.placeholder,
        items: ne.value,
        "sticky-item": e.showSelectAll ? J.value : void 0,
        "show-search": !0,
        "search-placeholder": e.searchPlaceholder,
        "search-clear-label": e.searchClearLabel,
        "empty-label": te.value,
        "disable-internal-search-filter": l.value,
        "max-list-height": e.maxListHeight,
        "footer-buttons": Y.value,
        "footer-label": e.footerLabel,
        "menu-width": le.value,
        "freeze-on-open": e.freezeOnOpen,
        class: "w-full",
        onOpen: k,
        onClose: $
      }, {
        trigger: me(({ toggle: Re, isOpen: Ae }) => [
          U(en, {
            id: r.value,
            ref_key: "shellRef",
            ref: W,
            role: "combobox",
            "aria-expanded": Ae,
            "aria-haspopup": "dialog",
            "aria-labelledby": i.value,
            "aria-label": e.label ? void 0 : e.ariaLabel,
            "aria-describedby": f.value,
            "aria-required": e.required ? "true" : void 0,
            "aria-invalid": c.value ? "true" : void 0,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-readonly": e.readonly ? "true" : void 0,
            "aria-busy": G.value ? "true" : void 0,
            tabindex: e.disabled ? -1 : 0,
            tags: "",
            size: e.size,
            disabled: e.disabled,
            readonly: e.readonly || e.removeOnly,
            error: c.value,
            success: e.success,
            focused: Ae,
            "focus-scope": "any",
            "has-value": g.value.length > 0,
            class: C(["w-full flex-nowrap! overflow-hidden focus:outline-none", !e.disabled && !e.readonly && !e.removeOnly && "cursor-pointer"]),
            onClick: (xe) => !e.disabled && !e.readonly && !e.removeOnly && Re(),
            onKeydown: [
              (xe) => F(xe, Re, Ae),
              St(_e((xe) => !e.disabled && !e.readonly && !e.removeOnly && Re(), ["self", "prevent"]), ["enter"]),
              St(_e((xe) => !e.disabled && !e.readonly && !e.removeOnly && Re(), ["self", "prevent"]), ["space"])
            ],
            onFocusin: ae[0] || (ae[0] = (xe) => p.value = !0),
            onFocusout: B
          }, {
            default: me(({ textClass: xe, iconBoxClass: we }) => [
              g.value.length === 0 ? (u(), b("span", i2, [
                U(it, {
                  text: e.placeholder,
                  focusable: !1,
                  "text-class": [xe, e.disabled ? "" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"].join(" ")
                }, null, 8, ["text", "text-class"])
              ])) : w("", !0),
              (u(!0), b(ie, null, Oe(O.value, (fe) => (u(), b("div", {
                key: fe.id,
                "data-badge-chip": "",
                class: "inline-flex shrink-0"
              }, [
                U(L(yt), {
                  label: fe.label,
                  theme: e.disabled ? "disabled" : fe.badgeTheme ?? e.chipTheme,
                  "tooltip-text": fe.tooltipText,
                  "right-icon": fe.badgeRightIcon,
                  size: A.value,
                  truncate: "",
                  "truncation-focusable": !1,
                  "show-close-icon": "",
                  "close-icon-inactive": E.value,
                  "remove-label": e.removeChipLabel(fe.label),
                  onClose: (Ne) => Ee(fe.id)
                }, null, 8, ["label", "theme", "tooltip-text", "right-icon", "size", "close-icon-inactive", "remove-label", "onClose"])
              ]))), 128)),
              N.value > 0 ? (u(), b("div", s2, [
                U(L(yt), {
                  label: `+${N.value}`,
                  theme: e.disabled ? "disabled" : e.chipTheme,
                  size: A.value,
                  "show-close-icon": !1
                }, null, 8, ["label", "theme", "size"])
              ])) : w("", !0),
              x("span", d2, [
                g.value.length > 0 && !e.disabled && !e.readonly ? (u(), b("button", {
                  key: 0,
                  type: "button",
                  class: C([
                    we,
                    "relative cursor-pointer rounded-(--border-border-radius-rounded-xs) border-none bg-transparent p-0 text-(--text-text-body-subtle) transition-colors hover:text-(--text-text-black-default) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-hidden dark:text-(--colors-text-white-secondary) dark:hover:text-(--colors-text-white-default)",
                    "before:absolute before:top-1/2 before:left-1/2 before:size-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']"
                  ]),
                  "aria-label": e.clearAllLabel,
                  onClick: _e(j, ["stop"])
                }, [...ae[2] || (ae[2] = [
                  x("i", {
                    class: "ri-close-line",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, u2)) : w("", !0),
                e.removeOnly ? w("", !0) : (u(), b("i", {
                  key: 1,
                  class: C([
                    "ri-arrow-down-s-line transition-transform duration-200 ease-in-out motion-reduce:transition-none",
                    we,
                    z.value
                  ]),
                  style: Ge({ transform: Ae ? "rotate(180deg)" : "rotate(0deg)" }),
                  "aria-hidden": "true"
                }, null, 6))
              ])
            ]),
            _: 2
          }, 1032, ["id", "aria-expanded", "aria-labelledby", "aria-label", "aria-describedby", "aria-required", "aria-invalid", "aria-disabled", "aria-readonly", "aria-busy", "tabindex", "size", "disabled", "readonly", "error", "success", "focused", "has-value", "class", "onClick", "onKeydown"])
        ]),
        _: 1
      }, 8, ["search-query", "aria-label", "items", "sticky-item", "search-placeholder", "search-clear-label", "empty-label", "disable-internal-search-filter", "max-list-height", "footer-buttons", "footer-label", "menu-width", "freeze-on-open"]),
      U(Pt, {
        ref_key: "helperRef",
        ref: T,
        focused: p.value,
        hint: e.hint,
        error: e.error,
        "hint-id": d,
        "error-id": s,
        "test-id-prefix": "multiple-select"
      }, null, 8, ["focused", "hint", "error"])
    ]));
  }
}), c2 = ["aria-label"], f2 = { class: "w-full sm:w-56 sm:shrink-0" }, h2 = /* @__PURE__ */ ke({
  __name: "AccessRuleRow",
  props: {
    rule: {},
    position: {},
    options: {},
    labels: {},
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    disabledLevels: { default: () => [] },
    levelHint: { default: void 0 },
    removeOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:userIds", "update:level", "remove", "search", "activate"],
  setup(e, { expose: a, emit: t }) {
    const n = t, l = R(null), o = () => {
      var i, s;
      (s = (i = l.value) == null ? void 0 : i.querySelector('[role="combobox"]')) == null || s.focus();
    }, r = (i) => {
      i && n("update:level", i);
    };
    return a({ focusPicker: o }), (i, s) => (u(), b("div", {
      role: "group",
      "aria-label": e.labels.ruleGroupLabel(e.position),
      "data-testid": "access-rule",
      class: "flex flex-col gap-3 sm:flex-row sm:items-start"
    }, [
      x("div", {
        ref_key: "pickerRef",
        ref: l,
        class: "min-w-0 flex-1",
        onFocusin: s[2] || (s[2] = (d) => n("activate"))
      }, [
        U(um, {
          "model-value": e.rule.userIds,
          options: e.options,
          label: e.labels.rulePeopleLabel,
          placeholder: e.labels.pickerPlaceholder,
          "confirm-label": e.labels.pickerConfirm,
          "search-placeholder": e.labels.pickerSearchPlaceholder,
          "select-all-label": e.labels.pickerSelectAll,
          "clear-all-label": e.labels.pickerClearAll,
          "remove-chip-label": e.labels.removeUser,
          "empty-label": e.labels.pickerEmpty,
          "loading-label": e.labels.pickerLoading,
          loading: e.loading,
          disabled: e.disabled,
          "remove-only": e.removeOnly,
          async: "",
          "onUpdate:modelValue": s[0] || (s[0] = (d) => n("update:userIds", d)),
          onSearch: s[1] || (s[1] = (d) => n("search", d))
        }, null, 8, ["model-value", "options", "label", "placeholder", "confirm-label", "search-placeholder", "select-all-label", "clear-all-label", "remove-chip-label", "empty-label", "loading-label", "loading", "disabled", "remove-only"])
      ], 544),
      x("div", f2, [
        U(uu, {
          "model-value": e.rule.level,
          label: e.labels.ruleLevelLabel,
          levels: e.labels.levels,
          "disabled-levels": e.disabledLevels,
          hint: e.levelHint,
          disabled: e.disabled,
          "onUpdate:modelValue": r
        }, null, 8, ["model-value", "label", "levels", "disabled-levels", "hint", "disabled"])
      ]),
      U(Be, {
        variant: "secondary",
        size: "sm",
        "icon-only": "",
        "icon-left": "ri-delete-bin-line",
        "aria-label": e.labels.removeRule,
        disabled: e.disabled,
        class: "self-start sm:mt-5.5",
        "data-testid": "access-rule-remove",
        onClick: s[3] || (s[3] = (d) => n("remove"))
      }, null, 8, ["aria-label", "disabled"])
    ], 8, c2));
  }
}), sd = ["Edit", "View"];
function b2() {
  let e = 0;
  return () => `rule-${++e}`;
}
function _f(e, a) {
  const t = /* @__PURE__ */ new Map();
  for (const { id: n, level: l } of e) {
    const o = t.get(n);
    (!o || sd.indexOf(l) < sd.indexOf(o)) && t.set(n, l);
  }
  return sd.map((n) => ({
    key: a(),
    level: n,
    userIds: [...t].filter(([, l]) => l === n).map(([l]) => l)
  })).filter((n) => n.userIds.length > 0);
}
function eh(e) {
  const a = /* @__PURE__ */ new Set(), t = [];
  for (const n of e)
    for (const l of n.userIds)
      a.has(l) || (a.add(l), t.push({ id: l, level: n.level }));
  return t;
}
function th(e, a) {
  if (e.organization !== a.organization || e.users.length !== a.users.length) return !1;
  const t = new Map(e.users.map((n) => [n.id, n.level]));
  return a.users.every((n) => t.get(n.id) === n.level);
}
const g2 = {
  class: "flex flex-col gap-6",
  "data-testid": "access-settings"
}, m2 = ["aria-labelledby"], v2 = { class: "flex flex-col gap-1" }, p2 = ["id"], x2 = { class: "text-sm leading-5 font-normal text-text-black-default dark:text-(--colors-text-white-default)" }, y2 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" }, k2 = { "data-testid": "access-organization" }, w2 = ["aria-labelledby", "aria-describedby"], C2 = { class: "flex flex-col gap-1" }, S2 = ["id"], $2 = { class: "text-sm leading-5 font-normal text-text-black-default dark:text-(--colors-text-white-default)" }, I2 = { class: "text-sm leading-5 font-normal text-text-black-default dark:text-(--colors-text-white-default)" }, L2 = {
  "aria-live": "polite",
  "data-testid": "access-people-status"
}, T2 = ["id"], E2 = {
  key: 0,
  class: "flex flex-col rounded-xl border border-(--border-border-base-soft) dark:border-(--colors-border-base)"
}, A2 = { class: "self-start" }, R2 = ["tabindex"], NU = /* @__PURE__ */ ke({
  __name: "AccessSettings",
  props: {
    modelValue: {},
    userOptions: {},
    knownUsers: { default: () => [] },
    usersLoading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    showTeam: { type: Boolean, default: !0 },
    labels: {}
  },
  emits: ["update:modelValue", "search"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = Ye(), o = Ye(), r = Ye(), i = b2(), s = R(_f(t.modelValue.users, i));
    let d = null;
    const c = R(t.modelValue.organization), f = m(() => c.value === "Edit" ? ["Edit", "View"] : c.value === "View" ? ["View"] : []), g = m(() => c.value === "Edit"), h = m(() => c.value === "View" ? t.labels.viewWithoutEffect : void 0);
    $e(
      () => t.modelValue,
      (N) => {
        const V = { organization: c.value, users: eh(s.value) };
        th(N, V) || (s.value = _f(N.users, i), c.value = N.organization, d = null);
      },
      { deep: !0 }
    );
    const v = (N = c.value) => {
      const V = { organization: N, users: eh(s.value) };
      th(V, d ?? t.modelValue) || (d = { organization: V.organization, users: V.users.map((M) => ({ ...M })) }, c.value = V.organization, n("update:modelValue", V));
    }, p = /* @__PURE__ */ new Map();
    let y = null, k = "";
    const $ = (N) => {
      N !== k && (k = N, n("search", N));
    }, S = (N, V) => {
      p.set(N, V), !(y !== null && y !== N) && (y = N, k = V, n("search", V));
    }, I = (N) => {
      y !== N && (y = N, $(p.get(N) ?? ""));
    }, T = R(/* @__PURE__ */ new Map());
    $e(
      () => [t.userOptions, t.knownUsers],
      ([N, V]) => {
        for (const M of [...N, ...V]) T.value.set(M.id, M);
      },
      { immediate: !0, deep: !0 }
    );
    const A = (N) => {
      const V = new Set(s.value.filter((Q) => Q.key !== N.key).flatMap((Q) => Q.userIds));
      return [.../* @__PURE__ */ new Set([...N.userIds, ...t.userOptions.map((Q) => Q.id)])].map((Q) => {
        const q = T.value.get(Q) ?? { name: Q }, K = V.has(Q), G = f.value.includes(N.level) && !N.userIds.includes(Q);
        return {
          id: Q,
          label: q.inactive ? t.labels.inactiveUser(q.name) : q.name,
          secondaryText: K ? t.labels.alreadyInOtherRule : q.secondaryText,
          disabled: K || G,
          // A warning colour, not the "disabled" theme: the chip stays removable, so its text must keep 4.5:1 contrast.
          badgeTheme: q.inactive ? "orange" : void 0
        };
      });
    }, E = /* @__PURE__ */ new Map(), z = (N) => (V) => {
      V ? E.set(N, V) : E.delete(N);
    }, B = R(null), W = R(null), _ = () => {
      var N, V;
      return (V = g.value ? B.value : (N = W.value) == null ? void 0 : N.$el) == null ? void 0 : V.focus();
    }, Z = async () => {
      var V;
      const N = { key: i(), level: c.value === "View" ? "Edit" : "View", userIds: [] };
      s.value.push(N), I(N.key), await Ze(), (V = E.get(N.key)) == null || V.focusPicker();
    }, le = async (N) => {
      var Q;
      const [V] = s.value.splice(N, 1);
      V && p.delete(V.key), v(), await Ze();
      const M = s.value[N - 1] ?? s.value[N];
      M ? (Q = E.get(M.key)) == null || Q.focusPicker() : _();
    }, D = (N, V) => {
      s.value[N].userIds = V, v();
    }, O = (N, V) => {
      s.value[N].level = V, v();
    };
    return (N, V) => (u(), b("div", g2, [
      x("section", {
        role: "group",
        "aria-labelledby": L(l),
        class: "flex flex-col gap-3"
      }, [
        x("div", v2, [
          x("p", {
            id: L(l),
            class: "text-base leading-5 font-bold text-text-black-default dark:text-(--colors-text-white-default)"
          }, H(e.labels.generalTitle), 9, p2),
          x("p", x2, H(e.labels.generalDescription), 1)
        ]),
        x("div", y2, [
          x("div", k2, [
            U(uu, {
              "model-value": c.value,
              label: e.labels.organizationLabel,
              levels: e.labels.levels,
              disabled: e.disabled,
              "allow-none": "",
              "onUpdate:modelValue": V[0] || (V[0] = (M) => v(M))
            }, null, 8, ["model-value", "label", "levels", "disabled"])
          ]),
          e.showTeam ? (u(), P($t, {
            key: 0,
            text: e.labels.teamUnavailableTooltip,
            role: "group",
            "aria-label": e.labels.teamLabel,
            "aria-disabled": "true",
            tabindex: "0",
            "data-testid": "access-team-row"
          }, {
            default: me(() => [
              U(uu, {
                "model-value": null,
                label: e.labels.teamLabel,
                levels: e.labels.levels,
                "allow-none": "",
                disabled: ""
              }, null, 8, ["label", "levels"])
            ]),
            _: 1
          }, 8, ["text", "aria-label"])) : w("", !0)
        ])
      ], 8, m2),
      x("section", {
        role: "group",
        "aria-labelledby": L(o),
        "aria-describedby": g.value ? L(r) : void 0,
        class: "flex flex-col gap-3"
      }, [
        x("div", C2, [
          x("p", {
            id: L(o),
            class: "text-base leading-5 font-bold text-text-black-default dark:text-(--colors-text-white-default)"
          }, H(e.labels.peopleTitle), 9, S2),
          x("p", $2, H(e.labels.peopleDescription), 1),
          x("p", I2, H(e.labels.groupingHint), 1),
          x("div", L2, [
            g.value ? (u(), b("p", {
              key: 0,
              id: L(r),
              class: "text-sm leading-5 font-medium text-text-black-default dark:text-(--colors-text-white-default)",
              "data-testid": "access-people-without-effect"
            }, H(e.labels.peopleWithoutEffect), 9, T2)) : w("", !0)
          ])
        ]),
        s.value.length > 0 ? (u(), b("div", E2, [
          (u(!0), b(ie, null, Oe(s.value, (M, Q) => (u(), P(h2, {
            key: M.key,
            ref_for: !0,
            ref: z(M.key),
            class: "border-t border-(--border-border-base-soft) p-4 first:border-t-0 dark:border-(--colors-border-base)",
            rule: M,
            position: Q + 1,
            options: A(M),
            "disabled-levels": f.value,
            "level-hint": h.value,
            "remove-only": g.value,
            labels: e.labels,
            loading: e.usersLoading,
            disabled: e.disabled,
            "onUpdate:userIds": (q) => D(Q, q),
            "onUpdate:level": (q) => O(Q, q),
            onRemove: (q) => le(Q),
            onSearch: (q) => S(M.key, q),
            onActivate: (q) => I(M.key)
          }, null, 8, ["rule", "position", "options", "disabled-levels", "level-hint", "remove-only", "labels", "loading", "disabled", "onUpdate:userIds", "onUpdate:level", "onRemove", "onSearch", "onActivate"]))), 128))
        ])) : w("", !0),
        x("div", A2, [
          U($t, {
            text: e.labels.peopleWithoutEffect,
            disabled: !g.value
          }, {
            default: me(() => [
              x("span", {
                ref_key: "addRuleStop",
                ref: B,
                class: "inline-flex rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-2",
                tabindex: g.value ? 0 : void 0,
                "data-testid": "access-add-rule-stop"
              }, [
                U(Be, {
                  ref_key: "addRuleButton",
                  ref: W,
                  variant: "secondary",
                  size: "sm",
                  "icon-left": "ri-add-line",
                  label: e.labels.addRule,
                  disabled: e.disabled || g.value,
                  "data-testid": "access-add-rule",
                  onClick: Z
                }, null, 8, ["label", "disabled"])
              ], 8, R2)
            ]),
            _: 1
          }, 8, ["text", "disabled"])
        ])
      ], 8, w2)
    ]));
  }
}), VU = /* @__PURE__ */ ke({
  __name: "WeekNavigator",
  props: {
    weekStartDate: {},
    weekEndDate: {},
    locale: { default: "en" },
    previousLabel: { default: "Previous week" },
    nextLabel: { default: "Next week" },
    todayLabel: { default: "Today" },
    previousDisabled: { type: Boolean, default: !1 },
    todayDisabled: { type: Boolean, default: !1 },
    previousDisabledReason: { default: void 0 },
    todayDisabledReason: { default: void 0 },
    showToday: { type: Boolean, default: !0 },
    fullWidth: { type: Boolean, default: !1 }
  },
  emits: ["previous-week", "next-week", "today-week"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => {
      const o = new Intl.DateTimeFormat(t.locale, {
        day: "numeric",
        month: "long",
        timeZone: "UTC"
      }), r = new Intl.DateTimeFormat(t.locale, {
        day: "numeric",
        month: "long",
        ...t.fullWidth ? { year: "numeric" } : {},
        timeZone: "UTC"
      }), i = o.format(/* @__PURE__ */ new Date(`${t.weekStartDate}T00:00:00Z`)), s = r.format(/* @__PURE__ */ new Date(`${t.weekEndDate}T00:00:00Z`));
      return `${i} - ${s}`;
    });
    return (o, r) => (u(), b("div", {
      class: C(["flex flex-wrap items-center gap-(--spacing-2)", e.fullWidth ? "w-full" : void 0])
    }, [
      e.showToday ? (u(), P($t, {
        key: 0,
        text: e.todayDisabledReason ?? "",
        disabled: !e.todayDisabled || !e.todayDisabledReason,
        tabindex: e.todayDisabled && e.todayDisabledReason ? 0 : void 0
      }, {
        default: me(() => [
          U(Be, {
            variant: "secondary",
            size: "sm",
            label: e.todayLabel,
            disabled: e.todayDisabled,
            "data-testid": "week-navigator-today",
            onClick: r[0] || (r[0] = (i) => n("today-week"))
          }, null, 8, ["label", "disabled"])
        ]),
        _: 1
      }, 8, ["text", "disabled", "tabindex"])) : w("", !0),
      x("div", {
        class: C(["flex items-center gap-(--spacing-2)", e.fullWidth ? "w-full justify-between" : void 0])
      }, [
        U($t, {
          text: e.previousDisabledReason ?? "",
          disabled: !e.previousDisabled || !e.previousDisabledReason,
          tabindex: e.previousDisabled && e.previousDisabledReason ? 0 : void 0
        }, {
          default: me(() => [
            U(Be, {
              variant: "ghost",
              size: e.fullWidth ? "md" : "sm",
              "icon-only": "",
              "icon-left": "ri-arrow-left-line",
              "aria-label": e.previousLabel,
              disabled: e.previousDisabled,
              onClick: r[1] || (r[1] = (i) => n("previous-week"))
            }, null, 8, ["size", "aria-label", "disabled"])
          ]),
          _: 1
        }, 8, ["text", "disabled", "tabindex"]),
        x("p", {
          "aria-live": "polite",
          class: C([
            "font-(--weight-semi-bold)",
            e.fullWidth ? "flex-1 text-center text-(length:--size-xl) leading-(--line-height-xl)" : "text-(length:--size-m)"
          ])
        }, H(l.value), 3),
        U(Be, {
          variant: "ghost",
          size: e.fullWidth ? "md" : "sm",
          "icon-only": "",
          "icon-right": "ri-arrow-right-line",
          "aria-label": e.nextLabel,
          onClick: r[2] || (r[2] = (i) => n("next-week"))
        }, null, 8, ["size", "aria-label"])
      ], 2)
    ], 2));
  }
}), z2 = {
  "data-testid": "metric-card-simple",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-center p-num-24 box-border gap-2"
}, D2 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, B2 = { class: "relative text-num-16 leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, HU = /* @__PURE__ */ ke({
  __name: "MetricCardSimple",
  props: {
    value: { default: "" },
    label: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (a, t) => (u(), b("div", z2, [
      e.loading ? (u(), b(ie, { key: 0 }, [
        t[0] || (t[0] = x("div", { class: "skeleton h-[29px] w-24" }, null, -1)),
        t[1] || (t[1] = x("div", { class: "skeleton h-6 w-40" }, null, -1))
      ], 64)) : (u(), b(ie, { key: 1 }, [
        x("b", D2, H(e.value), 1),
        x("div", B2, H(e.label), 1)
      ], 64))
    ]));
  }
}), M2 = {
  "data-testid": "metric-card-with-icon",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex items-center p-num-24 box-border gap-3.5"
}, O2 = { class: "h-16 w-[63.9px] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border box-border flex items-center justify-center" }, P2 = ["src", "alt"], F2 = { class: "flex flex-col items-start gap-2" }, N2 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, V2 = { class: "relative text-num-16 leading-6 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, jU = /* @__PURE__ */ ke({
  __name: "MetricCardWithIcon",
  props: {
    value: { default: "" },
    label: { default: "" },
    icon: { default: void 0 },
    iconAlt: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (a, t) => (u(), b("div", M2, [
      e.loading ? (u(), b(ie, { key: 0 }, [
        t[0] || (t[0] = x("div", { class: "skeleton h-16 w-[63.9px] rounded-num-12" }, null, -1)),
        t[1] || (t[1] = x("div", { class: "flex flex-col items-start gap-2 flex-1" }, [
          x("div", { class: "skeleton h-[29px] w-24" }),
          x("div", { class: "skeleton h-6 w-40" })
        ], -1))
      ], 64)) : (u(), b(ie, { key: 1 }, [
        x("div", O2, [
          Me(a.$slots, "icon", {}, () => [
            e.icon ? (u(), b("img", {
              key: 0,
              src: e.icon,
              alt: e.iconAlt,
              class: "h-9 w-9 relative"
            }, null, 8, P2)) : w("", !0)
          ])
        ]),
        x("div", F2, [
          x("b", N2, H(e.value), 1),
          x("div", V2, H(e.label), 1)
        ])
      ], 64))
    ]));
  }
}), H2 = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-center p-num-24 box-border gap-3" }, j2 = { class: "flex flex-col items-center gap-2" }, W2 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, q2 = { class: "relative text-num-16 leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, U2 = { class: "rounded-sm bg-honeydew dark:bg-[var(--colors-background-success)] flex items-center justify-center py-0.5 px-1 gap-1 text-center text-[12px]" }, G2 = ["src"], K2 = { class: "relative leading-num-20 font-medium dark:text-[var(--colors-text-success-strong)]" }, WU = /* @__PURE__ */ ke({
  __name: "MetricCardWithTrend",
  props: {
    value: { default: "" },
    label: { default: "" },
    trendText: { default: "" },
    trendIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (a, t) => (u(), b("div", H2, [
      e.loading ? (u(), b(ie, { key: 0 }, [
        t[0] || (t[0] = x("div", { class: "flex flex-col items-center gap-2" }, [
          x("div", { class: "skeleton h-[29px] w-24" }),
          x("div", { class: "skeleton h-6 w-40" })
        ], -1)),
        t[1] || (t[1] = x("div", { class: "skeleton h-5 w-32 rounded-sm" }, null, -1))
      ], 64)) : (u(), b(ie, { key: 1 }, [
        x("div", j2, [
          x("b", W2, H(e.value), 1),
          x("div", q2, H(e.label), 1)
        ]),
        x("div", U2, [
          Me(a.$slots, "trend-icon", {}, () => [
            e.trendIcon ? (u(), b("img", {
              key: 0,
              src: e.trendIcon,
              alt: "trend",
              class: "h-3 w-3 relative"
            }, null, 8, G2)) : w("", !0)
          ]),
          x("div", K2, H(e.trendText), 1)
        ])
      ], 64))
    ]));
  }
}), Y2 = {
  "data-testid": "metric-card-with-badge",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-start justify-center p-num-24 box-border gap-2 relative"
}, J2 = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter z-0" }, X2 = { class: "relative text-num-16 leading-6 text-slategray dark:text-[var(--colors-text-white-secondary)] z-1" }, Z2 = {
  key: 0,
  class: "absolute top-[10px] right-[11px] rounded-sm bg-honeydew dark:bg-[var(--colors-background-success)] flex items-center justify-center py-0.5 px-1 z-2 text-center text-[12px]"
}, Q2 = { class: "relative leading-num-20 font-medium dark:text-[var(--colors-text-success-strong)]" }, qU = /* @__PURE__ */ ke({
  __name: "MetricCardWithBadge",
  props: {
    value: { default: "" },
    label: { default: "" },
    badgeText: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (a, t) => (u(), b("div", Y2, [
      e.loading ? (u(), b(ie, { key: 0 }, [
        t[0] || (t[0] = x("div", { class: "skeleton h-[29px] w-24" }, null, -1)),
        t[1] || (t[1] = x("div", { class: "skeleton h-6 w-40" }, null, -1)),
        t[2] || (t[2] = x("div", { class: "skeleton h-5 w-12 rounded-sm absolute top-[10px] right-[11px]" }, null, -1))
      ], 64)) : (u(), b(ie, { key: 1 }, [
        x("b", J2, H(e.value), 1),
        x("div", X2, H(e.label), 1),
        e.badgeText ? (u(), b("div", Z2, [
          x("div", Q2, H(e.badgeText), 1)
        ])) : w("", !0)
      ], 64))
    ]));
  }
}), _2 = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex items-center p-num-24 box-border text-num-16 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, eC = {
  key: 0,
  class: "flex-1 flex flex-col items-start gap-3"
}, tC = {
  key: 1,
  class: "flex-1 flex flex-col items-start gap-3"
}, aC = { class: "flex items-center gap-2" }, nC = ["src"], lC = { class: "relative leading-6 dark:text-[var(--colors-text-white-secondary)]" }, oC = { class: "relative text-[24px] leading-num-29 text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, rC = { class: "flex items-center gap-2 text-[14px] text-text-success dark:text-[var(--colors-text-success-subtle)]" }, iC = { class: "flex items-center justify-end" }, sC = ["src"], dC = { class: "relative leading-num-20 font-medium" }, uC = { class: "relative leading-num-20 text-dimgray dark:text-[var(--colors-text-white-secondary)]" }, UU = /* @__PURE__ */ ke({
  __name: "MetricCardWithChart",
  props: {
    title: { default: "" },
    value: { default: "" },
    trendValue: { default: "" },
    trendLabel: { default: "" },
    chartIcon: { default: void 0 },
    trendIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (a, t) => (u(), b("div", _2, [
      e.loading ? (u(), b("div", eC, [...t[0] || (t[0] = [
        Ar('<div class="flex items-center gap-2"><div class="skeleton h-5 w-5 rounded"></div><div class="skeleton h-6 w-28"></div></div><div class="skeleton h-[29px] w-32"></div><div class="flex items-center gap-2"><div class="skeleton h-5 w-16"></div><div class="skeleton h-5 w-24"></div></div>', 3)
      ])])) : (u(), b("div", tC, [
        x("div", aC, [
          Me(a.$slots, "chart-icon", {}, () => [
            e.chartIcon ? (u(), b("img", {
              key: 0,
              src: e.chartIcon,
              alt: "chart",
              class: "h-5 w-5 relative"
            }, null, 8, nC)) : w("", !0)
          ]),
          x("div", lC, H(e.title), 1)
        ]),
        x("b", oC, H(e.value), 1),
        x("div", rC, [
          x("div", iC, [
            Me(a.$slots, "trend-icon", {}, () => [
              e.trendIcon ? (u(), b("img", {
                key: 0,
                src: e.trendIcon,
                alt: "trend",
                class: "h-4 w-4 relative"
              }, null, 8, sC)) : w("", !0)
            ]),
            x("div", dC, H(e.trendValue), 1)
          ]),
          x("div", uC, H(e.trendLabel), 1)
        ])
      ]))
    ]));
  }
}), cC = {
  class: "flex flex-col justify-center gap-6 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft) bg-(--colors-background-white) p-6 shadow-(--blur-shadow-s) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)]",
  "data-testid": "metric-card-progress"
}, fC = { class: "flex flex-col gap-2" }, hC = {
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "metric-card-progress-title"
}, bC = { class: "flex items-end gap-2" }, gC = {
  class: "text-2xl leading-[29px] font-bold text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "metric-card-progress-value"
}, mC = {
  key: 0,
  class: "text-sm leading-5 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "metric-card-progress-target"
}, vC = { class: "flex flex-col gap-1.5" }, pC = ["aria-label", "aria-valuenow", "aria-valuetext"], xC = {
  key: 0,
  class: "flex items-center justify-between gap-2"
}, yC = {
  class: "text-sm leading-5 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "metric-card-progress-label"
}, GU = /* @__PURE__ */ ke({
  __name: "MetricCardProgress",
  props: {
    title: { default: "" },
    value: { default: "" },
    target: { default: void 0 },
    used: { default: 0 },
    total: { default: 0 },
    unit: { default: "" },
    loading: { type: Boolean, default: !1 },
    progressFormat: { type: Function, default: void 0 },
    progressLabel: { default: void 0 }
  },
  setup(e) {
    const a = e, t = m(() => a.total <= 0 ? 0 : Math.min(Math.max(a.used / a.total * 100, 0), 100)), n = m(() => a.progressLabel !== void 0 ? a.progressLabel : a.total <= 0 || !a.progressFormat ? "" : a.progressFormat(a.used, a.total, a.unit));
    return (l, o) => (u(), b("div", cC, [
      e.loading ? (u(), b(ie, { key: 0 }, [
        o[0] || (o[0] = Ar('<div class="flex flex-col gap-2"><div class="skeleton h-6 w-32"></div><div class="skeleton h-[29px] w-24"></div></div><div class="flex flex-col gap-1.5"><div class="skeleton h-2.5 w-full rounded-full"></div><div class="skeleton h-5 w-40"></div></div>', 2))
      ], 64)) : (u(), b(ie, { key: 1 }, [
        x("div", fC, [
          x("span", hC, H(e.title), 1),
          x("div", bC, [
            x("b", gC, H(e.value), 1),
            e.target ? (u(), b("span", mC, "/ " + H(e.target), 1)) : w("", !0)
          ])
        ]),
        x("div", vC, [
          x("div", {
            class: "h-2.5 w-full overflow-hidden rounded-full bg-(--colors-background-gray)",
            role: "progressbar",
            "aria-label": e.title || void 0,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuenow": e.total > 0 ? t.value : void 0,
            "aria-valuetext": n.value || void 0
          }, [
            x("div", {
              class: "h-full rounded-full transition-[width] duration-300",
              style: Ge({
                width: `${t.value}%`,
                backgroundImage: "var(--gradient-brand-horizontal)"
              })
            }, null, 4)
          ], 8, pC),
          n.value || l.$slots.trend ? (u(), b("div", xC, [
            x("span", yC, H(n.value), 1),
            Me(l.$slots, "trend")
          ])) : w("", !0)
        ])
      ], 64))
    ]));
  }
}), kC = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-start p-num-24 box-border text-num-16 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, wC = {
  key: 0,
  class: "self-stretch flex flex-col items-start gap-2"
}, CC = {
  key: 1,
  class: "self-stretch flex flex-col items-start gap-2"
}, SC = { class: "self-stretch flex items-center justify-between gap-5" }, $C = { class: "flex items-center gap-1.5" }, IC = { class: "relative leading-6 dark:text-[var(--colors-text-white-secondary)]" }, LC = ["src"], TC = { class: "relative text-[24px] leading-num-29 text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, EC = { class: "relative leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, KU = /* @__PURE__ */ ke({
  __name: "MetricCardAction",
  props: {
    title: { default: "" },
    value: { default: "" },
    subtitle: { default: "" },
    actionText: { default: "" },
    dropdownIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["action"],
  setup(e) {
    return (a, t) => (u(), b("div", kC, [
      e.loading ? (u(), b("div", wC, [...t[1] || (t[1] = [
        Ar('<div class="self-stretch flex items-center justify-between gap-5"><div class="skeleton h-6 w-24"></div><div class="skeleton h-8 w-16 rounded"></div></div><div class="skeleton h-[29px] w-32"></div><div class="skeleton h-6 w-40"></div>', 3)
      ])])) : (u(), b("div", CC, [
        x("div", SC, [
          x("div", $C, [
            x("div", IC, H(e.title), 1),
            Me(a.$slots, "dropdown-icon", {}, () => [
              e.dropdownIcon ? (u(), b("img", {
                key: 0,
                src: e.dropdownIcon,
                alt: "dropdown",
                class: "h-[18px] w-[18px] relative"
              }, null, 8, LC)) : w("", !0)
            ])
          ]),
          e.actionText ? (u(), P(L(Be), {
            key: 0,
            variant: "secondary",
            label: e.actionText,
            size: "sm",
            onClick: t[0] || (t[0] = (n) => a.$emit("action"))
          }, null, 8, ["label"])) : w("", !0)
        ]),
        x("b", TC, H(e.value), 1),
        x("div", EC, H(e.subtitle), 1)
      ]))
    ]));
  }
}), cm = Symbol("FieldBelow"), Tc = (e) => e.some((a) => a.type === oc ? !1 : a.type === r0 ? typeof a.children == "string" && a.children.trim() !== "" : a.type === ie ? Array.isArray(a.children) && Tc(a.children) : !0), AC = new Proxy({}, { get: () => {
} });
function Ia() {
  const e = Na();
  return (a) => {
    var t;
    return !!((t = e[a]) != null && t.call(e, AC).some((n) => n.type !== oc));
  };
}
const Zn = {
  sm: {
    addon: "pl-[calc(--spacing(2)-1px)] pr-[calc(--spacing(2)-1px)]",
    input: "pl-[calc(--spacing(2))]",
    inputEnd: "pr-[calc(--spacing(2)-1px)]"
  },
  md: {
    addon: "pl-[calc(--spacing(2.5)-1px)] pr-[calc(--spacing(2.5)-1px)]",
    input: "pl-[calc(--spacing(2.5))]",
    inputEnd: "pr-[calc(--spacing(2.5)-1px)]"
  },
  lg: {
    addon: "pl-[calc(--spacing(3)-1px)] pr-[calc(--spacing(3)-1px)]",
    input: "pl-[calc(--spacing(3))]",
    inputEnd: "pr-[calc(--spacing(3)-1px)]"
  },
  xl: {
    addon: "pl-[calc(--spacing(3.5)-1px)] pr-[calc(--spacing(3.5)-1px)]",
    input: "pl-[calc(--spacing(3.5))]",
    inputEnd: "pr-[calc(--spacing(3.5)-1px)]"
  }
}, RC = ["id", "name", "type", "value", "placeholder", "disabled", "readonly", "inputmode", "autocomplete", "pattern", "maxlength", "minlength", "min", "max", "aria-labelledby", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required"], zC = ["aria-label", "onKeydown"], DC = {
  key: 0,
  class: "shrink-0"
}, BC = /* @__PURE__ */ ke({
  __name: "TextInput",
  props: {
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    iconLeft: { default: void 0 },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    labels: { default: () => ({ clear: "Clear input" }) },
    type: { default: "text" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelInline: { type: Boolean, default: !1 },
    reserveHelper: { type: Boolean, default: !0 },
    ariaLabel: { default: void 0 },
    inputmode: { default: void 0 },
    autocomplete: { default: "off" },
    pattern: { default: void 0 },
    maxlength: { default: void 0 },
    minlength: { default: void 0 },
    min: { default: void 0 },
    max: { default: void 0 },
    error: { default: void 0 },
    hint: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    readonlyChrome: { type: Boolean, default: !0 },
    valueVariant: { default: "default" },
    showEditIcon: { type: Boolean, default: !0 },
    variant: { default: "default" },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    innerButton: { default: void 0 },
    prefix: { default: void 0 },
    removeButton: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "keydown", "button-click"],
  setup(e, { emit: a }) {
    const t = e, n = (J, { slots: ne }) => {
      var Y;
      return (Y = ne.default) == null ? void 0 : Y.call(ne);
    }, l = a, o = R(!1), r = R(null), i = R(null), s = R(null), d = Na(), c = Ia(), f = m(() => c("actions")), g = na(cm, null), h = m(() => (g == null ? void 0 : g()) ?? null), v = m(() => t.modelValue !== void 0 && t.modelValue !== null && t.modelValue.trim() !== ""), p = m(() => !!t.error), y = Ye(), k = m(() => t.id || y), $ = m(() => t.label ? `${k.value}-label` : void 0), S = m(() => `${k.value}-error`), I = m(() => `${k.value}-hint`), T = m(() => {
      if (t.ariaDescribedby) return t.ariaDescribedby;
      const J = [];
      return t.hint && I.value && J.push(I.value), p.value && S.value && J.push(S.value), J.length > 0 ? J.join(" ") : void 0;
    }), A = m(() => p.value ? "true" : void 0), E = m(() => t.valueVariant === "link" ? "text-(--text-text-link) font-(--weight-semi-bold)" : ""), z = (J) => t.showEditIcon && J && !o.value && !t.disabled && !t.readonly, B = m(() => o.value && v.value && !t.disabled && !t.readonly), W = m(() => t.fullWidth || t.width === void 0), _ = m(() => W.value ? "w-full" : ""), Z = m(() => W.value ? {} : { width: t.width }), le = m(
      () => t.buttons.length > 0 && t.labelInline ? { style: Z.value } : {}
    ), D = m(() => t.buttons.length > 0), O = m(
      () => Co(t.labelInline, !!t.label && !G.value, !!t.removeButton)
    ), N = m(() => t.removeButton && Cc(t.removeButton)), V = R(null), { inGroup: M, groupPart: Q } = $c(V), q = m(() => `${`relative min-w-0 ${M ? Q.value.part : "pb-0.5"} text-left text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default) font-inter`} ${O.value.root}${W.value ? " w-full" : ""}`), K = m(() => W.value || t.labelInline ? {} : { width: t.width }), G = m(() => t.variant === "stacked"), te = m(() => !!t.prefix && !G.value), ve = m(() => {
      if (G.value)
        return { class: "relative flex w-full min-w-0 items-center justify-center gap-0.5 px-6" };
      if (te.value) {
        const J = Zn[t.size];
        return {
          class: [
            "flex h-full min-w-0 flex-1 items-center gap-2",
            J.input,
            t.innerButton ? "" : J.inputEnd
          ]
        };
      }
      return null;
    }), Se = m(() => t.disabled ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : !t.readonly && !p.value && !t.success && !o.value && !v.value ? "text-(--text-text-heading) dark:text-(--colors-text-white-default)" : "text-(--text-text-black-default) dark:text-(--colors-text-white-default)"), oe = (J) => {
      var ee;
      if (!G.value || t.disabled) return;
      const ne = J.target;
      if (ne === r.value) return;
      const Y = J.currentTarget, F = ne == null ? void 0 : ne.closest('button, a, [role="button"], input, select, textarea, [tabindex]');
      F && F !== Y && Y.contains(F) || (J.preventDefault(), (ee = r.value) == null || ee.focus());
    }, re = (J) => {
      const ne = J.target;
      l("update:modelValue", ne.value), l("input", J);
    }, ge = (J) => {
      var ne;
      t.disabled || (o.value = !0, (ne = J.target) == null || ne.select()), l("focus", J);
    }, de = (J) => {
      o.value = !1, l("blur", J);
    }, Ee = (J) => {
      var ne, Y;
      l("keydown", J), (ne = i.value) == null || ne.handleFieldKeydown(J), (Y = s.value) == null || Y.handleFieldKeydown(J);
    }, j = () => {
      l("update:modelValue", ""), l("clear");
    };
    return (J, ne) => (u(), b("div", {
      ref_key: "rootRef",
      ref: V,
      class: C(q.value),
      style: Ge(K.value)
    }, [
      e.label && !G.value ? (u(), P(Ft, {
        key: 0,
        id: $.value,
        ref_key: "labelRef",
        ref: i,
        text: e.label,
        "input-id": k.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: o.value,
        inline: e.labelInline,
        class: C(O.value.label),
        "test-id": "text-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : w("", !0),
      x("div", {
        class: C(["flex items-end gap-3 w-full", O.value.field])
      }, [
        U(Br, Ve({
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          disabled: e.disabled,
          "button-size": e.buttonSize
        }, le.value, {
          onButtonClick: ne[2] || (ne[2] = (Y) => l("button-click", Y))
        }), {
          default: me(({ fieldClass: Y }) => [
            U(en, {
              size: e.size,
              stacked: G.value,
              flush: te.value,
              "inner-button": !!e.innerButton,
              disabled: e.disabled,
              readonly: e.readonly && e.readonlyChrome,
              error: p.value,
              success: e.success,
              "has-value": v.value,
              class: C([
                e.disabled && e.valueVariant === "link" ? "cursor-pointer" : "",
                D.value ? "w-full" : _.value,
                !D.value && f.value ? "flex-1 min-w-0" : "",
                Y || L(Q).corners
              ]),
              style: Ge(D.value || f.value ? {} : Z.value),
              onMousedown: oe
            }, {
              default: me(({
                hovered: F,
                iconBoxClass: ee,
                leftIconBoxClass: ue,
                iconColorClass: se,
                textClass: X,
                topTextClass: ae,
                borderColorClass: Re,
                addonTextClass: Ae
              }) => [
                G.value && e.label ? (u(), P(Ft, {
                  key: 0,
                  id: $.value,
                  ref_key: "labelRef",
                  ref: i,
                  text: e.label,
                  "input-id": k.value,
                  required: e.required,
                  "required-indicator": e.requiredIndicator,
                  focused: o.value,
                  "text-class": `${ae} ${Se.value}`,
                  "test-id": "text-input-label"
                }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "focused", "text-class"])) : w("", !0),
                te.value ? (u(), b("span", {
                  key: 1,
                  "data-testid": "text-input-prefix",
                  class: C([
                    "flex shrink-0 select-none items-center gap-2 self-stretch border-r",
                    L(Zn)[e.size].addon,
                    "text-(length:--size-m) leading-(--line-height-l)",
                    Re,
                    Ae
                  ])
                }, [
                  e.iconLeft ? (u(), b("i", {
                    key: 0,
                    class: C([e.iconLeft, ue, se])
                  }, null, 2)) : w("", !0),
                  st(" " + H(e.prefix), 1)
                ], 2)) : w("", !0),
                (u(), P(gt(ve.value ? "div" : n), ga(ka(ve.value ?? {})), {
                  default: me(() => [
                    e.iconLeft && !te.value ? (u(), b("i", {
                      key: 0,
                      class: C([e.iconLeft, ue, se])
                    }, null, 2)) : w("", !0),
                    x("input", {
                      id: k.value,
                      ref_key: "inputRef",
                      ref: r,
                      name: e.name,
                      type: e.type,
                      value: e.modelValue,
                      placeholder: e.placeholder,
                      disabled: e.disabled,
                      readonly: e.readonly,
                      inputmode: e.inputmode,
                      autocomplete: e.autocomplete,
                      pattern: e.pattern,
                      maxlength: e.maxlength,
                      minlength: e.minlength,
                      min: e.min,
                      max: e.max,
                      "aria-labelledby": $.value,
                      "aria-label": e.label ? void 0 : e.ariaLabel,
                      "aria-disabled": e.disabled ? "true" : void 0,
                      "aria-invalid": A.value,
                      "aria-describedby": T.value,
                      "aria-required": e.required ? "true" : void 0,
                      "data-testid": "text-input",
                      class: C([
                        G.value ? "field-sizing-content not-supports-[field-sizing:content]:flex-1 max-w-full min-w-0 text-center text-ellipsis relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) p-0" : "flex-1 min-w-0 text-ellipsis relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) pl-0",
                        X,
                        e.readonly ? "cursor-default" : "",
                        E.value,
                        e.valueVariant === "link" ? "pointer-events-none" : ""
                      ]),
                      onInput: re,
                      onFocus: ge,
                      onBlur: de,
                      onKeydown: Ee
                    }, null, 42, RC),
                    Me(J.$slots, "suffix", {}, void 0, !0),
                    (u(), P(gt(G.value ? "span" : n), ga(ka(
                      G.value ? { class: "absolute right-0 top-1/2 flex -translate-y-1/2 items-center" } : {}
                    )), {
                      default: me(() => [
                        Me(J.$slots, "iconRight", {
                          iconColorClass: se,
                          iconBoxClass: ee
                        }, void 0, !0),
                        !d.iconRight && z(F) ? (u(), b("i", {
                          key: 0,
                          class: C(["ri-pencil-line text-(--icons-icon-accent)", ee])
                        }, null, 2)) : !d.iconRight && B.value ? (u(), b("i", {
                          key: 1,
                          class: C(["ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", ee]),
                          role: "button",
                          tabindex: "-1",
                          "aria-label": e.labels.clear,
                          onMousedown: ne[0] || (ne[0] = _e(() => {
                          }, ["prevent"])),
                          onClick: _e(j, ["stop"]),
                          onKeydown: [
                            St(j, ["enter"]),
                            St(_e(j, ["prevent"]), ["space"])
                          ]
                        }, null, 42, zC)) : w("", !0)
                      ]),
                      _: 2
                    }, 1040))
                  ]),
                  _: 2
                }, 1040)),
                e.innerButton ? (u(), P(Be, Ve({ key: 2 }, L(vn)(e.innerButton, e.disabled), {
                  size: "xs",
                  onClick: ne[1] || (ne[1] = (xe) => l("button-click", e.innerButton.id))
                }), null, 16)) : w("", !0)
              ]),
              _: 3
            }, 8, ["size", "stacked", "flush", "inner-button", "disabled", "readonly", "error", "success", "has-value", "class", "style"])
          ]),
          _: 3
        }, 16, ["buttons", "layout", "size", "disabled", "button-size"]),
        f.value ? (u(), b("div", DC, [
          Me(J.$slots, "actions", {}, void 0, !0)
        ])) : w("", !0),
        N.value && O.value.removeInFieldRow ? (u(), P(Be, Ve({ key: 1 }, L(vn)(N.value, e.disabled), {
          size: L(ol)(e.size, "attached"),
          onClick: ne[3] || (ne[3] = (Y) => l("button-click", N.value.id))
        }), null, 16, ["size"])) : w("", !0)
      ], 2),
      h.value ? (u(), b("div", {
        key: 1,
        class: C(["w-full", O.value.helper])
      }, [
        (u(), P(gt(() => h.value)))
      ], 2)) : w("", !0),
      !L(M) && O.value.reservesHelper && e.reserveHelper || e.hint || e.error ? (u(), P(Pt, {
        key: 2,
        ref_key: "helperRef",
        ref: s,
        class: C(O.value.helper),
        focused: o.value,
        hint: e.hint,
        error: e.error,
        "hint-id": I.value,
        "error-id": S.value,
        "test-id-prefix": "text-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id"])) : w("", !0),
      N.value && !O.value.removeInFieldRow ? (u(), P(Be, Ve({ key: 3 }, L(vn)(N.value, e.disabled), {
        class: O.value.remove,
        size: L(ol)(e.size, "attached"),
        onClick: ne[4] || (ne[4] = (Y) => l("button-click", N.value.id))
      }), null, 16, ["class", "size"])) : w("", !0)
    ], 6));
  }
}), Qt = /* @__PURE__ */ Ct(BC, [["__scopeId", "data-v-d334b014"]]), MC = ["aria-labelledby", "aria-describedby"], OC = { class: "mt-px flex min-w-0 flex-col gap-px" }, YU = /* @__PURE__ */ ke({
  __name: "FieldGroup",
  props: {
    label: {},
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    layout: { default: "attached" },
    fullWidth: { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = e, t = Ye(), n = `${t}-hint`, l = `${t}-error`, o = `${t}-label`, r = m(
      () => [a.hint ? n : "", a.error ? l : ""].filter(Boolean).join(" ") || void 0
    ), i = ko([]), s = (y, k) => y.compareDocumentPosition(k) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1, d = { part: "", corners: "" };
    wa(Sc, {
      register: (y) => {
        i.value = [...i.value, y].sort(s);
      },
      unregister: (y) => {
        i.value = i.value.filter((k) => k !== y);
      },
      partOf: (y) => {
        const k = y ? i.value.indexOf(y) : -1;
        return a.layout !== "attached" || k < 0 ? d : sm(im(k, i.value.length), "l");
      }
    });
    const c = m(
      () => a.layout === "attached" ? dm("l") : "flex w-full items-start gap-(--spacing-2-5)"
    ), f = R(!1), g = R(null), h = R(null);
    function v(y) {
      const k = y.relatedTarget;
      (!k || !y.currentTarget.contains(k)) && (f.value = !1);
    }
    function p(y) {
      var k, $;
      (k = g.value) == null || k.handleFieldKeydown(y), ($ = h.value) == null || $.handleFieldKeydown(y);
    }
    return (y, k) => (u(), b("fieldset", {
      "aria-labelledby": e.labelTooltip ? o : void 0,
      "aria-describedby": r.value,
      class: C(["m-0 w-full min-w-0 border-0 p-0 font-inter", { "max-w-sm": !e.fullWidth }]),
      "data-testid": "field-group",
      onFocusin: k[0] || (k[0] = ($) => f.value = !0),
      onFocusout: v,
      onKeydown: p
    }, [
      U(Ft, {
        id: o,
        ref_key: "labelRef",
        ref: g,
        as: "legend",
        class: "p-0",
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: f.value,
        "test-id": "field-group-label"
      }, null, 8, ["text", "required", "required-indicator", "tooltip", "focused"]),
      x("div", OC, [
        x("div", {
          class: C([c.value, "*:min-w-0 *:flex-1"]),
          "data-testid": "field-group-row"
        }, [
          Me(y.$slots, "default")
        ], 2),
        U(Pt, {
          ref_key: "helperRef",
          ref: h,
          focused: f.value,
          hint: e.hint,
          error: e.error,
          "hint-id": n,
          "error-id": l,
          "test-id-prefix": "field-group"
        }, null, 8, ["focused", "hint", "error"])
      ])
    ], 42, MC));
  }
}), PC = ["id", "value", "placeholder", "disabled", "aria-labelledby", "aria-label", "aria-invalid", "aria-describedby", "aria-required"], FC = {
  role: "status",
  class: "sr-only",
  "data-testid": "copy-input-status"
}, dd = "copy-to-clipboard", NC = 2e3, JU = /* @__PURE__ */ ke({
  __name: "CopyInput",
  props: {
    modelValue: { default: "" },
    variant: { default: "attached" },
    iconOnly: { type: Boolean, default: !1 },
    buttons: { default: () => [] },
    prefix: { default: void 0 },
    iconLeft: { default: void 0 },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    required: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    width: { default: void 0 },
    id: { default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["copy", "copy-error", "button-click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => t.labels.copy ?? "Copy"), o = m(() => t.labels.copied ?? "Copied!"), r = R(!1), i = R("");
    let s, d = !1;
    async function c() {
      try {
        await navigator.clipboard.writeText(t.modelValue);
      } catch (E) {
        n("copy-error", E);
        return;
      }
      clearTimeout(s), i.value = "", await Ze(), !d && (r.value = !0, i.value = o.value, n("copy", t.modelValue), s = setTimeout(() => {
        r.value = !1, i.value = "";
      }, NC));
    }
    Tt(() => {
      d = !0, clearTimeout(s);
    });
    const f = {
      attached: "ri-file-copy-2-line",
      spaced: void 0,
      inner: "ri-file-copy-line",
      large: "ri-file-copy-2-line"
    }, g = m(() => {
      const E = t.iconOnly && (t.variant === "attached" || t.variant === "spaced");
      return {
        id: dd,
        label: r.value && !E ? o.value : l.value,
        // The button keeps its name so only the status announces the copy, not also a name change
        ariaLabel: r.value && !E ? l.value : void 0,
        icon: E ? "ri-file-copy-line" : f[t.variant],
        iconOnly: E,
        color: t.variant === "inner" || t.variant === "large" ? "tertiary" : "secondary",
        position: "end"
      };
    }), h = m(
      () => t.variant === "inner" ? t.buttons : [...t.buttons, g.value]
    );
    function v(E) {
      E === dd ? c() : n("button-click", E);
    }
    const p = Ye(), y = m(() => t.id || p), k = m(() => t.label ? `${y.value}-label` : void 0), $ = m(() => `${y.value}-hint`), S = m(() => `${y.value}-error`), I = m(() => {
      const E = [t.hint ? $.value : "", t.error ? S.value : ""].filter(Boolean);
      return E.length ? E.join(" ") : void 0;
    }), T = R(!1), A = m(() => Co(!1, !!t.label, !1));
    return (E, z) => (u(), b("div", {
      class: C(["relative min-w-0", e.width ? "" : "w-full"]),
      style: Ge(e.width ? { width: e.width } : void 0),
      "data-testid": "copy-input"
    }, [
      e.variant === "large" ? (u(), b("div", {
        key: 0,
        class: C([
          "relative w-full min-w-0 pb-0.5 text-left font-inter text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
          A.value.root
        ])
      }, [
        e.label ? (u(), P(Ft, {
          key: 0,
          id: k.value,
          text: e.label,
          "input-id": y.value,
          required: e.required,
          tooltip: e.labelTooltip,
          focused: T.value,
          "test-id": "copy-input-label"
        }, null, 8, ["id", "text", "input-id", "required", "tooltip", "focused"])) : w("", !0),
        U(en, {
          multiline: "",
          disabled: e.disabled,
          error: !!e.error,
          "has-value": !!e.modelValue,
          class: "w-full gap-2"
        }, {
          default: me(() => [
            x("textarea", {
              id: y.value,
              value: e.modelValue,
              placeholder: e.placeholder,
              disabled: e.disabled,
              readonly: "",
              "aria-labelledby": k.value,
              "aria-label": e.label ? void 0 : e.ariaLabel,
              "aria-invalid": e.error ? "true" : void 0,
              "aria-describedby": I.value,
              "aria-required": e.required ? "true" : void 0,
              "data-testid": "copy-input-value",
              class: "h-full min-w-0 flex-1 self-stretch resize-none cursor-default border-0 bg-transparent p-0 text-(length:--size-sm) leading-(--line-height-l-tight) outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
              onFocus: z[0] || (z[0] = (B) => T.value = !0),
              onBlur: z[1] || (z[1] = (B) => T.value = !1)
            }, null, 40, PC),
            U(Be, {
              class: "-mr-1 mt-[calc(--spacing(2)+1px)] shrink-0 self-start",
              variant: "tertiary",
              size: "xs",
              "icon-left": g.value.icon,
              label: g.value.label,
              "aria-label": g.value.ariaLabel,
              disabled: e.disabled,
              "data-field-button": dd,
              onClick: c
            }, null, 8, ["icon-left", "label", "aria-label", "disabled"])
          ]),
          _: 1
        }, 8, ["disabled", "error", "has-value"]),
        U(Pt, {
          hint: e.hint,
          error: e.error,
          "hint-id": $.value,
          "error-id": S.value,
          focused: T.value,
          "test-id-prefix": "copy-input"
        }, null, 8, ["hint", "error", "hint-id", "error-id", "focused"])
      ], 2)) : (u(), P(Qt, {
        key: 1,
        id: e.id,
        "model-value": e.modelValue,
        readonly: "",
        "readonly-chrome": !1,
        placeholder: e.placeholder,
        label: e.label,
        "label-tooltip": e.labelTooltip,
        required: e.required,
        "aria-label": e.ariaLabel,
        hint: e.hint,
        error: e.error,
        disabled: e.disabled,
        size: e.size,
        "icon-left": e.iconLeft,
        prefix: e.prefix,
        buttons: h.value,
        "button-layout": e.variant === "spaced" ? "spaced" : "attached",
        "inner-button": e.variant === "inner" ? g.value : void 0,
        onButtonClick: v
      }, null, 8, ["id", "model-value", "placeholder", "label", "label-tooltip", "required", "aria-label", "hint", "error", "disabled", "size", "icon-left", "prefix", "buttons", "button-layout", "inner-button"])),
      x("span", FC, H(i.value), 1)
    ], 6));
  }
}), VC = ["id"], HC = ["id", "name", "value", "placeholder", "disabled", "readonly", "min", "max", "step", "aria-labelledby", "aria-label", "aria-invalid", "aria-describedby", "aria-required"], jC = ["aria-label", "onKeydown"], WC = /* @__PURE__ */ ke({
  __name: "NumberInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    iconLeft: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    prefix: { default: void 0 },
    min: { default: void 0 },
    max: { default: void 0 },
    step: { default: void 0 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    hint: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    labels: { default: () => ({ clear: "Clear input" }) },
    labelInline: { type: Boolean, default: !1 },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    removeButton: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "button-click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = R(!1), o = R(null), r = R(null), i = Ye(), s = m(() => t.id ?? i), d = m(() => t.label ? `${s.value}-label` : void 0), c = m(() => t.prefix ? `${s.value}-prefix` : void 0), f = m(() => `${s.value}-error`), g = m(() => `${s.value}-hint`), h = m(
      () => d.value ? [d.value, c.value].filter(Boolean).join(" ") : void 0
    ), v = m(() => !!t.error), p = m(
      () => t.modelValue !== void 0 && t.modelValue !== null && String(t.modelValue).trim() !== ""
    ), y = (N) => N && !l.value && !t.disabled && !t.readonly, k = m(
      () => l.value && p.value && !t.disabled && !t.readonly
    ), $ = m(() => {
      const N = [];
      return t.hint && N.push(g.value), v.value && N.push(f.value), N.join(" ") || void 0;
    }), S = m(() => t.fullWidth || t.width === void 0), I = m(
      () => Co(t.labelInline, !!t.label, !!t.removeButton)
    ), T = m(() => t.removeButton && Cc(t.removeButton)), A = R(null), { inGroup: E, groupPart: z } = $c(A), B = m(
      () => `relative min-w-0 ${E ? z.value.part : "pb-0.5"} text-left text-(length:--size-m) font-inter ${I.value.root}${S.value ? " w-full" : ""}`
    ), W = m(() => S.value ? {} : { width: t.width });
    function _(N) {
      n("update:modelValue", N.target.value), n("input", N);
    }
    function Z(N) {
      t.disabled || (l.value = !0), n("focus", N);
    }
    function le(N) {
      l.value = !1, n("blur", N);
    }
    function D(N) {
      var V, M;
      (V = o.value) == null || V.handleFieldKeydown(N), (M = r.value) == null || M.handleFieldKeydown(N);
    }
    function O() {
      n("update:modelValue", ""), n("clear");
    }
    return (N, V) => (u(), b("div", {
      ref_key: "rootRef",
      ref: A,
      class: C(B.value),
      style: Ge(W.value)
    }, [
      e.label ? (u(), P(Ft, {
        key: 0,
        id: d.value,
        ref_key: "labelRef",
        ref: o,
        text: e.label,
        "input-id": s.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: l.value,
        inline: e.labelInline,
        class: C(I.value.label),
        "test-id": "number-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : w("", !0),
      x("div", {
        class: C(["flex w-full items-end gap-3", I.value.field])
      }, [
        U(Br, {
          buttons: e.buttons,
          layout: e.buttonLayout,
          size: e.size,
          disabled: e.disabled,
          "button-size": e.buttonSize,
          onButtonClick: V[1] || (V[1] = (M) => n("button-click", M))
        }, {
          default: me(({ fieldClass: M }) => [
            U(en, {
              class: C(["w-full", M || L(z).corners]),
              flush: !!e.prefix,
              size: e.size,
              disabled: e.disabled,
              readonly: e.readonly,
              error: v.value,
              success: e.success,
              "has-value": p.value
            }, {
              default: me(({ hovered: Q, iconBoxClass: q, leftIconBoxClass: K, iconColorClass: G, borderColorClass: te, addonTextClass: ve, textClass: Se }) => [
                e.prefix ? (u(), b("span", {
                  key: 0,
                  id: c.value,
                  class: C([
                    "flex shrink-0 select-none items-center self-stretch border-r",
                    L(Zn)[e.size].addon,
                    "text-(length:--size-m) leading-(--line-height-l)",
                    te,
                    ve
                  ])
                }, H(e.prefix), 11, VC)) : w("", !0),
                x("div", {
                  class: C(
                    e.prefix ? ["flex h-full min-w-0 flex-1 items-center gap-2", L(Zn)[e.size].input, L(Zn)[e.size].inputEnd] : "contents"
                  )
                }, [
                  e.iconLeft && !e.prefix ? (u(), b("i", {
                    key: 0,
                    class: C([e.iconLeft, K, G]),
                    "aria-hidden": "true"
                  }, null, 2)) : w("", !0),
                  x("input", {
                    id: s.value,
                    name: e.name,
                    type: "number",
                    value: e.modelValue,
                    placeholder: e.placeholder,
                    disabled: e.disabled,
                    readonly: e.readonly,
                    min: e.min,
                    max: e.max,
                    step: e.step,
                    "aria-labelledby": h.value,
                    "aria-label": e.label ? void 0 : e.ariaLabel,
                    "aria-invalid": v.value ? "true" : void 0,
                    "aria-describedby": $.value,
                    "aria-required": e.required ? "true" : void 0,
                    "data-testid": "number-input",
                    class: C([
                      "relative min-w-0 flex-1 text-ellipsis border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
                      Se,
                      e.readonly ? "cursor-default" : ""
                    ]),
                    onInput: _,
                    onFocus: Z,
                    onBlur: le,
                    onKeydown: D
                  }, null, 42, HC),
                  y(Q) ? (u(), b("i", {
                    key: 1,
                    class: C(["ri-pencil-line text-(--icons-icon-accent)", q])
                  }, null, 2)) : k.value ? (u(), b("i", {
                    key: 2,
                    class: C([
                      "ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
                      q
                    ]),
                    role: "button",
                    tabindex: "-1",
                    "aria-label": e.labels.clear,
                    onMousedown: V[0] || (V[0] = _e(() => {
                    }, ["prevent"])),
                    onClick: _e(O, ["stop"]),
                    onKeydown: [
                      St(O, ["enter"]),
                      St(_e(O, ["prevent"]), ["space"])
                    ]
                  }, null, 42, jC)) : w("", !0)
                ], 2)
              ]),
              _: 1
            }, 8, ["class", "flush", "size", "disabled", "readonly", "error", "success", "has-value"])
          ]),
          _: 1
        }, 8, ["buttons", "layout", "size", "disabled", "button-size"]),
        T.value && I.value.removeInFieldRow ? (u(), P(Be, Ve({ key: 0 }, L(vn)(T.value, e.disabled), {
          size: L(ol)(e.size, "attached"),
          onClick: V[2] || (V[2] = (M) => n("button-click", T.value.id))
        }), null, 16, ["size"])) : w("", !0)
      ], 2),
      !L(E) && I.value.reservesHelper || e.hint || e.error ? (u(), P(Pt, {
        key: 1,
        ref_key: "helperRef",
        ref: r,
        class: C(I.value.helper),
        focused: l.value,
        hint: e.hint,
        error: e.error,
        "hint-id": g.value,
        "error-id": f.value,
        "test-id-prefix": "number-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id"])) : w("", !0),
      T.value && !I.value.removeInFieldRow ? (u(), P(Be, Ve({ key: 2 }, L(vn)(T.value, e.disabled), {
        class: I.value.remove,
        size: L(ol)(e.size, "attached"),
        onClick: V[3] || (V[3] = (M) => n("button-click", T.value.id))
      }), null, 16, ["class", "size"])) : w("", !0)
    ], 6));
  }
}), ah = /* @__PURE__ */ Ct(WC, [["__scopeId", "data-v-2b2a52df"]]), qC = ["id", "name", "checked", "disabled", "value", "aria-label", "aria-labelledby", "aria-describedby"], UC = {
  key: 1,
  class: "absolute left-1/2 top-1/2 size-6 -translate-x-1/2 -translate-y-1/2",
  "data-testid": "radio-hit-area"
}, GC = ["for"], KC = /* @__PURE__ */ ke({
  __name: "RadioButton",
  props: {
    label: { default: void 0 },
    modelValue: { type: [String, Number, Boolean], default: void 0 },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    value: { type: [String, Number, Boolean], default: void 0 },
    presentational: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaDescribedby: { default: void 0 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => t.modelValue === t.value), o = R(null), { resync: r } = As(o, () => l.value), i = Ye(), s = m(() => t.id ?? i), d = m(() => t.presentational ? "span" : "div"), c = m(() => !t.presentational && !!t.label), f = m(() => {
      const $ = "relative box-border flex size-4 shrink-0 items-center justify-center rounded-(--border-border-radius-rounded-full) border border-solid transition-all duration-200 motion-reduce:transition-none peer-focus-visible:shadow-(--shadow-focus-l) peer-focus-visible:outline-2 peer-focus-visible:outline-transparent", S = c.value ? " mt-0.5" : "";
      return t.disabled ? `${$}${S} bg-(--background-background-disabled) border-(--border-border-disabled) cursor-not-allowed` : l.value ? `${$}${S} bg-(--background-background-white) border-(--border-border-black-default) dark:bg-(--background-background-black-default) dark:border-(--border-border-base-medium) cursor-pointer` : `${$}${S} bg-(--background-background-white) border-(--border-border-base-medium) dark:bg-(--background-background-black-default) cursor-pointer peer-focus-visible:border-(--border-border-hover)`;
    }), g = m(() => {
      const $ = "size-2 rounded-(--border-border-radius-rounded-full)";
      return t.disabled ? `${$} bg-(--background-background-disabled-strong) forced-colors:bg-[GrayText]` : `${$} bg-(--background-background-black-default) dark:bg-(--background-background-white-secondary) forced-colors:bg-[CanvasText]`;
    }), h = m(() => t.presentational ? "pointer-events-none flex items-center justify-center" : `${c.value ? "min-h-6 px-px " : ""}self-stretch flex items-center`), v = m(() => c.value ? "flex min-w-0 items-start gap-2" : "flex items-center gap-2 shrink-0"), p = m(() => {
      const $ = "relative min-w-0 flex-1 break-words text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)";
      return t.disabled ? `${$} text-(--text-text-disabled-strong) dark:text-(--colors-text-disabled) cursor-not-allowed` : `${$} text-(--text-text-heading) dark:text-(--text-text-white-default) cursor-pointer`;
    }), y = ($) => {
      $.preventDefault(), !(t.disabled || l.value) && (t.value !== void 0 && n("update:modelValue", t.value), n("change", $));
    }, k = ($) => {
      if (t.disabled || l.value) return;
      $.target.checked && t.value !== void 0 && (n("update:modelValue", t.value), n("change", $), r());
    };
    return ($, S) => (u(), P(gt(d.value), Ve({
      "data-testid": "radio-container",
      class: h.value
    }, nl(e.presentational ? {} : { click: y })), {
      default: me(() => [
        (u(), P(gt(d.value), {
          class: C(v.value)
        }, {
          default: me(() => [
            e.presentational ? w("", !0) : (u(), b("input", {
              key: 0,
              id: s.value,
              ref_key: "inputRef",
              ref: o,
              name: e.name,
              type: "radio",
              checked: l.value,
              disabled: e.disabled,
              value: e.value,
              "aria-label": e.ariaLabel,
              "aria-labelledby": e.ariaLabelledby,
              "aria-describedby": e.ariaDescribedby,
              class: "peer sr-only",
              onChange: k,
              onClick: S[0] || (S[0] = _e(() => {
              }, ["stop"]))
            }, null, 40, qC)),
            (u(), P(gt(d.value), {
              "data-testid": "radio-button",
              class: C(f.value)
            }, {
              default: me(() => [
                l.value ? (u(), P(gt(d.value), {
                  key: 0,
                  class: C(g.value)
                }, null, 8, ["class"])) : w("", !0),
                e.presentational ? w("", !0) : (u(), b("span", UC))
              ]),
              _: 1
            }, 8, ["class"])),
            !e.presentational && e.label ? (u(), b("label", {
              key: 1,
              for: s.value,
              class: C(p.value)
            }, H(e.label), 11, GC)) : w("", !0)
          ]),
          _: 1
        }, 8, ["class"]))
      ]),
      _: 1
    }, 16, ["class"]));
  }
}), fm = "rounded-(--border-border-radius-rounded-l) border border-solid", hm = `${fm} p-[calc(--spacing(4)-1px)]`, bm = "shadow-(--blur-shadow-xs)", cu = "transition-[border-color,box-shadow,background-color] motion-reduce:transition-none", gm = "bg-(--background-background-white) dark:bg-(--colors-background-black-default)", mm = "border-(--border-border-base-medium) dark:border-(--colors-border-base)", vm = "hover:bg-(--background-background-hover) dark:hover:bg-white/5", pm = "border-(--border-border-disabled) dark:border-(--colors-border-disabled-subtle)", xm = "bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled)", Bs = "text-(--text-text-disabled-strong)", YC = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", JC = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", ym = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)", XC = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", zi = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold)", ZC = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)", QC = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)";
function km(e) {
  return e ? Bs : "text-(--text-text-heading) dark:text-(--colors-text-white-default)";
}
function wm(e) {
  return e ? Bs : "text-(--text-text-body) dark:text-(--colors-text-white-secondary)";
}
const fu = "[&_.opal-badge]:whitespace-normal [&_.opal-badge]:break-words [&_.opal-badge]:text-left [&_.opal-badge]:max-w-full";
function Cm(e, a) {
  return a ? "disabled" : e.theme ?? "neutral";
}
const Sm = "bg-(--background-background-selected)", hu = "border-(--border-border-accent)", bu = "border-(--border-border-hover)", Xo = "has-[[data-selectable-card-input]:focus-visible]:shadow-(--shadow-focus-l) has-[[data-selectable-card-input]:focus-visible]:outline-2 has-[[data-selectable-card-input]:focus-visible]:outline-transparent", $m = "has-[[data-selectable-card-input]:focus-visible]:border-(--border-border-hover)", _C = ["id", "role", "aria-label", "data-name"], eS = ["id"], tS = ["id", "name", "value", "checked", "disabled", "aria-label", "aria-labelledby", "aria-describedby"], aS = ["id"], nS = ["id"], lS = {
  key: 0,
  class: "flex flex-wrap items-center gap-1"
}, oS = ["id"], rS = ["id"], XU = /* @__PURE__ */ ke({
  __name: "RadioForm",
  props: {
    modelValue: { type: [String, Number, Boolean], default: void 0 },
    value: { type: [String, Number, Boolean] },
    label: {},
    helper: { default: void 0 },
    icon: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "card" },
    ctaLabel: { default: void 0 },
    ctaIcon: { default: "ri-eye-line" },
    ctaSecondaryLabel: { default: void 0 },
    ariaLabel: { default: void 0 },
    labelTooltip: { default: void 0 },
    badges: { default: void 0 },
    indicatorPosition: { default: "right" }
  },
  emits: ["update:modelValue", "cta", "cta-secondary"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = Ia(), o = m(() => t.modelValue === t.value), r = m(() => t.type === "simple"), i = m(() => !t.readonly && !t.disabled), s = Ye(), d = Ye(), c = m(() => !!t.helper && !r.value), f = Ye(), g = Ye(), h = R(null), v = R(!1);
    $e(
      h,
      (ee, ue, se) => {
        const X = () => {
          v.value = !!ee && !ee.querySelector(yn);
        };
        if (X(), !ee) return;
        const ae = new MutationObserver(X);
        ae.observe(ee, {
          childList: !0,
          subtree: !0,
          attributes: !0,
          attributeFilter: ["tabindex", "disabled", "href", "contenteditable", "type"]
        }), se(() => ae.disconnect());
      },
      { immediate: !0, flush: "post" }
    );
    const p = m(() => {
      const ee = [];
      return c.value && ee.push(d), v.value && ee.push(g), t.labelTooltip && ee.push(f), ee.length > 0 ? ee.join(" ") : void 0;
    }), y = R(null), k = R(null), $ = R(null), { resync: S } = As($, () => o.value), I = R(null), T = R(null), A = R(!1), E = R(!1), z = m(() => {
      if (t.labelTooltip)
        return E.value ? !1 : A.value ? !0 : void 0;
    });
    function B(ee) {
      try {
        return ee.matches(":focus-visible");
      } catch {
        return !0;
      }
    }
    function W(ee) {
      var ue;
      return ee instanceof Node && !!((ue = y.value) != null && ue.contains(ee));
    }
    function _(ee) {
      t.labelTooltip && ee.target === $.value && ee.target instanceof Element && B(ee.target) && (A.value = !0);
    }
    function Z(ee) {
      W(ee.relatedTarget) || (A.value = !1, E.value = !1);
    }
    const le = m(
      () => t.labelTooltip ? "flex items-center gap-1" : ""
    ), D = m(
      () => t.disabled ? Bs : "text-(--colors-icon-dark-default) dark:text-(--colors-text-white-default)"
    );
    function O() {
      A.value || (E.value = !1);
    }
    const N = m(() => {
      const ee = i.value ? " cursor-pointer" : t.disabled ? " cursor-not-allowed" : "";
      return r.value ? `flex w-full flex-wrap items-center gap-3${ee}` : `flex w-full flex-wrap items-start ${t.type === "card" && t.icon && c.value ? "gap-3" : "gap-2"}${ee}`;
    }), V = m(() => r.value || !t.icon || c.value ? "none" : ho(t.icon) ? "icon" : "emoji"), M = m(
      () => ({ none: "", icon: "pt-1.5", emoji: "pt-1" })[V.value]
    ), Q = m(
      () => t.type === "card-cta" && !!t.ctaLabel && !t.readonly
    ), q = m(() => Q.value && !!t.ctaSecondaryLabel), K = m(
      () => `relative flex flex-col gap-4 ${r.value ? "justify-center" : "min-w-60"} ${hm} ${cu} ${fu}`
    ), G = () => l("default");
    function te() {
      return t.type !== "card" ? hu : G() ? bu : t.icon && c.value ? hu : bu;
    }
    function ve() {
      const ee = `${bm} ${gm} ${mm}`;
      return t.readonly ? `${K.value} ${ee}` : t.disabled ? `${K.value} ${xm} ${pm} cursor-not-allowed` : o.value ? `${K.value} ${Sm} ${te()} cursor-pointer ${Xo}` : `${K.value} ${ee} ${vm} cursor-pointer ${Xo} ${$m}`;
    }
    const Se = m(() => km(t.disabled)), oe = () => t.type === "card-cta" || t.type === "card" && G() ? QC : zi, re = m(() => [ym, wm(t.disabled)]);
    function ge() {
      i.value && (n("update:modelValue", t.value), S());
    }
    const de = `${yn},a,button,input,select,textarea,[aria-disabled="true"]`;
    function Ee(ee) {
      var se, X;
      if ((se = I.value) != null && se.contains(ee)) return !0;
      const ue = ee.closest(de);
      return !!ue && ue !== $.value && !!((X = y.value) != null && X.contains(ue));
    }
    function j(ee) {
      !i.value || !(ee.target instanceof Element) || Ee(ee.target) || ee.preventDefault();
    }
    function J(ee) {
      var se, X, ae;
      if (!i.value || !(ee.target instanceof Element)) return;
      const ue = ee.target;
      (se = k.value) != null && se.contains(ue) || Ee(ue) || ((X = $.value) == null || X.focus({ preventScroll: !0 }), (ae = $.value) == null || ae.click());
    }
    function ne(ee) {
      var ue, se;
      ee.key !== "Escape" || !t.labelTooltip || ((ue = T.value) != null && ue.isVisible && (ee.stopPropagation(), ee.preventDefault()), E.value = !0, (se = T.value) == null || se.hide());
    }
    function Y() {
      t.disabled || n("cta");
    }
    function F() {
      t.disabled || n("cta-secondary");
    }
    return (ee, ue) => (u(), b("div", {
      id: e.readonly ? e.id : void 0,
      ref_key: "cardRef",
      ref: y,
      "data-testid": "radio-form",
      role: e.readonly ? "group" : void 0,
      "aria-label": e.readonly ? e.ariaLabel ?? e.label : void 0,
      "data-name": e.name,
      class: C(ve()),
      onMousedown: j,
      onClick: J,
      onKeydown: ne,
      onFocusin: _,
      onFocusout: Z,
      onMouseleave: O
    }, [
      e.labelTooltip ? (u(), b("span", {
        key: 0,
        id: L(f),
        class: "sr-only"
      }, H(e.labelTooltip), 9, eS)) : w("", !0),
      (u(), P(gt(e.readonly ? "div" : "label"), {
        ref_key: "labelRef",
        ref: k,
        "data-testid": "radio-form-label",
        class: C(N.value)
      }, {
        default: me(() => [
          e.readonly ? w("", !0) : (u(), b("input", {
            key: 0,
            id: e.id,
            ref_key: "inputRef",
            ref: $,
            type: "radio",
            class: "sr-only",
            name: e.name,
            value: String(e.value),
            checked: o.value,
            disabled: e.disabled,
            "aria-label": e.ariaLabel,
            "aria-labelledby": e.ariaLabel ? void 0 : L(s),
            "aria-describedby": p.value,
            "data-selectable-card-input": "",
            onChange: ge
          }, null, 40, tS)),
          e.icon ? (u(), b(ie, { key: 1 }, [
            L(ho)(e.icon) ? (u(), P(aa, {
              key: 0,
              as: "span",
              size: "md",
              type: "square",
              variant: "outlined",
              color: e.disabled ? "disabled" : "white",
              icon: e.icon
            }, null, 8, ["color", "icon"])) : (u(), b("span", {
              key: 1,
              class: C(["text-num-32 leading-none shrink-0", e.disabled ? "opacity-50" : ""]),
              "aria-hidden": "true"
            }, H(e.icon), 3))
          ], 64)) : w("", !0),
          r.value ? (u(), b("span", {
            key: 2,
            id: L(s),
            class: C(["min-w-0 flex-1", L(zi), le.value, Se.value])
          }, [
            st(H(e.label) + " ", 1),
            e.labelTooltip ? (u(), P($t, {
              key: 0,
              ref_key: "tooltipRef",
              ref: T,
              as: "span",
              text: e.labelTooltip,
              open: z.value,
              class: "shrink-0"
            }, {
              default: me(() => [
                x("i", {
                  class: C(["ri-information-line cursor-help text-(length:--size-sm) leading-none", D.value]),
                  "aria-hidden": "true"
                }, null, 2)
              ]),
              _: 1
            }, 8, ["text", "open"])) : w("", !0)
          ], 10, aS)) : (u(), b("span", {
            key: 3,
            class: C(["flex min-w-0 flex-1 flex-col gap-1", M.value])
          }, [
            x("span", {
              "data-testid": "radio-form-title-row",
              class: C(["flex flex-wrap items-start justify-between gap-1", c.value ? "" : "min-h-6"])
            }, [
              x("span", {
                id: L(s),
                "data-testid": "radio-form-title",
                class: C(["min-w-0 grow", oe(), le.value, Se.value])
              }, [
                st(H(e.label) + " ", 1),
                e.labelTooltip ? (u(), P($t, {
                  key: 0,
                  ref_key: "tooltipRef",
                  ref: T,
                  as: "span",
                  text: e.labelTooltip,
                  open: z.value,
                  class: "shrink-0"
                }, {
                  default: me(() => [
                    x("i", {
                      class: C(["ri-information-line cursor-help text-(length:--size-sm) leading-none", D.value]),
                      "aria-hidden": "true"
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["text", "open"])) : w("", !0)
              ], 10, nS),
              e.badges && e.badges.length > 0 ? (u(), b("span", lS, [
                (u(!0), b(ie, null, Oe(e.badges, (se, X) => (u(), P(yt, Ve({ key: X }, { ref_for: !0 }, se, {
                  theme: L(Cm)(se, e.disabled),
                  "show-close-icon": !1,
                  "truncation-focusable": !1
                }), null, 16, ["theme"]))), 128))
              ])) : w("", !0)
            ], 2),
            c.value ? (u(), b("span", {
              key: 0,
              id: L(d),
              class: C(re.value)
            }, H(e.helper), 11, oS)) : w("", !0)
          ], 2)),
          e.readonly ? w("", !0) : (u(), b("span", {
            key: 4,
            "data-testid": "radio-form-indicator",
            class: C(["pointer-events-none w-4 shrink-0", [M.value, e.indicatorPosition === "left" ? "order-first" : void 0]]),
            "aria-hidden": "true"
          }, [
            x("span", {
              "data-testid": "radio-form-indicator-line",
              class: C(r.value || c.value ? "block" : "block py-1")
            }, [
              U(KC, {
                "model-value": e.modelValue,
                value: e.value,
                disabled: e.disabled,
                presentational: ""
              }, null, 8, ["model-value", "value", "disabled"])
            ], 2)
          ], 2))
        ]),
        _: 1
      }, 8, ["class"])),
      G() ? (u(), b("div", {
        key: 1,
        id: L(g),
        ref_key: "bodyRef",
        ref: h,
        "data-testid": "radio-form-body",
        class: "flex w-full flex-col gap-3"
      }, [
        Me(ee.$slots, "default")
      ], 8, rS)) : w("", !0),
      Q.value ? (u(), b("div", {
        key: 2,
        ref_key: "footerRef",
        ref: I,
        "data-testid": "radio-form-footer",
        class: "flex items-center justify-between gap-4"
      }, [
        U(Be, {
          "data-testid": "radio-form-cta",
          variant: "secondary",
          size: "xs",
          "icon-left": e.ctaIcon,
          label: e.ctaLabel,
          disabled: e.disabled,
          onClick: Y
        }, null, 8, ["icon-left", "label", "disabled"]),
        q.value ? (u(), P(Be, {
          key: 0,
          "data-testid": "radio-form-cta-secondary",
          variant: "secondary",
          size: "xs",
          label: e.ctaSecondaryLabel,
          disabled: e.disabled,
          onClick: F
        }, null, 8, ["label", "disabled"])) : w("", !0)
      ], 512)) : w("", !0)
    ], 42, _C));
  }
}), iS = ["aria-labelledby"], sS = ["id"], ZU = /* @__PURE__ */ ke({
  __name: "RadioFormGroup",
  props: {
    legend: {}
  },
  setup(e) {
    const a = Ye();
    return (t, n) => (u(), b("div", {
      role: "radiogroup",
      "aria-labelledby": e.legend && !t.$attrs["aria-label"] ? L(a) : void 0
    }, [
      e.legend ? (u(), b("div", {
        key: 0,
        id: L(a),
        "data-testid": "radio-form-group-legend",
        class: C(L(Jg))
      }, H(e.legend), 11, sS)) : w("", !0),
      Me(t.$slots, "default")
    ], 8, iS));
  }
}), dS = ["aria-labelledby"], uS = {
  key: 0,
  "data-testid": "checkbox-group-required",
  class: "whitespace-pre"
}, cS = {
  "data-testid": "checkbox-group-items",
  class: "flex flex-wrap items-start gap-2 *:w-auto"
}, QU = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "CheckboxGroup",
  props: {
    legend: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    error: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 }
  },
  setup(e) {
    const a = e, t = rn(), n = Na(), l = Ye(), o = `${l}-error`, r = `${l}-legend`, i = m(
      () => a.ariaLabelledby ?? (a.labelTooltip && (a.legend || n.legend) ? r : void 0)
    ), s = m(() => {
      const d = [t["aria-describedby"], a.error ? o : void 0].filter(Boolean);
      return d.length > 0 ? d.join(" ") : void 0;
    });
    return wa(
      vc,
      m(() => a.error ? o : void 0)
    ), (d, c) => (u(), b("fieldset", Ve({ ...L(t), "aria-describedby": s.value }, {
      "aria-labelledby": i.value,
      class: "m-0 min-w-0 border-0 p-0"
    }), [
      e.legend || L(n).legend ? (u(), b("legend", {
        key: 0,
        "data-testid": "checkbox-group-legend",
        class: C([L(Jg), "p-0", e.labelTooltip ? "flex items-center gap-1" : ""])
      }, [
        x("span", { id: r }, [
          Me(d.$slots, "legend", {}, () => [
            st(H(e.legend), 1)
          ]),
          e.required ? (u(), b("span", uS, H(` ${e.requiredIndicator}`), 1)) : w("", !0)
        ]),
        e.labelTooltip ? (u(), P(om, {
          key: 0,
          text: e.labelTooltip
        }, null, 8, ["text"])) : w("", !0)
      ], 2)) : w("", !0),
      x("div", cS, [
        Me(d.$slots, "default")
      ]),
      e.error ? (u(), b("div", {
        key: 1,
        id: o,
        "data-testid": "checkbox-group-error",
        role: "alert",
        class: C(["mt-2", L(Xg)])
      }, [
        x("i", {
          class: C(L(Zg)),
          "aria-hidden": "true"
        }, null, 2),
        x("span", null, H(e.error), 1)
      ], 2)) : w("", !0)
    ], 16, dS));
  }
}), fS = ["id", "role", "aria-label", "data-name"], hS = ["id", "name", "checked", "disabled", "aria-label", "aria-labelledby", "aria-describedby"], bS = ["id"], gS = {
  key: 2,
  class: "flex min-w-0 flex-1 flex-col gap-2"
}, mS = ["src"], vS = { class: "flex w-full flex-col gap-1" }, pS = ["id"], xS = ["id"], yS = ["id"], kS = {
  key: 0,
  class: "flex min-w-0 flex-wrap items-center gap-3"
}, wS = {
  key: 1,
  class: "flex flex-wrap items-center gap-3"
}, CS = ["id"], SS = ["id"], _U = /* @__PURE__ */ ke({
  __name: "CheckboxForm",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    helper: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "card" },
    ariaLabel: { default: void 0 },
    align: { default: void 0 },
    badgesAlign: { default: void 0 },
    badges: { default: void 0 },
    icons: { default: void 0 },
    avatar: { default: void 0 },
    imageSrc: { default: void 0 },
    icon: { default: void 0 },
    subtitle: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = Ia(), o = m(() => !t.readonly && !t.disabled), r = m(() => t.type === "inline"), i = Ye(), s = Ye(), d = Ye(), c = m(() => t.type === "simple" && !t.icon), f = m(() => !!t.helper && !c.value), g = m(() => !!t.subtitle && t.type === "card"), h = m(() => t.type === "card" ? t.avatar : void 0), v = m(() => t.type === "card" ? t.icon : void 0), p = () => !c.value && t.type !== "big-card" && l("trailing"), y = m(() => !!t.icon && (t.type === "simple" || t.type === "card")), k = Yg(() => [
      g.value ? d : void 0,
      f.value ? s : void 0
    ]);
    ak();
    const $ = R(null), { resync: S } = As($, () => t.modelValue), I = R(null), T = m(() => (t.align ?? (t.avatar ? "center" : void 0) ?? (t.type === "simple" && t.icon ? "center" : void 0) ?? "top") === "center" ? "items-center" : "items-start"), A = m(
      () => t.badgesAlign ?? (t.avatar || g.value ? "title" : "end")
    ), E = m(() => r.value ? "flex flex-wrap items-start gap-1" : A.value === "title" ? "flex flex-wrap items-center gap-3" : "flex flex-wrap items-start justify-between gap-1"), z = `group relative flex flex-wrap gap-2 p-px min-w-60 ${fu}`, B = `relative flex flex-wrap ${hm} ${cu} ${fu}`, W = `relative flex items-center justify-center ${fm} px-[calc(--spacing(3)-1px)] py-[calc(--spacing(2)-1px)] ${cu}`, _ = m(() => {
      const re = t.type === "simple" ? "gap-3" : "gap-2";
      return `flex ${T.value} min-w-0 flex-1 ${re}`;
    });
    function Z() {
      if (r.value)
        return t.readonly ? z : t.disabled ? `${z} cursor-not-allowed` : `${z} cursor-pointer ${Xo}`;
      const re = t.type === "big-card" ? "min-w-46" : "min-w-60", ge = c.value ? W : `${B} ${re} ${h.value ? "gap-2" : "gap-1"}`, Ee = `${p() || g.value ? "" : `${bm} `}${gm} ${mm}`;
      if (t.readonly) return `${ge} ${Ee}`;
      if (t.disabled)
        return `${ge} ${xm} ${pm} cursor-not-allowed`;
      if (t.modelValue) {
        const j = y.value ? bu : hu;
        return `${ge} ${Sm} ${j} cursor-pointer ${Xo}`;
      }
      return `${ge} ${Ee} ${vm} cursor-pointer ${Xo} ${$m}`;
    }
    const le = m(() => km(t.disabled)), D = m(
      () => t.type === "inline" && o.value ? "group-hover:text-(--text-text-hover)" : ""
    ), O = m(() => t.type === "advanced" && t.modelValue), N = m(() => {
      if (c.value) return `${zi} text-center ${le.value}`;
      if (t.type === "simple" || v.value) return `min-w-0 flex-1 ${zi} ${le.value}`;
      const re = t.type === "big-card" ? ZC : XC, ge = r.value ? "min-w-0 flex-1" : "min-w-0", de = O.value ? " line-through" : "";
      return `${ge} ${re} ${le.value} ${D.value}${de}`;
    }), V = m(
      () => t.disabled ? Bs : "text-(--text-text-black-default) dark:text-(--colors-text-white-secondary)"
    ), M = m(() => {
      if (g.value || h.value)
        return `${YC} ${V.value}`;
      const re = wm(t.disabled), ge = O.value ? " line-through" : "";
      return `${ym} ${re} ${D.value}${ge}`;
    }), Q = m(() => `${JC} ${V.value}`), q = m(() => `flex min-w-0 flex-1 flex-col ${h.value ? "gap-1" : "gap-3"}`), K = m(() => `flex flex-wrap items-center ${h.value ? "gap-3" : "gap-4"}`), G = m(() => g.value ? "flex flex-col gap-px" : t.avatar || t.type === "simple" || v.value ? "flex flex-col gap-1" : "flex flex-col gap-0.5"), te = m(() => {
      const re = o.value ? " cursor-pointer" : t.disabled ? " cursor-not-allowed" : "";
      return `flex min-w-0 flex-1${c.value ? " justify-center" : ""}${re}`;
    });
    function ve(re) {
      const ge = re.target;
      n("update:modelValue", ge.checked), S();
    }
    function Se(re) {
      var Ee;
      const ge = re.currentTarget;
      if (!o.value || !(re.target instanceof Element) || (Ee = I.value) != null && Ee.contains(re.target)) return;
      const de = re.target.closest(yn);
      de && de !== $.value && ge.contains(de) || re.preventDefault();
    }
    function oe(re) {
      var ge, de;
      !o.value || re.target !== re.currentTarget || ((ge = $.value) == null || ge.focus({ preventScroll: !0 }), (de = $.value) == null || de.click());
    }
    return (re, ge) => (u(), b("div", {
      id: e.readonly ? e.id : void 0,
      "data-testid": "checkbox-form",
      role: e.readonly ? "group" : void 0,
      "aria-label": e.readonly ? e.ariaLabel ?? e.label : void 0,
      "data-name": e.name,
      class: C(Z()),
      onMousedown: Se,
      onClick: oe
    }, [
      (u(), P(gt(e.readonly ? "div" : "label"), {
        "data-testid": "checkbox-form-label",
        class: C(te.value)
      }, {
        default: me(() => [
          e.readonly ? w("", !0) : (u(), b("input", {
            key: 0,
            id: e.id,
            ref_key: "inputRef",
            ref: $,
            type: "checkbox",
            class: "sr-only",
            name: e.name,
            checked: e.modelValue,
            disabled: e.disabled,
            "aria-label": e.ariaLabel,
            "aria-labelledby": e.ariaLabel ? void 0 : L(i),
            "aria-describedby": L(k),
            "data-selectable-card-input": "",
            onChange: ve
          }, null, 40, hS)),
          c.value ? (u(), b("span", {
            key: 1,
            id: L(i),
            class: C(N.value)
          }, H(e.label), 11, bS)) : e.type === "big-card" ? (u(), b("span", gS, [
            e.imageSrc ? (u(), b("img", {
              key: 0,
              src: e.imageSrc,
              alt: "",
              class: "size-8 shrink-0 object-contain"
            }, null, 8, mS)) : w("", !0),
            x("span", vS, [
              x("span", {
                id: L(i),
                class: C(N.value)
              }, H(e.label), 11, pS),
              f.value ? (u(), b("span", {
                key: 0,
                id: L(s),
                class: C(M.value)
              }, H(e.helper), 11, xS)) : w("", !0)
            ])
          ])) : (u(), b("span", {
            key: 3,
            "data-testid": "checkbox-form-content-group",
            class: C(_.value)
          }, [
            !e.readonly && e.type !== "simple" ? (u(), b("span", {
              key: 0,
              "data-testid": "checkbox-form-indicator",
              class: C(["pointer-events-none w-4 shrink-0 py-1", v.value ? "me-1" : ""]),
              "aria-hidden": "true"
            }, [
              U(va, {
                "model-value": e.modelValue,
                disabled: e.disabled,
                presentational: ""
              }, null, 8, ["model-value", "disabled"])
            ], 2)) : w("", !0),
            y.value && e.icon ? (u(), b(ie, { key: 1 }, [
              L(ho)(e.icon) ? (u(), P(aa, {
                key: 0,
                as: "span",
                size: "md",
                type: "square",
                variant: "outlined",
                color: e.disabled ? "disabled" : e.type === "card" ? "default" : "white",
                icon: e.icon
              }, null, 8, ["color", "icon"])) : (u(), b("span", {
                key: 1,
                class: C([
                  "text-num-32 leading-none shrink-0",
                  e.disabled ? "opacity-50" : "",
                  e.type === "card" ? "me-1" : ""
                ]),
                "aria-hidden": "true"
              }, H(e.icon), 3))
            ], 64)) : w("", !0),
            h.value ? (u(), P(Jt, {
              key: 2,
              img: h.value.img,
              name: h.value.name,
              as: "span",
              size: "md",
              presentational: ""
            }, null, 8, ["img", "name"])) : w("", !0),
            x("span", {
              class: C(q.value)
            }, [
              x("span", {
                class: C(G.value)
              }, [
                x("span", {
                  "data-testid": "checkbox-form-title-row",
                  class: C(E.value)
                }, [
                  x("span", {
                    id: L(i),
                    class: C(N.value)
                  }, H(e.label), 11, yS),
                  e.badges && e.badges.length > 0 || e.icons && e.icons.length > 0 ? (u(), b("span", kS, [
                    e.badges && e.badges.length > 0 ? (u(), b("span", {
                      key: 0,
                      class: C(["flex flex-wrap items-center", A.value === "title" ? "gap-3" : "gap-1"])
                    }, [
                      (u(!0), b(ie, null, Oe(e.badges, (de, Ee) => (u(), P(yt, Ve({ key: Ee }, { ref_for: !0 }, de, {
                        theme: L(Cm)(de, e.disabled),
                        "show-close-icon": !1,
                        "truncation-focusable": !1
                      }), null, 16, ["theme"]))), 128))
                    ], 2)) : w("", !0),
                    e.icons && e.icons.length > 0 ? (u(), b("span", wS, [
                      (u(!0), b(ie, null, Oe(e.icons, (de, Ee) => (u(), b("i", {
                        key: Ee,
                        class: C([`ri-${de}`, "text-(length:--size-4xl) leading-none"]),
                        "aria-hidden": "true"
                      }, null, 2))), 128))
                    ])) : w("", !0)
                  ])) : w("", !0)
                ], 2),
                g.value ? (u(), b("span", {
                  key: 0,
                  id: L(d),
                  "data-testid": "checkbox-form-subtitle",
                  class: C(Q.value)
                }, H(e.subtitle), 11, CS)) : w("", !0),
                f.value ? (u(), b("span", {
                  key: 1,
                  id: L(s),
                  class: C(M.value)
                }, H(e.helper), 11, SS)) : w("", !0)
              ], 2),
              (e.type === "advanced" || e.type === "card") && L(l)("details") ? (u(), b("span", {
                key: 0,
                "data-testid": "checkbox-form-details",
                class: C(K.value)
              }, [
                Me(re.$slots, "details")
              ], 2)) : w("", !0)
            ], 2)
          ], 2))
        ]),
        _: 3
      }, 8, ["class"])),
      p() ? (u(), b("div", {
        key: 0,
        ref_key: "trailingRef",
        ref: I,
        "data-testid": "checkbox-form-trailing",
        class: "flex shrink-0 items-start justify-end"
      }, [
        Me(re.$slots, "trailing")
      ], 512)) : w("", !0)
    ], 42, fS));
  }
}), $S = { class: "w-full flex flex-col gap-2" }, IS = {
  key: 0,
  class: "text-sm font-medium text-text-black-default dark:text-(--colors-text-white-default)"
}, LS = { class: "flex flex-col items-center gap-2" }, TS = ["src"], ES = { class: "relative text-sm leading-5 dark:text-(--colors-text-white-default)" }, AS = {
  key: 1,
  class: "flex flex-col items-center gap-5"
}, RS = { class: "flex-1 flex flex-col items-center gap-1.5" }, zS = { class: "flex-1 flex flex-col items-center gap-1.5" }, DS = { class: "flex-1 flex flex-col items-center gap-1.5" }, BS = ["id", "name", "accept", "disabled"], MS = {
  key: 1,
  class: "text-sm text-red-600 dark:text-red-400"
}, OS = /* @__PURE__ */ ke({
  __name: "ImageInput",
  props: {
    variant: { default: "default" },
    uploadText: { default: "Click to upload or drag and drop" },
    maxFileSizeText: { default: "Max. File Size: 30MB" },
    browseButtonText: { default: "Browse file" },
    uploadIcon: { default: void 0 },
    browseButtonIcon: { default: void 0 },
    dragDropText: { default: "Drag and drop a file here, or:" },
    browseLabel: { default: "Browse" },
    browseIcon: { default: void 0 },
    libraryLabel: { default: "Library" },
    libraryIcon: { default: void 0 },
    linkLabel: { default: "Link" },
    linkIcon: { default: void 0 },
    accept: { default: "image/*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    size: { default: "md" },
    success: { type: Boolean, default: !1 },
    error: { type: [String, Boolean], default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    modelValue: { default: null }
  },
  emits: ["update:modelValue", "change", "error", "browse", "library", "link"],
  setup(e, { emit: a }) {
    const t = e, n = m(() => !!t.error), l = m(() => typeof t.error == "string" ? t.error : void 0), o = a, r = R(null), i = R(!1), s = R(!1), d = Ye(), c = `${d}-browse`, f = `${d}-library`, g = `${d}-link`, v = {
      sm: {
        container: "h-[180px]",
        text: "text-xs",
        icon: "w-5 h-5",
        gap: "gap-3"
      },
      md: {
        container: "h-[228px]",
        text: "text-sm",
        icon: "w-6 h-6",
        gap: "gap-4"
      },
      lg: {
        container: "h-[280px]",
        text: "text-base",
        icon: "w-7 h-7",
        gap: "gap-5"
      },
      xl: {
        container: "h-[320px]",
        text: "text-lg",
        icon: "w-8 h-8",
        gap: "gap-6"
      }
    }[t.size], p = m(() => {
      const D = t.variant === "buttons" ? "border-border-base" : "border-border-primary-button", O = `w-full relative rounded-xl border-dashed border-[1px] box-border flex flex-col items-center justify-center text-center text-sm font-inter transition-[border-color,background-color,box-shadow,color] duration-200 ${v.container}`;
      return t.disabled ? `${O} bg-background-disabled-subtle dark:bg-(--colors-background-disabled) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled) cursor-not-allowed` : n.value ? `${O} bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] text-[#B42318] dark:text-[#B42318] cursor-pointer` : t.success ? `${O} bg-background-white dark:bg-(--colors-background-black-default) border-[#009966] dark:border-[#009966] text-text-body dark:text-(--colors-text-white-default) cursor-pointer` : i.value ? `${O} shadow-[0px_0px_2px_#7c86ff] bg-background-hover dark:bg-[rgba(255,255,255,0.05)] border-[#7c86ff] dark:border-[#7c86ff] text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer` : s.value ? `${O} shadow-[0px_0px_2px_#7c86ff] bg-background-hover dark:bg-[rgba(255,255,255,0.05)] border-[#7c86ff] dark:border-[#7c86ff] text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer` : `${O} bg-background-white dark:bg-(--colors-background-black-default) ${D} dark:border-(--colors-border-base) text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer`;
    }), y = (D) => {
      if (!D || D.length === 0 || t.disabled) return;
      const O = Array.from(D);
      if (O.filter((Q) => Q.size > t.maxFileSize).length > 0) {
        o("error", `File size exceeds the maximum allowed size of ${t.maxFileSizeText}`);
        return;
      }
      const V = O.length === 1 ? O[0] : O;
      o("update:modelValue", V);
      const M = new Event("change", { bubbles: !0 });
      o("change", M);
    }, k = () => {
      var D;
      t.disabled || (D = r.value) == null || D.click();
    }, $ = (D) => {
      var O;
      t.disabled || (o("browse", D), (O = r.value) == null || O.click());
    }, S = (D) => {
      t.disabled || o("library", D);
    }, I = (D) => {
      t.disabled || o("link", D);
    }, T = (D) => {
      const O = D.target;
      y(O.files);
    }, A = (D) => {
      D.preventDefault(), D.stopPropagation(), t.disabled || (i.value = !0);
    }, E = (D) => {
      D.preventDefault(), D.stopPropagation(), i.value = !1;
    }, z = (D) => {
      var N;
      if (D.preventDefault(), D.stopPropagation(), i.value = !1, t.disabled) return;
      const O = (N = D.dataTransfer) == null ? void 0 : N.files;
      O && y(O);
    }, B = () => {
      var D;
      t.disabled || (D = r.value) == null || D.click();
    }, W = (D, O) => {
      try {
        if (D.startsWith("data:image/svg+xml")) {
          const N = D.split(",")[1];
          if (!N) return D;
          const M = decodeURIComponent(N).replace(/fill=["']currentColor["']/gi, `fill="${O}"`).replace(/fill=["']#[0-9A-Fa-f]{6}["']/gi, `fill="${O}"`);
          return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(M)}`;
        }
        return D.replace(/color=%[0-9A-Fa-f]{6}/, `color=%23${O.slice(1)}`);
      } catch {
        return D;
      }
    }, _ = m(() => {
      if (t.browseIcon)
        return t.success && t.variant === "buttons" ? W(t.browseIcon, "#007A55") : t.browseIcon;
    }), Z = m(() => {
      if (t.libraryIcon)
        return t.success && t.variant === "buttons" ? W(t.libraryIcon, "#007A55") : t.libraryIcon;
    }), le = m(() => {
      if (t.linkIcon)
        return t.success && t.variant === "buttons" ? W(t.linkIcon, "#007A55") : t.linkIcon;
    });
    return (D, O) => (u(), b("div", $S, [
      e.label ? (u(), b("div", IS, H(e.label), 1)) : w("", !0),
      x("div", {
        class: C(p.value),
        onDragover: A,
        onDragleave: E,
        onDrop: z,
        onClick: O[0] || (O[0] = (N) => e.variant === "default" ? B() : void 0),
        onMouseenter: O[1] || (O[1] = (N) => s.value = !0),
        onMouseleave: O[2] || (O[2] = (N) => s.value = !1)
      }, [
        e.variant === "default" ? (u(), b("div", {
          key: 0,
          class: C(["flex flex-col items-center", L(v).gap])
        }, [
          x("div", LS, [
            e.uploadIcon ? (u(), b("img", {
              key: 0,
              src: e.uploadIcon,
              class: C([L(v).icon, "relative", "image-input-icon"]),
              alt: ""
            }, null, 10, TS)) : w("", !0),
            x("div", ES, H(e.uploadText), 1),
            x("div", {
              class: C([
                "relative text-xs! leading-4 font-medium",
                e.success ? "text-[#007A55] dark:text-[#007A55]" : !e.disabled && !e.error ? "text-text-body dark:text-(--colors-text-white-default)" : "dark:text-(--colors-text-disabled)"
              ])
            }, H(e.maxFileSizeText), 3)
          ]),
          U(L(Be), {
            variant: "primary",
            label: e.browseButtonText,
            "icon-left": e.browseButtonIcon,
            size: "xs",
            disabled: e.disabled,
            type: "button",
            onClick: _e(k, ["stop"])
          }, null, 8, ["label", "icon-left", "disabled"])
        ], 2)) : (u(), b("div", AS, [
          x("div", {
            class: C([
              "relative leading-5 text-sm!",
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : n.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-text-body dark:text-(--colors-text-white-default)" : "text-text-black-default dark:text-(--colors-text-white-default)"
            ])
          }, H(e.dragDropText), 3),
          x("div", {
            class: C([
              "self-stretch flex items-start gap-6 text-xs!",
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : "text-text-body dark:text-(--colors-text-white-default)"
            ])
          }, [
            x("div", RS, [
              x("div", {
                class: C([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : n.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                _.value ? (u(), P(L(Be), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": _.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  "aria-labelledby": c,
                  onClick: _e($, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : w("", !0)
              ], 2),
              x("div", {
                id: c,
                class: C([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : n.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, H(e.browseLabel), 3)
            ]),
            x("div", zS, [
              x("div", {
                class: C([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : n.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                Z.value ? (u(), P(L(Be), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": Z.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  "aria-labelledby": f,
                  onClick: _e(S, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : w("", !0)
              ], 2),
              x("div", {
                id: f,
                class: C([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : n.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, H(e.libraryLabel), 3)
            ]),
            x("div", DS, [
              x("div", {
                class: C([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : n.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                le.value ? (u(), P(L(Be), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": le.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  "aria-labelledby": g,
                  onClick: _e(I, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : w("", !0)
              ], 2),
              x("div", {
                id: g,
                class: C([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : n.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, H(e.linkLabel), 3)
            ])
          ], 2)
        ])),
        x("input", {
          id: e.id,
          ref_key: "fileInputRef",
          ref: r,
          "data-testid": "image-input",
          name: e.name,
          type: "file",
          accept: e.accept,
          disabled: e.disabled,
          class: "sr-only",
          onChange: T
        }, null, 40, BS)
      ], 34),
      l.value ? (u(), b("div", MS, H(l.value), 1)) : w("", !0)
    ]));
  }
}), eG = /* @__PURE__ */ Ct(OS, [["__scopeId", "data-v-5b729c92"]]), PS = { class: "w-full flex flex-col gap-2" }, FS = {
  key: 1,
  class: "flex flex-col gap-0.5"
}, NS = { class: "relative" }, VS = ["id", "name", "accept", "disabled", "multiple", "aria-describedby", "aria-invalid"], HS = ["disabled"], jS = ["aria-label"], WS = {
  key: 2,
  class: "w-full flex flex-col gap-4"
}, qS = { class: "flex flex-col gap-0.5" }, US = { class: "flex flex-col items-center gap-2" }, GS = { class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--text-text-white-default) text-center" }, KS = { class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body) dark:text-(--text-text-white-default) text-center whitespace-pre-line" }, YS = ["id", "name", "accept", "disabled", "multiple", "aria-describedby", "aria-invalid"], JS = {
  key: 0,
  class: "flex flex-col gap-3"
}, XS = { class: "flex flex-1 items-center gap-2.5 min-w-0" }, ZS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  class: "shrink-0"
}, QS = ["id"], _S = ["stroke", "stroke-dashoffset"], e$ = { class: "flex flex-col min-w-0" }, t$ = { class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" }, a$ = { class: "flex gap-2 text-(length:--size-sm)" }, n$ = { class: "font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, l$ = { class: "flex items-center gap-1 shrink-0" }, o$ = {
  key: 1,
  class: "h-9 w-9 flex items-center justify-center shrink-0"
}, r$ = {
  key: 2,
  class: "h-9 w-9 flex items-center justify-center shrink-0"
}, i$ = {
  key: 3,
  class: "flex flex-col gap-0.5"
}, s$ = { class: "flex flex-col items-center gap-2" }, d$ = ["src"], u$ = { class: "flex flex-col items-center gap-2" }, c$ = ["src"], f$ = {
  key: 1,
  class: "flex flex-col items-center gap-5"
}, h$ = { class: "flex-1 flex flex-col items-center gap-1.5" }, b$ = { class: "flex-1 flex flex-col items-center gap-1.5" }, g$ = { class: "flex-1 flex flex-col items-center gap-1.5" }, m$ = ["id", "name", "accept", "disabled", "multiple", "aria-describedby", "aria-invalid"], v$ = {
  key: 4,
  class: "mt-3 space-y-1"
}, p$ = { class: "flex-shrink-0" }, x$ = {
  key: 0,
  class: "w-5 h-5 text-(--text-text-success-strong)",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, y$ = {
  key: 1,
  class: "w-5 h-5 text-(--text-text-error-strong)",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, k$ = { class: "flex-1 min-w-0" }, w$ = { key: 0 }, C$ = ["disabled", "onClick"], ud = 10.2, nh = 3.6, S$ = /* @__PURE__ */ ke({
  __name: "FileUploadInput",
  props: {
    variant: { default: "default" },
    uploadText: { default: "Click to upload or drag and drop" },
    maxFileSizeText: { default: "Max. File Size: 30MB" },
    hint: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    fileTypeErrorText: { default: void 0 },
    fileSizeErrorText: { default: void 0 },
    browseButtonText: { default: "Select file" },
    placeholder: { default: "Placeholder text" },
    uploadIcon: { default: void 0 },
    browseButtonIcon: { default: void 0 },
    dragDropText: { default: "Drag and drop a file here, or:" },
    browseLabel: { default: "Browse" },
    browseIcon: { default: void 0 },
    libraryLabel: { default: "Library" },
    libraryIcon: { default: void 0 },
    linkLabel: { default: "Link" },
    linkIcon: { default: void 0 },
    accept: { default: "*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    size: { default: "md" },
    success: { type: Boolean, default: !1 },
    error: { type: [String, Boolean], default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    modelValue: { default: null },
    uploadedFile: { default: null },
    uploadedFiles: { default: () => [] },
    multiple: { type: Boolean, default: !1 },
    addFilesText: { default: "Add file(s)" },
    addMoreText: { default: "Add more" },
    addMoreIcon: { default: void 0 },
    progressFiles: { default: () => [] },
    pauseLabel: { default: "Pause" },
    resumeLabel: { default: "Resume" },
    removeLabel: { default: "Remove file" },
    clearFileLabel: { default: "Clear file" },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "error", "browse", "library", "link", "addMore", "fileClick", "removeFile", "pauseFile", "resumeFile", "removeProgressFile", "clear"],
  setup(e, { emit: a }) {
    const t = e, n = m(() => !!t.error), l = m(() => typeof t.error == "string" ? t.error : void 0), o = Ye(), r = `${o}-browse`, i = `${o}-library`, s = `${o}-link`, d = m(() => !!t.uploadedFile), c = (se) => se ? se < 1024 ? `${se}B` : se < 1024 * 1024 ? `${(se / 1024).toFixed(0)}Ko` : `${(se / (1024 * 1024)).toFixed(1)}Mo` : "", f = m(() => {
      if (!t.uploadedFile) return "";
      const se = t.uploadedFile.name, X = t.uploadedFile.size ? ` (${c(t.uploadedFile.size)})` : "";
      return `${se}${X}`;
    }), g = a;
    function h() {
      v.value && (v.value.value = ""), g("update:modelValue", null), g("clear");
    }
    const v = R(null), p = Ye(), y = m(() => t.id || p), k = R(!1), $ = R(null), S = R(null), I = m(() => `${y.value}-hint`), T = m(() => `${y.value}-error`), A = m(() => t.hint ? t.hint : (t.variant === "basic" || t.variant === "dropzone") && t.maxFileSizeText || void 0), E = m(() => {
      var se;
      return (se = A.value) != null && se.includes(`
`) ? 2 : 1;
    }), z = m(() => {
      const se = [];
      return A.value && se.push(I.value), l.value && se.push(T.value), se.length > 0 ? se.join(" ") : void 0;
    });
    function B(se) {
      var X, ae;
      (X = $.value) == null || X.handleFieldKeydown(se), (ae = S.value) == null || ae.handleFieldKeydown(se);
    }
    const W = R(!1), _ = R(!1), Z = R(/* @__PURE__ */ new Set());
    function le(se) {
      Z.value.has(se) ? (Z.value.delete(se), g("resumeFile", se)) : (Z.value.add(se), g("pauseFile", se)), Z.value = new Set(Z.value);
    }
    const D = 2 * Math.PI * ud;
    function O(se) {
      return D * (1 - Math.min(Math.max(se, 0), 100) / 100);
    }
    const V = {
      sm: {
        container: "h-[180px]",
        text: "text-xs",
        icon: "w-5 h-5",
        gap: "gap-3"
      },
      md: {
        container: "h-[228px]",
        text: "text-sm",
        icon: "w-6 h-6",
        gap: "gap-4"
      },
      lg: {
        container: "h-[280px]",
        text: "text-base",
        icon: "w-7 h-7",
        gap: "gap-5"
      },
      xl: {
        container: "h-[320px]",
        text: "text-lg",
        icon: "w-8 h-8",
        gap: "gap-6"
      }
    }[t.size], M = m(() => {
      const se = t.variant === "dropzone" ? "border-(--border-border-base)" : "border-(--border-border-primary-button)", X = `w-full relative rounded-xl border-dashed border-[1px] box-border flex flex-col items-center justify-center text-center text-sm font-inter transition-[border-color,background-color,box-shadow,color] duration-200 ${V.container}`;
      return t.disabled ? `${X} bg-(--background-background-disabled-subtle) dark:bg-(--background-background-disabled) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light) cursor-not-allowed` : n.value ? `${X} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : t.success || d.value ? `${X} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-success-strong) dark:border-(--border-border-success-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : W.value ? `${X} shadow-[0px_0px_2px_var(--border-border-hover)] bg-(--background-background-hover) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-hover) dark:border-(--border-border-hover) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : _.value ? `${X} shadow-[0px_0px_2px_var(--border-border-hover)] bg-(--background-background-hover) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-hover) dark:border-(--border-border-hover) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : `${X} bg-(--background-background-white) dark:bg-(--background-background-black-default) ${se} dark:border-(--border-border-base) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer`;
    }), Q = (se, X) => {
      if (!X || X === "*" || X === "*/*") return !0;
      const ae = X.split(",").map((xe) => xe.trim().toLowerCase()).filter((xe) => xe.length > 0);
      if (ae.length === 0) return !0;
      const Re = (se.type || "").toLowerCase(), Ae = (se.name || "").toLowerCase();
      return ae.some((xe) => xe.startsWith(".") ? Ae.endsWith(xe) : xe.endsWith("/*") ? Re.startsWith(xe.slice(0, -1)) : Re === xe);
    }, q = (se) => {
      if (!se || se.length === 0 || t.disabled) return;
      const X = Array.from(se);
      if (X.filter((we) => !Q(we, t.accept)).length > 0) {
        g("error", t.fileTypeErrorText || "File type not supported.");
        return;
      }
      if (X.filter((we) => we.size > t.maxFileSize).length > 0) {
        g(
          "error",
          t.fileSizeErrorText || `File size exceeds the maximum allowed size of ${t.maxFileSizeText}`
        );
        return;
      }
      const Ae = t.multiple ? X : X[0];
      g("update:modelValue", Ae);
      const xe = new Event("change", { bubbles: !0 });
      g("change", xe);
    }, K = () => {
      var se;
      t.disabled || (se = v.value) == null || se.click();
    }, G = (se) => {
      var X;
      t.disabled || (g("browse", se), (X = v.value) == null || X.click());
    }, te = (se) => {
      t.disabled || g("library", se);
    }, ve = (se) => {
      t.disabled || g("link", se);
    }, Se = (se) => {
      var X;
      t.disabled || (g("addMore", se), (X = v.value) == null || X.click());
    }, oe = () => {
      t.uploadedFile && g("fileClick", t.uploadedFile);
    }, re = (se, X) => {
      t.disabled || g("removeFile", se, X);
    }, ge = (se) => {
      const X = se.target;
      q(X.files);
    }, de = (se) => {
      se.preventDefault(), se.stopPropagation(), t.disabled || (W.value = !0);
    }, Ee = (se) => {
      se.preventDefault(), se.stopPropagation(), W.value = !1;
    }, j = (se) => {
      var ae;
      if (se.preventDefault(), se.stopPropagation(), W.value = !1, t.disabled) return;
      const X = (ae = se.dataTransfer) == null ? void 0 : ae.files;
      X && q(X);
    }, J = () => {
      var se;
      t.disabled || d.value || (se = v.value) == null || se.click();
    }, ne = (se, X) => {
      try {
        if (se.startsWith("data:image/svg+xml")) {
          const ae = se.split(",")[1];
          if (!ae) return se;
          const Ae = decodeURIComponent(ae).replace(/fill=["']currentColor["']/gi, `fill="${X}"`).replace(/fill=["']#[0-9A-Fa-f]{6}["']/gi, `fill="${X}"`);
          return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(Ae)}`;
        }
        return se.replace(/color=%[0-9A-Fa-f]{6}/, `color=%23${X.slice(1)}`);
      } catch {
        return se;
      }
    }, Y = {
      // --icons-icon-dark-default
      error: "#b42318",
      // --icons-icon-error
      success: "#007a55",
      // --text-text-success-strong
      disabled: "#99a1af"
      // --icons-icon-disabled-light
    }, F = m(() => {
      if (t.browseIcon)
        return t.disabled && t.variant === "dropzone" ? ne(t.browseIcon, Y.disabled) : n.value && t.variant === "dropzone" ? ne(t.browseIcon, Y.error) : (t.success || d.value) && t.variant === "dropzone" ? ne(t.browseIcon, Y.success) : t.browseIcon;
    }), ee = m(() => {
      if (t.libraryIcon)
        return t.disabled && t.variant === "dropzone" ? ne(t.libraryIcon, Y.disabled) : n.value && t.variant === "dropzone" ? ne(t.libraryIcon, Y.error) : (t.success || d.value) && t.variant === "dropzone" ? ne(t.libraryIcon, Y.success) : t.libraryIcon;
    }), ue = m(() => {
      if (t.linkIcon)
        return t.disabled && t.variant === "dropzone" ? ne(t.linkIcon, Y.disabled) : n.value && t.variant === "dropzone" ? ne(t.linkIcon, Y.error) : (t.success || d.value) && t.variant === "dropzone" ? ne(t.linkIcon, Y.success) : t.linkIcon;
    });
    return (se, X) => (u(), b("div", PS, [
      e.label ? (u(), P(Ft, {
        key: 0,
        ref_key: "labelRef",
        ref: $,
        text: e.label,
        "input-id": y.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: k.value,
        "test-id": "file-upload-label"
      }, null, 8, ["text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : w("", !0),
      e.variant === "basic" ? (u(), b("div", FS, [
        x("div", NS, [
          x("input", {
            id: y.value,
            ref_key: "fileInputRef",
            ref: v,
            "data-testid": "file-upload-input-basic",
            name: e.name,
            type: "file",
            accept: e.accept,
            disabled: e.disabled,
            multiple: e.multiple,
            "aria-describedby": z.value,
            "aria-invalid": n.value ? "true" : void 0,
            class: "absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10",
            onChange: ge,
            onFocus: X[0] || (X[0] = (ae) => k.value = !0),
            onBlur: X[1] || (X[1] = (ae) => k.value = !1),
            onKeydown: B
          }, null, 40, VS),
          x("div", {
            class: C([
              "flex items-center w-full bg-(--background-background-white) dark:bg-(--background-background-black-default) border rounded-lg shadow-xs transition-colors",
              e.disabled ? "border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) cursor-not-allowed" : n.value ? "border-(--border-border-error-strong) dark:border-(--border-border-error-strong) focus-within:ring-4 focus-within:ring-(--border-border-error-medium)" : "border-(--border-border-base-medium) dark:border-(--border-border-base) focus-within:ring-4 focus-within:ring-(--border-border-hover-medium) focus-within:border-(--border-border-hover)"
            ])
          }, [
            x("button", {
              type: "button",
              class: C([
                "flex-shrink-0 px-3 py-2 text-sm font-medium rounded-l-lg border-r transition-colors",
                e.disabled ? "bg-(--background-background-disabled-subtle) dark:bg-(--background-background-disabled) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light) cursor-not-allowed" : n.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:bg-(--background-background-hover) dark:hover:bg-[rgba(255,255,255,0.05)]"
              ]),
              disabled: e.disabled,
              onClick: _e(K, ["stop"])
            }, H(e.browseButtonText), 11, HS),
            x("div", {
              class: C([
                "flex-1 px-3 py-2 text-sm pointer-events-none truncate",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : e.modelValue ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ])
            }, H(e.modelValue ? Array.isArray(e.modelValue) ? `${e.modelValue.length} file(s) selected` : e.modelValue.name : e.placeholder), 3),
            e.modelValue && !e.disabled ? (u(), b("button", {
              key: 0,
              type: "button",
              class: "relative z-20 shrink-0 flex items-center justify-center px-2 self-stretch text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:text-(--text-text-body)",
              "aria-label": e.clearFileLabel,
              onClick: _e(h, ["stop"])
            }, [...X[9] || (X[9] = [
              x("i", {
                class: "ri-close-fill text-base",
                "aria-hidden": "true"
              }, null, -1)
            ])], 8, jS)) : w("", !0)
          ], 2)
        ]),
        U(Pt, {
          ref_key: "helperRef",
          ref: S,
          focused: k.value,
          hint: A.value,
          "hint-lines": E.value,
          disabled: e.disabled,
          error: l.value,
          "hint-id": I.value,
          "error-id": T.value,
          "error-live": e.errorLive,
          "test-id-prefix": "file-upload"
        }, null, 8, ["focused", "hint", "hint-lines", "disabled", "error", "hint-id", "error-id", "error-live"])
      ])) : e.variant === "advanced" ? (u(), b("div", WS, [
        x("div", qS, [
          x("div", {
            class: "w-full rounded-xl border border-dashed border-(--border-border-base-medium) dark:border-(--border-border-base) bg-(--background-background-white-secondary-soft) dark:bg-(--background-background-black-default) flex h-[228px] flex-col items-center justify-center gap-4 px-5",
            onDragover: de,
            onDragleave: Ee,
            onDrop: j
          }, [
            x("div", US, [
              X[10] || (X[10] = x("i", {
                class: "ri-upload-2-line text-(length:--size-xl) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
                "aria-hidden": "true"
              }, null, -1)),
              x("p", GS, H(e.uploadText), 1),
              x("p", KS, H(e.maxFileSizeText), 1)
            ]),
            U(L(Be), {
              variant: "primary",
              label: e.addFilesText,
              "icon-left": "ri-add-line",
              size: "xs",
              disabled: e.disabled,
              type: "button",
              onClick: _e(K, ["stop"])
            }, null, 8, ["label", "disabled"]),
            x("input", {
              id: y.value,
              ref_key: "fileInputRef",
              ref: v,
              "data-testid": "file-upload-input",
              name: e.name,
              type: "file",
              accept: e.accept,
              disabled: e.disabled,
              multiple: e.multiple,
              "aria-describedby": z.value,
              "aria-invalid": n.value ? "true" : void 0,
              class: "sr-only",
              onChange: ge,
              onFocus: X[2] || (X[2] = (ae) => k.value = !0),
              onBlur: X[3] || (X[3] = (ae) => k.value = !1),
              onKeydown: B
            }, null, 40, YS)
          ], 32),
          U(Pt, {
            ref_key: "helperRef",
            ref: S,
            focused: k.value,
            hint: A.value,
            "hint-lines": E.value,
            disabled: e.disabled,
            error: l.value,
            "hint-id": I.value,
            "error-id": T.value,
            "error-live": e.errorLive,
            "test-id-prefix": "file-upload"
          }, null, 8, ["focused", "hint", "hint-lines", "disabled", "error", "hint-id", "error-id", "error-live"])
        ]),
        e.progressFiles.length ? (u(), b("div", JS, [
          (u(!0), b(ie, null, Oe(e.progressFiles, (ae) => (u(), b("div", {
            key: ae.id,
            "data-testid": "upload-progress-row",
            class: "flex w-full items-center justify-between gap-2.5"
          }, [
            x("div", XS, [
              (u(), b("svg", ZS, [
                x("defs", null, [
                  x("linearGradient", {
                    id: `upload-ring-gradient-${ae.id}`,
                    x1: "0%",
                    y1: "0%",
                    x2: "100%",
                    y2: "100%"
                  }, [...X[11] || (X[11] = [
                    x("stop", {
                      offset: "0%",
                      style: { "stop-color": "var(--gradient-brand-start)" }
                    }, null, -1),
                    x("stop", {
                      offset: "100%",
                      style: { "stop-color": "var(--gradient-brand-end)" }
                    }, null, -1)
                  ])], 8, QS)
                ]),
                x("circle", {
                  cx: "12",
                  cy: "12",
                  r: ud,
                  fill: "none",
                  "stroke-width": nh,
                  class: "stroke-(--border-border-base-soft) dark:stroke-(--border-border-base-soft)"
                }),
                x("circle", {
                  "data-testid": "progress-ring-fill",
                  cx: "12",
                  cy: "12",
                  r: ud,
                  fill: "none",
                  "stroke-width": nh,
                  "stroke-linecap": "round",
                  transform: "rotate(-90 12 12)",
                  stroke: `url(#upload-ring-gradient-${ae.id})`,
                  "stroke-dasharray": D,
                  "stroke-dashoffset": O(ae.percent)
                }, null, 8, _S)
              ])),
              x("div", e$, [
                x("p", t$, H(ae.name), 1),
                x("div", a$, [
                  x("span", n$, H(ae.percent) + "%", 1),
                  x("span", {
                    class: C(
                      ae.status === "success" ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : ae.status === "error" ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
                    )
                  }, H(ae.statusText), 3)
                ])
              ])
            ]),
            x("div", l$, [
              ae.status === "uploading" ? (u(), P(L(Be), {
                key: 0,
                variant: "text",
                "icon-only": "",
                size: "sm",
                "icon-left": Z.value.has(ae.id) ? "ri-play-line" : "ri-pause-line",
                "aria-label": Z.value.has(ae.id) ? e.resumeLabel : e.pauseLabel,
                "data-testid": "pause-icon",
                onClick: (Re) => le(ae.id)
              }, null, 8, ["icon-left", "aria-label", "onClick"])) : w("", !0),
              ae.status === "success" ? (u(), b("span", o$, [...X[12] || (X[12] = [
                x("i", {
                  "data-testid": "progress-success-icon",
                  class: "ri-checkbox-circle-line text-(length:--size-xxl) text-(--icons-icon-success) dark:text-(--icons-icon-success)",
                  "aria-hidden": "true"
                }, null, -1)
              ])])) : ae.status === "error" ? (u(), b("span", r$, [...X[13] || (X[13] = [
                x("i", {
                  "data-testid": "progress-error-icon",
                  class: "ri-error-warning-line text-(length:--size-xxl) text-(--icons-icon-error) dark:text-(--icons-icon-error)",
                  "aria-hidden": "true"
                }, null, -1)
              ])])) : w("", !0),
              U(L(Be), {
                variant: "text",
                "icon-only": "",
                size: "sm",
                "icon-left": "ri-close-line",
                "aria-label": e.removeLabel,
                "data-testid": "delete-icon",
                onClick: (Re) => g("removeProgressFile", ae.id)
              }, null, 8, ["aria-label", "onClick"])
            ])
          ]))), 128))
        ])) : w("", !0)
      ])) : (u(), b("div", i$, [
        x("div", {
          class: C(M.value),
          onDragover: de,
          onDragleave: Ee,
          onDrop: j,
          onClick: X[6] || (X[6] = (ae) => e.variant === "default" ? J() : void 0),
          onMouseenter: X[7] || (X[7] = (ae) => _.value = !0),
          onMouseleave: X[8] || (X[8] = (ae) => _.value = !1)
        }, [
          e.variant === "default" ? (u(), b(ie, { key: 0 }, [
            d.value ? (u(), b("div", {
              key: 1,
              class: C(["flex flex-col items-center", L(V).gap])
            }, [
              x("div", u$, [
                e.uploadIcon ? (u(), b("img", {
                  key: 0,
                  src: e.uploadIcon,
                  class: C([
                    L(V).icon,
                    "relative",
                    e.disabled ? "file-input-icon-disabled" : "file-input-icon"
                  ]),
                  alt: ""
                }, null, 10, c$)) : w("", !0),
                x("div", {
                  class: C([
                    "relative text-sm leading-5",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, H(e.uploadText), 3),
                x("button", {
                  type: "button",
                  class: C([
                    "relative text-sm leading-5 font-medium cursor-pointer hover:underline",
                    n.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)"
                  ]),
                  onClick: _e(oe, ["stop"])
                }, H(f.value), 3)
              ]),
              U(L(Be), {
                variant: "secondary",
                label: `+ ${e.addMoreText}`,
                size: "xs",
                disabled: e.disabled,
                type: "button",
                onClick: _e(Se, ["stop"])
              }, null, 8, ["label", "disabled"])
            ], 2)) : (u(), b("div", {
              key: 0,
              class: C(["flex flex-col items-center", L(V).gap])
            }, [
              x("div", s$, [
                e.uploadIcon ? (u(), b("img", {
                  key: 0,
                  src: e.uploadIcon,
                  class: C([
                    L(V).icon,
                    "relative",
                    e.disabled ? "file-input-icon-disabled" : "file-input-icon"
                  ]),
                  alt: ""
                }, null, 10, d$)) : w("", !0),
                x("div", {
                  class: C([
                    "relative text-sm leading-5",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, H(e.uploadText), 3),
                x("div", {
                  class: C([
                    "relative text-xs! leading-4 font-medium",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : e.success || d.value || e.error ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
                  ])
                }, H(e.maxFileSizeText), 3)
              ]),
              U(L(Be), {
                variant: "primary",
                label: e.browseButtonText,
                "icon-left": e.browseButtonIcon,
                size: "xs",
                disabled: e.disabled,
                type: "button",
                onClick: _e(K, ["stop"])
              }, null, 8, ["label", "icon-left", "disabled"])
            ], 2))
          ], 64)) : (u(), b("div", f$, [
            x("div", {
              class: C([
                "relative leading-5 text-sm!",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
              ])
            }, H(e.dragDropText), 3),
            x("div", {
              class: C([
                "self-stretch flex items-start gap-6 text-xs!",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ])
            }, [
              x("div", h$, [
                x("div", {
                  class: C([
                    "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                    e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : n.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || d.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                  ])
                }, [
                  F.value ? (u(), P(L(Be), {
                    key: 0,
                    variant: "secondary",
                    "icon-left": F.value,
                    "icon-only": "",
                    size: "sm",
                    disabled: e.disabled,
                    "aria-labelledby": r,
                    onClick: _e(G, ["stop"])
                  }, null, 8, ["icon-left", "disabled"])) : w("", !0)
                ], 2),
                x("div", {
                  id: r,
                  class: C([
                    "relative leading-5 font-medium text-sm!",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : n.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || d.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, H(e.browseLabel), 3)
              ]),
              x("div", b$, [
                x("div", {
                  class: C([
                    "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                    e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : n.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || d.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                  ])
                }, [
                  ee.value ? (u(), P(L(Be), {
                    key: 0,
                    variant: "secondary",
                    "icon-left": ee.value,
                    "icon-only": "",
                    size: "sm",
                    disabled: e.disabled,
                    "aria-labelledby": i,
                    onClick: _e(te, ["stop"])
                  }, null, 8, ["icon-left", "disabled"])) : w("", !0)
                ], 2),
                x("div", {
                  id: i,
                  class: C([
                    "relative leading-5 font-medium text-sm!",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : n.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || d.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, H(e.libraryLabel), 3)
              ]),
              x("div", g$, [
                x("div", {
                  class: C([
                    "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                    e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : n.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || d.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                  ])
                }, [
                  ue.value ? (u(), P(L(Be), {
                    key: 0,
                    variant: "secondary",
                    "icon-left": ue.value,
                    "icon-only": "",
                    size: "sm",
                    disabled: e.disabled,
                    "aria-labelledby": s,
                    onClick: _e(ve, ["stop"])
                  }, null, 8, ["icon-left", "disabled"])) : w("", !0)
                ], 2),
                x("div", {
                  id: s,
                  class: C([
                    "relative leading-5 font-medium text-sm!",
                    e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : n.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || d.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                  ])
                }, H(e.linkLabel), 3)
              ])
            ], 2)
          ])),
          x("input", {
            id: y.value,
            ref_key: "fileInputRef",
            ref: v,
            "data-testid": "file-upload-input",
            name: e.name,
            type: "file",
            accept: e.accept,
            disabled: e.disabled,
            multiple: e.multiple,
            "aria-describedby": z.value,
            "aria-invalid": n.value ? "true" : void 0,
            class: "sr-only",
            onChange: ge,
            onFocus: X[4] || (X[4] = (ae) => k.value = !0),
            onBlur: X[5] || (X[5] = (ae) => k.value = !1),
            onKeydown: B
          }, null, 40, m$)
        ], 34),
        U(Pt, {
          ref_key: "helperRef",
          ref: S,
          focused: k.value,
          hint: A.value,
          "hint-lines": E.value,
          disabled: e.disabled,
          error: l.value,
          "hint-id": I.value,
          "error-id": T.value,
          "error-live": e.errorLive,
          "test-id-prefix": "file-upload"
        }, null, 8, ["focused", "hint", "hint-lines", "disabled", "error", "hint-id", "error-id", "error-live"])
      ])),
      e.variant === "dropzone" && e.uploadedFiles && e.uploadedFiles.length > 0 ? (u(), b("div", v$, [
        (u(!0), b(ie, null, Oe(e.uploadedFiles, (ae, Re) => (u(), b("div", {
          key: `file-${Re}-${ae.name}`,
          class: "flex items-center gap-2"
        }, [
          x("div", p$, [
            ae.status === "success" ? (u(), b("svg", x$, [...X[14] || (X[14] = [
              x("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M5 13l4 4L19 7"
              }, null, -1)
            ])])) : ae.status === "error" ? (u(), b("svg", y$, [...X[15] || (X[15] = [
              x("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              }, null, -1)
            ])])) : w("", !0)
          ]),
          x("div", k$, [
            x("p", {
              class: C([
                "text-sm truncate",
                ae.status === "error" ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
              ])
            }, [
              st(H(ae.name) + " ", 1),
              ae.size ? (u(), b("span", w$, " (" + H(c(ae.size)) + ") ", 1)) : w("", !0)
            ], 2)
          ]),
          x("button", {
            type: "button",
            class: "flex-shrink-0 p-0.5 transition-colors",
            disabled: e.disabled,
            onClick: (Ae) => re(ae, Re)
          }, [
            (u(), b("svg", {
              class: C([
                "w-5 h-5",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ]),
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [...X[16] || (X[16] = [
              x("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              }, null, -1)
            ])], 2))
          ], 8, C$)
        ]))), 128))
      ])) : w("", !0)
    ]));
  }
}), $$ = /* @__PURE__ */ Ct(S$, [["__scopeId", "data-v-8ebe268e"]]), I$ = {
  "aria-hidden": "true",
  focusable: "false",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "textarea-icon pointer-events-none text-(--colors-icon-dark-default) dark:text-(--icons-icon-white-default)"
}, Im = /* @__PURE__ */ ke({
  __name: "ResizeGrip",
  setup(e) {
    return (a, t) => (u(), b("svg", I$, [...t[0] || (t[0] = [
      x("path", {
        d: "M21 11L11 21",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1),
      x("path", {
        d: "M21 15L15 21",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1),
      x("path", {
        d: "M21 19L19 21",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round"
      }, null, -1)
    ])]));
  }
}), L$ = { class: "flex min-w-0 items-center gap-4" }, T$ = {
  key: 0,
  class: "flex items-center gap-1"
}, Di = /* @__PURE__ */ ke({
  __name: "TextareaFooter",
  props: {
    labels: { default: () => ({}) },
    actions: { default: () => [] },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["send", "action"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => t.labels.send ?? "Send message");
    return (o, r) => (u(), b("div", L$, [
      U(Be, {
        variant: "primary",
        size: "sm",
        label: l.value,
        disabled: e.disabled,
        "data-testid": "field-footer-send",
        onClick: r[0] || (r[0] = (i) => n("send"))
      }, null, 8, ["label", "disabled"]),
      e.actions.length ? (u(), b("div", T$, [
        (u(!0), b(ie, null, Oe(e.actions, (i) => (u(), P(Be, {
          key: i.id,
          variant: "tertiary",
          size: "xs",
          "icon-only": "",
          "icon-left": i.icon,
          "aria-label": i.label,
          disabled: e.disabled,
          "data-field-footer-action": i.id,
          onClick: (s) => n("action", i.id)
        }, null, 8, ["icon-left", "aria-label", "disabled", "data-field-footer-action", "onClick"]))), 128))
      ])) : w("", !0)
    ]));
  }
}), E$ = ["data-type"], A$ = {
  key: 0,
  class: "flex min-w-0 max-w-full items-center gap-1"
}, R$ = ["src"], z$ = {
  key: 0,
  class: "flex w-full items-center gap-2 p-2 rounded-(--border-border-radius-rounded-sm) bg-(--background-background-white-secondary) dark:bg-(--background-background-black-default)",
  "data-testid": "textarea-chatroom"
}, D$ = {
  key: 0,
  class: "flex shrink-0 items-center gap-1"
}, B$ = { class: "self-stretch flex flex-1 min-h-0 p-2" }, M$ = ["rows"], O$ = {
  key: 0,
  class: "absolute bottom-2 right-2 flex items-center justify-center"
}, P$ = ["src"], F$ = {
  key: 1,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, N$ = {
  key: 1,
  class: "flex items-center gap-4",
  "data-testid": "textarea-footer"
}, V$ = "border border-solid rounded-b-(--border-border-radius-rounded-l) p-[calc(--spacing(2.5)-1px)] border-(--border-border-base-medium) dark:border-(--border-border-base) bg-(--background-background-white) dark:bg-(--background-background-black-default)", lh = "w-full relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 p-0 text-(length:--size-m) leading-(--line-height-l) placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)", H$ = "w-full relative flex flex-col items-start gap-0.5 pb-0.5 text-left text-(length:--size-m) text-(--text-text-black-default) dark:text-(--colors-text-white-default) font-inter", j$ = /* @__PURE__ */ ke({
  __name: "Textarea",
  props: {
    type: { default: "Default" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    helpIcon: { default: void 0 },
    placeholder: { default: void 0 },
    showPlaceholder: { type: Boolean, default: void 0 },
    modelValue: { default: "" },
    bottomRightIcon: { default: void 0 },
    helpText: { default: void 0 },
    helpTextIcon: { default: void 0 },
    error: { default: void 0 },
    showError: { type: Boolean, default: void 0 },
    rows: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !0 },
    width: { default: void 0 },
    height: { default: void 0 },
    maxLength: { default: void 0 },
    resizable: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    labels: { default: () => ({}) },
    submitLabel: { default: void 0 },
    actions: { default: () => [] }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "send", "action"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = Ye(), o = m(() => t.id || l), r = m(() => t.label ? `${o.value}-label` : void 0), i = m(() => `${o.value}-error`), s = m(() => `${o.value}-help`), d = R(!1), c = R(null), f = R(null), g = m(() => t.type === "Chatroom"), h = m(() => t.type === "Buttons inside"), v = m(() => t.type === "Buttons outside"), p = m(() => !!t.error), y = m(() => t.showError !== void 0 ? t.showError : p.value), k = m(() => {
      const oe = [];
      return y.value && p.value && oe.push(i.value), t.helpText && oe.push(s.value), oe.length ? oe.join(" ") : void 0;
    }), $ = m(() => !!t.modelValue), S = m(() => t.showPlaceholder === !1 ? !1 : t.showPlaceholder === !0 ? !0 : !$.value), I = m(() => S.value ? t.placeholder : void 0), T = R("auto"), A = R(null), E = { send: "Send message", field: "Message" }, z = m(() => ({ ...E, ...t.labels })), B = m(() => {
      const re = `relative self-stretch box-border flex flex-col items-start justify-between gap-2 border-solid px-[calc(--spacing(1)-1px)] pt-[calc(--spacing(1)-1px)] font-inter ${h.value ? "rounded-t-(--border-border-radius-rounded-l) rounded-b-none border-x border-t border-b-0 pb-1" : "rounded-(--border-border-radius-rounded-l) border pb-[calc(--spacing(1)-1px)]"}`, ge = "shadow-[0_0_2px_2px_var(--background-background-hover)]", de = "shadow-(--blur-shadow-xs)", Ee = "dark:shadow-(--blur-shadow-m-dark)";
      if (t.disabled)
        return `${re} ${de} ${Ee} bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled) border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle)`;
      if (t.readonly)
        return `${re} ${de} ${Ee} bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) border-(--border-border-base-soft) dark:border-(--border-border-base)`;
      if (p.value)
        return `${re} ${d.value ? ge : `${de} ${Ee}`} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)`;
      if (d.value)
        return `${re} ${ge} bg-(--background-background-selected) dark:bg-(--background-background-black-default) border-(--border-border-accent)`;
      const j = $.value ? "" : de;
      return `${re} ${j} ${Ee} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base)`;
    }), W = m(() => t.disabled ? "text-(--text-text-disabled-light) dark:text-(--colors-text-disabled)" : t.readonly ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : d.value || $.value ? "text-(--text-text-body) dark:text-(--colors-text-white-default)" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-default)"), _ = m(() => !t.fullWidth && t.width ? { width: t.width } : {}), Z = m(() => [
      "flex flex-col",
      v.value ? "gap-4" : "",
      h.value ? "rounded-(--border-border-radius-rounded-l) shadow-(--blur-shadow-xs)" : "",
      "w-full"
    ]), le = m(() => {
      const oe = t.height ?? (t.type === "Default" ? "204px" : "184px");
      return t.resizable ? { minHeight: oe } : { height: oe };
    }), D = m(() => {
      var oe;
      if (t.maxLength)
        return ((oe = t.modelValue) == null ? void 0 : oe.length) || 0;
    }), O = m(() => t.resizable ? "resize-y" : "resize-none"), N = m(() => ({
      id: o.value,
      "data-testid": "textarea",
      name: t.name,
      autocomplete: t.autocomplete,
      value: t.modelValue,
      placeholder: I.value,
      disabled: t.disabled,
      readonly: t.readonly,
      maxlength: t.maxLength,
      "aria-labelledby": r.value,
      // Without `label` or `ariaLabel` the Chatroom field still needs a name: its row has no room for a visible label.
      // `||`, not `??`: an empty `ariaLabel` names nothing (axe aria-input-field-name), so it counts as absent.
      "aria-label": t.label ? void 0 : t.ariaLabel || (g.value ? z.value.field : void 0),
      "aria-required": t.required ? !0 : void 0,
      "aria-invalid": p.value ? !0 : void 0,
      "aria-disabled": t.disabled,
      "aria-describedby": k.value
    })), V = (oe) => {
      const re = oe.target;
      n("update:modelValue", re.value), n("input", oe);
    }, M = (oe) => {
      t.disabled || (d.value = !0), n("focus", oe);
    }, Q = (oe) => {
      d.value = !1, n("blur", oe);
    }, q = (oe) => {
      var re, ge;
      (re = c.value) == null || re.handleFieldKeydown(oe), (ge = f.value) == null || ge.handleFieldKeydown(oe);
    }, K = m(() => t.disabled || t.readonly), G = () => n("send", t.modelValue), te = (oe) => n("action", oe), ve = () => {
      if (A.value && t.resizable) {
        const oe = A.value.offsetHeight;
        oe > 0 && (T.value = `${oe}px`);
      }
    };
    $e(
      () => t.resizable,
      (oe) => {
        oe || (T.value = "auto");
      }
    );
    let Se = null;
    return kt(() => {
      t.resizable && A.value && (Se = new ResizeObserver(() => {
        ve();
      }), Se.observe(A.value));
    }), zt(() => {
      Se && Se.disconnect();
    }), $e(
      () => A.value,
      (oe) => {
        Se && Se.disconnect(), oe && t.resizable && (Se = new ResizeObserver(() => {
          ve();
        }), Se.observe(oe));
      }
    ), (oe, re) => (u(), b("div", {
      class: C(H$),
      style: Ge(_.value),
      "data-type": e.type
    }, [
      e.label ? (u(), b("div", A$, [
        U(Ft, {
          id: r.value,
          ref_key: "labelRef",
          ref: c,
          text: e.label,
          "input-id": o.value,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: d.value,
          "test-id": "textarea-label"
        }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"]),
        e.helpIcon && !e.labelTooltip ? (u(), b("img", {
          key: 0,
          class: "h-3.5 w-3.5 relative textarea-icon",
          src: e.helpIcon,
          alt: ""
        }, null, 8, R$)) : w("", !0)
      ])) : w("", !0),
      x("div", {
        class: C(Z.value),
        "data-testid": "textarea-field"
      }, [
        g.value ? (u(), b("div", z$, [
          e.actions.length ? (u(), b("div", D$, [
            (u(!0), b(ie, null, Oe(e.actions, (ge) => (u(), P(Be, {
              key: ge.id,
              variant: "tertiary",
              size: "xs",
              "icon-only": "",
              "icon-left": ge.icon,
              "aria-label": ge.label,
              disabled: K.value,
              "data-textarea-action": ge.id,
              onClick: (de) => te(ge.id)
            }, null, 8, ["icon-left", "aria-label", "disabled", "data-textarea-action", "onClick"]))), 128))
          ])) : w("", !0),
          U(en, {
            size: "sm",
            flush: "",
            disabled: e.disabled,
            readonly: e.readonly,
            error: p.value,
            "has-value": $.value,
            class: "min-w-0 flex-1"
          }, {
            default: me(() => [
              x("textarea", Ve({
                ref_key: "textareaRef",
                ref: A
              }, N.value, {
                rows: "1",
                class: [lh, W.value, "h-5 resize-none overflow-hidden px-[calc(--spacing(2.5)-1px)]"],
                onInput: V,
                onFocus: M,
                onBlur: Q,
                onKeydown: q
              }), null, 16)
            ]),
            _: 1
          }, 8, ["disabled", "readonly", "error", "has-value"]),
          U(Be, {
            variant: "tertiary",
            size: "xs",
            "icon-only": "",
            "icon-left": "ri-send-plane-2-line",
            "aria-label": z.value.send,
            disabled: K.value,
            "data-testid": "textarea-send",
            onClick: G
          }, null, 8, ["aria-label", "disabled"])
        ])) : (u(), b(ie, { key: 1 }, [
          x("div", {
            class: C(B.value),
            style: Ge(le.value),
            "data-testid": "textarea-box"
          }, [
            x("div", B$, [
              x("textarea", Ve({
                ref_key: "textareaRef",
                ref: A
              }, N.value, {
                rows: e.rows,
                style: { height: T.value },
                class: [lh, W.value, O.value],
                onInput: V,
                onFocus: M,
                onBlur: Q,
                onKeydown: q
              }), null, 16, M$)
            ]),
            e.bottomRightIcon || e.maxLength || e.resizable ? (u(), b("div", O$, [
              e.bottomRightIcon ? (u(), b("img", {
                key: 0,
                class: "w-[24.2px] h-[24.2px] textarea-icon",
                src: e.bottomRightIcon,
                alt: ""
              }, null, 8, P$)) : e.maxLength ? (u(), b("div", F$, H(D.value) + "/" + H(e.maxLength), 1)) : e.resizable ? (u(), P(Im, { key: 2 })) : w("", !0)
            ])) : w("", !0)
          ], 6),
          h.value ? (u(), P(Di, {
            key: 0,
            class: C(V$),
            labels: { send: z.value.send },
            actions: e.actions,
            disabled: K.value,
            "data-testid": "textarea-footer",
            onSend: G,
            onAction: te
          }, null, 8, ["labels", "actions", "disabled"])) : w("", !0),
          v.value ? (u(), b("div", N$, [
            U(Di, {
              class: "shrink-0",
              labels: { send: z.value.send },
              actions: e.actions,
              disabled: K.value,
              onSend: G,
              onAction: te
            }, null, 8, ["labels", "actions", "disabled"]),
            U(Pt, {
              ref_key: "helperRef",
              ref: f,
              class: "min-w-0 flex-1",
              focused: d.value,
              hint: e.helpText,
              error: y.value ? e.error : void 0,
              "hint-id": s.value,
              "error-id": i.value,
              "hint-icon": e.helpTextIcon,
              "test-id-prefix": "textarea"
            }, null, 8, ["focused", "hint", "error", "hint-id", "error-id", "hint-icon"])
          ])) : w("", !0)
        ], 64))
      ], 2),
      v.value ? w("", !0) : (u(), P(Pt, {
        key: 1,
        ref_key: "helperRef",
        ref: f,
        focused: d.value,
        hint: e.helpText,
        error: y.value ? e.error : void 0,
        "hint-id": s.value,
        "error-id": i.value,
        "hint-icon": e.helpTextIcon,
        "test-id-prefix": "textarea"
      }, null, 8, ["focused", "hint", "error", "hint-id", "error-id", "hint-icon"])),
      e.submitLabel && !h.value && !v.value && !g.value ? (u(), P(Be, {
        key: 2,
        variant: "primary",
        size: "xs",
        label: e.submitLabel,
        disabled: K.value,
        "data-testid": "textarea-submit",
        onClick: G
      }, null, 8, ["label", "disabled"])) : w("", !0)
    ], 12, E$));
  }
}), tG = /* @__PURE__ */ Ct(j$, [["__scopeId", "data-v-d926decc"]]);
function sa(e) {
  this.content = e;
}
sa.prototype = {
  constructor: sa,
  find: function(e) {
    for (var a = 0; a < this.content.length; a += 2)
      if (this.content[a] === e) return a;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(e) {
    var a = this.find(e);
    return a == -1 ? void 0 : this.content[a + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(e, a, t) {
    var n = t && t != e ? this.remove(t) : this, l = n.find(e), o = n.content.slice();
    return l == -1 ? o.push(t || e, a) : (o[l + 1] = a, t && (o[l] = t)), new sa(o);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(e) {
    var a = this.find(e);
    if (a == -1) return this;
    var t = this.content.slice();
    return t.splice(a, 2), new sa(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(e, a) {
    return new sa([e, a].concat(this.remove(e).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(e, a) {
    var t = this.remove(e).content.slice();
    return t.push(e, a), new sa(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(e, a, t) {
    var n = this.remove(a), l = n.content.slice(), o = n.find(e);
    return l.splice(o == -1 ? l.length : o, 0, a, t), new sa(l);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(e) {
    for (var a = 0; a < this.content.length; a += 2)
      e(this.content[a], this.content[a + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(e) {
    return e = sa.from(e), e.size ? new sa(e.content.concat(this.subtract(e).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(e) {
    return e = sa.from(e), e.size ? new sa(this.subtract(e).content.concat(e.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(e) {
    var a = this;
    e = sa.from(e);
    for (var t = 0; t < e.content.length; t += 2)
      a = a.remove(e.content[t]);
    return a;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var e = {};
    return this.forEach(function(a, t) {
      e[a] = t;
    }), e;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
sa.from = function(e) {
  if (e instanceof sa) return e;
  var a = [];
  if (e) for (var t in e) a.push(t, e[t]);
  return new sa(a);
};
function Lm(e, a, t) {
  for (let n = 0; ; n++) {
    if (n == e.childCount || n == a.childCount)
      return e.childCount == a.childCount ? null : t;
    let l = e.child(n), o = a.child(n);
    if (l == o) {
      t += l.nodeSize;
      continue;
    }
    if (!l.sameMarkup(o))
      return t;
    if (l.isText && l.text != o.text) {
      for (let r = 0; l.text[r] == o.text[r]; r++)
        t++;
      return t;
    }
    if (l.content.size || o.content.size) {
      let r = Lm(l.content, o.content, t + 1);
      if (r != null)
        return r;
    }
    t += l.nodeSize;
  }
}
function Tm(e, a, t, n) {
  for (let l = e.childCount, o = a.childCount; ; ) {
    if (l == 0 || o == 0)
      return l == o ? null : { a: t, b: n };
    let r = e.child(--l), i = a.child(--o), s = r.nodeSize;
    if (r == i) {
      t -= s, n -= s;
      continue;
    }
    if (!r.sameMarkup(i))
      return { a: t, b: n };
    if (r.isText && r.text != i.text) {
      let d = 0, c = Math.min(r.text.length, i.text.length);
      for (; d < c && r.text[r.text.length - d - 1] == i.text[i.text.length - d - 1]; )
        d++, t--, n--;
      return { a: t, b: n };
    }
    if (r.content.size || i.content.size) {
      let d = Tm(r.content, i.content, t - 1, n - 1);
      if (d)
        return d;
    }
    t -= s, n -= s;
  }
}
class We {
  /**
  @internal
  */
  constructor(a, t) {
    if (this.content = a, this.size = t || 0, t == null)
      for (let n = 0; n < a.length; n++)
        this.size += a[n].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(a, t, n, l = 0, o) {
    for (let r = 0, i = 0; i < t; r++) {
      let s = this.content[r], d = i + s.nodeSize;
      if (d > a && n(s, l + i, o || null, r) !== !1 && s.content.size) {
        let c = i + 1;
        s.nodesBetween(Math.max(0, a - c), Math.min(s.content.size, t - c), n, l + c);
      }
      i = d;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(a) {
    this.nodesBetween(0, this.size, a);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(a, t, n, l) {
    let o = "", r = !0;
    return this.nodesBetween(a, t, (i, s) => {
      let d = i.isText ? i.text.slice(Math.max(a, s) - s, t - s) : i.isLeaf ? l ? typeof l == "function" ? l(i) : l : i.type.spec.leafText ? i.type.spec.leafText(i) : "" : "";
      i.isBlock && (i.isLeaf && d || i.isTextblock) && n && (r ? r = !1 : o += n), o += d;
    }, 0), o;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(a) {
    if (!a.size)
      return this;
    if (!this.size)
      return a;
    let t = this.lastChild, n = a.firstChild, l = this.content.slice(), o = 0;
    for (t.isText && t.sameMarkup(n) && (l[l.length - 1] = t.withText(t.text + n.text), o = 1); o < a.content.length; o++)
      l.push(a.content[o]);
    return new We(l, this.size + a.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(a, t = this.size) {
    if (a == 0 && t == this.size)
      return this;
    let n = [], l = 0;
    if (t > a)
      for (let o = 0, r = 0; r < t; o++) {
        let i = this.content[o], s = r + i.nodeSize;
        s > a && ((r < a || s > t) && (i.isText ? i = i.cut(Math.max(0, a - r), Math.min(i.text.length, t - r)) : i = i.cut(Math.max(0, a - r - 1), Math.min(i.content.size, t - r - 1))), n.push(i), l += i.nodeSize), r = s;
      }
    return new We(n, l);
  }
  /**
  @internal
  */
  cutByIndex(a, t) {
    return a == t ? We.empty : a == 0 && t == this.content.length ? this : new We(this.content.slice(a, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(a, t) {
    let n = this.content[a];
    if (n == t)
      return this;
    let l = this.content.slice(), o = this.size + t.nodeSize - n.nodeSize;
    return l[a] = t, new We(l, o);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(a) {
    return new We([a].concat(this.content), this.size + a.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(a) {
    return new We(this.content.concat(a), this.size + a.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(a) {
    if (this.content.length != a.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(a.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(a) {
    let t = this.content[a];
    if (!t)
      throw new RangeError("Index " + a + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(a) {
    return this.content[a] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(a) {
    for (let t = 0, n = 0; t < this.content.length; t++) {
      let l = this.content[t];
      a(l, n, t), n += l.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(a, t = 0) {
    return Lm(this, a, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(a, t = this.size, n = a.size) {
    return Tm(this, a, t, n);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(a) {
    if (a == 0)
      return Kr(0, a);
    if (a == this.size)
      return Kr(this.content.length, a);
    if (a > this.size || a < 0)
      throw new RangeError(`Position ${a} outside of fragment (${this})`);
    for (let t = 0, n = 0; ; t++) {
      let l = this.child(t), o = n + l.nodeSize;
      if (o >= a)
        return o == a ? Kr(t + 1, o) : Kr(t, n);
      n = o;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((a) => a.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(a, t) {
    if (!t)
      return We.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return We.fromArray(t.map(a.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(a) {
    if (!a.length)
      return We.empty;
    let t, n = 0;
    for (let l = 0; l < a.length; l++) {
      let o = a[l];
      n += o.nodeSize, l && o.isText && a[l - 1].sameMarkup(o) ? (t || (t = a.slice(0, l)), t[t.length - 1] = o.withText(t[t.length - 1].text + o.text)) : t && t.push(o);
    }
    return new We(t || a, n);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(a) {
    if (!a)
      return We.empty;
    if (a instanceof We)
      return a;
    if (Array.isArray(a))
      return this.fromArray(a);
    if (a.attrs)
      return new We([a], a.nodeSize);
    throw new RangeError("Can not convert " + a + " to a Fragment" + (a.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
We.empty = new We([], 0);
const cd = { index: 0, offset: 0 };
function Kr(e, a) {
  return cd.index = e, cd.offset = a, cd;
}
function Bi(e, a) {
  if (e === a)
    return !0;
  if (!(e && typeof e == "object") || !(a && typeof a == "object"))
    return !1;
  let t = Array.isArray(e);
  if (Array.isArray(a) != t)
    return !1;
  if (t) {
    if (e.length != a.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (!Bi(e[n], a[n]))
        return !1;
  } else {
    for (let n in e)
      if (!(n in a) || !Bi(e[n], a[n]))
        return !1;
    for (let n in a)
      if (!(n in e))
        return !1;
  }
  return !0;
}
let Mt = class gu {
  /**
  @internal
  */
  constructor(a, t) {
    this.type = a, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(a) {
    let t, n = !1;
    for (let l = 0; l < a.length; l++) {
      let o = a[l];
      if (this.eq(o))
        return a;
      if (this.type.excludes(o.type))
        t || (t = a.slice(0, l));
      else {
        if (o.type.excludes(this.type))
          return a;
        !n && o.type.rank > this.type.rank && (t || (t = a.slice(0, l)), t.push(this), n = !0), t && t.push(o);
      }
    }
    return t || (t = a.slice()), n || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(a) {
    for (let t = 0; t < a.length; t++)
      if (this.eq(a[t]))
        return a.slice(0, t).concat(a.slice(t + 1));
    return a;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(a) {
    for (let t = 0; t < a.length; t++)
      if (this.eq(a[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(a) {
    return this == a || this.type == a.type && Bi(this.attrs, a.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let a = { type: this.type.name };
    for (let t in this.attrs) {
      a.attrs = this.attrs;
      break;
    }
    return a;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(a, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let n = a.marks[t.type];
    if (!n)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let l = n.create(t.attrs);
    return n.checkAttrs(l.attrs), l;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(a, t) {
    if (a == t)
      return !0;
    if (a.length != t.length)
      return !1;
    for (let n = 0; n < a.length; n++)
      if (!a[n].eq(t[n]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(a) {
    if (!a || Array.isArray(a) && a.length == 0)
      return gu.none;
    if (a instanceof gu)
      return [a];
    let t = a.slice();
    return t.sort((n, l) => n.type.rank - l.type.rank), t;
  }
};
Mt.none = [];
class Mi extends Error {
}
class tt {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(a, t, n) {
    this.content = a, this.openStart = t, this.openEnd = n;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(a, t) {
    let n = Am(this.content, a + this.openStart, t, this.openStart + 1, this.openEnd + 1);
    return n && new tt(n, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(a, t) {
    return new tt(Em(this.content, a + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(a) {
    return this.content.eq(a.content) && this.openStart == a.openStart && this.openEnd == a.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let a = { content: this.content.toJSON() };
    return this.openStart > 0 && (a.openStart = this.openStart), this.openEnd > 0 && (a.openEnd = this.openEnd), a;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(a, t) {
    if (!t)
      return tt.empty;
    let n = t.openStart || 0, l = t.openEnd || 0;
    if (typeof n != "number" || typeof l != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new tt(We.fromJSON(a, t.content), n, l);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(a, t = !0) {
    let n = 0, l = 0;
    for (let o = a.firstChild; o && !o.isLeaf && (t || !o.type.spec.isolating); o = o.firstChild)
      n++;
    for (let o = a.lastChild; o && !o.isLeaf && (t || !o.type.spec.isolating); o = o.lastChild)
      l++;
    return new tt(a, n, l);
  }
}
tt.empty = new tt(We.empty, 0, 0);
function Em(e, a, t) {
  let { index: n, offset: l } = e.findIndex(a), o = e.maybeChild(n), { index: r, offset: i } = e.findIndex(t);
  if (l == a || o.isText) {
    if (i != t && !e.child(r).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, a).append(e.cut(t));
  }
  if (n != r)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(n, o.copy(Em(o.content, a - l - 1, t - l - 1)));
}
function Am(e, a, t, n, l, o) {
  let { index: r, offset: i } = e.findIndex(a), s = e.maybeChild(r);
  if (i == a || s.isText)
    return o && n <= 0 && l <= 0 && !o.canReplace(r, r, t) ? null : e.cut(0, a).append(t).append(e.cut(a));
  let d = Am(s.content, a - i - 1, t, r == 0 ? n - 1 : 0, r == e.childCount - 1 ? l - 1 : 0, s);
  return d && e.replaceChild(r, s.copy(d));
}
function W$(e, a, t) {
  if (t.openStart > e.depth)
    throw new Mi("Inserted content deeper than insertion position");
  if (e.depth - t.openStart != a.depth - t.openEnd)
    throw new Mi("Inconsistent open depths");
  return Rm(e, a, t, 0);
}
function Rm(e, a, t, n) {
  let l = e.index(n), o = e.node(n);
  if (l == a.index(n) && n < e.depth - t.openStart) {
    let r = Rm(e, a, t, n + 1);
    return o.copy(o.content.replaceChild(l, r));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && e.depth == n && a.depth == n) {
      let r = e.parent, i = r.content;
      return Tl(r, i.cut(0, e.parentOffset).append(t.content).append(i.cut(a.parentOffset)));
    } else {
      let { start: r, end: i } = q$(t, e);
      return Tl(o, Dm(e, r, i, a, n));
    }
  else return Tl(o, Oi(e, a, n));
}
function zm(e, a) {
  if (!a.type.compatibleContent(e.type))
    throw new Mi("Cannot join " + a.type.name + " onto " + e.type.name);
}
function mu(e, a, t) {
  let n = e.node(t);
  return zm(n, a.node(t)), n;
}
function Ll(e, a) {
  let t = a.length - 1;
  t >= 0 && e.isText && e.sameMarkup(a[t]) ? a[t] = e.withText(a[t].text + e.text) : a.push(e);
}
function Zo(e, a, t, n) {
  let l = (a || e).node(t), o = 0, r = a ? a.index(t) : l.childCount;
  e && (o = e.index(t), e.depth > t ? o++ : e.textOffset && (Ll(e.nodeAfter, n), o++));
  for (let i = o; i < r; i++)
    Ll(l.child(i), n);
  a && a.depth == t && a.textOffset && Ll(a.nodeBefore, n);
}
function Tl(e, a) {
  return e.type.checkContent(a), e.copy(a);
}
function Dm(e, a, t, n, l) {
  let o = e.depth > l && mu(e, a, l + 1), r = n.depth > l && mu(t, n, l + 1), i = [];
  return Zo(null, e, l, i), o && r && a.index(l) == t.index(l) ? (zm(o, r), Ll(Tl(o, Dm(e, a, t, n, l + 1)), i)) : (o && Ll(Tl(o, Oi(e, a, l + 1)), i), Zo(a, t, l, i), r && Ll(Tl(r, Oi(t, n, l + 1)), i)), Zo(n, null, l, i), new We(i);
}
function Oi(e, a, t) {
  let n = [];
  if (Zo(null, e, t, n), e.depth > t) {
    let l = mu(e, a, t + 1);
    Ll(Tl(l, Oi(e, a, t + 1)), n);
  }
  return Zo(a, null, t, n), new We(n);
}
function q$(e, a) {
  let t = a.depth - e.openStart, l = a.node(t).copy(e.content);
  for (let o = t - 1; o >= 0; o--)
    l = a.node(o).copy(We.from(l));
  return {
    start: l.resolveNoCache(e.openStart + t),
    end: l.resolveNoCache(l.content.size - e.openEnd - t)
  };
}
class gr {
  /**
  @internal
  */
  constructor(a, t, n) {
    this.pos = a, this.path = t, this.parentOffset = n, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(a) {
    return a == null ? this.depth : a < 0 ? this.depth + a : a;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(a) {
    return this.path[this.resolveDepth(a) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(a) {
    return this.path[this.resolveDepth(a) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(a) {
    return a = this.resolveDepth(a), this.index(a) + (a == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(a) {
    return a = this.resolveDepth(a), a == 0 ? 0 : this.path[a * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(a) {
    return a = this.resolveDepth(a), this.start(a) + this.node(a).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(a) {
    if (a = this.resolveDepth(a), !a)
      throw new RangeError("There is no position before the top-level node");
    return a == this.depth + 1 ? this.pos : this.path[a * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(a) {
    if (a = this.resolveDepth(a), !a)
      throw new RangeError("There is no position after the top-level node");
    return a == this.depth + 1 ? this.pos : this.path[a * 3 - 1] + this.path[a * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let a = this.parent, t = this.index(this.depth);
    if (t == a.childCount)
      return null;
    let n = this.pos - this.path[this.path.length - 1], l = a.child(t);
    return n ? a.child(t).cut(n) : l;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let a = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(a).cut(0, t) : a == 0 ? null : this.parent.child(a - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(a, t) {
    t = this.resolveDepth(t);
    let n = this.path[t * 3], l = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let o = 0; o < a; o++)
      l += n.child(o).nodeSize;
    return l;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let a = this.parent, t = this.index();
    if (a.content.size == 0)
      return Mt.none;
    if (this.textOffset)
      return a.child(t).marks;
    let n = a.maybeChild(t - 1), l = a.maybeChild(t);
    if (!n) {
      let i = n;
      n = l, l = i;
    }
    let o = n.marks;
    for (var r = 0; r < o.length; r++)
      o[r].type.spec.inclusive === !1 && (!l || !o[r].isInSet(l.marks)) && (o = o[r--].removeFromSet(o));
    return o;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(a) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let n = t.marks, l = a.parent.maybeChild(a.index());
    for (var o = 0; o < n.length; o++)
      n[o].type.spec.inclusive === !1 && (!l || !n[o].isInSet(l.marks)) && (n = n[o--].removeFromSet(n));
    return n;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(a) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= a && this.end(t) >= a)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(a = this, t) {
    if (a.pos < this.pos)
      return a.blockRange(this);
    for (let n = this.depth - (this.parent.inlineContent || this.pos == a.pos ? 1 : 0); n >= 0; n--)
      if (a.pos <= this.end(n) && (!t || t(this.node(n))))
        return new Pi(this, a, n);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(a) {
    return this.pos - this.parentOffset == a.pos - a.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(a) {
    return a.pos > this.pos ? a : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(a) {
    return a.pos < this.pos ? a : this;
  }
  /**
  @internal
  */
  toString() {
    let a = "";
    for (let t = 1; t <= this.depth; t++)
      a += (a ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return a + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(a, t) {
    if (!(t >= 0 && t <= a.content.size))
      throw new RangeError("Position " + t + " out of range");
    let n = [], l = 0, o = t;
    for (let r = a; ; ) {
      let { index: i, offset: s } = r.content.findIndex(o), d = o - s;
      if (n.push(r, i, l + s), !d || (r = r.child(i), r.isText))
        break;
      o = d - 1, l += s + 1;
    }
    return new gr(t, n, o);
  }
  /**
  @internal
  */
  static resolveCached(a, t) {
    let n = oh.get(a);
    if (n)
      for (let o = 0; o < n.elts.length; o++) {
        let r = n.elts[o];
        if (r.pos == t)
          return r;
      }
    else
      oh.set(a, n = new U$());
    let l = n.elts[n.i] = gr.resolve(a, t);
    return n.i = (n.i + 1) % G$, l;
  }
}
class U$ {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const G$ = 12, oh = /* @__PURE__ */ new WeakMap();
class Pi {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(a, t, n) {
    this.$from = a, this.$to = t, this.depth = n;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const K$ = /* @__PURE__ */ Object.create(null);
let Qn = class vu {
  /**
  @internal
  */
  constructor(a, t, n, l = Mt.none) {
    this.type = a, this.attrs = t, this.marks = l, this.content = n || We.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(a) {
    return this.content.child(a);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(a) {
    return this.content.maybeChild(a);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(a) {
    this.content.forEach(a);
  }
  /**
  Invoke a callback for all descendant nodes recursively overlapping
  the given two positions that are relative to start of this
  node's content. This includes all ancestors of the nodes
  containing the two positions. The callback is invoked with the
  node, its position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(a, t, n, l = 0) {
    this.content.nodesBetween(a, t, n, l, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(a) {
    this.nodesBetween(0, this.content.size, a);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(a, t, n, l) {
    return this.content.textBetween(a, t, n, l);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(a) {
    return this == a || this.sameMarkup(a) && this.content.eq(a.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(a) {
    return this.hasMarkup(a.type, a.attrs, a.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(a, t, n) {
    return this.type == a && Bi(this.attrs, t || a.defaultAttrs || K$) && Mt.sameSet(this.marks, n || Mt.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(a = null) {
    return a == this.content ? this : new vu(this.type, this.attrs, a, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(a) {
    return a == this.marks ? this : new vu(this.type, this.attrs, this.content, a);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(a, t = this.content.size) {
    return a == 0 && t == this.content.size ? this : this.copy(this.content.cut(a, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(a, t = this.content.size, n = !1) {
    if (a == t)
      return tt.empty;
    let l = this.resolve(a), o = this.resolve(t), r = n ? 0 : l.sharedDepth(t), i = l.start(r), d = l.node(r).content.cut(l.pos - i, o.pos - i);
    return new tt(d, l.depth - r, o.depth - r);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(a, t, n) {
    return W$(this.resolve(a), this.resolve(t), n);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(a) {
    for (let t = this; ; ) {
      let { index: n, offset: l } = t.content.findIndex(a);
      if (t = t.maybeChild(n), !t)
        return null;
      if (l == a || t.isText)
        return t;
      a -= l + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(a) {
    let { index: t, offset: n } = this.content.findIndex(a);
    return { node: this.content.maybeChild(t), index: t, offset: n };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(a) {
    if (a == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: n } = this.content.findIndex(a);
    if (n < a)
      return { node: this.content.child(t), index: t, offset: n };
    let l = this.content.child(t - 1);
    return { node: l, index: t - 1, offset: n - l.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(a) {
    return gr.resolveCached(this, a);
  }
  /**
  @internal
  */
  resolveNoCache(a) {
    return gr.resolve(this, a);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(a, t, n) {
    let l = !1;
    return t > a && this.nodesBetween(a, t, (o) => (n.isInSet(o.marks) && (l = !0), !l)), l;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let a = this.type.name;
    return this.content.size && (a += "(" + this.content.toStringInner() + ")"), Bm(this.marks, a);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(a) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, a);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(a, t, n = We.empty, l = 0, o = n.childCount) {
    let r = this.contentMatchAt(a).matchFragment(n, l, o), i = r && r.matchFragment(this.content, t);
    if (!i || !i.validEnd)
      return !1;
    for (let s = l; s < o; s++)
      if (!this.type.allowsMarks(n.child(s).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(a, t, n, l) {
    if (l && !this.type.allowsMarks(l))
      return !1;
    let o = this.contentMatchAt(a).matchType(n), r = o && o.matchFragment(this.content, t);
    return r ? r.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(a) {
    return a.content.size ? this.canReplace(this.childCount, this.childCount, a.content) : this.type.compatibleContent(a.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let a = Mt.none;
    for (let t = 0; t < this.marks.length; t++) {
      let n = this.marks[t];
      n.type.checkAttrs(n.attrs), a = n.addToSet(a);
    }
    if (!Mt.sameSet(a, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let a = { type: this.type.name };
    for (let t in this.attrs) {
      a.attrs = this.attrs;
      break;
    }
    return this.content.size && (a.content = this.content.toJSON()), this.marks.length && (a.marks = this.marks.map((t) => t.toJSON())), a;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(a, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let n;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      n = t.marks.map(a.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return a.text(t.text, n);
    }
    let l = We.fromJSON(a, t.content), o = a.nodeType(t.type).create(t.attrs, l, n);
    return o.type.checkAttrs(o.attrs), o;
  }
};
Qn.prototype.text = void 0;
class Fi extends Qn {
  /**
  @internal
  */
  constructor(a, t, n, l) {
    if (super(a, t, null, l), !n)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = n;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Bm(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(a, t) {
    return this.text.slice(a, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(a) {
    return a == this.marks ? this : new Fi(this.type, this.attrs, this.text, a);
  }
  withText(a) {
    return a == this.text ? this : new Fi(this.type, this.attrs, a, this.marks);
  }
  cut(a = 0, t = this.text.length) {
    return a == 0 && t == this.text.length ? this : this.withText(this.text.slice(a, t));
  }
  eq(a) {
    return this.sameMarkup(a) && this.text == a.text;
  }
  toJSON() {
    let a = super.toJSON();
    return a.text = this.text, a;
  }
}
function Bm(e, a) {
  for (let t = e.length - 1; t >= 0; t--)
    a = e[t].type.name + "(" + a + ")";
  return a;
}
class Ml {
  /**
  @internal
  */
  constructor(a) {
    this.validEnd = a, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(a, t) {
    let n = new Y$(a, t);
    if (n.next == null)
      return Ml.empty;
    let l = Mm(n);
    n.next && n.err("Unexpected trailing text");
    let o = tI(eI(l));
    return aI(o, n), o;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(a) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == a)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(a, t = 0, n = a.childCount) {
    let l = this;
    for (let o = t; l && o < n; o++)
      l = l.matchType(a.child(o).type);
    return l;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let a = 0; a < this.next.length; a++) {
      let { type: t } = this.next[a];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(a) {
    for (let t = 0; t < this.next.length; t++)
      for (let n = 0; n < a.next.length; n++)
        if (this.next[t].type == a.next[n].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(a, t = !1, n = 0) {
    let l = [this];
    function o(r, i) {
      let s = r.matchFragment(a, n);
      if (s && (!t || s.validEnd))
        return We.from(i.map((d) => d.createAndFill()));
      for (let d = 0; d < r.next.length; d++) {
        let { type: c, next: f } = r.next[d];
        if (!(c.isText || c.hasRequiredAttrs()) && l.indexOf(f) == -1) {
          l.push(f);
          let g = o(f, i.concat(c));
          if (g)
            return g;
        }
      }
      return null;
    }
    return o(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(a) {
    for (let n = 0; n < this.wrapCache.length; n += 2)
      if (this.wrapCache[n] == a)
        return this.wrapCache[n + 1];
    let t = this.computeWrapping(a);
    return this.wrapCache.push(a, t), t;
  }
  /**
  @internal
  */
  computeWrapping(a) {
    let t = /* @__PURE__ */ Object.create(null), n = [{ match: this, type: null, via: null }];
    for (; n.length; ) {
      let l = n.shift(), o = l.match;
      if (o.matchType(a)) {
        let r = [];
        for (let i = l; i.type; i = i.via)
          r.push(i.type);
        return r.reverse();
      }
      for (let r = 0; r < o.next.length; r++) {
        let { type: i, next: s } = o.next[r];
        !i.isLeaf && !i.hasRequiredAttrs() && !(i.name in t) && (!l.type || s.validEnd) && (n.push({ match: i.contentMatch, type: i, via: l }), t[i.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(a) {
    if (a >= this.next.length)
      throw new RangeError(`There's no ${a}th edge in this content match`);
    return this.next[a];
  }
  /**
  @internal
  */
  toString() {
    let a = [];
    function t(n) {
      a.push(n);
      for (let l = 0; l < n.next.length; l++)
        a.indexOf(n.next[l].next) == -1 && t(n.next[l].next);
    }
    return t(this), a.map((n, l) => {
      let o = l + (n.validEnd ? "*" : " ") + " ";
      for (let r = 0; r < n.next.length; r++)
        o += (r ? ", " : "") + n.next[r].type.name + "->" + a.indexOf(n.next[r].next);
      return o;
    }).join(`
`);
  }
}
Ml.empty = new Ml(!0);
class Y$ {
  constructor(a, t) {
    this.string = a, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = a.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(a) {
    return this.next == a && (this.pos++ || !0);
  }
  err(a) {
    throw new SyntaxError(a + " (in content expression '" + this.string + "')");
  }
}
function Mm(e) {
  let a = [];
  do
    a.push(J$(e));
  while (e.eat("|"));
  return a.length == 1 ? a[0] : { type: "choice", exprs: a };
}
function J$(e) {
  let a = [];
  do
    a.push(X$(e));
  while (e.next && e.next != ")" && e.next != "|");
  return a.length == 1 ? a[0] : { type: "seq", exprs: a };
}
function X$(e) {
  let a = _$(e);
  for (; ; )
    if (e.eat("+"))
      a = { type: "plus", expr: a };
    else if (e.eat("*"))
      a = { type: "star", expr: a };
    else if (e.eat("?"))
      a = { type: "opt", expr: a };
    else if (e.eat("{"))
      a = Z$(e, a);
    else
      break;
  return a;
}
function rh(e) {
  /\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
  let a = Number(e.next);
  return e.pos++, a;
}
function Z$(e, a) {
  let t = rh(e), n = t;
  return e.eat(",") && (e.next != "}" ? n = rh(e) : n = -1), e.eat("}") || e.err("Unclosed braced range"), { type: "range", min: t, max: n, expr: a };
}
function Q$(e, a) {
  let t = e.nodeTypes, n = t[a];
  if (n)
    return [n];
  let l = [];
  for (let o in t) {
    let r = t[o];
    r.isInGroup(a) && l.push(r);
  }
  return l.length == 0 && e.err("No node type or group '" + a + "' found"), l;
}
function _$(e) {
  if (e.eat("(")) {
    let a = Mm(e);
    return e.eat(")") || e.err("Missing closing paren"), a;
  } else if (/\W/.test(e.next))
    e.err("Unexpected token '" + e.next + "'");
  else {
    let a = Q$(e, e.next).map((t) => (e.inline == null ? e.inline = t.isInline : e.inline != t.isInline && e.err("Mixing inline and block content"), { type: "name", value: t }));
    return e.pos++, a.length == 1 ? a[0] : { type: "choice", exprs: a };
  }
}
function eI(e) {
  let a = [[]];
  return l(o(e, 0), t()), a;
  function t() {
    return a.push([]) - 1;
  }
  function n(r, i, s) {
    let d = { term: s, to: i };
    return a[r].push(d), d;
  }
  function l(r, i) {
    r.forEach((s) => s.to = i);
  }
  function o(r, i) {
    if (r.type == "choice")
      return r.exprs.reduce((s, d) => s.concat(o(d, i)), []);
    if (r.type == "seq")
      for (let s = 0; ; s++) {
        let d = o(r.exprs[s], i);
        if (s == r.exprs.length - 1)
          return d;
        l(d, i = t());
      }
    else if (r.type == "star") {
      let s = t();
      return n(i, s), l(o(r.expr, s), s), [n(s)];
    } else if (r.type == "plus") {
      let s = t();
      return l(o(r.expr, i), s), l(o(r.expr, s), s), [n(s)];
    } else {
      if (r.type == "opt")
        return [n(i)].concat(o(r.expr, i));
      if (r.type == "range") {
        let s = i;
        for (let d = 0; d < r.min; d++) {
          let c = t();
          l(o(r.expr, s), c), s = c;
        }
        if (r.max == -1)
          l(o(r.expr, s), s);
        else
          for (let d = r.min; d < r.max; d++) {
            let c = t();
            n(s, c), l(o(r.expr, s), c), s = c;
          }
        return [n(s)];
      } else {
        if (r.type == "name")
          return [n(i, void 0, r.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function Om(e, a) {
  return a - e;
}
function ih(e, a) {
  let t = [];
  return n(a), t.sort(Om);
  function n(l) {
    let o = e[l];
    if (o.length == 1 && !o[0].term)
      return n(o[0].to);
    t.push(l);
    for (let r = 0; r < o.length; r++) {
      let { term: i, to: s } = o[r];
      !i && t.indexOf(s) == -1 && n(s);
    }
  }
}
function tI(e) {
  let a = /* @__PURE__ */ Object.create(null);
  return t(ih(e, 0));
  function t(n) {
    let l = [];
    n.forEach((r) => {
      e[r].forEach(({ term: i, to: s }) => {
        if (!i)
          return;
        let d;
        for (let c = 0; c < l.length; c++)
          l[c][0] == i && (d = l[c][1]);
        ih(e, s).forEach((c) => {
          d || l.push([i, d = []]), d.indexOf(c) == -1 && d.push(c);
        });
      });
    });
    let o = a[n.join(",")] = new Ml(n.indexOf(e.length - 1) > -1);
    for (let r = 0; r < l.length; r++) {
      let i = l[r][1].sort(Om);
      o.next.push({ type: l[r][0], next: a[i.join(",")] || t(i) });
    }
    return o;
  }
}
function aI(e, a) {
  for (let t = 0, n = [e]; t < n.length; t++) {
    let l = n[t], o = !l.validEnd, r = [];
    for (let i = 0; i < l.next.length; i++) {
      let { type: s, next: d } = l.next[i];
      r.push(s.name), o && !(s.isText || s.hasRequiredAttrs()) && (o = !1), n.indexOf(d) == -1 && n.push(d);
    }
    o && a.err("Only non-generatable nodes (" + r.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Pm(e) {
  let a = /* @__PURE__ */ Object.create(null);
  for (let t in e) {
    let n = e[t];
    if (!n.hasDefault)
      return null;
    a[t] = n.default;
  }
  return a;
}
function Fm(e, a) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e) {
    let l = a && a[n];
    if (l === void 0) {
      let o = e[n];
      if (o.hasDefault)
        l = o.default;
      else
        throw new RangeError("No value supplied for attribute " + n);
    }
    t[n] = l;
  }
  return t;
}
function Nm(e, a, t, n) {
  for (let l in a)
    if (!(l in e))
      throw new RangeError(`Unsupported attribute ${l} for ${t} of type ${l}`);
  for (let l in e) {
    let o = e[l];
    o.validate && o.validate(a[l]);
  }
}
function Vm(e, a) {
  let t = /* @__PURE__ */ Object.create(null);
  if (a)
    for (let n in a)
      t[n] = new lI(e, n, a[n]);
  return t;
}
let sh = class Hm {
  /**
  @internal
  */
  constructor(a, t, n) {
    this.name = a, this.schema = t, this.spec = n, this.markSet = null, this.groups = n.group ? n.group.split(" ") : [], this.attrs = Vm(a, n.attrs), this.defaultAttrs = Pm(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(n.inline || a == "text"), this.isText = a == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == Ml.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(a) {
    return this.groups.indexOf(a) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let a in this.attrs)
      if (this.attrs[a].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(a) {
    return this == a || this.contentMatch.compatible(a.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(a) {
    return !a && this.defaultAttrs ? this.defaultAttrs : Fm(this.attrs, a);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(a = null, t, n) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Qn(this, this.computeAttrs(a), We.from(t), Mt.setFrom(n));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(a = null, t, n) {
    return t = We.from(t), this.checkContent(t), new Qn(this, this.computeAttrs(a), t, Mt.setFrom(n));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(a = null, t, n) {
    if (a = this.computeAttrs(a), t = We.from(t), t.size) {
      let r = this.contentMatch.fillBefore(t);
      if (!r)
        return null;
      t = r.append(t);
    }
    let l = this.contentMatch.matchFragment(t), o = l && l.fillBefore(We.empty, !0);
    return o ? new Qn(this, a, t.append(o), Mt.setFrom(n)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(a) {
    let t = this.contentMatch.matchFragment(a);
    if (!t || !t.validEnd)
      return !1;
    for (let n = 0; n < a.childCount; n++)
      if (!this.allowsMarks(a.child(n).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(a) {
    if (!this.validContent(a))
      throw new RangeError(`Invalid content for node ${this.name}: ${a.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(a) {
    Nm(this.attrs, a, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(a) {
    return this.markSet == null || this.markSet.indexOf(a) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(a) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < a.length; t++)
      if (!this.allowsMarkType(a[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(a) {
    if (this.markSet == null)
      return a;
    let t;
    for (let n = 0; n < a.length; n++)
      this.allowsMarkType(a[n].type) ? t && t.push(a[n]) : t || (t = a.slice(0, n));
    return t ? t.length ? t : Mt.none : a;
  }
  /**
  @internal
  */
  static compile(a, t) {
    let n = /* @__PURE__ */ Object.create(null);
    a.forEach((o, r) => n[o] = new Hm(o, t, r));
    let l = t.spec.topNode || "doc";
    if (!n[l])
      throw new RangeError("Schema is missing its top node type ('" + l + "')");
    if (!n.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let o in n.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return n;
  }
};
function nI(e, a, t) {
  let n = t.split("|");
  return (l) => {
    let o = l === null ? "null" : typeof l;
    if (n.indexOf(o) < 0)
      throw new RangeError(`Expected value of type ${n} for attribute ${a} on type ${e}, got ${o}`);
  };
}
class lI {
  constructor(a, t, n) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(n, "default"), this.default = n.default, this.validate = typeof n.validate == "string" ? nI(a, t, n.validate) : n.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Ms {
  /**
  @internal
  */
  constructor(a, t, n, l) {
    this.name = a, this.rank = t, this.schema = n, this.spec = l, this.attrs = Vm(a, l.attrs), this.excluded = null;
    let o = Pm(this.attrs);
    this.instance = o ? new Mt(this, o) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(a = null) {
    return !a && this.instance ? this.instance : new Mt(this, Fm(this.attrs, a));
  }
  /**
  @internal
  */
  static compile(a, t) {
    let n = /* @__PURE__ */ Object.create(null), l = 0;
    return a.forEach((o, r) => n[o] = new Ms(o, l++, t, r)), n;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(a) {
    for (var t = 0; t < a.length; t++)
      a[t].type == this && (a = a.slice(0, t).concat(a.slice(t + 1)), t--);
    return a;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(a) {
    for (let t = 0; t < a.length; t++)
      if (a[t].type == this)
        return a[t];
  }
  /**
  @internal
  */
  checkAttrs(a) {
    Nm(this.attrs, a, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(a) {
    return this.excluded.indexOf(a) > -1;
  }
}
class jm {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(a) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let l in a)
      t[l] = a[l];
    t.nodes = sa.from(a.nodes), t.marks = sa.from(a.marks || {}), this.nodes = sh.compile(this.spec.nodes, this), this.marks = Ms.compile(this.spec.marks, this);
    let n = /* @__PURE__ */ Object.create(null);
    for (let l in this.nodes) {
      if (l in this.marks)
        throw new RangeError(l + " can not be both a node and a mark");
      let o = this.nodes[l], r = o.spec.content || "", i = o.spec.marks;
      if (o.contentMatch = n[r] || (n[r] = Ml.parse(r, this.nodes)), o.inlineContent = o.contentMatch.inlineContent, o.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!o.isInline || !o.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = o;
      }
      o.markSet = i == "_" ? null : i ? dh(this, i.split(" ")) : i == "" || !o.inlineContent ? [] : null;
    }
    for (let l in this.marks) {
      let o = this.marks[l], r = o.spec.excludes;
      o.excluded = r == null ? [o] : r == "" ? [] : dh(this, r.split(" "));
    }
    this.nodeFromJSON = (l) => Qn.fromJSON(this, l), this.markFromJSON = (l) => Mt.fromJSON(this, l), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(a, t = null, n, l) {
    if (typeof a == "string")
      a = this.nodeType(a);
    else if (a instanceof sh) {
      if (a.schema != this)
        throw new RangeError("Node type from different schema used (" + a.name + ")");
    } else throw new RangeError("Invalid node type: " + a);
    return a.createChecked(t, n, l);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(a, t) {
    let n = this.nodes.text;
    return new Fi(n, n.defaultAttrs, a, Mt.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(a, t) {
    return typeof a == "string" && (a = this.marks[a]), a.create(t);
  }
  /**
  @internal
  */
  nodeType(a) {
    let t = this.nodes[a];
    if (!t)
      throw new RangeError("Unknown node type: " + a);
    return t;
  }
}
function dh(e, a) {
  let t = [];
  for (let n = 0; n < a.length; n++) {
    let l = a[n], o = e.marks[l], r = o;
    if (o)
      t.push(o);
    else
      for (let i in e.marks) {
        let s = e.marks[i];
        (l == "_" || s.spec.group && s.spec.group.split(" ").indexOf(l) > -1) && t.push(r = s);
      }
    if (!r)
      throw new SyntaxError("Unknown mark type: '" + a[n] + "'");
  }
  return t;
}
function oI(e) {
  return e.tag != null;
}
function rI(e) {
  return e.style != null;
}
class _n {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(a, t) {
    this.schema = a, this.rules = t, this.tags = [], this.styles = [];
    let n = this.matchedStyles = [];
    t.forEach((l) => {
      if (oI(l))
        this.tags.push(l);
      else if (rI(l)) {
        let o = /[^=]*/.exec(l.style)[0];
        n.indexOf(o) < 0 && n.push(o), this.styles.push(l);
      }
    }), this.normalizeLists = !this.tags.some((l) => {
      if (!/^(ul|ol)\b/.test(l.tag) || !l.node)
        return !1;
      let o = a.nodes[l.node];
      return o.contentMatch.matchType(o);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(a, t = {}) {
    let n = new ch(this, t, !1);
    return n.addAll(a, Mt.none, t.from, t.to), n.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(a, t = {}) {
    let n = new ch(this, t, !0);
    return n.addAll(a, Mt.none, t.from, t.to), tt.maxOpen(n.finish());
  }
  /**
  @internal
  */
  matchTag(a, t, n) {
    for (let l = n ? this.tags.indexOf(n) + 1 : 0; l < this.tags.length; l++) {
      let o = this.tags[l];
      if (dI(a, o.tag) && (o.namespace === void 0 || a.namespaceURI == o.namespace) && (!o.context || t.matchesContext(o.context))) {
        if (o.getAttrs) {
          let r = o.getAttrs(a);
          if (r === !1)
            continue;
          o.attrs = r || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(a, t, n, l) {
    for (let o = l ? this.styles.indexOf(l) + 1 : 0; o < this.styles.length; o++) {
      let r = this.styles[o], i = r.style;
      if (!(i.indexOf(a) != 0 || r.context && !n.matchesContext(r.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      i.length > a.length && (i.charCodeAt(a.length) != 61 || i.slice(a.length + 1) != t))) {
        if (r.getAttrs) {
          let s = r.getAttrs(t);
          if (s === !1)
            continue;
          r.attrs = s || void 0;
        }
        return r;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(a) {
    let t = [];
    function n(l) {
      let o = l.priority == null ? 50 : l.priority, r = 0;
      for (; r < t.length; r++) {
        let i = t[r];
        if ((i.priority == null ? 50 : i.priority) < o)
          break;
      }
      t.splice(r, 0, l);
    }
    for (let l in a.marks) {
      let o = a.marks[l].spec.parseDOM;
      o && o.forEach((r) => {
        n(r = fh(r)), r.mark || r.ignore || r.clearMark || (r.mark = l);
      });
    }
    for (let l in a.nodes) {
      let o = a.nodes[l].spec.parseDOM;
      o && o.forEach((r) => {
        n(r = fh(r)), r.node || r.ignore || r.mark || (r.node = l);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(a) {
    return a.cached.domParser || (a.cached.domParser = new _n(a, _n.schemaRules(a)));
  }
}
const Wm = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, iI = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, qm = { ol: !0, ul: !0 }, mr = 1, pu = 2, Qo = 4;
function uh(e, a, t) {
  return a != null ? (a ? mr : 0) | (a === "full" ? pu : 0) : e && e.whitespace == "pre" ? mr | pu : t & ~Qo;
}
class Yr {
  constructor(a, t, n, l, o, r) {
    this.type = a, this.attrs = t, this.marks = n, this.solid = l, this.options = r, this.content = [], this.activeMarks = Mt.none, this.match = o || (r & Qo ? null : a.contentMatch);
  }
  findWrapping(a) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(We.from(a));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let n = this.type.contentMatch, l;
        return (l = n.findWrapping(a.type)) ? (this.match = n, l) : null;
      }
    }
    return this.match.findWrapping(a.type);
  }
  finish(a) {
    if (!(this.options & mr)) {
      let n = this.content[this.content.length - 1], l;
      if (n && n.isText && (l = /[ \t\r\n\u000c]+$/.exec(n.text))) {
        let o = n;
        n.text.length == l[0].length ? this.content.pop() : this.content[this.content.length - 1] = o.withText(o.text.slice(0, o.text.length - l[0].length));
      }
    }
    let t = We.from(this.content);
    return !a && this.match && (t = t.append(this.match.fillBefore(We.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(a) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : a.parentNode && !Wm.hasOwnProperty(a.parentNode.nodeName.toLowerCase());
  }
}
class ch {
  constructor(a, t, n) {
    this.parser = a, this.options = t, this.isOpen = n, this.open = 0, this.localPreserveWS = !1;
    let l = t.topNode, o, r = uh(null, t.preserveWhitespace, 0) | (n ? Qo : 0);
    l ? o = new Yr(l.type, l.attrs, Mt.none, !0, t.topMatch || l.type.contentMatch, r) : n ? o = new Yr(null, null, Mt.none, !0, null, r) : o = new Yr(a.schema.topNodeType, null, Mt.none, !0, null, r), this.nodes = [o], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(a, t) {
    a.nodeType == 3 ? this.addTextNode(a, t) : a.nodeType == 1 && this.addElement(a, t);
  }
  addTextNode(a, t) {
    let n = a.nodeValue, l = this.top, o = l.options & pu ? "full" : this.localPreserveWS || (l.options & mr) > 0, { schema: r } = this.parser;
    if (o === "full" || l.inlineContext(a) || /[^ \t\r\n\u000c]/.test(n)) {
      if (o)
        if (o === "full")
          n = n.replace(/\r\n?/g, `
`);
        else if (r.linebreakReplacement && /[\r\n]/.test(n) && this.top.findWrapping(r.linebreakReplacement.create())) {
          let i = n.split(/\r?\n|\r/);
          for (let s = 0; s < i.length; s++)
            s && this.insertNode(r.linebreakReplacement.create(), t, !0), i[s] && this.insertNode(r.text(i[s]), t, !/\S/.test(i[s]));
          n = "";
        } else
          n = n.replace(/\r?\n|\r/g, " ");
      else if (n = n.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(n) && this.open == this.nodes.length - 1) {
        let i = l.content[l.content.length - 1], s = a.previousSibling;
        (!i || s && s.nodeName == "BR" || i.isText && /[ \t\r\n\u000c]$/.test(i.text)) && (n = n.slice(1));
      }
      n && this.insertNode(r.text(n), t, !/\S/.test(n)), this.findInText(a);
    } else
      this.findInside(a);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(a, t, n) {
    let l = this.localPreserveWS, o = this.top;
    (a.tagName == "PRE" || /pre/.test(a.style && a.style.whiteSpace)) && (this.localPreserveWS = !0);
    let r = a.nodeName.toLowerCase(), i;
    qm.hasOwnProperty(r) && this.parser.normalizeLists && sI(a);
    let s = this.options.ruleFromNode && this.options.ruleFromNode(a) || (i = this.parser.matchTag(a, this, n));
    e: if (s ? s.ignore : iI.hasOwnProperty(r))
      this.findInside(a), this.ignoreFallback(a, t);
    else if (!s || s.skip || s.closeParent) {
      s && s.closeParent ? this.open = Math.max(0, this.open - 1) : s && s.skip.nodeType && (a = s.skip);
      let d, c = this.needsBlock;
      if (Wm.hasOwnProperty(r))
        o.content.length && o.content[0].isInline && this.open && (this.open--, o = this.top), d = !0, o.type || (this.needsBlock = !0);
      else if (!a.firstChild) {
        this.leafFallback(a, t);
        break e;
      }
      let f = s && s.skip ? t : this.readStyles(a, t);
      f && this.addAll(a, f), d && this.sync(o), this.needsBlock = c;
    } else {
      let d = this.readStyles(a, t);
      d && this.addElementByRule(a, s, d, s.consuming === !1 ? i : void 0);
    }
    this.localPreserveWS = l;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(a, t) {
    a.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(a.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(a, t) {
    a.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(a, t) {
    let n = a.style;
    if (n && n.length)
      for (let l = 0; l < this.parser.matchedStyles.length; l++) {
        let o = this.parser.matchedStyles[l], r = n.getPropertyValue(o);
        if (r)
          for (let i = void 0; ; ) {
            let s = this.parser.matchStyle(o, r, this, i);
            if (!s)
              break;
            if (s.ignore)
              return null;
            if (s.clearMark ? t = t.filter((d) => !s.clearMark(d)) : t = t.concat(this.parser.schema.marks[s.mark].create(s.attrs)), s.consuming === !1)
              i = s;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(a, t, n, l) {
    let o, r;
    if (t.node)
      if (r = this.parser.schema.nodes[t.node], r.isLeaf)
        this.insertNode(r.create(t.attrs), n, a.nodeName == "BR") || this.leafFallback(a, n);
      else {
        let s = this.enter(r, t.attrs || null, n, t.preserveWhitespace);
        s && (o = !0, n = s);
      }
    else {
      let s = this.parser.schema.marks[t.mark];
      n = n.concat(s.create(t.attrs));
    }
    let i = this.top;
    if (r && r.isLeaf)
      this.findInside(a);
    else if (l)
      this.addElement(a, n, l);
    else if (t.getContent)
      this.findInside(a), t.getContent(a, this.parser.schema).forEach((s) => this.insertNode(s, n, !1));
    else {
      let s = a;
      typeof t.contentElement == "string" ? s = a.querySelector(t.contentElement) : typeof t.contentElement == "function" ? s = t.contentElement(a) : t.contentElement && (s = t.contentElement), this.findAround(a, s, !0), this.addAll(s, n), this.findAround(a, s, !1);
    }
    o && this.sync(i) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(a, t, n, l) {
    let o = n || 0;
    for (let r = n ? a.childNodes[n] : a.firstChild, i = l == null ? null : a.childNodes[l]; r != i; r = r.nextSibling, ++o)
      this.findAtPoint(a, o), this.addDOM(r, t);
    this.findAtPoint(a, o);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(a, t, n) {
    let l, o;
    for (let r = this.open, i = 0; r >= 0; r--) {
      let s = this.nodes[r], d = s.findWrapping(a);
      if (d && (!l || l.length > d.length + i) && (l = d, o = s, !d.length))
        break;
      if (s.solid) {
        if (n)
          break;
        i += 2;
      }
    }
    if (!l)
      return null;
    this.sync(o);
    for (let r = 0; r < l.length; r++)
      t = this.enterInner(l[r], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(a, t, n) {
    if (a.isInline && this.needsBlock && !this.top.type) {
      let o = this.textblockFromContext();
      o && (t = this.enterInner(o, null, t));
    }
    let l = this.findPlace(a, t, n);
    if (l) {
      this.closeExtra();
      let o = this.top;
      o.match && (o.match = o.match.matchType(a.type));
      let r = Mt.none;
      for (let i of l.concat(a.marks))
        (o.type ? o.type.allowsMarkType(i.type) : hh(i.type, a.type)) && (r = i.addToSet(r));
      return o.content.push(a.mark(r)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(a, t, n, l) {
    let o = this.findPlace(a.create(t), n, !1);
    return o && (o = this.enterInner(a, t, n, !0, l)), o;
  }
  // Open a node of the given type
  enterInner(a, t, n, l = !1, o) {
    this.closeExtra();
    let r = this.top;
    r.match = r.match && r.match.matchType(a);
    let i = uh(a, o, r.options);
    r.options & Qo && r.content.length == 0 && (i |= Qo);
    let s = Mt.none;
    return n = n.filter((d) => (r.type ? r.type.allowsMarkType(d.type) : hh(d.type, a)) ? (s = d.addToSet(s), !1) : !0), this.nodes.push(new Yr(a, t, s, l, null, i)), this.open++, n;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(a = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(a));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(a) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == a)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= mr);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let a = 0;
    for (let t = this.open; t >= 0; t--) {
      let n = this.nodes[t].content;
      for (let l = n.length - 1; l >= 0; l--)
        a += n[l].nodeSize;
      t && a++;
    }
    return a;
  }
  findAtPoint(a, t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == a && this.find[n].offset == t && (this.find[n].pos = this.currentPos);
  }
  findInside(a) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && a.nodeType == 1 && a.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(a, t, n) {
    if (a != t && this.find)
      for (let l = 0; l < this.find.length; l++)
        this.find[l].pos == null && a.nodeType == 1 && a.contains(this.find[l].node) && t.compareDocumentPosition(this.find[l].node) & (n ? 2 : 4) && (this.find[l].pos = this.currentPos);
  }
  findInText(a) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == a && (this.find[t].pos = this.currentPos - (a.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(a) {
    if (a.indexOf("|") > -1)
      return a.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = a.split("/"), n = this.options.context, l = !this.isOpen && (!n || n.parent.type == this.nodes[0].type), o = -(n ? n.depth + 1 : 0) + (l ? 0 : 1), r = (i, s) => {
      for (; i >= 0; i--) {
        let d = t[i];
        if (d == "") {
          if (i == t.length - 1 || i == 0)
            continue;
          for (; s >= o; s--)
            if (r(i - 1, s))
              return !0;
          return !1;
        } else {
          let c = s > 0 || s == 0 && l ? this.nodes[s].type : n && s >= o ? n.node(s - o).type : null;
          if (!c || c.name != d && !c.isInGroup(d))
            return !1;
          s--;
        }
      }
      return !0;
    };
    return r(t.length - 1, this.open);
  }
  textblockFromContext() {
    let a = this.options.context;
    if (a)
      for (let t = a.depth; t >= 0; t--) {
        let n = a.node(t).contentMatchAt(a.indexAfter(t)).defaultType;
        if (n && n.isTextblock && n.defaultAttrs)
          return n;
      }
    for (let t in this.parser.schema.nodes) {
      let n = this.parser.schema.nodes[t];
      if (n.isTextblock && n.defaultAttrs)
        return n;
    }
  }
}
function sI(e) {
  for (let a = e.firstChild, t = null; a; a = a.nextSibling) {
    let n = a.nodeType == 1 ? a.nodeName.toLowerCase() : null;
    n && qm.hasOwnProperty(n) && t ? (t.appendChild(a), a = t) : n == "li" ? t = a : n && (t = null);
  }
}
function dI(e, a) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, a);
}
function fh(e) {
  let a = {};
  for (let t in e)
    a[t] = e[t];
  return a;
}
function hh(e, a) {
  let t = a.schema.nodes;
  for (let n in t) {
    let l = t[n];
    if (!l.allowsMarkType(e))
      continue;
    let o = [], r = (i) => {
      o.push(i);
      for (let s = 0; s < i.edgeCount; s++) {
        let { type: d, next: c } = i.edge(s);
        if (d == a || o.indexOf(c) < 0 && r(c))
          return !0;
      }
    };
    if (r(l.contentMatch))
      return !0;
  }
}
class Vl {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(a, t) {
    this.nodes = a, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(a, t = {}, n) {
    n || (n = Jr(t).createDocumentFragment());
    let l = n, o = [];
    return a.forEach((r) => {
      if (o.length || r.marks.length) {
        let i = 0, s = 0;
        for (; i < o.length && s < r.marks.length; ) {
          let d = r.marks[s];
          if (!this.marks[d.type.name]) {
            s++;
            continue;
          }
          if (!d.eq(o[i][0]) || d.type.spec.spanning === !1)
            break;
          i++, s++;
        }
        for (; i < o.length; )
          l = o.pop()[1];
        for (; s < r.marks.length; ) {
          let d = r.marks[s++], c = this.serializeMark(d, r.isInline, t);
          c && (o.push([d, l]), l.appendChild(c.dom), l = c.contentDOM || c.dom);
        }
      }
      l.appendChild(this.serializeNodeInner(r, t));
    }), n;
  }
  /**
  @internal
  */
  serializeNodeInner(a, t) {
    if (a.isText)
      return Jr(t).createTextNode(a.text);
    let { dom: n, contentDOM: l } = xi(Jr(t), this.nodes[a.type.name](a), null, a.attrs);
    if (l) {
      if (a.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(a.content, t, l);
    }
    return n;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(a, t = {}) {
    let n = this.serializeNodeInner(a, t);
    for (let l = a.marks.length - 1; l >= 0; l--) {
      let o = this.serializeMark(a.marks[l], a.isInline, t);
      o && ((o.contentDOM || o.dom).appendChild(n), n = o.dom);
    }
    return n;
  }
  /**
  @internal
  */
  serializeMark(a, t, n = {}) {
    let l = this.marks[a.type.name];
    return l && xi(Jr(n), l(a, t), null, a.attrs);
  }
  static renderSpec(a, t, n = null, l) {
    return typeof t == "string" ? { dom: a.createTextNode(t) } : xi(a, t, n, l);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(a) {
    return a.cached.domSerializer || (a.cached.domSerializer = new Vl(this.nodesFromSchema(a), this.marksFromSchema(a)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(a) {
    let t = bh(a.nodes);
    return t.text || (t.text = (n) => n.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(a) {
    return bh(a.marks);
  }
}
function bh(e) {
  let a = {};
  for (let t in e) {
    let n = e[t].spec.toDOM;
    n && (a[t] = n);
  }
  return a;
}
function Jr(e) {
  return e.document || window.document;
}
const gh = /* @__PURE__ */ new WeakMap();
function uI(e) {
  let a = gh.get(e);
  return a === void 0 && gh.set(e, a = cI(e)), a;
}
function cI(e) {
  let a = null;
  function t(n) {
    if (n && typeof n == "object")
      if (Array.isArray(n))
        if (typeof n[0] == "string")
          a || (a = []), a.push(n);
        else
          for (let l = 0; l < n.length; l++)
            t(n[l]);
      else
        for (let l in n)
          t(n[l]);
  }
  return t(e), a;
}
function xi(e, a, t, n) {
  if (a.nodeType == 1)
    return { dom: a };
  if (a.dom && a.dom.nodeType == 1)
    return a;
  let l = a[0], o;
  if (typeof l != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (n && (o = uI(n)) && o.indexOf(a) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let r = l.indexOf(" ");
  r > 0 && (t = l.slice(0, r), l = l.slice(r + 1));
  let i, s = t ? e.createElementNS(t, l) : e.createElement(l), d = a[1], c = 1;
  if (d && typeof d == "object" && d.nodeType == null && !Array.isArray(d)) {
    c = 2;
    for (let f in d)
      if (d[f] != null) {
        let g = f.indexOf(" ");
        g > 0 ? s.setAttributeNS(f.slice(0, g), f.slice(g + 1), d[f]) : f == "style" && s.style ? s.style.cssText = d[f] : s.setAttribute(f, d[f]);
      }
  }
  for (let f = c; f < a.length; f++) {
    let g = a[f];
    if (g === 0) {
      if (f < a.length - 1 || f > c)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: s, contentDOM: s };
    } else if (typeof g == "string")
      s.appendChild(e.createTextNode(g));
    else {
      let { dom: h, contentDOM: v } = xi(e, g, t, n);
      if (s.appendChild(h), v) {
        if (i)
          throw new RangeError("Multiple content holes");
        i = v;
      }
    }
  }
  return { dom: s, contentDOM: i };
}
const Um = 65535, Gm = Math.pow(2, 16);
function fI(e, a) {
  return e + a * Gm;
}
function mh(e) {
  return e & Um;
}
function hI(e) {
  return (e - (e & Um)) / Gm;
}
const Km = 1, Ym = 2, yi = 4, Jm = 8;
class xu {
  /**
  @internal
  */
  constructor(a, t, n) {
    this.pos = a, this.delInfo = t, this.recover = n;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & Jm) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (Km | yi)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Ym | yi)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & yi) > 0;
  }
}
class Ba {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(a, t = !1) {
    if (this.ranges = a, this.inverted = t, !a.length && Ba.empty)
      return Ba.empty;
  }
  /**
  @internal
  */
  recover(a) {
    let t = 0, n = mh(a);
    if (!this.inverted)
      for (let l = 0; l < n; l++)
        t += this.ranges[l * 3 + 2] - this.ranges[l * 3 + 1];
    return this.ranges[n * 3] + t + hI(a);
  }
  mapResult(a, t = 1) {
    return this._map(a, t, !1);
  }
  map(a, t = 1) {
    return this._map(a, t, !0);
  }
  /**
  @internal
  */
  _map(a, t, n) {
    let l = 0, o = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let s = this.ranges[i] - (this.inverted ? l : 0);
      if (s > a)
        break;
      let d = this.ranges[i + o], c = this.ranges[i + r], f = s + d;
      if (a <= f) {
        let g = d ? a == s ? -1 : a == f ? 1 : t : t, h = s + l + (g < 0 ? 0 : c);
        if (n)
          return h;
        let v = a == (t < 0 ? s : f) ? null : fI(i / 3, a - s), p = a == s ? Ym : a == f ? Km : yi;
        return (t < 0 ? a != s : a != f) && (p |= Jm), new xu(h, p, v);
      }
      l += c - d;
    }
    return n ? a + l : new xu(a + l, 0, null);
  }
  /**
  @internal
  */
  touches(a, t) {
    let n = 0, l = mh(t), o = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let s = this.ranges[i] - (this.inverted ? n : 0);
      if (s > a)
        break;
      let d = this.ranges[i + o], c = s + d;
      if (a <= c && i == l * 3)
        return !0;
      n += this.ranges[i + r] - d;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(a) {
    let t = this.inverted ? 2 : 1, n = this.inverted ? 1 : 2;
    for (let l = 0, o = 0; l < this.ranges.length; l += 3) {
      let r = this.ranges[l], i = r - (this.inverted ? o : 0), s = r + (this.inverted ? 0 : o), d = this.ranges[l + t], c = this.ranges[l + n];
      a(i, i + d, s, s + c), o += c - d;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new Ba(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(a) {
    return a == 0 ? Ba.empty : new Ba(a < 0 ? [0, -a, 0] : [0, 0, a]);
  }
}
Ba.empty = new Ba([]);
class vr {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(a, t, n = 0, l = a ? a.length : 0) {
    this.mirror = t, this.from = n, this.to = l, this._maps = a || [], this.ownData = !(a || t);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(a = 0, t = this.maps.length) {
    return new vr(this._maps, this.mirror, a, t);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(a, t) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(a), t != null && this.setMirror(this._maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(a) {
    for (let t = 0, n = this._maps.length; t < a._maps.length; t++) {
      let l = a.getMirror(t);
      this.appendMap(a._maps[t], l != null && l < t ? n + l : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(a) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == a)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(a, t) {
    this.mirror || (this.mirror = []), this.mirror.push(a, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(a) {
    for (let t = a.maps.length - 1, n = this._maps.length + a._maps.length; t >= 0; t--) {
      let l = a.getMirror(t);
      this.appendMap(a._maps[t].invert(), l != null && l > t ? n - l - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let a = new vr();
    return a.appendMappingInverted(this), a;
  }
  /**
  Map a position through this mapping.
  */
  map(a, t = 1) {
    if (this.mirror)
      return this._map(a, t, !0);
    for (let n = this.from; n < this.to; n++)
      a = this._maps[n].map(a, t);
    return a;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(a, t = 1) {
    return this._map(a, t, !1);
  }
  /**
  @internal
  */
  _map(a, t, n) {
    let l = 0;
    for (let o = this.from; o < this.to; o++) {
      let r = this._maps[o], i = r.mapResult(a, t);
      if (i.recover != null) {
        let s = this.getMirror(o);
        if (s != null && s > o && s < this.to) {
          o = s, a = this._maps[s].recover(i.recover);
          continue;
        }
      }
      l |= i.delInfo, a = i.pos;
    }
    return n ? a : new xu(a, l, null);
  }
}
const fd = /* @__PURE__ */ Object.create(null);
class ya {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return Ba.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(a) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(a, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let n = fd[t.stepType];
    if (!n)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return n.fromJSON(a, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(a, t) {
    if (a in fd)
      throw new RangeError("Duplicate use of step JSON ID " + a);
    return fd[a] = t, t.prototype.jsonID = a, t;
  }
}
class _t {
  /**
  @internal
  */
  constructor(a, t) {
    this.doc = a, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(a) {
    return new _t(a, null);
  }
  /**
  Create a failed step result.
  */
  static fail(a) {
    return new _t(null, a);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(a, t, n, l) {
    try {
      return _t.ok(a.replace(t, n, l));
    } catch (o) {
      if (o instanceof Mi)
        return _t.fail(o.message);
      throw o;
    }
  }
}
function Ec(e, a, t) {
  let n = [];
  for (let l = 0; l < e.childCount; l++) {
    let o = e.child(l);
    o.content.size && (o = o.copy(Ec(o.content, a, o))), o.isInline && (o = a(o, t, l)), n.push(o);
  }
  return We.fromArray(n);
}
class Kn extends ya {
  /**
  Create a mark step.
  */
  constructor(a, t, n) {
    super(), this.from = a, this.to = t, this.mark = n;
  }
  apply(a) {
    let t = a.slice(this.from, this.to), n = a.resolve(this.from), l = n.node(n.sharedDepth(this.to)), o = new tt(Ec(t.content, (r, i) => !r.isAtom || !i.type.allowsMarkType(this.mark.type) ? r : r.mark(this.mark.addToSet(r.marks)), l), t.openStart, t.openEnd);
    return _t.fromReplace(a, this.from, this.to, o);
  }
  invert() {
    return new ln(this.from, this.to, this.mark);
  }
  map(a) {
    let t = a.mapResult(this.from, 1), n = a.mapResult(this.to, -1);
    return t.deleted && n.deleted || t.pos >= n.pos ? null : new Kn(t.pos, n.pos, this.mark);
  }
  merge(a) {
    return a instanceof Kn && a.mark.eq(this.mark) && this.from <= a.to && this.to >= a.from ? new Kn(Math.min(this.from, a.from), Math.max(this.to, a.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(a, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Kn(t.from, t.to, a.markFromJSON(t.mark));
  }
}
ya.jsonID("addMark", Kn);
class ln extends ya {
  /**
  Create a mark-removing step.
  */
  constructor(a, t, n) {
    super(), this.from = a, this.to = t, this.mark = n;
  }
  apply(a) {
    let t = a.slice(this.from, this.to), n = new tt(Ec(t.content, (l) => l.mark(this.mark.removeFromSet(l.marks)), a), t.openStart, t.openEnd);
    return _t.fromReplace(a, this.from, this.to, n);
  }
  invert() {
    return new Kn(this.from, this.to, this.mark);
  }
  map(a) {
    let t = a.mapResult(this.from, 1), n = a.mapResult(this.to, -1);
    return t.deleted && n.deleted || t.pos >= n.pos ? null : new ln(t.pos, n.pos, this.mark);
  }
  merge(a) {
    return a instanceof ln && a.mark.eq(this.mark) && this.from <= a.to && this.to >= a.from ? new ln(Math.min(this.from, a.from), Math.max(this.to, a.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(a, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new ln(t.from, t.to, a.markFromJSON(t.mark));
  }
}
ya.jsonID("removeMark", ln);
class Yn extends ya {
  /**
  Create a node mark step.
  */
  constructor(a, t) {
    super(), this.pos = a, this.mark = t;
  }
  apply(a) {
    let t = a.nodeAt(this.pos);
    if (!t)
      return _t.fail("No node at mark step's position");
    let n = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return _t.fromReplace(a, this.pos, this.pos + 1, new tt(We.from(n), 0, t.isLeaf ? 0 : 1));
  }
  invert(a) {
    let t = a.nodeAt(this.pos);
    if (t) {
      let n = this.mark.addToSet(t.marks);
      if (n.length == t.marks.length) {
        for (let l = 0; l < t.marks.length; l++)
          if (!t.marks[l].isInSet(n))
            return new Yn(this.pos, t.marks[l]);
        return new Yn(this.pos, this.mark);
      }
    }
    return new Ol(this.pos, this.mark);
  }
  map(a) {
    let t = a.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Yn(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(a, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Yn(t.pos, a.markFromJSON(t.mark));
  }
}
ya.jsonID("addNodeMark", Yn);
class Ol extends ya {
  /**
  Create a mark-removing step.
  */
  constructor(a, t) {
    super(), this.pos = a, this.mark = t;
  }
  apply(a) {
    let t = a.nodeAt(this.pos);
    if (!t)
      return _t.fail("No node at mark step's position");
    let n = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return _t.fromReplace(a, this.pos, this.pos + 1, new tt(We.from(n), 0, t.isLeaf ? 0 : 1));
  }
  invert(a) {
    let t = a.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new Yn(this.pos, this.mark);
  }
  map(a) {
    let t = a.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Ol(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(a, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Ol(t.pos, a.markFromJSON(t.mark));
  }
}
ya.jsonID("removeNodeMark", Ol);
class Zt extends ya {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(a, t, n, l = !1) {
    super(), this.from = a, this.to = t, this.slice = n, this.structure = l;
  }
  apply(a) {
    return this.structure && yu(a, this.from, this.to) ? _t.fail("Structure replace would overwrite content") : _t.fromReplace(a, this.from, this.to, this.slice);
  }
  getMap() {
    return new Ba([this.from, this.to - this.from, this.slice.size]);
  }
  invert(a) {
    return new Zt(this.from, this.from + this.slice.size, a.slice(this.from, this.to));
  }
  map(a) {
    let t = a.mapResult(this.to, -1), n = this.from == this.to && Zt.MAP_BIAS < 0 ? t : a.mapResult(this.from, 1);
    return n.deletedAcross && t.deletedAcross ? null : new Zt(n.pos, Math.max(n.pos, t.pos), this.slice, this.structure);
  }
  merge(a) {
    if (!(a instanceof Zt) || a.structure || this.structure)
      return null;
    if (this.from + this.slice.size == a.from && !this.slice.openEnd && !a.slice.openStart) {
      let t = this.slice.size + a.slice.size == 0 ? tt.empty : new tt(this.slice.content.append(a.slice.content), this.slice.openStart, a.slice.openEnd);
      return new Zt(this.from, this.to + (a.to - a.from), t, this.structure);
    } else if (a.to == this.from && !this.slice.openStart && !a.slice.openEnd) {
      let t = this.slice.size + a.slice.size == 0 ? tt.empty : new tt(a.slice.content.append(this.slice.content), a.slice.openStart, this.slice.openEnd);
      return new Zt(a.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let a = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (a.slice = this.slice.toJSON()), this.structure && (a.structure = !0), a;
  }
  /**
  @internal
  */
  static fromJSON(a, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Zt(t.from, t.to, tt.fromJSON(a, t.slice), !!t.structure);
  }
}
Zt.MAP_BIAS = 1;
ya.jsonID("replace", Zt);
class ra extends ya {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(a, t, n, l, o, r, i = !1) {
    super(), this.from = a, this.to = t, this.gapFrom = n, this.gapTo = l, this.slice = o, this.insert = r, this.structure = i;
  }
  apply(a) {
    if (this.structure && (yu(a, this.from, this.gapFrom) || yu(a, this.gapTo, this.to)))
      return _t.fail("Structure gap-replace would overwrite content");
    let t = a.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return _t.fail("Gap is not a flat range");
    let n = this.slice.insertAt(this.insert, t.content);
    return n ? _t.fromReplace(a, this.from, this.to, n) : _t.fail("Content does not fit in gap");
  }
  getMap() {
    return new Ba([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(a) {
    let t = this.gapTo - this.gapFrom;
    return new ra(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, a.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(a) {
    let t = a.mapResult(this.from, 1), n = a.mapResult(this.to, -1), l = this.from == this.gapFrom ? t.pos : a.map(this.gapFrom, -1), o = this.to == this.gapTo ? n.pos : a.map(this.gapTo, 1);
    return t.deletedAcross && n.deletedAcross || l < t.pos || o > n.pos ? null : new ra(t.pos, n.pos, l, o, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let a = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (a.slice = this.slice.toJSON()), this.structure && (a.structure = !0), a;
  }
  /**
  @internal
  */
  static fromJSON(a, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new ra(t.from, t.to, t.gapFrom, t.gapTo, tt.fromJSON(a, t.slice), t.insert, !!t.structure);
  }
}
ya.jsonID("replaceAround", ra);
function yu(e, a, t) {
  let n = e.resolve(a), l = t - a, o = n.depth;
  for (; l > 0 && o > 0 && n.indexAfter(o) == n.node(o).childCount; )
    o--, l--;
  if (l > 0) {
    let r = n.node(o).maybeChild(n.indexAfter(o));
    for (; l > 0; ) {
      if (!r || r.isLeaf)
        return !0;
      r = r.firstChild, l--;
    }
  }
  return !1;
}
function bI(e, a, t, n) {
  let l = [], o = [], r, i;
  e.doc.nodesBetween(a, t, (s, d, c) => {
    if (!s.isInline)
      return;
    let f = s.marks;
    if (!n.isInSet(f) && c.type.allowsMarkType(n.type)) {
      let g = Math.max(d, a), h = Math.min(d + s.nodeSize, t), v = n.addToSet(f);
      for (let p = 0; p < f.length; p++)
        f[p].isInSet(v) || (r && r.to == g && r.mark.eq(f[p]) ? r.to = h : l.push(r = new ln(g, h, f[p])));
      i && i.to == g ? i.to = h : o.push(i = new Kn(g, h, n));
    }
  }), l.forEach((s) => e.step(s)), o.forEach((s) => e.step(s));
}
function gI(e, a, t, n) {
  let l = [], o = 0;
  e.doc.nodesBetween(a, t, (r, i) => {
    if (!r.isInline)
      return;
    o++;
    let s = null;
    if (n instanceof Ms) {
      let d = r.marks, c;
      for (; c = n.isInSet(d); )
        (s || (s = [])).push(c), d = c.removeFromSet(d);
    } else n ? n.isInSet(r.marks) && (s = [n]) : s = r.marks;
    if (s && s.length) {
      let d = Math.min(i + r.nodeSize, t);
      for (let c = 0; c < s.length; c++) {
        let f = s[c], g;
        for (let h = 0; h < l.length; h++) {
          let v = l[h];
          v.step == o - 1 && f.eq(l[h].style) && (g = v);
        }
        g ? (g.to = d, g.step = o) : l.push({ style: f, from: Math.max(i, a), to: d, step: o });
      }
    }
  }), l.forEach((r) => e.step(new ln(r.from, r.to, r.style)));
}
function Ac(e, a, t, n = t.contentMatch, l = !0) {
  let o = e.doc.nodeAt(a), r = [], i = a + 1;
  for (let s = 0; s < o.childCount; s++) {
    let d = o.child(s), c = i + d.nodeSize, f = n.matchType(d.type);
    if (!f)
      r.push(new Zt(i, c, tt.empty));
    else {
      n = f;
      for (let g = 0; g < d.marks.length; g++)
        t.allowsMarkType(d.marks[g].type) || e.step(new ln(i, c, d.marks[g]));
      if (l && d.isText && t.whitespace != "pre") {
        let g, h = /\r?\n|\r/g, v;
        for (; g = h.exec(d.text); )
          v || (v = new tt(We.from(t.schema.text(" ", t.allowedMarks(d.marks))), 0, 0)), r.push(new Zt(i + g.index, i + g.index + g[0].length, v));
      }
    }
    i = c;
  }
  if (!n.validEnd) {
    let s = n.fillBefore(We.empty, !0);
    e.replace(i, i, new tt(s, 0, 0));
  }
  for (let s = r.length - 1; s >= 0; s--)
    e.step(r[s]);
}
function mI(e, a, t) {
  return (a == 0 || e.canReplace(a, e.childCount)) && (t == e.childCount || e.canReplace(0, t));
}
function $o(e) {
  let t = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let n = e.depth, l = 0, o = 0; ; --n) {
    let r = e.$from.node(n), i = e.$from.index(n) + l, s = e.$to.indexAfter(n) - o;
    if (n < e.depth && r.canReplace(i, s, t))
      return n;
    if (n == 0 || r.type.spec.isolating || !mI(r, i, s))
      break;
    i && (l = 1), s < r.childCount && (o = 1);
  }
  return null;
}
function vI(e, a, t) {
  let { $from: n, $to: l, depth: o } = a, r = n.before(o + 1), i = l.after(o + 1), s = r, d = i, c = We.empty, f = 0;
  for (let v = o, p = !1; v > t; v--)
    p || n.index(v) > 0 ? (p = !0, c = We.from(n.node(v).copy(c)), f++) : s--;
  let g = We.empty, h = 0;
  for (let v = o, p = !1; v > t; v--)
    p || l.after(v + 1) < l.end(v) ? (p = !0, g = We.from(l.node(v).copy(g)), h++) : d++;
  e.step(new ra(s, d, r, i, new tt(c.append(g), f, h), c.size - f, !0));
}
function Rc(e, a, t = null, n = e) {
  let l = pI(e, a), o = l && xI(n, a);
  return o ? l.map(vh).concat({ type: a, attrs: t }).concat(o.map(vh)) : null;
}
function vh(e) {
  return { type: e, attrs: null };
}
function pI(e, a) {
  let { parent: t, startIndex: n, endIndex: l } = e, o = t.contentMatchAt(n).findWrapping(a);
  if (!o)
    return null;
  let r = o.length ? o[0] : a;
  return t.canReplaceWith(n, l, r) ? o : null;
}
function xI(e, a) {
  let { parent: t, startIndex: n, endIndex: l } = e, o = t.child(n), r = a.contentMatch.findWrapping(o.type);
  if (!r)
    return null;
  let s = (r.length ? r[r.length - 1] : a).contentMatch;
  for (let d = n; s && d < l; d++)
    s = s.matchType(t.child(d).type);
  return !s || !s.validEnd ? null : r;
}
function yI(e, a, t) {
  let n = We.empty;
  for (let r = t.length - 1; r >= 0; r--) {
    if (n.size) {
      let i = t[r].type.contentMatch.matchFragment(n);
      if (!i || !i.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    n = We.from(t[r].type.create(t[r].attrs, n));
  }
  let l = a.start, o = a.end;
  e.step(new ra(l, o, l, o, new tt(n, 0, 0), t.length, !0));
}
function kI(e, a, t, n, l) {
  if (!n.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let o = e.steps.length;
  e.doc.nodesBetween(a, t, (r, i) => {
    let s = typeof l == "function" ? l(r) : l;
    if (r.isTextblock && !r.hasMarkup(n, s) && wI(e.doc, e.mapping.slice(o).map(i), n)) {
      let d = null;
      if (n.schema.linebreakReplacement) {
        let h = n.whitespace == "pre", v = !!n.contentMatch.matchType(n.schema.linebreakReplacement);
        h && !v ? d = !1 : !h && v && (d = !0);
      }
      d === !1 && Zm(e, r, i, o), Ac(e, e.mapping.slice(o).map(i, 1), n, void 0, d === null);
      let c = e.mapping.slice(o), f = c.map(i, 1), g = c.map(i + r.nodeSize, 1);
      return e.step(new ra(f, g, f + 1, g - 1, new tt(We.from(n.create(s, null, r.marks)), 0, 0), 1, !0)), d === !0 && Xm(e, r, i, o), !1;
    }
  });
}
function Xm(e, a, t, n) {
  a.forEach((l, o) => {
    if (l.isText) {
      let r, i = /\r?\n|\r/g;
      for (; r = i.exec(l.text); ) {
        let s = e.mapping.slice(n).map(t + 1 + o + r.index);
        e.replaceWith(s, s + 1, a.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function Zm(e, a, t, n) {
  a.forEach((l, o) => {
    if (l.type == l.type.schema.linebreakReplacement) {
      let r = e.mapping.slice(n).map(t + 1 + o);
      e.replaceWith(r, r + 1, a.type.schema.text(`
`));
    }
  });
}
function wI(e, a, t) {
  let n = e.resolve(a), l = n.index();
  return n.parent.canReplaceWith(l, l + 1, t);
}
function CI(e, a, t, n, l) {
  let o = e.doc.nodeAt(a);
  if (!o)
    throw new RangeError("No node at given position");
  t || (t = o.type);
  let r = t.create(n, null, l || o.marks);
  if (o.isLeaf)
    return e.replaceWith(a, a + o.nodeSize, r);
  if (!t.validContent(o.content))
    throw new RangeError("Invalid content for node type " + t.name);
  e.step(new ra(a, a + o.nodeSize, a + 1, a + o.nodeSize - 1, new tt(We.from(r), 0, 0), 1, !0));
}
function zn(e, a, t = 1, n) {
  let l = e.resolve(a), o = l.depth - t, r = n && n[n.length - 1] || l.parent;
  if (o < 0 || l.parent.type.spec.isolating || !l.parent.canReplace(l.index(), l.parent.childCount) || !r.type.validContent(l.parent.content.cutByIndex(l.index(), l.parent.childCount)))
    return !1;
  for (let d = l.depth - 1, c = t - 2; d > o; d--, c--) {
    let f = l.node(d), g = l.index(d);
    if (f.type.spec.isolating)
      return !1;
    let h = f.content.cutByIndex(g, f.childCount), v = n && n[c + 1];
    v && (h = h.replaceChild(0, v.type.create(v.attrs)));
    let p = n && n[c] || f;
    if (!f.canReplace(g + 1, f.childCount) || !p.type.validContent(h))
      return !1;
  }
  let i = l.indexAfter(o), s = n && n[0];
  return l.node(o).canReplaceWith(i, i, s ? s.type : l.node(o + 1).type);
}
function SI(e, a, t = 1, n) {
  let l = e.doc.resolve(a), o = We.empty, r = We.empty;
  for (let i = l.depth, s = l.depth - t, d = t - 1; i > s; i--, d--) {
    o = We.from(l.node(i).copy(o));
    let c = n && n[d];
    r = We.from(c ? c.type.create(c.attrs, r) : l.node(i).copy(r));
  }
  e.step(new Zt(a, a, new tt(o.append(r), t, t), !0));
}
function bl(e, a) {
  let t = e.resolve(a), n = t.index();
  return Qm(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(n, n + 1);
}
function $I(e, a) {
  a.content.size || e.type.compatibleContent(a.type);
  let t = e.contentMatchAt(e.childCount), { linebreakReplacement: n } = e.type.schema;
  for (let l = 0; l < a.childCount; l++) {
    let o = a.child(l), r = o.type == n ? e.type.schema.nodes.text : o.type;
    if (t = t.matchType(r), !t || !e.type.allowsMarks(o.marks))
      return !1;
  }
  return t.validEnd;
}
function Qm(e, a) {
  return !!(e && a && !e.isLeaf && $I(e, a));
}
function Os(e, a, t = -1) {
  let n = e.resolve(a);
  for (let l = n.depth; ; l--) {
    let o, r, i = n.index(l);
    if (l == n.depth ? (o = n.nodeBefore, r = n.nodeAfter) : t > 0 ? (o = n.node(l + 1), i++, r = n.node(l).maybeChild(i)) : (o = n.node(l).maybeChild(i - 1), r = n.node(l + 1)), o && !o.isTextblock && Qm(o, r) && n.node(l).canReplace(i, i + 1))
      return a;
    if (l == 0)
      break;
    a = t < 0 ? n.before(l) : n.after(l);
  }
}
function II(e, a, t) {
  let n = null, { linebreakReplacement: l } = e.doc.type.schema, o = e.doc.resolve(a - t), r = o.node().type;
  if (l && r.inlineContent) {
    let c = r.whitespace == "pre", f = !!r.contentMatch.matchType(l);
    c && !f ? n = !1 : !c && f && (n = !0);
  }
  let i = e.steps.length;
  if (n === !1) {
    let c = e.doc.resolve(a + t);
    Zm(e, c.node(), c.before(), i);
  }
  r.inlineContent && Ac(e, a + t - 1, r, o.node().contentMatchAt(o.index()), n == null);
  let s = e.mapping.slice(i), d = s.map(a - t);
  if (e.step(new Zt(d, s.map(a + t, -1), tt.empty, !0)), n === !0) {
    let c = e.doc.resolve(d);
    Xm(e, c.node(), c.before(), e.steps.length);
  }
  return e;
}
function LI(e, a, t) {
  let n = e.resolve(a);
  if (n.parent.canReplaceWith(n.index(), n.index(), t))
    return a;
  if (n.parentOffset == 0)
    for (let l = n.depth - 1; l >= 0; l--) {
      let o = n.index(l);
      if (n.node(l).canReplaceWith(o, o, t))
        return n.before(l + 1);
      if (o > 0)
        return null;
    }
  if (n.parentOffset == n.parent.content.size)
    for (let l = n.depth - 1; l >= 0; l--) {
      let o = n.indexAfter(l);
      if (n.node(l).canReplaceWith(o, o, t))
        return n.after(l + 1);
      if (o < n.node(l).childCount)
        return null;
    }
  return null;
}
function _m(e, a, t) {
  let n = e.resolve(a);
  if (!t.content.size)
    return a;
  let l = t.content;
  for (let o = 0; o < t.openStart; o++)
    l = l.firstChild.content;
  for (let o = 1; o <= (t.openStart == 0 && t.size ? 2 : 1); o++)
    for (let r = n.depth; r >= 0; r--) {
      let i = r == n.depth ? 0 : n.pos <= (n.start(r + 1) + n.end(r + 1)) / 2 ? -1 : 1, s = n.index(r) + (i > 0 ? 1 : 0), d = n.node(r), c = !1;
      if (o == 1)
        c = d.canReplace(s, s, l);
      else {
        let f = d.contentMatchAt(s).findWrapping(l.firstChild.type);
        c = f && d.canReplaceWith(s, s, f[0]);
      }
      if (c)
        return i == 0 ? n.pos : i < 0 ? n.before(r + 1) : n.after(r + 1);
    }
  return null;
}
function Ps(e, a, t = a, n = tt.empty) {
  if (a == t && !n.size)
    return null;
  let l = e.resolve(a), o = e.resolve(t);
  return ev(l, o, n) ? new Zt(a, t, n) : new TI(l, o, n).fit();
}
function ev(e, a, t) {
  return !t.openStart && !t.openEnd && e.start() == a.start() && e.parent.canReplace(e.index(), a.index(), t.content);
}
class TI {
  constructor(a, t, n) {
    this.$from = a, this.$to = t, this.unplaced = n, this.frontier = [], this.placed = We.empty;
    for (let l = 0; l <= a.depth; l++) {
      let o = a.node(l);
      this.frontier.push({
        type: o.type,
        match: o.contentMatchAt(a.indexAfter(l))
      });
    }
    for (let l = a.depth; l > 0; l--)
      this.placed = We.from(a.node(l).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let d = this.findFittable();
      d ? this.placeNodes(d) : this.openMore() || this.dropNode();
    }
    let a = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, n = this.$from, l = this.close(a < 0 ? this.$to : n.doc.resolve(a));
    if (!l)
      return null;
    let o = this.placed, r = n.depth, i = l.depth;
    for (; r && i && o.childCount == 1; )
      o = o.firstChild.content, r--, i--;
    let s = new tt(o, r, i);
    return a > -1 ? new ra(n.pos, a, this.$to.pos, this.$to.end(), s, t) : s.size || n.pos != this.$to.pos ? new Zt(n.pos, l.pos, s) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let a = this.unplaced.openStart;
    for (let t = this.unplaced.content, n = 0, l = this.unplaced.openEnd; n < a; n++) {
      let o = t.firstChild;
      if (t.childCount > 1 && (l = 0), o.type.spec.isolating && l <= n) {
        a = n;
        break;
      }
      t = o.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let n = t == 1 ? a : this.unplaced.openStart; n >= 0; n--) {
        let l, o = null;
        n ? (o = hd(this.unplaced.content, n - 1).firstChild, l = o.content) : l = this.unplaced.content;
        let r = l.firstChild;
        for (let i = this.depth; i >= 0; i--) {
          let { type: s, match: d } = this.frontier[i], c, f = null;
          if (t == 1 && (r ? d.matchType(r.type) || (f = d.fillBefore(We.from(r), !1)) : o && s.compatibleContent(o.type)))
            return { sliceDepth: n, frontierDepth: i, parent: o, inject: f };
          if (t == 2 && r && (c = d.findWrapping(r.type)))
            return { sliceDepth: n, frontierDepth: i, parent: o, wrap: c };
          if (o && d.matchType(o.type))
            break;
        }
      }
  }
  openMore() {
    let { content: a, openStart: t, openEnd: n } = this.unplaced, l = hd(a, t);
    return !l.childCount || l.firstChild.isLeaf ? !1 : (this.unplaced = new tt(a, t + 1, Math.max(n, l.size + t >= a.size - n ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: a, openStart: t, openEnd: n } = this.unplaced, l = hd(a, t);
    if (l.childCount <= 1 && t > 0) {
      let o = a.size - t <= t + l.size;
      this.unplaced = new tt(Ho(a, t - 1, 1), t - 1, o ? t - 1 : n);
    } else
      this.unplaced = new tt(Ho(a, t, 1), t, n);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: a, frontierDepth: t, parent: n, inject: l, wrap: o }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (o)
      for (let p = 0; p < o.length; p++)
        this.openFrontierNode(o[p]);
    let r = this.unplaced, i = n ? n.content : r.content, s = r.openStart - a, d = 0, c = [], { match: f, type: g } = this.frontier[t];
    if (l) {
      for (let p = 0; p < l.childCount; p++)
        c.push(l.child(p));
      f = f.matchFragment(l);
    }
    let h = i.size + a - (r.content.size - r.openEnd);
    for (; d < i.childCount; ) {
      let p = i.child(d), y = f.matchType(p.type);
      if (!y)
        break;
      d++, (d > 1 || s == 0 || p.content.size) && (f = y, c.push(tv(p.mark(g.allowedMarks(p.marks)), d == 1 ? s : 0, d == i.childCount ? h : -1)));
    }
    let v = d == i.childCount;
    v || (h = -1), this.placed = jo(this.placed, t, We.from(c)), this.frontier[t].match = f, v && h < 0 && n && n.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let p = 0, y = i; p < h; p++) {
      let k = y.lastChild;
      this.frontier.push({ type: k.type, match: k.contentMatchAt(k.childCount) }), y = k.content;
    }
    this.unplaced = v ? a == 0 ? tt.empty : new tt(Ho(r.content, a - 1, 1), a - 1, h < 0 ? r.openEnd : a - 1) : new tt(Ho(r.content, a, d), r.openStart, r.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let a = this.frontier[this.depth], t;
    if (!a.type.isTextblock || !bd(this.$to, this.$to.depth, a.type, a.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: n } = this.$to, l = this.$to.after(n);
    for (; n > 1 && l == this.$to.end(--n); )
      ++l;
    return l;
  }
  findCloseLevel(a) {
    e: for (let t = Math.min(this.depth, a.depth); t >= 0; t--) {
      let { match: n, type: l } = this.frontier[t], o = t < a.depth && a.end(t + 1) == a.pos + (a.depth - (t + 1)), r = bd(a, t, l, n, o);
      if (r) {
        for (let i = t - 1; i >= 0; i--) {
          let { match: s, type: d } = this.frontier[i], c = bd(a, i, d, s, !0);
          if (!c || c.childCount)
            continue e;
        }
        return { depth: t, fit: r, move: o ? a.doc.resolve(a.after(t + 1)) : a };
      }
    }
  }
  close(a) {
    let t = this.findCloseLevel(a);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = jo(this.placed, t.depth, t.fit)), a = t.move;
    for (let n = t.depth + 1; n <= a.depth; n++) {
      let l = a.node(n), o = l.type.contentMatch.fillBefore(l.content, !0, a.index(n));
      this.openFrontierNode(l.type, l.attrs, o);
    }
    return a;
  }
  openFrontierNode(a, t = null, n) {
    let l = this.frontier[this.depth];
    l.match = l.match.matchType(a), this.placed = jo(this.placed, this.depth, We.from(a.create(t, n))), this.frontier.push({ type: a, match: a.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(We.empty, !0);
    t.childCount && (this.placed = jo(this.placed, this.frontier.length, t));
  }
}
function Ho(e, a, t) {
  return a == 0 ? e.cutByIndex(t, e.childCount) : e.replaceChild(0, e.firstChild.copy(Ho(e.firstChild.content, a - 1, t)));
}
function jo(e, a, t) {
  return a == 0 ? e.append(t) : e.replaceChild(e.childCount - 1, e.lastChild.copy(jo(e.lastChild.content, a - 1, t)));
}
function hd(e, a) {
  for (let t = 0; t < a; t++)
    e = e.firstChild.content;
  return e;
}
function tv(e, a, t) {
  if (a <= 0)
    return e;
  let n = e.content;
  return a > 1 && (n = n.replaceChild(0, tv(n.firstChild, a - 1, n.childCount == 1 ? t - 1 : 0))), a > 0 && (n = e.type.contentMatch.fillBefore(n).append(n), t <= 0 && (n = n.append(e.type.contentMatch.matchFragment(n).fillBefore(We.empty, !0)))), e.copy(n);
}
function bd(e, a, t, n, l) {
  let o = e.node(a), r = l ? e.indexAfter(a) : e.index(a);
  if (r == o.childCount && !t.compatibleContent(o.type))
    return null;
  let i = n.fillBefore(o.content, !0, r);
  return i && !EI(t, o.content, r) ? i : null;
}
function EI(e, a, t) {
  for (let n = t; n < a.childCount; n++)
    if (!e.allowsMarks(a.child(n).marks))
      return !0;
  return !1;
}
function AI(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function RI(e, a, t, n) {
  if (!n.size)
    return e.deleteRange(a, t);
  let l = e.doc.resolve(a), o = e.doc.resolve(t);
  if (ev(l, o, n))
    return e.step(new Zt(a, t, n));
  let r = nv(l, o);
  r[r.length - 1] == 0 && r.pop();
  let i = -(l.depth + 1);
  r.unshift(i);
  for (let g = l.depth, h = l.pos - 1; g > 0; g--, h--) {
    let v = l.node(g).type.spec;
    if (v.defining || v.definingAsContext || v.isolating)
      break;
    r.indexOf(g) > -1 ? i = g : l.before(g) == h && r.splice(1, 0, -g);
  }
  let s = r.indexOf(i), d = [], c = n.openStart;
  for (let g = n.content, h = 0; ; h++) {
    let v = g.firstChild;
    if (d.push(v), h == n.openStart)
      break;
    g = v.content;
  }
  for (let g = c - 1; g >= 0; g--) {
    let h = d[g], v = AI(h.type);
    if (v && !h.sameMarkup(l.node(Math.abs(i) - 1)))
      c = g;
    else if (v || !h.type.isTextblock)
      break;
  }
  for (let g = n.openStart; g >= 0; g--) {
    let h = (g + c + 1) % (n.openStart + 1), v = d[h];
    if (v)
      for (let p = 0; p < r.length; p++) {
        let y = r[(p + s) % r.length], k = !0;
        y < 0 && (k = !1, y = -y);
        let $ = l.node(y - 1), S = l.index(y - 1);
        if ($.canReplaceWith(S, S, v.type, v.marks))
          return e.replace(l.before(y), k ? o.after(y) : t, new tt(av(n.content, 0, n.openStart, h), h, n.openEnd));
      }
  }
  let f = e.steps.length;
  for (let g = r.length - 1; g >= 0 && (e.replace(a, t, n), !(e.steps.length > f)); g--) {
    let h = r[g];
    h < 0 || (a = l.before(h), t = o.after(h));
  }
}
function av(e, a, t, n, l) {
  if (a < t) {
    let o = e.firstChild;
    e = e.replaceChild(0, o.copy(av(o.content, a + 1, t, n, o)));
  }
  if (a > n) {
    let o = l.contentMatchAt(0), r = o.fillBefore(e).append(e);
    e = r.append(o.matchFragment(r).fillBefore(We.empty, !0));
  }
  return e;
}
function zI(e, a, t, n) {
  if (!n.isInline && a == t && e.doc.resolve(a).parent.content.size) {
    let l = LI(e.doc, a, n.type);
    l != null && (a = t = l);
  }
  e.replaceRange(a, t, new tt(We.from(n), 0, 0));
}
function DI(e, a, t) {
  let n = e.doc.resolve(a), l = e.doc.resolve(t);
  if (n.parent.isTextblock && l.parent.isTextblock && n.start() != l.start() && n.parentOffset == 0 && l.parentOffset == 0) {
    let r = n.sharedDepth(t), i = !1;
    for (let s = n.depth; s > r; s--)
      n.node(s).type.spec.isolating && (i = !0);
    for (let s = l.depth; s > r; s--)
      l.node(s).type.spec.isolating && (i = !0);
    if (!i) {
      for (let s = n.depth; s > 0 && a == n.start(s); s--)
        a = n.before(s);
      for (let s = l.depth; s > 0 && t == l.start(s); s--)
        t = l.before(s);
      n = e.doc.resolve(a), l = e.doc.resolve(t);
    }
  }
  let o = nv(n, l);
  for (let r = 0; r < o.length; r++) {
    let i = o[r], s = r == o.length - 1;
    if (s && i == 0 || n.node(i).type.contentMatch.validEnd)
      return e.delete(n.start(i), l.end(i));
    if (i > 0 && (s || n.node(i - 1).canReplace(n.index(i - 1), l.indexAfter(i - 1))))
      return e.delete(n.before(i), l.after(i));
  }
  for (let r = 1; r <= n.depth && r <= l.depth; r++)
    if (a - n.start(r) == n.depth - r && t > n.end(r) && l.end(r) - t != l.depth - r && n.start(r - 1) == l.start(r - 1) && n.node(r - 1).canReplace(n.index(r - 1), l.index(r - 1)))
      return e.delete(n.before(r), t);
  e.delete(a, t);
}
function nv(e, a) {
  let t = [], n = Math.min(e.depth, a.depth);
  for (let l = n; l >= 0; l--) {
    let o = e.start(l);
    if (o < e.pos - (e.depth - l) || a.end(l) > a.pos + (a.depth - l) || e.node(l).type.spec.isolating || a.node(l).type.spec.isolating)
      break;
    (o == a.start(l) || l == e.depth && l == a.depth && e.parent.inlineContent && a.parent.inlineContent && l && a.start(l - 1) == o - 1) && t.push(l);
  }
  return t;
}
class no extends ya {
  /**
  Construct an attribute step.
  */
  constructor(a, t, n) {
    super(), this.pos = a, this.attr = t, this.value = n;
  }
  apply(a) {
    let t = a.nodeAt(this.pos);
    if (!t)
      return _t.fail("No node at attribute step's position");
    let n = /* @__PURE__ */ Object.create(null);
    for (let o in t.attrs)
      n[o] = t.attrs[o];
    n[this.attr] = this.value;
    let l = t.type.create(n, null, t.marks);
    return _t.fromReplace(a, this.pos, this.pos + 1, new tt(We.from(l), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return Ba.empty;
  }
  invert(a) {
    return new no(this.pos, this.attr, a.nodeAt(this.pos).attrs[this.attr]);
  }
  map(a) {
    let t = a.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new no(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(a, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new no(t.pos, t.attr, t.value);
  }
}
ya.jsonID("attr", no);
class pr extends ya {
  /**
  Construct an attribute step.
  */
  constructor(a, t) {
    super(), this.attr = a, this.value = t;
  }
  apply(a) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let l in a.attrs)
      t[l] = a.attrs[l];
    t[this.attr] = this.value;
    let n = a.type.create(t, a.content, a.marks);
    return _t.ok(n);
  }
  getMap() {
    return Ba.empty;
  }
  invert(a) {
    return new pr(this.attr, a.attrs[this.attr]);
  }
  map(a) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(a, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new pr(t.attr, t.value);
  }
}
ya.jsonID("docAttr", pr);
let bo = class extends Error {
};
bo = function e(a) {
  let t = Error.call(this, a);
  return t.__proto__ = e.prototype, t;
};
bo.prototype = Object.create(Error.prototype);
bo.prototype.constructor = bo;
bo.prototype.name = "TransformError";
class lv {
  /**
  Create a transform that starts with the given document.
  */
  constructor(a) {
    this.doc = a, this.steps = [], this.docs = [], this.mapping = new vr();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(a) {
    let t = this.maybeStep(a);
    if (t.failed)
      throw new bo(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(a) {
    let t = a.apply(this.doc);
    return t.failed || this.addStep(a, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  Return a single range, in post-transform document positions,
  that covers all content changed by this transform. Returns null
  if no replacements are made. Note that this will ignore changes
  that add/remove marks without replacing the underlying content.
  */
  changedRange() {
    let a = 1e9, t = -1e9;
    for (let n = 0; n < this.mapping.maps.length; n++) {
      let l = this.mapping.maps[n];
      n && (a = l.map(a, 1), t = l.map(t, -1)), l.forEach((o, r, i, s) => {
        a = Math.min(a, i), t = Math.max(t, s);
      });
    }
    return a == 1e9 ? null : { from: a, to: t };
  }
  /**
  @internal
  */
  addStep(a, t) {
    this.docs.push(this.doc), this.steps.push(a), this.mapping.appendMap(a.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(a, t = a, n = tt.empty) {
    let l = Ps(this.doc, a, t, n);
    return l && this.step(l), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(a, t, n) {
    return this.replace(a, t, new tt(We.from(n), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(a, t) {
    return this.replace(a, t, tt.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(a, t) {
    return this.replaceWith(a, a, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(a, t, n) {
    return RI(this, a, t, n), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(a, t, n) {
    return zI(this, a, t, n), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(a, t) {
    return DI(this, a, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(a, t) {
    return vI(this, a, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(a, t = 1) {
    return II(this, a, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(a, t) {
    return yI(this, a, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(a, t = a, n, l = null) {
    return kI(this, a, t, n, l), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(a, t, n = null, l) {
    return CI(this, a, t, n, l), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(a, t, n) {
    return this.step(new no(a, t, n)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(a, t) {
    return this.step(new pr(a, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(a, t) {
    return this.step(new Yn(a, t)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(a, t) {
    let n = this.doc.nodeAt(a);
    if (!n)
      throw new RangeError("No node at position " + a);
    if (t instanceof Mt)
      t.isInSet(n.marks) && this.step(new Ol(a, t));
    else {
      let l = n.marks, o, r = [];
      for (; o = t.isInSet(l); )
        r.push(new Ol(a, o)), l = o.removeFromSet(l);
      for (let i = r.length - 1; i >= 0; i--)
        this.step(r[i]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(a, t = 1, n) {
    return SI(this, a, t, n), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(a, t, n) {
    return bI(this, a, t, n), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(a, t, n) {
    return gI(this, a, t, n), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(a, t, n) {
    return Ac(this, a, t, n), this;
  }
}
const gd = /* @__PURE__ */ Object.create(null);
class xt {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(a, t, n) {
    this.$anchor = a, this.$head = t, this.ranges = n || [new BI(a.min(t), a.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let a = this.ranges;
    for (let t = 0; t < a.length; t++)
      if (a[t].$from.pos != a[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(a, t = tt.empty) {
    let n = t.content.lastChild, l = null;
    for (let i = 0; i < t.openEnd; i++)
      l = n, n = n.lastChild;
    let o = a.steps.length, r = this.ranges;
    for (let i = 0; i < r.length; i++) {
      let { $from: s, $to: d } = r[i], c = a.mapping.slice(o);
      a.replaceRange(c.map(s.pos), c.map(d.pos), i ? tt.empty : t), i == 0 && yh(a, o, (n ? n.isInline : l && l.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(a, t) {
    let n = a.steps.length, l = this.ranges;
    for (let o = 0; o < l.length; o++) {
      let { $from: r, $to: i } = l[o], s = a.mapping.slice(n), d = s.map(r.pos), c = s.map(i.pos);
      o ? a.deleteRange(d, c) : (a.replaceRangeWith(d, c, t), yh(a, n, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(a, t, n = !1) {
    let l = a.parent.inlineContent ? new ht(a) : Jl(a.node(0), a.parent, a.pos, a.index(), t, n);
    if (l)
      return l;
    for (let o = a.depth - 1; o >= 0; o--) {
      let r = t < 0 ? Jl(a.node(0), a.node(o), a.before(o + 1), a.index(o), t, n) : Jl(a.node(0), a.node(o), a.after(o + 1), a.index(o) + 1, t, n);
      if (r)
        return r;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(a, t = 1) {
    return this.findFrom(a, t) || this.findFrom(a, -t) || new Ma(a.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(a) {
    return Jl(a, a, 0, 0, 1) || new Ma(a);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(a) {
    return Jl(a, a, a.content.size, a.childCount, -1) || new Ma(a);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(a, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let n = gd[t.type];
    if (!n)
      throw new RangeError(`No selection type ${t.type} defined`);
    return n.fromJSON(a, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(a, t) {
    if (a in gd)
      throw new RangeError("Duplicate use of selection JSON ID " + a);
    return gd[a] = t, t.prototype.jsonID = a, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return ht.between(this.$anchor, this.$head).getBookmark();
  }
}
xt.prototype.visible = !0;
class BI {
  /**
  Create a range.
  */
  constructor(a, t) {
    this.$from = a, this.$to = t;
  }
}
let ph = !1;
function xh(e) {
  !ph && !e.parent.inlineContent && (ph = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class ht extends xt {
  /**
  Construct a text selection between the given points.
  */
  constructor(a, t = a) {
    xh(a), xh(t), super(a, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(a, t) {
    let n = a.resolve(t.map(this.head));
    if (!n.parent.inlineContent)
      return xt.near(n);
    let l = a.resolve(t.map(this.anchor));
    return new ht(l.parent.inlineContent ? l : n, n);
  }
  replace(a, t = tt.empty) {
    if (super.replace(a, t), t == tt.empty) {
      let n = this.$from.marksAcross(this.$to);
      n && a.ensureMarks(n);
    }
  }
  eq(a) {
    return a instanceof ht && a.anchor == this.anchor && a.head == this.head;
  }
  getBookmark() {
    return new Fs(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(a, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new ht(a.resolve(t.anchor), a.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(a, t, n = t) {
    let l = a.resolve(t);
    return new this(l, n == t ? l : a.resolve(n));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(a, t, n) {
    let l = a.pos - t.pos;
    if ((!n || l) && (n = l >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let o = xt.findFrom(t, n, !0) || xt.findFrom(t, -n, !0);
      if (o)
        t = o.$head;
      else
        return xt.near(t, n);
    }
    return a.parent.inlineContent || (l == 0 ? a = t : (a = (xt.findFrom(a, -n, !0) || xt.findFrom(a, n, !0)).$anchor, a.pos < t.pos != l < 0 && (a = t))), new ht(a, t);
  }
}
xt.jsonID("text", ht);
class Fs {
  constructor(a, t) {
    this.anchor = a, this.head = t;
  }
  map(a) {
    return new Fs(a.map(this.anchor), a.map(this.head));
  }
  resolve(a) {
    return ht.between(a.resolve(this.anchor), a.resolve(this.head));
  }
}
class dt extends xt {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(a) {
    let t = a.nodeAfter, n = a.node(0).resolve(a.pos + t.nodeSize);
    super(a, n), this.node = t;
  }
  map(a, t) {
    let { deleted: n, pos: l } = t.mapResult(this.anchor), o = a.resolve(l);
    return n ? xt.near(o) : new dt(o);
  }
  content() {
    return new tt(We.from(this.node), 0, 0);
  }
  eq(a) {
    return a instanceof dt && a.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new zc(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(a, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new dt(a.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(a, t) {
    return new dt(a.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(a) {
    return !a.isText && a.type.spec.selectable !== !1;
  }
}
dt.prototype.visible = !1;
xt.jsonID("node", dt);
class zc {
  constructor(a) {
    this.anchor = a;
  }
  map(a) {
    let { deleted: t, pos: n } = a.mapResult(this.anchor);
    return t ? new Fs(n, n) : new zc(n);
  }
  resolve(a) {
    let t = a.resolve(this.anchor), n = t.nodeAfter;
    return n && dt.isSelectable(n) ? new dt(t) : xt.near(t);
  }
}
class Ma extends xt {
  /**
  Create an all-selection over the given document.
  */
  constructor(a) {
    super(a.resolve(0), a.resolve(a.content.size));
  }
  replace(a, t = tt.empty) {
    if (t == tt.empty) {
      a.delete(0, a.doc.content.size);
      let n = xt.atStart(a.doc);
      n.eq(a.selection) || a.setSelection(n);
    } else
      super.replace(a, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(a) {
    return new Ma(a);
  }
  map(a) {
    return new Ma(a);
  }
  eq(a) {
    return a instanceof Ma;
  }
  getBookmark() {
    return MI;
  }
}
xt.jsonID("all", Ma);
const MI = {
  map() {
    return this;
  },
  resolve(e) {
    return new Ma(e);
  }
};
function Jl(e, a, t, n, l, o = !1) {
  if (a.inlineContent)
    return ht.create(e, t);
  for (let r = n - (l > 0 ? 0 : 1); l > 0 ? r < a.childCount : r >= 0; r += l) {
    let i = a.child(r);
    if (i.isAtom) {
      if (!o && dt.isSelectable(i))
        return dt.create(e, t - (l < 0 ? i.nodeSize : 0));
    } else {
      let s = Jl(e, i, t + l, l < 0 ? i.childCount : 0, l, o);
      if (s)
        return s;
    }
    t += i.nodeSize * l;
  }
  return null;
}
function yh(e, a, t) {
  let n = e.steps.length - 1;
  if (n < a)
    return;
  let l = e.steps[n];
  if (!(l instanceof Zt || l instanceof ra))
    return;
  let o = e.mapping.maps[n], r;
  o.forEach((i, s, d, c) => {
    r == null && (r = c);
  }), e.setSelection(xt.near(e.doc.resolve(r), t));
}
const kh = 1, Xr = 2, wh = 4;
class OI extends lv {
  /**
  @internal
  */
  constructor(a) {
    super(a.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = a.selection, this.storedMarks = a.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(a) {
    if (a.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = a, this.curSelectionFor = this.steps.length, this.updated = (this.updated | kh) & ~Xr, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & kh) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(a) {
    return this.storedMarks = a, this.updated |= Xr, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(a) {
    return Mt.sameSet(this.storedMarks || this.selection.$from.marks(), a) || this.setStoredMarks(a), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(a) {
    return this.ensureMarks(a.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(a) {
    return this.ensureMarks(a.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & Xr) > 0;
  }
  /**
  @internal
  */
  addStep(a, t) {
    super.addStep(a, t), this.updated = this.updated & ~Xr, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(a) {
    return this.time = a, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(a) {
    return this.selection.replace(this, a), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(a, t = !0) {
    let n = this.selection;
    return t && (a = a.mark(this.storedMarks || (n.empty ? n.$from.marks() : n.$from.marksAcross(n.$to) || Mt.none))), n.replaceWith(this, a), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(a, t, n) {
    let l = this.doc.type.schema;
    if (t == null)
      return a ? this.replaceSelectionWith(l.text(a), !0) : this.deleteSelection();
    {
      if (n == null && (n = t), !a)
        return this.deleteRange(t, n);
      let o = this.storedMarks;
      if (!o) {
        let r = this.doc.resolve(t);
        o = n == t ? r.marks() : r.marksAcross(this.doc.resolve(n));
      }
      return this.replaceRangeWith(t, n, l.text(a, o)), !this.selection.empty && this.selection.to == t + a.length && this.setSelection(xt.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(a, t) {
    return this.meta[typeof a == "string" ? a : a.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(a) {
    return this.meta[typeof a == "string" ? a : a.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let a in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= wh, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & wh) > 0;
  }
}
function Ch(e, a) {
  return !a || !e ? e : e.bind(a);
}
class Wo {
  constructor(a, t, n) {
    this.name = a, this.init = Ch(t.init, n), this.apply = Ch(t.apply, n);
  }
}
const PI = [
  new Wo("doc", {
    init(e) {
      return e.doc || e.schema.topNodeType.createAndFill();
    },
    apply(e) {
      return e.doc;
    }
  }),
  new Wo("selection", {
    init(e, a) {
      return e.selection || xt.atStart(a.doc);
    },
    apply(e) {
      return e.selection;
    }
  }),
  new Wo("storedMarks", {
    init(e) {
      return e.storedMarks || null;
    },
    apply(e, a, t, n) {
      return n.selection.$cursor ? e.storedMarks : null;
    }
  }),
  new Wo("scrollToSelection", {
    init() {
      return 0;
    },
    apply(e, a) {
      return e.scrolledIntoView ? a + 1 : a;
    }
  })
];
class md {
  constructor(a, t) {
    this.schema = a, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = PI.slice(), t && t.forEach((n) => {
      if (this.pluginsByKey[n.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + n.key + ")");
      this.plugins.push(n), this.pluginsByKey[n.key] = n, n.spec.state && this.fields.push(new Wo(n.key, n.spec.state, n));
    });
  }
}
class _l {
  /**
  @internal
  */
  constructor(a) {
    this.config = a;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(a) {
    return this.applyTransaction(a).state;
  }
  /**
  @internal
  */
  filterTransaction(a, t = -1) {
    for (let n = 0; n < this.config.plugins.length; n++)
      if (n != t) {
        let l = this.config.plugins[n];
        if (l.spec.filterTransaction && !l.spec.filterTransaction.call(l, a, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(a) {
    if (!this.filterTransaction(a))
      return { state: this, transactions: [] };
    let t = [a], n = this.applyInner(a), l = null;
    for (; ; ) {
      let o = !1;
      for (let r = 0; r < this.config.plugins.length; r++) {
        let i = this.config.plugins[r];
        if (i.spec.appendTransaction) {
          let s = l ? l[r].n : 0, d = l ? l[r].state : this, c = s < t.length && i.spec.appendTransaction.call(i, s ? t.slice(s) : t, d, n);
          if (c && n.filterTransaction(c, r)) {
            if (c.setMeta("appendedTransaction", a), !l) {
              l = [];
              for (let f = 0; f < this.config.plugins.length; f++)
                l.push(f < r ? { state: n, n: t.length } : { state: this, n: 0 });
            }
            t.push(c), n = n.applyInner(c), o = !0;
          }
          l && (l[r] = { state: n, n: t.length });
        }
      }
      if (!o)
        return { state: n, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(a) {
    if (!a.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new _l(this.config), n = this.config.fields;
    for (let l = 0; l < n.length; l++) {
      let o = n[l];
      t[o.name] = o.apply(a, this[o.name], this, t);
    }
    return t;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new OI(this);
  }
  /**
  Create a new state.
  */
  static create(a) {
    let t = new md(a.doc ? a.doc.type.schema : a.schema, a.plugins), n = new _l(t);
    for (let l = 0; l < t.fields.length; l++)
      n[t.fields[l].name] = t.fields[l].init(a, n);
    return n;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(a) {
    let t = new md(this.schema, a.plugins), n = t.fields, l = new _l(t);
    for (let o = 0; o < n.length; o++) {
      let r = n[o].name;
      l[r] = this.hasOwnProperty(r) ? this[r] : n[o].init(a, l);
    }
    return l;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(a) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((n) => n.toJSON())), a && typeof a == "object")
      for (let n in a) {
        if (n == "doc" || n == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let l = a[n], o = l.spec.state;
        o && o.toJSON && (t[n] = o.toJSON.call(l, this[l.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(a, t, n) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!a.schema)
      throw new RangeError("Required config field 'schema' missing");
    let l = new md(a.schema, a.plugins), o = new _l(l);
    return l.fields.forEach((r) => {
      if (r.name == "doc")
        o.doc = Qn.fromJSON(a.schema, t.doc);
      else if (r.name == "selection")
        o.selection = xt.fromJSON(o.doc, t.selection);
      else if (r.name == "storedMarks")
        t.storedMarks && (o.storedMarks = t.storedMarks.map(a.schema.markFromJSON));
      else {
        if (n)
          for (let i in n) {
            let s = n[i], d = s.spec.state;
            if (s.key == r.name && d && d.fromJSON && Object.prototype.hasOwnProperty.call(t, i)) {
              o[r.name] = d.fromJSON.call(s, a, t[i], o);
              return;
            }
          }
        o[r.name] = r.init(a, o);
      }
    }), o;
  }
}
function ov(e, a, t) {
  for (let n in e) {
    let l = e[n];
    l instanceof Function ? l = l.bind(a) : n == "handleDOMEvents" && (l = ov(l, a, {})), t[n] = l;
  }
  return t;
}
class Ut {
  /**
  Create a plugin.
  */
  constructor(a) {
    this.spec = a, this.props = {}, a.props && ov(a.props, this, this.props), this.key = a.key ? a.key.key : rv("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(a) {
    return a[this.key];
  }
}
const vd = /* @__PURE__ */ Object.create(null);
function rv(e) {
  return e in vd ? e + "$" + ++vd[e] : (vd[e] = 0, e + "$");
}
class la {
  /**
  Create a plugin key.
  */
  constructor(a = "key") {
    this.key = rv(a);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(a) {
    return a.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(a) {
    return a[this.key];
  }
}
const iv = (e, a) => e.selection.empty ? !1 : (a && a(e.tr.deleteSelection().scrollIntoView()), !0);
function sv(e, a) {
  let { $cursor: t } = e.selection;
  return !t || (a ? !a.endOfTextblock("backward", e) : t.parentOffset > 0) ? null : t;
}
const dv = (e, a, t) => {
  let n = sv(e, t);
  if (!n)
    return !1;
  let l = Dc(n);
  if (!l) {
    let r = n.blockRange(), i = r && $o(r);
    return i == null ? !1 : (a && a(e.tr.lift(r, i).scrollIntoView()), !0);
  }
  let o = l.nodeBefore;
  if (pv(e, l, a, -1))
    return !0;
  if (n.parent.content.size == 0 && (go(o, "end") || dt.isSelectable(o)))
    for (let r = n.depth; ; r--) {
      let i = Ps(e.doc, n.before(r), n.after(r), tt.empty);
      if (i && i.slice.size < i.to - i.from) {
        if (a) {
          let s = e.tr.step(i);
          s.setSelection(go(o, "end") ? xt.findFrom(s.doc.resolve(s.mapping.map(l.pos, -1)), -1) : dt.create(s.doc, l.pos - o.nodeSize)), a(s.scrollIntoView());
        }
        return !0;
      }
      if (r == 1 || n.node(r - 1).childCount > 1)
        break;
    }
  return o.isAtom && l.depth == n.depth - 1 ? (a && a(e.tr.delete(l.pos - o.nodeSize, l.pos).scrollIntoView()), !0) : !1;
}, FI = (e, a, t) => {
  let n = sv(e, t);
  if (!n)
    return !1;
  let l = Dc(n);
  return l ? uv(e, l, a) : !1;
}, NI = (e, a, t) => {
  let n = fv(e, t);
  if (!n)
    return !1;
  let l = Bc(n);
  return l ? uv(e, l, a) : !1;
};
function uv(e, a, t) {
  let n = a.nodeBefore, l = n, o = a.pos - 1;
  for (; !l.isTextblock; o--) {
    if (l.type.spec.isolating)
      return !1;
    let c = l.lastChild;
    if (!c)
      return !1;
    l = c;
  }
  let r = a.nodeAfter, i = r, s = a.pos + 1;
  for (; !i.isTextblock; s++) {
    if (i.type.spec.isolating)
      return !1;
    let c = i.firstChild;
    if (!c)
      return !1;
    i = c;
  }
  let d = Ps(e.doc, o, s, tt.empty);
  if (!d || d.from != o || d instanceof Zt && d.slice.size >= s - o)
    return !1;
  if (t) {
    let c = e.tr.step(d);
    c.setSelection(ht.create(c.doc, o)), t(c.scrollIntoView());
  }
  return !0;
}
function go(e, a, t = !1) {
  for (let n = e; n; n = a == "start" ? n.firstChild : n.lastChild) {
    if (n.isTextblock)
      return !0;
    if (t && n.childCount != 1)
      return !1;
  }
  return !1;
}
const cv = (e, a, t) => {
  let { $head: n, empty: l } = e.selection, o = n;
  if (!l)
    return !1;
  if (n.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", e) : n.parentOffset > 0)
      return !1;
    o = Dc(n);
  }
  let r = o && o.nodeBefore;
  return !r || !dt.isSelectable(r) ? !1 : (a && a(e.tr.setSelection(dt.create(e.doc, o.pos - r.nodeSize)).scrollIntoView()), !0);
};
function Dc(e) {
  if (!e.parent.type.spec.isolating)
    for (let a = e.depth - 1; a >= 0; a--) {
      if (e.index(a) > 0)
        return e.doc.resolve(e.before(a + 1));
      if (e.node(a).type.spec.isolating)
        break;
    }
  return null;
}
function fv(e, a) {
  let { $cursor: t } = e.selection;
  return !t || (a ? !a.endOfTextblock("forward", e) : t.parentOffset < t.parent.content.size) ? null : t;
}
const hv = (e, a, t) => {
  let n = fv(e, t);
  if (!n)
    return !1;
  let l = Bc(n);
  if (!l)
    return !1;
  let o = l.nodeAfter;
  if (pv(e, l, a, 1))
    return !0;
  if (n.parent.content.size == 0 && (go(o, "start") || dt.isSelectable(o))) {
    let r = Ps(e.doc, n.before(), n.after(), tt.empty);
    if (r && r.slice.size < r.to - r.from) {
      if (a) {
        let i = e.tr.step(r);
        i.setSelection(go(o, "start") ? xt.findFrom(i.doc.resolve(i.mapping.map(l.pos)), 1) : dt.create(i.doc, i.mapping.map(l.pos))), a(i.scrollIntoView());
      }
      return !0;
    }
  }
  return o.isAtom && l.depth == n.depth - 1 ? (a && a(e.tr.delete(l.pos, l.pos + o.nodeSize).scrollIntoView()), !0) : !1;
}, bv = (e, a, t) => {
  let { $head: n, empty: l } = e.selection, o = n;
  if (!l)
    return !1;
  if (n.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", e) : n.parentOffset < n.parent.content.size)
      return !1;
    o = Bc(n);
  }
  let r = o && o.nodeAfter;
  return !r || !dt.isSelectable(r) ? !1 : (a && a(e.tr.setSelection(dt.create(e.doc, o.pos)).scrollIntoView()), !0);
};
function Bc(e) {
  if (!e.parent.type.spec.isolating)
    for (let a = e.depth - 1; a >= 0; a--) {
      let t = e.node(a);
      if (e.index(a) + 1 < t.childCount)
        return e.doc.resolve(e.after(a + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const VI = (e, a) => {
  let t = e.selection, n = t instanceof dt, l;
  if (n) {
    if (t.node.isTextblock || !bl(e.doc, t.from))
      return !1;
    l = t.from;
  } else if (l = Os(e.doc, t.from, -1), l == null)
    return !1;
  if (a) {
    let o = e.tr.join(l);
    n && o.setSelection(dt.create(o.doc, l - e.doc.resolve(l).nodeBefore.nodeSize)), a(o.scrollIntoView());
  }
  return !0;
}, HI = (e, a) => {
  let t = e.selection, n;
  if (t instanceof dt) {
    if (t.node.isTextblock || !bl(e.doc, t.to))
      return !1;
    n = t.to;
  } else if (n = Os(e.doc, t.to, 1), n == null)
    return !1;
  return a && a(e.tr.join(n).scrollIntoView()), !0;
}, jI = (e, a) => {
  let { $from: t, $to: n } = e.selection, l = t.blockRange(n), o = l && $o(l);
  return o == null ? !1 : (a && a(e.tr.lift(l, o).scrollIntoView()), !0);
}, gv = (e, a) => {
  let { $head: t, $anchor: n } = e.selection;
  return !t.parent.type.spec.code || !t.sameParent(n) ? !1 : (a && a(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function Mc(e) {
  for (let a = 0; a < e.edgeCount; a++) {
    let { type: t } = e.edge(a);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const WI = (e, a) => {
  let { $head: t, $anchor: n } = e.selection;
  if (!t.parent.type.spec.code || !t.sameParent(n))
    return !1;
  let l = t.node(-1), o = t.indexAfter(-1), r = Mc(l.contentMatchAt(o));
  if (!r || !l.canReplaceWith(o, o, r))
    return !1;
  if (a) {
    let i = t.after(), s = e.tr.replaceWith(i, i, r.createAndFill());
    s.setSelection(xt.near(s.doc.resolve(i), 1)), a(s.scrollIntoView());
  }
  return !0;
}, mv = (e, a) => {
  let t = e.selection, { $from: n, $to: l } = t;
  if (t instanceof Ma || n.parent.inlineContent || l.parent.inlineContent)
    return !1;
  let o = Mc(l.parent.contentMatchAt(l.indexAfter()));
  if (!o || !o.isTextblock)
    return !1;
  if (a) {
    let r = (!n.parentOffset && l.index() < l.parent.childCount ? n : l).pos, i = e.tr.insert(r, o.createAndFill());
    i.setSelection(ht.create(i.doc, r + 1)), a(i.scrollIntoView());
  }
  return !0;
}, vv = (e, a) => {
  let { $cursor: t } = e.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let o = t.before();
    if (zn(e.doc, o))
      return a && a(e.tr.split(o).scrollIntoView()), !0;
  }
  let n = t.blockRange(), l = n && $o(n);
  return l == null ? !1 : (a && a(e.tr.lift(n, l).scrollIntoView()), !0);
};
function qI(e) {
  return (a, t) => {
    let { $from: n, $to: l } = a.selection;
    if (a.selection instanceof dt && a.selection.node.isBlock)
      return !n.parentOffset || !zn(a.doc, n.pos) ? !1 : (t && t(a.tr.split(n.pos).scrollIntoView()), !0);
    if (!n.depth)
      return !1;
    let o = [], r, i, s = !1, d = !1;
    for (let h = n.depth; ; h--)
      if (n.node(h).isBlock) {
        s = n.end(h) == n.pos + (n.depth - h), d = n.start(h) == n.pos - (n.depth - h), i = Mc(n.node(h - 1).contentMatchAt(n.indexAfter(h - 1))), o.unshift(s && i ? { type: i } : null), r = h;
        break;
      } else {
        if (h == 1)
          return !1;
        o.unshift(null);
      }
    let c = a.tr;
    (a.selection instanceof ht || a.selection instanceof Ma) && c.deleteSelection();
    let f = c.mapping.map(n.pos), g = zn(c.doc, f, o.length, o);
    if (g || (o[0] = i ? { type: i } : null, g = zn(c.doc, f, o.length, o)), !g)
      return !1;
    if (c.split(f, o.length, o), !s && d && n.node(r).type != i) {
      let h = c.mapping.map(n.before(r)), v = c.doc.resolve(h);
      i && n.node(r - 1).canReplaceWith(v.index(), v.index() + 1, i) && c.setNodeMarkup(c.mapping.map(n.before(r)), i);
    }
    return t && t(c.scrollIntoView()), !0;
  };
}
const UI = qI(), GI = (e, a) => {
  let { $from: t, to: n } = e.selection, l, o = t.sharedDepth(n);
  return o == 0 ? !1 : (l = t.before(o), a && a(e.tr.setSelection(dt.create(e.doc, l))), !0);
};
function KI(e, a, t) {
  let n = a.nodeBefore, l = a.nodeAfter, o = a.index();
  return !n || !l || !n.type.compatibleContent(l.type) ? !1 : !n.content.size && a.parent.canReplace(o - 1, o) ? (t && t(e.tr.delete(a.pos - n.nodeSize, a.pos).scrollIntoView()), !0) : !a.parent.canReplace(o, o + 1) || !(l.isTextblock || bl(e.doc, a.pos)) ? !1 : (t && t(e.tr.join(a.pos).scrollIntoView()), !0);
}
function pv(e, a, t, n) {
  let l = a.nodeBefore, o = a.nodeAfter, r, i, s = l.type.spec.isolating || o.type.spec.isolating;
  if (!s && KI(e, a, t))
    return !0;
  let d = !s && a.parent.canReplace(a.index(), a.index() + 1);
  if (d && (r = (i = l.contentMatchAt(l.childCount)).findWrapping(o.type)) && i.matchType(r[0] || o.type).validEnd) {
    if (t) {
      let h = a.pos + o.nodeSize, v = We.empty;
      for (let k = r.length - 1; k >= 0; k--)
        v = We.from(r[k].create(null, v));
      v = We.from(l.copy(v));
      let p = e.tr.step(new ra(a.pos - 1, h, a.pos, h, new tt(v, 1, 0), r.length, !0)), y = p.doc.resolve(h + 2 * r.length);
      y.nodeAfter && y.nodeAfter.type == l.type && bl(p.doc, y.pos) && p.join(y.pos), t(p.scrollIntoView());
    }
    return !0;
  }
  let c = o.type.spec.isolating || n > 0 && s ? null : xt.findFrom(a, 1), f = c && c.$from.blockRange(c.$to), g = f && $o(f);
  if (g != null && g >= a.depth)
    return t && t(e.tr.lift(f, g).scrollIntoView()), !0;
  if (d && go(o, "start", !0) && go(l, "end")) {
    let h = l, v = [];
    for (; v.push(h), !h.isTextblock; )
      h = h.lastChild;
    let p = o, y = 1;
    for (; !p.isTextblock; p = p.firstChild)
      y++;
    if (h.canReplace(h.childCount, h.childCount, p.content)) {
      if (t) {
        let k = We.empty;
        for (let S = v.length - 1; S >= 0; S--)
          k = We.from(v[S].copy(k));
        let $ = e.tr.step(new ra(a.pos - v.length, a.pos + o.nodeSize, a.pos + y, a.pos + o.nodeSize - y, new tt(k, v.length, 0), 0, !0));
        t($.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function xv(e) {
  return function(a, t) {
    let n = a.selection, l = e < 0 ? n.$from : n.$to, o = l.depth;
    for (; l.node(o).isInline; ) {
      if (!o)
        return !1;
      o--;
    }
    return l.node(o).isTextblock ? (t && t(a.tr.setSelection(ht.create(a.doc, e < 0 ? l.start(o) : l.end(o)))), !0) : !1;
  };
}
const YI = xv(-1), JI = xv(1);
function XI(e, a = null) {
  return function(t, n) {
    let { $from: l, $to: o } = t.selection, r = l.blockRange(o), i = r && Rc(r, e, a);
    return i ? (n && n(t.tr.wrap(r, i).scrollIntoView()), !0) : !1;
  };
}
function Sh(e, a = null) {
  return function(t, n) {
    let l = !1;
    for (let o = 0; o < t.selection.ranges.length && !l; o++) {
      let { $from: { pos: r }, $to: { pos: i } } = t.selection.ranges[o];
      t.doc.nodesBetween(r, i, (s, d) => {
        if (l)
          return !1;
        if (!(!s.isTextblock || s.hasMarkup(e, a)))
          if (s.type == e)
            l = !0;
          else {
            let c = t.doc.resolve(d), f = c.index();
            l = c.parent.canReplaceWith(f, f + 1, e);
          }
      });
    }
    if (!l)
      return !1;
    if (n) {
      let o = t.tr;
      for (let r = 0; r < t.selection.ranges.length; r++) {
        let { $from: { pos: i }, $to: { pos: s } } = t.selection.ranges[r];
        o.setBlockType(i, s, e, a);
      }
      n(o.scrollIntoView());
    }
    return !0;
  };
}
function Oc(...e) {
  return function(a, t, n) {
    for (let l = 0; l < e.length; l++)
      if (e[l](a, t, n))
        return !0;
    return !1;
  };
}
Oc(iv, dv, cv);
Oc(iv, hv, bv);
Oc(gv, mv, vv, UI);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function ZI(e, a = null) {
  return function(t, n) {
    let { $from: l, $to: o } = t.selection, r = l.blockRange(o);
    if (!r)
      return !1;
    let i = n ? t.tr : null;
    return QI(i, r, e, a) ? (n && n(i.scrollIntoView()), !0) : !1;
  };
}
function QI(e, a, t, n = null) {
  let l = !1, o = a, r = a.$from.doc;
  if (a.depth >= 2 && a.$from.node(a.depth - 1).type.compatibleContent(t) && a.startIndex == 0) {
    if (a.$from.index(a.depth - 1) == 0)
      return !1;
    let s = r.resolve(a.start - 2);
    o = new Pi(s, s, a.depth), a.endIndex < a.parent.childCount && (a = new Pi(a.$from, r.resolve(a.$to.end(a.depth)), a.depth)), l = !0;
  }
  let i = Rc(o, t, n, a);
  return i ? (e && _I(e, a, i, l, t), !0) : !1;
}
function _I(e, a, t, n, l) {
  let o = We.empty;
  for (let c = t.length - 1; c >= 0; c--)
    o = We.from(t[c].type.create(t[c].attrs, o));
  e.step(new ra(a.start - (n ? 2 : 0), a.end, a.start, a.end, new tt(o, 0, 0), t.length, !0));
  let r = 0;
  for (let c = 0; c < t.length; c++)
    t[c].type == l && (r = c + 1);
  let i = t.length - r, s = a.start + t.length - (n ? 2 : 0), d = a.parent;
  for (let c = a.startIndex, f = a.endIndex, g = !0; c < f; c++, g = !1)
    !g && zn(e.doc, s, i) && (e.split(s, i), s += 2 * i), s += d.child(c).nodeSize;
  return e;
}
function eL(e) {
  return function(a, t) {
    let { $from: n, $to: l } = a.selection, o = n.blockRange(l, (r) => r.childCount > 0 && r.firstChild.type == e);
    return o ? t ? n.node(o.depth - 1).type == e ? tL(a, t, e, o) : aL(a, t, o) : !0 : !1;
  };
}
function tL(e, a, t, n) {
  let l = e.tr, o = n.end, r = n.$to.end(n.depth);
  o < r && (l.step(new ra(o - 1, r, o, r, new tt(We.from(t.create(null, n.parent.copy())), 1, 0), 1, !0)), n = new Pi(l.doc.resolve(n.$from.pos), l.doc.resolve(r), n.depth));
  const i = $o(n);
  if (i == null)
    return !1;
  l.lift(n, i);
  let s = l.doc.resolve(l.mapping.map(o, -1) - 1);
  return bl(l.doc, s.pos) && s.nodeBefore.type == s.nodeAfter.type && l.join(s.pos), a(l.scrollIntoView()), !0;
}
function aL(e, a, t) {
  let n = e.tr, l = t.parent;
  for (let h = t.end, v = t.endIndex - 1, p = t.startIndex; v > p; v--)
    h -= l.child(v).nodeSize, n.delete(h - 1, h + 1);
  let o = n.doc.resolve(t.start), r = o.nodeAfter;
  if (n.mapping.map(t.end) != t.start + o.nodeAfter.nodeSize)
    return !1;
  let i = t.startIndex == 0, s = t.endIndex == l.childCount, d = o.node(-1), c = o.index(-1);
  if (!d.canReplace(c + (i ? 0 : 1), c + 1, r.content.append(s ? We.empty : We.from(l))))
    return !1;
  let f = o.pos, g = f + r.nodeSize;
  return n.step(new ra(f - (i ? 1 : 0), g + (s ? 1 : 0), f + 1, g - 1, new tt((i ? We.empty : We.from(l.copy(We.empty))).append(s ? We.empty : We.from(l.copy(We.empty))), i ? 0 : 1, s ? 0 : 1), i ? 0 : 1)), a(n.scrollIntoView()), !0;
}
function nL(e) {
  return function(a, t) {
    let { $from: n, $to: l } = a.selection, o = n.blockRange(l, (d) => d.childCount > 0 && d.firstChild.type == e);
    if (!o)
      return !1;
    let r = o.startIndex;
    if (r == 0)
      return !1;
    let i = o.parent, s = i.child(r - 1);
    if (s.type != e)
      return !1;
    if (t) {
      let d = s.lastChild && s.lastChild.type == i.type, c = We.from(d ? e.create() : null), f = new tt(We.from(e.create(null, We.from(i.type.create(null, c)))), d ? 3 : 1, 0), g = o.start, h = o.end;
      t(a.tr.step(new ra(g - (d ? 3 : 1), h, g, h, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
const da = function(e) {
  for (var a = 0; ; a++)
    if (e = e.previousSibling, !e)
      return a;
}, mo = function(e) {
  let a = e.assignedSlot || e.parentNode;
  return a && a.nodeType == 11 ? a.host : a;
};
let ku = null;
const Tn = function(e, a, t) {
  let n = ku || (ku = document.createRange());
  return n.setEnd(e, t ?? e.nodeValue.length), n.setStart(e, a || 0), n;
}, lL = function() {
  ku = null;
}, Pl = function(e, a, t, n) {
  return t && ($h(e, a, t, n, -1) || $h(e, a, t, n, 1));
}, oL = /^(img|br|input|textarea|hr)$/i;
function $h(e, a, t, n, l) {
  for (var o; ; ) {
    if (e == t && a == n)
      return !0;
    if (a == (l < 0 ? 0 : qa(e))) {
      let r = e.parentNode;
      if (!r || r.nodeType != 1 || Or(e) || oL.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      a = da(e) + (l < 0 ? 0 : 1), e = r;
    } else if (e.nodeType == 1) {
      let r = e.childNodes[a + (l < 0 ? -1 : 0)];
      if (r.nodeType == 1 && r.contentEditable == "false")
        if (!((o = r.pmViewDesc) === null || o === void 0) && o.ignoreForSelection)
          a += l;
        else
          return !1;
      else
        e = r, a = l < 0 ? qa(e) : 0;
    } else
      return !1;
  }
}
function qa(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function rL(e, a) {
  for (; ; ) {
    if (e.nodeType == 3 && a)
      return e;
    if (e.nodeType == 1 && a > 0) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[a - 1], a = qa(e);
    } else if (e.parentNode && !Or(e))
      a = da(e), e = e.parentNode;
    else
      return null;
  }
}
function iL(e, a) {
  for (; ; ) {
    if (e.nodeType == 3 && a < e.nodeValue.length)
      return e;
    if (e.nodeType == 1 && a < e.childNodes.length) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[a], a = 0;
    } else if (e.parentNode && !Or(e))
      a = da(e) + 1, e = e.parentNode;
    else
      return null;
  }
}
function sL(e, a, t) {
  for (let n = a == 0, l = a == qa(e); n || l; ) {
    if (e == t)
      return !0;
    let o = da(e);
    if (e = e.parentNode, !e)
      return !1;
    n = n && o == 0, l = l && o == qa(e);
  }
}
function Or(e) {
  let a;
  for (let t = e; t && !(a = t.pmViewDesc); t = t.parentNode)
    ;
  return a && a.node && a.node.isBlock && (a.dom == e || a.contentDOM == e);
}
const Ns = function(e) {
  return e.focusNode && Pl(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function xl(e, a) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = e, t.key = t.code = a, t;
}
function dL(e) {
  let a = e.activeElement;
  for (; a && a.shadowRoot; )
    a = a.shadowRoot.activeElement;
  return a;
}
function uL(e, a, t) {
  if (e.caretPositionFromPoint)
    try {
      let n = e.caretPositionFromPoint(a, t);
      if (n)
        return { node: n.offsetNode, offset: Math.min(qa(n.offsetNode), n.offset) };
    } catch {
    }
  if (e.caretRangeFromPoint) {
    let n = e.caretRangeFromPoint(a, t);
    if (n)
      return { node: n.startContainer, offset: Math.min(qa(n.startContainer), n.startOffset) };
  }
}
const kn = typeof navigator < "u" ? navigator : null, Ih = typeof document < "u" ? document : null, gl = kn && kn.userAgent || "", wu = /Edge\/(\d+)/.exec(gl), yv = /MSIE \d/.exec(gl), Cu = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(gl), Aa = !!(yv || Cu || wu), el = yv ? document.documentMode : Cu ? +Cu[1] : wu ? +wu[1] : 0, Ya = !Aa && /gecko\/(\d+)/i.test(gl);
Ya && +(/Firefox\/(\d+)/.exec(gl) || [0, 0])[1];
const Su = !Aa && /Chrome\/(\d+)/.exec(gl), ca = !!Su, kv = Su ? +Su[1] : 0, xa = !Aa && !!kn && /Apple Computer/.test(kn.vendor), vo = xa && (/Mobile\/\w+/.test(gl) || !!kn && kn.maxTouchPoints > 2), Wa = vo || (kn ? /Mac/.test(kn.platform) : !1), wv = kn ? /Win/.test(kn.platform) : !1, Rn = /Android \d/.test(gl), Pr = !!Ih && "webkitFontSmoothing" in Ih.documentElement.style, cL = Pr ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function fL(e) {
  let a = e.defaultView && e.defaultView.visualViewport;
  return a ? {
    left: 0,
    right: a.width,
    top: 0,
    bottom: a.height
  } : {
    left: 0,
    right: e.documentElement.clientWidth,
    top: 0,
    bottom: e.documentElement.clientHeight
  };
}
function Sn(e, a) {
  return typeof e == "number" ? e : e[a];
}
function hL(e) {
  let a = e.getBoundingClientRect(), t = a.width / e.offsetWidth || 1, n = a.height / e.offsetHeight || 1;
  return {
    left: a.left,
    right: a.left + e.clientWidth * t,
    top: a.top,
    bottom: a.top + e.clientHeight * n
  };
}
function Lh(e, a, t) {
  let n = e.someProp("scrollThreshold") || 0, l = e.someProp("scrollMargin") || 5, o = e.dom.ownerDocument;
  for (let r = t || e.dom; r; ) {
    if (r.nodeType != 1) {
      r = mo(r);
      continue;
    }
    let i = r, s = i == o.body, d = s ? fL(o) : hL(i), c = 0, f = 0;
    if (a.top < d.top + Sn(n, "top") ? f = -(d.top - a.top + Sn(l, "top")) : a.bottom > d.bottom - Sn(n, "bottom") && (f = a.bottom - a.top > d.bottom - d.top ? a.top + Sn(l, "top") - d.top : a.bottom - d.bottom + Sn(l, "bottom")), a.left < d.left + Sn(n, "left") ? c = -(d.left - a.left + Sn(l, "left")) : a.right > d.right - Sn(n, "right") && (c = a.right - d.right + Sn(l, "right")), c || f)
      if (s)
        o.defaultView.scrollBy(c, f);
      else {
        let h = i.scrollLeft, v = i.scrollTop;
        f && (i.scrollTop += f), c && (i.scrollLeft += c);
        let p = i.scrollLeft - h, y = i.scrollTop - v;
        a = { left: a.left - p, top: a.top - y, right: a.right - p, bottom: a.bottom - y };
      }
    let g = s ? "fixed" : getComputedStyle(r).position;
    if (/^(fixed|sticky)$/.test(g))
      break;
    r = g == "absolute" ? r.offsetParent : mo(r);
  }
}
function bL(e) {
  let a = e.dom.getBoundingClientRect(), t = Math.max(0, a.top), n, l;
  for (let o = (a.left + a.right) / 2, r = t + 1; r < Math.min(innerHeight, a.bottom); r += 5) {
    let i = e.root.elementFromPoint(o, r);
    if (!i || i == e.dom || !e.dom.contains(i))
      continue;
    let s = i.getBoundingClientRect();
    if (s.top >= t - 20) {
      n = i, l = s.top;
      break;
    }
  }
  return { refDOM: n, refTop: l, stack: Cv(e.dom) };
}
function Cv(e) {
  let a = [], t = e.ownerDocument;
  for (let n = e; n && (a.push({ dom: n, top: n.scrollTop, left: n.scrollLeft }), e != t); n = mo(n))
    ;
  return a;
}
function gL({ refDOM: e, refTop: a, stack: t }) {
  let n = e ? e.getBoundingClientRect().top : 0;
  Sv(t, n == 0 ? 0 : n - a);
}
function Sv(e, a) {
  for (let t = 0; t < e.length; t++) {
    let { dom: n, top: l, left: o } = e[t];
    n.scrollTop != l + a && (n.scrollTop = l + a), n.scrollLeft != o && (n.scrollLeft = o);
  }
}
let Wl = null;
function mL(e) {
  if (e.setActive)
    return e.setActive();
  if (Wl)
    return e.focus(Wl);
  let a = Cv(e);
  e.focus(Wl == null ? {
    get preventScroll() {
      return Wl = { preventScroll: !0 }, !0;
    }
  } : void 0), Wl || (Wl = !1, Sv(a, 0));
}
function $v(e, a) {
  let t, n = 2e8, l, o = 0, r = a.top, i = a.top, s, d;
  for (let c = e.firstChild, f = 0; c; c = c.nextSibling, f++) {
    let g;
    if (c.nodeType == 1)
      g = c.getClientRects();
    else if (c.nodeType == 3)
      g = Tn(c).getClientRects();
    else
      continue;
    for (let h = 0; h < g.length; h++) {
      let v = g[h];
      if (v.top <= r && v.bottom >= i) {
        r = Math.max(v.bottom, r), i = Math.min(v.top, i);
        let p = v.left > a.left ? v.left - a.left : v.right < a.left ? a.left - v.right : 0;
        if (p < n) {
          t = c, n = p, l = p && t.nodeType == 3 ? {
            left: v.right < a.left ? v.right : v.left,
            top: a.top
          } : a, c.nodeType == 1 && p && (o = f + (a.left >= (v.left + v.right) / 2 ? 1 : 0));
          continue;
        }
      } else v.top > a.top && !s && v.left <= a.left && v.right >= a.left && (s = c, d = { left: Math.max(v.left, Math.min(v.right, a.left)), top: v.top });
      !t && (a.left >= v.right && a.top >= v.top || a.left >= v.left && a.top >= v.bottom) && (o = f + 1);
    }
  }
  return !t && s && (t = s, l = d, n = 0), t && t.nodeType == 3 ? vL(t, l) : !t || n && t.nodeType == 1 ? { node: e, offset: o } : $v(t, l);
}
function vL(e, a) {
  let t = e.nodeValue.length, n = document.createRange(), l;
  for (let o = 0; o < t; o++) {
    n.setEnd(e, o + 1), n.setStart(e, o);
    let r = Vn(n, 1);
    if (r.top != r.bottom && Pc(a, r)) {
      l = { node: e, offset: o + (a.left >= (r.left + r.right) / 2 ? 1 : 0) };
      break;
    }
  }
  return n.detach(), l || { node: e, offset: 0 };
}
function Pc(e, a) {
  return e.left >= a.left - 1 && e.left <= a.right + 1 && e.top >= a.top - 1 && e.top <= a.bottom + 1;
}
function pL(e, a) {
  let t = e.parentNode;
  return t && /^li$/i.test(t.nodeName) && a.left < e.getBoundingClientRect().left ? t : e;
}
function xL(e, a, t) {
  let { node: n, offset: l } = $v(a, t), o = -1;
  if (n.nodeType == 1 && !n.firstChild) {
    let r = n.getBoundingClientRect();
    o = r.left != r.right && t.left > (r.left + r.right) / 2 ? 1 : -1;
  }
  return e.docView.posFromDOM(n, l, o);
}
function yL(e, a, t, n) {
  let l = -1;
  for (let o = a, r = !1; o != e.dom; ) {
    let i = e.docView.nearestDesc(o, !0), s;
    if (!i)
      return null;
    if (i.dom.nodeType == 1 && (i.node.isBlock && i.parent || !i.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((s = i.dom.getBoundingClientRect()).width || s.height) && (i.node.isBlock && i.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(i.dom.nodeName) && (!r && s.left > n.left || s.top > n.top ? l = i.posBefore : (!r && s.right < n.left || s.bottom < n.top) && (l = i.posAfter), r = !0), !i.contentDOM && l < 0 && !i.node.isText))
      return (i.node.isBlock ? n.top < (s.top + s.bottom) / 2 : n.left < (s.left + s.right) / 2) ? i.posBefore : i.posAfter;
    o = i.dom.parentNode;
  }
  return l > -1 ? l : e.docView.posFromDOM(a, t, -1);
}
function Iv(e, a, t) {
  let n = e.childNodes.length;
  if (n && t.top < t.bottom)
    for (let l = Math.max(0, Math.min(n - 1, Math.floor(n * (a.top - t.top) / (t.bottom - t.top)) - 2)), o = l; ; ) {
      let r = e.childNodes[o];
      if (r.nodeType == 1) {
        let i = r.getClientRects();
        for (let s = 0; s < i.length; s++) {
          let d = i[s];
          if (Pc(a, d))
            return Iv(r, a, d);
        }
      }
      if ((o = (o + 1) % n) == l)
        break;
    }
  return e;
}
function kL(e, a) {
  let t = e.dom.ownerDocument, n, l = 0, o = uL(t, a.left, a.top);
  o && ({ node: n, offset: l } = o);
  let r = (e.root.elementFromPoint ? e.root : t).elementFromPoint(a.left, a.top), i;
  if (!r || !e.dom.contains(r.nodeType != 1 ? r.parentNode : r)) {
    let d = e.dom.getBoundingClientRect();
    if (!Pc(a, d) || (r = Iv(e.dom, a, d), !r))
      return null;
  }
  if (xa)
    for (let d = r; n && d; d = mo(d))
      d.draggable && (n = void 0);
  if (r = pL(r, a), n) {
    if (Ya && n.nodeType == 1 && (l = Math.min(l, n.childNodes.length), l < n.childNodes.length)) {
      let c = n.childNodes[l], f;
      c.nodeName == "IMG" && (f = c.getBoundingClientRect()).right <= a.left && f.bottom > a.top && l++;
    }
    let d;
    Pr && l && n.nodeType == 1 && (d = n.childNodes[l - 1]).nodeType == 1 && d.contentEditable == "false" && d.getBoundingClientRect().top >= a.top && l--, n == e.dom && l == n.childNodes.length - 1 && n.lastChild.nodeType == 1 && a.top > n.lastChild.getBoundingClientRect().bottom ? i = e.state.doc.content.size : (l == 0 || n.nodeType != 1 || n.childNodes[l - 1].nodeName != "BR") && (i = yL(e, n, l, a));
  }
  i == null && (i = xL(e, r, a));
  let s = e.docView.nearestDesc(r, !0);
  return { pos: i, inside: s ? s.posAtStart - s.border : -1 };
}
function Th(e) {
  return e.top < e.bottom || e.left < e.right;
}
function Vn(e, a) {
  let t = e.getClientRects();
  if (t.length) {
    let n = t[a < 0 ? 0 : t.length - 1];
    if (Th(n))
      return n;
  }
  return Array.prototype.find.call(t, Th) || e.getBoundingClientRect();
}
const wL = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function Lv(e, a, t) {
  let { node: n, offset: l, atom: o } = e.docView.domFromPos(a, t < 0 ? -1 : 1), r = Pr || Ya;
  if (n.nodeType == 3)
    if (r && (wL.test(n.nodeValue) || (t < 0 ? !l : l == n.nodeValue.length))) {
      let s = Vn(Tn(n, l, l), t);
      if (Ya && l && /\s/.test(n.nodeValue[l - 1]) && l < n.nodeValue.length) {
        let d = Vn(Tn(n, l - 1, l - 1), -1);
        if (d.top == s.top) {
          let c = Vn(Tn(n, l, l + 1), -1);
          if (c.top != s.top)
            return zo(c, c.left < d.left);
        }
      }
      return s;
    } else {
      let s = l, d = l, c = t < 0 ? 1 : -1;
      return t < 0 && !l ? (d++, c = -1) : t >= 0 && l == n.nodeValue.length ? (s--, c = 1) : t < 0 ? s-- : d++, zo(Vn(Tn(n, s, d), c), c < 0);
    }
  if (!e.state.doc.resolve(a - (o || 0)).parent.inlineContent) {
    if (o == null && l && (t < 0 || l == qa(n))) {
      let s = n.childNodes[l - 1];
      if (s.nodeType == 1)
        return pd(s.getBoundingClientRect(), !1);
    }
    if (o == null && l < qa(n)) {
      let s = n.childNodes[l];
      if (s.nodeType == 1)
        return pd(s.getBoundingClientRect(), !0);
    }
    return pd(n.getBoundingClientRect(), t >= 0);
  }
  if (o == null && l && (t < 0 || l == qa(n))) {
    let s = n.childNodes[l - 1], d = s.nodeType == 3 ? Tn(s, qa(s) - (r ? 0 : 1)) : s.nodeType == 1 && (s.nodeName != "BR" || !s.nextSibling) ? s : null;
    if (d)
      return zo(Vn(d, 1), !1);
  }
  if (o == null && l < qa(n)) {
    let s = n.childNodes[l];
    for (; s.pmViewDesc && s.pmViewDesc.ignoreForCoords; )
      s = s.nextSibling;
    let d = s ? s.nodeType == 3 ? Tn(s, 0, r ? 0 : 1) : s.nodeType == 1 ? s : null : null;
    if (d)
      return zo(Vn(d, -1), !0);
  }
  return zo(Vn(n.nodeType == 3 ? Tn(n) : n, -t), t >= 0);
}
function zo(e, a) {
  if (e.width == 0)
    return e;
  let t = a ? e.left : e.right;
  return { top: e.top, bottom: e.bottom, left: t, right: t };
}
function pd(e, a) {
  if (e.height == 0)
    return e;
  let t = a ? e.top : e.bottom;
  return { top: t, bottom: t, left: e.left, right: e.right };
}
function Tv(e, a, t) {
  let n = e.state, l = e.root.activeElement;
  n != a && e.updateState(a), l != e.dom && e.focus();
  try {
    return t();
  } finally {
    n != a && e.updateState(n), l != e.dom && l && l.focus();
  }
}
function CL(e, a, t) {
  let n = a.selection, l = t == "up" ? n.$from : n.$to;
  return Tv(e, a, () => {
    let { node: o } = e.docView.domFromPos(l.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let i = e.docView.nearestDesc(o, !0);
      if (!i)
        break;
      if (i.node.isBlock) {
        o = i.contentDOM || i.dom;
        break;
      }
      o = i.dom.parentNode;
    }
    let r = Lv(e, l.pos, 1);
    for (let i = o.firstChild; i; i = i.nextSibling) {
      let s;
      if (i.nodeType == 1)
        s = i.getClientRects();
      else if (i.nodeType == 3)
        s = Tn(i, 0, i.nodeValue.length).getClientRects();
      else
        continue;
      for (let d = 0; d < s.length; d++) {
        let c = s[d];
        if (c.bottom > c.top + 1 && (t == "up" ? r.top - c.top > (c.bottom - r.top) * 2 : c.bottom - r.bottom > (r.bottom - c.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const SL = /[\u0590-\u08ac]/;
function $L(e, a, t) {
  let { $head: n } = a.selection;
  if (!n.parent.isTextblock)
    return !1;
  let l = n.parentOffset, o = !l, r = l == n.parent.content.size, i = e.domSelection();
  return i ? !SL.test(n.parent.textContent) || !i.modify ? t == "left" || t == "backward" ? o : r : Tv(e, a, () => {
    let { focusNode: s, focusOffset: d, anchorNode: c, anchorOffset: f } = e.domSelectionRange(), g = i.caretBidiLevel;
    i.modify("move", t, "character");
    let h = n.depth ? e.docView.domAfterPos(n.before()) : e.dom, { focusNode: v, focusOffset: p } = e.domSelectionRange(), y = v && !h.contains(v.nodeType == 1 ? v : v.parentNode) || s == v && d == p;
    try {
      i.collapse(c, f), s && (s != c || d != f) && i.extend && i.extend(s, d);
    } catch {
    }
    return g != null && (i.caretBidiLevel = g), y;
  }) : n.pos == n.start() || n.pos == n.end();
}
let Eh = null, Ah = null, Rh = !1;
function IL(e, a, t) {
  return Eh == a && Ah == t ? Rh : (Eh = a, Ah = t, Rh = t == "up" || t == "down" ? CL(e, a, t) : $L(e, a, t));
}
const Ja = 0, zh = 1, kl = 2, wn = 3;
class Fr {
  constructor(a, t, n, l) {
    this.parent = a, this.children = t, this.dom = n, this.contentDOM = l, this.dirty = Ja, n.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(a) {
    return !1;
  }
  matchesMark(a) {
    return !1;
  }
  matchesNode(a, t, n) {
    return !1;
  }
  matchesHack(a) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(a) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let a = 0;
    for (let t = 0; t < this.children.length; t++)
      a += this.children[t].size;
    return a;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let a = 0; a < this.children.length; a++)
      this.children[a].destroy();
  }
  posBeforeChild(a) {
    for (let t = 0, n = this.posAtStart; ; t++) {
      let l = this.children[t];
      if (l == a)
        return n;
      n += l.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(a, t, n) {
    if (this.contentDOM && this.contentDOM.contains(a.nodeType == 1 ? a : a.parentNode))
      if (n < 0) {
        let o, r;
        if (a == this.contentDOM)
          o = a.childNodes[t - 1];
        else {
          for (; a.parentNode != this.contentDOM; )
            a = a.parentNode;
          o = a.previousSibling;
        }
        for (; o && !((r = o.pmViewDesc) && r.parent == this); )
          o = o.previousSibling;
        return o ? this.posBeforeChild(r) + r.size : this.posAtStart;
      } else {
        let o, r;
        if (a == this.contentDOM)
          o = a.childNodes[t];
        else {
          for (; a.parentNode != this.contentDOM; )
            a = a.parentNode;
          o = a.nextSibling;
        }
        for (; o && !((r = o.pmViewDesc) && r.parent == this); )
          o = o.nextSibling;
        return o ? this.posBeforeChild(r) : this.posAtEnd;
      }
    let l;
    if (a == this.dom && this.contentDOM)
      l = t > da(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      l = a.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let o = a; ; o = o.parentNode) {
          if (o == this.dom) {
            l = !1;
            break;
          }
          if (o.previousSibling)
            break;
        }
      if (l == null && t == a.childNodes.length)
        for (let o = a; ; o = o.parentNode) {
          if (o == this.dom) {
            l = !0;
            break;
          }
          if (o.nextSibling)
            break;
        }
    }
    return l ?? n > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(a, t = !1) {
    for (let n = !0, l = a; l; l = l.parentNode) {
      let o = this.getDesc(l), r;
      if (o && (!t || o.node))
        if (n && (r = o.nodeDOM) && !(r.nodeType == 1 ? r.contains(a.nodeType == 1 ? a : a.parentNode) : r == a))
          n = !1;
        else
          return o;
    }
  }
  getDesc(a) {
    let t = a.pmViewDesc;
    for (let n = t; n; n = n.parent)
      if (n == this)
        return t;
  }
  posFromDOM(a, t, n) {
    for (let l = a; l; l = l.parentNode) {
      let o = this.getDesc(l);
      if (o)
        return o.localPosFromDOM(a, t, n);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(a) {
    for (let t = 0, n = 0; t < this.children.length; t++) {
      let l = this.children[t], o = n + l.size;
      if (n == a && o != n) {
        for (; !l.border && l.children.length; )
          for (let r = 0; r < l.children.length; r++) {
            let i = l.children[r];
            if (i.size) {
              l = i;
              break;
            }
          }
        return l;
      }
      if (a < o)
        return l.descAt(a - n - l.border);
      n = o;
    }
  }
  domFromPos(a, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: a + 1 };
    let n = 0, l = 0;
    for (let o = 0; n < this.children.length; n++) {
      let r = this.children[n], i = o + r.size;
      if (i > a || r instanceof Av) {
        l = a - o;
        break;
      }
      o = i;
    }
    if (l)
      return this.children[n].domFromPos(l - this.children[n].border, t);
    for (let o; n && !(o = this.children[n - 1]).size && o instanceof Ev && o.side >= 0; n--)
      ;
    if (t <= 0) {
      let o, r = !0;
      for (; o = n ? this.children[n - 1] : null, !(!o || o.dom.parentNode == this.contentDOM); n--, r = !1)
        ;
      return o && t && r && !o.border && !o.domAtom ? o.domFromPos(o.size, t) : { node: this.contentDOM, offset: o ? da(o.dom) + 1 : 0 };
    } else {
      let o, r = !0;
      for (; o = n < this.children.length ? this.children[n] : null, !(!o || o.dom.parentNode == this.contentDOM); n++, r = !1)
        ;
      return o && r && !o.border && !o.domAtom ? o.domFromPos(0, t) : { node: this.contentDOM, offset: o ? da(o.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(a, t, n = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: a, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let l = -1, o = -1;
    for (let r = n, i = 0; ; i++) {
      let s = this.children[i], d = r + s.size;
      if (l == -1 && a <= d) {
        let c = r + s.border;
        if (a >= c && t <= d - s.border && s.node && s.contentDOM && this.contentDOM.contains(s.contentDOM))
          return s.parseRange(a, t, c);
        a = r;
        for (let f = i; f > 0; f--) {
          let g = this.children[f - 1];
          if (g.size && g.dom.parentNode == this.contentDOM && !g.emptyChildAt(1)) {
            l = da(g.dom) + 1;
            break;
          }
          a -= g.size;
        }
        l == -1 && (l = 0);
      }
      if (l > -1 && (d > t || i == this.children.length - 1)) {
        t = d;
        for (let c = i + 1; c < this.children.length; c++) {
          let f = this.children[c];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(-1)) {
            o = da(f.dom);
            break;
          }
          t += f.size;
        }
        o == -1 && (o = this.contentDOM.childNodes.length);
        break;
      }
      r = d;
    }
    return { node: this.contentDOM, from: a, to: t, fromOffset: l, toOffset: o };
  }
  emptyChildAt(a) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[a < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(a);
  }
  domAfterPos(a) {
    let { node: t, offset: n } = this.domFromPos(a, 0);
    if (t.nodeType != 1 || n == t.childNodes.length)
      throw new RangeError("No node after pos " + a);
    return t.childNodes[n];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(a, t, n, l = !1) {
    let o = Math.min(a, t), r = Math.max(a, t);
    for (let h = 0, v = 0; h < this.children.length; h++) {
      let p = this.children[h], y = v + p.size;
      if (o > v && r < y)
        return p.setSelection(a - v - p.border, t - v - p.border, n, l);
      v = y;
    }
    let i = this.domFromPos(a, a ? -1 : 1), s = t == a ? i : this.domFromPos(t, t ? -1 : 1), d = n.root.getSelection(), c = n.domSelectionRange(), f = !1;
    if ((Ya || xa) && a == t) {
      let { node: h, offset: v } = i;
      if (h.nodeType == 3) {
        if (f = !!(v && h.nodeValue[v - 1] == `
`), f && v == h.nodeValue.length)
          for (let p = h, y; p; p = p.parentNode) {
            if (y = p.nextSibling) {
              y.nodeName == "BR" && (i = s = { node: y.parentNode, offset: da(y) + 1 });
              break;
            }
            let k = p.pmViewDesc;
            if (k && k.node && k.node.isBlock)
              break;
          }
      } else {
        let p = h.childNodes[v - 1];
        f = p && (p.nodeName == "BR" || p.contentEditable == "false");
      }
    }
    if (Ya && c.focusNode && c.focusNode != s.node && c.focusNode.nodeType == 1) {
      let h = c.focusNode.childNodes[c.focusOffset];
      h && h.contentEditable == "false" && (l = !0);
    }
    if (!(l || f && xa) && Pl(i.node, i.offset, c.anchorNode, c.anchorOffset) && Pl(s.node, s.offset, c.focusNode, c.focusOffset))
      return;
    let g = !1;
    if ((d.extend || a == t) && !(f && Ya)) {
      d.collapse(i.node, i.offset);
      try {
        a != t && d.extend(s.node, s.offset), g = !0;
      } catch {
      }
    }
    if (!g) {
      if (a > t) {
        let v = i;
        i = s, s = v;
      }
      let h = document.createRange();
      h.setEnd(s.node, s.offset), h.setStart(i.node, i.offset), d.removeAllRanges(), d.addRange(h);
    }
  }
  ignoreMutation(a) {
    return !this.contentDOM && a.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(a, t) {
    for (let n = 0, l = 0; l < this.children.length; l++) {
      let o = this.children[l], r = n + o.size;
      if (n == r ? a <= r && t >= n : a < r && t > n) {
        let i = n + o.border, s = r - o.border;
        if (a >= i && t <= s) {
          this.dirty = a == n || t == r ? kl : zh, a == i && t == s && (o.contentLost || o.dom.parentNode != this.contentDOM) ? o.dirty = wn : o.markDirty(a - i, t - i);
          return;
        } else
          o.dirty = o.dom == o.contentDOM && o.dom.parentNode == this.contentDOM && !o.children.length ? kl : wn;
      }
      n = r;
    }
    this.dirty = kl;
  }
  markParentsDirty() {
    let a = 1;
    for (let t = this.parent; t; t = t.parent, a++) {
      let n = a == 1 ? kl : zh;
      t.dirty < n && (t.dirty = n);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(a) {
    return !1;
  }
}
class Ev extends Fr {
  constructor(a, t, n, l) {
    let o, r = t.type.toDOM;
    if (typeof r == "function" && (r = r(n, () => {
      if (!o)
        return l;
      if (o.parent)
        return o.parent.posBeforeChild(o);
    })), !t.type.spec.raw) {
      if (r.nodeType != 1) {
        let i = document.createElement("span");
        i.appendChild(r), r = i;
      }
      r.contentEditable = "false", r.classList.add("ProseMirror-widget");
    }
    super(a, [], r, null), this.widget = t, this.widget = t, o = this;
  }
  matchesWidget(a) {
    return this.dirty == Ja && a.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(a) {
    let t = this.widget.spec.stopEvent;
    return t ? t(a) : !1;
  }
  ignoreMutation(a) {
    return a.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class LL extends Fr {
  constructor(a, t, n, l) {
    super(a, [], t, null), this.textDOM = n, this.text = l;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(a, t) {
    return a != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(a) {
    return { node: this.textDOM, offset: a };
  }
  ignoreMutation(a) {
    return a.type === "characterData" && a.target.nodeValue == a.oldValue;
  }
}
class Fl extends Fr {
  constructor(a, t, n, l, o) {
    super(a, [], n, l), this.mark = t, this.spec = o;
  }
  static create(a, t, n, l) {
    let o = l.nodeViews[t.type.name], r = o && o(t, l, n);
    return (!r || !r.dom) && (r = Vl.renderSpec(document, t.type.spec.toDOM(t, n), null, t.attrs)), new Fl(a, t, r.dom, r.contentDOM || r.dom, r);
  }
  parseRule() {
    return this.dirty & wn || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(a) {
    return this.dirty != wn && this.mark.eq(a);
  }
  markDirty(a, t) {
    if (super.markDirty(a, t), this.dirty != Ja) {
      let n = this.parent;
      for (; !n.node; )
        n = n.parent;
      n.dirty < this.dirty && (n.dirty = this.dirty), this.dirty = Ja;
    }
  }
  slice(a, t, n) {
    let l = Fl.create(this.parent, this.mark, !0, n), o = this.children, r = this.size;
    t < r && (o = Iu(o, t, r, n)), a > 0 && (o = Iu(o, 0, a, n));
    for (let i = 0; i < o.length; i++)
      o[i].parent = l;
    return l.children = o, l;
  }
  ignoreMutation(a) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(a) : super.ignoreMutation(a);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class tl extends Fr {
  constructor(a, t, n, l, o, r, i, s, d) {
    super(a, [], o, r), this.node = t, this.outerDeco = n, this.innerDeco = l, this.nodeDOM = i;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(a, t, n, l, o, r) {
    let i = o.nodeViews[t.type.name], s, d = i && i(t, o, () => {
      if (!s)
        return r;
      if (s.parent)
        return s.parent.posBeforeChild(s);
    }, n, l), c = d && d.dom, f = d && d.contentDOM;
    if (t.isText) {
      if (!c)
        c = document.createTextNode(t.text);
      else if (c.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else c || ({ dom: c, contentDOM: f } = Vl.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !f && !t.isText && c.nodeName != "BR" && (c.hasAttribute("contenteditable") || (c.contentEditable = "false"), t.type.spec.draggable && (c.draggable = !0));
    let g = c;
    return c = Dv(c, n, t), d ? s = new TL(a, t, n, l, c, f || null, g, d, o, r + 1) : t.isText ? new Vs(a, t, n, l, c, g, o) : new tl(a, t, n, l, c, f || null, g, o, r + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let a = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (a.preserveWhitespace = "full"), !this.contentDOM)
      a.getContent = () => this.node.content;
    else if (!this.contentLost)
      a.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let n = this.children[t];
        if (this.dom.contains(n.dom.parentNode)) {
          a.contentElement = n.dom.parentNode;
          break;
        }
      }
      a.contentElement || (a.getContent = () => We.empty);
    }
    return a;
  }
  matchesNode(a, t, n) {
    return this.dirty == Ja && a.eq(this.node) && Ni(t, this.outerDeco) && n.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(a, t) {
    let n = this.node.inlineContent, l = t, o = a.composing ? this.localCompositionInfo(a, t) : null, r = o && o.pos > -1 ? o : null, i = o && o.pos < 0, s = new AL(this, r && r.node, a);
    DL(this.node, this.innerDeco, (d, c, f) => {
      d.spec.marks ? s.syncToMarks(d.spec.marks, n, a, c) : d.type.side >= 0 && !f && s.syncToMarks(c == this.node.childCount ? Mt.none : this.node.child(c).marks, n, a, c), s.placeWidget(d, a, l);
    }, (d, c, f, g) => {
      s.syncToMarks(d.marks, n, a, g);
      let h;
      s.findNodeMatch(d, c, f, g) || i && a.state.selection.from > l && a.state.selection.to < l + d.nodeSize && (h = s.findIndexWithChild(o.node)) > -1 && s.updateNodeAt(d, c, f, h, a) || s.updateNextNode(d, c, f, a, g, l) || s.addNode(d, c, f, a, l), l += d.nodeSize;
    }), s.syncToMarks([], n, a, 0), this.node.isTextblock && s.addTextblockHacks(), s.destroyRest(), (s.changed || this.dirty == kl) && (r && this.protectLocalComposition(a, r), Rv(this.contentDOM, this.children, a), vo && BL(this.dom));
  }
  localCompositionInfo(a, t) {
    let { from: n, to: l } = a.state.selection;
    if (!(a.state.selection instanceof ht) || n < t || l > t + this.node.content.size)
      return null;
    let o = a.input.compositionNode;
    if (!o || !this.dom.contains(o.parentNode))
      return null;
    if (this.node.inlineContent) {
      let r = o.nodeValue, i = ML(this.node.content, r, n - t, l - t);
      return i < 0 ? null : { node: o, pos: i, text: r };
    } else
      return { node: o, pos: -1, text: "" };
  }
  protectLocalComposition(a, { node: t, pos: n, text: l }) {
    if (this.getDesc(t))
      return;
    let o = t;
    for (; o.parentNode != this.contentDOM; o = o.parentNode) {
      for (; o.previousSibling; )
        o.parentNode.removeChild(o.previousSibling);
      for (; o.nextSibling; )
        o.parentNode.removeChild(o.nextSibling);
      o.pmViewDesc && (o.pmViewDesc = void 0);
    }
    let r = new LL(this, o, t, l);
    a.input.compositionNodes.push(r), this.children = Iu(this.children, n, n + l.length, a, r);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(a, t, n, l) {
    return this.dirty == wn || !a.sameMarkup(this.node) ? !1 : (this.updateInner(a, t, n, l), !0);
  }
  updateInner(a, t, n, l) {
    this.updateOuterDeco(t), this.node = a, this.innerDeco = n, this.contentDOM && this.updateChildren(l, this.posAtStart), this.dirty = Ja;
  }
  updateOuterDeco(a) {
    if (Ni(a, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, n = this.dom;
    this.dom = zv(this.dom, this.nodeDOM, $u(this.outerDeco, this.node, t), $u(a, this.node, t)), this.dom != n && (n.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = a;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function Dh(e, a, t, n, l) {
  Dv(n, a, e);
  let o = new tl(void 0, e, a, t, n, n, n, l, 0);
  return o.contentDOM && o.updateChildren(l, 0), o;
}
class Vs extends tl {
  constructor(a, t, n, l, o, r, i) {
    super(a, t, n, l, o, null, r, i, 0);
  }
  parseRule() {
    let a = this.nodeDOM.parentNode;
    for (; a && a != this.dom && !a.pmIsDeco; )
      a = a.parentNode;
    return { skip: a || !0 };
  }
  update(a, t, n, l) {
    return this.dirty == wn || this.dirty != Ja && !this.inParent() || !a.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != Ja || a.text != this.node.text) && a.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = a.text, l.trackWrites == this.nodeDOM && (l.trackWrites = null)), this.node = a, this.dirty = Ja, !0);
  }
  inParent() {
    let a = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == a)
        return !0;
    return !1;
  }
  domFromPos(a) {
    return { node: this.nodeDOM, offset: a };
  }
  localPosFromDOM(a, t, n) {
    return a == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(a, t, n);
  }
  ignoreMutation(a) {
    return a.type != "characterData" && a.type != "selection";
  }
  slice(a, t, n) {
    let l = this.node.cut(a, t), o = document.createTextNode(l.text);
    return new Vs(this.parent, l, this.outerDeco, this.innerDeco, o, o, n);
  }
  markDirty(a, t) {
    super.markDirty(a, t), this.dom != this.nodeDOM && (a == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = wn);
  }
  get domAtom() {
    return !1;
  }
  isText(a) {
    return this.node.text == a;
  }
}
class Av extends Fr {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(a) {
    return this.dirty == Ja && this.dom.nodeName == a;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class TL extends tl {
  constructor(a, t, n, l, o, r, i, s, d, c) {
    super(a, t, n, l, o, r, i, d, c), this.spec = s;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(a, t, n, l) {
    if (this.dirty == wn)
      return !1;
    if (this.spec.update && (this.node.type == a.type || this.spec.multiType)) {
      let o = this.spec.update(a, t, n);
      return o && this.updateInner(a, t, n, l), o;
    } else return !this.contentDOM && !a.isLeaf ? !1 : super.update(a, t, n, l);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(a, t, n, l) {
    this.spec.setSelection ? this.spec.setSelection(a, t, n.root) : super.setSelection(a, t, n, l);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(a) {
    return this.spec.stopEvent ? this.spec.stopEvent(a) : !1;
  }
  ignoreMutation(a) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(a) : super.ignoreMutation(a);
  }
}
function Rv(e, a, t) {
  let n = e.firstChild, l = !1;
  for (let o = 0; o < a.length; o++) {
    let r = a[o], i = r.dom;
    if (i.parentNode == e) {
      for (; i != n; )
        n = Bh(n), l = !0;
      n = n.nextSibling;
    } else
      l = !0, e.insertBefore(i, n);
    if (r instanceof Fl) {
      let s = n ? n.previousSibling : e.lastChild;
      Rv(r.contentDOM, r.children, t), n = s ? s.nextSibling : e.firstChild;
    }
  }
  for (; n; )
    n = Bh(n), l = !0;
  l && t.trackWrites == e && (t.trackWrites = null);
}
const _o = function(e) {
  e && (this.nodeName = e);
};
_o.prototype = /* @__PURE__ */ Object.create(null);
const wl = [new _o()];
function $u(e, a, t) {
  if (e.length == 0)
    return wl;
  let n = t ? wl[0] : new _o(), l = [n];
  for (let o = 0; o < e.length; o++) {
    let r = e[o].type.attrs;
    if (r) {
      r.nodeName && l.push(n = new _o(r.nodeName));
      for (let i in r) {
        let s = r[i];
        s != null && (t && l.length == 1 && l.push(n = new _o(a.isInline ? "span" : "div")), i == "class" ? n.class = (n.class ? n.class + " " : "") + s : i == "style" ? n.style = (n.style ? n.style + ";" : "") + s : i != "nodeName" && (n[i] = s));
      }
    }
  }
  return l;
}
function zv(e, a, t, n) {
  if (t == wl && n == wl)
    return a;
  let l = a;
  for (let o = 0; o < n.length; o++) {
    let r = n[o], i = t[o];
    if (o) {
      let s;
      i && i.nodeName == r.nodeName && l != e && (s = l.parentNode) && s.nodeName.toLowerCase() == r.nodeName || (s = document.createElement(r.nodeName), s.pmIsDeco = !0, s.appendChild(l), i = wl[0]), l = s;
    }
    EL(l, i || wl[0], r);
  }
  return l;
}
function EL(e, a, t) {
  for (let n in a)
    n != "class" && n != "style" && n != "nodeName" && !(n in t) && e.removeAttribute(n);
  for (let n in t)
    n != "class" && n != "style" && n != "nodeName" && t[n] != a[n] && e.setAttribute(n, t[n]);
  if (a.class != t.class) {
    let n = a.class ? a.class.split(" ").filter(Boolean) : [], l = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let o = 0; o < n.length; o++)
      l.indexOf(n[o]) == -1 && e.classList.remove(n[o]);
    for (let o = 0; o < l.length; o++)
      n.indexOf(l[o]) == -1 && e.classList.add(l[o]);
    e.classList.length == 0 && e.removeAttribute("class");
  }
  if (a.style != t.style) {
    if (a.style) {
      let n = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, l;
      for (; l = n.exec(a.style); )
        e.style.removeProperty(l[1]);
    }
    t.style && (e.style.cssText += t.style);
  }
}
function Dv(e, a, t) {
  return zv(e, e, wl, $u(a, t, e.nodeType != 1));
}
function Ni(e, a) {
  if (e.length != a.length)
    return !1;
  for (let t = 0; t < e.length; t++)
    if (!e[t].type.eq(a[t].type))
      return !1;
  return !0;
}
function Bh(e) {
  let a = e.nextSibling;
  return e.parentNode.removeChild(e), a;
}
class AL {
  constructor(a, t, n) {
    this.lock = t, this.view = n, this.index = 0, this.stack = [], this.changed = !1, this.top = a, this.preMatch = RL(a.node.content, a);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(a, t) {
    if (a != t) {
      for (let n = a; n < t; n++)
        this.top.children[n].destroy();
      this.top.children.splice(a, t - a), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(a, t, n, l) {
    let o = 0, r = this.stack.length >> 1, i = Math.min(r, a.length);
    for (; o < i && (o == r - 1 ? this.top : this.stack[o + 1 << 1]).matchesMark(a[o]) && a[o].type.spec.spanning !== !1; )
      o++;
    for (; o < r; )
      this.destroyRest(), this.top.dirty = Ja, this.index = this.stack.pop(), this.top = this.stack.pop(), r--;
    for (; r < a.length; ) {
      this.stack.push(this.top, this.index + 1);
      let s = -1, d = this.top.children.length;
      l < this.preMatch.index && (d = Math.min(this.index + 3, d));
      for (let c = this.index; c < d; c++) {
        let f = this.top.children[c];
        if (f.matchesMark(a[r]) && !this.isLocked(f.dom)) {
          s = c;
          break;
        }
      }
      if (s > -1)
        s > this.index && (this.changed = !0, this.destroyBetween(this.index, s)), this.top = this.top.children[this.index];
      else {
        let c = Fl.create(this.top, a[r], t, n);
        this.top.children.splice(this.index, 0, c), this.top = c, this.changed = !0;
      }
      this.index = 0, r++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(a, t, n, l) {
    let o = -1, r;
    if (l >= this.preMatch.index && (r = this.preMatch.matches[l - this.preMatch.index]).parent == this.top && r.matchesNode(a, t, n))
      o = this.top.children.indexOf(r, this.index);
    else
      for (let i = this.index, s = Math.min(this.top.children.length, i + 5); i < s; i++) {
        let d = this.top.children[i];
        if (d.matchesNode(a, t, n) && !this.preMatch.matched.has(d)) {
          o = i;
          break;
        }
      }
    return o < 0 ? !1 : (this.destroyBetween(this.index, o), this.index++, !0);
  }
  updateNodeAt(a, t, n, l, o) {
    let r = this.top.children[l];
    return r.dirty == wn && r.dom == r.contentDOM && (r.dirty = kl), r.update(a, t, n, o) ? (this.destroyBetween(this.index, l), this.index++, !0) : !1;
  }
  findIndexWithChild(a) {
    for (; ; ) {
      let t = a.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let n = a.pmViewDesc;
        if (n) {
          for (let l = this.index; l < this.top.children.length; l++)
            if (this.top.children[l] == n)
              return l;
        }
        return -1;
      }
      a = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(a, t, n, l, o, r) {
    for (let i = this.index; i < this.top.children.length; i++) {
      let s = this.top.children[i];
      if (s instanceof tl) {
        let d = this.preMatch.matched.get(s);
        if (d != null && d != o)
          return !1;
        let c = s.dom, f, g = this.isLocked(c) && !(a.isText && s.node && s.node.isText && s.nodeDOM.nodeValue == a.text && s.dirty != wn && Ni(t, s.outerDeco));
        if (!g && s.update(a, t, n, l))
          return this.destroyBetween(this.index, i), s.dom != c && (this.changed = !0), this.index++, !0;
        if (!g && (f = this.recreateWrapper(s, a, t, n, l, r)))
          return this.destroyBetween(this.index, i), this.top.children[this.index] = f, f.contentDOM && (f.dirty = kl, f.updateChildren(l, r + 1), f.dirty = Ja), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(a, t, n, l, o, r) {
    if (a.dirty || t.isAtom || !a.children.length || !a.node.content.eq(t.content) || !Ni(n, a.outerDeco) || !l.eq(a.innerDeco))
      return null;
    let i = tl.create(this.top, t, n, l, o, r);
    if (i.contentDOM) {
      i.children = a.children, a.children = [];
      for (let s of i.children)
        s.parent = i;
    }
    return a.destroy(), i;
  }
  // Insert the node as a newly created node desc.
  addNode(a, t, n, l, o) {
    let r = tl.create(this.top, a, t, n, l, o);
    r.contentDOM && r.updateChildren(l, o + 1), this.top.children.splice(this.index++, 0, r), this.changed = !0;
  }
  placeWidget(a, t, n) {
    let l = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (l && l.matchesWidget(a) && (a == l.widget || !l.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let o = new Ev(this.top, a, t, n);
      this.top.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let a = this.top.children[this.index - 1], t = this.top;
    for (; a instanceof Fl; )
      t = a, a = t.children[t.children.length - 1];
    (!a || // Empty textblock
    !(a instanceof Vs) || /\n$/.test(a.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(a.node.text)) && ((xa || ca) && a && a.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(a, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(a))
      this.index++;
    else {
      let n = document.createElement(a);
      a == "IMG" && (n.className = "ProseMirror-separator", n.alt = ""), a == "BR" && (n.className = "ProseMirror-trailingBreak");
      let l = new Av(this.top, [], n, null);
      t != this.top ? t.children.push(l) : t.children.splice(this.index++, 0, l), this.changed = !0;
    }
  }
  isLocked(a) {
    return this.lock && (a == this.lock || a.nodeType == 1 && a.contains(this.lock.parentNode));
  }
}
function RL(e, a) {
  let t = a, n = t.children.length, l = e.childCount, o = /* @__PURE__ */ new Map(), r = [];
  e: for (; l > 0; ) {
    let i;
    for (; ; )
      if (n) {
        let d = t.children[n - 1];
        if (d instanceof Fl)
          t = d, n = d.children.length;
        else {
          i = d, n--;
          break;
        }
      } else {
        if (t == a)
          break e;
        n = t.parent.children.indexOf(t), t = t.parent;
      }
    let s = i.node;
    if (s) {
      if (s != e.child(l - 1))
        break;
      --l, o.set(i, l), r.push(i);
    }
  }
  return { index: l, matched: o, matches: r.reverse() };
}
function zL(e, a) {
  return e.type.side - a.type.side;
}
function DL(e, a, t, n) {
  let l = a.locals(e), o = 0;
  if (l.length == 0) {
    for (let d = 0; d < e.childCount; d++) {
      let c = e.child(d);
      n(c, l, a.forChild(o, c), d), o += c.nodeSize;
    }
    return;
  }
  let r = 0, i = [], s = null;
  for (let d = 0; ; ) {
    let c, f;
    for (; r < l.length && l[r].to == o; ) {
      let y = l[r++];
      y.widget && (c ? (f || (f = [c])).push(y) : c = y);
    }
    if (c)
      if (f) {
        f.sort(zL);
        for (let y = 0; y < f.length; y++)
          t(f[y], d, !!s);
      } else
        t(c, d, !!s);
    let g, h;
    if (s)
      h = -1, g = s, s = null;
    else if (d < e.childCount)
      h = d, g = e.child(d++);
    else
      break;
    for (let y = 0; y < i.length; y++)
      i[y].to <= o && i.splice(y--, 1);
    for (; r < l.length && l[r].from <= o && l[r].to > o; )
      i.push(l[r++]);
    let v = o + g.nodeSize;
    if (g.isText) {
      let y = v;
      r < l.length && l[r].from < y && (y = l[r].from);
      for (let k = 0; k < i.length; k++)
        i[k].to < y && (y = i[k].to);
      y < v && (s = g.cut(y - o), g = g.cut(0, y - o), v = y, h = -1);
    } else
      for (; r < l.length && l[r].to < v; )
        r++;
    let p = g.isInline && !g.isLeaf ? i.filter((y) => !y.inline) : i.slice();
    n(g, p, a.forChild(o, g), h), o = v;
  }
}
function BL(e) {
  if (e.nodeName == "UL" || e.nodeName == "OL") {
    let a = e.style.cssText;
    e.style.cssText = a + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = a;
  }
}
function ML(e, a, t, n) {
  for (let l = 0, o = 0; l < e.childCount && o <= n; ) {
    let r = e.child(l++), i = o;
    if (o += r.nodeSize, !r.isText)
      continue;
    let s = r.text;
    for (; l < e.childCount; ) {
      let d = e.child(l++);
      if (o += d.nodeSize, !d.isText)
        break;
      s += d.text;
    }
    if (o >= t) {
      if (o >= n && s.slice(n - a.length - i, n - i) == a)
        return n - a.length;
      let d = i < n ? s.lastIndexOf(a, n - i - 1) : -1;
      if (d >= 0 && d + a.length + i >= t)
        return i + d;
      if (t == n && s.length >= n + a.length - i && s.slice(n - i, n - i + a.length) == a)
        return n;
    }
  }
  return -1;
}
function Iu(e, a, t, n, l) {
  let o = [];
  for (let r = 0, i = 0; r < e.length; r++) {
    let s = e[r], d = i, c = i += s.size;
    d >= t || c <= a ? o.push(s) : (d < a && o.push(s.slice(0, a - d, n)), l && (o.push(l), l = void 0), c > t && o.push(s.slice(t - d, s.size, n)));
  }
  return o;
}
function Fc(e, a = null) {
  let t = e.domSelectionRange(), n = e.state.doc;
  if (!t.focusNode)
    return null;
  let l = e.docView.nearestDesc(t.focusNode), o = l && l.size == 0, r = e.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (r < 0)
    return null;
  let i = n.resolve(r), s, d;
  if (Ns(t)) {
    for (s = r; l && !l.node; )
      l = l.parent;
    let f = l.node;
    if (l && f.isAtom && dt.isSelectable(f) && l.parent && !(f.isInline && sL(t.focusNode, t.focusOffset, l.dom))) {
      let g = l.posBefore;
      d = new dt(r == g ? i : n.resolve(g));
    }
  } else {
    if (t instanceof e.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let f = r, g = r;
      for (let h = 0; h < t.rangeCount; h++) {
        let v = t.getRangeAt(h);
        f = Math.min(f, e.docView.posFromDOM(v.startContainer, v.startOffset, 1)), g = Math.max(g, e.docView.posFromDOM(v.endContainer, v.endOffset, -1));
      }
      if (f < 0)
        return null;
      [s, r] = g == e.state.selection.anchor ? [g, f] : [f, g], i = n.resolve(r);
    } else
      s = e.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (s < 0)
      return null;
  }
  let c = n.resolve(s);
  if (!d) {
    let f = a == "pointer" || e.state.selection.head < i.pos && !o ? 1 : -1;
    d = Nc(e, c, i, f);
  }
  return d;
}
function Bv(e) {
  return e.editable ? e.hasFocus() : Ov(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function Dn(e, a = !1) {
  let t = e.state.selection;
  if (Mv(e, t), !!Bv(e)) {
    if (!a && e.input.mouseDown && e.input.mouseDown.allowDefault && ca) {
      let n = e.domSelectionRange(), l = e.domObserver.currentSelection;
      if (n.anchorNode && l.anchorNode && Pl(n.anchorNode, n.anchorOffset, l.anchorNode, l.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      PL(e);
    else {
      let { anchor: n, head: l } = t, o, r;
      Mh && !(t instanceof ht) && (t.$from.parent.inlineContent || (o = Oh(e, t.from)), !t.empty && !t.$from.parent.inlineContent && (r = Oh(e, t.to))), e.docView.setSelection(n, l, e, a), Mh && (o && Ph(o), r && Ph(r)), t.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && OL(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const Mh = xa || ca && kv < 63;
function Oh(e, a) {
  let { node: t, offset: n } = e.docView.domFromPos(a, 0), l = n < t.childNodes.length ? t.childNodes[n] : null, o = n ? t.childNodes[n - 1] : null;
  if (xa && l && l.contentEditable == "false")
    return xd(l);
  if ((!l || l.contentEditable == "false") && (!o || o.contentEditable == "false")) {
    if (l)
      return xd(l);
    if (o)
      return xd(o);
  }
}
function xd(e) {
  return e.contentEditable = "true", xa && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function Ph(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function OL(e) {
  let a = e.dom.ownerDocument;
  a.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let t = e.domSelectionRange(), n = t.anchorNode, l = t.anchorOffset;
  a.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (t.anchorNode != n || t.anchorOffset != l) && (a.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!Bv(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function PL(e) {
  let a = e.domSelection();
  if (!a)
    return;
  let t = e.cursorWrapper.dom, n = t.nodeName == "IMG";
  n ? a.collapse(t.parentNode, da(t) + 1) : a.collapse(t, 0), !n && !e.state.selection.visible && Aa && el <= 11 && (t.disabled = !0, t.disabled = !1);
}
function Mv(e, a) {
  if (a instanceof dt) {
    let t = e.docView.descAt(a.from);
    t != e.lastSelectedViewDesc && (Fh(e), t && t.selectNode(), e.lastSelectedViewDesc = t);
  } else
    Fh(e);
}
function Fh(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function Nc(e, a, t, n) {
  return e.someProp("createSelectionBetween", (l) => l(e, a, t)) || ht.between(a, t, n);
}
function Nh(e) {
  return e.editable && !e.hasFocus() ? !1 : Ov(e);
}
function Ov(e) {
  let a = e.domSelectionRange();
  if (!a.anchorNode)
    return !1;
  try {
    return e.dom.contains(a.anchorNode.nodeType == 3 ? a.anchorNode.parentNode : a.anchorNode) && (e.editable || e.dom.contains(a.focusNode.nodeType == 3 ? a.focusNode.parentNode : a.focusNode));
  } catch {
    return !1;
  }
}
function FL(e) {
  let a = e.docView.domFromPos(e.state.selection.anchor, 0), t = e.domSelectionRange();
  return Pl(a.node, a.offset, t.anchorNode, t.anchorOffset);
}
function Lu(e, a) {
  let { $anchor: t, $head: n } = e.selection, l = a > 0 ? t.max(n) : t.min(n), o = l.parent.inlineContent ? l.depth ? e.doc.resolve(a > 0 ? l.after() : l.before()) : null : l;
  return o && xt.findFrom(o, a);
}
function Hn(e, a) {
  return e.dispatch(e.state.tr.setSelection(a).scrollIntoView()), !0;
}
function Vh(e, a, t) {
  let n = e.state.selection;
  if (n instanceof ht)
    if (t.indexOf("s") > -1) {
      let { $head: l } = n, o = l.textOffset ? null : a < 0 ? l.nodeBefore : l.nodeAfter;
      if (!o || o.isText || !o.isLeaf)
        return !1;
      let r = e.state.doc.resolve(l.pos + o.nodeSize * (a < 0 ? -1 : 1));
      return Hn(e, new ht(n.$anchor, r));
    } else if (n.empty) {
      if (e.endOfTextblock(a > 0 ? "forward" : "backward")) {
        let l = Lu(e.state, a);
        return l && l instanceof dt ? Hn(e, l) : !1;
      } else if (!(Wa && t.indexOf("m") > -1)) {
        let l = n.$head, o = l.textOffset ? null : a < 0 ? l.nodeBefore : l.nodeAfter, r;
        if (!o || o.isText)
          return !1;
        let i = a < 0 ? l.pos - o.nodeSize : l.pos;
        return o.isAtom || (r = e.docView.descAt(i)) && !r.contentDOM ? dt.isSelectable(o) ? Hn(e, new dt(a < 0 ? e.state.doc.resolve(l.pos - o.nodeSize) : l)) : Pr ? Hn(e, new ht(e.state.doc.resolve(a < 0 ? i : i + o.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (n instanceof dt && n.node.isInline)
      return Hn(e, new ht(a > 0 ? n.$to : n.$from));
    {
      let l = Lu(e.state, a);
      return l ? Hn(e, l) : !1;
    }
  }
}
function Vi(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function er(e, a) {
  let t = e.pmViewDesc;
  return t && t.size == 0 && (a < 0 || e.nextSibling || e.nodeName != "BR");
}
function ql(e, a) {
  return a < 0 ? NL(e) : VL(e);
}
function NL(e) {
  let a = e.domSelectionRange(), t = a.focusNode, n = a.focusOffset;
  if (!t)
    return;
  let l, o, r = !1;
  for (Ya && t.nodeType == 1 && n < Vi(t) && er(t.childNodes[n], -1) && (r = !0); ; )
    if (n > 0) {
      if (t.nodeType != 1)
        break;
      {
        let i = t.childNodes[n - 1];
        if (er(i, -1))
          l = t, o = --n;
        else if (i.nodeType == 3)
          t = i, n = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (Pv(t))
        break;
      {
        let i = t.previousSibling;
        for (; i && er(i, -1); )
          l = t.parentNode, o = da(i), i = i.previousSibling;
        if (i)
          t = i, n = Vi(t);
        else {
          if (t = t.parentNode, t == e.dom)
            break;
          n = 0;
        }
      }
    }
  r ? Tu(e, t, n) : l && Tu(e, l, o);
}
function VL(e) {
  let a = e.domSelectionRange(), t = a.focusNode, n = a.focusOffset;
  if (!t)
    return;
  let l = Vi(t), o, r;
  for (; ; )
    if (n < l) {
      if (t.nodeType != 1)
        break;
      let i = t.childNodes[n];
      if (er(i, 1))
        o = t, r = ++n;
      else
        break;
    } else {
      if (Pv(t))
        break;
      {
        let i = t.nextSibling;
        for (; i && er(i, 1); )
          o = i.parentNode, r = da(i) + 1, i = i.nextSibling;
        if (i)
          t = i, n = 0, l = Vi(t);
        else {
          if (t = t.parentNode, t == e.dom)
            break;
          n = l = 0;
        }
      }
    }
  o && Tu(e, o, r);
}
function Pv(e) {
  let a = e.pmViewDesc;
  return a && a.node && a.node.isBlock;
}
function HL(e, a) {
  for (; e && a == e.childNodes.length && !Or(e); )
    a = da(e) + 1, e = e.parentNode;
  for (; e && a < e.childNodes.length; ) {
    let t = e.childNodes[a];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    e = t, a = 0;
  }
}
function jL(e, a) {
  for (; e && !a && !Or(e); )
    a = da(e), e = e.parentNode;
  for (; e && a; ) {
    let t = e.childNodes[a - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    e = t, a = e.childNodes.length;
  }
}
function Tu(e, a, t) {
  if (a.nodeType != 3) {
    let o, r;
    (r = HL(a, t)) ? (a = r, t = 0) : (o = jL(a, t)) && (a = o, t = o.nodeValue.length);
  }
  let n = e.domSelection();
  if (!n)
    return;
  if (Ns(n)) {
    let o = document.createRange();
    o.setEnd(a, t), o.setStart(a, t), n.removeAllRanges(), n.addRange(o);
  } else n.extend && n.extend(a, t);
  e.domObserver.setCurSelection();
  let { state: l } = e;
  setTimeout(() => {
    e.state == l && Dn(e);
  }, 50);
}
function Hh(e, a) {
  let t = e.state.doc.resolve(a);
  if (!(ca || wv) && t.parent.inlineContent) {
    let l = e.coordsAtPos(a);
    if (a > t.start()) {
      let o = e.coordsAtPos(a - 1), r = (o.top + o.bottom) / 2;
      if (r > l.top && r < l.bottom && Math.abs(o.left - l.left) > 1)
        return o.left < l.left ? "ltr" : "rtl";
    }
    if (a < t.end()) {
      let o = e.coordsAtPos(a + 1), r = (o.top + o.bottom) / 2;
      if (r > l.top && r < l.bottom && Math.abs(o.left - l.left) > 1)
        return o.left > l.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function jh(e, a, t) {
  let n = e.state.selection;
  if (n instanceof ht && !n.empty || t.indexOf("s") > -1 || Wa && t.indexOf("m") > -1)
    return !1;
  let { $from: l, $to: o } = n;
  if (!l.parent.inlineContent || e.endOfTextblock(a < 0 ? "up" : "down")) {
    let r = Lu(e.state, a);
    if (r && r instanceof dt)
      return Hn(e, r);
  }
  if (!l.parent.inlineContent) {
    let r = a < 0 ? l : o, i = n instanceof Ma ? xt.near(r, a) : xt.findFrom(r, a);
    return i ? Hn(e, i) : !1;
  }
  return !1;
}
function Wh(e, a) {
  if (!(e.state.selection instanceof ht))
    return !0;
  let { $head: t, $anchor: n, empty: l } = e.state.selection;
  if (!t.sameParent(n))
    return !0;
  if (!l)
    return !1;
  if (e.endOfTextblock(a > 0 ? "forward" : "backward"))
    return !0;
  let o = !t.textOffset && (a < 0 ? t.nodeBefore : t.nodeAfter);
  if (o && !o.isText) {
    let r = e.state.tr;
    return a < 0 ? r.delete(t.pos - o.nodeSize, t.pos) : r.delete(t.pos, t.pos + o.nodeSize), e.dispatch(r), !0;
  }
  return !1;
}
function qh(e, a, t) {
  e.domObserver.stop(), a.contentEditable = t, e.domObserver.start();
}
function WL(e) {
  if (!xa || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: a, focusOffset: t } = e.domSelectionRange();
  if (a && a.nodeType == 1 && t == 0 && a.firstChild && a.firstChild.contentEditable == "false") {
    let n = a.firstChild;
    qh(e, n, "true"), setTimeout(() => qh(e, n, "false"), 20);
  }
  return !1;
}
function qL(e) {
  let a = "";
  return e.ctrlKey && (a += "c"), e.metaKey && (a += "m"), e.altKey && (a += "a"), e.shiftKey && (a += "s"), a;
}
function UL(e, a) {
  let t = a.keyCode, n = qL(a);
  if (t == 8 || Wa && t == 72 && n == "c")
    return Wh(e, -1) || ql(e, -1);
  if (t == 46 && !a.shiftKey || Wa && t == 68 && n == "c")
    return Wh(e, 1) || ql(e, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || Wa && t == 66 && n == "c") {
    let l = t == 37 ? Hh(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return Vh(e, l, n) || ql(e, l);
  } else if (t == 39 || Wa && t == 70 && n == "c") {
    let l = t == 39 ? Hh(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return Vh(e, l, n) || ql(e, l);
  } else {
    if (t == 38 || Wa && t == 80 && n == "c")
      return jh(e, -1, n) || ql(e, -1);
    if (t == 40 || Wa && t == 78 && n == "c")
      return WL(e) || jh(e, 1, n) || ql(e, 1);
    if (n == (Wa ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function Vc(e, a) {
  e.someProp("transformCopied", (h) => {
    a = h(a, e);
  });
  let t = [], { content: n, openStart: l, openEnd: o } = a;
  for (; l > 1 && o > 1 && n.childCount == 1 && n.firstChild.childCount == 1; ) {
    l--, o--;
    let h = n.firstChild;
    t.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), n = h.content;
  }
  let r = e.someProp("clipboardSerializer") || Vl.fromSchema(e.state.schema), i = Wv(), s = i.createElement("div");
  s.appendChild(r.serializeFragment(n, { document: i }));
  let d = s.firstChild, c, f = 0;
  for (; d && d.nodeType == 1 && (c = jv[d.nodeName.toLowerCase()]); ) {
    for (let h = c.length - 1; h >= 0; h--) {
      let v = i.createElement(c[h]);
      for (; s.firstChild; )
        v.appendChild(s.firstChild);
      s.appendChild(v), f++;
    }
    d = s.firstChild;
  }
  d && d.nodeType == 1 && d.setAttribute("data-pm-slice", `${l} ${o}${f ? ` -${f}` : ""} ${JSON.stringify(t)}`);
  let g = e.someProp("clipboardTextSerializer", (h) => h(a, e)) || a.content.textBetween(0, a.content.size, `

`);
  return { dom: s, text: g, slice: a };
}
function Fv(e, a, t, n, l) {
  let o = l.parent.type.spec.code, r, i;
  if (!t && !a)
    return null;
  let s = !!a && (n || o || !t);
  if (s) {
    if (e.someProp("transformPastedText", (g) => {
      a = g(a, o || n, e);
    }), o)
      return i = new tt(We.from(e.state.schema.text(a.replace(/\r\n?/g, `
`))), 0, 0), e.someProp("transformPasted", (g) => {
        i = g(i, e, !0);
      }), i;
    let f = e.someProp("clipboardTextParser", (g) => g(a, l, n, e));
    if (f)
      i = f;
    else {
      let g = l.marks(), { schema: h } = e.state, v = Vl.fromSchema(h);
      r = document.createElement("div"), a.split(/(?:\r\n?|\n)+/).forEach((p) => {
        let y = r.appendChild(document.createElement("p"));
        p && y.appendChild(v.serializeNode(h.text(p, g)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (f) => {
      t = f(t, e);
    }), r = JL(t), Pr && XL(r);
  let d = r && r.querySelector("[data-pm-slice]"), c = d && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(d.getAttribute("data-pm-slice") || "");
  if (c && c[3])
    for (let f = +c[3]; f > 0; f--) {
      let g = r.firstChild;
      for (; g && g.nodeType != 1; )
        g = g.nextSibling;
      if (!g)
        break;
      r = g;
    }
  if (i || (i = (e.someProp("clipboardParser") || e.someProp("domParser") || _n.fromSchema(e.state.schema)).parseSlice(r, {
    preserveWhitespace: !!(s || c),
    context: l,
    ruleFromNode(g) {
      return g.nodeName == "BR" && !g.nextSibling && g.parentNode && !GL.test(g.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), c)
    i = ZL(Uh(i, +c[1], +c[2]), c[4]);
  else if (i = tt.maxOpen(KL(i.content, l), !0), i.openStart || i.openEnd) {
    let f = 0, g = 0;
    for (let h = i.content.firstChild; f < i.openStart && !h.type.spec.isolating; f++, h = h.firstChild)
      ;
    for (let h = i.content.lastChild; g < i.openEnd && !h.type.spec.isolating; g++, h = h.lastChild)
      ;
    i = Uh(i, f, g);
  }
  return e.someProp("transformPasted", (f) => {
    i = f(i, e, s);
  }), i;
}
const GL = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function KL(e, a) {
  if (e.childCount < 2)
    return e;
  for (let t = a.depth; t >= 0; t--) {
    let l = a.node(t).contentMatchAt(a.index(t)), o, r = [];
    if (e.forEach((i) => {
      if (!r)
        return;
      let s = l.findWrapping(i.type), d;
      if (!s)
        return r = null;
      if (d = r.length && o.length && Vv(s, o, i, r[r.length - 1], 0))
        r[r.length - 1] = d;
      else {
        r.length && (r[r.length - 1] = Hv(r[r.length - 1], o.length));
        let c = Nv(i, s);
        r.push(c), l = l.matchType(c.type), o = s;
      }
    }), r)
      return We.from(r);
  }
  return e;
}
function Nv(e, a, t = 0) {
  for (let n = a.length - 1; n >= t; n--)
    e = a[n].create(null, We.from(e));
  return e;
}
function Vv(e, a, t, n, l) {
  if (l < e.length && l < a.length && e[l] == a[l]) {
    let o = Vv(e, a, t, n.lastChild, l + 1);
    if (o)
      return n.copy(n.content.replaceChild(n.childCount - 1, o));
    if (n.contentMatchAt(n.childCount).matchType(l == e.length - 1 ? t.type : e[l + 1]))
      return n.copy(n.content.append(We.from(Nv(t, e, l + 1))));
  }
}
function Hv(e, a) {
  if (a == 0)
    return e;
  let t = e.content.replaceChild(e.childCount - 1, Hv(e.lastChild, a - 1)), n = e.contentMatchAt(e.childCount).fillBefore(We.empty, !0);
  return e.copy(t.append(n));
}
function Eu(e, a, t, n, l, o) {
  let r = a < 0 ? e.firstChild : e.lastChild, i = r.content;
  return e.childCount > 1 && (o = 0), l < n - 1 && (i = Eu(i, a, t, n, l + 1, o)), l >= t && (i = a < 0 ? r.contentMatchAt(0).fillBefore(i, o <= l).append(i) : i.append(r.contentMatchAt(r.childCount).fillBefore(We.empty, !0))), e.replaceChild(a < 0 ? 0 : e.childCount - 1, r.copy(i));
}
function Uh(e, a, t) {
  return a < e.openStart && (e = new tt(Eu(e.content, -1, a, e.openStart, 0, e.openEnd), a, e.openEnd)), t < e.openEnd && (e = new tt(Eu(e.content, 1, t, e.openEnd, 0, 0), e.openStart, t)), e;
}
const jv = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let Gh = null;
function Wv() {
  return Gh || (Gh = document.implementation.createHTMLDocument("title"));
}
let yd = null;
function YL(e) {
  let a = window.trustedTypes;
  return a ? (yd || (yd = a.defaultPolicy || a.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), yd.createHTML(e)) : e;
}
function JL(e) {
  let a = /^(\s*<meta [^>]*>)*/.exec(e);
  a && (e = e.slice(a[0].length));
  let t = Wv().createElement("div"), n = /<([a-z][^>\s]+)/i.exec(e), l;
  if ((l = n && jv[n[1].toLowerCase()]) && (e = l.map((o) => "<" + o + ">").join("") + e + l.map((o) => "</" + o + ">").reverse().join("")), t.innerHTML = YL(e), l)
    for (let o = 0; o < l.length; o++)
      t = t.querySelector(l[o]) || t;
  return t;
}
function XL(e) {
  let a = e.querySelectorAll(ca ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < a.length; t++) {
    let n = a[t];
    n.childNodes.length == 1 && n.textContent == " " && n.parentNode && n.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), n);
  }
}
function ZL(e, a) {
  if (!e.size)
    return e;
  let t = e.content.firstChild.type.schema, n;
  try {
    n = JSON.parse(a);
  } catch {
    return e;
  }
  let { content: l, openStart: o, openEnd: r } = e;
  for (let i = n.length - 2; i >= 0; i -= 2) {
    let s = t.nodes[n[i]];
    if (!s || s.hasRequiredAttrs())
      break;
    l = We.from(s.create(n[i + 1], l)), o++, r++;
  }
  return new tt(l, o, r);
}
const Sa = {}, $a = {}, QL = { touchstart: !0, touchmove: !0 };
class _L {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.badSafariComposition = !1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function eT(e) {
  for (let a in Sa) {
    let t = Sa[a];
    e.dom.addEventListener(a, e.input.eventHandlers[a] = (n) => {
      aT(e, n) && !Hc(e, n) && (e.editable || !(n.type in $a)) && t(e, n);
    }, QL[a] ? { passive: !0 } : void 0);
  }
  xa && e.dom.addEventListener("input", () => null), Au(e);
}
function Jn(e, a) {
  e.input.lastSelectionOrigin = a, e.input.lastSelectionTime = Date.now();
}
function tT(e) {
  e.domObserver.stop();
  for (let a in e.input.eventHandlers)
    e.dom.removeEventListener(a, e.input.eventHandlers[a]);
  clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
}
function Au(e) {
  e.someProp("handleDOMEvents", (a) => {
    for (let t in a)
      e.input.eventHandlers[t] || e.dom.addEventListener(t, e.input.eventHandlers[t] = (n) => Hc(e, n));
  });
}
function Hc(e, a) {
  return e.someProp("handleDOMEvents", (t) => {
    let n = t[a.type];
    return n ? n(e, a) || a.defaultPrevented : !1;
  });
}
function aT(e, a) {
  if (!a.bubbles)
    return !0;
  if (a.defaultPrevented)
    return !1;
  for (let t = a.target; t != e.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(a))
      return !1;
  return !0;
}
function nT(e, a) {
  !Hc(e, a) && Sa[a.type] && (e.editable || !(a.type in $a)) && Sa[a.type](e, a);
}
$a.keydown = (e, a) => {
  let t = a;
  if (e.input.shiftKey = t.keyCode == 16 || t.shiftKey, !Uv(e, t) && (e.input.lastKeyCode = t.keyCode, e.input.lastKeyCodeTime = Date.now(), !(Rn && ca && t.keyCode == 13)))
    if (t.keyCode != 229 && e.domObserver.forceFlush(), vo && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let n = Date.now();
      e.input.lastIOSEnter = n, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == n && (e.someProp("handleKeyDown", (l) => l(e, xl(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else e.someProp("handleKeyDown", (n) => n(e, t)) || UL(e, t) ? t.preventDefault() : Jn(e, "key");
};
$a.keyup = (e, a) => {
  a.keyCode == 16 && (e.input.shiftKey = !1);
};
$a.keypress = (e, a) => {
  let t = a;
  if (Uv(e, t) || !t.charCode || t.ctrlKey && !t.altKey || Wa && t.metaKey)
    return;
  if (e.someProp("handleKeyPress", (l) => l(e, t))) {
    t.preventDefault();
    return;
  }
  let n = e.state.selection;
  if (!(n instanceof ht) || !n.$from.sameParent(n.$to)) {
    let l = String.fromCharCode(t.charCode), o = () => e.state.tr.insertText(l).scrollIntoView();
    !/[\r\n]/.test(l) && !e.someProp("handleTextInput", (r) => r(e, n.$from.pos, n.$to.pos, l, o)) && e.dispatch(o()), t.preventDefault();
  }
};
function Hs(e) {
  return { left: e.clientX, top: e.clientY };
}
function lT(e, a) {
  let t = a.x - e.clientX, n = a.y - e.clientY;
  return t * t + n * n < 100;
}
function jc(e, a, t, n, l) {
  if (n == -1)
    return !1;
  let o = e.state.doc.resolve(n);
  for (let r = o.depth + 1; r > 0; r--)
    if (e.someProp(a, (i) => r > o.depth ? i(e, t, o.nodeAfter, o.before(r), l, !0) : i(e, t, o.node(r), o.before(r), l, !1)))
      return !0;
  return !1;
}
function lo(e, a, t) {
  if (e.focused || e.focus(), e.state.selection.eq(a))
    return;
  let n = e.state.tr.setSelection(a);
  n.setMeta("pointer", !0), e.dispatch(n);
}
function oT(e, a) {
  if (a == -1)
    return !1;
  let t = e.state.doc.resolve(a), n = t.nodeAfter;
  return n && n.isAtom && dt.isSelectable(n) ? (lo(e, new dt(t)), !0) : !1;
}
function rT(e, a) {
  if (a == -1)
    return !1;
  let t = e.state.selection, n, l;
  t instanceof dt && (n = t.node);
  let o = e.state.doc.resolve(a);
  for (let r = o.depth + 1; r > 0; r--) {
    let i = r > o.depth ? o.nodeAfter : o.node(r);
    if (dt.isSelectable(i)) {
      n && t.$from.depth > 0 && r >= t.$from.depth && o.before(t.$from.depth + 1) == t.$from.pos ? l = o.before(t.$from.depth) : l = o.before(r);
      break;
    }
  }
  return l != null ? (lo(e, dt.create(e.state.doc, l)), !0) : !1;
}
function iT(e, a, t, n, l) {
  return jc(e, "handleClickOn", a, t, n) || e.someProp("handleClick", (o) => o(e, a, n)) || (l ? rT(e, t) : oT(e, t));
}
function sT(e, a, t, n) {
  return jc(e, "handleDoubleClickOn", a, t, n) || e.someProp("handleDoubleClick", (l) => l(e, a, n));
}
function dT(e, a, t, n) {
  return jc(e, "handleTripleClickOn", a, t, n) || e.someProp("handleTripleClick", (l) => l(e, a, n)) || uT(e, t, n);
}
function uT(e, a, t) {
  if (t.button != 0)
    return !1;
  let n = e.state.doc;
  if (a == -1)
    return n.inlineContent ? (lo(e, ht.create(n, 0, n.content.size)), !0) : !1;
  let l = n.resolve(a);
  for (let o = l.depth + 1; o > 0; o--) {
    let r = o > l.depth ? l.nodeAfter : l.node(o), i = l.before(o);
    if (r.inlineContent)
      lo(e, ht.create(n, i + 1, i + 1 + r.content.size));
    else if (dt.isSelectable(r))
      lo(e, dt.create(n, i));
    else
      continue;
    return !0;
  }
}
function Wc(e) {
  return Hi(e);
}
const qv = Wa ? "metaKey" : "ctrlKey";
Sa.mousedown = (e, a) => {
  let t = a;
  e.input.shiftKey = t.shiftKey;
  let n = Wc(e), l = Date.now(), o = "singleClick";
  l - e.input.lastClick.time < 500 && lT(t, e.input.lastClick) && !t[qv] && e.input.lastClick.button == t.button && (e.input.lastClick.type == "singleClick" ? o = "doubleClick" : e.input.lastClick.type == "doubleClick" && (o = "tripleClick")), e.input.lastClick = { time: l, x: t.clientX, y: t.clientY, type: o, button: t.button };
  let r = e.posAtCoords(Hs(t));
  r && (o == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new cT(e, r, t, !!n)) : (o == "doubleClick" ? sT : dT)(e, r.pos, r.inside, t) ? t.preventDefault() : Jn(e, "pointer"));
};
class cT {
  constructor(a, t, n, l) {
    this.view = a, this.pos = t, this.event = n, this.flushed = l, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = a.state.doc, this.selectNode = !!n[qv], this.allowDefault = n.shiftKey;
    let o, r;
    if (t.inside > -1)
      o = a.state.doc.nodeAt(t.inside), r = t.inside;
    else {
      let c = a.state.doc.resolve(t.pos);
      o = c.parent, r = c.depth ? c.before() : 0;
    }
    const i = l ? null : n.target, s = i ? a.docView.nearestDesc(i, !0) : null;
    this.target = s && s.nodeDOM.nodeType == 1 ? s.nodeDOM : null;
    let { selection: d } = a.state;
    n.button == 0 && (o.type.spec.draggable && o.type.spec.selectable !== !1 || d instanceof dt && d.from <= r && d.to > r) && (this.mightDrag = {
      node: o,
      pos: r,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Ya && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), a.root.addEventListener("mouseup", this.up = this.up.bind(this)), a.root.addEventListener("mousemove", this.move = this.move.bind(this)), Jn(a, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => Dn(this.view)), this.view.input.mouseDown = null;
  }
  up(a) {
    if (this.done(), !this.view.dom.contains(a.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(Hs(a))), this.updateAllowDefault(a), this.allowDefault || !t ? Jn(this.view, "pointer") : iT(this.view, t.pos, t.inside, a, this.selectNode) ? a.preventDefault() : a.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    xa && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    ca && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (lo(this.view, xt.near(this.view.state.doc.resolve(t.pos))), a.preventDefault()) : Jn(this.view, "pointer");
  }
  move(a) {
    this.updateAllowDefault(a), Jn(this.view, "pointer"), a.buttons == 0 && this.done();
  }
  updateAllowDefault(a) {
    !this.allowDefault && (Math.abs(this.event.x - a.clientX) > 4 || Math.abs(this.event.y - a.clientY) > 4) && (this.allowDefault = !0);
  }
}
Sa.touchstart = (e) => {
  e.input.lastTouch = Date.now(), Wc(e), Jn(e, "pointer");
};
Sa.touchmove = (e) => {
  e.input.lastTouch = Date.now(), Jn(e, "pointer");
};
Sa.contextmenu = (e) => Wc(e);
function Uv(e, a) {
  return e.composing ? !0 : xa && Math.abs(a.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const fT = Rn ? 5e3 : -1;
$a.compositionstart = $a.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: a } = e, t = a.selection.$to;
    if (a.selection instanceof ht && (a.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((n) => n.type.spec.inclusive === !1) || ca && wv && hT(e)))
      e.markCursor = e.state.storedMarks || t.marks(), Hi(e, !0), e.markCursor = null;
    else if (Hi(e, !a.selection.empty), Ya && a.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let n = e.domSelectionRange();
      for (let l = n.focusNode, o = n.focusOffset; l && l.nodeType == 1 && o != 0; ) {
        let r = o < 0 ? l.lastChild : l.childNodes[o - 1];
        if (!r)
          break;
        if (r.nodeType == 3) {
          let i = e.domSelection();
          i && i.collapse(r, r.nodeValue.length);
          break;
        } else
          l = r, o = -1;
      }
    }
    e.input.composing = !0;
  }
  Gv(e, fT);
};
function hT(e) {
  let { focusNode: a, focusOffset: t } = e.domSelectionRange();
  if (!a || a.nodeType != 1 || t >= a.childNodes.length)
    return !1;
  let n = a.childNodes[t];
  return n.nodeType == 1 && n.contentEditable == "false";
}
$a.compositionend = (e, a) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = a.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionNode = null, e.input.badSafariComposition ? e.domObserver.forceFlush() : e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, Gv(e, 20));
};
function Gv(e, a) {
  clearTimeout(e.input.composingTimeout), a > -1 && (e.input.composingTimeout = setTimeout(() => Hi(e), a));
}
function Kv(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = gT()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function bT(e) {
  let a = e.domSelectionRange();
  if (!a.focusNode)
    return null;
  let t = rL(a.focusNode, a.focusOffset), n = iL(a.focusNode, a.focusOffset);
  if (t && n && t != n) {
    let l = n.pmViewDesc, o = e.domObserver.lastChangedTextNode;
    if (t == o || n == o)
      return o;
    if (!l || !l.isText(n.nodeValue))
      return n;
    if (e.input.compositionNode == n) {
      let r = t.pmViewDesc;
      if (!(!r || !r.isText(t.nodeValue)))
        return n;
    }
  }
  return t || n;
}
function gT() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function Hi(e, a = !1) {
  if (!(Rn && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), Kv(e), a || e.docView && e.docView.dirty) {
      let t = Fc(e), n = e.state.selection;
      return t && !t.eq(n) ? e.dispatch(e.state.tr.setSelection(t)) : (e.markCursor || a) && !n.$from.node(n.$from.sharedDepth(n.to)).inlineContent ? e.dispatch(e.state.tr.deleteSelection()) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function mT(e, a) {
  if (!e.dom.parentNode)
    return;
  let t = e.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(a), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let n = getSelection(), l = document.createRange();
  l.selectNodeContents(a), e.dom.blur(), n.removeAllRanges(), n.addRange(l), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), e.focus();
  }, 50);
}
const xr = Aa && el < 15 || vo && cL < 604;
Sa.copy = $a.cut = (e, a) => {
  let t = a, n = e.state.selection, l = t.type == "cut";
  if (n.empty)
    return;
  let o = xr ? null : t.clipboardData, r = n.content(), { dom: i, text: s } = Vc(e, r);
  o ? (t.preventDefault(), o.clearData(), o.setData("text/html", i.innerHTML), o.setData("text/plain", s)) : mT(e, i), l && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function vT(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function pT(e, a) {
  if (!e.dom.parentNode)
    return;
  let t = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, n = e.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (n.contentEditable = "true"), n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus();
  let l = e.input.shiftKey && e.input.lastKeyCode != 45;
  setTimeout(() => {
    e.focus(), n.parentNode && n.parentNode.removeChild(n), t ? yr(e, n.value, null, l, a) : yr(e, n.textContent, n.innerHTML, l, a);
  }, 50);
}
function yr(e, a, t, n, l) {
  let o = Fv(e, a, t, n, e.state.selection.$from);
  if (e.someProp("handlePaste", (s) => s(e, l, o || tt.empty)))
    return !0;
  if (!o)
    return !1;
  let r = vT(o), i = r ? e.state.tr.replaceSelectionWith(r, n) : e.state.tr.replaceSelection(o);
  return e.dispatch(i.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Yv(e) {
  let a = e.getData("text/plain") || e.getData("Text");
  if (a)
    return a;
  let t = e.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
$a.paste = (e, a) => {
  let t = a;
  if (e.composing && !Rn)
    return;
  let n = xr ? null : t.clipboardData, l = e.input.shiftKey && e.input.lastKeyCode != 45;
  n && yr(e, Yv(n), n.getData("text/html"), l, t) ? t.preventDefault() : pT(e, t);
};
class Jv {
  constructor(a, t, n) {
    this.slice = a, this.move = t, this.node = n;
  }
}
const xT = Wa ? "altKey" : "ctrlKey";
function Xv(e, a) {
  let t;
  return e.someProp("dragCopies", (n) => {
    t = t || n(a);
  }), t != null ? !t : !a[xT];
}
Sa.dragstart = (e, a) => {
  let t = a, n = e.input.mouseDown;
  if (n && n.done(), !t.dataTransfer)
    return;
  let l = e.state.selection, o = l.empty ? null : e.posAtCoords(Hs(t)), r;
  if (!(o && o.pos >= l.from && o.pos <= (l instanceof dt ? l.to - 1 : l.to))) {
    if (n && n.mightDrag)
      r = dt.create(e.state.doc, n.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let f = e.docView.nearestDesc(t.target, !0);
      f && f.node.type.spec.draggable && f != e.docView && (r = dt.create(e.state.doc, f.posBefore));
    }
  }
  let i = (r || e.state.selection).content(), { dom: s, text: d, slice: c } = Vc(e, i);
  (!t.dataTransfer.files.length || !ca || kv > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(xr ? "Text" : "text/html", s.innerHTML), t.dataTransfer.effectAllowed = "copyMove", xr || t.dataTransfer.setData("text/plain", d), e.dragging = new Jv(c, Xv(e, t), r);
};
Sa.dragend = (e) => {
  let a = e.dragging;
  window.setTimeout(() => {
    e.dragging == a && (e.dragging = null);
  }, 50);
};
$a.dragover = $a.dragenter = (e, a) => a.preventDefault();
$a.drop = (e, a) => {
  try {
    yT(e, a, e.dragging);
  } finally {
    e.dragging = null;
  }
};
function yT(e, a, t) {
  if (!a.dataTransfer)
    return;
  let n = e.posAtCoords(Hs(a));
  if (!n)
    return;
  let l = e.state.doc.resolve(n.pos), o = t && t.slice;
  o ? e.someProp("transformPasted", (h) => {
    o = h(o, e, !1);
  }) : o = Fv(e, Yv(a.dataTransfer), xr ? null : a.dataTransfer.getData("text/html"), !1, l);
  let r = !!(t && Xv(e, a));
  if (e.someProp("handleDrop", (h) => h(e, a, o || tt.empty, r))) {
    a.preventDefault();
    return;
  }
  if (!o)
    return;
  a.preventDefault();
  let i = o ? _m(e.state.doc, l.pos, o) : l.pos;
  i == null && (i = l.pos);
  let s = e.state.tr;
  if (r) {
    let { node: h } = t;
    h ? h.replace(s) : s.deleteSelection();
  }
  let d = s.mapping.map(i), c = o.openStart == 0 && o.openEnd == 0 && o.content.childCount == 1, f = s.doc;
  if (c ? s.replaceRangeWith(d, d, o.content.firstChild) : s.replaceRange(d, d, o), s.doc.eq(f))
    return;
  let g = s.doc.resolve(d);
  if (c && dt.isSelectable(o.content.firstChild) && g.nodeAfter && g.nodeAfter.sameMarkup(o.content.firstChild))
    s.setSelection(new dt(g));
  else {
    let h = s.mapping.map(i);
    s.mapping.maps[s.mapping.maps.length - 1].forEach((v, p, y, k) => h = k), s.setSelection(Nc(e, g, s.doc.resolve(h)));
  }
  e.focus(), e.dispatch(s.setMeta("uiEvent", "drop"));
}
Sa.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && Dn(e);
  }, 20));
};
Sa.blur = (e, a) => {
  let t = a;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), t.relatedTarget && e.dom.contains(t.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
Sa.beforeinput = (e, a) => {
  if (ca && Rn && a.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: n } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != n || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (o) => o(e, xl(8, "Backspace")))))
        return;
      let { $cursor: l } = e.state.selection;
      l && l.pos > 0 && e.dispatch(e.state.tr.delete(l.pos - 1, l.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in $a)
  Sa[e] = $a[e];
function kr(e, a) {
  if (e == a)
    return !0;
  for (let t in e)
    if (e[t] !== a[t])
      return !1;
  for (let t in a)
    if (!(t in e))
      return !1;
  return !0;
}
class ji {
  constructor(a, t) {
    this.toDOM = a, this.spec = t || El, this.side = this.spec.side || 0;
  }
  map(a, t, n, l) {
    let { pos: o, deleted: r } = a.mapResult(t.from + l, this.side < 0 ? -1 : 1);
    return r ? null : new Ca(o - n, o - n, this);
  }
  valid() {
    return !0;
  }
  eq(a) {
    return this == a || a instanceof ji && (this.spec.key && this.spec.key == a.spec.key || this.toDOM == a.toDOM && kr(this.spec, a.spec));
  }
  destroy(a) {
    this.spec.destroy && this.spec.destroy(a);
  }
}
class al {
  constructor(a, t) {
    this.attrs = a, this.spec = t || El;
  }
  map(a, t, n, l) {
    let o = a.map(t.from + l, this.spec.inclusiveStart ? -1 : 1) - n, r = a.map(t.to + l, this.spec.inclusiveEnd ? 1 : -1) - n;
    return o >= r ? null : new Ca(o, r, this);
  }
  valid(a, t) {
    return t.from < t.to;
  }
  eq(a) {
    return this == a || a instanceof al && kr(this.attrs, a.attrs) && kr(this.spec, a.spec);
  }
  static is(a) {
    return a.type instanceof al;
  }
  destroy() {
  }
}
class qc {
  constructor(a, t) {
    this.attrs = a, this.spec = t || El;
  }
  map(a, t, n, l) {
    let o = a.mapResult(t.from + l, 1);
    if (o.deleted)
      return null;
    let r = a.mapResult(t.to + l, -1);
    return r.deleted || r.pos <= o.pos ? null : new Ca(o.pos - n, r.pos - n, this);
  }
  valid(a, t) {
    let { index: n, offset: l } = a.content.findIndex(t.from), o;
    return l == t.from && !(o = a.child(n)).isText && l + o.nodeSize == t.to;
  }
  eq(a) {
    return this == a || a instanceof qc && kr(this.attrs, a.attrs) && kr(this.spec, a.spec);
  }
  destroy() {
  }
}
class Ca {
  /**
  @internal
  */
  constructor(a, t, n) {
    this.from = a, this.to = t, this.type = n;
  }
  /**
  @internal
  */
  copy(a, t) {
    return new Ca(a, t, this.type);
  }
  /**
  @internal
  */
  eq(a, t = 0) {
    return this.type.eq(a.type) && this.from + t == a.from && this.to + t == a.to;
  }
  /**
  @internal
  */
  map(a, t, n) {
    return this.type.map(a, this, t, n);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(a, t, n) {
    return new Ca(a, a, new ji(t, n));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(a, t, n, l) {
    return new Ca(a, t, new al(n, l));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(a, t, n, l) {
    return new Ca(a, t, new qc(n, l));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof al;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof ji;
  }
}
const Xl = [], El = {};
class jt {
  /**
  @internal
  */
  constructor(a, t) {
    this.local = a.length ? a : Xl, this.children = t.length ? t : Xl;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(a, t) {
    return t.length ? Wi(t, a, 0, El) : ma;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(a, t, n) {
    let l = [];
    return this.findInner(a ?? 0, t ?? 1e9, l, 0, n), l;
  }
  findInner(a, t, n, l, o) {
    for (let r = 0; r < this.local.length; r++) {
      let i = this.local[r];
      i.from <= t && i.to >= a && (!o || o(i.spec)) && n.push(i.copy(i.from + l, i.to + l));
    }
    for (let r = 0; r < this.children.length; r += 3)
      if (this.children[r] < t && this.children[r + 1] > a) {
        let i = this.children[r] + 1;
        this.children[r + 2].findInner(a - i, t - i, n, l + i, o);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(a, t, n) {
    return this == ma || a.maps.length == 0 ? this : this.mapInner(a, t, 0, 0, n || El);
  }
  /**
  @internal
  */
  mapInner(a, t, n, l, o) {
    let r;
    for (let i = 0; i < this.local.length; i++) {
      let s = this.local[i].map(a, n, l);
      s && s.type.valid(t, s) ? (r || (r = [])).push(s) : o.onRemove && o.onRemove(this.local[i].spec);
    }
    return this.children.length ? kT(this.children, r || [], a, t, n, l, o) : r ? new jt(r.sort(Al), Xl) : ma;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(a, t) {
    return t.length ? this == ma ? jt.create(a, t) : this.addInner(a, t, 0) : this;
  }
  addInner(a, t, n) {
    let l, o = 0;
    a.forEach((i, s) => {
      let d = s + n, c;
      if (c = Qv(t, i, d)) {
        for (l || (l = this.children.slice()); o < l.length && l[o] < s; )
          o += 3;
        l[o] == s ? l[o + 2] = l[o + 2].addInner(i, c, d + 1) : l.splice(o, 0, s, s + i.nodeSize, Wi(c, i, d + 1, El)), o += 3;
      }
    });
    let r = Zv(o ? _v(t) : t, -n);
    for (let i = 0; i < r.length; i++)
      r[i].type.valid(a, r[i]) || r.splice(i--, 1);
    return new jt(r.length ? this.local.concat(r).sort(Al) : this.local, l || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(a) {
    return a.length == 0 || this == ma ? this : this.removeInner(a, 0);
  }
  removeInner(a, t) {
    let n = this.children, l = this.local;
    for (let o = 0; o < n.length; o += 3) {
      let r, i = n[o] + t, s = n[o + 1] + t;
      for (let c = 0, f; c < a.length; c++)
        (f = a[c]) && f.from > i && f.to < s && (a[c] = null, (r || (r = [])).push(f));
      if (!r)
        continue;
      n == this.children && (n = this.children.slice());
      let d = n[o + 2].removeInner(r, i + 1);
      d != ma ? n[o + 2] = d : (n.splice(o, 3), o -= 3);
    }
    if (l.length) {
      for (let o = 0, r; o < a.length; o++)
        if (r = a[o])
          for (let i = 0; i < l.length; i++)
            l[i].eq(r, t) && (l == this.local && (l = this.local.slice()), l.splice(i--, 1));
    }
    return n == this.children && l == this.local ? this : l.length || n.length ? new jt(l, n) : ma;
  }
  forChild(a, t) {
    if (this == ma)
      return this;
    if (t.isLeaf)
      return jt.empty;
    let n, l;
    for (let i = 0; i < this.children.length; i += 3)
      if (this.children[i] >= a) {
        this.children[i] == a && (n = this.children[i + 2]);
        break;
      }
    let o = a + 1, r = o + t.content.size;
    for (let i = 0; i < this.local.length; i++) {
      let s = this.local[i];
      if (s.from < r && s.to > o && s.type instanceof al) {
        let d = Math.max(o, s.from) - o, c = Math.min(r, s.to) - o;
        d < c && (l || (l = [])).push(s.copy(d, c));
      }
    }
    if (l) {
      let i = new jt(l.sort(Al), Xl);
      return n ? new Gn([i, n]) : i;
    }
    return n || ma;
  }
  /**
  @internal
  */
  eq(a) {
    if (this == a)
      return !0;
    if (!(a instanceof jt) || this.local.length != a.local.length || this.children.length != a.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(a.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != a.children[t] || this.children[t + 1] != a.children[t + 1] || !this.children[t + 2].eq(a.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(a) {
    return Uc(this.localsInner(a));
  }
  /**
  @internal
  */
  localsInner(a) {
    if (this == ma)
      return Xl;
    if (a.inlineContent || !this.local.some(al.is))
      return this.local;
    let t = [];
    for (let n = 0; n < this.local.length; n++)
      this.local[n].type instanceof al || t.push(this.local[n]);
    return t;
  }
  forEachSet(a) {
    a(this);
  }
}
jt.empty = new jt([], []);
jt.removeOverlap = Uc;
const ma = jt.empty;
class Gn {
  constructor(a) {
    this.members = a;
  }
  map(a, t) {
    const n = this.members.map((l) => l.map(a, t, El));
    return Gn.from(n);
  }
  forChild(a, t) {
    if (t.isLeaf)
      return jt.empty;
    let n = [];
    for (let l = 0; l < this.members.length; l++) {
      let o = this.members[l].forChild(a, t);
      o != ma && (o instanceof Gn ? n = n.concat(o.members) : n.push(o));
    }
    return Gn.from(n);
  }
  eq(a) {
    if (!(a instanceof Gn) || a.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(a.members[t]))
        return !1;
    return !0;
  }
  locals(a) {
    let t, n = !0;
    for (let l = 0; l < this.members.length; l++) {
      let o = this.members[l].localsInner(a);
      if (o.length)
        if (!t)
          t = o;
        else {
          n && (t = t.slice(), n = !1);
          for (let r = 0; r < o.length; r++)
            t.push(o[r]);
        }
    }
    return t ? Uc(n ? t : t.sort(Al)) : Xl;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(a) {
    switch (a.length) {
      case 0:
        return ma;
      case 1:
        return a[0];
      default:
        return new Gn(a.every((t) => t instanceof jt) ? a : a.reduce((t, n) => t.concat(n instanceof jt ? n : n.members), []));
    }
  }
  forEachSet(a) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(a);
  }
}
function kT(e, a, t, n, l, o, r) {
  let i = e.slice();
  for (let d = 0, c = o; d < t.maps.length; d++) {
    let f = 0;
    t.maps[d].forEach((g, h, v, p) => {
      let y = p - v - (h - g);
      for (let k = 0; k < i.length; k += 3) {
        let $ = i[k + 1];
        if ($ < 0 || g > $ + c - f)
          continue;
        let S = i[k] + c - f;
        h >= S ? i[k + 1] = g <= S ? -2 : -1 : g >= c && y && (i[k] += y, i[k + 1] += y);
      }
      f += y;
    }), c = t.maps[d].map(c, -1);
  }
  let s = !1;
  for (let d = 0; d < i.length; d += 3)
    if (i[d + 1] < 0) {
      if (i[d + 1] == -2) {
        s = !0, i[d + 1] = -1;
        continue;
      }
      let c = t.map(e[d] + o), f = c - l;
      if (f < 0 || f >= n.content.size) {
        s = !0;
        continue;
      }
      let g = t.map(e[d + 1] + o, -1), h = g - l, { index: v, offset: p } = n.content.findIndex(f), y = n.maybeChild(v);
      if (y && p == f && p + y.nodeSize == h) {
        let k = i[d + 2].mapInner(t, y, c + 1, e[d] + o + 1, r);
        k != ma ? (i[d] = f, i[d + 1] = h, i[d + 2] = k) : (i[d + 1] = -2, s = !0);
      } else
        s = !0;
    }
  if (s) {
    let d = wT(i, e, a, t, l, o, r), c = Wi(d, n, 0, r);
    a = c.local;
    for (let f = 0; f < i.length; f += 3)
      i[f + 1] < 0 && (i.splice(f, 3), f -= 3);
    for (let f = 0, g = 0; f < c.children.length; f += 3) {
      let h = c.children[f];
      for (; g < i.length && i[g] < h; )
        g += 3;
      i.splice(g, 0, c.children[f], c.children[f + 1], c.children[f + 2]);
    }
  }
  return new jt(a.sort(Al), i);
}
function Zv(e, a) {
  if (!a || !e.length)
    return e;
  let t = [];
  for (let n = 0; n < e.length; n++) {
    let l = e[n];
    t.push(new Ca(l.from + a, l.to + a, l.type));
  }
  return t;
}
function wT(e, a, t, n, l, o, r) {
  function i(s, d) {
    for (let c = 0; c < s.local.length; c++) {
      let f = s.local[c].map(n, l, d);
      f ? t.push(f) : r.onRemove && r.onRemove(s.local[c].spec);
    }
    for (let c = 0; c < s.children.length; c += 3)
      i(s.children[c + 2], s.children[c] + d + 1);
  }
  for (let s = 0; s < e.length; s += 3)
    e[s + 1] == -1 && i(e[s + 2], a[s] + o + 1);
  return t;
}
function Qv(e, a, t) {
  if (a.isLeaf)
    return null;
  let n = t + a.nodeSize, l = null;
  for (let o = 0, r; o < e.length; o++)
    (r = e[o]) && r.from > t && r.to < n && ((l || (l = [])).push(r), e[o] = null);
  return l;
}
function _v(e) {
  let a = [];
  for (let t = 0; t < e.length; t++)
    e[t] != null && a.push(e[t]);
  return a;
}
function Wi(e, a, t, n) {
  let l = [], o = !1;
  a.forEach((i, s) => {
    let d = Qv(e, i, s + t);
    if (d) {
      o = !0;
      let c = Wi(d, i, t + s + 1, n);
      c != ma && l.push(s, s + i.nodeSize, c);
    }
  });
  let r = Zv(o ? _v(e) : e, -t).sort(Al);
  for (let i = 0; i < r.length; i++)
    r[i].type.valid(a, r[i]) || (n.onRemove && n.onRemove(r[i].spec), r.splice(i--, 1));
  return r.length || l.length ? new jt(r, l) : ma;
}
function Al(e, a) {
  return e.from - a.from || e.to - a.to;
}
function Uc(e) {
  let a = e;
  for (let t = 0; t < a.length - 1; t++) {
    let n = a[t];
    if (n.from != n.to)
      for (let l = t + 1; l < a.length; l++) {
        let o = a[l];
        if (o.from == n.from) {
          o.to != n.to && (a == e && (a = e.slice()), a[l] = o.copy(o.from, n.to), Kh(a, l + 1, o.copy(n.to, o.to)));
          continue;
        } else {
          o.from < n.to && (a == e && (a = e.slice()), a[t] = n.copy(n.from, o.from), Kh(a, l, n.copy(o.from, n.to)));
          break;
        }
      }
  }
  return a;
}
function Kh(e, a, t) {
  for (; a < e.length && Al(t, e[a]) > 0; )
    a++;
  e.splice(a, 0, t);
}
function kd(e) {
  let a = [];
  return e.someProp("decorations", (t) => {
    let n = t(e.state);
    n && n != ma && a.push(n);
  }), e.cursorWrapper && a.push(jt.create(e.state.doc, [e.cursorWrapper.deco])), Gn.from(a);
}
const CT = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, ST = Aa && el <= 11;
class $T {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(a) {
    this.anchorNode = a.anchorNode, this.anchorOffset = a.anchorOffset, this.focusNode = a.focusNode, this.focusOffset = a.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(a) {
    return a.anchorNode == this.anchorNode && a.anchorOffset == this.anchorOffset && a.focusNode == this.focusNode && a.focusOffset == this.focusOffset;
  }
}
class IT {
  constructor(a, t) {
    this.view = a, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new $T(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((n) => {
      for (let l = 0; l < n.length; l++)
        this.queue.push(n[l]);
      Aa && el <= 11 && n.some((l) => l.type == "childList" && l.removedNodes.length || l.type == "characterData" && l.oldValue.length > l.target.nodeValue.length) ? this.flushSoon() : xa && a.composing && n.some((l) => l.type == "childList" && l.target.nodeName == "TR") ? (a.input.badSafariComposition = !0, this.flushSoon()) : this.flush();
    }), ST && (this.onCharData = (n) => {
      this.queue.push({ target: n.target, type: "characterData", oldValue: n.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, CT)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let a = this.observer.takeRecords();
      if (a.length) {
        for (let t = 0; t < a.length; t++)
          this.queue.push(a[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (Nh(this.view)) {
      if (this.suppressingSelectionUpdates)
        return Dn(this.view);
      if (Aa && el <= 11 && !this.view.state.selection.empty) {
        let a = this.view.domSelectionRange();
        if (a.focusNode && Pl(a.focusNode, a.focusOffset, a.anchorNode, a.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(a) {
    if (!a.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), n;
    for (let o = a.focusNode; o; o = mo(o))
      t.add(o);
    for (let o = a.anchorNode; o; o = mo(o))
      if (t.has(o)) {
        n = o;
        break;
      }
    let l = n && this.view.docView.nearestDesc(n);
    if (l && l.ignoreMutation({
      type: "selection",
      target: n.nodeType == 3 ? n.parentNode : n
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let a of this.observer.takeRecords())
        this.queue.push(a);
    return this.queue;
  }
  flush() {
    let { view: a } = this;
    if (!a.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let n = a.domSelectionRange(), l = !this.suppressingSelectionUpdates && !this.currentSelection.eq(n) && Nh(a) && !this.ignoreSelectionChange(n), o = -1, r = -1, i = !1, s = [];
    if (a.editable)
      for (let c = 0; c < t.length; c++) {
        let f = this.registerMutation(t[c], s);
        f && (o = o < 0 ? f.from : Math.min(f.from, o), r = r < 0 ? f.to : Math.max(f.to, r), f.typeOver && (i = !0));
      }
    if (s.some((c) => c.nodeName == "BR") && (a.input.lastKeyCode == 8 || a.input.lastKeyCode == 46)) {
      for (let c of s)
        if (c.nodeName == "BR" && c.parentNode) {
          let f = c.nextSibling;
          for (; f && f.nodeType == 1; ) {
            if (f.contentEditable == "false") {
              c.parentNode.removeChild(c);
              break;
            }
            f = f.firstChild;
          }
        }
    } else if (Ya && s.length) {
      let c = s.filter((f) => f.nodeName == "BR");
      if (c.length == 2) {
        let [f, g] = c;
        f.parentNode && f.parentNode.parentNode == g.parentNode ? g.remove() : f.remove();
      } else {
        let { focusNode: f } = this.currentSelection;
        for (let g of c) {
          let h = g.parentNode;
          h && h.nodeName == "LI" && (!f || ET(a, f) != h) && g.remove();
        }
      }
    }
    let d = null;
    o < 0 && l && a.input.lastFocus > Date.now() - 200 && Math.max(a.input.lastTouch, a.input.lastClick.time) < Date.now() - 300 && Ns(n) && (d = Fc(a)) && d.eq(xt.near(a.state.doc.resolve(0), 1)) ? (a.input.lastFocus = 0, Dn(a), this.currentSelection.set(n), a.scrollToSelection()) : (o > -1 || l) && (o > -1 && (a.docView.markDirty(o, r), LT(a)), a.input.badSafariComposition && (a.input.badSafariComposition = !1, AT(a, s)), this.handleDOMChange(o, r, i, s), a.docView && a.docView.dirty ? a.updateState(a.state) : this.currentSelection.eq(n) || Dn(a), this.currentSelection.set(n));
  }
  registerMutation(a, t) {
    if (t.indexOf(a.target) > -1)
      return null;
    let n = this.view.docView.nearestDesc(a.target);
    if (a.type == "attributes" && (n == this.view.docView || a.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    a.attributeName == "style" && !a.oldValue && !a.target.getAttribute("style")) || !n || n.ignoreMutation(a))
      return null;
    if (a.type == "childList") {
      for (let c = 0; c < a.addedNodes.length; c++) {
        let f = a.addedNodes[c];
        t.push(f), f.nodeType == 3 && (this.lastChangedTextNode = f);
      }
      if (n.contentDOM && n.contentDOM != n.dom && !n.contentDOM.contains(a.target))
        return { from: n.posBefore, to: n.posAfter };
      let l = a.previousSibling, o = a.nextSibling;
      if (Aa && el <= 11 && a.addedNodes.length)
        for (let c = 0; c < a.addedNodes.length; c++) {
          let { previousSibling: f, nextSibling: g } = a.addedNodes[c];
          (!f || Array.prototype.indexOf.call(a.addedNodes, f) < 0) && (l = f), (!g || Array.prototype.indexOf.call(a.addedNodes, g) < 0) && (o = g);
        }
      let r = l && l.parentNode == a.target ? da(l) + 1 : 0, i = n.localPosFromDOM(a.target, r, -1), s = o && o.parentNode == a.target ? da(o) : a.target.childNodes.length, d = n.localPosFromDOM(a.target, s, 1);
      return { from: i, to: d };
    } else return a.type == "attributes" ? { from: n.posAtStart - n.border, to: n.posAtEnd + n.border } : (this.lastChangedTextNode = a.target, {
      from: n.posAtStart,
      to: n.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: a.target.nodeValue == a.oldValue
    });
  }
}
let Yh = /* @__PURE__ */ new WeakMap(), Jh = !1;
function LT(e) {
  if (!Yh.has(e) && (Yh.set(e, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(e.dom).whiteSpace) !== -1)) {
    if (e.requiresGeckoHackNode = Ya, Jh)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), Jh = !0;
  }
}
function Xh(e, a) {
  let t = a.startContainer, n = a.startOffset, l = a.endContainer, o = a.endOffset, r = e.domAtPos(e.state.selection.anchor);
  return Pl(r.node, r.offset, l, o) && ([t, n, l, o] = [l, o, t, n]), { anchorNode: t, anchorOffset: n, focusNode: l, focusOffset: o };
}
function TT(e, a) {
  if (a.getComposedRanges) {
    let l = a.getComposedRanges(e.root)[0];
    if (l)
      return Xh(e, l);
  }
  let t;
  function n(l) {
    l.preventDefault(), l.stopImmediatePropagation(), t = l.getTargetRanges()[0];
  }
  return e.dom.addEventListener("beforeinput", n, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", n, !0), t ? Xh(e, t) : null;
}
function ET(e, a) {
  for (let t = a.parentNode; t && t != e.dom; t = t.parentNode) {
    let n = e.docView.nearestDesc(t, !0);
    if (n && n.node.isBlock)
      return t;
  }
  return null;
}
function AT(e, a) {
  var t;
  let { focusNode: n, focusOffset: l } = e.domSelectionRange();
  for (let o of a)
    if (((t = o.parentNode) === null || t === void 0 ? void 0 : t.nodeName) == "TR") {
      let r = o.nextSibling;
      for (; r && r.nodeName != "TD" && r.nodeName != "TH"; )
        r = r.nextSibling;
      if (r) {
        let i = r;
        for (; ; ) {
          let s = i.firstChild;
          if (!s || s.nodeType != 1 || s.contentEditable == "false" || /^(BR|IMG)$/.test(s.nodeName))
            break;
          i = s;
        }
        i.insertBefore(o, i.firstChild), n == o && e.domSelection().collapse(o, l);
      } else
        o.parentNode.removeChild(o);
    }
}
function RT(e, a, t) {
  let { node: n, fromOffset: l, toOffset: o, from: r, to: i } = e.docView.parseRange(a, t), s = e.domSelectionRange(), d, c = s.anchorNode;
  if (c && e.dom.contains(c.nodeType == 1 ? c : c.parentNode) && (d = [{ node: c, offset: s.anchorOffset }], Ns(s) || d.push({ node: s.focusNode, offset: s.focusOffset })), ca && e.input.lastKeyCode === 8)
    for (let y = o; y > l; y--) {
      let k = n.childNodes[y - 1], $ = k.pmViewDesc;
      if (k.nodeName == "BR" && !$) {
        o = y;
        break;
      }
      if (!$ || $.size)
        break;
    }
  let f = e.state.doc, g = e.someProp("domParser") || _n.fromSchema(e.state.schema), h = f.resolve(r), v = null, p = g.parse(n, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: l,
    to: o,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: d,
    ruleFromNode: zT,
    context: h
  });
  if (d && d[0].pos != null) {
    let y = d[0].pos, k = d[1] && d[1].pos;
    k == null && (k = y), v = { anchor: y + r, head: k + r };
  }
  return { doc: p, sel: v, from: r, to: i };
}
function zT(e) {
  let a = e.pmViewDesc;
  if (a)
    return a.parseRule();
  if (e.nodeName == "BR" && e.parentNode) {
    if (xa && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (e.parentNode.lastChild == e || xa && /^(tr|table)$/i.test(e.parentNode.nodeName))
      return { ignore: !0 };
  } else if (e.nodeName == "IMG" && e.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const DT = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function BT(e, a, t, n, l) {
  let o = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
  if (e.input.compositionPendingChanges = 0, a < 0) {
    let E = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null, z = Fc(e, E);
    if (z && !e.state.selection.eq(z)) {
      if (ca && Rn && e.input.lastKeyCode === 13 && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", (W) => W(e, xl(13, "Enter"))))
        return;
      let B = e.state.tr.setSelection(z);
      E == "pointer" ? B.setMeta("pointer", !0) : E == "key" && B.scrollIntoView(), o && B.setMeta("composition", o), e.dispatch(B);
    }
    return;
  }
  let r = e.state.doc.resolve(a), i = r.sharedDepth(t);
  a = r.before(i + 1), t = e.state.doc.resolve(t).after(i + 1);
  let s = e.state.selection, d = RT(e, a, t), c = e.state.doc, f = c.slice(d.from, d.to), g, h;
  e.input.lastKeyCode === 8 && Date.now() - 100 < e.input.lastKeyCodeTime ? (g = e.state.selection.to, h = "end") : (g = e.state.selection.from, h = "start"), e.input.lastKeyCode = null;
  let v = PT(f.content, d.doc.content, d.from, g, h);
  if (v && e.input.domChangeCount++, (vo && e.input.lastIOSEnter > Date.now() - 225 || Rn) && l.some((E) => E.nodeType == 1 && !DT.test(E.nodeName)) && (!v || v.endA >= v.endB) && e.someProp("handleKeyDown", (E) => E(e, xl(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (!v)
    if (n && s instanceof ht && !s.empty && s.$head.sameParent(s.$anchor) && !e.composing && !(d.sel && d.sel.anchor != d.sel.head))
      v = { start: s.from, endA: s.to, endB: s.to };
    else {
      if (d.sel) {
        let E = Zh(e, e.state.doc, d.sel);
        if (E && !E.eq(e.state.selection)) {
          let z = e.state.tr.setSelection(E);
          o && z.setMeta("composition", o), e.dispatch(z);
        }
      }
      return;
    }
  e.state.selection.from < e.state.selection.to && v.start == v.endB && e.state.selection instanceof ht && (v.start > e.state.selection.from && v.start <= e.state.selection.from + 2 && e.state.selection.from >= d.from ? v.start = e.state.selection.from : v.endA < e.state.selection.to && v.endA >= e.state.selection.to - 2 && e.state.selection.to <= d.to && (v.endB += e.state.selection.to - v.endA, v.endA = e.state.selection.to)), Aa && el <= 11 && v.endB == v.start + 1 && v.endA == v.start && v.start > d.from && d.doc.textBetween(v.start - d.from - 1, v.start - d.from + 1) == "  " && (v.start--, v.endA--, v.endB--);
  let p = d.doc.resolveNoCache(v.start - d.from), y = d.doc.resolveNoCache(v.endB - d.from), k = c.resolve(v.start), $ = p.sameParent(y) && p.parent.inlineContent && k.end() >= v.endA;
  if ((vo && e.input.lastIOSEnter > Date.now() - 225 && (!$ || l.some((E) => E.nodeName == "DIV" || E.nodeName == "P")) || !$ && p.pos < d.doc.content.size && (!p.sameParent(y) || !p.parent.inlineContent) && p.pos < y.pos && !/\S/.test(d.doc.textBetween(p.pos, y.pos, "", ""))) && e.someProp("handleKeyDown", (E) => E(e, xl(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (e.state.selection.anchor > v.start && OT(c, v.start, v.endA, p, y) && e.someProp("handleKeyDown", (E) => E(e, xl(8, "Backspace")))) {
    Rn && ca && e.domObserver.suppressSelectionUpdates();
    return;
  }
  ca && v.endB == v.start && (e.input.lastChromeDelete = Date.now()), Rn && !$ && p.start() != y.start() && y.parentOffset == 0 && p.depth == y.depth && d.sel && d.sel.anchor == d.sel.head && d.sel.head == v.endA && (v.endB -= 2, y = d.doc.resolveNoCache(v.endB - d.from), setTimeout(() => {
    e.someProp("handleKeyDown", function(E) {
      return E(e, xl(13, "Enter"));
    });
  }, 20));
  let S = v.start, I = v.endA, T = (E) => {
    let z = E || e.state.tr.replace(S, I, d.doc.slice(v.start - d.from, v.endB - d.from));
    if (d.sel) {
      let B = Zh(e, z.doc, d.sel);
      B && !(ca && e.composing && B.empty && (v.start != v.endB || e.input.lastChromeDelete < Date.now() - 100) && (B.head == S || B.head == z.mapping.map(I) - 1) || Aa && B.empty && B.head == S) && z.setSelection(B);
    }
    return o && z.setMeta("composition", o), z.scrollIntoView();
  }, A;
  if ($)
    if (p.pos == y.pos) {
      Aa && el <= 11 && p.parentOffset == 0 && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => Dn(e), 20));
      let E = T(e.state.tr.delete(S, I)), z = c.resolve(v.start).marksAcross(c.resolve(v.endA));
      z && E.ensureMarks(z), e.dispatch(E);
    } else if (
      // Adding or removing a mark
      v.endA == v.endB && (A = MT(p.parent.content.cut(p.parentOffset, y.parentOffset), k.parent.content.cut(k.parentOffset, v.endA - k.start())))
    ) {
      let E = T(e.state.tr);
      A.type == "add" ? E.addMark(S, I, A.mark) : E.removeMark(S, I, A.mark), e.dispatch(E);
    } else if (p.parent.child(p.index()).isText && p.index() == y.index() - (y.textOffset ? 0 : 1)) {
      let E = p.parent.textBetween(p.parentOffset, y.parentOffset), z = () => T(e.state.tr.insertText(E, S, I));
      e.someProp("handleTextInput", (B) => B(e, S, I, E, z)) || e.dispatch(z());
    } else
      e.dispatch(T());
  else
    e.dispatch(T());
}
function Zh(e, a, t) {
  return Math.max(t.anchor, t.head) > a.content.size ? null : Nc(e, a.resolve(t.anchor), a.resolve(t.head));
}
function MT(e, a) {
  let t = e.firstChild.marks, n = a.firstChild.marks, l = t, o = n, r, i, s;
  for (let c = 0; c < n.length; c++)
    l = n[c].removeFromSet(l);
  for (let c = 0; c < t.length; c++)
    o = t[c].removeFromSet(o);
  if (l.length == 1 && o.length == 0)
    i = l[0], r = "add", s = (c) => c.mark(i.addToSet(c.marks));
  else if (l.length == 0 && o.length == 1)
    i = o[0], r = "remove", s = (c) => c.mark(i.removeFromSet(c.marks));
  else
    return null;
  let d = [];
  for (let c = 0; c < a.childCount; c++)
    d.push(s(a.child(c)));
  if (We.from(d).eq(e))
    return { mark: i, type: r };
}
function OT(e, a, t, n, l) {
  if (
    // The content must have shrunk
    t - a <= l.pos - n.pos || // newEnd must point directly at or after the end of the block that newStart points into
    wd(n, !0, !1) < l.pos
  )
    return !1;
  let o = e.resolve(a);
  if (!n.parent.isTextblock) {
    let i = o.nodeAfter;
    return i != null && t == a + i.nodeSize;
  }
  if (o.parentOffset < o.parent.content.size || !o.parent.isTextblock)
    return !1;
  let r = e.resolve(wd(o, !0, !0));
  return !r.parent.isTextblock || r.pos > t || wd(r, !0, !1) < t ? !1 : n.parent.content.cut(n.parentOffset).eq(r.parent.content);
}
function wd(e, a, t) {
  let n = e.depth, l = a ? e.end() : e.pos;
  for (; n > 0 && (a || e.indexAfter(n) == e.node(n).childCount); )
    n--, l++, a = !1;
  if (t) {
    let o = e.node(n).maybeChild(e.indexAfter(n));
    for (; o && !o.isLeaf; )
      o = o.firstChild, l++;
  }
  return l;
}
function PT(e, a, t, n, l) {
  let o = e.findDiffStart(a, t);
  if (o == null)
    return null;
  let { a: r, b: i } = e.findDiffEnd(a, t + e.size, t + a.size);
  if (l == "end") {
    let s = Math.max(0, o - Math.min(r, i));
    n -= r + s - o;
  }
  if (r < o && e.size < a.size) {
    let s = n <= o && n >= r ? o - n : 0;
    o -= s, o && o < a.size && Qh(a.textBetween(o - 1, o + 1)) && (o += s ? 1 : -1), i = o + (i - r), r = o;
  } else if (i < o) {
    let s = n <= o && n >= i ? o - n : 0;
    o -= s, o && o < e.size && Qh(e.textBetween(o - 1, o + 1)) && (o += s ? 1 : -1), r = o + (r - i), i = o;
  }
  return { start: o, endA: r, endB: i };
}
function Qh(e) {
  if (e.length != 2)
    return !1;
  let a = e.charCodeAt(0), t = e.charCodeAt(1);
  return a >= 56320 && a <= 57343 && t >= 55296 && t <= 56319;
}
class ep {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(a, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new _L(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(nb), this.dispatch = this.dispatch.bind(this), this.dom = a && a.mount || document.createElement("div"), a && (a.appendChild ? a.appendChild(this.dom) : typeof a == "function" ? a(this.dom) : a.mount && (this.mounted = !0)), this.editable = tb(this), eb(this), this.nodeViews = ab(this), this.docView = Dh(this.state.doc, _h(this), kd(this), this.dom, this), this.domObserver = new IT(this, (n, l, o, r) => BT(this, n, l, o, r)), this.domObserver.start(), eT(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let a = this._props;
      this._props = {};
      for (let t in a)
        this._props[t] = a[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(a) {
    a.handleDOMEvents != this._props.handleDOMEvents && Au(this);
    let t = this._props;
    this._props = a, a.plugins && (a.plugins.forEach(nb), this.directPlugins = a.plugins), this.updateStateInner(a.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(a) {
    let t = {};
    for (let n in this._props)
      t[n] = this._props[n];
    t.state = this.state;
    for (let n in a)
      t[n] = a[n];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(a) {
    this.updateStateInner(a, this._props);
  }
  updateStateInner(a, t) {
    var n;
    let l = this.state, o = !1, r = !1;
    a.storedMarks && this.composing && (Kv(this), r = !0), this.state = a;
    let i = l.plugins != a.plugins || this._props.plugins != t.plugins;
    if (i || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let h = ab(this);
      NT(h, this.nodeViews) && (this.nodeViews = h, o = !0);
    }
    (i || t.handleDOMEvents != this._props.handleDOMEvents) && Au(this), this.editable = tb(this), eb(this);
    let s = kd(this), d = _h(this), c = l.plugins != a.plugins && !l.doc.eq(a.doc) ? "reset" : a.scrollToSelection > l.scrollToSelection ? "to selection" : "preserve", f = o || !this.docView.matchesNode(a.doc, d, s);
    (f || !a.selection.eq(l.selection)) && (r = !0);
    let g = c == "preserve" && r && this.dom.style.overflowAnchor == null && bL(this);
    if (r) {
      this.domObserver.stop();
      let h = f && (Aa || ca) && !this.composing && !l.selection.empty && !a.selection.empty && FT(l.selection, a.selection);
      if (f) {
        let v = ca ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = bT(this)), (o || !this.docView.update(a.doc, d, s, this)) && (this.docView.updateOuterDeco(d), this.docView.destroy(), this.docView = Dh(a.doc, d, s, this.dom, this)), v && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && FL(this)) ? Dn(this, h) : (Mv(this, a.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(l), !((n = this.dragging) === null || n === void 0) && n.node && !l.doc.eq(a.doc) && this.updateDraggedNode(this.dragging, l), c == "reset" ? this.dom.scrollTop = 0 : c == "to selection" ? this.scrollToSelection() : g && gL(g);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let a = this.domSelectionRange().focusNode;
    if (!(!a || !this.dom.contains(a.nodeType == 1 ? a : a.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof dt) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && Lh(this, t.getBoundingClientRect(), a);
      } else
        Lh(this, this.coordsAtPos(this.state.selection.head, 1), a);
    }
  }
  destroyPluginViews() {
    let a;
    for (; a = this.pluginViews.pop(); )
      a.destroy && a.destroy();
  }
  updatePluginViews(a) {
    if (!a || a.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let n = this.directPlugins[t];
        n.spec.view && this.pluginViews.push(n.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let n = this.state.plugins[t];
        n.spec.view && this.pluginViews.push(n.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let n = this.pluginViews[t];
        n.update && n.update(this, a);
      }
  }
  updateDraggedNode(a, t) {
    let n = a.node, l = -1;
    if (n.from < this.state.doc.content.size && this.state.doc.nodeAt(n.from) == n.node)
      l = n.from;
    else {
      let o = n.from + (this.state.doc.content.size - t.doc.content.size);
      (o > 0 && o < this.state.doc.content.size && this.state.doc.nodeAt(o)) == n.node && (l = o);
    }
    this.dragging = new Jv(a.slice, a.move, l < 0 ? void 0 : dt.create(this.state.doc, l));
  }
  someProp(a, t) {
    let n = this._props && this._props[a], l;
    if (n != null && (l = t ? t(n) : n))
      return l;
    for (let r = 0; r < this.directPlugins.length; r++) {
      let i = this.directPlugins[r].props[a];
      if (i != null && (l = t ? t(i) : i))
        return l;
    }
    let o = this.state.plugins;
    if (o)
      for (let r = 0; r < o.length; r++) {
        let i = o[r].props[a];
        if (i != null && (l = t ? t(i) : i))
          return l;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Aa) {
      let a = this.root.activeElement;
      if (a == this.dom)
        return !0;
      if (!a || !this.dom.contains(a))
        return !1;
      for (; a && this.dom != a && this.dom.contains(a); ) {
        if (a.contentEditable == "false")
          return !1;
        a = a.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && mL(this.dom), Dn(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let a = this._root;
    if (a == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return a || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(a) {
    return kL(this, a);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(a, t = 1) {
    return Lv(this, a, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(a, t = 0) {
    return this.docView.domFromPos(a, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(a) {
    let t = this.docView.descAt(a);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(a, t, n = -1) {
    let l = this.docView.posFromDOM(a, t, n);
    if (l == null)
      throw new RangeError("DOM position not inside the editor");
    return l;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(a, t) {
    return IL(this, t || this.state, a);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(a, t) {
    return yr(this, "", a, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(a, t) {
    return yr(this, a, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(a) {
    return Vc(this, a);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (tT(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], kd(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, lL());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(a) {
    return nT(this, a);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let a = this.domSelection();
    return a ? xa && this.root.nodeType === 11 && dL(this.dom.ownerDocument) == this.dom && TT(this, a) || a : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
ep.prototype.dispatch = function(e) {
  let a = this._props.dispatchTransaction;
  a ? a.call(this, e) : this.updateState(this.state.apply(e));
};
function _h(e) {
  let a = /* @__PURE__ */ Object.create(null);
  return a.class = "ProseMirror", a.contenteditable = String(e.editable), e.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(e.state)), t)
      for (let n in t)
        n == "class" ? a.class += " " + t[n] : n == "style" ? a.style = (a.style ? a.style + ";" : "") + t[n] : !a[n] && n != "contenteditable" && n != "nodeName" && (a[n] = String(t[n]));
  }), a.translate || (a.translate = "no"), [Ca.node(0, e.state.doc.content.size, a)];
}
function eb(e) {
  if (e.markCursor) {
    let a = document.createElement("img");
    a.className = "ProseMirror-separator", a.setAttribute("mark-placeholder", "true"), a.setAttribute("alt", ""), e.cursorWrapper = { dom: a, deco: Ca.widget(e.state.selection.from, a, { raw: !0, marks: e.markCursor }) };
  } else
    e.cursorWrapper = null;
}
function tb(e) {
  return !e.someProp("editable", (a) => a(e.state) === !1);
}
function FT(e, a) {
  let t = Math.min(e.$anchor.sharedDepth(e.head), a.$anchor.sharedDepth(a.head));
  return e.$anchor.start(t) != a.$anchor.start(t);
}
function ab(e) {
  let a = /* @__PURE__ */ Object.create(null);
  function t(n) {
    for (let l in n)
      Object.prototype.hasOwnProperty.call(a, l) || (a[l] = n[l]);
  }
  return e.someProp("nodeViews", t), e.someProp("markViews", t), a;
}
function NT(e, a) {
  let t = 0, n = 0;
  for (let l in e) {
    if (e[l] != a[l])
      return !0;
    t++;
  }
  for (let l in a)
    n++;
  return t != n;
}
function nb(e) {
  if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var rl = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, qi = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, VT = typeof navigator < "u" && /Mac/.test(navigator.platform), HT = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var ua = 0; ua < 10; ua++) rl[48 + ua] = rl[96 + ua] = String(ua);
for (var ua = 1; ua <= 24; ua++) rl[ua + 111] = "F" + ua;
for (var ua = 65; ua <= 90; ua++)
  rl[ua] = String.fromCharCode(ua + 32), qi[ua] = String.fromCharCode(ua);
for (var Cd in rl) qi.hasOwnProperty(Cd) || (qi[Cd] = rl[Cd]);
function jT(e) {
  var a = VT && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || HT && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", t = !a && e.key || (e.shiftKey ? qi : rl)[e.keyCode] || e.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const WT = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), qT = typeof navigator < "u" && /Win/.test(navigator.platform);
function UT(e) {
  let a = e.split(/-(?!$)/), t = a[a.length - 1];
  t == "Space" && (t = " ");
  let n, l, o, r;
  for (let i = 0; i < a.length - 1; i++) {
    let s = a[i];
    if (/^(cmd|meta|m)$/i.test(s))
      r = !0;
    else if (/^a(lt)?$/i.test(s))
      n = !0;
    else if (/^(c|ctrl|control)$/i.test(s))
      l = !0;
    else if (/^s(hift)?$/i.test(s))
      o = !0;
    else if (/^mod$/i.test(s))
      WT ? r = !0 : l = !0;
    else
      throw new Error("Unrecognized modifier name: " + s);
  }
  return n && (t = "Alt-" + t), l && (t = "Ctrl-" + t), r && (t = "Meta-" + t), o && (t = "Shift-" + t), t;
}
function GT(e) {
  let a = /* @__PURE__ */ Object.create(null);
  for (let t in e)
    a[UT(t)] = e[t];
  return a;
}
function Sd(e, a, t = !0) {
  return a.altKey && (e = "Alt-" + e), a.ctrlKey && (e = "Ctrl-" + e), a.metaKey && (e = "Meta-" + e), t && a.shiftKey && (e = "Shift-" + e), e;
}
function KT(e) {
  return new Ut({ props: { handleKeyDown: tp(e) } });
}
function tp(e) {
  let a = GT(e);
  return function(t, n) {
    let l = jT(n), o, r = a[Sd(l, n)];
    if (r && r(t.state, t.dispatch, t))
      return !0;
    if (l.length == 1 && l != " ") {
      if (n.shiftKey) {
        let i = a[Sd(l, n, !1)];
        if (i && i(t.state, t.dispatch, t))
          return !0;
      }
      if ((n.altKey || n.metaKey || n.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(qT && n.ctrlKey && n.altKey) && (o = rl[n.keyCode]) && o != l) {
        let i = a[Sd(o, n)];
        if (i && i(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
var YT = Object.defineProperty, Gc = (e, a) => {
  for (var t in a)
    YT(e, t, { get: a[t], enumerable: !0 });
};
function js(e) {
  const { state: a, transaction: t } = e;
  let { selection: n } = t, { doc: l } = t, { storedMarks: o } = t;
  return {
    ...a,
    apply: a.apply.bind(a),
    applyTransaction: a.applyTransaction.bind(a),
    plugins: a.plugins,
    schema: a.schema,
    reconfigure: a.reconfigure.bind(a),
    toJSON: a.toJSON.bind(a),
    get storedMarks() {
      return o;
    },
    get selection() {
      return n;
    },
    get doc() {
      return l;
    },
    get tr() {
      return n = t.selection, l = t.doc, o = t.storedMarks, t;
    }
  };
}
var Ws = class {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: a, state: t } = this, { view: n } = a, { tr: l } = t, o = this.buildProps(l);
    return Object.fromEntries(
      Object.entries(e).map(([r, i]) => [r, (...d) => {
        const c = i(...d)(o);
        return !l.getMeta("preventDispatch") && !this.hasCustomState && n.dispatch(l), c;
      }])
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, a = !0) {
    const { rawCommands: t, editor: n, state: l } = this, { view: o } = n, r = [], i = !!e, s = e || l.tr, d = () => (!i && a && !s.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(s), r.every((f) => f === !0)), c = {
      ...Object.fromEntries(
        Object.entries(t).map(([f, g]) => [f, (...v) => {
          const p = this.buildProps(s, a), y = g(...v)(p);
          return r.push(y), c;
        }])
      ),
      run: d
    };
    return c;
  }
  createCan(e) {
    const { rawCommands: a, state: t } = this, n = !1, l = e || t.tr, o = this.buildProps(l, n);
    return {
      ...Object.fromEntries(
        Object.entries(a).map(([i, s]) => [i, (...d) => s(...d)({ ...o, dispatch: void 0 })])
      ),
      chain: () => this.createChain(l, n)
    };
  }
  buildProps(e, a = !0) {
    const { rawCommands: t, editor: n, state: l } = this, { view: o } = n, r = {
      tr: e,
      editor: n,
      view: o,
      state: js({
        state: l,
        transaction: e
      }),
      dispatch: a ? () => {
      } : void 0,
      chain: () => this.createChain(e, a),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(
          Object.entries(t).map(([i, s]) => [i, (...d) => s(...d)(r)])
        );
      }
    };
    return r;
  }
}, ap = {};
Gc(ap, {
  blur: () => JT,
  clearContent: () => XT,
  clearNodes: () => ZT,
  command: () => QT,
  createParagraphNear: () => _T,
  cut: () => eE,
  deleteCurrentNode: () => tE,
  deleteNode: () => aE,
  deleteRange: () => nE,
  deleteSelection: () => rE,
  enter: () => iE,
  exitCode: () => sE,
  extendMarkRange: () => dE,
  first: () => uE,
  focus: () => fE,
  forEach: () => hE,
  insertContent: () => bE,
  insertContentAt: () => vE,
  joinBackward: () => yE,
  joinDown: () => xE,
  joinForward: () => kE,
  joinItemBackward: () => wE,
  joinItemForward: () => CE,
  joinTextblockBackward: () => SE,
  joinTextblockForward: () => $E,
  joinUp: () => pE,
  keyboardShortcut: () => LE,
  lift: () => TE,
  liftEmptyBlock: () => EE,
  liftListItem: () => AE,
  newlineInCode: () => RE,
  resetAttributes: () => zE,
  scrollIntoView: () => DE,
  selectAll: () => BE,
  selectNodeBackward: () => ME,
  selectNodeForward: () => OE,
  selectParentNode: () => PE,
  selectTextblockEnd: () => FE,
  selectTextblockStart: () => NE,
  setContent: () => VE,
  setMark: () => iA,
  setMeta: () => sA,
  setNode: () => dA,
  setNodeSelection: () => uA,
  setTextDirection: () => cA,
  setTextSelection: () => fA,
  sinkListItem: () => hA,
  splitBlock: () => bA,
  splitListItem: () => gA,
  toggleList: () => vA,
  toggleMark: () => pA,
  toggleNode: () => xA,
  toggleWrap: () => yA,
  undoInputRule: () => kA,
  unsetAllMarks: () => wA,
  unsetMark: () => CA,
  unsetTextDirection: () => SA,
  updateAttributes: () => $A,
  wrapIn: () => IA,
  wrapInList: () => LA
});
var JT = () => ({ editor: e, view: a }) => (requestAnimationFrame(() => {
  var t;
  e.isDestroyed || (a.dom.blur(), (t = window == null ? void 0 : window.getSelection()) == null || t.removeAllRanges());
}), !0), XT = (e = !0) => ({ commands: a }) => a.setContent("", { emitUpdate: e }), ZT = () => ({ state: e, tr: a, dispatch: t }) => {
  const { selection: n } = a, { ranges: l } = n;
  return t && l.forEach(({ $from: o, $to: r }) => {
    e.doc.nodesBetween(o.pos, r.pos, (i, s) => {
      if (i.type.isText)
        return;
      const { doc: d, mapping: c } = a, f = d.resolve(c.map(s)), g = d.resolve(c.map(s + i.nodeSize)), h = f.blockRange(g);
      if (!h)
        return;
      const v = $o(h);
      if (i.type.isTextblock) {
        const { defaultType: p } = f.parent.contentMatchAt(f.index());
        a.setNodeMarkup(h.start, p);
      }
      (v || v === 0) && a.lift(h, v);
    });
  }), !0;
}, QT = (e) => (a) => e(a), _T = () => ({ state: e, dispatch: a }) => mv(e, a), eE = (e, a) => ({ editor: t, tr: n }) => {
  const { state: l } = t, o = l.doc.slice(e.from, e.to);
  n.deleteRange(e.from, e.to);
  const r = n.mapping.map(a);
  return n.insert(r, o.content), n.setSelection(new ht(n.doc.resolve(Math.max(r - 1, 0)))), !0;
}, tE = () => ({ tr: e, dispatch: a }) => {
  const { selection: t } = e, n = t.$anchor.node();
  if (n.content.size > 0)
    return !1;
  const l = e.selection.$anchor;
  for (let o = l.depth; o > 0; o -= 1)
    if (l.node(o).type === n.type) {
      if (a) {
        const i = l.before(o), s = l.after(o);
        e.delete(i, s).scrollIntoView();
      }
      return !0;
    }
  return !1;
};
function ea(e, a) {
  if (typeof e == "string") {
    if (!a.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return a.nodes[e];
  }
  return e;
}
var aE = (e) => ({ tr: a, state: t, dispatch: n }) => {
  const l = ea(e, t.schema), o = a.selection.$anchor;
  for (let r = o.depth; r > 0; r -= 1)
    if (o.node(r).type === l) {
      if (n) {
        const s = o.before(r), d = o.after(r);
        a.delete(s, d).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, nE = (e) => ({ tr: a, dispatch: t }) => {
  const { from: n, to: l } = e;
  return t && a.delete(n, l), !0;
}, lE = (e) => e.content ? /^text(\*|\+)/.test(e.content) : !1, lb = (e, a, t) => {
  if (!e.parent.isInline || t === "left" && e.pos > e.start() || t === "right" && e.pos < e.end())
    return e.pos;
  const n = a.nodes[e.parent.type.name].spec;
  return lE(n) ? t === "left" ? e.start() - 1 : e.end() + 1 : e.pos;
}, oE = (e, a, t) => {
  const n = lb(e, t, "left"), l = lb(a, t, "right");
  return { from: n, to: l };
}, rE = () => ({ state: e, dispatch: a }) => {
  const { $from: t, $to: n } = e.selection;
  if (e.selection.empty)
    return !1;
  const { from: l, to: o } = oE(t, n, e.schema);
  return a && (e.tr.deleteRange(l, o).scrollIntoView(), a(e.tr)), !0;
}, iE = () => ({ commands: e }) => e.keyboardShortcut("Enter"), sE = () => ({ state: e, dispatch: a }) => WI(e, a);
function Kc(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
function Ui(e, a, t = { strict: !0 }) {
  const n = Object.keys(a);
  return n.length ? n.every((l) => t.strict ? a[l] === e[l] : Kc(a[l]) ? a[l].test(e[l]) : a[l] === e[l]) : !0;
}
function np(e, a, t = {}) {
  return e.find((n) => n.type === a && Ui(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((l) => [l, n.attrs[l]])),
    t
  ));
}
function ob(e, a, t = {}) {
  return !!np(e, a, t);
}
function Yc(e, a, t) {
  if (!e || !a)
    return;
  let n = e.parent.childAfter(e.parentOffset);
  if ((!n.node || !n.node.marks.some((d) => d.type === a)) && (n = e.parent.childBefore(e.parentOffset)), !n.node || !n.node.marks.some((d) => d.type === a))
    return;
  if (!t) {
    const d = n.node.marks.find((c) => c.type === a);
    d && (t = d.attrs);
  }
  if (!np([...n.node.marks], a, t))
    return;
  let o = n.index, r = e.start() + n.offset, i = o + 1, s = r + n.node.nodeSize;
  for (; o > 0 && ob([...e.parent.child(o - 1).marks], a, t); )
    o -= 1, r -= e.parent.child(o).nodeSize;
  for (; i < e.parent.childCount && ob([...e.parent.child(i).marks], a, t); )
    s += e.parent.child(i).nodeSize, i += 1;
  return {
    from: r,
    to: s
  };
}
function Pn(e, a) {
  if (typeof e == "string") {
    if (!a.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return a.marks[e];
  }
  return e;
}
var dE = (e, a) => ({ tr: t, state: n, dispatch: l }) => {
  const o = Pn(e, n.schema), { doc: r, selection: i } = t, { $from: s, from: d, to: c } = i;
  if (l) {
    const f = Yc(s, o, a);
    if (f && f.from <= d && f.to >= c) {
      const g = ht.create(r, f.from, f.to);
      t.setSelection(g);
    }
  }
  return !0;
}, uE = (e) => (a) => {
  const t = typeof e == "function" ? e(a) : e;
  for (let n = 0; n < t.length; n += 1)
    if (t[n](a))
      return !0;
  return !1;
};
function lp(e) {
  return e instanceof ht;
}
function Cl(e = 0, a = 0, t = 0) {
  return Math.min(Math.max(e, a), t);
}
function op(e, a = null) {
  if (!a)
    return null;
  const t = xt.atStart(e), n = xt.atEnd(e);
  if (a === "start" || a === !0)
    return t;
  if (a === "end")
    return n;
  const l = t.from, o = n.to;
  return a === "all" ? ht.create(e, Cl(0, l, o), Cl(e.content.size, l, o)) : ht.create(e, Cl(a, l, o), Cl(a, l, o));
}
function rb() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function Gi() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function cE() {
  return typeof navigator < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
}
var fE = (e = null, a = {}) => ({ editor: t, view: n, tr: l, dispatch: o }) => {
  a = {
    scrollIntoView: !0,
    ...a
  };
  const r = () => {
    (Gi() || rb()) && n.dom.focus(), cE() && !Gi() && !rb() && n.dom.focus({ preventScroll: !0 }), requestAnimationFrame(() => {
      t.isDestroyed || (n.focus(), a != null && a.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  try {
    if (n.hasFocus() && e === null || e === !1)
      return !0;
  } catch {
    return !1;
  }
  if (o && e === null && !lp(t.state.selection))
    return r(), !0;
  const i = op(l.doc, e) || t.state.selection, s = t.state.selection.eq(i);
  return o && (s || l.setSelection(i), s && l.storedMarks && l.setStoredMarks(l.storedMarks), r()), !0;
}, hE = (e, a) => (t) => e.every((n, l) => a(n, { ...t, index: l })), bE = (e, a) => ({ tr: t, commands: n }) => n.insertContentAt({ from: t.selection.from, to: t.selection.to }, e, a), rp = (e) => {
  const a = e.childNodes;
  for (let t = a.length - 1; t >= 0; t -= 1) {
    const n = a[t];
    n.nodeType === 3 && n.nodeValue && /^(\n\s\s|\n)$/.test(n.nodeValue) ? e.removeChild(n) : n.nodeType === 1 && rp(n);
  }
  return e;
};
function Zr(e) {
  if (typeof window > "u")
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  const a = `<body>${e}</body>`, t = new window.DOMParser().parseFromString(a, "text/html").body;
  return rp(t);
}
function wr(e, a, t) {
  if (e instanceof Qn || e instanceof We)
    return e;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const n = typeof e == "object" && e !== null, l = typeof e == "string";
  if (n)
    try {
      if (Array.isArray(e) && e.length > 0)
        return We.fromArray(e.map((i) => a.nodeFromJSON(i)));
      const r = a.nodeFromJSON(e);
      return t.errorOnInvalidContent && r.check(), r;
    } catch (o) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: o });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", o), wr("", a, t);
    }
  if (l) {
    if (t.errorOnInvalidContent) {
      let r = !1, i = "";
      const s = new jm({
        topNode: a.spec.topNode,
        marks: a.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: a.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (d) => (r = !0, i = typeof d == "string" ? d : d.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? _n.fromSchema(s).parseSlice(Zr(e), t.parseOptions) : _n.fromSchema(s).parse(Zr(e), t.parseOptions), t.errorOnInvalidContent && r)
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${i}`)
        });
    }
    const o = _n.fromSchema(a);
    return t.slice ? o.parseSlice(Zr(e), t.parseOptions).content : o.parse(Zr(e), t.parseOptions);
  }
  return wr("", a, t);
}
function gE(e, a, t) {
  const n = e.steps.length - 1;
  if (n < a)
    return;
  const l = e.steps[n];
  if (!(l instanceof Zt || l instanceof ra))
    return;
  const o = e.mapping.maps[n];
  let r = 0;
  o.forEach((i, s, d, c) => {
    r === 0 && (r = c);
  }), e.setSelection(xt.near(e.doc.resolve(r), t));
}
var mE = (e) => !("type" in e), vE = (e, a, t) => ({ tr: n, dispatch: l, editor: o }) => {
  var r;
  if (l) {
    t = {
      parseOptions: o.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let i;
    const s = (y) => {
      o.emit("contentError", {
        editor: o,
        error: y,
        disableCollaboration: () => {
          "collaboration" in o.storage && typeof o.storage.collaboration == "object" && o.storage.collaboration && (o.storage.collaboration.isDisabled = !0);
        }
      });
    }, d = {
      preserveWhitespace: "full",
      ...t.parseOptions
    };
    if (!t.errorOnInvalidContent && !o.options.enableContentCheck && o.options.emitContentError)
      try {
        wr(a, o.schema, {
          parseOptions: d,
          errorOnInvalidContent: !0
        });
      } catch (y) {
        s(y);
      }
    try {
      i = wr(a, o.schema, {
        parseOptions: d,
        errorOnInvalidContent: (r = t.errorOnInvalidContent) != null ? r : o.options.enableContentCheck
      });
    } catch (y) {
      return s(y), !1;
    }
    let { from: c, to: f } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, g = !0, h = !0;
    if ((mE(i) ? i : [i]).forEach((y) => {
      y.check(), g = g ? y.isText && y.marks.length === 0 : !1, h = h ? y.isBlock : !1;
    }), c === f && h) {
      const { parent: y } = n.doc.resolve(c);
      y.isTextblock && !y.type.spec.code && !y.childCount && (c -= 1, f += 1);
    }
    let p;
    if (g) {
      if (Array.isArray(a))
        p = a.map((y) => y.text || "").join("");
      else if (a instanceof We) {
        let y = "";
        a.forEach((k) => {
          k.text && (y += k.text);
        }), p = y;
      } else typeof a == "object" && a && a.text ? p = a.text : p = a;
      n.insertText(p, c, f);
    } else {
      p = i;
      const y = n.doc.resolve(c), k = y.node(), $ = y.parentOffset === 0, S = k.isText || k.isTextblock, I = k.content.size > 0;
      $ && S && I && h && (c = Math.max(0, c - 1)), n.replaceWith(c, f, p);
    }
    t.updateSelection && gE(n, n.steps.length - 1, -1), t.applyInputRules && n.setMeta("applyInputRules", { from: c, text: p }), t.applyPasteRules && n.setMeta("applyPasteRules", { from: c, text: p });
  }
  return !0;
}, pE = () => ({ state: e, dispatch: a }) => VI(e, a), xE = () => ({ state: e, dispatch: a }) => HI(e, a), yE = () => ({ state: e, dispatch: a }) => dv(e, a), kE = () => ({ state: e, dispatch: a }) => hv(e, a), wE = () => ({ state: e, dispatch: a, tr: t }) => {
  try {
    const n = Os(e.doc, e.selection.$from.pos, -1);
    return n == null ? !1 : (t.join(n, 2), a && a(t), !0);
  } catch {
    return !1;
  }
}, CE = () => ({ state: e, dispatch: a, tr: t }) => {
  try {
    const n = Os(e.doc, e.selection.$from.pos, 1);
    return n == null ? !1 : (t.join(n, 2), a && a(t), !0);
  } catch {
    return !1;
  }
}, SE = () => ({ state: e, dispatch: a }) => FI(e, a), $E = () => ({ state: e, dispatch: a }) => NI(e, a);
function ip() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function IE(e) {
  const a = e.split(/-(?!$)/);
  let t = a[a.length - 1];
  t === "Space" && (t = " ");
  let n, l, o, r;
  for (let i = 0; i < a.length - 1; i += 1) {
    const s = a[i];
    if (/^(cmd|meta|m)$/i.test(s))
      r = !0;
    else if (/^a(lt)?$/i.test(s))
      n = !0;
    else if (/^(c|ctrl|control)$/i.test(s))
      l = !0;
    else if (/^s(hift)?$/i.test(s))
      o = !0;
    else if (/^mod$/i.test(s))
      Gi() || ip() ? r = !0 : l = !0;
    else
      throw new Error(`Unrecognized modifier name: ${s}`);
  }
  return n && (t = `Alt-${t}`), l && (t = `Ctrl-${t}`), r && (t = `Meta-${t}`), o && (t = `Shift-${t}`), t;
}
var LE = (e) => ({ editor: a, view: t, tr: n, dispatch: l }) => {
  const o = IE(e).split(/-(?!$)/), r = o.find((d) => !["Alt", "Ctrl", "Meta", "Shift"].includes(d)), i = new KeyboardEvent("keydown", {
    key: r === "Space" ? " " : r,
    altKey: o.includes("Alt"),
    ctrlKey: o.includes("Ctrl"),
    metaKey: o.includes("Meta"),
    shiftKey: o.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), s = a.captureTransaction(() => {
    t.someProp("handleKeyDown", (d) => d(t, i));
  });
  return s == null || s.steps.forEach((d) => {
    const c = d.map(n.mapping);
    c && l && n.maybeStep(c);
  }), !0;
};
function il(e, a, t = {}) {
  const { from: n, to: l, empty: o } = e.selection, r = a ? ea(a, e.schema) : null, i = [];
  e.doc.nodesBetween(n, l, (f, g) => {
    if (f.isText)
      return;
    const h = Math.max(n, g), v = Math.min(l, g + f.nodeSize);
    i.push({
      node: f,
      from: h,
      to: v
    });
  });
  const s = l - n, d = i.filter((f) => r ? r.name === f.node.type.name : !0).filter((f) => Ui(f.node.attrs, t, { strict: !1 }));
  return o ? !!d.length : d.reduce((f, g) => f + g.to - g.from, 0) >= s;
}
var TE = (e, a = {}) => ({ state: t, dispatch: n }) => {
  const l = ea(e, t.schema);
  return il(t, l, a) ? jI(t, n) : !1;
}, EE = () => ({ state: e, dispatch: a }) => vv(e, a), AE = (e) => ({ state: a, dispatch: t }) => {
  const n = ea(e, a.schema);
  return eL(n)(a, t);
}, RE = () => ({ state: e, dispatch: a }) => gv(e, a);
function qs(e, a) {
  return a.nodes[e] ? "node" : a.marks[e] ? "mark" : null;
}
function ib(e, a) {
  const t = typeof a == "string" ? [a] : a;
  return Object.keys(e).reduce((n, l) => (t.includes(l) || (n[l] = e[l]), n), {});
}
var zE = (e, a) => ({ tr: t, state: n, dispatch: l }) => {
  let o = null, r = null;
  const i = qs(
    typeof e == "string" ? e : e.name,
    n.schema
  );
  if (!i)
    return !1;
  i === "node" && (o = ea(e, n.schema)), i === "mark" && (r = Pn(e, n.schema));
  let s = !1;
  return t.selection.ranges.forEach((d) => {
    n.doc.nodesBetween(d.$from.pos, d.$to.pos, (c, f) => {
      o && o === c.type && (s = !0, l && t.setNodeMarkup(f, void 0, ib(c.attrs, a))), r && c.marks.length && c.marks.forEach((g) => {
        r === g.type && (s = !0, l && t.addMark(f, f + c.nodeSize, r.create(ib(g.attrs, a))));
      });
    });
  }), s;
}, DE = () => ({ tr: e, dispatch: a }) => (a && e.scrollIntoView(), !0), BE = () => ({ tr: e, dispatch: a }) => {
  if (a) {
    const t = new Ma(e.doc);
    e.setSelection(t);
  }
  return !0;
}, ME = () => ({ state: e, dispatch: a }) => cv(e, a), OE = () => ({ state: e, dispatch: a }) => bv(e, a), PE = () => ({ state: e, dispatch: a }) => GI(e, a), FE = () => ({ state: e, dispatch: a }) => JI(e, a), NE = () => ({ state: e, dispatch: a }) => YI(e, a);
function Ru(e, a, t = {}, n = {}) {
  return wr(e, a, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: n.errorOnInvalidContent
  });
}
var VE = (e, { errorOnInvalidContent: a, emitUpdate: t = !0, parseOptions: n = {} } = {}) => ({ editor: l, tr: o, dispatch: r, commands: i }) => {
  const { doc: s } = o;
  if (n.preserveWhitespace !== "full") {
    const d = Ru(e, l.schema, n, {
      errorOnInvalidContent: a ?? l.options.enableContentCheck
    });
    return r && o.replaceWith(0, s.content.size, d).setMeta("preventUpdate", !t), !0;
  }
  return r && o.setMeta("preventUpdate", !t), i.insertContentAt({ from: 0, to: s.content.size }, e, {
    parseOptions: n,
    errorOnInvalidContent: a ?? l.options.enableContentCheck
  });
};
function sp(e, a) {
  const t = Pn(a, e.schema), { from: n, to: l, empty: o } = e.selection, r = [];
  o ? (e.storedMarks && r.push(...e.storedMarks), r.push(...e.selection.$head.marks())) : e.doc.nodesBetween(n, l, (s) => {
    r.push(...s.marks);
  });
  const i = r.find((s) => s.type.name === t.name);
  return i ? { ...i.attrs } : {};
}
function dp(e, a) {
  const t = new lv(e);
  return a.forEach((n) => {
    n.steps.forEach((l) => {
      t.step(l);
    });
  }), t;
}
function HE(e) {
  for (let a = 0; a < e.edgeCount; a += 1) {
    const { type: t } = e.edge(a);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function jE(e, a, t) {
  const n = [];
  return e.nodesBetween(a.from, a.to, (l, o) => {
    t(l) && n.push({
      node: l,
      pos: o
    });
  }), n;
}
function WE(e, a) {
  for (let t = e.depth; t > 0; t -= 1) {
    const n = e.node(t);
    if (a(n))
      return {
        pos: t > 0 ? e.before(t) : 0,
        start: e.start(t),
        depth: t,
        node: n
      };
  }
}
function Us(e) {
  return (a) => WE(a.$from, e);
}
function rt(e, a, t) {
  return e.config[a] === void 0 && e.parent ? rt(e.parent, a, t) : typeof e.config[a] == "function" ? e.config[a].bind({
    ...t,
    parent: e.parent ? rt(e.parent, a, t) : null
  }) : e.config[a];
}
function Jc(e) {
  return e.map((a) => {
    const t = {
      name: a.name,
      options: a.options,
      storage: a.storage
    }, n = rt(a, "addExtensions", t);
    return n ? [a, ...Jc(n())] : a;
  }).flat(10);
}
function Xc(e, a) {
  const t = Vl.fromSchema(a).serializeFragment(e), l = document.implementation.createHTMLDocument().createElement("div");
  return l.appendChild(t), l.innerHTML;
}
function up(e) {
  return typeof e == "function";
}
function Et(e, a = void 0, ...t) {
  return up(e) ? a ? e.bind(a)(...t) : e(...t) : e;
}
function qE(e = {}) {
  return Object.keys(e).length === 0 && e.constructor === Object;
}
function po(e) {
  const a = e.filter((l) => l.type === "extension"), t = e.filter((l) => l.type === "node"), n = e.filter((l) => l.type === "mark");
  return {
    baseExtensions: a,
    nodeExtensions: t,
    markExtensions: n
  };
}
function cp(e) {
  const a = [], { nodeExtensions: t, markExtensions: n } = po(e), l = [...t, ...n], o = {
    default: null,
    validate: void 0,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  }, r = t.filter((d) => d.name !== "text").map((d) => d.name), i = n.map((d) => d.name), s = [...r, ...i];
  return e.forEach((d) => {
    const c = {
      name: d.name,
      options: d.options,
      storage: d.storage,
      extensions: l
    }, f = rt(
      d,
      "addGlobalAttributes",
      c
    );
    if (!f)
      return;
    f().forEach((h) => {
      let v;
      Array.isArray(h.types) ? v = h.types : h.types === "*" ? v = s : h.types === "nodes" ? v = r : h.types === "marks" ? v = i : v = [], v.forEach((p) => {
        Object.entries(h.attributes).forEach(([y, k]) => {
          a.push({
            type: p,
            name: y,
            attribute: {
              ...o,
              ...k
            }
          });
        });
      });
    });
  }), l.forEach((d) => {
    const c = {
      name: d.name,
      options: d.options,
      storage: d.storage
    }, f = rt(
      d,
      "addAttributes",
      c
    );
    if (!f)
      return;
    const g = f();
    Object.entries(g).forEach(([h, v]) => {
      const p = {
        ...o,
        ...v
      };
      typeof (p == null ? void 0 : p.default) == "function" && (p.default = p.default()), p != null && p.isRequired && (p == null ? void 0 : p.default) === void 0 && delete p.default, a.push({
        type: d.name,
        name: h,
        attribute: p
      });
    });
  }), a;
}
function UE(e) {
  const a = [];
  let t = "", n = !1, l = !1, o = 0;
  const r = e.length;
  for (let i = 0; i < r; i += 1) {
    const s = e[i];
    if (s === "'" && !l) {
      n = !n, t += s;
      continue;
    }
    if (s === '"' && !n) {
      l = !l, t += s;
      continue;
    }
    if (!n && !l) {
      if (s === "(") {
        o += 1, t += s;
        continue;
      }
      if (s === ")" && o > 0) {
        o -= 1, t += s;
        continue;
      }
      if (s === ";" && o === 0) {
        a.push(t), t = "";
        continue;
      }
    }
    t += s;
  }
  return t && a.push(t), a;
}
function sb(e) {
  const a = [], t = UE(e || ""), n = t.length;
  for (let l = 0; l < n; l += 1) {
    const o = t[l], r = o.indexOf(":");
    if (r === -1)
      continue;
    const i = o.slice(0, r).trim(), s = o.slice(r + 1).trim();
    i && s && a.push([i, s]);
  }
  return a;
}
function qt(...e) {
  return e.filter((a) => !!a).reduce((a, t) => {
    const n = { ...a };
    return Object.entries(t).forEach(([l, o]) => {
      if (!n[l]) {
        n[l] = o;
        return;
      }
      if (l === "class") {
        const i = o ? String(o).split(" ") : [], s = n[l] ? n[l].split(" ") : [], d = i.filter((c) => !s.includes(c));
        n[l] = [...s, ...d].join(" ");
      } else if (l === "style") {
        const i = new Map([...sb(n[l]), ...sb(o)]);
        n[l] = Array.from(i.entries()).map(([s, d]) => `${s}: ${d}`).join("; ");
      } else
        n[l] = o;
    }), n;
  }, {});
}
function Cr(e, a) {
  return a.filter((t) => t.type === e.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(e.attrs) || {} : {
    [t.name]: e.attrs[t.name]
  }).reduce((t, n) => qt(t, n), {});
}
function GE(e) {
  return typeof e != "string" ? e : e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : e === "true" ? !0 : e === "false" ? !1 : e;
}
function db(e, a) {
  return "style" in e ? e : {
    ...e,
    getAttrs: (t) => {
      const n = e.getAttrs ? e.getAttrs(t) : e.attrs;
      if (n === !1)
        return !1;
      const l = a.reduce((o, r) => {
        const i = r.attribute.parseHTML ? r.attribute.parseHTML(t) : GE(t.getAttribute(r.name));
        return i == null ? o : {
          ...o,
          [r.name]: i
        };
      }, {});
      return { ...n, ...l };
    }
  };
}
function ub(e) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(e).filter(([a, t]) => a === "attrs" && qE(t) ? !1 : t != null)
  );
}
function cb(e) {
  var a, t;
  const n = {};
  return !((a = e == null ? void 0 : e.attribute) != null && a.isRequired) && "default" in ((e == null ? void 0 : e.attribute) || {}) && (n.default = e.attribute.default), ((t = e == null ? void 0 : e.attribute) == null ? void 0 : t.validate) !== void 0 && (n.validate = e.attribute.validate), [e.name, n];
}
function KE(e, a) {
  var t;
  const n = cp(e), { nodeExtensions: l, markExtensions: o } = po(e), r = (t = l.find((d) => rt(d, "topNode"))) == null ? void 0 : t.name, i = Object.fromEntries(
    l.map((d) => {
      const c = n.filter((k) => k.type === d.name), f = {
        name: d.name,
        options: d.options,
        storage: d.storage,
        editor: a
      }, g = e.reduce((k, $) => {
        const S = rt($, "extendNodeSchema", f);
        return {
          ...k,
          ...S ? S(d) : {}
        };
      }, {}), h = ub({
        ...g,
        content: Et(rt(d, "content", f)),
        marks: Et(rt(d, "marks", f)),
        group: Et(rt(d, "group", f)),
        inline: Et(rt(d, "inline", f)),
        atom: Et(rt(d, "atom", f)),
        selectable: Et(rt(d, "selectable", f)),
        draggable: Et(rt(d, "draggable", f)),
        code: Et(rt(d, "code", f)),
        whitespace: Et(rt(d, "whitespace", f)),
        linebreakReplacement: Et(
          rt(d, "linebreakReplacement", f)
        ),
        defining: Et(rt(d, "defining", f)),
        isolating: Et(rt(d, "isolating", f)),
        attrs: Object.fromEntries(c.map(cb))
      }), v = Et(rt(d, "parseHTML", f));
      v && (h.parseDOM = v.map(
        (k) => db(k, c)
      ));
      const p = rt(d, "renderHTML", f);
      p && (h.toDOM = (k) => p({
        node: k,
        HTMLAttributes: Cr(k, c)
      }));
      const y = rt(d, "renderText", f);
      return y && (h.toText = y), [d.name, h];
    })
  ), s = Object.fromEntries(
    o.map((d) => {
      const c = n.filter((y) => y.type === d.name), f = {
        name: d.name,
        options: d.options,
        storage: d.storage,
        editor: a
      }, g = e.reduce((y, k) => {
        const $ = rt(k, "extendMarkSchema", f);
        return {
          ...y,
          ...$ ? $(d) : {}
        };
      }, {}), h = ub({
        ...g,
        inclusive: Et(rt(d, "inclusive", f)),
        excludes: Et(rt(d, "excludes", f)),
        group: Et(rt(d, "group", f)),
        spanning: Et(rt(d, "spanning", f)),
        code: Et(rt(d, "code", f)),
        attrs: Object.fromEntries(c.map(cb))
      }), v = Et(rt(d, "parseHTML", f));
      v && (h.parseDOM = v.map(
        (y) => db(y, c)
      ));
      const p = rt(d, "renderHTML", f);
      return p && (h.toDOM = (y) => p({
        mark: y,
        HTMLAttributes: Cr(y, c)
      })), [d.name, h];
    })
  );
  return new jm({
    topNode: r,
    nodes: i,
    marks: s
  });
}
function YE(e) {
  const a = e.filter((t, n) => e.indexOf(t) !== n);
  return Array.from(new Set(a));
}
function tr(e) {
  return e.sort((t, n) => {
    const l = rt(t, "priority") || 100, o = rt(n, "priority") || 100;
    return l > o ? -1 : l < o ? 1 : 0;
  });
}
function fp(e) {
  const a = tr(Jc(e)), t = YE(a.map((n) => n.name));
  return t.length && console.warn(
    `[tiptap warn]: Duplicate extension names found: [${t.map((n) => `'${n}'`).join(", ")}]. This can lead to issues.`
  ), a;
}
function hp(e, a, t) {
  const { from: n, to: l } = a, { blockSeparator: o = `

`, textSerializers: r = {} } = t || {};
  let i = "";
  return e.nodesBetween(n, l, (s, d, c, f) => {
    var g;
    s.isBlock && d > n && (i += o);
    const h = r == null ? void 0 : r[s.type.name];
    if (h)
      return c && (i += h({
        node: s,
        pos: d,
        parent: c,
        index: f,
        range: a
      })), !1;
    s.isText && (i += (g = s == null ? void 0 : s.text) == null ? void 0 : g.slice(Math.max(n, d) - d, l - d));
  }), i;
}
function JE(e, a) {
  const t = {
    from: 0,
    to: e.content.size
  };
  return hp(e, t, a);
}
function bp(e) {
  return Object.fromEntries(
    Object.entries(e.nodes).filter(([, a]) => a.spec.toText).map(([a, t]) => [a, t.spec.toText])
  );
}
function XE(e, a) {
  const t = ea(a, e.schema), { from: n, to: l } = e.selection, o = [];
  e.doc.nodesBetween(n, l, (i) => {
    o.push(i);
  });
  const r = o.reverse().find((i) => i.type.name === t.name);
  return r ? { ...r.attrs } : {};
}
function gp(e, a) {
  const t = qs(
    typeof a == "string" ? a : a.name,
    e.schema
  );
  return t === "node" ? XE(e, a) : t === "mark" ? sp(e, a) : {};
}
function ZE(e, a = JSON.stringify) {
  const t = {};
  return e.filter((n) => {
    const l = a(n);
    return Object.prototype.hasOwnProperty.call(t, l) ? !1 : t[l] = !0;
  });
}
function QE(e) {
  const a = ZE(e);
  return a.length === 1 ? a : a.filter((t, n) => !a.filter((o, r) => r !== n).some((o) => t.oldRange.from >= o.oldRange.from && t.oldRange.to <= o.oldRange.to && t.newRange.from >= o.newRange.from && t.newRange.to <= o.newRange.to));
}
function mp(e) {
  const { mapping: a, steps: t } = e, n = [];
  return a.maps.forEach((l, o) => {
    const r = [];
    if (l.ranges.length)
      l.forEach((i, s) => {
        r.push({ from: i, to: s });
      });
    else {
      const { from: i, to: s } = t[o];
      if (i === void 0 || s === void 0)
        return;
      r.push({ from: i, to: s });
    }
    r.forEach(({ from: i, to: s }) => {
      const d = a.slice(o).map(i, -1), c = a.slice(o).map(s), f = a.invert().map(d, -1), g = a.invert().map(c);
      n.push({
        oldRange: {
          from: f,
          to: g
        },
        newRange: {
          from: d,
          to: c
        }
      });
    });
  }), QE(n);
}
function Zc(e, a, t) {
  const n = [];
  return e === a ? t.resolve(e).marks().forEach((l) => {
    const o = t.resolve(e), r = Yc(o, l.type);
    r && n.push({
      mark: l,
      ...r
    });
  }) : t.nodesBetween(e, a, (l, o) => {
    !l || (l == null ? void 0 : l.nodeSize) === void 0 || n.push(
      ...l.marks.map((r) => ({
        from: o,
        to: o + l.nodeSize,
        mark: r
      }))
    );
  }), n;
}
var _E = (e, a, t, n = 20) => {
  const l = e.doc.resolve(t);
  let o = n, r = null;
  for (; o > 0 && r === null; ) {
    const i = l.node(o);
    (i == null ? void 0 : i.type.name) === a ? r = i : o -= 1;
  }
  return [r, o];
};
function Do(e, a) {
  return a.nodes[e] || a.marks[e] || null;
}
function ki(e, a, t) {
  return Object.fromEntries(
    Object.entries(t).filter(([n]) => {
      const l = e.find((o) => o.type === a && o.name === n);
      return l ? l.attribute.keepOnSplit : !1;
    })
  );
}
var eA = (e, a = 500) => {
  let t = "";
  const n = e.parentOffset;
  return e.parent.nodesBetween(Math.max(0, n - a), n, (l, o, r, i) => {
    var s, d;
    const c = ((d = (s = l.type.spec).toText) == null ? void 0 : d.call(s, {
      node: l,
      pos: o,
      parent: r,
      index: i
    })) || l.textContent || "%leaf%";
    t += l.isAtom && !l.isText ? c : c.slice(0, Math.max(0, n - o));
  }), t;
};
function zu(e, a, t = {}) {
  const { empty: n, ranges: l } = e.selection, o = a ? Pn(a, e.schema) : null;
  if (n)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((f) => o ? o.name === f.type.name : !0).find((f) => Ui(f.attrs, t, { strict: !1 }));
  let r = 0;
  const i = [];
  if (l.forEach(({ $from: f, $to: g }) => {
    const h = f.pos, v = g.pos;
    e.doc.nodesBetween(h, v, (p, y) => {
      if (o && p.inlineContent && !p.type.allowsMarkType(o))
        return !1;
      if (!p.isText && !p.marks.length)
        return;
      const k = Math.max(h, y), $ = Math.min(v, y + p.nodeSize), S = $ - k;
      r += S, i.push(
        ...p.marks.map((I) => ({
          mark: I,
          from: k,
          to: $
        }))
      );
    });
  }), r === 0)
    return !1;
  const s = i.filter((f) => o ? o.name === f.mark.type.name : !0).filter((f) => Ui(f.mark.attrs, t, { strict: !1 })).reduce((f, g) => f + g.to - g.from, 0), d = i.filter((f) => o ? f.mark.type !== o && f.mark.type.excludes(o) : !0).reduce((f, g) => f + g.to - g.from, 0);
  return (s > 0 ? s + d : s) >= r;
}
function tA(e, a, t = {}) {
  if (!a)
    return il(e, null, t) || zu(e, null, t);
  const n = qs(a, e.schema);
  return n === "node" ? il(e, a, t) : n === "mark" ? zu(e, a, t) : !1;
}
var aA = (e, a) => {
  const { $from: t, $to: n, $anchor: l } = e.selection;
  if (a) {
    const o = Us((i) => i.type.name === a)(e.selection);
    if (!o)
      return !1;
    const r = e.doc.resolve(o.pos + 1);
    return l.pos + 1 === r.end();
  }
  return !(n.parentOffset < n.parent.nodeSize - 2 || t.pos !== n.pos);
}, nA = (e) => {
  const { $from: a, $to: t } = e.selection;
  return !(a.parentOffset > 0 || a.pos !== t.pos);
};
function fb(e, a) {
  return Array.isArray(a) ? a.some((t) => (typeof t == "string" ? t : t.name) === e.name) : a;
}
function $d(e, a) {
  const { nodeExtensions: t } = po(a), n = t.find((r) => r.name === e);
  if (!n)
    return !1;
  const l = {
    name: n.name,
    options: n.options,
    storage: n.storage
  }, o = Et(rt(n, "group", l));
  return typeof o != "string" ? !1 : o.split(" ").includes("list");
}
function Sr(e, {
  checkChildren: a = !0,
  ignoreWhitespace: t = !1
} = {}) {
  var n;
  if (t) {
    if (e.type.name === "hardBreak")
      return !0;
    if (e.isText)
      return !/\S/.test((n = e.text) != null ? n : "");
  }
  if (e.isText)
    return !e.text;
  if (e.isAtom || e.isLeaf)
    return !1;
  if (e.content.childCount === 0)
    return !0;
  if (a) {
    let l = !0;
    return e.content.forEach((o) => {
      l !== !1 && (Sr(o, { ignoreWhitespace: t, checkChildren: a }) || (l = !1));
    }), l;
  }
  return !1;
}
function vp(e) {
  return e instanceof dt;
}
var pp = class xp {
  constructor(a) {
    this.position = a;
  }
  /**
   * Creates a MappablePosition from a JSON object.
   */
  static fromJSON(a) {
    return new xp(a.position);
  }
  /**
   * Converts the MappablePosition to a JSON object.
   */
  toJSON() {
    return {
      position: this.position
    };
  }
};
function lA(e, a) {
  const t = a.mapping.mapResult(e.position);
  return {
    position: new pp(t.pos),
    mapResult: t
  };
}
function oA(e) {
  return new pp(e);
}
function rA(e, a, t) {
  var n;
  const { selection: l } = a;
  let o = null;
  if (lp(l) && (o = l.$cursor), o) {
    const i = (n = e.storedMarks) != null ? n : o.marks();
    return o.parent.type.allowsMarkType(t) && (!!t.isInSet(i) || !i.some((d) => d.type.excludes(t)));
  }
  const { ranges: r } = l;
  return r.some(({ $from: i, $to: s }) => {
    let d = i.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(t) : !1;
    return e.doc.nodesBetween(i.pos, s.pos, (c, f, g) => {
      if (d)
        return !1;
      if (c.isInline) {
        const h = !g || g.type.allowsMarkType(t), v = !!t.isInSet(c.marks) || !c.marks.some((p) => p.type.excludes(t));
        d = h && v;
      }
      return !d;
    }), d;
  });
}
var iA = (e, a = {}) => ({ tr: t, state: n, dispatch: l }) => {
  const { selection: o } = t, { empty: r, ranges: i } = o, s = Pn(e, n.schema);
  if (l)
    if (r) {
      const d = sp(n, s);
      t.addStoredMark(
        s.create({
          ...d,
          ...a
        })
      );
    } else
      i.forEach((d) => {
        const c = d.$from.pos, f = d.$to.pos;
        n.doc.nodesBetween(c, f, (g, h) => {
          const v = Math.max(h, c), p = Math.min(h + g.nodeSize, f);
          g.marks.find((k) => k.type === s) ? g.marks.forEach((k) => {
            s === k.type && t.addMark(
              v,
              p,
              s.create({
                ...k.attrs,
                ...a
              })
            );
          }) : t.addMark(v, p, s.create(a));
        });
      });
  return rA(n, t, s);
}, sA = (e, a) => ({ tr: t }) => (t.setMeta(e, a), !0), dA = (e, a = {}) => ({ state: t, dispatch: n, chain: l }) => {
  const o = ea(e, t.schema);
  let r;
  return t.selection.$anchor.sameParent(t.selection.$head) && (r = t.selection.$anchor.parent.attrs), o.isTextblock ? l().command(({ commands: i }) => Sh(o, { ...r, ...a })(t) ? !0 : i.clearNodes()).command(({ state: i }) => Sh(o, { ...r, ...a })(i, n)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, uA = (e) => ({ tr: a, dispatch: t }) => {
  if (t) {
    const { doc: n } = a, l = Cl(e, 0, n.content.size), o = dt.create(n, l);
    a.setSelection(o);
  }
  return !0;
}, cA = (e, a) => ({ tr: t, state: n, dispatch: l }) => {
  const { selection: o } = n;
  let r, i;
  return typeof a == "number" ? (r = a, i = a) : a && "from" in a && "to" in a ? (r = a.from, i = a.to) : (r = o.from, i = o.to), l && t.doc.nodesBetween(r, i, (s, d) => {
    s.isText || t.setNodeMarkup(d, void 0, {
      ...s.attrs,
      dir: e
    });
  }), !0;
}, fA = (e) => ({ tr: a, dispatch: t }) => {
  if (t) {
    const { doc: n } = a, { from: l, to: o } = typeof e == "number" ? { from: e, to: e } : e, r = ht.atStart(n).from, i = ht.atEnd(n).to, s = Cl(l, r, i), d = Cl(o, r, i), c = ht.create(n, s, d);
    a.setSelection(c);
  }
  return !0;
}, hA = (e) => ({ state: a, dispatch: t }) => {
  const n = ea(e, a.schema);
  return nL(n)(a, t);
};
function hb(e, a) {
  const t = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (t) {
    const n = t.filter((l) => a == null ? void 0 : a.includes(l.type.name));
    e.tr.ensureMarks(n);
  }
}
var bA = ({ keepMarks: e = !0 } = {}) => ({ tr: a, state: t, dispatch: n, editor: l }) => {
  const { selection: o, doc: r } = a, { $from: i, $to: s } = o, d = l.extensionManager.attributes, c = ki(d, i.node().type.name, i.node().attrs);
  if (o instanceof dt && o.node.isBlock)
    return !i.parentOffset || !zn(r, i.pos) ? !1 : (n && (e && hb(t, l.extensionManager.splittableMarks), a.split(i.pos).scrollIntoView()), !0);
  if (!i.parent.isBlock)
    return !1;
  const f = s.parentOffset === s.parent.content.size, g = i.depth === 0 ? void 0 : HE(i.node(-1).contentMatchAt(i.indexAfter(-1)));
  let h = f && g ? [
    {
      type: g,
      attrs: c
    }
  ] : void 0, v = zn(a.doc, a.mapping.map(i.pos), 1, h);
  if (!h && !v && zn(a.doc, a.mapping.map(i.pos), 1, g ? [{ type: g }] : void 0) && (v = !0, h = g ? [
    {
      type: g,
      attrs: c
    }
  ] : void 0), n) {
    if (v && (o instanceof ht && a.deleteSelection(), a.split(a.mapping.map(i.pos), 1, h), g && !f && !i.parentOffset && i.parent.type !== g)) {
      const p = a.mapping.map(i.before()), y = a.doc.resolve(p);
      i.node(-1).canReplaceWith(y.index(), y.index() + 1, g) && a.setNodeMarkup(a.mapping.map(i.before()), g);
    }
    e && hb(t, l.extensionManager.splittableMarks), a.scrollIntoView();
  }
  return v;
}, gA = (e, a = {}) => ({ tr: t, state: n, dispatch: l, editor: o }) => {
  var r;
  const i = ea(e, n.schema), { $from: s, $to: d } = n.selection, c = n.selection.node;
  if (c && c.isBlock || s.depth < 2 || !s.sameParent(d))
    return !1;
  const f = s.node(-1);
  if (f.type !== i)
    return !1;
  const g = o.extensionManager.attributes;
  if (s.parent.content.size === 0 && s.node(-1).childCount === s.indexAfter(-1)) {
    if (s.depth === 2 || s.node(-3).type !== i || s.index(-2) !== s.node(-2).childCount - 1)
      return !1;
    if (l) {
      let k = We.empty;
      const $ = s.index(-1) ? 1 : s.index(-2) ? 2 : 3;
      for (let z = s.depth - $; z >= s.depth - 3; z -= 1)
        k = We.from(s.node(z).copy(k));
      const S = (
        // eslint-disable-next-line no-nested-ternary
        s.indexAfter(-1) < s.node(-2).childCount ? 1 : s.indexAfter(-2) < s.node(-3).childCount ? 2 : 3
      ), I = {
        ...ki(g, s.node().type.name, s.node().attrs),
        ...a
      }, T = ((r = i.contentMatch.defaultType) == null ? void 0 : r.createAndFill(I)) || void 0;
      k = k.append(We.from(i.createAndFill(null, T) || void 0));
      const A = s.before(s.depth - ($ - 1));
      t.replace(A, s.after(-S), new tt(k, 4 - $, 0));
      let E = -1;
      t.doc.nodesBetween(A, t.doc.content.size, (z, B) => {
        if (E > -1)
          return !1;
        z.isTextblock && z.content.size === 0 && (E = B + 1);
      }), E > -1 && t.setSelection(ht.near(t.doc.resolve(E))), t.scrollIntoView();
    }
    return !0;
  }
  const h = d.pos === s.end() ? f.contentMatchAt(0).defaultType : null, v = {
    ...ki(g, f.type.name, f.attrs),
    ...a
  }, p = {
    ...ki(g, s.node().type.name, s.node().attrs),
    ...a
  };
  t.delete(s.pos, d.pos);
  const y = h ? [
    { type: i, attrs: v },
    { type: h, attrs: p }
  ] : [{ type: i, attrs: v }];
  if (!zn(t.doc, s.pos, 2))
    return !1;
  if (l) {
    const { selection: k, storedMarks: $ } = n, { splittableMarks: S } = o.extensionManager, I = $ || k.$to.parentOffset && k.$from.marks();
    if (t.split(s.pos, 2, y).scrollIntoView(), !I || !l)
      return !0;
    const T = I.filter((A) => S.includes(A.type.name));
    t.ensureMarks(T);
  }
  return !0;
}, Id = (e, a) => {
  const t = Us((r) => r.type === a)(e.selection);
  if (!t)
    return !0;
  const n = e.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (n === void 0)
    return !0;
  const l = e.doc.nodeAt(n);
  return t.node.type === (l == null ? void 0 : l.type) && bl(e.doc, t.pos) && e.join(t.pos), !0;
}, Ld = (e, a) => {
  const t = Us((r) => r.type === a)(e.selection);
  if (!t)
    return !0;
  const n = e.doc.resolve(t.start).after(t.depth);
  if (n === void 0)
    return !0;
  const l = e.doc.nodeAt(n);
  return t.node.type === (l == null ? void 0 : l.type) && bl(e.doc, n) && e.join(n), !0;
};
function mA(e) {
  const a = e.doc, t = a.firstChild;
  if (!t)
    return null;
  const n = a.resolve(1), l = a.resolve(t.nodeSize - 1);
  return ht.between(n, l);
}
var vA = (e, a, t, n = {}) => ({ editor: l, tr: o, state: r, dispatch: i, chain: s, commands: d, can: c }) => {
  const { extensions: f, splittableMarks: g } = l.extensionManager, h = ea(e, r.schema), v = ea(a, r.schema), { selection: p, storedMarks: y } = r, { $from: k, $to: $ } = p, S = k.blockRange($), I = y || p.$to.parentOffset && p.$from.marks();
  if (!S)
    return !1;
  const T = Us((le) => $d(le.type.name, f))(p), A = p.from === 0 && p.to === r.doc.content.size, E = r.doc.content.content, z = E.length === 1 ? E[0] : null, B = A && z && $d(z.type.name, f) ? {
    node: z,
    pos: 0
  } : null, W = T ?? B, _ = !!T && S.depth >= 1 && S.depth - T.depth <= 1, Z = !!B;
  if ((_ || Z) && W) {
    if (W.node.type === h)
      return A && Z ? s().command(({ tr: le, dispatch: D }) => {
        const O = mA(le);
        return O ? (le.setSelection(O), D && D(le), !0) : !1;
      }).liftListItem(v).run() : d.liftListItem(v);
    if ($d(W.node.type.name, f) && h.validContent(W.node.content))
      return s().command(() => (o.setNodeMarkup(W.pos, h), !0)).command(() => Id(o, h)).command(() => Ld(o, h)).run();
  }
  return !t || !I || !i ? s().command(() => c().wrapInList(h, n) ? !0 : d.clearNodes()).wrapInList(h, n).command(() => Id(o, h)).command(() => Ld(o, h)).run() : s().command(() => {
    const le = c().wrapInList(h, n), D = I.filter((O) => g.includes(O.type.name));
    return o.ensureMarks(D), le ? !0 : d.clearNodes();
  }).wrapInList(h, n).command(() => Id(o, h)).command(() => Ld(o, h)).run();
}, pA = (e, a = {}, t = {}) => ({ state: n, commands: l }) => {
  const { extendEmptyMarkRange: o = !1 } = t, r = Pn(e, n.schema);
  return zu(n, r, a) ? l.unsetMark(r, { extendEmptyMarkRange: o }) : l.setMark(r, a);
}, xA = (e, a, t = {}) => ({ state: n, commands: l }) => {
  const o = ea(e, n.schema), r = ea(a, n.schema), i = il(n, o, t);
  let s;
  return n.selection.$anchor.sameParent(n.selection.$head) && (s = n.selection.$anchor.parent.attrs), i ? l.setNode(r, s) : l.setNode(o, { ...s, ...t });
}, yA = (e, a = {}) => ({ state: t, commands: n }) => {
  const l = ea(e, t.schema);
  return il(t, l, a) ? n.lift(l) : n.wrapIn(l, a);
}, kA = () => ({ state: e, dispatch: a }) => {
  const t = e.plugins;
  for (let n = 0; n < t.length; n += 1) {
    const l = t[n];
    let o;
    if (l.spec.isInputRules && (o = l.getState(e))) {
      if (a) {
        const r = e.tr, i = o.transform;
        for (let s = i.steps.length - 1; s >= 0; s -= 1)
          r.step(i.steps[s].invert(i.docs[s]));
        if (o.text) {
          const s = r.doc.resolve(o.from).marks();
          r.replaceWith(o.from, o.to, e.schema.text(o.text, s));
        } else
          r.delete(o.from, o.to);
      }
      return !0;
    }
  }
  return !1;
}, wA = () => ({ tr: e, dispatch: a }) => {
  const { selection: t } = e, { empty: n, ranges: l } = t;
  return n || a && l.forEach((o) => {
    e.removeMark(o.$from.pos, o.$to.pos);
  }), !0;
}, CA = (e, a = {}) => ({ tr: t, state: n, dispatch: l }) => {
  var o;
  const { extendEmptyMarkRange: r = !1 } = a, { selection: i } = t, s = Pn(e, n.schema), { $from: d, empty: c, ranges: f } = i;
  if (!l)
    return !0;
  if (c && r) {
    let { from: g, to: h } = i;
    const v = (o = d.marks().find((y) => y.type === s)) == null ? void 0 : o.attrs, p = Yc(d, s, v);
    p && (g = p.from, h = p.to), t.removeMark(g, h, s);
  } else
    f.forEach((g) => {
      t.removeMark(g.$from.pos, g.$to.pos, s);
    });
  return t.removeStoredMark(s), !0;
}, SA = (e) => ({ tr: a, state: t, dispatch: n }) => {
  const { selection: l } = t;
  let o, r;
  return typeof e == "number" ? (o = e, r = e) : e && "from" in e && "to" in e ? (o = e.from, r = e.to) : (o = l.from, r = l.to), n && a.doc.nodesBetween(o, r, (i, s) => {
    if (i.isText)
      return;
    const d = { ...i.attrs };
    delete d.dir, a.setNodeMarkup(s, void 0, d);
  }), !0;
}, $A = (e, a = {}) => ({ tr: t, state: n, dispatch: l }) => {
  let o = null, r = null;
  const i = qs(
    typeof e == "string" ? e : e.name,
    n.schema
  );
  if (!i)
    return !1;
  i === "node" && (o = ea(e, n.schema)), i === "mark" && (r = Pn(e, n.schema));
  let s = !1;
  return t.selection.ranges.forEach((d) => {
    const c = d.$from.pos, f = d.$to.pos;
    let g, h, v, p;
    t.selection.empty ? n.doc.nodesBetween(c, f, (y, k) => {
      o && o === y.type && (s = !0, v = Math.max(k, c), p = Math.min(k + y.nodeSize, f), g = k, h = y);
    }) : n.doc.nodesBetween(c, f, (y, k) => {
      k < c && o && o === y.type && (s = !0, v = Math.max(k, c), p = Math.min(k + y.nodeSize, f), g = k, h = y), k >= c && k <= f && (o && o === y.type && (s = !0, l && t.setNodeMarkup(k, void 0, {
        ...y.attrs,
        ...a
      })), r && y.marks.length && y.marks.forEach(($) => {
        if (r === $.type && (s = !0, l)) {
          const S = Math.max(k, c), I = Math.min(k + y.nodeSize, f);
          t.addMark(
            S,
            I,
            r.create({
              ...$.attrs,
              ...a
            })
          );
        }
      }));
    }), h && (g !== void 0 && l && t.setNodeMarkup(g, void 0, {
      ...h.attrs,
      ...a
    }), r && h.marks.length && h.marks.forEach((y) => {
      r === y.type && l && t.addMark(
        v,
        p,
        r.create({
          ...y.attrs,
          ...a
        })
      );
    }));
  }), s;
}, IA = (e, a = {}) => ({ state: t, dispatch: n }) => {
  const l = ea(e, t.schema);
  return XI(l, a)(t, n);
}, LA = (e, a = {}) => ({ state: t, dispatch: n }) => {
  const l = ea(e, t.schema);
  return ZI(l, a)(t, n);
}, TA = class {
  constructor() {
    this.callbacks = {};
  }
  on(e, a) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(a), this;
  }
  emit(e, ...a) {
    const t = this.callbacks[e];
    return t && t.forEach((n) => n.apply(this, a)), this;
  }
  off(e, a) {
    const t = this.callbacks[e];
    return t && (a ? this.callbacks[e] = t.filter((n) => n !== a) : delete this.callbacks[e]), this;
  }
  once(e, a) {
    const t = (...n) => {
      this.off(e, t), a.apply(this, n);
    };
    return this.on(e, t);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}, Gs = class {
  constructor(e) {
    var a;
    this.find = e.find, this.handler = e.handler, this.undoable = (a = e.undoable) != null ? a : !0;
  }
}, EA = (e, a) => {
  if (Kc(a))
    return a.exec(e);
  const t = a(e);
  if (!t)
    return null;
  const n = [t.text];
  return n.index = t.index, n.input = e, n.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), n.push(t.replaceWith)), n;
};
function Qr(e) {
  var a;
  const { editor: t, from: n, to: l, text: o, rules: r, plugin: i } = e, { view: s } = t;
  if (s.composing)
    return !1;
  const d = s.state.doc.resolve(n);
  if (
    // check for code node
    d.parent.type.spec.code || (a = d.nodeBefore || d.nodeAfter) != null && a.marks.find((g) => g.type.spec.code)
  )
    return !1;
  let c = !1;
  const f = eA(d) + o;
  return r.forEach((g) => {
    if (c)
      return;
    const h = EA(f, g.find);
    if (!h)
      return;
    const v = s.state.tr, p = js({
      state: s.state,
      transaction: v
    }), y = {
      from: n - (h[0].length - o.length),
      to: l
    }, { commands: k, chain: $, can: S } = new Ws({
      editor: t,
      state: p
    });
    g.handler({
      state: p,
      range: y,
      match: h,
      commands: k,
      chain: $,
      can: S
    }) === null || !v.steps.length || (g.undoable && v.setMeta(i, {
      transform: v,
      from: n,
      to: l,
      text: o
    }), s.dispatch(v), c = !0);
  }), c;
}
function AA(e) {
  const { editor: a, rules: t } = e, n = new Ut({
    state: {
      init() {
        return null;
      },
      apply(l, o, r) {
        const i = l.getMeta(n);
        if (i)
          return i;
        const s = l.getMeta("applyInputRules");
        return !!s && setTimeout(() => {
          let { text: c } = s;
          typeof c == "string" ? c = c : c = Xc(We.from(c), r.schema);
          const { from: f } = s, g = f + c.length;
          Qr({
            editor: a,
            from: f,
            to: g,
            text: c,
            rules: t,
            plugin: n
          });
        }), l.selectionSet || l.docChanged ? null : o;
      }
    },
    props: {
      handleTextInput(l, o, r, i) {
        return Qr({
          editor: a,
          from: o,
          to: r,
          text: i,
          rules: t,
          plugin: n
        });
      },
      handleDOMEvents: {
        compositionend: (l) => (setTimeout(() => {
          const { $cursor: o } = l.state.selection;
          o && Qr({
            editor: a,
            from: o.pos,
            to: o.pos,
            text: "",
            rules: t,
            plugin: n
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(l, o) {
        if (o.key !== "Enter")
          return !1;
        const { $cursor: r } = l.state.selection;
        return r ? Qr({
          editor: a,
          from: r.pos,
          to: r.pos,
          text: `
`,
          rules: t,
          plugin: n
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return n;
}
function RA(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function _r(e) {
  return RA(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function yp(e, a) {
  const t = { ...e };
  return _r(e) && _r(a) && Object.keys(a).forEach((n) => {
    _r(a[n]) && _r(e[n]) ? t[n] = yp(e[n], a[n]) : t[n] = a[n];
  }), t;
}
var Qc = class {
  constructor(e = {}) {
    this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = {
      name: this.name
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name;
  }
  get options() {
    return {
      ...Et(
        rt(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...Et(
        rt(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(e = {}) {
    const a = this.extend({
      ...this.config,
      addOptions: () => yp(this.options, e)
    });
    return a.name = this.name, a.parent = this.parent, this.child = null, a;
  }
  extend(e = {}) {
    const a = new this.constructor({ ...this.config, ...e });
    return a.parent = this, this.child = a, a.name = "name" in e ? e.name : a.parent.name, a;
  }
}, Fn = class kp extends Qc {
  constructor() {
    super(...arguments), this.type = "mark";
  }
  /**
   * Create a new Mark instance
   * @param config - Mark configuration object or a function that returns a configuration object
   */
  static create(a = {}) {
    const t = typeof a == "function" ? a() : a;
    return new kp(t);
  }
  static handleExit({ editor: a, mark: t }) {
    const { tr: n } = a.state, l = a.state.selection.$from;
    if (l.pos === l.end()) {
      const r = l.marks();
      if (!!!r.find((d) => (d == null ? void 0 : d.type.name) === t.name))
        return !1;
      const s = r.find((d) => (d == null ? void 0 : d.type.name) === t.name);
      return s && n.removeStoredMark(s), n.insertText(" ", l.pos), a.view.dispatch(n), !0;
    }
    return !1;
  }
  configure(a) {
    return super.configure(a);
  }
  extend(a) {
    const t = typeof a == "function" ? a() : a;
    return super.extend(t);
  }
};
function zA(e) {
  return typeof e == "number";
}
var DA = class {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}, BA = (e, a, t) => {
  if (Kc(a))
    return [...e.matchAll(a)];
  const n = a(e, t);
  return n ? n.map((l) => {
    const o = [l.text];
    return o.index = l.index, o.input = e, o.data = l.data, l.replaceWith && (l.text.includes(l.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), o.push(l.replaceWith)), o;
  }) : [];
};
function MA(e) {
  const { editor: a, state: t, from: n, to: l, rule: o, pasteEvent: r, dropEvent: i } = e, { commands: s, chain: d, can: c } = new Ws({
    editor: a,
    state: t
  }), f = [];
  return t.doc.nodesBetween(n, l, (h, v) => {
    var p, y, k, $, S;
    if ((y = (p = h.type) == null ? void 0 : p.spec) != null && y.code || !(h.isText || h.isTextblock || h.isInline))
      return;
    const I = (S = ($ = (k = h.content) == null ? void 0 : k.size) != null ? $ : h.nodeSize) != null ? S : 0, T = Math.max(n, v), A = Math.min(l, v + I);
    if (T >= A)
      return;
    const E = h.isText ? h.text || "" : h.textBetween(T - v, A - v, void 0, "￼");
    BA(E, o.find, r).forEach((B) => {
      if (B.index === void 0)
        return;
      const W = T + B.index + 1, _ = W + B[0].length, Z = {
        from: t.tr.mapping.map(W),
        to: t.tr.mapping.map(_)
      }, le = o.handler({
        state: t,
        range: Z,
        match: B,
        commands: s,
        chain: d,
        can: c,
        pasteEvent: r,
        dropEvent: i
      });
      f.push(le);
    });
  }), f.every((h) => h !== null);
}
var ei = null, OA = (e) => {
  var a;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (a = t.clipboardData) == null || a.setData("text/html", e), t;
};
function PA(e) {
  const { editor: a, rules: t } = e;
  let n = null, l = !1, o = !1, r = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, i;
  try {
    i = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    i = null;
  }
  const s = ({
    state: c,
    from: f,
    to: g,
    rule: h,
    pasteEvt: v
  }) => {
    const p = c.tr, y = js({
      state: c,
      transaction: p
    });
    if (!(!MA({
      editor: a,
      state: y,
      from: Math.max(f - 1, 0),
      to: g.b - 1,
      rule: h,
      pasteEvent: v,
      dropEvent: i
    }) || !p.steps.length)) {
      try {
        i = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        i = null;
      }
      return r = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, p;
    }
  };
  return t.map((c) => new Ut({
    // we register a global drag handler to track the current drag source element
    view(f) {
      const g = (v) => {
        var p;
        n = (p = f.dom.parentElement) != null && p.contains(v.target) ? f.dom.parentElement : null, n && (ei = a);
      }, h = () => {
        ei && (ei = null);
      };
      return window.addEventListener("dragstart", g), window.addEventListener("dragend", h), {
        destroy() {
          window.removeEventListener("dragstart", g), window.removeEventListener("dragend", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (f, g) => {
          if (o = n === f.dom.parentElement, i = g, !o) {
            const h = ei;
            h != null && h.isEditable && setTimeout(() => {
              const v = h.state.selection;
              v && h.commands.deleteRange({ from: v.from, to: v.to });
            }, 10);
          }
          return !1;
        },
        paste: (f, g) => {
          var h;
          const v = (h = g.clipboardData) == null ? void 0 : h.getData("text/html");
          return r = g, l = !!(v != null && v.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (f, g, h) => {
      const v = f[0], p = v.getMeta("uiEvent") === "paste" && !l, y = v.getMeta("uiEvent") === "drop" && !o, k = v.getMeta("applyPasteRules"), $ = !!k;
      if (!p && !y && !$)
        return;
      if ($) {
        let { text: T } = k;
        typeof T == "string" ? T = T : T = Xc(We.from(T), h.schema);
        const { from: A } = k, E = A + T.length, z = OA(T);
        return s({
          rule: c,
          state: h,
          from: A,
          to: { b: E },
          pasteEvt: z
        });
      }
      const S = g.doc.content.findDiffStart(h.doc.content), I = g.doc.content.findDiffEnd(h.doc.content);
      if (!(!zA(S) || !I || S === I.b))
        return s({
          rule: c,
          state: h,
          from: S,
          to: I,
          pasteEvt: r
        });
    }
  }));
}
var Ks = class {
  constructor(e, a) {
    this.splittableMarks = [], this.editor = a, this.baseExtensions = e, this.extensions = fp(e), this.schema = KE(this.extensions, a), this.setupExtensions();
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, a) => {
      const t = {
        name: a.name,
        options: a.options,
        storage: this.editor.extensionStorage[a.name],
        editor: this.editor,
        type: Do(a.name, this.schema)
      }, n = rt(a, "addCommands", t);
      return n ? {
        ...e,
        ...n()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this;
    return tr([...this.extensions].reverse()).flatMap((n) => {
      const l = {
        name: n.name,
        options: n.options,
        storage: this.editor.extensionStorage[n.name],
        editor: e,
        type: Do(n.name, this.schema)
      }, o = [], r = rt(
        n,
        "addKeyboardShortcuts",
        l
      );
      let i = {};
      if (n.type === "mark" && rt(n, "exitable", l) && (i.ArrowRight = () => Fn.handleExit({ editor: e, mark: n })), r) {
        const g = Object.fromEntries(
          Object.entries(r()).map(([h, v]) => [h, () => v({ editor: e })])
        );
        i = { ...i, ...g };
      }
      const s = KT(i);
      o.push(s);
      const d = rt(n, "addInputRules", l);
      if (fb(n, e.options.enableInputRules) && d) {
        const g = d();
        if (g && g.length) {
          const h = AA({
            editor: e,
            rules: g
          }), v = Array.isArray(h) ? h : [h];
          o.push(...v);
        }
      }
      const c = rt(n, "addPasteRules", l);
      if (fb(n, e.options.enablePasteRules) && c) {
        const g = c();
        if (g && g.length) {
          const h = PA({ editor: e, rules: g });
          o.push(...h);
        }
      }
      const f = rt(
        n,
        "addProseMirrorPlugins",
        l
      );
      if (f) {
        const g = f();
        o.push(...g);
      }
      return o;
    });
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return cp(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: a } = po(this.extensions);
    return Object.fromEntries(
      a.filter((t) => !!rt(t, "addNodeView")).map((t) => {
        const n = this.attributes.filter((s) => s.type === t.name), l = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: e,
          type: ea(t.name, this.schema)
        }, o = rt(t, "addNodeView", l);
        if (!o)
          return [];
        const r = o();
        if (!r)
          return [];
        const i = (s, d, c, f, g) => {
          const h = Cr(s, n);
          return r({
            // pass-through
            node: s,
            view: d,
            getPos: c,
            decorations: f,
            innerDecorations: g,
            // tiptap-specific
            editor: e,
            extension: t,
            HTMLAttributes: h
          });
        };
        return [t.name, i];
      })
    );
  }
  /**
   * Get the composed dispatchTransaction function from all extensions.
   * @param baseDispatch The base dispatch function (e.g. from the editor or user props)
   * @returns A composed dispatch function
   */
  dispatchTransaction(e) {
    const { editor: a } = this;
    return tr([...this.extensions].reverse()).reduceRight((n, l) => {
      const o = {
        name: l.name,
        options: l.options,
        storage: this.editor.extensionStorage[l.name],
        editor: a,
        type: Do(l.name, this.schema)
      }, r = rt(
        l,
        "dispatchTransaction",
        o
      );
      return r ? (i) => {
        r.call(o, { transaction: i, next: n });
      } : n;
    }, e);
  }
  /**
   * Get the composed transformPastedHTML function from all extensions.
   * @param baseTransform The base transform function (e.g. from the editor props)
   * @returns A composed transform function that chains all extension transforms
   */
  transformPastedHTML(e) {
    const { editor: a } = this;
    return tr([...this.extensions]).reduce(
      (n, l) => {
        const o = {
          name: l.name,
          options: l.options,
          storage: this.editor.extensionStorage[l.name],
          editor: a,
          type: Do(l.name, this.schema)
        }, r = rt(
          l,
          "transformPastedHTML",
          o
        );
        return r ? (i, s) => {
          const d = n(i, s);
          return r.call(o, d);
        } : n;
      },
      e || ((n) => n)
    );
  }
  get markViews() {
    const { editor: e } = this, { markExtensions: a } = po(this.extensions);
    return Object.fromEntries(
      a.filter((t) => !!rt(t, "addMarkView")).map((t) => {
        const n = this.attributes.filter((i) => i.type === t.name), l = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: e,
          type: Pn(t.name, this.schema)
        }, o = rt(t, "addMarkView", l);
        if (!o)
          return [];
        const r = (i, s, d) => {
          const c = Cr(i, n);
          return o()({
            // pass-through
            mark: i,
            view: s,
            inline: d,
            // tiptap-specific
            editor: e,
            extension: t,
            HTMLAttributes: c,
            updateAttributes: (f) => {
              QA(i, e, f);
            }
          });
        };
        return [t.name, r];
      })
    );
  }
  /**
   * Destroy the extension manager and clean up all extension references
   * to prevent memory leaks through parent/child extension chains.
   *
   * Walks each extension's full parent chain and nulls every forward
   * `parent.child → current` link where the parent still points to the
   * current node. This breaks the retention path from module-scope
   * singleton roots through deep extend() chains.
   *
   * Only ancestor `.child` links matching the current chain are cleared.
   * The `.parent` pointer on ancestors is never touched — extensions
   * may be shared across live editors, so their own backward references
   * and non-matching forward links must remain intact.
   */
  destroy() {
    this.extensions.forEach((e) => {
      let a = e;
      for (; a.parent; ) {
        const t = a.parent;
        t.child === a && (t.child = null), a = t;
      }
    }), this.extensions = [], this.baseExtensions = [], this.schema = null, this.editor = null;
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    const e = this.extensions;
    this.editor.extensionStorage = Object.fromEntries(
      e.map((a) => [a.name, a.storage])
    ), e.forEach((a) => {
      var t;
      const n = {
        name: a.name,
        options: a.options,
        storage: this.editor.extensionStorage[a.name],
        editor: this.editor,
        type: Do(a.name, this.schema)
      };
      a.type === "mark" && ((t = Et(rt(a, "keepOnSplit", n))) == null || t) && this.splittableMarks.push(a.name);
      const l = rt(a, "onBeforeCreate", n), o = rt(a, "onCreate", n), r = rt(a, "onUpdate", n), i = rt(
        a,
        "onSelectionUpdate",
        n
      ), s = rt(a, "onTransaction", n), d = rt(a, "onFocus", n), c = rt(a, "onBlur", n), f = rt(a, "onDestroy", n);
      l && this.editor.on("beforeCreate", l), o && this.editor.on("create", o), r && this.editor.on("update", r), i && this.editor.on("selectionUpdate", i), s && this.editor.on("transaction", s), d && this.editor.on("focus", d), c && this.editor.on("blur", c), f && this.editor.on("destroy", f);
    });
  }
};
Ks.resolve = fp;
Ks.sort = tr;
Ks.flatten = Jc;
var FA = {};
Gc(FA, {
  ClipboardTextSerializer: () => Cp,
  Commands: () => Sp,
  Delete: () => $p,
  Drop: () => Ip,
  Editable: () => Lp,
  FocusEvents: () => Ep,
  Keymap: () => Ap,
  Paste: () => Rp,
  Tabindex: () => zp,
  TextDirection: () => Dp,
  focusEventsPluginKey: () => Tp
});
var Dt = class wp extends Qc {
  constructor() {
    super(...arguments), this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(a = {}) {
    const t = typeof a == "function" ? a() : a;
    return new wp(t);
  }
  configure(a) {
    return super.configure(a);
  }
  extend(a) {
    const t = typeof a == "function" ? a() : a;
    return super.extend(t);
  }
}, Cp = Dt.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Ut({
        key: new la("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: a, schema: t } = e, { doc: n, selection: l } = a, { ranges: o } = l, r = Math.min(...o.map((c) => c.$from.pos)), i = Math.max(...o.map((c) => c.$to.pos)), s = bp(t);
            return hp(n, { from: r, to: i }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: s
            });
          }
        }
      })
    ];
  }
}), Sp = Dt.create({
  name: "commands",
  addCommands() {
    return {
      ...ap
    };
  }
}), $p = Dt.create({
  name: "delete",
  onUpdate({ transaction: e, appendedTransactions: a }) {
    var t, n, l;
    const o = () => {
      var r, i, s, d;
      if ((d = (s = (i = (r = this.editor.options.coreExtensionOptions) == null ? void 0 : r.delete) == null ? void 0 : i.filterTransaction) == null ? void 0 : s.call(i, e)) != null ? d : e.getMeta("y-sync$"))
        return;
      const c = dp(e.before, [e, ...a]);
      mp(c).forEach((h) => {
        c.mapping.mapResult(h.oldRange.from).deletedAfter && c.mapping.mapResult(h.oldRange.to).deletedBefore && c.before.nodesBetween(h.oldRange.from, h.oldRange.to, (v, p) => {
          const y = p + v.nodeSize - 2, k = h.oldRange.from <= p && y <= h.oldRange.to;
          this.editor.emit("delete", {
            type: "node",
            node: v,
            from: p,
            to: y,
            newFrom: c.mapping.map(p),
            newTo: c.mapping.map(y),
            deletedRange: h.oldRange,
            newRange: h.newRange,
            partial: !k,
            editor: this.editor,
            transaction: e,
            combinedTransform: c
          });
        });
      });
      const g = c.mapping;
      c.steps.forEach((h, v) => {
        var p, y;
        if (h instanceof ln) {
          const k = g.slice(v).map(h.from, -1), $ = g.slice(v).map(h.to), S = g.invert().map(k, -1), I = g.invert().map($), T = k > 0 ? (p = c.doc.nodeAt(k - 1)) == null ? void 0 : p.marks.some((E) => E.eq(h.mark)) : !1, A = (y = c.doc.nodeAt($)) == null ? void 0 : y.marks.some((E) => E.eq(h.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: h.mark,
            from: h.from,
            to: h.to,
            deletedRange: {
              from: S,
              to: I
            },
            newRange: {
              from: k,
              to: $
            },
            partial: !!(A || T),
            editor: this.editor,
            transaction: e,
            combinedTransform: c
          });
        }
      });
    };
    (l = (n = (t = this.editor.options.coreExtensionOptions) == null ? void 0 : t.delete) == null ? void 0 : n.async) == null || l ? setTimeout(o, 0) : o();
  }
}), Ip = Dt.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Ut({
        key: new la("tiptapDrop"),
        props: {
          handleDrop: (e, a, t, n) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: a,
              slice: t,
              moved: n
            });
          }
        }
      })
    ];
  }
}), Lp = Dt.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Ut({
        key: new la("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), Tp = new la("focusEvents"), Ep = Dt.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new Ut({
        key: Tp,
        props: {
          handleDOMEvents: {
            focus: (a, t) => {
              e.isFocused = !0;
              const n = e.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return a.dispatch(n), !1;
            },
            blur: (a, t) => {
              e.isFocused = !1;
              const n = e.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return a.dispatch(n), !1;
            }
          }
        }
      })
    ];
  }
}), Ap = Dt.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: r }) => [
      () => r.undoInputRule(),
      // maybe convert first text block node to default node
      () => r.command(({ tr: i }) => {
        const { selection: s, doc: d } = i, { empty: c, $anchor: f } = s, { pos: g, parent: h } = f, v = f.parent.isTextblock && g > 0 ? i.doc.resolve(g - 1) : f, p = v.parent.type.spec.isolating, y = f.pos - f.parentOffset, k = p && v.parent.childCount === 1 ? y === f.pos : xt.atStart(d).from === g;
        return !c || !h.type.isTextblock || h.textContent.length || !k || k && f.parent.type.name === "paragraph" ? !1 : r.clearNodes();
      }),
      () => r.deleteSelection(),
      () => r.joinBackward(),
      () => r.selectNodeBackward()
    ]), a = () => this.editor.commands.first(({ commands: r }) => [
      () => r.deleteSelection(),
      () => r.deleteCurrentNode(),
      () => r.joinForward(),
      () => r.selectNodeForward()
    ]), n = {
      Enter: () => this.editor.commands.first(({ commands: r }) => [
        () => r.newlineInCode(),
        () => r.createParagraphNear(),
        () => r.liftEmptyBlock(),
        () => r.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: a,
      "Mod-Delete": a,
      "Mod-a": () => this.editor.commands.selectAll()
    }, l = {
      ...n
    }, o = {
      ...n,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": a,
      "Ctrl-Alt-Backspace": a,
      "Alt-Delete": a,
      "Alt-d": a,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return Gi() || ip() ? o : l;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Ut({
        key: new la("clearDocument"),
        appendTransaction: (e, a, t) => {
          if (e.some((p) => p.getMeta("composition")))
            return;
          const n = e.some((p) => p.docChanged) && !a.doc.eq(t.doc), l = e.some((p) => p.getMeta("preventClearDocument"));
          if (!n || l)
            return;
          const { empty: o, from: r, to: i } = a.selection, s = xt.atStart(a.doc).from, d = xt.atEnd(a.doc).to;
          if (o || !(r === s && i === d) || !Sr(t.doc))
            return;
          const g = t.tr, h = js({
            state: t,
            transaction: g
          }), { commands: v } = new Ws({
            editor: this.editor,
            state: h
          });
          if (v.clearNodes(), !!g.steps.length)
            return g;
        }
      })
    ];
  }
}), Rp = Dt.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Ut({
        key: new la("tiptapPaste"),
        props: {
          handlePaste: (e, a, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: a,
              slice: t
            });
          }
        }
      })
    ];
  }
}), zp = Dt.create({
  name: "tabindex",
  addOptions() {
    return {
      value: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Ut({
        key: new la("tabindex"),
        props: {
          attributes: () => {
            var e;
            return !this.editor.isEditable && this.options.value === void 0 ? {} : { tabindex: (e = this.options.value) != null ? e : "0" };
          }
        }
      })
    ];
  }
}), Dp = Dt.create({
  name: "textDirection",
  addOptions() {
    return {
      direction: void 0
    };
  },
  addGlobalAttributes() {
    if (!this.options.direction)
      return [];
    const { nodeExtensions: e } = po(this.extensions);
    return [
      {
        types: e.filter((a) => a.name !== "text").map((a) => a.name),
        attributes: {
          dir: {
            default: this.options.direction,
            parseHTML: (a) => {
              const t = a.getAttribute("dir");
              return t && (t === "ltr" || t === "rtl" || t === "auto") ? t : this.options.direction;
            },
            renderHTML: (a) => a.dir ? {
              dir: a.dir
            } : {}
          }
        }
      }
    ];
  },
  addProseMirrorPlugins() {
    return [
      new Ut({
        key: new la("textDirection"),
        props: {
          attributes: () => {
            const e = this.options.direction;
            return e ? {
              dir: e
            } : {};
          }
        }
      })
    ];
  }
}), NA = class qo {
  constructor(a, t, n = !1, l = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = n, this.resolvedPos = a, this.editor = t, this.currentNode = l;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var a;
    return (a = this.actualDepth) != null ? a : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(a) {
    let t = this.from, n = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, n = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: n }, a);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const a = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(a);
    return new qo(t, this.editor);
  }
  get before() {
    let a = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return a.depth !== this.depth && (a = this.resolvedPos.doc.resolve(this.from - 3)), new qo(a, this.editor);
  }
  get after() {
    let a = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return a.depth !== this.depth && (a = this.resolvedPos.doc.resolve(this.to + 3)), new qo(a, this.editor);
  }
  get children() {
    const a = [];
    return this.node.content.forEach((t, n) => {
      const l = t.isBlock && !t.isTextblock, o = t.isAtom && !t.isText, r = t.isInline, i = this.pos + n + (o ? 0 : 1);
      if (i < 0 || i > this.resolvedPos.doc.nodeSize - 2)
        return;
      const s = this.resolvedPos.doc.resolve(i);
      if (!l && !r && s.depth <= this.depth)
        return;
      const d = new qo(s, this.editor, l, l || r ? t : null);
      l && (d.actualDepth = this.depth + 1), a.push(d);
    }), a;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const a = this.children;
    return a[a.length - 1] || null;
  }
  closest(a, t = {}) {
    let n = null, l = this.parent;
    for (; l && !n; ) {
      if (l.node.type.name === a)
        if (Object.keys(t).length > 0) {
          const o = l.node.attrs, r = Object.keys(t);
          for (let i = 0; i < r.length; i += 1) {
            const s = r[i];
            if (o[s] !== t[s])
              break;
          }
        } else
          n = l;
      l = l.parent;
    }
    return n;
  }
  querySelector(a, t = {}) {
    return this.querySelectorAll(a, t, !0)[0] || null;
  }
  querySelectorAll(a, t = {}, n = !1) {
    let l = [];
    if (!this.children || this.children.length === 0)
      return l;
    const o = Object.keys(t);
    return this.children.forEach((r) => {
      n && l.length > 0 || (r.node.type.name === a && o.every((s) => t[s] === r.node.attrs[s]) && l.push(r), !(n && l.length > 0) && (l = l.concat(r.querySelectorAll(a, t, n))));
    }), l;
  }
  setAttribute(a) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...a
    }), this.editor.view.dispatch(t);
  }
}, VA = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}`;
function HA(e, a, t) {
  const n = document.querySelector("style[data-tiptap-style]");
  if (n !== null)
    return n;
  const l = document.createElement("style");
  return a && l.setAttribute("nonce", a), l.setAttribute("data-tiptap-style", ""), l.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(l), l;
}
var jA = class extends TA {
  constructor(a = {}) {
    super(), this.css = null, this.className = "tiptap", this.editorView = null, this.isFocused = !1, this.destroyed = !1, this.isInitialized = !1, this.extensionStorage = {}, this.instanceId = Math.random().toString(36).slice(2, 9), this.options = {
      element: typeof document < "u" ? document.createElement("div") : null,
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      textDirection: void 0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onMount: () => null,
      onUnmount: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: l }) => {
        throw l;
      },
      onPaste: () => null,
      onDrop: () => null,
      onDelete: () => null,
      enableExtensionDispatchTransaction: !0
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.utils = {
      getUpdatedPosition: lA,
      createMappablePosition: oA
    }, this.setOptions(a), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("mount", this.options.onMount), this.on("unmount", this.options.onUnmount), this.on("contentError", this.options.onContentError), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: l, slice: o, moved: r }) => this.options.onDrop(l, o, r)), this.on("paste", ({ event: l, slice: o }) => this.options.onPaste(l, o)), this.on("delete", this.options.onDelete);
    const t = this.createDoc(), n = op(t, this.options.autofocus);
    this.editorState = _l.create({
      doc: t,
      schema: this.schema,
      selection: n || void 0
    }), this.options.element && this.mount(this.options.element);
  }
  /**
   * Attach the editor to the DOM, creating a new editor view.
   */
  mount(a) {
    if (typeof document > "u")
      throw new Error(
        "[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment."
      );
    this.createView(a), this.emit("mount", { editor: this }), this.css && !document.head.contains(this.css) && document.head.appendChild(this.css), window.setTimeout(() => {
      this.isDestroyed || (this.options.autofocus !== !1 && this.options.autofocus !== null && this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Remove the editor from the DOM, but still allow remounting at a different point in time
   */
  unmount() {
    if (this.editorView) {
      const a = this.editorView.dom;
      a != null && a.editor && delete a.editor, this.editorView.destroy();
    }
    if (this.editorView = null, this.isInitialized = !1, this.css && !document.querySelectorAll(`.${this.className}`).length)
      try {
        typeof this.css.remove == "function" ? this.css.remove() : this.css.parentNode && this.css.parentNode.removeChild(this.css);
      } catch (a) {
        console.warn("Failed to remove CSS element:", a);
      }
    this.css = null, this.emit("unmount", { editor: this });
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && typeof document < "u" && (this.css = HA(VA, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(a = {}) {
    this.options = {
      ...this.options,
      ...a
    }, !(!this.editorView || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(a, t = !0) {
    this.setOptions({ editable: a }), t && this.emit("update", { editor: this, transaction: this.state.tr, appendedTransactions: [] });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor view.
   */
  get view() {
    return this.editorView ? this.editorView : new Proxy(
      {
        state: this.editorState,
        updateState: (a) => {
          this.editorState = a;
        },
        dispatch: (a) => {
          this.dispatchTransaction(a);
        },
        // Stub some commonly accessed properties to prevent errors
        composing: !1,
        dragging: null,
        editable: !0,
        isDestroyed: !1
      },
      {
        get: (a, t) => {
          if (this.editorView)
            return this.editorView[t];
          if (t === "state")
            return this.editorState;
          if (t in a)
            return Reflect.get(a, t);
          throw new Error(
            `[tiptap error]: The editor view is not available. Cannot access view['${t}']. The editor may not be mounted yet.`
          );
        }
      }
    );
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.editorView && (this.editorState = this.view.state), this.editorState;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(a, t) {
    const n = up(t) ? t(a, [...this.state.plugins]) : [...this.state.plugins, a], l = this.state.reconfigure({ plugins: n });
    return this.view.updateState(l), l;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(a) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let n = t;
    if ([].concat(a).forEach((o) => {
      const r = typeof o == "string" ? `${o}$` : o.key;
      n = n.filter((i) => !i.key.startsWith(r));
    }), t.length === n.length)
      return;
    const l = this.state.reconfigure({
      plugins: n
    });
    return this.view.updateState(l), l;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var a, t, n, l;
    const r = [...this.options.enableCoreExtensions ? [
      Lp,
      Cp.configure({
        blockSeparator: (t = (a = this.options.coreExtensionOptions) == null ? void 0 : a.clipboardTextSerializer) == null ? void 0 : t.blockSeparator
      }),
      Sp,
      Ep,
      Ap,
      zp.configure({
        value: (l = (n = this.options.coreExtensionOptions) == null ? void 0 : n.tabindex) == null ? void 0 : l.value
      }),
      Ip,
      Rp,
      $p,
      Dp.configure({
        direction: this.options.textDirection
      })
    ].filter((i) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[i.name] !== !1 : !0) : [], ...this.options.extensions].filter((i) => ["extension", "node", "mark"].includes(i == null ? void 0 : i.type));
    this.extensionManager = new Ks(r, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new Ws({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates the initial document.
   */
  createDoc() {
    let a;
    try {
      a = Ru(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: this.options.enableContentCheck
      });
    } catch (t) {
      if (!(t instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(t.message))
        throw t;
      this.emit("contentError", {
        editor: this,
        error: t,
        disableCollaboration: () => {
          "collaboration" in this.storage && typeof this.storage.collaboration == "object" && this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((n) => n.name !== "collaboration"), this.createExtensionManager();
        }
      }), a = Ru(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: !1
      });
    }
    return a;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView(a) {
    const { editorProps: t, enableExtensionDispatchTransaction: n } = this.options, l = t.dispatchTransaction || this.dispatchTransaction.bind(this), o = n ? this.extensionManager.dispatchTransaction(l) : l, r = t.transformPastedHTML, i = this.extensionManager.transformPastedHTML(r);
    this.editorView = new ep(a, {
      ...t,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...t == null ? void 0 : t.attributes
      },
      dispatchTransaction: o,
      transformPastedHTML: i,
      state: this.editorState,
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
    const s = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(s), this.prependClass(), this.injectCSS();
    const d = this.view.dom;
    d.editor = this;
  }
  /**
   * Creates all node and mark views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `${this.className} ${this.view.dom.className}`;
  }
  captureTransaction(a) {
    this.isCapturingTransaction = !0, a(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(a) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = a;
        return;
      }
      a.steps.forEach((c) => {
        var f;
        return (f = this.capturedTransaction) == null ? void 0 : f.step(c);
      });
      return;
    }
    const { state: t, transactions: n } = this.state.applyTransaction(a), l = !this.state.selection.eq(t.selection), o = n.includes(a), r = this.state;
    if (this.emit("beforeTransaction", {
      editor: this,
      transaction: a,
      nextState: t
    }), !o)
      return;
    this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: a,
      appendedTransactions: n.slice(1)
    }), l && this.emit("selectionUpdate", {
      editor: this,
      transaction: a
    });
    const i = n.findLast((c) => c.getMeta("focus") || c.getMeta("blur")), s = i == null ? void 0 : i.getMeta("focus"), d = i == null ? void 0 : i.getMeta("blur");
    s && this.emit("focus", {
      editor: this,
      event: s.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: i
    }), d && this.emit("blur", {
      editor: this,
      event: d.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: i
    }), !(a.getMeta("preventUpdate") || !n.some((c) => c.docChanged) || r.doc.eq(t.doc)) && this.emit("update", {
      editor: this,
      transaction: a,
      appendedTransactions: n.slice(1)
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(a) {
    return gp(this.state, a);
  }
  isActive(a, t) {
    const n = typeof a == "string" ? a : null, l = typeof a == "string" ? t : a;
    return tA(this.state, n, l);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return Xc(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(a) {
    const { blockSeparator: t = `

`, textSerializers: n = {} } = a || {};
    return JE(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...bp(this.schema),
        ...n
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Sr(this.state.doc);
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.destroyed || (this.destroyed = !0, this.emit("destroy"), this.unmount(), this.removeAllListeners(), this.extensionManager.destroy(), this.extensionManager = null, this.schema = null, this.commandManager = null, this.extensionStorage = {});
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var a, t;
    return (t = (a = this.editorView) == null ? void 0 : a.isDestroyed) != null ? t : !0;
  }
  $node(a, t) {
    var n;
    return ((n = this.$doc) == null ? void 0 : n.querySelector(a, t)) || null;
  }
  $nodes(a, t) {
    var n;
    return ((n = this.$doc) == null ? void 0 : n.querySelectorAll(a, t)) || null;
  }
  $pos(a) {
    const t = this.state.doc.resolve(a), n = a > 0 && t.nodeAfter && !t.nodeAfter.isText ? t.nodeAfter : null;
    return new NA(t, this, !1, n);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function Nl(e) {
  return new Gs({
    find: e.find,
    handler: ({ state: a, range: t, match: n }) => {
      const l = Et(e.getAttributes, void 0, n);
      if (l === !1 || l === null)
        return null;
      const { tr: o } = a, r = n[n.length - 1], i = n[0];
      if (r) {
        const s = i.search(/\S/), d = t.from + i.indexOf(r), c = d + r.length;
        if (Zc(t.from, t.to, a.doc).filter((h) => h.mark.type.excluded.find((p) => p === e.type && p !== h.mark.type)).filter((h) => h.to > d).length)
          return null;
        c < t.to && o.delete(c, t.to), d > t.from && o.delete(t.from + s, d);
        const g = t.from + s + r.length;
        o.addMark(t.from + s, g, e.type.create(l || {})), o.removeStoredMark(e.type);
      }
    },
    undoable: e.undoable
  });
}
function Bp(e) {
  return new Gs({
    find: e.find,
    handler: ({ state: a, range: t, match: n }) => {
      const l = Et(e.getAttributes, void 0, n) || {}, { tr: o } = a, r = t.from;
      let i = t.to;
      const s = e.type.create(l);
      if (n[1]) {
        const d = n[0].lastIndexOf(n[1]);
        let c = r + d;
        c > i ? c = i : i = c + n[1].length;
        const f = n[0][n[0].length - 1];
        o.insertText(f, r + n[0].length - 1), o.replaceWith(c, i, s);
      } else if (n[0]) {
        const d = e.type.isInline ? r : r - 1;
        o.insert(d, e.type.create(l)).delete(o.mapping.map(r), o.mapping.map(i));
      }
      o.scrollIntoView();
    },
    undoable: e.undoable
  });
}
function Du(e) {
  return new Gs({
    find: e.find,
    handler: ({ state: a, range: t, match: n }) => {
      const l = a.doc.resolve(t.from), o = Et(e.getAttributes, void 0, n) || {};
      if (!l.node(-1).canReplaceWith(l.index(-1), l.indexAfter(-1), e.type))
        return null;
      a.tr.delete(t.from, t.to).setBlockType(t.from, t.from, e.type, o);
    },
    undoable: e.undoable
  });
}
function xo(e) {
  return new Gs({
    find: e.find,
    handler: ({ state: a, range: t, match: n, chain: l }) => {
      const o = Et(e.getAttributes, void 0, n) || {}, r = a.tr.delete(t.from, t.to), s = r.doc.resolve(t.from).blockRange(), d = s && Rc(s, e.type, o);
      if (!d)
        return null;
      if (r.wrap(s, d), e.keepMarks && e.editor) {
        const { selection: f, storedMarks: g } = a, { splittableMarks: h } = e.editor.extensionManager, v = g || f.$to.parentOffset && f.$from.marks();
        if (v) {
          const p = v.filter((y) => h.includes(y.type.name));
          r.ensureMarks(p);
        }
      }
      if (e.keepAttributes) {
        const f = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
        l().updateAttributes(f, o).run();
      }
      const c = r.doc.resolve(t.from - 1).nodeBefore;
      c && c.type === e.type && bl(r.doc, t.from - 1) && (!e.joinPredicate || e.joinPredicate(n, c)) && r.join(t.from - 1);
    },
    undoable: e.undoable
  });
}
var WA = (e) => "touches" in e, qA = class {
  /**
   * Creates a new ResizableNodeView instance.
   *
   * The constructor sets up the resize handles, applies initial sizing from
   * node attributes, and configures all resize behavior options.
   *
   * @param options - Configuration options for the resizable node view
   */
  constructor(e) {
    this.directions = ["bottom-left", "bottom-right", "top-left", "top-right"], this.minSize = {
      height: 8,
      width: 8
    }, this.preserveAspectRatio = !1, this.classNames = {
      container: "",
      wrapper: "",
      handle: "",
      resizing: ""
    }, this.initialWidth = 0, this.initialHeight = 0, this.aspectRatio = 1, this.isResizing = !1, this.activeHandle = null, this.startX = 0, this.startY = 0, this.startWidth = 0, this.startHeight = 0, this.isShiftKeyPressed = !1, this.lastEditableState = void 0, this.handleMap = /* @__PURE__ */ new Map(), this.handleMouseMove = (i) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const s = i.clientX - this.startX, d = i.clientY - this.startY;
      this.handleResize(s, d);
    }, this.handleTouchMove = (i) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const s = i.touches[0];
      if (!s)
        return;
      const d = s.clientX - this.startX, c = s.clientY - this.startY;
      this.handleResize(d, c);
    }, this.handleMouseUp = () => {
      if (!this.isResizing)
        return;
      const i = this.element.offsetWidth, s = this.element.offsetHeight;
      this.onCommit(i, s), this.isResizing = !1, this.activeHandle = null, this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
    }, this.handleKeyDown = (i) => {
      i.key === "Shift" && (this.isShiftKeyPressed = !0);
    }, this.handleKeyUp = (i) => {
      i.key === "Shift" && (this.isShiftKeyPressed = !1);
    };
    var a, t, n, l, o, r;
    this.node = e.node, this.editor = e.editor, this.element = e.element, this.contentElement = e.contentElement, this.getPos = e.getPos, this.onResize = e.onResize, this.onCommit = e.onCommit, this.onUpdate = e.onUpdate, (a = e.options) != null && a.min && (this.minSize = {
      ...this.minSize,
      ...e.options.min
    }), (t = e.options) != null && t.max && (this.maxSize = e.options.max), (n = e == null ? void 0 : e.options) != null && n.directions && (this.directions = e.options.directions), (l = e.options) != null && l.preserveAspectRatio && (this.preserveAspectRatio = e.options.preserveAspectRatio), (o = e.options) != null && o.className && (this.classNames = {
      container: e.options.className.container || "",
      wrapper: e.options.className.wrapper || "",
      handle: e.options.className.handle || "",
      resizing: e.options.className.resizing || ""
    }), (r = e.options) != null && r.createCustomHandle && (this.createCustomHandle = e.options.createCustomHandle), this.wrapper = this.createWrapper(), this.container = this.createContainer(), this.applyInitialSize(), this.attachHandles(), this.editor.on("update", this.handleEditorUpdate.bind(this));
  }
  /**
   * Returns the top-level DOM node that should be placed in the editor.
   *
   * This is required by the ProseMirror NodeView interface. The container
   * includes the wrapper, handles, and the actual content element.
   *
   * @returns The container element to be inserted into the editor
   */
  get dom() {
    return this.container;
  }
  get contentDOM() {
    var e;
    return (e = this.contentElement) != null ? e : null;
  }
  handleEditorUpdate() {
    const e = this.editor.isEditable;
    e !== this.lastEditableState && (this.lastEditableState = e, e ? e && this.handleMap.size === 0 && this.attachHandles() : this.removeHandles());
  }
  /**
   * Called when the node's content or attributes change.
   *
   * Updates the internal node reference. If a custom `onUpdate` callback
   * was provided, it will be called to handle additional update logic.
   *
   * @param node - The new/updated node
   * @param decorations - Node decorations
   * @param innerDecorations - Inner decorations
   * @returns `false` if the node type has changed (requires full rebuild), otherwise the result of `onUpdate` or `true`
   */
  update(e, a, t) {
    return e.type !== this.node.type ? !1 : (this.node = e, this.onUpdate ? this.onUpdate(e, a, t) : !0);
  }
  /**
   * Cleanup method called when the node view is being removed.
   *
   * Removes all event listeners to prevent memory leaks. This is required
   * by the ProseMirror NodeView interface. If a resize is active when
   * destroy is called, it will be properly cancelled.
   */
  destroy() {
    this.isResizing && (this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp), this.isResizing = !1, this.activeHandle = null), this.editor.off("update", this.handleEditorUpdate.bind(this)), this.container.remove();
  }
  /**
   * Creates the outer container element.
   *
   * The container is the top-level element returned by the NodeView and
   * wraps the entire resizable node. It's set up with flexbox to handle
   * alignment and includes data attributes for styling and identification.
   *
   * @returns The container element
   */
  createContainer() {
    const e = document.createElement("div");
    return e.dataset.resizeContainer = "", e.dataset.node = this.node.type.name, e.style.display = this.node.type.isInline ? "inline-flex" : "flex", this.classNames.container && (e.className = this.classNames.container), e.appendChild(this.wrapper), e;
  }
  /**
   * Creates the wrapper element that contains the content and handles.
   *
   * The wrapper uses relative positioning so that resize handles can be
   * positioned absolutely within it. This is the direct parent of the
   * content element being made resizable.
   *
   * @returns The wrapper element
   */
  createWrapper() {
    const e = document.createElement("div");
    return e.style.position = "relative", e.style.display = "block", e.dataset.resizeWrapper = "", this.classNames.wrapper && (e.className = this.classNames.wrapper), e.appendChild(this.element), e;
  }
  /**
   * Creates a resize handle element for a specific direction.
   *
   * Each handle is absolutely positioned and includes a data attribute
   * identifying its direction for styling purposes.
   *
   * @param direction - The resize direction for this handle
   * @returns The handle element
   */
  createHandle(e) {
    const a = document.createElement("div");
    return a.dataset.resizeHandle = e, a.style.position = "absolute", this.classNames.handle && (a.className = this.classNames.handle), a;
  }
  /**
   * Positions a handle element according to its direction.
   *
   * Corner handles (e.g., 'top-left') are positioned at the intersection
   * of two edges. Edge handles (e.g., 'top') span the full width or height.
   *
   * @param handle - The handle element to position
   * @param direction - The direction determining the position
   */
  positionHandle(e, a) {
    const t = a.includes("top"), n = a.includes("bottom"), l = a.includes("left"), o = a.includes("right");
    t && (e.style.top = "0"), n && (e.style.bottom = "0"), l && (e.style.left = "0"), o && (e.style.right = "0"), (a === "top" || a === "bottom") && (e.style.left = "0", e.style.right = "0"), (a === "left" || a === "right") && (e.style.top = "0", e.style.bottom = "0");
  }
  /**
   * Creates and attaches all resize handles to the wrapper.
   *
   * Iterates through the configured directions, creates a handle for each,
   * positions it, attaches the mousedown listener, and appends it to the DOM.
   */
  attachHandles() {
    this.directions.forEach((e) => {
      let a;
      this.createCustomHandle ? a = this.createCustomHandle(e) : a = this.createHandle(e), a instanceof HTMLElement || (console.warn(
        `[ResizableNodeView] createCustomHandle("${e}") did not return an HTMLElement. Falling back to default handle.`
      ), a = this.createHandle(e)), this.createCustomHandle || this.positionHandle(a, e), a.addEventListener("mousedown", (t) => this.handleResizeStart(t, e)), a.addEventListener("touchstart", (t) => this.handleResizeStart(t, e)), this.handleMap.set(e, a), this.wrapper.appendChild(a);
    });
  }
  /**
   * Removes all resize handles from the wrapper.
   *
   * Cleans up the handle map and removes each handle element from the DOM.
   */
  removeHandles() {
    this.handleMap.forEach((e) => e.remove()), this.handleMap.clear();
  }
  /**
   * Applies initial sizing from node attributes to the element.
   *
   * If width/height attributes exist on the node, they're applied to the element.
   * Otherwise, the element's natural/current dimensions are measured. The aspect
   * ratio is calculated for later use in aspect-ratio-preserving resizes.
   */
  applyInitialSize() {
    const e = this.node.attrs.width, a = this.node.attrs.height;
    e ? (this.element.style.width = `${e}px`, this.initialWidth = e) : this.initialWidth = this.element.offsetWidth, a ? (this.element.style.height = `${a}px`, this.initialHeight = a) : this.initialHeight = this.element.offsetHeight, this.initialWidth > 0 && this.initialHeight > 0 && (this.aspectRatio = this.initialWidth / this.initialHeight);
  }
  /**
   * Initiates a resize operation when a handle is clicked.
   *
   * Captures the starting mouse position and element dimensions, sets up
   * the resize state, adds the resizing class and state attribute, and
   * attaches document-level listeners for mouse movement and keyboard input.
   *
   * @param event - The mouse down event
   * @param direction - The direction of the handle being dragged
   */
  handleResizeStart(e, a) {
    e.preventDefault(), e.stopPropagation(), this.isResizing = !0, this.activeHandle = a, WA(e) ? (this.startX = e.touches[0].clientX, this.startY = e.touches[0].clientY) : (this.startX = e.clientX, this.startY = e.clientY), this.startWidth = this.element.offsetWidth, this.startHeight = this.element.offsetHeight, this.startWidth > 0 && this.startHeight > 0 && (this.aspectRatio = this.startWidth / this.startHeight), this.getPos(), this.container.dataset.resizeState = "true", this.classNames.resizing && this.container.classList.add(this.classNames.resizing), document.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("touchmove", this.handleTouchMove), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
  }
  handleResize(e, a) {
    if (!this.activeHandle)
      return;
    const t = this.preserveAspectRatio || this.isShiftKeyPressed, { width: n, height: l } = this.calculateNewDimensions(this.activeHandle, e, a), o = this.applyConstraints(n, l, t);
    this.element.style.width = `${o.width}px`, this.element.style.height = `${o.height}px`, this.onResize && this.onResize(o.width, o.height);
  }
  /**
   * Calculates new dimensions based on mouse delta and resize direction.
   *
   * Takes the starting dimensions and applies the mouse movement delta
   * according to the handle direction. For corner handles, both dimensions
   * are affected. For edge handles, only one dimension changes. If aspect
   * ratio should be preserved, delegates to applyAspectRatio.
   *
   * @param direction - The active resize handle direction
   * @param deltaX - Horizontal mouse movement since resize start
   * @param deltaY - Vertical mouse movement since resize start
   * @returns The calculated width and height
   */
  calculateNewDimensions(e, a, t) {
    let n = this.startWidth, l = this.startHeight;
    const o = e.includes("right"), r = e.includes("left"), i = e.includes("bottom"), s = e.includes("top");
    return o ? n = this.startWidth + a : r && (n = this.startWidth - a), i ? l = this.startHeight + t : s && (l = this.startHeight - t), (e === "right" || e === "left") && (n = this.startWidth + (o ? a : -a)), (e === "top" || e === "bottom") && (l = this.startHeight + (i ? t : -t)), this.preserveAspectRatio || this.isShiftKeyPressed ? this.applyAspectRatio(n, l, e) : { width: n, height: l };
  }
  /**
   * Applies min/max constraints to dimensions.
   *
   * When aspect ratio is NOT preserved, constraints are applied independently
   * to width and height. When aspect ratio IS preserved, constraints are
   * applied while maintaining the aspect ratio—if one dimension hits a limit,
   * the other is recalculated proportionally.
   *
   * This ensures that aspect ratio is never broken when constrained.
   *
   * @param width - The unconstrained width
   * @param height - The unconstrained height
   * @param preserveAspectRatio - Whether to maintain aspect ratio while constraining
   * @returns The constrained dimensions
   */
  applyConstraints(e, a, t) {
    var n, l, o, r;
    if (!t) {
      let d = Math.max(this.minSize.width, e), c = Math.max(this.minSize.height, a);
      return (n = this.maxSize) != null && n.width && (d = Math.min(this.maxSize.width, d)), (l = this.maxSize) != null && l.height && (c = Math.min(this.maxSize.height, c)), { width: d, height: c };
    }
    let i = e, s = a;
    return i < this.minSize.width && (i = this.minSize.width, s = i / this.aspectRatio), s < this.minSize.height && (s = this.minSize.height, i = s * this.aspectRatio), (o = this.maxSize) != null && o.width && i > this.maxSize.width && (i = this.maxSize.width, s = i / this.aspectRatio), (r = this.maxSize) != null && r.height && s > this.maxSize.height && (s = this.maxSize.height, i = s * this.aspectRatio), { width: i, height: s };
  }
  /**
   * Adjusts dimensions to maintain the original aspect ratio.
   *
   * For horizontal handles (left/right), uses width as the primary dimension
   * and calculates height from it. For vertical handles (top/bottom), uses
   * height as primary and calculates width. For corner handles, uses width
   * as the primary dimension.
   *
   * @param width - The new width
   * @param height - The new height
   * @param direction - The active resize direction
   * @returns Dimensions adjusted to preserve aspect ratio
   */
  applyAspectRatio(e, a, t) {
    const n = t === "left" || t === "right", l = t === "top" || t === "bottom";
    return n ? {
      width: e,
      height: e / this.aspectRatio
    } : l ? {
      width: a * this.aspectRatio,
      height: a
    } : {
      width: e,
      height: e / this.aspectRatio
    };
  }
};
function UA(e, a) {
  const { selection: t } = e, { $from: n } = t;
  if (t instanceof dt) {
    const o = n.index();
    return n.parent.canReplaceWith(o, o + 1, a);
  }
  let l = n.depth;
  for (; l >= 0; ) {
    const o = n.index(l);
    if (n.node(l).contentMatchAt(o).matchType(a))
      return !0;
    l -= 1;
  }
  return !1;
}
function Io(e, a) {
  const t = e.getAttribute("style");
  if (!t)
    return null;
  const n = t.split(";").map((o) => o.trim()).filter(Boolean), l = a.toLowerCase();
  for (let o = n.length - 1; o >= 0; o -= 1) {
    const r = n[o], i = r.indexOf(":");
    if (i === -1)
      continue;
    if (r.slice(0, i).trim().toLowerCase() === l)
      return r.slice(i + 1).trim();
  }
  return null;
}
var GA = {};
Gc(GA, {
  createAtomBlockMarkdownSpec: () => KA,
  createBlockMarkdownSpec: () => YA,
  createInlineMarkdownSpec: () => ZA,
  parseAttributes: () => _c,
  parseIndentedBlocks: () => Bu,
  renderNestedMarkdownContent: () => tf,
  serializeAttributes: () => ef
});
function _c(e) {
  if (!(e != null && e.trim()))
    return {};
  const a = {}, t = [], n = e.replace(/["']([^"']*)["']/g, (d) => (t.push(d), `__QUOTED_${t.length - 1}__`)), l = n.match(/(?:^|\s)\.([a-zA-Z][\w-]*)/g);
  if (l) {
    const d = l.map((c) => c.trim().slice(1));
    a.class = d.join(" ");
  }
  const o = n.match(/(?:^|\s)#([a-zA-Z][\w-]*)/);
  o && (a.id = o[1]);
  const r = /([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g;
  Array.from(n.matchAll(r)).forEach(([, d, c]) => {
    var f;
    const g = parseInt(((f = c.match(/__QUOTED_(\d+)__/)) == null ? void 0 : f[1]) || "0", 10), h = t[g];
    h && (a[d] = h.slice(1, -1));
  });
  const s = n.replace(/(?:^|\s)\.([a-zA-Z][\w-]*)/g, "").replace(/(?:^|\s)#([a-zA-Z][\w-]*)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
  return s && s.split(/\s+/).filter(Boolean).forEach((c) => {
    c.match(/^[a-zA-Z][\w-]*$/) && (a[c] = !0);
  }), a;
}
function ef(e) {
  if (!e || Object.keys(e).length === 0)
    return "";
  const a = [];
  return e.class && String(e.class).split(/\s+/).filter(Boolean).forEach((n) => a.push(`.${n}`)), e.id && a.push(`#${e.id}`), Object.entries(e).forEach(([t, n]) => {
    t === "class" || t === "id" || (n === !0 ? a.push(t) : n !== !1 && n != null && a.push(`${t}="${String(n)}"`));
  }), a.join(" ");
}
function KA(e) {
  const {
    nodeName: a,
    name: t,
    parseAttributes: n = _c,
    serializeAttributes: l = ef,
    defaultAttributes: o = {},
    requiredAttributes: r = [],
    allowedAttributes: i
  } = e, s = t || a, d = (c) => {
    if (!i)
      return c;
    const f = {};
    return i.forEach((g) => {
      g in c && (f[g] = c[g]);
    }), f;
  };
  return {
    parseMarkdown: (c, f) => {
      const g = { ...o, ...c.attributes };
      return f.createNode(a, g, []);
    },
    markdownTokenizer: {
      name: a,
      level: "block",
      start(c) {
        var f;
        const g = new RegExp(`^:::${s}(?:\\s|$)`, "m"), h = (f = c.match(g)) == null ? void 0 : f.index;
        return h !== void 0 ? h : -1;
      },
      tokenize(c, f, g) {
        const h = new RegExp(`^:::${s}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`), v = c.match(h);
        if (!v)
          return;
        const p = v[1] || "", y = n(p);
        if (!r.find(($) => !($ in y)))
          return {
            type: a,
            raw: v[0],
            attributes: y
          };
      }
    },
    renderMarkdown: (c) => {
      const f = d(c.attrs || {}), g = l(f), h = g ? ` {${g}}` : "";
      return `:::${s}${h} :::`;
    }
  };
}
function YA(e) {
  const {
    nodeName: a,
    name: t,
    getContent: n,
    parseAttributes: l = _c,
    serializeAttributes: o = ef,
    defaultAttributes: r = {},
    content: i = "block",
    allowedAttributes: s
  } = e, d = t || a, c = (f) => {
    if (!s)
      return f;
    const g = {};
    return s.forEach((h) => {
      h in f && (g[h] = f[h]);
    }), g;
  };
  return {
    parseMarkdown: (f, g) => {
      let h;
      if (n) {
        const p = n(f);
        h = typeof p == "string" ? [{ type: "text", text: p }] : p;
      } else i === "block" ? h = g.parseChildren(f.tokens || []) : h = g.parseInline(f.tokens || []);
      const v = { ...r, ...f.attributes };
      return g.createNode(a, v, h);
    },
    markdownTokenizer: {
      name: a,
      level: "block",
      start(f) {
        var g;
        const h = new RegExp(`^:::${d}`, "m"), v = (g = f.match(h)) == null ? void 0 : g.index;
        return v !== void 0 ? v : -1;
      },
      tokenize(f, g, h) {
        var v;
        const p = new RegExp(`^:::${d}(?:\\s+\\{([^}]*)\\})?\\s*\\n`), y = f.match(p);
        if (!y)
          return;
        const [k, $ = ""] = y, S = l($);
        let I = 1;
        const T = k.length;
        let A = "";
        const E = /^:::([\w-]*)(\s.*)?/gm, z = f.slice(T);
        for (E.lastIndex = 0; ; ) {
          const B = E.exec(z);
          if (B === null)
            break;
          const W = B.index, _ = B[1];
          if (!((v = B[2]) != null && v.endsWith(":::"))) {
            if (_)
              I += 1;
            else if (I -= 1, I === 0) {
              const Z = z.slice(0, W);
              A = Z.trim();
              const le = f.slice(0, T + W + B[0].length);
              let D = [];
              if (A)
                if (i === "block")
                  for (D = h.blockTokens(Z), D.forEach((O) => {
                    O.text && (!O.tokens || O.tokens.length === 0) && (O.tokens = h.inlineTokens(O.text));
                  }); D.length > 0; ) {
                    const O = D[D.length - 1];
                    if (O.type === "paragraph" && (!O.text || O.text.trim() === ""))
                      D.pop();
                    else
                      break;
                  }
                else
                  D = h.inlineTokens(A);
              return {
                type: a,
                raw: le,
                attributes: S,
                content: A,
                tokens: D
              };
            }
          }
        }
      }
    },
    renderMarkdown: (f, g) => {
      const h = c(f.attrs || {}), v = o(h), p = v ? ` {${v}}` : "", y = g.renderChildren(f.content || [], `

`);
      return `:::${d}${p}

${y}

:::`;
    }
  };
}
function JA(e) {
  if (!e.trim())
    return {};
  const a = {}, t = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
  let n = t.exec(e);
  for (; n !== null; ) {
    const [, l, o, r] = n;
    a[l] = o || r, n = t.exec(e);
  }
  return a;
}
function XA(e) {
  return Object.entries(e).filter(([, a]) => a != null).map(([a, t]) => `${a}="${t}"`).join(" ");
}
function ZA(e) {
  const {
    nodeName: a,
    name: t,
    getContent: n,
    parseAttributes: l = JA,
    serializeAttributes: o = XA,
    defaultAttributes: r = {},
    selfClosing: i = !1,
    allowedAttributes: s
  } = e, d = t || a, c = (g) => {
    if (!s)
      return g;
    const h = {};
    return s.forEach((v) => {
      const p = typeof v == "string" ? v : v.name, y = typeof v == "string" ? void 0 : v.skipIfDefault;
      if (p in g) {
        const k = g[p];
        if (y !== void 0 && k === y)
          return;
        h[p] = k;
      }
    }), h;
  }, f = d.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return {
    parseMarkdown: (g, h) => {
      const v = { ...r, ...g.attributes };
      if (i)
        return h.createNode(a, v);
      const p = n ? n(g) : g.content || "";
      return p ? h.createNode(a, v, [h.createTextNode(p)]) : h.createNode(a, v, []);
    },
    markdownTokenizer: {
      name: a,
      level: "inline",
      start(g) {
        const h = i ? new RegExp(`\\[${f}\\s*[^\\]]*\\]`) : new RegExp(`\\[${f}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${f}\\]`), v = g.match(h), p = v == null ? void 0 : v.index;
        return p !== void 0 ? p : -1;
      },
      tokenize(g, h, v) {
        const p = i ? new RegExp(`^\\[${f}\\s*([^\\]]*)\\]`) : new RegExp(`^\\[${f}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${f}\\]`), y = g.match(p);
        if (!y)
          return;
        let k = "", $ = "";
        if (i) {
          const [, I] = y;
          $ = I;
        } else {
          const [, I, T] = y;
          $ = I, k = T || "";
        }
        const S = l($.trim());
        return {
          type: a,
          raw: y[0],
          content: k.trim(),
          attributes: S
        };
      }
    },
    renderMarkdown: (g) => {
      let h = "";
      n ? h = n(g) : g.content && g.content.length > 0 && (h = g.content.filter((k) => k.type === "text").map((k) => k.text).join(""));
      const v = c(g.attrs || {}), p = o(v), y = p ? ` ${p}` : "";
      return i ? `[${d}${y}]` : `[${d}${y}]${h}[/${d}]`;
    }
  };
}
function Bu(e, a, t) {
  var n, l, o, r;
  const i = e.split(`
`), s = [];
  let d = "", c = 0;
  const f = a.baseIndentSize || 2;
  for (; c < i.length; ) {
    const g = i[c], h = g.match(a.itemPattern);
    if (!h) {
      if (s.length > 0)
        break;
      if (g.trim() === "") {
        c += 1, d = `${d}${g}
`;
        continue;
      } else
        return;
    }
    const v = a.extractItemData(h), { indentLevel: p, mainContent: y } = v;
    d = `${d}${g}
`;
    const k = [y];
    for (c += 1; c < i.length; ) {
      const T = i[c];
      if (T.trim() === "") {
        const E = i.slice(c + 1).findIndex((W) => W.trim() !== "");
        if (E === -1)
          break;
        if ((((l = (n = i[c + 1 + E].match(/^(\s*)/)) == null ? void 0 : n[1]) == null ? void 0 : l.length) || 0) > p) {
          k.push(T), d = `${d}${T}
`, c += 1;
          continue;
        } else
          break;
      }
      if ((((r = (o = T.match(/^(\s*)/)) == null ? void 0 : o[1]) == null ? void 0 : r.length) || 0) > p)
        k.push(T), d = `${d}${T}
`, c += 1;
      else
        break;
    }
    let $;
    const S = k.slice(1);
    if (S.length > 0) {
      const T = S.map((A) => A.slice(p + f)).join(`
`);
      T.trim() && (a.customNestedParser ? $ = a.customNestedParser(T) : $ = t.blockTokens(T));
    }
    const I = a.createToken(v, $);
    s.push(I);
  }
  if (s.length !== 0)
    return {
      items: s,
      raw: d
    };
}
function tf(e, a, t, n) {
  if (!e || !Array.isArray(e.content))
    return "";
  const l = typeof t == "function" ? t(n) : t, [o, ...r] = e.content, i = a.renderChildren([o]);
  let s = `${l}${i}`;
  return r && r.length > 0 && r.forEach((d, c) => {
    var f, g;
    const h = (g = (f = a.renderChild) == null ? void 0 : f.call(a, d, c + 1)) != null ? g : a.renderChildren([d]);
    if (h != null) {
      const v = h.split(`
`).map((p) => p ? a.indent(p) : a.indent("")).join(`
`);
      s += d.type === "paragraph" ? `

${v}` : `
${v}`;
    }
  }), s;
}
function QA(e, a, t = {}) {
  const { state: n } = a, { doc: l, tr: o } = n, r = e;
  l.descendants((i, s) => {
    const d = o.mapping.map(s), c = o.mapping.map(s) + i.nodeSize;
    let f = null;
    if (i.marks.forEach((h) => {
      if (h !== r)
        return !1;
      f = h;
    }), !f)
      return;
    let g = !1;
    if (Object.keys(t).forEach((h) => {
      t[h] !== f.attrs[h] && (g = !0);
    }), g) {
      const h = e.type.create({
        ...e.attrs,
        ...t
      });
      o.removeMark(d, c, e.type), o.addMark(d, c, h);
    }
  }), o.docChanged && a.view.dispatch(o);
}
var za = class Mp extends Qc {
  constructor() {
    super(...arguments), this.type = "node";
  }
  /**
   * Create a new Node instance
   * @param config - Node configuration object or a function that returns a configuration object
   */
  static create(a = {}) {
    const t = typeof a == "function" ? a() : a;
    return new Mp(t);
  }
  configure(a) {
    return super.configure(a);
  }
  extend(a) {
    const t = typeof a == "function" ? a() : a;
    return super.extend(t);
  }
};
function sl(e) {
  return new DA({
    find: e.find,
    handler: ({ state: a, range: t, match: n, pasteEvent: l }) => {
      const o = Et(e.getAttributes, void 0, n, l);
      if (o === !1 || o === null)
        return null;
      const { tr: r } = a, i = n[n.length - 1], s = n[0];
      let d = t.to;
      if (i) {
        const c = s.search(/\S/), f = t.from + s.indexOf(i), g = f + i.length;
        if (Zc(t.from, t.to, a.doc).filter((p) => p.mark.type.excluded.find((k) => k === e.type && k !== p.mark.type)).filter((p) => p.to > f).length)
          return null;
        g < t.to && r.delete(g, t.to), f > t.from && r.delete(t.from + c, f), d = t.from + c + i.length, r.addMark(t.from + c, d, e.type.create(o || {})), n.index !== void 0 && n.input !== void 0 && n.index + n[0].length >= n.input.length || r.removeStoredMark(e.type);
      }
    }
  });
}
function bb(e) {
  return s0((a, t) => ({
    get() {
      return a(), e;
    },
    set(n) {
      e = n, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t();
        });
      });
    }
  }));
}
var _A = class extends jA {
  constructor(e = {}) {
    return super(e), this.contentComponent = null, this.appContext = null, this.reactiveState = bb(this.view.state), this.reactiveExtensionStorage = bb(this.extensionStorage), this.on("beforeTransaction", ({ nextState: a }) => {
      this.reactiveState.value = a, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), i0(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(e, a) {
    const t = super.registerPlugin(e, a);
    return this.reactiveState && (this.reactiveState.value = t), t;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(e) {
    const a = super.unregisterPlugin(e);
    return this.reactiveState && a && (this.reactiveState.value = a), a;
  }
}, eR = ke({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(e) {
    const a = R(), t = rc();
    return Tg(() => {
      const n = e.editor;
      n && n.options.element && a.value && Ze(() => {
        var l;
        if (!a.value || !((l = n.view.dom) != null && l.parentNode))
          return;
        const o = L(a.value);
        a.value.append(...n.view.dom.parentNode.childNodes), n.contentComponent = t.ctx._, t && (n.appContext = {
          ...t.appContext,
          // Vue internally uses prototype chain to forward/shadow injects across the entire component chain
          // so don't use object spread operator or 'Object.assign' and just set `provides` as is on editor's appContext
          // @ts-expect-error forward instance's 'provides' into appContext
          provides: t.provides
        }), n.setOptions({
          element: o
        }), n.createNodeViews();
      });
    }), Tt(() => {
      const n = e.editor;
      n && (n.contentComponent = null, n.appContext = null);
    }), { rootEl: a };
  },
  render() {
    return gn("div", {
      ref: (e) => {
        this.rootEl = e;
      }
    });
  }
});
ke({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return gn(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
ke({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var e, a;
    return gn(
      this.as,
      {
        // @ts-ignore
        class: this.decorationClasses,
        style: {
          whiteSpace: "normal"
        },
        "data-node-view-wrapper": "",
        // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
        onDragstart: this.onDragStart
      },
      (a = (e = this.$slots).default) == null ? void 0 : a.call(e)
    );
  }
});
var tR = (e = {}) => {
  const a = ko();
  return kt(() => {
    a.value = new _A(e);
  }), Tt(() => {
    var t;
    (t = a.value) == null || t.destroy();
  }), a;
};
ke({
  name: "MarkViewContent",
  props: {
    as: {
      type: String,
      default: "span"
    }
  },
  render() {
    return gn(this.as, {
      style: {
        whiteSpace: "inherit"
      },
      "data-mark-view-content": ""
    });
  }
});
var Ki = (e, a) => {
  if (e === "slot")
    return 0;
  if (e instanceof Function)
    return e(a);
  const { children: t, ...n } = a ?? {};
  if (e === "svg")
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  return [e, n, t];
}, aR = /^\s*>\s$/, nR = za.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return /* @__PURE__ */ Ki("blockquote", { ...qt(this.options.HTMLAttributes, e), children: /* @__PURE__ */ Ki("slot", {}) });
  },
  parseMarkdown: (e, a) => {
    var t;
    const n = (t = a.parseBlockChildren) != null ? t : a.parseChildren;
    return a.createNode("blockquote", void 0, n(e.tokens || []));
  },
  renderMarkdown: (e, a) => {
    if (!e.content)
      return "";
    const t = ">", n = [];
    return e.content.forEach((l, o) => {
      var r, i;
      const c = ((i = (r = a.renderChild) == null ? void 0 : r.call(a, l, o)) != null ? i : a.renderChildren([l])).split(`
`).map((f) => f.trim() === "" ? t : `${t} ${f}`);
      n.push(c.join(`
`));
    }), n.join(`
${t}
`);
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      xo({
        find: aR,
        type: this.type
      })
    ];
  }
}), lR = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, oR = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, rR = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, iR = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, sR = Fn.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return /* @__PURE__ */ Ki("strong", { ...qt(this.options.HTMLAttributes, e), children: /* @__PURE__ */ Ki("slot", {}) });
  },
  markdownTokenName: "strong",
  parseMarkdown: (e, a) => a.applyMark("bold", a.parseInline(e.tokens || [])),
  markdownOptions: {
    htmlReopen: {
      open: "<strong>",
      close: "</strong>"
    }
  },
  renderMarkdown: (e, a) => `**${a.renderChildren(e)}**`,
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      Nl({
        find: lR,
        type: this.type
      }),
      Nl({
        find: rR,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      sl({
        find: oR,
        type: this.type
      }),
      sl({
        find: iR,
        type: this.type
      })
    ];
  }
}), dR = /(^|[^`])`([^`]+)`(?!`)$/, uR = /(^|[^`])`([^`]+)`(?!`)/g, cR = Fn.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [{ tag: "code" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["code", qt(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "codespan",
  parseMarkdown: (e, a) => a.applyMark("code", [{ type: "text", text: e.text || "" }]),
  renderMarkdown: (e, a) => e.content ? `\`${a.renderChildren(e.content)}\`` : "",
  addCommands() {
    return {
      setCode: () => ({ commands: e }) => e.setMark(this.name),
      toggleCode: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetCode: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      Nl({
        find: dR,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      sl({
        find: uR,
        type: this.type
      })
    ];
  }
}), Td = 4, fR = /^```([a-z]+)?[\s\n]$/, hR = /^~~~([a-z]+)?[\s\n]$/, bR = za.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      enableTabIndentation: !1,
      tabSize: Td,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (e) => {
          var a;
          const { languageClassPrefix: t } = this.options;
          if (!t)
            return null;
          const o = [...((a = e.firstElementChild) == null ? void 0 : a.classList) || []].filter((r) => r.startsWith(t)).map((r) => r.replace(t, ""))[0];
          return o || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: a }) {
    return [
      "pre",
      qt(this.options.HTMLAttributes, a),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
        },
        0
      ]
    ];
  },
  markdownTokenName: "code",
  parseMarkdown: (e, a) => {
    var t, n;
    return ((t = e.raw) == null ? void 0 : t.startsWith("```")) === !1 && ((n = e.raw) == null ? void 0 : n.startsWith("~~~")) === !1 && e.codeBlockStyle !== "indented" ? [] : a.createNode(
      "codeBlock",
      { language: e.lang || null },
      e.text ? [a.createTextNode(e.text)] : []
    );
  },
  renderMarkdown: (e, a) => {
    var t;
    let n = "";
    const l = ((t = e.attrs) == null ? void 0 : t.language) || "";
    return e.content ? n = [`\`\`\`${l}`, a.renderChildren(e.content), "```"].join(`
`) : n = `\`\`\`${l}

\`\`\``, n;
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: a }) => a.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: a }) => a.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: a } = this.editor.state.selection, t = a.pos === 1;
        return !e || a.parent.type.name !== this.name ? !1 : t || !a.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // handle tab indentation
      Tab: ({ editor: e }) => {
        var a;
        if (!this.options.enableTabIndentation)
          return !1;
        const t = (a = this.options.tabSize) != null ? a : Td, { state: n } = e, { selection: l } = n, { $from: o, empty: r } = l;
        if (o.parent.type !== this.type)
          return !1;
        const i = " ".repeat(t);
        return r ? e.commands.insertContent(i) : e.commands.command(({ tr: s }) => {
          const { from: d, to: c } = l, h = n.doc.textBetween(d, c, `
`, `
`).split(`
`).map((v) => i + v).join(`
`);
          return s.replaceWith(d, c, n.schema.text(h)), !0;
        });
      },
      // handle shift+tab reverse indentation
      "Shift-Tab": ({ editor: e }) => {
        var a;
        if (!this.options.enableTabIndentation)
          return !1;
        const t = (a = this.options.tabSize) != null ? a : Td, { state: n } = e, { selection: l } = n, { $from: o, empty: r } = l;
        return o.parent.type !== this.type ? !1 : r ? e.commands.command(({ tr: i }) => {
          var s;
          const { pos: d } = o, c = o.start(), f = o.end(), h = n.doc.textBetween(c, f, `
`, `
`).split(`
`);
          let v = 0, p = 0;
          const y = d - c;
          for (let A = 0; A < h.length; A += 1) {
            if (p + h[A].length >= y) {
              v = A;
              break;
            }
            p += h[A].length + 1;
          }
          const $ = ((s = h[v].match(/^ */)) == null ? void 0 : s[0]) || "", S = Math.min($.length, t);
          if (S === 0)
            return !0;
          let I = c;
          for (let A = 0; A < v; A += 1)
            I += h[A].length + 1;
          return i.delete(I, I + S), d - I <= S && i.setSelection(ht.create(i.doc, I)), !0;
        }) : e.commands.command(({ tr: i }) => {
          const { from: s, to: d } = l, g = n.doc.textBetween(s, d, `
`, `
`).split(`
`).map((h) => {
            var v;
            const p = ((v = h.match(/^ */)) == null ? void 0 : v[0]) || "", y = Math.min(p.length, t);
            return h.slice(y);
          }).join(`
`);
          return i.replaceWith(s, d, n.schema.text(g)), !0;
        });
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: a } = e, { selection: t } = a, { $from: n, empty: l } = t;
        if (!l || n.parent.type !== this.type)
          return !1;
        const o = n.parentOffset === n.parent.nodeSize - 2, r = n.parent.textContent.endsWith(`

`);
        return !o || !r ? !1 : e.chain().command(({ tr: i }) => (i.delete(n.pos - 2, n.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: a } = e, { selection: t, doc: n } = a, { $from: l, empty: o } = t;
        if (!o || l.parent.type !== this.type || !(l.parentOffset === l.parent.nodeSize - 2))
          return !1;
        const i = l.after();
        return i === void 0 ? !1 : n.nodeAt(i) ? e.commands.command(({ tr: d }) => (d.setSelection(xt.near(n.resolve(i))), !0)) : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      Du({
        find: fR,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      Du({
        find: hR,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Ut({
        key: new la("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, a) => {
            if (!a.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = a.clipboardData.getData("text/plain"), n = a.clipboardData.getData("vscode-editor-data"), l = n ? JSON.parse(n) : void 0, o = l == null ? void 0 : l.mode;
            if (!t || !o)
              return !1;
            const { tr: r, schema: i } = e.state, s = i.text(t.replace(/\r\n?/g, `
`));
            return r.replaceSelectionWith(this.type.create({ language: o }, s)), r.selection.$from.parent.type !== this.type && r.setSelection(ht.near(r.doc.resolve(Math.max(0, r.selection.from - 2)))), r.setMeta("paste", !0), e.dispatch(r), !0;
          }
        }
      })
    ];
  }
}), gR = za.create({
  name: "doc",
  topNode: !0,
  content: "block+",
  renderMarkdown: (e, a) => e.content ? a.renderChildren(e.content, `

`) : ""
}), mR = za.create({
  name: "hardBreak",
  markdownTokenName: "br",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", qt(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  renderMarkdown: () => `  
`,
  parseMarkdown: () => ({
    type: "hardBreak"
  }),
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: a, state: t, editor: n }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: l, storedMarks: o } = t;
          if (l.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: r } = this.options, { splittableMarks: i } = n.extensionManager, s = o || l.$to.parentOffset && l.$from.marks();
          return a().insertContent({ type: this.name }).command(({ tr: d, dispatch: c }) => {
            if (c && s && r) {
              const f = s.filter((g) => i.includes(g.type.name));
              d.ensureMarks(f);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), vR = za.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: a }) {
    return [`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`, qt(this.options.HTMLAttributes, a), 0];
  },
  parseMarkdown: (e, a) => a.createNode("heading", { level: e.depth || 1 }, a.parseInline(e.tokens || [])),
  renderMarkdown: (e, a) => {
    var t;
    const n = (t = e.attrs) != null && t.level ? parseInt(e.attrs.level, 10) : 1, l = "#".repeat(n);
    return e.content ? `${l} ${a.renderChildren(e.content)}` : "";
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: a }) => this.options.levels.includes(e.level) ? a.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: a }) => this.options.levels.includes(e.level) ? a.toggleNode(this.name, "paragraph", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (e, a) => ({
        ...e,
        [`Mod-Alt-${a}`]: () => this.editor.commands.toggleHeading({ level: a })
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((e) => Du({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
}), pR = za.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {},
      nextNodeType: "paragraph"
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["hr", qt(this.options.HTMLAttributes, e)];
  },
  markdownTokenName: "hr",
  parseMarkdown: (e, a) => a.createNode("horizontalRule"),
  renderMarkdown: () => "---",
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: e, state: a }) => {
        if (!UA(a, a.schema.nodes[this.name]))
          return !1;
        const { selection: t } = a, { $to: n } = t, l = e();
        return vp(t) ? l.insertContentAt(n.pos, {
          type: this.name
        }) : l.insertContent({ type: this.name }), l.command(({ state: o, tr: r, dispatch: i }) => {
          if (i) {
            const { $to: s } = r.selection, d = s.end();
            if (s.nodeAfter)
              s.nodeAfter.isTextblock ? r.setSelection(ht.create(r.doc, s.pos + 1)) : s.nodeAfter.isBlock ? r.setSelection(dt.create(r.doc, s.pos)) : r.setSelection(ht.create(r.doc, s.pos));
            else {
              const c = o.schema.nodes[this.options.nextNodeType] || s.parent.type.contentMatch.defaultType, f = c == null ? void 0 : c.create();
              f && (r.insert(d, f), r.setSelection(ht.create(r.doc, d + 1)));
            }
            r.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      Bp({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), xR = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, yR = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, kR = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, wR = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, CR = Fn.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["em", qt(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  markdownTokenName: "em",
  parseMarkdown: (e, a) => a.applyMark("italic", a.parseInline(e.tokens || [])),
  markdownOptions: {
    htmlReopen: {
      open: "<em>",
      close: "</em>"
    }
  },
  renderMarkdown: (e, a) => `*${a.renderChildren(e)}*`,
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      Nl({
        find: xR,
        type: this.type
      }),
      Nl({
        find: kR,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      sl({
        find: yR,
        type: this.type
      }),
      sl({
        find: wR,
        type: this.type
      })
    ];
  }
});
const SR = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2odyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rck0msd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2oodside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", $R = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", Mu = "numeric", Ou = "ascii", Pu = "alpha", ar = "asciinumeric", Uo = "alphanumeric", Fu = "domain", Op = "emoji", IR = "scheme", LR = "slashscheme", Ed = "whitespace";
function TR(e, a) {
  return e in a || (a[e] = []), a[e];
}
function Sl(e, a, t) {
  a[Mu] && (a[ar] = !0, a[Uo] = !0), a[Ou] && (a[ar] = !0, a[Pu] = !0), a[ar] && (a[Uo] = !0), a[Pu] && (a[Uo] = !0), a[Uo] && (a[Fu] = !0), a[Op] && (a[Fu] = !0);
  for (const n in a) {
    const l = TR(n, t);
    l.indexOf(e) < 0 && l.push(e);
  }
}
function ER(e, a) {
  const t = {};
  for (const n in a)
    a[n].indexOf(e) >= 0 && (t[n] = !0);
  return t;
}
function La(e = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
La.groups = {};
La.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(e) {
    const a = this, t = a.j[e];
    if (t)
      return t;
    for (let n = 0; n < a.jr.length; n++) {
      const l = a.jr[n][0], o = a.jr[n][1];
      if (o && l.test(e))
        return o;
    }
    return a.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(e, a = !1) {
    return a ? e in this.j : !!this.go(e);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(e, a, t, n) {
    for (let l = 0; l < e.length; l++)
      this.tt(e[l], a, t, n);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(e, a, t, n) {
    n = n || La.groups;
    let l;
    return a && a.j ? l = a : (l = new La(a), t && n && Sl(a, t, n)), this.jr.push([e, l]), l;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(e, a, t, n) {
    let l = this;
    const o = e.length;
    if (!o)
      return l;
    for (let r = 0; r < o - 1; r++)
      l = l.tt(e[r]);
    return l.tt(e[o - 1], a, t, n);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(e, a, t, n) {
    n = n || La.groups;
    const l = this;
    if (a && a.j)
      return l.j[e] = a, a;
    const o = a;
    let r, i = l.go(e);
    if (i ? (r = new La(), Object.assign(r.j, i.j), r.jr.push.apply(r.jr, i.jr), r.jd = i.jd, r.t = i.t) : r = new La(), o) {
      if (n)
        if (r.t && typeof r.t == "string") {
          const s = Object.assign(ER(r.t, n), t);
          Sl(o, s, n);
        } else t && Sl(o, t, n);
      r.t = o;
    }
    return l.j[e] = r, r;
  }
};
const wt = (e, a, t, n, l) => e.ta(a, t, n, l), Kt = (e, a, t, n, l) => e.tr(a, t, n, l), gb = (e, a, t, n, l) => e.ts(a, t, n, l), Ue = (e, a, t, n, l) => e.tt(a, t, n, l), Ln = "WORD", Nu = "UWORD", Pp = "ASCIINUMERICAL", Fp = "ALPHANUMERICAL", $r = "LOCALHOST", Vu = "TLD", Hu = "UTLD", wi = "SCHEME", Zl = "SLASH_SCHEME", af = "NUM", ju = "WS", nf = "NL", nr = "OPENBRACE", lr = "CLOSEBRACE", Yi = "OPENBRACKET", Ji = "CLOSEBRACKET", Xi = "OPENPAREN", Zi = "CLOSEPAREN", Qi = "OPENANGLEBRACKET", _i = "CLOSEANGLEBRACKET", es = "FULLWIDTHLEFTPAREN", ts = "FULLWIDTHRIGHTPAREN", as = "LEFTCORNERBRACKET", ns = "RIGHTCORNERBRACKET", ls = "LEFTWHITECORNERBRACKET", rs = "RIGHTWHITECORNERBRACKET", is = "FULLWIDTHLESSTHAN", ss = "FULLWIDTHGREATERTHAN", ds = "AMPERSAND", us = "APOSTROPHE", cs = "ASTERISK", jn = "AT", fs = "BACKSLASH", hs = "BACKTICK", bs = "CARET", $l = "COLON", lf = "COMMA", gs = "DOLLAR", dn = "DOT", ms = "EQUALS", of = "EXCLAMATION", ja = "HYPHEN", or = "PERCENT", vs = "PIPE", ps = "PLUS", xs = "POUND", rr = "QUERY", rf = "QUOTE", Np = "FULLWIDTHMIDDLEDOT", sf = "SEMI", un = "SLASH", ir = "TILDE", ys = "UNDERSCORE", Vp = "EMOJI", ks = "SYM";
var Hp = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: Fp,
  AMPERSAND: ds,
  APOSTROPHE: us,
  ASCIINUMERICAL: Pp,
  ASTERISK: cs,
  AT: jn,
  BACKSLASH: fs,
  BACKTICK: hs,
  CARET: bs,
  CLOSEANGLEBRACKET: _i,
  CLOSEBRACE: lr,
  CLOSEBRACKET: Ji,
  CLOSEPAREN: Zi,
  COLON: $l,
  COMMA: lf,
  DOLLAR: gs,
  DOT: dn,
  EMOJI: Vp,
  EQUALS: ms,
  EXCLAMATION: of,
  FULLWIDTHGREATERTHAN: ss,
  FULLWIDTHLEFTPAREN: es,
  FULLWIDTHLESSTHAN: is,
  FULLWIDTHMIDDLEDOT: Np,
  FULLWIDTHRIGHTPAREN: ts,
  HYPHEN: ja,
  LEFTCORNERBRACKET: as,
  LEFTWHITECORNERBRACKET: ls,
  LOCALHOST: $r,
  NL: nf,
  NUM: af,
  OPENANGLEBRACKET: Qi,
  OPENBRACE: nr,
  OPENBRACKET: Yi,
  OPENPAREN: Xi,
  PERCENT: or,
  PIPE: vs,
  PLUS: ps,
  POUND: xs,
  QUERY: rr,
  QUOTE: rf,
  RIGHTCORNERBRACKET: ns,
  RIGHTWHITECORNERBRACKET: rs,
  SCHEME: wi,
  SEMI: sf,
  SLASH: un,
  SLASH_SCHEME: Zl,
  SYM: ks,
  TILDE: ir,
  TLD: Vu,
  UNDERSCORE: ys,
  UTLD: Hu,
  UWORD: Nu,
  WORD: Ln,
  WS: ju
});
const $n = /[a-z]/, Bo = new RegExp("\\p{L}", "u"), Ad = new RegExp("\\p{Emoji}", "u"), In = /\d/, Rd = /\s/, mb = "\r", zd = `
`, AR = "️", RR = "‍", Dd = "￼";
let ti = null, ai = null;
function zR(e = []) {
  const a = {};
  La.groups = a;
  const t = new La();
  ti == null && (ti = vb(SR)), ai == null && (ai = vb($R)), Ue(t, "'", us), Ue(t, "{", nr), Ue(t, "}", lr), Ue(t, "[", Yi), Ue(t, "]", Ji), Ue(t, "(", Xi), Ue(t, ")", Zi), Ue(t, "<", Qi), Ue(t, ">", _i), Ue(t, "（", es), Ue(t, "）", ts), Ue(t, "「", as), Ue(t, "」", ns), Ue(t, "『", ls), Ue(t, "』", rs), Ue(t, "＜", is), Ue(t, "＞", ss), Ue(t, "&", ds), Ue(t, "*", cs), Ue(t, "@", jn), Ue(t, "`", hs), Ue(t, "^", bs), Ue(t, ":", $l), Ue(t, ",", lf), Ue(t, "$", gs), Ue(t, ".", dn), Ue(t, "=", ms), Ue(t, "!", of), Ue(t, "-", ja), Ue(t, "%", or), Ue(t, "|", vs), Ue(t, "+", ps), Ue(t, "#", xs), Ue(t, "?", rr), Ue(t, '"', rf), Ue(t, "/", un), Ue(t, ";", sf), Ue(t, "~", ir), Ue(t, "_", ys), Ue(t, "\\", fs), Ue(t, "・", Np);
  const n = Kt(t, In, af, {
    [Mu]: !0
  });
  Kt(n, In, n);
  const l = Kt(n, $n, Pp, {
    [ar]: !0
  }), o = Kt(n, Bo, Fp, {
    [Uo]: !0
  }), r = Kt(t, $n, Ln, {
    [Ou]: !0
  });
  Kt(r, In, l), Kt(r, $n, r), Kt(l, In, l), Kt(l, $n, l);
  const i = Kt(t, Bo, Nu, {
    [Pu]: !0
  });
  Kt(i, $n), Kt(i, In, o), Kt(i, Bo, i), Kt(o, In, o), Kt(o, $n), Kt(o, Bo, o);
  const s = Ue(t, zd, nf, {
    [Ed]: !0
  }), d = Ue(t, mb, ju, {
    [Ed]: !0
  }), c = Kt(t, Rd, ju, {
    [Ed]: !0
  });
  Ue(t, Dd, c), Ue(d, zd, s), Ue(d, Dd, c), Kt(d, Rd, c), Ue(c, mb), Ue(c, zd), Kt(c, Rd, c), Ue(c, Dd, c);
  const f = Kt(t, Ad, Vp, {
    [Op]: !0
  });
  Ue(f, "#"), Kt(f, Ad, f), Ue(f, AR, f);
  const g = Ue(f, RR);
  Ue(g, "#"), Kt(g, Ad, f);
  const h = [[$n, r], [In, l]], v = [[$n, null], [Bo, i], [In, o]];
  for (let p = 0; p < ti.length; p++)
    Nn(t, ti[p], Vu, Ln, h);
  for (let p = 0; p < ai.length; p++)
    Nn(t, ai[p], Hu, Nu, v);
  Sl(Vu, {
    tld: !0,
    ascii: !0
  }, a), Sl(Hu, {
    utld: !0,
    alpha: !0
  }, a), Nn(t, "file", wi, Ln, h), Nn(t, "mailto", wi, Ln, h), Nn(t, "http", Zl, Ln, h), Nn(t, "https", Zl, Ln, h), Nn(t, "ftp", Zl, Ln, h), Nn(t, "ftps", Zl, Ln, h), Sl(wi, {
    scheme: !0,
    ascii: !0
  }, a), Sl(Zl, {
    slashscheme: !0,
    ascii: !0
  }, a), e = e.sort((p, y) => p[0] > y[0] ? 1 : -1);
  for (let p = 0; p < e.length; p++) {
    const y = e[p][0], $ = e[p][1] ? {
      [IR]: !0
    } : {
      [LR]: !0
    };
    y.indexOf("-") >= 0 ? $[Fu] = !0 : $n.test(y) ? In.test(y) ? $[ar] = !0 : $[Ou] = !0 : $[Mu] = !0, gb(t, y, y, $);
  }
  return gb(t, "localhost", $r, {
    ascii: !0
  }), t.jd = new La(ks), {
    start: t,
    tokens: Object.assign({
      groups: a
    }, Hp)
  };
}
function jp(e, a) {
  const t = DR(a.replace(/[A-Z]/g, (i) => i.toLowerCase())), n = t.length, l = [];
  let o = 0, r = 0;
  for (; r < n; ) {
    let i = e, s = null, d = 0, c = null, f = -1, g = -1;
    for (; r < n && (s = i.go(t[r])); )
      i = s, i.accepts() ? (f = 0, g = 0, c = i) : f >= 0 && (f += t[r].length, g++), d += t[r].length, o += t[r].length, r++;
    o -= f, r -= g, d -= f, l.push({
      t: c.t,
      // token type/name
      v: a.slice(o - d, o),
      // string value
      s: o - d,
      // start index
      e: o
      // end index (excluding)
    });
  }
  return l;
}
function DR(e) {
  const a = [], t = e.length;
  let n = 0;
  for (; n < t; ) {
    let l = e.charCodeAt(n), o, r = l < 55296 || l > 56319 || n + 1 === t || (o = e.charCodeAt(n + 1)) < 56320 || o > 57343 ? e[n] : e.slice(n, n + 2);
    a.push(r), n += r.length;
  }
  return a;
}
function Nn(e, a, t, n, l) {
  let o;
  const r = a.length;
  for (let i = 0; i < r - 1; i++) {
    const s = a[i];
    e.j[s] ? o = e.j[s] : (o = new La(n), o.jr = l.slice(), e.j[s] = o), e = o;
  }
  return o = new La(t), o.jr = l.slice(), e.j[a[r - 1]] = o, o;
}
function vb(e) {
  const a = [], t = [];
  let n = 0, l = "0123456789";
  for (; n < e.length; ) {
    let o = 0;
    for (; l.indexOf(e[n + o]) >= 0; )
      o++;
    if (o > 0) {
      a.push(t.join(""));
      for (let r = parseInt(e.substring(n, n + o), 10); r > 0; r--)
        t.pop();
      n += o;
    } else
      t.push(e[n]), n++;
  }
  return a;
}
const Ir = {
  defaultProtocol: "http",
  events: null,
  format: pb,
  formatHref: pb,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function df(e, a = null) {
  let t = Object.assign({}, Ir);
  e && (t = Object.assign(t, e instanceof df ? e.o : e));
  const n = t.ignoreTags, l = [];
  for (let o = 0; o < n.length; o++)
    l.push(n[o].toUpperCase());
  this.o = t, a && (this.defaultRender = a), this.ignoreTags = l;
}
df.prototype = {
  o: Ir,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(e) {
    return e;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(e) {
    return this.get("validate", e.toString(), e);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(e, a, t) {
    const n = a != null;
    let l = this.o[e];
    return l && (typeof l == "object" ? (l = t.t in l ? l[t.t] : Ir[e], typeof l == "function" && n && (l = l(a, t))) : typeof l == "function" && n && (l = l(a, t.t, t)), l);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(e, a, t) {
    let n = this.o[e];
    return typeof n == "function" && a != null && (n = n(a, t.t, t)), n;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(e) {
    const a = e.render(this);
    return (this.get("render", null, e) || this.defaultRender)(a, e.t, e);
  }
};
function pb(e) {
  return e;
}
function Wp(e, a) {
  this.t = "token", this.v = e, this.tk = a;
}
Wp.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(e) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(e) {
    const a = this.toString(), t = e.get("truncate", a, this), n = e.get("format", a, this);
    return t && n.length > t ? n.substring(0, t) + "…" : n;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(e) {
    return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(e = Ir.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(e) {
    return {
      type: this.t,
      value: this.toFormattedString(e),
      isLink: this.isLink,
      href: this.toFormattedHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(e) {
    return e.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(e) {
    const a = this, t = this.toHref(e.get("defaultProtocol")), n = e.get("formatHref", t, this), l = e.get("tagName", t, a), o = this.toFormattedString(e), r = {}, i = e.get("className", t, a), s = e.get("target", t, a), d = e.get("rel", t, a), c = e.getObj("attributes", t, a), f = e.getObj("events", t, a);
    return r.href = n, i && (r.class = i), s && (r.target = s), d && (r.rel = d), c && Object.assign(r, c), {
      tagName: l,
      attributes: r,
      content: o,
      eventListeners: f
    };
  }
};
function Ys(e, a) {
  class t extends Wp {
    constructor(l, o) {
      super(l, o), this.t = e;
    }
  }
  for (const n in a)
    t.prototype[n] = a[n];
  return t.t = e, t;
}
const BR = Ys("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), xb = Ys("text"), MR = Ys("nl"), ni = Ys("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(e = Ir.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${e}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const e = this.tk;
    return e.length >= 2 && e[0].t !== $r && e[1].t === $l;
  }
}), Ha = (e) => new La(e);
function OR({
  groups: e
}) {
  const a = e.domain.concat([ds, cs, jn, fs, hs, bs, gs, ms, ja, af, or, vs, ps, xs, un, ks, ir, ys]), t = [us, $l, lf, dn, of, or, rr, rf, sf, Qi, _i, nr, lr, Ji, Yi, Xi, Zi, es, ts, as, ns, ls, rs, is, ss], n = [ds, us, cs, fs, hs, bs, gs, ms, ja, nr, lr, or, vs, ps, xs, rr, un, ks, ir, ys], l = Ha(), o = Ue(l, ir);
  wt(o, n, o), wt(o, e.domain, o);
  const r = Ha(), i = Ha(), s = Ha();
  wt(l, e.domain, r), wt(l, e.scheme, i), wt(l, e.slashscheme, s), wt(r, n, o), wt(r, e.domain, r);
  const d = Ue(r, jn);
  Ue(o, jn, d), Ue(i, jn, d), Ue(s, jn, d);
  const c = Ue(o, dn);
  wt(c, n, o), wt(c, e.domain, o);
  const f = Ha();
  wt(d, e.domain, f), wt(f, e.domain, f);
  const g = Ue(f, dn);
  wt(g, e.domain, f);
  const h = Ha(BR);
  wt(g, e.tld, h), wt(g, e.utld, h), Ue(d, $r, h);
  const v = Ue(f, ja);
  Ue(v, ja, v), wt(v, e.domain, f), wt(h, e.domain, f), Ue(h, dn, g), Ue(h, ja, v);
  const p = Ue(r, ja), y = Ue(r, dn);
  Ue(p, ja, p), wt(p, e.domain, r), wt(y, n, o), wt(y, e.domain, r);
  const k = Ha(ni);
  wt(y, e.tld, k), wt(y, e.utld, k), wt(k, e.domain, r), wt(k, n, o), Ue(k, dn, y), Ue(k, ja, p), Ue(k, jn, d);
  const $ = Ue(k, $l), S = Ha(ni);
  wt($, e.numeric, S);
  const I = Ha(ni), T = Ha();
  wt(I, a, I), wt(I, t, T), wt(T, a, I), wt(T, t, T), Ue(k, un, I), Ue(S, un, I);
  const A = Ue(i, $l), E = Ue(s, $l), z = Ue(E, un), B = Ue(z, un);
  wt(i, e.domain, r), Ue(i, dn, y), Ue(i, ja, p), wt(s, e.domain, r), Ue(s, dn, y), Ue(s, ja, p), wt(A, e.domain, I), Ue(A, un, I), Ue(A, rr, I), wt(B, e.domain, I), wt(B, a, I), Ue(B, un, I);
  const W = [
    [nr, lr],
    // {}
    [Yi, Ji],
    // []
    [Xi, Zi],
    // ()
    [Qi, _i],
    // <>
    [es, ts],
    // （）
    [as, ns],
    // 「」
    [ls, rs],
    // 『』
    [is, ss]
    // ＜＞
  ];
  for (let _ = 0; _ < W.length; _++) {
    const [Z, le] = W[_], D = Ue(I, Z);
    Ue(T, Z, D);
    const O = Ha(ni);
    wt(D, a, O);
    const N = Ha();
    wt(D, t, N), Ue(D, le, I), wt(O, a, O), wt(O, t, N), wt(N, a, O), wt(N, t, N), Ue(O, le, I), Ue(N, le, I);
  }
  return Ue(l, $r, k), Ue(l, nf, MR), {
    start: l,
    tokens: Hp
  };
}
function PR(e, a, t) {
  let n = t.length, l = 0, o = [], r = [];
  for (; l < n; ) {
    let i = e, s = null, d = null, c = 0, f = null, g = -1;
    for (; l < n && !(s = i.go(t[l].t)); )
      r.push(t[l++]);
    for (; l < n && (d = s || i.go(t[l].t)); )
      s = null, i = d, i.accepts() ? (g = 0, f = i) : g >= 0 && g++, l++, c++;
    if (g < 0)
      l -= c, l < n && (r.push(t[l]), l++);
    else {
      r.length > 0 && (o.push(Bd(xb, a, r)), r = []), l -= g, c -= g;
      const h = f.t, v = t.slice(l - c, l);
      o.push(Bd(h, a, v));
    }
  }
  return r.length > 0 && o.push(Bd(xb, a, r)), o;
}
function Bd(e, a, t) {
  const n = t[0].s, l = t[t.length - 1].e, o = a.slice(n, l);
  return new e(o, t);
}
const FR = typeof console < "u" && console && console.warn || (() => {
}), NR = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", Vt = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function VR() {
  return La.groups = {}, Vt.scanner = null, Vt.parser = null, Vt.tokenQueue = [], Vt.pluginQueue = [], Vt.customSchemes = [], Vt.initialized = !1, Vt;
}
function yb(e, a = !1) {
  if (Vt.initialized && FR(`linkifyjs: already initialized - will not register custom scheme "${e}" ${NR}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(e))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  Vt.customSchemes.push([e, a]);
}
function HR() {
  Vt.scanner = zR(Vt.customSchemes);
  for (let e = 0; e < Vt.tokenQueue.length; e++)
    Vt.tokenQueue[e][1]({
      scanner: Vt.scanner
    });
  Vt.parser = OR(Vt.scanner.tokens);
  for (let e = 0; e < Vt.pluginQueue.length; e++)
    Vt.pluginQueue[e][1]({
      scanner: Vt.scanner,
      parser: Vt.parser
    });
  return Vt.initialized = !0, Vt;
}
function uf(e) {
  return Vt.initialized || HR(), PR(Vt.parser.start, e, jp(Vt.scanner.start, e));
}
uf.scan = jp;
function qp(e, a = null, t = null) {
  if (a && typeof a == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${a}; must be a string`);
    t = a, a = null;
  }
  const n = new df(t), l = uf(e), o = [];
  for (let r = 0; r < l.length; r++) {
    const i = l[r];
    i.isLink && (!a || i.t === a) && n.check(i) && o.push(i.toFormattedObject(n));
  }
  return o;
}
var cf = "[\0-   ᠎ -\u2029 　]", jR = new RegExp(cf), WR = new RegExp(`${cf}$`), qR = new RegExp(cf, "g");
function UR(e) {
  return e.length === 1 ? e[0].isLink : e.length === 3 && e[1].isLink ? ["()", "[]"].includes(e[0].value + e[2].value) : !1;
}
function GR(e) {
  return new Ut({
    key: new la("autolink"),
    appendTransaction: (a, t, n) => {
      const l = a.some((d) => d.docChanged) && !t.doc.eq(n.doc), o = a.some((d) => d.getMeta("preventAutolink"));
      if (!l || o)
        return;
      const { tr: r } = n, i = dp(t.doc, [...a]);
      if (mp(i).forEach(({ newRange: d }) => {
        const c = jE(n.doc, d, (h) => h.isTextblock);
        let f, g;
        if (c.length > 1)
          f = c[0], g = n.doc.textBetween(
            f.pos,
            f.pos + f.node.nodeSize,
            void 0,
            " "
          );
        else if (c.length) {
          const h = n.doc.textBetween(d.from, d.to, " ", " ");
          if (!WR.test(h))
            return;
          f = c[0], g = n.doc.textBetween(f.pos, d.to, void 0, " ");
        }
        if (f && g) {
          const h = g.split(jR).filter(Boolean);
          if (h.length <= 0)
            return !1;
          const v = h[h.length - 1], p = f.pos + g.lastIndexOf(v);
          if (!v)
            return !1;
          const y = uf(v).map((k) => k.toObject(e.defaultProtocol));
          if (!UR(y))
            return !1;
          y.filter((k) => k.isLink).map((k) => ({
            ...k,
            from: p + k.start + 1,
            to: p + k.end + 1
          })).filter((k) => n.schema.marks.code ? !n.doc.rangeHasMark(k.from, k.to, n.schema.marks.code) : !0).filter((k) => e.validate(k.value)).filter((k) => e.shouldAutoLink(k.value)).forEach((k) => {
            Zc(k.from, k.to, n.doc).some(($) => $.mark.type === e.type) || r.addMark(
              k.from,
              k.to,
              e.type.create({
                href: k.href
              })
            );
          });
        }
      }), !!r.steps.length)
        return r;
    }
  });
}
function KR(e) {
  return new Ut({
    key: new la("handleClickLink"),
    props: {
      handleClick: (a, t, n) => {
        var l, o;
        if (n.button !== 0 || !a.editable)
          return !1;
        let r = null;
        if (n.target instanceof HTMLAnchorElement)
          r = n.target;
        else {
          const s = n.target;
          if (!s)
            return !1;
          const d = e.editor.view.dom;
          r = s.closest("a"), r && !d.contains(r) && (r = null);
        }
        if (!r)
          return !1;
        let i = !1;
        if (e.enableClickSelection && (i = e.editor.commands.extendMarkRange(e.type.name)), e.openOnClick) {
          const s = gp(a.state, e.type.name), d = (l = r.href) != null ? l : s.href, c = (o = r.target) != null ? o : s.target;
          d && (window.open(d, c), i = !0);
        }
        return i;
      }
    }
  });
}
function YR(e) {
  return new Ut({
    key: new la("handlePasteLink"),
    props: {
      handlePaste: (a, t, n) => {
        const { shouldAutoLink: l } = e, { state: o } = a, { selection: r } = o, { empty: i } = r;
        if (i)
          return !1;
        let s = "";
        n.content.forEach((c) => {
          s += c.textContent;
        });
        const d = qp(s, { defaultProtocol: e.defaultProtocol }).find(
          (c) => c.isLink && c.value === s
        );
        return !s || !d || l !== void 0 && !l(d.value) ? !1 : e.editor.commands.setMark(e.type, {
          href: d.href
        });
      }
    }
  });
}
function vl(e, a) {
  const t = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  return a && a.forEach((n) => {
    const l = typeof n == "string" ? n : n.scheme;
    l && t.push(l);
  }), !e || e.replace(qR, "").match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
      "i"
    )
  );
}
var JR = Fn.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((e) => {
      if (typeof e == "string") {
        yb(e);
        return;
      }
      yb(e.scheme, e.optionalSlashes);
    });
  },
  onDestroy() {
    VR();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      enableClickSelection: !1,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (e, a) => !!vl(e, a.protocols),
      validate: (e) => !!e,
      shouldAutoLink: (e) => {
        const a = /^[a-z][a-z0-9+.-]*:\/\//i.test(e), t = /^[a-z][a-z0-9+.-]*:/i.test(e);
        if (a || t && !e.includes("@"))
          return !0;
        const l = (e.includes("@") ? e.split("@").pop() : e).split(/[/?#:]/)[0];
        return !(/^\d{1,3}(\.\d{1,3}){3}$/.test(l) || !/\./.test(l));
      }
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(e) {
          return e.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (e) => {
          const a = e.getAttribute("href");
          return !a || !this.options.isAllowedUri(a, {
            defaultValidate: (t) => !!vl(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return this.options.isAllowedUri(e.href, {
      defaultValidate: (a) => !!vl(a, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", qt(this.options.HTMLAttributes, e), 0] : ["a", qt(this.options.HTMLAttributes, { ...e, href: "" }), 0];
  },
  markdownTokenName: "link",
  parseMarkdown: (e, a) => a.applyMark("link", a.parseInline(e.tokens || []), {
    href: e.href,
    title: e.title || null
  }),
  renderMarkdown: (e, a) => {
    var t, n, l, o;
    const r = (n = (t = e.attrs) == null ? void 0 : t.href) != null ? n : "", i = (o = (l = e.attrs) == null ? void 0 : l.title) != null ? o : "", s = a.renderChildren(e);
    return i ? `[${s}](${r} "${i}")` : `[${s}](${r})`;
  },
  addCommands() {
    return {
      setLink: (e) => ({ chain: a }) => {
        const { href: t } = e;
        return this.options.isAllowedUri(t, {
          defaultValidate: (n) => !!vl(n, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? a().setMark(this.name, e).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (e) => ({ chain: a }) => {
        const { href: t } = e || {};
        return t && !this.options.isAllowedUri(t, {
          defaultValidate: (n) => !!vl(n, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? !1 : a().toggleMark(this.name, e, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run();
      },
      unsetLink: () => ({ chain: e }) => e().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      sl({
        find: (e) => {
          const a = [];
          if (e) {
            const { protocols: t, defaultProtocol: n } = this.options, l = qp(e).filter(
              (o) => o.isLink && this.options.isAllowedUri(o.value, {
                defaultValidate: (r) => !!vl(r, t),
                protocols: t,
                defaultProtocol: n
              })
            );
            l.length && l.forEach((o) => {
              this.options.shouldAutoLink(o.value) && a.push({
                text: o.value,
                data: {
                  href: o.href
                },
                index: o.start
              });
            });
          }
          return a;
        },
        type: this.type,
        getAttributes: (e) => {
          var a;
          return {
            href: (a = e.data) == null ? void 0 : a.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [], { protocols: a, defaultProtocol: t } = this.options;
    return this.options.autolink && e.push(
      GR({
        type: this.type,
        defaultProtocol: this.options.defaultProtocol,
        validate: (n) => this.options.isAllowedUri(n, {
          defaultValidate: (l) => !!vl(l, a),
          protocols: a,
          defaultProtocol: t
        }),
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), e.push(
      KR({
        type: this.type,
        editor: this.editor,
        openOnClick: this.options.openOnClick === "whenNotEditable" ? !0 : this.options.openOnClick,
        enableClickSelection: this.options.enableClickSelection
      })
    ), this.options.linkOnPaste && e.push(
      YR({
        editor: this.editor,
        defaultProtocol: this.options.defaultProtocol,
        type: this.type,
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), e;
  }
}), XR = Object.defineProperty, ZR = (e, a) => {
  for (var t in a)
    XR(e, t, { get: a[t], enumerable: !0 });
}, QR = "listItem", kb = "textStyle", wb = /^\s*([-+*])\s$/, Up = za.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", qt(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (e, a) => e.type !== "list" || e.ordered ? [] : {
    type: "bulletList",
    content: e.items ? a.parseChildren(e.items) : []
  },
  renderMarkdown: (e, a) => e.content ? a.renderChildren(e.content, `
`) : "",
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: e, chain: a }) => this.options.keepAttributes ? a().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(QR, this.editor.getAttributes(kb)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let e = xo({
      find: wb,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = xo({
      find: wb,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(kb),
      editor: this.editor
    })), [e];
  }
});
function _R(e) {
  var a, t;
  const n = (a = e.tokens) == null ? void 0 : a[0];
  return !!(e.text && ((t = e.tokens) == null ? void 0 : t.length) === 1 && (n == null ? void 0 : n.type) === "list" && n.ordered && n.raw === e.text);
}
function ez(e, a) {
  return a.tokenizeInline ? a.parseInline(a.tokenizeInline(e)) : a.parseInline([
    {
      type: "text",
      raw: e,
      text: e
    }
  ]);
}
var Gp = za.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", qt(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list_item",
  parseMarkdown: (e, a) => {
    var t;
    if (e.type !== "list_item")
      return [];
    const n = (t = a.parseBlockChildren) != null ? t : a.parseChildren;
    let l = [];
    if (e.tokens && e.tokens.length > 0) {
      if (_R(e))
        return {
          type: "listItem",
          content: [
            {
              type: "paragraph",
              content: ez(e.text || "", a)
            }
          ]
        };
      if (e.tokens.some((r) => r.type === "paragraph"))
        l = n(e.tokens);
      else {
        const r = e.tokens[0];
        if (r && r.type === "text" && r.tokens && r.tokens.length > 0) {
          if (l = [
            {
              type: "paragraph",
              content: a.parseInline(r.tokens)
            }
          ], e.tokens.length > 1) {
            const s = e.tokens.slice(1), d = n(s);
            l.push(...d);
          }
        } else
          l = n(e.tokens);
      }
    }
    return l.length === 0 && (l = [
      {
        type: "paragraph",
        content: []
      }
    ]), {
      type: "listItem",
      content: l
    };
  },
  renderMarkdown: (e, a, t) => tf(
    e,
    a,
    (n) => {
      var l, o;
      return n.parentType === "bulletList" ? "- " : n.parentType === "orderedList" ? `${(((o = (l = n.meta) == null ? void 0 : l.parentAttrs) == null ? void 0 : o.start) || 1) + n.index}. ` : "- ";
    },
    t
  ),
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), tz = {};
ZR(tz, {
  findListItemPos: () => Nr,
  getNextListDepth: () => ff,
  handleBackspace: () => Wu,
  handleDelete: () => qu,
  hasListBefore: () => Kp,
  hasListItemAfter: () => az,
  hasListItemBefore: () => Yp,
  listItemHasSubList: () => Jp,
  nextListIsDeeper: () => Xp,
  nextListIsHigher: () => Zp
});
var Nr = (e, a) => {
  const { $from: t } = a.selection, n = ea(e, a.schema);
  let l = null, o = t.depth, r = t.pos, i = null;
  for (; o > 0 && i === null; )
    l = t.node(o), l.type === n ? i = o : (o -= 1, r -= 1);
  return i === null ? null : { $pos: a.doc.resolve(r), depth: i };
}, ff = (e, a) => {
  const t = Nr(e, a);
  if (!t)
    return !1;
  const [, n] = _E(a, e, t.$pos.pos + 4);
  return n;
}, Kp = (e, a, t) => {
  const { $anchor: n } = e.selection, l = Math.max(0, n.pos - 2), o = e.doc.resolve(l).node();
  return !(!o || !t.includes(o.type.name));
}, Yp = (e, a) => {
  var t;
  const { $anchor: n } = a.selection, l = a.doc.resolve(n.pos - 2);
  return !(l.index() === 0 || ((t = l.nodeBefore) == null ? void 0 : t.type.name) !== e);
}, Jp = (e, a, t) => {
  if (!t)
    return !1;
  const n = ea(e, a.schema);
  let l = !1;
  return t.descendants((o) => {
    o.type === n && (l = !0);
  }), l;
}, Wu = (e, a, t) => {
  if (e.commands.undoInputRule())
    return !0;
  if (e.state.selection.from !== e.state.selection.to)
    return !1;
  if (!il(e.state, a) && Kp(e.state, a, t)) {
    const { $anchor: i } = e.state.selection, s = e.state.doc.resolve(i.before() - 1), d = [];
    s.node().descendants((g, h) => {
      g.type.name === a && d.push({ node: g, pos: h });
    });
    const c = d.at(-1);
    if (!c)
      return !1;
    const f = e.state.doc.resolve(s.start() + c.pos + 1);
    return e.chain().cut({ from: i.start() - 1, to: i.end() + 1 }, f.end()).joinForward().run();
  }
  if (!il(e.state, a) || !nA(e.state))
    return !1;
  const n = Nr(a, e.state);
  if (!n)
    return !1;
  const o = e.state.doc.resolve(n.$pos.pos - 2).node(n.depth), r = Jp(a, e.state, o);
  return Yp(a, e.state) && !r ? e.commands.joinItemBackward() : e.chain().liftListItem(a).run();
}, Xp = (e, a) => {
  const t = ff(e, a), n = Nr(e, a);
  return !n || !t ? !1 : t > n.depth;
}, Zp = (e, a) => {
  const t = ff(e, a), n = Nr(e, a);
  return !n || !t ? !1 : t < n.depth;
}, qu = (e, a) => {
  if (!il(e.state, a) || !aA(e.state, a))
    return !1;
  const { selection: t } = e.state, { $from: n, $to: l } = t;
  return !t.empty && n.sameParent(l) ? !1 : Xp(a, e.state) ? e.chain().focus(e.state.selection.from + 4).lift(a).joinBackward().run() : Zp(a, e.state) ? e.chain().joinForward().joinBackward().run() : e.commands.joinItemForward();
}, az = (e, a) => {
  var t;
  const { $anchor: n } = a.selection, l = a.doc.resolve(n.pos - n.parentOffset - 2);
  return !(l.index() === l.parent.childCount - 1 || ((t = l.nodeAfter) == null ? void 0 : t.type.name) !== e);
}, Qp = Dt.create({
  name: "listKeymap",
  addOptions() {
    return {
      listTypes: [
        {
          itemName: "listItem",
          wrapperNames: ["bulletList", "orderedList"]
        },
        {
          itemName: "taskItem",
          wrapperNames: ["taskList"]
        }
      ]
    };
  },
  addKeyboardShortcuts() {
    return {
      Delete: ({ editor: e }) => {
        let a = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          e.state.schema.nodes[t] !== void 0 && qu(e, t) && (a = !0);
        }), a;
      },
      "Mod-Delete": ({ editor: e }) => {
        let a = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          e.state.schema.nodes[t] !== void 0 && qu(e, t) && (a = !0);
        }), a;
      },
      Backspace: ({ editor: e }) => {
        let a = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: n }) => {
          e.state.schema.nodes[t] !== void 0 && Wu(e, t, n) && (a = !0);
        }), a;
      },
      "Mod-Backspace": ({ editor: e }) => {
        let a = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: n }) => {
          e.state.schema.nodes[t] !== void 0 && Wu(e, t, n) && (a = !0);
        }), a;
      }
    };
  }
}), Cb = /^(\s*)(\d+)\.\s+(.*)$/, nz = /^\s/;
function lz(e) {
  const a = e.trimStart();
  return /^[-+*]\s+/.test(a) || /^\d+\.\s+/.test(a) || /^>\s?/.test(a) || /^```/.test(a) || /^~~~/.test(a);
}
function oz(e) {
  const a = [], t = [];
  let n = !1;
  return e.forEach((l) => {
    if (n) {
      t.push(l);
      return;
    }
    if (l.trim() === "") {
      n = !0, t.push(l);
      return;
    }
    if (a.length > 0 && lz(l)) {
      n = !0, t.push(l);
      return;
    }
    a.push(l);
  }), {
    paragraphLines: a,
    blockLines: t
  };
}
function rz(e) {
  const a = [];
  let t = 0, n = 0;
  for (; t < e.length; ) {
    const l = e[t], o = l.match(Cb);
    if (!o)
      break;
    const [, r, i, s] = o, d = r.length, c = [s];
    let f = t + 1;
    const g = [l];
    let h = !1;
    for (; f < e.length; ) {
      const v = e[f];
      if (v.match(Cb))
        break;
      if (v.trim() === "")
        g.push(v), c.push(""), h = !0, f += 1;
      else if (v.match(nz))
        g.push(v), c.push(v.slice(d + 2)), f += 1;
      else {
        if (h)
          break;
        g.push(v), c.push(v), f += 1;
      }
    }
    a.push({
      indent: d,
      number: parseInt(i, 10),
      content: c.join(`
`).trim(),
      contentLines: c,
      raw: g.join(`
`)
    }), n = f, t = f;
  }
  return [a, n];
}
function _p(e, a, t) {
  const n = [];
  let l = 0;
  for (; l < e.length; ) {
    const o = e[l];
    if (o.indent === a) {
      const { paragraphLines: r, blockLines: i } = oz(o.contentLines), s = r.join(`
`).trim(), d = [];
      s && d.push({
        type: "paragraph",
        raw: s,
        tokens: t.inlineTokens(s)
      });
      const c = i.join(`
`).trim();
      if (c) {
        const h = t.blockTokens(c);
        d.push(...h);
      }
      let f = l + 1;
      const g = [];
      for (; f < e.length && e[f].indent > a; )
        g.push(e[f]), f += 1;
      if (g.length > 0) {
        const h = Math.min(...g.map((p) => p.indent)), v = _p(g, h, t);
        d.push({
          type: "list",
          ordered: !0,
          start: g[0].number,
          items: v,
          raw: g.map((p) => p.raw).join(`
`)
        });
      }
      n.push({
        type: "list_item",
        raw: o.raw,
        tokens: d
      }), l = f;
    } else
      l += 1;
  }
  return n;
}
function iz(e, a) {
  return e.map((t) => {
    if (t.type !== "list_item")
      return a.parseChildren([t])[0];
    const n = [];
    return t.tokens && t.tokens.length > 0 && t.tokens.forEach((l) => {
      if (l.type === "paragraph" || l.type === "list" || l.type === "blockquote" || l.type === "code")
        n.push(...a.parseChildren([l]));
      else if (l.type === "text" && l.tokens) {
        const o = a.parseChildren([l]);
        n.push({
          type: "paragraph",
          content: o
        });
      } else {
        const o = a.parseChildren([l]);
        o.length > 0 && n.push(...o);
      }
    }), {
      type: "listItem",
      content: n
    };
  });
}
var sz = "listItem", Sb = "textStyle", $b = /^(\d+)\.\s$/, ex = za.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (e) => e.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: a, ...t } = e;
    return a === 1 ? ["ol", qt(this.options.HTMLAttributes, t), 0] : ["ol", qt(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (e, a) => {
    if (e.type !== "list" || !e.ordered)
      return [];
    const t = e.start || 1, n = e.items ? iz(e.items, a) : [];
    return t !== 1 ? {
      type: "orderedList",
      attrs: { start: t },
      content: n
    } : {
      type: "orderedList",
      content: n
    };
  },
  renderMarkdown: (e, a) => e.content ? a.renderChildren(e.content, `
`) : "",
  markdownTokenizer: {
    name: "orderedList",
    level: "block",
    start: (e) => {
      const a = e.match(/^(\s*)(\d+)\.\s+/), t = a == null ? void 0 : a.index;
      return t !== void 0 ? t : -1;
    },
    tokenize: (e, a, t) => {
      var n;
      const l = e.split(`
`), [o, r] = rz(l);
      if (o.length === 0)
        return;
      const i = _p(o, 0, t);
      return i.length === 0 ? void 0 : {
        type: "list",
        ordered: !0,
        start: ((n = o[0]) == null ? void 0 : n.number) || 1,
        items: i,
        raw: l.slice(0, r).join(`
`)
      };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: e, chain: a }) => this.options.keepAttributes ? a().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(sz, this.editor.getAttributes(Sb)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = xo({
      find: $b,
      type: this.type,
      getAttributes: (a) => ({ start: +a[1] }),
      joinPredicate: (a, t) => t.childCount + t.attrs.start === +a[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = xo({
      find: $b,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (a) => ({ start: +a[1], ...this.editor.getAttributes(Sb) }),
      joinPredicate: (a, t) => t.childCount + t.attrs.start === +a[1],
      editor: this.editor
    })), [e];
  }
}), dz = /^\s*(\[([( |x])?\])\s$/, uz = za.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList",
      a11y: void 0
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (e) => {
          const a = e.getAttribute("data-checked");
          return a === "" || a === "true";
        },
        renderHTML: (e) => ({
          "data-checked": e.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: a }) {
    return [
      "li",
      qt(this.options.HTMLAttributes, a, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: e.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  parseMarkdown: (e, a) => {
    const t = [];
    if (e.tokens && e.tokens.length > 0 ? t.push(a.createNode("paragraph", {}, a.parseInline(e.tokens))) : e.text ? t.push(a.createNode("paragraph", {}, [a.createNode("text", { text: e.text })])) : t.push(a.createNode("paragraph", {}, [])), e.nestedTokens && e.nestedTokens.length > 0) {
      const n = a.parseChildren(e.nestedTokens);
      t.push(...n);
    }
    return a.createNode("taskItem", { checked: e.checked || !1 }, t);
  },
  renderMarkdown: (e, a) => {
    var t;
    const l = `- [${(t = e.attrs) != null && t.checked ? "x" : " "}] `;
    return tf(e, a, l);
  },
  addKeyboardShortcuts() {
    const e = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...e,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : e;
  },
  addNodeView() {
    return ({ node: e, HTMLAttributes: a, getPos: t, editor: n }) => {
      const l = document.createElement("li"), o = document.createElement("label"), r = document.createElement("span"), i = document.createElement("input"), s = document.createElement("div"), d = (f) => {
        var g, h;
        i.ariaLabel = ((h = (g = this.options.a11y) == null ? void 0 : g.checkboxLabel) == null ? void 0 : h.call(g, f, i.checked)) || `Task item checkbox for ${f.textContent || "empty task item"}`;
      };
      d(e), o.contentEditable = "false", i.type = "checkbox", i.addEventListener("mousedown", (f) => f.preventDefault()), i.addEventListener("change", (f) => {
        if (!n.isEditable && !this.options.onReadOnlyChecked) {
          i.checked = !i.checked;
          return;
        }
        const { checked: g } = f.target;
        n.isEditable && typeof t == "function" && n.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: h }) => {
          const v = t();
          if (typeof v != "number")
            return !1;
          const p = h.doc.nodeAt(v);
          return h.setNodeMarkup(v, void 0, {
            ...p == null ? void 0 : p.attrs,
            checked: g
          }), !0;
        }).run(), !n.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(e, g) || (i.checked = !i.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([f, g]) => {
        l.setAttribute(f, g);
      }), l.dataset.checked = e.attrs.checked, i.checked = e.attrs.checked, o.append(i, r), l.append(o, s), Object.entries(a).forEach(([f, g]) => {
        l.setAttribute(f, g);
      });
      let c = new Set(Object.keys(a));
      return {
        dom: l,
        contentDOM: s,
        update: (f) => {
          if (f.type !== this.type)
            return !1;
          l.dataset.checked = f.attrs.checked, i.checked = f.attrs.checked, d(f);
          const g = n.extensionManager.attributes, h = Cr(f, g), v = new Set(Object.keys(h)), p = this.options.HTMLAttributes;
          return c.forEach((y) => {
            v.has(y) || (y in p ? l.setAttribute(y, p[y]) : l.removeAttribute(y));
          }), Object.entries(h).forEach(([y, k]) => {
            k == null ? y in p ? l.setAttribute(y, p[y]) : l.removeAttribute(y) : l.setAttribute(y, k);
          }), c = v, !0;
        }
      };
    };
  },
  addInputRules() {
    return [
      xo({
        find: dz,
        type: this.type,
        getAttributes: (e) => ({
          checked: e[e.length - 1] === "x"
        })
      })
    ];
  }
}), cz = za.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", qt(this.options.HTMLAttributes, e, { "data-type": this.name }), 0];
  },
  parseMarkdown: (e, a) => a.createNode("taskList", {}, a.parseChildren(e.items || [])),
  renderMarkdown: (e, a) => e.content ? a.renderChildren(e.content, `
`) : "",
  markdownTokenizer: {
    name: "taskList",
    level: "block",
    start(e) {
      var a;
      const t = (a = e.match(/^\s*[-+*]\s+\[([ xX])\]\s+/)) == null ? void 0 : a.index;
      return t !== void 0 ? t : -1;
    },
    tokenize(e, a, t) {
      const n = (o) => {
        const r = Bu(
          o,
          {
            itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
            extractItemData: (i) => ({
              indentLevel: i[1].length,
              mainContent: i[4],
              checked: i[3].toLowerCase() === "x"
            }),
            createToken: (i, s) => ({
              type: "taskItem",
              raw: "",
              mainContent: i.mainContent,
              indentLevel: i.indentLevel,
              checked: i.checked,
              text: i.mainContent,
              tokens: t.inlineTokens(i.mainContent),
              nestedTokens: s
            }),
            // Allow recursive nesting
            customNestedParser: n
          },
          t
        );
        return r ? [
          {
            type: "taskList",
            raw: r.raw,
            items: r.items
          }
        ] : t.blockTokens(o);
      }, l = Bu(
        e,
        {
          itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
          extractItemData: (o) => ({
            indentLevel: o[1].length,
            mainContent: o[4],
            checked: o[3].toLowerCase() === "x"
          }),
          createToken: (o, r) => ({
            type: "taskItem",
            raw: "",
            mainContent: o.mainContent,
            indentLevel: o.indentLevel,
            checked: o.checked,
            text: o.mainContent,
            tokens: t.inlineTokens(o.mainContent),
            nestedTokens: r
          }),
          // Use the recursive parser for nested content
          customNestedParser: n
        },
        t
      );
      if (l)
        return {
          type: "taskList",
          raw: l.raw,
          items: l.items
        };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: e }) => e.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
});
Dt.create({
  name: "listKit",
  addExtensions() {
    const e = [];
    return this.options.bulletList !== !1 && e.push(Up.configure(this.options.bulletList)), this.options.listItem !== !1 && e.push(Gp.configure(this.options.listItem)), this.options.listKeymap !== !1 && e.push(Qp.configure(this.options.listKeymap)), this.options.orderedList !== !1 && e.push(ex.configure(this.options.orderedList)), this.options.taskItem !== !1 && e.push(uz.configure(this.options.taskItem)), this.options.taskList !== !1 && e.push(cz.configure(this.options.taskList)), e;
  }
});
var li = "&nbsp;", Md = " ", fz = za.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", qt(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown: (e, a) => {
    const t = e.tokens || [];
    if (t.length === 1 && t[0].type === "image")
      return a.parseChildren([t[0]]);
    const n = a.parseInline(t);
    return t.length === 1 && t[0].type === "text" && (t[0].raw === li || t[0].text === li || t[0].raw === Md || t[0].text === Md) && n.length === 1 && n[0].type === "text" && (n[0].text === li || n[0].text === Md) ? a.createNode("paragraph", void 0, []) : a.createNode("paragraph", void 0, n);
  },
  renderMarkdown: (e, a, t) => {
    var n, l;
    if (!e)
      return "";
    const o = Array.isArray(e.content) ? e.content : [];
    if (o.length === 0) {
      const r = Array.isArray((n = t == null ? void 0 : t.previousNode) == null ? void 0 : n.content) ? t.previousNode.content : [];
      return ((l = t == null ? void 0 : t.previousNode) == null ? void 0 : l.type) === "paragraph" && r.length === 0 ? li : "";
    }
    return a.renderChildren(o);
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: e }) => e.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), hz = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, bz = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, gz = Fn.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["s", qt(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "del",
  parseMarkdown: (e, a) => a.applyMark("strike", a.parseInline(e.tokens || [])),
  renderMarkdown: (e, a) => `~~${a.renderChildren(e)}~~`,
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      Nl({
        find: hz,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      sl({
        find: bz,
        type: this.type
      })
    ];
  }
}), mz = za.create({
  name: "text",
  group: "inline",
  parseMarkdown: (e) => ({
    type: "text",
    text: e.text || ""
  }),
  renderMarkdown: (e) => e.text || ""
}), vz = Fn.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["u", qt(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown(e, a) {
    return a.applyMark(this.name || "underline", a.parseInline(e.tokens || []));
  },
  renderMarkdown(e, a) {
    return `++${a.renderChildren(e)}++`;
  },
  markdownTokenizer: {
    name: "underline",
    level: "inline",
    start(e) {
      return e.indexOf("++");
    },
    tokenize(e, a, t) {
      const l = /^(\+\+)([\s\S]+?)(\+\+)/.exec(e);
      if (!l)
        return;
      const o = l[2].trim();
      return {
        type: "underline",
        raw: l[0],
        text: o,
        tokens: t.inlineTokens(o)
      };
    }
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: e }) => e.setMark(this.name),
      toggleUnderline: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetUnderline: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
function pz(e = {}) {
  return new Ut({
    view(a) {
      return new xz(a, e);
    }
  });
}
class xz {
  constructor(a, t) {
    var n;
    this.editorView = a, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (n = t.width) !== null && n !== void 0 ? n : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((l) => {
      let o = (r) => {
        this[l](r);
      };
      return a.dom.addEventListener(l, o), { name: l, handler: o };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: a, handler: t }) => this.editorView.dom.removeEventListener(a, t));
  }
  update(a, t) {
    this.cursorPos != null && t.doc != a.state.doc && (this.cursorPos > a.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(a) {
    a != this.cursorPos && (this.cursorPos = a, a == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let a = this.editorView.state.doc.resolve(this.cursorPos), t = !a.parent.inlineContent, n, l = this.editorView.dom, o = l.getBoundingClientRect(), r = o.width / l.offsetWidth, i = o.height / l.offsetHeight;
    if (t) {
      let f = a.nodeBefore, g = a.nodeAfter;
      if (f || g) {
        let h = this.editorView.nodeDOM(this.cursorPos - (f ? f.nodeSize : 0));
        if (h) {
          let v = h.getBoundingClientRect(), p = f ? v.bottom : v.top;
          f && g && (p = (p + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let y = this.width / 2 * i;
          n = { left: v.left, right: v.right, top: p - y, bottom: p + y };
        }
      }
    }
    if (!n) {
      let f = this.editorView.coordsAtPos(this.cursorPos), g = this.width / 2 * r;
      n = { left: f.left - g, right: f.left + g, top: f.top, bottom: f.bottom };
    }
    let s = this.editorView.dom.offsetParent;
    this.element || (this.element = s.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let d, c;
    if (!s || s == document.body && getComputedStyle(s).position == "static")
      d = -pageXOffset, c = -pageYOffset;
    else {
      let f = s.getBoundingClientRect(), g = f.width / s.offsetWidth, h = f.height / s.offsetHeight;
      d = f.left - s.scrollLeft * g, c = f.top - s.scrollTop * h;
    }
    this.element.style.left = (n.left - d) / r + "px", this.element.style.top = (n.top - c) / i + "px", this.element.style.width = (n.right - n.left) / r + "px", this.element.style.height = (n.bottom - n.top) / i + "px";
  }
  scheduleRemoval(a) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), a);
  }
  dragover(a) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: a.clientX, top: a.clientY }), n = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), l = n && n.type.spec.disableDropCursor, o = typeof l == "function" ? l(this.editorView, t, a) : l;
    if (t && !o) {
      let r = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let i = _m(this.editorView.state.doc, r, this.editorView.dragging.slice);
        i != null && (r = i);
      }
      this.setCursor(r), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(a) {
    this.editorView.dom.contains(a.relatedTarget) || this.setCursor(null);
  }
}
class Yt extends xt {
  /**
  Create a gap cursor.
  */
  constructor(a) {
    super(a, a);
  }
  map(a, t) {
    let n = a.resolve(t.map(this.head));
    return Yt.valid(n) ? new Yt(n) : xt.near(n);
  }
  content() {
    return tt.empty;
  }
  eq(a) {
    return a instanceof Yt && a.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(a, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Yt(a.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new hf(this.anchor);
  }
  /**
  @internal
  */
  static valid(a) {
    let t = a.parent;
    if (t.inlineContent || !yz(a) || !kz(a))
      return !1;
    let n = t.type.spec.allowGapCursor;
    if (n != null)
      return n;
    let l = t.contentMatchAt(a.index()).defaultType;
    return l && l.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(a, t, n = !1) {
    e: for (; ; ) {
      if (!n && Yt.valid(a))
        return a;
      let l = a.pos, o = null;
      for (let r = a.depth; ; r--) {
        let i = a.node(r);
        if (t > 0 ? a.indexAfter(r) < i.childCount : a.index(r) > 0) {
          o = i.child(t > 0 ? a.indexAfter(r) : a.index(r) - 1);
          break;
        } else if (r == 0)
          return null;
        l += t;
        let s = a.doc.resolve(l);
        if (Yt.valid(s))
          return s;
      }
      for (; ; ) {
        let r = t > 0 ? o.firstChild : o.lastChild;
        if (!r) {
          if (o.isAtom && !o.isText && !dt.isSelectable(o)) {
            a = a.doc.resolve(l + o.nodeSize * t), n = !1;
            continue e;
          }
          break;
        }
        o = r, l += t;
        let i = a.doc.resolve(l);
        if (Yt.valid(i))
          return i;
      }
      return null;
    }
  }
}
Yt.prototype.visible = !1;
Yt.findFrom = Yt.findGapCursorFrom;
xt.jsonID("gapcursor", Yt);
class hf {
  constructor(a) {
    this.pos = a;
  }
  map(a) {
    return new hf(a.map(this.pos));
  }
  resolve(a) {
    let t = a.resolve(this.pos);
    return Yt.valid(t) ? new Yt(t) : xt.near(t);
  }
}
function tx(e) {
  return e.isAtom || e.spec.isolating || e.spec.createGapCursor;
}
function yz(e) {
  for (let a = e.depth; a >= 0; a--) {
    let t = e.index(a), n = e.node(a);
    if (t == 0) {
      if (n.type.spec.isolating)
        return !0;
      continue;
    }
    for (let l = n.child(t - 1); ; l = l.lastChild) {
      if (l.childCount == 0 && !l.inlineContent || tx(l.type))
        return !0;
      if (l.inlineContent)
        return !1;
    }
  }
  return !0;
}
function kz(e) {
  for (let a = e.depth; a >= 0; a--) {
    let t = e.indexAfter(a), n = e.node(a);
    if (t == n.childCount) {
      if (n.type.spec.isolating)
        return !0;
      continue;
    }
    for (let l = n.child(t); ; l = l.firstChild) {
      if (l.childCount == 0 && !l.inlineContent || tx(l.type))
        return !0;
      if (l.inlineContent)
        return !1;
    }
  }
  return !0;
}
function wz() {
  return new Ut({
    props: {
      decorations: Iz,
      createSelectionBetween(e, a, t) {
        return a.pos == t.pos && Yt.valid(t) ? new Yt(t) : null;
      },
      handleClick: Sz,
      handleKeyDown: Cz,
      handleDOMEvents: { beforeinput: $z }
    }
  });
}
const Cz = tp({
  ArrowLeft: oi("horiz", -1),
  ArrowRight: oi("horiz", 1),
  ArrowUp: oi("vert", -1),
  ArrowDown: oi("vert", 1)
});
function oi(e, a) {
  const t = e == "vert" ? a > 0 ? "down" : "up" : a > 0 ? "right" : "left";
  return function(n, l, o) {
    let r = n.selection, i = a > 0 ? r.$to : r.$from, s = r.empty;
    if (r instanceof ht) {
      if (!o.endOfTextblock(t) || i.depth == 0)
        return !1;
      s = !1, i = n.doc.resolve(a > 0 ? i.after() : i.before());
    }
    let d = Yt.findGapCursorFrom(i, a, s);
    return d ? (l && l(n.tr.setSelection(new Yt(d))), !0) : !1;
  };
}
function Sz(e, a, t) {
  if (!e || !e.editable)
    return !1;
  let n = e.state.doc.resolve(a);
  if (!Yt.valid(n))
    return !1;
  let l = e.posAtCoords({ left: t.clientX, top: t.clientY });
  return l && l.inside > -1 && dt.isSelectable(e.state.doc.nodeAt(l.inside)) ? !1 : (e.dispatch(e.state.tr.setSelection(new Yt(n))), !0);
}
function $z(e, a) {
  if (a.inputType != "insertCompositionText" || !(e.state.selection instanceof Yt))
    return !1;
  let { $from: t } = e.state.selection, n = t.parent.contentMatchAt(t.index()).findWrapping(e.state.schema.nodes.text);
  if (!n)
    return !1;
  let l = We.empty;
  for (let r = n.length - 1; r >= 0; r--)
    l = We.from(n[r].createAndFill(null, l));
  let o = e.state.tr.replace(t.pos, t.pos, new tt(l, 0, 0));
  return o.setSelection(ht.near(o.doc.resolve(t.pos + 1))), e.dispatch(o), !1;
}
function Iz(e) {
  if (!(e.selection instanceof Yt))
    return null;
  let a = document.createElement("div");
  return a.className = "ProseMirror-gapcursor", jt.create(e.doc, [Ca.widget(e.selection.head, a, { key: "gapcursor" })]);
}
var ws = 200, ia = function() {
};
ia.prototype.append = function(a) {
  return a.length ? (a = ia.from(a), !this.length && a || a.length < ws && this.leafAppend(a) || this.length < ws && a.leafPrepend(this) || this.appendInner(a)) : this;
};
ia.prototype.prepend = function(a) {
  return a.length ? ia.from(a).append(this) : this;
};
ia.prototype.appendInner = function(a) {
  return new Lz(this, a);
};
ia.prototype.slice = function(a, t) {
  return a === void 0 && (a = 0), t === void 0 && (t = this.length), a >= t ? ia.empty : this.sliceInner(Math.max(0, a), Math.min(this.length, t));
};
ia.prototype.get = function(a) {
  if (!(a < 0 || a >= this.length))
    return this.getInner(a);
};
ia.prototype.forEach = function(a, t, n) {
  t === void 0 && (t = 0), n === void 0 && (n = this.length), t <= n ? this.forEachInner(a, t, n, 0) : this.forEachInvertedInner(a, t, n, 0);
};
ia.prototype.map = function(a, t, n) {
  t === void 0 && (t = 0), n === void 0 && (n = this.length);
  var l = [];
  return this.forEach(function(o, r) {
    return l.push(a(o, r));
  }, t, n), l;
};
ia.from = function(a) {
  return a instanceof ia ? a : a && a.length ? new ax(a) : ia.empty;
};
var ax = /* @__PURE__ */ function(e) {
  function a(n) {
    e.call(this), this.values = n;
  }
  e && (a.__proto__ = e), a.prototype = Object.create(e && e.prototype), a.prototype.constructor = a;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return a.prototype.flatten = function() {
    return this.values;
  }, a.prototype.sliceInner = function(l, o) {
    return l == 0 && o == this.length ? this : new a(this.values.slice(l, o));
  }, a.prototype.getInner = function(l) {
    return this.values[l];
  }, a.prototype.forEachInner = function(l, o, r, i) {
    for (var s = o; s < r; s++)
      if (l(this.values[s], i + s) === !1)
        return !1;
  }, a.prototype.forEachInvertedInner = function(l, o, r, i) {
    for (var s = o - 1; s >= r; s--)
      if (l(this.values[s], i + s) === !1)
        return !1;
  }, a.prototype.leafAppend = function(l) {
    if (this.length + l.length <= ws)
      return new a(this.values.concat(l.flatten()));
  }, a.prototype.leafPrepend = function(l) {
    if (this.length + l.length <= ws)
      return new a(l.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(a.prototype, t), a;
}(ia);
ia.empty = new ax([]);
var Lz = /* @__PURE__ */ function(e) {
  function a(t, n) {
    e.call(this), this.left = t, this.right = n, this.length = t.length + n.length, this.depth = Math.max(t.depth, n.depth) + 1;
  }
  return e && (a.__proto__ = e), a.prototype = Object.create(e && e.prototype), a.prototype.constructor = a, a.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, a.prototype.getInner = function(n) {
    return n < this.left.length ? this.left.get(n) : this.right.get(n - this.left.length);
  }, a.prototype.forEachInner = function(n, l, o, r) {
    var i = this.left.length;
    if (l < i && this.left.forEachInner(n, l, Math.min(o, i), r) === !1 || o > i && this.right.forEachInner(n, Math.max(l - i, 0), Math.min(this.length, o) - i, r + i) === !1)
      return !1;
  }, a.prototype.forEachInvertedInner = function(n, l, o, r) {
    var i = this.left.length;
    if (l > i && this.right.forEachInvertedInner(n, l - i, Math.max(o, i) - i, r + i) === !1 || o < i && this.left.forEachInvertedInner(n, Math.min(l, i), o, r) === !1)
      return !1;
  }, a.prototype.sliceInner = function(n, l) {
    if (n == 0 && l == this.length)
      return this;
    var o = this.left.length;
    return l <= o ? this.left.slice(n, l) : n >= o ? this.right.slice(n - o, l - o) : this.left.slice(n, o).append(this.right.slice(0, l - o));
  }, a.prototype.leafAppend = function(n) {
    var l = this.right.leafAppend(n);
    if (l)
      return new a(this.left, l);
  }, a.prototype.leafPrepend = function(n) {
    var l = this.left.leafPrepend(n);
    if (l)
      return new a(l, this.right);
  }, a.prototype.appendInner = function(n) {
    return this.left.depth >= Math.max(this.right.depth, n.depth) + 1 ? new a(this.left, new a(this.right, n)) : new a(this, n);
  }, a;
}(ia);
const Tz = 500;
class an {
  constructor(a, t) {
    this.items = a, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(a, t) {
    if (this.eventCount == 0)
      return null;
    let n = this.items.length;
    for (; ; n--)
      if (this.items.get(n - 1).selection) {
        --n;
        break;
      }
    let l, o;
    t && (l = this.remapping(n, this.items.length), o = l.maps.length);
    let r = a.tr, i, s, d = [], c = [];
    return this.items.forEach((f, g) => {
      if (!f.step) {
        l || (l = this.remapping(n, g + 1), o = l.maps.length), o--, c.push(f);
        return;
      }
      if (l) {
        c.push(new cn(f.map));
        let h = f.step.map(l.slice(o)), v;
        h && r.maybeStep(h).doc && (v = r.mapping.maps[r.mapping.maps.length - 1], d.push(new cn(v, void 0, void 0, d.length + c.length))), o--, v && l.appendMap(v, o);
      } else
        r.maybeStep(f.step);
      if (f.selection)
        return i = l ? f.selection.map(l.slice(o)) : f.selection, s = new an(this.items.slice(0, n).append(c.reverse().concat(d)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: s, transform: r, selection: i };
  }
  // Create a new branch with the given transform added.
  addTransform(a, t, n, l) {
    let o = [], r = this.eventCount, i = this.items, s = !l && i.length ? i.get(i.length - 1) : null;
    for (let c = 0; c < a.steps.length; c++) {
      let f = a.steps[c].invert(a.docs[c]), g = new cn(a.mapping.maps[c], f, t), h;
      (h = s && s.merge(g)) && (g = h, c ? o.pop() : i = i.slice(0, i.length - 1)), o.push(g), t && (r++, t = void 0), l || (s = g);
    }
    let d = r - n.depth;
    return d > Az && (i = Ez(i, d), r -= d), new an(i.append(o), r);
  }
  remapping(a, t) {
    let n = new vr();
    return this.items.forEach((l, o) => {
      let r = l.mirrorOffset != null && o - l.mirrorOffset >= a ? n.maps.length - l.mirrorOffset : void 0;
      n.appendMap(l.map, r);
    }, a, t), n;
  }
  addMaps(a) {
    return this.eventCount == 0 ? this : new an(this.items.append(a.map((t) => new cn(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(a, t) {
    if (!this.eventCount)
      return this;
    let n = [], l = Math.max(0, this.items.length - t), o = a.mapping, r = a.steps.length, i = this.eventCount;
    this.items.forEach((g) => {
      g.selection && i--;
    }, l);
    let s = t;
    this.items.forEach((g) => {
      let h = o.getMirror(--s);
      if (h == null)
        return;
      r = Math.min(r, h);
      let v = o.maps[h];
      if (g.step) {
        let p = a.steps[h].invert(a.docs[h]), y = g.selection && g.selection.map(o.slice(s + 1, h));
        y && i++, n.push(new cn(v, p, y));
      } else
        n.push(new cn(v));
    }, l);
    let d = [];
    for (let g = t; g < r; g++)
      d.push(new cn(o.maps[g]));
    let c = this.items.slice(0, l).append(d).append(n), f = new an(c, i);
    return f.emptyItemCount() > Tz && (f = f.compress(this.items.length - n.length)), f;
  }
  emptyItemCount() {
    let a = 0;
    return this.items.forEach((t) => {
      t.step || a++;
    }), a;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(a = this.items.length) {
    let t = this.remapping(0, a), n = t.maps.length, l = [], o = 0;
    return this.items.forEach((r, i) => {
      if (i >= a)
        l.push(r), r.selection && o++;
      else if (r.step) {
        let s = r.step.map(t.slice(n)), d = s && s.getMap();
        if (n--, d && t.appendMap(d, n), s) {
          let c = r.selection && r.selection.map(t.slice(n));
          c && o++;
          let f = new cn(d.invert(), s, c), g, h = l.length - 1;
          (g = l.length && l[h].merge(f)) ? l[h] = g : l.push(f);
        }
      } else r.map && n--;
    }, this.items.length, 0), new an(ia.from(l.reverse()), o);
  }
}
an.empty = new an(ia.empty, 0);
function Ez(e, a) {
  let t;
  return e.forEach((n, l) => {
    if (n.selection && a-- == 0)
      return t = l, !1;
  }), e.slice(t);
}
class cn {
  constructor(a, t, n, l) {
    this.map = a, this.step = t, this.selection = n, this.mirrorOffset = l;
  }
  merge(a) {
    if (this.step && a.step && !a.selection) {
      let t = a.step.merge(this.step);
      if (t)
        return new cn(t.getMap().invert(), t, this.selection);
    }
  }
}
class Wn {
  constructor(a, t, n, l, o) {
    this.done = a, this.undone = t, this.prevRanges = n, this.prevTime = l, this.prevComposition = o;
  }
}
const Az = 20;
function Rz(e, a, t, n) {
  let l = t.getMeta(Rl), o;
  if (l)
    return l.historyState;
  t.getMeta(Bz) && (e = new Wn(e.done, e.undone, null, 0, -1));
  let r = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return e;
  if (r && r.getMeta(Rl))
    return r.getMeta(Rl).redo ? new Wn(e.done.addTransform(t, void 0, n, Ci(a)), e.undone, Ib(t.mapping.maps), e.prevTime, e.prevComposition) : new Wn(e.done, e.undone.addTransform(t, void 0, n, Ci(a)), null, e.prevTime, e.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(r && r.getMeta("addToHistory") === !1)) {
    let i = t.getMeta("composition"), s = e.prevTime == 0 || !r && e.prevComposition != i && (e.prevTime < (t.time || 0) - n.newGroupDelay || !zz(t, e.prevRanges)), d = r ? Od(e.prevRanges, t.mapping) : Ib(t.mapping.maps);
    return new Wn(e.done.addTransform(t, s ? a.selection.getBookmark() : void 0, n, Ci(a)), an.empty, d, t.time, i ?? e.prevComposition);
  } else return (o = t.getMeta("rebased")) ? new Wn(e.done.rebased(t, o), e.undone.rebased(t, o), Od(e.prevRanges, t.mapping), e.prevTime, e.prevComposition) : new Wn(e.done.addMaps(t.mapping.maps), e.undone.addMaps(t.mapping.maps), Od(e.prevRanges, t.mapping), e.prevTime, e.prevComposition);
}
function zz(e, a) {
  if (!a)
    return !1;
  if (!e.docChanged)
    return !0;
  let t = !1;
  return e.mapping.maps[0].forEach((n, l) => {
    for (let o = 0; o < a.length; o += 2)
      n <= a[o + 1] && l >= a[o] && (t = !0);
  }), t;
}
function Ib(e) {
  let a = [];
  for (let t = e.length - 1; t >= 0 && a.length == 0; t--)
    e[t].forEach((n, l, o, r) => a.push(o, r));
  return a;
}
function Od(e, a) {
  if (!e)
    return null;
  let t = [];
  for (let n = 0; n < e.length; n += 2) {
    let l = a.map(e[n], 1), o = a.map(e[n + 1], -1);
    l <= o && t.push(l, o);
  }
  return t;
}
function Dz(e, a, t) {
  let n = Ci(a), l = Rl.get(a).spec.config, o = (t ? e.undone : e.done).popEvent(a, n);
  if (!o)
    return null;
  let r = o.selection.resolve(o.transform.doc), i = (t ? e.done : e.undone).addTransform(o.transform, a.selection.getBookmark(), l, n), s = new Wn(t ? i : o.remaining, t ? o.remaining : i, null, 0, -1);
  return o.transform.setSelection(r).setMeta(Rl, { redo: t, historyState: s });
}
let Pd = !1, Lb = null;
function Ci(e) {
  let a = e.plugins;
  if (Lb != a) {
    Pd = !1, Lb = a;
    for (let t = 0; t < a.length; t++)
      if (a[t].spec.historyPreserveItems) {
        Pd = !0;
        break;
      }
  }
  return Pd;
}
const Rl = new la("history"), Bz = new la("closeHistory");
function Mz(e = {}) {
  return e = {
    depth: e.depth || 100,
    newGroupDelay: e.newGroupDelay || 500
  }, new Ut({
    key: Rl,
    state: {
      init() {
        return new Wn(an.empty, an.empty, null, 0, -1);
      },
      apply(a, t, n) {
        return Rz(t, n, a, e);
      }
    },
    config: e,
    props: {
      handleDOMEvents: {
        beforeinput(a, t) {
          let n = t.inputType, l = n == "historyUndo" ? lx : n == "historyRedo" ? ox : null;
          return !l || !a.editable ? !1 : (t.preventDefault(), l(a.state, a.dispatch));
        }
      }
    }
  });
}
function nx(e, a) {
  return (t, n) => {
    let l = Rl.getState(t);
    if (!l || (e ? l.undone : l.done).eventCount == 0)
      return !1;
    if (n) {
      let o = Dz(l, t, e);
      o && n(a ? o.scrollIntoView() : o);
    }
    return !0;
  };
}
const lx = nx(!1, !0), ox = nx(!0, !0);
Dt.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      autoTrim: !0,
      mode: "textSize",
      textCounter: (e) => e.length,
      wordCounter: (e) => e.split(" ").filter((a) => a !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (e) => {
      const a = (e == null ? void 0 : e.node) || this.editor.state.doc;
      if (((e == null ? void 0 : e.mode) || this.options.mode) === "textSize") {
        const n = a.textBetween(0, a.content.size, void 0, " ");
        return this.options.textCounter(n);
      }
      return a.nodeSize;
    }, this.storage.words = (e) => {
      const a = (e == null ? void 0 : e.node) || this.editor.state.doc, t = a.textBetween(0, a.content.size, " ", " ");
      return this.options.wordCounter(t);
    };
  },
  addProseMirrorPlugins() {
    let e = !1;
    return [
      new Ut({
        key: new la("characterCount"),
        appendTransaction: (a, t, n) => {
          if (e)
            return;
          const l = this.options.limit, o = this.options.autoTrim;
          if (l == null || l === 0 || o === !1) {
            e = !0;
            return;
          }
          const r = this.storage.characters({ node: n.doc });
          if (r > l) {
            const i = r - l, s = 0, d = i;
            console.warn(
              `[CharacterCount] Initial content exceeded limit of ${l} characters. Content was automatically trimmed.`
            );
            const c = n.tr.deleteRange(s, d);
            return e = !0, c;
          }
          e = !0;
        },
        filterTransaction: (a, t) => {
          const n = this.options.limit;
          if (!a.docChanged || n === 0 || n === null || n === void 0)
            return !0;
          const l = this.storage.characters({ node: t.doc }), o = this.storage.characters({ node: a.doc });
          if (o <= n || l > n && o > n && o <= l)
            return !0;
          if (l > n && o > n && o > l || !a.getMeta("paste"))
            return !1;
          const i = a.selection.$head.pos, s = o - n, d = i - s, c = i;
          return a.deleteRange(d, c), !(this.storage.characters({ node: a.doc }) > n);
        }
      })
    ];
  }
});
var Oz = Dt.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [pz(this.options)];
  }
});
Dt.create({
  name: "focus",
  addOptions() {
    return {
      className: "has-focus",
      mode: "all"
    };
  },
  addProseMirrorPlugins() {
    return [
      new Ut({
        key: new la("focus"),
        props: {
          decorations: ({ doc: e, selection: a }) => {
            const { isEditable: t, isFocused: n } = this.editor, { anchor: l } = a, o = [];
            if (!t || !n)
              return jt.create(e, []);
            let r = 0;
            this.options.mode === "deepest" && e.descendants((s, d) => {
              if (s.isText)
                return;
              if (!(l >= d && l <= d + s.nodeSize - 1))
                return !1;
              r += 1;
            });
            let i = 0;
            return e.descendants((s, d) => {
              if (s.isText || !(l >= d && l <= d + s.nodeSize - 1))
                return !1;
              if (i += 1, this.options.mode === "deepest" && r - i > 0 || this.options.mode === "shallowest" && i > 1)
                return this.options.mode === "deepest";
              o.push(
                Ca.node(d, d + s.nodeSize, {
                  class: this.options.className
                })
              );
            }), jt.create(e, o);
          }
        }
      })
    ];
  }
});
var Pz = Dt.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [wz()];
  },
  extendNodeSchema(e) {
    var a;
    const t = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      allowGapCursor: (a = Et(rt(e, "allowGapCursor", t))) != null ? a : null
    };
  }
});
function Tb(e) {
  const {
    editor: a,
    placeholder: t,
    dataAttribute: n,
    pos: l,
    node: o,
    isEmptyDoc: r,
    hasAnchor: i,
    classes: { emptyNode: s, emptyEditor: d }
  } = e, c = [s];
  return r && c.push(d), Ca.node(l, l + o.nodeSize, {
    class: c.join(" "),
    [n]: typeof t == "function" ? t({
      editor: a,
      node: o,
      pos: l,
      hasAnchor: i
    }) : t
  });
}
function Fz(e) {
  const a = getComputedStyle(e), t = `${a.overflow} ${a.overflowY} ${a.overflowX}`;
  return /auto|scroll|overlay/.test(t);
}
function Nz(e) {
  let a = e;
  for (; a; ) {
    if (Fz(a))
      return a;
    const t = a.parentElement;
    if (!t) {
      const n = a.getRootNode();
      if (n instanceof ShadowRoot) {
        a = n.host;
        continue;
      }
      return window;
    }
    a = t;
  }
  return window;
}
function Vz(e) {
  return e === window ? { top: 0, bottom: window.innerHeight } : e.getBoundingClientRect();
}
function Hz({
  doc: e,
  view: a,
  scrollContainer: t
}) {
  const n = a.dom.getBoundingClientRect(), l = t ? Vz(t) : { top: 0, bottom: window.innerHeight }, o = Math.max(n.top, l.top), r = Math.min(n.bottom, l.bottom);
  if (o >= r)
    return { top: 0, bottom: e.content.size };
  const s = getComputedStyle(a.dom).direction === "rtl" ? Math.max(n.right - 2, n.left + 2) : n.left + 2, d = a.posAtCoords({ left: s, top: o + 2 }), c = a.posAtCoords({ left: s, top: r - 2 });
  return {
    top: d ? d.pos : 0,
    bottom: c ? c.pos : e.content.size
  };
}
function jz(e, a) {
  let t = null;
  return { call: (...o) => {
    t || (e(...o), t = setTimeout(() => {
      t = null;
    }, a));
  }, cancel: () => {
    t && (clearTimeout(t), t = null);
  } };
}
var Eb = "placeholder";
function Wz(e) {
  return e.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "").replace(/^[0-9-]+/, "").replace(/^-+/, "").toLowerCase();
}
var Mo = new la("tiptap__placeholder");
Dt.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      dataAttribute: Eb,
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    const e = this.options.dataAttribute ? `data-${Wz(this.options.dataAttribute)}` : `data-${Eb}`;
    return [
      new Ut({
        state: {
          init() {
            return {
              // null means "no viewport info yet" — decoration callback falls
              // back to full document scan until the scroll handler fires.
              topPos: null,
              bottomPos: null
            };
          },
          apply(a, t) {
            const n = a.getMeta(Mo);
            return n != null && n.positions ? {
              topPos: n.positions.top,
              bottomPos: n.positions.bottom
            } : a.docChanged ? {
              topPos: t.topPos !== null ? a.mapping.map(t.topPos) : null,
              bottomPos: t.bottomPos !== null ? a.mapping.map(t.bottomPos) : null
            } : t;
          }
        },
        key: Mo,
        view(a) {
          const t = Nz(a.dom), n = () => {
            const i = Hz({
              view: a,
              doc: a.state.doc,
              scrollContainer: t
            }), s = Mo.getState(a.state);
            if (s.topPos === i.top && s.bottomPos === i.bottom)
              return;
            const d = a.state.tr.setMeta(Mo, { positions: i }).setMeta("tiptap__viewportUpdate", !0);
            a.dispatch(d);
          }, { call: l, cancel: o } = jz(n, 250), r = t;
          return r.addEventListener("scroll", l, { passive: !0 }), n(), {
            update(i, s) {
              a.state.doc.content.size !== s.doc.content.size && n();
            },
            destroy: () => {
              o(), r.removeEventListener("scroll", l);
            }
          };
        },
        props: {
          decorations: ({ doc: a, selection: t }) => {
            var n, l;
            if (!(this.editor.isEditable || !this.options.showOnlyWhenEditable))
              return null;
            const { anchor: r } = t, i = [], s = this.editor.isEmpty;
            if (this.options.showOnlyCurrent && !this.options.includeChildren) {
              const c = a.resolve(r);
              if (c.depth > 0) {
                const f = c.node(1), g = c.before(1);
                if (f.type.isTextblock && Sr(f)) {
                  const h = r >= g && r <= g + f.nodeSize, v = Tb({
                    node: f,
                    dataAttribute: e,
                    hasAnchor: h,
                    placeholder: this.options.placeholder,
                    classes: {
                      emptyEditor: this.options.emptyEditorClass,
                      emptyNode: this.options.emptyNodeClass
                    },
                    editor: this.editor,
                    isEmptyDoc: s,
                    pos: c.before(1)
                  });
                  i.push(v);
                }
              }
            } else {
              const c = Mo.getState(this.editor.state), f = (n = c.topPos) != null ? n : 0, g = (l = c.bottomPos) != null ? l : a.content.size;
              a.nodesBetween(f, g, (h, v) => {
                const p = r >= v && r <= v + h.nodeSize, y = !h.isLeaf && Sr(h);
                if (!h.type.isTextblock)
                  return this.options.includeChildren;
                if ((p || !this.options.showOnlyCurrent) && y) {
                  const k = Tb({
                    classes: { emptyEditor: this.options.emptyEditorClass, emptyNode: this.options.emptyNodeClass },
                    editor: this.editor,
                    isEmptyDoc: s,
                    dataAttribute: e,
                    hasAnchor: p,
                    placeholder: this.options.placeholder,
                    node: h,
                    pos: v
                  });
                  i.push(k);
                }
                return this.options.includeChildren;
              });
            }
            return jt.create(a, i);
          }
        }
      })
    ];
  }
});
Dt.create({
  name: "selection",
  addOptions() {
    return {
      className: "selection"
    };
  },
  addProseMirrorPlugins() {
    const { editor: e, options: a } = this;
    return [
      new Ut({
        key: new la("selection"),
        props: {
          decorations(t) {
            return t.selection.empty || e.isFocused || !e.isEditable || vp(t.selection) || e.view.dragging ? null : jt.create(t.doc, [
              Ca.inline(t.selection.from, t.selection.to, {
                class: a.className
              })
            ]);
          }
        }
      })
    ];
  }
});
var qz = "skipTrailingNode";
function Ab({ types: e, node: a }) {
  return a && Array.isArray(e) && e.includes(a.type) || (a == null ? void 0 : a.type) === e;
}
var Uz = Dt.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: void 0,
      notAfter: []
    };
  },
  addProseMirrorPlugins() {
    var e;
    const a = new la(this.name), t = this.options.node || ((e = this.editor.schema.topNodeType.contentMatch.defaultType) == null ? void 0 : e.name) || "paragraph", n = Object.entries(this.editor.schema.nodes).map(([, l]) => l).filter((l) => (this.options.notAfter || []).concat(t).includes(l.name));
    return [
      new Ut({
        key: a,
        appendTransaction: (l, o, r) => {
          const { doc: i, tr: s, schema: d } = r, c = a.getState(r), f = i.content.size, g = d.nodes[t];
          if (!l.some((h) => h.getMeta(qz)) && c)
            return s.insert(f, g.create());
        },
        state: {
          init: (l, o) => {
            const r = o.tr.doc.lastChild;
            return !Ab({ node: r, types: n });
          },
          apply: (l, o) => {
            if (!l.docChanged || l.getMeta("__uniqueIDTransaction"))
              return o;
            const r = l.doc.lastChild;
            return !Ab({ node: r, types: n });
          }
        }
      })
    ];
  }
}), Gz = Dt.create({
  name: "undoRedo",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: e, dispatch: a }) => lx(e, a),
      redo: () => ({ state: e, dispatch: a }) => ox(e, a)
    };
  },
  addProseMirrorPlugins() {
    return [Mz(this.options)];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), Kz = Dt.create({
  name: "starterKit",
  addExtensions() {
    var e, a, t, n;
    const l = [];
    return this.options.bold !== !1 && l.push(sR.configure(this.options.bold)), this.options.blockquote !== !1 && l.push(nR.configure(this.options.blockquote)), this.options.bulletList !== !1 && l.push(Up.configure(this.options.bulletList)), this.options.code !== !1 && l.push(cR.configure(this.options.code)), this.options.codeBlock !== !1 && l.push(bR.configure(this.options.codeBlock)), this.options.document !== !1 && l.push(gR.configure(this.options.document)), this.options.dropcursor !== !1 && l.push(Oz.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && l.push(Pz.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && l.push(mR.configure(this.options.hardBreak)), this.options.heading !== !1 && l.push(vR.configure(this.options.heading)), this.options.undoRedo !== !1 && l.push(Gz.configure(this.options.undoRedo)), this.options.horizontalRule !== !1 && l.push(pR.configure(this.options.horizontalRule)), this.options.italic !== !1 && l.push(CR.configure(this.options.italic)), this.options.listItem !== !1 && l.push(Gp.configure(this.options.listItem)), this.options.listKeymap !== !1 && l.push(Qp.configure((e = this.options) == null ? void 0 : e.listKeymap)), this.options.link !== !1 && l.push(JR.configure((a = this.options) == null ? void 0 : a.link)), this.options.orderedList !== !1 && l.push(ex.configure(this.options.orderedList)), this.options.paragraph !== !1 && l.push(fz.configure(this.options.paragraph)), this.options.strike !== !1 && l.push(gz.configure(this.options.strike)), this.options.text !== !1 && l.push(mz.configure(this.options.text)), this.options.underline !== !1 && l.push(vz.configure((t = this.options) == null ? void 0 : t.underline)), this.options.trailingNode !== !1 && l.push(Uz.configure((n = this.options) == null ? void 0 : n.trailingNode)), l;
  }
}), Yz = Kz, Jz = Dt.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (e) => {
              const a = e.style.textAlign;
              return this.options.alignments.includes(a) ? a : this.options.defaultAlignment;
            },
            renderHTML: (e) => e.textAlign ? { style: `text-align: ${e.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (e) => ({ commands: a }) => this.options.alignments.includes(e) ? this.options.types.map((t) => a.updateAttributes(t, { textAlign: e })).some((t) => t) : !1,
      unsetTextAlign: () => ({ commands: e }) => this.options.types.map((a) => e.resetAttributes(a, "textAlign")).some((a) => a),
      toggleTextAlign: (e) => ({ editor: a, commands: t }) => this.options.alignments.includes(e) ? a.isActive({ textAlign: e }) ? t.unsetTextAlign() : t.setTextAlign(e) : !1
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), Xz = Jz, Zz = 20, rx = (e, a = 0) => {
  const t = [];
  return !e.children.length || a > Zz || Array.from(e.children).forEach((n) => {
    n.tagName === "SPAN" ? t.push(n) : n.children.length && t.push(...rx(n, a + 1));
  }), t;
}, Qz = (e) => {
  if (!e.children.length)
    return;
  const a = rx(e);
  a && a.forEach((t) => {
    var n, l;
    const o = t.getAttribute("style"), r = (l = (n = t.parentElement) == null ? void 0 : n.closest("span")) == null ? void 0 : l.getAttribute("style");
    t.setAttribute("style", `${r};${o}`);
  });
}, ix = Fn.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !0
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        consuming: !1,
        getAttrs: (e) => e.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && Qz(e), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", qt(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleTextStyle: (e) => ({ commands: a }) => a.toggleMark(this.name, e),
      removeEmptyTextStyle: () => ({ tr: e }) => {
        const { selection: a } = e;
        return e.doc.nodesBetween(a.from, a.to, (t, n) => {
          if (t.isTextblock)
            return !0;
          t.marks.filter((l) => l.type === this.type).some((l) => Object.values(l.attrs).some((o) => !!o)) || e.removeMark(n, n + t.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), _z = Dt.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (e) => {
              var a;
              const t = (a = Io(e, "background-color")) != null ? a : e.style.backgroundColor;
              return t == null ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.backgroundColor ? {
              style: `background-color: ${e.backgroundColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (e) => ({ chain: a }) => a().setMark("textStyle", { backgroundColor: e }).run(),
      unsetBackgroundColor: () => ({ chain: e }) => e().setMark("textStyle", { backgroundColor: null }).removeEmptyTextStyle().run()
    };
  }
}), sx = Dt.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (e) => {
              var a;
              const t = (a = Io(e, "color")) != null ? a : e.style.color;
              return t == null ? void 0 : t.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.color ? {
              style: `color: ${e.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (e) => ({ chain: a }) => a().setMark("textStyle", { color: e }).run(),
      unsetColor: () => ({ chain: e }) => e().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), eD = Dt.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            // Prefer the raw inline `style` attribute so unquoted or
            // single-quoted multi-word names are preserved instead of being
            // canonicalized by `element.style.fontFamily`, which forces double
            // quotes that then get HTML-encoded to `&quot;` on serialization.
            parseHTML: (e) => {
              var a;
              return (a = Io(e, "font-family")) != null ? a : e.style.fontFamily;
            },
            renderHTML: (e) => e.fontFamily ? {
              style: `font-family: ${e.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (e) => ({ chain: a }) => a().setMark("textStyle", { fontFamily: e }).run(),
      unsetFontFamily: () => ({ chain: e }) => e().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
}), dx = Dt.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            // Prefer the raw inline `style` attribute so the original format
            // is preserved instead of the canonicalized value returned by
            // `element.style.fontSize`.
            parseHTML: (e) => {
              var a;
              return (a = Io(e, "font-size")) != null ? a : e.style.fontSize;
            },
            renderHTML: (e) => e.fontSize ? {
              style: `font-size: ${e.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (e) => ({ chain: a }) => a().setMark("textStyle", { fontSize: e }).run(),
      unsetFontSize: () => ({ chain: e }) => e().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
}), ux = Dt.create({
  name: "lineHeight",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: null,
            // Prefer the raw inline `style` attribute so the original format
            // is preserved instead of the canonicalized value returned by
            // `element.style.lineHeight`.
            parseHTML: (e) => {
              var a;
              return (a = Io(e, "line-height")) != null ? a : e.style.lineHeight;
            },
            renderHTML: (e) => e.lineHeight ? {
              style: `line-height: ${e.lineHeight}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLineHeight: (e) => ({ chain: a }) => a().setMark("textStyle", { lineHeight: e }).run(),
      unsetLineHeight: () => ({ chain: e }) => e().setMark("textStyle", { lineHeight: null }).removeEmptyTextStyle().run()
    };
  }
});
Dt.create({
  name: "textStyleKit",
  addExtensions() {
    const e = [];
    return this.options.backgroundColor !== !1 && e.push(_z.configure(this.options.backgroundColor)), this.options.color !== !1 && e.push(sx.configure(this.options.color)), this.options.fontFamily !== !1 && e.push(eD.configure(this.options.fontFamily)), this.options.fontSize !== !1 && e.push(dx.configure(this.options.fontSize)), this.options.lineHeight !== !1 && e.push(ux.configure(this.options.lineHeight)), this.options.textStyle !== !1 && e.push(ix.configure(this.options.textStyle)), e;
  }
});
var tD = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/, aD = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g, nD = Fn.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        // Prefer `data-color` (set by our own `renderHTML`) for lossless
        // round-trips. Otherwise parse the raw inline `style` attribute so
        // the original color format (e.g. `#rrggbb`) is preserved instead of
        // the canonicalized `rgb(...)` value from `element.style.backgroundColor`.
        parseHTML: (e) => e.getAttribute("data-color") || Io(e, "background-color") || e.style.backgroundColor,
        renderHTML: (e) => e.color ? {
          "data-color": e.color,
          style: `background-color: ${e.color}; color: inherit`
        } : {}
      }
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["mark", qt(this.options.HTMLAttributes, e), 0];
  },
  renderMarkdown: (e, a) => `==${a.renderChildren(e)}==`,
  parseMarkdown: (e, a) => a.applyMark("highlight", a.parseInline(e.tokens || [])),
  markdownTokenizer: {
    name: "highlight",
    level: "inline",
    start: (e) => e.indexOf("=="),
    tokenize(e, a, t) {
      const l = /^(==)([^=]+)(==)/.exec(e);
      if (l) {
        const o = l[2].trim(), r = t.inlineTokens(o);
        return {
          type: "highlight",
          raw: l[0],
          text: o,
          tokens: r
        };
      }
    }
  },
  addCommands() {
    return {
      setHighlight: (e) => ({ commands: a }) => a.setMark(this.name, e),
      toggleHighlight: (e) => ({ commands: a }) => a.toggleMark(this.name, e),
      unsetHighlight: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      Nl({
        find: tD,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      sl({
        find: aD,
        type: this.type
      })
    ];
  }
}), lD = nD, oD = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, rD = za.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {},
      resize: !1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["img", qt(this.options.HTMLAttributes, e)];
  },
  parseMarkdown: (e, a) => a.createNode("image", {
    src: e.href,
    title: e.title,
    alt: e.text
  }),
  renderMarkdown: (e) => {
    var a, t, n, l, o, r;
    const i = (t = (a = e.attrs) == null ? void 0 : a.src) != null ? t : "", s = (l = (n = e.attrs) == null ? void 0 : n.alt) != null ? l : "", d = (r = (o = e.attrs) == null ? void 0 : o.title) != null ? r : "";
    return d ? `![${s}](${i} "${d}")` : `![${s}](${i})`;
  },
  addNodeView() {
    if (!this.options.resize || !this.options.resize.enabled || typeof document > "u")
      return null;
    const { directions: e, minWidth: a, minHeight: t, alwaysPreserveAspectRatio: n } = this.options.resize;
    return ({ node: l, getPos: o, HTMLAttributes: r, editor: i }) => {
      const s = document.createElement("img");
      Object.entries(r).forEach(([f, g]) => {
        if (g != null)
          switch (f) {
            case "width":
            case "height":
              break;
            default:
              s.setAttribute(f, g);
              break;
          }
      }), s.src = r.src;
      const d = new qA({
        element: s,
        editor: i,
        node: l,
        getPos: o,
        onResize: (f, g) => {
          s.style.width = `${f}px`, s.style.height = `${g}px`;
        },
        onCommit: (f, g) => {
          const h = o();
          h !== void 0 && this.editor.chain().setNodeSelection(h).updateAttributes(this.name, {
            width: f,
            height: g
          }).run();
        },
        onUpdate: (f, g, h) => f.type === l.type,
        options: {
          directions: e,
          min: {
            width: a,
            height: t
          },
          preserveAspectRatio: n === !0
        }
      }), c = d.dom;
      return c.style.visibility = "hidden", c.style.pointerEvents = "none", s.onload = () => {
        c.style.visibility = "", c.style.pointerEvents = "";
      }, d;
    };
  },
  addCommands() {
    return {
      setImage: (e) => ({ commands: a }) => a.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addInputRules() {
    return [
      Bp({
        find: oD,
        type: this.type,
        getAttributes: (e) => {
          const [, , a, t, n] = e;
          return { src: t, alt: a, title: n };
        }
      })
    ];
  }
}), iD = rD;
const Rb = 60, sD = 10, dD = 290;
function cx(e) {
  const a = Symbol("opal-overlay-layer");
  $e(
    e,
    (o) => o ? py(a) : Vf(a),
    { immediate: !0 }
  ), zt(() => Vf(a));
  let t = Rb;
  const n = m(() => {
    const o = nn.value.indexOf(a);
    return o >= 0 && (t = Math.min(Rb + o * sD, dD)), t;
  }), l = m(() => nn.value[nn.value.length - 1] === a);
  return { zIndex: n, isTop: l };
}
const uD = ["aria-label", "aria-labelledby", "aria-describedby", "aria-modal"], cD = {
  "data-testid": "modal-pre-header",
  class: "flex items-center justify-end h-9"
}, fD = {
  key: 0,
  class: "flex-1 min-w-0"
}, hD = ["data-testid"], bD = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "Modal",
  props: {
    modelValue: { type: Boolean, default: !1 },
    size: { default: "md" },
    showCloseButton: { type: Boolean, default: !0 },
    title: { default: void 0 },
    subtitle: { default: void 0 },
    headingLevel: { default: 2 },
    icon: { default: void 0 },
    avatar: { default: void 0 },
    headerAlign: { default: "stacked" },
    headerPosition: { default: "left" },
    actions: { default: () => [] },
    footerAlign: { default: "right" },
    footerPosition: { default: "right" },
    initialFocus: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    dismissable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    showFooter: { type: Boolean, default: !0 },
    showHeader: { type: Boolean, default: !0 },
    showHeaderBorder: { type: Boolean, default: !1 },
    showFooterBorder: { type: Boolean, default: !1 },
    contentClass: { default: void 0 },
    headerClass: { default: void 0 },
    overlayClass: { default: void 0 },
    borderGradient: { default: void 0 },
    ariaCloseLabel: { default: "Close modal" }
  },
  emits: ["update:modelValue", "close", "action"],
  setup(e, { emit: a }) {
    var ee;
    const t = rn(), n = () => Object.fromEntries(Object.entries(t).filter(([, ue]) => ue !== void 0)), l = Na();
    wa(Sc, null);
    const o = e, r = a, i = (ue) => {
      var se;
      (se = ue.onClick) == null || se.call(ue), r("action", ue.id);
    }, s = () => {
      r("update:modelValue", !1), r("close");
    }, d = () => {
      o.dismissable && s();
    }, c = Symbol("opal-modal"), f = () => xn(c), g = () => _a(c), h = (ue) => {
      ue.key !== "Escape" || !o.closeOnEscape || !o.modelValue || On(c) && (ue.defaultPrevented || (ue.preventDefault(), s()));
    }, { zIndex: v, isTop: p } = cx(Ua(o, "modelValue"));
    $e(
      () => o.modelValue,
      (ue) => {
        ue ? f() : g();
      }
    ), kt(() => {
      document.addEventListener("keydown", h), o.modelValue && f();
    }), zt(() => {
      document.removeEventListener("keydown", h), g();
    });
    const y = {
      xs: "max-w-[384px]",
      sm: "max-w-[500px]",
      md: "max-w-[704px]",
      lg: "max-w-[996px]",
      xl: "max-w-[1340px]",
      "2xl": "max-w-full"
    }, k = {
      left: "justify-start text-left",
      center: "justify-center text-center"
    }, $ = {
      right: "justify-end",
      center: "justify-center",
      split: "justify-between"
    }, S = Ye(), I = `${S}-title`, T = `${S}-subtitle`, A = (ue) => {
      const se = l[ue];
      return !!se && Tc(se({ titleId: I, subtitleId: T }));
    }, E = () => A("header"), z = () => A("footer"), B = () => o.showHeader && (!!o.title || !!o.icon || !!o.avatar || E()), W = () => o.showFooter && (z() || o.actions.length > 0), _ = () => B() && !E() && !!o.title, Z = () => B() && !E() && !!o.subtitle, le = () => o.ariaLabelledby || (_() ? I : void 0), D = () => Z() ? T : void 0, O = m(() => `h${o.headingLevel}`), N = m(() => o.headerAlign === "middle-stacked"), V = m(() => !o.icon && !o.avatar || o.headerAlign === "aligned"), M = m(() => V.value ? "flex-row items-start" : N.value ? "flex-col items-center" : "flex-col items-start"), Q = m(
      () => o.footerAlign === "split" && o.actions.length < 2 ? "right" : o.footerAlign
    ), q = m(() => (Q.value === "split" ? [
      { side: "start", actions: o.actions.slice(0, 1) },
      { side: "end", actions: o.actions.slice(1) }
    ] : [{ side: "all", actions: o.actions }]).filter((se) => se.actions.length > 0)), K = m(() => y[o.size]), G = () => E() ? k[o.headerPosition] : k[N.value ? "center" : "left"], te = () => $[z() ? o.footerPosition : Q.value], ve = m(() => o.size === "2xl"), Se = m(
      () => o.borderGradient ? { "--Border-gradient": o.borderGradient } : void 0
    ), oe = R(null);
    Is({
      active: Ua(o, "modelValue"),
      container: oe,
      containFocus: !0
    });
    const re = typeof process < "u" && ((ee = process.env) == null ? void 0 : ee.NODE_ENV) !== "production", ge = (ue) => {
      var se;
      if (typeof ue != "string") return ue;
      try {
        return (se = oe.value) == null ? void 0 : se.querySelector(ue);
      } catch {
        re && console.warn(`[OPAL Modal] \`initialFocus\` "${ue}" is not a valid CSS selector.`);
        return;
      }
    }, de = 96, Ee = R(!1), j = () => {
      const ue = oe.value, se = ue == null ? void 0 : ue.querySelector('[data-testid="modal-content"]');
      if (!ue || !se) return;
      const X = getComputedStyle(ue), ae = parseFloat(X.maxHeight);
      if (!Number.isFinite(ae)) {
        Ee.value = !1;
        return;
      }
      let Ae = ["paddingTop", "paddingBottom", "borderTopWidth", "borderBottomWidth"].reduce((xe, we) => xe + (parseFloat(X[we]) || 0), 0);
      for (const xe of Array.from(ue.children)) xe !== se && (Ae += xe.offsetHeight);
      Ee.value = ae - Ae < Math.min(se.scrollHeight, de);
    };
    let J, ne;
    const Y = () => {
      J == null || J.disconnect(), J = void 0, ne == null || ne.disconnect(), ne = void 0, window.removeEventListener("resize", j);
    }, F = (ue) => {
      if (!J) return;
      J.observe(ue);
      for (const X of Array.from(ue.children)) J.observe(X);
      const se = ue.querySelector('[data-testid="modal-content"]');
      for (const X of Array.from((se == null ? void 0 : se.children) ?? [])) J.observe(X);
    };
    return $e(oe, (ue) => {
      if (Y(), Ee.value = !1, !(!ue || typeof ResizeObserver > "u")) {
        if (J = new ResizeObserver(j), F(ue), typeof MutationObserver < "u") {
          ne = new MutationObserver(() => {
            F(ue), j();
          }), ne.observe(ue, { childList: !0 });
          const se = ue.querySelector('[data-testid="modal-content"]');
          se && ne.observe(se, { childList: !0 });
        }
        window.addEventListener("resize", j), j();
      }
    }), zt(Y), $e(
      () => o.modelValue,
      async (ue) => {
        var se;
        ue && (await Ze(), !(!o.modelValue || !o.initialFocus) && ((se = ge(o.initialFocus)) == null || se.focus()));
      },
      { immediate: !0 }
    ), (ue, se) => (u(), P(Fa, { to: "body" }, [
      U(Wt, { name: "modal-fade" }, {
        default: me(() => [
          e.modelValue ? (u(), b("div", {
            key: 0,
            "data-testid": "modal-backdrop",
            class: C([
              "fixed inset-0 flex overflow-y-auto overflow-x-hidden",
              ve.value ? "p-0" : "p-4",
              e.overlayClass
            ]),
            style: Ge({ zIndex: L(v) }),
            onClick: _e(d, ["self"])
          }, [
            x("div", {
              class: "fixed inset-0 bg-black/50 dark:bg-black/70",
              onClick: d
            }),
            x("div", Ve({
              "data-testid": "modal-container",
              "aria-label": e.ariaLabel,
              "aria-labelledby": le(),
              "aria-describedby": D()
            }, n(), {
              role: "dialog",
              "aria-modal": L(p) ? "true" : void 0,
              class: ["relative z-10 w-full m-auto", K.value, ve.value ? "h-full" : ""],
              onClick: se[0] || (se[0] = _e(() => {
              }, ["stop"]))
            }), [
              x("div", {
                ref_key: "panelRef",
                ref: oe,
                class: C([
                  // overflow-y-auto: the whole panel scrolls only in the `cramped` state (see measureCramped).
                  "relative flex flex-col overflow-y-auto bg-(--colors-background-white) dark:bg-(--colors-background-black-default) modal-container",
                  ve.value ? "rounded-none h-full border border-(--colors-border-base-soft) dark:border-(--colors-border-base) shadow-xl" : (
                    // DS rule: constant 30px vertical margin — beyond that the content scrolls
                    // internally and the footer stays pinned (except in the `cramped` state, see
                    // measureCramped). Figma's 8px padding
                    // includes its INSIDE stroke, so the CSS border is subtracted.
                    "rounded-[var(--border-border-radius-rounded-base,24px)] p-[calc(var(--spacing-2)_-_var(--border-border-width-border-sm))] shadow-(--shadow-xl) max-h-[calc(100dvh-60px)]"
                  ),
                  e.contentClass
                ]),
                style: Ge(Se.value)
              }, [
                x("div", cD, [
                  e.showCloseButton ? (u(), P(Be, {
                    key: 0,
                    "data-testid": "modal-close-button",
                    variant: "ghost",
                    size: "sm",
                    "icon-only": "",
                    "icon-left": "ri-close-fill",
                    "aria-label": e.ariaCloseLabel,
                    onClick: s
                  }, null, 8, ["aria-label"])) : w("", !0)
                ]),
                B() ? (u(), b("div", {
                  key: 0,
                  "data-testid": "modal-header",
                  class: C([
                    [
                      "flex items-center gap-5 pt-0 pb-6 px-6",
                      e.showHeaderBorder && "border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                    ],
                    G(),
                    e.headerClass
                  ])
                }, [
                  E() ? (u(), b("div", fD, [
                    Me(ue.$slots, "header", {
                      titleId: I,
                      subtitleId: T
                    }, void 0, !0)
                  ])) : (u(), b("div", {
                    key: 1,
                    "data-testid": "modal-heading-lead",
                    class: C(["flex flex-1 min-w-0 gap-2", M.value])
                  }, [
                    e.icon ? (u(), P(aa, {
                      key: 0,
                      icon: e.icon,
                      size: "lg",
                      type: "square",
                      variant: "outlined",
                      color: "white",
                      "data-testid": "modal-header-icon",
                      class: "shrink-0"
                    }, null, 8, ["icon"])) : e.avatar ? (u(), P(Jt, {
                      key: 1,
                      name: e.avatar.name,
                      img: e.avatar.img,
                      entity: e.avatar.entity,
                      size: "xl",
                      "avatar-style": "circle",
                      presentational: "",
                      class: "shrink-0"
                    }, null, 8, ["name", "img", "entity"])) : w("", !0),
                    x("div", {
                      "data-testid": "modal-heading-text",
                      class: C([
                        "flex min-w-0 flex-col justify-center gap-0.5 self-stretch",
                        V.value && "flex-1",
                        N.value && "items-center text-center"
                      ])
                    }, [
                      e.title ? (u(), P(gt(O.value), {
                        key: 0,
                        id: I,
                        "data-testid": "modal-title",
                        class: "text-(length:--size-xxl) leading-(--line-height-xxl) font-(--weight-bold) text-(--colors-text-black-default) dark:text-(--colors-text-white-default) break-words [overflow-wrap:anywhere]"
                      }, {
                        default: me(() => [
                          st(H(e.title), 1)
                        ]),
                        _: 1
                      })) : w("", !0),
                      e.subtitle ? (u(), b("p", {
                        key: 1,
                        id: T,
                        "data-testid": "modal-subtitle",
                        class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--colors-text-black-default) dark:text-(--colors-text-white-default) break-words [overflow-wrap:anywhere]"
                      }, H(e.subtitle), 1)) : w("", !0)
                    ], 2)
                  ], 2))
                ], 2)) : w("", !0),
                x("div", {
                  "data-testid": "modal-content",
                  class: C([
                    "flex flex-col gap-5 pt-0 px-6",
                    Ee.value ? "flex-none" : "flex-1 overflow-y-auto",
                    W() ? "pb-0" : "pb-6"
                  ])
                }, [
                  Me(ue.$slots, "default", {}, void 0, !0)
                ], 2),
                W() ? (u(), b("div", {
                  key: 1,
                  "data-testid": "modal-footer",
                  class: C([
                    [
                      "flex flex-wrap items-center gap-4 pt-6 pb-6 px-6",
                      e.showFooterBorder && "border-t border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                    ],
                    te()
                  ])
                }, [
                  z() ? Me(ue.$slots, "footer", { key: 0 }, void 0, !0) : (u(!0), b(ie, { key: 1 }, Oe(q.value, (X) => (u(), b("div", {
                    key: X.side,
                    "data-testid": `modal-actions-${X.side}`,
                    class: "flex flex-wrap items-center gap-4"
                  }, [
                    (u(!0), b(ie, null, Oe(X.actions, (ae) => (u(), P(Be, {
                      key: ae.id,
                      "data-testid": ae.testId ?? `modal-action-${ae.id}`,
                      size: "md",
                      label: ae.label,
                      variant: ae.variant,
                      "icon-left": ae.icon,
                      disabled: ae.disabled,
                      "aria-disabled": ae.ariaDisabled,
                      loading: ae.loading,
                      "loading-label": ae.loadingLabel,
                      type: ae.type,
                      form: ae.form,
                      onClick: (Re) => i(ae)
                    }, null, 8, ["data-testid", "label", "variant", "icon-left", "disabled", "aria-disabled", "loading", "loading-label", "type", "form", "onClick"]))), 128))
                  ], 8, hD))), 128))
                ], 2)) : w("", !0)
              ], 6)
            ], 16, uD)
          ], 6)) : w("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), dl = /* @__PURE__ */ Ct(bD, [["__scopeId", "data-v-6fa2d15b"]]), gD = ["data-type"], mD = ["aria-label"], vD = { class: "flex items-center gap-1 flex-wrap" }, pD = ["disabled", "aria-label", "title"], xD = ["disabled", "aria-label", "title"], yD = ["disabled", "aria-label", "title"], kD = ["disabled", "aria-label", "title"], wD = ["disabled", "aria-label", "title"], CD = ["title"], SD = ["aria-label", "disabled"], $D = ["title"], ID = ["aria-label", "disabled"], LD = ["disabled", "aria-expanded", "aria-label", "title"], TD = ["aria-label"], ED = ["disabled", "aria-label", "title"], AD = ["disabled", "aria-label", "title"], RD = ["disabled", "aria-label", "title"], zD = { class: "flex items-center gap-2 flex-wrap" }, DD = ["disabled", "aria-expanded", "aria-label"], BD = { class: "leading-(--line-height-l)" }, MD = ["aria-label"], OD = ["disabled", "aria-label", "title"], PD = ["disabled", "aria-label", "title"], FD = ["disabled", "aria-label", "title"], ND = ["disabled", "aria-label", "title"], VD = ["disabled", "aria-label", "title"], HD = ["disabled", "aria-expanded", "aria-label", "title"], jD = ["aria-label"], WD = { class: "min-h-0 flex-1 overflow-y-auto" }, qD = {
  key: 0,
  "aria-hidden": "true",
  "data-testid": "rich-text-editor-placeholder",
  class: "pointer-events-none absolute top-[calc(--spacing(3)-1px)] left-[calc(--spacing(3)-1px)] text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body-subtle)"
}, UD = {
  key: 0,
  class: "flex items-start gap-4",
  "data-testid": "rich-text-editor-footer"
}, GD = "w-full flex flex-col items-start gap-0.5 text-left text-(length:--size-m) font-inter", KD = /* @__PURE__ */ ke({
  __name: "RichTextEditor",
  props: {
    type: { default: "Default" },
    modelValue: { default: "" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    placeholder: { default: void 0 },
    helpText: { default: void 0 },
    error: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !0 },
    width: { default: void 0 },
    minHeight: { default: "184px" },
    resizable: { type: Boolean, default: !1 },
    id: { default: void 0 },
    labels: { default: void 0 },
    actions: { default: () => [] }
  },
  emits: ["update:modelValue", "focus", "blur", "send", "action"],
  setup(e, { emit: a }) {
    const t = `absolute top-[calc(100%+4px)] z-20 min-w-50 w-max ${Ai}`, n = {
      toolbar: "Rich text formatting",
      bold: "Bold",
      clearFormatting: "Clear formatting",
      italic: "Italic",
      underline: "Underline",
      strikethrough: "Strikethrough",
      textColor: "Text color",
      highlight: "Highlight",
      alignLeft: "Align left",
      alignCenter: "Align center",
      alignRight: "Align right",
      textFormat: "Text format",
      paragraph: "Paragraph",
      heading1: "Heading 1",
      heading2: "Heading 2",
      heading3: "Heading 3",
      insertLink: "Insert link",
      insertImage: "Insert image",
      bulletList: "Bullet list",
      orderedList: "Ordered list",
      blockquote: "Blockquote",
      closeDialog: "Close modal",
      linkDialogTitle: "Insert link",
      linkUrlLabel: "URL",
      linkUrlPlaceholder: "https://example.com",
      linkInsert: "Insert",
      linkRemove: "Remove link",
      imageDialogTitle: "Insert image",
      imageUrlLabel: "Image URL",
      imageUrlPlaceholder: "https://example.com/image.png",
      imageInsert: "Insert",
      cancel: "Cancel",
      invalidUrl: "Enter a valid http(s) URL.",
      send: "Send message",
      fontSize: "Font size",
      lineHeight: "Line height",
      defaultStyle: "Default"
    }, l = e, o = m(() => ({ ...n, ...l.labels })), r = a, i = Ye(), s = m(() => l.id || i), d = m(() => l.label ? `${s.value}-label` : void 0), c = m(() => `${s.value}-error`), f = m(() => `${s.value}-help`), g = m(() => !!l.error), h = m(() => {
      const ce = [];
      return g.value && ce.push(c.value), l.helpText && ce.push(f.value), ce.length ? ce.join(" ") : void 0;
    }), v = m(() => d.value ? { "aria-labelledby": d.value } : l.ariaLabel ? { "aria-label": l.ariaLabel } : {}), p = m(
      () => h.value ? { "aria-describedby": h.value } : {}
    ), y = m(() => ({
      id: s.value,
      role: "textbox",
      "aria-multiline": "true",
      "aria-disabled": l.disabled ? "true" : "false",
      "aria-required": l.required ? "true" : "false",
      ...v.value,
      "aria-invalid": g.value ? "true" : "false",
      ...p.value,
      class: "prose prose-sm max-w-none focus:outline-none text-(--text-text-black-default) dark:text-(--colors-text-white-default) min-h-full"
    })), k = ["paragraph", "heading"], $ = tR({
      content: l.modelValue,
      editable: !l.disabled,
      extensions: [
        Yz.configure({
          // StarterKit v3 already bundles Underline, Link, lists.
          link: {
            openOnClick: !1,
            autolink: !0,
            defaultProtocol: "https"
          }
        }),
        Xz.configure({ types: ["heading", "paragraph"] }),
        ix,
        dx,
        ux.configure({ types: k }),
        sx,
        lD.configure({ multicolor: !0 }),
        iD.configure({ inline: !1 })
      ],
      editorProps: { attributes: y.value },
      onUpdate({ editor: ce }) {
        r("update:modelValue", ce.getHTML());
      },
      onFocus() {
        S.value = !0, r("focus");
      },
      onBlur() {
        S.value = !1, r("blur");
      }
    }), S = R(!1), I = R(null), T = R(null);
    $e(
      () => l.modelValue,
      (ce) => {
        var Le, Je;
        const he = (Le = $.value) == null ? void 0 : Le.getHTML();
        ce !== void 0 && ce !== he && ((Je = $.value) == null || Je.commands.setContent(ce || "", { emitUpdate: !1 }));
      }
    ), $e(
      () => l.disabled,
      (ce) => {
        var he;
        (he = $.value) == null || he.setEditable(!ce);
      }
    ), $e(y, (ce) => {
      var he;
      (he = $.value) == null || he.setOptions({ editorProps: { attributes: ce } });
    }), Tt(() => {
      var ce;
      (ce = $.value) == null || ce.destroy();
    });
    const A = m(() => [
      { value: "paragraph", label: o.value.paragraph, shortcut: "⌘⌥0" },
      { value: "h1", label: o.value.heading1, shortcut: "⌘⌥1" },
      { value: "h2", label: o.value.heading2, shortcut: "⌘⌥2" },
      { value: "h3", label: o.value.heading3, shortcut: "⌘⌥3" }
    ]), E = ["12px", "14px", "16px", "18px", "20px", "24px"], z = ["1", "1.25", "1.5", "2"], B = m(() => [
      { value: "", label: o.value.defaultStyle },
      ...E.map((ce) => ({ value: ce, label: ce.replace("px", " px") }))
    ]), W = m(() => [
      { value: "", label: o.value.defaultStyle },
      ...z.map((ce) => ({ value: ce, label: ce }))
    ]), _ = (ce) => {
      var Le;
      const he = (Le = $.value) == null ? void 0 : Le.chain().focus();
      if (he) {
        if (ce === "paragraph")
          he.setParagraph().run();
        else {
          const Je = Number(ce.replace("h", ""));
          he.toggleHeading({ level: Je }).run();
        }
        D.value = null;
      }
    }, Z = (ce) => {
      var Le;
      const he = (Le = $.value) == null ? void 0 : Le.chain().focus();
      ce ? he == null || he.setFontSize(ce).run() : he == null || he.unsetFontSize().run(), D.value = null;
    }, le = (ce) => {
      var he;
      (he = $.value) == null || he.chain().focus().command(
        ({ commands: Le }) => k.map((Je) => Le.updateAttributes(Je, { lineHeight: ce || null })).some(Boolean)
      ).run(), D.value = null;
    }, D = R(null), O = R(null), N = R(null), V = R(null), M = { format: O, fontSize: N, lineHeight: V }, Q = (ce) => {
      l.disabled || (D.value = D.value === ce ? null : ce);
    }, q = R(null), K = R(!1), G = async () => {
      var Je;
      K.value = !1;
      const ce = D.value;
      if (!ce) return;
      await Ze();
      const he = (Je = M[ce].value) == null ? void 0 : Je.querySelector('[role="menu"]'), Le = q.value;
      !he || !Le || D.value !== ce || (K.value = he.getBoundingClientRect().right > Le.getBoundingClientRect().right);
    };
    $e(D, G);
    const te = (ce) => Array.from(ce.querySelectorAll('[role="menuitemradio"]'));
    $e(D, async (ce) => {
      var Je, Bt;
      if (!ce) return;
      await Ze();
      const he = (Je = M[ce].value) == null ? void 0 : Je.querySelector('[role="menu"]');
      if (!he) return;
      const Le = te(he);
      (Bt = Le.find((Va) => Va.getAttribute("aria-checked") === "true") ?? Le[0]) == null || Bt.focus();
    });
    const ve = (ce) => {
      if (ce.key === "Tab") {
        D.value = null;
        return;
      }
      const he = te(ce.currentTarget), Le = he.indexOf(document.activeElement), Je = {
        ArrowDown: (Le + 1) % he.length,
        ArrowUp: (Le - 1 + he.length) % he.length,
        Home: 0,
        End: he.length - 1
      }[ce.key];
      Je === void 0 || !he.length || (ce.preventDefault(), he[Je].focus());
    }, Se = (ce) => {
      var he, Le;
      return (Le = (he = M[ce].value) == null ? void 0 : he.querySelector('[aria-haspopup="menu"]')) == null ? void 0 : Le.focus();
    }, oe = () => {
      D.value && G();
    }, re = (ce) => {
      if (!D.value) return;
      const he = M[D.value].value;
      he && !he.contains(ce.target) && (D.value = null);
    }, ge = (ce) => {
      if (D.value && ce.key === "Escape") {
        ce.stopPropagation(), ce.preventDefault();
        const he = D.value;
        D.value = null, Se(he);
      }
    };
    kt(() => {
      document.addEventListener("mousedown", re), document.addEventListener("keydown", ge), window.addEventListener("resize", oe);
    }), Tt(() => {
      document.removeEventListener("mousedown", re), document.removeEventListener("keydown", ge), window.removeEventListener("resize", oe);
    });
    const de = (ce) => {
      var Le;
      const he = ce.target.value;
      (Le = $.value) == null || Le.chain().focus().setColor(he).run();
    }, Ee = (ce) => {
      var Le;
      const he = ce.target.value;
      (Le = $.value) == null || Le.chain().focus().toggleHighlight({ color: he }).run();
    }, j = R(!1), J = R(""), ne = R(!1), Y = R(!1), F = R(""), ee = R(!1);
    function ue(ce) {
      try {
        const he = new URL(ce);
        return he.protocol === "http:" || he.protocol === "https:";
      } catch {
        return !1;
      }
    }
    const se = (ce) => {
      var he;
      return (he = ce == null ? void 0 : ce.currentTarget) == null ? void 0 : he.focus();
    }, X = (ce) => {
      var Le;
      if (l.disabled) return;
      se(ce);
      const he = (Le = $.value) == null ? void 0 : Le.getAttributes("link").href;
      J.value = he ?? "", ne.value = !1, j.value = !0;
    }, ae = () => {
      var ce;
      (ce = $.value) == null || ce.chain().extendMarkRange("link").unsetLink().run(), j.value = !1;
    }, Re = () => {
      var he;
      const ce = J.value.trim();
      if (ce === "") {
        ae();
        return;
      }
      if (!ue(ce)) {
        ne.value = !0;
        return;
      }
      (he = $.value) == null || he.chain().extendMarkRange("link").setLink({ href: ce, target: "_blank", rel: "noopener noreferrer" }).run(), j.value = !1;
    }, Ae = () => {
      j.value = !1;
    }, xe = (ce) => {
      l.disabled || (se(ce), F.value = "", ee.value = !1, Y.value = !0);
    }, we = () => {
      var he;
      const ce = F.value.trim();
      if (!ue(ce)) {
        ee.value = !0;
        return;
      }
      (he = $.value) == null || he.chain().setImage({ src: ce }).run(), Y.value = !1;
    }, fe = () => {
      Y.value = !1;
    }, Ne = m(() => [
      { id: "remove", label: o.value.linkRemove, variant: "tertiary", onClick: ae },
      { id: "cancel", label: o.value.cancel, variant: "secondary", onClick: Ae },
      { id: "insert", label: o.value.linkInsert, variant: "primary", onClick: Re }
    ]), De = m(() => [
      { id: "cancel", label: o.value.cancel, variant: "secondary", onClick: fe },
      { id: "insert", label: o.value.imageInsert, variant: "primary", onClick: we }
    ]), qe = (ce, he) => {
      ce.key === "Enter" && (ce.preventDefault(), he());
    }, Qe = () => {
      var ce;
      (ce = $.value) == null || ce.chain().focus().clearNodes().unsetAllMarks().run();
    }, lt = (ce, he) => $.value ? typeof ce == "string" ? $.value.isActive(ce, {}) : $.value.isActive(ce) : !1, Ie = m(() => $.value ? $.value.isActive("heading", { level: 1 }) ? "h1" : $.value.isActive("heading", { level: 2 }) ? "h2" : $.value.isActive("heading", { level: 3 }) ? "h3" : "paragraph" : "paragraph"), pe = m(
      () => {
        var ce;
        return ((ce = $.value) == null ? void 0 : ce.getAttributes("textStyle").fontSize) ?? "";
      }
    ), Pe = m(() => k.map((he) => {
      var Le;
      return (Le = $.value) == null ? void 0 : Le.getAttributes(he).lineHeight;
    }).find(Boolean) ?? ""), Xe = m(
      () => {
        var ce;
        return ((ce = A.value.find((he) => he.value === Ie.value)) == null ? void 0 : ce.label) ?? o.value.paragraph;
      }
    ), nt = m(() => l.type === "Buttons inside"), vt = m(() => l.type === "Buttons outside"), Gt = m(() => !!$.value && !$.value.isEmpty), Fe = m(() => {
      var Le;
      const ce = (Le = $.value) == null ? void 0 : Le.state.doc, he = (ce == null ? void 0 : ce.childCount) === 1 ? ce.firstChild : null;
      return !!l.placeholder && (he == null ? void 0 : he.type.name) === "paragraph" && he.content.size === 0;
    }), je = m(
      () => l.disabled ? "border-(--border-border-disabled-subtle) dark:border-(--colors-border-disabled-subtle)" : "border-(--border-border-base-medium) dark:border-(--border-border-base)"
    ), Ke = m(
      () => l.disabled ? `bg-(--background-background-disabled-opacity) dark:bg-(--colors-background-disabled) ${je.value}` : `bg-(--background-background-white) dark:bg-(--background-background-black-default) ${je.value}`
    ), bt = m(() => l.type === "Default"), At = m(() => {
      const ce = "flex flex-col rounded-(--border-border-radius-rounded-l) shadow-(--blur-shadow-xs)";
      if (bt.value) return `${ce} gap-0.5`;
      const he = `${ce} dark:shadow-(--blur-shadow-m-dark)`;
      return nt.value ? `${he} border border-solid ${je.value}` : he;
    }), Ce = m(
      () => bt.value ? "flex flex-col rounded-(--border-border-radius-rounded-l) dark:shadow-(--blur-shadow-m-dark)" : "flex flex-col"
    ), He = m(() => `flex flex-col gap-2 border-solid rounded-t-(--border-border-radius-rounded-l) px-[calc(--spacing(3)-1px)] pt-[calc(--spacing(3)-1px)] ${nt.value ? "-mx-px -mt-px border-x border-t pb-3" : "border pb-[calc(--spacing(3)-1px)]"} ${Ke.value}`), et = m(() => {
      const ce = nt.value ? "-mx-px" : "rounded-b-(--border-border-radius-rounded-l)", he = l.resizable && !l.disabled ? "resize-y" : "", Le = `relative flex flex-col overflow-hidden border border-solid p-[calc(--spacing(3)-1px)] ${ce} ${he}`, Je = nt.value ? "" : "border-t-transparent dark:border-t-transparent", Bt = "shadow-[0_0_2px_2px_var(--background-background-hover)]", Va = "shadow-(--blur-shadow-xs) dark:shadow-(--blur-shadow-m-dark)";
      return l.disabled ? `${Le} ${Je} ${Ke.value} cursor-not-allowed` : g.value ? `${Le} ${S.value ? Bt : Va} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)` : S.value ? `${Le} ${Bt} bg-(--background-background-selected) dark:bg-(--background-background-black-default) border-(--border-border-accent)` : `${Le} ${Je} ${Gt.value ? "" : Va} ${Ke.value}`;
    }), pt = m(
      () => `-mx-px -mb-px flex items-center gap-4 border-x border-b border-solid rounded-b-(--border-border-radius-rounded-l) px-[calc(--spacing(3)-1px)] pt-3 pb-[calc(--spacing(3)-1px)] ${Ke.value}`
    ), It = () => {
      var ce;
      return r("send", ((ce = $.value) == null ? void 0 : ce.getHTML()) ?? l.modelValue);
    }, Ht = (ce) => r("action", ce), ha = m(() => l.fullWidth ? {} : l.width ? { width: l.width } : {}), Ot = (ce) => {
      var he, Le;
      l.disabled || (he = ce.target) != null && he.closest("[data-field-label-tooltip]") || (Le = $.value) == null || Le.commands.focus();
    };
    return (ce, he) => (u(), b("div", {
      class: C(GD),
      style: Ge(ha.value),
      "data-type": e.type
    }, [
      e.label ? (u(), P(Ft, {
        key: 0,
        id: d.value,
        ref_key: "labelRef",
        ref: I,
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: S.value,
        "test-id": "rich-text-editor-label",
        class: C(!e.disabled && "cursor-pointer"),
        onClick: Ot
      }, null, 8, ["id", "text", "required", "required-indicator", "tooltip", "focused", "class"])) : w("", !0),
      x("div", {
        class: C(["self-stretch flex flex-col", vt.value && "gap-4"])
      }, [
        x("div", {
          ref_key: "fieldRef",
          ref: q,
          class: C(At.value),
          "data-testid": "rich-text-editor-field"
        }, [
          x("div", {
            class: C(Ce.value),
            "data-testid": "rich-text-editor-box"
          }, [
            x("div", {
              class: C(He.value),
              role: "toolbar",
              "aria-label": o.value.toolbar,
              "data-testid": "rich-text-editor-toolbar"
            }, [
              x("div", vD, [
                x("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": lt("bold") }]),
                  disabled: e.disabled,
                  "aria-label": o.value.bold,
                  title: o.value.bold,
                  onClick: he[0] || (he[0] = (Le) => {
                    var Je;
                    return (Je = L($)) == null ? void 0 : Je.chain().focus().toggleBold().run();
                  })
                }, [...he[20] || (he[20] = [
                  x("i", {
                    class: "ri-bold",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, pD),
                x("button", {
                  type: "button",
                  class: "toolbar-btn",
                  disabled: e.disabled,
                  "aria-label": o.value.clearFormatting,
                  title: o.value.clearFormatting,
                  onClick: Qe
                }, [...he[21] || (he[21] = [
                  x("i", {
                    class: "ri-format-clear",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 8, xD),
                x("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": lt("italic") }]),
                  disabled: e.disabled,
                  "aria-label": o.value.italic,
                  title: o.value.italic,
                  onClick: he[1] || (he[1] = (Le) => {
                    var Je;
                    return (Je = L($)) == null ? void 0 : Je.chain().focus().toggleItalic().run();
                  })
                }, [...he[22] || (he[22] = [
                  x("i", {
                    class: "ri-italic",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, yD),
                x("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": lt("underline") }]),
                  disabled: e.disabled,
                  "aria-label": o.value.underline,
                  title: o.value.underline,
                  onClick: he[2] || (he[2] = (Le) => {
                    var Je;
                    return (Je = L($)) == null ? void 0 : Je.chain().focus().toggleUnderline().run();
                  })
                }, [...he[23] || (he[23] = [
                  x("i", {
                    class: "ri-underline",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, kD),
                x("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": lt("strike") }]),
                  disabled: e.disabled,
                  "aria-label": o.value.strikethrough,
                  title: o.value.strikethrough,
                  onClick: he[3] || (he[3] = (Le) => {
                    var Je;
                    return (Je = L($)) == null ? void 0 : Je.chain().focus().toggleStrike().run();
                  })
                }, [...he[24] || (he[24] = [
                  x("i", {
                    class: "ri-strikethrough",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, wD),
                x("label", {
                  class: C(["toolbar-btn relative cursor-pointer", { "opacity-50 cursor-not-allowed": e.disabled }]),
                  title: o.value.textColor
                }, [
                  he[25] || (he[25] = x("i", {
                    class: "ri-font-color",
                    "aria-hidden": "true"
                  }, null, -1)),
                  x("input", {
                    type: "color",
                    "aria-label": o.value.textColor,
                    class: "absolute inset-0 opacity-0 cursor-pointer",
                    disabled: e.disabled,
                    onInput: de
                  }, null, 40, SD)
                ], 10, CD),
                x("label", {
                  class: C(["toolbar-btn relative cursor-pointer", {
                    "is-active": lt("highlight"),
                    "opacity-50 cursor-not-allowed": e.disabled
                  }]),
                  title: o.value.highlight
                }, [
                  he[26] || (he[26] = x("i", {
                    class: "ri-mark-pen-line",
                    "aria-hidden": "true"
                  }, null, -1)),
                  x("input", {
                    type: "color",
                    "aria-label": o.value.highlight,
                    class: "absolute inset-0 opacity-0 cursor-pointer",
                    disabled: e.disabled,
                    onInput: Ee
                  }, null, 40, ID)
                ], 10, $D),
                x("div", {
                  ref_key: "fontSizeWrapperRef",
                  ref: N,
                  class: "relative"
                }, [
                  x("button", {
                    type: "button",
                    class: C(["toolbar-btn", { "is-active": D.value === "fontSize" }]),
                    disabled: e.disabled,
                    "aria-expanded": D.value === "fontSize",
                    "aria-haspopup": "menu",
                    "aria-label": o.value.fontSize,
                    title: o.value.fontSize,
                    onClick: he[4] || (he[4] = (Le) => Q("fontSize"))
                  }, [...he[27] || (he[27] = [
                    x("i", {
                      class: "ri-font-size",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])], 10, LD),
                  D.value === "fontSize" ? (u(), b("div", {
                    key: 0,
                    role: "menu",
                    "aria-label": o.value.fontSize,
                    class: C([t, K.value ? "right-0 left-auto" : "left-0"]),
                    onKeydown: ve
                  }, [
                    (u(!0), b(ie, null, Oe(B.value, (Le) => (u(), P(fa, {
                      key: Le.value,
                      as: "button",
                      type: "default",
                      role: "menuitemradio",
                      tabindex: "-1",
                      label: Le.label,
                      selected: pe.value === Le.value,
                      "aria-checked": pe.value === Le.value,
                      onClick: (Je) => Z(Le.value)
                    }, null, 8, ["label", "selected", "aria-checked", "onClick"]))), 128))
                  ], 42, TD)) : w("", !0)
                ], 512),
                he[31] || (he[31] = x("span", {
                  class: "mx-1 inline-block w-px h-4 bg-(--colors-background-gray)",
                  "aria-hidden": "true"
                }, null, -1)),
                x("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": lt({ textAlign: "left" }) }]),
                  disabled: e.disabled,
                  "aria-label": o.value.alignLeft,
                  title: o.value.alignLeft,
                  onClick: he[5] || (he[5] = (Le) => {
                    var Je;
                    return (Je = L($)) == null ? void 0 : Je.chain().focus().setTextAlign("left").run();
                  })
                }, [...he[28] || (he[28] = [
                  x("i", {
                    class: "ri-align-left",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, ED),
                x("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": lt({ textAlign: "center" }) }]),
                  disabled: e.disabled,
                  "aria-label": o.value.alignCenter,
                  title: o.value.alignCenter,
                  onClick: he[6] || (he[6] = (Le) => {
                    var Je;
                    return (Je = L($)) == null ? void 0 : Je.chain().focus().setTextAlign("center").run();
                  })
                }, [...he[29] || (he[29] = [
                  x("i", {
                    class: "ri-align-center",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, AD),
                x("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": lt({ textAlign: "right" }) }]),
                  disabled: e.disabled,
                  "aria-label": o.value.alignRight,
                  title: o.value.alignRight,
                  onClick: he[7] || (he[7] = (Le) => {
                    var Je;
                    return (Je = L($)) == null ? void 0 : Je.chain().focus().setTextAlign("right").run();
                  })
                }, [...he[30] || (he[30] = [
                  x("i", {
                    class: "ri-align-right",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, RD)
              ]),
              x("div", zD, [
                x("div", {
                  ref_key: "formatWrapperRef",
                  ref: O,
                  class: "relative"
                }, [
                  x("button", {
                    type: "button",
                    class: C(["format-btn", { "is-open": D.value === "format" }]),
                    disabled: e.disabled,
                    "aria-expanded": D.value === "format",
                    "aria-haspopup": "menu",
                    "aria-label": o.value.textFormat,
                    onClick: he[8] || (he[8] = (Le) => Q("format"))
                  }, [
                    x("span", BD, H(Xe.value), 1),
                    he[32] || (he[32] = x("i", {
                      class: "ri-arrow-down-s-line text-(length:--size-m)",
                      "aria-hidden": "true"
                    }, null, -1))
                  ], 10, DD),
                  D.value === "format" ? (u(), b("div", {
                    key: 0,
                    role: "menu",
                    "aria-label": o.value.textFormat,
                    class: C([t, K.value ? "right-0 left-auto" : "left-0"]),
                    onKeydown: ve
                  }, [
                    (u(!0), b(ie, null, Oe(A.value, (Le) => (u(), P(fa, {
                      key: Le.value,
                      as: "button",
                      type: "secondary-text",
                      role: "menuitemradio",
                      tabindex: "-1",
                      label: Le.label,
                      "secondary-label": Le.shortcut,
                      "aria-label": Le.label,
                      selected: Ie.value === Le.value,
                      "aria-checked": Ie.value === Le.value,
                      onClick: (Je) => _(Le.value)
                    }, null, 8, ["label", "secondary-label", "aria-label", "selected", "aria-checked", "onClick"]))), 128))
                  ], 42, MD)) : w("", !0)
                ], 512),
                x("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": lt("link") }]),
                  disabled: e.disabled,
                  "aria-label": o.value.insertLink,
                  title: o.value.insertLink,
                  onClick: X
                }, [...he[33] || (he[33] = [
                  x("i", {
                    class: "ri-link",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, OD),
                x("button", {
                  type: "button",
                  class: "toolbar-btn",
                  disabled: e.disabled,
                  "aria-label": o.value.insertImage,
                  title: o.value.insertImage,
                  onClick: xe
                }, [...he[34] || (he[34] = [
                  x("i", {
                    class: "ri-image-line",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 8, PD),
                x("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": lt("bulletList") }]),
                  disabled: e.disabled,
                  "aria-label": o.value.bulletList,
                  title: o.value.bulletList,
                  onClick: he[9] || (he[9] = (Le) => {
                    var Je;
                    return (Je = L($)) == null ? void 0 : Je.chain().focus().toggleBulletList().run();
                  })
                }, [...he[35] || (he[35] = [
                  x("i", {
                    class: "ri-list-unordered",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, FD),
                x("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": lt("orderedList") }]),
                  disabled: e.disabled,
                  "aria-label": o.value.orderedList,
                  title: o.value.orderedList,
                  onClick: he[10] || (he[10] = (Le) => {
                    var Je;
                    return (Je = L($)) == null ? void 0 : Je.chain().focus().toggleOrderedList().run();
                  })
                }, [...he[36] || (he[36] = [
                  x("i", {
                    class: "ri-list-ordered",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, ND),
                x("button", {
                  type: "button",
                  class: C(["toolbar-btn", { "is-active": lt("blockquote") }]),
                  disabled: e.disabled,
                  "aria-label": o.value.blockquote,
                  title: o.value.blockquote,
                  onClick: he[11] || (he[11] = (Le) => {
                    var Je;
                    return (Je = L($)) == null ? void 0 : Je.chain().focus().toggleBlockquote().run();
                  })
                }, [...he[37] || (he[37] = [
                  x("i", {
                    class: "ri-double-quotes-l",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 10, VD),
                x("div", {
                  ref_key: "lineHeightWrapperRef",
                  ref: V,
                  class: "relative"
                }, [
                  x("button", {
                    type: "button",
                    class: C(["toolbar-btn", { "is-active": D.value === "lineHeight" }]),
                    disabled: e.disabled,
                    "aria-expanded": D.value === "lineHeight",
                    "aria-haspopup": "menu",
                    "aria-label": o.value.lineHeight,
                    title: o.value.lineHeight,
                    onClick: he[12] || (he[12] = (Le) => Q("lineHeight"))
                  }, [...he[38] || (he[38] = [
                    x("i", {
                      class: "ri-line-height",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])], 10, HD),
                  D.value === "lineHeight" ? (u(), b("div", {
                    key: 0,
                    role: "menu",
                    "aria-label": o.value.lineHeight,
                    class: C([t, K.value ? "right-0 left-auto" : "left-0"]),
                    onKeydown: ve
                  }, [
                    (u(!0), b(ie, null, Oe(W.value, (Le) => (u(), P(fa, {
                      key: Le.value,
                      as: "button",
                      type: "default",
                      role: "menuitemradio",
                      tabindex: "-1",
                      label: Le.label,
                      selected: Pe.value === Le.value,
                      "aria-checked": Pe.value === Le.value,
                      onClick: (Je) => le(Le.value)
                    }, null, 8, ["label", "selected", "aria-checked", "onClick"]))), 128))
                  ], 42, jD)) : w("", !0)
                ], 512)
              ])
            ], 10, mD),
            x("div", {
              class: C(et.value),
              style: Ge({ minHeight: e.minHeight }),
              "data-testid": "rich-text-editor-content"
            }, [
              x("div", WD, [
                L($) ? (u(), P(L(eR), {
                  key: 0,
                  editor: L($),
                  "data-testid": "rich-text-editor",
                  class: "text-(length:--size-m) leading-(--line-height-l)",
                  onKeydown: he[13] || (he[13] = (Le) => {
                    var Je, Bt;
                    (Je = I.value) == null || Je.handleFieldKeydown(Le), (Bt = T.value) == null || Bt.handleFieldKeydown(Le);
                  })
                }, null, 8, ["editor"])) : w("", !0)
              ]),
              Fe.value ? (u(), b("span", qD, H(e.placeholder), 1)) : w("", !0),
              e.resizable && !e.disabled ? (u(), P(Im, {
                key: 1,
                class: "absolute right-[calc(--spacing(2)-1px)] bottom-[calc(--spacing(2)-1px)]"
              })) : w("", !0)
            ], 6)
          ], 2),
          bt.value ? (u(), P(Pt, {
            key: 0,
            ref_key: "helperRef",
            ref: T,
            focused: S.value,
            hint: e.helpText,
            error: e.error,
            "hint-id": f.value,
            "error-id": c.value,
            "test-id-prefix": "rich-text-editor"
          }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])) : w("", !0),
          nt.value ? (u(), b("div", {
            key: 1,
            class: C(pt.value),
            "data-testid": "rich-text-editor-footer"
          }, [
            U(Di, {
              class: "shrink-0",
              labels: { send: o.value.send },
              actions: e.actions,
              disabled: e.disabled,
              onSend: It,
              onAction: Ht
            }, null, 8, ["labels", "actions", "disabled"]),
            U(Pt, {
              ref_key: "helperRef",
              ref: T,
              class: "min-w-0 flex-1",
              focused: S.value,
              hint: e.helpText,
              error: e.error,
              "hint-id": f.value,
              "error-id": c.value,
              "test-id-prefix": "rich-text-editor"
            }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
          ], 2)) : w("", !0)
        ], 2),
        vt.value ? (u(), b("div", UD, [
          U(Di, {
            class: "shrink-0",
            labels: { send: o.value.send },
            actions: e.actions,
            disabled: e.disabled,
            onSend: It,
            onAction: Ht
          }, null, 8, ["labels", "actions", "disabled"]),
          U(Pt, {
            ref_key: "helperRef",
            ref: T,
            class: "min-w-0 flex-1",
            focused: S.value,
            hint: e.helpText,
            error: e.error,
            "hint-id": f.value,
            "error-id": c.value,
            "test-id-prefix": "rich-text-editor"
          }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
        ])) : w("", !0)
      ], 2),
      U(dl, {
        modelValue: j.value,
        "onUpdate:modelValue": he[16] || (he[16] = (Le) => j.value = Le),
        size: "sm",
        title: o.value.linkDialogTitle,
        "aria-close-label": o.value.closeDialog,
        "footer-align": "split",
        actions: Ne.value
      }, {
        default: me(() => [
          U(Qt, {
            "model-value": J.value,
            type: "url",
            label: o.value.linkUrlLabel,
            placeholder: o.value.linkUrlPlaceholder,
            error: ne.value ? o.value.invalidUrl : void 0,
            "full-width": "",
            "onUpdate:modelValue": he[14] || (he[14] = (Le) => {
              J.value = Le, ne.value = !1;
            }),
            onKeydown: he[15] || (he[15] = (Le) => qe(Le, Re))
          }, null, 8, ["model-value", "label", "placeholder", "error"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "aria-close-label", "actions"]),
      U(dl, {
        modelValue: Y.value,
        "onUpdate:modelValue": he[19] || (he[19] = (Le) => Y.value = Le),
        size: "xs",
        title: o.value.imageDialogTitle,
        "aria-close-label": o.value.closeDialog,
        actions: De.value
      }, {
        default: me(() => [
          U(Qt, {
            "model-value": F.value,
            type: "url",
            label: o.value.imageUrlLabel,
            placeholder: o.value.imageUrlPlaceholder,
            error: ee.value ? o.value.invalidUrl : void 0,
            "full-width": "",
            "onUpdate:modelValue": he[17] || (he[17] = (Le) => {
              F.value = Le, ee.value = !1;
            }),
            onKeydown: he[18] || (he[18] = (Le) => qe(Le, we))
          }, null, 8, ["model-value", "label", "placeholder", "error"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "aria-close-label", "actions"])
    ], 12, gD));
  }
}), nG = /* @__PURE__ */ Ct(KD, [["__scopeId", "data-v-8601a4c1"]]), YD = /* @__PURE__ */ ke({
  __name: "EmailInput",
  props: {
    modelValue: { default: "" },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    success: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    labels: { default: () => ({ clear: "Clear input" }) },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    iconLeft: { default: void 0 },
    hint: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    error: { default: void 0 },
    validator: { type: Function, default: void 0 },
    validateOnBlur: { type: Boolean, default: !0 },
    validateOnInput: { type: Boolean, default: !1 },
    invalidEmailMessage: { default: "Please enter a valid email address" },
    requiredMessage: { default: "Email is required" }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "validation-change"],
  setup(e, { expose: a, emit: t }) {
    const n = Ia(), l = e, o = t, r = R(void 0), i = R(!1), s = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, d = (k) => {
      if (l.validator)
        return l.validator(k) ?? void 0;
      if (l.required && !k.trim())
        return l.requiredMessage;
      if (k.trim() && !s.test(k))
        return l.invalidEmailMessage;
    }, c = () => {
      const k = d(l.modelValue ?? "");
      r.value = k, o("validation-change", !k, k);
    }, f = m(() => {
      if (l.error) return l.error;
      if (i.value) return r.value;
    }), g = (k) => {
      const $ = k.target;
      o("update:modelValue", $.value), o("input", k), l.validateOnInput && c();
    }, h = (k) => {
      o("focus", k);
    }, v = (k) => {
      i.value = !0, o("blur", k), l.validateOnBlur && c();
    };
    return $e(
      () => l.modelValue,
      () => {
        i.value && (l.validateOnBlur || l.validateOnInput) && c();
      }
    ), $e(
      () => l.error,
      (k) => {
        k && (r.value = void 0);
      }
    ), a({
      validate: () => (i.value = !0, c(), !r.value),
      resetValidation: () => {
        i.value = !1, r.value = void 0;
      }
    }), (k, $) => (u(), P(Qt, {
      id: e.id,
      "model-value": e.modelValue,
      placeholder: e.placeholder,
      label: e.label,
      required: e.required,
      "required-indicator": e.requiredIndicator,
      success: e.success,
      "label-tooltip": e.labelTooltip,
      labels: e.labels,
      disabled: e.disabled,
      readonly: e.readonly,
      size: e.size,
      name: e.name,
      "full-width": e.fullWidth,
      width: e.width,
      "icon-left": e.iconLeft,
      hint: e.hint,
      "label-inline": e.labelInline,
      error: f.value,
      type: "email",
      inputmode: "email",
      autocomplete: e.autocomplete,
      "data-testid": "email-input",
      "onUpdate:modelValue": $[0] || ($[0] = (S) => o("update:modelValue", S)),
      onInput: g,
      onFocus: h,
      onBlur: v
    }, Xa({ _: 2 }, [
      L(n)("actions") ? {
        name: "actions",
        fn: me(() => [
          Me(k.$slots, "actions")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["id", "model-value", "placeholder", "label", "required", "required-indicator", "success", "label-tooltip", "labels", "disabled", "readonly", "size", "name", "full-width", "width", "icon-left", "hint", "label-inline", "error", "autocomplete"]));
  }
}), JD = ["disabled", "aria-pressed", "aria-controls", "aria-label"], lG = /* @__PURE__ */ ke({
  __name: "PasswordInput",
  props: {
    modelValue: { default: "" },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    ariaLabel: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "current-password" },
    maxlength: { default: void 0 },
    minlength: { default: void 0 },
    labels: { default: () => ({}) },
    remember: { type: Boolean, default: !1 },
    rememberLabel: { default: void 0 },
    forgotLabel: { default: void 0 },
    forgotHref: { default: void 0 }
  },
  emits: ["update:modelValue", "update:remember", "forgot", "focus", "blur"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = Ye(), o = m(() => t.id ?? l), r = R(!1), i = m(() => t.labels.show ?? "Show password"), s = m(() => !!t.rememberLabel || !!t.forgotLabel), d = m(() => t.disabled ? "cursor-not-allowed" : "cursor-pointer");
    function c() {
      t.forgotHref || n("forgot");
    }
    return wa(
      cm,
      () => s.value ? gn("div", { class: "flex w-full items-center justify-between gap-1", "data-testid": "password-input-row" }, [
        t.rememberLabel ? gn(va, {
          modelValue: t.remember,
          label: t.rememberLabel,
          disabled: t.disabled,
          "onUpdate:modelValue": (f) => n("update:remember", f)
        }) : null,
        t.forgotLabel ? gn(
          pa,
          {
            class: "ml-auto shrink-0",
            "data-testid": "password-input-forgot",
            as: t.forgotHref ? "a" : "button",
            href: t.forgotHref,
            disabled: t.disabled,
            onClick: c
          },
          () => t.forgotLabel
        ) : null
      ]) : null
    ), (f, g) => (u(), P(Qt, {
      id: o.value,
      "model-value": e.modelValue,
      type: r.value ? "text" : "password",
      "icon-left": "ri-lock-2-line",
      placeholder: e.placeholder,
      label: e.label,
      "label-tooltip": e.labelTooltip,
      required: e.required,
      "required-indicator": e.requiredIndicator,
      "aria-label": e.ariaLabel,
      hint: e.hint,
      error: e.error,
      success: e.success,
      disabled: e.disabled,
      readonly: e.readonly,
      size: e.size,
      name: e.name,
      "full-width": e.fullWidth,
      width: e.width,
      "label-inline": e.labelInline,
      autocomplete: e.autocomplete,
      maxlength: e.maxlength,
      minlength: e.minlength,
      "onUpdate:modelValue": g[1] || (g[1] = (h) => n("update:modelValue", h)),
      onFocus: g[2] || (g[2] = (h) => n("focus", h)),
      onBlur: g[3] || (g[3] = (h) => n("blur", h))
    }, {
      iconRight: me(({ iconColorClass: h, iconBoxClass: v }) => [
        x("button", {
          type: "button",
          "data-testid": "password-input-toggle",
          class: C([
            v,
            h,
            d.value,
            "rounded-(--border-border-radius-rounded-xs) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
          ]),
          disabled: e.disabled,
          "aria-pressed": r.value,
          "aria-controls": o.value,
          "aria-label": i.value,
          onClick: g[0] || (g[0] = (p) => r.value = !r.value)
        }, [
          x("i", {
            class: C(r.value ? "ri-eye-off-line" : "ri-eye-line"),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, JD)
      ]),
      _: 1
    }, 8, ["id", "model-value", "type", "placeholder", "label", "label-tooltip", "required", "required-indicator", "aria-label", "hint", "error", "success", "disabled", "readonly", "size", "name", "full-width", "width", "label-inline", "autocomplete", "maxlength", "minlength"]));
  }
});
function fx(e) {
  if (!e || !/^[dmy/\-. ]+$/.test(e) || !/[dmy]/.test(e)) return null;
  for (const a of e.match(/([dmy])\1*/g) ?? [])
    if (a.length < 2) return null;
  return e.replace(/[dmy]/g, "0");
}
function Uu(e) {
  const a = new Set([...e].filter((l) => /\D/.test(l)));
  if (a.size !== 1) return null;
  const [t] = [...a], n = e.split(t).map((l) => l.length).filter((l) => l > 0);
  return n.length === 0 ? null : { groupSizes: n, separator: t };
}
function XD(e) {
  if (!e) return null;
  const a = e.match(/[Xx]+/g);
  if (!a) return null;
  const t = e.split(/[Xx]+/);
  if (t[0] !== "" || t[t.length - 1] !== "") return null;
  const n = t.slice(1, -1);
  if (n.length === 0) return null;
  const [l] = n;
  return l === "" || n.some((o) => o !== l) ? null : { groupSizes: a.map((o) => o.length), separator: l };
}
function Lr(e, a) {
  if (!e) return "";
  const t = [];
  let n = 0;
  for (const l of a.groupSizes) {
    if (n >= e.length) break;
    t.push(e.slice(n, n + l)), n += l;
  }
  return n < e.length && t.push(e.slice(n)), t.join(a.separator);
}
function ZD(e, a) {
  if (a <= 0) return 0;
  let t = 0;
  for (let n = 0; n < e.length; n++)
    if (/\d/.test(e[n]) && (t += 1, t === a))
      return n + 1;
  return e.length;
}
function hx(e, a, t) {
  const n = e.value, l = e.selectionStart ?? n.length, o = a(n.slice(0, l)).length, r = a(n), i = t(r);
  e.value = i;
  const s = ZD(i, o);
  try {
    e.setSelectionRange(s, s);
  } catch {
  }
  return i;
}
function zb(e, a, t) {
  return hx(
    e,
    a,
    (n) => t ? Lr(n, t) : n
  );
}
function bx(e, a, t) {
  if (e.key !== "Backspace" && e.key !== "Delete" || e.ctrlKey || e.altKey || e.metaKey) return !1;
  const n = a.selectionStart, l = a.selectionEnd;
  if (n === null || l === null || n !== l) return !1;
  const o = a.value, r = (d) => d !== void 0 && /\d/.test(d);
  let i, s;
  if (e.key === "Backspace") {
    if (n === 0 || r(o[n - 1])) return !1;
    let d = n - 1;
    for (; d >= 0 && !r(o[d]); ) d -= 1;
    if (d < 0) return !1;
    i = d, s = d;
  } else {
    if (n >= o.length || r(o[n])) return !1;
    let d = n;
    for (; d < o.length && !r(o[d]); ) d += 1;
    if (d >= o.length) return !1;
    i = d, s = n;
  }
  a.value = o.slice(0, i) + o.slice(i + 1);
  try {
    a.setSelectionRange(s, s);
  } catch {
  }
  return e.preventDefault(), t(a), !0;
}
const bn = {
  FR: { placeholder: "6 12 34 56 78", min: 9, max: 9, name: "France", hasTrunkZero: !0 },
  GB: {
    placeholder: "7911 123456",
    min: 9,
    max: 10,
    name: "United Kingdom",
    hasTrunkZero: !0
  },
  CA: {
    placeholder: "123-456-7890",
    min: 10,
    max: 10,
    name: "Canada",
    hasTrunkZero: !1,
    displaySeparator: " "
  },
  US: {
    placeholder: "123-456-7890",
    min: 10,
    max: 10,
    name: "United States",
    hasTrunkZero: !1,
    displaySeparator: " "
  },
  NL: { placeholder: "6 12345678", min: 9, max: 9, name: "Netherlands", hasTrunkZero: !0 },
  DE: { placeholder: "176 12345678", min: 10, max: 11, name: "Germany", hasTrunkZero: !0 },
  // min: 8 covers landline numbers behind a 2-digit area code (Brussels "02 XXX XX XX" = 8
  // significant digits); mobiles and other landlines are 9 (the placeholder's own length).
  BE: { placeholder: "470 12 34 56", min: 8, max: 9, name: "Belgium", hasTrunkZero: !0 },
  CH: { placeholder: "78 123 45 67", min: 9, max: 9, name: "Switzerland", hasTrunkZero: !0 },
  // The leading "0" is a significant digit of the Italian landline numbering plan (mandatory,
  // not a trunk prefix) — hasTrunkZero: false so it is never split out, stripped, or parenthesised
  // anywhere (input, display, validation count). min/max count the "0" itself, so hasTrunkZero:
  // false means nothing strips it before counting. min: 9 covers a shorter landline behind a
  // 2-digit area code ("02 1234 567" = 9 digits); max: 10 matches the placeholder (mobiles and
  // longer landlines).
  IT: { placeholder: "06 1234 5678", min: 9, max: 10, name: "Italy", hasTrunkZero: !1 },
  ES: { placeholder: "612 34 56 78", min: 9, max: 9, name: "Spain", hasTrunkZero: !1 },
  PT: { placeholder: "912 345 678", min: 9, max: 9, name: "Portugal", hasTrunkZero: !1 },
  GR: { placeholder: "691 234 5678", min: 10, max: 10, name: "Greece", hasTrunkZero: !1 },
  DK: { placeholder: "20 12 34 56", min: 8, max: 8, name: "Denmark", hasTrunkZero: !1 },
  NO: { placeholder: "406 12 345", min: 8, max: 8, name: "Norway", hasTrunkZero: !1 }
}, eo = {
  placeholder: "123 456 789",
  min: 6,
  max: Number.POSITIVE_INFINITY,
  name: "",
  hasTrunkZero: !1
}, Db = "FR", gx = {
  FR: "+33",
  GB: "+44",
  CA: "+1",
  US: "+1",
  NL: "+31",
  DE: "+49",
  BE: "+32",
  CH: "+41",
  IT: "+39",
  ES: "+34",
  PT: "+351",
  GR: "+30",
  DK: "+45",
  NO: "+47"
}, bf = Object.entries(gx).sort((e, a) => a[1].length - e[1].length), QD = Object.entries(
  bn
).reduce((e, [a, t]) => {
  const n = gx[a];
  return n in e || (e[n] = t), e;
}, {});
function Bb(e) {
  const a = e.replace(/^0+/, "");
  return a.length > 0 ? a : e;
}
function Mb(e, a) {
  const t = bn[a] ?? eo, n = Uu(t.placeholder);
  if (!n) return e;
  const l = t.displaySeparator ?? n.separator;
  return Lr(e, { groupSizes: n.groupSizes, separator: l });
}
function Oo(e, a, t) {
  if (!e) return "";
  if (!t) {
    const i = Uu(a);
    return i ? Lr(e, i) : e;
  }
  if (/^0*$/.test(e)) return e;
  const n = e.startsWith("0"), l = n ? "0" : "", o = n ? e.slice(1) : e, r = Uu(a);
  return l + (r ? Lr(o, r) : o);
}
function gf(e, a) {
  return /^0*$/.test(e) ? "" : a && e.startsWith("0") ? e.slice(1) : e;
}
function oG(e) {
  const a = (e ?? "").trim();
  if (!a.startsWith("+")) return e;
  const t = bf.find(([, i]) => a.startsWith(i));
  if (!t) return e;
  const [n, l] = t;
  if (!bn[n].hasTrunkZero) return e;
  const r = a.slice(l.length).replace(/\D/g, "");
  return !r || r.startsWith("0") ? e : `${l}0${r}`;
}
function rG(e) {
  const a = (e ?? "").trim();
  if (!a.startsWith("+")) return e;
  const t = bf.find(([, s]) => a.startsWith(s));
  if (!t) return e;
  const [n, l] = t, o = bn[n], r = a.slice(l.length).replace(/\D/g, ""), i = o.hasTrunkZero ? gf(r, !0) : r;
  return i ? `${l}${i}` : e;
}
function _D(e) {
  const a = (e ?? "").trim();
  if (!a) return e;
  if (a.startsWith("+")) {
    const i = bf.find(([, p]) => a.startsWith(p));
    if (!i) return e;
    const [s, d] = i, c = bn[s], f = a.slice(d.length).replace(/\D/g, ""), g = c.hasTrunkZero ? Bb(f) : f;
    if (!g) return e;
    const h = Mb(g, s), v = c.hasTrunkZero ? "(0)" : "";
    return `${d} ${v}${h}`;
  }
  const t = Bb(a.replace(/\D/g, ""));
  if (!t) return e;
  const { min: n, max: l } = bn[Db];
  if (t.length < n || t.length > l) return e;
  const o = Mb(t, Db);
  return `${a.replace(/\D/g, "").startsWith("0") ? "0" : ""}${o}`;
}
const eB = ["id"], tB = { class: "relative min-w-0 flex-1" }, aB = { class: "inline-flex items-center gap-1.5" }, nB = { class: "inline-flex size-4 shrink-0 items-center justify-center" }, lB = ["title"], oB = ["id", "autocomplete", "disabled", "readonly", "aria-labelledby", "aria-invalid", "aria-describedby", "placeholder"], rB = ["aria-label"], iB = {
  key: 0,
  class: "shrink-0"
}, sB = /* @__PURE__ */ ke({
  __name: "PhoneInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 },
    disableInternalValidation: { type: Boolean, default: !1 },
    showCountrySelector: { type: Boolean, default: !0 },
    showVerificationButton: { type: Boolean, default: !1 },
    verificationOptions: { default: () => [
      { id: "sms", label: "Send SMS" },
      { id: "call", label: "Call" }
    ] },
    countries: { default: () => [
      { code: "FR", name: "France", dialCode: "+33" },
      { code: "GB", name: "United Kingdom", dialCode: "+44" },
      { code: "CA", name: "Canada", dialCode: "+1" },
      { code: "NL", name: "Netherlands", dialCode: "+31" },
      { code: "DE", name: "Germany", dialCode: "+49" },
      { code: "BE", name: "Belgium", dialCode: "+32" },
      { code: "CH", name: "Switzerland", dialCode: "+41" },
      { code: "IT", name: "Italy", dialCode: "+39" },
      { code: "ES", name: "Spain", dialCode: "+34" },
      { code: "PT", name: "Portugal", dialCode: "+351" },
      { code: "GR", name: "Greece", dialCode: "+30" },
      { code: "DK", name: "Denmark", dialCode: "+45" },
      { code: "NO", name: "Norway", dialCode: "+47" }
    ] },
    countryListLabel: { default: "Country" },
    locale: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    size: { default: "md" },
    autocomplete: { default: "tel" },
    maskInput: { type: Boolean, default: !0 },
    formatHintLabel: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    labelInline: { type: Boolean, default: !1 },
    buttons: { default: () => [] },
    buttonLayout: { default: "attached" },
    buttonSize: { default: void 0 },
    innerButton: { default: void 0 },
    removeButton: { default: void 0 }
  },
  emits: ["update:modelValue", "focus", "blur", "validation-change", "verification-click", "country-change", "button-click"],
  setup(e, { emit: a }) {
    const t = e, n = Ia(), l = m(() => n("actions")), o = a, r = R(!1), i = R(!1), s = R(""), d = R(t.countries[0]), c = R(t.verificationOptions[0]), f = R(!1), g = R(void 0), h = R(null), v = R(null), p = m(() => {
      var Fe;
      return ((Fe = h.value) == null ? void 0 : Fe.$el) ?? null;
    }), y = R(null), k = m(
      () => {
        var Fe;
        return ((Fe = v.value) == null ? void 0 : Fe.$el) ?? null;
      }
    ), $ = R(null), S = wc(), I = m(() => {
      if (!t.locale) return null;
      try {
        return new Intl.DisplayNames([t.locale], { type: "region", fallback: "none" });
      } catch {
        return null;
      }
    }), T = (Fe) => {
      var je;
      return ((je = I.value) == null ? void 0 : je.of(Fe.code)) ?? Fe.name;
    }, A = (Fe) => {
      var je;
      return Fe.placeholder || ((je = bn[Fe.code]) == null ? void 0 : je.placeholder) || eo.placeholder;
    }, E = (Fe) => {
      const je = Fe.replace(/\s/g, "");
      return [...t.countries].sort((bt, At) => At.dialCode.length - bt.dialCode.length).find((bt) => je.startsWith(bt.dialCode));
    }, z = () => {
      if (!t.modelValue) {
        s.value = "";
        return;
      }
      const Fe = E(t.modelValue);
      if (Fe) {
        d.value = Fe;
        const je = t.modelValue.slice(Fe.dialCode.length);
        s.value = t.maskInput && t.showCountrySelector ? Oo(
          je.replace(/\D/g, ""),
          A(Fe),
          (bn[Fe.code] ?? eo).hasTrunkZero
        ) : je;
        return;
      }
      s.value = t.modelValue.replace(/^\+/, "");
    };
    z();
    const B = m(() => {
      const Fe = s.value.replace(/\D/g, "");
      return !Fe || !/[1-9]/.test(Fe) ? "" : t.showCountrySelector ? `${d.value.dialCode}${Fe}` : `+${Fe}`;
    }), W = m(() => bn[d.value.code] || eo), _ = m(() => t.showCountrySelector ? A(d.value) : "+33612345678"), Z = m(() => {
      if (t.error) return t.error;
      if (!t.disableInternalValidation && f.value)
        return g.value;
    }), le = () => {
      const Fe = s.value.replace(/\D/g, "");
      if (t.required && !Fe)
        return "Phone number is required";
      if (!Fe)
        return;
      const je = gf(Fe, W.value.hasTrunkZero), { min: Ke, max: bt } = W.value;
      if (je.length < Ke || je.length > bt)
        return `Phone number must be ${Ke === bt ? `${Ke}` : `${Ke}–${bt}`} digits for ${d.value.name}`;
    }, D = () => {
      const Fe = le();
      g.value = Fe, o("validation-change", !Fe, Fe);
    }, O = () => {
      g.value = void 0;
    }, N = (Fe) => hx(
      Fe,
      (je) => je.replace(/\D/g, ""),
      (je) => Oo(je, _.value, W.value.hasTrunkZero)
    ), V = (Fe) => {
      const je = Fe.target;
      if (O(), t.maskInput && t.showCountrySelector) {
        s.value = N(je);
        return;
      }
      const Ke = je.value.replace(/[^\d\s\-()]/g, "");
      s.value = Ke, je.value = Ke;
    }, M = (Fe) => {
      var bt, At;
      if ((bt = Ne.value) == null || bt.handleFieldKeydown(Fe), (At = De.value) == null || At.handleFieldKeydown(Fe), t.readonly || t.disabled || !(t.maskInput && t.showCountrySelector)) return;
      const je = Fe.target;
      bx(Fe, je, (Ce) => N(Ce)) && (O(), s.value = je.value);
    }, Q = (Fe) => {
      if (fe.value = !1, f.value = !0, t.showCountrySelector) {
        const je = s.value.replace(/\D/g, "");
        s.value = t.maskInput ? Oo(
          je,
          _.value,
          W.value.hasTrunkZero
        ) : je;
      }
      D(), o("blur", Fe);
    }, q = (Fe) => {
      fe.value = !0, o("focus", Fe);
    }, K = (Fe) => {
      var Ce;
      if (!t.showCountrySelector) return;
      const je = (((Ce = Fe.clipboardData) == null ? void 0 : Ce.getData("text")) ?? "").trim();
      if (!je.startsWith("+")) return;
      const Ke = E(je);
      if (!Ke) return;
      Fe.preventDefault(), O(), d.value = Ke;
      const bt = bn[Ke.code] ?? eo, At = je.replace(/\D/g, "").slice(Ke.dialCode.replace(/\D/g, "").length);
      s.value = t.maskInput ? Oo(At, A(Ke), bt.hasTrunkZero) : At;
    }, G = (Fe) => {
      d.value = Fe, J("country"), t.maskInput && t.showCountrySelector && s.value && (s.value = Oo(
        s.value.replace(/\D/g, ""),
        _.value,
        W.value.hasTrunkZero
      )), f.value && D();
    }, te = (Fe, je) => {
      je.stopPropagation(), G(Fe);
    }, ve = (Fe) => Fe === "country" ? r : i, Se = (Fe) => Fe === "country" ? p.value : k.value, oe = (Fe) => Fe === "country" ? y.value : $.value, re = (Fe) => {
      var je;
      return Array.from(((je = oe(Fe)) == null ? void 0 : je.querySelectorAll("[data-popup-row]")) ?? []);
    }, ge = (Fe) => Fe.findIndex((je) => je.getAttribute("aria-selected") === "true" || je.getAttribute("aria-checked") === "true"), de = (Fe, je) => {
      const Ke = Fe[(je + Fe.length) % Fe.length];
      Ke == null || Ke.focus({ preventScroll: !0 }), Ke == null || Ke.scrollIntoView({ block: "nearest" });
    }, Ee = (Fe, je) => {
      const Ke = ge(Fe);
      de(Fe, Ke !== -1 ? Ke : je === "first" ? 0 : Fe.length - 1);
    }, j = async (Fe, je = "first") => {
      ve(Fe).value = !0, await Ze(), Ee(re(Fe), je);
    }, J = (Fe) => {
      var je, Ke;
      (je = oe(Fe)) != null && je.contains(document.activeElement) && ((Ke = Se(Fe)) == null || Ke.focus()), ve(Fe).value = !1;
    }, ne = (Fe, je) => {
      t.disabled || (je.stopPropagation(), ve(Fe).value ? J(Fe) : je.detail === 0 ? j(Fe) : ve(Fe).value = !0);
    }, Y = (Fe, je) => {
      const Ke = ll(S.query.value), bt = /^(.)\1+$/u.test(Ke) ? Ke[0] : Ke, At = bt.length === 1 ? je + 1 : Math.max(je, 0);
      for (let Ce = 0; Ce < t.countries.length; Ce++) {
        const He = (At + Ce) % t.countries.length;
        if (ll(T(t.countries[He])).startsWith(bt)) {
          de(Fe, He);
          return;
        }
      }
    }, F = (Fe, je) => {
      var At;
      if (!ve(Fe).value) {
        (je.key === "ArrowDown" || je.key === "ArrowUp") && (je.preventDefault(), j(Fe, je.key === "ArrowDown" ? "first" : "last"));
        return;
      }
      const Ke = re(Fe), bt = Ke.indexOf(document.activeElement);
      if (Fe === "country" && !(je.key === " " && !S.query.value) && S.handleKey(je)) {
        je.preventDefault(), je.stopPropagation(), Y(Ke, bt);
        return;
      }
      switch (je.key) {
        case "ArrowDown":
        case "ArrowUp":
          je.preventDefault(), bt === -1 ? Ee(Ke, je.key === "ArrowDown" ? "first" : "last") : de(Ke, bt + (je.key === "ArrowDown" ? 1 : -1));
          break;
        case "Home":
        case "End":
          je.preventDefault(), de(Ke, je.key === "Home" ? 0 : Ke.length - 1);
          break;
        case "Enter":
        case " ":
          if (bt === -1) return;
          je.preventDefault(), je.stopPropagation(), Ke[bt].click();
          break;
        case "Escape":
          je.preventDefault(), je.stopPropagation(), J(Fe), (At = Se(Fe)) == null || At.focus();
          break;
        case "Tab":
          J(Fe);
          break;
      }
    }, ee = (Fe) => ne("country", Fe), ue = (Fe) => ne("verification", Fe), se = (Fe, je) => {
      je.stopPropagation(), c.value = Fe, J("verification"), o("verification-click", Fe.id);
    }, X = (Fe) => {
      const je = Fe.target, Ke = !p.value || !p.value.contains(je), bt = !y.value || !y.value.contains(je);
      Ke && bt && (r.value = !1);
      const At = !k.value || !k.value.contains(je), Ce = !$.value || !$.value.contains(je);
      At && Ce && (i.value = !1);
    };
    $e([s, d], () => {
      if (o("update:modelValue", B.value), t.showCountrySelector) {
        const Fe = s.value.replace(/\D/g, "");
        o("country-change", d.value, Fe);
      }
    }), $e(
      () => t.modelValue,
      (Fe) => {
        Fe !== B.value && (O(), z());
      }
    ), $e([r, i], ([Fe, je]) => {
      Fe || je ? document.addEventListener("click", X) : document.removeEventListener("click", X), Fe || S.reset();
    }), kt(() => {
      t.maskInput && t.showCountrySelector && t.modelValue && t.countries.some((Fe) => t.modelValue.startsWith(Fe.dialCode)) && B.value !== t.modelValue && o("update:modelValue", B.value);
    }), zt(() => {
      document.removeEventListener("click", X);
    });
    const ae = m(
      () => Co(t.labelInline, !!t.label, !!t.removeButton)
    ), Re = m(() => t.removeButton && Cc(t.removeButton)), Ae = m(() => !!t.innerButton || t.showVerificationButton), xe = m(
      () => t.size === "md" ? "pl-[calc(--spacing(2)-1px)] pr-[calc(--spacing(2)-1px)]" : ""
    ), we = Ye(), fe = R(!1), Ne = R(null), De = R(null), qe = m(() => `${we}-phone`), Qe = m(() => t.label ? `${we}-label` : void 0), lt = m(() => `${we}-error`), Ie = m(() => `${we}-hint`), pe = m(() => `${we}-format-hint`), Pe = `${we}-countries`, Xe = `${we}-verification`, nt = `${we}-verification-menu`, vt = m(() => t.formatHintLabel ? `${t.formatHintLabel} ${_.value}` : t.showCountrySelector ? _.value : ""), Gt = m(() => {
      const Fe = [];
      return vt.value && Fe.push(pe.value), t.hint && Fe.push(Ie.value), Z.value && Fe.push(lt.value), Fe.length > 0 ? Fe.join(" ") : void 0;
    });
    return (Fe, je) => (u(), b("div", {
      class: C(["relative w-full pb-0.5", ae.value.root])
    }, [
      e.label ? (u(), P(Ft, {
        key: 0,
        id: Qe.value,
        ref_key: "labelRef",
        ref: Ne,
        text: e.label,
        "input-id": qe.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: fe.value,
        inline: e.labelInline,
        class: C(ae.value.label),
        "test-id": "phone-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : w("", !0),
      vt.value ? (u(), b("span", {
        key: 1,
        id: pe.value,
        class: "sr-only"
      }, H(vt.value), 9, eB)) : w("", !0),
      x("div", {
        class: C(["flex w-full items-end gap-3", ae.value.field])
      }, [
        x("div", tB, [
          U(Br, {
            buttons: e.buttons,
            layout: e.buttonLayout,
            size: e.size,
            disabled: e.disabled,
            "button-size": e.buttonSize,
            onButtonClick: je[4] || (je[4] = (Ke) => o("button-click", Ke))
          }, Xa({
            default: me(({ fieldClass: Ke }) => [
              U(en, {
                class: C(["w-full", Ke]),
                size: e.size,
                "inner-button": Ae.value,
                disabled: e.disabled,
                readonly: e.readonly,
                error: !!Z.value,
                "has-value": !!s.value
              }, {
                default: me(({ leftIconBoxClass: bt, iconColorClass: At, textClass: Ce }) => [
                  x("i", {
                    class: C(["ri-phone-fill", bt, At]),
                    "aria-hidden": "true"
                  }, null, 2),
                  wo(x("input", {
                    id: qe.value,
                    "onUpdate:modelValue": je[1] || (je[1] = (He) => s.value = He),
                    type: "tel",
                    inputmode: "tel",
                    autocomplete: e.autocomplete,
                    disabled: e.disabled,
                    readonly: e.readonly,
                    "aria-labelledby": Qe.value,
                    "aria-invalid": !!Z.value,
                    "aria-describedby": Gt.value,
                    class: C([
                      "relative min-w-0 flex-1 text-ellipsis border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
                      Ce,
                      e.readonly ? "cursor-default" : ""
                    ]),
                    placeholder: _.value,
                    onInput: V,
                    onKeydown: M,
                    onPaste: K,
                    onBlur: Q,
                    onFocus: q
                  }, null, 42, oB), [
                    [Eg, s.value]
                  ]),
                  e.innerButton ? (u(), P(Be, Ve({ key: 0 }, L(vn)(e.innerButton, e.disabled), {
                    size: "xs",
                    onClick: je[2] || (je[2] = (He) => o("button-click", e.innerButton.id))
                  }), null, 16)) : w("", !0),
                  e.showVerificationButton ? (u(), P(Be, {
                    key: 1,
                    id: Xe,
                    ref_key: "verificationButtonRef",
                    ref: v,
                    variant: "tertiary",
                    size: "xs",
                    class: C(e.size === "md" ? "-mr-0.5" : ""),
                    label: c.value.label,
                    disabled: e.disabled || e.readonly,
                    "aria-haspopup": "menu",
                    "aria-expanded": i.value,
                    "aria-controls": i.value ? nt : void 0,
                    "dropdown-icon": "",
                    onClick: ue,
                    onKeydown: je[3] || (je[3] = (He) => F("verification", He))
                  }, null, 8, ["class", "label", "disabled", "aria-expanded", "aria-controls"])) : w("", !0)
                ]),
                _: 1
              }, 8, ["class", "size", "inner-button", "disabled", "readonly", "error", "has-value"])
            ]),
            _: 2
          }, [
            e.showCountrySelector ? {
              name: "leading",
              fn: me(({ partClass: Ke, buttonSize: bt }) => [
                U(Be, {
                  ref_key: "countryButtonRef",
                  ref: h,
                  variant: "secondary",
                  size: bt,
                  class: C([Ke, xe.value]),
                  disabled: e.disabled || e.readonly,
                  "aria-haspopup": "listbox",
                  "aria-expanded": r.value,
                  "aria-controls": r.value ? Pe : void 0,
                  "dropdown-icon": "",
                  onClick: ee,
                  onKeydown: je[0] || (je[0] = (At) => F("country", At))
                }, {
                  default: me(() => [
                    x("span", aB, [
                      x("span", nB, [
                        x("span", {
                          class: C(["fi fis size-[13.33px] rounded-full", `fi-${d.value.code.toLowerCase()}`]),
                          title: T(d.value)
                        }, null, 10, lB)
                      ]),
                      x("span", null, H(d.value.dialCode), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["size", "class", "disabled", "aria-expanded", "aria-controls"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["buttons", "layout", "size", "disabled", "button-size"]),
          e.showCountrySelector && r.value ? (u(), b("div", {
            key: 0,
            ref_key: "countryDropdownMenuRef",
            ref: y,
            class: C(["absolute left-0 top-full z-50 mt-1 w-56 max-h-[min(400px,calc(100vh-24px))] overflow-y-auto", L(Ai)]),
            onKeydown: je[5] || (je[5] = (Ke) => F("country", Ke))
          }, [
            x("ul", {
              id: Pe,
              class: "flex min-w-0 flex-col gap-1.5",
              role: "listbox",
              "aria-label": e.countryListLabel
            }, [
              (u(!0), b(ie, null, Oe(e.countries, (Ke) => (u(), P(fa, {
                key: Ke.code,
                as: "li",
                type: "flag",
                role: "option",
                tabindex: "-1",
                "data-popup-row": "",
                "aria-selected": Ke.code === d.value.code,
                label: T(Ke),
                flag: Ke.code,
                selected: Ke.code === d.value.code,
                "data-testid": `phone-country-${Ke.code}`,
                onClick: (bt) => te(Ke, bt)
              }, null, 8, ["aria-selected", "label", "flag", "selected", "data-testid", "onClick"]))), 128))
            ], 8, rB)
          ], 34)) : w("", !0),
          e.showVerificationButton && i.value ? (u(), b("div", {
            key: 1,
            ref_key: "verificationDropdownMenuRef",
            ref: $,
            class: C(["absolute right-0 top-full z-50 mt-1 min-w-36 w-max", L(Ai)]),
            onKeydown: je[6] || (je[6] = (Ke) => F("verification", Ke))
          }, [
            x("ul", {
              id: nt,
              class: "flex min-w-0 flex-col gap-1.5",
              role: "menu",
              "aria-labelledby": Xe
            }, [
              (u(!0), b(ie, null, Oe(e.verificationOptions, (Ke) => (u(), P(fa, {
                key: Ke.id,
                as: "li",
                type: "default",
                role: "menuitemradio",
                tabindex: "-1",
                "data-popup-row": "",
                "aria-checked": Ke.id === c.value.id,
                label: Ke.label,
                selected: Ke.id === c.value.id,
                onClick: (bt) => se(Ke, bt)
              }, null, 8, ["aria-checked", "label", "selected", "onClick"]))), 128))
            ])
          ], 34)) : w("", !0)
        ]),
        l.value ? (u(), b("div", iB, [
          Me(Fe.$slots, "actions", {}, void 0, !0)
        ])) : w("", !0),
        Re.value && ae.value.removeInFieldRow ? (u(), P(Be, Ve({ key: 1 }, L(vn)(Re.value, e.disabled), {
          size: L(ol)(e.size, "attached"),
          onClick: je[7] || (je[7] = (Ke) => o("button-click", Re.value.id))
        }), null, 16, ["size"])) : w("", !0)
      ], 2),
      ae.value.reservesHelper || e.hint || Z.value ? (u(), P(Pt, {
        key: 2,
        ref_key: "helperRef",
        ref: De,
        class: C(ae.value.helper),
        focused: fe.value,
        hint: e.hint,
        error: Z.value,
        "hint-id": Ie.value,
        "error-id": lt.value,
        "test-id-prefix": "phone-input"
      }, null, 8, ["class", "focused", "hint", "error", "hint-id", "error-id"])) : w("", !0),
      Re.value && !ae.value.removeInFieldRow ? (u(), P(Be, Ve({ key: 3 }, L(vn)(Re.value, e.disabled), {
        class: ae.value.remove,
        size: L(ol)(e.size, "attached"),
        onClick: je[8] || (je[8] = (Ke) => o("button-click", Re.value.id))
      }), null, 16, ["class", "size"])) : w("", !0)
    ], 2));
  }
}), dB = /* @__PURE__ */ Ct(sB, [["__scopeId", "data-v-da8fce2b"]]), uB = ["href", "aria-label"], cB = { key: 1 }, iG = /* @__PURE__ */ ke({
  __name: "PhoneDisplay",
  props: {
    value: {},
    link: { type: Boolean, default: !0 },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    const a = e, t = m(() => _D(a.value)), n = m(() => `tel:${a.value.replace(/[^\d+]/g, "")}`);
    return (l, o) => e.link ? (u(), b("a", {
      key: 0,
      href: n.value,
      "aria-label": e.ariaLabel
    }, H(t.value), 9, uB)) : (u(), b("span", cB, H(t.value), 1));
  }
}), fB = ["id"], sG = /* @__PURE__ */ ke({
  __name: "MaskedInput",
  props: {
    modelValue: { default: "" },
    mask: {},
    label: { default: void 0 },
    placeholder: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    success: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    labels: { default: () => ({ clear: "Clear input" }) },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    iconLeft: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    formatHintLabel: { default: void 0 },
    showEditIcon: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = Ia(), o = m(() => XD(t.mask)), r = ($) => $.replace(/\D/g, ""), i = m(() => {
      const $ = r(t.modelValue ?? "");
      return o.value ? Lr($, o.value) : $;
    }), s = Ye(), d = m(() => t.id || `${s}-masked`), c = m(() => `${d.value}-format-hint`), f = m(
      () => t.formatHintLabel ? `${t.formatHintLabel} ${t.mask}` : t.mask
    ), g = m(() => {
      const $ = [c.value];
      return t.hint && $.push(`${d.value}-hint`), t.error && $.push(`${d.value}-error`), $.join(" ");
    }), h = ($) => {
      const S = $.target, I = zb(S, r, o.value);
      n("update:modelValue", I), n("input", $);
    }, v = ($) => {
      if (t.readonly || t.disabled) return;
      const S = $.target;
      bx(
        $,
        S,
        (T) => zb(T, r, o.value)
      ) && n("update:modelValue", S.value);
    }, p = ($) => n("focus", $), y = ($) => n("blur", $), k = () => {
      n("update:modelValue", ""), n("clear");
    };
    return ($, S) => (u(), b("div", null, [
      x("span", {
        id: c.value,
        class: "sr-only"
      }, H(f.value), 9, fB),
      U(Qt, {
        id: d.value,
        "model-value": i.value,
        placeholder: e.placeholder,
        label: e.label,
        hint: e.hint,
        error: e.error,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        disabled: e.disabled,
        success: e.success,
        "label-tooltip": e.labelTooltip,
        labels: e.labels,
        readonly: e.readonly,
        size: e.size,
        name: e.name,
        "full-width": e.fullWidth,
        width: e.width,
        "icon-left": e.iconLeft,
        "show-edit-icon": e.showEditIcon,
        "label-inline": e.labelInline,
        autocomplete: e.autocomplete,
        "aria-describedby": g.value,
        type: "text",
        inputmode: "numeric",
        "data-testid": "masked-input",
        onInput: h,
        onKeydown: v,
        onFocus: p,
        onBlur: y,
        onClear: k
      }, Xa({ _: 2 }, [
        L(l)("actions") ? {
          name: "actions",
          fn: me(() => [
            Me($.$slots, "actions")
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "model-value", "placeholder", "label", "hint", "error", "required", "required-indicator", "disabled", "success", "label-tooltip", "labels", "readonly", "size", "name", "full-width", "width", "icon-left", "show-edit-icon", "label-inline", "autocomplete", "aria-describedby"])
    ]));
  }
}), hB = ["disabled", "aria-disabled", "aria-label", "data-testid"], bB = {
  key: 2,
  role: "status",
  class: "sr-only"
}, gB = 2e3, Fd = /* @__PURE__ */ ke({
  __name: "ListItemActionButton",
  props: {
    action: {},
    appearance: {},
    variant: {},
    muted: { type: Boolean },
    rowHover: { type: Boolean },
    keepFocusable: { type: Boolean }
  },
  setup(e, { expose: a }) {
    const t = e, n = m(() => t.action.disabled ? t.action.disabledReason : void 0), l = m(() => !!t.action.disabled), o = m(() => l.value && !n.value && !t.keepFocusable), r = m(() => l.value && !o.value), i = m(() => t.muted || l.value ? "text-(--icons-icon-base)" : t.rowHover ? "text-(--icons-icon-base-strong) group-hover/row:text-(--icons-icon-hover)" : "text-(--icons-icon-base-strong)"), s = R(null), d = R(null), c = R(!1);
    let f, g = !1;
    const h = m(() => "copiedLabel" in t.action ? t.action.copiedLabel : void 0);
    async function v(k) {
      l.value || (clearTimeout(f), c.value = !1, await t.action.onClick(k), await Ze(), !(!h.value || g) && (c.value = !0, f = setTimeout(() => c.value = !1, gB)));
    }
    Tt(() => {
      g = !0, clearTimeout(f);
    });
    const p = m(() => (c.value ? h.value : n.value) ?? "");
    function y() {
      var $;
      const k = d.value ?? (($ = s.value) == null ? void 0 : $.$el) ?? null;
      return !k || o.value ? !1 : (k.focus(), !0);
    }
    return a({ focus: y }), (k, $) => (u(), P($t, {
      text: p.value,
      disabled: !p.value,
      open: c.value ? !0 : void 0,
      as: "span",
      class: "shrink-0"
    }, {
      default: me(() => [
        e.appearance === "inline-icon" ? (u(), b("button", {
          key: 0,
          ref_key: "inlineRef",
          ref: d,
          type: "button",
          class: C(["inline-flex size-6 -mx-1 shrink-0 items-center justify-center rounded-(--border-border-radius-rounded-xs) focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", l.value ? "cursor-default" : "cursor-pointer"]),
          disabled: o.value,
          "aria-disabled": r.value ? "true" : void 0,
          "aria-label": e.action.label,
          "data-testid": e.action.testId ?? "list-item-copy-action",
          onClick: v
        }, [
          x("i", {
            class: C(["ri-file-copy-line inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm)", i.value]),
            "aria-hidden": "true"
          }, null, 2)
        ], 10, hB)) : (u(), P(Be, Ve({
          key: 1,
          ref_key: "buttonRef",
          ref: s,
          variant: e.variant,
          size: "xs",
          "icon-only": e.appearance === "icon",
          "icon-left": "icon" in e.action ? e.action.icon : void 0,
          label: e.appearance === "label" ? e.action.label : void 0,
          "aria-label": e.appearance === "icon" ? e.action.label : void 0,
          disabled: o.value,
          "aria-disabled": r.value
        }, e.action.testId ? { "data-testid": e.action.testId } : {}, {
          onClick: e.action.onClick
        }), null, 16, ["variant", "icon-only", "icon-left", "label", "aria-label", "disabled", "aria-disabled", "onClick"])),
        e.appearance === "inline-icon" ? (u(), b("span", bB, H(c.value ? h.value : ""), 1)) : w("", !0)
      ]),
      _: 1
    }, 8, ["text", "disabled", "open"]));
  }
}), mB = ["id"], vB = {
  key: 0,
  class: "flex shrink-0",
  "data-testid": "list-item-leading"
}, pB = {
  key: 1,
  class: "flex shrink-0",
  "data-testid": "list-item-leading"
}, xB = {
  key: 0,
  class: "flex",
  "data-testid": "list-item-top-badge"
}, yB = ["id"], kB = ["id"], wB = ["id"], CB = {
  key: 3,
  class: "flex min-w-0 items-end justify-between gap-1.5",
  "data-testid": "list-item-amount-row"
}, SB = { class: "flex min-w-0 items-end gap-1.5" }, $B = ["id"], IB = ["id"], LB = ["id"], TB = ["id"], EB = ["id"], AB = {
  key: 6,
  class: "flex flex-wrap gap-1",
  "data-testid": "list-item-label-badge"
}, RB = ["id"], zB = ["id"], DB = {
  key: 5,
  class: "flex shrink-0",
  "data-testid": "list-item-right-icon"
}, BB = {
  key: 6,
  class: "ml-0.5 flex shrink-0 items-center gap-1.5",
  "data-testid": "list-item-icons"
}, MB = ["id", "src", "alt"], OB = ["id", "role", "aria-label", "aria-hidden"], PB = {
  key: 0,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-trend"
}, FB = { class: "flex items-center" }, NB = ["id"], VB = ["id"], Ob = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)", Pb = "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", Fb = "@max-[24rem]/item:flex-col-reverse", Nb = "pt-3.5 pr-3.5", HB = 2, jB = "ri-arrow-right-line", WB = "cursor-pointer text-left disabled:cursor-default aria-disabled:cursor-default focus-visible:outline-hidden after:absolute after:inset-0 after:content-[''] after:rounded-(--border-border-radius-rounded-xs) focus-visible:after:ring-2 focus-visible:after:ring-(--border-border-accent) focus-visible:after:outline-2 focus-visible:after:outline-transparent", qB = /* @__PURE__ */ ke({
  __name: "ListItem",
  props: {
    type: {},
    label: {},
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    interactive: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    value: { default: void 0 },
    rightIcon: { default: void 0 },
    icons: { default: void 0 },
    avatar: { default: void 0 },
    iconShape: { default: void 0 },
    helperText: { default: void 0 },
    extraText: { default: void 0 },
    labelBadge: { default: void 0 },
    badge: { default: void 0 },
    status: { default: void 0 },
    copyAction: { default: void 0 },
    primaryAction: { default: void 0 },
    secondaryAction: { default: void 0 },
    trend: { default: void 0 },
    progress: { default: void 0 },
    max: { default: void 0 },
    amount: { default: void 0 },
    total: { default: void 0 },
    sideText: { default: void 0 },
    percentText: { default: void 0 },
    valueTone: { default: void 0 },
    meta: { default: void 0 },
    author: { default: void 0 },
    badges: { default: void 0 },
    selected: { type: Boolean, default: void 0 }
  },
  emits: ["click"],
  setup(e, { expose: a, emit: t }) {
    var Y;
    const n = e, l = t, o = {
      root: "items-center justify-between gap-1.5",
      main: "flex-1",
      height: "min-h-6",
      labelText: Ob,
      extra: Pb,
      column: "gap-px",
      labelGap: "gap-1.5",
      surface: "",
      surfaceHover: "",
      surfaceActive: "",
      surfaceMuted: "",
      recolour: !0,
      hoverRecolour: !0,
      caption: "text-(--text-text-body)",
      gap: "gap-1.5",
      align: "items-center",
      value: "text-(--text-text-black-default)",
      valueText: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
      valueBox: "shrink-0",
      end: "inline",
      shape: "circle",
      trailingGap: "gap-4",
      trailingStack: Fb,
      label: "text-(--text-text-body)",
      helper: "text-(--text-text-body)",
      labelRow: "items-center",
      leading: "",
      badgePlacement: "trailing",
      secondaryVariant: "secondary",
      mutedBadges: !0,
      mutedIconShape: !0
    }, r = {
      root: "items-center justify-between gap-0.5",
      main: "flex-1",
      height: "",
      gap: "gap-2",
      labelText: Ob,
      extra: Pb,
      column: "gap-px",
      labelGap: "gap-1.5",
      surface: "",
      surfaceHover: "",
      surfaceActive: "",
      surfaceMuted: "",
      recolour: !0,
      hoverRecolour: !0,
      caption: "text-(--text-text-body)",
      value: "",
      valueText: "",
      valueBox: "",
      end: "inline",
      shape: "circle",
      trailingGap: "gap-4",
      trailingStack: Fb,
      mutedBadges: !0,
      mutedIconShape: !0
    }, i = {
      ...r,
      root: "items-center justify-between gap-1.5",
      height: "",
      label: "text-(--text-text-body)",
      helper: "text-(--text-text-body)",
      value: "text-(--text-text-body)",
      valueText: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
      // Figma puts the value in the root, 6 px after `Left content`; here it sits in the main zone,
      // whose gap is the 8 px of `Left content`.
      valueBox: "shrink-0 -ml-0.5",
      align: "items-center",
      labelRow: "items-center",
      leading: "",
      badgePlacement: "trailing",
      secondaryVariant: "secondary",
      // Figma Disabled object rows keep the Icon Shape colours.
      mutedIconShape: !1
    }, s = `${Nb} pl-3.5 pb-[calc(--spacing(3.5)-1px)]`, d = `${s} border-b border-(--border-border-disabled-subtle) bg-(--background-background-disabled-opacity)`, c = `${s} border-b border-(--border-border-disabled) bg-(--background-background-disabled-opacity)`, f = {
      ...i,
      root: "items-center justify-between gap-2",
      gap: "gap-2",
      labelText: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold)",
      label: "text-(--text-text-black-default)",
      column: "gap-1",
      labelGap: "gap-0",
      hoverRecolour: !1,
      surface: `${s} border-b border-(--border-border-base-soft) bg-(--background-background-white)`,
      surfaceHover: "hover:pl-[calc(--spacing(3.5)-2px)] hover:pb-3.5 hover:border-b-0 hover:border-l-2 hover:border-l-(--border-border-hover) hover:bg-(--background-background-hover)",
      surfaceActive: `${Nb} pl-[calc(--spacing(3.5)-2px)] pb-3.5 border-l-2 border-(--border-border-hover) bg-(--background-background-hover)`,
      surfaceMuted: d,
      mutedIconShape: !0
    }, g = {
      avatar: !0,
      helperText: !0,
      extraText: !0,
      labelBadge: !0,
      badge: !0,
      secondaryAction: !0
    }, h = {
      default: { ...o, props: { icon: !0 } },
      "with-number": { ...o, props: { icon: !0, value: !0 } },
      "with-badge": { ...o, props: { icon: !0, badge: !0 } },
      "with-right-icon": { ...o, props: { icon: !0, rightIcon: !0 } },
      "with-icons": { ...o, root: "items-center justify-start gap-2", main: "flex-initial", props: { icon: !0, icons: !0 } },
      "image-number": { ...i, props: { avatar: !0, helperText: !0, value: !0 } },
      "icon-number": {
        ...i,
        root: "items-start justify-start gap-2",
        main: "flex-initial",
        valueBox: "shrink-0 self-start",
        props: { iconShape: !0, helperText: !0, value: !0 }
      },
      // Figma Disabled 12773:10692, 15346:13357, 12773:13407 keep the Badge theme.
      "icon-number-badge": {
        ...i,
        badgePlacement: "above",
        mutedBadges: !1,
        props: { iconShape: !0, helperText: !0, badge: !0 }
      },
      "icon-badge": { ...i, mutedBadges: !1, props: { iconShape: !0, helperText: !0, badge: !0 } },
      "badge-name": { ...i, badgePlacement: "above", mutedBadges: !1, props: { badge: !0, helperText: !0 } },
      "image-buttons": {
        ...i,
        trailingGap: "gap-1.5",
        // Two buttons: on screen in their Tab order.
        trailingStack: "@max-[24rem]/item:flex-col",
        secondaryVariant: "ghost",
        props: { avatar: !0, helperText: !0, primaryAction: !0, secondaryAction: !0 }
      },
      transaction: {
        ...i,
        label: "text-(--text-text-black-default)",
        helper: "text-(--text-text-black-default)",
        valueText: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
        value: "text-(--text-text-black-default)",
        end: "column",
        shape: "square",
        props: { iconShape: !0, helperText: !0, value: !0, status: !0 }
      },
      // Figma 19619:3015: only the label and extra text recolour (hover and disabled).
      "data-list": {
        ...i,
        root: "items-center justify-between gap-1.5 pb-1.5",
        height: "",
        gap: "gap-1.5",
        labelText: "text-(length:--size-xxl) leading-(--line-height-xxl) font-(--weight-bold)",
        label: "text-(--text-text-heading)",
        extra: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular)",
        helper: "text-(--text-text-black-default)",
        column: "gap-0.5",
        trailingGap: "gap-1.5",
        props: { extraText: !0, trend: !0 }
      },
      // Figma 19563:13185: hover and disabled change the fill only.
      progress: {
        ...i,
        root: "flex-col items-stretch gap-1.5 p-1 pt-0 rounded-(--border-border-radius-rounded-xs)",
        main: "w-full",
        gap: "gap-0",
        labelText: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular)",
        labelGap: "gap-4",
        labelRow: "items-end",
        column: "gap-0",
        surfaceHover: "hover:bg-(--background-background-hover)",
        surfaceMuted: "bg-(--background-background-disabled-opacity)",
        recolour: !1,
        hoverRecolour: !1,
        props: {
          progress: !0,
          max: !0,
          amount: !0,
          total: !0,
          sideText: !0,
          percentText: !0,
          valueTone: !0
        }
      },
      "tab-document": {
        ...f,
        shape: "square",
        props: { iconShape: !0, meta: !0, author: !0, selected: !0 }
      },
      // The Figma raw binds a stronger disabled border on these two than on tab-document.
      "tab-badge": { ...f, badgePlacement: "below", surfaceMuted: c, props: { badge: !0, selected: !0 } },
      "tab-history": {
        ...f,
        surfaceMuted: c,
        props: { meta: !0, author: !0, badges: !0, selected: !0 }
      },
      "avatar-text-badge": {
        ...r,
        props: { ...g, copyAction: !0 },
        label: "text-(--text-text-body)",
        helper: "text-(--text-text-body)",
        align: "items-center",
        labelRow: "items-center",
        leading: "",
        badgePlacement: "trailing",
        secondaryVariant: "secondary"
      },
      "avatar-text-two-badges": {
        ...r,
        props: g,
        label: "text-(--text-text-heading)",
        helper: "text-(--text-text-black-default)",
        align: "items-start",
        labelRow: "items-start",
        leading: "py-1",
        badgePlacement: "label-row",
        secondaryVariant: "secondary"
      },
      "contact-item-badge": {
        ...r,
        props: g,
        label: "text-(--text-text-heading)",
        helper: "text-(--text-text-black-default)",
        align: "items-center",
        labelRow: "items-start",
        leading: "",
        badgePlacement: "trailing",
        secondaryVariant: "secondary"
      }
    }, v = m(() => h[n.type] ?? h.default), p = m(() => n.disabled || n.ariaDisabled), y = [
      "icon",
      "value",
      "rightIcon",
      "icons",
      "avatar",
      "iconShape",
      "helperText",
      "extraText",
      "labelBadge",
      "badge",
      "status",
      "copyAction",
      "primaryAction",
      "secondaryAction",
      "trend",
      "progress",
      "max",
      "amount",
      "total",
      "sideText",
      "percentText",
      "valueTone",
      "meta",
      "author",
      "badges",
      "selected"
    ];
    function k(F) {
      return !!v.value.props[F];
    }
    const $ = m(() => {
      const F = k("copyAction") ? n.copyAction : void 0;
      return F && p.value ? { ...F, disabled: !0, disabledReason: void 0 } : F;
    }), S = m(() => {
      var ue;
      const F = (se) => k(se) ? n[se] : void 0, ee = v.value.badgePlacement;
      return {
        icon: F("icon"),
        value: F("value"),
        rightIcon: k("rightIcon") ? n.rightIcon ?? jB : void 0,
        icons: F("icons"),
        avatar: F("avatar"),
        iconShape: F("iconShape"),
        status: F("status"),
        helperText: F("helperText"),
        extraText: F("extraText"),
        labelBadge: F("labelBadge"),
        belowBadges: [
          k("labelBadge") ? n.labelBadge : void 0,
          ee === "below" ? n.badge : void 0,
          ...k("badges") ? (n.badges ?? []).slice(0, HB) : []
        ].filter((se) => !!se),
        meta: k("meta") && ((ue = n.meta) != null && ue.length) ? n.meta.join(" · ") : void 0,
        author: F("author"),
        selected: k("selected") && n.interactive && !!n.selected,
        rowBadge: ee === "label-row" ? F("badge") : void 0,
        topBadge: ee === "above" ? F("badge") : void 0,
        trailingBadge: ee === "trailing" ? F("badge") : void 0,
        copyAction: $.value,
        primaryAction: F("primaryAction"),
        secondaryAction: F("secondaryAction"),
        trend: F("trend"),
        progress: F("progress"),
        max: F("max"),
        amount: F("amount"),
        total: F("total"),
        sideText: F("sideText"),
        percentText: F("percentText")
      };
    }), I = {
      neutral: "text-(--text-text-body)",
      success: "text-(--text-text-success)",
      warning: "text-(--text-text-warning)",
      destructive: "text-(--text-text-error-strong)",
      info: "text-(--text-text-info)"
    }, T = m(() => I[n.valueTone ?? "neutral"]), A = Ye(), E = Ye(), z = (F) => `${E}-${F}`, B = m(() => {
      var ue;
      const F = S.value;
      return [
        F.topBadge && z("top-badge"),
        F.sideText && z("side"),
        F.rowBadge && z("row-badge"),
        F.helperText && z("helper"),
        F.extraText && z("extra"),
        F.amount && z("amount"),
        F.amount && F.total && z("total"),
        F.amount && F.percentText && z("percent"),
        F.meta && z("meta"),
        F.author && z("author"),
        ...F.belowBadges.map((se, X) => z(`below-badge-${X}`)),
        F.value && z("value"),
        F.value && F.status && v.value.end === "column" && z("status"),
        ...(F.icons ?? []).flatMap((se, X) => se.label ? [z(`icon-${X}`)] : []),
        F.trend && z("trend-value"),
        ((ue = F.trend) == null ? void 0 : ue.caption) && z("trend-caption"),
        F.trailingBadge && z("trailing-badge")
      ].filter((se) => !!se).join(" ") || void 0;
    }), W = m(() => p.value ? v.value.surfaceMuted : S.value.selected ? v.value.surfaceActive : n.interactive ? [v.value.surface, v.value.surfaceHover] : v.value.surface), _ = m(() => p.value ? "text-(--text-text-disabled-strong)" : v.value.caption), Z = m(
      () => !!(S.value.trailingBadge || S.value.primaryAction || S.value.secondaryAction || S.value.trend)
    ), le = m(() => {
      if (p.value && v.value.recolour) return "text-(--text-text-disabled-strong)";
      const F = v.value.label;
      return n.interactive && v.value.hoverRecolour ? `${F} group-hover/row:text-(--text-text-hover)` : F;
    }), D = m(() => {
      if (p.value && v.value.recolour) return "text-(--text-text-disabled-strong)";
      const F = v.value.helper;
      return n.interactive && v.value.hoverRecolour ? `${F} group-hover/row:text-(--text-text-hover)` : F;
    }), O = m(() => {
      if (p.value) return "text-(--icons-icon-disabled-strong)";
      const F = "text-(--icons-icon-dark-default)";
      return n.interactive ? `${F} group-hover/row:text-(--icons-icon-hover)` : F;
    }), N = m(() => {
      if (p.value) return `${v.value.valueText} text-(--text-text-disabled-strong)`;
      const F = `${v.value.valueText} ${v.value.value}`;
      return n.interactive ? `${F} group-hover/row:text-(--text-text-hover)` : F;
    }), V = m(() => p.value ? "grayscale opacity-60" : "");
    function M(F) {
      return p.value && v.value.mutedBadges ? "disabled" : F.theme;
    }
    const Q = m(() => n.interactive && !p.value ? "group-hover/row:text-(--text-text-hover)" : "");
    function q(F) {
      p.value || l("click", F);
    }
    const K = m(
      () => n.interactive ? {
        type: "button",
        disabled: n.disabled,
        "aria-disabled": n.ariaDisabled && !n.disabled ? "true" : void 0,
        "aria-current": S.value.selected ? "true" : void 0,
        "aria-labelledby": A,
        "aria-describedby": B.value,
        "data-row-button": "",
        "data-testid": "list-item-row-button"
      } : {}
    ), G = R(null), te = R(null), ve = R(null);
    function Se(F) {
      const ee = { primary: G, secondary: te, copy: ve }[F].value;
      return (ee == null ? void 0 : ee.focus()) ?? !1;
    }
    a({ focusAction: Se });
    const oe = R(null), re = R(!1), ge = R(!1), de = m(() => ge.value ? !1 : re.value ? !0 : void 0);
    function Ee(F) {
      try {
        re.value = F.target.matches(":focus-visible");
      } catch {
        re.value = !0;
      }
    }
    function j() {
      re.value = !1, ge.value = !1;
    }
    $e(
      () => [n.disabled, n.interactive],
      ([F, ee]) => {
        (F || !ee) && j();
      }
    );
    function J(F) {
      var ee;
      F.key !== "Escape" || ge.value || !re.value || !((ee = oe.value) != null && ee.isTruncated) || (F.stopPropagation(), F.preventDefault(), ge.value = !0);
    }
    const ne = typeof process < "u" && ((Y = process.env) == null ? void 0 : Y.NODE_ENV) !== "production";
    return $e(
      () => [n.type, n.interactive, n.selected, ...y.map((F) => n[F] !== void 0)].join(),
      () => {
        if (!ne) return;
        if (!(n.type in h)) {
          console.warn(`[OPAL ListItem] unknown type "${n.type}": rendered as "default".`);
          return;
        }
        const F = y.filter((ee) => n[ee] !== void 0 && !k(ee));
        F.length && console.warn(`[OPAL ListItem] type "${n.type}" takes no ${F.map((ee) => `\`${ee}\``).join(", ")}: ignored.`), n.selected && !n.interactive && console.warn("[OPAL ListItem] `selected` needs `interactive`: ignored.");
      },
      { immediate: !0 }
    ), (F, ee) => {
      var ue;
      return u(), b("li", {
        class: C(["@container/item flex w-full min-w-0", [v.value.root, v.value.height, W.value, e.interactive ? "group/row relative" : ""]]),
        "data-testid": "list-item"
      }, [
        e.interactive || S.value.progress !== void 0 ? (u(), b("span", {
          key: 0,
          id: L(A),
          hidden: ""
        }, H(e.label), 9, mB)) : w("", !0),
        x("div", {
          class: C(["flex min-w-0", [v.value.main, v.value.gap, v.value.align]]),
          "data-testid": "list-item-main"
        }, [
          S.value.icon ? (u(), b("div", vB, [
            x("i", {
              class: C(["inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm)", [S.value.icon, O.value]]),
              "aria-hidden": "true"
            }, null, 2)
          ])) : w("", !0),
          S.value.iconShape ? (u(), b("div", pB, [
            U(aa, {
              icon: S.value.iconShape.icon,
              color: p.value && v.value.mutedIconShape ? "disabled" : S.value.iconShape.color ?? "default",
              type: v.value.shape,
              variant: "outlined",
              size: "md",
              as: "span"
            }, null, 8, ["icon", "color", "type"])
          ])) : w("", !0),
          S.value.avatar ? (u(), b("div", {
            key: 2,
            class: C(["flex shrink-0", v.value.leading]),
            "data-testid": "list-item-leading"
          }, [
            U(Jt, {
              name: S.value.avatar.name,
              img: S.value.avatar.img,
              entity: S.value.avatar.entity,
              size: "md",
              as: "span",
              presentational: ""
            }, null, 8, ["name", "img", "entity"])
          ], 2)) : w("", !0),
          x("div", {
            class: C(["flex flex-1 min-w-0 flex-col", v.value.column])
          }, [
            S.value.topBadge ? (u(), b("div", xB, [
              U(yt, {
                id: z("top-badge"),
                label: S.value.topBadge.label,
                theme: M(S.value.topBadge),
                "left-icon": S.value.topBadge.leftIcon,
                "show-left-icon": !!S.value.topBadge.leftIcon,
                size: "sm"
              }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"])
            ])) : w("", !0),
            x("div", {
              class: C(["flex min-w-0", [v.value.labelGap, v.value.labelRow]]),
              "data-testid": "list-item-label-row"
            }, [
              (u(), P(gt(e.interactive ? "button" : "span"), Ve({
                class: ["flex min-w-0", [S.value.copyAction ? "" : "flex-1", e.interactive ? WB : ""]]
              }, K.value, nl(e.interactive ? { click: q, focus: Ee, blur: j, keydown: J } : {})), {
                default: me(() => [
                  U(it, {
                    ref_key: "labelRef",
                    ref: oe,
                    as: "span",
                    class: C(e.interactive ? "relative z-1" : ""),
                    text: e.label,
                    focusable: !e.interactive,
                    open: e.interactive ? de.value : void 0,
                    "text-class": `${v.value.labelText} @max-[24rem]/item:whitespace-normal @max-[24rem]/item:wrap-break-word ${le.value}`,
                    "data-testid": "list-item-label"
                  }, null, 8, ["class", "text", "focusable", "open", "text-class"])
                ]),
                _: 1
              }, 16, ["class"])),
              S.value.sideText ? (u(), b("div", {
                key: 0,
                id: z("side"),
                class: "block min-w-0 max-w-1/2 shrink-0 wrap-break-word text-right text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
                "data-testid": "list-item-side-text"
              }, H(S.value.sideText), 9, yB)) : w("", !0),
              S.value.copyAction ? (u(), P(Fd, {
                key: 1,
                ref_key: "copyRef",
                ref: ve,
                class: C(e.interactive ? "relative z-1" : ""),
                action: S.value.copyAction,
                appearance: "inline-icon",
                muted: p.value,
                "row-hover": e.interactive,
                "keep-focusable": e.ariaDisabled && !e.disabled
              }, null, 8, ["class", "action", "muted", "row-hover", "keep-focusable"])) : w("", !0),
              S.value.rowBadge ? (u(), P(yt, {
                key: 2,
                id: z("row-badge"),
                class: "shrink-0",
                label: S.value.rowBadge.label,
                theme: M(S.value.rowBadge),
                "left-icon": S.value.rowBadge.leftIcon,
                "show-left-icon": !!S.value.rowBadge.leftIcon,
                size: "sm",
                "data-testid": "list-item-badge"
              }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"])) : w("", !0)
            ], 2),
            S.value.helperText ? (u(), b("span", {
              key: 1,
              id: z("helper"),
              class: C(["block min-w-0 wrap-break-word text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)", D.value]),
              "data-testid": "list-item-helper"
            }, H(S.value.helperText), 11, kB)) : w("", !0),
            S.value.extraText ? (u(), b("span", {
              key: 2,
              id: z("extra"),
              class: C(["block min-w-0 wrap-break-word", [v.value.extra, D.value]]),
              "data-testid": "list-item-extra"
            }, H(S.value.extraText), 11, wB)) : w("", !0),
            S.value.amount ? (u(), b("div", CB, [
              x("div", SB, [
                x("span", {
                  id: z("amount"),
                  class: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-heading)",
                  "data-testid": "list-item-amount"
                }, H(S.value.amount), 9, $B),
                S.value.total ? (u(), b("span", {
                  key: 0,
                  id: z("total"),
                  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
                  "data-testid": "list-item-total"
                }, H(S.value.total), 9, IB)) : w("", !0)
              ]),
              S.value.percentText ? (u(), b("span", {
                key: 0,
                id: z("percent"),
                class: C(["shrink-0 text-right text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", T.value]),
                "data-testid": "list-item-percent"
              }, H(S.value.percentText), 11, LB)) : w("", !0)
            ])) : w("", !0),
            S.value.meta ? (u(), b("span", {
              key: 4,
              id: z("meta"),
              class: C(["block min-w-0 wrap-break-word text-(length:--size-sm) leading-(--line-height-s) font-(--weight-regular)", _.value]),
              "data-testid": "list-item-meta"
            }, H(S.value.meta), 11, TB)) : w("", !0),
            S.value.author ? (u(), b("span", {
              key: 5,
              id: z("author"),
              class: C(["block min-w-0 wrap-break-word text-(length:--size-xs) leading-(--line-height-xs) font-(--weight-regular)", _.value]),
              "data-testid": "list-item-author"
            }, H(S.value.author), 11, EB)) : w("", !0),
            S.value.belowBadges.length ? (u(), b("div", AB, [
              (u(!0), b(ie, null, Oe(S.value.belowBadges, (se, X) => (u(), P(yt, {
                id: z(`below-badge-${X}`),
                key: X,
                label: se.label,
                theme: M(se),
                "left-icon": se.leftIcon,
                "show-left-icon": !!se.leftIcon,
                size: "sm"
              }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"]))), 128))
            ])) : w("", !0)
          ], 2),
          S.value.value && v.value.end === "column" ? (u(), b("div", {
            key: 3,
            class: C(["flex shrink-0 flex-col items-end", v.value.valueBox]),
            "data-testid": "list-item-end"
          }, [
            x("span", {
              id: z("value"),
              class: C(N.value),
              "data-testid": "list-item-value"
            }, H(S.value.value), 11, RB),
            S.value.status ? (u(), P(yt, {
              key: 0,
              id: z("status"),
              label: S.value.status.label,
              theme: M(S.value.status),
              type: "with-dot",
              size: "sm",
              class: C(Q.value),
              "data-testid": "list-item-status"
            }, null, 8, ["id", "label", "theme", "class"])) : w("", !0)
          ], 2)) : S.value.value ? (u(), b("span", {
            key: 4,
            id: z("value"),
            class: C([v.value.valueBox, N.value]),
            "data-testid": "list-item-value"
          }, H(S.value.value), 11, zB)) : w("", !0),
          S.value.rightIcon ? (u(), b("div", DB, [
            x("i", {
              class: C(["inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm)", [S.value.rightIcon, O.value]]),
              "aria-hidden": "true"
            }, null, 2)
          ])) : w("", !0),
          (ue = S.value.icons) != null && ue.length ? (u(), b("div", BB, [
            (u(!0), b(ie, null, Oe(S.value.icons, (se, X) => (u(), b(ie, { key: X }, [
              se.src ? (u(), b("img", {
                key: 0,
                id: se.label ? z(`icon-${X}`) : void 0,
                class: C(["size-4.5 shrink-0 object-contain", V.value]),
                src: se.src,
                alt: se.label,
                "data-testid": "list-item-icons-entry"
              }, null, 10, MB)) : (u(), b("i", {
                key: 1,
                id: se.label ? z(`icon-${X}`) : void 0,
                class: C(["inline-flex size-4.5 items-center justify-center text-[18px] leading-[18px]", [se.icon, O.value]]),
                role: se.label ? "img" : void 0,
                "aria-label": se.label,
                "aria-hidden": se.label ? void 0 : "true",
                "data-testid": "list-item-icons-entry"
              }, null, 10, OB))
            ], 64))), 128))
          ])) : w("", !0)
        ], 2),
        S.value.progress !== void 0 ? (u(), P(Dr, {
          key: 1,
          value: S.value.progress,
          max: S.value.max,
          size: "lg",
          "aria-labelledby": L(A),
          "aria-valuetext": S.value.percentText,
          "data-testid": "list-item-progress"
        }, null, 8, ["value", "max", "aria-labelledby", "aria-valuetext"])) : w("", !0),
        Z.value ? (u(), b("div", {
          key: 2,
          class: C(["flex shrink-0 items-center @max-[24rem]/item:items-end @max-[24rem]/item:gap-2", [v.value.trailingGap, v.value.trailingStack]]),
          "data-testid": "list-item-trailing"
        }, [
          S.value.trend ? (u(), b("div", PB, [
            x("span", FB, [
              ee[0] || (ee[0] = x("i", {
                class: "ri-arrow-right-up-line inline-flex size-(--icon-size-sm) items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm) text-(--icons-icon-success)",
                "aria-hidden": "true"
              }, null, -1)),
              x("span", {
                id: z("trend-value"),
                class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-success)",
                "data-testid": "list-item-trend-value"
              }, H(S.value.trend.value), 9, NB)
            ]),
            S.value.trend.caption ? (u(), b("span", {
              key: 0,
              id: z("trend-caption"),
              class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
              "data-testid": "list-item-trend-caption"
            }, H(S.value.trend.caption), 9, VB)) : w("", !0)
          ])) : w("", !0),
          S.value.trailingBadge ? (u(), P(yt, {
            key: 1,
            id: z("trailing-badge"),
            label: S.value.trailingBadge.label,
            theme: M(S.value.trailingBadge),
            "left-icon": S.value.trailingBadge.leftIcon,
            "show-left-icon": !!S.value.trailingBadge.leftIcon,
            size: "sm",
            "data-testid": "list-item-badge"
          }, null, 8, ["id", "label", "theme", "left-icon", "show-left-icon"])) : w("", !0),
          S.value.primaryAction ? (u(), P(Fd, {
            key: 2,
            ref_key: "primaryRef",
            ref: G,
            class: C(e.interactive ? "relative z-1" : ""),
            action: S.value.primaryAction,
            appearance: "label",
            variant: "secondary"
          }, null, 8, ["class", "action"])) : w("", !0),
          S.value.secondaryAction ? (u(), P(Fd, {
            key: 3,
            ref_key: "secondaryRef",
            ref: te,
            class: C(e.interactive ? "relative z-1" : ""),
            action: S.value.secondaryAction,
            appearance: "icon",
            variant: v.value.secondaryVariant
          }, null, 8, ["class", "action", "variant"])) : w("", !0)
        ], 2)) : w("", !0)
      ], 2);
    };
  }
}), UB = /* @__PURE__ */ ke({
  __name: "ListItemGroup",
  props: {
    divider: { type: Boolean, default: !1 },
    dividerColor: { default: "var(--border-border-base-soft)" }
  },
  setup(e) {
    const a = e, t = m(() => a.divider ? { "--list-item-group-divider": a.dividerColor } : void 0);
    return (n, l) => (u(), b("ul", {
      role: "list",
      class: C(["m-0 flex w-full min-w-0 list-none flex-col p-0", e.divider ? "gap-3 [&>li+li]:border-t [&>li+li]:border-solid [&>li+li]:border-(--list-item-group-divider) [&>li+li]:pt-3" : "gap-4"]),
      style: Ge(t.value),
      "data-testid": "list-item-group"
    }, [
      Me(n.$slots, "default")
    ], 6));
  }
});
function mx(e) {
  return m(() => {
    const a = e(), t = a.border !== !1, n = [
      `flex items-center rounded-(--border-border-radius-rounded-l) border border-solid w-full transition-[color,background-color,border-color,box-shadow] duration-200 ${a.padding}`,
      a.gap
    ];
    return a.minHeight && n.push(a.minHeight), a.alwaysClasses && n.push(a.alwaysClasses), a.disabled ? (n.push("bg-(--background-background-disabled-opacity) cursor-default"), n.push(t ? "border-(--border-border-disabled)" : "border-transparent"), n) : (a.selected ? n.push("bg-(--background-background-accent) border-(--border-border-accent)") : (n.push("bg-(--background-background-white) hover:bg-(--background-background-hover)"), n.push(
      t ? "border-(--border-border-base-medium) hover:border-(--border-border-hover)" : "border-transparent"
    )), a.restingClasses && n.push(a.restingClasses), a.grabbed && n.push("ring-2 ring-(--border-border-accent)"), n);
  });
}
const GB = {
  key: 0,
  class: "min-w-0 flex-1"
}, KB = ["aria-label"], YB = /* @__PURE__ */ ke({
  __name: "EditableTitle",
  props: {
    modelValue: {},
    editable: { type: Boolean, default: !0 },
    showPen: { type: Boolean, default: !0 },
    size: { default: "md" },
    placeholder: { default: void 0 },
    emptyText: { default: void 0 },
    maxlength: { default: void 0 },
    error: { default: void 0 },
    editLabel: {},
    saveLabel: {},
    penVariant: { default: "secondary" },
    inputWidth: { default: void 0 },
    maxWidth: { default: void 0 },
    warnPattern: { default: void 0 },
    warnLabel: { default: void 0 },
    autoEdit: { type: Boolean, default: !1 }
  },
  emits: ["save", "cancel", "edit-start", "edit-end"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = {
      sm: {
        text: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
        gap: "gap-1.5",
        pen: "xs"
      },
      md: {
        text: "text-(length:--size-4xl) leading-(--line-height-4xl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
        gap: "gap-3",
        pen: "xs"
      },
      lg: {
        text: "text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
        gap: "gap-2",
        pen: "xs"
      }
    }, o = m(() => l[t.size]), r = m(() => t.modelValue || t.emptyText || ""), i = R(!1), s = R(""), d = R(null), c = R(null), f = m(
      () => t.maxWidth && !i.value ? { maxWidth: t.maxWidth } : void 0
    ), g = m(() => !!t.warnPattern && t.warnPattern.test(s.value));
    function h() {
      var T;
      const S = (T = d.value) == null ? void 0 : T.$el, I = S == null ? void 0 : S.querySelector("input");
      I == null || I.focus(), I == null || I.select();
    }
    async function v() {
      t.editable && (s.value = t.modelValue, i.value = !0, await Ze(), h());
    }
    async function p() {
      var S, I;
      i.value = !1, await Ze(), (I = (S = c.value) == null ? void 0 : S.$el) == null || I.focus();
    }
    function y() {
      p(), n("cancel");
    }
    function k() {
      const S = s.value.trim();
      if (S.length === 0 || S === t.modelValue) {
        y();
        return;
      }
      n("save", S), p();
    }
    function $(S) {
      S.key === "Enter" ? (S.preventDefault(), k()) : S.key === "Escape" && (S.preventDefault(), y());
    }
    return $e(
      () => t.error,
      async (S) => {
        S && !i.value && (i.value = !0, await Ze(), h());
      }
    ), $e(i, (S) => {
      n(S ? "edit-start" : "edit-end");
    }), $e(
      () => t.autoEdit,
      (S) => {
        S && t.editable && !i.value && v();
      },
      { immediate: !0 }
    ), (S, I) => (u(), b("div", {
      class: C(["inline-flex min-w-0 items-center", i.value ? "gap-3" : o.value.gap]),
      style: Ge(f.value),
      "data-testid": "editable-title"
    }, [
      i.value ? (u(), b(ie, { key: 1 }, [
        U(Qt, {
          ref_key: "inputRef",
          ref: d,
          modelValue: s.value,
          "onUpdate:modelValue": I[0] || (I[0] = (T) => s.value = T),
          size: "md",
          placeholder: e.placeholder,
          maxlength: e.maxlength,
          "aria-label": e.editLabel,
          "full-width": !e.inputWidth,
          width: e.inputWidth,
          "data-testid": "editable-title-input",
          onKeydown: $
        }, Xa({ _: 2 }, [
          g.value ? {
            name: "iconRight",
            fn: me(() => [
              U($t, {
                text: e.warnLabel ?? "",
                disabled: !e.warnLabel,
                position: "bottom"
              }, {
                default: me(() => [
                  x("i", {
                    class: "ri-alert-fill inline-flex size-4 shrink-0 items-center justify-center text-(length:--size-l) text-(--icons-icon-warning)",
                    role: "img",
                    "aria-label": e.warnLabel,
                    "data-testid": "editable-title-warning"
                  }, null, 8, KB)
                ]),
                _: 1
              }, 8, ["text", "disabled"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["modelValue", "placeholder", "maxlength", "aria-label", "full-width", "width"]),
        U(Be, {
          variant: "secondary",
          size: "sm",
          "icon-only": "",
          "icon-left": "ri-save-3-fill",
          "aria-label": e.saveLabel,
          "data-testid": "editable-title-save",
          onMousedown: I[1] || (I[1] = _e(() => {
          }, ["prevent"])),
          onClick: k
        }, null, 8, ["aria-label"])
      ], 64)) : (u(), b(ie, { key: 0 }, [
        e.maxWidth ? (u(), b("div", GB, [
          U(it, {
            text: r.value,
            position: "bottom",
            "text-class": o.value.text,
            "data-testid": "editable-title-text"
          }, null, 8, ["text", "text-class"])
        ])) : (u(), b("span", {
          key: 1,
          class: C([o.value.text, "truncate"]),
          "data-testid": "editable-title-text"
        }, H(r.value), 3)),
        e.editable && e.showPen ? (u(), P(Be, {
          key: 2,
          ref_key: "penRef",
          ref: c,
          variant: e.penVariant,
          size: o.value.pen,
          "icon-only": "",
          "icon-left": "ri-pencil-line",
          "aria-label": e.editLabel,
          "data-testid": "editable-title-edit",
          onClick: v
        }, null, 8, ["variant", "size", "aria-label"])) : w("", !0)
      ], 64))
    ], 6));
  }
}), mf = /* @__PURE__ */ Ct(YB, [["__scopeId", "data-v-b33d760d"]]), JB = { class: "flex flex-1 min-w-0 items-center gap-2" }, XB = { class: "flex-1 min-w-0 flex flex-col gap-0" }, ZB = { class: "flex grow shrink basis-48 min-w-0 items-center gap-2" }, QB = { class: "flex flex-1 min-w-0 flex-col gap-0" }, _B = {
  key: 0,
  class: "w-full min-w-0 truncate text-(length:--size-sm) leading-(--line-height-s) text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, eM = {
  key: 0,
  class: "ml-auto flex min-w-0 flex-wrap items-center justify-end gap-x-6 gap-y-3",
  "data-testid": "list-item-trailing"
}, tM = {
  key: 0,
  class: "flex flex-wrap items-center justify-end gap-x-6 gap-y-3",
  "data-testid": "list-item-trailing-actions"
}, aM = {
  key: 0,
  class: "flex items-center gap-6",
  "data-testid": "list-item-stats"
}, nM = { class: "flex min-w-0 grow shrink basis-32 flex-col" }, lM = {
  key: 0,
  class: "flex min-w-0 flex-wrap items-center gap-x-4 gap-y-3",
  "data-testid": "list-item-stats"
}, oM = {
  key: 1,
  class: "flex min-h-12.5 w-[153px] max-w-full shrink-0 flex-col justify-center gap-1.5",
  "data-testid": "list-item-progress"
}, rM = ["id"], iM = ["id"], sM = {
  key: 2,
  class: "flex shrink-0 items-center gap-4",
  "data-testid": "list-item-trailing-actions"
}, dM = { class: "flex grow shrink basis-48 min-w-0 items-center gap-2" }, uM = ["aria-label", "aria-pressed", "disabled"], cM = { class: "flex flex-1 min-w-0 flex-col gap-0" }, fM = {
  key: 1,
  class: "w-full min-w-0 truncate text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading)",
  "data-testid": "list-item-title"
}, hM = {
  key: 0,
  class: "w-full min-w-0 truncate text-(length:--size-sm) leading-(--line-height-s) text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, bM = {
  key: 0,
  class: "ml-auto flex max-w-full shrink-0 flex-wrap items-center justify-end gap-3.5",
  "data-testid": "list-item-trailing"
}, gM = ["aria-label", "aria-pressed", "disabled"], mM = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "ListItemCard",
  props: {
    type: { default: "default" },
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    reorderable: { type: Boolean, default: void 0 },
    dragHandleLabel: { default: void 0 },
    grabbed: { type: Boolean, default: !1 },
    editable: { type: Boolean, default: !1 },
    showEdit: { type: Boolean, default: !1 },
    editLabel: { default: void 0 },
    saveLabel: { default: void 0 },
    maxlength: { default: void 0 },
    editError: { default: void 0 },
    autoEdit: { type: Boolean, default: !1 },
    editInputWidth: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    progress: { default: void 0 },
    max: { default: 100 },
    progressLabel: { default: void 0 }
  },
  emits: ["rename", "grab", "grab-cancel", "select"],
  setup(e, { emit: a }) {
    const t = ["draggable-edit", "draggable-collapsed"], n = ["card-item", "draggable-edit"], l = e, o = a, r = Ia();
    let i = {};
    d0(() => {
      i = {};
    });
    const s = (z) => i[z] ?? (i[z] = r(z)), d = R(!1), c = m(() => t.includes(l.type)), f = m(
      () => l.type === "draggable-collapsed" ? {
        role: "button",
        tabindex: l.disabled ? void 0 : 0,
        "aria-pressed": l.selected || void 0,
        // The row IS the button here, so it carries the disabled state (other types' roots have a
        // role that supports none). Only set when disabled, so a forwarded attr is not clobbered.
        ...l.disabled ? { "aria-disabled": "true" } : {}
      } : {}
    ), g = m(() => !c.value || l.reorderable === !1 ? !1 : l.reorderable === !0 ? !0 : !l.disabled), h = {
      default: { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-3.5", shadow: !0 },
      "card-item": { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-6", minHeight: "min-h-[74px]", shadow: !1 },
      "draggable-edit": { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-3.5", minHeight: "min-h-[74px]", shadow: !0 },
      "draggable-collapsed": { padding: "p-[calc(--spacing(3.5)-1px)]", gap: "gap-2", minHeight: "min-h-14", shadow: !0 },
      progression: {
        padding: "pt-[calc(--spacing(4.5)-1px)] pr-[calc(--spacing(5)-1px)] pb-[calc(--spacing(4.5)-1px)] pl-[calc(--spacing(6)-1px)]",
        gap: "gap-4",
        shadow: !0
      }
    }, v = mx(() => {
      const z = h[l.type];
      return {
        padding: z.padding,
        gap: z.gap,
        minHeight: z.minHeight,
        // The draggable Figma variants drop the DS card shadow on hover and when disabled.
        restingClasses: z.shadow ? l.type === "progression" ? "shadow-(--blur-shadow-s)" : "shadow-(--blur-shadow-s) hover:shadow-none" : void 0,
        // The trailing zone wraps under the text only when it no longer fits beside a 12rem text
        // block (`basis-48` below; Figma has no narrow card), 12px below it. The drag rows of a
        // drawer (`default`) and the palette (`draggable-collapsed`) stay on one line.
        alwaysClasses: n.includes(l.type) ? "flex-wrap gap-y-3" : l.type === "progression" ? "flex-wrap justify-between gap-y-3" : void 0,
        disabled: l.disabled,
        // selected wins over the resting border (collapsed palette pick); grabbed is the
        // keyboard-grabbed accent ring (Rule n°4 feedback) — both are no-ops outside their own type.
        selected: l.selected,
        grabbed: l.grabbed
      };
    }), p = Ye(), y = Ye(), k = m(() => {
      var z;
      return ((z = l.progressLabel) == null ? void 0 : z.trim()) || void 0;
    }), $ = m(
      () => l.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-body)"
    );
    function S() {
      g.value && o("grab");
    }
    function I() {
      o("grab-cancel");
    }
    function T(z) {
      o("rename", z);
    }
    function A() {
      l.disabled || l.type !== "draggable-collapsed" || o("select");
    }
    function E(z) {
      l.type !== "draggable-collapsed" || l.disabled || (z.key === "Enter" || z.key === " ") && (z.preventDefault(), o("select"));
    }
    return (z, B) => (u(), b("div", Ve({ ...z.$attrs, ...f.value }, {
      class: L(v),
      onClick: A,
      onKeydown: E
    }), [
      e.type === "default" ? (u(), b(ie, { key: 0 }, [
        x("div", JB, [
          s("icon") || s("leading") ? (u(), b("div", {
            key: 0,
            class: C(["shrink-0 flex items-center", { "opacity-40": e.disabled }])
          }, [
            Me(z.$slots, "leading", {}, () => [
              Me(z.$slots, "icon")
            ])
          ], 2)) : w("", !0),
          x("div", XB, [
            x("p", {
              class: C(["text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) w-full truncate", $.value])
            }, H(e.label), 3),
            e.subtitle ? (u(), b("p", {
              key: 0,
              class: C(["text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) w-full", $.value])
            }, H(e.subtitle), 3)) : w("", !0)
          ])
        ]),
        Me(z.$slots, "badge"),
        Me(z.$slots, "actions")
      ], 64)) : e.type === "card-item" ? (u(), b(ie, { key: 1 }, [
        x("div", ZB, [
          Me(z.$slots, "leading"),
          x("div", QB, [
            U(it, {
              text: e.label,
              "text-class": "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading)",
              "data-testid": "list-item-title"
            }, null, 8, ["text"]),
            Me(z.$slots, "subtitle", {}, () => [
              e.subtitle ? (u(), b("p", _B, H(e.subtitle), 1)) : w("", !0)
            ])
          ])
        ]),
        s("badge") || s("stats") || s("actions") ? (u(), b("div", eM, [
          Me(z.$slots, "badge"),
          s("stats") || s("actions") ? (u(), b("div", tM, [
            s("stats") ? (u(), b("div", aM, [
              Me(z.$slots, "stats")
            ])) : w("", !0),
            Me(z.$slots, "actions")
          ])) : w("", !0)
        ])) : w("", !0)
      ], 64)) : e.type === "progression" ? (u(), b(ie, { key: 2 }, [
        x("div", nM, [
          U(it, {
            text: e.label,
            "text-class": "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-heading)",
            "data-testid": "list-item-title"
          }, null, 8, ["text"])
        ]),
        s("stats") ? (u(), b("div", lM, [
          Me(z.$slots, "stats")
        ])) : w("", !0),
        e.progress !== void 0 ? (u(), b("div", oM, [
          k.value ? (u(), b("span", {
            key: 0,
            id: L(p),
            class: "min-w-0 wrap-break-word text-(length:--size-xs) leading-(--line-height-s) font-(--weight-regular) text-(--text-text-black-default)",
            "data-testid": "list-item-progress-label"
          }, H(k.value), 9, rM)) : w("", !0),
          U(Dr, Ve({
            value: e.progress,
            max: e.max
          }, k.value ? { "aria-labelledby": `${L(y)} ${L(p)}` } : { ariaLabel: e.label }), null, 16, ["value", "max"]),
          k.value ? (u(), b("span", {
            key: 1,
            id: L(y),
            hidden: ""
          }, H(e.label), 9, iM)) : w("", !0)
        ])) : w("", !0),
        s("actions") ? (u(), b("div", sM, [
          Me(z.$slots, "actions")
        ])) : w("", !0)
      ], 64)) : e.type === "draggable-edit" ? (u(), b(ie, { key: 3 }, [
        x("div", dM, [
          x("button", {
            type: "button",
            class: C(["ri-draggable shrink-0 rounded-(--border-border-radius-rounded-xs) p-0 text-(length:--icon-size-lg) leading-none focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", [
              g.value ? "cursor-grab text-(--icons-icon-dark-default)" : "opacity-40 cursor-default",
              e.grabbed ? "text-(--text-text-accent)" : ""
            ]]),
            "aria-label": e.dragHandleLabel,
            "aria-roledescription": "draggable",
            "aria-pressed": e.grabbed || void 0,
            disabled: e.disabled || !g.value,
            "data-testid": "list-item-drag-handle",
            onClick: S,
            onKeydown: St(I, ["esc"])
          }, null, 42, uM),
          Me(z.$slots, "leading"),
          x("div", cM, [
            e.editable ? (u(), P(mf, {
              key: 0,
              "model-value": e.label,
              editable: !e.disabled,
              "show-pen": e.showEdit && !e.disabled,
              size: "sm",
              "pen-variant": "tertiary",
              maxlength: e.maxlength,
              error: e.editError,
              "auto-edit": e.autoEdit,
              "input-width": e.editInputWidth,
              "edit-label": e.editLabel ?? "",
              "save-label": e.saveLabel ?? "",
              class: "w-full min-w-0 min-h-8",
              onSave: T,
              onEditStart: B[0] || (B[0] = (W) => d.value = !0),
              onEditEnd: B[1] || (B[1] = (W) => d.value = !1)
            }, null, 8, ["model-value", "editable", "show-pen", "maxlength", "error", "auto-edit", "input-width", "edit-label", "save-label"])) : (u(), b("p", fM, H(e.label), 1)),
            Me(z.$slots, "subtitle", {}, () => [
              e.subtitle ? (u(), b("p", hM, H(e.subtitle), 1)) : w("", !0)
            ])
          ])
        ]),
        !d.value && (s("badge") || s("actions")) ? (u(), b("div", bM, [
          Me(z.$slots, "badge"),
          Me(z.$slots, "actions")
        ])) : w("", !0)
      ], 64)) : (u(), b(ie, { key: 4 }, [
        x("button", {
          type: "button",
          class: C(["ri-draggable shrink-0 rounded-(--border-border-radius-rounded-xs) p-0 text-(length:--icon-size-lg) leading-none focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", [
            g.value ? "cursor-grab text-(--icons-icon-dark-default)" : "opacity-40 cursor-default",
            e.grabbed ? "text-(--text-text-accent)" : ""
          ]]),
          "aria-label": e.dragHandleLabel,
          "aria-roledescription": "draggable",
          "aria-pressed": e.grabbed || void 0,
          disabled: e.disabled || !g.value,
          "data-testid": "list-item-drag-handle",
          onClick: _e(S, ["stop"]),
          onKeydown: St(I, ["esc"])
        }, null, 42, gM),
        Me(z.$slots, "leading"),
        x("span", {
          class: C(["flex-1 min-w-0 truncate text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", e.disabled ? "text-(--text-text-disabled-strong)" : e.selected ? "text-(--text-text-accent)" : "text-(--text-text-body)"]),
          "data-testid": "list-item-label"
        }, H(e.label), 3),
        Me(z.$slots, "badge"),
        Me(z.$slots, "actions")
      ], 64))
    ], 16));
  }
}), vM = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "DraggableListItem",
  props: {
    reorderable: { type: Boolean, default: void 0 },
    type: {},
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    dragHandleLabel: {},
    grabbed: { type: Boolean },
    editable: { type: Boolean },
    showEdit: { type: Boolean },
    editLabel: {},
    saveLabel: {},
    maxlength: {},
    editError: {},
    autoEdit: { type: Boolean },
    editInputWidth: {},
    selected: { type: Boolean },
    progress: {},
    max: {},
    progressLabel: {}
  },
  setup(e) {
    const a = e, t = Ia(), n = m(() => a.reorderable === !1 ? !1 : a.reorderable === !0 ? !0 : !a.disabled);
    return (l, o) => (u(), P(mM, Ve(l.$attrs, {
      label: a.label,
      subtitle: a.subtitle,
      disabled: a.disabled,
      draggable: n.value ? "true" : "false"
    }), Xa({
      icon: me(() => [
        x("i", {
          class: C(["ri-draggable text-(length:--icon-size-lg) leading-none select-none text-(--icons-icon-dark-default)", n.value ? "cursor-grab" : "opacity-40"]),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      _: 2
    }, [
      L(t)("badge") ? {
        name: "badge",
        fn: me(() => [
          x("div", null, [
            Me(l.$slots, "badge")
          ])
        ]),
        key: "0"
      } : void 0,
      L(t)("actions") ? {
        name: "actions",
        fn: me(() => [
          Me(l.$slots, "actions")
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["label", "subtitle", "disabled", "draggable"]));
  }
}), pM = ["aria-level"], xM = {
  class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body-subtle)",
  "data-testid": "date-group-header-label"
}, dG = /* @__PURE__ */ ke({
  __name: "DateGroupHeader",
  props: {
    label: {},
    count: {},
    ariaLevel: { default: 3 },
    fullWidth: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (a, t) => (u(), b("div", {
      class: C([
        "flex items-center gap-2.5 rounded-md bg-(--background-background-white-tertiary) px-4 py-1",
        e.fullWidth ? "w-full" : "w-fit"
      ]),
      role: "heading",
      "aria-level": e.ariaLevel
    }, [
      x("span", xM, H(e.label), 1),
      U(yt, {
        theme: "gradient-light",
        size: "sm",
        "badge-style": "circle",
        "text-only": "",
        value: e.count,
        "data-testid": "date-group-header-count"
      }, null, 8, ["value"])
    ], 10, pM));
  }
}), yM = ["role", "aria-label", "aria-hidden"], vf = /* @__PURE__ */ ke({
  __name: "AvatarGroup",
  props: {
    avatars: {},
    size: { default: "md" },
    max: { default: 4 },
    ariaLabel: { default: void 0 },
    ringClass: { default: "ring-(--border-border-white-full)" }
  },
  setup(e) {
    const a = e, t = m(() => a.avatars.slice(0, a.max)), n = m(() => Math.max(a.avatars.length - a.max, 0)), l = m(() => (a.ariaLabel ?? "").trim().length > 0), o = {
      sm: { item: "-ml-2 first:ml-0 ring-1", bubble: "h-6 w-6 text-(length:--size-2xs)" },
      md: { item: "-ml-3.5 first:ml-0 ring-2", bubble: "h-9 w-9 text-(length:--size-sm)" },
      lg: { item: "-ml-4 first:ml-0 ring-2", bubble: "h-11 w-11 text-(length:--size-m)" }
    };
    return (r, i) => (u(), b("div", {
      class: "flex items-center",
      role: l.value ? "img" : void 0,
      "aria-label": l.value ? e.ariaLabel : void 0,
      "aria-hidden": l.value ? void 0 : "true",
      "data-testid": "avatar-group"
    }, [
      (u(!0), b(ie, null, Oe(t.value, (s, d) => (u(), P(Jt, {
        key: d,
        name: s.name,
        img: s.img,
        size: e.size,
        "avatar-style": "circle",
        presentational: !0,
        class: C([e.ringClass, o[e.size].item]),
        "data-testid": "avatar-group-avatar",
        "aria-hidden": "true"
      }, null, 8, ["name", "img", "size", "class"]))), 128)),
      n.value > 0 ? (u(), b("span", {
        key: 0,
        class: C(["flex shrink-0 items-center justify-center rounded-full bg-(--colors-indigo-100) font-(--weight-medium) text-(--icons-icon-dark-default)", [e.ringClass, o[e.size].item, o[e.size].bubble]]),
        "data-testid": "avatar-group-overflow",
        "aria-hidden": "true"
      }, "+" + H(n.value), 3)) : w("", !0)
    ], 8, yM));
  }
}), kM = { class: "flex grow shrink basis-64 min-w-0 flex-wrap items-center gap-5" }, wM = {
  class: "flex grow shrink basis-64 min-w-0 flex-col gap-1",
  "data-testid": "list-item-interaction-content"
}, CM = {
  class: "flex items-center gap-2",
  "data-testid": "list-item-interaction-header"
}, SM = {
  key: 0,
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
  "data-testid": "list-item-interaction-date-time"
}, $M = {
  class: "flex min-w-0 flex-col gap-1.5",
  "data-testid": "list-item-interaction-body"
}, IM = {
  key: 0,
  class: "w-full min-w-0 wrap-break-word text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, LM = {
  key: 1,
  class: "flex flex-col gap-1 rounded-(--border-border-radius-rounded-sm) border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft) px-4 py-3 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body)",
  "data-testid": "list-item-call-summary"
}, TM = {
  key: 0,
  class: "flex items-center gap-1.5"
}, EM = {
  class: "font-(--weight-medium)",
  "data-testid": "list-item-call-duration"
}, AM = {
  key: 1,
  class: "wrap-break-word font-(--weight-regular)",
  "data-testid": "list-item-call-summary-text"
}, RM = {
  key: 2,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body)",
  "data-testid": "list-item-interaction-meta"
}, zM = {
  key: 3,
  class: "flex items-center gap-1",
  "data-testid": "list-item-person"
}, DM = {
  class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body)",
  "data-testid": "list-item-person-name"
}, BM = {
  class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body)",
  "data-testid": "list-item-attachment-label"
}, MM = {
  key: 0,
  class: "ml-auto flex max-w-full shrink-0 flex-wrap items-center justify-end gap-3",
  "data-testid": "list-item-trailing-actions"
}, uG = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "InteractionListItem",
  props: {
    label: {},
    subtitle: { default: void 0 },
    cancelled: { type: Boolean, default: !1 },
    kind: { default: void 0 },
    typeLabel: { default: "" },
    date: { default: void 0 },
    time: { default: void 0 },
    dotTheme: { default: "green" },
    people: { default: void 0 },
    peopleLabel: { default: void 0 },
    attachmentLabel: { default: void 0 },
    durationLabel: { default: void 0 },
    summary: { default: void 0 },
    summaryBadgeLabel: { default: void 0 }
  },
  setup(e) {
    const a = {
      call: "ri-phone-fill",
      email: "ri-mail-line",
      "face-to-face": "ri-user-line",
      event: "ri-group-2-line",
      meeting: "ri-calendar-2-line"
    }, t = e, n = Ia(), l = {
      green: "green",
      active: "active",
      red: "red",
      disabled: "neutral",
      orange: "orange",
      dark: "dark"
    }, o = m(() => l[t.dotTheme]), r = m(
      () => t.cancelled ? "text-(--text-text-disabled-strong) line-through" : "text-(--text-text-heading)"
    ), i = m(() => [t.date, t.time].filter(Boolean).join(" · ")), s = m(() => t.kind ? a[t.kind] : void 0);
    return $e(
      () => {
        var d;
        return [((d = t.people) == null ? void 0 : d.length) ?? 0, t.peopleLabel];
      },
      ([d, c]) => {
        d > 0 && !(c != null && c.trim()) && console.warn(
          "[InteractionListItem] `people` is set without `peopleLabel` — the avatar group has no accessible name for assistive tech (WCAG 1.1.1). Pass a pre-formatted `peopleLabel`."
        );
      },
      { immediate: !0 }
    ), (d, c) => {
      var f;
      return u(), b("div", Ve({
        class: "flex w-full min-w-64 flex-wrap items-start gap-4",
        "data-testid": "list-item-interaction-row"
      }, d.$attrs), [
        s.value ? (u(), P(aa, {
          key: 0,
          size: "md",
          type: "square",
          variant: "outlined",
          color: e.cancelled ? "disabled" : "default",
          icon: s.value,
          class: "shrink-0"
        }, null, 8, ["color", "icon"])) : w("", !0),
        x("div", kM, [
          x("div", wM, [
            x("div", CM, [
              U(yt, {
                type: "with-dot",
                theme: o.value,
                label: e.typeLabel,
                size: "lg",
                "data-testid": "list-item-interaction-type-label"
              }, null, 8, ["theme", "label"]),
              Me(d.$slots, "header-badges"),
              i.value ? (u(), b("span", SM, H(i.value), 1)) : w("", !0)
            ]),
            x("div", $M, [
              x("p", {
                class: C(["w-full min-w-0 wrap-break-word text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)", r.value]),
                "data-testid": "list-item-title"
              }, H(e.label), 3),
              e.subtitle ? (u(), b("p", IM, H(e.subtitle), 1)) : w("", !0),
              e.durationLabel || e.summary || e.summaryBadgeLabel ? (u(), b("div", LM, [
                e.durationLabel || e.summaryBadgeLabel ? (u(), b("div", TM, [
                  e.durationLabel ? (u(), b(ie, { key: 0 }, [
                    c[0] || (c[0] = x("i", {
                      class: "ri-timer-line shrink-0 leading-none",
                      "aria-hidden": "true"
                    }, null, -1)),
                    x("span", EM, H(e.durationLabel), 1)
                  ], 64)) : w("", !0),
                  e.summaryBadgeLabel ? (u(), P(yt, {
                    key: 1,
                    label: e.summaryBadgeLabel,
                    theme: "purple",
                    size: "sm",
                    "show-left-icon": !1,
                    "show-close-icon": !1,
                    "data-testid": "list-item-call-summary-badge"
                  }, null, 8, ["label"])) : w("", !0)
                ])) : w("", !0),
                e.summary ? (u(), b("p", AM, H(e.summary), 1)) : w("", !0)
              ])) : w("", !0),
              L(n)("interaction-meta") ? (u(), b("div", RM, [
                Me(d.$slots, "interaction-meta")
              ])) : w("", !0),
              (f = e.people) != null && f.length ? (u(), b("div", zM, [
                U(vf, {
                  avatars: e.people,
                  "ring-class": "ring-(--background-background-white)",
                  size: "sm"
                }, null, 8, ["avatars"]),
                x("span", DM, H(e.peopleLabel), 1),
                e.attachmentLabel ? (u(), b(ie, { key: 0 }, [
                  c[1] || (c[1] = x("span", {
                    class: "text-(length:--size-m) font-(--weight-medium) text-(--text-text-body)",
                    "aria-hidden": "true"
                  }, "·", -1)),
                  c[2] || (c[2] = x("i", {
                    class: "ri-attachment-2 shrink-0 text-(length:--size-sm) leading-none text-(--text-text-body)",
                    "aria-hidden": "true"
                  }, null, -1)),
                  x("span", BM, H(e.attachmentLabel), 1)
                ], 64)) : w("", !0)
              ])) : w("", !0)
            ])
          ]),
          L(n)("cta") || L(n)("actions") ? (u(), b("div", MM, [
            Me(d.$slots, "cta"),
            Me(d.$slots, "actions")
          ])) : w("", !0)
        ])
      ], 16);
    };
  }
}), OM = {
  class: "flex flex-1 min-w-0 flex-col gap-2 py-3.5 pl-6 @[calc(44rem-25px)]/meeting:flex-row @[calc(44rem-25px)]/meeting:items-center @[calc(44rem-25px)]/meeting:gap-0 @[calc(44rem-25px)]/meeting:py-0 @[calc(44rem-25px)]/meeting:pl-0",
  "data-testid": "list-item-content-row"
}, PM = {
  class: "flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2 @[calc(44rem-25px)]/meeting:contents",
  "data-testid": "list-item-time-meta"
}, FM = { class: "flex items-center self-stretch shrink-0" }, NM = {
  key: 0,
  class: "flex items-center self-stretch shrink-0 overflow-hidden @[calc(44rem-25px)]/meeting:px-5 @[calc(44rem-25px)]/meeting:w-[185px]",
  "data-testid": "list-item-meta-badge"
}, VM = { class: "flex flex-1 min-w-0 flex-col gap-0.5 @[calc(44rem-25px)]/meeting:basis-64 @[calc(44rem-25px)]/meeting:px-6 @[calc(44rem-25px)]/meeting:py-3.5" }, HM = { class: "flex w-full min-w-0 items-start gap-1.5" }, jM = ["aria-label"], WM = { class: "flex flex-wrap items-center gap-x-2 gap-y-1 @[calc(44rem-25px)]/meeting:flex-col @[calc(44rem-25px)]/meeting:items-start @[calc(44rem-25px)]/meeting:gap-1 @[calc(50rem-25px)]/meeting:flex-row @[calc(50rem-25px)]/meeting:items-center @[calc(50rem-25px)]/meeting:gap-x-2" }, qM = {
  key: 1,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-person"
}, UM = {
  key: 0,
  class: "flex min-w-min flex-wrap items-center justify-end gap-x-4 gap-y-3 @[calc(44rem-25px)]/meeting:flex-col @[calc(44rem-25px)]/meeting:items-end @[calc(44rem-25px)]/meeting:gap-3 @[calc(50rem-25px)]/meeting:flex-row @[calc(50rem-25px)]/meeting:items-center @[calc(50rem-25px)]/meeting:gap-x-4",
  "data-testid": "list-item-trailing-actions"
}, GM = { class: "flex flex-1 min-w-0 flex-col gap-3 py-4" }, KM = { class: "flex flex-col gap-0.5 min-w-0" }, YM = { class: "flex items-center justify-between gap-2" }, JM = { class: "flex w-full min-w-0 items-start gap-1.5" }, XM = ["aria-label"], ZM = {
  key: 1,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-person"
}, QM = {
  key: 1,
  class: "flex items-start gap-3",
  "data-testid": "list-item-cta"
}, cG = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "MeetingListItem",
  props: {
    layout: {},
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    border: { type: Boolean, default: !0 },
    time: { default: void 0 },
    statusTheme: { default: "green" },
    statusLabel: { default: "" },
    struckThrough: { type: Boolean, default: !1 },
    metaBadge: { default: void 0 },
    personName: { default: void 0 },
    personAvatarUrl: { default: void 0 },
    date: { default: void 0 },
    urgencyLabel: { default: void 0 },
    titleIcon: { default: void 0 }
  },
  setup(e) {
    const a = e, t = Ia(), n = {
      long: { padding: "pl-0 pr-[calc(--spacing(6)-1px)] py-0", gap: "gap-6", minHeight: "min-h-[100px]" },
      short: { padding: "pl-0 pr-[calc(--spacing(4)-1px)] py-0", gap: "gap-4" }
    }, l = mx(() => {
      const f = n[a.layout];
      return {
        padding: f.padding,
        gap: f.gap,
        minHeight: f.minHeight,
        disabled: a.disabled,
        border: a.border,
        // Only Long queries its own width; Short keeps its content-based width.
        alwaysClasses: `overflow-hidden min-w-64 ${a.layout === "long" ? "@container/meeting" : ""}`,
        restingClasses: "shadow-(--blur-shadow-s)"
      };
    }), o = m(
      () => a.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-heading)"
    ), r = {
      green: "green",
      active: "active",
      red: "red",
      disabled: "neutral",
      orange: "orange"
    }, i = {
      green: "bg-(--components-badge-background-badge-green-strong-bg)",
      active: "bg-(--components-badge-background-badge-indigo-strong-bg)",
      red: "bg-(--components-badge-background-badge-error-strong-bg)",
      disabled: "bg-(--components-badge-background-badge-neutral-strong-bg)",
      orange: "bg-(--components-badge-background-badge-orange-strong-bg)"
    }, s = m(() => r[a.statusTheme]), d = m(() => i[a.statusTheme]), c = m(() => [a.date, a.time].filter(Boolean).join(" · "));
    return (f, g) => (u(), b("div", Ve(f.$attrs, { class: L(l) }), [
      e.layout === "long" ? (u(), b(ie, { key: 0 }, [
        x("div", {
          class: C(["w-[5px] self-stretch shrink-0", d.value]),
          "aria-hidden": "true",
          "data-testid": "list-item-accent-bar"
        }, null, 2),
        x("div", OM, [
          x("div", PM, [
            x("div", FM, [
              x("p", {
                class: C(["whitespace-nowrap text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)", o.value]),
                "data-testid": "list-item-time"
              }, H(e.time), 3)
            ]),
            e.metaBadge ? (u(), b("div", NM, [
              U(yt, {
                label: e.metaBadge.label,
                theme: e.metaBadge.theme ?? "cyan",
                size: "sm",
                truncate: "",
                "show-left-icon": !1,
                "show-close-icon": !1
              }, null, 8, ["label", "theme"])
            ])) : w("", !0)
          ]),
          x("div", VM, [
            U(yt, {
              type: "with-dot",
              theme: s.value,
              label: e.statusLabel,
              size: "sm",
              class: "self-start",
              "data-testid": "list-item-status-badge"
            }, null, 8, ["theme", "label"]),
            x("div", HM, [
              e.titleIcon ? (u(), b("i", {
                key: 0,
                class: C([[e.titleIcon.icon, o.value], "shrink-0 text-(length:--size-l) leading-(--line-height-xxl)"]),
                role: "img",
                "aria-label": e.titleIcon.label,
                "data-testid": "list-item-title-icon"
              }, null, 10, jM)) : w("", !0),
              U(it, {
                text: e.label,
                lines: 2,
                "text-class": ["text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)", o.value, e.struckThrough ? "line-through" : ""].join(" "),
                "data-testid": "list-item-title"
              }, null, 8, ["text", "text-class"])
            ]),
            x("div", WM, [
              e.subtitle ? (u(), b("p", {
                key: 0,
                class: C(["min-w-0 text-(length:--size-m) leading-(--line-height-l)", o.value]),
                "data-testid": "list-item-subtitle"
              }, H(e.subtitle), 3)) : w("", !0),
              e.personName ? (u(), b("div", qM, [
                U(Jt, {
                  name: e.personName,
                  img: e.personAvatarUrl,
                  size: "sm",
                  presentational: !0,
                  class: C({ "opacity-70": e.disabled })
                }, null, 8, ["name", "img", "class"]),
                x("span", {
                  class: C(["text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", o.value])
                }, H(e.personName), 3)
              ])) : w("", !0)
            ])
          ]),
          L(t)("cta") || L(t)("actions") ? (u(), b("div", UM, [
            Me(f.$slots, "cta"),
            Me(f.$slots, "actions")
          ])) : w("", !0)
        ])
      ], 64)) : (u(), b(ie, { key: 1 }, [
        x("div", {
          class: C(["w-[5px] self-stretch shrink-0", d.value]),
          "aria-hidden": "true",
          "data-testid": "list-item-accent-bar"
        }, null, 2),
        x("div", GM, [
          x("div", KM, [
            x("div", YM, [
              x("p", {
                class: C(["whitespace-nowrap text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold)", o.value]),
                "data-testid": "list-item-date-time"
              }, H(c.value), 3),
              U(yt, {
                type: "with-dot",
                theme: s.value,
                label: e.statusLabel,
                size: "sm",
                "data-testid": "list-item-status-badge"
              }, null, 8, ["theme", "label"])
            ]),
            x("div", JM, [
              e.titleIcon ? (u(), b("i", {
                key: 0,
                class: C([[e.titleIcon.icon, o.value], "shrink-0 text-(length:--size-l) leading-(--line-height-xxl)"]),
                role: "img",
                "aria-label": e.titleIcon.label,
                "data-testid": "list-item-title-icon"
              }, null, 10, XM)) : w("", !0),
              x("p", {
                class: C(["w-full min-w-0 break-words text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold)", [o.value, e.struckThrough ? "line-through" : ""]]),
                "data-testid": "list-item-title"
              }, H(e.label), 3)
            ]),
            e.subtitle ? (u(), b("p", {
              key: 0,
              class: C(["w-full min-w-0 break-words text-(length:--size-m) leading-(--line-height-l)", o.value]),
              "data-testid": "list-item-subtitle"
            }, H(e.subtitle), 3)) : w("", !0),
            e.personName ? (u(), b("div", ZM, [
              U(Jt, {
                name: e.personName,
                img: e.personAvatarUrl,
                size: "sm",
                presentational: !0,
                class: C({ "opacity-70": e.disabled })
              }, null, 8, ["name", "img", "class"]),
              x("span", {
                class: C(["text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)", o.value])
              }, H(e.personName), 3)
            ])) : w("", !0)
          ]),
          e.urgencyLabel ? (u(), P(yt, {
            key: 0,
            theme: "red",
            size: "xs",
            label: e.urgencyLabel,
            "show-close-icon": !1,
            "data-testid": "list-item-urgency-badge",
            "left-icon": "ri-alert-line"
          }, null, 8, ["label"])) : w("", !0),
          L(t)("cta") ? (u(), b("div", QM, [
            Me(f.$slots, "cta")
          ])) : w("", !0)
        ])
      ], 64))
    ], 16));
  }
}), _M = {
  class: "flex min-w-0 flex-col gap-3",
  "data-testid": "list-item-accordion"
}, e5 = { class: "border-b border-solid border-(--border-border-base-soft) pb-3" }, t5 = ["aria-expanded", "aria-controls"], a5 = { class: "flex min-w-0 flex-1 items-center gap-1.5" }, n5 = { class: "flex shrink-0 items-center gap-1.5" }, l5 = {
  class: "flex size-8 items-center justify-center",
  "aria-hidden": "true"
}, o5 = ["id", "hidden"], fG = /* @__PURE__ */ ke({
  __name: "ListItemAccordion",
  props: /* @__PURE__ */ ou({
    title: {},
    icon: { default: void 0 },
    count: { default: void 0 }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(e) {
    const a = Ag(e, "open"), t = Ye(), n = R(null), l = R(!1), o = R(!1), r = m(() => o.value ? !1 : l.value ? !0 : void 0);
    function i(c) {
      try {
        l.value = c.target.matches(":focus-visible");
      } catch {
        l.value = !0;
      }
    }
    function s() {
      l.value = !1, o.value = !1;
    }
    function d(c) {
      var f;
      c.key !== "Escape" || o.value || !l.value || !((f = n.value) != null && f.isTruncated) || (c.stopPropagation(), c.preventDefault(), o.value = !0);
    }
    return (c, f) => (u(), b("div", _M, [
      x("div", e5, [
        x("button", {
          type: "button",
          class: "flex h-8 w-full min-w-0 cursor-pointer items-center justify-between gap-1.5 rounded-(--border-border-radius-rounded-xs) border-0 bg-transparent p-0 text-left focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
          "aria-expanded": a.value,
          "aria-controls": L(t),
          "data-testid": "list-item-accordion-header",
          onClick: f[0] || (f[0] = (g) => a.value = !a.value),
          onFocus: i,
          onBlur: s,
          onKeydown: d
        }, [
          x("span", a5, [
            e.icon ? (u(), b("i", {
              key: 0,
              class: C([e.icon, "shrink-0 text-(length:--icon-size-sm) text-(--icons-icon-dark-default)"]),
              "aria-hidden": "true",
              "data-testid": "list-item-accordion-icon"
            }, null, 2)) : w("", !0),
            U(it, {
              ref_key: "titleRef",
              ref: n,
              as: "span",
              class: "min-w-0",
              text: e.title,
              focusable: !1,
              open: r.value,
              "text-class": "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-heading)",
              "data-testid": "list-item-accordion-title"
            }, null, 8, ["text", "open"])
          ]),
          x("span", n5, [
            e.count !== void 0 ? (u(), P(yt, {
              key: 0,
              label: String(e.count),
              theme: "gradient-light",
              size: "lg",
              "badge-style": "circle",
              "text-only": "",
              "data-testid": "list-item-accordion-count"
            }, null, 8, ["label"])) : w("", !0),
            x("span", l5, [
              x("i", {
                class: C([a.value ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line", "text-(length:--icon-size-sm) text-(--icons-icon-dark-default)"]),
                "data-testid": "list-item-accordion-chevron"
              }, null, 2)
            ])
          ])
        ], 40, t5)
      ]),
      x("ul", {
        id: L(t),
        role: "list",
        class: "m-0 list-none flex-col gap-3 p-0 [&:not([hidden])]:flex",
        hidden: !a.value,
        "data-testid": "list-item-accordion-body"
      }, [
        Me(c.$slots, "default")
      ], 8, o5)
    ]));
  }
}), r5 = {
  class: "m-0 min-w-0 list-none border-b border-solid border-(--border-border-base-soft) pb-3",
  "data-testid": "list-item-accordion-row"
}, i5 = { class: "flex min-w-0 flex-1 items-center gap-1.5" }, hG = /* @__PURE__ */ ke({
  __name: "ListItemAccordionRow",
  props: {
    label: {},
    value: { default: void 0 },
    variant: { default: "default" },
    icon: { default: void 0 }
  },
  setup(e) {
    const a = e, t = {
      default: {
        row: "min-h-5 pl-6",
        label: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body)",
        value: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)",
        icon: ""
      },
      header: {
        row: "min-h-5",
        label: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body)",
        value: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)",
        icon: "size-(--icon-size-sm) text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      title: {
        row: "min-h-6",
        label: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-body)",
        value: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-black-default)",
        icon: "size-(--icon-size-md) text-(length:--icon-size-md) leading-(--icon-size-md)"
      }
    };
    return (n, l) => (u(), b("li", r5, [
      x("div", {
        class: C(["flex min-w-0 items-center justify-between gap-1.5", t[a.variant].row])
      }, [
        x("div", i5, [
          e.icon && e.variant !== "default" ? (u(), b("i", {
            key: 0,
            class: C([e.icon, t[a.variant].icon, "inline-flex shrink-0 items-center justify-center text-(--icons-icon-dark-default)"]),
            "aria-hidden": "true",
            "data-testid": "list-item-accordion-row-icon"
          }, null, 2)) : w("", !0),
          U(it, {
            class: "min-w-0",
            text: e.label,
            "text-class": t[a.variant].label,
            "data-testid": "list-item-accordion-row-label"
          }, null, 8, ["text", "text-class"])
        ]),
        e.value !== void 0 ? (u(), b("span", {
          key: 0,
          class: C(["shrink-0", t[a.variant].value]),
          "data-testid": "list-item-accordion-row-value"
        }, H(e.value), 3)) : w("", !0)
      ], 2)
    ]));
  }
}), s5 = qB, d5 = { class: "flex w-full min-w-0 items-start gap-2" }, u5 = {
  "data-testid": "alert-icon-column",
  class: "flex items-start py-1 shrink-0"
}, c5 = {
  "data-testid": "alert-text-column",
  class: "flex min-w-0 flex-1 flex-col"
}, f5 = { class: "flex min-w-0 items-center gap-2" }, h5 = { class: "flex min-w-0 flex-1 flex-col gap-2" }, b5 = {
  key: 0,
  "data-testid": "alert-heading",
  class: "wrap-break-word text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)"
}, g5 = {
  key: 1,
  "data-testid": "alert-message",
  class: "wrap-break-word text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)"
}, m5 = { class: "accordion-content-inner" }, v5 = { class: "min-w-0 pt-2" }, p5 = /* @__PURE__ */ ke({
  __name: "AlertDuplicatesList",
  props: {
    duplicates: {},
    heading: {},
    message: {},
    icon: {},
    iconTint: {},
    listBorderClass: {},
    listDividerVar: {},
    open: { type: Boolean },
    defaultOpen: { type: Boolean },
    labels: {}
  },
  emits: ["update:open", "remove"],
  setup(e, { emit: a }) {
    const t = e, n = a, { isOpen: l, toggle: o, triggerProps: r, panelProps: i, panelClasses: s, onTransitionEnd: d } = Dg({
      open: () => t.open,
      defaultOpen: () => t.defaultOpen,
      onOpenChange: ($) => n("update:open", $)
    }), c = R(null), f = R(null), g = /* @__PURE__ */ new Map();
    function h($, S) {
      S ? g.set($, S) : g.delete($);
    }
    const v = m(() => t.labels.toggleButton ?? (t.heading || t.message || "Show duplicates"));
    function p($) {
      var I, T;
      const S = $.helperText ? `${$.label}, ${$.helperText}` : $.label;
      return ((T = (I = t.labels).removeDuplicate) == null ? void 0 : T.call(I, $)) ?? `Remove ${S}`;
    }
    $e(l, ($) => {
      var S, I;
      !$ && ((S = f.value) != null && S.contains(document.activeElement)) && ((I = c.value) == null || I.$el.focus());
    });
    let y = null;
    function k($, S) {
      y = { id: $.id, index: S }, n("remove", $);
    }
    return $e(
      () => t.duplicates.map(($) => $.id),
      async ($, S) => {
        var B;
        const I = y;
        if (!I) return;
        const T = !$.includes(I.id);
        if (!T && $.length >= S.length || (y = null, !T)) return;
        await Ze();
        const A = document.activeElement;
        if (A && A !== document.body && A.isConnected) return;
        const E = $[Math.min(I.index, $.length - 1)], z = E !== void 0 ? g.get(E) : void 0;
        z != null && z.focusAction("secondary") || (B = c.value) == null || B.$el.focus();
      }
    ), ($, S) => (u(), b("div", d5, [
      x("div", u5, [
        x("i", {
          class: C([[e.icon, e.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      x("div", c5, [
        x("div", f5, [
          x("div", h5, [
            e.heading ? (u(), b("p", b5, H(e.heading), 1)) : w("", !0),
            e.message ? (u(), b("p", g5, H(e.message), 1)) : w("", !0)
          ]),
          U(L(Be), Ve({
            ref_key: "toggleRef",
            ref: c
          }, L(r), {
            "data-testid": "alert-duplicates-toggle",
            variant: "tertiary",
            size: "md",
            "icon-only": "",
            "icon-left": L(l) ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line",
            "aria-label": v.value,
            class: "shrink-0",
            onClick: L(o)
          }), null, 16, ["icon-left", "aria-label", "onClick"])
        ]),
        x("div", Ve({
          ref_key: "panelRef",
          ref: f
        }, L(i), {
          class: L(s),
          "data-testid": "alert-duplicates-panel",
          onTransitionend: S[0] || (S[0] = //@ts-ignore
          (...I) => L(d) && L(d)(...I))
        }), [
          x("div", m5, [
            x("div", v5, [
              x("div", {
                "data-testid": "alert-duplicates-list",
                class: C(["min-w-0 border-y-(length:--border-border-width-border) border-solid py-3", e.listBorderClass])
              }, [
                U(L(UB), {
                  divider: "",
                  "divider-color": `var(${e.listDividerVar})`
                }, {
                  default: me(() => [
                    (u(!0), b(ie, null, Oe(e.duplicates, (I, T) => (u(), P(L(s5), {
                      key: I.id,
                      ref_for: !0,
                      ref: (A) => h(I.id, A),
                      type: "avatar-text-badge",
                      label: I.label,
                      "helper-text": I.helperText,
                      "label-badge": I.badge ? { label: I.badge, theme: "orange" } : void 0,
                      "secondary-action": {
                        label: p(I),
                        icon: "ri-delete-bin-line",
                        testId: "alert-duplicate-remove",
                        onClick: () => k(I, T)
                      }
                    }, null, 8, ["label", "helper-text", "label-badge", "secondary-action"]))), 128))
                  ]),
                  _: 1
                }, 8, ["divider-color"])
              ], 2)
            ])
          ])
        ], 16)
      ])
    ]));
  }
}), x5 = { class: "flex w-full min-w-0 items-start gap-2" }, y5 = {
  "data-testid": "alert-icon-column",
  class: "flex items-start py-1 shrink-0"
}, k5 = {
  "data-testid": "alert-text-column",
  class: "flex min-w-0 flex-1 flex-col gap-2"
}, w5 = {
  "data-testid": "alert-heading",
  class: "wrap-break-word text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)"
}, C5 = {
  key: 0,
  "data-testid": "alert-message",
  class: "wrap-break-word text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"
}, S5 = {
  key: 1,
  "data-testid": "alert-error-links",
  class: "flex flex-col gap-1"
}, $5 = /* @__PURE__ */ ke({
  __name: "AlertErrorSummary",
  props: {
    errors: {},
    message: {},
    showLinks: { type: Boolean },
    icon: {},
    iconTint: {},
    labels: {}
  },
  setup(e) {
    const a = e, t = m(() => {
      var o, r;
      const l = a.errors.length;
      return ((r = (o = a.labels).errorSummaryHeading) == null ? void 0 : r.call(o, l)) ?? (l === 1 ? "1 error" : `${l} errors`);
    });
    function n(l, o) {
      const r = document.getElementById(o);
      r && (l.preventDefault(), r.scrollIntoView({ block: "center" }), r.focus({ preventScroll: !0 }));
    }
    return (l, o) => (u(), b("div", x5, [
      x("div", y5, [
        x("i", {
          class: C([[e.icon, e.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      x("div", k5, [
        x("h2", w5, H(t.value), 1),
        e.message ? (u(), b("p", C5, H(e.message), 1)) : w("", !0),
        e.showLinks ? (u(), b("ul", S5, [
          (u(!0), b(ie, null, Oe(e.errors, (r) => (u(), b("li", {
            key: r.fieldId
          }, [
            U(L(pa), {
              as: "a",
              href: `#${r.fieldId}`,
              onClick: (i) => n(i, r.fieldId)
            }, {
              default: me(() => [
                st(H(r.message), 1)
              ]),
              _: 2
            }, 1032, ["href", "onClick"])
          ]))), 128))
        ])) : w("", !0)
      ])
    ]));
  }
}), I5 = {
  "data-testid": "alert-pill-link",
  class: "flex min-w-0 flex-1 items-center gap-0.5"
}, L5 = {
  key: 4,
  "data-testid": "alert-inline-row",
  class: "flex w-full items-start gap-2"
}, T5 = { class: "flex-1 flex flex-col gap-3" }, E5 = {
  "data-testid": "alert-text-group",
  class: "flex flex-col gap-1"
}, A5 = {
  key: 5,
  "data-testid": "alert-compact-row",
  class: "flex w-full items-start gap-2"
}, R5 = { class: "flex-1 flex flex-col gap-2" }, z5 = { class: "flex flex-col gap-1" }, D5 = {
  key: 1,
  class: "flex items-center gap-1"
}, B5 = {
  key: 0,
  "data-testid": "alert-actions",
  class: "flex items-center gap-4"
}, M5 = {
  key: 1,
  "data-testid": "alert-actions",
  class: "flex items-center gap-4"
}, O5 = {
  key: 2,
  "data-testid": "alert-right-column",
  class: "flex flex-col items-end justify-center gap-2 shrink-0"
}, Vb = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)", P5 = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", Hb = "text-(length:--size-xs) leading-(--line-height-xs) font-(--weight-regular)", yo = /* @__PURE__ */ ke({
  __name: "Alert",
  props: /* @__PURE__ */ ou({
    color: { default: "success" },
    surface: { default: "card" },
    layout: { default: "inline" },
    heading: { default: void 0 },
    message: { default: "" },
    closable: { type: Boolean, default: !1 },
    percentage: { default: void 0 },
    buttons: { default: () => [] },
    buttonsPosition: { default: "bottom" },
    compact: { type: Boolean, default: !1 },
    href: { default: void 0 },
    optionalIcon: { default: void 0 },
    checkbox: { default: void 0 },
    duplicates: { default: void 0 },
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    errors: { default: void 0 },
    labels: { default: () => ({}) }
  }, {
    checked: { type: Boolean, default: !1 },
    checkedModifiers: {}
  }),
  emits: /* @__PURE__ */ ou(["close", "navigate", "update:open", "remove"], ["update:checked"]),
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = Ag(e, "checked"), r = R(!1), i = {
      success: {
        bg: "bg-(--background-background-success)",
        borderClass: "border-(--border-border-success)",
        borderTopClass: "border-(--border-border-success)",
        pillHoverBorderClass: "hover:border-(--background-background-success)",
        icon: "ri-checkbox-circle-line",
        iconTint: "text-(--icons-icon-success)",
        badgeTheme: "green",
        listBorderClass: "border-(--border-border-success-sublte)",
        listDividerVar: "--border-border-success-sublte"
      },
      danger: {
        bg: "bg-(--background-background-error)",
        borderClass: "border-(--border-border-error-subtle)",
        borderTopClass: "border-(--border-border-error-strong)",
        pillHoverBorderClass: "hover:border-(--background-background-error)",
        icon: "ri-alert-line",
        iconTint: "text-(--icons-icon-error)",
        badgeTheme: "red",
        listBorderClass: "border-(--border-border-error-strong)",
        listDividerVar: "--border-border-error-strong"
      },
      warning: {
        bg: "bg-(--background-background-warning)",
        borderClass: "border-(--border-border-warning-subtle)",
        borderTopClass: "border-(--border-border-warning)",
        pillHoverBorderClass: "hover:border-(--background-background-warning)",
        icon: "ri-alert-line",
        iconTint: "text-(--icons-icon-warning)",
        badgeTheme: "orange",
        listBorderClass: "border-(--border-border-warning)",
        listDividerVar: "--border-border-warning"
      },
      info: {
        bg: "bg-(--background-background-info)",
        borderClass: "border-(--border-border-info-subtle)",
        borderTopClass: "border-(--border-border-info-subtle)",
        pillHoverBorderClass: "hover:border-(--background-background-info)",
        icon: "ri-information-line",
        iconTint: "text-(--icons-icon-info)",
        badgeTheme: "indigo",
        listBorderClass: "border-(--border-border-info-strong)",
        listDividerVar: "--border-border-info-strong"
      },
      default: {
        bg: "bg-(--background-background-white)",
        borderClass: "border-(--border-border-base-medium)",
        borderTopClass: "border-(--border-border-base-medium)",
        pillHoverBorderClass: "hover:border-(--background-background-white)",
        icon: "ri-information-line",
        iconTint: "text-(--icons-icon-dark-default)",
        badgeTheme: "neutral",
        listBorderClass: "border-(--border-border-base)",
        listDividerVar: "--border-border-base"
      },
      ia: {
        bg: "bg-(--background-background-ia)",
        borderClass: "border-(--border-border-ia)",
        borderTopClass: "border-(--colors-border-ia-strong)",
        pillHoverBorderClass: "hover:border-(--background-background-ia)",
        icon: "ri-magic-line",
        iconTint: "text-(--icons-icon-ia)",
        badgeTheme: "purple",
        listBorderClass: "border-(--border-border-ia)",
        listDividerVar: "--border-border-ia"
      }
    }, s = m(() => {
      var V;
      return i[(V = n.errors) != null && V.length ? "danger" : n.color];
    }), d = m(() => s.value.badgeTheme), c = m(
      () => n.color === "danger" ? { role: "alert", ariaLive: "assertive", ariaAtomic: "true" } : { role: "status", ariaLive: "polite", ariaAtomic: void 0 }
    ), f = m(() => n.surface === "pill"), g = m(() => {
      var V;
      return (((V = n.errors) == null ? void 0 : V.length) ?? 0) > 10;
    }), h = m(() => f.value ? n.href ? "a" : "button" : "div"), v = m(() => {
      var V;
      return f.value ? n.href ? { href: n.href } : { type: "button" } : n.duplicates ? {} : (V = n.errors) != null && V.length ? { tabindex: -1, role: "group" } : {
        role: c.value.role,
        "aria-live": c.value.ariaLive,
        "aria-atomic": c.value.ariaAtomic
      };
    }), p = m(() => n.surface === "pill" ? "rounded-(--border-border-radius-rounded-full) border-(length:--border-border-width-border) border-solid flex-row items-center gap-2 py-[calc(--spacing(1)-1px)] pr-[calc(--spacing(2)-1px)] pl-[calc(--spacing(1)-1px)] w-full" : n.surface === "borderTop" ? "rounded-none border-t-(length:--border-border-width-border-lg) border-solid flex-col items-start gap-4 px-4 pb-4 pt-[calc(--spacing(4)-4px)] w-full" : "rounded-(--border-border-radius-rounded-l) border-(length:--border-border-width-border) border-solid flex-col items-start gap-4 p-[calc(--spacing(4)-1px)] w-full"), y = m(() => [
      g.value ? "sticky top-0 z-10 max-h-[40vh] overflow-y-auto" : "relative",
      "box-border flex min-w-64 text-left font-inter transition-all duration-300",
      s.value.bg,
      n.surface === "borderTop" ? s.value.borderTopClass : s.value.borderClass,
      "text-(--text-text-heading)",
      p.value,
      f.value ? ["cursor-pointer", "transition-colors", s.value.pillHoverBorderClass] : ""
    ]), k = m(() => n.percentage !== void 0 || n.layout === "stacked" && n.buttonsPosition === "bottom" ? "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)" : "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"), $ = m(() => !!n.heading && n.surface !== "borderTop"), S = m(
      () => n.surface === "borderTop" ? "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)" : Vb
    ), I = m(
      () => n.closable && n.percentage === void 0 && !f.value && !n.compact
    ), T = m(
      () => n.buttonsPosition === "right" && (I.value || n.buttons.length > 0)
    ), A = m(
      () => n.buttonsPosition === "right" && (!n.message || n.buttons.length > 0 && n.buttons.every((V) => V.variant === "tertiary"))
    ), E = m(
      () => !!n.checkbox && !f.value && !n.compact && !n.heading && !n.message
    ), z = m(() => n.percentage !== void 0), B = m(() => {
      var V;
      return ((V = n.labels) == null ? void 0 : V.closeButton) ?? "Dismiss alert";
    });
    function W() {
      r.value = !0, l("close");
    }
    function _() {
      l("navigate");
    }
    function Z(V) {
      var M;
      (M = V.onClick) == null || M.call(V);
    }
    function le(V) {
      return {
        as: V.href ? "a" : "button",
        href: V.href,
        ariaLabel: V.ariaLabel,
        iconLeft: V.iconPosition !== "right" ? V.icon : void 0,
        iconRight: V.iconPosition === "right" ? V.icon : void 0,
        size: "s",
        onClick: () => Z(V)
      };
    }
    function D(V) {
      return {
        label: V.label,
        variant: V.variant ?? (n.buttonsPosition === "right" ? "primary" : "secondary"),
        as: V.href ? "a" : "button",
        href: V.href,
        // Passed as a literal HTML attribute key, not a declared Button prop —
        // Button.vue never declares `ariaLabel`, so this lands in Button's
        // $attrs and Vue's default attrs inheritance forwards it straight to
        // the root <button>/<a> element, overriding nothing else. Declaring a
        // real `ariaLabel` prop on Button.vue would close the automatic $attrs
        // fallthrough for that attribute name for every consumer in the
        // monorepo (many icon-only Button call sites rely on a raw, undeclared
        // :aria-label falling through) — see Refs: #OP-5881 fix commit.
        "aria-label": V.ariaLabel,
        iconLeft: V.iconPosition !== "right" ? V.icon : void 0,
        iconRight: V.iconPosition === "right" ? V.icon : void 0,
        size: "xs",
        loading: V.loading,
        onClick: () => Z(V)
      };
    }
    const O = R(null);
    a({
      /** Moves focus to the Alert; only the error summary (`errors`) can take it. */
      focus: () => {
        var V;
        return (V = O.value) == null ? void 0 : V.focus();
      }
    });
    function N() {
      f.value && !n.href && _();
    }
    return (V, M) => r.value ? w("", !0) : (u(), P(gt(h.value), Ve({
      key: 0,
      ref_key: "rootRef",
      ref: O
    }, v.value, { class: y.value }, nl(f.value ? { click: N } : {})), {
      default: me(() => {
        var Q;
        return [
          E.value && !V.$slots.body ? (u(), P(va, {
            key: 0,
            modelValue: o.value,
            "onUpdate:modelValue": M[0] || (M[0] = (q) => o.value = q),
            label: e.checkbox.label,
            "label-wrap": ""
          }, null, 8, ["modelValue", "label"])) : f.value ? (u(), b(ie, { key: 1 }, [
            U(L(yt), {
              "data-testid": "alert-badge",
              label: e.heading,
              theme: d.value,
              size: "sm",
              "show-left-icon": !1,
              "show-close-icon": !1,
              class: "h-5! min-h-5! min-w-0! max-w-1/2 rounded-(--border-border-radius-rounded-full)! px-2! py-0! [&>span>span]:min-w-0 [&>span>span]:truncate"
            }, null, 8, ["label", "theme"]),
            x("span", I5, [
              e.message ? (u(), b("span", {
                key: 0,
                "data-testid": "alert-message",
                class: C([k.value, "min-w-0 truncate"])
              }, H(e.message), 3)) : w("", !0),
              M[5] || (M[5] = x("i", {
                class: "ri-arrow-right-line inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l) shrink-0",
                "aria-hidden": "true"
              }, null, -1))
            ])
          ], 64)) : e.duplicates ? (u(), P(p5, {
            key: 2,
            duplicates: e.duplicates,
            heading: e.heading,
            message: e.message,
            icon: s.value.icon,
            "icon-tint": s.value.iconTint,
            "list-border-class": s.value.listBorderClass,
            "list-divider-var": s.value.listDividerVar,
            open: e.open,
            "default-open": e.defaultOpen,
            labels: e.labels,
            "onUpdate:open": M[1] || (M[1] = (q) => l("update:open", q)),
            onRemove: M[2] || (M[2] = (q) => l("remove", q))
          }, null, 8, ["duplicates", "heading", "message", "icon", "icon-tint", "list-border-class", "list-divider-var", "open", "default-open", "labels"])) : (Q = e.errors) != null && Q.length ? (u(), P($5, {
            key: 3,
            errors: e.errors,
            message: e.message,
            "show-links": g.value,
            icon: s.value.icon,
            "icon-tint": s.value.iconTint,
            labels: e.labels
          }, null, 8, ["errors", "message", "show-links", "icon", "icon-tint", "labels"])) : e.layout === "inline" ? (u(), b("div", L5, [
            x("div", {
              "data-testid": "alert-icon-column",
              class: C(["flex items-center shrink-0", $.value ? "py-1" : "py-0.5"])
            }, [
              x("i", {
                class: C([[s.value.icon, s.value.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
                "aria-hidden": "true"
              }, null, 2)
            ], 2),
            x("div", T5, [
              x("div", E5, [
                e.heading ? (u(), b("p", {
                  key: 0,
                  "data-testid": "alert-heading",
                  class: C(S.value)
                }, H(e.heading), 3)) : w("", !0),
                e.message ? (u(), b("p", {
                  key: 1,
                  "data-testid": "alert-message",
                  class: C(k.value)
                }, H(e.message), 3)) : w("", !0)
              ]),
              e.checkbox ? (u(), P(va, {
                key: 0,
                modelValue: o.value,
                "onUpdate:modelValue": M[3] || (M[3] = (q) => o.value = q),
                label: e.checkbox.label,
                "label-wrap": ""
              }, null, 8, ["modelValue", "label"])) : w("", !0)
            ]),
            I.value ? (u(), P(L(Be), {
              key: 0,
              variant: "text",
              "icon-only": "",
              "icon-left": "ri-close-line",
              size: "xs",
              "aria-label": B.value,
              class: C(["-mx-2 shrink-0", $.value ? "-my-1" : "-my-1.5"]),
              onClick: W
            }, null, 8, ["aria-label", "class"])) : w("", !0)
          ])) : e.compact ? (u(), b("div", A5, [
            z.value ? (u(), P(L(yt), {
              key: 0,
              "data-testid": "alert-percentage",
              label: `${e.percentage}%`,
              theme: d.value,
              size: "sm",
              "show-left-icon": !1,
              "show-close-icon": !1,
              class: "min-w-10 rounded-(--border-border-radius-rounded-xs)!"
            }, null, 8, ["label", "theme"])) : w("", !0),
            x("div", R5, [
              x("div", z5, [
                e.heading ? (u(), b("p", {
                  key: 0,
                  "data-testid": "alert-heading",
                  class: C(P5)
                }, H(e.heading), 1)) : w("", !0),
                e.optionalIcon ? (u(), b("div", D5, [
                  Me(V.$slots, "body", {}, () => [
                    e.message ? (u(), b("p", {
                      key: 0,
                      "data-testid": "alert-message",
                      class: C(Hb)
                    }, H(e.message), 1)) : w("", !0)
                  ]),
                  U(L(aa), {
                    icon: e.optionalIcon,
                    color: "yellow",
                    size: "xs",
                    type: "square",
                    variant: "outlined"
                  }, null, 8, ["icon"])
                ])) : Me(V.$slots, "body", { key: 2 }, () => [
                  e.message ? (u(), b("p", {
                    key: 0,
                    "data-testid": "alert-message",
                    class: C(Hb)
                  }, H(e.message), 1)) : w("", !0)
                ])
              ]),
              e.buttons.length ? (u(), b("div", B5, [
                (u(!0), b(ie, null, Oe(e.buttons, (q, K) => (u(), b(ie, { key: K }, [
                  q.component === "link" ? (u(), P(L(pa), Ve({
                    key: 0,
                    ref_for: !0
                  }, le(q)), {
                    default: me(() => [
                      st(H(q.label), 1)
                    ]),
                    _: 2
                  }, 1040)) : (u(), P(L(Be), Ve({
                    key: 1,
                    ref_for: !0
                  }, D(q)), null, 16))
                ], 64))), 128))
              ])) : w("", !0)
            ])
          ])) : (u(), b("div", {
            key: 6,
            "data-testid": "alert-main-row",
            class: C(["flex w-full", [
              A.value ? "items-center" : "items-start",
              z.value ? "gap-1 ps-5" : "gap-2 ps-6",
              { "flex-wrap": T.value }
            ]])
          }, [
            x("div", {
              class: C(["relative flex min-h-6 min-w-0", T.value ? "grow basis-40" : "flex-1"])
            }, [
              x("div", {
                "data-testid": "alert-icon-column",
                class: C(["absolute top-0 flex items-start py-1", z.value ? "-start-5" : "-start-6"])
              }, [
                x("i", {
                  class: C([[s.value.icon, s.value.iconTint], "inline-flex items-center justify-center size-(--icon-size-sm) text-(length:--size-l)"]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 2),
              x("div", {
                "data-testid": "alert-text-column",
                class: C(["flex min-w-0 flex-1 flex-col", e.checkbox ? "gap-3" : "gap-2"])
              }, [
                x("div", {
                  "data-testid": "alert-text-group",
                  class: C(e.checkbox ? "flex flex-col gap-1" : "contents")
                }, [
                  e.heading ? (u(), b("p", {
                    key: 0,
                    "data-testid": "alert-heading",
                    class: C(Vb)
                  }, H(e.heading), 1)) : w("", !0),
                  Me(V.$slots, "body", {}, () => [
                    e.message ? (u(), b("p", {
                      key: 0,
                      "data-testid": "alert-message",
                      class: C(k.value)
                    }, H(e.message), 3)) : w("", !0)
                  ])
                ], 2),
                e.checkbox ? (u(), P(va, {
                  key: 0,
                  modelValue: o.value,
                  "onUpdate:modelValue": M[4] || (M[4] = (q) => o.value = q),
                  label: e.checkbox.label,
                  "label-wrap": ""
                }, null, 8, ["modelValue", "label"])) : w("", !0),
                e.buttons.length && e.buttonsPosition === "bottom" ? (u(), b("div", M5, [
                  (u(!0), b(ie, null, Oe(e.buttons, (q, K) => (u(), b(ie, { key: K }, [
                    q.component === "link" ? (u(), P(L(pa), Ve({
                      key: 0,
                      ref_for: !0
                    }, le(q)), {
                      default: me(() => [
                        st(H(q.label), 1)
                      ]),
                      _: 2
                    }, 1040)) : (u(), P(L(Be), Ve({
                      key: 1,
                      ref_for: !0
                    }, D(q)), null, 16))
                  ], 64))), 128))
                ])) : w("", !0)
              ], 2)
            ], 2),
            z.value ? (u(), P(L(yt), {
              key: 0,
              "data-testid": "alert-percentage",
              label: `${e.percentage}%`,
              theme: d.value,
              size: "sm",
              "show-left-icon": !1,
              "show-close-icon": !1,
              class: "shrink-0 min-w-10 rounded-(--border-border-radius-rounded-xs)!"
            }, null, 8, ["label", "theme"])) : w("", !0),
            I.value && e.buttonsPosition !== "right" ? (u(), P(L(Be), {
              key: 1,
              variant: "text",
              "icon-only": "",
              "icon-left": "ri-close-line",
              size: "xs",
              "aria-label": B.value,
              class: "-mx-2 -my-1 shrink-0",
              onClick: W
            }, null, 8, ["aria-label"])) : w("", !0),
            T.value ? (u(), b("div", O5, [
              I.value ? (u(), P(L(Be), {
                key: 0,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-close-line",
                size: "xs",
                "aria-label": B.value,
                class: "-m-2",
                onClick: W
              }, null, 8, ["aria-label"])) : w("", !0),
              (u(!0), b(ie, null, Oe(e.buttons, (q, K) => (u(), b(ie, { key: K }, [
                q.component === "link" ? (u(), P(L(pa), Ve({
                  key: 0,
                  ref_for: !0
                }, le(q)), {
                  default: me(() => [
                    st(H(q.label), 1)
                  ]),
                  _: 2
                }, 1040)) : (u(), P(L(Be), Ve({
                  key: 1,
                  ref_for: !0
                }, D(q)), null, 16))
              ], 64))), 128))
            ])) : w("", !0)
          ], 2))
        ];
      }),
      _: 3
    }, 16, ["class"]));
  }
}), F5 = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z"/></svg>', jb = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"/></svg>', N5 = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"/></svg>', V5 = ["src", "alt"], H5 = ["aria-label", "disabled", "aria-describedby"], j5 = { class: "flex flex-col gap-4" }, W5 = { class: "flex items-start gap-4" }, q5 = {
  "data-testid": "image-upload-preview",
  class: "shrink-0"
}, U5 = ["src", "alt"], G5 = { class: "flex-1 min-w-0" }, K5 = { key: 0 }, Wb = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='%23c0c0c0'/%3E%3Crect x='30' y='30' width='140' height='140' rx='4' fill='%23e0e0e0'/%3E%3Ccircle cx='80' cy='82' r='14' fill='%23b0b0b0'/%3E%3Cpath d='M50 140 l30-40 l20 25 l15-18 l35 45 H50z' fill='%23b0b0b0'/%3E%3C/svg%3E", bG = /* @__PURE__ */ ke({
  __name: "ImageUploadInput",
  props: {
    imageUrl: { default: void 0 },
    imageAlt: { default: "Profile picture" },
    avatarSize: { default: 64 },
    label: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    accept: { default: "image/*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    maxFileSizeText: { default: "SVG, PNG, JPG or GIF (MAX. 800x400px)." },
    fileTypeErrorText: { default: void 0 },
    fileSizeErrorText: { default: void 0 },
    fileInputLabel: { default: void 0 },
    browseButtonText: { default: "Choose files" },
    placeholder: { default: "No file chosen" },
    removeButtonLabel: { default: "Remove current picture" },
    alertHeading: { default: "Important" },
    alertMessage: { default: "In order for new users to access their accounts, they must receive approval from an administrator to verify their eligibility." },
    alertVariant: { default: "info" },
    showAlert: { type: Boolean, default: !0 },
    cancelButtonLabel: { default: "Cancel" },
    uploadButtonLabel: { default: "Upload new picture" },
    modalTitle: { default: "Upload profile picture" },
    modalSize: { default: "sm" },
    disabled: { type: Boolean, default: !1 },
    editButtonLabel: { default: "Edit profile picture" },
    closeModalLabel: { default: "Close modal" }
  },
  emits: ["upload", "remove", "cancel"],
  setup(e, { expose: a, emit: t }) {
    const n = (Z, le) => {
      const D = Z.replace('fill="currentColor"', `fill="${le}"`).replace("<svg", '<svg width="16" height="16"');
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(D)}`;
    }, l = {
      arrowLeftDark: n(F5, "#242424"),
      arrowRightDark: n(jb, "#242424"),
      arrowRightLight: n(jb, "#f2f0f0"),
      deleteDark: n(N5, "#242424")
    }, o = e, r = t, i = R(!1), s = R(!1), d = R(null), c = Ye(), f = `${c}-hint`, g = `${c}-error`, h = m(() => {
      const Z = [];
      return o.hint && Z.push(f), o.error && Z.push(g), Z.length > 0 ? Z.join(" ") : void 0;
    }), v = R(null), p = R(void 0), y = R(null), k = m(() => ({
      width: `${o.avatarSize}px`,
      height: `${o.avatarSize}px`
    })), $ = m(() => {
      const Z = "flex text-left text-sm font-inter";
      return o.labelInline ? `${Z} flex-row items-center gap-4` : `${Z} flex-col items-start gap-2`;
    }), S = () => {
      o.disabled || (v.value = null, p.value = o.imageUrl, y.value = null, i.value = !0);
    };
    a({
      /** Opens the upload modal, as the edit button does (no-op while `disabled`). */
      open: S
    });
    const I = () => {
      i.value = !1, v.value = null, p.value = void 0;
    }, T = () => {
      r("cancel"), I();
    }, A = (Z) => {
      !Z || Array.isArray(Z) || (y.value = null, v.value = Z, p.value = URL.createObjectURL(Z));
    }, E = (Z) => {
      y.value = Z, v.value = null;
    }, z = () => {
      v.value = null, p.value = void 0, r("remove");
    }, B = () => {
      v.value && (r("upload", v.value), I());
    }, W = m(() => !!v.value), _ = m(() => !!p.value);
    return $e(i, (Z) => {
      !Z && p.value && p.value !== o.imageUrl && URL.revokeObjectURL(p.value);
    }), (Z, le) => (u(), b("div", {
      "data-testid": "image-upload-input",
      class: C($.value)
    }, [
      e.label ? (u(), P(Ft, {
        key: 0,
        text: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        inline: e.labelInline,
        "test-id": "image-upload-label"
      }, null, 8, ["text", "required", "required-indicator", "tooltip", "inline"])) : w("", !0),
      x("div", {
        class: C(["flex min-w-0 flex-col items-start gap-0.5", e.labelInline ? "flex-1" : "self-stretch"])
      }, [
        x("div", {
          class: "relative inline-block",
          style: Ge(k.value)
        }, [
          x("div", {
            "data-testid": "image-upload-trigger",
            class: C(["w-full h-full rounded-(--border-border-radius-rounded-l) overflow-hidden border border-(--colors-border-base-soft) dark:border-(--colors-border-base)", e.disabled ? "opacity-50" : ""])
          }, [
            x("img", {
              src: e.imageUrl || Wb,
              alt: e.imageAlt,
              class: "w-full h-full object-cover"
            }, null, 8, V5)
          ], 2),
          x("button", {
            "data-testid": "image-upload-edit-button",
            type: "button",
            "aria-label": e.editButtonLabel,
            class: C(["absolute -top-2 -right-2 flex items-center justify-center w-8 h-8 rounded-full bg-(--background-background-white) dark:bg-(--colors-background-black-default) border border-(--colors-border-base-soft) dark:border-(--colors-border-base) shadow-sm transition-colors duration-200 hover:bg-(--colors-background-hover) dark:hover:bg-[rgba(255,255,255,0.1)]", e.disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"]),
            disabled: e.disabled,
            "aria-describedby": h.value,
            onClick: S,
            onFocus: le[0] || (le[0] = (D) => s.value = !0),
            onBlur: le[1] || (le[1] = (D) => s.value = !1),
            onKeydown: le[2] || (le[2] = (D) => {
              var O;
              return (O = d.value) == null ? void 0 : O.handleFieldKeydown(D);
            })
          }, [...le[4] || (le[4] = [
            x("i", {
              class: "ri-pencil-line text-(length:--size-m) text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
              "aria-hidden": "true"
            }, null, -1)
          ])], 42, H5)
        ], 4),
        e.hint || e.error ? (u(), P(Pt, {
          key: 0,
          ref_key: "helperRef",
          ref: d,
          focused: s.value,
          hint: e.hint,
          error: e.error,
          "hint-id": f,
          "error-id": g,
          "error-live": e.errorLive,
          "test-id-prefix": "image-upload"
        }, null, 8, ["focused", "hint", "error", "error-live"])) : w("", !0)
      ], 2),
      U(L(dl), {
        modelValue: i.value,
        "onUpdate:modelValue": le[3] || (le[3] = (D) => i.value = D),
        size: e.modalSize,
        title: e.modalTitle,
        "aria-close-label": e.closeModalLabel
      }, {
        footer: me(() => [
          U(L(Be), {
            "data-testid": "image-upload-cancel-button",
            variant: "secondary",
            label: e.cancelButtonLabel,
            "icon-left": l.arrowLeftDark,
            onClick: T
          }, null, 8, ["label", "icon-left"]),
          U(L(Be), {
            "data-testid": "image-upload-submit-button",
            variant: "primary",
            label: e.uploadButtonLabel,
            "icon-right": l.arrowRightLight,
            disabled: !W.value,
            onClick: B
          }, null, 8, ["label", "icon-right", "disabled"])
        ]),
        default: me(() => [
          x("div", j5, [
            x("div", W5, [
              x("div", q5, [
                x("img", {
                  src: p.value || Wb,
                  alt: e.imageAlt,
                  class: "w-16 h-16 rounded-xl object-cover border border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                }, null, 8, U5)
              ]),
              x("div", G5, [
                U(L($$), {
                  variant: "basic",
                  accept: e.accept,
                  "max-file-size": e.maxFileSize,
                  "max-file-size-text": e.maxFileSizeText,
                  "file-type-error-text": e.fileTypeErrorText,
                  "file-size-error-text": e.fileSizeErrorText,
                  label: e.fileInputLabel,
                  "browse-button-text": e.browseButtonText,
                  placeholder: e.placeholder,
                  "model-value": v.value,
                  error: y.value ?? void 0,
                  "onUpdate:modelValue": A,
                  onError: E
                }, null, 8, ["accept", "max-file-size", "max-file-size-text", "file-type-error-text", "file-size-error-text", "label", "browse-button-text", "placeholder", "model-value", "error"])
              ])
            ]),
            _.value ? (u(), b("div", K5, [
              U(L(Be), {
                "data-testid": "image-upload-remove-button",
                variant: "secondary",
                label: e.removeButtonLabel,
                "icon-left": l.deleteDark,
                size: "sm",
                onClick: z
              }, null, 8, ["label", "icon-left"])
            ])) : w("", !0),
            e.showAlert ? (u(), P(L(yo), {
              key: 1,
              heading: e.alertHeading,
              message: e.alertMessage,
              color: e.alertVariant === "error" ? "danger" : e.alertVariant,
              closable: !1
            }, null, 8, ["heading", "message", "color"])) : w("", !0)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "size", "title", "aria-close-label"])
    ], 2));
  }
}), Y5 = ["id", "aria-label", "data-testid"], J5 = {
  key: 0,
  class: "flex w-full items-center gap-3"
}, vx = /* @__PURE__ */ ke({
  __name: "DatepickerPanel",
  props: {
    open: { type: Boolean, default: !1 },
    anchorEl: {},
    dialogLabel: {},
    testId: {},
    widthClass: {},
    id: { default: void 0 },
    keepAnchorFocusable: { type: Boolean, default: !1 },
    additionalAnchorEls: { default: () => [] },
    placement: { default: "bottom-start" }
  },
  emits: ["update:open", "close"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = R(null);
    let r = null;
    function i(v) {
      return v.startsWith("bottom") ? v.replace("bottom", "top") : v.replace("top", "bottom");
    }
    function s() {
      o.value && (r == null || r.destroy(), r = fl(n.anchorEl, o.value, {
        strategy: "fixed",
        placement: n.placement,
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: [i(n.placement)] } },
          { name: "preventOverflow", options: { padding: 8 } }
        ]
      }));
    }
    function d() {
      r == null || r.destroy(), r = null;
    }
    function c() {
      r == null || r.update();
    }
    function f() {
      l("update:open", !1), l("close");
    }
    Is({
      active: Ua(n, "open"),
      container: o,
      containFocus: !0,
      restoreFocusTo: () => n.anchorEl,
      // See keepAnchorFocusable's doc above: without this, a consumer whose anchor IS its own
      // typing surface can never place a caret in it while the panel is open — containFocus treats
      // the click as focus escaping the trap and yanks it straight back to the panel's first
      // focusable cell.
      allowOutsideElements: n.keepAnchorFocusable ? () => [n.anchorEl, ...n.additionalAnchorEls] : void 0
    }), Ds(o, f, {
      isActive: () => n.open,
      ignoreElements: () => [n.anchorEl, ...n.additionalAnchorEls]
    });
    const g = Symbol("datepicker-panel");
    function h(v) {
      v.key !== "Escape" || !n.open || On(g) && (v.defaultPrevented || (v.stopPropagation(), v.preventDefault(), f()));
    }
    return $e(
      () => n.open,
      async (v) => {
        v ? (xn(g), await Ze(), s()) : (_a(g), d());
      },
      { immediate: !0 }
    ), $e(
      () => n.anchorEl,
      () => {
        n.open && s();
      }
    ), kt(() => {
      document.addEventListener("keydown", h);
    }), Tt(() => {
      document.removeEventListener("keydown", h), _a(g), d();
    }), a({ updatePosition: c }), (v, p) => (u(), P(Fa, { to: "body" }, [
      e.open ? (u(), b("div", {
        key: 0,
        id: e.id,
        ref_key: "panelRef",
        ref: o,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": e.dialogLabel,
        "data-focus-trap-allow-outside": "",
        "data-testid": e.testId,
        class: C([
          "z-[350] flex flex-col items-center gap-4 rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-5 shadow-(--blur-shadow-m) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
          e.widthClass
        ])
      }, [
        Me(v.$slots, "default"),
        v.$slots.actions ? (u(), b("div", J5, [
          Me(v.$slots, "actions")
        ])) : w("", !0)
      ], 10, Y5)) : w("", !0)
    ]));
  }
}), X5 = ["aria-disabled", "data-state", "aria-current"], pl = "relative inline-flex items-center justify-center font-inter focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1", Z5 = "flex size-9 items-center justify-center rounded-(--border-border-radius-rounded-full) border border-solid datepicker-cell--gradient-white", Ul = "text-(length:--size-sm) leading-(--line-height-l)", Q5 = /* @__PURE__ */ ke({
  __name: "DatepickerCell",
  props: {
    type: { default: "Day" },
    state: { default: "Initial" },
    text: { default: "" },
    muted: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => t.state === "Disabled");
    function o(c) {
      l.value || n("click", c);
    }
    const r = m(
      () => t.type === "Day" && (t.state === "Active start" || t.state === "Active end")
    ), i = m(() => {
      switch (t.type) {
        case "Month":
          return "h-9 min-w-[78px] flex-1";
        case "Year":
        case "Wheel":
          return "h-9 min-w-[57px] flex-1";
        default:
          return "size-9 shrink-0";
      }
    }), s = m(() => {
      switch (t.state) {
        case "Hover":
          return `${pl} bg-(--background-background-accent) rounded-(--border-border-radius-rounded-base)`;
        case "Active":
          return `${pl} datepicker-cell--gradient-white border border-solid rounded-(--border-border-radius-rounded-full)`;
        case "Active start":
          return `${pl} bg-(--background-background-accent) rounded-l-(--border-border-radius-rounded-base)`;
        case "Active between":
          return `${pl} bg-(--background-background-accent)`;
        case "Active end":
          return `${pl} bg-(--background-background-accent) rounded-r-(--border-border-radius-rounded-base)`;
        case "Today":
          return `${pl} datepicker-cell--gradient-black border border-solid rounded-(--border-border-radius-rounded-full)`;
        default:
          return `${pl} rounded-(--border-border-radius-rounded-base)`;
      }
    }), d = m(() => {
      switch (t.state) {
        case "Active":
        case "Active start":
        case "Active end":
          return `${Ul} font-(--weight-semi-bold) text-(--text-text-accent)`;
        case "Today":
          return `${Ul} font-(--weight-semi-bold) text-(--text-text-white-default)`;
        case "Disabled":
          return `${Ul} font-(--weight-medium) text-(--text-text-disabled-light)`;
        case "Hover":
        case "Active between":
          return `${Ul} font-(--weight-medium) text-(--text-text-black-default)`;
        default:
          return t.muted ? `${Ul} font-(--weight-medium) text-(--text-text-disabled-strong) dark:text-(--text-text-disabled-light)` : `${Ul} font-(--weight-medium) text-(--text-text-black-default) dark:text-(--colors-text-white-default)`;
      }
    });
    return (c, f) => (u(), b("button", {
      type: "button",
      "aria-disabled": l.value ? "true" : void 0,
      class: C([s.value, i.value, l.value ? "cursor-not-allowed" : "cursor-pointer"]),
      "data-state": e.state,
      "aria-current": e.state === "Today" ? "date" : void 0,
      "data-testid": "datepicker-cell",
      onClick: o
    }, [
      r.value ? (u(), b("span", {
        key: 0,
        class: C(Z5),
        "data-testid": "datepicker-cell-inner"
      }, [
        x("span", {
          class: C(d.value)
        }, H(e.text), 3)
      ])) : (u(), b("span", {
        key: 1,
        class: C(d.value)
      }, H(e.text), 3))
    ], 10, X5));
  }
}), sr = /* @__PURE__ */ Ct(Q5, [["__scopeId", "data-v-c4eaa4a3"]]);
function Nd(e, a) {
  const t = R(0);
  function n() {
    const s = e.value.findIndex((d) => d.value === a.value);
    t.value = s >= 0 ? s : Math.max(e.value.findIndex((d) => !d.disabled), 0);
  }
  n();
  function l(s) {
    const d = e.value[s];
    !d || d.disabled || (t.value = s, a.value = d.value);
  }
  function o(s) {
    if (s < 0 || s >= e.value.length) return;
    t.value = s;
    const d = e.value[s];
    d.disabled || (a.value = d.value);
  }
  function r(s) {
    o(t.value + s);
  }
  function i(s) {
    const d = e.value;
    o(s === "start" ? 0 : d.length - 1);
  }
  return { focusedIndex: t, selectIndex: l, moveFocus: r, moveToEdge: i, syncFocusToSelected: n };
}
const _5 = { class: "w-full text-center text-(length:--size-m) font-(--weight-semi-bold) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, e3 = { class: "flex w-full flex-wrap content-start items-start justify-between" }, t3 = ["aria-label"], a3 = ["aria-label"], n3 = ["aria-label"], l3 = 120, o3 = 10, r3 = 200, i3 = 200, s3 = /* @__PURE__ */ ke({
  __name: "DatepickerDobPicker",
  props: {
    open: { type: Boolean, default: !1 },
    modelValue: { default: void 0 },
    anchorEl: {},
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    defaultDate: { default: void 0 },
    id: { default: void 0 },
    autoFocusOnOpen: { type: Boolean, default: !0 },
    title: {},
    yearColumnLabel: {},
    monthColumnLabel: {},
    dayColumnLabel: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {}
  },
  emits: ["update:open", "update:modelValue", "clear", "close"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t;
    function o(j) {
      return String(j).padStart(2, "0");
    }
    function r(j, J, ne) {
      return `${j}-${o(J + 1)}-${o(ne)}`;
    }
    function i(j, J) {
      return new Date(j, J + 1, 0).getDate();
    }
    function s() {
      const j = n.modelValue || n.defaultDate, J = j ? /* @__PURE__ */ new Date(`${j}T00:00:00`) : /* @__PURE__ */ new Date();
      return { year: J.getFullYear(), month: J.getMonth(), day: J.getDate() };
    }
    const d = s(), c = R(d.year), f = R(d.month), g = R(d.day);
    function h(j) {
      const J = (/* @__PURE__ */ new Date()).getFullYear();
      return Math.min(Math.max(j, J - r3), J + i3);
    }
    const v = m(() => n.minDate ? h(Number(n.minDate.slice(0, 4))) : void 0), p = m(() => n.maxDate ? h(Number(n.maxDate.slice(0, 4))) : void 0), y = m(() => {
      const j = (/* @__PURE__ */ new Date()).getFullYear(), J = [j - l3, j + o3];
      return v.value !== void 0 && J.push(v.value), p.value !== void 0 && J.push(p.value), J.push(h(c.value)), {
        min: Math.min(...J),
        max: Math.max(...J)
      };
    });
    function k(j) {
      const { minDate: J, maxDate: ne } = n;
      return !!(J && j < J.slice(0, j.length) || ne && j > ne.slice(0, j.length));
    }
    const $ = m(() => {
      const { min: j, max: J } = y.value, ne = [];
      for (let Y = j; Y <= J; Y++) {
        const F = String(Y);
        k(F) || ne.push({ value: Y, label: F, disabled: !1 });
      }
      return ne;
    }), S = m(() => {
      const j = [];
      return n.monthShortLabels.forEach((J, ne) => {
        const Y = `${c.value}-${o(ne + 1)}`;
        k(Y) || j.push({ value: ne, label: J, disabled: !1 });
      }), j;
    }), I = m(() => {
      const j = i(c.value, f.value), J = [];
      for (let ne = 0; ne < j; ne++) {
        const Y = ne + 1, F = r(c.value, f.value, Y);
        k(F) || J.push({ value: Y, label: String(Y), disabled: !1 });
      }
      return J;
    }), T = Nd($, c), A = Nd(S, f), E = Nd(I, g);
    function z() {
      l("update:modelValue", r(c.value, f.value, g.value));
    }
    function B(j) {
      c.value = h(c.value), p.value !== void 0 && c.value > p.value && (c.value = p.value), v.value !== void 0 && c.value < v.value && (c.value = v.value);
      const J = i(c.value, f.value);
      if (g.value > J && (g.value = J), n.maxDate) {
        const [F, ee, ue] = n.maxDate.split("-").map(Number);
        c.value === F && f.value > ee - 1 && (f.value = ee - 1, g.value = Math.min(g.value, i(c.value, f.value))), c.value === F && f.value === ee - 1 && g.value > ue && (g.value = ue);
      }
      if (n.minDate) {
        const [F, ee, ue] = n.minDate.split("-").map(Number);
        c.value === F && f.value < ee - 1 && (f.value = ee - 1, g.value = Math.min(g.value, i(c.value, f.value))), c.value === F && f.value === ee - 1 && g.value < ue && (g.value = ue);
      }
      const ne = j ?? ve, Y = ["year", "month", "day"].filter((F) => F !== ne);
      Y.forEach((F) => te.value.add(F)), j !== void 0 && (ve = j), T.syncFocusToSelected(), A.syncFocusToSelected(), E.syncFocusToSelected(), Ze(() => {
        Y.forEach((F) => te.value.delete(F)), j !== void 0 && (ve = void 0);
      });
    }
    $e([c, f], () => B());
    function W(j) {
      T.selectIndex(j), B("year"), z();
    }
    function _(j) {
      A.selectIndex(j), B("month"), z();
    }
    function Z(j) {
      E.selectIndex(j), z();
    }
    const le = { year: T, month: A, day: E }, D = {
      year: c,
      month: f,
      day: g
    }, O = ["year", "month", "day"];
    function N(j, J) {
      const ne = O.indexOf(j) + J;
      if (ne < 0 || ne >= O.length) return;
      const Y = O[ne], F = G[Y].value, ee = F == null ? void 0 : F.querySelectorAll('[role="option"]')[le[Y].focusedIndex.value];
      ee == null || ee.focus({ preventScroll: !0 }), ee == null || ee.scrollIntoView({ block: "center", behavior: "smooth" });
    }
    function V() {
      l("update:open", !1), l("close");
    }
    function M(j, J) {
      if (j.key === "ArrowLeft" || j.key === "ArrowRight") {
        j.preventDefault(), N(J, j.key === "ArrowLeft" ? -1 : 1);
        return;
      }
      if (j.key === "Enter" || j.key === " ") {
        j.preventDefault(), V();
        return;
      }
      const ne = le[J], Y = D[J], F = Y.value;
      switch (j.key) {
        case "ArrowDown":
          j.preventDefault(), ne.moveFocus(1);
          break;
        case "ArrowUp":
          j.preventDefault(), ne.moveFocus(-1);
          break;
        case "Home":
          j.preventDefault(), ne.moveToEdge("start");
          break;
        case "End":
          j.preventDefault(), ne.moveToEdge("end");
          break;
        default:
          return;
      }
      Y.value !== F && (J !== "day" && B(J), z());
    }
    const Q = R(null), q = R(null), K = R(null), G = { year: Q, month: q, day: K }, te = R(/* @__PURE__ */ new Set());
    let ve;
    function Se(j) {
      const J = G[j].value, ne = J == null ? void 0 : J.querySelectorAll('[role="option"]')[le[j].focusedIndex.value];
      te.value.has(j) || ne == null || ne.focus({ preventScroll: !0 }), ne == null || ne.scrollIntoView({ block: "center", behavior: "smooth" });
    }
    $e(T.focusedIndex, () => Se("year"), { flush: "post" }), $e(A.focusedIndex, () => Se("month"), { flush: "post" }), $e(E.focusedIndex, () => Se("day"), { flush: "post" });
    function oe(j, J) {
      return j.value === J ? "Active" : "Initial";
    }
    function re() {
      l("clear");
    }
    async function ge() {
      const j = s();
      c.value = j.year, f.value = j.month, g.value = j.day, B(), te.value.add("year"), te.value.add("month"), te.value.add("day"), T.syncFocusToSelected(), A.syncFocusToSelected(), E.syncFocusToSelected(), await Ze(), te.value.delete("year"), te.value.delete("month"), te.value.delete("day");
      const J = ["year", "month", "day"].map(
        (ne) => {
          var Y;
          return (Y = G[ne].value) == null ? void 0 : Y.querySelectorAll('[role="option"]')[le[ne].focusedIndex.value];
        }
      );
      return J.forEach((ne) => ne == null ? void 0 : ne.scrollIntoView({ block: "center" })), J[0];
    }
    async function de() {
      const j = await ge();
      j == null || j.focus({ preventScroll: !0 });
    }
    $e(
      () => n.open,
      (j) => {
        j && (n.autoFocusOnOpen ? de() : ge());
      },
      // DatePickerInput's openDobPicker() sets
      // dobMounted/isDobOpen true in the SAME synchronous call, so this component can mount with
      // `open` ALREADY true on first open — without `immediate`, this watcher would never fire for
      // that case (a plain watch only fires on a subsequent CHANGE), and the explicit year-column
      // focus above would never run on the very first open at all.
      { immediate: !0 }
    );
    function Ee() {
      de();
    }
    return a({ focusYearColumn: Ee }), $e(
      () => n.modelValue,
      (j) => {
        if (!n.open || j === r(c.value, f.value, g.value)) return;
        const J = s();
        c.value = J.year, f.value = J.month, g.value = J.day, B();
      }
    ), (j, J) => (u(), P(vx, {
      id: e.id,
      open: e.open,
      "anchor-el": e.anchorEl,
      "keep-anchor-focusable": "",
      "dialog-label": e.title,
      "test-id": "datepicker-dob-picker",
      "width-class": "w-[224px]",
      "onUpdate:open": J[3] || (J[3] = (ne) => l("update:open", ne)),
      onClose: J[4] || (J[4] = (ne) => l("close"))
    }, {
      actions: me(() => [
        U(Be, {
          variant: "secondary",
          size: "sm",
          class: "flex-1",
          "full-width": "",
          label: e.clearLabel,
          "data-testid": "datepicker-dob-picker-clear",
          onClick: re
        }, null, 8, ["label"])
      ]),
      default: me(() => [
        x("p", _5, H(e.title), 1),
        x("div", e3, [
          x("div", {
            ref_key: "yearListRef",
            ref: Q,
            role: "listbox",
            "aria-label": e.yearColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: J[0] || (J[0] = (ne) => M(ne, "year"))
          }, [
            (u(!0), b(ie, null, Oe($.value, (ne, Y) => (u(), P(sr, {
              key: ne.value,
              type: "Wheel",
              state: oe(ne, c.value),
              text: ne.label,
              role: "option",
              class: "snap-center",
              "aria-selected": ne.value === c.value ? "true" : void 0,
              tabindex: Y === L(T).focusedIndex.value ? 0 : -1,
              "aria-label": ne.label,
              onClick: (F) => W(Y)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, t3),
          x("div", {
            ref_key: "monthListRef",
            ref: q,
            role: "listbox",
            "aria-label": e.monthColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: J[1] || (J[1] = (ne) => M(ne, "month"))
          }, [
            (u(!0), b(ie, null, Oe(S.value, (ne, Y) => (u(), P(sr, {
              key: ne.value,
              type: "Wheel",
              state: oe(ne, f.value),
              text: ne.label,
              role: "option",
              class: "snap-center",
              "aria-selected": ne.value === f.value ? "true" : void 0,
              tabindex: Y === L(A).focusedIndex.value ? 0 : -1,
              "aria-label": e.monthLabels[ne.value],
              onClick: (F) => _(Y)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, a3),
          x("div", {
            ref_key: "dayListRef",
            ref: K,
            role: "listbox",
            "aria-label": e.dayColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: J[2] || (J[2] = (ne) => M(ne, "day"))
          }, [
            (u(!0), b(ie, null, Oe(I.value, (ne, Y) => (u(), P(sr, {
              key: ne.value,
              type: "Wheel",
              state: oe(ne, g.value),
              text: ne.label,
              role: "option",
              class: "snap-center",
              "aria-selected": ne.value === g.value ? "true" : void 0,
              tabindex: Y === L(E).focusedIndex.value ? 0 : -1,
              "aria-label": ne.label,
              onClick: (F) => Z(Y)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, n3)
        ])
      ]),
      _: 1
    }, 8, ["id", "open", "anchor-el", "dialog-label"]));
  }
}), d3 = /* @__PURE__ */ Ct(s3, [["__scopeId", "data-v-f30f2f82"]]), u3 = { class: "flex w-full items-center justify-between" }, c3 = ["disabled"], f3 = /* @__PURE__ */ ke({
  __name: "DatepickerControls",
  props: {
    label: {},
    previousLabel: {},
    nextLabel: {},
    labelDisabled: { type: Boolean, default: !1 },
    previousDisabled: { type: Boolean, default: !1 },
    nextDisabled: { type: Boolean, default: !1 }
  },
  emits: ["prev", "next", "drill-up"],
  setup(e, { emit: a }) {
    const t = a;
    return (n, l) => (u(), b("div", u3, [
      U(Be, {
        variant: "ghost",
        size: "xs",
        "icon-only": "",
        "icon-left": "ri-arrow-left-line",
        "aria-label": e.previousLabel,
        disabled: e.previousDisabled,
        "data-testid": "datepicker-controls-prev",
        onClick: l[0] || (l[0] = (o) => t("prev"))
      }, null, 8, ["aria-label", "disabled"]),
      x("button", {
        type: "button",
        "aria-live": "polite",
        disabled: e.labelDisabled,
        class: "font-(--weight-semi-bold) text-(length:--size-m) leading-(--line-height-l) text-(--text-text-heading) dark:text-(--colors-text-white-default) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1 rounded-(--border-border-radius-rounded-sm) cursor-pointer disabled:cursor-not-allowed disabled:opacity-60",
        "data-testid": "datepicker-controls-label",
        onClick: l[1] || (l[1] = (o) => t("drill-up"))
      }, H(e.label), 9, c3),
      U(Be, {
        variant: "ghost",
        size: "xs",
        "icon-only": "",
        "icon-right": "ri-arrow-right-line",
        "aria-label": e.nextLabel,
        disabled: e.nextDisabled,
        "data-testid": "datepicker-controls-next",
        onClick: l[2] || (l[2] = (o) => t("next"))
      }, null, 8, ["aria-label", "disabled"])
    ]));
  }
});
function Gu(e) {
  return String(e).padStart(2, "0");
}
function qb(e, a, t) {
  const n = e * 12 + a + t;
  return { year: Math.floor(n / 12), month: (n % 12 + 12) % 12 };
}
function pf(e, a, t) {
  return `${e}-${Gu(a + 1)}-${Gu(t)}`;
}
function Ku(e, a) {
  return `${e}-${Gu(a + 1)}`;
}
function Ga(e, a) {
  return e < a ? -1 : e > a ? 1 : 0;
}
function Si() {
  const e = /* @__PURE__ */ new Date();
  return pf(e.getFullYear(), e.getMonth(), e.getDate());
}
function xf(e, a, t) {
  const { selectedIso: n, selectedEndIso: l, todayIso: o, minIso: r, maxIso: i } = a, s = o.substring(0, e.length), d = n !== void 0 ? n.substring(0, e.length) : void 0, c = l !== void 0 ? l.substring(0, e.length) : void 0;
  if (r !== void 0 && Ga(e, r) < 0 || i !== void 0 && Ga(e, i) > 0) return "Disabled";
  if (d !== void 0 && c !== void 0) {
    if (e === d) return "Active start";
    if (e === c) return "Active end";
    if (Ga(e, d) > 0 && Ga(e, c) < 0) return "Active between";
  } else {
    if (d !== void 0 && e === d)
      return "Active";
    if (c !== void 0 && e === c)
      return "Active";
  }
  return e === s ? "Today" : t;
}
function h3(e, a, t) {
  const l = (new Date(e, a, 1).getDay() + 6) % 7, o = new Date(e, a, 1 - l), r = [];
  for (let i = 0; i < 42; i++) {
    const s = new Date(o);
    s.setDate(o.getDate() + i);
    const d = pf(s.getFullYear(), s.getMonth(), s.getDate()), c = s.getMonth() === a && s.getFullYear() === e, f = xf(d, t, "Initial");
    r.push({ iso: d, label: String(s.getDate()), state: f, inMonth: c });
  }
  return r;
}
function b3(e, a, t) {
  return a.map((n, l) => {
    const o = Ku(e, l);
    return { iso: o, label: n, state: xf(o, t, "Initial"), inMonth: !0 };
  });
}
function g3(e, a) {
  return Array.from({ length: 12 }, (t, n) => {
    const l = e + n, o = String(l);
    return { iso: o, label: o, state: xf(o, a, "Initial"), inMonth: !0 };
  });
}
const m3 = {
  key: 0,
  class: "flex w-[252px] flex-col"
}, v3 = {
  role: "row",
  "data-testid": "datepicker-weekday-header-row",
  class: "mb-1.5 flex items-center"
}, yf = /* @__PURE__ */ ke({
  __name: "DatepickerDropdownMenu",
  props: {
    open: { type: Boolean, default: !1 },
    modelValue: { default: void 0 },
    startDate: { default: void 0 },
    endDate: { default: void 0 },
    seedField: { default: "start" },
    anchorEl: {},
    additionalAnchorEls: { default: () => [] },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    todayButtonMode: { default: "highlight" },
    mode: { default: "day" },
    showTodayButton: { type: Boolean, default: !0 },
    showClearButton: { type: Boolean, default: !0 },
    weekdayLabels: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {},
    todayLabel: {},
    previousLabel: {},
    nextLabel: {},
    unavailableLabel: {},
    rangeStartLabel: { default: "start of selected range" },
    rangeEndLabel: { default: "end of selected range" },
    rangeBetweenLabel: { default: "in selected range" },
    dialogLabel: {},
    id: { default: void 0 },
    placement: { default: "bottom-start" },
    keepAnchorFocusable: { type: Boolean, default: !1 },
    autoFocusOnOpen: { type: Boolean, default: !0 }
  },
  emits: ["update:open", "update:modelValue", "select", "range-select", "clear", "close"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = m(() => n.startDate !== void 0 || n.endDate !== void 0), r = R(/* @__PURE__ */ new Date()), i = m(() => {
      const Y = r.value;
      return `${Y.getFullYear()}-${String(Y.getMonth() + 1).padStart(2, "0")}-${String(Y.getDate()).padStart(2, "0")}`;
    });
    function s(Y) {
      const F = Y ?? n.seedField, ee = F === "end" ? n.endDate : n.startDate, ue = F === "end" ? n.startDate : n.endDate, se = o.value ? ee || ue : n.modelValue;
      if (se) {
        const [X, ae, Re] = se.split("-").map(Number);
        return { year: X, month: ae - 1, day: Re };
      }
      return { year: r.value.getFullYear(), month: r.value.getMonth(), day: r.value.getDate() };
    }
    const d = s(), c = R(d.year), f = R(d.month), g = R(d.day), h = R(n.mode), v = R(r.value.getFullYear() - r.value.getFullYear() % 12), p = m(
      () => h3(c.value, f.value, {
        todayIso: i.value,
        // "" (not yet picked) is normalized to undefined here — cellState's own selectedEndIso
        // contract treats any DEFINED value, empty string included, as a real endpoint, which would
        // otherwise render the lone startDate cell "Active start" instead of plain "Active" before an
        // end date is chosen.
        selectedIso: o.value ? n.startDate || void 0 : n.modelValue,
        selectedEndIso: o.value && n.endDate || void 0,
        minIso: n.minDate,
        maxIso: n.maxDate
      })
    ), y = m(
      () => {
        var Y, F;
        return b3(c.value, n.monthShortLabels, {
          todayIso: i.value,
          selectedIso: o.value ? n.startDate || void 0 : n.modelValue,
          selectedEndIso: o.value && n.endDate || void 0,
          minIso: (Y = n.minDate) == null ? void 0 : Y.slice(0, 7),
          maxIso: (F = n.maxDate) == null ? void 0 : F.slice(0, 7)
        });
      }
    ), k = m(
      () => {
        var Y, F;
        return g3(v.value, {
          todayIso: i.value,
          selectedIso: o.value ? n.startDate || void 0 : n.modelValue,
          selectedEndIso: o.value && n.endDate || void 0,
          minIso: (Y = n.minDate) == null ? void 0 : Y.slice(0, 4),
          maxIso: (F = n.maxDate) == null ? void 0 : F.slice(0, 4)
        });
      }
    ), $ = m(() => h.value === "month" ? y.value : h.value === "year" ? k.value : p.value), S = m(() => {
      const Y = [];
      for (let F = 0; F < 6; F++)
        Y.push(
          p.value.slice(F * 7, F * 7 + 7).map((ee, ue) => ({ cell: ee, index: F * 7 + ue }))
        );
      return Y;
    }), I = m(() => h.value === "day" ? 7 : h.value === "month" ? 3 : 4), T = m(() => {
      const Y = I.value, F = $.value, ee = [];
      for (let ue = 0; ue < F.length; ue += Y)
        ee.push(F.slice(ue, ue + Y).map((se, X) => ({ cell: se, index: ue + X })));
      return ee;
    }), A = R(null);
    function E(Y) {
      return Y.state === "Initial" && A.value === Y.iso ? "Hover" : Y.state;
    }
    const z = /* @__PURE__ */ new Set([
      "Active",
      "Active start",
      "Active between",
      "Active end"
    ]);
    function B(Y) {
      const [F, ee] = Y.iso.split("-").map(Number), ue = `${n.monthLabels[ee - 1]} ${Y.label}, ${F}`;
      return Y.state === "Disabled" ? `${ue}, ${n.unavailableLabel}` : Y.state === "Active start" ? `${ue}, ${n.rangeStartLabel}` : Y.state === "Active end" ? `${ue}, ${n.rangeEndLabel}` : Y.state === "Active between" ? `${ue}, ${n.rangeBetweenLabel}` : ue;
    }
    function W(Y) {
      const F = Number(Y.iso.split("-")[1]), ee = n.monthLabels[F - 1];
      return Y.state === "Disabled" ? `${ee}, ${n.unavailableLabel}` : ee;
    }
    const _ = m(() => h.value === "month" ? String(c.value) : h.value === "year" ? `${v.value}-${v.value + 11}` : `${n.monthLabels[f.value]} ${c.value}`), Z = m(() => n.mode !== "day" || h.value === "year"), le = m(() => {
      var F;
      if (h.value === "day") {
        if (n.minDate === void 0) return !1;
        const ee = (F = p.value[0]) == null ? void 0 : F.iso;
        return ee !== void 0 && Ga(ee, n.minDate) <= 0;
      }
      if (n.minDate === void 0) return !1;
      const Y = Number(n.minDate.slice(0, 4));
      return h.value === "month" ? c.value <= Y : v.value <= Y;
    }), D = m(() => {
      var F;
      if (h.value === "day") {
        if (n.maxDate === void 0) return !1;
        const ee = (F = p.value[41]) == null ? void 0 : F.iso;
        return ee !== void 0 && Ga(ee, n.maxDate) >= 0;
      }
      if (n.maxDate === void 0) return !1;
      const Y = Number(n.maxDate.slice(0, 4));
      return h.value === "month" ? c.value >= Y : v.value + 11 >= Y;
    }), O = m(() => {
      var se, X;
      const Y = n.mode === "month" ? 7 : n.mode === "year" ? 4 : 10, F = i.value.slice(0, Y), ee = (se = n.minDate) == null ? void 0 : se.slice(0, Y), ue = (X = n.maxDate) == null ? void 0 : X.slice(0, Y);
      return ee !== void 0 && Ga(F, ee) < 0 || ue !== void 0 && Ga(F, ue) > 0;
    });
    async function N() {
      await Ze(), de(Se.value);
    }
    function V() {
      var Y;
      return ((Y = document.activeElement) == null ? void 0 : Y.getAttribute("data-testid")) === "datepicker-cell";
    }
    async function M() {
      if (le.value) return;
      const Y = V();
      if (h.value === "day") {
        const { year: F, month: ee } = qb(c.value, f.value, -1);
        c.value = F, f.value = ee;
      } else h.value === "month" ? c.value -= 1 : v.value -= 12;
      Y && await N();
    }
    async function Q() {
      if (D.value) return;
      const Y = V();
      if (h.value === "day") {
        const { year: F, month: ee } = qb(c.value, f.value, 1);
        c.value = F, f.value = ee;
      } else h.value === "month" ? c.value += 1 : v.value += 12;
      Y && await N();
    }
    async function q() {
      const Y = V();
      if (h.value === "day")
        h.value = "month";
      else if (h.value === "month")
        v.value = c.value - c.value % 12, h.value = "year";
      else
        return;
      Y && await N();
    }
    function K() {
      l("clear");
    }
    async function G() {
      if (!O.value) {
        if (n.mode === "month") {
          if (c.value = r.value.getFullYear(), n.todayButtonMode === "select") {
            te(Ku(r.value.getFullYear(), r.value.getMonth()));
            return;
          }
          await Ze(), de(y.value.findIndex((Y) => Y.iso === i.value.slice(0, 7)));
          return;
        }
        if (n.mode === "year") {
          if (v.value = r.value.getFullYear() - r.value.getFullYear() % 12, n.todayButtonMode === "select") {
            te(String(r.value.getFullYear()));
            return;
          }
          await Ze(), de(k.value.findIndex((Y) => Y.iso === i.value.slice(0, 4)));
          return;
        }
        if (h.value = "day", c.value = r.value.getFullYear(), f.value = r.value.getMonth(), n.todayButtonMode === "select") {
          if (o.value) {
            l("range-select", i.value);
            return;
          }
          l("update:modelValue", i.value), l("select", i.value), j();
          return;
        }
        await Ze(), de(p.value.findIndex((Y) => Y.iso === i.value));
      }
    }
    function te(Y) {
      l("update:modelValue", Y), l("select", Y), j();
    }
    async function ve(Y) {
      if (Y.state !== "Disabled") {
        if (h.value === "year") {
          if (n.mode === "year") {
            te(Y.iso);
            return;
          }
          c.value = Number(Y.iso), h.value = "month", await N();
          return;
        }
        if (h.value === "month") {
          if (n.mode === "month") {
            te(Y.iso);
            return;
          }
          f.value = Number(Y.iso.slice(5)) - 1, h.value = "day", await N();
          return;
        }
        if (o.value) {
          l("range-select", Y.iso);
          return;
        }
        te(Y.iso);
      }
    }
    const Se = R(0);
    function oe() {
      const Y = $.value;
      let F;
      if (h.value === "day") {
        const ue = new Date(c.value, f.value + 1, 0).getDate();
        F = pf(c.value, f.value, Math.min(g.value, ue));
      } else h.value === "month" ? F = Ku(c.value, f.value) : F = String(c.value);
      const ee = Y.findIndex((ue) => ue.iso === F);
      Se.value = ee >= 0 ? ee : Math.max(Y.findIndex((ue) => ue.state !== "Disabled"), 0);
    }
    oe(), $e([c, f, h, v], oe);
    const re = R(null), ge = R(null);
    function de(Y) {
      var F, ee;
      if (Se.value = Y, h.value === "day") {
        const ue = p.value[Y];
        ue && (g.value = Number(ue.iso.slice(8, 10)));
      }
      (ee = (F = re.value) == null ? void 0 : F.querySelectorAll('[data-testid="datepicker-cell"]')[Y]) == null || ee.focus({ preventScroll: !0 });
    }
    function Ee(Y) {
      const F = $.value, ee = F.length, ue = Se.value, se = I.value, X = ue - ue % se;
      switch (Y.key) {
        case "ArrowRight":
          Y.preventDefault(), ue < ee - 1 && de(ue + 1);
          break;
        case "ArrowLeft":
          Y.preventDefault(), ue > 0 && de(ue - 1);
          break;
        case "ArrowDown":
          Y.preventDefault(), ue + se < ee && de(ue + se);
          break;
        case "ArrowUp":
          Y.preventDefault(), ue - se >= 0 && de(ue - se);
          break;
        case "Home":
          Y.preventDefault(), de(X);
          break;
        case "End":
          Y.preventDefault(), de(Math.min(X + se - 1, ee - 1));
          break;
        case "PageUp":
          h.value === "day" && (Y.preventDefault(), M());
          break;
        case "PageDown":
          h.value === "day" && (Y.preventDefault(), Q());
          break;
        case "Enter":
        case " ":
          Y.preventDefault(), ve(F[ue]);
          break;
      }
    }
    function j() {
      l("update:open", !1), l("close");
    }
    function J(Y) {
      r.value = /* @__PURE__ */ new Date(), h.value = n.mode;
      const F = s(Y);
      c.value = F.year, f.value = F.month, g.value = F.day, v.value = F.year - F.year % 12, oe();
    }
    $e(
      () => n.open,
      (Y) => {
        Y ? (J(), n.autoFocusOnOpen && Ze(() => de(Se.value))) : A.value = null;
      },
      { immediate: !0 }
    ), $e(h, async () => {
      var Y;
      await Ze(), (Y = ge.value) == null || Y.updatePosition();
    });
    async function ne(Y) {
      J(Y), await Ze(), de(Se.value);
    }
    return a({ focusGrid: ne, reseedVisibleGrid: J }), (Y, F) => (u(), P(vx, {
      id: e.id,
      ref_key: "panelComponent",
      ref: ge,
      open: e.open,
      "anchor-el": e.anchorEl,
      "additional-anchor-els": e.additionalAnchorEls,
      "dialog-label": e.dialogLabel,
      "test-id": "datepicker-dropdown-menu",
      "width-class": "w-[292px]",
      placement: e.placement,
      "keep-anchor-focusable": e.keepAnchorFocusable,
      "onUpdate:open": F[2] || (F[2] = (ee) => l("update:open", ee)),
      onClose: F[3] || (F[3] = (ee) => l("close"))
    }, Xa({
      default: me(() => [
        x("div", {
          ref_key: "contentRef",
          ref: re,
          class: "contents"
        }, [
          U(f3, {
            label: _.value,
            "previous-label": e.previousLabel,
            "next-label": e.nextLabel,
            "label-disabled": Z.value,
            "previous-disabled": le.value,
            "next-disabled": D.value,
            onPrev: M,
            onNext: Q,
            onDrillUp: q
          }, null, 8, ["label", "previous-label", "next-label", "label-disabled", "previous-disabled", "next-disabled"]),
          h.value === "day" ? (u(), b("div", m3, [
            x("div", {
              role: "grid",
              class: "flex flex-col gap-0.5",
              onKeydown: Ee
            }, [
              x("div", v3, [
                (u(!0), b(ie, null, Oe(e.weekdayLabels, (ee, ue) => (u(), b("span", {
                  key: ue,
                  role: "columnheader",
                  "data-testid": "datepicker-weekday-header",
                  class: "w-9 flex-1 text-center text-(length:--size-sm) font-(--weight-medium) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
                }, H(ee), 1))), 128))
              ]),
              (u(!0), b(ie, null, Oe(S.value, (ee, ue) => (u(), b("div", {
                key: ue,
                role: "row",
                "data-testid": "datepicker-day-row",
                class: "flex items-center"
              }, [
                (u(!0), b(ie, null, Oe(ee, ({ cell: se, index: X }) => (u(), P(sr, {
                  key: se.iso,
                  type: "Day",
                  state: E(se),
                  text: se.label,
                  muted: !se.inMonth,
                  role: "gridcell",
                  tabindex: X === Se.value ? 0 : -1,
                  "aria-selected": L(z).has(se.state) ? "true" : void 0,
                  "aria-label": B(se),
                  onClick: (ae) => ve(se),
                  onMouseover: (ae) => A.value = se.iso,
                  onMouseout: F[0] || (F[0] = (ae) => A.value = null)
                }, null, 8, ["state", "text", "muted", "tabindex", "aria-selected", "aria-label", "onClick", "onMouseover"]))), 128))
              ]))), 128))
            ], 32)
          ])) : (u(), b("div", {
            key: 1,
            role: "grid",
            class: "flex w-[252px] flex-col gap-1.5",
            onKeydown: Ee
          }, [
            (u(!0), b(ie, null, Oe(T.value, (ee, ue) => (u(), b("div", {
              key: ue,
              role: "row",
              "data-testid": "datepicker-grid-row",
              class: "flex gap-1.5"
            }, [
              (u(!0), b(ie, null, Oe(ee, ({ cell: se, index: X }) => (u(), P(sr, {
                key: se.iso,
                type: h.value === "month" ? "Month" : "Year",
                state: E(se),
                text: se.label,
                role: "gridcell",
                tabindex: X === Se.value ? 0 : -1,
                "aria-selected": L(z).has(se.state) ? "true" : void 0,
                "aria-label": h.value === "month" ? W(se) : se.state === "Disabled" ? `${se.label}, ${e.unavailableLabel}` : se.label,
                onClick: (ae) => ve(se),
                onMouseover: (ae) => A.value = se.iso,
                onMouseout: F[1] || (F[1] = (ae) => A.value = null)
              }, null, 8, ["type", "state", "text", "tabindex", "aria-selected", "aria-label", "onClick", "onMouseover"]))), 128))
            ]))), 128))
          ], 32))
        ], 512)
      ]),
      _: 2
    }, [
      e.showClearButton || e.showTodayButton ? {
        name: "actions",
        fn: me(() => [
          e.showClearButton ? (u(), P(Be, {
            key: 0,
            variant: "secondary",
            size: "sm",
            class: "flex-1",
            "full-width": "",
            label: e.clearLabel,
            "data-testid": "datepicker-dropdown-menu-clear",
            onClick: K
          }, null, 8, ["label"])) : w("", !0),
          e.showTodayButton ? (u(), P(Be, {
            key: 1,
            variant: "primary",
            size: "sm",
            class: "flex-1",
            "full-width": "",
            label: e.todayLabel,
            disabled: O.value,
            "data-testid": "datepicker-dropdown-menu-today",
            onClick: G
          }, null, 8, ["label", "disabled"])) : w("", !0)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["id", "open", "anchor-el", "additional-anchor-els", "dialog-label", "placement", "keep-anchor-focusable"]));
  }
}), p3 = {
  en: "mm/yyyy",
  fr: "mm/yyyy",
  nl: "mm-yyyy"
};
function x3(e) {
  return e ?? "";
}
function y3(e) {
  return /^\d{4}$/.test(e) ? e : void 0;
}
function px(e) {
  return e.replace(/[my]/g, "");
}
function k3(e, a) {
  if (!e) return "";
  const [t, n] = e.split("-");
  return `${n}${px(a)}${t}`;
}
function w3(e, a) {
  const t = px(a), [n, l] = e.split(t);
  if (!n || !l || !/^\d{2}$/.test(n) || !/^\d{4}$/.test(l)) return;
  const o = Number(n);
  if (!(o < 1 || o > 12))
    return `${l}-${n}`;
}
function Da(e, a) {
  if (!e) return "";
  const [t, n, l] = e.split("-");
  return !t || !n || !l ? "" : a.replace(/y+/, t).replace(/m+/, n).replace(/d+/, l);
}
function C3(e) {
  const a = e.match(/([dmy])\1*|[^dmy]+/g) ?? [], t = [];
  let n = "^";
  for (const o of a)
    /^[dmy]+$/.test(o) ? (t.push({ field: o[0], length: o.length }), n += o.length > 1 ? `(\\d{${o.length}})` : "(\\d{1,2})") : n += o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  n += "$";
  const l = t.map((o) => o.field);
  if (l.filter((o) => o === "d").length === 1 && l.filter((o) => o === "m").length === 1 && l.filter((o) => o === "y").length === 1)
    return { tokens: t, regex: new RegExp(n) };
}
function oa(e, a) {
  const t = C3(a);
  if (!t) return;
  const n = t.regex.exec(e);
  if (!n) return;
  let l, o, r;
  if (t.tokens.forEach((s, d) => {
    const c = Number(n[d + 1]);
    s.field === "d" ? l = c : s.field === "m" ? o = c : r = c;
  }), l === void 0 || o === void 0 || r === void 0 || o < 1 || o > 12) return;
  const i = new Date(r, o, 0).getDate();
  if (!(l < 1 || l > i))
    return `${String(r).padStart(4, "0")}-${String(o).padStart(2, "0")}-${String(l).padStart(2, "0")}`;
}
function Yu(e) {
  const { inputRef: a, format: t, maskEnabled: n, disabled: l, readonly: o, onAccept: r, resolveRevertValue: i, resolveResyncValue: s } = e;
  let d = null, c = null, f = 0, g = !1;
  const h = R(!1), v = R(!1), p = R(!1), y = R(e.initialDisplayValue), k = m(() => n.value ? fx(t.value) : null), $ = () => {
    if (!c || !a.value || k.value === null) return;
    S();
    const D = y.value || a.value.value;
    d = c(a.value, { mask: k.value, lazy: !0 }), d.value = D ?? "", p.value = !0, d.on("accept", () => {
      if (!d) return;
      const O = g;
      if (g = !1, o.value || l.value) {
        const V = i();
        d.value = V, y.value = V;
        return;
      }
      const N = d.value;
      y.value = N, !O && r(N);
    });
  }, S = () => {
    d == null || d.destroy(), d = null, p.value = !1;
  };
  kt(async () => {
    if (a.value && k.value !== null) {
      const D = ++f;
      if (c = (await import("./index-CZ98n4Cf.js")).default, !a.value || D !== f) return;
      $();
    }
  }), zt(() => {
    S();
  }), $e(k, async (D) => {
    const O = ++f;
    S(), D !== null && (c || (c = (await import("./index-CZ98n4Cf.js")).default), O === f && $());
  });
  const I = () => {
    l.value || (v.value = !0);
  }, T = () => {
    v.value = !1;
  }, A = () => {
    l.value || (h.value = !0);
  }, E = (D) => {
    y.value = D, d && (g = !0, d.value = D, g = !1);
  }, z = () => {
    h.value = !1, E(s());
  }, B = (D) => {
    if (d) return;
    const O = D.target.value;
    y.value = O, r(O);
  }, W = (D) => {
    d ? d.value = D : (y.value = D, r(D));
  };
  let _ = !1;
  return {
    displayValue: y,
    isFocused: h,
    isHovered: v,
    datePattern: k,
    isMaskAttached: p,
    handleMouseEnter: I,
    handleMouseLeave: T,
    handleFocus: A,
    handleBlur: z,
    handleInput: B,
    setValue: W,
    syncDisplayValue: E,
    armMouseDown: (D) => {
      _ = D;
    },
    consumeClick: () => {
      const D = _;
      return _ = !1, D;
    }
  };
}
const xx = {
  weekdayLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  monthLabels: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  monthShortLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  clearLabel: "Clear",
  todayLabel: "Today",
  previousLabel: "Previous month",
  nextLabel: "Next month",
  unavailableLabel: "Unavailable",
  dialogLabel: "Choose date",
  rangeStartLabel: "start of selected range",
  rangeEndLabel: "end of selected range",
  rangeBetweenLabel: "in selected range",
  rangeDialogLabel: "Choose date range",
  clearStartLabel: "Clear start date",
  clearEndLabel: "Clear end date"
}, yx = {
  fr: {
    weekdayLabels: ["lun.", "mar.", "mer.", "jeu.", "ven.", "sam.", "dim."],
    monthLabels: [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre"
    ],
    monthShortLabels: [
      "janv.",
      "févr.",
      "mars",
      "avril",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc."
    ],
    clearLabel: "Effacer",
    todayLabel: "Aujourd'hui",
    previousLabel: "Mois précédent",
    nextLabel: "Mois suivant",
    unavailableLabel: "Indisponible",
    dialogLabel: "Choisir une date",
    rangeStartLabel: "début de la période sélectionnée",
    rangeEndLabel: "fin de la période sélectionnée",
    rangeBetweenLabel: "dans la période sélectionnée",
    rangeDialogLabel: "Choisir une période",
    clearStartLabel: "Effacer la date de début",
    clearEndLabel: "Effacer la date de fin"
  },
  nl: {
    weekdayLabels: ["ma", "di", "wo", "do", "vr", "za", "zo"],
    monthLabels: [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ],
    monthShortLabels: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
    clearLabel: "Wissen",
    todayLabel: "Vandaag",
    previousLabel: "Vorige maand",
    nextLabel: "Volgende maand",
    unavailableLabel: "Niet beschikbaar",
    dialogLabel: "Kies een datum",
    rangeStartLabel: "begin van de geselecteerde periode",
    rangeEndLabel: "einde van de geselecteerde periode",
    rangeBetweenLabel: "in de geselecteerde periode",
    rangeDialogLabel: "Kies een periode",
    clearStartLabel: "Startdatum wissen",
    clearEndLabel: "Einddatum wissen"
  }
}, S3 = ["id", "name", "inputmode", "value", "placeholder", "disabled", "readonly", "autocomplete", "aria-labelledby", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required", "aria-expanded", "aria-controls", "data-testid"], Ju = /* @__PURE__ */ ke({
  __name: "DatePickerInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    placeholder: { default: void 0 },
    format: { default: void 0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    autohide: { type: Boolean, default: !0 },
    buttons: { type: Boolean, default: !0 },
    orientation: { default: "auto" },
    weekStart: { default: 1 },
    language: { default: "en" },
    title: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    hint: { default: void 0 },
    showHint: { type: Boolean, default: !0 },
    labelInline: { type: Boolean, default: !1 },
    id: { default: void 0 },
    name: { default: void 0 },
    autocomplete: { default: void 0 },
    testId: { default: void 0 },
    maskInput: { type: Boolean, default: !0 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "default" },
    dobLabels: { default: void 0 },
    dobDefaultDate: { default: void 0 },
    labels: { default: void 0 }
  },
  emits: ["update:modelValue", "changeDate", "show", "hide"],
  setup(e, { emit: a }) {
    var xe;
    const t = e, n = a, l = R(null), o = R(null), r = R(null), i = m(() => t.modelValue !== void 0 && t.modelValue !== null && t.modelValue.trim() !== ""), s = m(() => !!t.error), d = Ye(), c = m(() => t.id || d), f = m(() => t.label ? `${c.value}-label` : void 0), g = m(() => `${c.value}-error`), h = m(() => `${c.value}-hint`), v = m(() => t.language.slice(0, 2).toLowerCase()), p = {
      en: "mm/dd/yyyy",
      fr: "dd/mm/yyyy",
      nl: "dd-mm-yyyy"
    }, y = m(() => t.format !== void 0 ? t.format : p[v.value] ?? "dd/mm/yyyy"), k = m(
      () => t.labels ?? yx[v.value] ?? xx
    ), $ = m(
      () => t.minDate ? oa(t.minDate, y.value) ?? t.minDate : void 0
    ), S = m(
      () => t.maxDate ? oa(t.maxDate, y.value) ?? t.maxDate : void 0
    ), I = {
      fr: { d: "j", y: "a" },
      // jour / année
      nl: { y: "j" }
      // jaar
    }, T = m(() => {
      const we = I[v.value];
      return we ? y.value.replace(/d+|m+|y+/g, (fe) => {
        const Ne = we[fe[0]];
        return Ne ? Ne.repeat(fe.length) : fe;
      }) : y.value;
    }), A = m(() => {
      var fe;
      const we = (fe = t.hint) == null ? void 0 : fe.trim();
      return we && we.length > 0 ? we : s.value ? void 0 : T.value;
    }), E = m(() => {
      var fe;
      const we = (fe = t.placeholder) == null ? void 0 : fe.trim();
      return we && we.length > 0 ? we : T.value;
    }), z = m(() => {
      const we = [];
      return t.showHint && A.value && we.push(h.value), s.value && we.push(g.value), we.length > 0 ? we.join(" ") : void 0;
    }), B = m(() => s.value ? "true" : void 0), W = m(() => {
      const we = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      if (t.disabled)
        return `${we} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)`;
      if (t.readonly) {
        const De = M.isFocused.value ? "shadow-[0px_0px_2px_var(--border-border-accent)] border-(--border-border-accent)" : "shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${we} border-[1px] ${De} bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      }
      if (s.value)
        return `${we} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (M.isFocused.value)
        return `${we} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (M.isHovered.value)
        return `${we} border-[1px] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      const fe = i.value ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)";
      return `${we} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${fe} dark:text-(--text-text-white-default)`;
    }), Z = {
      sm: {
        container: "h-[32px] px-2 py-1.5 gap-2",
        text: "text-sm leading-5"
      },
      md: {
        container: "h-[36px] px-3 py-2 gap-2",
        text: "text-sm leading-5"
      },
      lg: {
        container: "h-[48px] px-3.5 py-3 gap-2",
        text: "text-base leading-6"
      },
      xl: {
        container: "h-[52px] px-4 py-3.5 gap-2",
        text: "text-base leading-6"
      }
    }[t.size], le = m(() => t.fullWidth ? "w-full" : ""), D = m(() => t.fullWidth ? {} : { width: t.width }), O = m(() => {
      const we = "relative flex pb-0.5 text-left text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter";
      return t.labelInline ? `${we} flex-row items-center gap-2${t.fullWidth ? " w-full" : ""}` : `${we} flex-col items-start gap-0.5${t.fullWidth ? " w-full" : ""}`;
    }), N = m(() => t.fullWidth || t.labelInline ? {} : { width: t.width });
    function V(we) {
      if (we === "") {
        t.modelValue && n("update:modelValue", "");
        return;
      }
      const fe = oa(we, y.value);
      fe !== void 0 && fe !== t.modelValue && n("update:modelValue", fe);
    }
    const M = Yu({
      inputRef: l,
      format: y,
      maskEnabled: m(() => t.maskInput),
      disabled: Ua(t, "disabled"),
      readonly: Ua(t, "readonly"),
      initialDisplayValue: t.type === "dob" ? Da(t.modelValue, y.value) : t.modelValue,
      onAccept: (we) => {
        if (t.type === "dob") {
          V(we);
          return;
        }
        (!M.isMaskAttached.value || we === "" || oa(we, y.value) !== void 0) && we !== t.modelValue && n("update:modelValue", we);
      },
      resolveRevertValue: () => t.type === "dob" ? Da(t.modelValue, y.value) : t.modelValue ?? "",
      resolveResyncValue: () => t.type === "dob" ? Da(t.modelValue, y.value) : t.modelValue
    });
    $e(
      () => t.modelValue,
      (we) => {
        if (M.isFocused.value) return;
        const fe = t.type === "dob" ? Da(we, y.value) : we;
        M.syncDisplayValue(fe);
      }
    ), $e([y, v], ([we], [fe]) => {
      if (t.type === "dob" && !M.isFocused.value && M.syncDisplayValue(Da(t.modelValue, we)), t.type === "default" && !M.isFocused.value && we !== fe) {
        const Ne = oa(M.displayValue.value, fe);
        Ne !== void 0 && M.syncDisplayValue(Da(Ne, we));
      }
    });
    const Q = R(!1), q = R(!1), K = m(() => `${c.value}-dob-dialog`), G = R(null), te = typeof process < "u" && ((xe = process.env) == null ? void 0 : xe.NODE_ENV) !== "production";
    function ve() {
      if (!(t.type !== "dob" || t.disabled || t.readonly) && !Q.value) {
        if (!t.dobLabels) {
          te && console.error(
            '[OPAL DatePickerInput] type="dob" requires the `dobLabels` prop (see DatepickerDobLabels) — the wheel picker was not opened.'
          );
          return;
        }
        Q.value = !0, q.value = !0, n("show");
      }
    }
    function Se(we) {
      M.setValue(Da(we, y.value)), n("changeDate", we);
    }
    function oe() {
      M.setValue(""), n("changeDate", "");
    }
    function re() {
      var we;
      Q.value = !1, n("hide"), (we = l.value) == null || we.focus();
    }
    const ge = R(!1), de = R(!1), Ee = m(() => `${c.value}-default-dialog`), j = R(null), J = R(!0), ne = m(
      () => oa(M.displayValue.value, y.value) ?? ""
    ), Y = m(() => {
      const we = t.orientation.includes("right") ? "end" : "start";
      return `${t.orientation.includes("top") ? "top" : "bottom"}-${we}`;
    });
    function F() {
      t.type !== "default" || t.disabled || t.readonly || ge.value || (ge.value = !0, de.value = !0, n("show"));
    }
    function ee(we) {
      const fe = Da(we, y.value);
      M.setValue(fe), n("changeDate", fe);
    }
    function ue() {
      M.setValue(""), n("changeDate", "");
    }
    function se() {
      var we;
      ge.value = !1, n("hide"), (we = l.value) == null || we.focus();
    }
    function X() {
      t.type === "dob" ? ve() : F();
    }
    function ae() {
      M.armMouseDown(t.type === "dob" ? Q.value : ge.value);
    }
    function Re() {
      var we;
      t.disabled || t.readonly || M.consumeClick() || (J.value = !1, X(), (we = l.value) == null || we.focus());
    }
    function Ae(we) {
      var fe, Ne, De, qe;
      if (!Q.value && !ge.value && ((fe = o.value) == null || fe.handleFieldKeydown(we), (Ne = r.value) == null || Ne.handleFieldKeydown(we)), !(t.disabled || t.readonly)) {
        if (we.key === "Enter") {
          Q.value ? re() : ge.value && se();
          const Qe = Si(), lt = ($.value === void 0 || Ga(Qe, $.value) >= 0) && (S.value === void 0 || Ga(Qe, S.value) <= 0);
          (M.displayValue.value ?? "").trim() === "" && lt && (t.type === "dob" ? Se(Qe) : ee(Qe));
          return;
        }
        if (we.key === "ArrowDown") {
          if (we.preventDefault(), Q.value) {
            (De = G.value) == null || De.focusYearColumn();
            return;
          }
          if (ge.value) {
            (qe = j.value) == null || qe.focusGrid();
            return;
          }
          J.value = !0, X();
        }
      }
    }
    return (we, fe) => (u(), b("div", {
      class: C(O.value),
      style: Ge(N.value),
      "data-testid": "date-picker-wrapper"
    }, [
      e.label ? (u(), P(Ft, {
        key: 0,
        id: f.value,
        ref_key: "labelRef",
        ref: o,
        text: e.label,
        "input-id": c.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: L(M).isFocused.value,
        inline: e.labelInline,
        class: C(e.labelInline ? "" : "order-1"),
        "test-id": "date-picker-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline", "class"])) : w("", !0),
      x("div", {
        class: C(e.labelInline ? "flex flex-col gap-0.5" : "contents")
      }, [
        U(Pt, {
          ref_key: "helperRef",
          ref: r,
          focused: L(M).isFocused.value,
          class: "order-3",
          hint: e.showHint ? A.value : void 0,
          error: e.error,
          "hint-id": h.value,
          "error-id": g.value,
          "error-live": e.errorLive,
          "test-id-prefix": "date-picker"
        }, null, 8, ["focused", "hint", "error", "hint-id", "error-id", "error-live"]),
        x("div", {
          class: C([W.value, L(Z).container, le.value, "order-2"]),
          style: Ge(D.value),
          "data-testid": "date-picker-container",
          onMouseenter: fe[3] || (fe[3] = //@ts-ignore
          (...Ne) => L(M).handleMouseEnter && L(M).handleMouseEnter(...Ne)),
          onMouseleave: fe[4] || (fe[4] = //@ts-ignore
          (...Ne) => L(M).handleMouseLeave && L(M).handleMouseLeave(...Ne)),
          onMousedown: ae,
          onClick: Re
        }, [
          x("i", {
            "aria-hidden": "true",
            "data-testid": "date-picker-calendar-icon",
            class: C([
              "ri-calendar-line",
              L(Z).text,
              e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
            ])
          }, null, 2),
          x("input", {
            id: c.value,
            ref_key: "inputRef",
            ref: l,
            name: e.name,
            type: "text",
            inputmode: L(M).datePattern.value ? "numeric" : void 0,
            value: L(M).displayValue.value,
            placeholder: E.value,
            disabled: e.disabled,
            readonly: e.readonly,
            autocomplete: e.autocomplete ?? "off",
            "aria-labelledby": f.value,
            "aria-label": e.label ? void 0 : e.ariaLabel,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-invalid": B.value,
            "aria-describedby": z.value,
            "aria-required": e.required ? "true" : void 0,
            role: "combobox",
            "aria-haspopup": "dialog",
            "aria-expanded": e.type === "dob" ? Q.value : ge.value,
            "aria-controls": e.type === "dob" ? q.value ? K.value : void 0 : de.value ? Ee.value : void 0,
            "data-testid": e.testId ?? "date-picker-input",
            class: C([
              "flex-1 min-w-0 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) pl-0",
              !e.disabled && !e.readonly && "cursor-text",
              L(Z).text
            ]),
            onFocus: fe[0] || (fe[0] = //@ts-ignore
            (...Ne) => L(M).handleFocus && L(M).handleFocus(...Ne)),
            onBlur: fe[1] || (fe[1] = //@ts-ignore
            (...Ne) => L(M).handleBlur && L(M).handleBlur(...Ne)),
            onInput: fe[2] || (fe[2] = //@ts-ignore
            (...Ne) => L(M).handleInput && L(M).handleInput(...Ne)),
            onKeydown: Ae
          }, null, 42, S3)
        ], 38)
      ], 2),
      e.type === "dob" && l.value && q.value ? (u(), P(d3, Ve({ key: 1 }, e.dobLabels, {
        id: K.value,
        ref_key: "dobPickerRef",
        ref: G,
        open: Q.value,
        "model-value": e.modelValue,
        "anchor-el": l.value,
        "auto-focus-on-open": J.value,
        "min-date": $.value,
        "max-date": S.value,
        "default-date": e.dobDefaultDate,
        "onUpdate:open": fe[5] || (fe[5] = (Ne) => Q.value = Ne),
        "onUpdate:modelValue": Se,
        onClear: oe,
        onClose: re
      }), null, 16, ["id", "open", "model-value", "anchor-el", "auto-focus-on-open", "min-date", "max-date", "default-date"])) : w("", !0),
      e.type === "default" && l.value && de.value ? (u(), P(yf, {
        key: 2,
        id: Ee.value,
        ref_key: "defaultDropdownMenuRef",
        ref: j,
        open: ge.value,
        "model-value": ne.value,
        "anchor-el": l.value,
        "keep-anchor-focusable": "",
        "auto-focus-on-open": J.value,
        "min-date": $.value,
        "max-date": S.value,
        "today-button-mode": "select",
        "show-today-button": e.buttons,
        "show-clear-button": e.buttons,
        placement: Y.value,
        "weekday-labels": k.value.weekdayLabels,
        "month-labels": k.value.monthLabels,
        "month-short-labels": k.value.monthShortLabels,
        "clear-label": k.value.clearLabel,
        "today-label": k.value.todayLabel,
        "previous-label": k.value.previousLabel,
        "next-label": k.value.nextLabel,
        "unavailable-label": k.value.unavailableLabel,
        "dialog-label": k.value.dialogLabel,
        "onUpdate:open": fe[6] || (fe[6] = (Ne) => ge.value = Ne),
        "onUpdate:modelValue": ee,
        onClear: ue,
        onClose: se
      }, null, 8, ["id", "open", "model-value", "anchor-el", "auto-focus-on-open", "min-date", "max-date", "show-today-button", "show-clear-button", "placement", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "dialog-label"])) : w("", !0)
    ], 6));
  }
}), $3 = { class: "relative flex flex-col items-start gap-0.5 text-left text-(length:--size-m) font-inter" }, I3 = ["id", "inputmode", "value", "disabled", "aria-labelledby", "aria-required", "aria-invalid", "aria-describedby", "aria-expanded", "data-testid"], gG = /* @__PURE__ */ ke({
  __name: "YearMonthPickerInput",
  props: {
    type: {},
    modelValue: { default: "" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    errorLive: { type: Boolean, default: !0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    language: { default: "en" },
    disabled: { type: Boolean, default: !1 },
    showTodayButton: { type: Boolean, default: !1 },
    todayButtonMode: { default: "highlight" },
    weekdayLabels: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {},
    todayLabel: {},
    previousLabel: {},
    nextLabel: {},
    unavailableLabel: {},
    dialogLabel: {},
    testId: { default: void 0 }
  },
  emits: ["update:modelValue", "select"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => t.language.slice(0, 2).toLowerCase()), o = m(() => p3[l.value] ?? "mm/yyyy"), r = m(() => t.type === "year" ? "yyyy" : o.value), i = m(() => fx(r.value));
    function s(G) {
      return t.type === "year" ? x3(G) : k3(G, o.value);
    }
    function d(G) {
      return t.type === "year" ? y3(G) : w3(G, o.value);
    }
    const c = R(null), f = R(null), g = R(!1), h = R(!1), v = R(null), p = R(null), y = R(s(t.modelValue));
    let k = null, $ = null, S = 0;
    function I() {
      k == null || k.destroy(), k = null;
    }
    function T() {
      !$ || !c.value || i.value === null || (I(), k = $(c.value, { mask: i.value, lazy: !0 }), k.value = y.value, k.on("accept", () => {
        if (!k) return;
        const G = k.value;
        if (y.value = G, G === "") {
          t.modelValue !== "" && n("update:modelValue", "");
          return;
        }
        const te = d(G);
        te !== void 0 && te !== t.modelValue && n("update:modelValue", te);
      }));
    }
    kt(async () => {
      if (!c.value || i.value === null) return;
      const G = ++S;
      $ = (await import("./index-CZ98n4Cf.js")).default, !(!c.value || G !== S) && T();
    }), zt(() => {
      I();
    }), $e(
      () => t.modelValue,
      (G) => {
        if (h.value) return;
        const te = s(G);
        y.value = te, k && (k.value = te);
      }
    ), $e([i], async () => {
      const G = ++S;
      I(), i.value !== null && ($ || ($ = (await import("./index-CZ98n4Cf.js")).default), G === S && T());
    });
    function A() {
      t.disabled || (h.value = !0);
    }
    function E() {
      h.value = !1;
      const G = s(t.modelValue);
      y.value = G, k && (k.value = G);
    }
    function z(G) {
      if (k) return;
      const te = G.target.value;
      y.value = te;
      const ve = d(te);
      ve !== void 0 && n("update:modelValue", ve);
    }
    function B() {
      t.disabled || (g.value = !0);
    }
    function W(G) {
      var te, ve;
      g.value || ((te = v.value) == null || te.handleFieldKeydown(G), (ve = p.value) == null || ve.handleFieldKeydown(G)), !(G.key !== "Enter" && G.key !== " " && G.key !== "ArrowDown") && (G.preventDefault(), B());
    }
    function _(G) {
      n("select", G);
    }
    function Z() {
      var G;
      (G = c.value) == null || G.focus();
    }
    const D = Ye(), O = m(() => t.label ? `${D}-label` : void 0), N = `${D}-dialog`, V = `${D}-hint`, M = `${D}-error`, Q = m(() => {
      const G = [];
      return t.hint && G.push(V), t.error && G.push(M), G.length > 0 ? G.join(" ") : void 0;
    }), q = m(() => t.disabled ? "border-border-disabled-subtle bg-gainsboro-200 dark:border-(--colors-border-disabled-subtle) dark:bg-(--colors-background-disabled)" : t.error ? "border-(--border-border-error-strong) bg-(--background-background-white) dark:border-(--border-border-error) dark:bg-(--background-background-black-default)" : "border-(--border-border-base-medium) bg-(--background-background-white) dark:border-(--border-border-base) dark:bg-(--background-background-black-default)"), K = m(
      () => t.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
    );
    return (G, te) => (u(), b("div", $3, [
      e.label ? (u(), P(Ft, {
        key: 0,
        id: O.value,
        ref_key: "labelRef",
        ref: v,
        text: e.label,
        "input-id": L(D),
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: h.value,
        "test-id": "year-month-picker-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : w("", !0),
      x("div", {
        ref_key: "triggerRef",
        ref: f,
        class: C([
          "relative flex h-[36px] items-center gap-2 rounded-xl border-[1px] border-solid px-3 py-2",
          q.value
        ])
      }, [
        x("i", {
          "aria-hidden": "true",
          class: C(["ri-calendar-line text-sm", K.value])
        }, null, 2),
        x("input", {
          id: L(D),
          ref_key: "inputRef",
          ref: c,
          type: "text",
          inputmode: i.value ? "numeric" : void 0,
          value: y.value,
          disabled: e.disabled,
          "aria-labelledby": O.value,
          "aria-required": e.required ? "true" : void 0,
          "aria-invalid": e.error ? "true" : void 0,
          "aria-describedby": Q.value,
          "aria-haspopup": "dialog",
          "aria-expanded": g.value,
          "aria-controls": N,
          "data-testid": e.testId ?? "year-month-picker-input",
          class: "min-w-0 flex-1 border-0 bg-transparent text-(length:--size-m) leading-(--line-height-l) outline-none placeholder:text-text-body-subtle focus:outline-none focus:ring-0",
          onFocus: A,
          onBlur: E,
          onInput: z,
          onClick: B,
          onKeydown: W
        }, null, 40, I3)
      ], 2),
      U(Pt, {
        ref_key: "helperRef",
        ref: p,
        class: "self-stretch",
        focused: h.value,
        hint: e.hint,
        error: e.error,
        "hint-id": V,
        "error-id": M,
        "error-live": e.errorLive,
        "test-id-prefix": "year-month-picker"
      }, null, 8, ["focused", "hint", "error", "error-live"]),
      f.value ? (u(), P(yf, {
        key: 1,
        id: N,
        open: g.value,
        "onUpdate:open": te[0] || (te[0] = (ve) => g.value = ve),
        "model-value": e.modelValue,
        "anchor-el": f.value,
        mode: e.type,
        "min-date": e.minDate,
        "max-date": e.maxDate,
        "show-today-button": e.showTodayButton,
        "today-button-mode": e.todayButtonMode,
        "weekday-labels": e.weekdayLabels,
        "month-labels": e.monthLabels,
        "month-short-labels": e.monthShortLabels,
        "clear-label": e.clearLabel,
        "today-label": e.todayLabel,
        "previous-label": e.previousLabel,
        "next-label": e.nextLabel,
        "unavailable-label": e.unavailableLabel,
        "dialog-label": e.dialogLabel,
        "onUpdate:modelValue": te[1] || (te[1] = (ve) => n("update:modelValue", ve)),
        onSelect: _,
        onClear: te[2] || (te[2] = (ve) => n("update:modelValue", "")),
        onClose: Z
      }, null, 8, ["open", "model-value", "anchor-el", "mode", "min-date", "max-date", "show-today-button", "today-button-mode", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "dialog-label"])) : w("", !0)
    ]));
  }
}), L3 = {
  class: "flex flex-col gap-0.5 pb-0.5",
  "data-testid": "date-range-wrapper"
}, T3 = ["id", "value", "placeholder", "disabled", "readonly", "inputmode", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "aria-required", "aria-invalid", "aria-describedby"], E3 = ["aria-label"], A3 = ["id", "value", "placeholder", "disabled", "readonly", "inputmode", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "aria-required", "aria-invalid", "aria-describedby"], R3 = ["aria-label"], z3 = /* @__PURE__ */ ke({
  __name: "DateRangePickerInput",
  props: {
    startDate: { default: "" },
    endDate: { default: "" },
    startLabel: { default: "From" },
    endLabel: { default: "To" },
    startPlaceholder: { default: "Select date start" },
    endPlaceholder: { default: "Select date end" },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    format: { default: void 0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    buttons: { type: Boolean, default: !0 },
    weekStart: { default: 1 },
    language: { default: "en" },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 },
    readonly: { type: Boolean, default: !0 },
    labels: { default: void 0 }
  },
  emits: ["update:startDate", "update:endDate", "changeDate"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = R(null), o = R(null), r = Ye(), i = m(() => t.language.slice(0, 2).toLowerCase()), s = {
      en: "mm/dd/yyyy",
      fr: "dd/mm/yyyy",
      nl: "dd-mm-yyyy"
    }, d = m(() => t.format !== void 0 ? t.format : s[i.value] ?? "mm/dd/yyyy"), c = m(
      () => t.labels ?? yx[i.value] ?? xx
    ), f = m(() => !!t.error), g = Ye(), h = m(() => `${g}-start-input`), v = m(() => `${g}-end-input`), p = m(() => t.startLabel ? `${g}-start-label` : void 0), y = m(() => t.endLabel ? `${g}-end-label` : void 0), k = m(() => `${g}-hint`), $ = R(null), S = R(null), I = R(null), T = m(() => `${g}-error`), A = m(() => {
      const xe = [];
      return t.hint && xe.push(k.value), f.value && xe.push(T.value), xe.length > 0 ? xe.join(" ") : void 0;
    }), E = R(!1), z = R(null), B = R(null), W = R("start"), _ = R("start"), Z = R(!1), le = R(!0), D = Yu({
      inputRef: l,
      format: d,
      maskEnabled: m(() => !t.readonly),
      disabled: Ua(t, "disabled"),
      readonly: Ua(t, "readonly"),
      initialDisplayValue: t.startDate,
      onAccept: (xe) => {
        if (xe === "") {
          t.startDate !== "" && (n("update:startDate", ""), n("changeDate", { startDate: "", endDate: O.displayValue.value }));
          return;
        }
        oa(xe, d.value) !== void 0 && xe !== t.startDate && (n("update:startDate", xe), n("changeDate", { startDate: xe, endDate: O.displayValue.value }));
      },
      resolveRevertValue: () => t.startDate,
      resolveResyncValue: () => t.startDate
    }), O = Yu({
      inputRef: o,
      format: d,
      maskEnabled: m(() => !t.readonly),
      disabled: Ua(t, "disabled"),
      readonly: Ua(t, "readonly"),
      initialDisplayValue: t.endDate,
      onAccept: (xe) => {
        if (xe === "") {
          t.endDate !== "" && (n("update:endDate", ""), n("changeDate", { startDate: D.displayValue.value, endDate: "" }));
          return;
        }
        oa(xe, d.value) !== void 0 && xe !== t.endDate && (n("update:endDate", xe), n("changeDate", { startDate: D.displayValue.value, endDate: xe }));
      },
      resolveRevertValue: () => t.endDate,
      resolveResyncValue: () => t.endDate
    });
    $e(
      () => t.startDate,
      (xe) => {
        D.isFocused.value || D.syncDisplayValue(xe);
      }
    ), $e(
      () => t.endDate,
      (xe) => {
        O.isFocused.value || O.syncDisplayValue(xe);
      }
    ), $e([d], ([xe], [we]) => {
      if (xe !== we) {
        if (!D.isFocused.value) {
          const fe = oa(D.displayValue.value, we);
          fe !== void 0 && D.syncDisplayValue(Da(fe, xe));
        }
        if (!O.isFocused.value) {
          const fe = oa(O.displayValue.value, we);
          fe !== void 0 && O.syncDisplayValue(Da(fe, xe));
        }
      }
    });
    const N = (xe, we, fe) => {
      const Ne = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      return t.disabled ? `${Ne} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)` : f.value ? `${Ne} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)` : xe || we ? `${Ne} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)` : `${Ne} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${fe ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)"} dark:text-(--text-text-white-default)`;
    }, V = m(
      () => N(D.isFocused.value, D.isHovered.value, !!t.startDate)
    ), M = m(
      () => N(O.isFocused.value, O.isHovered.value, !!t.endDate)
    ), q = {
      sm: { container: "h-[32px] px-2 py-1.5 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      md: { container: "h-[36px] px-3 py-2 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      lg: { container: "h-[48px] px-3.5 py-3 gap-2", text: "text-base leading-6", icon: "h-5 w-5" },
      xl: { container: "h-[52px] px-4 py-3.5 gap-2", text: "text-base leading-6", icon: "h-5 w-5" }
    }[t.size], K = m(
      () => t.fullWidth ? "flex flex-col items-start gap-0.5 flex-1 min-w-0" : "flex flex-col items-start gap-0.5"
    ), G = m(() => t.fullWidth ? "w-full" : "w-[180px]"), te = m(
      () => t.fullWidth ? "flex flex-row gap-4 w-full" : "flex flex-row gap-4"
    ), ve = m(() => oa(t.startDate, d.value) ?? ""), Se = m(() => oa(t.endDate, d.value) ?? ""), oe = m(
      () => t.minDate ? oa(t.minDate, d.value) ?? t.minDate : void 0
    ), re = m(
      () => t.maxDate ? oa(t.maxDate, d.value) ?? t.maxDate : void 0
    );
    function ge() {
      const xe = Si();
      return (oe.value === void 0 || Ga(xe, oe.value) >= 0) && (re.value === void 0 || Ga(xe, re.value) <= 0);
    }
    function de(xe) {
      var Ne;
      z.value = xe;
      const we = xe === o.value ? "end" : "start";
      _.value = we;
      const fe = we === "end" ? t.endDate !== "" : t.startDate !== "";
      Z.value = fe, W.value = Z.value ? we : t.startDate === "" ? "start" : "end", E.value = !0, (Ne = B.value) == null || Ne.reseedVisibleGrid(we);
    }
    function Ee() {
      D.armMouseDown(E.value && z.value === l.value);
    }
    function j() {
      var xe;
      t.disabled || D.consumeClick() || (le.value = !1, de(l.value), (xe = l.value) == null || xe.focus());
    }
    function J(xe) {
      var fe;
      if (t.disabled) return;
      xe.preventDefault();
      const we = E.value;
      le.value = !0, de(l.value), we && ((fe = B.value) == null || fe.focusGrid("start"));
    }
    function ne(xe) {
      var fe, Ne;
      if (E.value || ((fe = $.value) == null || fe.handleFieldKeydown(xe), (Ne = I.value) == null || Ne.handleFieldKeydown(xe)), xe.key === "ArrowDown") {
        J(xe);
        return;
      }
      if (xe.key !== "Enter" || t.disabled || t.readonly) return;
      E.value && (E.value = !1), D.displayValue.value.trim() === "" && ge() && D.setValue(Da(Si(), d.value));
    }
    function Y() {
      O.armMouseDown(E.value && z.value === o.value);
    }
    function F() {
      var xe;
      t.disabled || O.consumeClick() || (le.value = !1, de(o.value), (xe = o.value) == null || xe.focus());
    }
    function ee(xe) {
      var fe;
      if (t.disabled) return;
      xe.preventDefault();
      const we = E.value;
      le.value = !0, de(o.value), we && ((fe = B.value) == null || fe.focusGrid("end"));
    }
    function ue(xe) {
      var fe, Ne;
      if (E.value || ((fe = S.value) == null || fe.handleFieldKeydown(xe), (Ne = I.value) == null || Ne.handleFieldKeydown(xe)), xe.key === "ArrowDown") {
        ee(xe);
        return;
      }
      if (xe.key !== "Enter" || t.disabled || t.readonly) return;
      E.value && (E.value = !1), O.displayValue.value.trim() === "" && ge() && O.setValue(Da(Si(), d.value));
    }
    function se(xe) {
      const we = Da(xe, d.value);
      if (Z.value) {
        if (W.value === "start") {
          D.setValue(we);
          const Ne = oa(t.endDate, d.value);
          Ne !== void 0 && xe > Ne && O.setValue("");
        } else {
          O.setValue(we);
          const Ne = oa(t.startDate, d.value);
          Ne !== void 0 && xe < Ne && D.setValue("");
        }
        E.value = !1;
        return;
      }
      if (W.value === "start") {
        D.setValue(we);
        const Ne = oa(t.endDate, d.value);
        Ne !== void 0 && xe > Ne && O.setValue(""), W.value = "end";
        return;
      }
      const fe = oa(t.startDate, d.value);
      if (fe !== void 0 && xe < fe) {
        D.setValue(we), O.setValue(""), W.value = "end";
        return;
      }
      O.setValue(we), E.value = !1;
    }
    function X() {
      E.value = !1;
    }
    function ae() {
      D.setValue(""), O.setValue(""), W.value = "start", Z.value = !1;
    }
    function Re() {
      D.consumeClick(), D.setValue("");
    }
    function Ae() {
      O.consumeClick(), O.setValue("");
    }
    return (xe, we) => (u(), b("div", L3, [
      x("div", {
        class: C(te.value),
        "data-testid": "date-range-row"
      }, [
        x("div", {
          class: C(K.value)
        }, [
          e.startLabel ? (u(), P(Ft, {
            key: 0,
            id: p.value,
            ref_key: "startLabelRef",
            ref: $,
            text: e.startLabel,
            "input-id": h.value,
            required: e.required,
            "required-indicator": e.requiredIndicator,
            tooltip: e.labelTooltip,
            focused: L(D).isFocused.value,
            "test-id": "date-range-start-label"
          }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : w("", !0),
          x("div", {
            class: C([V.value, L(q).container, G.value]),
            "data-testid": "date-range-start-container",
            onMouseenter: we[3] || (we[3] = //@ts-ignore
            (...fe) => L(D).handleMouseEnter && L(D).handleMouseEnter(...fe)),
            onMouseleave: we[4] || (we[4] = //@ts-ignore
            (...fe) => L(D).handleMouseLeave && L(D).handleMouseLeave(...fe)),
            onMousedown: Ee,
            onClick: j
          }, [
            x("i", {
              class: C([
                "ri-calendar-line",
                L(q).icon,
                e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
              ])
            }, null, 2),
            x("input", {
              id: h.value,
              ref_key: "startInputRef",
              ref: l,
              name: "start",
              type: "text",
              value: L(D).displayValue.value,
              placeholder: e.startPlaceholder,
              disabled: e.disabled,
              readonly: e.readonly,
              autocomplete: "off",
              inputmode: L(D).datePattern.value ? "numeric" : void 0,
              role: "combobox",
              "aria-haspopup": "dialog",
              "aria-expanded": E.value && z.value === l.value,
              "aria-controls": E.value && z.value === l.value ? L(r) : void 0,
              "aria-labelledby": p.value,
              "aria-label": p.value ? void 0 : e.startPlaceholder,
              "aria-required": e.required ? "true" : void 0,
              "aria-invalid": f.value ? "true" : void 0,
              "aria-describedby": A.value,
              "data-testid": "date-range-start-input",
              class: C([
                // forced-colors:focus-visible: mirrors DatePickerInput.vue's own gap fix — the
                // designed focus indicator lives on the CONTAINER (startInputClasses, CSS-var
                // border + box-shadow), and Windows High Contrast Mode suppresses both, so a real
                // outline is re-added here, painted by the UA in the system Highlight color.
                "flex-1 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) min-w-0",
                !e.disabled && !e.readonly ? "cursor-text" : "cursor-pointer",
                L(q).text
              ]),
              onFocus: we[0] || (we[0] = //@ts-ignore
              (...fe) => L(D).handleFocus && L(D).handleFocus(...fe)),
              onBlur: we[1] || (we[1] = //@ts-ignore
              (...fe) => L(D).handleBlur && L(D).handleBlur(...fe)),
              onInput: we[2] || (we[2] = //@ts-ignore
              (...fe) => L(D).handleInput && L(D).handleInput(...fe)),
              onKeydown: ne
            }, null, 42, T3),
            e.disabled ? w("", !0) : (u(), b("button", {
              key: 0,
              type: "button",
              "data-testid": "date-range-start-clear",
              class: C([
                "shrink-0 flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) bg-transparent border-0 p-0 transition-opacity",
                e.startDate ? "opacity-100 hover:opacity-70 cursor-pointer" : "hidden"
              ]),
              "aria-label": c.value.clearStartLabel,
              onClick: _e(Re, ["stop"])
            }, [
              x("i", {
                class: C(["ri-close-line", L(q).icon])
              }, null, 2)
            ], 10, E3))
          ], 34)
        ], 2),
        x("div", {
          class: C(K.value)
        }, [
          e.endLabel ? (u(), P(Ft, {
            key: 0,
            id: y.value,
            ref_key: "endLabelRef",
            ref: S,
            text: e.endLabel,
            "input-id": v.value,
            required: e.required,
            "required-indicator": e.requiredIndicator,
            focused: L(O).isFocused.value,
            "test-id": "date-range-end-label"
          }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "focused"])) : w("", !0),
          x("div", {
            class: C([M.value, L(q).container, G.value]),
            "data-testid": "date-range-end-container",
            onMouseenter: we[8] || (we[8] = //@ts-ignore
            (...fe) => L(O).handleMouseEnter && L(O).handleMouseEnter(...fe)),
            onMouseleave: we[9] || (we[9] = //@ts-ignore
            (...fe) => L(O).handleMouseLeave && L(O).handleMouseLeave(...fe)),
            onMousedown: Y,
            onClick: F
          }, [
            x("i", {
              class: C([
                "ri-calendar-line",
                L(q).icon,
                e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
              ])
            }, null, 2),
            x("input", {
              id: v.value,
              ref_key: "endInputRef",
              ref: o,
              name: "end",
              type: "text",
              value: L(O).displayValue.value,
              placeholder: e.endPlaceholder,
              disabled: e.disabled,
              readonly: e.readonly,
              autocomplete: "off",
              inputmode: L(O).datePattern.value ? "numeric" : void 0,
              role: "combobox",
              "aria-haspopup": "dialog",
              "aria-expanded": E.value && z.value === o.value,
              "aria-controls": E.value && z.value === o.value ? L(r) : void 0,
              "aria-labelledby": y.value,
              "aria-label": y.value ? void 0 : e.endPlaceholder,
              "aria-required": e.required ? "true" : void 0,
              "aria-invalid": f.value ? "true" : void 0,
              "aria-describedby": A.value,
              "data-testid": "date-range-end-input",
              class: C([
                // See the Start input's own class comment above — same forced-colors rationale.
                "flex-1 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) min-w-0",
                !e.disabled && !e.readonly ? "cursor-text" : "cursor-pointer",
                L(q).text
              ]),
              onFocus: we[5] || (we[5] = //@ts-ignore
              (...fe) => L(O).handleFocus && L(O).handleFocus(...fe)),
              onBlur: we[6] || (we[6] = //@ts-ignore
              (...fe) => L(O).handleBlur && L(O).handleBlur(...fe)),
              onInput: we[7] || (we[7] = //@ts-ignore
              (...fe) => L(O).handleInput && L(O).handleInput(...fe)),
              onKeydown: ue
            }, null, 42, A3),
            e.disabled ? w("", !0) : (u(), b("button", {
              key: 0,
              type: "button",
              "data-testid": "date-range-end-clear",
              class: C([
                "shrink-0 flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) bg-transparent border-0 p-0 transition-opacity",
                e.endDate ? "opacity-100 hover:opacity-70 cursor-pointer" : "hidden"
              ]),
              "aria-label": c.value.clearEndLabel,
              onClick: _e(Ae, ["stop"])
            }, [
              x("i", {
                class: C(["ri-close-line", L(q).icon])
              }, null, 2)
            ], 10, R3))
          ], 34)
        ], 2)
      ], 2),
      U(Pt, {
        ref_key: "helperRef",
        ref: I,
        focused: L(D).isFocused.value || L(O).isFocused.value,
        hint: e.hint,
        error: e.error,
        "hint-id": k.value,
        "error-id": T.value,
        "test-id-prefix": "date-range"
      }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"]),
      z.value ? (u(), P(yf, {
        key: 0,
        id: L(r),
        ref_key: "dropdownMenuRef",
        ref: B,
        open: E.value,
        "anchor-el": z.value,
        "additional-anchor-els": [l.value, o.value],
        "keep-anchor-focusable": "",
        "auto-focus-on-open": le.value,
        "start-date": ve.value,
        "end-date": Se.value,
        "seed-field": _.value,
        "min-date": oe.value,
        "max-date": re.value,
        "today-button-mode": "select",
        "show-today-button": e.buttons,
        "show-clear-button": e.buttons,
        "weekday-labels": c.value.weekdayLabels,
        "month-labels": c.value.monthLabels,
        "month-short-labels": c.value.monthShortLabels,
        "clear-label": c.value.clearLabel,
        "today-label": c.value.todayLabel,
        "previous-label": c.value.previousLabel,
        "next-label": c.value.nextLabel,
        "unavailable-label": c.value.unavailableLabel,
        "range-start-label": c.value.rangeStartLabel,
        "range-end-label": c.value.rangeEndLabel,
        "range-between-label": c.value.rangeBetweenLabel,
        "dialog-label": c.value.rangeDialogLabel,
        "onUpdate:open": we[10] || (we[10] = (fe) => E.value = fe),
        onRangeSelect: se,
        onClear: ae,
        onClose: X
      }, null, 8, ["id", "open", "anchor-el", "additional-anchor-els", "auto-focus-on-open", "start-date", "end-date", "seed-field", "min-date", "max-date", "show-today-button", "show-clear-button", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "range-start-label", "range-end-label", "range-between-label", "dialog-label"])) : w("", !0)
    ]));
  }
}), D3 = { class: "flex w-full items-end gap-3" }, B3 = ["id", "value", "name", "title", "placeholder", "disabled", "readonly", "required", "autocomplete", "aria-labelledby", "aria-invalid", "aria-describedby", "aria-required", "aria-disabled"], M3 = ["aria-label", "onKeydown"], O3 = /* @__PURE__ */ ke({
  __name: "UrlInput",
  props: {
    modelValue: { default: "" },
    prefix: { default: void 0 },
    iconLeft: { default: void 0 },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 },
    hint: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    error: { default: void 0 },
    validator: { type: Function, default: void 0 },
    validateOnBlur: { type: Boolean, default: !0 },
    validateOnInput: { type: Boolean, default: !1 },
    invalidUrlMessage: { default: "Please enter a valid URL" },
    requiredMessage: { default: "URL is required" },
    buttonLabels: { default: () => ({
      label: "",
      labelWhenCopied: ""
    }) },
    resolvedUrl: { default: void 0 },
    labels: { default: () => ({ clear: "Clear input" }) }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "validation-change"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = R(!1), r = R(null), i = R(null), s = R(!1), d = R(!1), c = R(void 0), f = (G) => {
      if (n.validator)
        return n.validator(G) ?? void 0;
      if (n.required && !G.trim())
        return n.requiredMessage;
      if (G.trim())
        try {
          const te = !n.prefix && /^https?:\/\/|^ftps?:\/\//i.test(G), Se = new URL(te ? G : (n.prefix || "https://") + G).hostname.split("."), oe = Se[Se.length - 1];
          if (Se.length < 2 || oe.length < 2)
            return n.invalidUrlMessage;
        } catch {
          return n.invalidUrlMessage;
        }
    }, g = () => {
      const G = f(n.modelValue ?? "");
      c.value = G, l("validation-change", !G, G);
    }, h = m(() => {
      if (n.error) return n.error;
      if (d.value && s.value) return c.value;
    }), v = m(() => !!(n.modelValue ?? "").trim()), p = m(
      () => d.value && s.value && !h.value && v.value
    ), y = (G) => G && !o.value && !n.disabled && !n.readonly, k = m(
      () => o.value && v.value && !n.disabled && !n.readonly
    ), $ = m(() => {
      var G;
      return !!((G = n.buttonLabels) != null && G.label);
    }), S = m(() => n.fullWidth || n.width === void 0), I = (G) => {
      const te = G.target;
      d.value = !0, l("update:modelValue", te.value), l("input", G), n.validateOnInput && g();
    }, T = (G) => {
      o.value = !0, l("focus", G);
    }, A = (G) => {
      o.value = !1, s.value = !0, l("blur", G), n.validateOnBlur && g();
    }, E = (G) => {
      var te, ve;
      (te = r.value) == null || te.handleFieldKeydown(G), (ve = i.value) == null || ve.handleFieldKeydown(G);
    }, z = () => {
      l("update:modelValue", ""), l("clear");
    }, B = R("idle"), W = m(() => {
      if (n.resolvedUrl !== void 0) return n.resolvedUrl;
      const G = n.modelValue ?? "";
      return G.trim() ? !n.prefix && /^https?:\/\/|^ftps?:\/\//i.test(G) ? G : (n.prefix ?? "") + G : "";
    });
    async function _() {
      if (W.value)
        try {
          await navigator.clipboard.writeText(W.value), B.value = "copied", setTimeout(() => {
            B.value = "idle";
          }, 2e3);
        } catch (G) {
          console.error("Copy failed", G);
        }
    }
    const Z = m(() => n.buttonLabels ? B.value === "copied" ? n.buttonLabels.labelWhenCopied : n.buttonLabels.label : ""), le = m(
      () => B.value === "copied" ? "ri-check-line" : "ri-file-copy-2-line"
    );
    $e(
      () => n.modelValue,
      () => {
        s.value && (n.validateOnBlur || n.validateOnInput) && g();
      }
    ), $e(
      () => n.error,
      (G) => {
        G && (c.value = void 0);
      }
    ), a({ validate: () => (s.value = !0, g(), !c.value), resetValidation: () => {
      s.value = !1, c.value = void 0;
    } });
    const N = Ye(), V = m(() => n.id ?? `${N}-url`), M = m(() => n.label ? `${N}-label` : void 0), Q = m(() => `${N}-error`), q = m(() => `${N}-hint`), K = m(() => {
      const G = [];
      return n.hint && G.push(q.value), h.value && G.push(Q.value), G.join(" ") || void 0;
    });
    return (G, te) => (u(), b("div", {
      class: C([
        "relative flex min-w-0 pb-0.5 text-left font-inter",
        e.labelInline ? "flex-row items-center gap-2" : "flex-col items-start gap-0.5",
        S.value ? "w-full" : ""
      ]),
      style: Ge(S.value ? void 0 : { width: e.width })
    }, [
      e.label ? (u(), P(Ft, {
        key: 0,
        id: M.value,
        ref_key: "labelRef",
        ref: r,
        text: e.label,
        "input-id": V.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: o.value,
        inline: e.labelInline,
        "test-id": "url-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused", "inline"])) : w("", !0),
      x("div", {
        class: C(["flex min-w-0 flex-col gap-0.5", S.value || e.labelInline ? "w-full flex-1" : "w-full"])
      }, [
        x("div", D3, [
          U(en, {
            class: "min-w-0 flex-1",
            flush: !!e.prefix,
            "inner-button": $.value,
            size: e.size,
            disabled: e.disabled,
            readonly: e.readonly,
            error: !!h.value,
            success: p.value,
            "has-value": v.value,
            "data-testid": "url-input-shell"
          }, {
            default: me(({ hovered: ve, iconBoxClass: Se, leftIconBoxClass: oe, iconColorClass: re, borderColorClass: ge, addonTextClass: de, textClass: Ee }) => [
              e.iconLeft && !e.prefix ? (u(), b("i", {
                key: 0,
                class: C([e.iconLeft, oe, re])
              }, null, 2)) : w("", !0),
              e.prefix ? (u(), b("span", {
                key: 1,
                "data-testid": "url-input-prefix",
                class: C([
                  "flex shrink-0 select-none items-center gap-2 self-stretch border-r",
                  L(Zn)[e.size].addon,
                  "text-(length:--size-m) leading-(--line-height-l)",
                  ge,
                  de
                ])
              }, [
                e.iconLeft ? (u(), b("i", {
                  key: 0,
                  class: C([e.iconLeft, oe, re])
                }, null, 2)) : w("", !0),
                st(" " + H(e.prefix), 1)
              ], 2)) : w("", !0),
              x("div", {
                class: C([
                  e.prefix ? ["flex h-full min-w-0 flex-1 items-center gap-2", L(Zn)[e.size].input] : "contents",
                  e.prefix && !$.value ? L(Zn)[e.size].inputEnd : ""
                ])
              }, [
                x("input", {
                  id: V.value,
                  value: e.modelValue,
                  name: e.name,
                  title: W.value || void 0,
                  placeholder: e.placeholder,
                  disabled: e.disabled,
                  readonly: e.readonly,
                  required: e.required,
                  type: "url",
                  inputmode: "url",
                  autocomplete: e.autocomplete,
                  "aria-labelledby": M.value,
                  "aria-invalid": !!h.value,
                  "aria-describedby": K.value,
                  "aria-required": e.required || void 0,
                  "aria-disabled": e.disabled || void 0,
                  "data-testid": "url-input",
                  class: C([
                    "relative min-w-0 flex-1 text-ellipsis border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
                    Ee,
                    e.readonly ? "cursor-default" : ""
                  ]),
                  onInput: I,
                  onFocus: T,
                  onBlur: A,
                  onKeydown: E
                }, null, 42, B3),
                y(ve) ? (u(), b("i", {
                  key: 0,
                  class: C(["ri-pencil-line text-(--icons-icon-accent)", Se])
                }, null, 2)) : k.value ? (u(), b("i", {
                  key: 1,
                  class: C([
                    "ri-close-fill cursor-pointer text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
                    Se
                  ]),
                  role: "button",
                  tabindex: "-1",
                  "aria-label": e.labels.clear,
                  onMousedown: te[0] || (te[0] = _e(() => {
                  }, ["prevent"])),
                  onClick: _e(z, ["stop"]),
                  onKeydown: [
                    St(z, ["enter"]),
                    St(_e(z, ["prevent"]), ["space"])
                  ]
                }, null, 42, M3)) : w("", !0),
                $.value ? (u(), P(Be, {
                  key: 2,
                  variant: "secondary",
                  size: "xs",
                  "icon-left": le.value,
                  label: Z.value,
                  "aria-label": Z.value,
                  disabled: e.disabled || !e.modelValue,
                  onClick: _
                }, null, 8, ["icon-left", "label", "aria-label", "disabled"])) : w("", !0)
              ], 2)
            ]),
            _: 1
          }, 8, ["flush", "inner-button", "size", "disabled", "readonly", "error", "success", "has-value"]),
          Me(G.$slots, "actions", {}, void 0, !0)
        ]),
        U(Pt, {
          ref_key: "helperRef",
          ref: i,
          focused: o.value,
          hint: e.hint,
          error: h.value,
          "hint-id": q.value,
          "error-id": Q.value,
          "test-id-prefix": "url-input"
        }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
      ], 2)
    ], 6));
  }
}), mG = /* @__PURE__ */ Ct(O3, [["__scopeId", "data-v-3d78c675"]]), kf = {
  name: "sameWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  }
}, P3 = {
  indigo: "indigo",
  amber: "orange",
  green: "green",
  red: "red"
}, kx = (e) => e.badge ? {
  label: e.badge,
  theme: e.badgeTheme ?? P3[e.badgeVariant ?? "indigo"],
  icon: e.badgeIcon,
  brandIcon: e.badgeBrandIcon
} : void 0, F3 = ["aria-expanded", "aria-activedescendant", "aria-required", "aria-invalid", "aria-disabled", "aria-describedby", "disabled", "placeholder"], N3 = ["aria-label"], V3 = { class: "flex items-start justify-between gap-2" }, H3 = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only",
  "data-testid": "autocomplete-status"
}, j3 = {
  key: 0,
  class: "flex justify-center py-4"
}, W3 = {
  key: 1,
  "data-testid": "autocomplete-empty",
  class: "flex px-2.5 py-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)"
}, q3 = {
  key: 2,
  "data-testid": "autocomplete-results-heading",
  class: "flex shrink-0 px-2.5 pt-2 text-(length:--size-m) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default)"
}, U3 = ["aria-labelledby", "aria-label"], wx = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "AutoComplete",
  props: {
    modelValue: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean },
    requiredIndicator: { default: "*" },
    placeholder: { default: void 0 },
    iconLeft: { default: "ri-map-pin-2-line" },
    iconRight: { default: "ri-search-line" },
    options: { default: void 0 },
    loading: { type: Boolean },
    emptyLabel: { default: void 0 },
    resultsLabel: { default: void 0 },
    error: { default: void 0 },
    hint: { default: void 0 },
    disabled: { type: Boolean },
    fullWidth: { type: Boolean, default: !0 },
    showAddMoreDetails: { type: Boolean },
    addMoreDetailsLabel: { default: void 0 },
    labelTooltip: { default: void 0 },
    debounce: { default: 300 },
    minSearchLength: { default: 1 },
    maxVisibleOptions: { default: 5 },
    keepInputOnEdit: { type: Boolean },
    clearable: { type: Boolean, default: !0 },
    clearLabel: { default: "Clear" },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    seeAllLabel: { type: [String, Function], default: void 0 },
    createLabel: { type: [String, Function], default: void 0 },
    createIcon: { default: "ri-add-line" }
  },
  emits: ["update:modelValue", "search", "select", "clear", "addMoreDetails", "blur", "see-all", "create"],
  setup(e, { expose: a, emit: t }) {
    var xe, we;
    const n = e, l = t, o = Ye(), r = `autocomplete-input-${o}`, i = `autocomplete-listbox-${o}`, s = `autocomplete-error-${o}`, d = `autocomplete-hint-${o}`, c = `autocomplete-label-${o}`, f = m(() => {
      const fe = [];
      return n.hint && fe.push(d), n.error && fe.push(s), fe.length > 0 ? fe.join(" ") : void 0;
    }), g = R(
      n.modelValue ? ((we = (xe = n.options) == null ? void 0 : xe.find((fe) => fe.value === n.modelValue)) == null ? void 0 : we.label) ?? n.modelValue : ""
    ), h = R(!1), v = R(!1), p = R(!1), y = R(null), k = R(null), $ = R(!1), S = R(-1), I = R(), T = R(), A = R(), E = R(null), z = R(!1), B = R(!1);
    let W = null, _ = null, Z = !1, le = !1, D = !1;
    const O = m(
      () => h.value && !v.value && g.value.length >= (n.minSearchLength ?? 1) && !n.disabled
    ), N = m(() => (n.options ?? []).slice(0, n.maxVisibleOptions)), V = (fe) => fe.image !== void 0 ? { name: fe.label, img: fe.image ?? void 0, logo: fe.logo } : void 0, M = m(() => {
      if (!O.value || n.loading || B.value) return "";
      const fe = N.value.length;
      return fe === 0 ? n.emptyLabel ?? "No results" : Rs(n.resultsCountLabel, fe);
    }), Q = (fe) => typeof fe == "function" ? fe(g.value) : fe, q = m(() => Q(n.seeAllLabel)), K = m(() => Q(n.createLabel)), G = m(() => !!(q.value || K.value)), te = m(() => !!n.modelValue), ve = m(
      () => n.clearable && !!g.value && !n.disabled && ($.value || h.value)
    ), Se = m(() => n.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : h.value ? "text-(--border-border-accent)" : te.value ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body-subtle)"), oe = m(() => n.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : $.value && !h.value ? "text-(--border-border-accent)" : te.value ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body-subtle)"), re = m(() => {
      const fe = "relative rounded-(--border-border-radius-rounded-l) border-solid box-border flex items-center gap-2 px-3 h-9 font-inter";
      return n.disabled ? `${fe} border-[1px] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)` : n.error ? `${fe} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)` : h.value ? `${fe} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent)` : $.value ? `${fe} border-[1px] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent)` : `${fe} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base)`;
    });
    $e(O, async (fe) => {
      fe ? (await Ze(), W = fl(I.value, A.value, {
        placement: "bottom-start",
        onFirstUpdate: () => {
          z.value = !0;
        },
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          kf
        ]
      })) : (W == null || W.destroy(), W = null, z.value = !1);
    }), $e(z, async (fe) => {
      fe && (await Ze(), await (W == null ? void 0 : W.update()));
    }), $e(
      [() => n.options, () => n.loading],
      async () => {
        var fe;
        if (!h.value && n.modelValue) {
          const Ne = (fe = n.options) == null ? void 0 : fe.find((De) => De.value === n.modelValue);
          Ne && (g.value = Ne.label);
        }
        S.value = -1, await Ze(), await (W == null ? void 0 : W.update());
      }
    ), $e(O, (fe) => {
      fe || (S.value = -1);
    }), $e(
      () => n.modelValue,
      (fe) => {
        var De;
        if (!fe) {
          Z || (g.value = ""), Z = !1;
          return;
        }
        const Ne = (De = n.options) == null ? void 0 : De.find((qe) => qe.value === fe);
        g.value = Ne ? Ne.label : fe;
      },
      { immediate: !0 }
    ), Tt(() => {
      W == null || W.destroy(), W = null, _ && clearTimeout(_);
    });
    const ge = (fe) => {
      if (le) {
        le = !1;
        return;
      }
      h.value = !0, v.value = !1, fe.target.select();
    }, de = () => {
      n.disabled || (h.value = !0, v.value = !1);
    }, Ee = (fe) => {
      var Ne;
      if (D || (Ne = A.value) != null && Ne.contains(fe.relatedTarget)) {
        D = !1;
        return;
      }
      h.value = !1, l("blur");
    }, j = () => {
      v.value = !1, n.modelValue && (n.keepInputOnEdit && (Z = !0), l("update:modelValue", "")), B.value = !0, _ && clearTimeout(_), _ = setTimeout(() => {
        B.value = !1, l("search", g.value);
      }, n.debounce ?? 300);
    }, J = (fe) => {
      fe.disabled || (g.value = fe.label, l("update:modelValue", fe.value), l("select", fe), Y());
    }, ne = () => {
      g.value = "", l("update:modelValue", ""), l("clear");
    }, Y = () => {
      v.value = !0;
    }, F = () => {
      Y(), T.value && document.activeElement !== T.value && (le = !0, T.value.focus());
    }, ee = () => {
      var fe, Ne;
      return Array.from(
        ((Ne = (fe = E.value) == null ? void 0 : fe.$el) == null ? void 0 : Ne.querySelectorAll("button, a[href]")) ?? []
      );
    };
    function ue(fe) {
      const Ne = g.value;
      F(), l(fe === "see-all" ? "see-all" : "create", Ne);
    }
    function se(fe) {
      var De, qe;
      const Ne = ee();
      fe.key === "Escape" ? (fe.preventDefault(), fe.stopPropagation(), F()) : fe.key === "Tab" && fe.shiftKey && fe.target === Ne[0] ? (fe.preventDefault(), (De = T.value) == null || De.focus()) : fe.key === "Tab" && !fe.shiftKey && fe.target === Ne[Ne.length - 1] && (le = !0, (qe = T.value) == null || qe.focus(), Y());
    }
    function X(fe) {
      var De;
      const Ne = fe.relatedTarget;
      Ne === T.value || (De = A.value) != null && De.contains(Ne) || (h.value = !1, l("blur"));
    }
    function ae(fe, Ne) {
      fe.disabled || (S.value = Ne, p.value = !1);
    }
    const Re = async () => {
      var fe;
      await Ze(), (fe = document.getElementById(`${i}-option-${S.value}`)) == null || fe.scrollIntoView({ block: "nearest" });
    }, Ae = (fe) => {
      var qe, Qe;
      if (!O.value) {
        if (v.value && (fe.key === "ArrowDown" || fe.key === "ArrowUp")) {
          fe.preventDefault(), v.value = !1;
          return;
        }
        (qe = y.value) == null || qe.handleFieldKeydown(fe), (Qe = k.value) == null || Qe.handleFieldKeydown(fe);
        return;
      }
      if (fe.key === "Escape") {
        fe.stopPropagation(), fe.preventDefault(), Y();
        return;
      }
      const Ne = N.value.length;
      if (!Ne && fe.key !== "Tab") return;
      const De = S.value < Ne ? S.value : -1;
      switch (fe.key) {
        case "ArrowDown": {
          fe.preventDefault(), S.value = (De + 1) % Ne, p.value = !0, Re();
          break;
        }
        case "ArrowUp": {
          fe.preventDefault(), S.value = De === -1 ? Ne - 1 : De - 1, p.value = !0, Re();
          break;
        }
        case "Enter": {
          fe.preventDefault(), S.value >= 0 && N.value[S.value] && J(N.value[S.value]);
          break;
        }
        case "Tab": {
          if (!fe.shiftKey && S.value >= 0 && N.value[S.value])
            J(N.value[S.value]);
          else if (!fe.shiftKey && ee()[0]) {
            fe.preventDefault(), D = !0, ee()[0].focus();
            break;
          }
          Y();
          break;
        }
      }
    };
    return a({ focus: () => {
      var fe;
      return (fe = T.value) == null ? void 0 : fe.focus();
    } }), (fe, Ne) => (u(), b(ie, null, [
      x("div", {
        class: C(["font-inter text-(length:--size-m) leading-(--line-height-l) flex flex-col gap-0.5 pb-0.5", e.fullWidth ? "w-full" : ""])
      }, [
        e.label ? (u(), P(Ft, {
          key: 0,
          id: c,
          ref_key: "labelRef",
          ref: y,
          text: e.label,
          "input-id": r,
          required: e.required,
          "required-indicator": e.requiredIndicator,
          tooltip: e.labelTooltip,
          focused: h.value,
          "test-id": "autocomplete-label"
        }, null, 8, ["text", "required", "required-indicator", "tooltip", "focused"])) : w("", !0),
        x("div", {
          ref_key: "inputRef",
          ref: I,
          class: C(re.value),
          onMouseenter: Ne[2] || (Ne[2] = (De) => $.value = !0),
          onMouseleave: Ne[3] || (Ne[3] = (De) => $.value = !1)
        }, [
          e.iconLeft ? (u(), b("i", {
            key: 0,
            class: C([e.iconLeft, "shrink-0 text-(length:--icon-size-sm) leading-(--line-height-xxl) transition-colors", Se.value])
          }, null, 2)) : w("", !0),
          wo(x("input", Ve(fe.$attrs, {
            id: r,
            ref_key: "nativeInputRef",
            ref: T,
            "onUpdate:modelValue": Ne[0] || (Ne[0] = (De) => g.value = De),
            role: "combobox",
            "aria-expanded": O.value,
            "aria-autocomplete": "list",
            "aria-controls": i,
            "aria-activedescendant": S.value >= 0 ? `${i}-option-${S.value}` : void 0,
            "aria-haspopup": "listbox",
            "aria-required": e.required || void 0,
            "aria-invalid": !!e.error || void 0,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-describedby": f.value,
            autocomplete: "off",
            disabled: e.disabled,
            placeholder: e.placeholder,
            class: ["flex-1 min-w-0 truncate bg-transparent outline-none text-(length:--size-m) leading-(--line-height-l) placeholder:text-(--text-text-body-subtle)", e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"],
            onInput: j,
            onFocus: ge,
            onClick: de,
            onBlur: Ee,
            onKeydown: Ae
          }), null, 16, F3), [
            [u0, g.value]
          ]),
          ve.value ? (u(), b("button", {
            key: 1,
            type: "button",
            "aria-label": e.clearLabel,
            "data-testid": "autocomplete-clear",
            class: C(["-m-1 inline-flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-full transition-colors focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", oe.value]),
            onMousedown: Ne[1] || (Ne[1] = _e(() => {
            }, ["prevent"])),
            onClick: ne
          }, [...Ne[8] || (Ne[8] = [
            x("i", {
              class: "ri-close-line text-(length:--icon-size-sm) leading-(--line-height-xxl)",
              "aria-hidden": "true"
            }, null, -1)
          ])], 42, N3)) : e.iconRight ? (u(), b("i", {
            key: 2,
            class: C([e.iconRight, "shrink-0 text-(length:--icon-size-sm) leading-(--line-height-xxl) transition-colors", oe.value])
          }, null, 2)) : w("", !0)
        ], 34),
        x("div", V3, [
          U(Pt, {
            ref_key: "helperRef",
            ref: k,
            focused: h.value,
            class: "flex-1",
            hint: e.hint,
            error: e.error,
            "hint-id": d,
            "error-id": s,
            "test-id-prefix": "autocomplete"
          }, null, 8, ["focused", "hint", "error"]),
          U(Wt, {
            "enter-active-class": "transition duration-150 ease-in-out motion-reduce:transition-none",
            "enter-from-class": "opacity-0 -translate-y-1 motion-reduce:translate-y-0",
            "enter-to-class": "opacity-100 translate-y-0"
          }, {
            default: me(() => [
              e.showAddMoreDetails ? (u(), P(L(pa), {
                key: 0,
                "data-testid": "autocomplete-add-more-details",
                "icon-right": "ri-pencil-line",
                class: "shrink-0 ml-2",
                disabled: e.disabled,
                onClick: Ne[4] || (Ne[4] = (De) => l("addMoreDetails"))
              }, {
                default: me(() => [
                  st(H(e.addMoreDetailsLabel ?? "Add more details"), 1)
                ]),
                _: 1
              }, 8, ["disabled"])) : w("", !0)
            ]),
            _: 1
          })
        ]),
        x("span", H3, H(M.value), 1)
      ], 2),
      (u(), P(Fa, { to: "body" }, [
        O.value ? (u(), b("div", {
          key: 0,
          ref_key: "panelRef",
          ref: A,
          class: "fixed z-[200]",
          "data-focus-trap-allow-outside": "",
          onMousedown: Ne[7] || (Ne[7] = _e(() => {
          }, ["prevent"])),
          onFocusout: X
        }, [
          U(Wt, {
            "enter-active-class": "transition duration-100 ease-out",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: me(() => [
              z.value ? (u(), b("div", {
                key: 0,
                "data-testid": "autocomplete-panel",
                class: C([
                  "flex w-full flex-col overflow-hidden",
                  // Without a footer the border is medium and there is no blur, so only the footer panel is the shared surface.
                  G.value ? L(hl) : "rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-medium) bg-(--background-background-white) shadow-(--blur-shadow-m) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
                ])
              }, [
                x("div", {
                  "data-testid": "autocomplete-list",
                  class: C([
                    "flex min-h-0 flex-col",
                    G.value ? "p-1" : "gap-1.5 p-[calc(--spacing(2)-1px)]"
                  ])
                }, [
                  e.loading ? (u(), b("div", j3, [...Ne[9] || (Ne[9] = [
                    x("i", {
                      class: "ri-loader-4-line animate-spin text-(--text-text-body-subtle)",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])])) : !N.value.length && !B.value ? (u(), b("div", W3, H(e.emptyLabel ?? "No results"), 1)) : e.resultsLabel ? (u(), b("div", q3, H(e.resultsLabel), 1)) : w("", !0),
                  x("ul", {
                    id: i,
                    role: "listbox",
                    "aria-labelledby": e.label ? c : void 0,
                    "aria-label": e.label ? void 0 : e.resultsLabel,
                    class: C([
                      "flex flex-col",
                      !G.value && "gap-1.5",
                      (e.loading || !N.value.length) && "hidden"
                    ])
                  }, [
                    (u(!0), b(ie, null, Oe(N.value, (De, qe) => (u(), P(fa, {
                      id: `${i}-option-${qe}`,
                      key: De.value,
                      as: "li",
                      type: "autocomplete",
                      role: "option",
                      "aria-selected": qe === S.value,
                      label: De.label,
                      highlight: g.value,
                      icon: De.icon,
                      avatar: V(De),
                      "secondary-label": De.description,
                      badge: L(kx)(De),
                      description: De.disabled ? De.disabledReason : void 0,
                      "aria-disabled": !!De.disabled,
                      highlighted: qe === S.value,
                      "keyboard-active": p.value && qe === S.value,
                      "data-testid": `autocomplete-option-${De.value}`,
                      onClick: (Qe) => J(De),
                      onMouseenter: (Qe) => ae(De, qe)
                    }, null, 8, ["id", "aria-selected", "label", "highlight", "icon", "avatar", "secondary-label", "badge", "description", "aria-disabled", "highlighted", "keyboard-active", "data-testid", "onClick", "onMouseenter"]))), 128))
                  ], 10, U3)
                ], 2),
                G.value ? (u(), P(Dl, {
                  key: 0,
                  ref_key: "footerRef",
                  ref: E,
                  type: "see-all-create",
                  "see-all-label": q.value,
                  "create-label": K.value,
                  "create-icon": e.createIcon,
                  class: "shrink-0",
                  onKeydown: se,
                  onSeeAll: Ne[5] || (Ne[5] = (De) => ue("see-all")),
                  onCreate: Ne[6] || (Ne[6] = (De) => ue("create"))
                }, null, 8, ["see-all-label", "create-label", "create-icon"])) : w("", !0)
              ], 2)) : w("", !0)
            ]),
            _: 1
          })
        ], 544)) : w("", !0)
      ]))
    ], 64));
  }
}), G3 = { class: "flex w-full flex-col" }, K3 = { class: "@container flex flex-col" }, Y3 = {
  "data-testid": "address-input-zip-city",
  class: "grid grid-cols-1 gap-x-4 @sm:grid-cols-2"
}, J3 = { class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, X3 = "ri-map-pin-2-line", Ub = "ri-search-line", vG = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "AddressInput",
  props: {
    modelValue: { default: "" },
    details: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    ariaLabel: { default: void 0 },
    labelTooltip: { default: void 0 },
    options: { default: () => [] },
    loading: { type: Boolean, default: !1 },
    hint: { default: void 0 },
    error: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    countries: { default: () => [] },
    formatAddress: { type: Function, default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["update:modelValue", "update:details", "search", "select", "clear", "blur", "addMoreDetails"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = { line1: "", line2: "", line3: "", zip: "", city: "", country: "" }, o = m(() => ({
      addMoreDetails: t.labels.addMoreDetails ?? "Add more details",
      modalTitle: t.labels.modalTitle ?? "Edit address",
      line1: t.labels.line1 ?? "Address line 1",
      line2: t.labels.line2 ?? "Address line 2 (optional)",
      line3: t.labels.line3 ?? "Address line 3 (optional)",
      linePlaceholder: t.labels.linePlaceholder ?? "Enter a new address line",
      zip: t.labels.zip ?? "Zip code",
      city: t.labels.city ?? "City",
      country: t.labels.country ?? "Country",
      save: t.labels.save ?? "Save",
      cancel: t.labels.cancel ?? "Cancel",
      closeModal: t.labels.closeModal ?? "Close modal"
    })), r = R(t.modelValue);
    $e(
      () => t.modelValue,
      (_) => {
        r.value = _;
      }
    );
    const i = R({ ...l, ...t.details });
    $e(
      () => t.details,
      (_) => {
        i.value = { ...l, ..._ };
      },
      { deep: !0 }
    );
    const s = m(() => !!r.value), d = R(null);
    function c() {
      t.details || (i.value = { ...l });
    }
    function f(_) {
      c(), n("select", _);
    }
    function g() {
      i.value = { ...l }, n("clear");
    }
    function h(_) {
      r.value = _, n("update:modelValue", _);
    }
    function v(_) {
      c(), h(_);
    }
    function p(_) {
      var Z, le;
      t.disabled || (Z = _.target) != null && Z.closest(`.${Ub}`) && ((le = d.value) == null || le.focus());
    }
    const y = m(() => [
      "[&_.ri-search-line]:cursor-pointer",
      // AutoComplete sizes its icons `text-base`, a 24 px line box; Figma's icons are 16 px squares.
      "[&_.ri-map-pin-2-line]:text-(length:--icon-size-sm) [&_.ri-map-pin-2-line]:leading-(--icon-size-sm)",
      "[&_.ri-search-line]:text-(length:--icon-size-sm) [&_.ri-search-line]:leading-(--icon-size-sm)",
      s.value && !t.disabled ? "[&_input]:text-(--text-text-link) [&_input]:font-(--weight-medium)" : ""
    ]), k = R(!1), $ = Bn({ ...l }), S = `address-input-description-${Ye()}`;
    function I(_) {
      var D;
      const Z = ((D = t.countries.find((O) => O.value === _.country)) == null ? void 0 : D.label) ?? _.country, le = [_.zip, _.city].filter((O) => O.trim()).join(" ");
      return [_.line1, _.line2, _.line3, le, Z].filter((O) => O.trim());
    }
    const T = (_) => t.formatAddress ? t.formatAddress(_) : I(_).join(", "), A = m(() => I($));
    function E() {
      Object.assign($, i.value), k.value = !0, n("addMoreDetails");
    }
    function z() {
      const _ = { ...$ }, Z = T(_);
      k.value = !1, Z && (i.value = _, n("update:details", _), h(Z));
    }
    function B() {
      k.value = !1;
    }
    const W = m(() => [
      { id: "cancel", label: o.value.cancel, variant: "secondary", onClick: B, testId: "address-input-cancel" },
      { id: "save", label: o.value.save, variant: "primary", onClick: z, testId: "address-input-save" }
    ]);
    return (_, Z) => (u(), b("div", G3, [
      x("div", {
        "data-testid": "address-input-field",
        class: C(y.value),
        onClick: p
      }, [
        U(wx, Ve({
          ref_key: "autoCompleteRef",
          ref: d
        }, _.$attrs, {
          "model-value": r.value,
          label: e.label,
          required: e.required,
          placeholder: e.placeholder,
          "aria-label": e.label ? void 0 : e.ariaLabel,
          "label-tooltip": e.labelTooltip,
          options: e.options,
          loading: e.loading,
          hint: e.hint,
          error: e.error,
          disabled: e.disabled,
          "icon-left": X3,
          "icon-right": Ub,
          "keep-input-on-edit": "",
          "show-add-more-details": s.value,
          "add-more-details-label": o.value.addMoreDetails,
          onAddMoreDetails: E,
          "onUpdate:modelValue": v,
          onSearch: Z[0] || (Z[0] = (le) => n("search", le)),
          onSelect: f,
          onClear: g,
          onBlur: Z[1] || (Z[1] = (le) => n("blur"))
        }), null, 16, ["model-value", "label", "required", "placeholder", "aria-label", "label-tooltip", "options", "loading", "hint", "error", "disabled", "show-add-more-details", "add-more-details-label"])
      ], 2),
      U(dl, {
        modelValue: k.value,
        "onUpdate:modelValue": Z[8] || (Z[8] = (le) => k.value = le),
        size: "sm",
        title: o.value.modalTitle,
        "aria-close-label": o.value.closeModal,
        actions: W.value,
        "aria-describedby": A.value.length ? S : void 0
      }, {
        default: me(() => [
          x("div", K3, [
            U(Qt, {
              modelValue: $.line1,
              "onUpdate:modelValue": Z[2] || (Z[2] = (le) => $.line1 = le),
              "data-testid": "address-input-line1",
              label: o.value.line1,
              "full-width": ""
            }, null, 8, ["modelValue", "label"]),
            U(Qt, {
              modelValue: $.line2,
              "onUpdate:modelValue": Z[3] || (Z[3] = (le) => $.line2 = le),
              "data-testid": "address-input-line2",
              label: o.value.line2,
              placeholder: o.value.linePlaceholder,
              "full-width": ""
            }, null, 8, ["modelValue", "label", "placeholder"]),
            U(Qt, {
              modelValue: $.line3,
              "onUpdate:modelValue": Z[4] || (Z[4] = (le) => $.line3 = le),
              "data-testid": "address-input-line3",
              label: o.value.line3,
              placeholder: o.value.linePlaceholder,
              "full-width": ""
            }, null, 8, ["modelValue", "label", "placeholder"]),
            x("div", Y3, [
              U(Qt, {
                modelValue: $.zip,
                "onUpdate:modelValue": Z[5] || (Z[5] = (le) => $.zip = le),
                "data-testid": "address-input-zip",
                label: o.value.zip,
                "full-width": ""
              }, null, 8, ["modelValue", "label"]),
              U(Qt, {
                modelValue: $.city,
                "onUpdate:modelValue": Z[6] || (Z[6] = (le) => $.city = le),
                "data-testid": "address-input-city",
                label: o.value.city,
                "full-width": ""
              }, null, 8, ["modelValue", "label"])
            ]),
            U(yl, {
              modelValue: $.country,
              "onUpdate:modelValue": Z[7] || (Z[7] = (le) => $.country = le),
              "data-testid": "address-input-country",
              label: o.value.country,
              options: e.countries,
              "full-width": ""
            }, null, 8, ["modelValue", "label", "options"]),
            A.value.length ? (u(), P(yo, {
              key: 0,
              id: S,
              "data-testid": "address-input-description",
              color: "default",
              layout: "stacked",
              "aria-live": "off"
            }, {
              body: me(() => [
                x("p", J3, [
                  (u(!0), b(ie, null, Oe(A.value, (le, D) => (u(), b("span", {
                    key: D,
                    class: "block"
                  }, H(le), 1))), 128))
                ])
              ]),
              _: 1
            })) : w("", !0)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "aria-close-label", "actions", "aria-describedby"])
    ]));
  }
}), Z3 = { class: "flex w-full flex-col" }, Q3 = { class: "box-border flex w-full flex-col gap-1.5 p-[calc(--spacing(2)-1px)]" }, _3 = ["id"], e4 = {
  key: 1,
  class: "flex justify-center py-2"
}, t4 = {
  key: 2,
  class: "px-2 py-2 text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)",
  "data-testid": "relation-input-empty"
}, a4 = ["id", "aria-labelledby", "aria-label", "aria-owns", "aria-busy"], n4 = ["id", "aria-selected", "onClick", "onMouseenter"], l4 = { class: "flex min-w-0 flex-1 flex-col gap-px" }, o4 = {
  class: "truncate text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "relation-input-option-name"
}, r4 = {
  key: 0,
  class: "bg-transparent text-(--text-text-accent)"
}, i4 = {
  key: 0,
  class: "truncate text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--colors-text-white-secondary)"
}, s4 = /* @__PURE__ */ ke({
  __name: "RelationListbox",
  props: {
    listboxId: {},
    items: {},
    activeIndex: {},
    query: {},
    heading: {},
    name: {},
    loading: { type: Boolean },
    loadingLabel: {},
    emptyText: {}
  },
  emits: ["choose", "hover"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => `${t.listboxId}-heading`), o = m(
      () => t.items.map((f, g) => ({ item: f, index: g })).filter(
        (f) => f.item.kind === "record"
      )
    ), r = m(
      () => t.items.map((f, g) => ({ item: f, index: g })).filter(
        (f) => f.item.kind !== "record"
      )
    ), i = m(() => r.value.find((f) => f.item.kind === "viewAll")), s = m(() => r.value.find((f) => f.item.kind === "create")), d = m(() => r.value.map((f) => f.item.id).join(" ") || void 0), c = (f) => f.role ?? f.email;
    return (f, g) => {
      var h, v;
      return u(), b("div", Z3, [
        x("div", Q3, [
          e.heading ? (u(), b("div", {
            key: 0,
            id: l.value,
            class: "flex h-4 w-full items-end px-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
          }, H(e.heading), 9, _3)) : w("", !0),
          e.loading ? (u(), b("div", e4, [
            U(gc, {
              size: "sm",
              label: e.loadingLabel
            }, null, 8, ["label"])
          ])) : e.emptyText ? (u(), b("div", t4, H(e.emptyText), 1)) : w("", !0),
          x("div", {
            id: e.listboxId,
            role: "listbox",
            "aria-labelledby": e.heading ? l.value : void 0,
            "aria-label": e.heading ? void 0 : e.name,
            "aria-owns": d.value,
            "aria-busy": e.loading || void 0,
            class: C(["flex flex-col gap-1.5", d.value ? "empty:sr-only" : "empty:hidden"]),
            "data-testid": "relation-input-listbox"
          }, [
            (u(!0), b(ie, null, Oe(o.value, ({ item: p, index: y }) => (u(), b("div", {
              id: p.id,
              key: p.id,
              role: "option",
              "aria-selected": y === e.activeIndex,
              "data-testid": "relation-input-option",
              class: C([
                "flex h-[46px] cursor-pointer items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) p-2",
                y === e.activeIndex ? "bg-(--background-background-hover) dark:bg-white/8" : "hover:bg-(--background-background-hover) dark:hover:bg-white/8"
              ]),
              onClick: (k) => n("choose", p),
              onMouseenter: (k) => n("hover", y)
            }, [
              U(Jt, {
                name: p.record.label,
                img: p.record.avatarSrc,
                size: "sm",
                presentational: ""
              }, null, 8, ["name", "img"]),
              x("span", l4, [
                x("span", o4, [
                  (u(!0), b(ie, null, Oe([L(em)(p.record.label, e.query)], (k, $) => (u(), b(ie, { key: $ }, [
                    st(H(k.before), 1),
                    k.match ? (u(), b("mark", r4, H(k.match), 1)) : w("", !0),
                    st(H(k.after), 1)
                  ], 64))), 128))
                ]),
                c(p.record) ? (u(), b("span", i4, H(c(p.record)), 1)) : w("", !0)
              ]),
              p.record.badge ? (u(), P(yt, {
                key: 0,
                label: p.record.badge.label,
                theme: p.record.badge.color,
                size: "sm",
                "show-left-icon": !1,
                class: "shrink-0",
                "data-testid": "relation-input-option-badge"
              }, null, 8, ["label", "theme"])) : w("", !0)
            ], 42, n4))), 128))
          ], 10, a4)
        ]),
        r.value.length ? (u(), P(Dl, {
          key: 0,
          type: "see-all-create",
          "see-all-label": (h = i.value) == null ? void 0 : h.item.label,
          "see-all-option": i.value && {
            id: i.value.item.id,
            active: i.value.index === e.activeIndex,
            testId: "relation-input-view-all"
          },
          "create-label": (v = s.value) == null ? void 0 : v.item.label,
          "create-option": s.value && {
            id: s.value.item.id,
            active: s.value.index === e.activeIndex,
            testId: "relation-input-create"
          },
          onSeeAll: g[0] || (g[0] = (p) => i.value && n("choose", i.value.item)),
          onCreate: g[1] || (g[1] = (p) => s.value && n("choose", s.value.item)),
          onOptionHover: g[2] || (g[2] = (p) => n("hover", (p === "see-all" ? i.value : s.value).index))
        }, null, 8, ["see-all-label", "see-all-option", "create-label", "create-option"])) : w("", !0)
      ]);
    };
  }
}), Gl = ko(null), d4 = ["id", "role", "aria-labelledby"], u4 = { class: "opal-popover-inner" }, c4 = { class: "opal-popover-header flex h-8 items-center justify-between ps-3 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)" }, f4 = {
  key: 0,
  class: "opal-popover-record mb-1 flex min-w-0 flex-col"
}, h4 = {
  key: 0,
  class: "flex items-start justify-between gap-2"
}, b4 = {
  key: 0,
  class: "opal-popover-avatar"
}, g4 = {
  key: 1,
  class: "opal-popover-action ml-auto shrink-0"
}, m4 = {
  key: 2,
  class: "opal-popover-badges mt-px flex flex-wrap gap-1.5"
}, v4 = { class: "opal-popover-content" }, p4 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "Popover",
  props: {
    header: {},
    position: { default: "bottom" },
    delay: { default: 400 },
    closeDelay: { default: 100 },
    disabled: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    interactive: { type: Boolean, default: !1 },
    closable: { type: Boolean, default: !1 },
    closeLabel: { default: "Close" },
    minWidth: { default: void 0 },
    maxWidth: { default: "255px" }
  },
  emits: ["update:open"],
  setup(e, { emit: a }) {
    var Ne;
    const t = rc(), n = e, l = a, o = Ia(), r = () => ["avatar", "title", "badges", "action"].some(o), i = Ye(), s = `${i}-header`, d = `${i}-body`, c = R(n.position), f = () => c.value === "bottom" ? "var(--background-background-white-secondary)" : "var(--colors-white-50-opacity-bold)", g = R(null), h = R(null), v = R(!1), p = R(!1), y = Symbol("popover"), k = m(() => n.open !== void 0), $ = m(() => k.value ? n.open === !0 : v.value), S = m(() => n.interactive || n.closable), I = typeof process < "u" && ((Ne = process.env) == null ? void 0 : Ne.NODE_ENV) !== "production", T = m(
      () => S.value ? {
        "aria-haspopup": "dialog",
        "aria-expanded": $.value,
        "aria-controls": $.value ? i : void 0
      } : { "aria-describedby": $.value ? d : void 0 }
    );
    let A = null, E = null, z = null, B = null, W = !1, _ = null, Z = !1;
    const le = (De) => De === "top" || De === "bottom", D = {
      name: "syncSide",
      enabled: !0,
      phase: "afterWrite",
      fn: ({ state: De, instance: qe }) => {
        const Qe = c.value;
        c.value = De.placement.split("-")[0], le(Qe) !== le(c.value) && Ze(() => qe.update());
      }
    }, O = () => {
      _ == null || _.disconnect(), _ = null, A == null || A.destroy(), A = null;
    };
    $e(
      $,
      async (De) => {
        if (!De) {
          Z = !1, M();
          return;
        }
        if (c.value = n.position, await Ze(), !$.value || !g.value || !h.value) return;
        O();
        const qe = fl(g.value, h.value, {
          placement: n.position,
          modifiers: [
            // Arrow height: the caret tip touches the trigger.
            { name: "offset", options: { offset: [0, 10] } },
            { name: "arrow", options: { element: ".opal-popover-arrow", padding: 12 } },
            {
              name: "flip",
              // altAxis off: near the top or bottom edge a side bubble is shifted, not flipped.
              options: { fallbackPlacements: qg[n.position], altAxis: !1 }
            },
            { name: "preventOverflow", options: { padding: Ug } },
            D
          ],
          // The first pass measures the caret before the side's CSS (10×40 on left/right) applies.
          onFirstUpdate: () => void qe.update()
        });
        A = qe, typeof ResizeObserver < "u" && (_ = new ResizeObserver(() => void qe.update()), _.observe(h.value));
      },
      { immediate: !0 }
    );
    const N = () => {
      E && (clearTimeout(E), E = null);
    }, V = () => {
      z && (clearTimeout(z), z = null);
    };
    function M() {
      Gl.value === y && (Gl.value = null), p.value = !1, document.removeEventListener("pointerdown", q, !0);
    }
    const Q = () => {
      if (k.value) {
        l("update:open", !1);
        return;
      }
      M(), v.value = !1;
    };
    function q(De) {
      Se(g.value, De.target) || Se(h.value, De.target) || Q();
    }
    const K = () => {
      !n.closable || n.disabled || k.value || p.value || (N(), V(), Gl.value = y, p.value = !0, v.value = !0, document.addEventListener("pointerdown", q, !0));
    };
    $e(Gl, (De) => {
      p.value && De !== y && Q();
    });
    const G = () => !n.disabled && !k.value && !(Gl.value && Gl.value !== y), te = () => {
      G() && (V(), !E && (E = setTimeout(() => {
        v.value = !0, E = null;
      }, n.delay)));
    }, ve = () => {
      k.value || (N(), V(), z = setTimeout(Q, n.closeDelay));
    }, Se = (De, qe) => !!De && qe instanceof Node && De.contains(qe), oe = () => {
      p.value || Se(h.value, document.activeElement) || Se(g.value, document.activeElement) || ve();
    }, re = () => (B != null && B.isConnected ? B : null) ?? (g.value ? qn(g.value)[0] ?? null : null), ge = (De) => {
      De.target instanceof HTMLElement && (B = De.target), W || te();
    }, de = () => {
      Z = !0, V();
    }, Ee = () => {
      Z = !1, oe();
    }, j = (De) => De.relatedTarget === null && (document.activeElement === De.target || Z), J = () => p.value ? Q() : ve(), ne = (De) => {
      j(De) || Se(h.value, De.relatedTarget) || J();
    }, Y = (De) => {
      j(De) || Se(h.value, De.relatedTarget) || Se(g.value, De.relatedTarget) || J();
    }, F = (De) => void Ze(
      () => (
        // Two frames: the first can already be pending and fire in the same task as the re-render.
        requestAnimationFrame(
          () => requestAnimationFrame(() => {
            W = !0;
            try {
              De == null || De.focus();
            } finally {
              W = !1;
            }
          })
        )
      )
    ), ee = () => {
      const De = re();
      Q(), k.value || F(De);
    }, ue = (De) => {
      var Ie;
      if (!$.value) return;
      De.stopPropagation(), De.preventDefault();
      const qe = document.activeElement, Qe = Se(h.value, qe) || p.value && (!qe || qe === document.body), lt = re();
      Q(), I && k.value && !((Ie = t == null ? void 0 : t.vnode.props) != null && Ie["onUpdate:open"]) && console.warn(
        "[OPAL Popover] Escape was consumed and emitted as `update:open(false)`, but no `update:open` listener is bound: nothing can close this controlled popover. Listen for the emit (`v-model:open`), or Escape does nothing."
      ), !(!Qe || k.value) && F(lt);
    }, se = Symbol("popover"), X = (De) => {
      De.key !== "Escape" || De.defaultPrevented || On(se) && ue(De);
    }, ae = () => {
      document.removeEventListener("keydown", X), _a(se);
    }, Re = m(() => $.value && !k.value);
    $e(Re, (De) => {
      De ? (xn(se), document.addEventListener("keydown", X)) : ae();
    });
    const Ae = (De) => {
      if (De.key === "Escape") {
        ue(De);
        return;
      }
      if ((De.key === "Enter" || De.key === " ") && !De.repeat && De.target instanceof Element && De.target.matches("[aria-haspopup='dialog']") && n.interactive && !n.closable && !$.value && G()) {
        De.key === " " && De.preventDefault(), N(), V(), v.value = !0;
        return;
      }
      if (De.key !== "Tab" || De.shiftKey || !S.value || !$.value || !h.value)
        return;
      const qe = qn(h.value)[0];
      qe && (xe(De), qe.focus());
    }, xe = (De) => {
      De.preventDefault(), De.stopPropagation();
    }, we = () => {
      const De = re();
      if (!De) return;
      const qe = yy(document.body).filter((lt) => {
        if (Se(h.value, lt)) return !1;
        const Ie = lt.closest("[role='dialog'], [role='alertdialog']");
        return !Ie || Ie.contains(De);
      }), Qe = qe.indexOf(De);
      return Qe < 0 ? void 0 : qe[Qe + 1];
    }, fe = (De) => {
      var lt;
      if (De.key === "Escape") {
        ue(De);
        return;
      }
      if (De.key !== "Tab" || !S.value || !h.value) return;
      const qe = qn(h.value), Qe = document.activeElement;
      if (De.shiftKey && Qe === qe[0])
        xe(De), (lt = re()) == null || lt.focus();
      else if (!De.shiftKey && Qe === qe[qe.length - 1]) {
        const Ie = we();
        if (!Ie) return;
        xe(De), Ie.focus(), k.value || Q();
      }
    };
    return Tt(() => {
      N(), V(), M(), ae(), O();
    }), (De, qe) => (u(), b(ie, null, [
      x("div", Ve({
        ref_key: "triggerRef",
        ref: g,
        class: "inline-flex"
      }, De.$attrs, {
        onMouseenter: te,
        onMouseleave: oe,
        onFocusin: ge,
        onFocusout: ne,
        onKeydown: Ae,
        onClick: K
      }), [
        Me(De.$slots, "trigger", { triggerProps: T.value }, void 0, !0)
      ], 16),
      (u(), P(Fa, { to: "body" }, [
        U(Wt, {
          name: "opal-popover",
          onAfterLeave: O
        }, {
          default: me(() => [
            $.value ? (u(), b("div", {
              key: 0,
              id: L(i),
              ref_key: "bubbleRef",
              ref: h,
              role: S.value ? "dialog" : "tooltip",
              "aria-labelledby": S.value ? s : void 0,
              class: C(["opal-popover absolute z-9999", `opal-popover--${c.value}`]),
              style: Ge({ minWidth: n.minWidth, maxWidth: n.maxWidth }),
              "data-focus-trap-allow-outside": "",
              onMouseenter: de,
              onMouseleave: Ee,
              onFocusin: K,
              onFocusout: Y,
              onKeydown: fe
            }, [
              x("div", u4, [
                x("div", c4, [
                  x("span", {
                    id: s,
                    class: "min-w-0"
                  }, H(n.header), 1),
                  n.closable ? (u(), P(Be, {
                    key: 0,
                    variant: "ghost",
                    size: "xs",
                    "icon-only": "",
                    "icon-left": "ri-close-line",
                    "aria-label": n.closeLabel,
                    class: "opal-popover-close shrink-0",
                    onClick: ee
                  }, null, 8, ["aria-label"])) : w("", !0)
                ]),
                x("div", {
                  id: d,
                  class: "opal-popover-body p-3 text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"
                }, [
                  r() ? (u(), b("div", f4, [
                    L(o)("avatar") || L(o)("action") ? (u(), b("div", h4, [
                      L(o)("avatar") ? (u(), b("div", b4, [
                        Me(De.$slots, "avatar", {}, void 0, !0)
                      ])) : w("", !0),
                      L(o)("action") ? (u(), b("div", g4, [
                        Me(De.$slots, "action", {}, void 0, !0)
                      ])) : w("", !0)
                    ])) : w("", !0),
                    L(o)("title") ? (u(), b("div", {
                      key: 1,
                      class: C(["opal-popover-title min-w-0 font-(--weight-semi-bold)", { "mt-0.5": L(o)("avatar") || L(o)("action") }])
                    }, [
                      Me(De.$slots, "title", {}, void 0, !0)
                    ], 2)) : w("", !0),
                    L(o)("badges") ? (u(), b("div", m4, [
                      Me(De.$slots, "badges", {}, void 0, !0)
                    ])) : w("", !0)
                  ])) : w("", !0),
                  x("div", v4, [
                    Me(De.$slots, "default", {}, void 0, !0)
                  ])
                ])
              ]),
              x("div", {
                class: "opal-popover-arrow",
                "aria-hidden": "true",
                style: Ge({ "--arrow-bg": f() })
              }, [...qe[0] || (qe[0] = [
                x("svg", {
                  viewBox: "0 0 40 10",
                  width: "40",
                  height: "10",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  x("path", {
                    class: "opal-popover-arrow-fill",
                    d: "M 0 0 L 6.59 0 Q 10.59 0 13.33 2.91 L 17.26 7.09 Q 20 10 22.74 7.09 L 26.67 2.91 Q 29.41 0 33.41 0 L 40 0 Z"
                  }),
                  x("path", {
                    class: "opal-popover-arrow-outline",
                    d: "M 6.59 0 Q 10.59 0 13.33 2.91 L 17.26 7.09 Q 20 10 22.74 7.09 L 26.67 2.91 Q 29.41 0 33.41 0"
                  })
                ], -1)
              ])], 4)
            ], 46, d4)) : w("", !0)
          ]),
          _: 3
        })
      ]))
    ], 64));
  }
}), Cx = /* @__PURE__ */ Ct(p4, [["__scopeId", "data-v-0eb73eba"]]), x4 = {
  key: 0,
  class: "block truncate"
}, y4 = {
  key: 1,
  class: "block truncate text-(--text-text-body)"
}, k4 = /* @__PURE__ */ ke({
  __name: "RelationPopover",
  props: {
    record: {},
    linkId: {},
    header: {},
    viewRecordLabel: {},
    disabled: { type: Boolean },
    linkClass: {}
  },
  setup(e) {
    return (a, t) => (u(), P(Cx, {
      header: e.header,
      position: "top",
      interactive: "",
      delay: 0,
      "min-width": "260px",
      "max-width": "none",
      disabled: e.disabled,
      class: "min-w-0 max-w-full"
    }, Xa({
      trigger: me(({ triggerProps: n }) => [
        (u(), P(gt(e.record.href ? "a" : "span"), Ve({ id: e.linkId }, n, {
          href: e.record.href,
          tabindex: e.record.href ? void 0 : 0,
          role: e.record.href ? void 0 : "button",
          "data-testid": "relation-input-link",
          class: ["min-w-0 truncate rounded-(--border-border-radius-rounded-xs) font-(--weight-medium) hover:underline focus-visible:underline focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-hidden", e.linkClass]
        }), {
          default: me(() => [
            st(H(e.record.label), 1)
          ]),
          _: 1
        }, 16, ["id", "href", "tabindex", "role", "class"]))
      ]),
      avatar: me(() => [
        U(Jt, {
          name: e.record.label,
          img: e.record.avatarSrc,
          size: "md"
        }, null, 8, ["name", "img"])
      ]),
      title: me(() => [
        U(it, {
          text: e.record.label
        }, null, 8, ["text"])
      ]),
      default: me(() => [
        e.record.email ? (u(), b("span", x4, H(e.record.email), 1)) : w("", !0),
        e.record.role ? (u(), b("span", y4, H(e.record.role), 1)) : w("", !0)
      ]),
      _: 2
    }, [
      e.record.href ? {
        name: "action",
        fn: me(() => [
          U(Be, {
            as: "a",
            href: e.record.href,
            variant: "primary",
            size: "xs",
            label: e.viewRecordLabel
          }, null, 8, ["href", "label"])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["header", "disabled"]));
  }
}), w4 = ["id", "value", "aria-expanded", "aria-controls", "aria-activedescendant", "aria-required", "aria-invalid", "aria-label", "aria-describedby", "placeholder"], C4 = ["aria-label"], S4 = ["id", "value", "readonly", "disabled", "placeholder", "aria-label", "aria-describedby"], $4 = {
  class: "sr-only",
  role: "status",
  "data-testid": "relation-input-status"
}, pG = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "RelationInput",
  props: {
    modelValue: { default: null },
    recentRecords: { default: () => [] },
    results: { default: () => [] },
    loading: { type: Boolean, default: !1 },
    resultsCount: { default: void 0 },
    label: { default: void 0 },
    labelTooltip: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    id: { default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["update:modelValue", "select", "search", "clear", "restore", "view-all", "create"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = m(() => ({
      recent: n.labels.recent ?? "Recently viewed",
      viewAll: n.labels.viewAll ?? "View all results",
      linkRemoved: n.labels.linkRemoved ?? "Link removed",
      restore: n.labels.restore ?? "Restore",
      clear: n.labels.clear ?? "Remove link",
      viewRecord: n.labels.viewRecord ?? "View record",
      noResults: n.labels.noResults ?? "No results",
      recordDetails: n.labels.recordDetails ?? "Record details",
      resultCount: n.labels.resultCount ?? ((F) => `${F} results`),
      loading: n.labels.loading ?? "Loading"
    })), r = Ye(), i = m(() => n.id ?? `relation-input-${r}`), s = `relation-input-listbox-${r}`, d = `relation-input-hint-${r}`, c = `relation-input-error-${r}`, f = R(null), g = R(null), h = R(null), v = R(null), p = R(null), y = R(""), k = R(!1), $ = R(!1), S = R(!1), I = R(-1), T = R(null), A = m(() => !n.readonly && !n.disabled), E = m(() => y.value.trim() !== ""), z = m(() => !!n.modelValue), B = m(() => z.value && !E.value), W = `relation-input-link-${r}`, _ = m(() => {
      const F = [B.value && A.value && W, n.hint && d, n.error && c].filter(Boolean);
      return F.length ? F.join(" ") : void 0;
    }), Z = m(() => n.resultsCount ?? n.results.length), le = m(() => {
      const F = n.labels.create;
      if (F)
        return typeof F == "function" ? F(y.value.trim()) : F;
    }), D = m(() => {
      const F = E.value ? n.results : n.recentRecords, ee = n.loading ? [] : F.map((ue, se) => ({ kind: "record", id: `${s}-option-${se}`, record: ue }));
      return E.value && (!n.loading && Z.value > 0 && ee.push({ kind: "viewAll", id: `${s}-view-all`, label: `${o.value.viewAll} (${Z.value})` }), le.value && ee.push({ kind: "create", id: `${s}-create`, label: le.value })), ee;
    }), O = m(
      () => E.value && !n.loading && n.results.length === 0 ? o.value.noResults : void 0
    ), N = m(
      () => k.value && A.value && (E.value || n.loading || n.recentRecords.length > 0)
    ), V = m(() => !N.value || !E.value || n.loading ? "" : n.results.length ? o.value.resultCount(Z.value) : o.value.noResults), M = m(() => {
      var F;
      return (F = D.value[I.value]) == null ? void 0 : F.id;
    });
    $e(D, () => {
      I.value = -1;
    }), $e(
      () => n.modelValue,
      (F) => {
        F && (T.value = null);
      }
    );
    let Q = null;
    $e(N, async (F) => {
      var ue;
      if (Q == null || Q.destroy(), Q = null, !F) return;
      await Ze();
      const ee = (ue = g.value) == null ? void 0 : ue.$el;
      !ee || !h.value || (Q = fl(ee, h.value, {
        placement: "bottom-start",
        strategy: "fixed",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          kf
        ]
      }));
    }), $e(D, async () => {
      await Ze(), await (Q == null ? void 0 : Q.update());
    }), Tt(() => Q == null ? void 0 : Q.destroy());
    function q() {
      A.value && (T.value = null, k.value = !0);
    }
    function K() {
      k.value = !1, I.value = -1;
    }
    function G(F) {
      T.value = null, y.value = "", K(), l("update:modelValue", F), l("select", F);
    }
    function te(F) {
      if (F.kind === "record") {
        G(F.record);
        return;
      }
      const ee = y.value.trim();
      K(), F.kind === "viewAll" ? l("view-all", ee) : l("create", ee);
    }
    function ve() {
      var ee;
      const F = n.modelValue;
      F && (T.value = F, y.value = "", K(), l("update:modelValue", null), l("clear", F), (ee = f.value) == null || ee.focus());
    }
    function Se() {
      var ee;
      const F = T.value;
      F && (T.value = null, l("update:modelValue", F), l("restore", F), (ee = f.value) == null || ee.focus());
    }
    function oe(F) {
      y.value = F.target.value, T.value = null, q(), l("search", y.value);
    }
    function re(F) {
      var ue;
      if (!A.value) return;
      const ee = F.target;
      ee != null && ee.closest("a, button") || (ee !== f.value && (F.preventDefault(), (ue = f.value) == null || ue.focus()), q());
    }
    function ge() {
      $.value = !1, K(), y.value = "";
    }
    function de(F) {
      const ee = D.value.length;
      ee && (I.value = I.value === -1 ? F === 1 ? 0 : ee - 1 : (I.value + F + ee) % ee, Ze(() => {
        var ue, se;
        return (se = (ue = document.getElementById(M.value ?? "")) == null ? void 0 : ue.scrollIntoView) == null ? void 0 : se.call(ue, { block: "nearest" });
      }));
    }
    function Ee(F) {
      var ue, se;
      const ee = N.value;
      switch (F.key) {
        case "ArrowDown":
        case "ArrowUp": {
          F.preventDefault();
          const X = F.key === "ArrowDown" ? 1 : -1;
          if (!ee) {
            if (q(), F.altKey) return;
            Ze(() => de(X));
            return;
          }
          F.altKey || de(X);
          return;
        }
        case "Enter": {
          if (!ee) {
            E.value || (F.preventDefault(), q());
            return;
          }
          F.preventDefault();
          const X = D.value[I.value];
          X && te(X);
          return;
        }
        case " ": {
          !ee && !E.value && (F.preventDefault(), q());
          return;
        }
        case "Escape": {
          if (ee) {
            F.preventDefault(), F.stopPropagation(), K();
            return;
          }
          if (E.value || T.value) {
            F.preventDefault(), F.stopPropagation(), y.value = "", T.value = null;
            return;
          }
          (ue = v.value) == null || ue.handleFieldKeydown(F), (se = p.value) == null || se.handleFieldKeydown(F);
          return;
        }
        case "Tab": {
          const X = D.value[I.value];
          ee && (X == null ? void 0 : X.kind) === "record" && G(X.record);
          return;
        }
      }
    }
    function j(F) {
      const ee = F.currentTarget;
      S.value = ee.contains(F.relatedTarget);
    }
    const J = (F) => F || $.value || N.value ? "text-(--icons-icon-accent)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", ne = (F) => A.value && z.value && (F || S.value || N.value), Y = m(
      () => n.disabled ? "text-(--text-text-link)/44" : "text-(--text-text-link) dark:text-(--colors-text-link)"
    );
    return a({ focus: () => {
      var F;
      return (F = f.value) == null ? void 0 : F.focus();
    } }), (F, ee) => (u(), b(ie, null, [
      x("div", Ve(F.$attrs, {
        class: "flex w-full flex-col gap-px font-inter",
        "data-testid": "relation-input",
        onFocusin: ee[2] || (ee[2] = (ue) => S.value = !0),
        onFocusout: j
      }), [
        e.label ? (u(), P(Ft, {
          key: 0,
          ref_key: "labelRef",
          ref: v,
          text: e.label,
          "input-id": i.value,
          required: e.required,
          tooltip: e.labelTooltip,
          focused: $.value,
          "test-id": "relation-input-label"
        }, null, 8, ["text", "input-id", "required", "tooltip", "focused"])) : w("", !0),
        U(en, {
          ref_key: "shellRef",
          ref: g,
          size: e.size,
          disabled: e.disabled,
          readonly: e.readonly,
          error: !!e.error,
          focused: N.value,
          "has-value": z.value,
          class: C(A.value ? "cursor-text" : ""),
          "data-testid": "relation-input-field",
          onMousedown: re
        }, {
          default: me(({ hovered: ue, iconBoxClass: se, textClass: X }) => {
            var ae;
            return [
              A.value ? (u(), b(ie, { key: 0 }, [
                B.value && e.modelValue ? (u(), P(k4, {
                  key: 0,
                  record: e.modelValue,
                  header: o.value.recordDetails,
                  "view-record-label": o.value.viewRecord,
                  "link-id": W,
                  disabled: N.value,
                  "link-class": [X, Y.value]
                }, null, 8, ["record", "header", "view-record-label", "disabled", "link-class"])) : w("", !0),
                x("input", {
                  id: i.value,
                  ref_key: "inputRef",
                  ref: f,
                  value: y.value,
                  type: "text",
                  role: "combobox",
                  "aria-autocomplete": "list",
                  "aria-haspopup": "listbox",
                  "aria-expanded": N.value,
                  "aria-controls": N.value ? s : void 0,
                  "aria-activedescendant": N.value ? M.value : void 0,
                  "aria-required": e.required || void 0,
                  "aria-invalid": !!e.error || void 0,
                  "aria-label": e.label ? void 0 : e.ariaLabel,
                  "aria-describedby": _.value,
                  autocomplete: "off",
                  placeholder: z.value ? void 0 : e.placeholder,
                  "data-testid": "relation-input-input",
                  class: C(["min-w-0 flex-1 truncate border-0 bg-transparent p-0 font-(--weight-medium) text-(--text-text-black-default) outline-none placeholder:text-(--text-text-disabled-strong) dark:text-(--text-text-white-default) dark:placeholder:text-(--colors-text-white-secondary)", X]),
                  onInput: oe,
                  onFocus: ee[0] || (ee[0] = (Re) => $.value = !0),
                  onBlur: ge,
                  onKeydown: Ee
                }, null, 42, w4),
                ne(ue) ? (u(), b("button", {
                  key: 1,
                  type: "button",
                  "aria-label": o.value.clear,
                  "data-testid": "relation-input-clear",
                  class: C(["cursor-pointer rounded-(--border-border-radius-rounded-xs) text-(--icons-icon-dark-default) focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l) dark:text-(--icons-icon-white-default)", se]),
                  onMousedown: ee[1] || (ee[1] = _e(() => {
                  }, ["prevent"])),
                  onClick: ve
                }, [...ee[5] || (ee[5] = [
                  x("i", {
                    class: "ri-close-line",
                    "aria-hidden": "true"
                  }, null, -1)
                ])], 42, C4)) : (u(), b("i", {
                  key: 2,
                  class: C(["ri-search-line", [se, J(ue)]]),
                  "aria-hidden": "true",
                  "data-testid": "relation-input-search-icon"
                }, null, 2))
              ], 64)) : (u(), b("input", {
                key: 1,
                id: i.value,
                value: ((ae = e.modelValue) == null ? void 0 : ae.label) ?? "",
                type: "text",
                readonly: e.readonly,
                disabled: e.disabled,
                placeholder: e.placeholder,
                "aria-label": e.label ? void 0 : e.ariaLabel,
                "aria-describedby": _.value,
                "data-testid": "relation-input-input",
                class: C(["min-w-0 flex-1 truncate border-0 bg-transparent p-0 font-(--weight-medium) outline-none placeholder:text-(--text-text-disabled-strong)", [X, Y.value, e.readonly ? "cursor-default" : "cursor-not-allowed"]])
              }, null, 10, S4))
            ];
          }),
          _: 1
        }, 8, ["size", "disabled", "readonly", "error", "focused", "has-value", "class"]),
        T.value && A.value ? (u(), P(yo, {
          key: 1,
          class: "mt-1",
          color: "info",
          layout: "stacked",
          "buttons-position": "right",
          message: o.value.linkRemoved,
          buttons: [{ label: o.value.restore, variant: "tertiary", icon: "ri-arrow-left-line", onClick: Se }],
          "data-testid": "relation-input-removed"
        }, null, 8, ["message", "buttons"])) : w("", !0),
        U(Pt, {
          ref_key: "helperRef",
          ref: p,
          focused: $.value,
          hint: e.hint,
          error: e.error,
          "hint-id": d,
          "error-id": c,
          "test-id-prefix": "relation-input"
        }, null, 8, ["focused", "hint", "error"]),
        x("span", $4, H(V.value), 1)
      ], 16),
      (u(), P(Fa, { to: "body" }, [
        N.value ? (u(), b("div", {
          key: 0,
          ref_key: "panelRef",
          ref: h,
          class: C(["fixed z-[200] overflow-y-auto", [L(hl), L(xc)]]),
          "data-focus-trap-allow-outside": "",
          onMousedown: ee[4] || (ee[4] = _e(() => {
          }, ["prevent"]))
        }, [
          U(s4, {
            "listbox-id": s,
            items: D.value,
            "active-index": I.value,
            query: y.value,
            heading: E.value ? void 0 : o.value.recent,
            name: e.label ?? o.value.recent,
            loading: e.loading,
            "loading-label": o.value.loading,
            "empty-text": O.value,
            onChoose: te,
            onHover: ee[3] || (ee[3] = (ue) => I.value = ue)
          }, null, 8, ["items", "active-index", "query", "heading", "name", "loading", "loading-label", "empty-text"])
        ], 34)) : w("", !0)
      ]))
    ], 64));
  }
}), I4 = {
  key: 0,
  class: "sr-only"
}, L4 = {
  key: 1,
  class: "flex flex-wrap gap-1.5",
  "data-testid": "avatar-label-badges"
}, Sx = /* @__PURE__ */ ke({
  __name: "AvatarLabel",
  props: {
    name: {},
    helperText: { default: void 0 },
    type: { default: "heading-helper" },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    img: { default: void 0 },
    entity: { default: "contact" },
    avatarStyle: { default: "circle" },
    status: { default: void 0 },
    statusLabel: { default: void 0 },
    badges: { default: () => [] },
    maxBadges: { default: 3 },
    truncationFocusable: { type: Boolean, default: !0 }
  },
  setup(e) {
    const a = e, t = {
      "heading-helper": {
        sm: {
          avatar: "sm",
          gap: "gap-1.5",
          name: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)",
          helper: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)"
        },
        md: {
          avatar: "md",
          gap: "gap-2",
          name: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
          helper: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"
        },
        lg: {
          avatar: "lg",
          gap: "gap-2.5",
          name: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)",
          helper: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular)"
        },
        xl: {
          avatar: "xl",
          gap: "gap-2.5",
          name: "text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold)",
          helper: "text-(length:--size-xl) leading-(--line-height-xxl) font-(--weight-regular)"
        }
      },
      text: {
        sm: { avatar: "xs", gap: "gap-1.5", name: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium)" },
        md: { avatar: "sm", gap: "gap-1.5", name: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)" },
        lg: { avatar: "lg", gap: "gap-2", name: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold)" },
        xl: { avatar: "xl", gap: "gap-2", name: "text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold)" }
      }
    }, n = m(() => t[a.type][a.size]), l = m(() => {
      var g;
      return a.type === "heading-helper" && !!((g = a.helperText) != null && g.trim());
    }), o = m(() => a.type === "heading-helper" ? "xs" : "sm"), r = m(
      () => Es(a.badges, a.maxBadges).map((g) => ({
        ...g,
        theme: a.disabled ? "disabled" : g.theme ?? "neutral"
      }))
    ), i = m(() => a.type === "heading-helper" && r.value.length > 0), s = m(() => i.value ? "items-start" : "items-center"), d = m(
      () => i.value ? a.size === "xl" ? "mt-0.5" : "mt-1" : void 0
    ), c = m(
      () => a.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-heading)"
    ), f = m(
      () => a.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-body)"
    );
    return (g, h) => (u(), b("div", {
      class: C(["flex min-w-0", [n.value.gap, s.value]]),
      "data-testid": "avatar-label"
    }, [
      U(Jt, {
        name: e.name,
        img: e.img,
        size: n.value.avatar,
        entity: e.entity,
        "avatar-style": e.avatarStyle,
        status: e.status,
        "status-label": e.statusLabel,
        presentational: "",
        class: C([{ "opacity-70": e.disabled }, d.value])
      }, null, 8, ["name", "img", "size", "entity", "avatar-style", "status", "status-label", "class"]),
      x("div", {
        class: C(["flex min-w-0 flex-1 flex-col", e.type === "text" ? "gap-1" : "gap-px"])
      }, [
        x("div", {
          class: C(["flex min-w-0", [n.value.name, c.value]]),
          "data-testid": "avatar-label-name"
        }, [
          U(it, {
            text: e.name,
            focusable: e.truncationFocusable
          }, {
            default: me(() => {
              var v;
              return [
                e.status && ((v = e.statusLabel) != null && v.trim()) ? (u(), b("span", I4, ", " + H(e.statusLabel.trim()), 1)) : w("", !0)
              ];
            }),
            _: 1
          }, 8, ["text", "focusable"])
        ], 2),
        l.value ? (u(), b("div", {
          key: 0,
          class: C(["flex min-w-0", [n.value.helper, f.value]]),
          "data-testid": "avatar-label-helper"
        }, [
          U(it, {
            text: e.helperText,
            focusable: e.truncationFocusable
          }, null, 8, ["text", "focusable"])
        ], 2)) : w("", !0),
        r.value.length ? (u(), b("div", L4, [
          (u(!0), b(ie, null, Oe(r.value, (v, p) => (u(), b(ie, { key: p }, [
            L(Ts)(v) ? (u(), P(Ls, {
              key: 0,
              label: v.label,
              "hidden-labels": v.hiddenLabels,
              theme: v.theme,
              size: o.value,
              focusable: e.truncationFocusable
            }, null, 8, ["label", "hidden-labels", "theme", "size", "focusable"])) : (u(), P(yt, {
              key: 1,
              label: v.label,
              theme: v.theme,
              size: o.value,
              truncate: v.truncate ?? !1,
              "truncation-focusable": e.truncationFocusable,
              "show-close-icon": !1
            }, null, 8, ["label", "theme", "size", "truncate", "truncation-focusable"]))
          ], 64))), 128))
        ])) : w("", !0)
      ], 2)
    ], 2));
  }
}), T4 = { class: "modal-scrollbar border border-(--border-border-base-medium) dark:border-(--colors-border-base) rounded-xl p-1 overflow-y-auto max-h-135" }, E4 = {
  key: 0,
  class: "flex justify-center py-8"
}, A4 = {
  key: 1,
  class: "flex flex-col items-center gap-2 py-8 text-center"
}, R4 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, z4 = {
  key: 2,
  class: "flex flex-col items-center gap-2 py-8 text-center"
}, D4 = { class: "text-sm text-(--text-text-body-subtle)" }, B4 = ["aria-label"], M4 = ["aria-selected", "onClick"], O4 = { class: "flex items-center gap-1.5 min-w-0 flex-1" }, P4 = { class: "flex flex-col min-w-0" }, F4 = { class: "text-xs leading-5 font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, N4 = {
  key: 0,
  class: "text-xs leading-5 text-(--text-text-body) dark:text-(--text-text-white-default)"
}, xG = /* @__PURE__ */ ke({
  __name: "AutoCompleteAllResultsModal",
  props: {
    modelValue: { type: Boolean },
    options: {},
    title: {},
    subtitle: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    loadErrorLabel: { default: void 0 },
    emptyLabel: { default: void 0 },
    closeLabel: { default: void 0 },
    selectLabel: { default: void 0 }
  },
  emits: ["update:modelValue", "confirm"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = R(null);
    $e(
      () => t.modelValue,
      (d) => {
        d && (l.value = null);
      }
    );
    function o(d) {
      var c;
      return ((c = d.meta) == null ? void 0 : c.uniqueKey) ?? d.value;
    }
    function r(d) {
      const c = kx(d);
      return { label: c == null ? void 0 : c.label, theme: c == null ? void 0 : c.theme, leftIcon: c == null ? void 0 : c.icon, brandIcon: c == null ? void 0 : c.brandIcon };
    }
    const i = m(() => [
      {
        id: "close",
        label: t.closeLabel ?? "Close",
        variant: "secondary",
        testId: "autocomplete-all-results-close",
        onClick: () => n("update:modelValue", !1)
      },
      {
        id: "select",
        label: t.selectLabel ?? "Select",
        variant: "primary",
        testId: "autocomplete-all-results-select",
        icon: "ri-check-line",
        disabled: !l.value,
        onClick: s
      }
    ]);
    function s() {
      l.value && (n("confirm", l.value), n("update:modelValue", !1));
    }
    return (d, c) => (u(), P(L(dl), {
      "model-value": e.modelValue,
      size: "lg",
      "show-close-button": !0,
      "footer-align": "split",
      "overlay-class": "!z-[300]",
      "content-class": "!max-h-[748px]",
      "header-class": "pt-0!",
      title: e.title,
      subtitle: e.subtitle,
      actions: i.value,
      "onUpdate:modelValue": c[0] || (c[0] = (f) => d.$emit("update:modelValue", f))
    }, {
      default: me(() => [
        x("div", T4, [
          e.loading ? (u(), b("div", E4, [...c[1] || (c[1] = [
            x("i", { class: "ri-loader-4-line animate-spin text-2xl text-(--text-text-body-subtle)" }, null, -1)
          ])])) : e.error ? (u(), b("div", A4, [
            c[2] || (c[2] = x("i", { class: "ri-error-warning-line text-2xl text-red-500" }, null, -1)),
            x("span", R4, H(e.loadErrorLabel ?? "Unable to load results."), 1)
          ])) : e.options.length ? (u(), b("div", {
            key: 3,
            role: "listbox",
            "aria-label": e.title,
            class: "flex flex-col gap-0.5"
          }, [
            (u(!0), b(ie, null, Oe(e.options, (f) => (u(), b("button", {
              key: o(f),
              type: "button",
              role: "option",
              "aria-selected": !!l.value && o(l.value) === o(f),
              class: C([
                "flex items-center justify-between h-11.5 w-full p-2 rounded-lg cursor-pointer transition-colors text-left",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
                l.value && o(l.value) === o(f) ? "bg-(--colors-background-accent) dark:bg-indigo-950/20" : "bg-transparent hover:bg-(--colors-background-hover) dark:hover:bg-(--colors-background-hover)"
              ]),
              onClick: (g) => l.value = f
            }, [
              x("span", O4, [
                f.image !== void 0 ? (u(), P(L(Jt), {
                  key: 0,
                  as: "span",
                  img: f.image ?? void 0,
                  name: f.label,
                  size: "sm",
                  presentational: !0,
                  class: "border border-(--border-border-base-soft)"
                }, null, 8, ["img", "name"])) : w("", !0),
                x("span", P4, [
                  x("span", F4, H(f.label), 1),
                  f.description ? (u(), b("span", N4, H(f.description), 1)) : w("", !0)
                ])
              ]),
              f.badge ? (u(), P(mc, Ve({
                key: 0,
                ref_for: !0
              }, r(f), {
                size: "sm",
                class: "shrink-0 ml-2",
                "data-testid": "autocomplete-all-results-badge"
              }), null, 16)) : w("", !0)
            ], 10, M4))), 128))
          ], 8, B4)) : (u(), b("div", z4, [
            x("span", D4, H(e.emptyLabel ?? "No results to display."), 1)
          ]))
        ])
      ]),
      _: 1
    }, 8, ["model-value", "title", "subtitle", "actions"]));
  }
}), V4 = ["id", "name", "value", "placeholder", "disabled", "required", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby", "aria-activedescendant"], H4 = ["id", "aria-label"], j4 = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-400 dark:text-(--colors-text-white-secondary)"
}, W4 = ["id", "data-index", "aria-selected", "aria-disabled", "onMousedown", "onMouseenter"], q4 = /* @__PURE__ */ ke({
  __name: "TimePickerInput",
  props: {
    modelValue: { default: void 0 },
    label: { default: void 0 },
    placeholder: { default: "HH:mm" },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    showError: { type: Boolean, default: void 0 },
    hint: { default: void 0 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    minuteStep: { default: 15 },
    minTime: { default: void 0 },
    maxTime: { default: void 0 },
    gridStartTime: { default: void 0 },
    gridEndTime: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    groupPosition: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    ariaLabel: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "focus", "blur"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = R(!1), o = R(!1), r = R(null), i = R(null), s = R(""), d = R(-1), c = R(null), f = R(null), g = R(null);
    let h = null;
    const v = () => {
      !f.value || !c.value || (h == null || h.destroy(), h = fl(f.value, c.value, {
        strategy: "fixed",
        placement: "bottom-start",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          kf
        ]
      }));
    }, p = () => {
      h == null || h.destroy(), h = null;
    }, y = Ye(), k = m(() => t.id || y), $ = m(() => t.label ? `${k.value}-label` : void 0), S = m(() => `${k.value}-error`), I = m(() => `${k.value}-hint`), T = m(() => `${k.value}-listbox`), A = m(() => !!t.error), E = m(
      () => t.showError !== void 0 ? t.showError : A.value
    ), z = m(() => {
      if (t.ariaDescribedby) return t.ariaDescribedby;
      const J = [];
      return t.hint && J.push(I.value), A.value && E.value && J.push(S.value), J.length > 0 ? J.join(" ") : void 0;
    }), B = m(() => {
      const J = [], ne = t.minuteStep, Y = t.gridStartTime ? _(t.gridStartTime) : 0, F = t.gridEndTime ? _(t.gridEndTime) : 24 * 60 - 1;
      for (let ee = Y; ee <= F; ee += ne) {
        const ue = Math.floor(ee / 60).toString().padStart(2, "0"), se = (ee % 60).toString().padStart(2, "0");
        J.push(`${ue}:${se}`);
      }
      return J;
    }), W = m(() => {
      if (!s.value) return B.value;
      const J = s.value.replace(/[^0-9:]/g, "");
      return B.value.filter((ne) => ne.includes(J));
    });
    function _(J) {
      const [ne, Y] = J.split(":").map(Number);
      return ne * 60 + Y;
    }
    function Z(J) {
      if (!t.minTime && !t.maxTime) return !1;
      const ne = _(J), Y = t.minTime ? _(t.minTime) : 0, F = t.maxTime ? _(t.maxTime) : 24 * 60 - 1;
      return ne < Y || ne > F;
    }
    function le(J) {
      const ne = J.findIndex((Y) => !Z(Y));
      return ne >= 0 ? ne : 0;
    }
    function D(J, ne, Y) {
      let F = J;
      for (let ee = 0; ee < Y.length; ee++) {
        if (F += ne, F < 0 || F >= Y.length) return J;
        if (!Z(Y[F])) return F;
      }
      return J;
    }
    const N = {
      sm: {
        container: "h-[36px] px-2.5 gap-2",
        text: "text-sm leading-5",
        icon: "h-4 w-4"
      },
      md: {
        container: "h-[36px] px-3 py-2 gap-2",
        text: "text-sm leading-5",
        icon: "h-4 w-4"
      },
      lg: {
        container: "h-[48px] px-3.5 gap-2",
        text: "text-base leading-6",
        icon: "h-5 w-5"
      }
    }[t.size], V = m(() => t.groupPosition === "start" ? "rounded-r-none! border-r-0!" : t.groupPosition === "end" ? "rounded-l-none!" : ""), M = m(() => {
      const J = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      if (t.disabled)
        return `${J} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)`;
      if (A.value)
        return `${J} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-white dark:bg-(--colors-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-text-black-default dark:text-(--colors-text-white-default)`;
      if (o.value)
        return `${J} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-text-black-default dark:text-(--colors-text-white-default)`;
      const Y = t.modelValue !== void 0 && t.modelValue !== "" ? "text-text-black-default" : "text-text-body-subtle";
      return `${J} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--border-border-base-medium) hover:border-(--border-border-accent) dark:border-(--colors-border-base) transition-colors ${Y} dark:text-(--colors-text-white-default)`;
    }), Q = m(() => t.fullWidth ? "w-full" : ""), q = m(() => t.fullWidth ? {} : { width: t.width }), K = m(() => `relative flex items-start pb-0.5 text-left text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter flex-col gap-0.5 ${t.fullWidth ? "w-full" : ""}`), G = m(() => t.fullWidth ? {} : { width: t.width }), te = () => {
      if (t.disabled) return;
      l.value = !0, s.value = "";
      const J = B.value.indexOf(t.modelValue || "");
      J >= 0 ? d.value = J : t.modelValue ? d.value = -1 : d.value = le(B.value), Ee();
    }, ve = () => {
      l.value = !1, s.value = "", d.value = -1;
    }, Se = (J) => {
      var ne;
      Z(J) || (n("update:modelValue", J), n("change", J), ve(), (ne = f.value) == null || ne.focus());
    }, oe = (J) => {
      t.disabled || (o.value = !0, n("focus", J));
    }, re = (J) => {
      setTimeout(() => {
        var ne;
        (ne = g.value) != null && ne.contains(document.activeElement) || (o.value = !1, ve(), n("blur", J));
      }, 150);
    }, ge = (J) => {
      const ne = J.target;
      s.value = ne.value, l.value || te(), d.value = 0;
    }, de = (J) => {
      var Y, F;
      l.value || ((Y = r.value) == null || Y.handleFieldKeydown(J), (F = i.value) == null || F.handleFieldKeydown(J));
      const ne = W.value;
      switch (J.key) {
        case "ArrowDown":
          J.preventDefault(), l.value ? (d.value = D(d.value, 1, ne), Ee()) : te();
          break;
        case "ArrowUp":
          J.preventDefault(), l.value && (d.value = D(d.value, -1, ne), Ee());
          break;
        case "Enter":
          J.preventDefault(), l.value && d.value >= 0 && d.value < ne.length ? Se(ne[d.value]) : l.value || te();
          break;
        case "Escape":
          l.value && (J.stopPropagation(), J.preventDefault(), ve());
          break;
        case "Tab":
          ve();
          break;
      }
    }, Ee = () => {
      requestAnimationFrame(() => {
        var ne;
        const J = (ne = c.value) == null ? void 0 : ne.querySelector(`[data-index="${d.value}"]`);
        J == null || J.scrollIntoView({ block: "nearest" });
      });
    }, j = (J) => {
      g.value && !g.value.contains(J.target) && (ve(), o.value = !1);
    };
    return kt(() => {
      document.addEventListener("mousedown", j);
    }), zt(() => {
      document.removeEventListener("mousedown", j), p();
    }), $e(l, async (J) => {
      J ? (await Ze(), v()) : p();
    }), $e(s, () => {
      d.value = 0;
    }), (J, ne) => (u(), b("div", {
      ref_key: "containerRef",
      ref: g,
      class: C(K.value),
      style: Ge(G.value)
    }, [
      e.label ? (u(), P(Ft, {
        key: 0,
        id: $.value,
        ref_key: "labelRef",
        ref: r,
        text: e.label,
        "input-id": k.value,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: o.value,
        "test-id": "time-picker-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : w("", !0),
      x("div", {
        class: C(["relative", Q.value]),
        style: Ge(q.value)
      }, [
        x("div", {
          class: C([M.value, L(N).container, Q.value, V.value]),
          style: Ge(q.value),
          onClick: te
        }, [
          x("i", {
            class: C(["ri-time-line flex-shrink-0", [
              L(N).icon,
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : o.value ? "text-[#7c86ff]" : "text-gray-400 dark:text-(--colors-text-white-secondary)"
            ]])
          }, null, 2),
          x("input", {
            id: k.value,
            ref_key: "inputRef",
            ref: f,
            type: "text",
            name: e.name,
            value: l.value ? s.value : e.modelValue || "",
            placeholder: e.placeholder,
            disabled: e.disabled,
            required: e.required,
            autocomplete: "off",
            "data-testid": "time-picker-input",
            role: "combobox",
            "aria-expanded": l.value,
            "aria-controls": T.value,
            "aria-labelledby": $.value,
            "aria-label": e.ariaLabel,
            "aria-disabled": e.disabled ? "true" : "false",
            "aria-invalid": A.value ? "true" : void 0,
            "aria-describedby": z.value,
            "aria-activedescendant": l.value && d.value >= 0 ? `${k.value}-option-${d.value}` : void 0,
            class: C([
              "flex-1 min-w-0 bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 w-full",
              L(N).text,
              !e.disabled && "cursor-text"
            ]),
            onFocus: oe,
            onBlur: re,
            onInput: ge,
            onKeydown: de
          }, null, 42, V4)
        ], 6),
        wo(x("div", {
          id: T.value,
          ref_key: "dropdownRef",
          ref: c,
          role: "listbox",
          "aria-label": e.label || e.ariaLabel || "Time selection",
          class: "fixed z-50 max-h-[200px] overflow-auto rounded-xl border border-solid border-lightgray dark:border-(--colors-border-base) bg-white-50-opacity-bold dark:bg-(--colors-background-black-default) shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:shadow-(--blur-shadow-m-dark)",
          "data-testid": "time-picker-dropdown"
        }, [
          W.value.length === 0 ? (u(), b("div", j4, " Aucun horaire disponible ")) : w("", !0),
          (u(!0), b(ie, null, Oe(W.value, (Y, F) => (u(), b("div", {
            id: `${k.value}-option-${F}`,
            key: Y,
            "data-index": F,
            role: "option",
            "aria-selected": Y === e.modelValue,
            "aria-disabled": Z(Y) ? "true" : void 0,
            class: C(["px-3 py-2 text-sm transition-colors", [
              Z(Y) ? "cursor-not-allowed text-text-disabled dark:text-(--colors-text-disabled)" : "cursor-pointer",
              !Z(Y) && Y === e.modelValue ? "bg-[#7c86ff]/10 text-[#7c86ff] font-medium" : "",
              !Z(Y) && Y !== e.modelValue && F === d.value ? "bg-gray-100 dark:bg-[rgba(255,255,255,0.08)] text-text-black-default dark:text-(--colors-text-white-default)" : "",
              !Z(Y) && Y !== e.modelValue && F !== d.value ? "text-text-black-default dark:text-(--colors-text-white-default) hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)]" : ""
            ]]),
            onMousedown: _e((ee) => Se(Y), ["prevent"]),
            onMouseenter: (ee) => !Z(Y) && (d.value = F)
          }, H(Y), 43, W4))), 128))
        ], 8, H4), [
          [ic, l.value]
        ])
      ], 6),
      U(Pt, {
        ref_key: "helperRef",
        ref: i,
        focused: o.value,
        hint: e.hint,
        error: E.value ? e.error : void 0,
        "hint-id": I.value,
        "error-id": S.value,
        "test-id-prefix": "time-picker"
      }, null, 8, ["focused", "hint", "error", "hint-id", "error-id"])
    ], 6));
  }
}), yG = /* @__PURE__ */ Ct(q4, [["__scopeId", "data-v-60bc77d5"]]), U4 = {
  "data-testid": "number-range-input",
  class: "flex flex-col gap-4 w-full"
}, G4 = {
  key: 0,
  "data-testid": "number-range-slider",
  class: "relative w-full h-5"
}, K4 = ["min", "max", "step", "value", "disabled", "aria-label"], Y4 = ["min", "max", "step", "value", "disabled", "aria-label"], J4 = { class: "flex flex-1 min-w-0 flex-col gap-px" }, X4 = ["id", "value", "min", "max", "step", "placeholder", "disabled", "aria-label"], Z4 = { class: "shrink-0 py-2 font-(--weight-medium) text-(length:--size-m) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, Q4 = { class: "flex flex-1 min-w-0 flex-col gap-px" }, _4 = ["id", "value", "min", "max", "step", "placeholder", "disabled", "aria-label"], eO = {
  key: 1,
  "data-testid": "number-range-hint",
  class: "text-(length:--size-xs) leading-(--line-height-s) text-(--text-text-body-subtle) dark:text-(--colors-text-body-subtle) m-0"
}, tO = /* @__PURE__ */ ke({
  __name: "NumberRangeInput",
  props: {
    minValue: { default: null },
    maxValue: { default: null },
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 },
    minPlaceholder: { default: "0" },
    maxPlaceholder: { default: "" },
    separatorLabel: { default: "to" },
    showSlider: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    minAriaLabel: { default: "Minimum value" },
    maxAriaLabel: { default: "Maximum value" },
    minLabel: { default: void 0 },
    maxLabel: { default: void 0 },
    clampInputToBounds: { type: Boolean, default: !0 },
    dataMin: { default: null },
    dataMax: { default: null },
    hintLabel: { default: "" }
  },
  emits: ["update:minValue", "update:maxValue"],
  setup(e, { emit: a }) {
    const t = e, n = Ye(), l = Ye(), o = a, r = (T) => Math.max(t.min, Math.min(T, t.max)), i = R(r(t.minValue ?? t.min)), s = R(r(t.maxValue ?? t.max));
    $e(
      () => t.minValue,
      (T) => {
        i.value = r(T ?? t.min);
      }
    ), $e(
      () => t.maxValue,
      (T) => {
        s.value = r(T ?? t.max);
      }
    );
    const d = m(() => t.max - t.min || 1), c = m(() => (i.value - t.min) / d.value * 100), f = m(() => (s.value - t.min) / d.value * 100), g = m(() => ({
      left: `${c.value}%`,
      width: `${f.value - c.value}%`
    })), h = m(() => c.value > 50), v = m(
      () => t.dataMin != null && t.dataMax != null && t.dataMax > t.dataMin
    ), p = m(
      () => t.dataMin != null ? Math.max(0, Math.min(100, (t.dataMin - t.min) / d.value * 100)) : 0
    ), y = m(
      () => t.dataMax != null ? Math.max(0, Math.min(100, (t.dataMax - t.min) / d.value * 100)) : 100
    );
    function k(T) {
      const A = T.target, E = Number(A.value), z = Math.min(E, s.value - t.step);
      i.value = z, E !== z && (A.value = String(z)), o("update:minValue", z);
    }
    function $(T) {
      const A = T.target, E = Number(A.value), z = Math.max(E, i.value + t.step);
      s.value = z, E !== z && (A.value = String(z)), o("update:maxValue", z);
    }
    function S(T) {
      const A = T.target, E = A.value;
      if (E === "") {
        o("update:minValue", null);
        return;
      }
      const z = Number(E);
      if (Number.isFinite(z))
        if (i.value = r(z), t.clampInputToBounds) {
          const B = r(z);
          z !== B && (A.value = String(B)), o("update:minValue", B);
        } else
          o("update:minValue", z);
    }
    function I(T) {
      const A = T.target, E = A.value;
      if (E === "") {
        o("update:maxValue", null);
        return;
      }
      const z = Number(E);
      if (Number.isFinite(z))
        if (s.value = r(z), t.clampInputToBounds) {
          const B = r(z);
          z !== B && (A.value = String(B)), o("update:maxValue", B);
        } else
          o("update:maxValue", z);
    }
    return (T, A) => (u(), b("div", U4, [
      e.showSlider ? (u(), b("div", G4, [
        A[0] || (A[0] = x("div", { class: "absolute top-1/2 -translate-y-1/2 w-full h-2 rounded-(--border-border-radius-rounded-base) bg-(--background-background-gray)" }, null, -1)),
        v.value ? (u(), b(ie, { key: 0 }, [
          x("div", {
            "data-testid": "number-range-data-marker-min",
            class: "absolute top-1/2 -translate-y-1/2 h-3 w-px bg-(--border-border-base-soft) dark:bg-(--colors-border-base-soft) opacity-80 pointer-events-none",
            style: Ge({ left: `${p.value}%` }),
            "aria-hidden": "true"
          }, null, 4),
          x("div", {
            "data-testid": "number-range-data-marker-max",
            class: "absolute top-1/2 -translate-y-1/2 h-3 w-px bg-(--border-border-base-soft) dark:bg-(--colors-border-base-soft) opacity-80 pointer-events-none",
            style: Ge({ left: `${y.value}%` }),
            "aria-hidden": "true"
          }, null, 4)
        ], 64)) : w("", !0),
        x("div", {
          class: "absolute top-1/2 -translate-y-1/2 h-2 rounded-(--border-border-radius-rounded-base)",
          style: Ge({ ...g.value, background: "linear-gradient(36deg, #716FF2 11%, #52DBF5 87%)" })
        }, null, 4),
        x("input", {
          type: "range",
          min: e.min,
          max: e.max,
          step: e.step,
          value: i.value,
          disabled: e.disabled,
          "aria-label": e.minAriaLabel,
          class: C(["range-thumb absolute top-0 left-0 w-full h-5 appearance-none bg-transparent pointer-events-none", h.value ? "z-30" : "z-20"]),
          onInput: k
        }, null, 42, K4),
        x("input", {
          type: "range",
          min: e.min,
          max: e.max,
          step: e.step,
          value: s.value,
          disabled: e.disabled,
          "aria-label": e.maxAriaLabel,
          class: C(["range-thumb absolute top-0 left-0 w-full h-5 appearance-none bg-transparent pointer-events-none", h.value ? "z-20" : "z-30"]),
          onInput: $
        }, null, 42, Y4)
      ])) : w("", !0),
      x("div", {
        class: C(["flex gap-6 w-full", e.minLabel || e.maxLabel ? "items-end" : "items-center"])
      }, [
        x("div", J4, [
          e.minLabel ? (u(), P(Ft, {
            key: 0,
            text: e.minLabel,
            "input-id": L(n),
            "test-id": "number-range-min-label"
          }, null, 8, ["text", "input-id"])) : w("", !0),
          x("input", {
            id: L(n),
            type: "number",
            "data-testid": "number-range-min",
            value: e.minValue ?? "",
            min: e.clampInputToBounds ? e.min : void 0,
            max: e.clampInputToBounds ? e.max : void 0,
            step: e.step,
            placeholder: e.minPlaceholder,
            disabled: e.disabled,
            "aria-label": e.minLabel ? void 0 : e.minAriaLabel,
            class: "w-full bg-(--background-background-white) border border-solid border-(--border-border-base-soft) rounded-(--border-border-radius-rounded-l) px-3 py-2 text-(length:--size-m) font-inter leading-(--line-height-l) text-(--text-text-black-default) placeholder:text-(--text-text-body-subtle) outline-none focus:border-royalblue transition-colors disabled:opacity-50",
            onChange: S
          }, null, 40, X4)
        ]),
        x("span", Z4, H(e.separatorLabel), 1),
        x("div", Q4, [
          e.maxLabel ? (u(), P(Ft, {
            key: 0,
            text: e.maxLabel,
            "input-id": L(l),
            "test-id": "number-range-max-label"
          }, null, 8, ["text", "input-id"])) : w("", !0),
          x("input", {
            id: L(l),
            type: "number",
            "data-testid": "number-range-max",
            value: e.maxValue ?? "",
            min: e.clampInputToBounds ? e.min : void 0,
            max: e.clampInputToBounds ? e.max : void 0,
            step: e.step,
            placeholder: e.maxPlaceholder,
            disabled: e.disabled,
            "aria-label": e.maxLabel ? void 0 : e.maxAriaLabel,
            class: "w-full bg-(--background-background-white) border border-solid border-(--border-border-base-soft) rounded-(--border-border-radius-rounded-l) px-3 py-2 text-(length:--size-m) font-inter leading-(--line-height-l) text-(--text-text-black-default) placeholder:text-(--text-text-body-subtle) outline-none focus:border-royalblue transition-colors disabled:opacity-50",
            onChange: I
          }, null, 40, _4)
        ])
      ], 2),
      e.hintLabel ? (u(), b("p", eO, H(e.hintLabel), 1)) : w("", !0)
    ]));
  }
}), $x = /* @__PURE__ */ Ct(tO, [["__scopeId", "data-v-61d0ad59"]]), aO = { class: "inline-flex min-w-0 items-center gap-1" }, nO = { class: "inline-flex min-w-0 items-center gap-0.5" }, lO = ["for"], oO = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
}, Vd = /* @__PURE__ */ ke({
  __name: "ToggleLabel",
  props: {
    forId: {},
    text: {},
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    unavailable: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (a, t) => (u(), b("span", aO, [
      x("span", nO, [
        x("label", {
          for: e.forId,
          class: C(["min-w-0 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading) dark:text-(--colors-text-white-default)", e.unavailable ? "cursor-not-allowed" : "cursor-pointer"])
        }, H(e.text), 11, lO),
        e.required ? (u(), b("span", oO, "*")) : w("", !0)
      ]),
      e.labelTooltip ? (u(), P($t, {
        key: 0,
        text: e.labelTooltip,
        as: "span",
        "labels-trigger": "",
        role: "img",
        tabindex: "0",
        "aria-label": e.labelTooltip,
        class: "shrink-0 rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
      }, {
        default: me(() => [...t[0] || (t[0] = [
          x("i", {
            class: "ri-question-line text-(length:--icon-size-xs) leading-none text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
            "aria-hidden": "true"
          }, null, -1)
        ])]),
        _: 1
      }, 8, ["text", "aria-label"])) : w("", !0)
    ]));
  }
}), Ix = Symbol("ToggleGroup"), rO = { class: "flex min-w-0 flex-[1_1_11rem] flex-col gap-2" }, iO = { class: "flex h-8 w-22.5 shrink-0 items-center" }, sO = ["for"], dO = ["id"], uO = ["data-testid"], cO = ["id", "name", "checked", "disabled", "aria-disabled", "onChange"], fO = {
  key: 0,
  class: "whitespace-nowrap text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, hO = { class: "sr-only" }, bO = { class: "flex min-w-0 items-start justify-between gap-2" }, gO = ["id"], mO = ["id"], vO = { class: "flex min-w-0 flex-[1_1_11rem] items-center gap-2.5" }, pO = { class: "flex min-w-0 flex-1 flex-col gap-0.5" }, xO = ["id"], yO = "label, a, button, input, select, textarea, summary, [role=button], [role=link], [tabindex]", Hd = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)", Po = "min-w-0 rounded-(--border-border-radius-rounded-l) border border-(--colors-border-base-soft) bg-(--colors-background-white) shadow-(--blur-shadow-xs) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)", kO = /* @__PURE__ */ ke({
  __name: "ToggleInput",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    description: { default: void 0 },
    type: { default: void 0 },
    icon: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    leftLabel: { default: void 0 },
    rightLabel: { default: void 0 },
    leftIcon: { default: void 0 },
    rightIcon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    id: { default: void 0 },
    ariaDescribedby: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = na(Ix, void 0), o = m(() => t.type ?? (l == null ? void 0 : l.value) ?? "advanced"), r = m(() => o.value === "left-right-label" || o.value === "left-right-icons"), i = m(() => o.value !== "default" && !r.value), s = m(() => t.disabled || t.ariaDisabled), d = Ye(), c = m(() => t.id ?? d), f = m(() => `${c.value}-description`), g = m(() => {
      const B = !!t.description && !r.value, W = [t.ariaDescribedby, B ? f.value : void 0].filter(Boolean);
      return W.length > 0 ? W.join(" ") : void 0;
    }), h = m(() => ({
      id: c.value,
      modelValue: t.modelValue,
      disabled: t.disabled,
      ariaDisabled: t.ariaDisabled,
      "aria-describedby": g.value,
      "onUpdate:modelValue": (B) => n("update:modelValue", B)
    })), v = hn("toggleSwitch");
    function p(B) {
      var O;
      const W = B.currentTarget, _ = B.target;
      if (B.detail > 1) {
        const N = _ == null ? void 0 : _.closest("label");
        N && W.contains(N) && B.preventDefault();
        return;
      }
      if (!i.value) return;
      const Z = (O = v.value) == null ? void 0 : O.$el;
      if (!Z || !_ || Z.contains(_) || Z.disabled) return;
      const le = _.closest(yO);
      if (le && W.contains(le)) return;
      const D = window.getSelection();
      D && !D.isCollapsed && W.contains(D.anchorNode) || (B.stopPropagation(), Z.click());
    }
    const y = hn("leftRadio"), k = hn("rightRadio"), $ = m(() => [
      { key: "left", right: !1, text: t.leftLabel, icon: t.leftIcon },
      { key: "right", right: !0, text: t.rightLabel, icon: t.rightIcon }
    ]);
    function S(B) {
      t.ariaDisabled && B.preventDefault();
    }
    function I(B, W = !1) {
      var _, Z;
      s.value || t.modelValue === B || (n("update:modelValue", B), W && ((Z = (_ = (B ? k : y).value) == null ? void 0 : _[0]) == null || Z.focus()));
    }
    async function T(B) {
      var _;
      I(B), await Ze();
      const W = (_ = (t.modelValue ? k : y).value) == null ? void 0 : _[0];
      W && !W.checked && (W.checked = !0);
    }
    const A = m(() => {
      const B = s.value ? "" : " cursor-pointer";
      switch (o.value) {
        case "default":
          return "flex min-w-0 items-start gap-2";
        case "simple":
          return `${Po} flex items-start gap-2.5 p-4${B}`;
        case "logo":
          return `${Po} flex flex-wrap items-start justify-between gap-x-16 gap-y-3 p-4${B}`;
        case "title-toggle":
          return `${Po} flex flex-col gap-2 p-4${B}`;
        case "toggle-text":
          return `${Po} flex items-center gap-2.5 px-4 py-3${B}`;
        case "left-right-label":
        case "left-right-icons":
          return "group inline-flex items-center gap-3";
        default:
          return `${Po} flex flex-wrap items-center justify-between gap-x-16 gap-y-3 px-4 py-3${B}`;
      }
    }), E = m(() => s.value ? "relative flex cursor-not-allowed" : "relative flex cursor-pointer"), z = m(
      () => r.value ? { role: "radiogroup", "aria-label": t.label, "aria-describedby": t.ariaDescribedby } : {}
    );
    return (B, W) => (u(), b("div", Ve({ class: A.value }, z.value, { onClick: p }), [
      o.value === "logo" ? (u(), b(ie, { key: 0 }, [
        x("div", rO, [
          x("div", iO, [
            Me(B.$slots, "logo")
          ]),
          x("label", {
            for: c.value,
            class: "sr-only"
          }, H(e.label), 9, sO),
          e.description ? (u(), b("p", {
            key: 0,
            id: f.value,
            class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
          }, H(e.description), 9, dO)) : w("", !0)
        ]),
        U(Un, Ve({
          ref_key: "toggleSwitch",
          ref: v
        }, h.value), null, 16)
      ], 64)) : r.value ? (u(!0), b(ie, { key: 1 }, Oe($.value, (_) => (u(), b(ie, {
        key: _.key
      }, [
        _.right ? (u(), P(Un, {
          key: 0,
          type: "default",
          presentational: "",
          "aria-hidden": "true",
          "data-testid": "toggle-input-switch",
          class: C(["group-has-focus-visible:shadow-(--shadow-focus-l) group-has-focus-visible:outline-2 group-has-focus-visible:outline-transparent", s.value ? "cursor-not-allowed" : "cursor-pointer"]),
          "model-value": e.modelValue,
          disabled: e.disabled,
          "aria-disabled": e.ariaDisabled,
          onClick: W[0] || (W[0] = (Z) => I(!e.modelValue, !0))
        }, null, 8, ["class", "model-value", "disabled", "aria-disabled"])) : w("", !0),
        x("label", {
          class: C(E.value),
          "data-testid": `toggle-input-${_.key}`
        }, [
          x("input", {
            id: `${c.value}-${_.key}`,
            ref_for: !0,
            ref: _.right ? "rightRadio" : "leftRadio",
            type: "radio",
            class: "absolute inset-0 m-0 size-full cursor-[inherit] appearance-none opacity-0",
            name: c.value,
            checked: e.modelValue === _.right,
            disabled: e.disabled,
            "aria-disabled": e.ariaDisabled ? "true" : void 0,
            onClick: S,
            onChange: (Z) => T(_.right)
          }, null, 40, cO),
          o.value === "left-right-label" ? (u(), b("span", fO, H(_.text), 1)) : (u(), b(ie, { key: 1 }, [
            x("i", {
              "aria-hidden": "true",
              class: C([_.icon, "block text-(length:--icon-size-md) leading-none text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"])
            }, null, 2),
            x("span", hO, H(_.text), 1)
          ], 64))
        ], 10, uO)
      ], 64))), 128)) : o.value === "title-toggle" ? (u(), b(ie, { key: 2 }, [
        x("div", bO, [
          U(Vd, {
            "for-id": c.value,
            text: e.label,
            required: e.required,
            "label-tooltip": e.labelTooltip,
            unavailable: s.value
          }, null, 8, ["for-id", "text", "required", "label-tooltip", "unavailable"]),
          U(Un, Ve({
            ref_key: "toggleSwitch",
            ref: v
          }, h.value), null, 16)
        ]),
        e.description ? (u(), b("p", {
          key: 0,
          id: f.value,
          class: C(Hd)
        }, H(e.description), 9, gO)) : w("", !0)
      ], 64)) : o.value === "default" || o.value === "simple" || o.value === "toggle-text" ? (u(), b(ie, { key: 3 }, [
        U(Un, Ve({
          ref_key: "toggleSwitch",
          ref: v
        }, h.value), null, 16),
        x("div", {
          class: C(["flex min-w-0 flex-col", o.value === "default" ? "gap-0.5" : o.value === "simple" ? "flex-1 gap-1" : "flex-1 gap-0.5"])
        }, [
          U(Vd, {
            "for-id": c.value,
            text: e.label,
            required: e.required,
            "label-tooltip": e.labelTooltip,
            unavailable: s.value
          }, null, 8, ["for-id", "text", "required", "label-tooltip", "unavailable"]),
          e.description ? (u(), b("p", {
            key: 0,
            id: f.value,
            class: C(Hd)
          }, H(e.description), 9, mO)) : w("", !0)
        ], 2)
      ], 64)) : (u(), b(ie, { key: 4 }, [
        x("div", vO, [
          e.icon ? (u(), P(aa, {
            key: 0,
            icon: e.icon,
            color: "white",
            size: "md",
            type: "square"
          }, null, 8, ["icon"])) : w("", !0),
          x("div", pO, [
            U(Vd, {
              "for-id": c.value,
              text: e.label,
              required: e.required,
              "label-tooltip": e.labelTooltip,
              unavailable: s.value
            }, null, 8, ["for-id", "text", "required", "label-tooltip", "unavailable"]),
            e.description ? (u(), b("p", {
              key: 0,
              id: f.value,
              class: C(Hd)
            }, H(e.description), 9, xO)) : w("", !0)
          ])
        ]),
        U(Un, Ve({
          ref_key: "toggleSwitch",
          ref: v
        }, h.value), null, 16)
      ], 64))
    ], 16));
  }
}), wO = ["aria-label"], kG = /* @__PURE__ */ ke({
  __name: "ToggleGroup",
  props: {
    type: { default: "default" },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    const a = e, t = {
      default: "simple",
      integration: "logo",
      settings: "advanced"
    };
    return wa(
      Ix,
      m(() => t[a.type])
    ), (n, l) => (u(), b("div", {
      role: "group",
      "aria-label": e.ariaLabel,
      class: "flex min-w-0 flex-col gap-4"
    }, [
      Me(n.$slots, "default")
    ], 8, wO));
  }
});
function Lx(e) {
  const a = R(e.value());
  let t;
  function n() {
    var s;
    t !== void 0 && (clearTimeout(t), t = void 0, (s = e.onPending) == null || s.call(e, !1));
  }
  function l(s) {
    n(), s !== e.value() && e.commit(s);
  }
  function o(s) {
    var d;
    if (a.value = s, e.debounce() <= 0 || s === "") return l(s);
    if (s === e.value()) return n();
    t === void 0 ? (d = e.onPending) == null || d.call(e, !0) : clearTimeout(t), t = setTimeout(() => l(a.value), e.debounce());
  }
  function r() {
    t !== void 0 && l(a.value);
  }
  function i(s) {
    n(), a.value = s;
  }
  return $e(e.value, (s) => {
    s !== a.value && i(s);
  }), Tt(n), { draft: a, input: o, flush: r, cancelPending: n, discardPending: i };
}
const CO = ["value", "placeholder", "aria-label", "title", "disabled"], SO = ["aria-label"], $O = /* @__PURE__ */ ke({
  __name: "CollapsibleSearch",
  props: {
    modelValue: {},
    placeholder: { default: "Search..." },
    labels: { default: void 0 },
    maxWidth: { default: "175px" },
    disabled: { type: Boolean, default: !1 },
    autoFocus: { type: Boolean, default: !0 },
    debounce: { default: 0 }
  },
  emits: ["update:modelValue", "expand", "collapse", "clear", "pending"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = { closeSearch: "Clear search" }, r = m(() => ({ ...o, ...n.labels })), i = R(n.modelValue.length > 0), s = R(null), d = R(null), { draft: c, input: f, flush: g, cancelPending: h, discardPending: v } = Lx({
      value: () => n.modelValue,
      debounce: () => n.debounce,
      commit: (I) => l("update:modelValue", I),
      onPending: (I) => l("pending", I)
    });
    $e(
      () => n.modelValue,
      (I) => {
        I.length > 0 && (i.value = !0);
      }
    );
    function p() {
      n.disabled || (i.value = !0, l("expand"), n.autoFocus && Ze(() => {
        var I;
        return (I = s.value) == null ? void 0 : I.focus();
      }));
    }
    function y() {
      c.value.length > 0 || (i.value = !1, l("collapse"));
    }
    function k() {
      h(), c.value = "", l("update:modelValue", ""), l("clear"), i.value = !1, Ze(() => {
        var I, T;
        return (T = (I = d.value) == null ? void 0 : I.$el) == null ? void 0 : T.focus();
      });
    }
    function $(I) {
      I.preventDefault(), I.stopPropagation(), k();
    }
    function S(I) {
      f(I.target.value);
    }
    return a({ discardPending: v }), (I, T) => i.value ? (u(), P(Wt, {
      key: 1,
      "enter-active-class": "transition-all duration-200 ease-out",
      "enter-from-class": "opacity-0 w-0!",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition-all duration-150 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0 w-0!"
    }, {
      default: me(() => [
        x("div", {
          class: "flex h-8 items-center gap-2 p-2 rounded-(--border-border-radius-rounded-l) overflow-hidden group w-(--cs-w)",
          style: Ge({ "--cs-w": e.maxWidth })
        }, [
          x("i", {
            class: C(["ri-search-line text-(length:--icon-size-sm) leading-(--icon-size-sm) shrink-0 transition-colors text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", L(c) ? "group-focus-within:text-(--icons-icon-accent)" : ""]),
            "aria-hidden": "true"
          }, null, 2),
          x("input", {
            ref_key: "inputRef",
            ref: s,
            type: "text",
            "data-testid": "collapsible-search-input",
            value: L(c),
            placeholder: e.placeholder,
            "aria-label": r.value.input ?? e.placeholder,
            title: L(c) || void 0,
            disabled: e.disabled,
            class: "flex-1 min-w-0 bg-transparent border-0 outline-none focus:outline-none focus:ring-0 p-0 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default) placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) text-ellipsis overflow-hidden",
            onInput: S,
            onBlur: y,
            onKeydown: [
              St($, ["escape"]),
              T[0] || (T[0] = St(
                //@ts-ignore
                (...A) => L(g) && L(g)(...A),
                ["enter"]
              ))
            ]
          }, null, 40, CO),
          x("button", {
            type: "button",
            class: "shrink-0 inline-flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) cursor-pointer rounded-(--border-border-radius-rounded-xs) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent",
            "aria-label": r.value.closeSearch,
            "data-testid": "collapsible-search-clear",
            onClick: k
          }, [...T[1] || (T[1] = [
            x("i", {
              class: "ri-close-circle-line text-(length:--icon-size-sm) leading-(--icon-size-sm)",
              "aria-hidden": "true"
            }, null, -1)
          ])], 8, SO)
        ], 4)
      ]),
      _: 1
    })) : (u(), P(Be, {
      key: 0,
      ref_key: "toggleRef",
      ref: d,
      variant: "tertiary",
      "icon-left": "ri-search-line",
      "icon-only": "",
      size: "xs",
      class: "[&_i]:text-(length:--icon-size-sm) [&_i]:leading-(--icon-size-sm)",
      "aria-label": e.placeholder,
      disabled: e.disabled,
      "data-testid": "collapsible-search-toggle",
      onClick: p
    }, null, 8, ["aria-label", "disabled"]));
  }
}), IO = ["id", "value", "placeholder", "aria-labelledby", "aria-label", "aria-invalid", "aria-required", "aria-describedby", "disabled", "readonly"], LO = /* @__PURE__ */ ke({
  __name: "TagInput",
  props: {
    modelValue: {},
    placeholder: { default: void 0 },
    ariaLabel: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    removeLabel: { default: void 0 },
    truncate: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = R(""), o = Ye(), r = m(() => `${o}-error`), i = `${o}-hint`, s = m(() => t.label ? `${o}-label` : void 0), d = m(() => {
      const G = [];
      return t.hint && G.push(i), t.error && G.push(r.value), G.length > 0 ? G.join(" ") : void 0;
    }), c = R(!1), f = R(null), g = R(null), h = R(null), v = R(null), p = m(() => t.disabled || t.readonly), y = m(() => t.modelValue.length > 0 || l.value !== ""), k = m(() => t.fullWidth || t.width === void 0), $ = m(() => t.size === "lg" || t.size === "xl" ? "lg" : "sm"), S = m(() => t.disabled ? "disabled" : "white"), I = m(() => t.disabled ? void 0 : "border-(--border-border-base-medium)!");
    function T(G) {
      G.currentTarget.contains(G.relatedTarget) || (c.value = !1);
    }
    const A = m(() => !c.value && t.modelValue.length > 0), E = R(Number.POSITIVE_INFINITY), z = m(
      () => A.value ? Math.max(0, t.modelValue.length - E.value) : 0
    ), B = m(() => t.modelValue.slice(t.modelValue.length - z.value)), W = (G) => {
      var Se, oe;
      if (t.disabled) return;
      const te = G.currentTarget, ve = (Se = G.target) == null ? void 0 : Se.closest('button, a, [role="button"], input, [tabindex]');
      ve && ve !== te && te.contains(ve) || (G.preventDefault(), (oe = h.value) == null || oe.focus());
    }, _ = (G) => A.value && G >= E.value;
    function Z() {
      var Ee, j;
      const G = (Ee = v.value) == null ? void 0 : Ee.$el;
      if (!G || !A.value) return;
      const te = getComputedStyle(G), ve = parseFloat(te.columnGap) || 0, Se = G.clientWidth - (parseFloat(te.paddingLeft) || 0) - (parseFloat(te.paddingRight) || 0), oe = Array.from(G.querySelectorAll(":scope > [data-tag-chip]")).map(
        (J) => J.getBoundingClientRect().width
      );
      if (oe.reduce((J, ne, Y) => J + ne + (Y > 0 ? ve : 0), 0) <= Se) {
        E.value = oe.length;
        return;
      }
      let ge = ((j = G.querySelector(":scope > [data-tag-overflow]")) == null ? void 0 : j.getBoundingClientRect().width) ?? 0, de = 0;
      for (const J of oe) {
        if (ge + ve + J > Se) break;
        ge += ve + J, de++;
      }
      E.value = de;
    }
    let le = null, D = 0;
    const O = () => {
      cancelAnimationFrame(D), D = requestAnimationFrame(Z);
    };
    function N() {
      var te;
      const G = (te = v.value) == null ? void 0 : te.$el;
      !le || !G || (le.disconnect(), le.observe(G), G.querySelectorAll(":scope > [data-tag-chip], :scope > [data-tag-overflow]").forEach((ve) => le.observe(ve)));
    }
    kt(() => {
      typeof ResizeObserver < "u" && (le = new ResizeObserver(O)), N(), Z();
    }), Er(() => {
      N(), Z();
    }), Tt(() => {
      le == null || le.disconnect(), le = null, cancelAnimationFrame(D);
    });
    function V(G) {
      l.value = "";
      const te = G.split(",").map((Se) => Se.trim()).filter((Se) => Se.length > 0), ve = [...t.modelValue];
      for (const Se of te)
        ve.includes(Se) || ve.push(Se);
      ve.length !== t.modelValue.length && n("update:modelValue", ve);
    }
    function M(G) {
      const te = G.target.value;
      if (te.endsWith(",")) {
        V(te.slice(0, -1));
        return;
      }
      l.value = te;
    }
    function Q(G) {
      G.preventDefault(), !t.readonly && V(l.value);
    }
    function q() {
      t.readonly || l.value === "" && t.modelValue.length > 0 && n("update:modelValue", t.modelValue.slice(0, -1));
    }
    function K(G) {
      var te;
      n("update:modelValue", t.modelValue.filter((ve, Se) => Se !== G)), (te = h.value) == null || te.focus();
    }
    return (G, te) => (u(), b("div", {
      class: C(["flex min-w-0 flex-col gap-0.5", k.value ? "w-full" : ""]),
      style: Ge(k.value ? void 0 : { width: e.width })
    }, [
      e.label ? (u(), P(Ft, {
        key: 0,
        id: s.value,
        ref_key: "labelRef",
        ref: f,
        text: e.label,
        "input-id": L(o),
        required: e.required,
        tooltip: e.labelTooltip,
        focused: c.value,
        "test-id": "tag-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "tooltip", "focused"])) : w("", !0),
      U(en, {
        ref_key: "shellRef",
        ref: v,
        role: "group",
        "aria-labelledby": s.value,
        "aria-label": e.label ? void 0 : e.ariaLabel,
        "aria-describedby": d.value,
        class: C(["w-full", A.value ? "flex-nowrap! overflow-hidden" : ""]),
        tags: "",
        size: e.size,
        disabled: e.disabled,
        readonly: e.readonly,
        error: !!e.error,
        success: e.success,
        "has-value": y.value,
        "focus-scope": "any",
        onFocusin: te[2] || (te[2] = (ve) => c.value = !0),
        onFocusout: T,
        onMousedown: W
      }, {
        default: me(({ textClass: ve }) => [
          (u(!0), b(ie, null, Oe(e.modelValue, (Se, oe) => (u(), b("span", {
            key: `${Se}-${oe}`,
            "data-tag-chip": "",
            class: C(["inline-flex", { "shrink-0": A.value, "order-2 invisible": _(oe) }])
          }, [
            U(yt, {
              label: Se,
              size: $.value,
              theme: S.value,
              truncate: e.truncate,
              class: C(I.value),
              "show-close-icon": "",
              "close-icon-inactive": p.value,
              "remove-label": `${e.removeLabel ?? ""} ${Se}`.trim(),
              onClose: (re) => K(oe)
            }, null, 8, ["label", "size", "theme", "truncate", "class", "close-icon-inactive", "remove-label", "onClose"])
          ], 2))), 128)),
          z.value > 0 ? (u(), b("span", {
            key: 0,
            "data-tag-overflow": "",
            class: "order-1 inline-flex shrink-0 cursor-pointer",
            onClick: te[0] || (te[0] = (Se) => {
              var oe;
              return (oe = h.value) == null ? void 0 : oe.focus();
            })
          }, [
            U(yt, {
              label: `+${z.value}`,
              size: $.value,
              theme: S.value,
              class: C(I.value),
              "tooltip-text": B.value.join(", ")
            }, null, 8, ["label", "size", "theme", "class", "tooltip-text"])
          ])) : w("", !0),
          x("input", {
            id: L(o),
            ref_key: "inputRef",
            ref: h,
            value: l.value,
            type: "text",
            class: C([
              "flex-1 border-0 bg-transparent p-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)",
              ve,
              A.value ? "order-1 min-w-0" : "min-w-20",
              e.readonly ? "cursor-default" : ""
            ]),
            placeholder: e.modelValue.length > 0 ? void 0 : e.placeholder,
            "aria-labelledby": s.value,
            "aria-label": e.label ? void 0 : e.ariaLabel,
            "aria-invalid": e.error ? "true" : void 0,
            "aria-required": e.required ? "true" : void 0,
            "aria-describedby": d.value,
            disabled: e.disabled,
            readonly: e.readonly,
            onKeydown: [
              te[1] || (te[1] = (Se) => {
                var oe, re;
                (oe = f.value) == null || oe.handleFieldKeydown(Se), (re = g.value) == null || re.handleFieldKeydown(Se);
              }),
              St(Q, ["enter"]),
              St(q, ["delete"])
            ],
            onInput: M
          }, null, 42, IO)
        ]),
        _: 1
      }, 8, ["aria-labelledby", "aria-label", "aria-describedby", "class", "size", "disabled", "readonly", "error", "success", "has-value"]),
      U(Pt, {
        ref_key: "helperRef",
        ref: g,
        focused: c.value,
        hint: e.hint,
        error: e.error,
        "hint-id": i,
        "error-id": r.value,
        "test-id-prefix": "tag-input"
      }, null, 8, ["focused", "hint", "error", "error-id"])
    ], 6));
  }
}), TO = { class: "inline-flex max-w-full min-w-0 flex-col gap-1" }, EO = ["aria-labelledby", "aria-label"], AO = {
  key: 0,
  "data-otp-separator": "",
  "aria-hidden": "true",
  class: "h-0 w-3 shrink-0 border-t-(length:--border-border-width-border-base) border-(--border-border-black-default) dark:border-(--border-border-white-default)"
}, RO = ["id", "value", "inputmode", "autocomplete", "aria-label", "aria-invalid", "aria-required", "aria-describedby", "disabled", "readonly", "onInput", "onPaste", "onKeydown"], wG = /* @__PURE__ */ ke({
  __name: "OtpInput",
  props: {
    modelValue: {},
    length: { default: 6 },
    size: { default: "md" },
    type: { default: "default" },
    numeric: { type: Boolean, default: !0 },
    label: { default: void 0 },
    ariaLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelTooltip: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    success: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    labels: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = { cell: "Digit {index} of {length}" }, o = m(() => ({ ...l, ...t.labels })), r = (q) => o.value.cell.replace("{index}", String(q + 1)).replace("{length}", String(t.length)), i = Ye(), s = (q) => `${i}-cell-${q}`, d = m(() => t.label ? `${i}-label` : void 0), c = `${i}-hint`, f = `${i}-error`, g = m(() => {
      const q = [];
      return t.hint && q.push(c), t.error && q.push(f), q.length > 0 ? q.join(" ") : void 0;
    }), h = (q) => Array.from({ length: t.length }, (K, G) => q[G] ?? ""), v = R(h(t.modelValue));
    $e(
      () => [t.modelValue, t.length],
      ([q]) => {
        (q !== v.value.join("") || v.value.length !== t.length) && (v.value = h(q));
      }
    );
    const p = R([]), y = R(!1), k = R(null), $ = R(null), S = (q) => {
      const K = Array.from(q.replace(/\s/g, ""));
      return t.numeric ? K.filter((G) => /\d/.test(G)) : K;
    };
    function I() {
      n("update:modelValue", v.value.join(""));
    }
    function T(q) {
      const K = p.value[Math.max(0, Math.min(q, t.length - 1))];
      K == null || K.focus(), K == null || K.select();
    }
    function A(q, K) {
      const G = K.length >= t.length ? 0 : q, te = K.slice(0, t.length - G);
      te.forEach((ve, Se) => {
        v.value[G + Se] = ve;
      }), I(), T(G + te.length);
    }
    function E(q, K) {
      const G = K.target, te = K, ve = te.inputType === "insertText" && te.data ? te.data : G.value, Se = S(ve);
      if (Se.length > 1) {
        G.value = v.value[q], A(q, Se);
        return;
      }
      if (Se.length === 0) {
        G.value === "" ? (v.value[q] = "", I()) : G.value = v.value[q];
        return;
      }
      v.value[q] = Se[0], G.value = Se[0], I(), q < t.length - 1 && T(q + 1);
    }
    function z(q, K) {
      var te;
      if (K.preventDefault(), t.readonly || t.disabled) return;
      const G = S(((te = K.clipboardData) == null ? void 0 : te.getData("text")) ?? "");
      G.length > 0 && A(q, G);
    }
    function B(q, K) {
      var G, te;
      switch ((G = k.value) == null || G.handleFieldKeydown(K), (te = $.value) == null || te.handleFieldKeydown(K), K.key) {
        case "ArrowLeft":
          K.preventDefault(), T(q - 1);
          return;
        case "ArrowRight":
          K.preventDefault(), T(q + 1);
          return;
        case "Home":
          K.preventDefault(), T(0);
          return;
        case "End":
          K.preventDefault(), T(t.length - 1);
          return;
        case "Backspace":
          if (K.preventDefault(), t.readonly) return;
          v.value[q] ? (v.value[q] = "", I()) : q > 0 && (v.value[q - 1] = "", I(), T(q - 1));
          return;
        case "Delete":
          if (K.preventDefault(), t.readonly || !v.value[q]) return;
          v.value[q] = "", I();
          return;
      }
    }
    function W(q) {
      var K, G;
      y.value = !0, (G = (K = q.target).select) == null || G.call(K);
    }
    function _(q) {
      q.currentTarget.contains(q.relatedTarget) || (y.value = !1);
    }
    const Z = 3, le = m(() => t.type === "separator" || t.type === "separator-spaced"), D = m(() => t.type === "spaced" || t.type === "separator-spaced"), O = m(() => {
      const q = le.value ? Z : t.length, K = [];
      for (let G = 0; G < t.length; G += q)
        K.push(Array.from({ length: Math.min(q, t.length - G) }, (te, ve) => G + ve));
      return K;
    }), N = {
      sm: "size-9 text-(length:--size-l) leading-(--line-height-xxl)",
      md: "size-10 text-(length:--size-l) leading-(--line-height-xxl)",
      lg: "size-12 text-(length:--size-4xl) leading-(--line-height-4xl)",
      xl: "size-13 text-(length:--size-4xl) leading-(--line-height-4xl)"
    }, V = "focus:shadow-[0_0_2px_2px_var(--background-background-hover)]", M = m(() => {
      if (t.disabled)
        return "bg-(--background-background-disabled-subtle) dark:bg-(--colors-background-disabled) border-(--border-border-disabled) dark:border-(--colors-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--colors-text-disabled) cursor-not-allowed";
      if (t.readonly)
        return `bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) border-(--border-border-base-medium) dark:border-(--border-border-base) focus:border-(--border-border-accent) ${V} text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      const q = "bg-(--background-background-white) dark:bg-(--background-background-black-default) text-(--text-text-black-default) dark:text-(--text-text-white-default)";
      return t.error ? `${q} border-(--border-border-error-strong) dark:border-(--border-border-error) ${V}` : t.success ? `${q} border-(--border-border-success-strong) ${V}` : `${q} border-(--border-border-base-medium) dark:border-(--border-border-base) focus:border-(--border-border-accent) ${V}`;
    });
    function Q(q, K) {
      const G = D.value ? "rounded-(--border-border-radius-rounded-l)" : [
        K === 0 ? "rounded-l-(--border-border-radius-rounded-l)" : "-ml-px",
        K === q.length - 1 ? "rounded-r-(--border-border-radius-rounded-l)" : ""
      ].join(" ");
      return [
        "relative box-border border border-solid p-0 text-center font-inter font-(--weight-bold) outline-none focus:z-10 focus:outline-none focus:ring-0",
        N[t.size],
        G,
        M.value
      ];
    }
    return (q, K) => (u(), b("div", TO, [
      e.label ? (u(), P(Ft, {
        key: 0,
        id: d.value,
        ref_key: "labelRef",
        ref: k,
        text: e.label,
        "input-id": s(0),
        required: e.required,
        "required-indicator": e.requiredIndicator,
        tooltip: e.labelTooltip,
        focused: y.value,
        "test-id": "otp-input-label"
      }, null, 8, ["id", "text", "input-id", "required", "required-indicator", "tooltip", "focused"])) : w("", !0),
      x("div", {
        role: "group",
        "data-otp-cells": "",
        "aria-labelledby": d.value,
        "aria-label": e.label ? void 0 : e.ariaLabel,
        class: C(["flex items-center", le.value || D.value ? "gap-2" : ""]),
        onFocusin: W,
        onFocusout: _
      }, [
        (u(!0), b(ie, null, Oe(O.value, (G, te) => (u(), b(ie, { key: te }, [
          te > 0 && le.value ? (u(), b("span", AO)) : w("", !0),
          x("div", {
            class: C(["flex items-center", D.value ? "gap-2" : ""])
          }, [
            (u(!0), b(ie, null, Oe(G, (ve, Se) => (u(), b("input", {
              id: s(ve),
              key: ve,
              ref_for: !0,
              ref: (oe) => {
                oe && (p.value[ve] = oe);
              },
              value: v.value[ve],
              type: "text",
              inputmode: e.numeric ? "numeric" : "text",
              autocomplete: ve === 0 ? "one-time-code" : "off",
              "aria-label": r(ve),
              "aria-invalid": e.error ? "true" : void 0,
              "aria-required": e.required ? "true" : void 0,
              "aria-describedby": g.value,
              disabled: e.disabled,
              readonly: e.readonly,
              class: C(Q(G, Se)),
              onInput: (oe) => E(ve, oe),
              onPaste: (oe) => z(ve, oe),
              onKeydown: (oe) => B(ve, oe)
            }, null, 42, RO))), 128))
          ], 2)
        ], 64))), 128))
      ], 42, EO),
      U(Pt, {
        ref_key: "helperRef",
        ref: $,
        focused: y.value,
        hint: e.hint,
        error: e.error,
        "hint-id": c,
        "error-id": f,
        "test-id-prefix": "otp-input"
      }, null, 8, ["focused", "hint", "error"])
    ]));
  }
}), zO = ["data-status", "aria-label", "disabled"], CG = /* @__PURE__ */ ke({
  __name: "LookupInput",
  props: {
    placeholder: {},
    modelValue: {},
    iconLeft: {},
    size: {},
    disabled: { type: Boolean },
    success: { type: Boolean },
    type: {},
    name: {},
    id: {},
    fullWidth: { type: Boolean },
    width: {},
    label: {},
    labelTooltip: {},
    required: { type: Boolean },
    requiredIndicator: {},
    labelInline: { type: Boolean },
    reserveHelper: { type: Boolean },
    ariaLabel: {},
    inputmode: {},
    autocomplete: {},
    pattern: {},
    maxlength: {},
    minlength: {},
    min: {},
    max: {},
    error: {},
    hint: {},
    ariaDescribedby: {},
    readonly: { type: Boolean },
    readonlyChrome: { type: Boolean, default: !0 },
    valueVariant: {},
    showEditIcon: { type: Boolean, default: !0 },
    variant: {},
    buttons: {},
    buttonLayout: {},
    buttonSize: {},
    innerButton: {},
    prefix: {},
    removeButton: {},
    status: { default: null },
    statusTitle: { default: void 0 },
    statusText: { default: void 0 },
    open: { type: Boolean, default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["update:open", "update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = {
      recognized: { icon: "ri-check-fill", color: "text-(--icons-icon-success)" },
      unrecognized: { icon: "ri-alert-line", color: "text-(--icons-icon-warning)" }
    }, o = m(() => t.statusTitle ? t.statusTitle : t.status === "unrecognized" ? t.labels.unrecognized ?? "Not recognized" : t.labels.recognized ?? "Recognized"), r = /* @__PURE__ */ new Set(["status", "statusTitle", "statusText", "open", "labels"]), i = m(
      () => Object.fromEntries(Object.entries(t).filter(([d]) => !r.has(d)))
    ), s = m(() => t.labels.clear ? { clear: t.labels.clear } : void 0);
    return (d, c) => (u(), P(Qt, Ve(i.value, {
      labels: s.value,
      "onUpdate:modelValue": c[1] || (c[1] = (f) => n("update:modelValue", f))
    }), Xa({ _: 2 }, [
      e.status ? {
        name: "iconRight",
        fn: me(({ iconBoxClass: f }) => [
          U(Cx, {
            header: o.value,
            position: "top",
            delay: 0,
            open: e.open,
            disabled: !e.statusText || e.disabled,
            "onUpdate:open": c[0] || (c[0] = (g) => n("update:open", g))
          }, {
            trigger: me(({ triggerProps: g }) => [
              x("button", Ve({ type: "button" }, g, {
                "data-testid": "lookup-input-status",
                "data-status": e.status,
                "aria-label": o.value,
                disabled: e.disabled,
                class: [
                  f,
                  l[e.status].color,
                  "rounded-(--border-border-radius-rounded-xs) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent"
                ]
              }), [
                x("i", {
                  class: C(l[e.status].icon),
                  "aria-hidden": "true"
                }, null, 2)
              ], 16, zO)
            ]),
            default: me(() => [
              st(" " + H(e.statusText), 1)
            ]),
            _: 2
          }, 1032, ["header", "open", "disabled"])
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["labels"]));
  }
}), DO = ["disabled", "aria-current"], BO = "inline-flex h-9 min-w-9 shrink-0 items-center justify-center whitespace-nowrap rounded-full border border-solid px-[calc(--spacing(2.5)-1px)] text-(length:--size-m) leading-(--line-height-m) font-(--weight-semi-bold) focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", MO = "cursor-pointer border-(--border-border-white-default) bg-(--background-background-white) text-(--text-text-black-default) hover:border-(--border-border-hover) hover:bg-(--background-background-hover) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default) dark:hover:border-(--border-border-hover) dark:hover:bg-(--background-background-hover) dark:hover:text-(--text-text-black-default)", OO = "cursor-default border-(--border-border-black-default) bg-(--background-background-black-default) text-(--icons-icon-white-default) dark:border-(--background-background-white) dark:bg-(--background-background-white) dark:text-(--text-text-black-default)", PO = "cursor-not-allowed border-(--border-border-disabled) bg-(--components-button-button-disabled) text-(--icons-icon-disabled-strong)", FO = /* @__PURE__ */ ke({
  __name: "PageNumber",
  props: {
    page: {},
    active: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: a }) {
    const t = a;
    return (n, l) => (u(), b("button", {
      type: "button",
      disabled: e.disabled,
      "aria-current": e.active ? "page" : void 0,
      class: C([BO, e.disabled ? PO : e.active ? OO : MO]),
      onClick: l[0] || (l[0] = (o) => t("select", e.page))
    }, H(e.page), 11, DO));
  }
});
function Tx(e, a, t, n) {
  $e(
    a,
    () => {
      const l = document.activeElement;
      if (!e.value || !(l instanceof HTMLButtonElement) || !l.disabled) return;
      const o = e.value.querySelector(`[data-testid="${t}"]`), r = e.value.querySelector(`[data-testid="${n}"]`), i = l === r ? o : l === o ? r : null;
      i && !i.disabled && i.focus();
    },
    { flush: "post" }
  );
}
function Ex(e, a, t, n, l) {
  if (t === 0) return `0 ${n} 0`;
  const o = (e - 1) * a + 1, r = Math.min(e * a, t);
  return l ? l(o, r, t) : `${o}-${r} ${n} ${t}`;
}
const NO = {
  key: 0,
  class: "@4xl/pager:col-start-1 flex min-w-0 flex-wrap items-center gap-3"
}, VO = {
  key: 0,
  class: "flex items-center gap-3"
}, HO = ["id", "for"], jO = ["id", "aria-labelledby", "disabled", "aria-expanded", "aria-controls"], WO = { class: "min-w-0 flex-1 truncate" }, qO = ["id", "aria-labelledby"], UO = ["aria-selected", "tabindex", "onClick", "onKeydown", "onKeyup"], GO = {
  key: 1,
  "data-testid": "pager-items-count",
  class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, KO = { class: "flex min-w-0 flex-wrap items-center justify-center gap-1.5" }, YO = {
  key: 0,
  "data-testid": "pager-ellipsis",
  class: "flex size-9 shrink-0 select-none items-center justify-center text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
  "aria-hidden": "true"
}, JO = {
  key: 2,
  class: "@4xl/pager:col-start-3 ml-auto flex min-w-0 flex-wrap items-center justify-end gap-3"
}, XO = { class: "flex min-w-0 items-center gap-2" }, ZO = ["for"], QO = ["id", "max", "disabled", "aria-invalid", "aria-describedby"], _O = ["id"], eP = 1500, tP = /* @__PURE__ */ ke({
  __name: "Pager",
  props: {
    currentPage: { default: 1 },
    totalPages: { default: 1 },
    totalItems: { default: 0 },
    itemsPerPage: { default: 10 },
    previousLabel: { default: "Previous" },
    nextLabel: { default: "Next" },
    disabled: { type: Boolean, default: !1 },
    rowsPerPageOptions: { default: () => [10, 30, 50] },
    rowsPerPageLabel: { default: "Rows per page" },
    showRowsPerPage: { type: Boolean, default: !0 },
    showItemsCount: { type: Boolean, default: !1 },
    itemsCountSeparator: { default: "of" },
    itemsCountFormat: { type: Function, default: void 0 },
    maxVisiblePages: { default: 5 },
    alwaysShowPages: { type: Boolean, default: !1 },
    showPages: { type: Boolean, default: !0 },
    pageAlign: { default: "center" },
    showGoToPage: { type: Boolean, default: !1 },
    goToPageLabel: { default: "Go to page" },
    goLabel: { default: "Go" },
    goToPageErrorLabel: { default: void 0 },
    navLabel: { default: void 0 }
  },
  emits: ["page-change", "items-per-page-change"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => {
      const j = t.totalPages, J = t.currentPage, ne = Math.max(5, t.maxVisiblePages);
      if (j <= ne)
        return Array.from({ length: j }, (ee, ue) => ue + 1);
      const Y = Math.floor((ne - 5) / 2);
      if (J <= Y + 2)
        return [...Array.from({ length: ne - 2 }, (ue, se) => se + 1), "ellipsis-end", j];
      if (J >= j - Y - 1) {
        const ee = j - ne + 3;
        return [1, "ellipsis-start", ...Array.from({ length: ne - 2 }, (se, X) => ee + X)];
      }
      return [1, "ellipsis-start", ...Array.from({ length: Y * 2 + 1 }, (ee, ue) => J - Y + ue), "ellipsis-end", j];
    }), o = m(() => t.currentPage > 1 && !t.disabled), r = m(() => t.currentPage < t.totalPages && !t.disabled), i = m(
      () => Ex(
        t.currentPage,
        t.itemsPerPage,
        t.totalItems,
        t.itemsCountSeparator,
        t.itemsCountFormat
      )
    ), s = m(
      () => t.rowsPerPageOptions.map((j) => ({
        value: String(j),
        label: String(j)
      }))
    ), d = (j) => {
      t.disabled || j < 1 || j > t.totalPages || j !== t.currentPage && n("page-change", j);
    }, c = () => {
      o.value && d(t.currentPage - 1);
    }, f = () => {
      r.value && d(t.currentPage + 1);
    }, g = (j) => {
      n("items-per-page-change", Number(j));
    }, h = Ye(), v = Ye(), p = Na(), y = (j) => {
      const J = p[j];
      return J && J({}).length;
    }, k = Ye(), $ = R(""), S = R(!1), I = R(0);
    let T = null;
    function A() {
      T && clearTimeout(T), T = null;
    }
    const E = m(() => t.disabled || t.totalPages === 0), z = () => {
      A(), S.value = !1;
    };
    $e(
      [
        () => t.currentPage,
        () => t.totalPages,
        () => t.itemsPerPage,
        E,
        () => t.goToPageErrorLabel
      ],
      () => {
        T && ($.value = ""), A(), S.value = !1;
      }
    );
    const B = () => {
      A();
      const j = parseInt($.value, 10);
      if (isNaN(j) || j < 1 || j > t.totalPages) {
        S.value = !0, I.value += 1, t.goToPageErrorLabel || (T = setTimeout(() => {
          $.value = "", S.value = !1, T = null;
        }, eP));
        return;
      }
      S.value = !1, d(j), $.value = "";
    };
    Tt(() => {
      document.removeEventListener("click", oe), q(), A();
    });
    const W = R(!1), _ = R(null), Z = R(null), le = R(null);
    let D = !1;
    const O = R([]), N = R(0);
    function V(j) {
      var ne;
      const J = s.value.length;
      N.value = (j + J) % J, (ne = O.value[N.value]) == null || ne.focus();
    }
    async function M() {
      const j = s.value.findIndex((J) => J.value === String(t.itemsPerPage));
      N.value = Math.max(j, 0), W.value = !0, await Ze(), V(N.value);
    }
    function Q() {
      var j;
      W.value = !1, (j = Z.value) == null || j.focus();
    }
    function q() {
      D = !1, document.removeEventListener("mouseup", q, !0);
    }
    function K() {
      D = !0, document.addEventListener("mouseup", q, !0);
    }
    function G() {
      q(), !t.disabled && (W.value ? Q() : M());
    }
    function te(j) {
      Q(), g(j);
    }
    function ve(j, J) {
      const ne = {
        ArrowDown: J + 1,
        ArrowUp: J - 1,
        Home: 0,
        End: s.value.length - 1
      };
      j.key in ne && (j.preventDefault(), V(ne[j.key]));
    }
    function Se(j) {
      var ne;
      if (!W.value || D) return;
      const J = j.relatedTarget;
      J && ((ne = le.value) != null && ne.contains(J)) || (W.value = !1);
    }
    function oe(j) {
      W.value && _.value && !_.value.contains(j.target) && (W.value = !1);
    }
    function re(j) {
      j.key !== "Escape" || !W.value || (j.stopPropagation(), j.preventDefault(), Q());
    }
    $e(W, (j) => {
      j ? document.addEventListener("click", oe) : document.removeEventListener("click", oe);
    });
    const ge = m(() => t.showPages && (t.alwaysShowPages || t.totalPages > 1)), de = () => !!y("info") || t.showRowsPerPage || t.showItemsCount, Ee = R(null);
    return Tx(Ee, () => t.currentPage, "pager-previous", "pager-next"), (j, J) => (u(), b("div", {
      ref_key: "rootRef",
      ref: Ee,
      class: "@container/pager"
    }, [
      de() || ge.value || e.showGoToPage ? (u(), P(gt(e.showPages || e.showGoToPage ? "nav" : "div"), {
        key: 0,
        class: "flex flex-wrap items-center justify-between gap-x-6 gap-y-3 text-(length:--size-m) leading-(--line-height-l) @4xl/pager:grid @4xl/pager:grid-cols-[1fr_auto_1fr] @4xl/pager:gap-x-0 @4xl/pager:gap-y-0",
        "aria-label": e.showPages || e.showGoToPage ? e.navLabel : void 0,
        "data-testid": "pager-nav"
      }, {
        default: me(() => [
          de() ? (u(), b("div", NO, [
            y("info") ? Me(j.$slots, "info", { key: 0 }) : w("", !0),
            e.showRowsPerPage || e.showItemsCount ? (u(), b(ie, { key: 1 }, [
              e.showRowsPerPage ? (u(), b("div", VO, [
                x("label", {
                  id: `${L(h)}-label`,
                  for: L(h),
                  class: "whitespace-nowrap text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
                }, H(e.rowsPerPageLabel), 9, HO),
                x("div", {
                  ref_key: "rowsMenuRef",
                  ref: _,
                  class: "relative",
                  onKeydown: re,
                  onFocusout: Se
                }, [
                  U(en, {
                    size: "sm",
                    flush: "",
                    "has-value": "",
                    disabled: e.disabled,
                    "focus-scope": "any",
                    class: "min-w-16 shrink-0"
                  }, {
                    default: me(({ iconBoxClass: ne, iconColorClass: Y, textClass: F }) => [
                      x("button", {
                        id: L(h),
                        ref_key: "rowsTriggerRef",
                        ref: Z,
                        type: "button",
                        "aria-labelledby": `${L(h)}-label ${L(h)}`,
                        disabled: e.disabled,
                        "aria-haspopup": "listbox",
                        "aria-expanded": W.value,
                        "aria-controls": `${L(h)}-listbox`,
                        class: C([
                          "flex h-full w-full min-w-0 items-center gap-2 px-[calc(--spacing(2)-1px)] text-left focus-visible:outline-hidden focus-visible:-outline-offset-2 disabled:cursor-not-allowed",
                          F
                        ]),
                        "data-testid": "pager-rows-trigger",
                        onMousedown: K,
                        onClick: G
                      }, [
                        x("span", WO, H(e.itemsPerPage), 1),
                        x("i", {
                          class: C(["ri-arrow-down-s-line", ne, Y]),
                          "aria-hidden": "true"
                        }, null, 2)
                      ], 42, jO)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  W.value ? (u(), b("ul", {
                    key: 0,
                    id: `${L(h)}-listbox`,
                    ref_key: "rowsListboxRef",
                    ref: le,
                    role: "listbox",
                    "aria-labelledby": `${L(h)}-label`,
                    class: C([L(Ai), "absolute bottom-full left-0 z-30 mb-px min-w-full"]),
                    "data-testid": "pager-rows-menu"
                  }, [
                    (u(!0), b(ie, null, Oe(s.value, (ne, Y) => (u(), b("li", {
                      key: ne.value,
                      ref_for: !0,
                      ref_key: "rowsOptionRefs",
                      ref: O,
                      role: "option",
                      "aria-selected": String(e.itemsPerPage) === ne.value,
                      tabindex: Y === N.value ? 0 : -1,
                      class: C([L(Ok), String(e.itemsPerPage) === ne.value ? L(Pk) : ""]),
                      onClick: (F) => te(ne.value),
                      onKeydown: [
                        St(_e((F) => te(ne.value), ["prevent"]), ["enter"]),
                        J[0] || (J[0] = St(_e(() => {
                        }, ["prevent"]), ["space"])),
                        (F) => ve(F, Y)
                      ],
                      onKeyup: St(_e((F) => te(ne.value), ["prevent"]), ["space"])
                    }, H(ne.label), 43, UO))), 128))
                  ], 10, qO)) : w("", !0)
                ], 544)
              ])) : w("", !0),
              e.showItemsCount ? (u(), b("div", GO, H(i.value), 1)) : w("", !0)
            ], 64)) : w("", !0)
          ])) : w("", !0),
          ge.value ? (u(), b("div", {
            key: 1,
            class: C([
              "flex min-w-0 max-w-full items-center gap-x-4",
              e.pageAlign === "end" ? [
                "justify-end",
                // CONSTRAINT: never alone in a `1fr` side track: long page numbers would wrap there.
                e.showGoToPage ? "@4xl/pager:col-start-2" : de() ? "@4xl/pager:col-start-2 @4xl/pager:col-span-2" : "@4xl/pager:col-span-full @4xl/pager:justify-end"
              ] : "@4xl/pager:col-start-2 justify-center",
              // Alone at the start of the wrapping row, justify-between would push the centred pages to the left.
              e.pageAlign === "center" && !de() ? "mx-auto @4xl/pager:mx-0" : "",
              e.pageAlign === "end" && !de() ? "ml-auto @4xl/pager:ml-0" : ""
            ])
          }, [
            U(L(Be), {
              variant: "secondary",
              size: "sm",
              "icon-only": "",
              "icon-left": "ri-arrow-left-s-line",
              disabled: !o.value,
              "aria-label": e.previousLabel,
              "data-testid": "pager-previous",
              class: "shrink-0",
              onClick: c
            }, null, 8, ["disabled", "aria-label"]),
            x("div", KO, [
              (u(!0), b(ie, null, Oe(l.value, (ne) => (u(), b(ie, { key: ne }, [
                String(ne).startsWith("ellipsis") ? (u(), b("span", YO, " ... ")) : (u(), P(FO, {
                  key: 1,
                  page: ne,
                  active: ne === e.currentPage,
                  disabled: e.disabled,
                  "data-testid": "pager-page",
                  onSelect: d
                }, null, 8, ["page", "active", "disabled"]))
              ], 64))), 128))
            ]),
            U(L(Be), {
              variant: "secondary",
              size: "sm",
              "icon-only": "",
              "icon-right": "ri-arrow-right-s-line",
              disabled: !r.value,
              "aria-label": e.nextLabel,
              "data-testid": "pager-next",
              class: "shrink-0",
              onClick: f
            }, null, 8, ["disabled", "aria-label"])
          ], 2)) : w("", !0),
          e.showGoToPage ? (u(), b("div", JO, [
            x("div", XO, [
              x("label", {
                for: L(v),
                class: "whitespace-nowrap text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
              }, H(e.goToPageLabel), 9, ZO),
              U(en, {
                size: "sm",
                disabled: E.value,
                error: S.value,
                "has-value": $.value !== "",
                class: "w-16 shrink-0"
              }, {
                default: me(({ textClass: ne }) => [
                  wo(x("input", {
                    id: L(v),
                    "onUpdate:modelValue": J[1] || (J[1] = (Y) => $.value = Y),
                    type: "number",
                    min: "1",
                    max: e.totalPages,
                    disabled: E.value,
                    "aria-invalid": S.value || void 0,
                    "aria-describedby": S.value && e.goToPageErrorLabel ? L(k) : void 0,
                    "data-testid": "pager-go-to-page",
                    class: C([
                      "min-w-0 flex-1 border-0 bg-transparent p-0 outline-none focus:ring-0 disabled:cursor-not-allowed [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
                      ne
                    ]),
                    onInput: z,
                    onKeydown: St(B, ["enter"])
                  }, null, 42, QO), [
                    [Eg, $.value]
                  ])
                ]),
                _: 1
              }, 8, ["disabled", "error", "has-value"])
            ]),
            U(L(Be), {
              variant: "primary",
              size: "xs",
              label: e.goLabel,
              disabled: E.value,
              "data-testid": "pager-go-button",
              onClick: B
            }, null, 8, ["label", "disabled"])
          ])) : w("", !0),
          e.showGoToPage && e.goToPageErrorLabel && S.value ? (u(), b("p", {
            id: L(k),
            key: I.value,
            role: "alert",
            "data-testid": "pager-go-to-page-error",
            class: "basis-full text-right text-balance text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--border-border-error-subtle) @4xl/pager:col-start-3 @4xl/pager:row-start-2 @4xl/pager:pt-1"
          }, H(e.goToPageErrorLabel), 9, _O)) : w("", !0)
        ]),
        _: 3
      }, 8, ["aria-label"])) : w("", !0)
    ], 512));
  }
}), Ax = "enabled:z-10 hover:enabled:z-20 focus-visible:z-20", Rx = `${Ax} rounded-r-none -mr-px`, zx = `${Ax} rounded-l-none`, aP = ["aria-label"], nP = {
  key: 0,
  "data-testid": "compact-pager-helper",
  class: "text-center text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, lP = { class: "inline-flex shadow-(--blur-shadow-xs)" }, oP = ["id"], rP = { class: "inline-flex" }, iP = { "aria-hidden": "true" }, sP = { class: "sr-only" }, ri = "whitespace-nowrap text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default)", jd = "border border-solid border-(--border-border-secondary-button) bg-(--components-button-secondary-button-secondary)", dP = /* @__PURE__ */ ke({
  __name: "CompactPager",
  props: {
    type: { default: "arrows" },
    currentPage: { default: 1 },
    totalPages: { default: 1 },
    disabled: { type: Boolean, default: !1 },
    previousLabel: { default: "Previous" },
    nextLabel: { default: "Next" },
    pageStatusFormat: { type: Function, default: void 0 },
    navLabel: { default: void 0 },
    helperText: { default: void 0 },
    totalPagesFormat: { type: Function, default: void 0 },
    pageSelectLabel: { default: "Page" }
  },
  emits: ["page-change"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => !t.disabled && t.currentPage > 1), o = m(() => !t.disabled && t.currentPage < t.totalPages), r = m(
      () => t.pageStatusFormat ? t.pageStatusFormat(t.currentPage, t.totalPages) : `${t.currentPage} of ${t.totalPages}`
    ), i = m(
      () => t.totalPagesFormat ? t.totalPagesFormat(t.totalPages) : `of ${t.totalPages} pages`
    ), s = Ye(), d = (S) => String(S).padStart(2, "0"), c = m(
      () => Array.from({ length: Math.max(t.totalPages, 0) }, (S, I) => {
        const T = I + 1;
        return {
          label: d(T),
          active: T === t.currentPage,
          testId: `compact-pager-page-${T}`,
          onClick: () => {
            t.disabled || T > t.totalPages || T === t.currentPage || n("page-change", T);
          }
        };
      })
    );
    function f() {
      l.value && n("page-change", t.currentPage - 1);
    }
    function g() {
      o.value && n("page-change", t.currentPage + 1);
    }
    const h = {
      "arrow-buttons": { variant: "secondary", size: "xs", content: "icon", fused: !0 },
      arrows: { variant: "secondary", size: "xs", content: "icon", fused: !0 },
      "arrows-text": { variant: "text", size: "xs", content: "icon", fused: !1 },
      "arrows-number": { variant: "secondary", size: "sm", content: "icon", fused: !1 },
      "two-buttons": { variant: "secondary", size: "xs", content: "icon-label", fused: !1 },
      "buttons-helper": { variant: "secondary", size: "xs", content: "label", fused: !0 },
      "dropdown-buttons": { variant: "secondary", size: "xs", content: "icon", fused: !0 }
    };
    function v(S) {
      const I = h[t.type], T = S === "previous", A = T ? t.previousLabel : t.nextLabel, E = I.content === "label" ? void 0 : `ri-arrow-${T ? "left" : "right"}-s-line`;
      return {
        variant: I.variant,
        size: I.size,
        iconOnly: I.content === "icon",
        iconLeft: T ? E : void 0,
        iconRight: T ? void 0 : E,
        label: I.content === "icon" ? void 0 : A,
        ariaLabel: I.content === "icon" ? A : void 0,
        disabled: T ? !l.value : !o.value,
        "data-testid": `compact-pager-${S}`,
        class: I.fused ? T ? Rx : zx : void 0,
        onClick: T ? f : g
      };
    }
    const p = m(() => v("previous")), y = m(() => v("next")), k = R(null);
    Tx(k, () => t.currentPage, "compact-pager-previous", "compact-pager-next");
    const $ = {
      "arrow-buttons": "shadow-(--blur-shadow-xs)",
      arrows: "shadow-(--blur-shadow-xs)",
      "arrows-text": "",
      "arrows-number": "gap-1 shadow-(--blur-shadow-xs)",
      "two-buttons": "gap-3 shadow-(--blur-shadow-xs)",
      "buttons-helper": "flex-col gap-4",
      "dropdown-buttons": "gap-3 shadow-(--blur-shadow-xs)"
    };
    return (S, I) => (u(), b("nav", {
      ref_key: "rootRef",
      ref: k,
      "aria-label": e.navLabel,
      "data-testid": "compact-pager",
      class: C(["inline-flex items-center", $[e.type]])
    }, [
      e.type === "two-buttons" || e.type === "arrow-buttons" ? (u(), b(ie, { key: 0 }, [
        U(L(Be), ga(ka(p.value)), null, 16),
        U(L(Be), ga(ka(y.value)), null, 16)
      ], 64)) : e.type === "arrows" ? (u(), b(ie, { key: 1 }, [
        U(L(Be), ga(ka(p.value)), null, 16),
        x("span", {
          "data-testid": "compact-pager-status",
          class: C([
            "relative z-5 -mr-px self-stretch inline-flex items-center px-[calc(--spacing(3)-1px)] py-[calc(--spacing(1.5)-1px)]",
            jd,
            ri
          ])
        }, H(r.value), 3),
        U(L(Be), ga(ka(y.value)), null, 16)
      ], 64)) : e.type === "arrows-text" ? (u(), b(ie, { key: 2 }, [
        U(L(Be), ga(ka(p.value)), null, 16),
        x("span", {
          "data-testid": "compact-pager-status",
          class: C(["px-3 py-1.5", ri, "dark:text-(--text-text-white-default)"])
        }, H(r.value), 3),
        U(L(Be), ga(ka(y.value)), null, 16)
      ], 64)) : e.type === "buttons-helper" ? (u(), b(ie, { key: 3 }, [
        e.helperText ? (u(), b("span", nP, H(e.helperText), 1)) : w("", !0),
        x("div", lP, [
          U(L(Be), ga(ka(p.value)), null, 16),
          U(L(Be), ga(ka(y.value)), null, 16)
        ])
      ], 64)) : e.type === "dropdown-buttons" ? (u(), b(ie, { key: 4 }, [
        U(Ra, { items: c.value }, {
          trigger: me(({ triggerProps: T }) => [
            U(L(Be), Ve({
              variant: "secondary",
              size: "xs",
              label: d(e.currentPage),
              "dropdown-icon": "",
              "aria-label": `${e.pageSelectLabel} ${d(e.currentPage)}`,
              "aria-describedby": L(s),
              disabled: e.disabled,
              "data-testid": "compact-pager-page-select"
            }, T), null, 16, ["label", "aria-label", "aria-describedby", "disabled"])
          ]),
          _: 1
        }, 8, ["items"]),
        x("span", {
          id: L(s),
          "data-testid": "compact-pager-status",
          class: C([
            "inline-flex items-center rounded-(--border-border-radius-rounded-base) px-[calc(--spacing(3)-1px)] py-[calc(--spacing(1.5)-1px)]",
            jd,
            ri
          ])
        }, H(i.value), 11, oP),
        x("div", rP, [
          U(L(Be), ga(ka(p.value)), null, 16),
          U(L(Be), ga(ka(y.value)), null, 16)
        ])
      ], 64)) : e.type === "arrows-number" ? (u(), b(ie, { key: 5 }, [
        U(L(Be), ga(ka(p.value)), null, 16),
        x("span", {
          "data-testid": "compact-pager-status",
          class: C(["inline-flex size-9 shrink-0 items-center justify-center rounded-full", jd, ri])
        }, [
          x("span", iP, H(e.currentPage), 1),
          x("span", sP, H(r.value), 1)
        ], 2),
        U(L(Be), ga(ka(y.value)), null, 16)
      ], 64)) : w("", !0)
    ], 10, aP));
  }
});
function SG(e, a) {
  return {
    result: e.data.map(a),
    currentPage: e.pagination.page,
    pageSize: e.pagination.perPage,
    totalItems: e.pagination.totalItems,
    totalPages: e.pagination.totalPages
  };
}
const Hl = Symbol("tableQuery"), Js = Symbol("tableViews"), uP = Symbol(
  "tableColumnSettings"
), Dx = Symbol("tablePermissions"), Bx = Symbol("tableLabels"), Mx = Symbol("tableViewPanel");
function Ox(e, a) {
  return `${e}-tab-${a}`;
}
const Cs = {
  tableLabel: "Table",
  filterButton: "Filter",
  eraseAll: "Erase all",
  hideFilters: (e) => `Hide filters (${e})`,
  showFilters: (e) => `Show filters (${e})`,
  saveView: "Save",
  shareView: "Share",
  closeSearch: "Close search",
  removeFilter: (e) => `Remove ${e} filter`,
  scrollFiltersPrevious: "Previous filters",
  scrollFiltersNext: "Next filters",
  renameView: "Rename view",
  setAsDefault: "Set as default",
  deleteView: "Delete view",
  viewModeTable: "Table",
  viewModeBoard: "Board",
  viewModeCalendar: "Calendar",
  viewModeGantt: "Gantt",
  viewTabsLabel: "Pre-filtered lists",
  viewTabsOverflowLabel: "lists"
}, cP = {
  tabsLabel: "Table views",
  nextTabsLabel: "Show next tabs",
  previousTabsLabel: "Show previous tabs",
  clearSearchLabel: "Clear search"
};
function Lo() {
  return na(
    Bx,
    m(() => Cs)
  );
}
const fP = ["aria-label"], hP = ["id", "aria-controls", "aria-selected", "tabindex", "data-testid", "data-active", "onClick"], bP = {
  "data-tab-label": "",
  class: "truncate min-w-0"
}, gP = {
  key: 0,
  "data-tab-count": "",
  "data-testid": "table-view-tab-count",
  class: "shrink-0 whitespace-pre"
}, Gb = "ri-arrow-down-s-line", mP = "ri-information-line", vP = 6, pP = 233, Wd = 1, xP = /* @__PURE__ */ ke({
  __name: "TableViewTabs",
  props: {
    tabDropdowns: { default: () => [] },
    size: { default: "xs" },
    overflowLabel: { default: void 0 }
  },
  emits: ["tab-requested", "tab-reordered"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = na(Hl), o = na(Js), r = R(null), i = R(null), s = R(null), d = R(/* @__PURE__ */ new Map()), c = R([]), f = /* @__PURE__ */ new Map(), g = (de) => {
      var Ee;
      return ((Ee = f.get(de)) == null ? void 0 : Ee.width) ?? 0;
    };
    let h = 0;
    const v = m(() => (o == null ? void 0 : o.presetViews.value) ?? []), p = Lo(), y = na(Mx, null);
    function k(de) {
      return de.count === void 0 ? de.label : `${de.label} (${de.count})`;
    }
    const $ = R([]);
    function S() {
      const de = v.value.filter((Ee) => {
        var J;
        const j = (J = d.value.get(Ee.id)) == null ? void 0 : J.querySelector("[data-tab-label]");
        return !!j && j.scrollWidth > j.offsetWidth;
      }).map((Ee) => Ee.id);
      de.join("\0") !== $.value.join("\0") && ($.value = de);
    }
    const I = m(
      () => v.value.map((de) => de.id).filter((de) => !c.value.includes(de))
    ), T = m(() => z.value ? E.value : I.value[0] ?? null);
    function A(de) {
      var ne;
      const Ee = I.value, j = Ee.findIndex((Y) => d.value.get(Y) === document.activeElement);
      if (j < 0 || Ee.length === 0) return;
      let J;
      switch (de.key) {
        case "ArrowRight":
          J = (j + 1) % Ee.length;
          break;
        case "ArrowLeft":
          J = (j - 1 + Ee.length) % Ee.length;
          break;
        case "Home":
          J = 0;
          break;
        case "End":
          J = Ee.length - 1;
          break;
        default:
          return;
      }
      de.preventDefault(), (ne = d.value.get(Ee[J])) == null || ne.focus();
    }
    const E = m(() => (l == null ? void 0 : l.state.activeViewId) ?? null), z = m(() => !!E.value && v.value.some((de) => de.id === E.value)), B = m(() => t.tabDropdowns), W = m(
      () => {
        var de;
        return ((de = B.value.find((Ee) => Ee.overflowLabel)) == null ? void 0 : de.overflowLabel) ?? t.overflowLabel ?? p.value.viewTabsOverflowLabel;
      }
    ), _ = m(
      () => {
        var de;
        return (de = B.value.find((Ee) => Ee.overflowInfoTooltip)) == null ? void 0 : de.overflowInfoTooltip;
      }
    ), Z = R(
      t.tabDropdowns.reduce((de, Ee, j) => {
        var J, ne;
        return (ne = (J = Ee.groupButtons) == null ? void 0 : J[0]) != null && ne.value && (de[j] = Ee.groupButtons[0].value), de;
      }, {})
    ), le = (de, Ee) => {
      Z.value[de] = Ee;
    }, D = R({}), O = (de, Ee) => {
      D.value[de] = Ee;
    }, N = R({}), V = (de, Ee) => {
      const j = N.value[de] ?? [];
      j.indexOf(Ee) >= 0 ? N.value[de] = j.filter((ne) => ne !== Ee) : N.value[de] = [...j, Ee];
    }, M = m(
      () => B.value.map(
        (de, Ee) => {
          if (!de.showHeader) return { left: void 0, right: void 0 };
          const j = de.controlledSelection ? de.items.filter((ne) => ne.switchChecked).length : (N.value[Ee] ?? []).length, J = de.selectedCountSuffix ?? "selected";
          return {
            left: { text: de.label },
            right: { text: `${j}/${de.items.length} ${J}` }
          };
        }
      )
    ), Q = m(
      () => B.value.map(
        (de, Ee) => de.items.map((j) => de.controlledSelection ? {
          id: j.id,
          label: j.label,
          group: j.group,
          hasSwitch: !0,
          switchChecked: j.switchChecked === !0,
          disabled: j.disabled === !0,
          onClick: j.onClick,
          moreActions: j.moreActions
        } : {
          id: j.id,
          label: j.label,
          group: j.group,
          hasSwitch: !0,
          switchChecked: (N.value[Ee] ?? []).includes(j.id),
          onClick: () => V(Ee, j.id),
          moreActions: j.moreActions
        })
      )
    ), q = m(
      () => B.value.map(
        (de, Ee) => (de.footerButtons ?? []).map((j) => de.controlledSelection ? {
          label: j.label,
          variant: j.variant,
          keepOpen: j.keepOpen,
          disabled: j.disabled,
          onClick: () => {
            var J;
            return (J = j.onClick) == null ? void 0 : J.call(j, []);
          }
        } : {
          label: j.label,
          variant: j.variant,
          keepOpen: j.keepOpen,
          onClick: () => {
            var Y;
            const J = N.value[Ee] ?? [], ne = de.items.filter((F) => J.includes(F.id));
            n("tab-requested", Ee, ne), (Y = j.onClick) == null || Y.call(j, ne), N.value = { ...N.value, [Ee]: [] };
          }
        })
      )
    ), K = m(
      () => v.value.filter((de) => c.value.includes(de.id)).map((de) => ({
        label: k(de),
        onClick: () => l == null ? void 0 : l.setView(de.id)
      }))
    );
    let G = 0;
    function te() {
      return typeof window > "u" ? 0.72 : window.innerWidth >= 1920 ? 0.8 : 0.72;
    }
    function ve(de) {
      return de.reduce((Ee, j) => Ee + g(j), 0) + Wd * Math.max(0, de.length - 1);
    }
    function Se(de) {
      var ue, se;
      const Ee = de.getBoundingClientRect().width, j = ((ue = de.querySelector("[data-tab-label]")) == null ? void 0 : ue.scrollWidth) ?? 0;
      if (Ee === 0 && j === 0) return 0;
      const J = getComputedStyle(de), Y = ["paddingLeft", "paddingRight", "borderLeftWidth", "borderRightWidth"].reduce((X, ae) => X + (parseFloat(J[ae]) || 0), 0), F = ((se = de.querySelector("[data-tab-count]")) == null ? void 0 : se.getBoundingClientRect().width) ?? 0, ee = Math.ceil(Y + j + F);
      return Math.min(pP, Math.max(Ee, ee));
    }
    function oe() {
      var De, qe;
      if (G >= vP) return;
      const de = r.value, Ee = i.value;
      if (!de || !Ee) {
        c.value = [];
        return;
      }
      const j = de.getBoundingClientRect().width;
      if (j <= 0) return;
      let J = !1;
      for (const Qe of v.value) {
        if (((De = f.get(Qe.id)) == null ? void 0 : De.label) === k(Qe)) continue;
        const lt = d.value.get(Qe.id);
        if (lt) {
          const Ie = Se(lt);
          Ie > 0 ? f.set(Qe.id, { label: k(Qe), width: Ie }) : J = !0;
        } else
          J = !0;
      }
      if (J) {
        c.value = [], G++, Ze(oe);
        return;
      }
      S();
      const ne = ((qe = s.value) == null ? void 0 : qe.$el) ?? null;
      let Y = 0, F = 0;
      for (let Qe = 0; Qe < de.children.length; Qe++) {
        const lt = de.children[Qe];
        lt !== Ee && (ne && (lt === ne || lt.contains(ne)) || (Y += lt.getBoundingClientRect().width, F++));
      }
      const ee = (typeof window < "u" ? window.innerWidth : j) * te(), ue = Math.min(j, ee), se = Math.floor(ue - Y - Wd * F), X = v.value.map((Qe) => Qe.id);
      if (ve(X) <= se - 1) {
        const Qe = JSON.stringify(c.value);
        c.value = [], JSON.stringify([]) !== Qe ? (G++, Ze(oe)) : G = 0;
        return;
      }
      if (ne) {
        const Qe = ne.getBoundingClientRect().width;
        Qe > 0 && (h = Qe);
      }
      const ae = Math.floor(
        ue - Y - h - Wd * (F + 1)
      ), Re = (Qe) => ve(Qe) <= ae - 1, Ae = [], xe = [];
      for (const Qe of X) (Re([...xe, Qe]) ? xe : Ae).push(Qe);
      const we = E.value;
      if (we && Ae.includes(we)) {
        for (; xe.length > 0 && !Re([...xe, we]); ) Ae.push(xe.pop());
        Ae.splice(Ae.indexOf(we), 1), xe.push(we);
      }
      xe.length === 0 && Ae.length > 0 && xe.push(Ae.shift());
      const fe = JSON.stringify(c.value), Ne = JSON.stringify(Ae);
      c.value = Ae, fe !== Ne ? (G++, Ze(oe)) : G = 0;
    }
    function re() {
      G = 0, Ze(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(oe);
        });
      });
    }
    let ge = null;
    return $e(
      () => t.size,
      () => {
        f.clear(), h = 0, re();
      }
    ), kt(() => {
      var de;
      re(), ge = new ResizeObserver(() => {
        h = 0, re();
      }), r.value && ge.observe(r.value), (de = document.fonts) == null || de.ready.then(() => {
        f.clear(), h = 0, re();
      });
    }), zt(() => ge == null ? void 0 : ge.disconnect()), $e(
      v,
      (de) => {
        const Ee = new Set(de.map((j) => j.id));
        for (const [j] of f)
          Ee.has(j) || f.delete(j);
        h = 0, re();
      },
      // CONSTRAINT: deep, so a counter mutated in place on the same view object still re-measures.
      { deep: !0 }
    ), $e(E, () => {
      re();
    }), $e([W, _], () => {
      re();
    }), (de, Ee) => (u(), b("div", {
      ref_key: "outerRef",
      ref: r,
      class: "flex items-stretch gap-px min-w-0 flex-1"
    }, [
      x("div", {
        ref_key: "containerRef",
        ref: i,
        "data-testid": "tab-container",
        role: "tablist",
        "aria-label": L(p).viewTabsLabel,
        class: "flex items-stretch gap-px min-w-0 overflow-hidden",
        onKeydown: A
      }, [
        (u(!0), b(ie, null, Oe(v.value, (j) => (u(), P(L($t), {
          key: j.id,
          role: "presentation",
          class: C(["min-w-0", { "hidden!": c.value.includes(j.id) }]),
          text: k(j),
          disabled: !$.value.includes(j.id),
          "labels-trigger": ""
        }, {
          default: me(() => {
            var J;
            return [
              wo(x("button", {
                id: L(y) ? L(Ox)(L(y).id, j.id) : void 0,
                ref_for: !0,
                ref: (ne) => {
                  ne && d.value.set(j.id, ne);
                },
                type: "button",
                role: "tab",
                "aria-controls": (J = L(y)) != null && J.isTabpanel.value ? L(y).id : void 0,
                "aria-selected": E.value === j.id ? "true" : "false",
                tabindex: T.value === j.id ? 0 : -1,
                "data-testid": `table-view-tab-${j.id}`,
                "data-active": E.value === j.id ? "true" : "false",
                class: C(["min-w-0 flex cursor-pointer items-center leading-5 font-medium transition-colors duration-200 rounded-tl-(--border-border-radius-rounded-sm) rounded-tr-(--border-border-radius-rounded-sm) max-w-[233px] overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-royalblue", [
                  e.size === "md" ? "px-4 text-sm" : "px-3 text-xs",
                  E.value === j.id ? "tab-active tab-active--has-left -mb-px text-gray-900 dark:text-white" : "border-t border-r border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(--colors-text-black-default) hover:bg-whitesmoke dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10"
                ]]),
                onClick: (ne) => {
                  var Y;
                  return (Y = L(l)) == null ? void 0 : Y.setView(j.id);
                }
              }, [
                x("span", bP, H(j.label), 1),
                j.count !== void 0 ? (u(), b("span", gP, " (" + H(j.count) + ")", 1)) : w("", !0)
              ], 10, hP), [
                [ic, !c.value.includes(j.id)]
              ])
            ];
          }),
          _: 2
        }, 1032, ["class", "text", "disabled"]))), 128))
      ], 40, fP),
      K.value.length > 0 ? (u(), P(L(Ra), {
        key: 0,
        ref_key: "overflowDropdownRef",
        ref: s,
        class: "shrink-0",
        label: `+${K.value.length} ${W.value}`,
        items: K.value,
        "trigger-icon-info": _.value ? mP : void 0,
        "trigger-icon-info-tooltip": _.value,
        "trigger-icon": Gb,
        "menu-align": "left",
        "menu-width": "220px",
        tab: !0
      }, null, 8, ["label", "items", "trigger-icon-info", "trigger-icon-info-tooltip"])) : w("", !0),
      (u(!0), b(ie, null, Oe(B.value, (j, J) => (u(), b("div", {
        key: J,
        class: "flex items-center gap-1 shrink-0"
      }, [
        U(L(Lc), {
          class: "shrink-0",
          label: j.label,
          "trigger-icon-left": j.iconLeft,
          "trigger-icon": Gb,
          tab: !0,
          "header-label-left": M.value[J].left,
          "header-label-right": M.value[J].right,
          "show-search": j.showSearch,
          "search-query": D.value[J] ?? "",
          "search-placeholder": j.searchPlaceholder,
          "search-clear-label": j.searchClearLabel,
          "group-buttons": j.groupButtons,
          "active-group-button": Z.value[J],
          items: Q.value[J],
          "footer-buttons": q.value[J],
          reorderable: j.reorderable === !0,
          "freeze-on-open": !0,
          "menu-align": "left",
          size: j.size ?? "m",
          "max-list-height": "280px",
          "reserve-list-height": j.reserveListHeight !== !1,
          "empty-label": j.emptyLabel,
          "onUpdate:searchQuery": (ne) => O(J, ne),
          "onUpdate:activeGroupButton": (ne) => le(J, ne),
          onReorder: (ne) => n("tab-reordered", J, ne)
        }, null, 8, ["label", "trigger-icon-left", "header-label-left", "header-label-right", "show-search", "search-query", "search-placeholder", "search-clear-label", "group-buttons", "active-group-button", "items", "footer-buttons", "reorderable", "size", "reserve-list-height", "empty-label", "onUpdate:searchQuery", "onUpdate:activeGroupButton", "onReorder"])
      ]))), 128))
    ], 512));
  }
}), yP = /* @__PURE__ */ Ct(xP, [["__scopeId", "data-v-1a7ee892"]]), Vr = 300;
function $G(e = {}) {
  const { initialViewMode: a, filterLabels: t, filterItems: n, filterFieldConfigs: l, ...o } = e, r = R(a ?? "table"), i = R(!1), s = R(0), d = Bn({
    search: "",
    filters: {},
    sort: null,
    activeViewId: null,
    page: 1,
    pageSize: 10,
    ...o
  }), c = m(() => Object.keys(d.filters).length > 0), f = m(() => Object.keys(d.filters).length), g = m(() => {
    const B = Xt(t), W = Xt(n), _ = Xt(l);
    return Object.entries(d.filters).map(([Z, le]) => {
      const D = {
        key: Z,
        label: (B == null ? void 0 : B[Z]) ?? Z,
        valueLabel: kP(le, W == null ? void 0 : W[Z]),
        value: le
      };
      W != null && W[Z] && (D.items = W[Z]);
      const O = _ == null ? void 0 : _[Z];
      return O && (O.placeholder && (D.placeholder = O.placeholder), O.rangeConfig && (D.rangeConfig = O.rangeConfig), O.dateRangeConfig && (D.dateRangeConfig = O.dateRangeConfig)), D;
    });
  });
  function h(B, W) {
    d.filters[B] = W, d.page = 1;
  }
  function v(B) {
    delete d.filters[B], d.page = 1;
  }
  function p() {
    d.filters = {}, d.page = 1;
  }
  function y(B) {
    d.search = B, d.page = 1, s.value++;
  }
  function k(B) {
    i.value = B;
  }
  function $(B, W) {
    d.sort = { column: B, direction: W };
  }
  function S() {
    d.sort = null;
  }
  function I(B) {
    d.page = B;
  }
  function T(B) {
    d.pageSize = B, d.page = 1;
  }
  function A(B) {
    d.activeViewId = B, d.page = 1;
  }
  function E(B) {
    r.value = B;
  }
  function z(B) {
    Object.assign(d, B);
  }
  return {
    state: d,
    viewMode: r,
    searchPending: i,
    searchRevision: s,
    hasActiveFilters: c,
    activeFilterCount: f,
    activeFilterPills: g,
    setFilter: h,
    removeFilter: v,
    clearAllFilters: p,
    setSearch: y,
    setSearchPending: k,
    setSort: $,
    clearSort: S,
    setPage: I,
    setPageSize: T,
    setView: A,
    setViewMode: E,
    patch: z
  };
}
function kP(e, a) {
  switch (e.type) {
    case "equals":
      return String(e.value);
    case "in": {
      const t = (n) => {
        var l;
        return ((l = a == null ? void 0 : a.find((o) => o.id === n)) == null ? void 0 : l.label) ?? n;
      };
      return e.values.length === 1 ? t(e.values[0]) : `${t(e.values[0])} (+${e.values.length - 1})`;
    }
    case "range":
      return e.min != null && e.max != null ? `${e.min} – ${e.max}` : e.min != null ? `≥ ${e.min}` : e.max != null ? `≤ ${e.max}` : "";
    case "dateRange":
      return e.from && e.to ? `${e.from} – ${e.to}` : e.from ? `≥ ${e.from}` : e.to ? `≤ ${e.to}` : "";
    case "boolean":
      return e.value ? "Yes" : "No";
  }
}
const wP = /* @__PURE__ */ ke({
  __name: "TableSearch",
  props: {
    placeholder: { default: "Search..." },
    debounce: { default: Vr }
  },
  setup(e) {
    const a = na(Hl), t = Lo(), n = R(null);
    $e(
      () => a == null ? void 0 : a.searchRevision.value,
      () => {
        var o;
        return (o = n.value) == null ? void 0 : o.discardPending((a == null ? void 0 : a.state.search) ?? "");
      }
    );
    function l(o) {
      a == null || a.setSearch(o);
    }
    return (o, r) => {
      var i;
      return u(), P($O, {
        ref_key: "searchRef",
        ref: n,
        "data-table-search": "",
        "model-value": ((i = L(a)) == null ? void 0 : i.state.search) ?? "",
        placeholder: e.placeholder,
        labels: { closeSearch: L(t).closeSearch },
        debounce: e.debounce,
        "onUpdate:modelValue": l,
        onPending: r[0] || (r[0] = (s) => {
          var d;
          return (d = L(a)) == null ? void 0 : d.setSearchPending(s);
        })
      }, null, 8, ["model-value", "placeholder", "labels", "debounce"]);
    };
  }
}), CP = {
  key: 0,
  class: "inline-flex items-center px-3 py-2 text-(length:--size-m) leading-[20px] font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
  "data-testid": "table-view-selector-static"
}, SP = /* @__PURE__ */ ke({
  __name: "TableViewSelector",
  emits: ["rename-view", "delete-view", "set-default"],
  setup(e, { emit: a }) {
    const t = a, n = na(Hl), l = na(Js), o = Lo(), r = m(
      () => l == null ? void 0 : l.views.value.find((d) => d.id === (n == null ? void 0 : n.state.activeViewId))
    ), i = m(() => !!(r.value && !r.value.isPreset)), s = m(() => i.value ? [
      { label: o.value.renameView, onClick: () => t("rename-view", r.value.id) },
      {
        label: o.value.setAsDefault,
        hasDividerAfter: !0,
        onClick: () => {
          l == null || l.setDefault(r.value.id), t("set-default", r.value.id);
        }
      },
      { label: o.value.deleteView, onClick: () => t("delete-view", r.value.id) }
    ] : []);
    return (d, c) => i.value ? (u(), P(L(Ra), {
      key: 1,
      label: L(o).viewModeTable,
      items: s.value,
      "menu-align": "right",
      "menu-width": "180px",
      ghost: !0
    }, null, 8, ["label", "items"])) : (u(), b("div", CP, H(L(o).viewModeTable), 1));
  }
}), $P = { class: "@container/topbar relative flex flex-wrap items-stretch border-gainsboro dark:border-(--colors-border-base)" }, IP = {
  key: 1,
  class: "flex-1"
}, LP = /* @__PURE__ */ ke({
  __name: "TableTopbar",
  props: {
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    searchDebounce: { default: Vr },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] },
    tabSize: { default: "xs" }
  },
  emits: ["rename-view", "delete-view", "set-default", "tab-requested", "tab-reordered"],
  setup(e, { emit: a }) {
    const t = a, n = na(Js), l = m(() => ((n == null ? void 0 : n.presetViews.value.length) ?? 0) > 0);
    return (o, r) => (u(), b("div", $P, [
      x("div", {
        class: C(["items-stretch w-full @2xl/topbar:w-[73%] min-w-0", [e.tabSize === "md" ? "h-10" : "h-8", l.value ? "flex" : "hidden @2xl/topbar:flex"]]),
        "data-testid": "table-topbar-tabs"
      }, [
        l.value ? (u(), P(yP, {
          key: 0,
          "tab-dropdowns": e.tabDropdowns,
          size: e.tabSize,
          onTabRequested: r[0] || (r[0] = (i, s) => t("tab-requested", i, s)),
          onTabReordered: r[1] || (r[1] = (i, s) => t("tab-reordered", i, s))
        }, null, 8, ["tab-dropdowns", "size"])) : (u(), b("div", IP))
      ], 2),
      x("div", {
        class: C(["order-first flex items-center justify-end gap-1 w-full @2xl/topbar:order-none @2xl/topbar:w-[27%] px-4", [e.tabSize === "md" ? "h-10" : "h-8", l.value && "border-gainsboro dark:border-(--colors-border-base)"]]),
        "data-testid": "table-topbar-search"
      }, [
        e.showSearch ? (u(), P(wP, {
          key: 0,
          placeholder: e.searchPlaceholder,
          debounce: e.searchDebounce
        }, null, 8, ["placeholder", "debounce"])) : w("", !0),
        e.showViewSelector ? (u(), P(SP, {
          key: 1,
          onRenameView: r[2] || (r[2] = (i) => t("rename-view", i)),
          onDeleteView: r[3] || (r[3] = (i) => t("delete-view", i)),
          onSetDefault: r[4] || (r[4] = (i) => t("set-default", i))
        })) : w("", !0)
      ], 2)
    ]));
  }
}), TP = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M14%2014V20L10%2022V14L4%205V3H20V5L14%2014ZM6.4037%205L12%2013.3944L17.5963%205H6.4037Z'/%3e%3c/svg%3e", EP = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.8827%2019.2968C16.1814%2020.3755%2014.1638%2021.0002%2012.0003%2021.0002C6.60812%2021.0002%202.12215%2017.1204%201.18164%2012.0002C1.61832%209.62282%202.81932%207.5129%204.52047%205.93457L1.39366%202.80777L2.80788%201.39355L22.6069%2021.1925L21.1927%2022.6068L17.8827%2019.2968ZM5.9356%207.3497C4.60673%208.56015%203.6378%2010.1672%203.22278%2012.0002C4.14022%2016.0521%207.7646%2019.0002%2012.0003%2019.0002C13.5997%2019.0002%2015.112%2018.5798%2016.4243%2017.8384L14.396%2015.8101C13.7023%2016.2472%2012.8808%2016.5002%2012.0003%2016.5002C9.51498%2016.5002%207.50026%2014.4854%207.50026%2012.0002C7.50026%2011.1196%207.75317%2010.2981%208.19031%209.60442L5.9356%207.3497ZM12.9139%2014.328L9.67246%2011.0866C9.5613%2011.3696%209.50026%2011.6777%209.50026%2012.0002C9.50026%2013.3809%2010.6196%2014.5002%2012.0003%2014.5002C12.3227%2014.5002%2012.6309%2014.4391%2012.9139%2014.328ZM20.8068%2016.5925L19.376%2015.1617C20.0319%2014.2268%2020.5154%2013.1586%2020.7777%2012.0002C19.8603%207.94818%2016.2359%205.00016%2012.0003%205.00016C11.1544%205.00016%2010.3329%205.11773%209.55249%205.33818L7.97446%203.76015C9.22127%203.26959%2010.5793%203.00016%2012.0003%203.00016C17.3924%203.00016%2021.8784%206.87992%2022.8189%2012.0002C22.5067%2013.6998%2021.8038%2015.2628%2020.8068%2016.5925ZM11.7229%207.50857C11.8146%207.50299%2011.9071%207.50016%2012.0003%207.50016C14.4855%207.50016%2016.5003%209.51488%2016.5003%2012.0002C16.5003%2012.0933%2016.4974%2012.1858%2016.4919%2012.2775L11.7229%207.50857Z'/%3e%3c/svg%3e", AP = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.0003%203C17.3924%203%2021.8784%206.87976%2022.8189%2012C21.8784%2017.1202%2017.3924%2021%2012.0003%2021C6.60812%2021%202.12215%2017.1202%201.18164%2012C2.12215%206.87976%206.60812%203%2012.0003%203ZM12.0003%2019C16.2359%2019%2019.8603%2016.052%2020.7777%2012C19.8603%207.94803%2016.2359%205%2012.0003%205C7.7646%205%204.14022%207.94803%203.22278%2012C4.14022%2016.052%207.7646%2019%2012.0003%2019ZM12.0003%2016.5C9.51498%2016.5%207.50026%2014.4853%207.50026%2012C7.50026%209.51472%209.51498%207.5%2012.0003%207.5C14.4855%207.5%2016.5003%209.51472%2016.5003%2012C16.5003%2014.4853%2014.4855%2016.5%2012.0003%2016.5ZM12.0003%2014.5C13.381%2014.5%2014.5003%2013.3807%2014.5003%2012C14.5003%2010.6193%2013.381%209.5%2012.0003%209.5C10.6196%209.5%209.50026%2010.6193%209.50026%2012C9.50026%2013.3807%2010.6196%2014.5%2012.0003%2014.5Z'/%3e%3c/svg%3e", RP = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4%203H18L20.7071%205.70711C20.8946%205.89464%2021%206.149%2021%206.41421V20C21%2020.5523%2020.5523%2021%2020%2021H4C3.44772%2021%203%2020.5523%203%2020V4C3%203.44772%203.44772%203%204%203ZM7%204V9H16V4H7ZM6%2012V19H18V12H6ZM13%205H15V8H13V5Z'/%3e%3c/svg%3e", oo = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.9999%2013.1714L16.9497%208.22168L18.3639%209.63589L11.9999%2015.9999L5.63599%209.63589L7.0502%208.22168L11.9999%2013.1714Z'/%3e%3c/svg%3e", $i = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.9999%2010.8284L7.0502%2015.7782L5.63599%2014.364L11.9999%208L18.3639%2014.364L16.9497%2015.7782L11.9999%2010.8284Z'/%3e%3c/svg%3e", zP = /* @__PURE__ */ ke({
  __name: "TableControls",
  props: {
    isFilterPanelOpen: { type: Boolean, default: !1 },
    isFilterBarVisible: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    bordered: { type: Boolean, default: !0 },
    roundTopRight: { type: Boolean, default: !1 }
  },
  emits: ["toggle-filter-panel", "toggle-filter-bar", "save-view", "share-view", "focus-fallback"],
  setup(e, { expose: a, emit: t }) {
    const n = t, l = na(Hl), o = na(Dx), r = Lo(), i = m(() => (l == null ? void 0 : l.hasActiveFilters.value) ?? !1), s = m(() => (l == null ? void 0 : l.activeFilterCount.value) ?? 0), d = hn("filterTrigger");
    function c() {
      var h;
      const g = (h = d.value) == null ? void 0 : h.querySelector(yn);
      return g == null || g.focus(), !!g && document.activeElement === g;
    }
    async function f() {
      l == null || l.clearAllFilters(), await Ze(), c() || n("focus-fallback");
    }
    return a({ focusFilterTrigger: c }), (g, h) => {
      var v, p, y, k;
      return u(), b("div", {
        class: C([
          "flex flex-wrap items-center gap-3 py-3 bg-white dark:bg-(--colors-background-black-default)",
          e.roundTopRight && "rounded-tr-(--border-border-radius-rounded-l)",
          // Figma Second Level: strokes left and right only, top-right radius 12; the pill row follows with no line between.
          e.bordered ? "border-x border-(--colors-border-base-soft) dark:border-(--colors-border-base) px-[calc(--spacing(3)-1px)]" : "px-3"
        ])
      }, [
        e.showFilter ? (u(), b("div", {
          key: 0,
          ref_key: "filterTrigger",
          ref: d,
          class: "contents"
        }, [
          g.$slots.filter ? Me(g.$slots, "filter", { key: 0 }) : (u(), P(L(Be), {
            key: 1,
            variant: "tertiary",
            "icon-left": L(TP),
            "icon-right": L(oo),
            size: "xs",
            active: e.isFilterPanelOpen,
            onClick: h[0] || (h[0] = ($) => n("toggle-filter-panel"))
          }, {
            default: me(() => [
              st(H(L(r).filterButton), 1)
            ]),
            _: 1
          }, 8, ["icon-left", "icon-right", "active"]))
        ], 512)) : w("", !0),
        i.value ? (u(), P(L(O1), {
          key: 1,
          size: "s",
          class: "shrink-0",
          onClick: f
        }, {
          default: me(() => [
            st(H(L(r).eraseAll), 1)
          ]),
          _: 1
        })) : w("", !0),
        i.value ? (u(), P(L(Be), {
          key: 2,
          variant: "ghost",
          "icon-left": e.isFilterBarVisible ? L(EP) : L(AP),
          "icon-right": e.isFilterBarVisible ? L($i) : L(oo),
          size: "xs",
          "aria-expanded": e.isFilterBarVisible,
          "data-testid": "table-controls-filter-bar-toggle",
          onClick: h[1] || (h[1] = ($) => n("toggle-filter-bar"))
        }, {
          default: me(() => [
            st(H(e.isFilterBarVisible ? L(r).hideFilters(s.value) : L(r).showFilters(s.value)), 1)
          ]),
          _: 1
        }, 8, ["icon-left", "icon-right", "aria-expanded"])) : w("", !0),
        Me(g.$slots, "controls-actions"),
        h[4] || (h[4] = x("div", { class: "flex-1" }, null, -1)),
        ((v = L(o)) == null ? void 0 : v.canSaveView) !== !1 ? (u(), P(L(Be), {
          key: 3,
          variant: "secondary",
          label: L(r).saveView,
          "icon-left": L(RP),
          "icon-right": L(oo),
          size: "xs",
          disabled: ((p = L(o)) == null ? void 0 : p.canSaveView) === "disabled" || !i.value,
          onClick: h[2] || (h[2] = ($) => n("save-view"))
        }, null, 8, ["label", "icon-left", "icon-right", "disabled"])) : w("", !0),
        ((y = L(o)) == null ? void 0 : y.canShareView) !== !1 ? (u(), P(L(Be), {
          key: 4,
          variant: "secondary",
          label: L(r).shareView,
          size: "xs",
          disabled: ((k = L(o)) == null ? void 0 : k.canShareView) === "disabled",
          onClick: h[3] || (h[3] = ($) => n("share-view"))
        }, null, 8, ["label", "disabled"])) : w("", !0)
      ], 2);
    };
  }
}), DP = {
  class: "pill-ring relative inline-flex shrink-0 items-stretch rounded-full",
  "data-testid": "filter-pill"
}, BP = { class: "inline-flex min-w-0 whitespace-nowrap" }, MP = ["title"], OP = /* @__PURE__ */ ke({
  __name: "FilterPill",
  props: {
    pill: {}
  },
  emits: ["remove", "edit"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = Lo();
    function o() {
      n("edit", t.pill.key);
    }
    return (r, i) => (u(), b("div", DP, [
      U(L(Be), {
        variant: "tertiary",
        size: "xs",
        "icon-right": "ri-arrow-down-s-line",
        class: "rounded-r-none! border-transparent!",
        "data-filter-pill-edit": "",
        onClick: _e(o, ["stop"])
      }, {
        default: me(() => [
          x("span", BP, [
            st(H(e.pill.label) + " : ", 1),
            x("span", {
              class: "max-w-50 truncate",
              title: e.pill.valueLabel
            }, H(e.pill.valueLabel), 9, MP)
          ])
        ]),
        _: 1
      }),
      i[1] || (i[1] = x("span", {
        "aria-hidden": "true",
        class: "my-1.5 w-px shrink-0 bg-(--border-border-base-soft) dark:bg-(--colors-border-base)",
        "data-filter-pill-divider": ""
      }, null, -1)),
      U(L(Be), {
        variant: "tertiary",
        size: "xs",
        "icon-only": "",
        "icon-left": "ri-close-fill",
        class: "rounded-l-none! border-transparent!",
        "aria-label": L(l).removeFilter(e.pill.label),
        "data-filter-pill-remove": "",
        onClick: i[0] || (i[0] = _e((s) => n("remove", e.pill.key), ["stop"]))
      }, null, 8, ["aria-label"])
    ]));
  }
}), PP = /* @__PURE__ */ Ct(OP, [["__scopeId", "data-v-0b6a88f2"]]), FP = {
  key: 0,
  class: "flex shrink-0 items-center gap-1",
  "data-testid": "table-filter-bar-arrows"
}, NP = /* @__PURE__ */ ke({
  __name: "TableFilterBar",
  props: {
    bordered: { type: Boolean, default: !0 }
  },
  emits: ["edit-filter", "last-filter-removed"],
  setup(e, { emit: a }) {
    const t = a, n = na(Hl), l = Lo(), o = m(() => (n == null ? void 0 : n.activeFilterPills.value) ?? []), r = hn("pillList"), i = R(!1), s = R(!0), d = R(!0);
    function c() {
      const p = r.value;
      p && (i.value = p.scrollWidth > p.clientWidth + 1, s.value = p.scrollLeft <= 1, d.value = p.scrollLeft + p.clientWidth >= p.scrollWidth - 1);
    }
    function f(p) {
      const y = r.value;
      !y || (p < 0 ? s.value : d.value) || y.scrollBy({ left: p * y.clientWidth * 0.8, behavior: "smooth" });
    }
    let g;
    $e(
      r,
      (p) => {
        g == null || g.disconnect(), !(!p || typeof ResizeObserver > "u") && (g = new ResizeObserver(c), g.observe(p), c());
      },
      { flush: "post" }
    ), $e(o, () => Ze(c)), Tt(() => g == null ? void 0 : g.disconnect());
    async function h(p) {
      var $, S;
      const y = o.value.findIndex((I) => I.key === p);
      if (n == null || n.removeFilter(p), await Ze(), o.value.length === 0) {
        t("last-filter-removed");
        return;
      }
      const k = (($ = r.value) == null ? void 0 : $.querySelectorAll("[data-filter-pill-remove]")) ?? [];
      (S = k[Math.min(y, k.length - 1)]) == null || S.focus();
    }
    function v(p) {
      var y, k;
      (k = (y = p.target) == null ? void 0 : y.scrollIntoView) == null || k.call(y, { block: "nearest", inline: "nearest" }), requestAnimationFrame(c);
    }
    return (p, y) => (u(), P(Wt, {
      "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
      "enter-from-class": "max-h-0",
      "enter-to-class": "max-h-60",
      "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
      "leave-from-class": "max-h-60",
      "leave-to-class": "max-h-0"
    }, {
      default: me(() => [
        o.value.length > 0 ? (u(), b("div", {
          key: 0,
          "data-testid": "table-filter-bar",
          class: C([
            "flex items-center gap-2 pb-3 bg-white dark:bg-(--colors-background-black-default)",
            // Figma Third Level: strokes left and right only, straight under the controls row (no line between).
            e.bordered ? "border-x border-(--colors-border-base-soft) dark:border-(--colors-border-base) px-[calc(--spacing(3)-1px)]" : "px-3"
          ])
        }, [
          i.value ? (u(), b("div", FP, [
            U(L(Be), {
              variant: "secondary",
              size: "xs",
              "icon-only": "",
              "icon-left": "ri-arrow-left-s-line",
              "aria-label": L(l).scrollFiltersPrevious ?? L(Cs).scrollFiltersPrevious,
              "aria-disabled": s.value,
              onClick: y[0] || (y[0] = (k) => f(-1))
            }, null, 8, ["aria-label", "aria-disabled"]),
            U(L(Be), {
              variant: "secondary",
              size: "xs",
              "icon-only": "",
              "icon-left": "ri-arrow-right-s-line",
              "aria-label": L(l).scrollFiltersNext ?? L(Cs).scrollFiltersNext,
              "aria-disabled": d.value,
              onClick: y[1] || (y[1] = (k) => f(1))
            }, null, 8, ["aria-label", "aria-disabled"])
          ])) : w("", !0),
          x("div", {
            ref_key: "pillList",
            ref: r,
            "data-testid": "table-filter-bar-pills",
            class: "-my-1 flex min-w-0 flex-1 items-center gap-1.5 overflow-x-auto px-0.5 py-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
            onScrollPassive: c,
            onFocusin: v
          }, [
            (u(!0), b(ie, null, Oe(o.value, (k) => (u(), P(PP, {
              key: k.key,
              class: "shrink-0",
              pill: k,
              onRemove: h,
              onEdit: y[2] || (y[2] = ($) => t("edit-filter", $))
            }, null, 8, ["pill"]))), 128))
          ], 544)
        ], 2)) : w("", !0)
      ]),
      _: 1
    }));
  }
}), VP = {
  "data-testid": "table-skeleton",
  "aria-hidden": "true",
  class: "w-full"
}, HP = {
  key: 0,
  class: "flex border-b border-(--colors-border-base-medium) dark:border-(--colors-border-base)"
}, jP = /* @__PURE__ */ ke({
  __name: "TableSkeleton",
  props: {
    columns: { default: 5 },
    rows: { default: 10 },
    showHeader: { type: Boolean, default: !0 }
  },
  setup(e) {
    const a = [85, 45, 30, 65, 40, 55, 35, 75];
    function t(n, l) {
      return `${a[(n + l) % a.length]}%`;
    }
    return (n, l) => (u(), b("div", VP, [
      e.showHeader ? (u(), b("div", HP, [
        (u(!0), b(ie, null, Oe(e.columns, (o) => (u(), b("div", {
          key: `skeleton-header-${o}`,
          class: "flex-1 h-11 px-5 flex items-center"
        }, [...l[0] || (l[0] = [
          x("div", { class: "skeleton h-2.5 w-full max-w-[140px] rounded-full" }, null, -1)
        ])]))), 128))
      ])) : w("", !0),
      (u(!0), b(ie, null, Oe(e.rows, (o) => (u(), b("div", {
        key: `skeleton-row-${o}`,
        class: "flex border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base) last:border-b-0"
      }, [
        (u(!0), b(ie, null, Oe(e.columns, (r) => (u(), b("div", {
          key: `skeleton-cell-${o}-${r}`,
          class: "flex-1 h-14 px-5 flex items-center"
        }, [
          x("div", {
            class: "skeleton h-2.5 rounded-full",
            style: Ge({ width: t(o, r) })
          }, null, 4)
        ]))), 128))
      ]))), 128))
    ]));
  }
}), WP = {
  "data-testid": "table-footer-range",
  class: "whitespace-nowrap text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
}, qP = {
  "data-testid": "table-footer-totals",
  class: "flex flex-wrap items-start gap-x-6 gap-y-1"
}, UP = { class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--text-text-white-secondary)" }, GP = { class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) dark:text-(--text-text-white-default)" }, KP = {
  key: 1,
  "data-testid": "table-footer-range",
  class: "text-center text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
}, YP = {
  key: 2,
  class: "flex flex-wrap items-center justify-between gap-3"
}, JP = {
  key: 3,
  class: "flex flex-wrap items-center justify-between gap-3"
}, XP = { class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body) dark:text-(--text-text-white-secondary)" }, ZP = {
  key: 4,
  class: "flex flex-wrap items-center justify-between gap-x-6 gap-y-3"
}, QP = {
  "data-testid": "table-footer-totals",
  class: "flex flex-wrap items-start gap-x-6 gap-y-1"
}, _P = { class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body) dark:text-(--text-text-white-secondary)" }, e8 = { class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) dark:text-(--text-text-white-default)" }, t8 = /* @__PURE__ */ ke({
  __name: "TableFooter",
  props: {
    footer: {}
  },
  emits: ["page-change", "page-size-change", "action"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = /* @__PURE__ */ new Set(["pagination", "rows-per-page", "total-results", "rows-per-card", "showing-rows", "select-input"]), o = m(() => l.has(t.footer.type) ? t.footer : null), r = m(() => {
      const f = t.footer;
      if (f.type !== "pagination" && f.type !== "showing-rows") return "";
      const { currentPage: g, pageSize: h, totalItems: v, labels: p, itemsCountFormat: y } = f;
      return Ex(g, h, v, p.itemsCountSeparator, y);
    }), i = m(
      () => t.footer.type === "rows-per-page" || t.footer.type === "rows-per-card" || t.footer.type === "select-input" ? t.footer : null
    ), s = m(
      () => t.footer.type === "rows-per-card" ? "arrows-number" : t.footer.type === "select-input" ? "two-buttons" : null
    ), d = m(() => {
      var v;
      const { rowsPerCardLabel: f, pageStatusFormat: g, ...h } = ((v = o.value) == null ? void 0 : v.labels) ?? {};
      return s.value ? { ...h, navLabel: void 0 } : h;
    }), c = m(
      () => t.footer.type === "total-results" || t.footer.type === "progress-stats" ? t.footer.totals : null
    );
    return (f, g) => {
      var h, v, p, y, k, $;
      return o.value && e.footer.type !== "showing-rows" ? (u(), b("div", {
        key: 0,
        class: C(s.value && "flex flex-wrap items-center justify-between gap-x-6 gap-y-3")
      }, [
        U(L(tP), Ve(d.value, {
          class: s.value && "min-w-0 grow",
          "rows-per-page-label": e.footer.type === "rows-per-card" ? e.footer.labels.rowsPerCardLabel : (h = o.value.labels) == null ? void 0 : h.rowsPerPageLabel,
          "current-page": o.value.currentPage,
          "total-pages": o.value.totalPages,
          "total-items": o.value.totalItems,
          "items-per-page": o.value.pageSize,
          disabled: o.value.disabled,
          "show-rows-per-page": !!i.value,
          "rows-per-page-options": (v = i.value) == null ? void 0 : v.pageSizeOptions,
          "show-items-count": e.footer.type === "select-input" || e.footer.type === "rows-per-page" && !!e.footer.showItemsCount,
          "items-count-format": e.footer.type === "rows-per-page" || e.footer.type === "select-input" ? e.footer.itemsCountFormat : void 0,
          "show-pages": !s.value,
          "show-go-to-page": !s.value,
          onPageChange: g[0] || (g[0] = (S) => n("page-change", S)),
          onItemsPerPageChange: g[1] || (g[1] = (S) => n("page-size-change", S))
        }), Xa({ _: 2 }, [
          e.footer.type === "pagination" ? {
            name: "info",
            fn: me(() => [
              x("span", WP, H(r.value), 1)
            ]),
            key: "0"
          } : e.footer.type === "total-results" ? {
            name: "info",
            fn: me(() => [
              x("dl", qP, [
                (u(!0), b(ie, null, Oe(c.value, (S, I) => (u(), b("div", {
                  key: I,
                  class: "flex flex-col gap-0.5"
                }, [
                  x("dt", UP, H(S.term), 1),
                  x("dd", GP, H(S.description), 1)
                ]))), 128))
              ])
            ]),
            key: "1"
          } : void 0
        ]), 1040, ["class", "rows-per-page-label", "current-page", "total-pages", "total-items", "items-per-page", "disabled", "show-rows-per-page", "rows-per-page-options", "show-items-count", "items-count-format", "show-pages", "show-go-to-page"]),
        s.value ? (u(), P(dP, {
          key: 0,
          type: s.value,
          "current-page": o.value.currentPage,
          "total-pages": o.value.totalPages,
          disabled: o.value.disabled,
          "previous-label": (p = o.value.labels) == null ? void 0 : p.previousLabel,
          "next-label": (y = o.value.labels) == null ? void 0 : y.nextLabel,
          "nav-label": (k = o.value.labels) == null ? void 0 : k.navLabel,
          "page-status-format": ($ = o.value.labels) == null ? void 0 : $.pageStatusFormat,
          "data-testid": "table-footer-compact-pager",
          onPageChange: g[2] || (g[2] = (S) => n("page-change", S))
        }, null, 8, ["type", "current-page", "total-pages", "disabled", "previous-label", "next-label", "nav-label", "page-status-format"])) : w("", !0)
      ], 2)) : e.footer.type === "showing-rows" ? (u(), b("p", KP, H(r.value), 1)) : e.footer.type === "dropdown-link" ? (u(), b("div", YP, [
        U(Ra, {
          ghost: "",
          class: "-ms-3",
          label: e.footer.dropdown.label,
          items: e.footer.dropdown.items,
          "data-testid": "table-footer-dropdown"
        }, null, 8, ["label", "items"]),
        U(Be, {
          variant: "secondary",
          size: "sm",
          label: e.footer.action.label,
          "icon-right": e.footer.action.icon,
          "data-testid": "table-footer-action",
          onClick: g[3] || (g[3] = (S) => n("action", e.footer.action.id))
        }, null, 8, ["label", "icon-right"])
      ])) : e.footer.type === "button-text" ? (u(), b("div", JP, [
        x("p", XP, H(e.footer.text), 1),
        U(Be, {
          variant: "primary",
          size: "xs",
          label: e.footer.action.label,
          "icon-left": e.footer.action.icon,
          "data-testid": "table-footer-action",
          onClick: g[4] || (g[4] = (S) => n("action", e.footer.action.id))
        }, null, 8, ["label", "icon-left"])
      ])) : e.footer.type === "progress-stats" ? (u(), b("div", ZP, [
        x("dl", QP, [
          (u(!0), b(ie, null, Oe(c.value, (S, I) => (u(), b("div", {
            key: I,
            class: "flex flex-col gap-0.5"
          }, [
            x("dt", _P, H(S.term), 1),
            x("dd", e8, H(S.description), 1)
          ]))), 128))
        ]),
        U(Dr, {
          class: "w-87.5! max-w-full min-w-0",
          value: e.footer.progress.value,
          max: e.footer.progress.max,
          label: e.footer.progress.label,
          "value-label": e.footer.progress.valueLabel,
          "data-testid": "table-footer-progress"
        }, null, 8, ["value", "max", "label", "value-label"])
      ])) : w("", !0);
    };
  }
}), a8 = ["aria-label"], n8 = ["aria-orientation", "tabindex"], l8 = ["id", "data-testid", "aria-selected", "aria-disabled", "aria-controls", "tabindex", "onClick"], o8 = { class: "truncate" }, r8 = {
  key: 1,
  class: "ri-lock-line text-(length:--icon-size-sm) leading-none text-(--icons-icon-disabled-strong)",
  "aria-hidden": "true"
}, i8 = ["aria-label"], s8 = "before:pointer-events-none before:absolute before:inset-x-0 before:bottom-0 before:-z-1 before:border-b-3 before:border-(--border-border-base-soft)", Kb = "nav-pill relative isolate border border-transparent py-[calc(--spacing(2.5)-1px)] px-[calc(--spacing(4)-1px)] before:absolute before:-inset-px before:-z-10 before:rounded-[inherit] before:opacity-0 before:[background:var(--nav-pill-ring)] after:absolute after:inset-[calc(var(--border-border-width-border-sm)-1px)] after:-z-10 after:rounded-[inherit] after:opacity-0 after:bg-(--background-background-white) focus-visible:after:opacity-100 focus-visible:after:shadow-(--shadow-focus-l-inset)", Yb = "before:opacity-100 after:opacity-100 forced-colors:border-[Highlight]", qd = "text-(--text-text-disabled-strong)", d8 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "NavTabs",
  props: {
    tabs: {},
    modelValue: {},
    fullWidth: { type: Boolean, default: !1 },
    overflowLabel: {},
    overflowPreviousLabel: {},
    type: { default: "border-bottom" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = m(() => e.type === "vertical-pills"), n = m(() => [
      "relative isolate max-w-full",
      e.fullWidth || t.value ? "w-full" : "w-fit",
      e.type === "border-bottom" && s8
    ]), l = {
      "border-bottom": "size-8",
      default: "size-6",
      pills: "size-10"
    }, o = {
      "border-bottom": "scroll-px-8",
      default: "scroll-px-6",
      pills: "scroll-px-10"
    }, r = (I) => [
      "absolute top-1/2 -translate-y-1/2 z-20 inline-flex items-center justify-center cursor-pointer",
      I,
      "rounded-(--border-border-radius-rounded-base) bg-(--background-background-white) hover:bg-(--background-background-hover)",
      "text-(--icons-icon-dark-default) transition-colors duration-150 motion-reduce:transition-none",
      "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
      l[e.type]
    ], i = {
      "border-bottom": "flex items-end gap-3",
      default: "flex items-center gap-3",
      pills: "flex items-center gap-3",
      "vertical-pills": "flex flex-col justify-center gap-3"
    }, s = {
      "border-bottom": {
        // Figma pads 14 px above and below with a 3 px INSIDE stroke: the bottom padding gives the
        // border back, and the underline lands on the wrapper's rule.
        base: "px-0.5 pt-3.5 pb-[calc(--spacing(3.5)-3px)] border-b-3",
        activeMark: "border-solid [border-image:var(--gradient-brand-border)_1]",
        hoverMark: "border-transparent hover:[border-image:var(--gradient-brand-border)_1]",
        restMark: "border-transparent",
        activeText: "text-(--text-text-black-default)",
        hoverText: "hover:text-(--text-text-black-default)"
      },
      default: {
        base: "rounded-(--border-border-radius-rounded-xs)",
        activeMark: "underline",
        hoverMark: "hover:underline",
        restMark: "",
        activeText: "text-(--text-text-hover)",
        hoverText: "hover:text-(--text-text-hover)"
      },
      pills: {
        base: `${Kb} rounded-(--border-border-radius-rounded-full)`,
        activeMark: Yb,
        hoverMark: "hover:before:opacity-100 hover:after:opacity-100",
        restMark: "",
        activeText: "text-(--text-text-black-default)",
        hoverText: "hover:text-(--text-text-black-default)"
      },
      "vertical-pills": {
        base: `${Kb} justify-start rounded-(--border-border-radius-rounded-l)`,
        activeMark: Yb,
        hoverMark: "hover:before:opacity-100 hover:after:opacity-100",
        restMark: "",
        activeText: "text-(--text-text-black-default)",
        hoverText: "hover:text-(--text-text-black-default)"
      }
    };
    function d(I) {
      return I.locked === !0 || I.readOnly === !0;
    }
    function c(I) {
      const T = s[e.type], A = I.key === e.modelValue, E = e.type === "pills" || e.type === "vertical-pills";
      return I.locked ? [
        A ? T.activeMark : T.restMark,
        qd,
        "cursor-not-allowed",
        E && !A ? "bg-(--background-background-white)" : ""
      ] : A ? [T.activeMark, I.readOnly ? qd : T.activeText] : [T.hoverMark, I.readOnly ? qd : "text-(--text-text-body)", T.hoverText];
    }
    const f = a, g = R(null), h = R(null), v = R(null), p = rm({
      strip: g,
      arrow: h,
      backArrow: v,
      enabled: () => !t.value,
      selection: () => e.modelValue
    }), y = rn(), k = m(() => {
      const { class: I, style: T, ...A } = y;
      return A;
    });
    function $(I) {
      I.locked || f("update:modelValue", I.key);
    }
    function S(I) {
      var B;
      const T = Array.from(
        I.currentTarget.querySelectorAll("[role=tab]")
      ), A = document.activeElement, E = A ? T.indexOf(A) : -1;
      let z;
      switch (I.key) {
        case (t.value ? "ArrowDown" : "ArrowRight"):
          z = E < 0 ? 0 : (E + 1) % T.length;
          break;
        case (t.value ? "ArrowUp" : "ArrowLeft"):
          z = E <= 0 ? T.length - 1 : E - 1;
          break;
        case "Home":
          z = 0;
          break;
        case "End":
          z = T.length - 1;
          break;
        case "Enter":
        case " ":
          if (A && A.getAttribute("aria-disabled") !== "true") {
            const W = e.tabs[E];
            W && f("update:modelValue", W.key);
          }
          I.preventDefault();
          return;
        default:
          return;
      }
      I.preventDefault(), (B = T[z]) == null || B.focus();
    }
    return (I, T) => (u(), b("div", {
      class: C([n.value, L(y).class]),
      style: Ge(L(y).style)
    }, [
      L(p).showBackArrow.value ? (u(), b("button", {
        key: 0,
        ref_key: "backArrowRef",
        ref: v,
        type: "button",
        "aria-label": e.overflowPreviousLabel,
        "data-testid": "nav-tabs-overflow-back-arrow",
        class: C(r("left-0")),
        onClick: T[0] || (T[0] = //@ts-ignore
        (...A) => L(p).scrollBack && L(p).scrollBack(...A))
      }, [...T[3] || (T[3] = [
        x("i", {
          class: "ri-arrow-left-line text-(length:--icon-size-sm) leading-(--icon-size-sm)",
          "aria-hidden": "true"
        }, null, -1)
      ])], 10, a8)) : w("", !0),
      x("div", Ve({
        ref_key: "stripRef",
        ref: g
      }, k.value, {
        role: "tablist",
        "aria-orientation": t.value ? "vertical" : "horizontal",
        tabindex: L(p).overflowing.value ? -1 : void 0,
        class: [
          i[e.type],
          e.fullWidth || t.value ? "w-full" : "w-max max-w-full",
          !t.value && [
            "nav-tabs-scroll overflow-x-auto overflow-y-hidden",
            o[e.type]
          ]
        ],
        onKeydown: S,
        onScrollPassive: T[1] || (T[1] = //@ts-ignore
        (...A) => L(p).measure && L(p).measure(...A))
      }), [
        (u(!0), b(ie, null, Oe(e.tabs, (A) => (u(), P($t, {
          key: A.key,
          class: C(t.value ? "w-full" : e.fullWidth ? "flex-1 min-w-0" : "shrink-0"),
          text: A.lockTooltip ?? "",
          disabled: !d(A) || !A.lockTooltip,
          position: t.value ? "right" : "bottom"
        }, {
          default: me(() => [
            x("button", {
              id: A.id,
              type: "button",
              role: "tab",
              "data-testid": `nav-tab-${A.key}`,
              "aria-selected": A.key === e.modelValue,
              "aria-disabled": A.locked ? "true" : void 0,
              "aria-controls": A.panelId,
              tabindex: A.key === e.modelValue ? 0 : -1,
              class: C([
                "inline-flex min-w-0 items-center gap-1.5 whitespace-nowrap",
                "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)",
                "transition-colors motion-reduce:transition-none",
                "focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l-inset)",
                s[e.type].base,
                t.value ? "w-full" : e.fullWidth && "w-full justify-center",
                c(A)
              ]),
              onClick: (E) => $(A)
            }, [
              A.icon && !d(A) ? (u(), b("i", {
                key: 0,
                class: C([A.icon, "text-(length:--icon-size-sm) leading-none"]),
                "aria-hidden": "true"
              }, null, 2)) : w("", !0),
              x("span", o8, H(A.label), 1),
              d(A) ? (u(), b("i", r8)) : w("", !0)
            ], 10, l8)
          ]),
          _: 2
        }, 1032, ["class", "text", "disabled", "position"]))), 128))
      ], 16, n8),
      L(p).showArrow.value ? (u(), b("button", {
        key: 1,
        ref_key: "arrowRef",
        ref: h,
        type: "button",
        "aria-label": e.overflowLabel,
        "data-testid": "nav-tabs-overflow-arrow",
        class: C(r("right-0")),
        onClick: T[2] || (T[2] = //@ts-ignore
        (...A) => L(p).scrollForward && L(p).scrollForward(...A))
      }, [...T[4] || (T[4] = [
        x("i", {
          class: "ri-arrow-right-line text-(length:--icon-size-sm) leading-(--icon-size-sm)",
          "aria-hidden": "true"
        }, null, -1)
      ])], 10, i8)) : w("", !0)
    ], 6));
  }
}), u8 = /* @__PURE__ */ Ct(d8, [["__scopeId", "data-v-a1f63d2d"]]), Ud = /* @__PURE__ */ ke({
  __name: "TableHeaderSearch",
  props: {
    placeholder: { default: "Search..." },
    clearLabel: { default: "Clear search" },
    width: { default: "288px" },
    debounce: { default: Vr }
  },
  setup(e) {
    const a = e, t = na(Hl), { draft: n, input: l, flush: o, discardPending: r } = Lx({
      value: () => (t == null ? void 0 : t.state.search) ?? "",
      debounce: () => a.debounce,
      commit: (i) => t == null ? void 0 : t.setSearch(i),
      onPending: (i) => t == null ? void 0 : t.setSearchPending(i)
    });
    return $e(
      () => t == null ? void 0 : t.searchRevision.value,
      () => r((t == null ? void 0 : t.state.search) ?? "")
    ), (i, s) => (u(), P(zs, {
      "data-testid": "table-header-search",
      "data-table-search": "",
      class: "max-w-full",
      style: Ge({ width: e.width }),
      size: "sm",
      width: e.width,
      "model-value": L(n),
      placeholder: e.placeholder,
      "aria-label": e.placeholder,
      labels: { clear: e.clearLabel },
      "onUpdate:modelValue": L(l),
      onSearch: L(o)
    }, null, 8, ["style", "width", "model-value", "placeholder", "aria-label", "labels", "onUpdate:modelValue", "onSearch"]));
  }
});
function Jb(e) {
  return {
    label: e.iconOnly ? void 0 : e.label,
    ariaLabel: e.iconOnly ? e.label : void 0,
    iconLeft: e.icon,
    iconOnly: e.iconOnly,
    dropdownIcon: e.dropdownIcon,
    // With a reason the button stays focusable: aria-disabled blocks it, the reason shows as its tooltip.
    disabled: e.disabled === !0 && !e.description,
    ariaDisabled: e.disabled === !0 && !!e.description,
    "data-testid": e.testId
  };
}
const tn = /* @__PURE__ */ ke({
  __name: "TableHeaderActionButton",
  props: {
    button: {},
    variant: {},
    size: {}
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => t.button.disabled === !0 && !!t.button.description);
    return (o, r) => l.value ? (u(), P($t, {
      key: 0,
      as: "span",
      text: e.button.description ?? ""
    }, {
      default: me(() => [
        U(Be, Ve({
          variant: e.variant,
          size: e.size
        }, L(Jb)(e.button)), null, 16, ["variant", "size"])
      ]),
      _: 1
    }, 8, ["text"])) : (u(), P(Be, Ve({
      key: 1,
      variant: e.variant,
      size: e.size
    }, L(Jb)(e.button), {
      onClick: r[0] || (r[0] = (i) => n("click"))
    }), null, 16, ["variant", "size"]));
  }
}), c8 = ["data-type"], f8 = { class: "ml-auto flex flex-wrap items-center justify-end gap-3" }, h8 = { class: "flex flex-wrap items-center gap-4" }, b8 = { class: "font-(--weight-bold)" }, g8 = { class: "flex flex-wrap items-center gap-3" }, m8 = { class: "flex min-w-0 flex-col gap-1" }, v8 = {
  key: 0,
  class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium) text-(--text-text-body-subtle) dark:text-(--text-text-white-secondary)"
}, p8 = { class: "flex flex-wrap items-center justify-between gap-3" }, x8 = { class: "ml-auto flex flex-wrap items-center justify-end gap-3" }, y8 = { class: "flex flex-wrap items-start justify-between gap-4 border-b border-(--table-header-divider) pb-[calc(--spacing(4)-1px)]" }, k8 = { class: "flex min-w-0 flex-col gap-1.5" }, w8 = {
  key: 0,
  class: "flex items-center gap-1.5 text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
}, C8 = {
  key: 0,
  class: "flex flex-wrap items-center gap-6"
}, S8 = { class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-body) dark:text-(--text-text-white-secondary)" }, $8 = { class: "-mb-px flex flex-wrap items-center justify-between gap-3 pt-4" }, I8 = { class: "ml-auto flex flex-wrap items-center justify-end gap-3" }, L8 = ["aria-level"], T8 = { class: "flex flex-wrap items-center gap-3" }, E8 = "bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--border-border-base-soft) dark:border-(--colors-border-base)", A8 = /* @__PURE__ */ ke({
  __name: "TableShellHeader",
  props: {
    header: {},
    panelId: {},
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    searchDebounce: { default: Vr },
    inset: { type: Boolean, default: !1 }
  },
  emits: ["action", "tab-change"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => t.header), o = m(() => ({
      ...cP,
      ..."labels" in l.value ? l.value.labels : void 0
    })), r = m(() => `h${"headingLevel" in l.value ? l.value.headingLevel ?? 2 : 2}`), i = m(() => "filter" in l.value && !!l.value.filter), s = m(() => t.header.type === "two-levels-stats" ? "" : "rounded-t-(--border-border-radius-rounded-l)"), d = m(
      () => t.inset ? "border-b px-5 pt-5 pb-[calc(--spacing(5)-1px)]" : "border p-[calc(--spacing(5)-1px)]"
    ), c = m(
      () => t.inset ? "border-b px-3 pt-3 pb-[calc(--spacing(3)-1px)]" : "border p-[calc(--spacing(3)-1px)]"
    ), f = m(
      () => t.inset ? "border-b px-5 pt-5" : "border px-[calc(--spacing(5)-1px)] pt-[calc(--spacing(5)-1px)]"
    ), g = m(() => ({
      default: `${d.value} flex flex-wrap items-center justify-between gap-2.5`,
      "cta-button-group": `${d.value} flex flex-wrap items-start justify-between gap-2.5`,
      "stats-update-button": `${d.value} flex flex-wrap items-center justify-between gap-2.5`,
      "two-levels-stats": `${d.value} flex flex-wrap items-center justify-between gap-2.5`,
      "heading-description": `${d.value} flex flex-wrap items-center justify-between gap-4`,
      "tab-button-search": `${c.value} flex flex-col gap-3`,
      tabs: `${f.value} flex flex-col`,
      // Its filter controls row (TableControls, drawn by TableShell) follows and carries the bottom border.
      // Table & Title (7240:31167) puts 8px between this row and the controls row (the set default is 0).
      "title-quick-filters": "px-3 pt-3 pb-2 flex flex-wrap items-center justify-between gap-3",
      "modal-enlarged": "border-b px-3 pt-3 pb-[calc(--spacing(3)-1px)] flex flex-wrap items-center justify-between gap-2.5",
      relations: "border-b px-3 pt-3 pb-[calc(--spacing(3)-1px)] flex flex-wrap items-center justify-between gap-2.5",
      "two-levels-prefiltered-lists": ""
    })), h = {
      "heading-description": "text-(length:--size-xl) leading-(--line-height-m) font-(--weight-medium) text-(--text-text-heading) dark:text-(--text-text-white-default)",
      tabs: "text-(length:--size-xl) leading-(--line-height-xxl) font-(--weight-medium) text-(--text-text-heading) dark:text-(--text-text-white-default)",
      "title-quick-filters": "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--text-text-white-default)",
      "modal-enlarged": "text-(length:--size-3xl) leading-(--line-height-3xl) font-(--weight-bold) text-(--text-text-heading) dark:text-(--text-text-white-default)"
    }, v = {
      default: "text-(--text-text-heading) dark:text-(--text-text-white-default)",
      success: "text-(--text-text-success)",
      error: "text-(--text-text-error)"
    };
    return (p, y) => {
      var k, $, S;
      return u(), b("div", {
        "data-testid": "table-header",
        "data-type": l.value.type,
        class: C([E8, s.value, g.value[l.value.type]])
      }, [
        l.value.type === "default" ? (u(), b(ie, { key: 0 }, [
          e.showSearch ? (u(), P(Ud, {
            key: 0,
            width: "256px",
            placeholder: e.searchPlaceholder,
            "clear-label": o.value.clearSearchLabel,
            debounce: e.searchDebounce
          }, null, 8, ["placeholder", "clear-label", "debounce"])) : w("", !0),
          x("div", f8, [
            (u(!0), b(ie, null, Oe(l.value.leadingActions, (I) => (u(), P(tn, {
              key: I.id,
              button: I,
              variant: "secondary",
              size: "xs",
              onClick: (T) => n("action", I.id)
            }, null, 8, ["button", "onClick"]))), 128)),
            i.value ? Me(p.$slots, "filter", { key: 0 }) : w("", !0),
            (u(!0), b(ie, null, Oe(l.value.actions, (I) => (u(), P(tn, {
              key: I.id,
              button: I,
              variant: "secondary",
              size: "xs",
              onClick: (T) => n("action", I.id)
            }, null, 8, ["button", "onClick"]))), 128))
          ])
        ], 64)) : l.value.type === "cta-button-group" ? (u(), b(ie, { key: 1 }, [
          U(Ri, {
            variant: "pill",
            size: "xs",
            "aria-label": o.value.tabsLabel,
            "model-value": l.value.activeTab,
            "panel-id": e.panelId,
            "overflow-label": o.value.nextTabsLabel,
            "overflow-previous-label": o.value.previousTabsLabel,
            class: "min-w-0",
            "onUpdate:modelValue": y[0] || (y[0] = (I) => n("tab-change", String(I)))
          }, {
            default: me(() => [
              (u(!0), b(ie, null, Oe(l.value.tabs, (I) => (u(), P(Be, {
                key: I.value,
                variant: "tertiary",
                size: "xs",
                value: I.value,
                label: I.label
              }, null, 8, ["value", "label"]))), 128))
            ]),
            _: 1
          }, 8, ["aria-label", "model-value", "panel-id", "overflow-label", "overflow-previous-label"]),
          l.value.action ? (u(), P(tn, {
            key: 0,
            button: l.value.action,
            variant: "secondary",
            size: "sm",
            onClick: y[1] || (y[1] = (I) => n("action", l.value.action.id))
          }, null, 8, ["button"])) : w("", !0)
        ], 64)) : l.value.type === "stats-update-button" || l.value.type === "two-levels-stats" ? (u(), b(ie, { key: 2 }, [
          x("ul", h8, [
            (u(!0), b(ie, null, Oe(l.value.stats, (I, T) => (u(), b("li", {
              key: T,
              class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-heading) dark:text-(--text-text-white-default)"
            }, [
              typeof I == "string" ? (u(), b(ie, { key: 0 }, [
                st(H(I), 1)
              ], 64)) : (u(), b(ie, { key: 1 }, [
                st(H(I.label) + " ", 1),
                x("strong", b8, H(I.value), 1)
              ], 64))
            ]))), 128))
          ]),
          x("div", g8, [
            (u(!0), b(ie, null, Oe(l.value.actions, (I) => (u(), P(tn, {
              key: I.id,
              button: I,
              variant: "secondary",
              size: "xs",
              onClick: (T) => n("action", I.id)
            }, null, 8, ["button", "onClick"]))), 128))
          ])
        ], 64)) : l.value.type === "heading-description" ? (u(), b(ie, { key: 3 }, [
          x("div", m8, [
            (u(), P(gt(r.value), {
              class: C(h["heading-description"])
            }, {
              default: me(() => [
                st(H(l.value.title), 1)
              ]),
              _: 1
            }, 8, ["class"])),
            l.value.description ? (u(), b("p", v8, H(l.value.description), 1)) : w("", !0)
          ]),
          l.value.action ? (u(), P(tn, {
            key: 0,
            button: l.value.action,
            variant: "secondary",
            size: "sm",
            onClick: y[2] || (y[2] = (I) => n("action", l.value.action.id))
          }, null, 8, ["button"])) : w("", !0)
        ], 64)) : l.value.type === "tab-button-search" ? (u(), b(ie, { key: 4 }, [
          x("div", p8, [
            e.showSearch ? (u(), P(Ud, {
              key: 0,
              placeholder: e.searchPlaceholder,
              "clear-label": o.value.clearSearchLabel,
              debounce: e.searchDebounce
            }, null, 8, ["placeholder", "clear-label", "debounce"])) : w("", !0),
            x("div", x8, [
              l.value.primaryAction ? (u(), P(tn, {
                key: 0,
                button: l.value.primaryAction,
                variant: "primary",
                size: "sm",
                onClick: y[3] || (y[3] = (I) => n("action", l.value.primaryAction.id))
              }, null, 8, ["button"])) : w("", !0),
              i.value ? Me(p.$slots, "filter", { key: 1 }) : w("", !0),
              (u(!0), b(ie, null, Oe(l.value.actions, (I) => (u(), P(tn, {
                key: I.id,
                button: I,
                variant: "secondary",
                size: "sm",
                onClick: (T) => n("action", I.id)
              }, null, 8, ["button", "onClick"]))), 128))
            ])
          ]),
          U(Ri, {
            variant: "pill",
            size: "xs",
            "aria-label": o.value.tabsLabel,
            "model-value": l.value.activeTab,
            "panel-id": e.panelId,
            "overflow-label": o.value.nextTabsLabel,
            "overflow-previous-label": o.value.previousTabsLabel,
            class: "min-w-0 self-start",
            "onUpdate:modelValue": y[4] || (y[4] = (I) => n("tab-change", String(I)))
          }, {
            default: me(() => [
              (u(!0), b(ie, null, Oe(l.value.tabs, (I) => (u(), P(Be, {
                key: I.value,
                variant: "tertiary",
                size: "xs",
                value: I.value,
                label: I.label
              }, null, 8, ["value", "label"]))), 128))
            ]),
            _: 1
          }, 8, ["aria-label", "model-value", "panel-id", "overflow-label", "overflow-previous-label"])
        ], 64)) : l.value.type === "tabs" ? (u(), b(ie, { key: 5 }, [
          x("div", y8, [
            x("div", k8, [
              (u(), P(gt(r.value), {
                class: C(h.tabs)
              }, {
                default: me(() => [
                  st(H(l.value.title), 1)
                ]),
                _: 1
              }, 8, ["class"])),
              l.value.subtitle ? (u(), b("p", w8, [
                x("i", {
                  class: C([l.value.subtitleIcon ?? "ri-map-pin-fill", "text-(length:--size-m) leading-none text-(--text-text-heading) dark:text-(--text-text-white-default)"]),
                  "aria-hidden": "true"
                }, null, 2),
                st(" " + H(l.value.subtitle), 1)
              ])) : w("", !0)
            ]),
            (k = l.value.figures) != null && k.length ? (u(), b("dl", C8, [
              (u(!0), b(ie, null, Oe(l.value.figures, (I, T) => (u(), b("div", {
                key: T,
                class: "flex flex-col gap-1"
              }, [
                x("dt", S8, H(I.label), 1),
                x("dd", {
                  class: C(["text-(length:--size-xl) leading-(--table-header-figure-line-height) font-(--weight-semi-bold)", v[I.tone ?? "default"]])
                }, H(I.value), 3)
              ]))), 128))
            ])) : w("", !0)
          ]),
          x("div", $8, [
            U(u8, {
              type: "border-bottom",
              "aria-label": o.value.tabsLabel,
              tabs: l.value.tabs.map((I) => ({ key: I.value, label: I.label, id: L(pc)(e.panelId, I.value), panelId: e.panelId })),
              "model-value": l.value.activeTab,
              "overflow-label": o.value.nextTabsLabel,
              "overflow-previous-label": o.value.previousTabsLabel,
              class: "min-w-0",
              "onUpdate:modelValue": y[5] || (y[5] = (I) => n("tab-change", I))
            }, null, 8, ["aria-label", "tabs", "model-value", "overflow-label", "overflow-previous-label"]),
            x("div", I8, [
              i.value ? Me(p.$slots, "filter", { key: 0 }) : w("", !0),
              (u(!0), b(ie, null, Oe(l.value.actions, (I) => (u(), P(tn, {
                key: I.id,
                button: I,
                variant: "secondary",
                size: "sm",
                onClick: (T) => n("action", I.id)
              }, null, 8, ["button", "onClick"]))), 128))
            ])
          ])
        ], 64)) : l.value.type === "title-quick-filters" ? (u(), b(ie, { key: 6 }, [
          (u(), P(gt(r.value), {
            class: C(h["title-quick-filters"])
          }, {
            default: me(() => [
              st(H(l.value.title), 1)
            ]),
            _: 1
          }, 8, ["class"])),
          e.showSearch ? (u(), P(Ud, {
            key: 0,
            placeholder: e.searchPlaceholder,
            "clear-label": o.value.clearSearchLabel,
            debounce: e.searchDebounce
          }, null, 8, ["placeholder", "clear-label", "debounce"])) : w("", !0)
        ], 64)) : l.value.type === "modal-enlarged" ? (u(), b(ie, { key: 7 }, [
          (u(), P(gt(r.value), {
            class: C(h["modal-enlarged"])
          }, {
            default: me(() => [
              st(H(l.value.title), 1)
            ]),
            _: 1
          }, 8, ["class"])),
          l.value.action ? (u(), P(tn, {
            key: 0,
            button: l.value.action,
            variant: "primary",
            size: "xs",
            onClick: y[6] || (y[6] = (I) => n("action", l.value.action.id))
          }, null, 8, ["button"])) : w("", !0)
        ], 64)) : l.value.type === "relations" ? (u(), b(ie, { key: 8 }, [
          x("div", {
            role: "heading",
            "aria-level": l.value.headingLevel ?? 2,
            class: "min-w-0"
          }, [
            U(Sx, {
              size: "xl",
              type: "heading-helper",
              name: l.value.title,
              "helper-text": l.value.description,
              img: ($ = l.value.avatar) == null ? void 0 : $.img,
              entity: (S = l.value.avatar) == null ? void 0 : S.entity
            }, null, 8, ["name", "helper-text", "img", "entity"])
          ], 8, L8),
          x("div", T8, [
            (u(!0), b(ie, null, Oe(l.value.actions, (I) => (u(), P(tn, {
              key: I.id,
              button: I,
              variant: "secondary",
              size: "sm",
              onClick: (T) => n("action", I.id)
            }, null, 8, ["button", "onClick"]))), 128))
          ])
        ], 64)) : w("", !0)
      ], 10, c8);
    };
  }
}), R8 = {
  "data-testid": "filter-field-picker",
  class: "flex min-h-0 flex-col"
}, z8 = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only",
  "data-testid": "filter-field-picker-status"
}, D8 = {
  class: "flex min-h-0 flex-col pb-2",
  "data-testid": "filter-field-picker-content"
}, B8 = ["aria-label"], M8 = ["data-empty-reason"], Px = /* @__PURE__ */ ke({
  __name: "FilterFieldPicker",
  props: {
    fields: {},
    groups: { default: () => [] },
    activeGroup: { default: void 0 },
    strictGroups: { type: Boolean, default: !1 },
    searchQuery: { default: "" },
    searchPlaceholder: {},
    searchLabel: { default: void 0 },
    searchClearLabel: { default: "Clear search" },
    groupsLabel: { default: void 0 },
    groupAriaLabel: { default: void 0 },
    listLabel: {},
    selectedKey: { default: void 0 },
    selectable: { type: Boolean, default: !0 },
    noResultsLabel: { default: void 0 },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    noFieldsLabel: { default: void 0 },
    emptyGroupLabel: { default: void 0 }
  },
  emits: ["select", "update:activeGroup", "update:searchQuery"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = R(null), r = R(null), i = m(() => {
      let E = n.fields;
      return n.groups.length && n.activeGroup && (E = E.filter((z) => z.group === n.activeGroup || !z.group && !n.strictGroups)), n.searchQuery.trim() && (E = E.filter((z) => kc(z.label, n.searchQuery))), E;
    }), s = m(() => n.searchQuery.trim() ? n.noResultsLabel : n.fields.length ? n.emptyGroupLabel ?? n.noFieldsLabel : n.noFieldsLabel), d = m(() => n.searchQuery.trim() ? "no-results" : n.fields.length ? "empty-group" : "no-fields"), { focusedIndex: c, handleRovingKeydown: f, handleSearchFieldKeydown: g, clampFocusedIndex: h } = Mr(), v = m(() => i.value.findIndex((E) => E.key === n.selectedKey));
    $e(
      [v, () => i.value.length],
      ([E, z]) => {
        E >= 0 ? c.value = E : h(z);
      },
      { immediate: !0 }
    );
    function p(E) {
      return !n.selectable || !!E.disabled;
    }
    function y(E) {
      p(E) || l("select", E.key);
    }
    function k(E, z) {
      return {
        role: "option",
        "aria-selected": E.key === n.selectedKey,
        tabindex: z === c.value ? 0 : -1,
        "data-listbox-index": z,
        onClick: () => y(E),
        onKeydown: St(_e(() => y(E), ["self", "prevent"]), ["enter", "space"]),
        onFocus: () => {
          c.value = z;
        }
      };
    }
    function $(E) {
      f(E, i.value.length, r.value);
    }
    function S(E) {
      if (!(E.target instanceof HTMLInputElement)) return;
      const z = v.value;
      g(E, i.value.length, r.value, z >= 0 ? { downIndex: z, upIndex: z } : {});
    }
    function I() {
      var E;
      return ((E = o.value) == null ? void 0 : E.focusSearch()) ?? !1;
    }
    function T(E = c.value) {
      var B;
      const z = (B = r.value) == null ? void 0 : B.querySelector(`[data-listbox-index="${E}"]`);
      return z ? (c.value = E, z.focus({ preventScroll: !0 }), z.scrollIntoView({ block: "nearest" }), !0) : !1;
    }
    function A(E) {
      const z = i.value.findIndex((B) => B.key === E);
      return z >= 0 && T(z);
    }
    return a({ focusSearch: I, focusOption: T, focusField: A }), (E, z) => (u(), b("div", R8, [
      U(Bl, {
        ref_key: "headerRef",
        ref: o,
        class: "shrink-0",
        "show-search": "",
        "search-query": e.searchQuery,
        "search-placeholder": e.searchPlaceholder,
        "search-label": e.searchLabel ?? e.searchPlaceholder,
        "search-clear-label": e.searchClearLabel,
        "group-buttons": e.groups,
        "active-group": e.activeGroup,
        "group-label-left": e.groupsLabel,
        "group-aria-label": e.groupAriaLabel,
        onKeydown: S,
        "onUpdate:searchQuery": z[0] || (z[0] = (B) => l("update:searchQuery", B)),
        "onUpdate:activeGroup": z[1] || (z[1] = (B) => l("update:activeGroup", B))
      }, null, 8, ["search-query", "search-placeholder", "search-label", "search-clear-label", "group-buttons", "active-group", "group-label-left", "group-aria-label"]),
      x("span", z8, H(i.value.length ? L(Rs)(e.resultsCountLabel, i.value.length) : s.value), 1),
      x("div", D8, [
        i.value.length ? (u(), b("div", {
          key: 0,
          ref_key: "listboxRef",
          ref: r,
          role: "listbox",
          "aria-label": e.listLabel,
          class: "flex min-h-0 flex-col overflow-y-auto px-2 py-1.5",
          "data-testid": "filter-field-picker-list",
          onKeydown: $
        }, [
          (u(!0), b(ie, null, Oe(i.value, (B, W) => (u(), P(fa, Ve({
            key: B.key
          }, { ref_for: !0 }, k(B, W), {
            type: "two-icons",
            label: B.label,
            icon: B.icon,
            selected: B.key === e.selectedKey,
            "aria-disabled": p(B),
            description: B.disabled ? B.disabledReason : void 0,
            class: "shrink-0",
            "data-testid": `filter-field-picker-option-${B.key}`
          }), null, 16, ["label", "icon", "selected", "aria-disabled", "description", "data-testid"]))), 128))
        ], 40, B8)) : s.value ? (u(), b("div", {
          key: 1,
          "data-testid": "filter-field-picker-empty",
          "data-empty-reason": d.value,
          class: "flex flex-col items-center justify-center px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
        }, H(s.value), 9, M8)) : w("", !0)
      ])
    ]));
  }
}), O8 = ["id", "aria-label", "data-size"], P8 = {
  key: 0,
  "data-testid": "filter-step-list",
  class: "flex min-h-0 flex-col"
}, F8 = { class: "flex min-h-0 flex-col pb-2" }, N8 = ["aria-multiselectable", "aria-label"], V8 = {
  key: 0,
  "data-testid": "filter-select-all",
  class: "shrink-0 border-b border-(--border-border-base-soft) px-2 pt-2 pb-[calc(--spacing(2)-1px)] dark:border-(--colors-border-base)"
}, H8 = {
  key: 1,
  class: "min-h-0 overflow-y-auto"
}, j8 = {
  key: 1,
  "data-testid": "filter-step-list-empty",
  class: "px-4 py-6 text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, W8 = {
  key: 1,
  class: "flex min-h-0 flex-col"
}, q8 = { class: "flex min-h-0 flex-col overflow-y-auto pb-2" }, U8 = {
  key: 0,
  "data-testid": "filter-step-text",
  class: "flex flex-col gap-4 px-3 py-4"
}, G8 = { "data-testid": "filter-text-validate-error" }, K8 = ["aria-label"], Y8 = {
  key: 0,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, J8 = ["aria-label"], X8 = { class: "flex items-start gap-6" }, Z8 = {
  key: 0,
  class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, ii = 4, Fo = 16, Q8 = 540, _8 = 240, eF = /* @__PURE__ */ ke({
  __name: "TableFilterSelector",
  props: {
    triggerSize: { default: "xs" },
    fields: {},
    fieldGroups: { default: () => [] },
    fieldGroupsLabel: { default: "" },
    triggerLabel: { default: "Filter" },
    triggerIconLeft: { default: void 0 },
    activeCount: { default: 0 },
    step1SearchPlaceholder: { default: "Search a filter…" },
    searchClearLabel: { default: "Clear search" },
    step1FooterLabel: { default: "Rechercher par :" },
    advancedFiltersLabel: { default: "Filters avancées" },
    advancedFiltersIcon: { default: "ri-equalizer-line" },
    viewAdvancedLabel: { default: "" },
    createAdvancedLabel: { default: "" },
    advancedDisabled: { type: Boolean, default: !1 },
    advancedDisabledTooltip: { default: "" },
    backLabel: { default: "Back" },
    confirmLabel: { default: "Confirm" },
    closeOnConfirm: { type: Boolean, default: !0 },
    dateRangeErrorLabel: { default: 'The "From" date must be before or equal to the "To" date.' },
    noResultsLabel: { default: "No results for" },
    noFieldResultsLabel: { default: "No field matches your search" },
    resultsCountLabel: { type: [String, Function], default: "{count} results" },
    selectedCountLabel: { type: Function, default: (e, a) => `${e} of ${a} selected` },
    noFieldsLabel: { default: "" },
    activeFilters: { default: () => ({}) },
    fieldsSelectable: { type: Boolean, default: !0 }
  },
  emits: ["apply", "apply-filter", "remove-filter", "advanced-filters", "view-advanced-filters", "create-advanced-filter"],
  setup(e, { expose: a, emit: t }) {
    var ha, Ot;
    const n = e, l = t, o = R(null), r = m(() => {
      var ce;
      return ((ce = o.value) == null ? void 0 : ce.$el) ?? null;
    }), { isOpen: i, dropdownRef: s, toggleDropdown: d, openDropdown: c, closeDropdown: f } = So({
      onClose: Ht,
      ignoreSelectors: [
        '[data-testid="datepicker-dropdown-menu"]',
        '[data-testid="datepicker-dob-picker"]',
        '[data-testid="filter-selector-menu"]'
      ]
    }), g = R({}), h = R(null), v = R(null), p = R(null);
    function y() {
      var Te, ot;
      const ce = (Te = r.value) == null ? void 0 : Te.getBoundingClientRect();
      if (!ce) return;
      const he = typeof window < "u" ? window.innerWidth : ce.right, Le = typeof window < "u" ? window.innerHeight : ce.bottom, Je = ((ot = v.value) == null ? void 0 : ot.offsetWidth) ?? 0, ml = ce.left + ce.width / 2 > he / 2 ? ce.right - Je : ce.left, To = Math.max(Fo, he - Fo - Je), be = Le - ce.bottom - ii - Fo, ye = ce.top - ii - Fo, ze = be < _8 && ye > be;
      g.value = {
        position: "fixed",
        ...ze ? { bottom: `${Le - ce.top + ii}px` } : { top: `${ce.bottom + ii}px` },
        left: `${Math.max(Fo, Math.min(ml, To))}px`,
        maxHeight: `${Math.min(Q8, Math.max(ze ? ye : be, 0))}px`,
        zIndex: "350"
      };
    }
    function k() {
      typeof window > "u" || (window.addEventListener("scroll", y, !0), window.addEventListener("resize", y));
    }
    function $() {
      typeof window > "u" || (window.removeEventListener("scroll", y, !0), window.removeEventListener("resize", y));
    }
    $e(i, (ce) => {
      ce ? Ze(() => {
        var he;
        if (y(), k(), h.value) {
          je(h.value), h.value = null;
          return;
        }
        (he = p.value) != null && he.focusSearch() || Ie();
      }) : $();
    }), Tt($);
    function S(ce) {
      !i.value && (ce.key === "ArrowDown" || ce.key === "ArrowUp") && (ce.preventDefault(), c());
    }
    function I(ce) {
      if (i.value) {
        je(ce);
        return;
      }
      h.value = ce, setTimeout(d, 0);
    }
    a({ openDropdown: c, closeDropdown: f, openForField: I, triggerEl: r });
    function T(ce) {
      i.value && (ce.stopPropagation(), ce.preventDefault(), A.value === "value" ? bt() : (f(), Ze(() => {
        var he;
        return (he = r.value) == null ? void 0 : he.focus();
      })));
    }
    const A = R("field"), E = R(""), z = R(((Ot = (ha = n.fieldGroups) == null ? void 0 : ha[0]) == null ? void 0 : Ot.value) ?? "");
    $e(
      () => n.fieldGroups,
      (ce) => {
        ce != null && ce.length && (ce.some((he) => he.value === z.value) || (z.value = ce[0].value));
      },
      { immediate: !0 }
    );
    const B = R(null), W = R(null), _ = R(""), Z = R(/* @__PURE__ */ new Set()), le = R(""), D = R(null), O = R(null), N = R(""), V = R(""), M = m(
      () => B.value != null ? n.fields.find((ce) => ce.key === B.value) ?? null : null
    );
    function Q(ce, he) {
      if (!ce) return null;
      const Le = ce.split(/[/\\\-.]/), Je = he.toLowerCase().split(/[/\\\-.]/), Bt = {};
      return Je.forEach((Va, ml) => {
        Bt[Va] = parseInt(Le[ml], 10);
      }), isNaN(Bt.yyyy) || isNaN(Bt.mm) || isNaN(Bt.dd) ? null : new Date(Bt.yyyy, (Bt.mm || 1) - 1, Bt.dd || 1);
    }
    const q = m(() => {
      var ce;
      return (ce = M.value) != null && ce.maxLength ? le.value.length <= M.value.maxLength : !0;
    }), K = m(() => {
      var Le, Je;
      if (((Le = M.value) == null ? void 0 : Le.type) !== "text") return null;
      const ce = (Je = M.value) == null ? void 0 : Je.validate;
      if (!ce) return null;
      const he = le.value.trim();
      return he.length === 0 ? null : ce(he);
    }), G = m(() => {
      const ce = M.value;
      if (!(!ce || ce.type !== "text")) {
        if (ce.maxLength && le.value.length > ce.maxLength)
          return ce.maxLengthErrorLabel ?? `Maximum ${ce.maxLength} characters`;
        if (K.value) return K.value;
      }
    }), te = Ye(), ve = m(() => `${te}-text`), Se = m(() => `${te}-date-from`), oe = m(() => `${te}-date-to`), re = m(() => D.value == null || O.value == null ? !0 : D.value <= O.value), ge = m(() => {
      var Je;
      if (!N.value || !V.value) return !0;
      const ce = ((Je = M.value) == null ? void 0 : Je.dateFormat) ?? "dd/mm/yyyy", he = Q(N.value, ce), Le = Q(V.value, ce);
      return !he || !Le ? !0 : he <= Le;
    }), de = m(() => {
      var ce;
      return ((ce = M.value) == null ? void 0 : ce.type) ?? "list";
    }), Ee = m(
      () => A.value === "value" && M.value && de.value !== "list" ? "m" : "l"
    ), j = m(() => ({ width: Ic[Ee.value] }));
    $e(Ee, () => {
      i.value && Ze(y);
    });
    const J = m(
      () => n.fields.map((ce) => ({
        key: ce.key,
        label: ce.label,
        icon: ce.icon,
        group: ce.group,
        disabled: ce.disabled,
        disabledReason: ce.disabledReason
      }))
    ), ne = m(() => !!n.viewAdvancedLabel && !!n.createAdvancedLabel), Y = m(() => {
      const ce = n.step1FooterLabel;
      if (ne.value)
        return {
          type: "buttons-column",
          label: ce,
          buttons: [
            {
              label: n.createAdvancedLabel,
              variant: "primary",
              icon: "ri-add-line",
              ariaDisabled: n.advancedDisabled,
              testId: "create-advanced-filter-btn"
            },
            {
              label: n.viewAdvancedLabel,
              variant: "secondary",
              icon: n.advancedFiltersIcon,
              ariaDisabled: n.advancedDisabled,
              testId: "view-advanced-filters-btn"
            }
          ],
          description: n.advancedDisabled && n.advancedDisabledTooltip || void 0
        };
      if (!n.advancedFiltersLabel) return null;
      const he = {
        label: n.advancedFiltersLabel,
        variant: "secondary",
        icon: n.advancedFiltersIcon,
        testId: "advanced-filters-btn"
      };
      return ce ? { type: "label-button", label: ce, buttons: [he] } : { type: "button", buttons: [he] };
    });
    function F(ce) {
      ne.value ? ce === 0 ? It() : pt() : et();
    }
    const ee = m(() => {
      if (!M.value || de.value !== "list") return [];
      const ce = M.value.items ?? [], he = _.value.trim().toLowerCase();
      return he ? ce.filter((Le) => Le.label.toLowerCase().includes(he)) : ce;
    }), ue = m(() => {
      var ce;
      return (((ce = M.value) == null ? void 0 : ce.items) ?? []).length;
    }), se = m(() => {
      var Le;
      const ce = ((Le = M.value) == null ? void 0 : Le.items) ?? [];
      return ce.some((Je) => typeof Je.count == "number") ? ce.reduce((Je, Bt) => Je + (typeof Bt.count == "number" ? Bt.count : 0), 0) : ue.value;
    }), X = m(
      () => {
        var ce;
        return (((ce = M.value) == null ? void 0 : ce.items) ?? []).filter((he) => Z.value.has(he.id)).length;
      }
    ), ae = m(
      () => X.value === ue.value && ue.value > 0
    ), Re = m(
      () => X.value > 0 && X.value < ue.value
    ), Ae = R(null), {
      focusedIndex: xe,
      handleRovingKeydown: we,
      clampFocusedIndex: fe,
      focusListboxOption: Ne,
      handleSearchFieldKeydown: De
    } = Mr(), qe = m(
      () => {
        var ce, he;
        return !((ce = M.value) != null && ce.single) && !_.value && (((he = M.value) == null ? void 0 : he.items) ?? []).length > 0;
      }
    ), Qe = m(
      () => (qe.value ? 1 : 0) + ee.value.length
    );
    $e(
      () => Qe.value,
      (ce) => fe(ce)
    ), $e(A, (ce) => {
      if (ce === "field") {
        const he = W.value;
        Ze(() => {
          var Le, Je;
          he && ((Le = p.value) != null && Le.focusField(he)) || (Je = p.value) != null && Je.focusOption(0) || Ie();
        });
      }
    });
    function lt() {
      xe.value = 0, Ze(() => {
        Ne(Ae.value, 0), Ie();
      });
    }
    function Ie() {
      var he, Le, Je;
      if ((he = v.value) != null && he.contains(document.activeElement)) return;
      (Je = ((Le = v.value) == null ? void 0 : Le.querySelector(
        'input:not([type="hidden"]):not([type="range"]), textarea, button'
      )) ?? v.value) == null || Je.focus({ preventScroll: !0 });
    }
    function pe(ce) {
      we(ce, Qe.value, Ae.value);
    }
    function Pe(ce) {
      ce.target instanceof HTMLInputElement && De(ce, Qe.value, Ae.value);
    }
    function Xe(ce, he, Le) {
      return {
        role: "option",
        "aria-selected": he,
        tabindex: xe.value === ce ? 0 : -1,
        "data-listbox-index": ce,
        onClick: Le,
        onKeydown: St(_e(Le, ["self", "prevent"]), ["enter", "space"]),
        onFocus: () => {
          xe.value = ce;
        }
      };
    }
    const nt = m(
      () => X.value > 0 ? n.selectedCountLabel(X.value, ue.value) : ""
    ), vt = m(
      () => de.value === "text" && (!q.value || !!K.value) || de.value === "dateRange" && !ge.value || de.value === "range" && !re.value
    ), Gt = m(() => ({
      type: "buttons-inline",
      buttons: [
        { label: n.backLabel, variant: "secondary", icon: "ri-arrow-left-line", testId: "filter-back-btn" },
        { label: n.confirmLabel, variant: "primary", disabled: vt.value, testId: "filter-apply-btn" }
      ]
    }));
    function Fe(ce) {
      ce === 0 ? bt() : He();
    }
    function je(ce) {
      var Je, Bt;
      const he = B.value === ce;
      B.value = ce, _.value = "";
      const Le = (Je = n.activeFilters) == null ? void 0 : Je[ce];
      Le ? (Le.type === "in" ? Z.value = new Set(Le.values) : Z.value = /* @__PURE__ */ new Set(), le.value = Le.type === "equals" ? String(Le.value) : "", D.value = Le.type === "range" ? Le.min : null, O.value = Le.type === "range" ? Le.max : null, N.value = Le.type === "dateRange" ? Le.from ?? "" : "", V.value = Le.type === "dateRange" ? Le.to ?? "" : "") : (Z.value = /* @__PURE__ */ new Set(), le.value = "", D.value = null, O.value = null, N.value = "", V.value = ""), A.value = "value", (!he || !((Bt = v.value) != null && Bt.contains(document.activeElement))) && lt();
    }
    function Ke(ce) {
      n.fieldsSelectable && je(ce);
    }
    function bt() {
      W.value = B.value, A.value = "field", B.value = null;
    }
    function At(ce) {
      var Le;
      if ((Le = M.value) != null && Le.single) {
        Z.value = Z.value.has(ce) ? /* @__PURE__ */ new Set() : /* @__PURE__ */ new Set([ce]);
        return;
      }
      const he = new Set(Z.value);
      he.has(ce) ? he.delete(ce) : he.add(ce), Z.value = he;
    }
    function Ce() {
      var ce;
      ae.value ? Z.value = /* @__PURE__ */ new Set() : Z.value = new Set((((ce = M.value) == null ? void 0 : ce.items) ?? []).map((he) => he.id));
    }
    function He() {
      const ce = B.value, he = de.value;
      if (he === "list")
        l("apply", ce, [...Z.value]);
      else if (he === "text") {
        if (K.value)
          return;
        le.value.trim() ? l("apply-filter", ce, { type: "equals", value: le.value.trim() }) : l("remove-filter", ce);
      } else he === "range" ? D.value != null || O.value != null ? l("apply-filter", ce, { type: "range", min: D.value, max: O.value }) : l("remove-filter", ce) : he === "dateRange" && (N.value || V.value ? l("apply-filter", ce, {
        type: "dateRange",
        from: N.value || null,
        to: V.value || null
      }) : l("remove-filter", ce));
      n.closeOnConfirm ? (f(), Ze(() => {
        var Le;
        return (Le = r.value) == null ? void 0 : Le.focus();
      })) : bt();
    }
    function et() {
      l("advanced-filters"), f();
    }
    function pt() {
      n.advancedDisabled || (l("view-advanced-filters"), f());
    }
    function It() {
      n.advancedDisabled || (l("create-advanced-filter"), f());
    }
    function Ht() {
      var ce, he;
      W.value = null, A.value = "field", B.value = null, E.value = "", z.value = ((he = (ce = n.fieldGroups) == null ? void 0 : ce[0]) == null ? void 0 : he.value) ?? "", _.value = "", Z.value = /* @__PURE__ */ new Set(), le.value = "", D.value = null, O.value = null, N.value = "", V.value = "";
    }
    return (ce, he) => (u(), b("div", {
      ref_key: "dropdownRef",
      ref: s,
      class: "relative inline-block text-left dark:text-(--colors-text-white-default)",
      onKeydown: St(T, ["escape"])
    }, [
      U(L(Be), {
        ref_key: "triggerButtonRef",
        ref: o,
        "data-testid": "filter-selector-trigger",
        size: e.triggerSize,
        variant: "secondary",
        "icon-left": e.triggerIconLeft,
        "dropdown-icon": "",
        "aria-expanded": L(i),
        "aria-controls": L(i) ? L(te) : void 0,
        "aria-haspopup": "dialog",
        onClick: L(d),
        onKeydown: S
      }, {
        default: me(() => [
          st(H(e.triggerLabel) + " ", 1),
          e.activeCount > 0 ? (u(), P(yt, {
            key: 0,
            "data-testid": "filter-active-badge",
            class: "ms-1.5",
            theme: "active",
            size: "sm",
            "badge-style": "circle",
            "text-only": "",
            value: e.activeCount
          }, null, 8, ["value"])) : w("", !0)
        ]),
        _: 1
      }, 8, ["size", "icon-left", "aria-expanded", "aria-controls", "onClick"]),
      (u(), P(Fa, { to: "body" }, [
        U(Wt, {
          "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: me(() => [
            L(i) ? (u(), b("div", {
              key: 0,
              id: L(te),
              ref_key: "panelRef",
              ref: v,
              role: "dialog",
              "aria-label": e.triggerLabel,
              "data-testid": "filter-selector-menu",
              "data-size": Ee.value,
              "data-focus-trap-allow-outside": "",
              tabindex: "-1",
              style: Ge([j.value, g.value]),
              class: C([
                "flex max-h-[540px] max-w-[calc(100vw-2rem)] flex-col overflow-hidden focus-visible:outline-none",
                L(hl)
              ]),
              onKeydown: St(T, ["escape"])
            }, [
              A.value === "field" ? (u(), b(ie, { key: 0 }, [
                U(Px, {
                  ref_key: "pickerRef",
                  ref: p,
                  "active-group": z.value,
                  "onUpdate:activeGroup": he[0] || (he[0] = (Le) => z.value = Le),
                  "search-query": E.value,
                  "onUpdate:searchQuery": he[1] || (he[1] = (Le) => E.value = Le),
                  fields: J.value,
                  groups: e.fieldGroups,
                  "groups-label": e.fieldGroupsLabel || void 0,
                  "group-aria-label": e.triggerLabel,
                  "search-placeholder": e.step1SearchPlaceholder,
                  "search-clear-label": e.searchClearLabel,
                  "list-label": e.step1SearchPlaceholder,
                  selectable: e.fieldsSelectable,
                  "no-results-label": e.noFieldResultsLabel,
                  "results-count-label": e.resultsCountLabel,
                  "no-fields-label": e.noFieldsLabel || void 0,
                  onSelect: Ke
                }, null, 8, ["active-group", "search-query", "fields", "groups", "groups-label", "group-aria-label", "search-placeholder", "search-clear-label", "list-label", "selectable", "no-results-label", "results-count-label", "no-fields-label"]),
                Y.value ? (u(), P(Dl, Ve({ key: 0 }, Y.value, {
                  class: "shrink-0",
                  onButtonClick: F
                }), null, 16)) : w("", !0)
              ], 64)) : w("", !0),
              A.value === "value" && M.value ? (u(), b(ie, { key: 1 }, [
                de.value === "list" ? (u(), b("div", P8, [
                  U(Bl, {
                    class: "shrink-0",
                    "label-left": M.value.label,
                    "label-right": nt.value || void 0,
                    "show-search": "",
                    "search-query": _.value,
                    "search-placeholder": M.value.step2SearchPlaceholder ?? "Search…",
                    "search-label": M.value.step2SearchPlaceholder ?? "Search…",
                    "search-clear-label": e.searchClearLabel,
                    onKeydown: Pe,
                    "onUpdate:searchQuery": he[2] || (he[2] = (Le) => _.value = Le)
                  }, null, 8, ["label-left", "label-right", "search-query", "search-placeholder", "search-label", "search-clear-label"]),
                  x("div", F8, [
                    Qe.value ? (u(), b("div", {
                      key: 0,
                      ref_key: "step2ListboxRef",
                      ref: Ae,
                      role: "listbox",
                      "aria-multiselectable": !M.value.single,
                      "aria-label": M.value.label,
                      class: "flex min-h-0 flex-col",
                      onKeydown: pe
                    }, [
                      qe.value ? (u(), b("div", V8, [
                        U(fa, Ve(Xe(0, ae.value, Ce), {
                          type: "checkbox",
                          label: M.value.selectAllLabel ?? "Select all",
                          checked: ae.value,
                          indeterminate: Re.value,
                          count: se.value > 0 ? `(${se.value})` : void 0
                        }), null, 16, ["label", "checked", "indeterminate", "count"])
                      ])) : w("", !0),
                      ee.value.length ? (u(), b("div", H8, [
                        x("div", {
                          class: C(["flex flex-col gap-0.5 px-2", qe.value ? "pt-0.5 pb-0.5" : "py-1.5"])
                        }, [
                          (u(!0), b(ie, null, Oe(ee.value, (Le, Je) => (u(), P(fa, Ve({
                            key: Le.id
                          }, { ref_for: !0 }, Xe(qe.value ? Je + 1 : Je, Z.value.has(Le.id), () => At(Le.id)), {
                            class: "shrink-0",
                            type: "checkbox",
                            label: Le.label,
                            checked: Z.value.has(Le.id),
                            count: Le.count !== void 0 ? `(${Le.count})` : void 0,
                            "data-testid": `filter-item-${Le.id}`
                          }), null, 16, ["label", "checked", "count", "data-testid"]))), 128))
                        ], 2)
                      ])) : w("", !0)
                    ], 40, N8)) : w("", !0),
                    !ee.value.length && _.value ? (u(), b("div", j8, H(e.noResultsLabel) + ' "' + H(_.value) + '". ', 1)) : w("", !0)
                  ])
                ])) : (u(), b("div", W8, [
                  U(Bl, {
                    class: "shrink-0",
                    "label-left": M.value.label
                  }, null, 8, ["label-left"]),
                  x("div", q8, [
                    de.value === "text" ? (u(), b("div", U8, [
                      x("div", G8, [
                        U(L(Qt), {
                          id: ve.value,
                          modelValue: le.value,
                          "onUpdate:modelValue": he[3] || (he[3] = (Le) => le.value = Le),
                          "aria-label": M.value.label,
                          placeholder: M.value.placeholder ?? "",
                          error: G.value,
                          size: "md",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "aria-label", "placeholder", "error"])
                      ])
                    ])) : de.value === "range" ? (u(), b("div", {
                      key: 1,
                      "data-testid": "filter-step-range",
                      role: "group",
                      "aria-label": M.value.label,
                      class: "flex flex-col gap-4 px-3 py-4"
                    }, [
                      U(L($x), {
                        "min-value": D.value,
                        "onUpdate:minValue": he[4] || (he[4] = (Le) => D.value = Le),
                        "max-value": O.value,
                        "onUpdate:maxValue": he[5] || (he[5] = (Le) => O.value = Le),
                        min: M.value.rangeMin ?? 0,
                        max: M.value.rangeMax ?? 1e4,
                        step: M.value.rangeStep ?? 1,
                        "separator-label": M.value.rangeSeparatorLabel ?? "to",
                        "min-label": M.value.rangeMinLabel ?? "Minimum",
                        "max-label": M.value.rangeMaxLabel ?? "Maximum",
                        "clamp-input-to-bounds": M.value.rangeClampInputToBounds ?? !0,
                        "data-min": M.value.rangeDataMin ?? null,
                        "data-max": M.value.rangeDataMax ?? null,
                        "hint-label": M.value.rangeHintLabel ?? ""
                      }, null, 8, ["min-value", "max-value", "min", "max", "step", "separator-label", "min-label", "max-label", "clamp-input-to-bounds", "data-min", "data-max", "hint-label"]),
                      re.value ? w("", !0) : (u(), b("p", Y8, H(M.value.rangeErrorLabel ?? "Min value must be less than or equal to max value"), 1))
                    ], 8, K8)) : de.value === "dateRange" ? (u(), b("div", {
                      key: 2,
                      "data-testid": "filter-step-date-range",
                      role: "group",
                      "aria-label": M.value.label,
                      class: "flex flex-col gap-4 px-3 py-4"
                    }, [
                      x("div", X8, [
                        U(L(Ju), {
                          id: Se.value,
                          modelValue: N.value,
                          "onUpdate:modelValue": he[6] || (he[6] = (Le) => N.value = Le),
                          class: "min-w-0 flex-1",
                          label: M.value.dateFromLabel ?? "From",
                          placeholder: M.value.datePlaceholder,
                          format: M.value.dateFormat ?? "dd/mm/yyyy",
                          language: M.value.dateLanguage,
                          size: "md",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "label", "placeholder", "format", "language"]),
                        U(L(Ju), {
                          id: oe.value,
                          modelValue: V.value,
                          "onUpdate:modelValue": he[7] || (he[7] = (Le) => V.value = Le),
                          class: "min-w-0 flex-1",
                          label: M.value.dateToLabel ?? "To",
                          placeholder: M.value.datePlaceholder,
                          format: M.value.dateFormat ?? "dd/mm/yyyy",
                          language: M.value.dateLanguage,
                          size: "md",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "label", "placeholder", "format", "language"])
                      ]),
                      ge.value ? w("", !0) : (u(), b("p", Z8, H(e.dateRangeErrorLabel), 1))
                    ], 8, J8)) : w("", !0)
                  ])
                ])),
                U(Dl, Ve(Gt.value, {
                  class: "shrink-0",
                  onButtonClick: Fe
                }), null, 16)
              ], 64)) : w("", !0)
            ], 46, O8)) : w("", !0)
          ]),
          _: 1
        })
      ]))
    ], 544));
  }
}), Xb = /* @__PURE__ */ ke({
  __name: "TableHeaderFilter",
  props: {
    filter: {},
    triggerSize: { default: "xs" }
  },
  emits: ["filter-apply", "filter-apply-value", "filter-remove", "advanced-filters", "view-advanced-filters", "create-advanced-filter"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = m(() => {
      if (n.filter.type !== "selector") return null;
      const { type: g, testId: h, ...v } = n.filter;
      return v;
    }), r = R(null), i = /* @__PURE__ */ new Map();
    function s(g, h) {
      h ? i.set(g, h) : i.delete(g);
    }
    const d = Bn({});
    function c(g) {
      var h, v;
      if (n.filter.type === "selector") return (h = r.value) == null ? void 0 : h.openForField(g);
      (v = i.get(g)) == null || v.openDropdown();
    }
    const f = m(() => {
      var g;
      return ((g = r.value) == null ? void 0 : g.triggerEl) ?? null;
    });
    return a({ openForField: c, triggerEl: f }), (g, h) => e.filter.type === "selector" ? (u(), P(eF, Ve({
      key: 0,
      ref_key: "selector",
      ref: r
    }, o.value, {
      "trigger-size": o.value.triggerSize ?? e.triggerSize,
      "data-testid": e.filter.testId,
      onApply: h[0] || (h[0] = (v, p) => l("filter-apply", v, p)),
      onApplyFilter: h[1] || (h[1] = (v, p) => l("filter-apply-value", v, p)),
      onRemoveFilter: h[2] || (h[2] = (v) => l("filter-remove", v)),
      onAdvancedFilters: h[3] || (h[3] = (v) => l("advanced-filters")),
      onViewAdvancedFilters: h[4] || (h[4] = (v) => l("view-advanced-filters")),
      onCreateAdvancedFilter: h[5] || (h[5] = (v) => l("create-advanced-filter"))
    }), null, 16, ["trigger-size", "data-testid"])) : (u(!0), b(ie, { key: 1 }, Oe(e.filter.dropdowns, ({ key: v, testId: p, ...y }) => (u(), P(Lc, Ve({
      key: v,
      ref_for: !0,
      ref: (k) => s(v, k)
    }, { ref_for: !0 }, y, {
      "data-testid": p,
      "search-query": d[v] ?? "",
      "onUpdate:searchQuery": (k) => d[v] = k,
      onClose: (k) => d[v] = ""
    }), null, 16, ["data-testid", "search-query", "onUpdate:searchQuery", "onClose"]))), 128));
  }
}), tF = { class: "flex items-center gap-1.5 justify-center" }, aF = ["src"], nF = ["src"], lF = { class: "self-stretch flex flex-col items-start gap-2" }, oF = {
  key: 0,
  class: "self-stretch flex flex-col items-start"
}, rF = ["onClick"], iF = ["src"], sF = {
  key: 1,
  class: "h-5 w-5 relative flex-shrink-0"
}, dF = {
  key: 2,
  class: "relative leading-num-24 font-medium"
}, uF = ["src"], cF = ["onClick"], fF = { class: "flex-1 flex items-center py-num-0 pl-0.5 pr-num-0 shrink-0 relative z-10" }, hF = { class: "relative leading-num-24 font-medium" }, bF = ["onClick"], gF = ["src"], mF = {
  key: 1,
  class: "h-5 w-5 relative flex-shrink-0"
}, vF = {
  key: 2,
  class: "relative leading-num-24 font-medium z-10"
}, pF = {
  key: 0,
  class: "flex items-center gap-1.5 text-center text-[12px] text-colors-text-black-default relative z-10"
}, xF = { class: "relative leading-5 font-medium z-10" }, yF = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cline x1=%2218%22 y1=%226%22 x2=%226%22 y2=%2218%22/%3E%3Cline x1=%226%22 y1=%226%22 x2=%2218%22 y2=%2218%22/%3E%3C/svg%3E", kF = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%229 18 15 12 9 6%22/%3E%3C/svg%3E", wF = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%226 9 12 15 18 9%22/%3E%3C/svg%3E", CF = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%2218 15 12 9 6 15%22/%3E%3C/svg%3E", SF = /* @__PURE__ */ ke({
  __name: "MainDrawer",
  props: {
    logoIcon: { default: "/logo-eudonet.svg" },
    logoText: { default: void 0 },
    closeIcon: { default: void 0 },
    items: { default: () => [
      {
        label: "Overview",
        children: []
      },
      {
        label: "Pages",
        children: []
      },
      {
        label: "Ecommerce",
        icon: void 0,
        children: [
          { label: "All products" },
          { label: "Billing", active: !0 },
          { label: "Invoice" },
          { label: "Transactions" }
        ]
      },
      {
        label: "Messages",
        badge: 4,
        children: []
      },
      {
        label: "Users",
        children: []
      },
      {
        label: "Support",
        children: []
      }
    ] },
    modelValue: { type: Boolean, default: !0 },
    width: { default: "100%" }
  },
  emits: ["update:modelValue", "close", "item-click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = R({
      Ecommerce: !0
    }), o = R(!1), r = m(() => t.items), i = (p) => {
      l.value[p] = !l.value[p];
    }, s = (p) => l.value[p] === !0, d = (p) => {
      p.children && p.children.length > 0 && !o.value && i(p.label), p.onClick && p.onClick(), n("item-click", p);
    }, c = () => {
      const p = !o.value;
      o.value = p, p && Object.keys(l.value).forEach((y) => {
        l.value[y] = !1;
      });
    }, f = m(() => o.value ? "/logo-eudonet-small.svg" : t.logoIcon || "/logo-eudonet.svg"), g = (p) => {
      const y = 'self-stretch flex items-center py-num-6 pl-8 pr-num-8 cursor-pointer border-solid border-[1px] border-transparent transition-[background,border-color] duration-300 relative before:content-[""] before:absolute before:inset-[-1px] before:rounded-[48px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-[48px] after:bg-white after:transition-opacity after:duration-300 after:z-[1]';
      return p.active ? `${y} h-9 rounded-[48px] bg-white overflow-visible before:opacity-100 after:opacity-100` : `${y} rounded-num-12 hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden before:opacity-0 after:opacity-0`;
    }, h = (p) => {
      const y = "self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border-[1px] border-transparent transition-[background,border-color] duration-300";
      return p.active ? `${y} relative before:content-[""] before:absolute before:inset-[-1px] before:rounded-[48px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 before:opacity-100 after:content-[""] after:absolute after:inset-0 after:rounded-[48px] after:bg-white after:transition-opacity after:duration-300 after:z-[1] after:opacity-100 bg-white overflow-visible` : `${y} hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden`;
    }, v = () => 'h-[22px] w-[22px] rounded-[9999px] relative flex items-center justify-center overflow-visible before:opacity-100 after:opacity-100 before:content-[""] before:absolute before:inset-[-1px] before:rounded-[9999px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-[9999px] after:bg-white after:transition-opacity after:duration-300 after:z-[1]';
    return (p, y) => e.modelValue ? (u(), b("div", {
      key: 0,
      role: "dialog",
      class: C(["drawer h-[1184px] relative bg-white flex flex-col items-start box-border gap-5 text-left text-num-16 text-colors-text-body font-inter transition-all duration-300", { "w-20 p-2 overflow-visible": o.value, "p-5 overflow-hidden": !o.value }]),
      style: Ge(o.value ? { width: "80px" } : { width: e.width })
    }, [
      x("div", {
        class: C([
          "self-stretch border-colors-border-black-default border-solid border-b-[1px] pt-num-0 px-num-0 relative",
          o.value ? "flex flex-col items-center gap-2 overflow-visible pb-2" : "flex items-center justify-between gap-5 pb-4"
        ])
      }, [
        x("div", tF, [
          f.value ? (u(), b("img", {
            key: 0,
            class: "h-[30px] w-auto relative",
            src: f.value,
            alt: "Eudonet"
          }, null, 8, aF)) : w("", !0),
          e.logoText && !o.value ? (u(), b("img", {
            key: 1,
            class: "h-[30px] w-[73.8px] relative",
            src: e.logoText,
            alt: "Eudonet"
          }, null, 8, nF)) : w("", !0)
        ]),
        o.value ? (u(), P(L(Be), {
          key: 1,
          variant: "tertiary",
          "icon-left": kF,
          "icon-only": "",
          size: "md",
          "aria-label": "Expand",
          class: "drawer-expand-button flex-shrink-0",
          onClick: c
        })) : (u(), P(L(Be), {
          key: 0,
          variant: "tertiary",
          "icon-left": e.closeIcon || yF,
          "icon-only": "",
          size: "md",
          "aria-label": "Close",
          class: "drawer-close-button flex-shrink-0",
          onClick: c
        }, null, 8, ["icon-left"]))
      ], 2),
      x("div", lF, [
        (u(!0), b(ie, null, Oe(r.value, (k, $) => (u(), b(ie, { key: $ }, [
          k.children && k.children.length > 0 ? (u(), b("div", oF, [
            x("button", {
              type: "button",
              class: C(["self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border-[1px] border-transparent hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden transition-[background,border-color] duration-300", { "justify-center": o.value }]),
              onClick: (S) => d(k)
            }, [
              x("div", {
                class: C(["flex-1 flex items-center gap-1.5", { "justify-center": o.value }])
              }, [
                k.icon ? (u(), b("img", {
                  key: 0,
                  class: "h-5 w-5 relative flex-shrink-0",
                  src: k.icon,
                  alt: ""
                }, null, 8, iF)) : (u(), b("div", sF)),
                o.value ? w("", !0) : (u(), b("div", dF, H(k.label), 1))
              ], 2),
              o.value ? w("", !0) : (u(), b("img", {
                key: 0,
                class: "h-4 w-4 relative transition-transform duration-200",
                src: s(k.label) ? CF : wF,
                alt: ""
              }, null, 8, uF))
            ], 10, rF),
            U(cr, {
              name: "submenu",
              tag: "div",
              class: C([
                "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
                { "submenu-open": s(k.label) }
              ])
            }, {
              default: me(() => [
                (u(!0), b(ie, null, Oe(s(k.label) ? k.children : [], (S, I) => (u(), b("button", {
                  key: `${k.label}-${I}`,
                  type: "button",
                  class: C(g(S)),
                  onClick: (T) => d(S)
                }, [
                  x("div", fF, [
                    x("div", hF, H(S.label), 1)
                  ])
                ], 10, cF))), 128))
              ]),
              _: 2
            }, 1032, ["class"])
          ])) : (u(), b("button", {
            key: 1,
            type: "button",
            class: C([h(k), { "justify-center": o.value }]),
            onClick: (S) => d(k)
          }, [
            x("div", {
              class: C(["flex-1 flex items-center gap-1.5 relative z-10", { "justify-center": o.value }])
            }, [
              k.icon ? (u(), b("img", {
                key: 0,
                class: "h-5 w-5 relative flex-shrink-0 z-10",
                src: k.icon,
                alt: ""
              }, null, 8, gF)) : (u(), b("div", mF)),
              o.value ? w("", !0) : (u(), b("div", vF, H(k.label), 1))
            ], 2),
            k.badge && !o.value ? (u(), b("div", pF, [
              x("div", {
                class: C(v())
              }, [
                x("div", xF, H(k.badge), 1)
              ], 2)
            ])) : w("", !0)
          ], 10, bF))
        ], 64))), 128))
      ])
    ], 6)) : w("", !0);
  }
}), IG = /* @__PURE__ */ Ct(SF, [["__scopeId", "data-v-ce4179bf"]]), $F = ["aria-label"], IF = { class: "flex min-w-0 flex-wrap items-center gap-2.5 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)" }, LF = {
  key: 1,
  class: "sr-only"
}, TF = ["aria-current"], EF = {
  key: 1,
  class: "sr-only"
}, AF = {
  key: 2,
  "data-testid": "breadcrumb-separator",
  class: "ri-arrow-right-s-line inline-flex size-3.5 shrink-0 items-center justify-center text-num-14 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
  "aria-hidden": "true"
}, Zb = "inline-flex min-w-0 max-w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-xs)", RF = "text-(--text-text-heading) hover:text-(--text-text-body) dark:text-(--text-text-white-default) dark:hover:text-(--text-text-white-secondary) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)", Qb = "inline-flex size-4 shrink-0 items-center justify-center text-num-16 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)", zF = /* @__PURE__ */ ke({
  __name: "Breadcrumb",
  props: {
    items: {},
    type: { default: "default" },
    ariaLabel: {},
    linkAs: { default: "a" }
  },
  setup(e) {
    var y;
    const a = e, t = m(() => [
      "flex w-fit max-w-full min-w-0 items-center text-(--text-text-heading) dark:text-(--text-text-white-default)",
      a.type === "background" ? "border border-(--border-border-white-default) bg-(--background-background-white) p-[calc(--spacing(2.5)-1px)] rounded-(--border-border-radius-rounded-base) shadow-(--blur-shadow-xs) dark:bg-(--background-background-black-default) dark:border-(--border-border-base)" : "rounded-(--border-border-radius-rounded-xs)"
    ]);
    function n(k) {
      return k === a.items.length - 1;
    }
    function l(k) {
      return k.to != null && a.linkAs !== "a";
    }
    function o(k, $) {
      return !n($) && (l(k) || k.href !== void 0);
    }
    const r = typeof process < "u" && ((y = process.env) == null ? void 0 : y.NODE_ENV) !== "production";
    $e(
      () => a.items,
      (k) => {
        r && a.linkAs === "a" && k.some(($) => $.to != null) && console.warn(
          "[OPAL Breadcrumb] items with `to` need `linkAs` (e.g. RouterLink); they render as text."
        );
      },
      { immediate: !0 }
    );
    function i(k) {
      return !!(k.hideLabel && k.icon);
    }
    const s = R([]), d = R(null), c = R(!1);
    function f(k) {
      if (d.value === k)
        return !c.value;
    }
    function g(k, $) {
      let S;
      try {
        S = $.target.matches(":focus-visible");
      } catch {
        S = !0;
      }
      d.value = S ? k : null;
    }
    function h() {
      d.value = null, c.value = !1;
    }
    function v(k, $) {
      var S;
      $.key !== "Escape" || c.value || d.value !== k || !((S = s.value[k]) != null && S.isTruncated) || ($.stopPropagation(), $.preventDefault(), c.value = !0);
    }
    const p = R(null);
    return $e(
      () => a.items,
      () => {
        var k;
        (k = p.value) != null && k.contains(document.activeElement) || h();
      },
      { deep: 1, flush: "post" }
    ), (k, $) => (u(), b("nav", {
      ref_key: "navEl",
      ref: p,
      "aria-label": e.ariaLabel,
      "data-testid": "breadcrumb",
      class: C(t.value)
    }, [
      x("ol", IF, [
        (u(!0), b(ie, null, Oe(e.items, (S, I) => (u(), b("li", {
          key: I,
          "data-testid": "breadcrumb-item",
          class: "flex min-w-0 max-w-full items-center gap-1.5"
        }, [
          o(S, I) ? (u(), P(gt(l(S) ? e.linkAs : "a"), Ve({
            key: 0,
            ref_for: !0
          }, l(S) ? { to: S.to } : { href: S.href }, {
            "data-testid": "breadcrumb-link",
            class: [Zb, RF],
            onFocus: (T) => g(I, T),
            onBlur: h,
            onKeydown: (T) => v(I, T)
          }), {
            default: me(() => [
              S.icon ? (u(), b("i", {
                key: 0,
                class: C([S.icon, Qb]),
                "aria-hidden": "true"
              }, null, 2)) : w("", !0),
              i(S) ? (u(), b("span", LF, H(S.label), 1)) : (u(), P(it, {
                key: 2,
                ref_for: !0,
                ref: (T) => s.value[I] = T,
                text: S.label,
                focusable: !1,
                open: f(I)
              }, null, 8, ["text", "open"]))
            ]),
            _: 2
          }, 1040, ["class", "onFocus", "onKeydown"])) : (u(), b("span", {
            key: 1,
            "data-testid": "breadcrumb-text",
            "aria-current": n(I) && i(S) ? "page" : void 0,
            class: C([
              Zb,
              n(I) ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-heading) dark:text-(--text-text-white-default)"
            ])
          }, [
            S.icon ? (u(), b("i", {
              key: 0,
              class: C([S.icon, Qb]),
              "aria-hidden": "true"
            }, null, 2)) : w("", !0),
            i(S) ? (u(), b("span", EF, H(S.label), 1)) : (u(), P(it, {
              key: 2,
              text: S.label,
              "aria-current": n(I) ? "page" : void 0
            }, null, 8, ["text", "aria-current"]))
          ], 10, TF)),
          I < e.items.length - 1 ? (u(), b("i", AF)) : w("", !0)
        ]))), 128))
      ])
    ], 10, $F));
  }
}), DF = ["id", "aria-modal", "aria-label", "aria-labelledby", "aria-describedby"], BF = {
  key: 0,
  class: "flex-1 min-w-0"
}, MF = ["src", "alt"], OF = { class: "min-w-0 break-words [overflow-wrap:anywhere]" }, PF = {
  key: 2,
  "data-testid": "drawer-heading-badges",
  class: "flex flex-wrap items-start gap-1.5"
}, FF = {
  key: 3,
  "data-testid": "drawer-heading-actions",
  class: "flex shrink-0 items-center gap-2"
}, NF = {
  key: 1,
  "data-testid": "drawer-subheader",
  class: "shrink-0 px-5 pt-5 pb-3"
}, VF = {
  "data-testid": "drawer-content",
  class: "flex-1 overflow-y-auto px-5 py-5"
}, HF = ["data-layout"];
let jF = 0;
const WF = () => `drawer-${++jF}`, qF = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "Drawer",
  props: {
    modelValue: { type: Boolean, default: !1 },
    title: { default: void 0 },
    position: { default: "right" },
    subtitle: { default: void 0 },
    headingLevel: { default: 2 },
    back: { default: void 0 },
    icon: { default: void 0 },
    logo: { default: void 0 },
    avatar: { default: void 0 },
    avatars: { default: void 0 },
    badges: { default: void 0 },
    headerActions: { default: void 0 },
    breadcrumb: { default: void 0 },
    size: { default: "md" },
    actions: { default: void 0 },
    actionsLayout: { default: void 0 },
    showCloseButton: { type: Boolean, default: !0 },
    dismissable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    showBackdrop: { type: Boolean, default: !0 },
    backdropClass: { default: void 0 },
    panelClass: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaCloseLabel: { default: "Close drawer" },
    variant: { default: "default" },
    beforeClose: { type: Function, default: void 0 }
  },
  emits: ["update:modelValue", "close", "back", "header-action", "action"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = Na(), o = (Y) => {
      const F = l[Y];
      return !!F && Tc(F({ titleId: k, subtitleId: $ }));
    }, r = () => o("header"), i = () => {
      var Y;
      return n.showCloseButton || !!n.title || !!n.subtitle || !!n.back || !!n.breadcrumb || !!((Y = n.headerActions) != null && Y.length) || !!N.value || V.value || r();
    }, s = m(() => {
      var F;
      if (n.actionsLayout) return n.actionsLayout;
      const Y = ((F = n.actions) == null ? void 0 : F.length) ?? 0;
      return Y === 1 ? "one" : Y === 2 ? "two" : Y === 3 ? "three" : "stacked";
    }), d = {
      one: "items-center justify-end gap-4",
      two: "items-center justify-end gap-4",
      three: "items-center justify-between gap-3",
      stacked: "flex-col gap-4"
    }, c = m(() => {
      const Y = n.actions ?? [];
      return s.value === "three" ? [Y.slice(0, 1), Y.slice(1)] : [Y];
    }), f = (Y) => s.value === "three" && Y === 1 ? "flex items-center gap-4" : "contents", g = m(() => s.value === "one" || s.value === "stacked"), h = (Y) => {
      var F;
      (F = Y.onClick) == null || F.call(Y), p("action", Y.id);
    }, v = (Y) => [
      "flex shrink-0 pt-[calc(--spacing(5)-1px)] pb-5 border-t border-(--colors-border-base-medium) dark:border-(--colors-border-base)",
      Y,
      n.variant === "column" ? "px-5" : "mx-5"
    ], p = t, y = WF(), k = `${y}-title`, $ = `${y}-subtitle`, S = Symbol("opal-drawer"), I = () => {
      p("update:modelValue", !1), p("close");
    };
    let T = !1, A = 0;
    $e(
      () => n.modelValue,
      (Y) => {
        Y && A++;
      }
    );
    const E = async () => {
      if (T) return;
      if (!n.beforeClose) {
        I();
        return;
      }
      T = !0;
      const Y = A;
      try {
        await n.beforeClose() !== !1 && n.modelValue && Y === A && I();
      } catch {
      } finally {
        T = !1;
      }
    }, z = () => {
      n.dismissable && E();
    }, B = (Y) => {
      Y.key !== "Escape" || !n.closeOnEscape || !n.modelValue || On(S) && (Y.defaultPrevented || (Y.preventDefault(), E()));
    }, { zIndex: W, isTop: _ } = cx(Ua(n, "modelValue"));
    $e(
      () => n.modelValue,
      (Y) => {
        Y ? xn(S) : _a(S);
      }
    ), kt(() => {
      document.addEventListener("keydown", B), n.modelValue && xn(S);
    }), zt(() => {
      document.removeEventListener("keydown", B), _a(S);
    });
    const Z = {
      md: "w-80",
      lg: "w-96",
      xl: "w-[min(80%,1280px)]"
    }, le = m(() => n.variant === "column" ? "w-[512px]" : Z[n.size]), D = m(() => `h${n.headingLevel}`), O = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--colors-text-white-default) break-words [overflow-wrap:anywhere]", N = m(() => {
      if (n.icon) return "icon";
      if (n.logo) return "logo";
      if (n.avatar) return "avatar";
      if (n.avatars) return "avatars";
    }), V = m(() => {
      var Y;
      return !!((Y = n.badges) != null && Y.length);
    }), M = m(() => {
      var Y;
      return !!((Y = n.headerActions) != null && Y.length);
    }), Q = () => !!n.breadcrumb && !r(), q = () => r() || !N.value && !V.value && !M.value && !n.breadcrumb, K = () => !r() && !Q() && N.value === "avatars", G = () => q() ? "pb-[calc(--spacing(4)-1px)]" : "pb-[calc(--spacing(5)-1px)]", te = () => {
      if (!q())
        return K() ? "flex-wrap gap-x-6 gap-y-2" : "gap-6";
    }, ve = () => Q() ? "items-center" : "items-start", Se = m(() => {
      if (N.value)
        return N.value === "icon" ? "items-start gap-2.5" : "items-center gap-2.5";
    }), oe = () => !!n.title && !Q(), re = m(() => n.position === "left" ? "left-0" : "right-0"), ge = m(
      () => n.variant === "column" ? n.position === "left" ? "border-r" : "border-l" : void 0
    ), de = m(() => `drawer-slide-${n.position}`), Ee = () => n.subtitle && i() && !Q() ? $ : void 0, j = () => n.ariaLabelledby ?? (n.ariaLabel || !oe() ? void 0 : k);
    a({ focusTitle: () => {
      var Y;
      (Y = document.getElementById(k)) == null || Y.focus();
    } });
    const ne = R(null);
    return Is({
      active: Ua(n, "modelValue"),
      container: ne,
      containFocus: !0
    }), (Y, F) => (u(), P(Fa, { to: "body" }, [
      U(Wt, { name: "drawer-fade" }, {
        default: me(() => [
          e.modelValue && e.showBackdrop ? (u(), b("div", {
            key: 0,
            "data-testid": "drawer-backdrop",
            "aria-hidden": "true",
            class: C(["fixed inset-0 bg-(--colors-background-overlay) dark:bg-(--colors-background-overlay-dark)", e.backdropClass]),
            style: Ge({ zIndex: L(W) }),
            onClick: z
          }, null, 6)) : w("", !0)
        ]),
        _: 1
      }),
      U(Wt, { name: de.value }, {
        default: me(() => {
          var ee;
          return [
            e.modelValue ? (u(), b("div", Ve({
              key: 0,
              id: L(y),
              ref_key: "panelRef",
              ref: ne
            }, Y.$attrs, {
              "data-testid": "drawer-panel",
              role: "dialog",
              "aria-modal": L(_) ? "true" : void 0,
              "aria-label": e.ariaLabel,
              "aria-labelledby": j(),
              "aria-describedby": Ee(),
              class: [
                "fixed inset-y-0 flex flex-col",
                "bg-(--background-background-white) dark:bg-(--colors-background-black-default)",
                "border-(--colors-border-base-soft) dark:border-(--colors-border-base)",
                e.variant === "column" ? "shadow-(--shadow-drawer-column)" : "shadow-(--shadow-drawer)",
                le.value,
                re.value,
                ge.value,
                e.panelClass
              ],
              style: { zIndex: L(W) + 1 }
            }), [
              i() ? (u(), b("div", {
                key: 0,
                "data-testid": "drawer-header",
                class: C([
                  "flex shrink-0 justify-between mx-5 mt-5 border-b border-(--colors-border-base-medium) dark:border-(--colors-border-base)",
                  ve(),
                  te(),
                  G()
                ])
              }, [
                r() ? (u(), b("div", BF, [
                  Me(Y.$slots, "header", {
                    titleId: k,
                    subtitleId: $
                  }, void 0, !0)
                ])) : e.breadcrumb ? (u(), P(zF, ga(Ve({ key: 1 }, e.breadcrumb)), null, 16)) : (u(), b("div", {
                  key: 2,
                  "data-testid": "drawer-heading-lead",
                  class: C(["flex flex-1 min-w-0", Se.value])
                }, [
                  N.value === "icon" ? (u(), P(aa, {
                    key: 0,
                    "data-testid": "drawer-heading-icon",
                    icon: e.icon,
                    size: "lg",
                    type: "square",
                    variant: "outlined",
                    color: "white",
                    class: "shrink-0"
                  }, null, 8, ["icon"])) : N.value === "logo" && e.logo ? (u(), b("img", {
                    key: 1,
                    "data-testid": "drawer-heading-logo",
                    src: e.logo.src,
                    alt: e.logo.alt,
                    class: "size-12 shrink-0 object-contain"
                  }, null, 8, MF)) : N.value === "avatar" && e.avatar ? (u(), P(Jt, {
                    key: 2,
                    "data-testid": "drawer-heading-avatar",
                    name: e.avatar.name,
                    img: e.avatar.img,
                    entity: e.avatar.entity,
                    size: "lg",
                    "avatar-style": "circle",
                    presentational: "",
                    class: "shrink-0"
                  }, null, 8, ["name", "img", "entity"])) : N.value === "avatars" && e.avatars ? (u(), P(vf, {
                    key: 3,
                    "data-testid": "drawer-heading-avatars",
                    avatars: e.avatars.avatars,
                    max: e.avatars.max,
                    "aria-label": e.avatars.ariaLabel,
                    size: "lg",
                    class: "shrink-0"
                  }, null, 8, ["avatars", "max", "aria-label"])) : w("", !0),
                  x("div", {
                    class: C(["flex flex-1 min-w-0 flex-col", V.value ? "gap-0.5" : void 0])
                  }, [
                    e.back ? (u(), b("button", {
                      key: 0,
                      type: "button",
                      "data-testid": "drawer-heading-back",
                      class: "inline-flex w-fit max-w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-xs) text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) hover:text-(--text-text-body) dark:text-(--text-text-white-default) dark:hover:text-(--text-text-white-secondary) transition-colors duration-150 ease-in-out motion-reduce:transition-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)",
                      onClick: F[0] || (F[0] = (ue) => p("back"))
                    }, [
                      F[1] || (F[1] = x("i", {
                        class: "ri-arrow-left-line inline-flex size-4 shrink-0 items-center justify-center text-num-16 text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
                        "aria-hidden": "true"
                      }, null, -1)),
                      x("span", OF, H(e.back.label), 1)
                    ])) : w("", !0),
                    e.title ? (u(), P(gt(D.value), {
                      key: 1,
                      id: k,
                      "data-testid": "drawer-title",
                      tabindex: "-1",
                      class: "text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-black-default) dark:text-(--colors-text-white-default) break-words [overflow-wrap:anywhere] focus:outline-hidden"
                    }, {
                      default: me(() => [
                        st(H(e.title), 1)
                      ]),
                      _: 1
                    })) : w("", !0),
                    V.value ? (u(), b("div", PF, [
                      (u(!0), b(ie, null, Oe(e.badges, (ue, se) => (u(), P(yt, Ve({ key: se }, { ref_for: !0 }, ue, { size: "sm" }), null, 16))), 128))
                    ])) : w("", !0),
                    e.subtitle && !K() ? (u(), b("p", {
                      key: 3,
                      id: $,
                      "data-testid": "drawer-subtitle",
                      class: C(O)
                    }, H(e.subtitle), 1)) : w("", !0)
                  ], 2)
                ], 2)),
                M.value || e.showCloseButton ? (u(), b("div", FF, [
                  (u(!0), b(ie, null, Oe(e.headerActions, (ue) => (u(), P(Be, {
                    key: ue.id,
                    "data-testid": "drawer-header-action",
                    variant: "ghost",
                    size: "sm",
                    "icon-only": "",
                    "icon-left": ue.icon,
                    "aria-label": ue.label,
                    onClick: (se) => p("header-action", ue.id)
                  }, null, 8, ["icon-left", "aria-label", "onClick"]))), 128)),
                  e.showCloseButton ? (u(), P(Be, {
                    key: 0,
                    "data-testid": "drawer-close-button",
                    variant: "ghost",
                    size: "sm",
                    "icon-only": "",
                    "icon-left": "ri-close-fill",
                    "aria-label": e.ariaCloseLabel,
                    onClick: E
                  }, null, 8, ["aria-label"])) : w("", !0)
                ])) : w("", !0),
                e.subtitle && K() ? (u(), b("p", {
                  key: 4,
                  id: $,
                  "data-testid": "drawer-subtitle",
                  class: C(["basis-full", O])
                }, H(e.subtitle), 3)) : w("", !0)
              ], 2)) : w("", !0),
              o("subheader") ? (u(), b("div", NF, [
                Me(Y.$slots, "subheader", {}, void 0, !0)
              ])) : w("", !0),
              x("div", VF, [
                Me(Y.$slots, "default", {}, void 0, !0)
              ]),
              (ee = e.actions) != null && ee.length ? (u(), b("div", {
                key: 2,
                "data-testid": "drawer-footer",
                "data-layout": s.value,
                class: C(v(d[s.value]))
              }, [
                (u(!0), b(ie, null, Oe(c.value, (ue, se) => (u(), b("div", {
                  key: se,
                  class: C(f(se))
                }, [
                  (u(!0), b(ie, null, Oe(ue, (X) => (u(), P(Be, {
                    key: X.id,
                    "data-testid": X.testId ?? `drawer-action-${X.id}`,
                    variant: X.variant,
                    size: s.value === "one" ? "md" : "sm",
                    "full-width": g.value,
                    label: X.label,
                    "icon-left": X.icon,
                    disabled: X.disabled,
                    "aria-disabled": X.ariaDisabled,
                    loading: X.loading,
                    "loading-label": X.loadingLabel,
                    type: X.type,
                    form: X.form,
                    onClick: (ae) => h(X)
                  }, null, 8, ["data-testid", "variant", "size", "full-width", "label", "icon-left", "disabled", "aria-disabled", "loading", "loading-label", "type", "form", "onClick"]))), 128))
                ], 2))), 128))
              ], 10, HF)) : o("footer") ? (u(), b("div", {
                key: 3,
                "data-testid": "drawer-footer",
                class: C(v("items-center justify-end gap-4"))
              }, [
                Me(Y.$slots, "footer", {}, void 0, !0)
              ], 2)) : w("", !0)
            ], 16, DF)) : w("", !0)
          ];
        }),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), UF = /* @__PURE__ */ Ct(qF, [["__scopeId", "data-v-956ec5f9"]]), GF = {
  class: "inline-flex min-w-0 max-w-full items-stretch rounded-(--border-border-radius-rounded-base) shadow-(--blur-shadow-xs)",
  "data-testid": "split-button"
}, KF = "rounded-r-none! hover:z-10 focus-visible:z-10", YF = "flex! rounded-l-none! hover:z-10 focus-visible:z-10", JF = /* @__PURE__ */ ke({
  __name: "SplitButton",
  props: {
    label: {},
    menu: {},
    menuLabel: {},
    variant: { default: "secondary" },
    size: { default: "sm" },
    icon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: void 0 },
    menuAlign: { default: "right" }
  },
  emits: ["click", "select"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(
      () => t.menu.map((o) => ({
        ...o,
        onClick: () => {
          var r;
          (r = o.onClick) == null || r.call(o), n("select", o);
        }
      }))
    );
    return (o, r) => (u(), b("div", GF, [
      U(Be, {
        variant: e.variant,
        size: e.size,
        label: e.label,
        "icon-left": e.icon,
        disabled: e.disabled,
        "aria-disabled": e.ariaDisabled,
        shrink: "",
        loading: e.loading,
        "loading-label": e.loadingLabel,
        class: C(KF),
        "data-testid": "split-button-label",
        onClick: r[0] || (r[0] = (i) => n("click", i))
      }, null, 8, ["variant", "size", "label", "icon-left", "disabled", "aria-disabled", "loading", "loading-label"]),
      U(Ra, {
        items: l.value,
        "menu-align": e.menuAlign,
        class: "-ml-px shrink-0"
      }, {
        trigger: me(({ triggerProps: i }) => [
          U(Be, Ve({
            "icon-only": "",
            "icon-left": "ri-arrow-down-s-line",
            variant: e.variant,
            size: e.size,
            "aria-label": e.menuLabel,
            disabled: e.disabled,
            "aria-disabled": e.ariaDisabled,
            class: YF,
            "data-testid": "split-button-chevron"
          }, i), null, 16, ["variant", "size", "aria-label", "disabled", "aria-disabled"])
        ]),
        _: 1
      }, 8, ["items", "menu-align"])
    ]));
  }
}), ro = 3, XF = {
  class: "sr-only",
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  "data-testid": "faceted-reorder-live"
}, ZF = { class: "flex flex-col gap-3 px-5 py-4" }, QF = { class: "shadow-(--blur-shadow-xs)" }, _F = { class: "flex-1 overflow-y-auto px-5 pb-1" }, e6 = { key: "visible" }, t6 = ["aria-labelledby"], a6 = ["id"], n6 = { class: "flex flex-col gap-4" }, l6 = { class: "shrink-0 w-4.5" }, o6 = ["for"], r6 = { class: "flex items-center gap-3 shrink-0" }, i6 = ["aria-labelledby", "aria-label"], s6 = ["id"], d6 = { class: "flex flex-col gap-4" }, u6 = { class: "shrink-0 w-4.5" }, c6 = ["for"], f6 = { class: "flex items-center gap-3 shrink-0" }, h6 = ["disabled", "aria-label", "aria-pressed", "onClick"], b6 = {
  key: 1,
  class: "flex items-center justify-center py-8 text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body-subtle) font-inter"
}, g6 = { key: "order" }, m6 = {
  key: 0,
  class: "flex items-center gap-1.5 text-(length:--size-sm) leading-(--line-height-l) text-(--colors-text-body-subtle) mb-2 font-inter"
}, v6 = ["aria-label"], p6 = ["aria-label"], x6 = ["disabled", "aria-label", "aria-pressed", "onClick"], y6 = {
  key: 1,
  class: "flex items-center justify-center py-8 text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body-subtle) font-inter"
}, k6 = /* @__PURE__ */ ke({
  __name: "FacetedSearchDrawer",
  props: {
    modelValue: { type: Boolean },
    columns: {},
    defaultColumns: { default: () => [] },
    columnOrder: { default: () => [] },
    labels: { default: () => ({}) }
  },
  emits: ["update:modelValue", "save", "reset"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = R(!1), o = {
      fige: "Pinned",
      "actif-indigo": "Active",
      "actif-orange": "Active",
      fixe: "Fixed"
    }, r = m(() => ({
      title: t.labels.title ?? "Customize columns",
      subtitle: t.labels.subtitle ?? ((ae, Re) => `${ae} of ${Re} selected`),
      searchPlaceholder: t.labels.searchPlaceholder ?? "Search a column",
      searchClearLabel: t.labels.searchClearLabel ?? "Clear search",
      visibleTab: t.labels.visibleTab ?? "Visible",
      orderTab: t.labels.orderTab ?? "Order",
      defaultColumnHeader: t.labels.defaultColumnHeader ?? "Default fixed column",
      pinnedBadge: t.labels.pinnedBadge ?? "Pinned",
      resetLabel: t.labels.resetLabel ?? "Reset columns",
      cancelLabel: t.labels.cancelLabel ?? "Cancel",
      saveLabel: t.labels.saveLabel ?? "Save",
      closeAriaLabel: t.labels.closeAriaLabel ?? "Close",
      emptySearchText: t.labels.emptySearchText ?? "No columns found",
      emptyOrderText: t.labels.emptyOrderText ?? "No visible columns",
      orderSearchHint: t.labels.orderSearchHint ?? "Showing filtered results. Drag to reorder within visible columns.",
      pinTooltip: t.labels.pinTooltip ?? "Locked column",
      pinAriaLabelPinned: t.labels.pinAriaLabelPinned ?? "Unfreeze column",
      pinAriaLabelUnpinned: t.labels.pinAriaLabelUnpinned ?? "Freeze column",
      pinLimitTooltip: t.labels.pinLimitTooltip ?? `You can freeze up to ${ro} columns. Unfreeze a column to freeze another.`,
      badgeLabels: {
        ...o,
        ...t.labels.badgeLabels ?? {}
      },
      reorderMoved: t.labels.reorderMoved ?? ((ae, Re, Ae) => `${ae} moved to position ${Re} of ${Ae}`),
      reorderPickedUp: t.labels.reorderPickedUp ?? ((ae) => `${ae} picked up. Use arrow keys to move, space to drop, escape to cancel.`),
      reorderCancelled: t.labels.reorderCancelled ?? ((ae) => `${ae} reorder cancelled`),
      orderListLabel: t.labels.orderListLabel ?? "Column order"
    })), i = R(null), s = R([]), d = R(""), c = R("visible"), f = R(null), g = R(null), h = R(null), v = R(null);
    let p = null;
    const y = Ye();
    function k(ae) {
      return `${y}-section-${ae.replace(/\s+/g, "-").toLowerCase() || "ungrouped"}`;
    }
    function $(ae) {
      return `${y}-column-${ae.replace(/\s+/g, "-")}`;
    }
    const S = R("");
    function I(ae, Re, Ae) {
      S.value = r.value.reorderMoved(ae, Re, Ae);
    }
    function T(ae) {
      return ae.map((Re) => ({
        ...Re,
        visible: Re.disabled || Re.alwaysVisible ? !0 : Re.visible
      }));
    }
    function A() {
      const ae = T(t.columns);
      if (t.columnOrder.length > 0) {
        const Re = new Map(t.columnOrder.map((Ae, xe) => [Ae, xe]));
        ae.sort((Ae, xe) => (Re.get(Ae.key) ?? 1 / 0) - (Re.get(xe.key) ?? 1 / 0));
      }
      s.value = ge(ae);
    }
    $e(
      () => t.modelValue,
      (ae) => {
        ae && (A(), d.value = "", c.value = "visible", v.value = null, p = null, l.value = !1);
      },
      { immediate: !0 }
    ), $e(
      () => t.modelValue ? `${t.columnOrder.join("|")}::${t.columns.map((ae) => ae.key).join("|")}` : null,
      (ae) => {
        ae !== null && v.value === null && A();
      }
    );
    const E = {
      fige: "bg-white ring-1 ring-(--colors-border-base-soft) text-(--colors-text-black-default)",
      "actif-indigo": "bg-(--colors-indigo-100) text-(--colors-text-black-default)",
      "actif-orange": "bg-(--colors-warning-100) text-(--colors-text-black-default)",
      fixe: "bg-(--colors-indigo-100) text-(--colors-text-black-default)"
    };
    function z(ae) {
      return E[ae];
    }
    function B(ae) {
      return ae.badge ? r.value.badgeLabels[ae.badge] : ae.pinned || M(ae) ? r.value.pinnedBadge : "";
    }
    const W = m(() => s.value.filter((ae) => ae.visible).length), _ = m(() => s.value.length), Z = m(
      () => r.value.subtitle(W.value, _.value)
    ), le = m(() => {
      const ae = d.value.toLowerCase().trim();
      return ae ? s.value.filter((Re) => Re.label.toLowerCase().includes(ae)) : s.value;
    }), D = m(
      () => le.value.filter((ae) => ae.alwaysVisible || ae.disabled)
    ), O = m(
      () => le.value.filter((ae) => !ae.alwaysVisible && !ae.disabled)
    ), N = m(() => {
      const ae = [], Re = /* @__PURE__ */ new Map(), Ae = [];
      for (const xe of O.value)
        xe.group ? (Re.has(xe.group) || Re.set(xe.group, []), Re.get(xe.group).push(xe)) : Ae.push(xe);
      for (const [xe, we] of Re)
        ae.push({ name: xe, items: we });
      return Ae.length > 0 && ae.push({ name: "", items: Ae }), ae;
    }), V = m(() => {
      const ae = d.value.toLowerCase().trim(), Re = s.value.filter((Ae) => Ae.visible);
      return ae ? Re.filter((Ae) => Ae.label.toLowerCase().includes(ae)) : Re;
    });
    function M(ae) {
      return !!(ae.disabled || ae.alwaysVisible);
    }
    const Q = m(
      () => s.value.filter((ae) => ae.visible && (M(ae) || ae.pinned)).length
    ), q = m(() => Q.value >= ro);
    function K(ae) {
      return !ae.visible || M(ae) ? !1 : ae.pinned || !q.value;
    }
    function G(ae) {
      return ae.pinned ? r.value.pinAriaLabelPinned : r.value.pinAriaLabelUnpinned;
    }
    function te(ae) {
      return ae.visible && !ae.pinned && q.value ? r.value.pinLimitTooltip : G(ae);
    }
    function ve(ae) {
      return !M(ae);
    }
    function Se(ae) {
      return M(ae) ? "locked" : ae.pinned ? "pinned" : "regular";
    }
    function oe(ae, Re) {
      return Se(ae) === Se(Re);
    }
    function re(ae) {
      const Re = [], Ae = [], xe = [];
      for (const we of ae)
        M(we) ? Re.push(we) : we.pinned ? Ae.push(we) : xe.push(we);
      return [...Re, ...Ae, ...xe];
    }
    function ge(ae = s.value) {
      const Re = [], Ae = [];
      for (const xe of ae)
        (xe.visible ? Re : Ae).push(xe);
      return [...re(Re), ...Ae];
    }
    function de(ae) {
      M(ae) || (ae.visible = !ae.visible, ae.visible || (ae.pinned = !1));
    }
    function Ee(ae) {
      K(ae) && (ae.pinned = !ae.pinned, s.value = ge());
    }
    function j() {
      n("update:modelValue", !1);
    }
    function J() {
      l.value && n("reset"), n(
        "save",
        s.value.map((ae) => ({ ...ae }))
      ), n("update:modelValue", !1);
    }
    const ne = m(() => [
      {
        id: "reset",
        label: r.value.resetLabel,
        variant: "ghost",
        icon: "ri-restart-line",
        onClick: Y
      },
      { id: "cancel", label: r.value.cancelLabel, variant: "secondary", onClick: j },
      { id: "save", label: r.value.saveLabel, variant: "primary", onClick: J }
    ]);
    function Y() {
      s.value = ge(T(t.defaultColumns)), l.value = !0;
    }
    function F(ae, Re) {
      f.value = ae, Re.dataTransfer && (Re.dataTransfer.effectAllowed = "move");
    }
    function ee(ae) {
      const Re = V.value[ae], Ae = f.value !== null ? V.value[f.value] : null;
      if (!Re || !ve(Re)) {
        g.value = null;
        return;
      }
      if (Ae && !oe(Ae, Re)) {
        g.value = null;
        return;
      }
      g.value = ae;
    }
    function ue(ae) {
      if (f.value === null || f.value === ae) {
        f.value = null, g.value = null;
        return;
      }
      const Re = V.value[f.value], Ae = V.value[ae];
      if (!Re || !Ae || !ve(Re) || !ve(Ae) || !oe(Re, Ae)) {
        f.value = null, g.value = null;
        return;
      }
      const xe = Re.key, we = Ae.key, fe = [...s.value], Ne = fe.findIndex((Qe) => Qe.key === xe), De = fe.findIndex((Qe) => Qe.key === we), [qe] = fe.splice(Ne, 1);
      fe.splice(De, 0, qe), f.value = null, g.value = null, requestAnimationFrame(() => {
        s.value = ge(fe);
        const Qe = s.value.findIndex((Ie) => Ie.key === xe) + 1, lt = s.value.filter((Ie) => Ie.visible).length;
        I(Re.label, Qe, lt);
      });
    }
    function se() {
      f.value = null, g.value = null;
    }
    function X(ae, Re) {
      const Ae = V.value[ae];
      if (!Ae) return;
      if (Re.key === "Escape" && v.value !== null) {
        Re.preventDefault(), p && (s.value = p), v.value = null, p = null, S.value = r.value.reorderCancelled(Ae.label);
        return;
      }
      if (Re.key === " " || Re.key === "Enter") {
        if (v.value === null) {
          if (!ve(Ae)) return;
          Re.preventDefault(), v.value = ae, p = s.value.map((nt) => ({ ...nt })), S.value = r.value.reorderPickedUp(Ae.label);
          return;
        }
        Re.preventDefault();
        const Pe = V.value[v.value], Xe = V.value.length;
        I((Pe == null ? void 0 : Pe.label) ?? Ae.label, v.value + 1, Xe), v.value = null, p = null;
        return;
      }
      if (v.value === null || Re.key !== "ArrowUp" && Re.key !== "ArrowDown") return;
      const xe = v.value, we = V.value[xe];
      if (!we) return;
      let fe = Re.key === "ArrowUp" ? xe - 1 : xe + 1;
      for (; fe >= 0 && fe < V.value.length && (!ve(V.value[fe]) || !oe(we, V.value[fe])); )
        fe += Re.key === "ArrowUp" ? -1 : 1;
      if (fe < 0 || fe >= V.value.length) return;
      Re.preventDefault();
      const Ne = V.value[xe].key, De = V.value[fe].key, qe = [...s.value], Qe = qe.findIndex((Pe) => Pe.key === Ne), lt = qe.findIndex((Pe) => Pe.key === De), [Ie] = qe.splice(Qe, 1);
      qe.splice(lt, 0, Ie), s.value = ge(qe), v.value = fe, h.value = fe;
      const pe = s.value.filter((Pe) => Pe.visible).length;
      I(Ae.label, fe + 1, pe), requestAnimationFrame(() => {
        var Xe, nt;
        const Pe = (Xe = i.value) == null ? void 0 : Xe.querySelectorAll("[role='listitem']");
        (nt = Pe == null ? void 0 : Pe[fe]) == null || nt.focus();
      });
    }
    return (ae, Re) => (u(), P(L(UF), {
      "model-value": e.modelValue,
      position: "right",
      variant: "column",
      title: r.value.title,
      subtitle: Z.value,
      "aria-close-label": r.value.closeAriaLabel,
      actions: ne.value,
      dismissable: !0,
      "onUpdate:modelValue": Re[2] || (Re[2] = (Ae) => n("update:modelValue", Ae))
    }, {
      default: me(() => [
        x("div", {
          ref_key: "drawerContainerRef",
          ref: i,
          class: "flex flex-col h-full -mx-5 -mt-4 -mb-5 gap-1"
        }, [
          x("div", XF, H(S.value), 1),
          x("div", ZF, [
            x("div", QF, [
              U(L(zs), {
                modelValue: d.value,
                "onUpdate:modelValue": Re[0] || (Re[0] = (Ae) => d.value = Ae),
                placeholder: r.value.searchPlaceholder,
                labels: { clear: r.value.searchClearLabel },
                size: "sm",
                "full-width": ""
              }, null, 8, ["modelValue", "placeholder", "labels"])
            ]),
            U(L(Ri), {
              modelValue: c.value,
              "onUpdate:modelValue": Re[1] || (Re[1] = (Ae) => c.value = Ae),
              variant: "group",
              color: "dark",
              size: "sm",
              class: "w-full",
              "aria-label": r.value.title,
              "data-testid": "faceted-view-switch"
            }, {
              default: me(() => [
                U(L(Be), {
                  value: "visible",
                  variant: "tertiary",
                  size: "sm",
                  label: r.value.visibleTab,
                  class: "flex-1"
                }, null, 8, ["label"]),
                U(L(Be), {
                  value: "order",
                  variant: "tertiary",
                  size: "sm",
                  label: r.value.orderTab,
                  class: "flex-1"
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "aria-label"])
          ]),
          x("div", _F, [
            U(Wt, {
              name: "faceted-tab-fade",
              mode: "out-in"
            }, {
              default: me(() => [
                c.value === "visible" ? (u(), b("div", e6, [
                  D.value.length > 0 ? (u(), b("div", {
                    key: 0,
                    class: "mb-8",
                    role: "group",
                    "aria-labelledby": k("default-fixed")
                  }, [
                    x("div", {
                      id: k("default-fixed"),
                      class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--colors-text-heading) mb-4 font-inter"
                    }, H(r.value.defaultColumnHeader), 9, a6),
                    x("div", n6, [
                      (u(!0), b(ie, null, Oe(D.value, (Ae) => (u(), b("div", {
                        key: Ae.key,
                        class: "flex items-center gap-(--spacing-2-5) p-px"
                      }, [
                        x("div", l6, [
                          U(L(va), {
                            id: $(Ae.key),
                            "model-value": !0,
                            disabled: !0,
                            variant: "light"
                          }, null, 8, ["id"])
                        ]),
                        x("label", {
                          for: $(Ae.key),
                          class: "flex-1 min-w-0 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) font-inter truncate cursor-not-allowed text-(--colors-text-body-subtle)"
                        }, H(Ae.label), 9, o6),
                        x("div", r6, [
                          x("span", {
                            class: C(["inline-flex items-center px-1 py-0.5 rounded-(--border-border-radius-rounded-xs) text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) font-inter", z(Ae.badge ?? "fige")])
                          }, H(B(Ae)), 3),
                          Re[3] || (Re[3] = x("i", {
                            class: "ri-pushpin-2-fill text-(length:--icon-size-lg) leading-(--line-height-xxl) text-(--colors-text-body-subtle)",
                            "aria-hidden": "true"
                          }, null, -1))
                        ])
                      ]))), 128))
                    ])
                  ], 8, t6)) : w("", !0),
                  (u(!0), b(ie, null, Oe(N.value, (Ae) => (u(), b("div", {
                    key: Ae.name,
                    class: "mb-8 last:mb-0",
                    role: "group",
                    "aria-labelledby": Ae.name ? k(Ae.name) : void 0,
                    "aria-label": Ae.name ? void 0 : r.value.visibleTab
                  }, [
                    Ae.name ? (u(), b("div", {
                      key: 0,
                      id: k(Ae.name),
                      class: "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-bold) text-(--colors-text-heading) mb-4 font-inter"
                    }, H(Ae.name), 9, s6)) : w("", !0),
                    x("div", d6, [
                      (u(!0), b(ie, null, Oe(Ae.items, (xe) => (u(), b("div", {
                        key: xe.key,
                        class: "flex items-center gap-(--spacing-2-5) p-px"
                      }, [
                        x("div", u6, [
                          U(L(va), {
                            id: $(xe.key),
                            "model-value": xe.visible,
                            variant: "default",
                            "onUpdate:modelValue": (we) => de(xe)
                          }, null, 8, ["id", "model-value", "onUpdate:modelValue"])
                        ]),
                        x("label", {
                          for: $(xe.key),
                          class: "flex-1 min-w-0 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) font-inter truncate text-(--colors-text-heading) cursor-pointer"
                        }, H(xe.label), 9, c6),
                        x("div", f6, [
                          xe.pinned || xe.badge ? (u(), b("span", {
                            key: 0,
                            class: C(["inline-flex items-center px-1 py-0.5 rounded-(--border-border-radius-rounded-xs) text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) font-inter", z(xe.badge ?? "fige")])
                          }, H(B(xe)), 3)) : w("", !0),
                          U(L($t), {
                            text: te(xe),
                            position: "top",
                            tabindex: K(xe) ? void 0 : 0
                          }, {
                            default: me(() => [
                              x("button", {
                                type: "button",
                                class: C([
                                  "inline-flex items-center justify-center size-6 rounded-(--border-border-radius-rounded-xs) transition-colors duration-150 hover:bg-(--colors-background-hover) disabled:cursor-not-allowed disabled:hover:bg-transparent",
                                  xe.pinned ? "text-(--colors-text-black-default)" : "text-(--colors-text-body-subtle) hover:text-(--colors-text-black-default)"
                                ]),
                                disabled: !K(xe),
                                "aria-label": G(xe),
                                "aria-pressed": xe.pinned,
                                onClick: _e((we) => Ee(xe), ["stop"])
                              }, [
                                x("i", {
                                  class: C([xe.pinned ? "ri-pushpin-2-fill" : "ri-pushpin-2-line", "text-(length:--icon-size-lg) leading-(--line-height-xxl)"])
                                }, null, 2)
                              ], 10, h6)
                            ]),
                            _: 2
                          }, 1032, ["text", "tabindex"])
                        ])
                      ]))), 128))
                    ])
                  ], 8, i6))), 128)),
                  le.value.length === 0 ? (u(), b("div", b6, H(r.value.emptySearchText), 1)) : w("", !0)
                ])) : c.value === "order" ? (u(), b("div", g6, [
                  d.value.trim() && V.value.length > 0 ? (u(), b("div", m6, [
                    Re[4] || (Re[4] = x("i", { class: "ri-information-line text-(length:--icon-size-xs) shrink-0" }, null, -1)),
                    x("span", null, H(r.value.orderSearchHint), 1)
                  ])) : w("", !0),
                  x("div", {
                    class: "flex flex-col gap-3",
                    role: "list",
                    "aria-label": r.value.orderListLabel
                  }, [
                    (u(!0), b(ie, null, Oe(V.value, (Ae, xe) => (u(), P(vM, {
                      key: Ae.key,
                      label: Ae.label,
                      disabled: Ae.disabled || Ae.alwaysVisible,
                      reorderable: ve(Ae),
                      class: C([
                        "transition-all duration-150 ease-out rounded-(--border-border-radius-rounded-l) focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1",
                        g.value === xe && f.value !== xe ? "ring-2 ring-(--border-border-hover) rounded-(--border-border-radius-rounded-l)" : "",
                        f.value === xe ? "opacity-40" : "",
                        v.value === xe ? "ring-2 ring-(--border-border-accent) rounded-(--border-border-radius-rounded-l)" : ""
                      ]),
                      role: "listitem",
                      "aria-roledescription": ve(Ae) ? "sortable" : void 0,
                      "data-picked-up": v.value === xe ? "true" : void 0,
                      tabindex: "0",
                      onDragstart: (we) => F(xe, we),
                      onDragover: _e((we) => ee(xe), ["prevent"]),
                      onDragend: se,
                      onDrop: _e((we) => ue(xe), ["prevent"]),
                      onKeydown: (we) => X(xe, we)
                    }, {
                      badge: me(() => [
                        Ae.pinned || Ae.badge ? (u(), b("span", {
                          key: 0,
                          class: C(["shrink-0 inline-flex items-center px-1 py-0.5 rounded-(--border-border-radius-rounded-xs) text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) font-inter", z(Ae.badge ?? "fige")])
                        }, H(B(Ae)), 3)) : w("", !0)
                      ]),
                      actions: me(() => [
                        Ae.disabled || Ae.alwaysVisible ? (u(), P(L($t), {
                          key: 0,
                          text: r.value.pinTooltip,
                          position: "top"
                        }, {
                          default: me(() => [
                            x("button", {
                              type: "button",
                              class: "shrink-0 size-6 flex items-center justify-center",
                              disabled: "",
                              "aria-label": r.value.pinTooltip
                            }, [...Re[5] || (Re[5] = [
                              x("i", { class: "ri-pushpin-2-fill text-(length:--icon-size-lg) leading-(--line-height-xxl) text-(--colors-text-body-subtle)" }, null, -1)
                            ])], 8, p6)
                          ]),
                          _: 1
                        }, 8, ["text"])) : (u(), P(L($t), {
                          key: 1,
                          text: te(Ae),
                          position: "top",
                          tabindex: K(Ae) ? void 0 : 0
                        }, {
                          default: me(() => [
                            x("button", {
                              type: "button",
                              class: "shrink-0 size-6 flex items-center justify-center rounded-(--border-border-radius-rounded-xs) transition-colors duration-150 hover:bg-(--colors-background-hover) disabled:cursor-not-allowed disabled:hover:bg-transparent",
                              disabled: !K(Ae),
                              "aria-label": G(Ae),
                              "aria-pressed": Ae.pinned,
                              onClick: _e((we) => Ee(Ae), ["stop"])
                            }, [
                              x("i", {
                                class: C([
                                  Ae.pinned ? "ri-pushpin-2-fill text-(--colors-text-black-default)" : "ri-pushpin-2-line text-(--colors-text-body-subtle)",
                                  "text-(length:--icon-size-lg) leading-(--line-height-xxl)"
                                ])
                              }, null, 2)
                            ], 8, x6)
                          ]),
                          _: 2
                        }, 1032, ["text", "tabindex"]))
                      ]),
                      _: 2
                    }, 1032, ["label", "disabled", "reorderable", "class", "aria-roledescription", "data-picked-up", "onDragstart", "onDragover", "onDrop", "onKeydown"]))), 128))
                  ], 8, v6),
                  V.value.length === 0 ? (u(), b("div", y6, H(r.value.emptyOrderText), 1)) : w("", !0)
                ])) : w("", !0)
              ]),
              _: 1
            })
          ])
        ], 512)
      ]),
      _: 1
    }, 8, ["model-value", "title", "subtitle", "aria-close-label", "actions"]));
  }
}), w6 = /* @__PURE__ */ Ct(k6, [["__scopeId", "data-v-bacb0a0c"]]);
function LG(e = {}) {
  const { defaultOpen: a = !1, onClose: t } = e, n = R(a);
  return { isOpen: n, open: () => {
    n.value = !0;
  }, close: () => {
    n.value = !1, t == null || t();
  }, toggle: () => {
    n.value = !n.value;
  } };
}
function C6(e, a, t) {
  function n() {
    var s;
    const r = (s = e.value) == null ? void 0 : s.querySelector("[data-table-search]"), i = r != null && r.matches(yn) ? r : r == null ? void 0 : r.querySelector(yn);
    return i == null || i.focus(), !!i && document.activeElement === i;
  }
  function l() {
    if (n()) return;
    const r = e.value;
    r && (r.tabIndex = -1, r.setAttribute("role", "group"), r.setAttribute("aria-label", t()), r.addEventListener(
      "blur",
      () => {
        r.removeAttribute("tabindex"), r.removeAttribute("role"), r.removeAttribute("aria-label");
      },
      { once: !0 }
    ), r.focus());
  }
  function o() {
    var r;
    (r = a.value) != null && r.focusFilterTrigger() || l();
  }
  return { focusSearchOrRoot: l, focusAfterFiltersCleared: o };
}
const S6 = ["aria-busy"], $6 = {
  key: 0,
  class: "border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
}, I6 = ["id", "role", "aria-labelledby", "aria-busy"], L6 = {
  key: 0,
  "data-testid": "table-skeleton-footer",
  "aria-hidden": "true",
  class: "flex items-center justify-between h-7"
}, T6 = { class: "flex items-center gap-2" }, TG = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "TableShell",
  props: {
    query: {},
    views: { default: void 0 },
    permissions: { default: () => ({}) },
    labels: { default: void 0 },
    showTopbar: { type: Boolean, default: !0 },
    showControls: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    searchDebounce: { default: Vr },
    markSearchStale: { type: Boolean, default: !0 },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] },
    columnSettings: { default: void 0 },
    header: { default: void 0 },
    footer: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    skeletonColumns: { default: void 0 },
    skeletonRows: { default: void 0 },
    bordered: { type: Boolean, default: !1 }
  },
  emits: ["rename-view", "delete-view", "set-default", "save-view", "share-view", "toggle-filter-panel", "toggle-filter-bar", "edit-filter", "tab-requested", "tab-reordered", "header-action", "header-tab-change", "filter-apply", "filter-apply-value", "filter-remove", "advanced-filters", "view-advanced-filters", "create-advanced-filter", "page-change", "page-size-change", "footer-action"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t;
    wa(Hl, n.query), n.views && wa(Js, n.views), n.columnSettings && wa(uP, n.columnSettings);
    const o = m(() => n.permissions ?? {});
    wa(Dx, o.value);
    const r = m(() => ({ ...Cs, ...n.labels }));
    wa(Bx, r);
    const i = Ye(), s = m(
      () => n.header && n.header.type !== "two-levels-prefiltered-lists" ? n.header : null
    ), d = Na(), c = m(() => {
      const q = n.loading || !!n.footer, K = !s.value && !g.value && !Q.value, G = n.loading || !!d.table, te = K && !q, ve = te || K && G || !!s.value && s.value.type !== "two-levels-stats" && !g.value, Se = te || q, oe = !ve && g.value && Q.value;
      return [
        ve && "rounded-t-(--border-border-radius-rounded-l)",
        oe && "rounded-tr-(--border-border-radius-rounded-l)",
        Se && "rounded-b-(--border-border-radius-rounded-l)"
      ];
    }), f = m(() => !n.bordered && g.value && !s.value), g = m(
      () => n.showTopbar && (!s.value || s.value.type === "two-levels-stats")
    ), h = m(
      () => s.value && "activeTab" in s.value ? s.value.activeTab : null
    ), v = m(() => {
      var G;
      if (h.value !== null) return pc(i, h.value);
      const q = n.query.state.activeViewId;
      return g.value && !!q && !!((G = n.views) != null && G.presetViews.value.some((te) => te.id === q)) ? Ox(i, q) : null;
    });
    wa(Mx, { id: i, isTabpanel: m(() => v.value !== null) });
    const p = R(!1), y = R(!0), k = hn("controls"), $ = hn("shellRoot"), S = hn("headerFilter"), I = hn("boxFilter"), T = m(
      () => k.value ?? {
        focusFilterTrigger: () => {
          var K;
          const q = (K = I.value) == null ? void 0 : K.querySelector(yn);
          return q == null || q.focus(), !!q && document.activeElement === q;
        }
      }
    ), { focusSearchOrRoot: A, focusAfterFiltersCleared: E } = C6(
      $,
      T,
      () => r.value.tableLabel
    ), z = m(
      () => n.header && "filter" in n.header ? n.header.filter : void 0
    ), B = m(
      () => {
        var q, K;
        return ((q = n.header) == null ? void 0 : q.type) === "two-levels-prefiltered-lists" || ((K = n.header) == null ? void 0 : K.type) === "title-quick-filters" ? n.header.actions ?? [] : [];
      }
    ), W = {
      "filter-apply": (q, K) => l("filter-apply", q, K),
      "filter-apply-value": (q, K) => l("filter-apply-value", q, K),
      "filter-remove": (q) => l("filter-remove", q),
      "advanced-filters": () => l("advanced-filters"),
      "view-advanced-filters": () => l("view-advanced-filters"),
      "create-advanced-filter": () => l("create-advanced-filter")
    };
    function _(q) {
      var K;
      (K = S.value) == null || K.openForField(q);
    }
    function Z(q) {
      _(q), l("edit-filter", q);
    }
    const le = m(() => {
      var q;
      return ((q = S.value) == null ? void 0 : q.triggerEl) ?? null;
    });
    function D() {
      p.value = !p.value, l("toggle-filter-panel");
    }
    function O() {
      y.value = !y.value, l("toggle-filter-bar", y.value);
    }
    a({ toggleFilterPanel: D, openFilterField: _, filterTriggerEl: le });
    const N = m(
      () => n.skeletonColumns ?? (n.columnSettings && n.columnSettings.settingsItems.value.filter((q) => q.visible).length || void 0) ?? 5
    ), V = m(() => n.skeletonRows ?? n.query.state.pageSize), M = m(
      () => n.markSearchStale && n.query.searchPending.value && !n.loading
    ), Q = m(
      () => {
        var q, K;
        return (!n.header || n.header.type === "two-levels-prefiltered-lists") && n.showControls && (n.showFilter || ((q = n.permissions) == null ? void 0 : q.canSaveView) !== !1 || ((K = n.permissions) == null ? void 0 : K.canShareView) !== !1 || !!z.value || B.value.length > 0);
      }
    );
    return (q, K) => {
      var G, te, ve, Se, oe;
      return u(), b(ie, null, [
        x("div", Ve({
          ref_key: "shellRoot",
          ref: $
        }, q.$attrs, {
          "data-table-shell-root": "",
          class: "w-full flex flex-col flex-1 min-h-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-royalblue",
          "aria-busy": e.loading || void 0
        }), [
          g.value ? (u(), P(LP, {
            key: 0,
            "search-placeholder": e.searchPlaceholder,
            "show-search": e.showSearch,
            "search-debounce": e.searchDebounce,
            "show-view-selector": e.showViewSelector,
            "tab-dropdowns": e.tabDropdowns,
            "tab-size": ((G = e.header) == null ? void 0 : G.type) === "two-levels-stats" ? "md" : "xs",
            onRenameView: K[0] || (K[0] = (re) => l("rename-view", re)),
            onDeleteView: K[1] || (K[1] = (re) => l("delete-view", re)),
            onSetDefault: K[2] || (K[2] = (re) => l("set-default", re)),
            onTabRequested: K[3] || (K[3] = (re, ge) => l("tab-requested", re, ge)),
            onTabReordered: K[4] || (K[4] = (re, ge) => l("tab-reordered", re, ge))
          }, null, 8, ["search-placeholder", "show-search", "search-debounce", "show-view-selector", "tab-dropdowns", "tab-size"])) : w("", !0),
          x("div", {
            class: C([
              "flex flex-col flex-1 min-h-0 bg-white dark:bg-(--colors-background-black-default) shadow-(--blur-shadow-xs) dark:shadow-(--blur-shadow-m-dark) overflow-hidden",
              c.value,
              // -mt-px pulls this card up 1px over the tabs row above so its own top border sits
              // underneath the tabs' bottom edge instead of showing as a seam; pt-px compensates
              // so the card's own content doesn't shift up with it.
              e.bordered && "border border-(--colors-border-base-soft) dark:border-(--colors-border-base) -mt-px pt-px"
            ])
          }, [
            s.value ? (u(), P(A8, {
              key: 0,
              header: s.value,
              "panel-id": L(i),
              inset: e.bordered,
              "search-placeholder": e.searchPlaceholder,
              "show-search": e.showSearch,
              "search-debounce": e.searchDebounce,
              onAction: K[5] || (K[5] = (re) => l("header-action", re)),
              onTabChange: K[6] || (K[6] = (re) => l("header-tab-change", re))
            }, {
              filter: me(() => {
                var re, ge;
                return [
                  x("div", {
                    ref_key: "boxFilter",
                    ref: I,
                    class: "contents"
                  }, [
                    z.value ? (u(), P(Xb, Ve({
                      key: 0,
                      ref_key: "headerFilter",
                      ref: S,
                      filter: z.value,
                      "trigger-size": ((re = s.value) == null ? void 0 : re.type) === "tab-button-search" || ((ge = s.value) == null ? void 0 : ge.type) === "tabs" ? "sm" : "xs"
                    }, nl(W)), null, 16, ["filter", "trigger-size"])) : w("", !0)
                  ], 512)
                ];
              }),
              _: 1
            }, 8, ["header", "panel-id", "inset", "search-placeholder", "show-search", "search-debounce"])) : w("", !0),
            Q.value || ((te = e.header) == null ? void 0 : te.type) === "title-quick-filters" ? (u(), P(zP, {
              key: 1,
              ref_key: "controls",
              ref: k,
              "is-filter-panel-open": p.value,
              "is-filter-bar-visible": y.value,
              "show-filter": e.showFilter,
              bordered: f.value,
              "round-top-right": g.value && !s.value,
              onFocusFallback: L(A),
              onToggleFilterPanel: D,
              onToggleFilterBar: O,
              onSaveView: K[7] || (K[7] = (re) => l("save-view")),
              onShareView: K[8] || (K[8] = (re) => l("share-view"))
            }, Xa({ _: 2 }, [
              z.value ? {
                name: "filter",
                fn: me(() => [
                  U(Xb, Ve({
                    ref_key: "headerFilter",
                    ref: S,
                    filter: z.value
                  }, nl(W)), null, 16, ["filter"])
                ]),
                key: "0"
              } : void 0,
              B.value.length ? {
                name: "controls-actions",
                fn: me(() => [
                  (u(!0), b(ie, null, Oe(B.value, (re) => (u(), P(tn, {
                    key: re.id,
                    button: re,
                    variant: "ghost",
                    size: "xs",
                    onClick: (ge) => l("header-action", re.id)
                  }, null, 8, ["button", "onClick"]))), 128))
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["is-filter-panel-open", "is-filter-bar-visible", "show-filter", "bordered", "round-top-right", "onFocusFallback"])) : w("", !0),
            U(Wt, {
              "enter-active-class": "transition-all duration-200 ease-out overflow-hidden",
              "enter-from-class": "max-h-0 opacity-0",
              "enter-to-class": "max-h-[600px] opacity-100",
              "leave-active-class": "transition-all duration-150 ease-in overflow-hidden",
              "leave-from-class": "max-h-[600px] opacity-100",
              "leave-to-class": "max-h-0 opacity-0"
            }, {
              default: me(() => [
                p.value ? (u(), b("div", $6, [
                  Me(q.$slots, "filter-panel", {
                    close: () => p.value = !1
                  })
                ])) : w("", !0)
              ]),
              _: 3
            }),
            U(Wt, {
              "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
              "enter-from-class": "max-h-0",
              "enter-to-class": "max-h-[100px]",
              "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
              "leave-from-class": "max-h-[100px]",
              "leave-to-class": "max-h-0"
            }, {
              default: me(() => [
                y.value ? (u(), P(NP, {
                  key: 0,
                  bordered: f.value,
                  onEditFilter: Z,
                  onLastFilterRemoved: L(E)
                }, null, 8, ["bordered", "onLastFilterRemoved"])) : w("", !0)
              ]),
              _: 1
            }),
            x("div", {
              id: L(i),
              role: v.value ? "tabpanel" : void 0,
              "aria-labelledby": v.value ?? void 0,
              class: C(["flex-1 overflow-x-hidden min-h-0 transition-opacity", M.value && "opacity-50"]),
              "aria-busy": M.value || void 0,
              "data-testid": "table-shell-body"
            }, [
              e.loading ? (u(), P(jP, {
                key: 0,
                columns: N.value,
                rows: V.value
              }, null, 8, ["columns", "rows"])) : Me(q.$slots, "table", { key: 1 })
            ], 10, I6),
            e.loading || e.footer ? (u(), b("div", {
              key: 2,
              "data-testid": "table-footer",
              class: C([
                "flex min-h-14 flex-col justify-center border border-(--border-border-base-soft) dark:border-(--colors-border-base) bg-(--background-background-white) dark:bg-(--colors-background-black-default) px-[calc(--spacing(5)-1px)] rounded-b-(--border-border-radius-rounded-l)",
                e.loading ? "py-[calc(--spacing(2.5)-1px)]" : ((ve = e.footer) == null ? void 0 : ve.type) === "total-results" || ((Se = e.footer) == null ? void 0 : Se.type) === "progress-stats" ? "py-[calc(7px-1px)]" : ((oe = e.footer) == null ? void 0 : oe.type) === "select-input" ? "py-[calc(--spacing(5)-1px)]" : "py-[calc(--spacing(2.5)-1px)]"
              ])
            }, [
              e.loading ? (u(), b("div", L6, [
                K[13] || (K[13] = x("div", { class: "flex items-center gap-3" }, [
                  x("div", { class: "skeleton h-1.5 w-36 rounded-full" }),
                  x("div", { class: "skeleton h-1.5 w-11 rounded-full" })
                ], -1)),
                x("div", T6, [
                  (u(), b(ie, null, Oe(5, (re) => x("div", {
                    key: `skeleton-page-${re}`,
                    class: "skeleton size-7 rounded-(--border-border-radius-rounded-sm)"
                  })), 64))
                ])
              ])) : e.footer ? (u(), P(t8, {
                key: 1,
                footer: e.footer,
                onPageChange: K[9] || (K[9] = (re) => l("page-change", re)),
                onPageSizeChange: K[10] || (K[10] = (re) => l("page-size-change", re)),
                onAction: K[11] || (K[11] = (re) => l("footer-action", re))
              }, null, 8, ["footer"])) : w("", !0)
            ], 2)) : w("", !0)
          ], 2)
        ], 16, S6),
        e.columnSettings ? (u(), P(L(w6), {
          key: 0,
          modelValue: e.columnSettings.drawerOpen.value,
          "onUpdate:modelValue": K[12] || (K[12] = (re) => e.columnSettings.drawerOpen.value = re),
          columns: e.columnSettings.settingsItems.value,
          "default-columns": e.columnSettings.defaultSettingsItems.value,
          "column-order": e.columnSettings.order.value,
          labels: e.columnSettings.labels.value,
          onSave: e.columnSettings.handleSave,
          onReset: e.columnSettings.handleReset
        }, null, 8, ["modelValue", "columns", "default-columns", "column-order", "labels", "onSave", "onReset"])) : w("", !0)
      ], 64);
    };
  }
});
function EG(e = {}) {
  const a = R(e.initialViews ?? []), t = m(() => a.value.filter((d) => d.isPreset)), n = m(() => a.value.filter((d) => !d.isPreset));
  function l(d) {
    a.value.push(d);
  }
  function o(d, c) {
    const f = a.value.findIndex((g) => g.id === d);
    f !== -1 && (a.value[f] = { ...a.value[f], ...c });
  }
  function r(d) {
    a.value = a.value.filter((c) => c.id !== d);
  }
  function i(d) {
    a.value.forEach((c) => {
      c.isDefault = c.id === d;
    });
  }
  function s(d) {
    const c = new Map(d.map((h, v) => [h, v])), f = a.value.filter((h) => h.isPreset).sort(
      (h, v) => (c.get(h.id) ?? Number.MAX_SAFE_INTEGER) - (c.get(v.id) ?? Number.MAX_SAFE_INTEGER)
    ), g = a.value.filter((h) => !h.isPreset);
    a.value = [...f, ...g];
  }
  return {
    views: a,
    presetViews: t,
    savedViews: n,
    addView: l,
    updateView: o,
    removeView: r,
    setDefault: i,
    reorderViews: s
  };
}
const _b = 10, E6 = 30, A6 = 900;
function AG() {
  function e() {
    return typeof window > "u" ? _b : window.innerHeight >= A6 ? E6 : _b;
  }
  const a = R(e());
  function t() {
    a.value = e();
  }
  return kt(() => {
    a.value = e(), window.addEventListener("resize", t, { passive: !0 });
  }), zt(() => {
    window.removeEventListener("resize", t);
  }), { pageSize: a };
}
function RG(e) {
  const { defaultVisibility: a, defaultOrder: t = [] } = e, n = e.defaultPinning ?? {
    left: Xt(e.columns).filter((D) => D.pinned).map((D) => D.key),
    right: []
  }, l = m(
    () => new Set(
      Xt(e.columns).filter((D) => D.disabled || D.alwaysVisible).map((D) => D.key)
    )
  ), o = m(() => [...l.value]), r = (D) => l.value.has(D), i = Bn(
    a ?? Object.fromEntries(Xt(e.columns).map((D) => [D.key, D.visible ?? !0]))
  ), s = Array.from(/* @__PURE__ */ new Set([...o.value, ...n.left])), d = R({
    left: s,
    right: [...n.right]
  }), c = R([...t]), f = R(!1), g = (D) => {
    var O;
    return ((O = d.value.left) == null ? void 0 : O.includes(D)) ?? !1;
  }, h = m(
    () => Xt(e.columns).filter((D) => (r(D.key) || (i[D.key] ?? !0)) && (r(D.key) || g(D.key))).length
  ), v = m(() => h.value >= ro);
  function p(D) {
    return g(D) || !v.value;
  }
  const y = m(() => Xt(e.columns).map((D) => ({
    ...D,
    visible: i[D.key] ?? !0,
    pinned: g(D.key)
  }))), k = m(() => {
    const D = a ?? Object.fromEntries(Xt(e.columns).map((N) => [N.key, N.visible ?? !0])), O = new Set(n.left);
    return Xt(e.columns).map((N) => ({
      ...N,
      visible: D[N.key] ?? !0,
      pinned: O.has(N.key)
    }));
  }), $ = m(() => Xt(e.labels) ?? {});
  function S() {
    f.value = !0;
  }
  function I() {
    f.value = !1;
  }
  function T(D) {
    for (const K of D)
      i[K.key] = r(K.key) ? !0 : K.visible;
    const O = [], N = [], V = [], M = [];
    for (const K of D)
      r(K.key) ? O.push(K.key) : K.visible ? K.pinned ? N.push(K.key) : V.push(K.key) : M.push(K.key);
    c.value = [...O, ...N, ...V, ...M, ...e.trailingColumns ?? []];
    const Q = new Set(Xt(e.columns).map((K) => K.key)), q = (d.value.left ?? []).filter((K) => !Q.has(K));
    d.value = {
      left: [...q, ...O, ...N],
      right: [...d.value.right ?? []]
    };
  }
  function A() {
    const D = a ?? Object.fromEntries(Xt(e.columns).map((N) => [N.key, N.visible ?? !0]));
    Object.keys(i).forEach((N) => {
      i[N] = r(N) ? !0 : D[N] ?? !0;
    }), c.value = [...t];
    const O = Array.from(/* @__PURE__ */ new Set([...o.value, ...n.left]));
    d.value = { left: O, right: [...n.right] };
  }
  function E() {
    return c.value.length > 0 ? [...c.value] : [...Xt(e.columns).map((D) => D.key), ...e.trailingColumns ?? []];
  }
  function z(D) {
    if (g(D) || !p(D)) return;
    const O = [...d.value.left ?? [], D];
    d.value = { ...d.value, left: O };
    const N = new Set(O), V = E().filter((Q) => Q !== D);
    let M = -1;
    for (let Q = 0; Q < V.length; Q++)
      N.has(V[Q]) && (M = Q);
    V.splice(M + 1, 0, D), c.value = V;
  }
  function B(D) {
    r(D) || (d.value = {
      ...d.value,
      left: (d.value.left ?? []).filter((O) => O !== D)
    });
  }
  function W(D, O) {
    if (D.length !== O.length) return !1;
    for (let N = 0; N < D.length; N++) if (D[N] !== O[N]) return !1;
    return !0;
  }
  function _(D) {
    const O = e.trailingColumns ?? [], N = new Set(O), V = D.filter((K) => !N.has(K)), M = [...V, ...O];
    W(M, c.value) || (c.value = M);
    const Q = new Set(d.value.left ?? []), q = V.filter((K) => Q.has(K));
    W(q, d.value.left ?? []) || (d.value = { ...d.value, left: q });
  }
  function Z(D) {
    const O = new Set(Xt(e.columns).map((K) => K.key)), N = D.filter((K) => O.has(K));
    if (N.length <= ro) return D;
    const V = N.filter((K) => r(K)), M = N.filter((K) => !r(K)), Q = Math.max(0, ro - V.length), q = /* @__PURE__ */ new Set([...V, ...M.slice(0, Q)]);
    return D.filter((K) => !O.has(K) || q.has(K));
  }
  function le(D) {
    const O = Z(D.left ?? []), N = D.right ?? [], V = d.value.left ?? [], M = d.value.right ?? [];
    W(O, V) && W(N, M) || (d.value = { left: [...O], right: [...N] });
  }
  return {
    // State
    visibility: i,
    pinning: d,
    order: c,
    drawerOpen: f,
    // Computed
    settingsItems: y,
    defaultSettingsItems: k,
    labels: $,
    isPinned: g,
    isFrozenLimitReached: v,
    canPinColumn: p,
    // Actions
    openDrawer: S,
    closeDrawer: I,
    handleSave: T,
    handleReset: A,
    pinColumn: z,
    unpinColumn: B,
    setOrder: _,
    setPinning: le
  };
}
const zG = /* @__PURE__ */ ke({
  __name: "TablePanel",
  props: {
    roundTop: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (a, t) => (u(), b("div", {
      class: C([
        "min-w-0 border border-(--border-border-base-soft) overflow-x-auto shadow-(--blur-shadow-xs)",
        e.roundTop ? "rounded-(--border-border-radius-rounded-l)" : "rounded-b-(--border-border-radius-rounded-l)"
      ])
    }, [
      Me(a.$slots, "default")
    ], 2));
  }
}), R6 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10.8284%2012.0007L15.7782%2016.9504L14.364%2018.3646L8%2012.0007L14.364%205.63672L15.7782%207.05093L10.8284%2012.0007Z'/%3e%3c/svg%3e", z6 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.1717%2012.0007L8.22192%207.05093L9.63614%205.63672L16.0001%2012.0007L9.63614%2018.3646L8.22192%2016.9504L13.1717%2012.0007Z'/%3e%3c/svg%3e", D6 = ["data-theme", "data-collapsed", "aria-label"], B6 = { class: "flex items-center sidebar-logo" }, M6 = ["src"], O6 = {
  key: 0,
  class: "h-7.5 border-border-base-medium border-solid border-l box-border flex items-center justify-center py-num-0 pl-3 pr-num-0"
}, P6 = { class: "relative leading-5.5 font-semibold dark:text-(--colors-text-white-secondary)" }, F6 = ["aria-label", "aria-expanded"], N6 = ["src"], V6 = {
  key: 0,
  class: "self-stretch shrink-0 flex flex-col items-center relative z-10 sidebar-scroll-indicator"
}, H6 = ["src"], j6 = {
  key: 0,
  class: "self-stretch border-border-base-soft border-solid border-b flex flex-col items-start pt-num-0 px-num-0 pb-4 shrink-0"
}, W6 = ["data-active", "aria-label", "aria-expanded", "aria-controls", "aria-current", "disabled"], q6 = ["src"], U6 = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, G6 = {
  key: 2,
  class: "relative leading-num-24 font-medium dark:text-(--colors-text-white-secondary)"
}, K6 = {
  key: 0,
  class: "flex items-center gap-1.5 text-center text-[12px] text-text-black-default dark:text-(--colors-text-white-secondary) relative z-10"
}, Y6 = { class: "relative leading-5 font-medium z-10 dark:text-(--colors-text-white-secondary)" }, J6 = ["src"], X6 = ["data-active", "aria-current", "aria-disabled", "disabled", "onClick"], Z6 = { class: "flex-1 flex items-center justify-start py-num-0 pl-num-2 pr-num-0 shrink-0 relative z-10 text-left min-w-0" }, Q6 = { class: "relative leading-num-24 font-medium text-left dark:text-(--colors-text-white-secondary)" }, _6 = { class: "self-stretch flex flex-col items-start gap-2 shrink-0 text-text-black-default dark:text-(--colors-text-white-secondary)" }, eN = {
  key: 0,
  class: "self-stretch border-t border-border-base-soft my-1 sidebar-divider",
  "aria-hidden": "true"
}, tN = {
  key: 1,
  class: "self-stretch flex flex-col items-start"
}, aN = ["data-active", "data-opened", "data-testid", "aria-label", "aria-expanded", "aria-controls", "aria-current", "aria-disabled", "disabled", "onClick"], nN = ["src"], lN = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, oN = {
  key: 2,
  class: "relative leading-num-24 font-medium dark:text-(--colors-text-white-secondary) truncate"
}, rN = ["src"], iN = ["data-active", "data-testid", "aria-current", "aria-disabled", "disabled", "onClick"], sN = { class: "flex-1 flex items-center justify-start py-num-0 pl-num-2 pr-num-0 shrink-0 relative z-10 text-left min-w-0" }, dN = { class: "relative leading-num-24 font-medium text-left dark:text-(--colors-text-white-secondary) truncate" }, uN = ["data-active", "data-testid", "aria-label", "aria-current", "aria-disabled", "disabled", "onClick"], cN = ["src"], fN = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, hN = {
  key: 2,
  class: "relative leading-num-24 font-medium z-10 dark:text-(--colors-text-white-secondary) truncate"
}, bN = {
  key: 0,
  class: "self-stretch shrink-0 flex flex-col items-center relative z-10 sidebar-scroll-indicator"
}, gN = ["src"], mN = { class: "self-stretch border-border-base-soft border-solid border-t shrink-0 pt-4 text-[12px] relative z-10" }, vN = { key: 0 }, pN = ["href"], xN = {
  key: 1,
  class: "relative leading-5 font-medium mb-1 sidebar-footer-a11y"
}, yN = { class: "relative leading-5 font-medium dark:text-(--colors-text-white-secondary)" }, kN = /* @__PURE__ */ ke({
  __name: "Sidebar",
  props: {
    companyIcon: { default: "/logo-eudonet-small.svg" },
    companyName: { default: "Eudonet" },
    items: { default: () => [] },
    modelValue: { type: Boolean, default: !0 },
    collapsed: { type: Boolean, default: void 0 },
    width: { default: "239px" },
    collapsedWidth: { default: "80px" },
    theme: { default: "light" },
    footerText: { default: "Powered by Eudonet" },
    ariaLabel: {},
    accessibilityText: { default: "" },
    accessibilityLink: { default: void 0 },
    backgroundColor: { default: void 0 },
    textColor: { default: void 0 },
    borderColor: { default: void 0 },
    accentColor: { default: void 0 },
    hoverBackgroundColor: { default: void 0 }
  },
  emits: ["update:modelValue", "update:collapsed", "item-click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = R(!1), o = R({}), r = () => {
      Object.keys(o.value).forEach((Q) => {
        o.value[Q] = !1;
      });
    };
    $e(
      () => t.collapsed,
      (Q, q) => {
        Q !== void 0 && (l.value = Q, Q ? r() : q === !0 && !Object.values(o.value).some(Boolean) && y());
      },
      { immediate: !0 }
    );
    const i = () => {
      const Q = !l.value;
      l.value = Q, n("update:collapsed", Q), Q ? r() : y();
    }, s = R(
      typeof window < "u" ? window.matchMedia("(prefers-color-scheme: dark)").matches : !1
    );
    kt(() => {
      if (typeof window > "u") return;
      const Q = window.matchMedia("(prefers-color-scheme: dark)"), q = (K) => {
        s.value = K.matches;
      };
      Q.addEventListener("change", q), zt(() => Q.removeEventListener("change", q));
    });
    const d = m(
      () => t.theme === "auto" ? s.value : t.theme === "dark"
    ), c = m(() => d.value ? "sidebar-dark" : "sidebar-light"), f = m(() => {
      const Q = {};
      return t.backgroundColor && (Q["--sidebar-bg"] = t.backgroundColor), t.textColor && (Q["--sidebar-text"] = t.textColor), t.borderColor && (Q["--sidebar-border"] = t.borderColor), t.accentColor && (Q["--sidebar-accent"] = t.accentColor), t.hoverBackgroundColor && (Q["--sidebar-hover-bg"] = t.hoverBackgroundColor), Q.width = l.value ? t.collapsedWidth : t.width, Q;
    }), g = (Q) => Q.key ?? Q.label, h = m(() => t.items.find((Q) => Q.key === "bookmarks")), v = m(
      () => h.value ? g(h.value) : "bookmarks"
    ), p = m(() => t.items.filter((Q) => Q.key !== "bookmarks")), y = () => {
      t.items.forEach((Q) => {
        var q;
        (q = Q.children) != null && q.some((K) => K.active) && (o.value[g(Q)] = !0);
      });
    };
    kt(() => {
      l.value || y();
    });
    const k = (Q) => o.value[Q] === !0, $ = (Q) => {
      const q = !o.value[Q];
      q && Object.keys(o.value).forEach((K) => {
        K !== Q && (o.value[K] = !1);
      }), o.value[Q] = q;
    }, S = R(null), I = R(!1), T = R(!1), A = () => {
      const Q = S.value;
      Q && (I.value = Q.scrollTop > 4, T.value = Q.scrollTop + Q.clientHeight < Q.scrollHeight - 4);
    }, E = () => {
      const Q = S.value;
      Q && Q.scrollBy({ top: -100, behavior: "smooth" });
    }, z = () => {
      const Q = S.value;
      Q && Q.scrollBy({ top: 100, behavior: "smooth" });
    };
    let B = null, W = null;
    kt(() => {
      setTimeout(() => {
        A();
        const Q = S.value;
        Q && (W = new ResizeObserver(() => A()), W.observe(Q), B = new MutationObserver(() => A()), B.observe(Q, { childList: !0, subtree: !0 }));
      }, 0);
    }), zt(() => {
      W == null || W.disconnect(), W = null, B == null || B.disconnect(), B = null;
    }), $e(
      o,
      () => {
        Ze(A), setTimeout(A, 100), setTimeout(A, 200), setTimeout(A, 350);
      },
      { deep: !0 }
    );
    const _ = (Q) => {
      if (Q.disabled) return;
      const q = Q.children !== void 0 && Q.children.length > 0;
      l.value ? (l.value = !1, n("update:collapsed", !1), q ? $(g(Q)) : y()) : q && $(g(Q)), Q.onClick && Q.onClick(), n("item-click", Q);
    }, Z = (Q) => {
      var q;
      return Q.active === !0 || l.value && (((q = Q.children) == null ? void 0 : q.some((K) => K.active)) ?? !1);
    }, le = Na(), D = m(() => !!le.logo), O = m(
      () => l.value ? "/logo-eudonet-small.svg" : t.companyIcon
    ), N = (Q) => {
      const q = "group self-stretch flex items-center justify-start py-num-6 pl-num-32 pr-num-8 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 relative text-left sidebar-child-item";
      return Q.disabled ? `${q} opacity-50 cursor-not-allowed` : Q.active ? `${q} rounded-[48px] overflow-visible sidebar-item-active` : `${q} rounded-num-12 sidebar-item-hover`;
    }, V = (Q) => {
      const q = "group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-simple-item";
      return Q.disabled ? `${q} opacity-50 cursor-not-allowed` : Q.active ? `${q} relative overflow-visible sidebar-item-active` : `${q} sidebar-item-hover`;
    }, M = () => 'h-5.5 w-5.5 rounded-full relative flex items-center justify-center overflow-visible before:opacity-100 after:opacity-100 before:content-[""] before:absolute before:inset-[-1px] before:rounded-full before:[background:var(--sidebar-accent)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-full after:transition-opacity after:duration-300 after:z-[1] sidebar-badge';
    return (Q, q) => e.modelValue ? (u(), b("nav", {
      key: 0,
      class: C(["h-full relative shadow-[0px_4px_4px_rgba(0,0,0,0.25)] rounded-tl-none rounded-tr-3xl rounded-b-none box-border flex flex-col items-start text-left text-[18px] font-inter transition-all duration-300 sidebar-container", [c.value, { "sidebar-collapsed": l.value }, l.value ? "p-2" : "p-5"]]),
      "data-theme": d.value ? "dark" : "light",
      "data-collapsed": l.value ? "true" : "false",
      style: Ge(f.value),
      "aria-label": e.ariaLabel ?? "Main navigation"
    }, [
      x("div", {
        class: C([
          "self-stretch border-border-base-soft border-solid border-b pt-num-0 px-num-0 relative z-[2] shrink-0",
          l.value ? "flex flex-col items-center gap-2 overflow-visible pb-2" : "flex items-center justify-between gap-5 pb-5"
        ])
      }, [
        x("div", {
          class: C(["flex items-center gap-3", [{ "justify-center": l.value }, { "flex-1": !l.value }]])
        }, [
          x("div", B6, [
            D.value ? Me(Q.$slots, "logo", {
              key: 0,
              collapsed: l.value
            }, void 0, !0) : O.value ? (u(), b("img", {
              key: 1,
              class: "h-7 w-7 relative",
              src: O.value,
              alt: "Company logo"
            }, null, 8, M6)) : w("", !0)
          ]),
          l.value ? w("", !0) : (u(), b("div", O6, [
            x("div", P6, H(e.companyName), 1)
          ]))
        ], 2),
        x("button", {
          type: "button",
          class: "sidebar-toggle-button shrink-0 h-6 w-6 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center cursor-pointer hover:border-gray-300 transition-colors duration-200",
          "aria-label": l.value ? "Expand sidebar" : "Collapse sidebar",
          "aria-expanded": !l.value,
          onClick: i
        }, [
          x("img", {
            src: l.value ? L(z6) : L(R6),
            class: "h-4 w-4 relative sidebar-toggle-icon",
            alt: "",
            "aria-hidden": "true"
          }, null, 8, N6)
        ], 8, F6)
      ], 2),
      U(Wt, { name: "fade" }, {
        default: me(() => [
          I.value ? (u(), b("div", V6, [
            x("button", {
              type: "button",
              class: "flex w-9 h-9 p-0 justify-center items-center shrink-0 rounded-full cursor-pointer bg-transparent border-none sidebar-scroll-btn",
              "aria-label": "Scroll up",
              onClick: E
            }, [
              x("img", {
                src: L($i),
                class: "h-4 w-4 sidebar-scroll-icon",
                alt: "",
                "aria-hidden": "true"
              }, null, 8, H6)
            ]),
            q[1] || (q[1] = x("div", { class: "flex h-px justify-center items-center shrink-0 self-stretch sidebar-scroll-divider" }, null, -1))
          ])) : w("", !0)
        ]),
        _: 1
      }),
      x("div", {
        ref_key: "scrollAreaRef",
        ref: S,
        class: "flex-1 min-h-0 overflow-y-auto self-stretch flex flex-col gap-4 py-4 text-num-16 dark:text-(--colors-text-white-secondary) sidebar-scroll-area relative z-[2]",
        onScroll: A
      }, [
        h.value ? (u(), b("div", j6, [
          U($t, {
            text: h.value.label,
            position: "right",
            disabled: !l.value,
            class: "self-stretch flex-col"
          }, {
            default: me(() => {
              var K;
              return [
                x("button", {
                  type: "button",
                  class: C(["group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-section-header", [
                    { "justify-center": l.value },
                    { "sidebar-item-active": Z(h.value) },
                    { "opacity-50 cursor-not-allowed": h.value.disabled }
                  ]]),
                  "data-active": Z(h.value) ? "true" : "false",
                  "aria-label": l.value ? h.value.label : void 0,
                  "aria-expanded": k(v.value),
                  "aria-controls": (K = h.value.children) != null && K.length ? "sidebar-submenu-bookmarks" : void 0,
                  "aria-current": h.value.active ? "page" : void 0,
                  disabled: h.value.disabled,
                  onClick: q[0] || (q[0] = (G) => _(h.value))
                }, [
                  x("div", {
                    class: C(["flex-1 flex items-center gap-1.5", { "justify-center": l.value }])
                  }, [
                    h.value.icon ? (u(), b("img", {
                      key: 0,
                      class: "h-5 w-5 relative shrink-0",
                      src: h.value.icon,
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, q6)) : (u(), b("div", U6)),
                    l.value ? w("", !0) : (u(), b("div", G6, H(h.value.label), 1))
                  ], 2),
                  l.value ? w("", !0) : (u(), b("div", K6, [
                    x("div", {
                      class: C(M())
                    }, [
                      x("div", Y6, H(h.value.badge ?? 0), 1)
                    ], 2),
                    x("img", {
                      class: "h-4 w-4 relative z-10 transition-transform duration-200",
                      src: k(v.value) ? L($i) : L(oo),
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, J6)
                  ]))
                ], 10, W6)
              ];
            }),
            _: 1
          }, 8, ["text", "disabled"]),
          h.value.children && h.value.children.length > 0 ? (u(), P(cr, {
            key: 0,
            id: "sidebar-submenu-bookmarks",
            name: "submenu",
            tag: "div",
            role: "region",
            "aria-label": `${h.value.label} submenu`,
            class: C([
              "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
              { "submenu-open": k(v.value) }
            ])
          }, {
            default: me(() => [
              (u(!0), b(ie, null, Oe(k(v.value) ? h.value.children : [], (K) => (u(), b("button", {
                key: g(K),
                type: "button",
                class: C(N(K)),
                "data-active": K.active ? "true" : "false",
                "aria-current": K.active ? "page" : void 0,
                "aria-disabled": K.disabled ? "true" : void 0,
                disabled: K.disabled,
                onClick: (G) => _(K)
              }, [
                x("div", Z6, [
                  x("div", Q6, H(K.label), 1)
                ])
              ], 10, X6))), 128))
            ]),
            _: 1
          }, 8, ["aria-label", "class"])) : w("", !0)
        ])) : w("", !0),
        x("div", _6, [
          (u(!0), b(ie, null, Oe(p.value, (K) => (u(), b(ie, {
            key: g(K)
          }, [
            K.divider ? (u(), b("hr", eN)) : w("", !0),
            K.children !== void 0 ? (u(), b("div", tN, [
              U($t, {
                text: K.label,
                position: "right",
                disabled: !l.value,
                class: "self-stretch flex-col"
              }, {
                default: me(() => {
                  var G;
                  return [
                    x("button", {
                      type: "button",
                      class: C(["group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-section-header", [
                        { "justify-center": l.value },
                        { "sidebar-item-active": Z(K) },
                        {
                          "sidebar-item-opened": (k(g(K)) || ((G = K.children) == null ? void 0 : G.some((te) => te.active))) && !K.active
                        },
                        { "opacity-50 cursor-not-allowed": K.disabled }
                      ]]),
                      "data-active": Z(K) ? "true" : "false",
                      "data-opened": k(g(K)) ? "true" : "false",
                      "data-testid": K.testId,
                      "aria-label": l.value ? K.label : void 0,
                      "aria-expanded": k(g(K)),
                      "aria-controls": `sidebar-submenu-${g(K)}`,
                      "aria-current": K.active ? "page" : void 0,
                      "aria-disabled": K.disabled ? "true" : void 0,
                      disabled: K.disabled,
                      onClick: (te) => _(K)
                    }, [
                      x("div", {
                        class: C(["flex-1 flex items-center gap-1.5 min-w-0", { "justify-center": l.value }])
                      }, [
                        K.icon ? (u(), b("img", {
                          key: 0,
                          class: "h-5 w-5 relative shrink-0",
                          src: K.icon,
                          alt: "",
                          "aria-hidden": "true"
                        }, null, 8, nN)) : (u(), b("div", lN)),
                        l.value ? w("", !0) : (u(), b("div", oN, H(K.label), 1))
                      ], 2),
                      !l.value && K.children.length > 0 ? (u(), b("img", {
                        key: 0,
                        class: "h-4 w-4 relative transition-transform duration-200 shrink-0",
                        src: k(g(K)) ? L($i) : L(oo),
                        alt: "",
                        "aria-hidden": "true"
                      }, null, 8, rN)) : w("", !0)
                    ], 10, aN)
                  ];
                }),
                _: 2
              }, 1032, ["text", "disabled"]),
              U(cr, {
                id: `sidebar-submenu-${g(K)}`,
                name: "submenu",
                tag: "div",
                role: "region",
                "aria-label": `${K.label} submenu`,
                class: C([
                  "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
                  { "submenu-open": k(g(K)) }
                ])
              }, {
                default: me(() => [
                  (u(!0), b(ie, null, Oe(k(g(K)) ? K.children : [], (G) => (u(), b("button", {
                    key: g(G),
                    type: "button",
                    class: C(N(G)),
                    "data-active": G.active ? "true" : "false",
                    "data-testid": G.testId,
                    "aria-current": G.active ? "page" : void 0,
                    "aria-disabled": G.disabled ? "true" : void 0,
                    disabled: G.disabled,
                    onClick: (te) => _(G)
                  }, [
                    x("div", sN, [
                      x("div", dN, H(G.label), 1)
                    ])
                  ], 10, iN))), 128))
                ]),
                _: 2
              }, 1032, ["id", "aria-label", "class"])
            ])) : (u(), P($t, {
              key: 2,
              text: K.label,
              position: "right",
              disabled: !l.value,
              class: "self-stretch flex-col"
            }, {
              default: me(() => [
                x("button", {
                  type: "button",
                  class: C([V(K), { "justify-center": l.value }]),
                  "data-active": K.active ? "true" : "false",
                  "data-testid": K.testId,
                  "aria-label": l.value ? K.label : void 0,
                  "aria-current": K.active ? "page" : void 0,
                  "aria-disabled": K.disabled ? "true" : void 0,
                  disabled: K.disabled,
                  onClick: (G) => _(K)
                }, [
                  x("div", {
                    class: C(["flex-1 flex items-center gap-1.5 relative z-10 min-w-0", { "justify-center": l.value }])
                  }, [
                    K.icon ? (u(), b("img", {
                      key: 0,
                      class: "h-5 w-5 relative z-10 shrink-0",
                      src: K.icon,
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, cN)) : (u(), b("div", fN)),
                    l.value ? w("", !0) : (u(), b("div", hN, H(K.label), 1))
                  ], 2)
                ], 10, uN)
              ]),
              _: 2
            }, 1032, ["text", "disabled"]))
          ], 64))), 128))
        ])
      ], 544),
      U(Wt, { name: "fade" }, {
        default: me(() => [
          T.value ? (u(), b("div", bN, [
            q[2] || (q[2] = x("div", { class: "flex h-px justify-center items-center shrink-0 self-stretch sidebar-scroll-divider" }, null, -1)),
            x("button", {
              type: "button",
              class: "flex w-9 h-9 p-0 justify-center items-center shrink-0 rounded-full cursor-pointer bg-transparent border-none sidebar-scroll-btn",
              "aria-label": "Scroll down",
              onClick: z
            }, [
              x("img", {
                src: L(oo),
                class: "h-4 w-4 sidebar-scroll-icon",
                alt: "",
                "aria-hidden": "true"
              }, null, 8, gN)
            ])
          ])) : w("", !0)
        ]),
        _: 1
      }),
      x("div", mN, [
        l.value ? w("", !0) : (u(), b("div", vN, [
          Me(Q.$slots, "footer", {}, () => [
            e.accessibilityText && e.accessibilityLink ? (u(), b("a", {
              key: 0,
              href: e.accessibilityLink,
              class: "block relative leading-5 font-medium mb-1 underline sidebar-footer-a11y-link"
            }, H(e.accessibilityText), 9, pN)) : e.accessibilityText ? (u(), b("div", xN, H(e.accessibilityText), 1)) : w("", !0),
            x("div", yN, H(e.footerText), 1)
          ], !0)
        ]))
      ])
    ], 14, D6)) : w("", !0);
  }
}), DG = /* @__PURE__ */ Ct(kN, [["__scopeId", "data-v-0fb03d0f"]]), wN = { class: "px-4 pt-5 pb-4" }, CN = { class: "text-lg font-semibold secondary-sidebar-title" }, SN = { class: "flex flex-col gap-8 px-4 pb-5" }, $N = { class: "text-xs font-medium uppercase tracking-wider secondary-sidebar-group-header" }, IN = {
  key: 0,
  class: "flex flex-col gap-1"
}, LN = ["aria-expanded", "aria-controls", "data-testid", "onClick"], TN = { class: "text-sm font-medium secondary-sidebar-item-text" }, EN = ["id"], AN = ["data-active", "aria-current", "data-testid", "onClick"], RN = { class: "text-sm font-medium secondary-sidebar-item-text" }, zN = ["data-active", "aria-current", "data-testid", "onClick"], DN = { class: "text-sm font-medium secondary-sidebar-item-text" }, BN = /* @__PURE__ */ ke({
  __name: "SecondarySidebar",
  props: {
    title: { default: "Settings" },
    groups: { default: () => [
      {
        label: "Profile management",
        items: [
          { label: "Profile" },
          { label: "Security information", active: !0 },
          { label: "Permissions" },
          { label: "Notification settings" }
        ]
      },
      {
        label: "Organisation management",
        items: [
          { label: "Global settings" },
          { label: "Users" },
          { label: "Security" },
          { label: "Configuration" },
          { label: "IA" },
          { label: "Billing & Plan" }
        ]
      },
      {
        label: "Module management",
        items: [{ label: "Global settings" }, { label: "Contact" }, { label: "Security" }]
      }
    ] },
    theme: { default: "light" },
    width: { default: "248px" },
    backgroundColor: { default: void 0 },
    textColor: { default: void 0 },
    borderColor: { default: void 0 },
    accentColor: { default: void 0 },
    hoverBackgroundColor: { default: void 0 },
    groupHeaderColor: { default: void 0 }
  },
  emits: ["item-click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => t.theme === "auto" ? typeof window < "u" ? window.matchMedia("(prefers-color-scheme: dark)").matches : !1 : t.theme === "dark"), o = m(() => l.value ? "secondary-sidebar-dark" : "secondary-sidebar-light"), r = m(() => {
      const S = {};
      return t.backgroundColor && (S["--secondary-sidebar-bg"] = t.backgroundColor), t.textColor && (S["--secondary-sidebar-text"] = t.textColor), t.borderColor && (S["--secondary-sidebar-border"] = t.borderColor), t.accentColor && (S["--secondary-sidebar-accent"] = t.accentColor), t.hoverBackgroundColor && (S["--secondary-sidebar-hover-bg"] = t.hoverBackgroundColor), t.groupHeaderColor && (S["--secondary-sidebar-group-header"] = t.groupHeaderColor), S.width = t.width || "248px", S;
    }), i = Ye(), s = (S, I) => `${i}-category-${S}-${I}`, d = (S) => S.testId ?? S.label, c = (S, I) => I.key ?? `${S.label}/${d(I)}`, f = (S) => S.children !== void 0, g = (S) => {
      var I;
      return (I = S.children) == null ? void 0 : I.find((T) => T.active);
    }, h = R({}), v = (S, I) => h.value[c(S, I)] ?? (g(I) !== void 0 || I.defaultExpanded === !0), p = (S, I) => {
      h.value = {
        ...h.value,
        [c(S, I)]: !v(S, I)
      };
    }, y = m(() => {
      const S = {};
      for (const I of t.groups)
        for (const T of I.items) {
          const A = f(T) ? g(T) : void 0;
          A && (S[c(I, T)] = d(A));
        }
      return S;
    });
    $e(y, (S, I) => {
      const T = Object.keys(S).filter((E) => S[E] !== I[E]);
      if (T.length === 0) return;
      const A = { ...h.value };
      for (const E of T) delete A[E];
      h.value = A;
    });
    const k = (S, I) => {
      S.onClick && S.onClick(), n("item-click", S, I);
    }, $ = (S) => {
      const I = "w-full text-left py-2 cursor-pointer transition-all duration-200 secondary-sidebar-item";
      return S.active ? `${I} secondary-sidebar-item-active` : `${I} secondary-sidebar-item-hover`;
    };
    return (S, I) => (u(), b("aside", {
      class: C(["h-full flex flex-col box-border overflow-y-auto overflow-x-hidden secondary-sidebar-container", o.value]),
      style: Ge(r.value)
    }, [
      x("div", wN, [
        x("h2", CN, H(e.title), 1)
      ]),
      x("div", SN, [
        (u(!0), b(ie, null, Oe(e.groups, (T, A) => (u(), b("div", {
          key: A,
          class: "flex flex-col gap-1"
        }, [
          x("div", $N, H(T.label), 1),
          (u(!0), b(ie, null, Oe(T.items, (E, z) => (u(), b(ie, {
            key: `${A}-${z}`
          }, [
            f(E) ? (u(), b("div", IN, [
              x("button", {
                type: "button",
                class: "w-[calc(100%+24px)] -mx-3 px-3 flex items-center justify-between gap-2 text-left py-2 rounded-lg cursor-pointer transition-colors duration-200 secondary-sidebar-item hover:bg-(--secondary-sidebar-hover-bg)",
                "aria-expanded": v(T, E) ? "true" : "false",
                "aria-controls": s(A, z),
                "data-testid": E.testId,
                onClick: (B) => p(T, E)
              }, [
                x("span", TN, H(E.label), 1),
                x("i", {
                  class: C([
                    v(T, E) ? "ri-arrow-down-s-line" : "ri-arrow-right-s-line",
                    "text-base leading-none secondary-sidebar-item-text"
                  ]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 8, LN),
              wo(x("div", {
                id: s(A, z),
                class: "flex flex-col gap-1 pl-3"
              }, [
                (u(!0), b(ie, null, Oe(E.children, (B, W) => (u(), b("button", {
                  key: `${A}-${z}-${W}`,
                  type: "button",
                  class: C($(B)),
                  "data-active": B.active ? "true" : "false",
                  "aria-current": B.active ? "page" : void 0,
                  "data-testid": B.testId,
                  onClick: (_) => k(B, T)
                }, [
                  x("span", RN, H(B.label), 1)
                ], 10, AN))), 128))
              ], 8, EN), [
                [ic, v(T, E)]
              ])
            ])) : (u(), b("button", {
              key: 1,
              type: "button",
              class: C($(E)),
              "data-active": E.active ? "true" : "false",
              "aria-current": E.active ? "page" : void 0,
              "data-testid": E.testId,
              onClick: (B) => k(E, T)
            }, [
              x("span", DN, H(E.label), 1)
            ], 10, zN))
          ], 64))), 128))
        ]))), 128))
      ])
    ], 6));
  }
}), BG = /* @__PURE__ */ Ct(BN, [["__scopeId", "data-v-4e518031"]]), MN = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "FormSaveButton",
  props: {
    enabled: { type: Boolean },
    saving: { type: Boolean },
    saveLabel: {},
    savingLabel: {},
    disabledHint: {}
  },
  emits: ["save"],
  setup(e, { expose: a }) {
    const t = R(null);
    return a({ buttonElement: m(() => {
      var n;
      return ((n = t.value) == null ? void 0 : n.$el) ?? null;
    }) }), (n, l) => (u(), P($t, {
      text: e.disabledHint ?? "",
      disabled: e.enabled || e.saving || !e.disabledHint
    }, {
      default: me(() => [
        U(Be, Ve({
          ref_key: "buttonRef",
          ref: t
        }, n.$attrs, {
          variant: "primary",
          "icon-left": "ri-save-line",
          label: e.saveLabel,
          "aria-disabled": !e.enabled,
          loading: e.saving,
          "loading-label": e.savingLabel,
          onClick: l[0] || (l[0] = (o) => n.$emit("save"))
        }), null, 16, ["label", "aria-disabled", "loading", "loading-label"])
      ]),
      _: 1
    }, 8, ["text", "disabled"]));
  }
}), ON = {
  class: "flex",
  "data-testid": "nav-header-badges"
}, Ii = /* @__PURE__ */ ke({
  __name: "NavHeaderBadges",
  props: {
    badges: {}
  },
  setup(e) {
    return (a, t) => (u(), b("div", ON, [
      (u(!0), b(ie, null, Oe(e.badges, (n, l) => (u(), b(ie, { key: l }, [
        L(Ts)(n) ? (u(), P(Ls, {
          key: 0,
          label: n.label,
          "hidden-labels": n.hiddenLabels
        }, null, 8, ["label", "hidden-labels"])) : (u(), P(yt, {
          key: 1,
          label: n.label,
          theme: n.theme ?? "neutral",
          size: "sm",
          "left-icon": n.icon,
          "show-left-icon": !!n.icon,
          truncate: n.truncate ?? !0,
          "show-close-icon": !1
        }, null, 8, ["label", "theme", "left-icon", "show-left-icon", "truncate"]))
      ], 64))), 128))
    ]));
  }
}), PN = { class: "box-border flex w-full flex-col justify-center border-b border-solid border-(--colors-border-base-medium) px-5 pt-3 pb-[calc(--spacing(3)-1px)]" }, FN = {
  key: 0,
  class: "flex min-w-0 flex-wrap items-center gap-x-5 gap-y-2 self-stretch",
  "data-testid": "navbar-editor"
}, NN = {
  class: "flex min-w-0 grow basis-48 items-center gap-5",
  "data-testid": "navbar-left"
}, VN = {
  class: "flex min-w-0 items-center",
  "data-testid": "navbar-title"
}, HN = {
  key: 0,
  class: "ml-auto flex max-w-full min-w-0 flex-wrap items-center justify-end gap-2",
  "data-testid": "navbar-actions"
}, jN = {
  key: 0,
  class: "flex min-w-0 items-center gap-1 px-px text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--colors-text-white-default)",
  "data-testid": "navbar-status"
}, WN = {
  key: 1,
  class: "flex min-w-0 flex-wrap items-center justify-between gap-x-8 gap-y-2 self-stretch"
}, qN = {
  class: "flex min-w-0 grow basis-48 items-center gap-4",
  "data-testid": "navbar-left"
}, UN = {
  class: "ml-auto flex max-w-full shrink-0 flex-wrap items-center justify-end gap-2",
  "data-testid": "navbar-right"
}, MG = /* @__PURE__ */ ke({
  __name: "Navbar",
  props: {
    type: { default: "default" },
    backLabel: { default: void 0 },
    title: { default: "" },
    editableTitle: { type: Boolean, default: !0 },
    titleError: { default: void 0 },
    editTitleLabel: { default: "" },
    saveTitleLabel: { default: "" },
    editorBadges: { default: () => [] },
    editorStatus: { default: void 0 },
    editorActions: { default: () => [] },
    searchPlaceholder: { default: "" },
    searchLabel: { default: void 0 },
    searchControls: { default: void 0 },
    searchExpanded: { type: Boolean, default: !1 },
    searchActivedescendant: { default: void 0 },
    searchClearLabel: { default: void 0 },
    searchIcon: { default: void 0 },
    filterIcon: { default: void 0 },
    filterLabel: { default: void 0 },
    actions: { default: () => [] },
    avatar: { default: void 0 },
    searchWidth: { default: "453px" },
    searchSize: { default: "sm" },
    searchValue: { default: "" },
    searchDisabled: { type: Boolean, default: !1 },
    avatarDropdownItems: { default: void 0 },
    avatarDropdownWidth: { default: "288px" },
    avatarDropdownAriaLabel: { default: void 0 }
  },
  emits: ["action-click", "editor-action-click", "back", "update:title", "update:searchValue", "search-click", "search-keydown", "search-blur", "filter-click"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = R(null);
    a({
      /** The `<button>` of the `form-save` editor action, or null when there is none */
      buttonElement: m(() => {
        var v, p;
        return ((p = (v = o.value) == null ? void 0 : v[0]) == null ? void 0 : p.buttonElement) ?? null;
      })
    });
    const r = R(n.searchValue || "");
    $e(
      () => n.searchValue,
      (v) => {
        r.value = v || "";
      }
    ), $e(r, (v) => {
      l("update:searchValue", v);
    });
    let i = !1;
    const s = (v) => v.target instanceof HTMLInputElement, d = (v) => {
      s(v) && (i = document.activeElement === v.target);
    }, c = (v) => {
      const p = v.relatedTarget;
      v.currentTarget.contains(p) || s(v) && l("search-click");
    }, f = (v) => {
      i = !1, v.currentTarget.contains(v.relatedTarget) || l("search-blur");
    }, g = (v) => {
      s(v) && i && l("search-click");
    }, h = (v, p) => {
      v.onClick && v.onClick(), l("action-click", v, p);
    };
    return (v, p) => (u(), b("header", PN, [
      e.type === "editor" ? (u(), b("div", FN, [
        U(L(Be), {
          variant: "ghost",
          size: "md",
          "icon-left": "ri-arrow-left-line",
          label: e.backLabel,
          "data-testid": "navbar-back",
          onClick: p[0] || (p[0] = (y) => l("back"))
        }, null, 8, ["label"]),
        p[5] || (p[5] = x("span", {
          class: "h-8 w-px shrink-0 bg-(--colors-border-base-medium)",
          "aria-hidden": "true",
          "data-testid": "navbar-divider"
        }, null, -1)),
        x("div", NN, [
          x("div", VN, [
            U(mf, {
              "model-value": e.title,
              editable: e.editableTitle,
              error: e.titleError,
              "edit-label": e.editTitleLabel,
              "save-label": e.saveTitleLabel,
              "max-width": "100%",
              onSave: p[1] || (p[1] = (y) => l("update:title", y))
            }, null, 8, ["model-value", "editable", "error", "edit-label", "save-label"])
          ]),
          e.editorBadges.length ? (u(), P(Ii, {
            key: 0,
            badges: e.editorBadges,
            class: "shrink-0 items-start gap-1.5",
            "data-testid": "navbar-badges"
          }, null, 8, ["badges"])) : w("", !0)
        ]),
        e.editorStatus || e.editorActions.length ? (u(), b("div", HN, [
          e.editorStatus ? (u(), b("div", jN, [
            e.editorStatus.icon ? (u(), b("i", {
              key: 0,
              class: C([e.editorStatus.icon, "shrink-0 text-(length:--icon-size-xs) leading-(--icon-size-xs) text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"]),
              "aria-hidden": "true"
            }, null, 2)) : w("", !0),
            U(it, {
              text: e.editorStatus.label,
              class: "min-w-0",
              "data-testid": "navbar-status-text"
            }, null, 8, ["text"])
          ])) : w("", !0),
          (u(!0), b(ie, null, Oe(e.editorActions, (y, k) => (u(), b(ie, { key: k }, [
            y.kind === "form-save" ? (u(), P(MN, {
              key: 0,
              ref_for: !0,
              ref_key: "saveButtonRef",
              ref: o,
              enabled: y.enabled,
              saving: y.saving,
              "save-label": y.label,
              "saving-label": y.savingLabel,
              "disabled-hint": y.disabledHint,
              class: "shrink-0",
              "data-testid": "navbar-save",
              onSave: ($) => l("editor-action-click", y, k)
            }, null, 8, ["enabled", "saving", "save-label", "saving-label", "disabled-hint", "onSave"])) : (u(), P(L(Be), {
              key: 1,
              variant: y.variant,
              size: "md",
              "icon-left": y.icon,
              label: y.label,
              disabled: y.disabled,
              class: "shrink-0",
              onClick: ($) => l("editor-action-click", y, k)
            }, null, 8, ["variant", "icon-left", "label", "disabled", "onClick"]))
          ], 64))), 128))
        ])) : w("", !0)
      ])) : (u(), b("div", WN, [
        x("div", qN, [
          x("div", {
            role: "search",
            class: "min-w-0 flex-1",
            style: Ge({ maxWidth: e.searchWidth }),
            "data-testid": "navbar-search",
            onMousedown: d,
            onFocusin: c,
            onFocusout: f,
            onClick: g
          }, [
            U(zs, {
              modelValue: r.value,
              "onUpdate:modelValue": p[2] || (p[2] = (y) => r.value = y),
              placeholder: e.searchPlaceholder,
              "aria-label": e.searchLabel,
              "aria-controls": e.searchControls,
              "aria-expanded": e.searchExpanded,
              "aria-activedescendant": e.searchActivedescendant,
              labels: { clear: e.searchClearLabel },
              "icon-left": e.searchIcon,
              size: e.searchSize,
              disabled: e.searchDisabled,
              rounded: "full",
              onKeydown: p[3] || (p[3] = (y) => l("search-keydown", y))
            }, null, 8, ["modelValue", "placeholder", "aria-label", "aria-controls", "aria-expanded", "aria-activedescendant", "labels", "icon-left", "size", "disabled"])
          ], 36),
          e.filterIcon ? (u(), P(L(Be), {
            key: 0,
            variant: "primary",
            "icon-left": e.filterIcon,
            "icon-only": "",
            size: "xs",
            "aria-label": e.filterLabel,
            "data-testid": "navbar-filter",
            onClick: p[4] || (p[4] = () => v.$emit("filter-click"))
          }, null, 8, ["icon-left", "aria-label"])) : w("", !0)
        ]),
        x("div", UN, [
          (u(!0), b(ie, null, Oe(e.actions, (y, k) => (u(), b(ie, { key: k }, [
            y.icon ? (u(), P(L(Be), {
              key: 0,
              variant: "secondary",
              "icon-left": y.icon,
              "icon-only": "",
              size: "xs",
              "aria-label": y.label || y.alt,
              onClick: ($) => h(y, k)
            }, null, 8, ["icon-left", "aria-label", "onClick"])) : w("", !0)
          ], 64))), 128)),
          e.avatar && !e.avatarDropdownItems ? (u(), P(Jt, {
            key: 0,
            name: e.avatar.name,
            img: e.avatar.img
          }, null, 8, ["name", "img"])) : w("", !0),
          e.avatar && e.avatarDropdownItems ? (u(), P(Ra, {
            key: 1,
            avatar: e.avatar,
            items: e.avatarDropdownItems,
            "menu-align": "right",
            "menu-width": e.avatarDropdownWidth,
            "aria-label": e.avatarDropdownAriaLabel
          }, null, 8, ["avatar", "items", "menu-width", "aria-label"])) : w("", !0)
        ])
      ]))
    ]));
  }
}), GN = {
  "data-testid": "segmented-pager",
  role: "group",
  class: "inline-flex items-center shadow-(--blur-shadow-xs)"
}, KN = /* @__PURE__ */ ke({
  __name: "SegmentedPager",
  props: {
    prevLabel: {},
    nextLabel: {},
    prevDisabled: { type: Boolean, default: !1 },
    nextDisabled: { type: Boolean, default: !1 }
  },
  emits: ["prev", "next"],
  setup(e, { emit: a }) {
    const t = a;
    return (n, l) => (u(), b("div", GN, [
      U(Be, {
        variant: "secondary",
        size: "md",
        "icon-left": "ri-arrow-left-s-line",
        label: e.prevLabel,
        disabled: e.prevDisabled,
        "data-testid": "segmented-pager-prev",
        class: C(L(Rx)),
        onClick: l[0] || (l[0] = (o) => t("prev"))
      }, null, 8, ["label", "disabled", "class"]),
      U(Be, {
        variant: "secondary",
        size: "md",
        "icon-right": "ri-arrow-right-s-line",
        label: e.nextLabel,
        disabled: e.nextDisabled,
        "data-testid": "segmented-pager-next",
        class: C(L(zx)),
        onClick: l[1] || (l[1] = (o) => t("next"))
      }, null, 8, ["label", "disabled", "class"])
    ]));
  }
}), YN = {
  class: "nav-header-title flex min-w-0 text-(length:--size-5xl) leading-(--line-height-5xl) font-(--weight-bold) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "nav-header-title"
}, JN = /* @__PURE__ */ ke({
  __name: "NavHeaderTitle",
  props: {
    title: {},
    placeholder: {},
    editable: {}
  },
  emits: ["save"],
  setup(e, { emit: a }) {
    const t = e, n = m(() => t.title.trim() ? t.title : t.placeholder ?? ""), l = a;
    return (o, r) => (u(), b("h1", YN, [
      e.editable ? (u(), P(mf, {
        key: 0,
        "model-value": e.title,
        "empty-text": e.placeholder,
        placeholder: e.placeholder,
        "edit-label": e.editable.editLabel,
        "save-label": e.editable.saveLabel,
        size: "lg",
        "max-width": "100%",
        onSave: r[0] || (r[0] = (i) => l("save", i))
      }, null, 8, ["model-value", "empty-text", "placeholder", "edit-label", "save-label"])) : (u(), P(it, {
        key: 1,
        text: n.value,
        position: "bottom"
      }, null, 8, ["text"]))
    ]));
  }
}), XN = /* @__PURE__ */ Ct(JN, [["__scopeId", "data-v-615995d8"]]), ZN = {
  ref: "root",
  class: "flex min-w-0 flex-col",
  "data-testid": "nav-header"
}, QN = {
  key: 0,
  class: "flex",
  "data-testid": "nav-header-back-row"
}, _N = {
  key: 0,
  class: "flex min-w-0 items-start gap-2"
}, eV = {
  key: 0,
  class: "min-w-0 text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "nav-header-description"
}, tV = {
  key: 2,
  class: "min-w-0 text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "nav-header-description"
}, aV = {
  key: 2,
  class: "flex shrink-0 items-center gap-1.5",
  "data-testid": "nav-header-icon-actions"
}, OG = /* @__PURE__ */ ke({
  __name: "NavHeader",
  props: {
    type: {},
    title: {},
    titlePlaceholder: { default: "" },
    back: { default: void 0 },
    description: { default: void 0 },
    badges: { default: () => [] },
    maxBadges: { default: 3 },
    avatar: { default: void 0 },
    primaryAction: { default: void 0 },
    secondaryAction: { default: void 0 },
    iconActions: { default: () => [] },
    pagination: { default: void 0 },
    editableTitle: { default: void 0 }
  },
  emits: ["back", "primary-action", "primary-action-select", "secondary-action", "icon-action", "prev", "next", "title-save", "avatar-edit"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = hn("root");
    a({
      /**
       * Focuses the button of `iconActions[index]` (the trigger, for an action with a menu). For a host
       * returning focus after the menu item it opened closed: the item is unmounted with the menu, so
       * the overlay's own focus restore has nothing to land on.
       */
      focusIconAction(S) {
        var T, A;
        const I = (T = o.value) == null ? void 0 : T.querySelectorAll(
          '[data-testid="nav-header-icon-action"]'
        );
        (A = I == null ? void 0 : I[S]) == null || A.focus();
      }
    });
    const r = m(() => n.type === "wizard"), i = m(() => n.type === "table"), s = m(() => n.type === "record"), d = m(() => n.type === "settings");
    function c(S) {
      var I;
      if ((I = n.back) != null && I.href) {
        if (S.ctrlKey || S.metaKey || S.shiftKey || S.altKey || S.button !== 0) return;
        S.preventDefault();
      }
      l("back");
    }
    const f = m(() => !!n.back && !i.value), g = m(() => {
      var S;
      return !!((S = n.description) != null && S.trim()) && !s.value;
    }), h = m(
      () => s.value ? Es(n.badges, n.maxBadges) : n.badges
    ), v = m(() => !!n.secondaryAction && !r.value), p = m(() => n.iconActions.length > 0 && (i.value || s.value)), y = m(() => r.value ? "md" : "lg"), k = {
      wizard: "min-h-18 gap-x-4 gap-y-3",
      table: "items-start gap-x-4 gap-y-3 px-0.5 py-3",
      record: "items-start justify-between gap-x-4 gap-y-3 py-1",
      settings: "items-center gap-y-3"
    }, $ = {
      wizard: "items-end",
      table: "items-center self-stretch",
      record: "items-center self-stretch",
      settings: "items-center"
    };
    return (S, I) => (u(), b("div", ZN, [
      s.value && e.back ? (u(), b("div", QN, [
        U(Be, {
          variant: "text",
          size: "sm",
          "icon-left": "ri-arrow-left-line",
          label: e.back.label,
          as: e.back.href ? "a" : "button",
          href: e.back.href,
          "data-testid": "nav-header-back",
          onClick: c
        }, null, 8, ["label", "as", "href"])
      ])) : w("", !0),
      x("div", {
        class: C(["flex min-w-0 flex-wrap", k[e.type]]),
        "data-testid": "nav-header-row"
      }, [
        x("div", {
          class: C(["flex min-w-0 grow basis-64", {
            "flex-col items-start": r.value || d.value,
            "min-h-10 flex-col justify-center gap-1": i.value,
            "items-center gap-2": s.value
          }]),
          "data-testid": "nav-header-left"
        }, [
          f.value && !s.value ? (u(), P(Be, {
            key: 0,
            variant: "text",
            size: "sm",
            "icon-left": "ri-arrow-left-line",
            label: e.back.label,
            as: e.back.href ? "a" : "button",
            href: e.back.href,
            "data-testid": "nav-header-back",
            onClick: c
          }, null, 8, ["label", "as", "href"])) : w("", !0),
          s.value && e.avatar ? (u(), P($t, {
            key: 1,
            text: e.avatar.editDisabledReason ?? "",
            disabled: !e.avatar.editLabel || !e.avatar.editDisabledReason
          }, {
            default: me(() => [
              U(Jt, {
                name: e.avatar.name,
                img: e.avatar.img,
                entity: e.avatar.entity,
                "avatar-style": e.avatar.avatarStyle ?? "square",
                size: "xl",
                presentational: !e.avatar.editLabel,
                editable: !!e.avatar.editLabel,
                "edit-label": e.avatar.editLabel,
                "edit-disabled": !!e.avatar.editDisabledReason,
                "data-testid": "nav-header-avatar",
                onEdit: I[0] || (I[0] = (T) => l("avatar-edit"))
              }, null, 8, ["name", "img", "entity", "avatar-style", "presentational", "editable", "edit-label", "edit-disabled"])
            ]),
            _: 1
          }, 8, ["text", "disabled"])) : w("", !0),
          x("div", {
            class: C(["flex max-w-full min-w-0", {
              "flex-col": r.value,
              "flex-col gap-1": i.value || s.value,
              "flex-col gap-2 py-1": d.value
            }]),
            "data-testid": "nav-header-heading"
          }, [
            x("div", {
              class: C(["flex min-w-0 items-center", { "gap-4": r.value, "gap-2": d.value }])
            }, [
              U(XN, {
                title: e.title,
                placeholder: e.titlePlaceholder || void 0,
                editable: e.editableTitle,
                onSave: I[1] || (I[1] = (T) => l("title-save", T))
              }, null, 8, ["title", "placeholder", "editable"]),
              (r.value || d.value) && h.value.length ? (u(), P(Ii, {
                key: 0,
                badges: h.value,
                class: "shrink-0 items-center gap-2"
              }, null, 8, ["badges"])) : w("", !0)
            ], 2),
            i.value && (g.value || h.value.length) ? (u(), b("div", _N, [
              g.value ? (u(), b("p", eV, H(e.description), 1)) : w("", !0),
              h.value.length ? (u(), P(Ii, {
                key: 1,
                badges: h.value,
                class: "shrink-0 items-center gap-2"
              }, null, 8, ["badges"])) : w("", !0)
            ])) : w("", !0),
            s.value ? (u(), P(Ii, {
              key: 1,
              badges: h.value,
              class: "min-h-6 flex-wrap gap-1.5"
            }, null, 8, ["badges"])) : w("", !0),
            (r.value || d.value) && g.value ? (u(), b("p", tV, H(e.description), 1)) : w("", !0)
          ], 2)
        ], 2),
        e.primaryAction || v.value || p.value || r.value && e.pagination ? (u(), b("div", {
          key: 0,
          class: C(["ml-auto flex max-w-full min-w-0 flex-none flex-wrap justify-end gap-x-4 gap-y-3", $[e.type]]),
          "data-testid": "nav-header-right"
        }, [
          e.primaryAction ? (u(), b(ie, { key: 0 }, [
            e.primaryAction.menu ? (u(), P(JF, {
              key: 0,
              variant: "primary",
              size: y.value,
              label: e.primaryAction.label,
              icon: e.primaryAction.icon,
              menu: e.primaryAction.menu,
              "menu-label": e.primaryAction.menuLabel,
              disabled: e.primaryAction.disabled,
              "aria-disabled": e.primaryAction.ariaDisabled,
              loading: e.primaryAction.loading,
              "loading-label": e.primaryAction.loadingLabel,
              "data-testid": "nav-header-primary",
              onClick: I[2] || (I[2] = (T) => l("primary-action", T)),
              onSelect: I[3] || (I[3] = (T) => l("primary-action-select", T))
            }, null, 8, ["size", "label", "icon", "menu", "menu-label", "disabled", "aria-disabled", "loading", "loading-label"])) : (u(), P(Be, {
              key: 1,
              variant: "primary",
              size: y.value,
              label: e.primaryAction.label,
              "icon-left": e.primaryAction.icon,
              disabled: e.primaryAction.disabled,
              "aria-disabled": e.primaryAction.ariaDisabled,
              loading: e.primaryAction.loading,
              "loading-label": e.primaryAction.loadingLabel,
              "data-testid": "nav-header-primary",
              onClick: I[4] || (I[4] = (T) => l("primary-action", T))
            }, null, 8, ["size", "label", "icon-left", "disabled", "aria-disabled", "loading", "loading-label"]))
          ], 64)) : w("", !0),
          v.value ? (u(), b(ie, { key: 1 }, [
            e.secondaryAction.menu ? (u(), P(Ra, {
              key: 0,
              items: e.secondaryAction.menu,
              "menu-align": "right"
            }, {
              trigger: me(({ triggerProps: T }) => [
                U(Be, Ve(T, {
                  variant: "secondary",
                  size: "lg",
                  label: e.secondaryAction.label,
                  "icon-left": e.secondaryAction.icon,
                  "dropdown-icon": "",
                  disabled: e.secondaryAction.disabled,
                  "aria-disabled": e.secondaryAction.ariaDisabled,
                  "data-testid": "nav-header-secondary"
                }), null, 16, ["label", "icon-left", "disabled", "aria-disabled"])
              ]),
              _: 1
            }, 8, ["items"])) : (u(), P(Be, {
              key: 1,
              variant: "secondary",
              size: "lg",
              label: e.secondaryAction.label,
              "icon-left": e.secondaryAction.icon,
              disabled: e.secondaryAction.disabled,
              "aria-disabled": e.secondaryAction.ariaDisabled,
              "data-testid": "nav-header-secondary",
              onClick: I[5] || (I[5] = (T) => l("secondary-action", T))
            }, null, 8, ["label", "icon-left", "disabled", "aria-disabled"]))
          ], 64)) : w("", !0),
          p.value ? (u(), b("div", aV, [
            (u(!0), b(ie, null, Oe(e.iconActions, (T, A) => (u(), b(ie, { key: A }, [
              T.menu ? (u(), P(Ra, {
                key: 0,
                items: T.menu,
                "menu-align": "right"
              }, {
                trigger: me(({ triggerProps: E }) => [
                  U(Be, Ve({ ref_for: !0 }, E, {
                    variant: "secondary",
                    size: "lg",
                    "icon-only": "",
                    "icon-left": T.icon,
                    "aria-label": T.label,
                    disabled: T.disabled,
                    "aria-disabled": T.ariaDisabled,
                    "data-testid": "nav-header-icon-action"
                  }), null, 16, ["icon-left", "aria-label", "disabled", "aria-disabled"])
                ]),
                _: 2
              }, 1032, ["items"])) : (u(), P(Be, {
                key: 1,
                variant: "secondary",
                size: "lg",
                "icon-only": "",
                "icon-left": T.icon,
                "aria-label": T.label,
                disabled: T.disabled,
                "aria-disabled": T.ariaDisabled,
                "data-testid": "nav-header-icon-action",
                onClick: (E) => l("icon-action", T, A)
              }, null, 8, ["icon-left", "aria-label", "disabled", "aria-disabled", "onClick"]))
            ], 64))), 128))
          ])) : w("", !0),
          r.value && e.pagination ? (u(), P(KN, {
            key: 3,
            "prev-label": e.pagination.prevLabel,
            "next-label": e.pagination.nextLabel,
            "prev-disabled": e.pagination.prevDisabled,
            "next-disabled": e.pagination.nextDisabled,
            "data-testid": "nav-header-pagination",
            onPrev: I[6] || (I[6] = (T) => l("prev")),
            onNext: I[7] || (I[7] = (T) => l("next"))
          }, null, 8, ["prev-label", "next-label", "prev-disabled", "next-disabled"])) : w("", !0)
        ], 2)) : w("", !0)
      ], 2)
    ], 512));
  }
}), nV = /* @__PURE__ */ ke({
  __name: "SpeedDial",
  props: {
    primaryIcon: {},
    primaryIconAlt: { default: "" },
    items: {},
    size: { default: "md" },
    orientation: { default: "vertical" },
    direction: { default: "top" },
    open: { type: Boolean, default: !1 }
  },
  emits: ["update:open", "item-click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = R(t.open);
    $e(
      () => t.open,
      (h) => {
        l.value = h;
      }
    );
    const o = (h) => {
      l.value = h, n("update:open", h);
    }, r = () => {
      o(!l.value);
    }, i = (h, v) => {
      h.onClick && h.onClick(v), n("item-click", h, v);
    }, s = m(() => {
      const h = "relative w-full flex p-2.5 box-border gap-2";
      return t.orientation === "horizontal" ? t.direction === "left" ? `${h} flex-row items-center` : `${h} flex-row-reverse items-center` : t.direction === "top" ? `${h} flex-col-reverse items-end` : `${h} flex-col items-end`;
    }), d = m(() => ({
      position: "relative"
    })), c = m(() => {
      const h = "flex items-center";
      return t.orientation === "horizontal" ? `${h} flex-row` : `${h} flex-col`;
    }), f = m(() => (t.orientation === "horizontal", "gap-2")), g = m(() => t.direction);
    return (h, v) => (u(), b("div", {
      class: C([s.value, "speed-dial-container"])
    }, [
      U(cr, {
        name: `speed-dial-${g.value}`,
        tag: "div",
        class: C([[c.value, f.value], "relative"]),
        style: Ge(d.value)
      }, {
        default: me(() => [
          (u(!0), b(ie, null, Oe(l.value ? e.items : [], (p, y) => (u(), P(L(Be), {
            key: `speed-dial-item-${y}`,
            variant: "secondary",
            "icon-left": p.icon,
            "icon-only": "",
            "aria-label": p.iconAlt,
            size: e.size,
            style: Ge({
              "--index": y
            }),
            class: "relative",
            onClick: (k) => i(p, k)
          }, null, 8, ["icon-left", "aria-label", "size", "style", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["name", "class", "style"]),
      U(L(Be), {
        variant: "primary",
        "icon-left": e.primaryIcon,
        "icon-only": "",
        "aria-label": e.primaryIconAlt,
        size: e.size,
        class: "relative z-20 speed-dial-primary-button",
        onClick: r
      }, null, 8, ["icon-left", "aria-label", "size"])
    ], 2));
  }
}), PG = /* @__PURE__ */ Ct(nV, [["__scopeId", "data-v-0eb94464"]]);
function lV(e) {
  return !!e.duration && e.status !== "error" && !e.link && !e.primaryAction && !e.secondaryAction;
}
function Fx(e) {
  return (e.layout ?? "default") === "default" && (e.status === "error" || e.status === "warning");
}
function oV(e) {
  const a = e.layout === "withHeader" && e.avatar ? `${e.avatar.name} ${e.message}` : e.message;
  return [e.title, a].filter(Boolean).join(". ");
}
const rV = 3, sn = R([]), dr = /* @__PURE__ */ new Map(), No = /* @__PURE__ */ new Set();
let eg = !1;
function tg(e) {
  const a = dr.get(e);
  a != null && a.handle && clearTimeout(a.handle), dr.delete(e);
}
function iV() {
  function e(i, s) {
    s.startedAt = Date.now(), s.handle = setTimeout(() => r(i), s.remaining);
  }
  function a(i) {
    if (!lV(i)) return;
    const s = /* @__PURE__ */ new Set();
    eg && s.add("window"), No.has(i.id) && s.add("pointer");
    const d = { remaining: i.duration, startedAt: 0, pausedBy: s };
    dr.set(i.id, d), s.size || e(i.id, d);
  }
  function t(i) {
    const s = (f) => (f.layout ?? "default") === "default", d = s(i) ? sn.value.findIndex(
      (f) => s(f) && f.status === i.status && f.title === i.title && f.message === i.message
    ) : -1;
    if (d >= 0) {
      const f = { ariaClose: "Close", ...i, id: sn.value[d].id };
      return tg(f.id), sn.value[d] = f, a(f), f.id;
    }
    const c = {
      id: crypto.randomUUID(),
      ariaClose: "Close",
      ...i
    };
    if (sn.value.length >= rV) {
      const f = sn.value.find(
        (g) => g.status !== "error" && !g.link && !g.primaryAction && !g.secondaryAction && !No.has(g.id)
      );
      f && r(f.id);
    }
    return sn.value.push(c), a(c), c.id;
  }
  function n(i, s = "pointer") {
    s === "pointer" && No.add(i);
    const d = dr.get(i);
    d && (d.pausedBy.add(s), d.handle && (clearTimeout(d.handle), d.handle = void 0, d.remaining = Math.max(0, d.remaining - (Date.now() - d.startedAt))));
  }
  function l(i, s = "pointer") {
    s === "pointer" && No.delete(i);
    const d = dr.get(i);
    d && (d.pausedBy.delete(s), !(d.handle || d.pausedBy.size) && e(i, d));
  }
  function o(i) {
    eg = i, sn.value.forEach(
      (s) => i ? n(s.id, "window") : l(s.id, "window")
    );
  }
  function r(i) {
    tg(i), No.delete(i), sn.value = sn.value.filter((s) => s.id !== i);
  }
  return {
    toasts: sn,
    showToast: t,
    removeToast: r,
    pauseToast: n,
    resumeToast: l,
    setWindowBlurred: o
  };
}
const Gd = /* @__PURE__ */ ke({
  __name: "ToastActions",
  props: {
    primary: {},
    secondary: {}
  },
  emits: ["run"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => {
      const o = [];
      return t.primary && o.push({ action: t.primary, variant: "primary" }), t.secondary && o.push({ action: t.secondary, variant: "secondary" }), o;
    });
    return (o, r) => l.value.length ? (u(), b("div", {
      key: 0,
      "data-testid": "toast-actions",
      class: C(["grid items-center gap-3", l.value.length > 1 ? "grid-cols-2" : "grid-cols-1"])
    }, [
      (u(!0), b(ie, null, Oe(l.value, ({ action: i, variant: s }) => (u(), P(L(Be), {
        key: s,
        variant: s,
        size: "xs",
        "full-width": "",
        label: i.label,
        "icon-left": i.icon,
        onClick: (d) => n("run", i.onClick)
      }, null, 8, ["variant", "label", "icon-left", "onClick"]))), 128))
    ], 2)) : w("", !0);
  }
}), sV = ["role", "aria-atomic"], dV = { class: "flex min-w-0 flex-1 flex-col gap-1" }, uV = { class: "flex flex-col gap-px" }, cV = {
  key: 0,
  "data-testid": "toast-name",
  class: "text-(length:--size-l) leading-(--line-height-l-tight) font-(--weight-semi-bold)"
}, fV = {
  "data-testid": "toast-message",
  class: "text-(length:--size-m) leading-(--line-height-l)"
}, hV = {
  key: 0,
  "data-testid": "toast-time",
  class: "text-(length:--size-sm) leading-(--line-height-xs)"
}, bV = {
  key: 1,
  "data-testid": "toast-content",
  class: "flex items-start gap-3"
}, gV = { class: "flex min-w-0 flex-1 flex-col gap-3.5" }, mV = {
  key: 0,
  "data-testid": "toast-title",
  class: "text-(length:--size-l) font-(--weight-bold)"
}, vV = { "data-testid": "toast-message" }, pV = {
  key: 2,
  "data-testid": "toast-message-group",
  class: "flex min-w-0 flex-1 items-start gap-3"
}, xV = {
  "data-testid": "toast-icon",
  class: "inline-flex shrink-0 items-center justify-center",
  "aria-hidden": "true"
}, yV = { class: "flex min-w-0 flex-1 flex-col gap-1 text-(length:--size-m) leading-(--line-height-m)" }, kV = {
  key: 0,
  "data-testid": "toast-title",
  class: "text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)"
}, wV = /* @__PURE__ */ ke({
  __name: "ToastItem",
  props: {
    toast: {}
  },
  emits: ["close", "pause", "resume"],
  setup(e, { emit: a }) {
    const t = e, n = a;
    let l = !1, o = !1;
    function r($, S) {
      const I = l || o;
      l = $, o = S;
      const T = l || o;
      T && !I && n("pause"), !T && I && n("resume");
    }
    function i($) {
      $.currentTarget.contains($.relatedTarget) || r(l, !1);
    }
    function s($) {
      $.key === "Escape" && ($.stopPropagation(), $.preventDefault(), n("close"));
    }
    const d = m(() => t.toast.layout ?? "default"), c = m(() => Fx(t.toast) ? "alert" : void 0), f = {
      default: "items-center justify-between gap-3 p-4",
      withHeader: "flex-col gap-4 p-[calc(--spacing(4)-1px)]",
      iconShape: "flex-col p-[calc(--spacing(4)-1px)]"
    }, g = {
      success: {
        color: "text-(--icons-icon-success)",
        leading: "leading-(--line-height-l)",
        icon: "ri-checkbox-circle-fill"
      },
      info: {
        color: "text-(--icons-icon-info)",
        leading: "leading-(--line-height-l)",
        icon: "ri-information-fill"
      },
      warning: {
        color: "text-(--icons-icon-warning)",
        leading: "leading-(--line-height-m)",
        icon: "ri-alert-fill"
      },
      error: {
        color: "text-(--icons-icon-error)",
        leading: "leading-(--line-height-l)",
        icon: "ri-error-warning-fill"
      }
    }, h = m(() => g[t.toast.status]), v = m(
      () => d.value !== "withHeader" || !t.toast.primaryAction && !t.toast.secondaryAction
    ), p = m(() => v.value && d.value !== "default" ? "pe-6" : "");
    function y($) {
      try {
        $ == null || $();
      } finally {
        n("close");
      }
    }
    function k() {
      var $;
      ($ = t.toast.link) != null && $.onClick && y(t.toast.link.onClick);
    }
    return ($, S) => (u(), b("div", {
      class: C(["relative flex w-full overflow-hidden rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-medium) bg-(--background-background-black-default) text-(--text-text-white-default) shadow-(--blur-shadow-toast)", f[d.value]]),
      "data-testid": "toast",
      role: c.value,
      "aria-atomic": c.value ? "true" : void 0,
      onMouseenter: S[1] || (S[1] = (I) => r(!0, L(o))),
      onMouseleave: S[2] || (S[2] = (I) => r(!1, L(o))),
      onFocusin: S[3] || (S[3] = (I) => r(L(l), !0)),
      onFocusout: i,
      onKeydown: s
    }, [
      d.value === "withHeader" ? (u(), b(ie, { key: 0 }, [
        e.toast.title ? (u(), b("div", {
          key: 0,
          "data-testid": "toast-header",
          class: C(["py-1 text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)", p.value])
        }, H(e.toast.title), 3)) : w("", !0),
        x("div", {
          "data-testid": "toast-avatar-row",
          class: C(["flex items-start gap-3", !e.toast.title && p.value])
        }, [
          e.toast.avatar ? (u(), P(L(Jt), {
            key: 0,
            img: e.toast.avatar.src,
            name: e.toast.avatar.name,
            presentational: ""
          }, null, 8, ["img", "name"])) : w("", !0),
          x("div", dV, [
            x("div", uV, [
              e.toast.avatar ? (u(), b("div", cV, H(e.toast.avatar.name), 1)) : w("", !0),
              x("div", fV, H(e.toast.message), 1)
            ]),
            e.toast.time ? (u(), b("div", hV, H(e.toast.time), 1)) : w("", !0)
          ])
        ], 2),
        U(Gd, {
          primary: e.toast.primaryAction,
          secondary: e.toast.secondaryAction,
          onRun: y
        }, null, 8, ["primary", "secondary"])
      ], 64)) : d.value === "iconShape" ? (u(), b("div", bV, [
        e.toast.icon ? (u(), P(aa, {
          key: 0,
          "data-testid": "toast-icon-shape",
          color: "white",
          variant: "outlined",
          size: "md",
          icon: e.toast.icon
        }, null, 8, ["icon"])) : w("", !0),
        x("div", gV, [
          x("div", {
            class: C(["flex flex-col gap-2 text-(length:--size-m) leading-(--line-height-l)", p.value])
          }, [
            e.toast.title ? (u(), b("div", mV, H(e.toast.title), 1)) : w("", !0),
            x("div", vV, H(e.toast.message), 1)
          ], 2),
          U(Gd, {
            primary: e.toast.primaryAction,
            secondary: e.toast.secondaryAction,
            onRun: y
          }, null, 8, ["primary", "secondary"])
        ])
      ])) : (u(), b("div", pV, [
        x("div", xV, [
          x("i", {
            class: C(["size-(--icon-size-md) text-(length:--icon-size-md) leading-(--icon-size-md)", [h.value.icon, h.value.color]])
          }, null, 2)
        ]),
        x("div", yV, [
          e.toast.title ? (u(), b("div", kV, H(e.toast.title), 1)) : w("", !0),
          x("div", {
            "data-testid": "toast-message",
            class: C(h.value.leading)
          }, H(e.toast.message), 3),
          e.toast.link ? (u(), P(L(pa), {
            key: 1,
            "data-testid": "toast-link",
            class: "self-start text-(--text-text-link-on-dark)!",
            as: e.toast.link.href ? "a" : "button",
            href: e.toast.link.href,
            onClick: k
          }, {
            default: me(() => [
              st(H(e.toast.link.label), 1)
            ]),
            _: 1
          }, 8, ["as", "href"])) : w("", !0),
          U(Gd, {
            class: "mt-3.5",
            primary: e.toast.primaryAction,
            secondary: e.toast.secondaryAction,
            onRun: y
          }, null, 8, ["primary", "secondary"])
        ])
      ])),
      v.value ? (u(), b("div", {
        key: 3,
        "data-testid": "toast-close",
        class: C(d.value === "default" ? "flex shrink-0" : "absolute top-1 right-1")
      }, [
        U(L(Be), {
          class: "[&_i]:text-(--icons-icon-white-default)! hover:[&_i]:text-(--icons-icon-dark-default)! [&_i]:text-(length:--icon-size-sm) [&_i]:leading-(--icon-size-sm)",
          variant: "ghost",
          size: "xs",
          "icon-only": "",
          "icon-left": "ri-close-fill",
          "aria-label": t.toast.ariaClose,
          onClick: S[0] || (S[0] = (I) => n("close"))
        }, null, 8, ["aria-label"])
      ], 2)) : w("", !0)
    ], 42, sV));
  }
}), CV = {
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "sr-only",
  "data-testid": "toast-live-polite"
}, SV = 250, FG = /* @__PURE__ */ ke({
  __name: "ToastContainer",
  setup(e) {
    const { toasts: a, removeToast: t, pauseToast: n, resumeToast: l, setWindowBlurred: o } = iV(), r = R();
    let i, s = !1, d = null;
    const c = R("");
    let f = new Map(a.value.map(($) => [$.id, $])), g = /* @__PURE__ */ new Set();
    function h($) {
      var B, W, _;
      const S = $.map((Z) => {
        var le;
        return (le = r.value) == null ? void 0 : le.querySelector(`[data-toast-id="${Z}"]`);
      }), I = S.find((Z) => Z == null ? void 0 : Z.contains(document.activeElement));
      if (!I) return;
      const T = d;
      if (d = null, T != null && T.isConnected) return T.focus();
      if (!((B = document.activeElement) != null && B.matches(":focus-visible"))) return;
      const A = [...((W = r.value) == null ? void 0 : W.querySelectorAll("[data-toast-id]")) ?? []], E = A.indexOf(I), z = [...A.slice(E + 1), ...A.slice(0, E).reverse()].find(
        (Z) => !S.includes(Z)
      );
      (_ = z == null ? void 0 : z.querySelector("button")) == null || _.focus();
    }
    $e(
      () => [...a.value],
      async ($) => {
        const S = new Map($.map((T) => [T.id, T]));
        h([...f.keys()].filter((T) => !S.has(T)));
        const I = $.filter((T) => f.has(T.id) ? f.get(T.id) !== T : !Fx(T));
        if (f = S, !I.length) {
          g.size && ![...g].some((T) => S.has(T)) && (c.value = "", g = /* @__PURE__ */ new Set());
          return;
        }
        g = new Set(I.map((T) => T.id)), c.value = "", await Ze(), c.value = I.map(oV).join(" ");
      }
    );
    function v() {
      const $ = !document.hasFocus();
      $ !== s && (s = $, o($));
    }
    function p($) {
      clearInterval(i), i = void 0, $ && (v(), i = setInterval(v, SV));
    }
    $e(() => a.value.length > 0, p, { flush: "sync" });
    function y($) {
      var I;
      const S = $.relatedTarget;
      S instanceof HTMLElement && !((I = r.value) != null && I.contains(S)) && (d = S);
    }
    function k($) {
      var I;
      const S = $.relatedTarget;
      (S instanceof Node ? !((I = r.value) != null && I.contains(S)) : document.hasFocus()) && (d = null);
    }
    return kt(() => {
      s = !document.hasFocus(), o(s), p(a.value.length > 0);
    }), Tt(() => {
      p(!1), o(!1);
    }), ($, S) => (u(), b("div", {
      ref_key: "root",
      ref: r,
      class: "fixed right-4 z-[500] w-80 max-w-[calc(100vw-2rem)]",
      style: { top: "var(--toast-container-top, 1rem)" },
      onFocusin: y,
      onFocusout: k
    }, [
      x("div", CV, H(c.value), 1),
      U(cr, {
        name: "toast",
        tag: "div",
        class: "flex max-h-[calc(100vh-var(--toast-container-top,1rem)-1rem+--spacing(5))] flex-col gap-3 overflow-x-hidden overflow-y-auto not-empty:-m-2.5 not-empty:p-2.5 *:shrink-0"
      }, {
        default: me(() => [
          (u(!0), b(ie, null, Oe(L(a), (I) => (u(), P(wV, {
            key: I.id,
            toast: I,
            "data-toast-id": I.id,
            onClose: (T) => L(t)(I.id),
            onPause: (T) => L(n)(I.id, "pointer"),
            onResume: (T) => L(l)(I.id, "pointer")
          }, null, 8, ["toast", "data-toast-id", "onClose", "onPause", "onResume"]))), 128))
        ]),
        _: 1
      })
    ], 544));
  }
}), $V = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"/></svg>', IV = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"/></svg>', LV = { key: 0 }, TV = {
  key: 0,
  "data-testid": "form-error-summary-inline",
  class: "inline-flex items-center gap-2 px-3 py-1.5 rounded-(--border-border-radius-rounded-sm) bg-(--background-background-error) border border-solid border-(--border-border-error-subtle) text-(length:--size-m) leading-(--line-height-l) text-(--text-text-heading) font-(--weight-medium)"
}, EV = ["innerHTML"], AV = ["innerHTML"], RV = {
  key: 0,
  "data-testid": "form-error-summary-menu",
  class: "absolute left-0 top-[calc(100%+4px)] z-50 min-w-56 rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-error-subtle) bg-white-50-opacity-bold p-3 shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:border-(--border-border-base) dark:bg-(--background-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
}, zV = {
  key: 0,
  "data-testid": "form-error-summary-list-heading",
  class: "mb-2 text-(length:--size-sm) leading-(--line-height-l) font-(--weight-semi-bold) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
}, DV = { class: "flex flex-col gap-1" }, BV = ["onClick"], MV = ["innerHTML"], NG = /* @__PURE__ */ ke({
  __name: "FormErrorSummary",
  props: {
    errors: {},
    mode: { default: "inline" },
    heading: { default: void 0 },
    triggerLabel: { default: void 0 },
    listHeading: { default: void 0 }
  },
  emits: ["navigateToField"],
  setup(e, { emit: a }) {
    const t = a, { isOpen: n, dropdownRef: l, toggleDropdown: o, closeDropdown: r } = So(), i = m(
      () => $V.replace("<svg", '<svg width="16" height="16" style="display: block;"')
    ), s = m(
      () => IV.replace("<svg", '<svg width="12" height="12" style="display: block;"')
    ), d = (c) => {
      r(), t("navigateToField", c);
    };
    return (c, f) => e.errors.length > 0 ? (u(), b("div", LV, [
      e.mode === "inline" ? (u(), b("div", TV, [
        x("span", {
          class: "h-4 w-4 flex-shrink-0 inline-flex items-center justify-center text-(--icons-icon-error)",
          innerHTML: i.value
        }, null, 8, EV),
        x("span", null, H(e.heading), 1)
      ])) : (u(), b("div", {
        key: 1,
        ref_key: "dropdownRef",
        ref: l,
        class: "relative inline-block"
      }, [
        x("button", {
          type: "button",
          "data-testid": "form-error-summary-trigger",
          class: "inline-flex items-center gap-1.5 rounded-(--border-border-radius-rounded-full) border border-solid border-(--border-border-error-subtle) bg-(--background-background-error) px-3 py-1.5 text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-heading) cursor-pointer transition-opacity hover:opacity-80",
          onClick: f[0] || (f[0] = //@ts-ignore
          (...g) => L(o) && L(o)(...g))
        }, [
          x("span", {
            class: "h-4 w-4 flex-shrink-0 inline-flex items-center justify-center text-(--icons-icon-error)",
            innerHTML: i.value
          }, null, 8, AV),
          x("span", null, H(e.triggerLabel), 1),
          (u(), b("svg", {
            class: "h-4 w-4 transition-transform duration-200",
            style: Ge({ transform: L(n) ? "rotate(180deg)" : "rotate(0deg)" }),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [...f[1] || (f[1] = [
            x("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 9l-7 7-7-7"
            }, null, -1)
          ])], 4))
        ]),
        U(Wt, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: me(() => [
            L(n) ? (u(), b("div", RV, [
              e.listHeading ? (u(), b("p", zV, H(e.listHeading), 1)) : w("", !0),
              x("ul", DV, [
                (u(!0), b(ie, null, Oe(e.errors, (g) => (u(), b("li", {
                  key: g.key
                }, [
                  x("button", {
                    type: "button",
                    "data-testid": "form-error-summary-item",
                    class: "inline-flex w-full items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) px-2 py-1 text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) cursor-pointer transition-colors hover:bg-(--background-background-error) dark:text-(--text-text-white-secondary) dark:hover:bg-white/8",
                    onClick: (h) => d(g.key)
                  }, [
                    x("span", {
                      class: "h-3 w-3 flex-shrink-0 inline-flex items-center justify-center text-(--icons-icon-error)",
                      innerHTML: s.value
                    }, null, 8, MV),
                    x("span", null, H(g.label), 1)
                  ], 8, BV)
                ]))), 128))
              ])
            ])) : w("", !0)
          ]),
          _: 1
        })
      ], 512))
    ])) : w("", !0);
  }
}), OV = ["id"], VG = /* @__PURE__ */ ke({
  __name: "DynamicFormField",
  props: {
    field: {},
    modelValue: {},
    error: {}
  },
  emits: ["update:modelValue", "country-change", "blur"],
  setup(e) {
    return (a, t) => (u(), b("div", {
      id: `field-${e.field.key}`
    }, [
      e.field.type === "email" ? (u(), P(YD, {
        key: 0,
        "model-value": e.modelValue,
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        size: e.field.size,
        "full-width": !0,
        hint: e.field.hint,
        placeholder: e.field.placeholder ?? "",
        error: e.error,
        "onUpdate:modelValue": t[0] || (t[0] = (n) => a.$emit("update:modelValue", n)),
        onBlur: t[1] || (t[1] = (n) => a.$emit("blur"))
      }, null, 8, ["model-value", "label", "required", "readonly", "size", "hint", "placeholder", "error"])) : e.field.type === "text" ? (u(), P(Qt, {
        key: 1,
        "model-value": e.modelValue,
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        size: e.field.size,
        "full-width": !0,
        placeholder: e.field.placeholder ?? "",
        error: e.error,
        "onUpdate:modelValue": t[2] || (t[2] = (n) => a.$emit("update:modelValue", n)),
        onBlur: t[3] || (t[3] = (n) => a.$emit("blur"))
      }, null, 8, ["model-value", "label", "required", "readonly", "size", "placeholder", "error"])) : e.field.type === "phone" ? (u(), P(dB, {
        key: 2,
        "model-value": e.modelValue,
        label: e.field.label,
        readonly: e.field.readonly,
        "show-country-selector": e.field.showCountrySelector,
        countries: e.field.countries,
        "full-width": !0,
        size: e.field.size,
        error: e.error,
        "onUpdate:modelValue": t[4] || (t[4] = (n) => a.$emit("update:modelValue", n)),
        onBlur: t[5] || (t[5] = (n) => a.$emit("blur")),
        onCountryChange: t[6] || (t[6] = (n, l) => a.$emit("country-change", { dialCode: n.dialCode, nationalNumber: l }))
      }, null, 8, ["model-value", "label", "readonly", "show-country-selector", "countries", "size", "error"])) : e.field.type === "select" ? (u(), P(yl, {
        key: 3,
        "model-value": e.modelValue,
        options: e.field.options || [],
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        "full-width": !0,
        hint: e.field.hint,
        error: e.error,
        "onUpdate:modelValue": t[7] || (t[7] = (n) => a.$emit("update:modelValue", n)),
        onBlur: t[8] || (t[8] = (n) => a.$emit("blur"))
      }, null, 8, ["model-value", "options", "label", "required", "readonly", "hint", "error"])) : w("", !0)
    ], 8, OV));
  }
}), PV = /* @__PURE__ */ ke({
  __name: "UnsavedChangesModal",
  props: {
    modelValue: { type: Boolean },
    title: {},
    message: {},
    stayLabel: {},
    leaveLabel: {},
    saveLabel: {},
    saveDisabled: { type: Boolean },
    type: {}
  },
  emits: ["update:modelValue", "stay", "leave", "discard", "save"],
  setup(e, { emit: a }) {
    const t = e, n = m(
      () => (t.type ?? (t.saveLabel ? "leave-without-saving" : "leave-page")) === "leave-without-saving"
    ), l = a, o = m({
      get: () => t.modelValue,
      set: (f) => l("update:modelValue", f)
    }), r = m(
      () => t.saveLabel ? [
        {
          id: "discard",
          label: t.leaveLabel,
          variant: "secondary",
          testId: "unsaved-discard",
          onClick: d
        },
        {
          id: "save",
          label: t.saveLabel,
          variant: "primary",
          disabled: t.saveDisabled,
          testId: "unsaved-save",
          onClick: c
        }
      ] : n.value ? [
        { id: "leave", label: t.leaveLabel, variant: "secondary", testId: "unsaved-leave", onClick: s },
        { id: "stay", label: t.stayLabel, variant: "primary", testId: "unsaved-stay", onClick: i }
      ] : [
        { id: "stay", label: t.stayLabel, variant: "secondary", testId: "unsaved-stay", onClick: i },
        { id: "leave", label: t.leaveLabel, variant: "primary", testId: "unsaved-leave", onClick: s }
      ]
    );
    function i() {
      l("update:modelValue", !1), l("stay");
    }
    function s() {
      l("update:modelValue", !1), l("leave");
    }
    function d() {
      l("update:modelValue", !1), l("discard");
    }
    function c() {
      t.saveDisabled || l("save");
    }
    return (f, g) => (u(), P(dl, {
      modelValue: o.value,
      "onUpdate:modelValue": g[0] || (g[0] = (h) => o.value = h),
      size: n.value ? "sm" : "xs",
      dismissable: !1,
      "close-on-escape": !0,
      title: e.title,
      subtitle: e.message,
      icon: n.value ? "ℹ️" : "⚠️",
      "header-align": "middle-stacked",
      "footer-align": e.saveLabel ? "right" : "center",
      actions: r.value,
      "overlay-class": "!z-[400]",
      onClose: i
    }, null, 8, ["modelValue", "size", "title", "subtitle", "icon", "footer-align", "actions"]));
  }
}), HG = /* @__PURE__ */ ke({
  __name: "ConfirmDeleteModal",
  props: {
    modelValue: { type: Boolean },
    title: {},
    subtitle: {},
    confirmLabel: {},
    cancelLabel: {},
    icon: { default: "ri-delete-bin-6-line" },
    confirmDisabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m({
      get: () => t.modelValue,
      set: (s) => n("update:modelValue", s)
    }), o = m(() => [
      {
        id: "cancel",
        label: t.cancelLabel,
        variant: "secondary",
        testId: "confirm-delete-modal-cancel",
        onClick: i
      },
      {
        id: "confirm",
        label: t.confirmLabel,
        variant: "error",
        icon: "ri-delete-bin-6-line",
        disabled: t.confirmDisabled,
        testId: "confirm-delete-modal-confirm",
        onClick: r
      }
    ]);
    function r() {
      t.confirmDisabled || (n("update:modelValue", !1), n("confirm"));
    }
    function i() {
      n("update:modelValue", !1), n("cancel");
    }
    return (s, d) => (u(), P(dl, {
      modelValue: l.value,
      "onUpdate:modelValue": d[0] || (d[0] = (c) => l.value = c),
      size: "xs",
      dismissable: !1,
      "close-on-escape": !0,
      title: e.title,
      subtitle: e.subtitle,
      icon: e.icon,
      "header-align": "middle-stacked",
      "footer-align": "center",
      actions: o.value,
      "data-testid": "confirm-delete-modal-body",
      onClose: i
    }, null, 8, ["modelValue", "title", "subtitle", "icon", "actions"]));
  }
}), FV = /* @__PURE__ */ ke({
  __name: "DataTableContainer",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    tableWidth: {}
  },
  setup(e) {
    const a = e;
    return (t, n) => (u(), b("table", {
      "data-slot": "table",
      class: C([
        "min-w-full table-fixed border-spacing-0 text-(length:--size-m) leading-(--line-height-l) text-left text-(--text-text-body) dark:text-(--text-text-white-secondary)",
        a.class
      ]),
      style: Ge(e.tableWidth ? { width: e.tableWidth } : void 0)
    }, [
      Me(t.$slots, "default")
    ], 6));
  }
}), NV = /* @__PURE__ */ ke({
  __name: "DataTableBody",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e;
    return (t, n) => (u(), b("tbody", {
      "data-slot": "table-body",
      class: C(["", a.class])
    }, [
      Me(t.$slots, "default")
    ], 2));
  }
}), jG = /* @__PURE__ */ ke({
  __name: "DataTableCaption",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e;
    return (t, n) => (u(), b("caption", {
      "data-slot": "table-caption",
      class: C(["text-(--text-text-disabled-strong) mt-4 text-(length:--size-m)", a.class])
    }, [
      Me(t.$slots, "default")
    ], 2));
  }
}), VV = { class: "min-w-0" }, Xu = /* @__PURE__ */ ke({
  __name: "DataTableCellContent",
  setup(e) {
    const a = R(null), t = R(null), n = document.createElement("div");
    function l() {
      var s;
      const r = a.value;
      if (!r) return;
      const i = r.children.length === 0;
      t.value = i && ((s = r.textContent) == null ? void 0 : s.trim()) || null;
    }
    let o;
    return kt(() => {
      l(), !(typeof MutationObserver > "u" || !a.value) && (o = new MutationObserver(l), o.observe(a.value, { childList: !0, characterData: !0, subtree: !0 }));
    }), Tt(() => o == null ? void 0 : o.disconnect()), (r, i) => (u(), b("div", VV, [
      (u(), P(Fa, {
        to: L(n),
        disabled: !t.value
      }, [
        x("div", {
          ref_key: "sourceEl",
          ref: a,
          class: "min-w-0 truncate"
        }, [
          Me(r.$slots, "default")
        ], 512)
      ], 8, ["to", "disabled"])),
      t.value ? (u(), P(it, {
        key: 0,
        text: t.value
      }, null, 8, ["text"])) : w("", !0)
    ]));
  }
}), HV = {
  key: 0,
  class: "flex min-w-0 items-center gap-2"
}, jV = {
  key: 1,
  class: "flex min-w-0 flex-1 items-center"
}, WV = {
  key: 1,
  class: "flex min-w-0 items-center"
}, Li = /* @__PURE__ */ ke({
  __name: "DataTableCell",
  props: {
    class: { type: [Boolean, null, String, Object, Array], default: void 0 },
    noTruncate: { type: Boolean, default: !1 },
    typed: { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = e;
    return (t, n) => (u(), b("td", {
      "data-slot": "table-cell",
      class: C([
        "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-body) dark:text-(--text-text-white-secondary) border-b border-(--colors-border-base-medium) dark:border-(--colors-border-base) p-3 h-12 align-middle",
        // A consumer checkbox column shrinks to its checkbox; the built-in inline checkbox and typed cells keep the column.
        !t.$slots.leading && !e.typed && "[&:has([type=checkbox])]:pr-0 [&:has([type=checkbox])]:max-w-none",
        e.noTruncate ? "overflow-visible" : "overflow-hidden max-w-0",
        e.typed && "py-0",
        a.class
      ])
    }, [
      t.$slots.leading ? (u(), b("div", HV, [
        Me(t.$slots, "leading"),
        !e.noTruncate && !e.typed ? (u(), P(Xu, { key: 0 }, {
          default: me(() => [
            Me(t.$slots, "default")
          ]),
          _: 3
        })) : e.typed ? (u(), b("div", jV, [
          Me(t.$slots, "default")
        ])) : Me(t.$slots, "default", { key: 2 })
      ])) : e.typed ? (u(), b("div", WV, [
        Me(t.$slots, "default")
      ])) : e.noTruncate ? Me(t.$slots, "default", { key: 3 }) : (u(), P(Xu, { key: 2 }, {
        default: me(() => [
          Me(t.$slots, "default")
        ]),
        _: 3
      }))
    ], 2));
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function qV(e) {
  return vi(e) ? Bn(new Proxy({}, {
    get(a, t, n) {
      return L(Reflect.get(e.value, t, n));
    },
    set(a, t, n) {
      return vi(e.value[t]) && !vi(n) ? e.value[t].value = n : e.value[t] = n, !0;
    },
    deleteProperty(a, t) {
      return Reflect.deleteProperty(e.value, t);
    },
    has(a, t) {
      return Reflect.has(e.value, t);
    },
    ownKeys() {
      return Object.keys(e.value);
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    }
  })) : Bn(e);
}
function UV(e) {
  return qV(m(e));
}
function GV(e, ...a) {
  const t = a.flat(), n = t[0];
  return UV(() => Object.fromEntries(typeof n == "function" ? Object.entries(Af(e)).filter(([l, o]) => !n(Xt(o), l)) : Object.entries(Af(e)).filter((l) => !t.includes(l[0]))));
}
const KV = ["data-state", "aria-selected"], Go = /* @__PURE__ */ ke({
  __name: "DataTableRow",
  props: {
    class: { type: [Boolean, null, String, Object, Array], default: void 0 },
    selected: { type: Boolean, default: void 0 }
  },
  setup(e) {
    const a = e;
    return (t, n) => (u(), b("tr", {
      "data-slot": "table-row",
      "data-state": e.selected ? "selected" : void 0,
      "aria-selected": e.selected === void 0 ? void 0 : e.selected ? "true" : "false",
      class: C([
        "border-b border-border-base-soft dark:border-(--colors-border-base)",
        e.selected ? "bg-(--colors-background-selected) dark:bg-(--colors-background-black-default)" : "bg-white dark:bg-(--colors-background-black-default) hover:bg-(--background-background-hover) dark:hover:bg-(--colors-background-black-default)",
        a.class
      ])
    }, [
      Me(t.$slots, "default")
    ], 10, KV));
  }
}), YV = { class: "flex items-center justify-center py-10" }, WG = /* @__PURE__ */ ke({
  __name: "DataTableEmpty",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    colspan: { default: 1 }
  },
  setup(e) {
    const a = e, t = GV(a, "class");
    return (n, l) => (u(), P(Go, null, {
      default: me(() => [
        U(Li, Ve({
          class: ["p-4 whitespace-nowrap align-middle text-(length:--size-m) text-(--text-text-body)", a.class]
        }, L(t)), {
          default: me(() => [
            x("div", YV, [
              Me(n.$slots, "default")
            ])
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }));
  }
}), qG = /* @__PURE__ */ ke({
  __name: "DataTableFooter",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const a = e;
    return (t, n) => (u(), b("tfoot", {
      "data-slot": "table-footer",
      class: C(["", a.class])
    }, [
      Me(t.$slots, "default")
    ], 2));
  }
}), Nx = 1e3;
function Vx(e) {
  return e !== void 0 && e < Number.MAX_SAFE_INTEGER;
}
function Kl(e) {
  return Vx(e) ? e : Nx;
}
const JV = ["aria-sort"], XV = { class: "flex items-center gap-1 min-w-0" }, ZV = ["data-drag-handle", "draggable"], QV = {
  key: 1,
  "data-head-leading": "",
  class: "inline-flex shrink-0 items-center"
}, _V = {
  key: 2,
  class: "me-auto min-w-0"
}, e9 = ["aria-label", "aria-valuenow", "aria-valuemin", "aria-valuemax"], ag = 10, si = "inline-flex size-(--icon-size-xs) shrink-0 items-center justify-center text-(length:--icon-size-xs) leading-(--icon-size-xs)", t9 = /* @__PURE__ */ ke({
  __name: "DataTableHead",
  props: {
    class: { type: [Boolean, null, String, Object, Array], default: void 0 },
    isDraggable: { type: Boolean, default: !1 },
    isPinned: { type: Boolean, default: !1 },
    isLastPinned: { type: Boolean, default: !1 },
    isLocked: { type: Boolean, default: !1 },
    isPinIconVisible: { type: Boolean, default: !0 },
    isPinnable: { type: Boolean, default: !1 },
    isCustomHeader: { type: Boolean, default: !1 },
    isResizingActive: { type: Boolean, default: !1 },
    isResizable: { type: Boolean, default: !0 },
    sortDirection: { default: void 0 },
    menuGroups: { default: void 0 },
    menuLabel: { default: "Column options" },
    resizeLabel: { default: "Resize column" },
    width: { default: void 0 },
    minWidth: { default: 130 },
    maxWidth: { default: Nx }
  },
  emits: ["resize-start", "resize-auto", "resize-by", "drag-handle-start", "drag-handle-end"],
  setup(e, { emit: a }) {
    const t = e, n = m(() => {
      if (t.sortDirection !== void 0)
        return t.sortDirection === "asc" ? "ascending" : t.sortDirection === "desc" ? "descending" : "none";
    }), l = m(() => {
      if (t.sortDirection === "asc") return "ri-sort-asc";
      if (t.sortDirection === "desc") return "ri-sort-desc";
    }), o = m(() => {
      var p;
      return !!((p = t.menuGroups) != null && p.length);
    }), r = a;
    let i = 0;
    function s(p) {
      const y = Date.now();
      if (y - i < 300) {
        i = 0, r("resize-auto");
        return;
      }
      i = y, r("resize-start", p);
    }
    function d(p) {
      const y = t.width ?? t.minWidth;
      let k;
      switch (p.key) {
        case "ArrowLeft":
        case "ArrowDown":
          k = -ag;
          break;
        case "ArrowRight":
        case "ArrowUp":
          k = ag;
          break;
        case "Home":
          k = t.minWidth - y;
          break;
        case "End":
          k = t.maxWidth - y;
          break;
        default:
          return;
      }
      p.preventDefault(), r("resize-by", k);
    }
    const c = R(null), f = R(null);
    let g = !1;
    function h() {
      var p;
      g = !!((p = f.value) != null && p.isOpen);
    }
    function v(p) {
      var y, k;
      !o.value || g || p.target.closest("button, a, input, [role='slider'], [data-head-leading]") || (k = (y = c.value) == null ? void 0 : y.querySelector("[data-column-menu-trigger]")) == null || k.click();
    }
    return (p, y) => (u(), b("th", {
      ref_key: "thRef",
      ref: c,
      "data-slot": "table-head",
      scope: "col",
      "aria-sort": n.value,
      class: C([
        "group/head relative h-10 px-3 min-w-32.5 text-left align-middle text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) whitespace-nowrap border-y border-(--colors-border-base-medium) dark:border-(--colors-border-base) text-(--text-text-heading) dark:text-(--colors-text-white-default) [&_button]:border-0 [&>div>div>button]:p-0",
        // A consumer checkbox column shrinks to its checkbox; the built-in inline checkbox keeps the column.
        !p.$slots.leading && "[&:has([type=checkbox])]:min-w-auto [&:has([type=checkbox])]:w-10 [&:has([type=checkbox])]:pr-0",
        e.isPinned ? "bg-white dark:bg-(--colors-background-black-default) z-20" : "z-0",
        o.value && "cursor-pointer",
        t.class
      ]),
      onMousedown: h,
      onClick: v
    }, [
      x("div", XV, [
        e.isDraggable || e.isLocked ? (u(), b("span", {
          key: 0,
          class: C([
            // 24px hit area (WCAG 2.5.8) that takes Figma's 14px slot: -5px on each side.
            "-mx-[5px] inline-flex size-6 shrink-0 items-center justify-center",
            e.isLocked ? "cursor-not-allowed text-(--icons-icon-disabled-light)" : e.isPinned ? (
              // Figma (7240:31167): a pinned column's drag icon is grey like its pin; it still moves among the pinned.
              "cursor-grab text-(--icons-icon-disabled-light)"
            ) : "cursor-grab text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
          ]),
          "data-drag-handle": e.isLocked ? "false" : "true",
          draggable: e.isLocked ? "false" : "true",
          onDragstart: y[0] || (y[0] = _e((k) => !e.isLocked && r("drag-handle-start", k), ["stop"])),
          onDragend: y[1] || (y[1] = (k) => r("drag-handle-end"))
        }, [
          x("i", {
            class: C(["ri-draggable", si]),
            "aria-hidden": "true"
          }, null, 2)
        ], 42, ZV)) : w("", !0),
        p.$slots.leading ? (u(), b("span", QV, [
          Me(p.$slots, "leading")
        ])) : w("", !0),
        e.isCustomHeader ? (u(), b("div", _V, [
          Me(p.$slots, "default")
        ])) : (u(), P(Xu, {
          key: 3,
          class: "me-auto min-w-0"
        }, {
          default: me(() => [
            Me(p.$slots, "default")
          ]),
          _: 3
        })),
        l.value ? (u(), b("i", {
          key: 4,
          "data-testid": "column-sort-icon",
          class: C([l.value, si, "text-(--icons-icon-accent-strong) dark:text-(--icons-icon-accent)"]),
          "aria-hidden": "true"
        }, null, 2)) : w("", !0),
        e.isPinned && e.isPinIconVisible ? (u(), b("i", {
          key: 5,
          "data-testid": "column-pin-icon",
          "data-state": "frozen",
          class: C(["ri-pushpin-2-fill", si, "text-(--icons-icon-disabled-light)"]),
          "aria-hidden": "true"
        }, null, 2)) : e.isPinnable && !e.isPinned ? (u(), b("i", {
          key: 6,
          "data-testid": "column-pin-icon",
          "data-state": "unfrozen",
          class: C(["ri-pushpin-2-line", si, "text-(--icons-icon-disabled-light) opacity-0 group-hover/head:opacity-100 group-focus-within/head:opacity-100"]),
          "aria-hidden": "true"
        }, null, 2)) : w("", !0),
        o.value ? (u(), P(Ra, {
          key: 7,
          ref_key: "menuRef",
          ref: f,
          class: "-mx-[5px] shrink-0",
          groups: e.menuGroups,
          "selection-style": "check",
          "menu-align": "right"
        }, {
          trigger: me(({ triggerProps: k }) => [
            U(Be, Ve({
              variant: "ghost",
              size: "xs",
              "icon-only": "",
              "icon-left": "ri-expand-up-down-fill",
              "aria-label": e.menuLabel,
              "data-testid": "column-menu-trigger",
              "data-column-menu-trigger": ""
            }, k), null, 16, ["aria-label"])
          ]),
          _: 1
        }, 8, ["groups"])) : w("", !0)
      ]),
      e.isResizable ? (u(), b("div", {
        key: 0,
        role: "slider",
        "aria-orientation": "horizontal",
        tabindex: "0",
        "data-testid": "column-resize-handle",
        "aria-label": e.resizeLabel,
        "aria-valuenow": e.width,
        "aria-valuemin": e.minWidth,
        "aria-valuemax": e.maxWidth,
        class: C(["absolute top-0 right-0 z-10 h-full w-1 cursor-col-resize transition-colors motion-reduce:transition-none after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:w-px after:bg-(--background-background-white-tertiary) dark:after:bg-(--colors-border-base) hover:bg-(--border-border-accent) focus-visible:outline-hidden focus-visible:bg-(--border-border-accent) focus-visible:shadow-(--shadow-focus-l)", { "bg-(--border-border-accent)": e.isResizingActive }]),
        onMousedown: y[2] || (y[2] = _e((k) => s(k), ["stop", "prevent"])),
        onClick: y[3] || (y[3] = _e(() => {
        }, ["stop", "prevent"])),
        onKeydown: d
      }, null, 42, e9)) : w("", !0)
    ], 42, JV));
  }
}), a9 = /* @__PURE__ */ ke({
  __name: "DataTableHeader",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    isSticky: { type: Boolean }
  },
  setup(e) {
    const a = e;
    return (t, n) => (u(), b("thead", {
      "data-slot": "table-header",
      class: C([
        "shadow-(--table-header-shadow) [&_tr:hover]:bg-transparent",
        a.isSticky && "sticky top-0 z-30 bg-white dark:bg-(--colors-background-black-default)",
        a.class
      ])
    }, [
      Me(t.$slots, "default")
    ], 2));
  }
});
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Xn(e, a) {
  return typeof e == "function" ? e(a) : e;
}
function Pa(e, a) {
  return (t) => {
    a.setState((n) => ({
      ...n,
      [e]: Xn(t, n[e])
    }));
  };
}
function Xs(e) {
  return e instanceof Function;
}
function n9(e) {
  return Array.isArray(e) && e.every((a) => typeof a == "number");
}
function l9(e, a) {
  const t = [], n = (l) => {
    l.forEach((o) => {
      t.push(o);
      const r = a(o);
      r != null && r.length && n(r);
    });
  };
  return n(e), t;
}
function ct(e, a, t) {
  let n = [], l;
  return (o) => {
    let r;
    t.key && t.debug && (r = Date.now());
    const i = e(o);
    if (!(i.length !== n.length || i.some((c, f) => n[f] !== c)))
      return l;
    n = i;
    let d;
    if (t.key && t.debug && (d = Date.now()), l = a(...i), t == null || t.onChange == null || t.onChange(l), t.key && t.debug && t != null && t.debug()) {
      const c = Math.round((Date.now() - r) * 100) / 100, f = Math.round((Date.now() - d) * 100) / 100, g = f / 16, h = (v, p) => {
        for (v = String(v); v.length < p; )
          v = " " + v;
        return v;
      };
      console.info(`%c⏱ ${h(f, 5)} /${h(c, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * g, 120))}deg 100% 31%);`, t == null ? void 0 : t.key);
    }
    return l;
  };
}
function ft(e, a, t, n) {
  return {
    debug: () => {
      var l;
      return (l = e == null ? void 0 : e.debugAll) != null ? l : e[a];
    },
    key: process.env.NODE_ENV === "development" && t,
    onChange: n
  };
}
function o9(e, a, t, n) {
  const l = () => {
    var r;
    return (r = o.getValue()) != null ? r : e.options.renderFallbackValue;
  }, o = {
    id: `${a.id}_${t.id}`,
    row: a,
    column: t,
    getValue: () => a.getValue(n),
    renderValue: l,
    getContext: ct(() => [e, t, a, o], (r, i, s, d) => ({
      table: r,
      column: i,
      row: s,
      cell: d,
      getValue: d.getValue,
      renderValue: d.renderValue
    }), ft(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((r) => {
    r.createCell == null || r.createCell(o, t, a, e);
  }, {}), o;
}
function r9(e, a, t, n) {
  var l, o;
  const i = {
    ...e._getDefaultColumnDef(),
    ...a
  }, s = i.accessorKey;
  let d = (l = (o = i.id) != null ? o : s ? typeof String.prototype.replaceAll == "function" ? s.replaceAll(".", "_") : s.replace(/\./g, "_") : void 0) != null ? l : typeof i.header == "string" ? i.header : void 0, c;
  if (i.accessorFn ? c = i.accessorFn : s && (s.includes(".") ? c = (g) => {
    let h = g;
    for (const p of s.split(".")) {
      var v;
      h = (v = h) == null ? void 0 : v[p], process.env.NODE_ENV !== "production" && h === void 0 && console.warn(`"${p}" in deeply nested key "${s}" returned undefined.`);
    }
    return h;
  } : c = (g) => g[i.accessorKey]), !d)
    throw process.env.NODE_ENV !== "production" ? new Error(i.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let f = {
    id: `${String(d)}`,
    accessorFn: c,
    parent: n,
    depth: t,
    columnDef: i,
    columns: [],
    getFlatColumns: ct(() => [!0], () => {
      var g;
      return [f, ...(g = f.columns) == null ? void 0 : g.flatMap((h) => h.getFlatColumns())];
    }, ft(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: ct(() => [e._getOrderColumnsFn()], (g) => {
      var h;
      if ((h = f.columns) != null && h.length) {
        let v = f.columns.flatMap((p) => p.getLeafColumns());
        return g(v);
      }
      return [f];
    }, ft(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const g of e._features)
    g.createColumn == null || g.createColumn(f, e);
  return f;
}
const ba = "debugHeaders";
function ng(e, a, t) {
  var n;
  let o = {
    id: (n = t.id) != null ? n : a.id,
    column: a,
    index: t.index,
    isPlaceholder: !!t.isPlaceholder,
    placeholderId: t.placeholderId,
    depth: t.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const r = [], i = (s) => {
        s.subHeaders && s.subHeaders.length && s.subHeaders.map(i), r.push(s);
      };
      return i(o), r;
    },
    getContext: () => ({
      table: e,
      header: o,
      column: a
    })
  };
  return e._features.forEach((r) => {
    r.createHeader == null || r.createHeader(o, e);
  }), o;
}
const i9 = {
  createTable: (e) => {
    e.getHeaderGroups = ct(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (a, t, n, l) => {
      var o, r;
      const i = (o = n == null ? void 0 : n.map((f) => t.find((g) => g.id === f)).filter(Boolean)) != null ? o : [], s = (r = l == null ? void 0 : l.map((f) => t.find((g) => g.id === f)).filter(Boolean)) != null ? r : [], d = t.filter((f) => !(n != null && n.includes(f.id)) && !(l != null && l.includes(f.id)));
      return di(a, [...i, ...d, ...s], e);
    }, ft(e.options, ba, "getHeaderGroups")), e.getCenterHeaderGroups = ct(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (a, t, n, l) => (t = t.filter((o) => !(n != null && n.includes(o.id)) && !(l != null && l.includes(o.id))), di(a, t, e, "center")), ft(e.options, ba, "getCenterHeaderGroups")), e.getLeftHeaderGroups = ct(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (a, t, n) => {
      var l;
      const o = (l = n == null ? void 0 : n.map((r) => t.find((i) => i.id === r)).filter(Boolean)) != null ? l : [];
      return di(a, o, e, "left");
    }, ft(e.options, ba, "getLeftHeaderGroups")), e.getRightHeaderGroups = ct(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (a, t, n) => {
      var l;
      const o = (l = n == null ? void 0 : n.map((r) => t.find((i) => i.id === r)).filter(Boolean)) != null ? l : [];
      return di(a, o, e, "right");
    }, ft(e.options, ba, "getRightHeaderGroups")), e.getFooterGroups = ct(() => [e.getHeaderGroups()], (a) => [...a].reverse(), ft(e.options, ba, "getFooterGroups")), e.getLeftFooterGroups = ct(() => [e.getLeftHeaderGroups()], (a) => [...a].reverse(), ft(e.options, ba, "getLeftFooterGroups")), e.getCenterFooterGroups = ct(() => [e.getCenterHeaderGroups()], (a) => [...a].reverse(), ft(e.options, ba, "getCenterFooterGroups")), e.getRightFooterGroups = ct(() => [e.getRightHeaderGroups()], (a) => [...a].reverse(), ft(e.options, ba, "getRightFooterGroups")), e.getFlatHeaders = ct(() => [e.getHeaderGroups()], (a) => a.map((t) => t.headers).flat(), ft(e.options, ba, "getFlatHeaders")), e.getLeftFlatHeaders = ct(() => [e.getLeftHeaderGroups()], (a) => a.map((t) => t.headers).flat(), ft(e.options, ba, "getLeftFlatHeaders")), e.getCenterFlatHeaders = ct(() => [e.getCenterHeaderGroups()], (a) => a.map((t) => t.headers).flat(), ft(e.options, ba, "getCenterFlatHeaders")), e.getRightFlatHeaders = ct(() => [e.getRightHeaderGroups()], (a) => a.map((t) => t.headers).flat(), ft(e.options, ba, "getRightFlatHeaders")), e.getCenterLeafHeaders = ct(() => [e.getCenterFlatHeaders()], (a) => a.filter((t) => {
      var n;
      return !((n = t.subHeaders) != null && n.length);
    }), ft(e.options, ba, "getCenterLeafHeaders")), e.getLeftLeafHeaders = ct(() => [e.getLeftFlatHeaders()], (a) => a.filter((t) => {
      var n;
      return !((n = t.subHeaders) != null && n.length);
    }), ft(e.options, ba, "getLeftLeafHeaders")), e.getRightLeafHeaders = ct(() => [e.getRightFlatHeaders()], (a) => a.filter((t) => {
      var n;
      return !((n = t.subHeaders) != null && n.length);
    }), ft(e.options, ba, "getRightLeafHeaders")), e.getLeafHeaders = ct(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (a, t, n) => {
      var l, o, r, i, s, d;
      return [...(l = (o = a[0]) == null ? void 0 : o.headers) != null ? l : [], ...(r = (i = t[0]) == null ? void 0 : i.headers) != null ? r : [], ...(s = (d = n[0]) == null ? void 0 : d.headers) != null ? s : []].map((c) => c.getLeafHeaders()).flat();
    }, ft(e.options, ba, "getLeafHeaders"));
  }
};
function di(e, a, t, n) {
  var l, o;
  let r = 0;
  const i = function(g, h) {
    h === void 0 && (h = 1), r = Math.max(r, h), g.filter((v) => v.getIsVisible()).forEach((v) => {
      var p;
      (p = v.columns) != null && p.length && i(v.columns, h + 1);
    }, 0);
  };
  i(e);
  let s = [];
  const d = (g, h) => {
    const v = {
      depth: h,
      id: [n, `${h}`].filter(Boolean).join("_"),
      headers: []
    }, p = [];
    g.forEach((y) => {
      const k = [...p].reverse()[0], $ = y.column.depth === v.depth;
      let S, I = !1;
      if ($ && y.column.parent ? S = y.column.parent : (S = y.column, I = !0), k && (k == null ? void 0 : k.column) === S)
        k.subHeaders.push(y);
      else {
        const T = ng(t, S, {
          id: [n, h, S.id, y == null ? void 0 : y.id].filter(Boolean).join("_"),
          isPlaceholder: I,
          placeholderId: I ? `${p.filter((A) => A.column === S).length}` : void 0,
          depth: h,
          index: p.length
        });
        T.subHeaders.push(y), p.push(T);
      }
      v.headers.push(y), y.headerGroup = v;
    }), s.push(v), h > 0 && d(p, h - 1);
  }, c = a.map((g, h) => ng(t, g, {
    depth: r,
    index: h
  }));
  d(c, r - 1), s.reverse();
  const f = (g) => g.filter((v) => v.column.getIsVisible()).map((v) => {
    let p = 0, y = 0, k = [0];
    v.subHeaders && v.subHeaders.length ? (k = [], f(v.subHeaders).forEach((S) => {
      let {
        colSpan: I,
        rowSpan: T
      } = S;
      p += I, k.push(T);
    })) : p = 1;
    const $ = Math.min(...k);
    return y = y + $, v.colSpan = p, v.rowSpan = y, {
      colSpan: p,
      rowSpan: y
    };
  });
  return f((l = (o = s[0]) == null ? void 0 : o.headers) != null ? l : []), s;
}
const s9 = (e, a, t, n, l, o, r) => {
  let i = {
    id: a,
    index: n,
    original: t,
    depth: l,
    parentId: r,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (s) => {
      if (i._valuesCache.hasOwnProperty(s))
        return i._valuesCache[s];
      const d = e.getColumn(s);
      if (d != null && d.accessorFn)
        return i._valuesCache[s] = d.accessorFn(i.original, n), i._valuesCache[s];
    },
    getUniqueValues: (s) => {
      if (i._uniqueValuesCache.hasOwnProperty(s))
        return i._uniqueValuesCache[s];
      const d = e.getColumn(s);
      if (d != null && d.accessorFn)
        return d.columnDef.getUniqueValues ? (i._uniqueValuesCache[s] = d.columnDef.getUniqueValues(i.original, n), i._uniqueValuesCache[s]) : (i._uniqueValuesCache[s] = [i.getValue(s)], i._uniqueValuesCache[s]);
    },
    renderValue: (s) => {
      var d;
      return (d = i.getValue(s)) != null ? d : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => l9(i.subRows, (s) => s.subRows),
    getParentRow: () => i.parentId ? e.getRow(i.parentId, !0) : void 0,
    getParentRows: () => {
      let s = [], d = i;
      for (; ; ) {
        const c = d.getParentRow();
        if (!c) break;
        s.push(c), d = c;
      }
      return s.reverse();
    },
    getAllCells: ct(() => [e.getAllLeafColumns()], (s) => s.map((d) => o9(e, i, d, d.id)), ft(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: ct(() => [i.getAllCells()], (s) => s.reduce((d, c) => (d[c.column.id] = c, d), {}), ft(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let s = 0; s < e._features.length; s++) {
    const d = e._features[s];
    d == null || d.createRow == null || d.createRow(i, e);
  }
  return i;
}, d9 = {
  createColumn: (e, a) => {
    e._getFacetedRowModel = a.options.getFacetedRowModel && a.options.getFacetedRowModel(a, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : a.getPreFilteredRowModel(), e._getFacetedUniqueValues = a.options.getFacetedUniqueValues && a.options.getFacetedUniqueValues(a, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = a.options.getFacetedMinMaxValues && a.options.getFacetedMinMaxValues(a, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, Hx = (e, a, t) => {
  var n, l;
  const o = t == null || (n = t.toString()) == null ? void 0 : n.toLowerCase();
  return !!(!((l = e.getValue(a)) == null || (l = l.toString()) == null || (l = l.toLowerCase()) == null) && l.includes(o));
};
Hx.autoRemove = (e) => on(e);
const jx = (e, a, t) => {
  var n;
  return !!(!((n = e.getValue(a)) == null || (n = n.toString()) == null) && n.includes(t));
};
jx.autoRemove = (e) => on(e);
const Wx = (e, a, t) => {
  var n;
  return ((n = e.getValue(a)) == null || (n = n.toString()) == null ? void 0 : n.toLowerCase()) === (t == null ? void 0 : t.toLowerCase());
};
Wx.autoRemove = (e) => on(e);
const qx = (e, a, t) => {
  var n;
  return (n = e.getValue(a)) == null ? void 0 : n.includes(t);
};
qx.autoRemove = (e) => on(e);
const Ux = (e, a, t) => !t.some((n) => {
  var l;
  return !((l = e.getValue(a)) != null && l.includes(n));
});
Ux.autoRemove = (e) => on(e) || !(e != null && e.length);
const Gx = (e, a, t) => t.some((n) => {
  var l;
  return (l = e.getValue(a)) == null ? void 0 : l.includes(n);
});
Gx.autoRemove = (e) => on(e) || !(e != null && e.length);
const Kx = (e, a, t) => e.getValue(a) === t;
Kx.autoRemove = (e) => on(e);
const Yx = (e, a, t) => e.getValue(a) == t;
Yx.autoRemove = (e) => on(e);
const wf = (e, a, t) => {
  let [n, l] = t;
  const o = e.getValue(a);
  return o >= n && o <= l;
};
wf.resolveFilterValue = (e) => {
  let [a, t] = e, n = typeof a != "number" ? parseFloat(a) : a, l = typeof t != "number" ? parseFloat(t) : t, o = a === null || Number.isNaN(n) ? -1 / 0 : n, r = t === null || Number.isNaN(l) ? 1 / 0 : l;
  if (o > r) {
    const i = o;
    o = r, r = i;
  }
  return [o, r];
};
wf.autoRemove = (e) => on(e) || on(e[0]) && on(e[1]);
const En = {
  includesString: Hx,
  includesStringSensitive: jx,
  equalsString: Wx,
  arrIncludes: qx,
  arrIncludesAll: Ux,
  arrIncludesSome: Gx,
  equals: Kx,
  weakEquals: Yx,
  inNumberRange: wf
};
function on(e) {
  return e == null || e === "";
}
const u9 = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: Pa("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, a) => {
    e.getAutoFilterFn = () => {
      const t = a.getCoreRowModel().flatRows[0], n = t == null ? void 0 : t.getValue(e.id);
      return typeof n == "string" ? En.includesString : typeof n == "number" ? En.inNumberRange : typeof n == "boolean" || n !== null && typeof n == "object" ? En.equals : Array.isArray(n) ? En.arrIncludes : En.weakEquals;
    }, e.getFilterFn = () => {
      var t, n;
      return Xs(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (t = (n = a.options.filterFns) == null ? void 0 : n[e.columnDef.filterFn]) != null ? t : En[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var t, n, l;
      return ((t = e.columnDef.enableColumnFilter) != null ? t : !0) && ((n = a.options.enableColumnFilters) != null ? n : !0) && ((l = a.options.enableFilters) != null ? l : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var t;
      return (t = a.getState().columnFilters) == null || (t = t.find((n) => n.id === e.id)) == null ? void 0 : t.value;
    }, e.getFilterIndex = () => {
      var t, n;
      return (t = (n = a.getState().columnFilters) == null ? void 0 : n.findIndex((l) => l.id === e.id)) != null ? t : -1;
    }, e.setFilterValue = (t) => {
      a.setColumnFilters((n) => {
        const l = e.getFilterFn(), o = n == null ? void 0 : n.find((c) => c.id === e.id), r = Xn(t, o ? o.value : void 0);
        if (lg(l, r, e)) {
          var i;
          return (i = n == null ? void 0 : n.filter((c) => c.id !== e.id)) != null ? i : [];
        }
        const s = {
          id: e.id,
          value: r
        };
        if (o) {
          var d;
          return (d = n == null ? void 0 : n.map((c) => c.id === e.id ? s : c)) != null ? d : [];
        }
        return n != null && n.length ? [...n, s] : [s];
      });
    };
  },
  createRow: (e, a) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (a) => {
      const t = e.getAllLeafColumns(), n = (l) => {
        var o;
        return (o = Xn(a, l)) == null ? void 0 : o.filter((r) => {
          const i = t.find((s) => s.id === r.id);
          if (i) {
            const s = i.getFilterFn();
            if (lg(s, r.value, i))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(n);
    }, e.resetColumnFilters = (a) => {
      var t, n;
      e.setColumnFilters(a ? [] : (t = (n = e.initialState) == null ? void 0 : n.columnFilters) != null ? t : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function lg(e, a, t) {
  return (e && e.autoRemove ? e.autoRemove(a, t) : !1) || typeof a > "u" || typeof a == "string" && !a;
}
const c9 = (e, a, t) => t.reduce((n, l) => {
  const o = l.getValue(e);
  return n + (typeof o == "number" ? o : 0);
}, 0), f9 = (e, a, t) => {
  let n;
  return t.forEach((l) => {
    const o = l.getValue(e);
    o != null && (n > o || n === void 0 && o >= o) && (n = o);
  }), n;
}, h9 = (e, a, t) => {
  let n;
  return t.forEach((l) => {
    const o = l.getValue(e);
    o != null && (n < o || n === void 0 && o >= o) && (n = o);
  }), n;
}, b9 = (e, a, t) => {
  let n, l;
  return t.forEach((o) => {
    const r = o.getValue(e);
    r != null && (n === void 0 ? r >= r && (n = l = r) : (n > r && (n = r), l < r && (l = r)));
  }), [n, l];
}, g9 = (e, a) => {
  let t = 0, n = 0;
  if (a.forEach((l) => {
    let o = l.getValue(e);
    o != null && (o = +o) >= o && (++t, n += o);
  }), t) return n / t;
}, m9 = (e, a) => {
  if (!a.length)
    return;
  const t = a.map((o) => o.getValue(e));
  if (!n9(t))
    return;
  if (t.length === 1)
    return t[0];
  const n = Math.floor(t.length / 2), l = t.sort((o, r) => o - r);
  return t.length % 2 !== 0 ? l[n] : (l[n - 1] + l[n]) / 2;
}, v9 = (e, a) => Array.from(new Set(a.map((t) => t.getValue(e))).values()), p9 = (e, a) => new Set(a.map((t) => t.getValue(e))).size, x9 = (e, a) => a.length, Kd = {
  sum: c9,
  min: f9,
  max: h9,
  extent: b9,
  mean: g9,
  median: m9,
  unique: v9,
  uniqueCount: p9,
  count: x9
}, y9 = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var a, t;
      return (a = (t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) != null ? a : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: Pa("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, a) => {
    e.toggleGrouping = () => {
      a.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((n) => n !== e.id) : [...t ?? [], e.id]);
    }, e.getCanGroup = () => {
      var t, n;
      return ((t = e.columnDef.enableGrouping) != null ? t : !0) && ((n = a.options.enableGrouping) != null ? n : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var t;
      return (t = a.getState().grouping) == null ? void 0 : t.includes(e.id);
    }, e.getGroupedIndex = () => {
      var t;
      return (t = a.getState().grouping) == null ? void 0 : t.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const t = e.getCanGroup();
      return () => {
        t && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const t = a.getCoreRowModel().flatRows[0], n = t == null ? void 0 : t.getValue(e.id);
      if (typeof n == "number")
        return Kd.sum;
      if (Object.prototype.toString.call(n) === "[object Date]")
        return Kd.extent;
    }, e.getAggregationFn = () => {
      var t, n;
      if (!e)
        throw new Error();
      return Xs(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (t = (n = a.options.aggregationFns) == null ? void 0 : n[e.columnDef.aggregationFn]) != null ? t : Kd[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (a) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(a), e.resetGrouping = (a) => {
      var t, n;
      e.setGrouping(a ? [] : (t = (n = e.initialState) == null ? void 0 : n.grouping) != null ? t : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, a) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (t) => {
      if (e._groupingValuesCache.hasOwnProperty(t))
        return e._groupingValuesCache[t];
      const n = a.getColumn(t);
      return n != null && n.columnDef.getGroupingValue ? (e._groupingValuesCache[t] = n.columnDef.getGroupingValue(e.original), e._groupingValuesCache[t]) : e.getValue(t);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, a, t, n) => {
    e.getIsGrouped = () => a.getIsGrouped() && a.id === t.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && a.getIsGrouped(), e.getIsAggregated = () => {
      var l;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((l = t.subRows) != null && l.length);
    };
  }
};
function k9(e, a, t) {
  if (!(a != null && a.length) || !t)
    return e;
  const n = e.filter((o) => !a.includes(o.id));
  return t === "remove" ? n : [...a.map((o) => e.find((r) => r.id === o)).filter(Boolean), ...n];
}
const w9 = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: Pa("columnOrder", e)
  }),
  createColumn: (e, a) => {
    e.getIndex = ct((t) => [ur(a, t)], (t) => t.findIndex((n) => n.id === e.id), ft(a.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (t) => {
      var n;
      return ((n = ur(a, t)[0]) == null ? void 0 : n.id) === e.id;
    }, e.getIsLastColumn = (t) => {
      var n;
      const l = ur(a, t);
      return ((n = l[l.length - 1]) == null ? void 0 : n.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (a) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(a), e.resetColumnOrder = (a) => {
      var t;
      e.setColumnOrder(a ? [] : (t = e.initialState.columnOrder) != null ? t : []);
    }, e._getOrderColumnsFn = ct(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (a, t, n) => (l) => {
      let o = [];
      if (!(a != null && a.length))
        o = l;
      else {
        const r = [...a], i = [...l];
        for (; i.length && r.length; ) {
          const s = r.shift(), d = i.findIndex((c) => c.id === s);
          d > -1 && o.push(i.splice(d, 1)[0]);
        }
        o = [...o, ...i];
      }
      return k9(o, t, n);
    }, ft(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Yd = () => ({
  left: [],
  right: []
}), C9 = {
  getInitialState: (e) => ({
    columnPinning: Yd(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: Pa("columnPinning", e)
  }),
  createColumn: (e, a) => {
    e.pin = (t) => {
      const n = e.getLeafColumns().map((l) => l.id).filter(Boolean);
      a.setColumnPinning((l) => {
        var o, r;
        if (t === "right") {
          var i, s;
          return {
            left: ((i = l == null ? void 0 : l.left) != null ? i : []).filter((f) => !(n != null && n.includes(f))),
            right: [...((s = l == null ? void 0 : l.right) != null ? s : []).filter((f) => !(n != null && n.includes(f))), ...n]
          };
        }
        if (t === "left") {
          var d, c;
          return {
            left: [...((d = l == null ? void 0 : l.left) != null ? d : []).filter((f) => !(n != null && n.includes(f))), ...n],
            right: ((c = l == null ? void 0 : l.right) != null ? c : []).filter((f) => !(n != null && n.includes(f)))
          };
        }
        return {
          left: ((o = l == null ? void 0 : l.left) != null ? o : []).filter((f) => !(n != null && n.includes(f))),
          right: ((r = l == null ? void 0 : l.right) != null ? r : []).filter((f) => !(n != null && n.includes(f)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((n) => {
      var l, o, r;
      return ((l = n.columnDef.enablePinning) != null ? l : !0) && ((o = (r = a.options.enableColumnPinning) != null ? r : a.options.enablePinning) != null ? o : !0);
    }), e.getIsPinned = () => {
      const t = e.getLeafColumns().map((i) => i.id), {
        left: n,
        right: l
      } = a.getState().columnPinning, o = t.some((i) => n == null ? void 0 : n.includes(i)), r = t.some((i) => l == null ? void 0 : l.includes(i));
      return o ? "left" : r ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var t, n;
      const l = e.getIsPinned();
      return l ? (t = (n = a.getState().columnPinning) == null || (n = n[l]) == null ? void 0 : n.indexOf(e.id)) != null ? t : -1 : 0;
    };
  },
  createRow: (e, a) => {
    e.getCenterVisibleCells = ct(() => [e._getAllVisibleCells(), a.getState().columnPinning.left, a.getState().columnPinning.right], (t, n, l) => {
      const o = [...n ?? [], ...l ?? []];
      return t.filter((r) => !o.includes(r.column.id));
    }, ft(a.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = ct(() => [e._getAllVisibleCells(), a.getState().columnPinning.left], (t, n) => (n ?? []).map((o) => t.find((r) => r.column.id === o)).filter(Boolean).map((o) => ({
      ...o,
      position: "left"
    })), ft(a.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = ct(() => [e._getAllVisibleCells(), a.getState().columnPinning.right], (t, n) => (n ?? []).map((o) => t.find((r) => r.column.id === o)).filter(Boolean).map((o) => ({
      ...o,
      position: "right"
    })), ft(a.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (a) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(a), e.resetColumnPinning = (a) => {
      var t, n;
      return e.setColumnPinning(a ? Yd() : (t = (n = e.initialState) == null ? void 0 : n.columnPinning) != null ? t : Yd());
    }, e.getIsSomeColumnsPinned = (a) => {
      var t;
      const n = e.getState().columnPinning;
      if (!a) {
        var l, o;
        return !!((l = n.left) != null && l.length || (o = n.right) != null && o.length);
      }
      return !!((t = n[a]) != null && t.length);
    }, e.getLeftLeafColumns = ct(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (a, t) => (t ?? []).map((n) => a.find((l) => l.id === n)).filter(Boolean), ft(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = ct(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (a, t) => (t ?? []).map((n) => a.find((l) => l.id === n)).filter(Boolean), ft(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = ct(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (a, t, n) => {
      const l = [...t ?? [], ...n ?? []];
      return a.filter((o) => !l.includes(o.id));
    }, ft(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function S9(e) {
  return e || (typeof document < "u" ? document : null);
}
const ui = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Jd = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), $9 = {
  getDefaultColumnDef: () => ui,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: Jd(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: Pa("columnSizing", e),
    onColumnSizingInfoChange: Pa("columnSizingInfo", e)
  }),
  createColumn: (e, a) => {
    e.getSize = () => {
      var t, n, l;
      const o = a.getState().columnSizing[e.id];
      return Math.min(Math.max((t = e.columnDef.minSize) != null ? t : ui.minSize, (n = o ?? e.columnDef.size) != null ? n : ui.size), (l = e.columnDef.maxSize) != null ? l : ui.maxSize);
    }, e.getStart = ct((t) => [t, ur(a, t), a.getState().columnSizing], (t, n) => n.slice(0, e.getIndex(t)).reduce((l, o) => l + o.getSize(), 0), ft(a.options, "debugColumns", "getStart")), e.getAfter = ct((t) => [t, ur(a, t), a.getState().columnSizing], (t, n) => n.slice(e.getIndex(t) + 1).reduce((l, o) => l + o.getSize(), 0), ft(a.options, "debugColumns", "getAfter")), e.resetSize = () => {
      a.setColumnSizing((t) => {
        let {
          [e.id]: n,
          ...l
        } = t;
        return l;
      });
    }, e.getCanResize = () => {
      var t, n;
      return ((t = e.columnDef.enableResizing) != null ? t : !0) && ((n = a.options.enableColumnResizing) != null ? n : !0);
    }, e.getIsResizing = () => a.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, a) => {
    e.getSize = () => {
      let t = 0;
      const n = (l) => {
        if (l.subHeaders.length)
          l.subHeaders.forEach(n);
        else {
          var o;
          t += (o = l.column.getSize()) != null ? o : 0;
        }
      };
      return n(e), t;
    }, e.getStart = () => {
      if (e.index > 0) {
        const t = e.headerGroup.headers[e.index - 1];
        return t.getStart() + t.getSize();
      }
      return 0;
    }, e.getResizeHandler = (t) => {
      const n = a.getColumn(e.column.id), l = n == null ? void 0 : n.getCanResize();
      return (o) => {
        if (!n || !l || (o.persist == null || o.persist(), Xd(o) && o.touches && o.touches.length > 1))
          return;
        const r = e.getSize(), i = e ? e.getLeafHeaders().map((k) => [k.column.id, k.column.getSize()]) : [[n.id, n.getSize()]], s = Xd(o) ? Math.round(o.touches[0].clientX) : o.clientX, d = {}, c = (k, $) => {
          typeof $ == "number" && (a.setColumnSizingInfo((S) => {
            var I, T;
            const A = a.options.columnResizeDirection === "rtl" ? -1 : 1, E = ($ - ((I = S == null ? void 0 : S.startOffset) != null ? I : 0)) * A, z = Math.max(E / ((T = S == null ? void 0 : S.startSize) != null ? T : 0), -0.999999);
            return S.columnSizingStart.forEach((B) => {
              let [W, _] = B;
              d[W] = Math.round(Math.max(_ + _ * z, 0) * 100) / 100;
            }), {
              ...S,
              deltaOffset: E,
              deltaPercentage: z
            };
          }), (a.options.columnResizeMode === "onChange" || k === "end") && a.setColumnSizing((S) => ({
            ...S,
            ...d
          })));
        }, f = (k) => c("move", k), g = (k) => {
          c("end", k), a.setColumnSizingInfo(($) => ({
            ...$,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, h = S9(t), v = {
          moveHandler: (k) => f(k.clientX),
          upHandler: (k) => {
            h == null || h.removeEventListener("mousemove", v.moveHandler), h == null || h.removeEventListener("mouseup", v.upHandler), g(k.clientX);
          }
        }, p = {
          moveHandler: (k) => (k.cancelable && (k.preventDefault(), k.stopPropagation()), f(k.touches[0].clientX), !1),
          upHandler: (k) => {
            var $;
            h == null || h.removeEventListener("touchmove", p.moveHandler), h == null || h.removeEventListener("touchend", p.upHandler), k.cancelable && (k.preventDefault(), k.stopPropagation()), g(($ = k.touches[0]) == null ? void 0 : $.clientX);
          }
        }, y = I9() ? {
          passive: !1
        } : !1;
        Xd(o) ? (h == null || h.addEventListener("touchmove", p.moveHandler, y), h == null || h.addEventListener("touchend", p.upHandler, y)) : (h == null || h.addEventListener("mousemove", v.moveHandler, y), h == null || h.addEventListener("mouseup", v.upHandler, y)), a.setColumnSizingInfo((k) => ({
          ...k,
          startOffset: s,
          startSize: r,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: i,
          isResizingColumn: n.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (a) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(a), e.setColumnSizingInfo = (a) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(a), e.resetColumnSizing = (a) => {
      var t;
      e.setColumnSizing(a ? {} : (t = e.initialState.columnSizing) != null ? t : {});
    }, e.resetHeaderSizeInfo = (a) => {
      var t;
      e.setColumnSizingInfo(a ? Jd() : (t = e.initialState.columnSizingInfo) != null ? t : Jd());
    }, e.getTotalSize = () => {
      var a, t;
      return (a = (t = e.getHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, l) => n + l.getSize(), 0)) != null ? a : 0;
    }, e.getLeftTotalSize = () => {
      var a, t;
      return (a = (t = e.getLeftHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, l) => n + l.getSize(), 0)) != null ? a : 0;
    }, e.getCenterTotalSize = () => {
      var a, t;
      return (a = (t = e.getCenterHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, l) => n + l.getSize(), 0)) != null ? a : 0;
    }, e.getRightTotalSize = () => {
      var a, t;
      return (a = (t = e.getRightHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, l) => n + l.getSize(), 0)) != null ? a : 0;
    };
  }
};
let ci = null;
function I9() {
  if (typeof ci == "boolean") return ci;
  let e = !1;
  try {
    const a = {
      get passive() {
        return e = !0, !1;
      }
    }, t = () => {
    };
    window.addEventListener("test", t, a), window.removeEventListener("test", t);
  } catch {
    e = !1;
  }
  return ci = e, ci;
}
function Xd(e) {
  return e.type === "touchstart";
}
const L9 = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: Pa("columnVisibility", e)
  }),
  createColumn: (e, a) => {
    e.toggleVisibility = (t) => {
      e.getCanHide() && a.setColumnVisibility((n) => ({
        ...n,
        [e.id]: t ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var t, n;
      const l = e.columns;
      return (t = l.length ? l.some((o) => o.getIsVisible()) : (n = a.getState().columnVisibility) == null ? void 0 : n[e.id]) != null ? t : !0;
    }, e.getCanHide = () => {
      var t, n;
      return ((t = e.columnDef.enableHiding) != null ? t : !0) && ((n = a.options.enableHiding) != null ? n : !0);
    }, e.getToggleVisibilityHandler = () => (t) => {
      e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
    };
  },
  createRow: (e, a) => {
    e._getAllVisibleCells = ct(() => [e.getAllCells(), a.getState().columnVisibility], (t) => t.filter((n) => n.column.getIsVisible()), ft(a.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = ct(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (t, n, l) => [...t, ...n, ...l], ft(a.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const a = (t, n) => ct(() => [n(), n().filter((l) => l.getIsVisible()).map((l) => l.id).join("_")], (l) => l.filter((o) => o.getIsVisible == null ? void 0 : o.getIsVisible()), ft(e.options, "debugColumns", t));
    e.getVisibleFlatColumns = a("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = a("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = a("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = a("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = a("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
      var n;
      e.setColumnVisibility(t ? {} : (n = e.initialState.columnVisibility) != null ? n : {});
    }, e.toggleAllColumnsVisible = (t) => {
      var n;
      t = (n = t) != null ? n : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((l, o) => ({
        ...l,
        [o.id]: t || !(o.getCanHide != null && o.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((t) => !(t.getIsVisible != null && t.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((t) => t.getIsVisible == null ? void 0 : t.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
      var n;
      e.toggleAllColumnsVisible((n = t.target) == null ? void 0 : n.checked);
    };
  }
};
function ur(e, a) {
  return a ? a === "center" ? e.getCenterVisibleLeafColumns() : a === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const T9 = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, E9 = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: Pa("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (a) => {
      var t;
      const n = (t = e.getCoreRowModel().flatRows[0]) == null || (t = t._getAllCellsByColumnId()[a.id]) == null ? void 0 : t.getValue();
      return typeof n == "string" || typeof n == "number";
    }
  }),
  createColumn: (e, a) => {
    e.getCanGlobalFilter = () => {
      var t, n, l, o;
      return ((t = e.columnDef.enableGlobalFilter) != null ? t : !0) && ((n = a.options.enableGlobalFilter) != null ? n : !0) && ((l = a.options.enableFilters) != null ? l : !0) && ((o = a.options.getColumnCanGlobalFilter == null ? void 0 : a.options.getColumnCanGlobalFilter(e)) != null ? o : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => En.includesString, e.getGlobalFilterFn = () => {
      var a, t;
      const {
        globalFilterFn: n
      } = e.options;
      return Xs(n) ? n : n === "auto" ? e.getGlobalAutoFilterFn() : (a = (t = e.options.filterFns) == null ? void 0 : t[n]) != null ? a : En[n];
    }, e.setGlobalFilter = (a) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(a);
    }, e.resetGlobalFilter = (a) => {
      e.setGlobalFilter(a ? void 0 : e.initialState.globalFilter);
    };
  }
}, A9 = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: Pa("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let a = !1, t = !1;
    e._autoResetExpanded = () => {
      var n, l;
      if (!a) {
        e._queue(() => {
          a = !0;
        });
        return;
      }
      if ((n = (l = e.options.autoResetAll) != null ? l : e.options.autoResetExpanded) != null ? n : !e.options.manualExpanding) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetExpanded(), t = !1;
        });
      }
    }, e.setExpanded = (n) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(n), e.toggleAllRowsExpanded = (n) => {
      n ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (n) => {
      var l, o;
      e.setExpanded(n ? {} : (l = (o = e.initialState) == null ? void 0 : o.expanded) != null ? l : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((n) => n.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (n) => {
      n.persist == null || n.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const n = e.getState().expanded;
      return n === !0 || Object.values(n).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const n = e.getState().expanded;
      return typeof n == "boolean" ? n === !0 : !(!Object.keys(n).length || e.getRowModel().flatRows.some((l) => !l.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let n = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((o) => {
        const r = o.split(".");
        n = Math.max(n, r.length);
      }), n;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, a) => {
    e.toggleExpanded = (t) => {
      a.setExpanded((n) => {
        var l;
        const o = n === !0 ? !0 : !!(n != null && n[e.id]);
        let r = {};
        if (n === !0 ? Object.keys(a.getRowModel().rowsById).forEach((i) => {
          r[i] = !0;
        }) : r = n, t = (l = t) != null ? l : !o, !o && t)
          return {
            ...r,
            [e.id]: !0
          };
        if (o && !t) {
          const {
            [e.id]: i,
            ...s
          } = r;
          return s;
        }
        return n;
      });
    }, e.getIsExpanded = () => {
      var t;
      const n = a.getState().expanded;
      return !!((t = a.options.getIsRowExpanded == null ? void 0 : a.options.getIsRowExpanded(e)) != null ? t : n === !0 || n != null && n[e.id]);
    }, e.getCanExpand = () => {
      var t, n, l;
      return (t = a.options.getRowCanExpand == null ? void 0 : a.options.getRowCanExpand(e)) != null ? t : ((n = a.options.enableExpanding) != null ? n : !0) && !!((l = e.subRows) != null && l.length);
    }, e.getIsAllParentsExpanded = () => {
      let t = !0, n = e;
      for (; t && n.parentId; )
        n = a.getRow(n.parentId, !0), t = n.getIsExpanded();
      return t;
    }, e.getToggleExpandedHandler = () => {
      const t = e.getCanExpand();
      return () => {
        t && e.toggleExpanded();
      };
    };
  }
}, Zu = 0, Qu = 10, Zd = () => ({
  pageIndex: Zu,
  pageSize: Qu
}), R9 = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...Zd(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: Pa("pagination", e)
  }),
  createTable: (e) => {
    let a = !1, t = !1;
    e._autoResetPageIndex = () => {
      var n, l;
      if (!a) {
        e._queue(() => {
          a = !0;
        });
        return;
      }
      if ((n = (l = e.options.autoResetAll) != null ? l : e.options.autoResetPageIndex) != null ? n : !e.options.manualPagination) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetPageIndex(), t = !1;
        });
      }
    }, e.setPagination = (n) => {
      const l = (o) => Xn(n, o);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(l);
    }, e.resetPagination = (n) => {
      var l;
      e.setPagination(n ? Zd() : (l = e.initialState.pagination) != null ? l : Zd());
    }, e.setPageIndex = (n) => {
      e.setPagination((l) => {
        let o = Xn(n, l.pageIndex);
        const r = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return o = Math.max(0, Math.min(o, r)), {
          ...l,
          pageIndex: o
        };
      });
    }, e.resetPageIndex = (n) => {
      var l, o;
      e.setPageIndex(n ? Zu : (l = (o = e.initialState) == null || (o = o.pagination) == null ? void 0 : o.pageIndex) != null ? l : Zu);
    }, e.resetPageSize = (n) => {
      var l, o;
      e.setPageSize(n ? Qu : (l = (o = e.initialState) == null || (o = o.pagination) == null ? void 0 : o.pageSize) != null ? l : Qu);
    }, e.setPageSize = (n) => {
      e.setPagination((l) => {
        const o = Math.max(1, Xn(n, l.pageSize)), r = l.pageSize * l.pageIndex, i = Math.floor(r / o);
        return {
          ...l,
          pageIndex: i,
          pageSize: o
        };
      });
    }, e.setPageCount = (n) => e.setPagination((l) => {
      var o;
      let r = Xn(n, (o = e.options.pageCount) != null ? o : -1);
      return typeof r == "number" && (r = Math.max(-1, r)), {
        ...l,
        pageCount: r
      };
    }), e.getPageOptions = ct(() => [e.getPageCount()], (n) => {
      let l = [];
      return n && n > 0 && (l = [...new Array(n)].fill(null).map((o, r) => r)), l;
    }, ft(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: n
      } = e.getState().pagination, l = e.getPageCount();
      return l === -1 ? !0 : l === 0 ? !1 : n < l - 1;
    }, e.previousPage = () => e.setPageIndex((n) => n - 1), e.nextPage = () => e.setPageIndex((n) => n + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var n;
      return (n = e.options.pageCount) != null ? n : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var n;
      return (n = e.options.rowCount) != null ? n : e.getPrePaginationRowModel().rows.length;
    };
  }
}, Qd = () => ({
  top: [],
  bottom: []
}), z9 = {
  getInitialState: (e) => ({
    rowPinning: Qd(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: Pa("rowPinning", e)
  }),
  createRow: (e, a) => {
    e.pin = (t, n, l) => {
      const o = n ? e.getLeafRows().map((s) => {
        let {
          id: d
        } = s;
        return d;
      }) : [], r = l ? e.getParentRows().map((s) => {
        let {
          id: d
        } = s;
        return d;
      }) : [], i = /* @__PURE__ */ new Set([...r, e.id, ...o]);
      a.setRowPinning((s) => {
        var d, c;
        if (t === "bottom") {
          var f, g;
          return {
            top: ((f = s == null ? void 0 : s.top) != null ? f : []).filter((p) => !(i != null && i.has(p))),
            bottom: [...((g = s == null ? void 0 : s.bottom) != null ? g : []).filter((p) => !(i != null && i.has(p))), ...Array.from(i)]
          };
        }
        if (t === "top") {
          var h, v;
          return {
            top: [...((h = s == null ? void 0 : s.top) != null ? h : []).filter((p) => !(i != null && i.has(p))), ...Array.from(i)],
            bottom: ((v = s == null ? void 0 : s.bottom) != null ? v : []).filter((p) => !(i != null && i.has(p)))
          };
        }
        return {
          top: ((d = s == null ? void 0 : s.top) != null ? d : []).filter((p) => !(i != null && i.has(p))),
          bottom: ((c = s == null ? void 0 : s.bottom) != null ? c : []).filter((p) => !(i != null && i.has(p)))
        };
      });
    }, e.getCanPin = () => {
      var t;
      const {
        enableRowPinning: n,
        enablePinning: l
      } = a.options;
      return typeof n == "function" ? n(e) : (t = n ?? l) != null ? t : !0;
    }, e.getIsPinned = () => {
      const t = [e.id], {
        top: n,
        bottom: l
      } = a.getState().rowPinning, o = t.some((i) => n == null ? void 0 : n.includes(i)), r = t.some((i) => l == null ? void 0 : l.includes(i));
      return o ? "top" : r ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var t, n;
      const l = e.getIsPinned();
      if (!l) return -1;
      const o = (t = l === "top" ? a.getTopRows() : a.getBottomRows()) == null ? void 0 : t.map((r) => {
        let {
          id: i
        } = r;
        return i;
      });
      return (n = o == null ? void 0 : o.indexOf(e.id)) != null ? n : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (a) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(a), e.resetRowPinning = (a) => {
      var t, n;
      return e.setRowPinning(a ? Qd() : (t = (n = e.initialState) == null ? void 0 : n.rowPinning) != null ? t : Qd());
    }, e.getIsSomeRowsPinned = (a) => {
      var t;
      const n = e.getState().rowPinning;
      if (!a) {
        var l, o;
        return !!((l = n.top) != null && l.length || (o = n.bottom) != null && o.length);
      }
      return !!((t = n[a]) != null && t.length);
    }, e._getPinnedRows = (a, t, n) => {
      var l;
      return ((l = e.options.keepPinnedRows) == null || l ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (t ?? []).map((r) => {
          const i = e.getRow(r, !0);
          return i.getIsAllParentsExpanded() ? i : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (t ?? []).map((r) => a.find((i) => i.id === r))
      )).filter(Boolean).map((r) => ({
        ...r,
        position: n
      }));
    }, e.getTopRows = ct(() => [e.getRowModel().rows, e.getState().rowPinning.top], (a, t) => e._getPinnedRows(a, t, "top"), ft(e.options, "debugRows", "getTopRows")), e.getBottomRows = ct(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (a, t) => e._getPinnedRows(a, t, "bottom"), ft(e.options, "debugRows", "getBottomRows")), e.getCenterRows = ct(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (a, t, n) => {
      const l = /* @__PURE__ */ new Set([...t ?? [], ...n ?? []]);
      return a.filter((o) => !l.has(o.id));
    }, ft(e.options, "debugRows", "getCenterRows"));
  }
}, D9 = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: Pa("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (a) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(a), e.resetRowSelection = (a) => {
      var t;
      return e.setRowSelection(a ? {} : (t = e.initialState.rowSelection) != null ? t : {});
    }, e.toggleAllRowsSelected = (a) => {
      e.setRowSelection((t) => {
        a = typeof a < "u" ? a : !e.getIsAllRowsSelected();
        const n = {
          ...t
        }, l = e.getPreGroupedRowModel().flatRows;
        return a ? l.forEach((o) => {
          o.getCanSelect() && (n[o.id] = !0);
        }) : l.forEach((o) => {
          delete n[o.id];
        }), n;
      });
    }, e.toggleAllPageRowsSelected = (a) => e.setRowSelection((t) => {
      const n = typeof a < "u" ? a : !e.getIsAllPageRowsSelected(), l = {
        ...t
      };
      return e.getRowModel().rows.forEach((o) => {
        _u(l, o.id, n, !0, e);
      }), l;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = ct(() => [e.getState().rowSelection, e.getCoreRowModel()], (a, t) => Object.keys(a).length ? _d(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ft(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = ct(() => [e.getState().rowSelection, e.getFilteredRowModel()], (a, t) => Object.keys(a).length ? _d(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ft(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = ct(() => [e.getState().rowSelection, e.getSortedRowModel()], (a, t) => Object.keys(a).length ? _d(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ft(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const a = e.getFilteredRowModel().flatRows, {
        rowSelection: t
      } = e.getState();
      let n = !!(a.length && Object.keys(t).length);
      return n && a.some((l) => l.getCanSelect() && !t[l.id]) && (n = !1), n;
    }, e.getIsAllPageRowsSelected = () => {
      const a = e.getPaginationRowModel().flatRows.filter((l) => l.getCanSelect()), {
        rowSelection: t
      } = e.getState();
      let n = !!a.length;
      return n && a.some((l) => !t[l.id]) && (n = !1), n;
    }, e.getIsSomeRowsSelected = () => {
      var a;
      const t = Object.keys((a = e.getState().rowSelection) != null ? a : {}).length;
      return t > 0 && t < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const a = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : a.filter((t) => t.getCanSelect()).some((t) => t.getIsSelected() || t.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (a) => {
      e.toggleAllRowsSelected(a.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (a) => {
      e.toggleAllPageRowsSelected(a.target.checked);
    };
  },
  createRow: (e, a) => {
    e.toggleSelected = (t, n) => {
      const l = e.getIsSelected();
      a.setRowSelection((o) => {
        var r;
        if (t = typeof t < "u" ? t : !l, e.getCanSelect() && l === t)
          return o;
        const i = {
          ...o
        };
        return _u(i, e.id, t, (r = n == null ? void 0 : n.selectChildren) != null ? r : !0, a), i;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: t
      } = a.getState();
      return Cf(e, t);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: t
      } = a.getState();
      return ec(e, t) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: t
      } = a.getState();
      return ec(e, t) === "all";
    }, e.getCanSelect = () => {
      var t;
      return typeof a.options.enableRowSelection == "function" ? a.options.enableRowSelection(e) : (t = a.options.enableRowSelection) != null ? t : !0;
    }, e.getCanSelectSubRows = () => {
      var t;
      return typeof a.options.enableSubRowSelection == "function" ? a.options.enableSubRowSelection(e) : (t = a.options.enableSubRowSelection) != null ? t : !0;
    }, e.getCanMultiSelect = () => {
      var t;
      return typeof a.options.enableMultiRowSelection == "function" ? a.options.enableMultiRowSelection(e) : (t = a.options.enableMultiRowSelection) != null ? t : !0;
    }, e.getToggleSelectedHandler = () => {
      const t = e.getCanSelect();
      return (n) => {
        var l;
        t && e.toggleSelected((l = n.target) == null ? void 0 : l.checked);
      };
    };
  }
}, _u = (e, a, t, n, l) => {
  var o;
  const r = l.getRow(a, !0);
  t ? (r.getCanMultiSelect() || Object.keys(e).forEach((i) => delete e[i]), r.getCanSelect() && (e[a] = !0)) : delete e[a], n && (o = r.subRows) != null && o.length && r.getCanSelectSubRows() && r.subRows.forEach((i) => _u(e, i.id, t, n, l));
};
function _d(e, a) {
  const t = e.getState().rowSelection, n = [], l = {}, o = function(r, i) {
    return r.map((s) => {
      var d;
      const c = Cf(s, t);
      if (c && (n.push(s), l[s.id] = s), (d = s.subRows) != null && d.length && (s = {
        ...s,
        subRows: o(s.subRows)
      }), c)
        return s;
    }).filter(Boolean);
  };
  return {
    rows: o(a.rows),
    flatRows: n,
    rowsById: l
  };
}
function Cf(e, a) {
  var t;
  return (t = a[e.id]) != null ? t : !1;
}
function ec(e, a, t) {
  var n;
  if (!((n = e.subRows) != null && n.length)) return !1;
  let l = !0, o = !1;
  return e.subRows.forEach((r) => {
    if (!(o && !l) && (r.getCanSelect() && (Cf(r, a) ? o = !0 : l = !1), r.subRows && r.subRows.length)) {
      const i = ec(r, a);
      i === "all" ? o = !0 : (i === "some" && (o = !0), l = !1);
    }
  }), l ? "all" : o ? "some" : !1;
}
const tc = /([0-9]+)/gm, B9 = (e, a, t) => Jx(ul(e.getValue(t)).toLowerCase(), ul(a.getValue(t)).toLowerCase()), M9 = (e, a, t) => Jx(ul(e.getValue(t)), ul(a.getValue(t))), O9 = (e, a, t) => Sf(ul(e.getValue(t)).toLowerCase(), ul(a.getValue(t)).toLowerCase()), P9 = (e, a, t) => Sf(ul(e.getValue(t)), ul(a.getValue(t))), F9 = (e, a, t) => {
  const n = e.getValue(t), l = a.getValue(t);
  return n > l ? 1 : n < l ? -1 : 0;
}, N9 = (e, a, t) => Sf(e.getValue(t), a.getValue(t));
function Sf(e, a) {
  return e === a ? 0 : e > a ? 1 : -1;
}
function ul(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function Jx(e, a) {
  const t = e.split(tc).filter(Boolean), n = a.split(tc).filter(Boolean);
  for (; t.length && n.length; ) {
    const l = t.shift(), o = n.shift(), r = parseInt(l, 10), i = parseInt(o, 10), s = [r, i].sort();
    if (isNaN(s[0])) {
      if (l > o)
        return 1;
      if (o > l)
        return -1;
      continue;
    }
    if (isNaN(s[1]))
      return isNaN(r) ? -1 : 1;
    if (r > i)
      return 1;
    if (i > r)
      return -1;
  }
  return t.length - n.length;
}
const Vo = {
  alphanumeric: B9,
  alphanumericCaseSensitive: M9,
  text: O9,
  textCaseSensitive: P9,
  datetime: F9,
  basic: N9
}, V9 = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: Pa("sorting", e),
    isMultiSortEvent: (a) => a.shiftKey
  }),
  createColumn: (e, a) => {
    e.getAutoSortingFn = () => {
      const t = a.getFilteredRowModel().flatRows.slice(10);
      let n = !1;
      for (const l of t) {
        const o = l == null ? void 0 : l.getValue(e.id);
        if (Object.prototype.toString.call(o) === "[object Date]")
          return Vo.datetime;
        if (typeof o == "string" && (n = !0, o.split(tc).length > 1))
          return Vo.alphanumeric;
      }
      return n ? Vo.text : Vo.basic;
    }, e.getAutoSortDir = () => {
      const t = a.getFilteredRowModel().flatRows[0];
      return typeof (t == null ? void 0 : t.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var t, n;
      if (!e)
        throw new Error();
      return Xs(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (t = (n = a.options.sortingFns) == null ? void 0 : n[e.columnDef.sortingFn]) != null ? t : Vo[e.columnDef.sortingFn];
    }, e.toggleSorting = (t, n) => {
      const l = e.getNextSortingOrder(), o = typeof t < "u" && t !== null;
      a.setSorting((r) => {
        const i = r == null ? void 0 : r.find((h) => h.id === e.id), s = r == null ? void 0 : r.findIndex((h) => h.id === e.id);
        let d = [], c, f = o ? t : l === "desc";
        if (r != null && r.length && e.getCanMultiSort() && n ? i ? c = "toggle" : c = "add" : r != null && r.length && s !== r.length - 1 ? c = "replace" : i ? c = "toggle" : c = "replace", c === "toggle" && (o || l || (c = "remove")), c === "add") {
          var g;
          d = [...r, {
            id: e.id,
            desc: f
          }], d.splice(0, d.length - ((g = a.options.maxMultiSortColCount) != null ? g : Number.MAX_SAFE_INTEGER));
        } else c === "toggle" ? d = r.map((h) => h.id === e.id ? {
          ...h,
          desc: f
        } : h) : c === "remove" ? d = r.filter((h) => h.id !== e.id) : d = [{
          id: e.id,
          desc: f
        }];
        return d;
      });
    }, e.getFirstSortDir = () => {
      var t, n;
      return ((t = (n = e.columnDef.sortDescFirst) != null ? n : a.options.sortDescFirst) != null ? t : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (t) => {
      var n, l;
      const o = e.getFirstSortDir(), r = e.getIsSorted();
      return r ? r !== o && ((n = a.options.enableSortingRemoval) == null || n) && // If enableSortRemove, enable in general
      (!(t && (l = a.options.enableMultiRemove) != null) || l) ? !1 : r === "desc" ? "asc" : "desc" : o;
    }, e.getCanSort = () => {
      var t, n;
      return ((t = e.columnDef.enableSorting) != null ? t : !0) && ((n = a.options.enableSorting) != null ? n : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var t, n;
      return (t = (n = e.columnDef.enableMultiSort) != null ? n : a.options.enableMultiSort) != null ? t : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var t;
      const n = (t = a.getState().sorting) == null ? void 0 : t.find((l) => l.id === e.id);
      return n ? n.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var t, n;
      return (t = (n = a.getState().sorting) == null ? void 0 : n.findIndex((l) => l.id === e.id)) != null ? t : -1;
    }, e.clearSorting = () => {
      a.setSorting((t) => t != null && t.length ? t.filter((n) => n.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const t = e.getCanSort();
      return (n) => {
        t && (n.persist == null || n.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? a.options.isMultiSortEvent == null ? void 0 : a.options.isMultiSortEvent(n) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (a) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(a), e.resetSorting = (a) => {
      var t, n;
      e.setSorting(a ? [] : (t = (n = e.initialState) == null ? void 0 : n.sorting) != null ? t : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, H9 = [
  i9,
  L9,
  w9,
  C9,
  d9,
  u9,
  T9,
  //depends on ColumnFaceting
  E9,
  //depends on ColumnFiltering
  V9,
  y9,
  //depends on RowSorting
  A9,
  R9,
  z9,
  D9,
  $9
];
function j9(e) {
  var a, t;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const n = [...H9, ...(a = e._features) != null ? a : []];
  let l = {
    _features: n
  };
  const o = l._features.reduce((g, h) => Object.assign(g, h.getDefaultOptions == null ? void 0 : h.getDefaultOptions(l)), {}), r = (g) => l.options.mergeOptions ? l.options.mergeOptions(o, g) : {
    ...o,
    ...g
  };
  let s = {
    ...{},
    ...(t = e.initialState) != null ? t : {}
  };
  l._features.forEach((g) => {
    var h;
    s = (h = g.getInitialState == null ? void 0 : g.getInitialState(s)) != null ? h : s;
  });
  const d = [];
  let c = !1;
  const f = {
    _features: n,
    options: {
      ...o,
      ...e
    },
    initialState: s,
    _queue: (g) => {
      d.push(g), c || (c = !0, Promise.resolve().then(() => {
        for (; d.length; )
          d.shift()();
        c = !1;
      }).catch((h) => setTimeout(() => {
        throw h;
      })));
    },
    reset: () => {
      l.setState(l.initialState);
    },
    setOptions: (g) => {
      const h = Xn(g, l.options);
      l.options = r(h);
    },
    getState: () => l.options.state,
    setState: (g) => {
      l.options.onStateChange == null || l.options.onStateChange(g);
    },
    _getRowId: (g, h, v) => {
      var p;
      return (p = l.options.getRowId == null ? void 0 : l.options.getRowId(g, h, v)) != null ? p : `${v ? [v.id, h].join(".") : h}`;
    },
    getCoreRowModel: () => (l._getCoreRowModel || (l._getCoreRowModel = l.options.getCoreRowModel(l)), l._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => l.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (g, h) => {
      let v = (h ? l.getPrePaginationRowModel() : l.getRowModel()).rowsById[g];
      if (!v && (v = l.getCoreRowModel().rowsById[g], !v))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${g}`) : new Error();
      return v;
    },
    _getDefaultColumnDef: ct(() => [l.options.defaultColumn], (g) => {
      var h;
      return g = (h = g) != null ? h : {}, {
        header: (v) => {
          const p = v.header.column.columnDef;
          return p.accessorKey ? p.accessorKey : p.accessorFn ? p.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (v) => {
          var p, y;
          return (p = (y = v.renderValue()) == null || y.toString == null ? void 0 : y.toString()) != null ? p : null;
        },
        ...l._features.reduce((v, p) => Object.assign(v, p.getDefaultColumnDef == null ? void 0 : p.getDefaultColumnDef()), {}),
        ...g
      };
    }, ft(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => l.options.columns,
    getAllColumns: ct(() => [l._getColumnDefs()], (g) => {
      const h = function(v, p, y) {
        return y === void 0 && (y = 0), v.map((k) => {
          const $ = r9(l, k, y, p), S = k;
          return $.columns = S.columns ? h(S.columns, $, y + 1) : [], $;
        });
      };
      return h(g);
    }, ft(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: ct(() => [l.getAllColumns()], (g) => g.flatMap((h) => h.getFlatColumns()), ft(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: ct(() => [l.getAllFlatColumns()], (g) => g.reduce((h, v) => (h[v.id] = v, h), {}), ft(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: ct(() => [l.getAllColumns(), l._getOrderColumnsFn()], (g, h) => {
      let v = g.flatMap((p) => p.getLeafColumns());
      return h(v);
    }, ft(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (g) => {
      const h = l._getAllFlatColumnsById()[g];
      return process.env.NODE_ENV !== "production" && !h && console.error(`[Table] Column with id '${g}' does not exist.`), h;
    }
  };
  Object.assign(l, f);
  for (let g = 0; g < l._features.length; g++) {
    const h = l._features[g];
    h == null || h.createTable == null || h.createTable(l);
  }
  return l;
}
function W9() {
  return (e) => ct(() => [e.options.data], (a) => {
    const t = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, n = function(l, o, r) {
      o === void 0 && (o = 0);
      const i = [];
      for (let d = 0; d < l.length; d++) {
        const c = s9(e, e._getRowId(l[d], d, r), l[d], d, o, void 0, r == null ? void 0 : r.id);
        if (t.flatRows.push(c), t.rowsById[c.id] = c, i.push(c), e.options.getSubRows) {
          var s;
          c.originalSubRows = e.options.getSubRows(l[d], d), (s = c.originalSubRows) != null && s.length && (c.subRows = n(c.originalSubRows, o + 1, c));
        }
      }
      return i;
    };
    return t.rows = n(a), t;
  }, ft(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function q9() {
  return (e) => ct(() => [e.getState().expanded, e.getPreExpandedRowModel(), e.options.paginateExpandedRows], (a, t, n) => !t.rows.length || a !== !0 && !Object.keys(a ?? {}).length || !n ? t : U9(t), ft(e.options, "debugTable", "getExpandedRowModel"));
}
function U9(e) {
  const a = [], t = (n) => {
    var l;
    a.push(n), (l = n.subRows) != null && l.length && n.getIsExpanded() && n.subRows.forEach(t);
  };
  return e.rows.forEach(t), {
    rows: a,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
/**
   * vue-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function fi() {
  return !0;
}
const G9 = Symbol("merge-proxy"), K9 = {
  get(e, a, t) {
    return a === G9 ? t : e.get(a);
  },
  has(e, a) {
    return e.has(a);
  },
  set: fi,
  deleteProperty: fi,
  getOwnPropertyDescriptor(e, a) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(a);
      },
      set: fi,
      deleteProperty: fi
    };
  },
  ownKeys(e) {
    return e.keys();
  }
};
function eu(e) {
  return "value" in e ? e.value : e;
}
function Ko() {
  for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++)
    a[t] = arguments[t];
  return new Proxy({
    get(n) {
      for (let l = a.length - 1; l >= 0; l--) {
        const o = eu(a[l])[n];
        if (o !== void 0) return o;
      }
    },
    has(n) {
      for (let l = a.length - 1; l >= 0; l--)
        if (n in eu(a[l])) return !0;
      return !1;
    },
    keys() {
      const n = [];
      for (let l = 0; l < a.length; l++) n.push(...Object.keys(eu(a[l])));
      return [...Array.from(new Set(n))];
    }
  }, K9);
}
const og = ke({
  props: ["render", "props"],
  setup: (e) => () => typeof e.render == "function" || typeof e.render == "object" ? gn(e.render, e.props) : e.render
});
function rg(e) {
  return Ko(e, {
    data: L(e.data)
  });
}
function Y9(e) {
  const a = vi(e.data), t = Ko({
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    mergeOptions(o, r) {
      return a ? {
        ...o,
        ...r
      } : Ko(o, r);
    }
  }, a ? rg(e) : e), n = j9(t);
  if (a) {
    const o = ko(e.data);
    $e(o, () => {
      n.setState((r) => ({
        ...r,
        data: o.value
      }));
    }, {
      immediate: !0
    });
  }
  const l = R(n.initialState);
  return Tg(() => {
    n.setOptions((o) => {
      var r;
      const i = new Proxy({}, {
        get: (s, d) => l.value[d]
      });
      return Ko(o, a ? rg(e) : e, {
        // merge the initialState and `options.state`
        // create a new proxy on each `setOptions` call
        // and get the value from state on each property access
        state: Ko(i, (r = e.state) != null ? r : {}),
        // Similarly, we'll maintain both our internal state and any user-provided
        // state.
        onStateChange: (s) => {
          s instanceof Function ? l.value = s(l.value) : l.value = s, e.onStateChange == null || e.onStateChange(s);
        }
      });
    });
  }), n;
}
const J9 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M2.21232%2014.0601C1.91928%2012.6755%201.93115%2011.2743%202.21316%209.94038C3.32308%2010.0711%204.29187%209.7035%204.60865%208.93871C4.92544%208.17392%204.50032%207.22896%203.62307%206.53655C4.3669%205.3939%205.34931%204.39471%206.53554%203.62289C7.228%204.50059%208.17324%204.92601%208.93822%204.60914C9.7032%204.29227%2010.0708%203.32308%209.93979%202.21281C11.3243%201.91977%2012.7255%201.93164%2014.0595%202.21364C13.9288%203.32356%2014.2964%204.29235%2015.0612%204.60914C15.8259%204.92593%2016.7709%204.5008%2017.4633%203.62356C18.606%204.36739%2019.6052%205.3498%2020.377%206.53602C19.4993%207.22849%2019.0739%208.17373%2019.3907%208.93871C19.7076%209.70369%2020.6768%2010.0713%2021.7871%209.94028C22.0801%2011.3248%2022.0682%2012.726%2021.7862%2014.06C20.6763%2013.9293%2019.7075%2014.2969%2019.3907%2015.0616C19.0739%2015.8264%2019.4991%2016.7714%2020.3763%2017.4638C19.6325%2018.6064%2018.6501%2019.6056%2017.4638%2020.3775C16.7714%2019.4998%2015.8261%2019.0743%2015.0612%2019.3912C14.2962%2019.7081%2013.9286%2020.6773%2014.0596%2021.7875C12.675%2022.0806%2011.2738%2022.0687%209.93989%2021.7867C10.0706%2020.6768%209.70301%2019.708%208.93822%2019.3912C8.17343%2019.0744%207.22848%2019.4995%206.53606%2020.3768C5.39341%2019.633%204.39422%2018.6506%203.62241%2017.4643C4.5001%2016.7719%204.92552%2015.8266%204.60865%2015.0616C4.29179%2014.2967%203.32259%2013.9291%202.21232%2014.0601ZM3.99975%2012.2104C5.09956%2012.5148%206.00718%2013.2117%206.45641%2014.2963C6.90564%2015.3808%206.75667%2016.5154%206.19421%2017.5083C6.29077%2017.61%206.38998%2017.7092%206.49173%2017.8056C7.4846%2017.2432%208.61912%2017.0943%209.70359%2017.5435C10.7881%2017.9927%2011.485%2018.9002%2011.7894%2019.9999C11.9295%2020.0037%2012.0697%2020.0038%2012.2099%2020.0001C12.5143%2018.9003%2013.2112%2017.9927%2014.2958%2017.5435C15.3803%2017.0942%2016.5149%2017.2432%2017.5078%2017.8057C17.6096%2017.7091%2017.7087%2017.6099%2017.8051%2017.5081C17.2427%2016.5153%2017.0938%2015.3807%2017.543%2014.2963C17.9922%2013.2118%2018.8997%2012.5149%2019.9994%2012.2105C20.0032%2012.0704%2020.0033%2011.9301%2019.9996%2011.7899C18.8998%2011.4856%2017.9922%2010.7886%2017.543%209.70407C17.0937%208.61953%2017.2427%207.48494%2017.8052%206.49204C17.7086%206.39031%2017.6094%206.2912%2017.5076%206.19479C16.5148%206.75717%2015.3803%206.9061%2014.2958%206.4569C13.2113%206.0077%2012.5144%205.10016%2012.21%204.00044C12.0699%203.99666%2011.9297%203.99659%2011.7894%204.00024C11.4851%205.10005%2010.7881%206.00767%209.70359%206.4569C8.61904%206.90613%207.48446%206.75715%206.49155%206.1947C6.38982%206.29126%206.29071%206.39047%206.19431%206.49222C6.75668%207.48509%206.90561%208.61961%206.45641%209.70407C6.00721%2010.7885%205.09967%2011.4855%203.99995%2011.7899C3.99617%2011.93%203.9961%2012.0702%203.99975%2012.2104ZM11.9997%2015.0002C10.3428%2015.0002%208.99969%2013.657%208.99969%2012.0002C8.99969%2010.3433%2010.3428%209.00018%2011.9997%209.00018C13.6565%209.00018%2014.9997%2010.3433%2014.9997%2012.0002C14.9997%2013.657%2013.6565%2015.0002%2011.9997%2015.0002ZM11.9997%2013.0002C12.552%2013.0002%2012.9997%2012.5525%2012.9997%2012.0002C12.9997%2011.4479%2012.552%2011.0002%2011.9997%2011.0002C11.4474%2011.0002%2010.9997%2011.4479%2010.9997%2012.0002C10.9997%2012.5525%2011.4474%2013.0002%2011.9997%2013.0002Z'/%3e%3c/svg%3e", X9 = {
  selectAll: "Select all on this page",
  selectRow: (e, a) => `Select row ${a + 1}`,
  selectedCount: (e) => e === 1 ? "1 row selected" : `${e} rows selected`,
  actionsColumn: "Actions",
  rowActions: (e, a) => `Actions for row ${a + 1}`,
  toggleSubRows: (e, a) => `Sub-rows of row ${a + 1}`,
  moveUp: "Move up",
  moveDown: "Move down",
  rowMovedUp: "Row moved up",
  rowMovedDown: "Row moved down",
  rowMovedInto: (e) => `Row moved into ${e}`
};
function Z9(e, a, t) {
  return {
    key: "move",
    items: [
      { label: a.moveUp, icon: "ri-arrow-up-line", disabled: !e.canMoveUp, testId: "row-menu-move-up", onClick: () => t(-1) },
      { label: a.moveDown, icon: "ri-arrow-down-line", disabled: !e.canMoveDown, testId: "row-menu-move-down", onClick: () => t(1) }
    ]
  };
}
function Q9(e, a) {
  const t = /* @__PURE__ */ new Map(), n = { key: "destructive", items: [] };
  for (const o of e) {
    const r = {
      label: o.label,
      icon: o.icon,
      danger: o.destructive,
      disabled: o.disabled,
      description: o.description,
      testId: o.testId,
      onClick: () => a(o.id)
    };
    if (o.destructive) {
      n.items.push(r);
      continue;
    }
    const i = `group-${o.group ?? ""}`;
    t.has(i) || t.set(i, { key: i, items: [] }), t.get(i).items.push(r);
  }
  const l = [...t.values()];
  return n.items.length && l.push(n), l;
}
const _9 = { class: "grid h-[calc(--spacing(12)-1px)] grid-cols-[1fr_auto] items-center" }, eH = { class: "flex justify-center" }, tH = {
  key: 0,
  "data-testid": "data-row-pin",
  class: "ri-pushpin-fill inline-flex size-(--icon-size-xs) items-center justify-center text-(length:--icon-size-xs) leading-(--icon-size-xs) text-(--colors-text-accent-strong)",
  "aria-hidden": "true"
}, aH = /* @__PURE__ */ ke({
  __name: "DataTableRowActions",
  props: {
    actions: {},
    label: {},
    pinned: { type: Boolean, default: !1 },
    leadingGroups: { default: () => [] }
  },
  emits: ["select"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => [
      ...t.leadingGroups,
      ...Q9(t.actions, (o) => n("select", o))
    ]);
    return (o, r) => (u(), b("div", _9, [
      x("span", eH, [
        e.pinned ? (u(), b("i", tH)) : w("", !0)
      ]),
      l.value.length ? (u(), P(Ra, {
        key: 0,
        groups: l.value,
        "menu-align": "right"
      }, {
        trigger: me(({ triggerProps: i }) => [
          U(Be, Ve({
            variant: "ghost",
            size: "md",
            "icon-only": "",
            "icon-left": "ri-more-fill",
            "aria-label": e.label,
            "data-testid": "data-row-actions-trigger"
          }, i), null, 16, ["aria-label"])
        ]),
        _: 1
      }, 8, ["groups"])) : w("", !0)
    ]));
  }
}), nH = ["data-type"], lH = {
  key: 0,
  "data-part": "elbow",
  class: "absolute top-6 left-px w-3 border-t border-(--colors-border-base-medium) dark:border-(--colors-border-base)"
}, oH = /* @__PURE__ */ ke({
  __name: "DataTableTreeConnector",
  props: {
    type: { default: "middle" }
  },
  setup(e) {
    return (a, t) => (u(), b("span", {
      "data-testid": "data-table-tree-connector",
      "data-type": e.type,
      "aria-hidden": "true",
      class: "pointer-events-none absolute top-0 h-12 w-5"
    }, [
      x("span", {
        "data-part": "stem",
        class: C(["absolute top-0 left-0 border-l border-(--colors-border-base-medium) dark:border-(--colors-border-base)", e.type === "last" ? "h-[25px]" : "h-12"])
      }, null, 2),
      e.type !== "through" ? (u(), b("span", lH)) : w("", !0)
    ], 8, nH));
  }
}), rH = /* @__PURE__ */ new Set(["http:", "https:", "mailto:", "tel:"]), iH = "http://relative.invalid";
function sH(e) {
  try {
    return rH.has(new URL(e, iH).protocol);
  } catch {
    return !1;
  }
}
const dH = {
  text: "Text",
  "text-helper": "Text & helper",
  "checkbox-text": "Checkbox & text",
  "icons-text": "Side icons & text",
  icon: "Only icon",
  "icon-button": "Icon & button",
  "flag-text": "Flag & text",
  "badge-dot": "Badge dot",
  "avatar-group": "Avatar group",
  link: "Link",
  "progress-bar": "Progress bar",
  toggle: "With form",
  "toggle-labels": "Toggle & labels",
  rating: "Rating",
  buttons: "Buttons",
  checkbox: "Checkbox",
  user: "User",
  badge: "Badge",
  "two-data": "2 data",
  "logo-text": "Logo & text",
  "separate-data": "Separate data",
  date: "date format",
  input: "With input",
  "badge-name": "Badge & Name",
  "badge-helper": "Badge & helper",
  badges: "3 badges",
  "icon-shape-link": "icon shape & text link"
}, uH = /^(\d{4})-(\d{2})-(\d{2})$/;
function cH(e, a = "en-GB") {
  if (e == null || e === "") return "";
  const t = typeof e == "string" ? uH.exec(e) : null, n = t ? new Date(Number(t[1]), Number(t[2]) - 1, Number(t[3])) : e instanceof Date ? e : new Date(e);
  return Number.isNaN(n.getTime()) ? String(e) : new Intl.DateTimeFormat(a, { day: "2-digit", month: "2-digit", year: "numeric" }).format(n);
}
function fH(e, a, t, n) {
  return e.data ? { type: e.type, data: e.data(a, t) } : e.type === "date" ? { type: "date", data: { value: n } } : { type: "text", data: { text: n == null ? "" : String(n) } };
}
const hH = {
  key: 2,
  class: "flex min-w-0 flex-col gap-px"
}, bH = {
  key: 3,
  class: "flex min-w-0 items-center gap-2"
}, gH = ["for"], mH = {
  key: 4,
  class: "flex min-w-0 items-center gap-2"
}, vH = { class: "min-w-0" }, pH = {
  key: 5,
  class: "flex"
}, xH = { class: "sr-only" }, yH = {
  key: 6,
  class: "flex min-w-0 items-center gap-3"
}, kH = { class: "flex min-w-0 items-center gap-2" }, wH = { class: "min-w-0" }, CH = {
  key: 7,
  class: "flex min-w-0 items-center gap-2"
}, SH = { class: "min-w-0" }, $H = {
  key: 8,
  class: "flex min-w-0 items-center"
}, IH = {
  key: 10,
  class: "flex min-w-0 items-center"
}, LH = {
  key: 1,
  class: "min-w-0"
}, TH = {
  key: 12,
  class: "flex min-w-0 items-center gap-2.5"
}, EH = ["for"], AH = {
  key: 14,
  class: "flex min-w-0 items-center gap-2"
}, RH = {
  class: "flex shrink-0 items-center gap-1",
  "aria-hidden": "true"
}, zH = { class: "sr-only" }, DH = {
  key: 15,
  class: "flex min-w-0 items-center gap-2"
}, BH = {
  key: 16,
  class: "flex"
}, MH = {
  key: 17,
  class: "flex min-w-0 items-center gap-1.5",
  "data-testid": "data-table-cell-user-link"
}, OH = { class: "flex min-w-0 flex-1 flex-col gap-px" }, PH = {
  key: 19,
  class: "flex min-w-0 items-center"
}, FH = {
  key: 20,
  class: "flex min-w-0 flex-col gap-1"
}, NH = { class: "flex min-w-0 items-center gap-1.5" }, VH = { class: "min-w-0" }, HH = { class: "flex min-w-0 items-center gap-1.5" }, jH = { class: "min-w-0" }, WH = {
  key: 21,
  class: "flex min-w-0 items-center gap-2"
}, qH = ["src", "alt"], UH = {
  key: 1,
  class: "min-w-0"
}, GH = {
  key: 1,
  class: "shrink-0 whitespace-nowrap"
}, KH = {
  key: 2,
  class: "min-w-0"
}, YH = {
  key: 24,
  class: "flex min-w-0 items-center gap-2"
}, JH = { class: "min-w-0" }, XH = {
  key: 25,
  class: "flex min-w-0 flex-col gap-px"
}, ZH = { class: "flex min-w-0 items-center gap-2" }, QH = { class: "min-w-0" }, _H = {
  key: 26,
  class: "flex min-w-0 items-center gap-1"
}, e7 = {
  key: 27,
  class: "flex min-w-0 items-center gap-2"
}, t7 = {
  key: 1,
  class: "min-w-0"
}, ig = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", tu = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)", sg = "text-(--text-text-disabled-strong) dark:text-(--text-text-disabled-light)", Yl = "inline-flex size-4 shrink-0 items-center justify-center text-(length:--icon-size-sm) leading-(--icon-size-sm)", a7 = /* @__PURE__ */ ke({
  __name: "DataTableTypedCell",
  props: {
    cell: {},
    muted: { type: Boolean, default: !1 },
    linkAs: { default: "a" }
  },
  emits: ["action", "change"],
  setup(e, { emit: a }) {
    var A;
    const t = e, n = a, l = m(() => t.muted ? sg : "text-(--text-text-heading) dark:text-(--text-text-white-default)"), o = m(() => t.muted ? sg : "text-(--text-text-body) dark:text-(--text-text-white-secondary)"), r = m(
      () => t.muted ? "text-(--icons-icon-disabled-strong) dark:text-(--icons-icon-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
    ), i = m(() => t.muted ? "bg-(--icons-icon-disabled-strong)" : "bg-(--icons-icon-base-strong)");
    function s(E) {
      return t.muted ? "disabled" : E;
    }
    const d = Ye(), c = Ye(), f = m(
      () => t.cell.type === "badges" ? Es(t.cell.data.badges ?? [], t.cell.data.max ?? 2) : []
    ), g = m(
      () => {
        var E, z;
        return t.cell.type === "badges" ? s(((z = (E = t.cell.data.badges) == null ? void 0 : E[0]) == null ? void 0 : z.theme) ?? "neutral") : void 0;
      }
    ), h = m(() => {
      if (t.cell.type !== "rating") return;
      const E = t.cell.data.max ?? 5, z = Math.min(Math.max(t.cell.data.value ?? 0, 0), E), B = z.toFixed(1);
      return {
        stars: Array.from({ length: E }, (W, _) => _ < Math.round(z)),
        score: B,
        label: t.cell.data.ariaLabel ?? `${B} out of ${E}`
      };
    }), v = (E) => E.to != null && t.linkAs !== "a", p = (E) => !v(E) && !!E.href && !sH(E.href), y = (E) => v(E) || !!E.href && !p(E);
    function k(E) {
      return v(E) ? { as: t.linkAs, to: E.to, target: E.target } : E.href ? { as: "a", href: E.href, target: E.target } : { as: "button" };
    }
    function $() {
      if (t.cell.type !== "link" && t.cell.type !== "icon-shape-link") return;
      const E = t.cell.data;
      !v(E) && !E.href && n("action", E.actionId ?? "link");
    }
    const S = m(() => t.cell.type === "user" && y(t.cell.data));
    typeof process < "u" && ((A = process.env) == null ? void 0 : A.NODE_ENV) !== "production" && $e(
      () => "to" in t.cell.data && t.cell.data.to != null && t.linkAs === "a",
      (E) => {
        E && console.warn("[OPAL DataTable] cell links with `to` need the table's `linkAs` (e.g. RouterLink).");
      },
      { immediate: !0 }
    );
    const T = m(
      () => t.cell.type === "date" ? cH(t.cell.data.value, t.cell.data.locale) : ""
    );
    return (E, z) => {
      var B;
      return e.cell.type === "text" ? (u(), P(it, {
        key: 0,
        text: e.cell.data.text,
        "text-class": o.value
      }, null, 8, ["text", "text-class"])) : e.cell.type === "date" ? (u(), P(it, {
        key: 1,
        text: T.value,
        "text-class": o.value
      }, null, 8, ["text", "text-class"])) : e.cell.type === "text-helper" ? (u(), b("div", hH, [
        U(it, {
          text: e.cell.data.text,
          "text-class": [ig, l.value].join(" ")
        }, null, 8, ["text", "text-class"]),
        U(it, {
          text: e.cell.data.helper,
          "text-class": [tu, o.value].join(" ")
        }, null, 8, ["text", "text-class"])
      ])) : e.cell.type === "checkbox-text" ? (u(), b("div", bH, [
        U(va, {
          id: L(c),
          "model-value": e.cell.data.checked,
          "aria-label": e.cell.data.text,
          disabled: e.cell.data.disabled,
          "onUpdate:modelValue": z[0] || (z[0] = (W) => n("change", { type: "checkbox-text", value: W }))
        }, null, 8, ["id", "model-value", "aria-label", "disabled"]),
        x("label", {
          for: L(c),
          class: C(["min-w-0", e.cell.data.disabled ? "cursor-not-allowed" : "cursor-pointer"])
        }, [
          U(it, {
            text: e.cell.data.text,
            "text-class": o.value
          }, null, 8, ["text", "text-class"])
        ], 10, gH),
        e.cell.data.icon ? (u(), b("i", {
          key: 0,
          class: C([e.cell.data.icon, Yl, r.value]),
          "aria-hidden": "true"
        }, null, 2)) : w("", !0)
      ])) : e.cell.type === "icons-text" ? (u(), b("div", mH, [
        e.cell.data.leftIcon ? (u(), b("i", {
          key: 0,
          class: C([e.cell.data.leftIcon, Yl, r.value]),
          "aria-hidden": "true"
        }, null, 2)) : w("", !0),
        x("span", vH, [
          U(it, {
            text: e.cell.data.text,
            "text-class": o.value
          }, null, 8, ["text", "text-class"])
        ]),
        e.cell.data.rightIcon ? (u(), b("i", {
          key: 1,
          class: C([e.cell.data.rightIcon, Yl, r.value]),
          "aria-hidden": "true"
        }, null, 2)) : w("", !0)
      ])) : e.cell.type === "icon" ? (u(), b("span", pH, [
        x("i", {
          class: C([
            e.cell.data.icon,
            "inline-flex size-5 shrink-0 items-center justify-center text-(length:--icon-size-md) leading-(--icon-size-md)",
            r.value
          ]),
          "aria-hidden": "true"
        }, null, 2),
        x("span", xH, H(e.cell.data.label), 1)
      ])) : e.cell.type === "icon-button" ? (u(), b("div", yH, [
        x("div", kH, [
          e.cell.data.icon ? (u(), b("i", {
            key: 0,
            class: C([e.cell.data.icon, Yl, r.value]),
            "aria-hidden": "true"
          }, null, 2)) : w("", !0),
          x("span", wH, [
            U(it, {
              text: e.cell.data.text,
              "text-class": l.value
            }, null, 8, ["text", "text-class"])
          ])
        ]),
        U(Be, {
          variant: "secondary",
          size: "xs",
          label: e.cell.data.button.label,
          "icon-left": e.cell.data.button.icon,
          "aria-label": e.cell.data.button.ariaLabel,
          disabled: e.cell.data.button.disabled,
          class: "shrink-0",
          onClick: z[1] || (z[1] = (W) => n("action", e.cell.data.button.id))
        }, null, 8, ["label", "icon-left", "aria-label", "disabled"])
      ])) : e.cell.type === "flag-text" ? (u(), b("div", CH, [
        x("span", {
          class: C(["fi fis size-4 shrink-0 rounded-full text-(length:--icon-size-sm)", `fi-${e.cell.data.country.toLowerCase()}`]),
          "data-testid": "data-table-cell-flag",
          "aria-hidden": "true"
        }, null, 2),
        x("span", SH, [
          U(it, {
            text: e.cell.data.text,
            "text-class": l.value
          }, null, 8, ["text", "text-class"])
        ])
      ])) : e.cell.type === "badge-dot" ? (u(), b("div", $H, [
        U(yt, {
          type: "with-dot",
          size: "sm",
          label: e.cell.data.label,
          theme: s(e.cell.data.theme),
          truncate: e.cell.data.truncate ?? !1
        }, null, 8, ["label", "theme", "truncate"])
      ])) : e.cell.type === "avatar-group" ? (u(), P(vf, {
        key: 9,
        size: "md",
        avatars: e.cell.data.avatars,
        max: e.cell.data.max ?? 5,
        "aria-label": e.cell.data.label
      }, null, 8, ["avatars", "max", "aria-label"])) : e.cell.type === "link" ? (u(), b("div", IH, [
        p(e.cell.data) ? (u(), b("span", LH, [
          U(it, {
            text: e.cell.data.text,
            "text-class": l.value
          }, null, 8, ["text", "text-class"])
        ])) : (u(), P(pa, Ve({ key: 0 }, k(e.cell.data), {
          "icon-left": e.cell.data.leftIcon,
          "icon-right": e.cell.data.rightIcon,
          "aria-label": e.cell.data.ariaLabel,
          disabled: e.cell.data.disabled,
          class: "min-w-0 max-w-full",
          onClick: $
        }), {
          default: me(() => [
            U(it, {
              text: e.cell.data.text,
              focusable: !1
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 16, ["icon-left", "icon-right", "aria-label", "disabled"]))
      ])) : e.cell.type === "progress-bar" ? (u(), P(Dr, {
        key: 11,
        class: "w-full min-w-0",
        value: e.cell.data.value,
        max: e.cell.data.max,
        label: e.cell.data.label,
        "value-label": e.cell.data.valueLabel,
        "aria-label": e.cell.data.ariaLabel
      }, null, 8, ["value", "max", "label", "value-label", "aria-label"])) : e.cell.type === "toggle" ? (u(), b("div", TH, [
        U(Un, {
          id: L(d),
          "model-value": e.cell.data.checked,
          disabled: e.cell.data.disabled,
          "onUpdate:modelValue": z[2] || (z[2] = (W) => n("change", { type: "toggle", value: W }))
        }, null, 8, ["id", "model-value", "disabled"]),
        x("label", {
          for: L(d),
          class: C(["min-w-0", e.cell.data.disabled ? "cursor-not-allowed" : "cursor-pointer"])
        }, [
          U(it, {
            text: e.cell.data.label,
            "text-class": l.value,
            focusable: !1
          }, null, 8, ["text", "text-class"])
        ], 10, EH)
      ])) : e.cell.type === "toggle-labels" ? (u(), P(kO, {
        key: 13,
        type: "left-right-label",
        "model-value": e.cell.data.value,
        label: e.cell.data.label,
        "left-label": e.cell.data.leftLabel,
        "right-label": e.cell.data.rightLabel,
        disabled: e.cell.data.disabled,
        "onUpdate:modelValue": z[3] || (z[3] = (W) => n("change", { type: "toggle-labels", value: W }))
      }, null, 8, ["model-value", "label", "left-label", "right-label", "disabled"])) : e.cell.type === "rating" && h.value ? (u(), b("div", AH, [
        x("span", RH, [
          (u(!0), b(ie, null, Oe(h.value.stars, (W, _) => (u(), b("i", {
            key: _,
            class: C([
              W ? "ri-star-s-fill" : "ri-star-s-line",
              "inline-flex size-4.5 items-center justify-center text-[length:--spacing(4.5)] leading-none text-(--icons-icon-warning)"
            ]),
            "data-testid": "data-table-cell-star"
          }, null, 2))), 128))
        ]),
        x("span", {
          class: C(l.value),
          "aria-hidden": "true"
        }, H(h.value.score), 3),
        x("span", zH, H(h.value.label), 1)
      ])) : e.cell.type === "buttons" ? (u(), b("div", DH, [
        (u(!0), b(ie, null, Oe(e.cell.data.buttons, (W) => (u(), P(Be, {
          key: W.id,
          variant: W.variant ?? "secondary",
          size: "xs",
          label: W.label,
          "icon-left": W.icon,
          "dropdown-icon": W.dropdownIcon,
          "aria-label": W.ariaLabel,
          disabled: W.disabled,
          shrink: "",
          onClick: (_) => n("action", W.id)
        }, null, 8, ["variant", "label", "icon-left", "dropdown-icon", "aria-label", "disabled", "onClick"]))), 128))
      ])) : e.cell.type === "checkbox" ? (u(), b("span", BH, [
        U(va, {
          "model-value": e.cell.data.checked,
          "aria-label": e.cell.data.label,
          disabled: e.cell.data.disabled,
          "onUpdate:modelValue": z[4] || (z[4] = (W) => n("change", { type: "checkbox", value: W }))
        }, null, 8, ["model-value", "aria-label", "disabled"])
      ])) : e.cell.type === "user" && S.value ? (u(), b("div", MH, [
        U(Jt, {
          name: e.cell.data.name,
          img: e.cell.data.img,
          size: "sm",
          presentational: ""
        }, null, 8, ["name", "img"]),
        x("div", OH, [
          U(pa, Ve(k(e.cell.data), {
            size: "s",
            class: "min-w-0 max-w-full self-start py-0"
          }), {
            default: me(() => [
              U(it, {
                text: e.cell.data.name,
                focusable: !1
              }, null, 8, ["text"])
            ]),
            _: 1
          }, 16),
          (B = e.cell.data.helper) != null && B.trim() ? (u(), P(it, {
            key: 0,
            text: e.cell.data.helper,
            "text-class": ["text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)", o.value].join(" ")
          }, null, 8, ["text", "text-class"])) : w("", !0)
        ])
      ])) : e.cell.type === "user" ? (u(), P(Sx, {
        key: 18,
        class: "min-w-0 [&_[data-testid=avatar-label-name]]:text-(length:--size-m)",
        type: "heading-helper",
        size: "sm",
        name: e.cell.data.name,
        "helper-text": e.cell.data.helper,
        img: e.cell.data.img
      }, null, 8, ["name", "helper-text", "img"])) : e.cell.type === "badge" ? (u(), b("div", PH, [
        U(yt, {
          size: "sm",
          label: e.cell.data.label,
          theme: e.cell.data.theme,
          "left-icon": e.cell.data.icon,
          truncate: e.cell.data.truncate ?? !1
        }, null, 8, ["label", "theme", "left-icon", "truncate"])
      ])) : e.cell.type === "two-data" ? (u(), b("div", FH, [
        x("div", NH, [
          x("i", {
            class: C([e.cell.data.first.icon, Yl, r.value]),
            "aria-hidden": "true"
          }, null, 2),
          x("span", VH, [
            U(it, {
              text: e.cell.data.first.text,
              "text-class": [ig, l.value].join(" ")
            }, null, 8, ["text", "text-class"])
          ])
        ]),
        x("div", HH, [
          x("i", {
            class: C([e.cell.data.second.icon, Yl, r.value]),
            "aria-hidden": "true"
          }, null, 2),
          x("span", jH, [
            U(it, {
              text: e.cell.data.second.text,
              "text-class": [tu, l.value].join(" ")
            }, null, 8, ["text", "text-class"])
          ])
        ])
      ])) : e.cell.type === "logo-text" ? (u(), b("div", WH, [
        x("img", {
          src: e.cell.data.src,
          alt: e.cell.data.alt ?? "",
          class: "size-8 shrink-0 object-contain",
          "data-testid": "data-table-cell-logo"
        }, null, 8, qH),
        y(e.cell.data) ? (u(), P(pa, Ve({ key: 0 }, k(e.cell.data), {
          class: "min-w-0 max-w-full",
          "data-testid": "data-table-cell-logo-link"
        }), {
          default: me(() => [
            U(it, {
              text: e.cell.data.text,
              focusable: !1
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 16)) : (u(), b("span", UH, [
          U(it, {
            text: e.cell.data.text,
            "text-class": l.value
          }, null, 8, ["text", "text-class"])
        ]))
      ])) : e.cell.type === "separate-data" ? (u(), b("div", {
        key: 22,
        class: C(["flex min-w-0 items-center gap-2", o.value])
      }, [
        (u(!0), b(ie, null, Oe(e.cell.data.items, (W, _) => (u(), b(ie, { key: _ }, [
          _ > 0 ? (u(), b("span", {
            key: 0,
            class: C(["size-0.75 shrink-0 rounded-full", i.value]),
            "data-testid": "data-table-cell-separator",
            "aria-hidden": "true"
          }, null, 2)) : w("", !0),
          _ < e.cell.data.items.length - 1 ? (u(), b("span", GH, H(W), 1)) : (u(), b("span", KH, [
            U(it, { text: W }, null, 8, ["text"])
          ]))
        ], 64))), 128))
      ], 2)) : e.cell.type === "input" ? (u(), P(Qt, {
        key: 23,
        class: "min-w-0 flex-1 pb-0! font-(--weight-regular)",
        size: "sm",
        "reserve-helper": !1,
        "model-value": e.cell.data.value,
        "aria-label": e.cell.data.label,
        placeholder: e.cell.data.placeholder,
        "icon-left": e.cell.data.icon,
        disabled: e.cell.data.disabled,
        "onUpdate:modelValue": z[5] || (z[5] = (W) => n("change", { type: "input", value: W }))
      }, null, 8, ["model-value", "aria-label", "placeholder", "icon-left", "disabled"])) : e.cell.type === "badge-name" ? (u(), b("div", YH, [
        U(yt, {
          class: "shrink-0",
          size: "sm",
          label: e.cell.data.badge.label,
          theme: s(e.cell.data.badge.theme),
          "left-icon": e.cell.data.badge.icon,
          truncate: e.cell.data.badge.truncate ?? !1
        }, null, 8, ["label", "theme", "left-icon", "truncate"]),
        x("span", JH, [
          U(it, {
            text: e.cell.data.name,
            "text-class": o.value
          }, null, 8, ["text", "text-class"])
        ])
      ])) : e.cell.type === "badge-helper" ? (u(), b("div", XH, [
        x("div", ZH, [
          x("span", QH, [
            U(it, {
              text: e.cell.data.name,
              "text-class": o.value
            }, null, 8, ["text", "text-class"])
          ]),
          U(yt, {
            class: "shrink-0",
            size: "sm",
            label: e.cell.data.badge.label,
            theme: s(e.cell.data.badge.theme),
            "left-icon": e.cell.data.badge.icon,
            truncate: e.cell.data.badge.truncate ?? !1
          }, null, 8, ["label", "theme", "left-icon", "truncate"])
        ]),
        U(it, {
          text: e.cell.data.helper,
          "text-class": [tu, o.value].join(" ")
        }, null, 8, ["text", "text-class"])
      ])) : e.cell.type === "badges" ? (u(), b("div", _H, [
        (u(!0), b(ie, null, Oe(f.value, (W, _) => (u(), b(ie, { key: _ }, [
          L(Ts)(W) ? (u(), P(Ls, {
            key: 0,
            label: W.label,
            "hidden-labels": W.hiddenLabels,
            theme: g.value,
            size: "sm"
          }, null, 8, ["label", "hidden-labels", "theme"])) : (u(), P(yt, {
            key: 1,
            class: "shrink-0",
            size: "sm",
            label: W.label,
            theme: s(W.theme),
            truncate: W.truncate ?? !1
          }, null, 8, ["label", "theme", "truncate"]))
        ], 64))), 128))
      ])) : e.cell.type === "icon-shape-link" ? (u(), b("div", e7, [
        U(aa, {
          class: "shrink-0",
          color: "white",
          size: "md",
          type: "circle",
          variant: "outlined",
          icon: e.cell.data.icon
        }, null, 8, ["icon"]),
        p(e.cell.data) ? (u(), b("span", t7, [
          U(it, {
            text: e.cell.data.text,
            "text-class": l.value
          }, null, 8, ["text", "text-class"])
        ])) : (u(), P(pa, Ve({ key: 0 }, k(e.cell.data), {
          "aria-label": e.cell.data.ariaLabel,
          class: "min-w-0 max-w-full",
          onClick: $
        }), {
          default: me(() => [
            U(it, {
              text: e.cell.data.text,
              focusable: !1
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 16, ["aria-label"]))
      ])) : w("", !0);
    };
  }
});
function n7(e) {
  return e.map((a) => {
    const t = typeof a.header == "function" ? (l) => a.header({
      table: {
        getIsAllPageRowsSelected: () => l.table.getIsAllPageRowsSelected(),
        getIsSomePageRowsSelected: () => l.table.getIsSomePageRowsSelected(),
        toggleAllPageRowsSelected: (o) => l.table.toggleAllPageRowsSelected(o)
      }
    }) : a.header, n = {
      id: a.id,
      header: t,
      enableSorting: a.sortable,
      enableResizing: a.resizable,
      enablePinning: a.enablePinning ?? !1,
      meta: {
        enableColumnDragging: a.draggable,
        headerLabel: a.headerLabel ?? (typeof a.header == "string" ? a.header : void 0),
        definedWidth: a.width,
        sortable: a.sortable,
        sortType: a.sortType,
        filterable: a.filterable,
        isCustomHeader: a.customHeader,
        noTruncate: a.noTruncate,
        // CONSTRAINT: no `??` here — `undefined` and `null` are two different headers downstream.
        sortDirection: a.sortDirection,
        locked: a.locked,
        showPinIcon: a.showPinIcon ?? !0,
        cellType: a.cellType
      }
    };
    return a.width !== void 0 && (n.size = a.width), a.minWidth !== void 0 && (n.minSize = a.minWidth), a.maxWidth !== void 0 && (n.maxSize = a.maxWidth), a.cell && !a.cellType && (n.cell = (l) => a.cell({
      row: {
        original: l.row.original,
        getValue: (o) => l.row.getValue(o),
        id: l.row.id,
        getIsSelected: () => l.row.getIsSelected(),
        toggleSelected: (o) => l.row.toggleSelected(o)
      },
      getValue: () => l.getValue()
    })), a.key ? { ...n, accessorKey: a.key } : n;
  });
}
const l7 = {
  columnOptions: (e) => `${e}, column options`,
  resizeColumn: (e) => `Resize ${e}`,
  moveGroup: "Move column",
  moveLeft: "Move left",
  moveRight: "Move right",
  sortGroup: "Sort column",
  sortTextAsc: "Sort from A to Z",
  sortTextDesc: "Sort from Z to A",
  sortNumberAsc: "Sort from 1 to 9",
  sortNumberDesc: "Sort from 9 to 1",
  sortDateAsc: "Sort from oldest to newest",
  sortDateDesc: "Sort from newest to oldest",
  filter: "Filter column",
  freeze: "Freeze column",
  unfreeze: "Unfreeze column",
  frozen: "Frozen",
  frozenLimit: "You can freeze up to 3 columns. Unfreeze a column to freeze another."
}, o7 = {
  text: ["sortTextAsc", "sortTextDesc"],
  number: ["sortNumberAsc", "sortNumberDesc"],
  date: ["sortDateAsc", "sortDateDesc"]
};
function r7(e, a, t) {
  const n = [];
  if (e.draggable && !e.locked && n.push({
    key: "move",
    label: a.moveGroup,
    items: [
      { label: a.moveLeft, icon: "ri-arrow-left-line", disabled: !e.canMoveLeft, testId: "column-menu-move-left", onClick: () => t.move("left") },
      { label: a.moveRight, icon: "ri-arrow-right-line", disabled: !e.canMoveRight, testId: "column-menu-move-right", onClick: () => t.move("right") }
    ]
  }), e.sortable) {
    const [o, r] = o7[e.sortType], i = e.sortDirection !== void 0;
    n.push({
      key: "sort",
      label: a.sortGroup,
      items: [
        { label: a[o], icon: "ri-sort-asc", active: i ? e.sortDirection === "asc" : void 0, testId: "column-menu-sort-asc", onClick: () => t.sort("asc") },
        { label: a[r], icon: "ri-sort-desc", active: i ? e.sortDirection === "desc" : void 0, testId: "column-menu-sort-desc", onClick: () => t.sort("desc") }
      ]
    });
  }
  e.filterable && n.push({
    key: "filter",
    items: [{ label: a.filter, icon: "ri-filter-3-line", testId: "column-menu-filter", onClick: t.filter }]
  });
  const l = i7(e, a, t);
  return l && n.push({ key: "freeze", items: [l] }), n;
}
function i7(e, a, t) {
  return e.locked ? { label: a.frozen, icon: "ri-pushpin-2-fill", disabled: !0, testId: "column-menu-frozen" } : e.pinnable ? e.pinned ? { label: a.unfreeze, icon: "ri-pushpin-2-fill", testId: "column-menu-unfreeze", onClick: t.unfreeze } : {
    label: a.freeze,
    icon: "ri-pushpin-2-line",
    testId: "column-menu-freeze",
    disabled: e.frozenLimitReached,
    description: e.frozenLimitReached ? a.frozenLimit : void 0,
    onClick: t.freeze
  } : null;
}
const s7 = ["aria-label"], d7 = {
  key: 0,
  class: "size-3.5 shrink-0",
  "aria-hidden": "true"
}, u7 = {
  key: 1,
  "aria-hidden": "true",
  "data-testid": "data-table-stretcher-head",
  class: "h-10 p-0 border-y border-(--colors-border-base-medium) dark:border-(--colors-border-base)"
}, c7 = ["scope", "aria-label"], f7 = {
  key: 0,
  class: "sr-only",
  "aria-hidden": "true"
}, h7 = ["aria-label"], b7 = ["src"], g7 = { key: 1 }, m7 = ["onDragstart"], v7 = { key: 1 }, p7 = {
  key: 3,
  "aria-hidden": "true"
}, x7 = {
  role: "status",
  "data-testid": "data-table-loading-status",
  class: "sr-only"
}, y7 = {
  role: "status",
  "data-testid": "data-table-empty-status",
  class: "sr-only"
}, k7 = {
  key: 0,
  role: "status",
  "data-testid": "data-table-row-move-status",
  class: "sr-only"
}, w7 = {
  key: 1,
  role: "status",
  "data-testid": "data-table-selection-status",
  class: "sr-only"
}, dg = 56, C7 = 40, ug = 75, S7 = 32, $7 = 16, au = 36, cg = 8, fg = 32, I7 = 0, L7 = /* @__PURE__ */ ke({
  __name: "DataTable",
  props: {
    columns: {},
    data: {},
    hasSettings: { type: Boolean },
    columnVisibility: {},
    columnOrder: {},
    stickyHeader: { type: Boolean },
    maxHeight: {},
    emptyText: {},
    loading: { type: Boolean },
    loadingRows: {},
    loadingLabel: {},
    settingsAriaLabel: {},
    regionLabel: {},
    columnPinning: {},
    columnSizing: {},
    isRowMuted: { type: Function },
    isRowHighlighted: { type: Function },
    headerMenuLabels: {},
    selectable: { type: Boolean },
    selectionLayout: {},
    getRowId: { type: Function },
    selectedRowIds: {},
    rowActions: { type: Function },
    rowReorder: { type: Boolean },
    isRowPinned: { type: Function },
    rowLabels: {},
    linkAs: {},
    getSubRows: { type: Function },
    treeAlwaysOpen: { type: Boolean },
    expandedRowIds: {}
  },
  emits: ["settings-click", "pin-column", "update:columnOrder", "update:columnPinning", "update:columnSizing", "sort", "filter-column", "move-column", "update:selectedRowIds", "update:expandedRowIds", "move-row", "row-action", "cell-action", "cell-change"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t;
    function o(be, ye, ze) {
      l("cell-change", { ...ze, columnId: be, row: ye });
    }
    const r = m(() => ({ ...X9, ...n.rowLabels })), i = m(() => n.rowReorder === !0), s = m(() => n.selectable === !0 && n.selectionLayout !== "inline"), d = m(() => s.value || i.value), c = m(
      () => i.value ? "flex items-center justify-end gap-0.5 pl-1 pr-5" : "flex items-center justify-center"
    ), f = m(() => n.rowActions !== void 0 || i.value), g = m(() => n.hasSettings || f.value), h = m(
      () => M.getVisibleLeafColumns().length + (d.value ? 1 : 0) + (pe.value ? 1 : 0) + (g.value ? 1 : 0)
    ), v = m(() => Math.max(1, n.loadingRows ?? 10)), p = m(() => {
      var be;
      return !n.loading && !((be = M.getRowModel().rows) != null && be.length);
    }), y = R(n.columnOrder ?? []);
    $e(
      () => n.columnOrder,
      (be) => {
        be && (y.value = be);
      }
    );
    const k = R($(n.selectedRowIds));
    function $(be) {
      return Object.fromEntries((be ?? []).map((ye) => [ye, !0]));
    }
    function S(be) {
      return Object.keys(be).filter((ye) => be[ye]);
    }
    $e(
      () => n.selectedRowIds,
      (be) => {
        be && (k.value = $(be));
      },
      // A parent that pushes to / splices its array in place must be picked up too.
      { deep: !0 }
    );
    const I = R($(n.expandedRowIds));
    $e(
      () => n.expandedRowIds,
      (be) => {
        be && (I.value = $(be));
      }
    );
    const T = R(n.columnPinning ?? { left: [], right: [] }), A = R(null), E = R(null), z = R(0), B = m(() => d.value ? dg : 0), W = m(
      () => f.value ? ug : n.hasSettings ? C7 : 0
    ), _ = m(() => B.value + W.value), Z = R({}), le = R({}), D = /* @__PURE__ */ new Set(), N = R({ ...{
      startOffset: null,
      startSize: null,
      deltaOffset: null,
      deltaPercentage: null,
      isResizingColumn: !1,
      columnSizingStart: []
    } }), V = R(!1), M = Y9({
      get data() {
        return n.data;
      },
      get columns() {
        return n7(n.columns);
      },
      columnResizeMode: "onChange",
      enableRowSelection: !0,
      enableColumnPinning: !0,
      defaultColumn: {
        minSize: 130
      },
      state: {
        get columnOrder() {
          return y.value;
        },
        get columnVisibility() {
          return n.columnVisibility ?? {};
        },
        get columnSizing() {
          return Z.value;
        },
        get columnSizingInfo() {
          return N.value;
        },
        get columnPinning() {
          return T.value;
        },
        get rowSelection() {
          return k.value;
        },
        get expanded() {
          return n.treeAlwaysOpen ? !0 : I.value;
        }
      },
      onColumnOrderChange: (be) => {
        const ye = typeof be == "function" ? be(y.value) : be;
        y.value = ye, l("update:columnOrder", ye);
      },
      onColumnSizingChange: (be) => {
        const ye = typeof be == "function" ? be(Z.value) : be;
        Z.value = xe(ye);
      },
      onColumnSizingInfoChange: (be) => {
        N.value = typeof be == "function" ? be(N.value) : be;
      },
      onColumnPinningChange: (be) => {
        const ye = typeof be == "function" ? be(T.value) : be, ze = T.value, Te = (ye.left ?? []).length === (ze.left ?? []).length && (ye.left ?? []).every((ut, mt) => ut === (ze.left ?? [])[mt]), ot = (ye.right ?? []).length === (ze.right ?? []).length && (ye.right ?? []).every((ut, mt) => ut === (ze.right ?? [])[mt]);
        Te && ot || (T.value = ye, l("update:columnPinning", ye));
      },
      onRowSelectionChange: (be) => {
        k.value = typeof be == "function" ? be(k.value) : be, l("update:selectedRowIds", S(k.value));
      },
      onExpandedChange: (be) => {
        const ye = typeof be == "function" ? be(I.value) : be;
        I.value = ye === !0 ? $(M.getCoreRowModel().flatRows.filter((ze) => ze.getCanExpand()).map((ze) => ze.id)) : ye, l("update:expandedRowIds", S(I.value));
      },
      // Sub-rows default to a path id ("0.1"), so they never take a top-level row's id.
      getRowId: (be, ye, ze) => {
        var Te;
        return ((Te = n.getRowId) == null ? void 0 : Te.call(n, be, ye)) ?? (ze ? `${ze.id}.${ye}` : String(ye));
      },
      getSubRows: (be) => {
        var ye;
        return (ye = n.getSubRows) == null ? void 0 : ye.call(n, be);
      },
      getCoreRowModel: W9(),
      getExpandedRowModel: q9()
    });
    $e(
      () => n.data,
      () => {
        const be = S(k.value), ye = M.getCoreRowModel().rowsById, ze = n.getRowId ? be.filter((Te) => Te in ye) : [];
        ze.length !== be.length && (k.value = $(ze), l("update:selectedRowIds", ze));
      }
    );
    const Q = m(() => ({
      allSelected: M.getIsAllPageRowsSelected(),
      someSelected: M.getIsSomePageRowsSelected(),
      toggleAll: (be) => M.toggleAllPageRowsSelected(be),
      isSelected: (be) => {
        var ye;
        return ((ye = M.getRowModel().rows.find((ze) => ze.original === be)) == null ? void 0 : ye.getIsSelected()) ?? !1;
      },
      toggleRow: (be, ye) => {
        var ze;
        return (ze = M.getRowModel().rows.find((Te) => Te.original === be)) == null ? void 0 : ze.toggleSelected(ye);
      }
    })), q = m(() => Object.values(k.value).filter(Boolean).length), K = R("");
    $e(q, (be) => {
      n.selectable && (K.value = r.value.selectedCount(be));
    });
    const G = R(null), te = R("");
    async function ve(be) {
      te.value = "", await Ze(), te.value = be;
    }
    function Se(be) {
      return be ? be.subRows : M.getCoreRowModel().rows;
    }
    function oe(be) {
      return Se(be.getParentRow() ?? null).findIndex((ye) => ye.id === be.id);
    }
    function re(be) {
      const ye = [], ze = (Te) => {
        for (const ot of Te)
          ot.depth === be ? ye.push(ot) : ot.depth < be && ze(ot.subRows);
      };
      return ze(M.getCoreRowModel().rows), ye;
    }
    function ge(be, ye, ze) {
      var ot;
      const Te = (((ot = be.getParentRow()) == null ? void 0 : ot.id) ?? null) === ((ye == null ? void 0 : ye.id) ?? null);
      return { parent: ye, index: Te && oe(be) < ze ? ze - 1 : ze };
    }
    function de(be, ye) {
      const ze = be.getParentRow() ?? null, Te = oe(be) + ye;
      if (Te >= 0 && Te < Se(ze).length) return { parent: ze, index: Te };
      if (!ze) return null;
      const ot = re(ze.depth), ut = ot[ot.findIndex((mt) => mt.id === ze.id) + ye];
      return ut ? { parent: ut, index: ye < 0 ? ut.subRows.length : 0 } : null;
    }
    function Ee(be, ye, ze) {
      let Te = ye;
      for (; Te && Te.depth > be.depth; ) Te = Te.getParentRow();
      if (!Te || Te.id === be.id) return null;
      if (Te.depth === be.depth) {
        const mt = Te.getParentRow() ?? null;
        return ge(be, mt, oe(Te) + (ze ? 1 : 0));
      }
      if (Te.depth !== be.depth - 1) return null;
      if (ze) return ge(be, Te, 0);
      const ot = re(Te.depth), ut = ot[ot.findIndex((mt) => mt.id === Te.id) - 1];
      return ut ? ge(be, ut, ut.subRows.length) : null;
    }
    function j(be) {
      var ze;
      const ye = (ze = Xe()[0]) == null ? void 0 : ze.id;
      return ye ? String(be.getValue(ye) ?? "") : "";
    }
    function J(be) {
      return M.getRowModel().rows.findIndex((ye) => ye.id === be.id);
    }
    function ne(be) {
      if (n.treeAlwaysOpen) return;
      const ye = [];
      for (let ze = be; ze; ze = ze.getParentRow())
        I.value[ze.id] || ye.unshift(ze.id);
      ye.length && (I.value = { ...I.value, ...$(ye) }, l("update:expandedRowIds", S(I.value)));
    }
    function Y(be, ye) {
      var at, Lt, Rt;
      const Te = (((at = be.getParentRow()) == null ? void 0 : at.id) ?? null) === (((Lt = ye.parent) == null ? void 0 : Lt.id) ?? null), ot = oe(be);
      if (Te && ye.index === ot) return;
      l("move-row", be.id, { parentId: ((Rt = ye.parent) == null ? void 0 : Rt.id) ?? null, index: ye.index }), ye.parent && ne(ye.parent);
      const ut = !Te && ye.parent ? j(ye.parent) : "";
      if (ut) return void ve(r.value.rowMovedInto(ut));
      const mt = !Te && ye.parent ? J(ye.parent) < J(be) : ye.index < ot;
      ve(mt ? r.value.rowMovedUp : r.value.rowMovedDown);
    }
    function F(be, ye) {
      G.value = ye, be.dataTransfer && (be.dataTransfer.effectAllowed = "move", be.dataTransfer.setData("text/plain", ye));
    }
    function ee(be) {
      G.value && be.preventDefault();
    }
    function ue(be, ye) {
      const ze = G.value;
      if (G.value = null, !ze) return;
      be.preventDefault();
      const Te = M.getRowModel().rows.find((mt) => mt.id === ze);
      if (!Te) return;
      const ot = be.currentTarget.getBoundingClientRect(), ut = Ee(Te, ye, be.clientY >= ot.top + ot.height / 2);
      ut && Y(Te, ut);
    }
    function se(be) {
      if (!i.value) return [];
      const ye = de(be, -1), ze = de(be, 1);
      return [
        Z9({ canMoveUp: ye !== null, canMoveDown: ze !== null }, r.value, (Te) => {
          const ot = Te < 0 ? ye : ze;
          ot && Y(be, ot);
        })
      ];
    }
    function X(be, ye = "left") {
      const ze = M.getColumn(be);
      ze && (l("pin-column", be, ye), ze.pin(ye));
    }
    function ae(be) {
      X(be, !1);
    }
    function Re(be) {
      y.value = be;
    }
    $e(
      () => n.columnPinning,
      (be) => {
        if (!be) return;
        const ye = be.left ?? [], ze = be.right ?? [], Te = T.value, ot = ye.length === (Te.left ?? []).length && ye.every((mt, at) => mt === (Te.left ?? [])[at]), ut = ze.length === (Te.right ?? []).length && ze.every((mt, at) => mt === (Te.right ?? [])[at]);
        ot && ut || (T.value = { left: [...ye], right: [...ze] });
      },
      { deep: !0 }
    ), a({ selection: Q, pinColumn: X, unpinColumn: ae, setColumnOrder: Re });
    function Ae(be) {
      return !Vx(be.column.columnDef.maxSize);
    }
    function xe(be) {
      return Object.fromEntries(
        Object.entries(be).map(([ye, ze]) => {
          var Te;
          return [ye, Math.min(ze, Kl((Te = M.getColumn(ye)) == null ? void 0 : Te.columnDef.maxSize))];
        })
      );
    }
    function we() {
      var Te, ot;
      if (!E.value || Object.keys(Z.value).length > 0) return;
      const be = Array.from(E.value.querySelectorAll("thead th[data-slot='table-head']")), ye = ((Te = M.getHeaderGroups()[0]) == null ? void 0 : Te.headers) ?? [], ze = {};
      if (ye.forEach((ut, mt) => {
        const at = be[mt];
        at && (ze[ut.column.id] = Math.min(at.offsetWidth, Kl(ut.column.columnDef.maxSize)));
      }), Object.keys(ze).length > 0) {
        const ut = E.value.getBoundingClientRect().width, mt = ut > 0 ? Math.min(E.value.clientWidth, Math.floor(ut)) : E.value.clientWidth, at = mt - _.value, Rt = Object.values(ze).reduce((Nt, ta) => Nt + ta, 0) - at;
        if (Rt !== 0) {
          const Nt = (ot = [...ye].reverse().find(Ae)) == null ? void 0 : ot.column.id;
          Nt !== void 0 && (ze[Nt] = Math.max(130, ze[Nt] - Rt));
        }
        M.setColumnSizing(ze), z.value = mt, le.value = xe(ze), V.value = !0, fe();
      }
    }
    function fe() {
      if (!V.value) return;
      const be = n.columnSizing ?? {}, ye = Object.keys(be);
      if (ye.length === 0) {
        D.size > 0 && (Z.value = xe(le.value), D.clear());
        return;
      }
      const ze = new Set(M.getAllLeafColumns().map((at) => at.id)), Te = {};
      for (const at of ye) {
        const Lt = be[at];
        ze.has(at) && typeof Lt == "number" && Lt > 0 && (Te[at] = Lt);
      }
      const ot = Object.keys(Te), ut = xe(Te);
      ot.length === D.size && ot.every((at) => Z.value[at] === ut[at]) || (Z.value = xe({ ...le.value, ...Te }), D.clear(), ot.forEach((at) => D.add(at)));
    }
    function Ne() {
      const be = {};
      D.forEach((ye) => {
        const ze = Z.value[ye];
        typeof ze == "number" && (be[ye] = ze);
      }), l("update:columnSizing", be);
    }
    $e(
      () => N.value.isResizingColumn,
      (be, ye) => {
        ye && !be && (D.add(ye), Ne());
      }
    ), $e(() => n.columnSizing, fe, { deep: !0 });
    let De = null, qe = null;
    function Qe(be) {
      var Rt;
      if (!V.value) return;
      (!De || Z.value !== qe) && (De = { sizing: { ...Z.value }, width: z.value }), z.value = be;
      const ye = be - De.width, Te = (((Rt = M.getHeaderGroups()[0]) == null ? void 0 : Rt.headers) ?? []).filter(Ae);
      if (Te.length === 0) return;
      const ot = De.sizing, ut = (Nt) => ot[Nt.column.id] ?? Nt.column.getSize(), mt = Te.reduce((Nt, ta) => Nt + ut(ta), 0), at = { ...Z.value };
      let Lt = ye;
      Te.forEach((Nt, ta) => {
        const jl = Nt.column.columnDef.minSize ?? 130, Cn = ta === Te.length - 1 ? Lt : Math.round(ye * (ut(Nt) / mt));
        at[Nt.column.id] = Math.min(Kl(Nt.column.columnDef.maxSize), Math.max(jl, ut(Nt) + Cn)), Lt -= Cn;
      }), Z.value = at, qe = Z.value;
    }
    let lt = null;
    kt(() => {
      Ze(() => {
        E.value && (lt = new ResizeObserver((be) => {
          var ze, Te;
          const ye = ((ze = be[0]) == null ? void 0 : ze.contentRect.width) ?? ((Te = E.value) == null ? void 0 : Te.clientWidth) ?? 0;
          V.value ? Qe(Math.floor(ye)) : ye > 0 && we();
        }), lt.observe(E.value), E.value.clientWidth > 0 && we());
      });
    }), zt(() => {
      lt == null || lt.disconnect(), lt = null;
    });
    const Ie = m(() => {
      if (V.value)
        return `${M.getTotalSize() + _.value}px`;
    }), pe = m(() => V.value ? M.getTotalSize() + _.value < z.value : !1);
    function Pe(be) {
      var ze;
      const ye = M.getColumn(be);
      ((ze = ye == null ? void 0 : ye.columnDef.meta) == null ? void 0 : ze.locked) !== !0 && (A.value = be);
    }
    function Xe() {
      return [
        ...M.getLeftVisibleLeafColumns(),
        ...M.getCenterVisibleLeafColumns(),
        ...M.getRightVisibleLeafColumns()
      ];
    }
    function nt(be) {
      var ze;
      if (((ze = be.columnDef.meta) == null ? void 0 : ze.locked) === !0) return "locked";
      const ye = be.getIsPinned();
      return ye === "left" ? "pinned" : ye === "right" ? "pinned-right" : "regular";
    }
    function vt(be, ye) {
      var mt;
      if (!ye || be === ye) return !1;
      const ze = Xe().map((at) => at.id);
      if (ze.indexOf(be) === -1 || ze.indexOf(ye) <= 0) return !1;
      const Te = M.getColumn(be), ot = M.getColumn(ye);
      if (!Te || !ot || ((mt = ot.columnDef.meta) == null ? void 0 : mt.enableColumnDragging) !== !0) return !1;
      const ut = nt(Te);
      return ut !== "locked" && ut === nt(ot);
    }
    function Gt(be, ye) {
      const ze = Xe().map((Lt) => Lt.id), Te = ze.indexOf(be), ot = ze.indexOf(ye), ut = M.getColumn(be);
      if (ut && nt(ut) === "pinned") {
        const Lt = [...M.getState().columnPinning.left ?? []], Rt = Lt.indexOf(be), Nt = Lt.indexOf(ye);
        if (Rt !== -1 && Nt !== -1 && Rt !== Nt) {
          const [ta] = Lt.splice(Rt, 1);
          Lt.splice(Nt, 0, ta), M.setColumnPinning({
            left: Lt,
            right: M.getState().columnPinning.right ?? []
          });
        }
      }
      const mt = [...ze], [at] = mt.splice(Te, 1);
      mt.splice(ot, 0, at), M.setColumnOrder(mt);
    }
    function Fe(be) {
      return (ye) => {
        ye.preventDefault();
        const ze = A.value;
        A.value = null, !G.value && ze && vt(ze, be) && Gt(ze, be);
      };
    }
    function je(be, ye) {
      const ze = Xe().map((ot) => ot.id), Te = ze.indexOf(be);
      if (Te !== -1)
        return ze[ye === "left" ? Te - 1 : Te + 1];
    }
    function Ke(be, ye) {
      const ze = je(be, ye);
      !ze || !vt(be, ze) || (Gt(be, ze), l("move-column", be, ye));
    }
    const bt = m(() => ({
      ...l7,
      ...n.headerMenuLabels
    })), At = m(
      () => Xe().filter(
        (be) => {
          var ye, ze;
          return (((ye = be.columnDef.meta) == null ? void 0 : ye.locked) === !0 || be.getIsPinned() === "left") && ((ze = be.columnDef.meta) == null ? void 0 : ze.showPinIcon) !== !1;
        }
      ).length >= ro
    ), Ce = m(
      () => {
        var be;
        return (be = Xe().find((ye) => {
          var Te;
          const ze = (Te = ye.columnDef.meta) == null ? void 0 : Te.sortDirection;
          return ze === "asc" || ze === "desc";
        })) == null ? void 0 : be.id;
      }
    );
    function He(be) {
      var ze;
      const ye = (ze = be.columnDef.meta) == null ? void 0 : ze.sortDirection;
      return (ye === "asc" || ye === "desc") && be.id !== Ce.value ? null : ye;
    }
    function et(be) {
      var ye;
      return ((ye = be.columnDef.meta) == null ? void 0 : ye.headerLabel) ?? be.id;
    }
    function pt(be) {
      const ye = be.columnDef.meta, ze = be.id;
      return r7(
        {
          locked: (ye == null ? void 0 : ye.locked) === !0,
          draggable: (ye == null ? void 0 : ye.enableColumnDragging) === !0,
          canMoveLeft: vt(ze, je(ze, "left")),
          canMoveRight: vt(ze, je(ze, "right")),
          sortable: (ye == null ? void 0 : ye.sortable) === !0,
          sortType: (ye == null ? void 0 : ye.sortType) ?? "text",
          sortDirection: He(be),
          filterable: (ye == null ? void 0 : ye.filterable) === !0,
          pinnable: be.getCanPin(),
          pinned: be.getIsPinned() === "left",
          frozenLimitReached: At.value
        },
        bt.value,
        {
          move: (Te) => Ke(ze, Te),
          sort: (Te) => l("sort", ze, Te),
          filter: () => l("filter-column", ze),
          freeze: () => X(ze, "left"),
          unfreeze: () => ae(ze)
        }
      );
    }
    function It(be, ye) {
      const ze = M.getColumn(be);
      if (!ze) return;
      const Te = ze.columnDef.minSize ?? 130, ot = Kl(ze.columnDef.maxSize), ut = Math.min(ot, Math.max(Te, ze.getSize() + ye));
      ut !== ze.getSize() && (M.setColumnSizing({ ...Z.value, [be]: ut }), D.add(be), Ne());
    }
    function Ht(be) {
      const ye = be.style.width, ze = be.style.maxWidth;
      be.style.width = "max-content", be.style.maxWidth = "none";
      const Te = be.scrollWidth;
      return be.style.width = ye, be.style.maxWidth = ze, Te;
    }
    function ha(be) {
      var Cn, Lf, Tf;
      if (!E.value) return;
      const ye = (Cn = M.getHeaderGroups()[0]) == null ? void 0 : Cn.headers.findIndex((Zs) => Zs.column.id === be);
      if (ye === void 0 || ye < 0) return;
      const Te = Array.from(E.value.querySelectorAll("thead th[data-slot='table-head']"))[ye], ot = Te == null ? void 0 : Te.querySelector(".truncate, [data-slot]"), ut = ot ? Ht(ot) : (Te == null ? void 0 : Te.scrollWidth) ?? 0, mt = E.value.querySelectorAll("tbody tr");
      let at = 0;
      mt.forEach((Zs) => {
        const Qs = Zs.querySelectorAll("td[data-slot='table-cell']")[ye];
        if (Qs) {
          const Ef = Qs.querySelector(".truncate");
          at = Math.max(at, Ef ? Ht(Ef) : Qs.scrollWidth);
        }
      });
      const Lt = (Tf = (Lf = M.getHeaderGroups()[0]) == null ? void 0 : Lf.headers[ye]) == null ? void 0 : Tf.column, Rt = (Lt == null ? void 0 : Lt.columnDef.minSize) ?? 130, Nt = Kl(Lt == null ? void 0 : Lt.columnDef.maxSize), ta = Math.min(
        Nt,
        Math.max(Rt, Math.max(ut, at) + 24)
      ), jl = { ...Z.value, [be]: ta };
      M.setColumnSizing(jl), D.add(be), Ne();
    }
    function Ot(be) {
      return {
        position: "sticky",
        left: "0",
        zIndex: be ? "20" : "10",
        width: `${dg}px`
      };
    }
    function ce(be) {
      var ye;
      return n.selectable === !0 && n.selectionLayout === "inline" && ((ye = Xe()[0]) == null ? void 0 : ye.id) === be.id;
    }
    function he(be) {
      var ye;
      return n.getSubRows !== void 0 && ((ye = Xe()[0]) == null ? void 0 : ye.id) === be.id;
    }
    const Le = m(() => n.treeAlwaysOpen);
    function Je(be) {
      var ye, ze;
      return ((ze = (ye = be.getParentRow()) == null ? void 0 : ye.subRows.at(-1)) == null ? void 0 : ze.id) === be.id;
    }
    function Bt(be) {
      return Le.value ? { width: `${Math.max(0, be.depth * fg - cg)}px` } : be.getCanExpand() ? { paddingInlineStart: `${be.depth * au}px` } : { width: `${be.depth === 0 ? S7 : be.depth * au - cg}px` };
    }
    function Va(be) {
      const ye = [];
      let ze = be;
      for (; ze && ze.depth > 0; ) {
        const Te = Je(ze);
        (ze === be || !Te) && ye.unshift({
          type: ze === be ? Te ? "last" : "middle" : "through",
          left: Le.value ? `calc(var(--spacing) * 3 + ${(ze.depth - 1) * fg + I7}px)` : `calc(var(--spacing) * 3 + ${(ze.depth - 1) * au + $7}px)`
        }), ze = ze.getParentRow();
      }
      return ye;
    }
    function ml(be) {
      const ye = be.getIsSelected();
      return n.selectable || ye ? ye : void 0;
    }
    function To(be) {
      const ye = be.getIsPinned();
      if (!ye)
        return V.value ? { width: `${be.getSize()}px` } : void 0;
      const ze = {
        position: "sticky",
        zIndex: "10"
      };
      return ye === "left" && (ze.left = `${be.getStart("left") + B.value}px`), V.value && (ze.width = `${be.getSize()}px`), ze;
    }
    return (be, ye) => (u(), b("div", {
      class: C(["relative border-x border-(--colors-border-base-soft) dark:border-(--colors-border-base)", { "h-full flex flex-col": e.stickyHeader && !e.maxHeight }])
    }, [
      x("div", {
        ref_key: "containerRef",
        ref: E,
        role: "region",
        "aria-label": e.regionLabel ?? "Data table",
        "data-testid": "data-table-container",
        tabindex: "0",
        class: C(["relative overflow-x-auto text-(--text-text-heading) dark:text-(--text-text-white-default) focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l-inset)", { "overflow-y-auto flex-1 min-h-0": e.stickyHeader && !e.maxHeight }]),
        style: Ge(e.maxHeight ? { maxHeight: e.maxHeight, overflowY: "auto" } : void 0)
      }, [
        U(L(FV), {
          "table-width": Ie.value,
          "aria-busy": e.loading ? "true" : void 0
        }, {
          default: me(() => [
            U(L(a9), {
              "is-sticky": e.stickyHeader || !!e.maxHeight
            }, {
              default: me(() => [
                (u(!0), b(ie, null, Oe(L(M).getHeaderGroups(), (ze) => (u(), P(L(Go), {
                  key: ze.id
                }, {
                  default: me(() => [
                    d.value ? (u(), b("th", {
                      key: 0,
                      scope: "col",
                      "data-testid": "data-table-selection-head",
                      class: "h-10 p-0 align-middle border-y border-(--colors-border-base-medium) dark:border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default)",
                      style: Ge(Ot(!0))
                    }, [
                      x("div", {
                        class: C(c.value)
                      }, [
                        i.value ? (u(), b("span", d7)) : w("", !0),
                        s.value ? (u(), P(va, {
                          key: 1,
                          class: "w-fit!",
                          "model-value": L(M).getIsAllPageRowsSelected(),
                          indeterminate: L(M).getIsSomePageRowsSelected(),
                          "aria-label": r.value.selectAll,
                          "data-testid": "data-table-select-all",
                          "onUpdate:modelValue": ye[0] || (ye[0] = (Te) => L(M).toggleAllPageRowsSelected(Te))
                        }, null, 8, ["model-value", "indeterminate", "aria-label"])) : w("", !0)
                      ], 2)
                    ], 4)) : w("", !0),
                    (u(!0), b(ie, null, Oe(ze.headers, (Te) => {
                      var ot, ut, mt, at, Lt;
                      return u(), P(L(t9), {
                        key: Te.id,
                        style: Ge(To(Te.column)),
                        "is-pinned": Te.column.getIsPinned() === "left",
                        "is-last-pinned": Te.column.getIsLastColumn("left"),
                        "menu-groups": pt(Te.column),
                        "menu-label": bt.value.columnOptions(et(Te.column)),
                        "resize-label": bt.value.resizeColumn(et(Te.column)),
                        width: V.value ? Te.column.getSize() : (ot = Te.column.columnDef.meta) == null ? void 0 : ot.definedWidth,
                        "min-width": Te.column.columnDef.minSize ?? 130,
                        "max-width": L(Kl)(Te.column.columnDef.maxSize),
                        "is-pinnable": Te.column.getCanPin(),
                        "is-custom-header": (ut = Te.column.columnDef.meta) == null ? void 0 : ut.isCustomHeader,
                        "is-draggable": ((mt = Te.column.columnDef.meta) == null ? void 0 : mt.enableColumnDragging) === !0,
                        "is-locked": ((at = Te.column.columnDef.meta) == null ? void 0 : at.locked) === !0,
                        "is-pin-icon-visible": ((Lt = Te.column.columnDef.meta) == null ? void 0 : Lt.showPinIcon) !== !1,
                        "sort-direction": He(Te.column),
                        "is-resizable": Te.column.getCanResize(),
                        "is-resizing-active": Te.column.getIsResizing(),
                        class: "header-cell",
                        onDragHandleStart: (Rt) => Pe(Te.column.id),
                        onDragHandleEnd: ye[2] || (ye[2] = (Rt) => A.value = null),
                        onDragover: ye[3] || (ye[3] = _e(() => {
                        }, ["prevent"])),
                        onDrop: (Rt) => Fe(Te.column.id)(Rt),
                        onResizeStart: (Rt) => Te.getResizeHandler()(Rt),
                        onResizeAuto: (Rt) => ha(Te.column.id),
                        onResizeBy: (Rt) => It(Te.column.id, Rt)
                      }, Xa({
                        default: me(() => [
                          Te.isPlaceholder ? w("", !0) : (u(), P(L(og), {
                            key: 0,
                            render: Te.column.columnDef.header,
                            props: Te.getContext()
                          }, null, 8, ["render", "props"]))
                        ]),
                        _: 2
                      }, [
                        ce(Te.column) ? {
                          name: "leading",
                          fn: me(() => [
                            U(va, {
                              class: "w-fit!",
                              "model-value": L(M).getIsAllPageRowsSelected(),
                              indeterminate: L(M).getIsSomePageRowsSelected(),
                              "aria-label": r.value.selectAll,
                              "data-testid": "data-table-select-all",
                              "onUpdate:modelValue": ye[1] || (ye[1] = (Rt) => L(M).toggleAllPageRowsSelected(Rt))
                            }, null, 8, ["model-value", "indeterminate", "aria-label"])
                          ]),
                          key: "0"
                        } : void 0
                      ]), 1032, ["style", "is-pinned", "is-last-pinned", "menu-groups", "menu-label", "resize-label", "width", "min-width", "max-width", "is-pinnable", "is-custom-header", "is-draggable", "is-locked", "is-pin-icon-visible", "sort-direction", "is-resizable", "is-resizing-active", "onDragHandleStart", "onDrop", "onResizeStart", "onResizeAuto", "onResizeBy"]);
                    }), 128)),
                    pe.value ? (u(), b("th", u7)) : w("", !0),
                    g.value ? (u(), b("th", {
                      key: 2,
                      scope: f.value ? "col" : void 0,
                      "aria-label": f.value ? r.value.actionsColumn : void 0,
                      "data-testid": "data-table-tail-head",
                      class: "sticky right-0 z-30 p-0 border-y border-(--colors-border-base-medium) dark:border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default)",
                      style: Ge({ width: `${W.value}px` })
                    }, [
                      f.value ? (u(), b("span", f7, H(r.value.actionsColumn), 1)) : w("", !0),
                      e.hasSettings ? (u(), b("button", {
                        key: 1,
                        type: "button",
                        "data-testid": "data-settings",
                        "aria-label": e.settingsAriaLabel ?? "Column settings",
                        class: "data-settings-btn ms-auto flex items-center justify-center w-10 h-10 p-0 cursor-pointer focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:outline-none transition-colors",
                        onClick: ye[4] || (ye[4] = (Te) => l("settings-click"))
                      }, [
                        x("img", {
                          class: "size-5",
                          src: L(J9),
                          alt: ""
                        }, null, 8, b7)
                      ], 8, h7)) : w("", !0)
                    ], 12, c7)) : w("", !0)
                  ]),
                  _: 2
                }, 1024))), 128))
              ]),
              _: 1
            }, 8, ["is-sticky"]),
            U(L(NV), null, {
              default: me(() => {
                var ze;
                return [
                  e.loading ? (u(!0), b(ie, { key: 0 }, Oe(v.value, (Te) => (u(), P(L(Go), {
                    key: `skeleton-${Te}`,
                    "data-testid": "data-table-skeleton-row",
                    "aria-hidden": "true",
                    class: "hover:bg-white! dark:hover:bg-(--colors-background-black-default)!"
                  }, {
                    default: me(() => [
                      d.value ? (u(), b("td", {
                        key: 0,
                        class: "pinned-cell bg-white dark:bg-(--colors-background-black-default)",
                        style: Ge(Ot(!1))
                      }, null, 4)) : w("", !0),
                      (u(!0), b(ie, null, Oe(Xe(), (ot) => (u(), P(L(Li), {
                        key: ot.id,
                        style: Ge(To(ot)),
                        class: C([
                          ot.getIsPinned() === "left" ? "sticky z-10 bg-white dark:bg-(--colors-background-black-default) pinned-cell" : "",
                          ot.getIsLastColumn("left") ? "pinned-cell-last" : ""
                        ])
                      }, {
                        default: me(() => [...ye[6] || (ye[6] = [
                          x("div", { class: "skeleton h-3 w-3/4 max-w-40" }, null, -1)
                        ])]),
                        _: 1
                      }, 8, ["style", "class"]))), 128)),
                      pe.value ? (u(), b("td", g7)) : w("", !0),
                      g.value ? (u(), b("td", {
                        key: 2,
                        class: "p-0",
                        style: Ge({ width: `${W.value}px` })
                      }, null, 4)) : w("", !0)
                    ]),
                    _: 1
                  }))), 128)) : (ze = L(M).getRowModel().rows) != null && ze.length ? (u(!0), b(ie, { key: 1 }, Oe(L(M).getRowModel().rows, (Te) => {
                    var ot, ut;
                    return u(), P(L(Go), {
                      key: Te.id,
                      "data-row-id": Te.id,
                      selected: ml(Te),
                      "data-muted": (ot = e.isRowMuted) != null && ot.call(e, Te.original) ? "true" : void 0,
                      "data-highlighted": (ut = e.isRowHighlighted) != null && ut.call(e, Te.original) ? "true" : void 0,
                      "data-dragging": G.value === Te.id ? "true" : void 0,
                      onDragover: ee,
                      onDrop: (mt) => ue(mt, Te)
                    }, {
                      default: me(() => {
                        var mt;
                        return [
                          d.value ? (u(), b("td", {
                            key: 0,
                            "data-testid": "data-table-selection-cell",
                            class: C(["pinned-cell h-12 p-0 align-middle border-b border-(--colors-border-base-medium) dark:border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default)", { "pinned-cell-last": L(M).getLeftLeafColumns().length === 0 }]),
                            style: Ge(Ot(!1))
                          }, [
                            x("div", {
                              class: C(c.value)
                            }, [
                              i.value ? (u(), b("span", {
                                key: 0,
                                "data-testid": "data-row-drag-handle",
                                draggable: "true",
                                class: "-mx-[5px] inline-flex size-6 shrink-0 cursor-grab items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)",
                                onDragstart: _e((at) => F(at, Te.id), ["stop"]),
                                onDragend: ye[5] || (ye[5] = (at) => G.value = null)
                              }, [...ye[7] || (ye[7] = [
                                x("i", {
                                  class: "ri-draggable inline-flex size-(--icon-size-xs) shrink-0 items-center justify-center text-(length:--icon-size-xs) leading-(--icon-size-xs)",
                                  "aria-hidden": "true"
                                }, null, -1)
                              ])], 40, m7)) : w("", !0),
                              s.value ? (u(), P(va, {
                                key: 1,
                                class: "w-fit!",
                                "model-value": Te.getIsSelected(),
                                "aria-label": r.value.selectRow(Te.original, Te.index),
                                "data-testid": "data-table-select-row",
                                "onUpdate:modelValue": (at) => Te.toggleSelected(at)
                              }, null, 8, ["model-value", "aria-label", "onUpdate:modelValue"])) : w("", !0)
                            ], 2)
                          ], 6)) : w("", !0),
                          (u(!0), b(ie, null, Oe(Te.getVisibleCells(), (at) => {
                            var Lt, Rt, Nt;
                            return u(), P(L(Li), {
                              key: at.id,
                              "no-truncate": (Lt = at.column.columnDef.meta) == null ? void 0 : Lt.noTruncate,
                              typed: ((Rt = at.column.columnDef.meta) == null ? void 0 : Rt.cellType) !== void 0,
                              "data-type": (Nt = at.column.columnDef.meta) != null && Nt.cellType ? L(dH)[at.column.columnDef.meta.cellType.type] : void 0,
                              style: Ge(To(at.column)),
                              class: C([
                                at.column.getIsPinned() === "left" ? "sticky z-10 bg-white dark:bg-(--colors-background-black-default) pinned-cell" : "",
                                at.column.getIsLastColumn("left") ? "pinned-cell-last" : "",
                                // The Tree connectors are drawn against the cell's full 48 px height.
                                he(at.column) && at.column.getIsPinned() !== "left" ? "relative" : ""
                              ])
                            }, Xa({
                              default: me(() => {
                                var ta, jl;
                                return [
                                  (ta = at.column.columnDef.meta) != null && ta.cellType ? (u(), P(a7, {
                                    key: 0,
                                    cell: L(fH)(at.column.columnDef.meta.cellType, Te.original, Te.index, at.getValue()),
                                    muted: ((jl = e.isRowMuted) == null ? void 0 : jl.call(e, Te.original)) === !0,
                                    "link-as": e.linkAs,
                                    onAction: (Cn) => l("cell-action", { columnId: at.column.id, row: Te.original, actionId: Cn }),
                                    onChange: (Cn) => o(at.column.id, Te.original, Cn)
                                  }, null, 8, ["cell", "muted", "link-as", "onAction", "onChange"])) : (u(), P(L(og), {
                                    key: 1,
                                    render: at.column.columnDef.cell ?? at.getValue,
                                    props: at.getContext()
                                  }, null, 8, ["render", "props"]))
                                ];
                              }),
                              _: 2
                            }, [
                              ce(at.column) || he(at.column) ? {
                                name: "leading",
                                fn: me(() => [
                                  he(at.column) && !(Le.value && Te.depth === 0) ? (u(), b("span", {
                                    key: 0,
                                    "data-testid": "data-table-tree",
                                    class: "flex shrink-0 items-center",
                                    style: Ge(Bt(Te))
                                  }, [
                                    (u(!0), b(ie, null, Oe(Va(Te), (ta) => (u(), P(oH, {
                                      key: ta.left,
                                      type: ta.type,
                                      style: Ge({ insetInlineStart: ta.left })
                                    }, null, 8, ["type", "style"]))), 128)),
                                    Te.getCanExpand() && !Le.value ? (u(), P(Be, {
                                      key: 0,
                                      variant: "ghost",
                                      size: "xs",
                                      "icon-only": "",
                                      "icon-left": Te.getIsExpanded() ? "ri-arrow-down-s-line" : "ri-arrow-right-s-line",
                                      "aria-label": r.value.toggleSubRows(Te.original, Te.index),
                                      "aria-expanded": Te.getIsExpanded() ? "true" : "false",
                                      "data-testid": "data-table-row-toggle",
                                      class: "-my-1 shrink-0",
                                      onClick: (ta) => Te.toggleExpanded()
                                    }, null, 8, ["icon-left", "aria-label", "aria-expanded", "onClick"])) : w("", !0)
                                  ], 4)) : w("", !0),
                                  ce(at.column) ? (u(), P(va, {
                                    key: 1,
                                    class: "w-fit!",
                                    "model-value": Te.getIsSelected(),
                                    "aria-label": r.value.selectRow(Te.original, Te.index),
                                    "data-testid": "data-table-select-row",
                                    "onUpdate:modelValue": (ta) => Te.toggleSelected(ta)
                                  }, null, 8, ["model-value", "aria-label", "onUpdate:modelValue"])) : w("", !0)
                                ]),
                                key: "0"
                              } : void 0
                            ]), 1032, ["no-truncate", "typed", "data-type", "style", "class"]);
                          }), 128)),
                          pe.value ? (u(), b("td", v7)) : w("", !0),
                          f.value ? (u(), b("td", {
                            key: 2,
                            "data-testid": "data-row-actions",
                            class: "actions-cell sticky right-0 z-10 p-0 align-middle border-b border-(--colors-border-base-medium) dark:border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default)",
                            style: Ge({ width: `${ug}px` })
                          }, [
                            U(aH, {
                              actions: e.rowActions ? e.rowActions(Te.original) : [],
                              "leading-groups": se(Te),
                              label: r.value.rowActions(Te.original, Te.index),
                              pinned: ((mt = e.isRowPinned) == null ? void 0 : mt.call(e, Te.original)) === !0,
                              onSelect: (at) => l("row-action", at, Te.original)
                            }, null, 8, ["actions", "leading-groups", "label", "pinned", "onSelect"])
                          ], 4)) : e.hasSettings ? (u(), b("td", p7)) : w("", !0)
                        ];
                      }),
                      _: 2
                    }, 1032, ["data-row-id", "selected", "data-muted", "data-highlighted", "data-dragging", "onDrop"]);
                  }), 128)) : (u(), P(L(Go), {
                    key: 2,
                    class: "border-b-0! hover:bg-white! dark:hover:bg-(--colors-background-black-default)!"
                  }, {
                    default: me(() => [
                      U(L(Li), {
                        colspan: h.value,
                        class: "h-24 text-center"
                      }, {
                        default: me(() => [
                          st(H(e.emptyText ?? "No results."), 1)
                        ]),
                        _: 1
                      }, 8, ["colspan"])
                    ]),
                    _: 1
                  }))
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["table-width", "aria-busy"])
      ], 14, s7),
      x("div", x7, H(e.loading ? e.loadingLabel ?? "Loading" : ""), 1),
      x("div", y7, H(p.value ? e.emptyText ?? "No results." : ""), 1),
      i.value ? (u(), b("div", k7, H(te.value), 1)) : w("", !0),
      e.selectable ? (u(), b("div", w7, H(K.value), 1)) : w("", !0)
    ], 2));
  }
}), UG = /* @__PURE__ */ Ct(L7, [["__scopeId", "data-v-836d5d63"]]);
function GG(e, a, t) {
  return (n) => {
    const o = (e() || "").replace(/\D/g, ""), r = a() || "", i = QD[r], s = gf(o, (i == null ? void 0 : i.hasTrunkZero) ?? !1);
    if (!s) return;
    const d = (i == null ? void 0 : i.min) ?? 6, c = (i == null ? void 0 : i.max) ?? 1 / 0, f = (i == null ? void 0 : i.name) ?? r, g = (i == null ? void 0 : i.placeholder) ?? eo.placeholder;
    if (s.length < d)
      return t({ count: d, country: f, example: g });
    if (s.length > c)
      return t({ count: c, country: f, example: g });
  };
}
function hg(e) {
  return e == null ? !0 : typeof e == "string" ? e.trim() === "" : !1;
}
function T7(e) {
  const a = typeof e == "string" ? { requiredMessage: e } : e, { requiredMessage: t, watchData: n } = a, l = typeof t == "function" ? t : () => t, o = R(/* @__PURE__ */ new Map()), r = m(() => Array.from(o.value.values())), i = m(() => o.value.size), s = m(() => o.value.size > 0);
  function d(p, y) {
    if (p.required && hg(y))
      return l();
    if (p.validate)
      return p.validate(y);
  }
  function c(p, y) {
    const k = /* @__PURE__ */ new Map();
    for (const $ of p) {
      const S = d($, y[$.key]);
      S && k.set($.key, {
        key: $.key,
        label: $.label,
        message: S
      });
    }
    return o.value = k, k.size === 0;
  }
  function f(p, y) {
    const k = d(p, y);
    if (k) {
      const $ = new Map(o.value);
      return $.set(p.key, { key: p.key, label: p.label, message: k }), o.value = $, !1;
    } else
      return h(p.key), !0;
  }
  function g(p) {
    var y;
    return (y = o.value.get(p)) == null ? void 0 : y.message;
  }
  function h(p) {
    if (o.value.has(p)) {
      const y = new Map(o.value);
      y.delete(p), o.value = y;
    }
  }
  function v() {
    o.value = /* @__PURE__ */ new Map();
  }
  return n && $e(
    () => n,
    () => {
      if (s.value)
        for (const p of [...r.value]) {
          const y = n[p.key];
          hg(y) || h(p.key);
        }
    },
    { deep: !0 }
  ), {
    errors: o,
    errorList: r,
    errorCount: i,
    hasErrors: s,
    validateAll: c,
    validateField: d,
    validateAndSetField: f,
    getFieldError: g,
    clearFieldError: h,
    clearAllErrors: v
  };
}
function E7(e) {
  const a = R(!1);
  async function t() {
    var n, l;
    if (e.validate()) {
      a.value = !0;
      try {
        await e.save(), (n = e.onSuccess) == null || n.call(e);
      } catch (o) {
        (l = e.onError) == null || l.call(e, o);
      } finally {
        a.value = !1;
      }
    }
  }
  return { isSaving: a, handleSubmit: t };
}
function to(e) {
  if (e === null || typeof e != "object")
    return e;
  if (Array.isArray(e))
    return e.map(to);
  const a = {};
  for (const t in e)
    Object.prototype.hasOwnProperty.call(e, t) && (a[t] = to(e[t]));
  return a;
}
function ac(e, a) {
  if (e === a) return !0;
  if (e === null || a === null) return e === a;
  if (typeof e != typeof a) return !1;
  if (typeof e != "object") return e === a;
  if (Array.isArray(e) && Array.isArray(a))
    return e.length !== a.length ? !1 : e.every((l, o) => ac(l, a[o]));
  if (Array.isArray(e) || Array.isArray(a)) return !1;
  const t = Object.keys(e), n = Object.keys(a);
  return t.length !== n.length ? !1 : t.every(
    (l) => ac(e[l], a[l])
  );
}
function A7(e) {
  const { data: a, enableBeforeUnload: t = !0, beforeUnloadMessage: n } = e, l = R(null), o = R(!1), r = m(() => o.value ? !0 : l.value === null ? !1 : !ac(a, l.value));
  function i() {
    l.value = to(a), o.value = !1;
  }
  function s() {
    l.value = to(a), o.value = !1;
  }
  function d() {
    l.value !== null && Object.assign(a, to(l.value)), o.value = !1;
  }
  function c() {
    return to(l.value);
  }
  function f(h) {
    o.value = h;
  }
  function g(h) {
    if (r.value) {
      h.preventDefault();
      const v = n ? n() : "";
      return h.returnValue = v, v;
    }
  }
  return kt(() => {
    i(), t && window.addEventListener("beforeunload", g);
  }), zt(() => {
    t && window.removeEventListener("beforeunload", g);
  }), {
    isDirty: r,
    markAsSaved: s,
    resetToOriginal: d,
    getOriginalData: c,
    setDirty: f
  };
}
function KG(e) {
  const a = A7({
    data: e.data,
    enableBeforeUnload: e.enableBeforeUnload,
    beforeUnloadMessage: e.beforeUnloadMessage
  }), t = T7({
    requiredMessage: e.requiredMessage,
    watchData: e.data
  }), n = E7({
    validate: () => t.validateAll(e.fields(), e.data),
    save: e.save,
    onSuccess: () => {
      var l;
      t.clearAllErrors(), a.markAsSaved(), (l = e.onSuccess) == null || l.call(e);
    },
    onError: e.onError
  });
  return {
    // Dirty state
    isDirty: a.isDirty,
    markAsSaved: a.markAsSaved,
    resetToOriginal: a.resetToOriginal,
    setDirty: a.setDirty,
    // Validation
    errorList: t.errorList,
    errorCount: t.errorCount,
    hasErrors: t.hasErrors,
    getFieldError: t.getFieldError,
    clearFieldError: t.clearFieldError,
    clearAllErrors: t.clearAllErrors,
    // Submit
    isSaving: n.isSaving,
    handleSubmit: n.handleSubmit
  };
}
function R7(e) {
  const a = R(!1);
  if (typeof window > "u") return a;
  const t = window.matchMedia(e), n = () => {
    a.value = t.matches;
  };
  return rc() && (kt(() => {
    n(), t.addEventListener("change", n);
  }), zt(() => {
    t.removeEventListener("change", n);
  })), a;
}
const z7 = {
  key: 0,
  class: "p-3"
}, D7 = { class: "flex flex-col-reverse md:flex-row items-center justify-between md:space-x-4" }, B7 = { class: "w-full lg:w-2/3 flex flex-col space-y-3 md:space-y-0 md:flex-row md:items-center" }, M7 = {
  key: 0,
  class: "flex items-center space-x-4"
}, O7 = {
  key: 1,
  class: "w-full md:w-auto flex flex-col md:flex-row mb-3 md:mb-0 items-stretch md:items-center justify-end md:space-x-3 shrink-0"
}, P7 = {
  key: 0,
  class: "flex flex-wrap"
}, F7 = { class: "relative" }, N7 = { class: "flex-1 min-h-0 flex flex-col" }, V7 = {
  key: 1,
  class: "border-t border-gainsboro dark:border-(--colors-border-base) p-5"
}, YG = /* @__PURE__ */ ke({
  __name: "DataTableWrapper",
  props: {
    bordered: { type: Boolean }
  },
  setup(e) {
    const a = Ia();
    return (t, n) => (u(), b("div", {
      class: C([
        "relative bg-white rounded-(--border-border-radius-rounded-l) flex-1 flex flex-col min-h-0",
        e.bordered ? "border border-(--border-border-base-soft) overflow-hidden shadow-(--blur-shadow-xs)" : "border-l border-border-base-soft has-[>div:nth-child(2)>[role=data-settings]]:rounded-tr-none"
      ])
    }, [
      n[0] || (n[0] = x("div", { class: "absolute bottom-0 left-1.5 right-0 h-px bg-linear-to-r from-(--background-background-gray) to-transparent" }, null, -1)),
      L(a)("filters") || L(a)("actions") ? (u(), b("div", z7, [
        x("div", D7, [
          x("div", B7, [
            L(a)("filters") ? (u(), b("div", M7, [
              Me(t.$slots, "filters")
            ])) : w("", !0),
            L(a)("actions") ? (u(), b("div", O7, [
              Me(t.$slots, "actions")
            ])) : w("", !0)
          ]),
          L(a)("filter-items") ? (u(), b("div", P7, [
            Me(t.$slots, "filter-items")
          ])) : w("", !0)
        ])
      ])) : w("", !0),
      x("div", F7, [
        x("div", {
          class: C(["absolute top-0 right-0 h-0.5 bg-border-base-soft", L(a)("filters") ? "left-0" : "left-1.5"])
        }, null, 2)
      ]),
      x("div", N7, [
        Me(t.$slots, "table")
      ]),
      L(a)("pager") ? (u(), b("div", V7, [
        Me(t.$slots, "pager")
      ])) : w("", !0)
    ], 2));
  }
}), H7 = {
  key: 0,
  role: "menu",
  "data-testid": "card-actions-menu",
  class: "absolute right-0 top-10 z-50 min-w-160px rounded-xl border border-(--border-border-base-soft) bg-white py-1 shadow-[0_4px_16px_rgba(0,0,0,0.12)]"
}, j7 = ["onClick"], W7 = {
  key: 0,
  class: "skeleton w-full h-192px rounded-t-3xl"
}, q7 = {
  key: 1,
  class: "skeleton h-9 w-9 rounded-full shrink-0 m-6"
}, U7 = ["src", "alt"], G7 = { class: "h-9 w-9 rounded-full border border-(--border-border-base-soft) flex items-center justify-center bg-white" }, K7 = { class: "flex flex-col flex-1" }, Y7 = {
  key: 0,
  class: "self-start bg-(--background-background-white-tertiary) text-xs font-medium px-1 py-0.5 rounded text-(--text-text-black-default)"
}, J7 = {
  key: 1,
  class: "text-2xl font-bold text-(--text-text-heading) dark:text-(--colors-text-white-default) m-0"
}, X7 = {
  key: 2,
  class: "text-base text-(--text-text-body) dark:text-(--colors-text-white-secondary) m-0"
}, JG = /* @__PURE__ */ ke({
  __name: "Card",
  props: {
    layout: { default: "classic" },
    headerType: { default: "icon" },
    imageSrc: { default: void 0 },
    imageAlt: { default: "" },
    badge: { default: void 0 },
    title: { default: void 0 },
    description: { default: void 0 },
    primaryLabel: { default: void 0 },
    secondaryLabel: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    actions: { default: void 0 }
  },
  emits: ["primary-click", "secondary-click"],
  setup(e, { emit: a }) {
    const t = a, {
      isOpen: n,
      dropdownRef: l,
      toggleDropdown: o,
      closeDropdown: r
    } = So(), i = (d) => {
      var c;
      (c = d.onClick) == null || c.call(d), r();
    }, s = (d) => {
      l.value = d;
    };
    return (d, c) => (u(), b("div", {
      "data-testid": "card",
      class: C([
        "relative overflow-hidden rounded-3xl border border-(--border-border-base-medium) bg-white dark:bg-(--colors-background-black-default) shadow-[0px_0px_4px_rgba(0,0,0,0.1)]",
        e.layout === "aligned" ? "flex flex-row items-center" : "flex flex-col"
      ])
    }, [
      !e.loading && e.actions && e.actions.length ? (u(), b("div", {
        key: 0,
        ref: s,
        class: "absolute top-3 right-3 z-10",
        "data-testid": "card-actions"
      }, [
        x("button", {
          type: "button",
          "data-testid": "card-actions-trigger",
          class: "h-8 w-8 rounded-full border border-(--border-border-base-soft) bg-white flex items-center justify-center cursor-pointer hover:bg-(--background-background-white-tertiary) transition-colors",
          onClick: c[0] || (c[0] = //@ts-ignore
          (...f) => L(o) && L(o)(...f))
        }, [...c[3] || (c[3] = [
          x("i", { class: "ri-more-line text-sm text-(--text-text-body)" }, null, -1)
        ])]),
        U(Wt, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: me(() => [
            L(n) ? (u(), b("div", H7, [
              (u(!0), b(ie, null, Oe(e.actions, (f) => (u(), b("button", {
                key: f.label,
                type: "button",
                role: "menuitem",
                "data-testid": "card-action-item",
                class: C([
                  "w-full text-left px-4 py-2 text-sm hover:bg-(--background-background-white-tertiary) transition-colors flex items-center gap-2",
                  f.class || "text-(--text-text-black-default)"
                ]),
                onClick: (g) => i(f)
              }, [
                f.icon ? (u(), b("i", {
                  key: 0,
                  class: C(f.icon)
                }, null, 2)) : w("", !0),
                st(" " + H(f.label), 1)
              ], 10, j7))), 128))
            ])) : w("", !0)
          ]),
          _: 1
        })
      ])) : w("", !0),
      e.loading ? (u(), b(ie, { key: 1 }, [
        e.layout !== "aligned" ? (u(), b("div", W7)) : (u(), b("div", q7)),
        c[4] || (c[4] = Ar('<div class="flex flex-col gap-3 px-6 pb-6 pt-4 flex-1"><div class="skeleton h-5 w-16 rounded"></div><div class="skeleton h-8 w-3/4 rounded"></div><div class="skeleton h-4 w-full rounded"></div><div class="skeleton h-4 w-2/3 rounded"></div><div class="flex gap-2 pt-2"><div class="skeleton h-9 w-24 rounded-full"></div><div class="skeleton h-9 w-24 rounded-full"></div></div></div>', 1))
      ], 64)) : (u(), b(ie, { key: 2 }, [
        Me(d.$slots, "header", {}, () => [
          e.headerType === "image" ? (u(), b("div", {
            key: 0,
            class: C(e.layout === "aligned" ? "p-6 shrink-0" : "p-6")
          }, [
            e.imageSrc ? (u(), b("img", {
              key: 0,
              src: e.imageSrc,
              alt: e.imageAlt,
              class: C(
                e.layout === "aligned" ? "h-48 w-48 object-cover rounded-xl" : "w-full h-48 object-cover rounded-xl"
              )
            }, null, 10, U7)) : w("", !0)
          ], 2)) : (u(), b("div", {
            key: 1,
            class: C(e.layout === "aligned" ? "pl-6 shrink-0" : "pt-6 pb-6 px-6")
          }, [
            x("div", G7, [
              Me(d.$slots, "icon")
            ])
          ], 2))
        ]),
        x("div", K7, [
          Me(d.$slots, "default", {}, () => [
            x("div", {
              class: C(["flex flex-col gap-3", e.layout === "aligned" ? "p-6" : "px-6 pb-6"])
            }, [
              e.badge ? (u(), b("span", Y7, H(e.badge), 1)) : w("", !0),
              e.title ? (u(), b("p", J7, H(e.title), 1)) : w("", !0),
              e.description ? (u(), b("p", X7, H(e.description), 1)) : w("", !0)
            ], 2)
          ])
        ]),
        Me(d.$slots, "footer", {}, () => [
          e.primaryLabel || e.secondaryLabel ? (u(), b("div", {
            key: 0,
            class: C([
              e.layout === "aligned" ? "px-6 flex flex-col gap-4 items-start shrink-0" : "px-6 pb-6 flex items-center gap-4"
            ])
          }, [
            e.primaryLabel ? (u(), P(Be, {
              key: 0,
              variant: "primary",
              size: "xs",
              label: e.primaryLabel,
              onClick: c[1] || (c[1] = (f) => t("primary-click"))
            }, null, 8, ["label"])) : w("", !0),
            e.secondaryLabel ? (u(), P(Be, {
              key: 1,
              variant: "secondary",
              size: "xs",
              label: e.secondaryLabel,
              onClick: c[2] || (c[2] = (f) => t("secondary-click"))
            }, null, 8, ["label"])) : w("", !0)
          ], 2)) : w("", !0)
        ])
      ], 64))
    ], 2));
  }
}), Z7 = ["aria-checked", "aria-disabled"], Q7 = { class: "flex flex-col gap-1.5" }, XG = /* @__PURE__ */ ke({
  __name: "CardSelectable",
  props: {
    icon: { default: void 0 },
    title: { default: void 0 },
    description: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    iconVariant: { default: "default" }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, n = a;
    function l(o) {
      t.disabled || n("click", o);
    }
    return (o, r) => (u(), b("button", {
      type: "button",
      "data-testid": "card-selectable",
      "aria-checked": e.selected,
      "aria-disabled": e.disabled || void 0,
      class: C([
        "relative flex flex-col gap-3 p-6 rounded-xl border text-left w-full",
        "transition-colors duration-120 ease-in-out",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-hover)",
        // Disabled wins over selected (a disabled card can't be the chosen option). Use the DS
        // disabled surface (grey fill + border) rather than a flat opacity so the disabled state
        // reads clearly against the enabled cards (OP-6222).
        e.disabled ? "bg-(--colors-background-disabled) border-(--colors-border-disabled) cursor-not-allowed pointer-events-none" : e.selected ? "bg-(--background-background-hover) border-(--border-border-hover) shadow-[0px_0px_2px_var(--border-border-hover)] cursor-pointer" : "bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-hover) active:bg-(--background-background-hover) cursor-pointer"
      ]),
      onClick: l
    }, [
      Me(o.$slots, "default", {}, () => [
        x("div", {
          class: C([
            "h-9 w-9 flex items-center justify-center rounded-lg border shrink-0",
            e.disabled ? "bg-(--colors-background-disabled) border-(--colors-border-disabled)" : e.iconVariant === "accent" ? "bg-(--background-background-white) border-(--border-border-hover) shadow-[0px_0px_1px_var(--background-background-hover)]" : "bg-(--background-background-white) border-(--border-border-base-medium)"
          ])
        }, [
          x("i", {
            class: C([e.icon, "text-[20px]", e.disabled ? "text-(--colors-icon-disabled)" : "text-(--icons-icon-accent)"]),
            "aria-hidden": "true"
          }, null, 2)
        ], 2),
        x("div", Q7, [
          x("span", {
            class: C(["text-lg font-semibold", e.disabled ? "text-(--colors-text-disabled)" : "text-(--text-text-heading)"])
          }, H(e.title), 3),
          e.description ? (u(), b("span", {
            key: 0,
            class: C(["text-sm", e.disabled ? "text-(--colors-text-disabled)" : "text-(--text-text-body)"])
          }, H(e.description), 3)) : w("", !0)
        ])
      ])
    ], 10, Z7));
  }
}), ZG = /* @__PURE__ */ ke({
  __name: "Masonry",
  props: {
    gapX: { default: 20 },
    gapY: { default: 20 },
    breakpoint: { default: 640 },
    useViewport: { type: Boolean, default: !1 }
  },
  setup(e) {
    const a = e, t = Na(), n = R([]), l = R(null), o = R([]), r = R(0), i = R(2), s = m(
      () => {
        var y;
        return (((y = t.default) == null ? void 0 : y.call(t)) ?? []).filter(
          (k) => k.type !== oc
        );
      }
    );
    function d() {
      const y = n.value;
      if (!y.length) return;
      const k = i.value, $ = Array(k).fill(0), S = [];
      for (const I of y) {
        const T = $.indexOf(Math.min(...$));
        S.push({ col: T, top: $[T] }), $[T] += I.offsetHeight + a.gapY;
      }
      o.value = S, r.value = Math.max(...$) - a.gapY;
    }
    function c(y) {
      const k = o.value[y];
      if (!k) return { visibility: "hidden" };
      const $ = i.value;
      if ($ === 1)
        return { top: `${k.top}px`, left: "0", width: "100%" };
      const S = 100 / $, I = a.gapX * ($ - 1) / $;
      return {
        top: `${k.top}px`,
        left: k.col === 0 ? "0" : `calc(${k.col * S}% + ${k.col * a.gapX / $}px)`,
        width: `calc(${S}% - ${I}px)`
      };
    }
    let f, g, h;
    function v() {
      h !== void 0 && cancelAnimationFrame(h), h = requestAnimationFrame(() => {
        h = void 0, d();
      });
    }
    function p(y) {
      i.value = y.matches ? 1 : 2, v();
    }
    return kt(async () => {
      await Ze(), a.useViewport ? (g = window.matchMedia(`(max-width: ${a.breakpoint}px)`), i.value = g.matches ? 1 : 2, g.addEventListener("change", p), d(), f = new ResizeObserver(v), n.value.forEach((y) => f.observe(y))) : (f = new ResizeObserver(() => {
        var k;
        const y = ((k = l.value) == null ? void 0 : k.offsetWidth) ?? 0;
        i.value = y < a.breakpoint ? 1 : 2, v();
      }), n.value.forEach((y) => f.observe(y)), l.value && f.observe(l.value));
    }), zt(() => {
      h !== void 0 && cancelAnimationFrame(h), f == null || f.disconnect(), g == null || g.removeEventListener("change", p);
    }), (y, k) => (u(), b("div", {
      ref_key: "containerRef",
      ref: l,
      class: "relative w-full",
      style: Ge({ height: `${r.value}px` })
    }, [
      (u(!0), b(ie, null, Oe(s.value, ($, S) => (u(), b("div", {
        key: S,
        ref_for: !0,
        ref_key: "itemRefs",
        ref: n,
        class: "absolute",
        style: Ge(c(S))
      }, [
        (u(), P(gt($)))
      ], 4))), 128))
    ], 4));
  }
}), _7 = { class: "group-hover:underline" }, ej = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "InlineLink",
  props: {
    as: {},
    iconLeft: {}
  },
  setup(e) {
    return (a, t) => (u(), P(gt(e.as), Ve(a.$attrs, { class: "flex items-center px-3 py-2 gap-1.5 group leading-5 text-sm text-(--text-text-black-default)" }), {
      default: me(() => [
        e.iconLeft ? (u(), b("i", {
          key: 0,
          class: C(["text-current", e.iconLeft])
        }, null, 2)) : w("", !0),
        x("span", _7, [
          Me(a.$slots, "default")
        ])
      ]),
      _: 3
    }, 16));
  }
}), QG = ej, tj = ["aria-labelledby", "aria-busy"], aj = {
  key: 0,
  class: "flex flex-col space-y-5"
}, nj = {
  key: 0,
  class: "flex items-center gap-2"
}, lj = {
  key: 0,
  class: "flex items-center gap-2 shrink-0"
}, oj = {
  key: 1,
  class: "flex-1 min-w-0 flex flex-col gap-2"
}, rj = ["id"], ij = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "widget-shell-subtitle"
}, sj = {
  key: 2,
  class: "flex items-center gap-3 shrink-0 ms-auto",
  "data-testid": "widget-shell-actions"
}, dj = {
  key: 0,
  class: "flex items-center gap-1.5"
}, uj = {
  key: 1,
  class: "flex items-center gap-1.5"
}, cj = {
  key: 0,
  class: "flex-1 min-w-0 leading-6.5 text-num-16 font-medium truncate text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, fj = {
  key: 1,
  class: "flex items-center ms-auto shrink-0"
}, hj = {
  key: 1,
  "data-testid": "widget-shell-footer"
}, _G = /* @__PURE__ */ ke({
  __name: "WidgetShell",
  props: {
    header: {},
    subtitle: {},
    subheader: {},
    loading: { type: Boolean },
    flush: { type: Boolean },
    stretch: { type: Boolean },
    rounded: {},
    bordered: { type: Boolean, default: !0 }
  },
  setup(e) {
    const a = {
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-sm)",
      m: "rounded-(--border-border-radius-rounded-l)",
      l: "rounded-(--border-border-radius-rounded-base)",
      xl: "rounded-(--border-border-radius-rounded-xl)",
      "2xl": "rounded-(--border-border-radius-rounded-xxl)"
    }, t = e, n = m(() => a[t.rounded ?? "m"]), l = Ye(), o = rn(), r = m(
      () => !t.flush && t.header && !o["aria-label"] ? l : void 0
    ), i = Ia(), s = m(
      () => !!(t.header || t.subtitle || t.subheader) || i("before-actions") || i("actions") || i("nav-actions") || i("sub-info") || i("sub-actions")
    );
    return (d, c) => (u(), b("section", {
      "aria-labelledby": r.value,
      "aria-busy": e.loading || void 0,
      "data-testid": "widget-shell",
      class: C([
        n.value,
        e.bordered !== !1 ? "border border-(--border-border-base-soft) bg-(--colors-background-white) shadow-(--blur-shadow-s) break-inside-avoid" : void 0,
        e.bordered !== !1 ? "dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)" : void 0,
        e.flush ? "overflow-hidden" : "p-6 space-y-6",
        e.stretch ? "flex flex-col flex-1" : "inline-block w-full"
      ])
    }, [
      e.flush ? Me(d.$slots, "default", { key: 0 }) : (u(), b(ie, { key: 1 }, [
        s.value ? (u(), b("div", aj, [
          e.header || e.subtitle || L(i)("before-actions") || L(i)("actions") || L(i)("nav-actions") ? (u(), b("div", nj, [
            L(i)("before-actions") ? (u(), b("div", lj, [
              Me(d.$slots, "before-actions")
            ])) : w("", !0),
            e.header || e.subtitle ? (u(), b("div", oj, [
              e.header ? (u(), b("h2", {
                key: 0,
                id: L(l),
                class: "min-w-0 leading-6.5 text-[1.375rem] font-bold truncate text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
              }, H(e.header), 9, rj)) : w("", !0),
              e.subtitle ? (u(), b("p", ij, H(e.subtitle), 1)) : w("", !0)
            ])) : w("", !0),
            L(i)("actions") || L(i)("nav-actions") ? (u(), b("div", sj, [
              Me(d.$slots, "actions"),
              L(i)("nav-actions") ? (u(), b("div", dj, [
                Me(d.$slots, "nav-actions")
              ])) : w("", !0)
            ])) : w("", !0)
          ])) : w("", !0),
          e.subheader || L(i)("sub-info") || L(i)("sub-actions") ? (u(), b("div", uj, [
            e.subheader ? (u(), b("h3", cj, H(e.subheader), 1)) : w("", !0),
            Me(d.$slots, "sub-info"),
            L(i)("sub-actions") ? (u(), b("div", fj, [
              Me(d.$slots, "sub-actions")
            ])) : w("", !0)
          ])) : w("", !0)
        ])) : w("", !0),
        x("div", {
          class: C(e.stretch ? "flex-1 flex flex-col" : "")
        }, [
          Me(d.$slots, "default")
        ], 2),
        L(i)("footer") ? (u(), b("div", hj, [
          Me(d.$slots, "footer")
        ])) : w("", !0)
      ], 64))
    ], 10, tj));
  }
}), bj = { class: "flex flex-col min-h-0 h-full rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-medium) bg-white shadow-[0px_0px_4px_rgba(0,0,0,0.1)] overflow-hidden" }, eK = /* @__PURE__ */ ke({
  __name: "WidgetBlock",
  props: {
    headerBordered: { type: Boolean, default: !0 },
    footerBordered: { type: Boolean, default: !0 }
  },
  setup(e) {
    const a = Ia();
    return (t, n) => (u(), b("div", bj, [
      L(a)("header") ? (u(), b("div", {
        key: 0,
        "data-testid": "widget-block-header",
        class: C(["sticky top-0 z-10 bg-white px-6 py-5", e.headerBordered ? "border-b border-(--border-border-base-soft)" : ""])
      }, [
        Me(t.$slots, "header")
      ], 2)) : w("", !0),
      x("div", {
        "data-testid": "widget-block-main",
        class: C([
          "flex-1 min-h-0 overflow-y-auto overflow-x-hidden px-6 pb-6",
          L(a)("header") && !e.headerBordered ? "pt-0" : "pt-6"
        ])
      }, [
        Me(t.$slots, "default")
      ], 2),
      L(a)("footer") ? (u(), b("div", {
        key: 1,
        "data-testid": "widget-block-footer",
        class: C(["px-6 py-4", e.footerBordered ? "border-t border-(--border-border-base-soft)" : ""])
      }, [
        Me(t.$slots, "footer")
      ], 2)) : w("", !0)
    ]));
  }
}), gj = {
  key: 0,
  class: "flex flex-col gap-1",
  "data-testid": "widget-section-header"
}, mj = {
  key: 0,
  class: "text-lg font-semibold text-(--colors-text-black-default) m-0"
}, vj = {
  key: 0,
  class: "text-sm text-(--text-text-body) m-0"
}, tK = /* @__PURE__ */ ke({
  __name: "WidgetSection",
  props: {
    title: {},
    subtitle: {},
    bordered: { type: Boolean, default: !0 },
    padded: { type: Boolean, default: !0 },
    gap: { default: "md" }
  },
  setup(e) {
    const a = e, t = Ia(), n = m(
      () => !!a.title || !!a.subtitle || t("title") || t("subtitle")
    ), l = m(
      () => ({ sm: "gap-3", md: "gap-4", lg: "gap-5" })[a.gap]
    );
    return (o, r) => (u(), b("section", {
      class: C([
        "flex flex-col",
        l.value,
        e.bordered && "rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft)",
        e.padded && "p-6"
      ]),
      "data-testid": "widget-section"
    }, [
      n.value ? (u(), b("header", gj, [
        Me(o.$slots, "title", {}, () => [
          e.title ? (u(), b("h3", mj, H(e.title), 1)) : w("", !0)
        ]),
        Me(o.$slots, "subtitle", {}, () => [
          e.subtitle ? (u(), b("p", vj, H(e.subtitle), 1)) : w("", !0)
        ])
      ])) : w("", !0),
      Me(o.$slots, "default")
    ], 2));
  }
}), pj = {
  "data-testid": "cta-widget",
  class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft) shadow-[0px_0px_4px_rgba(0,0,0,0.1)] bg-white p-6",
  style: { "background-image": "var(--gradient-cta-widget)" }
}, xj = { class: "flex flex-col gap-1.5 min-w-0" }, yj = { class: "flex items-center gap-1.5" }, kj = { class: "text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold) text-(--text-text-black-default)" }, wj = { class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-heading)" }, Cj = { class: "flex flex-col items-stretch sm:items-center sm:shrink-0" }, aK = /* @__PURE__ */ ke({
  __name: "CtaWidget",
  props: {
    title: { default: "" },
    titleIcon: { default: void 0 },
    description: { default: "" },
    ctaLabel: { default: "" },
    ctaIcon: { default: "ri-add-line" },
    ctaDisabled: { type: Boolean, default: !1 }
  },
  emits: ["cta-click"],
  setup(e, { emit: a }) {
    const t = a;
    return (n, l) => (u(), b("div", pj, [
      x("div", xj, [
        x("div", yj, [
          e.titleIcon ? (u(), b("i", {
            key: 0,
            class: C([e.titleIcon, "text-(length:--size-l) text-(--text-text-black-default)"]),
            "aria-hidden": "true"
          }, null, 2)) : w("", !0),
          x("p", kj, [
            Me(n.$slots, "title", {}, () => [
              st(H(e.title), 1)
            ])
          ])
        ]),
        x("p", wj, [
          Me(n.$slots, "description", {}, () => [
            st(H(e.description), 1)
          ])
        ])
      ]),
      x("div", Cj, [
        Me(n.$slots, "actions", {}, () => [
          e.ctaLabel ? (u(), P(Be, {
            key: 0,
            variant: "primary",
            size: "xl",
            "icon-left": e.ctaIcon,
            label: e.ctaLabel,
            disabled: e.ctaDisabled,
            onClick: l[0] || (l[0] = (o) => t("cta-click", o))
          }, null, 8, ["icon-left", "label", "disabled"])) : w("", !0)
        ])
      ])
    ]));
  }
}), Sj = {
  "data-testid": "stats-widget",
  class: "flex flex-col justify-center gap-3 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft) bg-(--colors-background-white) p-6 shadow-(--blur-shadow-s) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
}, $j = { class: "flex items-start gap-2" }, Ij = { class: "min-w-0 text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)" }, Lj = { class: "flex flex-wrap items-end gap-x-2 gap-y-1" }, Tj = {
  class: "text-(length:--size-4xl) leading-(--line-height-4xl) font-(--weight-bold) text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
  "data-testid": "stats-widget-value"
}, Ej = ["aria-hidden"], Aj = {
  key: 0,
  class: "sr-only"
}, Rj = {
  key: 1,
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)",
  "data-testid": "stats-widget-caption"
}, zj = {
  key: 0,
  class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)",
  "data-testid": "stats-widget-caption"
}, nK = /* @__PURE__ */ ke({
  __name: "StatsWidget",
  props: {
    icon: { default: void 0 },
    label: { default: "" },
    value: { default: null },
    placeholder: { default: "—" },
    placeholderLabel: { default: "" },
    caption: { default: "" },
    captionInline: { type: Boolean, default: !1 },
    hint: { default: "" },
    valueHint: { default: "" },
    hintIcon: { default: "ri-question-line" }
  },
  setup(e) {
    const a = e, t = m(() => a.value === null || a.value === void 0 || a.value === "");
    return (n, l) => (u(), b("div", Sj, [
      x("div", $j, [
        e.icon ? (u(), b("i", {
          key: 0,
          class: C([e.icon, "shrink-0 text-(length:--size-xxl) leading-(--line-height-xxl) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"]),
          "aria-hidden": "true"
        }, null, 2)) : w("", !0),
        x("p", Ij, [
          Me(n.$slots, "label", {}, () => [
            st(H(e.label), 1)
          ])
        ]),
        e.hint ? (u(), P($t, {
          key: 1,
          text: e.hint,
          as: "span",
          "labels-trigger": "",
          role: "img",
          tabindex: "0",
          "aria-label": e.hint,
          class: "shrink-0 cursor-help self-center rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent",
          "data-testid": "stats-widget-hint"
        }, {
          default: me(() => [
            x("i", {
              class: C([e.hintIcon, "block text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"]),
              "data-testid": "stats-widget-hint-icon",
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : w("", !0)
      ]),
      x("div", Lj, [
        x("p", Tj, [
          Me(n.$slots, "value", {}, () => [
            t.value ? (u(), b(ie, { key: 0 }, [
              x("span", {
                "aria-hidden": e.placeholderLabel ? "true" : void 0
              }, H(e.placeholder), 9, Ej),
              e.placeholderLabel ? (u(), b("span", Aj, H(e.placeholderLabel), 1)) : w("", !0)
            ], 64)) : (u(), b(ie, { key: 1 }, [
              st(H(e.value), 1)
            ], 64))
          ])
        ]),
        e.valueHint ? (u(), P($t, {
          key: 0,
          text: e.valueHint,
          as: "span",
          "labels-trigger": "",
          role: "img",
          tabindex: "0",
          "aria-label": e.valueHint,
          class: "shrink-0 cursor-help self-center rounded-(--border-border-radius-rounded-full) focus-visible:shadow-(--shadow-focus-l) focus-visible:outline-2 focus-visible:outline-transparent",
          "data-testid": "stats-widget-value-hint"
        }, {
          default: me(() => [
            x("i", {
              class: C([e.hintIcon, "block text-(length:--size-m) leading-(--line-height-l) text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"]),
              "data-testid": "stats-widget-value-hint-icon",
              "aria-hidden": "true"
            }, null, 2)
          ]),
          _: 1
        }, 8, ["text", "aria-label"])) : w("", !0),
        e.caption && e.captionInline ? (u(), b("p", Rj, H(e.caption), 1)) : w("", !0)
      ]),
      e.caption && !e.captionInline ? (u(), b("p", zj, H(e.caption), 1)) : w("", !0)
    ]));
  }
}), Dj = ["aria-expanded", "aria-controls", "disabled"], Bj = { class: "flex-shrink-0" }, Mj = {
  key: 0,
  class: "flex h-6 w-6 items-center justify-center rounded-full bg-[#009966] border border-gray-200",
  "data-testid": "collapsible-section-validated"
}, Oj = {
  key: 1,
  class: "flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 dark:bg-[rgba(255,255,255,0.08)]"
}, Pj = { class: "flex-1 min-w-0" }, Fj = { class: "text-base font-semibold text-text-black-default dark:text-(--colors-text-white-default)" }, Nj = {
  key: 0,
  class: "text-sm text-gray-500 dark:text-(--colors-text-white-secondary) mt-0.5 truncate"
}, Vj = { class: "flex-shrink-0" }, Hj = ["id", "inert", "aria-hidden"], jj = { class: "px-14 py-5" }, Wj = ["disabled"], qj = {
  key: 0,
  class: "ri-loader-4-line animate-spin text-sm"
}, Uj = {
  key: 1,
  class: "ri-check-line text-sm"
}, Gj = ["disabled"], Kj = /* @__PURE__ */ ke({
  __name: "CollapsibleSection",
  props: {
    title: {},
    subtitle: { default: void 0 },
    icon: { default: void 0 },
    expanded: { type: Boolean, default: !1 },
    validated: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    showActions: { type: Boolean, default: !0 },
    validateDisabled: { type: Boolean, default: !1 },
    cancelDisabled: { type: Boolean, default: !1 },
    validateLoading: { type: Boolean, default: !1 },
    warning: { default: void 0 },
    validateLabel: { default: "Validate" },
    cancelLabel: { default: "Cancel" },
    actionsAlignment: { default: "start" }
  },
  emits: ["update:expanded", "validate", "cancel"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = R(!1), o = R(null), r = R(null), i = R(null), s = R(null), d = () => {
      var y, k;
      (y = r.value) == null || y.focus(), document.activeElement !== r.value && ((k = o.value) == null || k.focus());
    };
    $e(
      () => t.expanded,
      (y) => {
        var k;
        y || (l.value = !1, (k = i.value) != null && k.contains(document.activeElement) && d());
      }
    ), $e(
      () => t.validateDisabled || t.validateLoading,
      (y) => {
        y && s.value && document.activeElement === s.value && d();
      }
    );
    const c = (y) => {
      y.propertyName === "max-height" && t.expanded && (l.value = !0);
    }, f = Ye(), g = m(() => `${f}-content`), h = () => {
      t.disabled || n("update:expanded", !t.expanded);
    }, v = () => {
      n("validate");
    }, p = () => {
      n("cancel");
    };
    return (y, k) => (u(), b("div", {
      ref_key: "rootRef",
      ref: o,
      class: C(["rounded-xl border border-solid border-lightgray dark:border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default) overflow-hidden", { "opacity-60 cursor-not-allowed": e.disabled }]),
      "data-testid": "collapsible-section",
      tabindex: "-1"
    }, [
      x("button", {
        ref_key: "headerRef",
        ref: r,
        type: "button",
        class: C(["flex w-full items-center gap-6 px-6 py-5 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-hover)", [
          e.expanded ? "bg-gray-50 dark:bg-[rgba(255,255,255,0.03)]" : "",
          e.disabled ? "cursor-not-allowed" : "cursor-pointer hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.03)]"
        ]]),
        "aria-expanded": e.expanded,
        "aria-controls": g.value,
        disabled: e.disabled,
        "data-testid": "collapsible-section-header",
        onClick: h
      }, [
        x("div", Bj, [
          e.validated ? (u(), b("div", Mj, [...k[0] || (k[0] = [
            x("i", { class: "ri-check-fill text-white text-sm" }, null, -1)
          ])])) : e.icon ? (u(), b("div", Oj, [
            x("i", {
              class: C([e.icon, "text-gray-500 dark:text-(--colors-text-white-secondary) text-base"])
            }, null, 2)
          ])) : w("", !0)
        ]),
        x("div", Pj, [
          x("div", Fj, H(e.title), 1),
          e.subtitle ? (u(), b("div", Nj, H(e.subtitle), 1)) : w("", !0)
        ]),
        x("div", Vj, [
          x("i", {
            class: C(["text-xl text-gray-400 dark:text-(--colors-text-white-secondary) transition-transform duration-200", e.expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"])
          }, null, 2)
        ])
      ], 10, Dj),
      x("div", {
        id: g.value,
        ref_key: "contentRef",
        ref: i,
        class: C(["collapsible-content", {
          "collapsible-content--expanded": e.expanded,
          "collapsible-content--open": l.value
        }]),
        role: "region",
        inert: !e.expanded || void 0,
        "aria-hidden": !e.expanded,
        onTransitionend: c
      }, [
        x("div", jj, [
          Me(y.$slots, "default", {}, void 0, !0),
          e.showActions ? (u(), b("div", {
            key: 0,
            class: C(["flex items-center gap-3 mt-4", e.actionsAlignment === "end" ? "flex-row-reverse" : ""])
          }, [
            Me(y.$slots, "actions", {
              validate: v,
              cancel: p
            }, () => [
              x("button", {
                ref_key: "validateRef",
                ref: s,
                type: "button",
                class: C([
                  "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium text-white border border-[#6a7282] transition-colors",
                  e.validateDisabled || e.validateLoading ? "bg-[#242424] opacity-50 cursor-not-allowed" : "bg-[#242424] hover:bg-[#3a3a3a] cursor-pointer"
                ]),
                disabled: e.validateDisabled || e.validateLoading,
                "data-testid": "collapsible-section-validate",
                onClick: _e(v, ["stop"])
              }, [
                e.validateLoading ? (u(), b("i", qj)) : (u(), b("i", Uj)),
                st(" " + H(e.validateLabel), 1)
              ], 10, Wj),
              x("button", {
                type: "button",
                class: C([
                  "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium text-text-black-default dark:text-(--colors-text-white-default) bg-white dark:bg-(--colors-background-black-default) border border-solid border-[#919191] dark:border-(--colors-border-base) transition-colors",
                  e.cancelDisabled ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)] cursor-pointer"
                ]),
                disabled: e.cancelDisabled,
                "data-testid": "collapsible-section-cancel",
                onClick: _e(p, ["stop"])
              }, H(e.cancelLabel), 11, Gj)
            ], !0)
          ], 2)) : w("", !0),
          e.warning ? (u(), P(L(yo), {
            key: 1,
            color: "danger",
            heading: e.warning,
            class: "mt-4",
            "data-testid": "collapsible-section-warning"
          }, null, 8, ["heading"])) : w("", !0)
        ])
      ], 42, Hj)
    ], 2));
  }
}), lK = /* @__PURE__ */ Ct(Kj, [["__scopeId", "data-v-fb7f3a92"]]), Yj = ["aria-label"], Jj = { class: "flex w-full flex-col items-center gap-5" }, Xj = { class: "flex w-full flex-col items-center gap-3.5" }, Zj = {
  key: 0,
  class: "max-w-full truncate rounded border border-(--colors-border-base-soft) bg-white px-1 py-0.5 text-xs font-medium leading-5 text-(--colors-text-black-default) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)"
}, Qj = { class: "flex w-full flex-col items-center gap-2.5 text-center" }, _j = { class: "min-h-[48px] w-full text-xl font-bold leading-6 text-(--colors-text-heading) line-clamp-2 dark:text-(--colors-text-white-default)" }, eW = { class: "min-h-[20px] w-full truncate text-sm leading-5 text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)" }, oK = /* @__PURE__ */ ke({
  __name: "ProfileCard",
  props: {
    name: { default: void 0 },
    role: { default: void 0 },
    email: { default: void 0 },
    avatarUrl: { default: void 0 },
    buttonLabel: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e) {
    return (a, t) => (u(), b("article", {
      class: "flex w-full flex-col items-center gap-6",
      "aria-label": e.name
    }, [
      e.loading ? (u(), b(ie, { key: 0 }, [
        t[1] || (t[1] = Ar('<div class="h-16 w-16 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)"></div><div class="flex w-full flex-col items-center gap-5"><div class="flex w-full flex-col items-center gap-3.5"><div class="h-5 w-28 animate-pulse rounded bg-(--colors-border-base-soft)"></div><div class="flex w-full flex-col items-center gap-2"><div class="h-6 w-4/5 animate-pulse rounded bg-(--colors-border-base-soft)"></div><div class="h-5 w-3/5 animate-pulse rounded bg-(--colors-border-base-soft)"></div></div></div><div class="h-7 w-32 animate-pulse rounded-full bg-(--colors-border-base-soft)"></div></div>', 2))
      ], 64)) : (u(), b(ie, { key: 1 }, [
        U(Jt, {
          name: e.name ?? "",
          img: e.avatarUrl,
          size: "2xl",
          "avatar-style": "square",
          presentational: ""
        }, null, 8, ["name", "img"]),
        x("div", Jj, [
          x("div", Xj, [
            e.role ? (u(), b("span", Zj, H(e.role), 1)) : w("", !0),
            x("div", Qj, [
              x("p", _j, H(e.name), 1),
              x("p", eW, H(e.email), 1)
            ])
          ]),
          U(Be, {
            variant: "secondary",
            size: "xs",
            label: e.buttonLabel,
            "icon-right": "ri-external-link-line",
            "aria-label": `${e.buttonLabel}: ${e.name}`,
            onClick: t[0] || (t[0] = (n) => a.$emit("click"))
          }, null, 8, ["label", "aria-label"])
        ])
      ], 64))
    ], 8, Yj));
  }
}), tW = ["aria-label"], aW = { class: "flex w-full items-center" }, nW = ["aria-label"], lW = { class: "px-5 flex justify-center w-full" }, oW = { class: "flex w-full items-center" }, rW = { class: "flex flex-col items-center gap-0.5 text-center w-full px-5" }, iW = { class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)" }, sW = {
  key: 0,
  class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, dW = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, uW = ["aria-label"], cW = { class: "flex flex-col items-center" }, fW = ["aria-label"], hW = { class: "flex flex-col items-center" }, bW = { class: "flex flex-col gap-1 pb-8 pt-0.5" }, gW = { class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)" }, mW = {
  key: 0,
  class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, vW = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, rK = /* @__PURE__ */ ke({
  __name: "Timeline",
  props: {
    items: { default: () => [] },
    orientation: { default: "auto" },
    ariaLabel: { default: "Timeline" },
    loading: { type: Boolean, default: !1 },
    loadingCount: { default: 3 },
    itemMinWidth: { default: "160px" },
    showItemIcons: { type: Boolean, default: !0 }
  },
  setup(e) {
    const a = e, t = R7("(min-width: 768px)"), n = [
      "green",
      "violet",
      "yellow",
      "indigo",
      "cyan",
      "orange",
      "red",
      "purple",
      "neutral"
    ], l = (i, s) => i.badgeTheme ?? n[s % n.length], o = m(() => a.orientation === "horizontal" ? !0 : a.orientation === "vertical" ? !1 : t.value), r = m(() => Array.from({ length: a.loadingCount }));
    return (i, s) => o.value ? (u(), b("ol", {
      key: 0,
      "aria-label": e.ariaLabel,
      class: "flex w-full items-start overflow-x-auto pb-3"
    }, [
      e.loading ? (u(!0), b(ie, { key: 0 }, Oe(r.value, (d, c) => (u(), b("li", {
        key: c,
        class: "flex flex-1 flex-col items-center gap-4",
        style: Ge({ minWidth: e.itemMinWidth })
      }, [
        s[1] || (s[1] = x("div", { class: "px-5 flex justify-center w-full" }, [
          x("div", { class: "h-6 w-24 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1)),
        x("div", aW, [
          x("div", {
            class: C(["flex-1 h-px", c === 0 ? "invisible" : "bg-(--colors-border-base-soft)"])
          }, null, 2),
          s[0] || (s[0] = x("div", { class: "h-3 w-3 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)" }, null, -1)),
          x("div", {
            class: C([
              "flex-1 h-px",
              c === r.value.length - 1 ? "invisible" : "bg-(--colors-border-base-soft)"
            ])
          }, null, 2)
        ]),
        s[2] || (s[2] = x("div", { class: "flex flex-col items-center gap-2 w-full px-5" }, [
          x("div", { class: "h-5 w-28 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          x("div", { class: "h-4 w-20 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1))
      ], 4))), 128)) : (u(!0), b(ie, { key: 1 }, Oe(e.items, (d, c) => (u(), b("li", {
        key: c,
        "aria-label": `${d.title}, ${d.date}`,
        class: "flex flex-1 flex-col items-center gap-4",
        style: Ge({ minWidth: e.itemMinWidth })
      }, [
        x("div", lW, [
          U(yt, {
            label: d.date,
            theme: l(d, c),
            "show-close-icon": !1,
            "show-left-icon": e.showItemIcons,
            size: "sm",
            class: "whitespace-nowrap",
            "left-icon": e.showItemIcons ? d.icon ?? "ri-calendar-line" : void 0
          }, null, 8, ["label", "theme", "show-left-icon", "left-icon"])
        ]),
        x("div", oW, [
          x("div", {
            class: C(["flex-1 h-px bg-(--colors-border-base-medium)", c === 0 ? "invisible" : ""])
          }, null, 2),
          s[3] || (s[3] = x("div", { class: "h-3 w-3 shrink-0 rounded-full border-2 border-white bg-(--icons-icon-disabled-light) dark:border-(--colors-border-base) z-10" }, null, -1)),
          x("div", {
            class: C([
              "flex-1 h-px bg-(--colors-border-base-medium)",
              c === e.items.length - 1 ? "invisible" : ""
            ])
          }, null, 2)
        ]),
        x("div", rW, [
          x("p", iW, H(d.title), 1),
          d.subtitle ? (u(), b("p", sW, H(d.subtitle), 1)) : w("", !0),
          d.description ? (u(), b("p", dW, H(d.description), 1)) : w("", !0)
        ])
      ], 12, nW))), 128))
    ], 8, tW)) : (u(), b("ol", {
      key: 1,
      "aria-label": e.ariaLabel,
      class: "flex flex-col"
    }, [
      e.loading ? (u(!0), b(ie, { key: 0 }, Oe(r.value, (d, c) => (u(), b("li", {
        key: c,
        class: "flex flex-row gap-4"
      }, [
        x("div", cW, [
          x("div", {
            class: C([
              "w-px flex-1 bg-(--colors-border-base-soft)",
              c === 0 ? "invisible" : "animate-pulse"
            ])
          }, null, 2),
          s[4] || (s[4] = x("div", { class: "h-3 w-3 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)" }, null, -1)),
          x("div", {
            class: C([
              "w-px flex-1 bg-(--colors-border-base-soft)",
              c === r.value.length - 1 ? "invisible" : "animate-pulse"
            ])
          }, null, 2)
        ]),
        s[5] || (s[5] = x("div", { class: "flex flex-col gap-2 pb-8 pt-0.5" }, [
          x("div", { class: "h-6 w-24 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          x("div", { class: "h-5 w-36 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          x("div", { class: "h-4 w-28 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1))
      ]))), 128)) : (u(!0), b(ie, { key: 1 }, Oe(e.items, (d, c) => (u(), b("li", {
        key: c,
        "aria-label": `${d.title}, ${d.date}`,
        class: "flex flex-row gap-4"
      }, [
        x("div", hW, [
          x("div", {
            class: C([
              "w-px h-[9px] shrink-0 bg-(--colors-border-base-medium)",
              c === 0 ? "invisible" : ""
            ])
          }, null, 2),
          s[6] || (s[6] = x("div", { class: "h-3 w-3 shrink-0 rounded-full border-2 border-white bg-(--icons-icon-disabled-light) dark:border-(--colors-border-base) z-10" }, null, -1)),
          x("div", {
            class: C([
              "w-px flex-1 bg-(--colors-border-base-medium)",
              c === e.items.length - 1 ? "invisible" : ""
            ])
          }, null, 2)
        ]),
        x("div", bW, [
          U(yt, {
            label: d.date,
            theme: l(d, c),
            "show-close-icon": !1,
            "show-left-icon": e.showItemIcons,
            size: "sm",
            class: "self-start",
            "left-icon": e.showItemIcons ? d.icon ?? "ri-calendar-line" : void 0
          }, null, 8, ["label", "theme", "show-left-icon", "left-icon"]),
          x("p", gW, H(d.title), 1),
          d.subtitle ? (u(), b("p", mW, H(d.subtitle), 1)) : w("", !0),
          d.description ? (u(), b("p", vW, H(d.description), 1)) : w("", !0)
        ])
      ], 8, fW))), 128))
    ], 8, uW));
  }
}), bg = /* @__PURE__ */ ke({
  __name: "StepperWizardPhaseIcon",
  props: {
    icon: {},
    disabled: { type: Boolean }
  },
  setup(e) {
    return (a, t) => (u(), P(aa, {
      size: "md",
      type: "circle",
      variant: "outlined",
      color: e.disabled ? "disabled" : "white",
      icon: e.icon
    }, null, 8, ["color", "icon"]));
  }
}), pW = ["data-testid", "aria-current", "aria-disabled", "onClick"], xW = { class: "truncate" }, yW = ["data-testid", "aria-expanded", "aria-disabled", "onClick"], kW = { class: "flex items-center gap-3 truncate" }, wW = { class: "truncate" }, CW = ["data-testid", "aria-current", "aria-disabled", "onClick"], SW = {
  key: 1,
  class: "h-6 w-9 shrink-0",
  "aria-hidden": "true"
}, $W = { class: "py-0.5" }, gg = "flex items-center gap-3 p-1 w-full text-left rounded-(--border-border-radius-rounded-xs) text-base font-medium leading-6", iK = /* @__PURE__ */ ke({
  __name: "StepperWizardSidenav",
  props: {
    groups: {},
    currentStepId: {},
    showStatusIcons: { type: Boolean },
    showPhaseIcons: { type: Boolean }
  },
  emits: ["step-click", "group-toggle"],
  setup(e, { emit: a }) {
    function t(h, v) {
      if (h) return "text-(--text-text-disabled-light) cursor-not-allowed";
      const p = "text-(--text-text-heading) transition-colors";
      return v ? `${p} bg-[image:var(--gradient-brand-row-highlight)]` : `${p} hover:bg-[image:var(--gradient-brand-row-highlight)]`;
    }
    const n = e, l = a, o = Bn({});
    function r() {
      for (const h of n.groups)
        h.steps.length > 0 && (o[h.id] = h.defaultExpanded ?? !0);
    }
    r(), $e(
      () => n.groups,
      (h) => {
        for (const v of h)
          v.steps.length > 0 && !(v.id in o) && (o[v.id] = v.defaultExpanded ?? !0);
      },
      { deep: !1 }
    );
    const i = m(() => {
      var h;
      if (n.currentStepId)
        return (h = n.groups.find(
          (v) => v.steps.some((p) => p.id === n.currentStepId)
        )) == null ? void 0 : h.id;
    });
    $e(
      i,
      (h) => {
        h && (o[h] = !0);
      },
      { immediate: !0 }
    );
    function s(h, v) {
      return v != null && v.disabled ? "disabled" : h.id === n.currentStepId ? "current" : h.state ?? "upcoming";
    }
    function d(h) {
      switch (h) {
        case "done":
          return "ri-checkbox-circle-fill";
        case "current":
          return "ri-checkbox-circle-line";
        case "disabled":
          return "ri-checkbox-blank-circle-line";
        case "upcoming":
        default:
          return "ri-checkbox-blank-circle-line";
      }
    }
    function c(h) {
      l("step-click", h);
    }
    function f(h) {
      if (i.value === h) return;
      const v = !o[h];
      o[h] = v, l("group-toggle", h, v);
    }
    function g(h, v) {
      v != null && v.disabled || h.state !== "disabled" && (h.id, n.currentStepId, l("step-click", h.id));
    }
    return (h, v) => (u(), b("nav", {
      role: "navigation",
      class: C(["flex flex-col gap-3 pb-1.5 w-full min-w-72", h.$attrs.class])
    }, [
      (u(!0), b(ie, null, Oe(e.groups, (p) => (u(), b("div", {
        key: p.id,
        class: "flex flex-col gap-2 pr-1.5"
      }, [
        p.steps.length === 0 ? (u(), P($t, {
          key: 0,
          class: "w-full",
          text: p.lockTooltip ?? "",
          disabled: !p.disabled || !p.lockTooltip,
          position: "bottom"
        }, {
          default: me(() => [
            x("button", {
              type: "button",
              "data-testid": `sw-step-${p.id}`,
              "aria-current": p.id === e.currentStepId ? "step" : void 0,
              "aria-disabled": p.disabled ? "true" : void 0,
              class: C([gg, t(p.disabled, p.id === e.currentStepId)]),
              onClick: (y) => !p.disabled && c(p.id)
            }, [
              e.showPhaseIcons && p.icon ? (u(), P(bg, {
                key: 0,
                icon: p.icon,
                disabled: p.disabled
              }, null, 8, ["icon", "disabled"])) : w("", !0),
              x("span", xW, H(p.label), 1)
            ], 10, pW)
          ]),
          _: 2
        }, 1032, ["text", "disabled"])) : (u(), b(ie, { key: 1 }, [
          U($t, {
            class: "w-full",
            text: p.lockTooltip ?? "",
            disabled: !p.disabled || !p.lockTooltip,
            position: "bottom"
          }, {
            default: me(() => [
              x("button", {
                type: "button",
                "data-testid": `sw-group-${p.id}`,
                "aria-expanded": o[p.id],
                "aria-disabled": p.disabled ? "true" : void 0,
                class: C([
                  gg,
                  "justify-between",
                  t(p.disabled, i.value === p.id)
                ]),
                onClick: (y) => !p.disabled && f(p.id)
              }, [
                x("span", kW, [
                  e.showPhaseIcons && p.icon ? (u(), P(bg, {
                    key: 0,
                    icon: p.icon,
                    disabled: p.disabled
                  }, null, 8, ["icon", "disabled"])) : w("", !0),
                  x("span", wW, H(p.label), 1)
                ]),
                x("i", {
                  class: C([
                    "ri-arrow-down-s-line text-xl shrink-0 transition-transform",
                    o[p.id] ? "-rotate-180" : ""
                  ]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 10, yW)
            ]),
            _: 2
          }, 1032, ["text", "disabled"]),
          o[p.id] ? (u(!0), b(ie, { key: 0 }, Oe(p.steps, (y) => (u(), P($t, {
            key: y.id,
            class: "w-full",
            text: y.lockTooltip ?? "",
            disabled: s(y, p) !== "disabled" || !y.lockTooltip,
            position: "bottom"
          }, {
            default: me(() => [
              x("button", {
                type: "button",
                "data-testid": `sw-step-${y.id}`,
                "aria-current": s(y, p) === "current" ? "step" : void 0,
                "aria-disabled": s(y, p) === "disabled" ? "true" : void 0,
                class: C([
                  "flex items-start gap-3 px-1 w-full text-left text-sm font-medium leading-5",
                  s(y, p) === "disabled" ? "text-(--text-text-disabled-strong) cursor-not-allowed" : s(y, p) === "current" ? "text-(--text-text-hover)" : "text-(--text-text-body) hover:text-(--text-text-hover) transition-colors"
                ]),
                onClick: (k) => g(y, p)
              }, [
                e.showStatusIcons ? (u(), b("i", {
                  key: 0,
                  class: C([d(s(y, p)), "text-xl shrink-0"]),
                  "aria-hidden": "true"
                }, null, 2)) : (u(), b("span", SW)),
                x("span", $W, H(y.label), 1)
              ], 10, CW)
            ]),
            _: 2
          }, 1032, ["text", "disabled"]))), 128)) : w("", !0)
        ], 64))
      ]))), 128))
    ], 2));
  }
}), IW = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only"
}, LW = {
  key: 0,
  "data-testid": "actions-status",
  role: "status",
  "aria-live": "polite",
  class: "sr-only"
}, TW = ["aria-label"], EW = { class: "inline-flex items-center gap-3.5 shrink-0" }, AW = {
  "data-testid": "actions-group",
  class: "flex items-center gap-1 min-w-0"
}, RW = {
  key: 0,
  "data-testid": "actions-loading",
  class: "flex items-center gap-2 px-2 shrink-0",
  "aria-hidden": "true"
}, zW = ["inert"], DW = { class: "hidden sm:inline" }, nu = 640, mg = 560, BW = 1100, MW = "ri-lock-line", lu = 20, OW = "__untagged__", PW = 3, FW = '[data-testid="dropdown-menu"]', NW = /* @__PURE__ */ ke({
  __name: "FloatActionBar",
  props: {
    selectionCount: {},
    allPagesSelected: { type: Boolean },
    totalAcrossAllPages: {},
    actions: {},
    maxVisibleActions: { default: 4 },
    isLoading: { type: Boolean, default: !1 },
    actionsLoading: { type: Boolean, default: !1 },
    actionsError: { type: Boolean, default: !1 },
    moduleLabels: { default: void 0 },
    ariaLabel: {},
    selectedItemLabel: {},
    selectedItemsLabel: {},
    selectAllPagesLabel: {},
    moreLabel: {},
    moreActionsTitle: {},
    closeLabel: {},
    totalUnavailableLabel: {},
    selectionClearedLabel: {},
    actionsLoadingLabel: { default: void 0 }
  },
  emits: ["dismiss", "action-click", "select-all-pages"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = {
      primary: "primary",
      secondary: "secondary",
      text: "text",
      destructive: "error-text"
    };
    function o(Ie) {
      return Ie.variant ? l[Ie.variant] : Ie.destructive ? "error-text" : "text";
    }
    function r(Ie) {
      return Ie.variant === "destructive" || Ie.destructive === !0;
    }
    function i(Ie) {
      return s(Ie) ? MW : Ie.icon;
    }
    function s(Ie) {
      return Ie.disabled ? Ie.disabledReason : void 0;
    }
    const d = m(() => t.actions.some((Ie) => Ie.order !== void 0) ? t.actions.map((Ie, pe) => ({ action: Ie, index: pe })).sort(
      (Ie, pe) => (Ie.action.order ?? Number.MAX_SAFE_INTEGER) - (pe.action.order ?? Number.MAX_SAFE_INTEGER) || Ie.index - pe.index
    ).map((Ie) => Ie.action) : t.actions), c = m(
      () => t.actionsLoading || t.actionsError ? [] : d.value
    ), f = m(
      () => c.value.filter((Ie) => Ie.placement !== "overflow")
    ), g = R(typeof window < "u" ? window.innerWidth : 1024);
    function h() {
      g.value = window.innerWidth, Q.value !== null && (Q.value = Se(Q.value)), requestAnimationFrame($);
    }
    kt(() => window.addEventListener("resize", h)), zt(() => window.removeEventListener("resize", h));
    const v = R(null), p = R([]), y = R(t.actions.length);
    function k(Ie) {
      return (pe) => {
        p.value[Ie] = pe instanceof HTMLElement ? pe : null;
      };
    }
    function $() {
      const Ie = v.value;
      if (!Ie) {
        y.value = f.value.length;
        return;
      }
      const pe = Ie.getBoundingClientRect().right, Pe = p.value.findIndex(
        (Xe) => Xe && Xe.getBoundingClientRect().right > pe + 1
      );
      y.value = Pe === -1 ? f.value.length : Pe;
    }
    let S = null;
    $e(
      v,
      (Ie) => {
        S == null || S.disconnect(), Ie && (S ?? (S = new ResizeObserver(() => requestAnimationFrame($))), S.observe(Ie), requestAnimationFrame($));
      },
      { flush: "post", immediate: !0 }
    ), zt(() => S == null ? void 0 : S.disconnect());
    const I = m(
      () => f.value.map((Ie) => `${Ie.id}${Ie.label}${i(Ie) ?? ""}`).join("\0")
    );
    $e(I, () => requestAnimationFrame($));
    const T = m(() => g.value < nu ? 0 : Math.min(y.value, t.maxVisibleActions));
    function A(Ie) {
      return Ie >= t.maxVisibleActions || g.value < nu ? "hidden" : Ie >= T.value ? "invisible" : "";
    }
    const E = m(() => {
      const Ie = new Set(
        f.value.slice(0, T.value).map((pe) => pe.id)
      );
      return c.value.filter((pe) => !Ie.has(pe.id));
    }), z = m(() => E.value.length > 0);
    $e(
      () => E.value.length,
      (Ie) => {
        Ie > lu && console.warn(
          `[FloatActionBar] More menu has ${Ie} actions; only the first ${lu} are rendered.`
        );
      },
      { immediate: !0 }
    );
    const B = m(
      () => E.value.slice(0, lu)
    );
    function W(Ie) {
      return {
        label: Ie.label,
        icon: i(Ie),
        danger: r(Ie),
        disabled: Ie.disabled || t.isLoading,
        loading: Ie.loading,
        // Shown as helper text under the label; an item carrying a description stays
        // focusable (aria-disabled) so the reason is keyboard-reachable (R74).
        description: s(Ie),
        testId: "megamenu-nav-link",
        onClick: () => n("action-click", Ie.id, D.value)
      };
    }
    const _ = m(
      () => B.value.map(W)
    ), Z = m(() => {
      const Ie = [
        ...new Set(
          B.value.map((Xe) => Xe.module).filter((Xe) => !!Xe)
        )
      ], pe = B.value.filter((Xe) => !Xe.module);
      if (Ie.length + (pe.length > 0 ? 1 : 0) < 2) return;
      const Pe = Ie.map((Xe) => {
        var nt;
        return {
          key: Xe,
          // No fallback to the raw key: it is an identifier, and rendering it would ship
          // untranslated text to fr/nl users (R29). A heading-less column is the safe default.
          label: (nt = t.moduleLabels) == null ? void 0 : nt[Xe],
          items: B.value.filter((vt) => vt.module === Xe).map(W)
        };
      });
      return pe.length > 0 && Pe.push({ key: OW, items: pe.map(W) }), Pe;
    }), le = m(() => g.value < BW ? 2 : 4), D = m(() => ({
      selectedCount: t.selectionCount,
      allPagesSelected: t.allPagesSelected,
      totalCount: t.totalAcrossAllPages
    })), O = m(
      () => t.allPagesSelected && t.totalAcrossAllPages !== void 0 ? t.totalAcrossAllPages : t.selectionCount
    ), N = m(
      () => O.value === 1 ? t.selectedItemLabel : t.selectedItemsLabel
    ), V = R(null), M = R(null), Q = R(null), q = R(!1);
    let K = 0, G = 0, te = 0;
    function ve() {
      var Ie;
      return ((Ie = V.value) == null ? void 0 : Ie.offsetWidth) ?? 0;
    }
    function Se(Ie) {
      return Math.max(16, Math.min(Ie, window.innerWidth - ve() - 16));
    }
    let oe = null;
    $e(
      () => V.value,
      (Ie) => {
        oe == null || oe.disconnect(), !(!Ie || typeof ResizeObserver > "u") && (oe ?? (oe = new ResizeObserver(() => {
          Q.value !== null && (Q.value = Se(Q.value));
        })), oe.observe(Ie));
      },
      { flush: "post" }
    ), zt(() => oe == null ? void 0 : oe.disconnect());
    let re = !1;
    function ge(Ie) {
      var pe, Pe;
      !V.value || Ie.button !== 0 || ((Pe = (pe = Ie.currentTarget) == null ? void 0 : pe.setPointerCapture) == null || Pe.call(pe, Ie.pointerId), ae(), q.value = !0, re = !1, K = Ie.clientX, G = Ie.clientY, te = Q.value ?? (window.innerWidth - ve()) / 2, Ie.preventDefault());
    }
    function de(Ie) {
      if (!q.value) return;
      const pe = Ie.clientX - K;
      !re && Math.hypot(pe, Ie.clientY - G) <= PW || (re = !0, Q.value = Se(te + pe));
    }
    function Ee(Ie) {
      var pe, Pe;
      q.value && (q.value = !1, (Pe = (pe = Ie.currentTarget) == null ? void 0 : pe.releasePointerCapture) == null || Pe.call(pe, Ie.pointerId), Ie.type === "pointerup" && (j.value = re ? !1 : !j.value));
    }
    const j = R(!1);
    function J(Ie) {
      var pe;
      if (Ie.detail === 0) {
        j.value = !1;
        return;
      }
      if (Ie.button === 0) {
        if (ne(Ie.target)) {
          (pe = M.value) != null && pe.contains(Ie.target) || (j.value = !1);
          return;
        }
        Ie.preventDefault(), Ie.stopPropagation(), Q.value = Se(Ie.clientX - ve() / 2), j.value = !1;
      }
    }
    function ne(Ie) {
      var pe;
      return Ie instanceof Node && (!!((pe = V.value) != null && pe.contains(Ie)) || X(Ie));
    }
    function Y(Ie) {
      Ie.button !== 0 || ne(Ie.target) || (Ie.preventDefault(), Ie.stopPropagation());
    }
    const F = [
      ["click", J],
      ["pointerdown", Y],
      ["mousedown", Y],
      ["pointerup", Y],
      ["mouseup", Y]
    ];
    function ee(Ie) {
      for (const [pe, Pe] of F)
        Ie ? document.addEventListener(pe, Pe, !0) : document.removeEventListener(pe, Pe, !0);
    }
    let ue = "";
    $e(j, (Ie) => {
      ee(Ie);
      const pe = document.documentElement;
      Ie ? (ue = pe.style.cursor, pe.style.cursor = "crosshair") : pe.style.cursor = ue;
    }), zt(() => {
      ee(!1), j.value && (document.documentElement.style.cursor = ue);
    });
    const se = R(null);
    function X(Ie) {
      return Ie instanceof Element && !!Ie.closest(FW);
    }
    function ae() {
      var Pe, Xe, nt;
      if (!((Pe = se.value) != null && Pe.isOpen)) return;
      const Ie = document.activeElement, pe = !!Ie && X(Ie);
      se.value.close(), pe && ((nt = (Xe = V.value) == null ? void 0 : Xe.querySelector('[data-testid="more-btn"]')) == null || nt.focus());
    }
    $e(
      () => {
        var Ie;
        return (Ie = se.value) == null ? void 0 : Ie.isOpen;
      },
      (Ie) => {
        Ie && (j.value = !1);
      }
    );
    const Re = R(null), Ae = R([]);
    function xe(Ie) {
      return (pe) => {
        Ae.value[Ie] = pe ?? null;
      };
    }
    function we() {
      var Ie;
      return (Ie = Re.value) != null && Ie.isVisible ? Re.value : Ae.value.find((pe) => pe == null ? void 0 : pe.isVisible) ?? null;
    }
    const fe = Symbol("float-action-bar");
    function Ne(Ie) {
      var Pe, Xe, nt;
      if (Ie.key !== "Escape" || (Pe = se.value) != null && Pe.isOpen) return;
      const pe = we();
      if (pe) {
        Ie.stopPropagation(), Ie.preventDefault(), pe.hide();
        return;
      }
      if (j.value) {
        if (!On(fe)) return;
        Ie.preventDefault(), Ie.target instanceof Node && ((Xe = V.value) != null && Xe.contains(Ie.target)) && Ie.stopPropagation(), j.value = !1;
        return;
      }
      De.value && On(fe) && (Ie.preventDefault(), Ie.target instanceof Node && ((nt = V.value) != null && nt.contains(Ie.target)) && Ie.stopPropagation(), n("dismiss"));
    }
    kt(() => window.addEventListener("keydown", Ne, !0)), zt(() => {
      window.removeEventListener("keydown", Ne, !0), _a(fe);
    });
    const De = m(() => t.selectionCount > 0);
    let qe = null;
    $e(De, (Ie) => {
      Ie || (j.value = !1, q.value = !1);
    }), $e(
      De,
      (Ie) => Ie ? xn(fe) : _a(fe)
    );
    let Qe = !1;
    kt(() => {
      Qe = !0, Ze(() => {
        Qe && De.value && xn(fe);
      });
    }), zt(() => {
      Qe = !1;
    }), $e(De, (Ie) => {
      var pe;
      if (Ie) {
        qe = document.activeElement instanceof HTMLElement && document.activeElement !== document.body ? document.activeElement : null;
        return;
      }
      (pe = V.value) != null && pe.contains(document.activeElement) && qe && document.contains(qe) && qe.focus();
    });
    const lt = R("");
    return $e(
      () => [t.selectionCount, t.allPagesSelected, t.totalAcrossAllPages],
      ([Ie], pe) => {
        const Pe = pe == null ? void 0 : pe[0];
        Ie > 0 ? lt.value = `${O.value} ${N.value}` : Pe !== void 0 && Pe > 0 && (lt.value = t.selectionClearedLabel);
      },
      { immediate: !0 }
    ), (Ie, pe) => (u(), b(ie, null, [
      x("span", IW, H(lt.value), 1),
      e.actionsLoadingLabel ? (u(), b("span", LW, H(e.actionsLoading ? e.actionsLoadingLabel : ""), 1)) : w("", !0),
      U(Wt, {
        name: "float-bar",
        appear: ""
      }, {
        default: me(() => [
          e.selectionCount > 0 ? (u(), b("div", {
            key: 0,
            ref_key: "barRef",
            ref: V,
            "data-testid": "float-action-bar",
            role: "toolbar",
            "aria-label": e.ariaLabel,
            class: "inline-flex items-center gap-3.5 p-1.5 rounded-full overflow-hidden z-40 bg-(--background-background-black-default) shadow-(--shadow-xl)",
            style: Ge({
              position: "fixed",
              bottom: "24px",
              left: Q.value !== null ? `${Q.value}px` : "16px",
              right: Q.value !== null ? void 0 : "16px",
              width: Q.value !== null ? "max-content" : "fit-content",
              margin: Q.value !== null ? void 0 : "0 auto",
              maxWidth: "calc(100vw - 32px)",
              cursor: q.value ? "grabbing" : j.value ? "crosshair" : void 0
            })
          }, [
            x("button", {
              ref_key: "handleRef",
              ref: M,
              "data-testid": "drag-handle",
              tabindex: "-1",
              "aria-hidden": "true",
              class: C([j.value ? "cursor-crosshair" : "cursor-grab", "flex shrink-0 items-center justify-center size-9 rounded-full bg-transparent border-none touch-none focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-(--border-border-accent)"]),
              onPointerdown: ge,
              onPointermove: de,
              onPointerup: Ee,
              onPointercancel: Ee,
              onClick: pe[0] || (pe[0] = _e(() => {
              }, ["prevent"]))
            }, [...pe[3] || (pe[3] = [
              x("i", {
                class: "ri-draggable text-(length:--icon-size-md) leading-(--icon-size-md) text-(--icons-icon-white-default)",
                "aria-hidden": "true"
              }, null, -1)
            ])], 34),
            x("div", EW, [
              U(Be, {
                "data-testid": "selection-count",
                variant: "secondary",
                size: "xs",
                label: g.value >= mg ? `${O.value} ${N.value}` : `${O.value}`,
                "icon-right": "ri-close-fill",
                "aria-label": `${O.value} ${N.value}`,
                class: "shrink-0",
                onClick: pe[1] || (pe[1] = (Pe) => n("dismiss"))
              }, null, 8, ["label", "aria-label"]),
              U($t, {
                ref_key: "selectAllTooltipRef",
                ref: Re,
                text: e.totalUnavailableLabel,
                disabled: e.totalAcrossAllPages !== void 0
              }, {
                default: me(() => [
                  U(va, {
                    variant: "dark",
                    "model-value": e.allPagesSelected,
                    label: g.value >= mg ? e.selectAllPagesLabel : "",
                    "aria-label": e.selectAllPagesLabel,
                    "aria-disabled": e.totalAcrossAllPages === void 0,
                    class: "px-1 shrink-0 w-auto!",
                    "onUpdate:modelValue": pe[2] || (pe[2] = (Pe) => n("select-all-pages", Pe))
                  }, null, 8, ["model-value", "label", "aria-label", "aria-disabled"])
                ]),
                _: 1
              }, 8, ["text", "disabled"])
            ]),
            x("div", AW, [
              x("div", {
                ref_key: "btnAreaRef",
                ref: v,
                "data-testid": "action-buttons-area",
                class: "dark flex items-center gap-1 overflow-hidden min-w-0"
              }, [
                e.actionsLoading ? (u(), b("div", RW, [...pe[4] || (pe[4] = [
                  x("i", { class: "ri-loader-4-line animate-spin text-(length:--icon-size-sm) leading-(--icon-size-sm) text-(--icons-icon-white-default)" }, null, -1),
                  x("span", { class: "h-2 w-16 rounded-full bg-(--text-text-white-default) opacity-30" }, null, -1),
                  x("span", { class: "h-2 w-10 rounded-full bg-(--text-text-white-default) opacity-30" }, null, -1)
                ])])) : w("", !0),
                (u(!0), b(ie, null, Oe(f.value, (Pe, Xe) => (u(), b("div", {
                  key: Pe.id,
                  ref_for: !0,
                  ref: k(Xe),
                  class: C(["shrink-0", A(Xe)]),
                  inert: Xe >= T.value || void 0
                }, [
                  U($t, {
                    ref_for: !0,
                    ref: xe(Xe),
                    text: s(Pe) ?? "",
                    disabled: !s(Pe)
                  }, {
                    default: me(() => [
                      U(Be, {
                        "data-testid": `action-btn-${Pe.id}`,
                        variant: o(Pe),
                        size: "xs",
                        "icon-left": i(Pe),
                        "icon-only": g.value < nu,
                        loading: Pe.loading,
                        disabled: !s(Pe) && (Pe.disabled || e.isLoading),
                        "aria-disabled": !!s(Pe),
                        "aria-label": Pe.label,
                        onClick: (nt) => n("action-click", Pe.id, D.value)
                      }, {
                        default: me(() => [
                          x("span", DW, H(Pe.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["data-testid", "variant", "icon-left", "icon-only", "loading", "disabled", "aria-disabled", "aria-label", "onClick"])
                    ]),
                    _: 2
                  }, 1032, ["text", "disabled"])
                ], 10, zW))), 128))
              ], 512),
              z.value ? (u(), P(Ra, {
                key: 0,
                ref_key: "dropdownRef",
                ref: se,
                class: "shrink-0",
                "menu-item-variant": "nav",
                items: _.value,
                groups: Z.value,
                columns: le.value,
                "menu-header": e.moreActionsTitle,
                closeable: "",
                "close-label": e.closeLabel,
                "menu-reference": V.value,
                "menu-align": "right",
                "menu-side": "top",
                "menu-offset": 4
              }, {
                trigger: me(({ triggerProps: Pe }) => [
                  U(Be, Ve({
                    "data-testid": "more-btn",
                    variant: "secondary",
                    size: "xs",
                    "icon-left": "ri-more-line",
                    label: e.moreLabel,
                    class: "shrink-0"
                  }, Pe), null, 16, ["label"])
                ]),
                _: 1
              }, 8, ["items", "groups", "columns", "menu-header", "close-label", "menu-reference"])) : w("", !0)
            ])
          ], 12, TW)) : w("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), sK = /* @__PURE__ */ Ct(NW, [["__scopeId", "data-v-ed745030"]]);
function dK(e, a = {}) {
  const t = ko([]), n = R(!1), l = R(!1), o = R(null), r = R(void 0);
  let i = 0;
  async function s() {
    const d = ++i;
    n.value = !0, l.value = !1, o.value = null, t.value = [];
    try {
      const c = await e();
      if (d !== i) return;
      t.value = (c == null ? void 0 : c.actions) ?? [], r.value = c == null ? void 0 : c.version;
    } catch (c) {
      if (d !== i) return;
      l.value = !0, o.value = c, t.value = [];
    } finally {
      d === i && (n.value = !1);
    }
  }
  return a.immediate !== !1 && s(), { actions: t, isLoading: n, hasError: l, error: o, version: r, load: s };
}
const VW = {
  "data-testid": "field-skeleton",
  "aria-hidden": "true",
  class: "w-full"
}, HW = {
  key: 0,
  class: "flex items-center gap-2"
}, jW = {
  key: 0,
  class: "h-5 pb-0.5 flex items-center"
}, WW = /* @__PURE__ */ ke({
  __name: "FieldSkeleton",
  props: {
    variant: { default: "input" },
    size: { default: "md" },
    showLabel: { type: Boolean, default: !0 }
  },
  setup(e) {
    const a = {
      sm: "h-[32px]",
      md: "h-[36px]",
      lg: "h-[48px]",
      xl: "h-[52px]"
    };
    return (t, n) => (u(), b("div", VW, [
      e.variant === "checkbox" || e.variant === "toggle" ? (u(), b("div", HW, [
        x("div", {
          class: C([
            "skeleton shrink-0",
            e.variant === "toggle" ? "h-5 w-9 rounded-full" : "size-4 rounded"
          ])
        }, null, 2),
        n[0] || (n[0] = x("div", { class: "skeleton h-2.5 w-24 rounded-full" }, null, -1))
      ])) : (u(), b(ie, { key: 1 }, [
        e.showLabel ? (u(), b("div", jW, [...n[1] || (n[1] = [
          x("div", { class: "skeleton h-2.5 w-24 rounded-full" }, null, -1)
        ])])) : w("", !0),
        x("div", {
          class: C([
            "skeleton w-full rounded-xl",
            e.variant === "textarea" ? "h-24" : a[e.size]
          ])
        }, null, 2)
      ], 64))
    ]));
  }
}), uK = /* @__PURE__ */ ke({
  __name: "FormSkeleton",
  props: {
    fields: { default: 6 },
    columns: { default: 2 },
    size: { default: "md" },
    showLabels: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (a, t) => (u(), b("div", {
      "data-testid": "form-skeleton",
      "aria-hidden": "true",
      class: C(["grid gap-x-5 gap-y-4", e.columns === 2 ? "grid-cols-2" : "grid-cols-1"])
    }, [
      (u(!0), b(ie, null, Oe(e.fields, (n) => (u(), P(WW, {
        key: `form-skeleton-field-${n}`,
        size: e.size,
        "show-label": e.showLabels
      }, null, 8, ["size", "show-label"]))), 128))
    ], 2));
  }
}), qW = {
  class: "flex flex-col gap-(--spacing-3)",
  "data-testid": "color-picker-palette"
}, UW = { class: "flex min-w-0 flex-1 rounded-(--border-border-radius-rounded-xs) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-[calc(var(--spacing-1)-1px)]" }, GW = { class: "whitespace-nowrap text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-body)" }, KW = ["aria-label"], YW = ["aria-label", "aria-selected", "tabindex", "data-listbox-index", "onClick", "onFocus"], hi = 6, JW = /* @__PURE__ */ ke({
  __name: "ColorPickerPalette",
  props: {
    swatches: {},
    modelValue: {},
    labels: {},
    showReset: { type: Boolean }
  },
  emits: ["select", "reset", "custom"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = R(null), r = m(
      () => n.modelValue ? n.swatches.findIndex((h) => h.hex === n.modelValue) : -1
    ), i = R(Math.max(0, r.value));
    $e(
      () => n.swatches.length,
      (h) => {
        i.value >= h && (i.value = Math.max(0, h - 1));
      }
    );
    function s() {
      const h = n.swatches[i.value];
      h && l("select", h.hex);
    }
    function d(h) {
      var v, p;
      i.value = h, (p = (v = o.value) == null ? void 0 : v.querySelector(`[data-listbox-index="${h}"]`)) == null || p.focus();
    }
    function c() {
      i.value = Math.max(0, r.value), Ze(() => d(i.value));
    }
    function f(h) {
      const v = n.swatches.length - 1, p = i.value;
      let y;
      switch (h.key) {
        case "ArrowRight":
          y = Math.min(v, p + 1);
          break;
        case "ArrowLeft":
          y = Math.max(0, p - 1);
          break;
        case "ArrowDown":
          y = p + hi <= v ? p + hi : p;
          break;
        case "ArrowUp":
          y = p - hi >= 0 ? p - hi : p;
          break;
        case "Home":
          y = 0;
          break;
        case "End":
          y = v;
          break;
        case "Enter":
          h.preventDefault(), s();
          return;
        case " ":
          h.preventDefault();
          return;
        default:
          return;
      }
      h.preventDefault(), h.stopPropagation(), d(y);
    }
    function g(h) {
      h.key === " " && (h.preventDefault(), s());
    }
    return a({ focusInitial: c }), (h, v) => (u(), b("div", qW, [
      x("button", {
        type: "button",
        class: "flex w-full items-center gap-(--spacing-2) rounded-(--border-border-radius-rounded-xs) cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
        "data-testid": "color-picker-custom",
        onClick: v[0] || (v[0] = (p) => l("custom"))
      }, [
        x("span", UW, [
          x("span", {
            class: "h-(--spacing-6) w-full rounded-(--border-border-radius-rounded-xxs)",
            style: Ge({ backgroundColor: e.modelValue ?? "transparent" }),
            "data-testid": "color-picker-palette-preview"
          }, null, 4)
        ]),
        x("span", GW, H(e.labels.pickColor), 1)
      ]),
      x("div", {
        ref_key: "listboxRef",
        ref: o,
        role: "listbox",
        "aria-label": e.labels.palette,
        class: "grid w-fit grid-cols-6 gap-(--spacing-1)",
        "data-testid": "color-picker-swatches",
        onKeydown: f,
        onKeyup: g
      }, [
        (u(!0), b(ie, null, Oe(e.swatches, (p, y) => (u(), b("div", {
          key: y,
          role: "option",
          "aria-label": p.name,
          "aria-selected": y === r.value ? "true" : "false",
          tabindex: y === i.value ? 0 : -1,
          "data-listbox-index": y,
          class: C([
            "size-(--spacing-6) rounded-(--border-border-radius-rounded-xs) border border-solid cursor-pointer focus-visible:outline-none focus-visible:border-(--border-border-accent) focus-visible:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
            // Selected mark reuses the Button focus treatment: accent border + soft glow.
            y === r.value ? "border-(--border-border-accent) shadow-[0px_0px_2px_0px_var(--background-background-hover)]" : "border-(--border-border-base-soft)"
          ]),
          style: Ge({ backgroundColor: p.hex }),
          "data-testid": "color-picker-swatch",
          onClick: (k) => l("select", p.hex),
          onFocus: (k) => i.value = y
        }, null, 46, YW))), 128))
      ], 40, KW),
      e.showReset ? (u(), P(Be, {
        key: 0,
        class: "self-center",
        variant: "ghost",
        size: "xs",
        "icon-left": "ri-restart-line",
        label: e.labels.resetColor,
        "data-testid": "color-picker-reset",
        onClick: v[1] || (v[1] = (p) => l("reset"))
      }, null, 8, ["label"])) : w("", !0)
    ]));
  }
}), fn = (e, a, t) => Math.min(t, Math.max(a, e));
function An(e) {
  const a = e.trim().replace(/^#/, "");
  return /^[0-9a-f]{3}$/i.test(a) ? `#${a.split("").map((t) => t + t).join("").toUpperCase()}` : /^[0-9a-f]{6}$/i.test(a) ? `#${a.toUpperCase()}` : null;
}
function XW(e) {
  const a = An(e) ?? "#000000", t = parseInt(a.slice(1), 16);
  return { r: t >> 16 & 255, g: t >> 8 & 255, b: t & 255 };
}
function vg({ r: e, g: a, b: t }) {
  const n = (l) => Math.round(fn(l, 0, 255)).toString(16).padStart(2, "0");
  return `#${n(e)}${n(a)}${n(t)}`.toUpperCase();
}
function nc({ r: e, g: a, b: t }) {
  const n = e / 255, l = a / 255, o = t / 255, r = Math.max(n, l, o), i = r - Math.min(n, l, o);
  let s = 0;
  return i !== 0 && (r === n ? s = (l - o) / i % 6 : r === l ? s = (o - n) / i + 2 : s = (n - l) / i + 4, s = (s * 60 + 360) % 360), { h: s, s: r === 0 ? 0 : i / r * 100, v: r * 100 };
}
function bi({ h: e, s: a, v: t }) {
  const n = fn(a, 0, 100) / 100, l = fn(t, 0, 100) / 100, o = (r) => {
    const i = (r + (e % 360 + 360) / 60) % 6;
    return l - l * n * Math.max(0, Math.min(i, 4 - i, 1));
  };
  return { r: Math.round(o(5) * 255), g: Math.round(o(3) * 255), b: Math.round(o(1) * 255) };
}
function pg({ r: e, g: a, b: t }) {
  const n = e / 255, l = a / 255, o = t / 255, r = Math.max(n, l, o), i = Math.min(n, l, o), s = (r + i) / 2, d = r - i, c = d === 0 ? 0 : d / (1 - Math.abs(2 * s - 1));
  return { h: nc({ r: e, g: a, b: t }).h, s: c * 100, l: s * 100 };
}
function ZW({ h: e, s: a, l: t }) {
  const n = fn(a, 0, 100) / 100, l = fn(t, 0, 100) / 100, o = n * Math.min(l, 1 - l), r = (i) => {
    const s = (i + (e % 360 + 360) / 30) % 12;
    return l - o * Math.max(-1, Math.min(s - 3, 9 - s, 1));
  };
  return { r: Math.round(r(0) * 255), g: Math.round(r(8) * 255), b: Math.round(r(4) * 255) };
}
const QW = {
  class: "flex flex-col gap-(--spacing-3)",
  "data-testid": "color-picker-spectrum"
}, _W = ["value", "aria-label", "aria-valuetext"], eq = ["value", "aria-label", "aria-valuetext"], tq = { class: "flex items-center gap-(--spacing-2)" }, aq = ["aria-label"], nq = ["value", "aria-label", "aria-valuetext"], lq = { class: "flex items-end gap-(--spacing-1)" }, oq = { class: "flex min-w-0 flex-1 gap-(--spacing-2)" }, rq = { class: "flex w-[69px] shrink-0 flex-col items-center gap-[10px]" }, iq = ["id", "value", "onKeydown"], sq = ["for"], dq = ["id", "value", "aria-label", "data-testid", "onInput", "onKeydown"], uq = ["for"], cq = ["aria-label"], xg = "h-(--spacing-9) w-full min-w-0 rounded-(--border-border-radius-rounded-sm) border border-solid border-(--border-border-base-soft) bg-transparent px-(--spacing-1) text-center text-(length:--size-sm) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", yg = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--colors-text-heading)", fq = /* @__PURE__ */ ke({
  __name: "ColorPickerSpectrum",
  props: {
    modelValue: {},
    labels: {}
  },
  emits: ["update", "commit"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = Ye(), r = R(null), i = R(null), s = R(null), d = R(null), c = R({ h: 0, s: 100, v: 100 }), f = m(() => vg(bi(c.value))), g = m(() => `hsl(${c.value.h} 100% 50%)`);
    function h(oe) {
      if (!oe || An(oe) === f.value) return;
      const re = nc(XW(oe));
      c.value = re.s === 0 || re.v === 0 ? { ...re, h: c.value.h } : re;
    }
    $e(() => n.modelValue, h, { immediate: !0 });
    function v(oe) {
      c.value = { ...c.value, ...oe }, l("update", f.value);
    }
    function p(oe) {
      h(oe), l("update", f.value);
    }
    const y = R(null);
    function k(oe, re) {
      const ge = re.getBoundingClientRect();
      return {
        x: ge.width ? fn((oe.clientX - ge.left) / ge.width, 0, 1) : 0,
        y: ge.height ? fn((oe.clientY - ge.top) / ge.height, 0, 1) : 0
      };
    }
    function $(oe) {
      if (y.value === "area" && r.value) {
        const { x: re, y: ge } = k(oe, r.value);
        v({ s: re * 100, v: (1 - ge) * 100 });
      } else y.value === "hue" && i.value && v({ h: k(oe, i.value).x * 360 });
    }
    function S(oe, re) {
      var ge, de, Ee;
      re.preventDefault(), y.value = oe, (de = (ge = re.currentTarget).setPointerCapture) == null || de.call(ge, re.pointerId), $(re), (Ee = (oe === "area" ? s : d).value) == null || Ee.focus();
    }
    function I(oe) {
      y.value && $(oe);
    }
    function T() {
      y.value && (y.value = null, l("commit"));
    }
    function A(oe, re, ge) {
      if (!oe.shiftKey) return;
      const de = { ArrowRight: 10, ArrowUp: 10, ArrowLeft: -10, ArrowDown: -10 }[oe.key];
      de !== void 0 && (oe.preventDefault(), v({ [re]: fn(c.value[re] + de, 0, ge) }), l("commit"));
    }
    const E = {
      ArrowRight: ["s", 1],
      ArrowLeft: ["s", -1],
      ArrowUp: ["v", 1],
      ArrowDown: ["v", -1],
      PageUp: ["v", 10],
      PageDown: ["v", -10]
    };
    function z(oe) {
      const re = E[oe.key];
      if (!re) return;
      const [ge, de] = re;
      oe.preventDefault();
      const Ee = oe.shiftKey && Math.abs(de) === 1 ? de * 10 : de;
      v({ [ge]: fn(Math.round(c.value[ge]) + Ee, 0, 100) }), l("commit");
    }
    function B(oe, re) {
      v({ [re]: Number(oe.target.value) });
    }
    const W = R(!1), _ = m(
      () => `${n.labels.saturation} ${Math.round(c.value.s)} %, ${n.labels.brightness} ${Math.round(c.value.v)} %`
    ), Z = R(!1), le = R("rgb"), D = R(null), O = R(null), N = m(() => {
      const oe = bi(c.value);
      if (le.value === "rgb")
        return [
          { short: "R", name: n.labels.red, value: oe.r, max: 255 },
          { short: "G", name: n.labels.green, value: oe.g, max: 255 },
          { short: "B", name: n.labels.blue, value: oe.b, max: 255 }
        ];
      const re = pg(oe);
      return [
        { short: "H", name: n.labels.hue, value: Math.round(c.value.h), max: 360 },
        { short: "S", name: n.labels.saturation, value: Math.round(re.s), max: 100 },
        { short: "L", name: n.labels.lightness, value: Math.round(re.l), max: 100 }
      ];
    });
    function V() {
      if (D.value === null) return;
      const oe = An(D.value);
      D.value = null, !(!oe || oe === f.value) && (p(oe), l("commit"));
    }
    function M(oe, re) {
      const ge = fn(Math.round(re), 0, N.value[oe].max);
      if (le.value === "rgb") {
        const j = bi(c.value), J = [j.r, j.g, j.b];
        J[oe] = ge, p(vg({ r: J[0], g: J[1], b: J[2] }));
        return;
      }
      const de = pg(bi(c.value)), Ee = { h: c.value.h, s: de.s, l: de.l };
      oe === 0 ? Ee.h = ge : oe === 1 ? Ee.s = ge : Ee.l = ge, v({ ...nc(ZW(Ee)), h: Ee.h });
    }
    function Q(oe, re) {
      const ge = re.target.value;
      O.value = { index: oe, text: ge };
      const de = Number.parseInt(ge, 10);
      Number.isFinite(de) && M(oe, de);
    }
    function q(oe, re) {
      const ge = { ArrowUp: 1, ArrowDown: -1 }[re.key];
      if (ge === void 0) {
        re.key === "Enter" && (re.preventDefault(), K());
        return;
      }
      re.preventDefault(), O.value = null, M(oe, N.value[oe].value + ge * (re.shiftKey ? 10 : 1)), l("commit");
    }
    function K() {
      O.value !== null && (O.value = null, l("commit"));
    }
    const G = R(!1);
    kt(() => {
      G.value = typeof window.EyeDropper == "function";
    });
    async function te() {
      const oe = window.EyeDropper;
      if (oe)
        try {
          const { sRGBHex: re } = await new oe().open(), ge = An(re);
          if (!ge) return;
          p(ge), l("commit");
        } catch {
        }
    }
    const ve = `linear-gradient(to right, ${[0, 60, 120, 180, 240, 300, 360].map((oe) => `hsl(${oe} 100% 50%)`).join(", ")})`;
    function Se() {
      var oe;
      (oe = s.value) == null || oe.focus();
    }
    return a({ focusInitial: Se }), (oe, re) => (u(), b("div", QW, [
      x("div", {
        ref_key: "areaRef",
        ref: r,
        class: "relative h-[119px] w-full touch-none cursor-crosshair rounded-(--border-border-radius-rounded-xs) outline-1 outline-solid outline-(--border-border-base-soft)",
        style: Ge({
          backgroundImage: `linear-gradient(to top, var(--colors-color-picker-black), transparent), linear-gradient(to right, var(--colors-background-white), ${g.value})`
        }),
        "data-testid": "color-picker-area",
        onPointerdown: re[8] || (re[8] = (ge) => S("area", ge)),
        onMousedown: re[9] || (re[9] = _e(() => {
        }, ["prevent"])),
        onPointermove: I,
        onPointerup: T,
        onPointercancel: T
      }, [
        x("span", {
          class: C([
            "pointer-events-none absolute size-[14px] -translate-x-1/2 translate-y-1/2 rounded-full border-3 border-solid border-(--colors-background-white) shadow-(--shadow-color-picker-handle)",
            W.value && "ring-2 ring-(--border-border-accent)"
          ]),
          style: Ge({ left: `${c.value.s}%`, bottom: `${c.value.v}%` }),
          "data-testid": "color-picker-area-handle"
        }, null, 6),
        x("input", {
          ref_key: "saturationInputRef",
          ref: s,
          type: "range",
          class: "sr-only",
          min: "0",
          max: "100",
          step: "1",
          value: Math.round(c.value.s),
          "aria-label": e.labels.saturation,
          "aria-valuetext": _.value,
          "data-testid": "color-picker-saturation",
          onInput: re[0] || (re[0] = (ge) => B(ge, "s")),
          onChange: re[1] || (re[1] = (ge) => l("commit")),
          onKeydown: z,
          onFocus: re[2] || (re[2] = (ge) => W.value = !0),
          onBlur: re[3] || (re[3] = (ge) => W.value = !1)
        }, null, 40, _W),
        x("input", {
          type: "range",
          class: "sr-only",
          min: "0",
          max: "100",
          step: "1",
          value: Math.round(c.value.v),
          "aria-label": e.labels.brightness,
          "aria-valuetext": _.value,
          tabindex: "-1",
          "data-testid": "color-picker-brightness",
          onInput: re[4] || (re[4] = (ge) => B(ge, "v")),
          onChange: re[5] || (re[5] = (ge) => l("commit")),
          onKeydown: z,
          onFocus: re[6] || (re[6] = (ge) => W.value = !0),
          onBlur: re[7] || (re[7] = (ge) => W.value = !1)
        }, null, 40, eq)
      ], 36),
      x("div", tq, [
        G.value ? (u(), b("button", {
          key: 0,
          type: "button",
          class: "relative flex size-(--icon-size-md) shrink-0 items-center justify-center cursor-pointer rounded-(--border-border-radius-rounded-xs) text-(length:--icon-size-md) text-(--icons-icon-dark-default) after:absolute after:-inset-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
          "aria-label": e.labels.eyedropper,
          "data-testid": "color-picker-eyedropper",
          onClick: te
        }, [...re[19] || (re[19] = [
          x("i", {
            class: "ri-sip-line",
            "aria-hidden": "true"
          }, null, -1)
        ])], 8, aq)) : w("", !0),
        x("span", {
          class: "size-(--spacing-6) shrink-0 rounded-full",
          style: Ge({ backgroundColor: f.value }),
          "aria-hidden": "true",
          "data-testid": "color-picker-current"
        }, null, 4),
        x("div", {
          ref_key: "hueRef",
          ref: i,
          class: "relative h-[10px] min-w-0 flex-1 touch-none cursor-pointer rounded-(--border-border-radius-rounded-sm) outline-1 outline-solid outline-(--border-border-base-soft)",
          style: Ge({ backgroundImage: ve }),
          "data-testid": "color-picker-hue",
          onPointerdown: re[15] || (re[15] = (ge) => S("hue", ge)),
          onMousedown: re[16] || (re[16] = _e(() => {
          }, ["prevent"])),
          onPointermove: I,
          onPointerup: T,
          onPointercancel: T
        }, [
          x("span", {
            class: C([
              "pointer-events-none absolute top-1/2 size-(--spacing-4) -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-solid border-(--colors-background-white) shadow-(--shadow-color-picker-thumb)",
              Z.value && "ring-2 ring-(--border-border-accent)"
            ]),
            style: Ge({ left: `${c.value.h / 360 * 100}%`, backgroundColor: g.value }),
            "data-testid": "color-picker-hue-thumb"
          }, null, 6),
          x("input", {
            ref_key: "hueInputRef",
            ref: d,
            type: "range",
            class: "sr-only",
            min: "0",
            max: "360",
            step: "1",
            value: Math.round(c.value.h),
            "aria-label": e.labels.hue,
            "aria-valuetext": `${Math.round(c.value.h)}°`,
            "data-testid": "color-picker-hue-input",
            onInput: re[10] || (re[10] = (ge) => B(ge, "h")),
            onChange: re[11] || (re[11] = (ge) => l("commit")),
            onKeydown: re[12] || (re[12] = (ge) => A(ge, "h", 360)),
            onFocus: re[13] || (re[13] = (ge) => Z.value = !0),
            onBlur: re[14] || (re[14] = (ge) => Z.value = !1)
          }, null, 40, nq)
        ], 36)
      ]),
      x("div", lq, [
        x("div", oq, [
          x("div", rq, [
            x("input", {
              id: `${L(o)}-hex`,
              type: "text",
              maxlength: "7",
              spellcheck: "false",
              class: C(xg),
              value: D.value ?? f.value,
              "data-testid": "color-picker-hex",
              onInput: re[17] || (re[17] = (ge) => D.value = ge.target.value),
              onBlur: V,
              onKeydown: St(_e(V, ["prevent"]), ["enter"])
            }, null, 40, iq),
            x("label", {
              for: `${L(o)}-hex`,
              class: C(yg)
            }, H(e.labels.hex), 9, sq)
          ]),
          (u(!0), b(ie, null, Oe(N.value, (ge, de) => {
            var Ee;
            return u(), b("div", {
              key: `${le.value}-${ge.short}`,
              class: "flex min-w-0 flex-1 flex-col items-center gap-[10px]"
            }, [
              x("input", {
                id: `${L(o)}-${ge.short}`,
                type: "text",
                inputmode: "numeric",
                class: C(xg),
                value: ((Ee = O.value) == null ? void 0 : Ee.index) === de ? O.value.text : ge.value,
                "aria-label": `${ge.name} (${ge.short})`,
                "data-testid": `color-picker-channel-${ge.short}`,
                onInput: (j) => Q(de, j),
                onKeydown: (j) => q(de, j),
                onBlur: K
              }, null, 40, dq),
              x("label", {
                for: `${L(o)}-${ge.short}`,
                class: C(yg),
                "aria-hidden": "true"
              }, H(ge.short), 9, uq)
            ]);
          }), 128))
        ]),
        x("button", {
          type: "button",
          class: "relative flex size-(--icon-size-sm) shrink-0 items-center justify-center cursor-pointer rounded-(--border-border-radius-rounded-xs) text-(length:--icon-size-sm) text-(--icons-icon-dark-default) after:absolute after:-inset-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
          "aria-label": le.value === "rgb" ? e.labels.switchToHsl : e.labels.switchToRgb,
          "data-testid": "color-picker-format",
          onClick: re[18] || (re[18] = (ge) => le.value = le.value === "rgb" ? "hsl" : "rgb")
        }, [...re[20] || (re[20] = [
          x("i", {
            class: "ri-expand-up-down-line",
            "aria-hidden": "true"
          }, null, -1)
        ])], 8, cq)
      ])
    ]));
  }
}), hq = {
  dialog: "Color picker",
  openPicker: "Choose a color",
  pickColor: "Pick a color",
  resetColor: "Reset color",
  palette: "Colors",
  saturation: "Saturation",
  brightness: "Brightness",
  hue: "Hue",
  hex: "Hex",
  red: "Red",
  green: "Green",
  blue: "Blue",
  lightness: "Lightness",
  eyedropper: "Pick a color from the screen",
  switchToHsl: "Switch to HSL",
  switchToRgb: "Switch to RGB",
  invalidHex: "Enter a color in the #RRGGBB format"
}, bq = {
  fr: {
    dialog: "Sélecteur de couleur",
    openPicker: "Choisir une couleur",
    pickColor: "Choisir une couleur",
    resetColor: "Réinitialiser la couleur",
    palette: "Couleurs",
    saturation: "Saturation",
    brightness: "Brillance",
    hue: "Teinte",
    hex: "Hex",
    red: "Rouge",
    green: "Vert",
    blue: "Bleu",
    lightness: "Luminosité",
    eyedropper: "Prélever une couleur à l'écran",
    switchToHsl: "Passer en TSL",
    switchToRgb: "Passer en RVB",
    invalidHex: "Saisissez une couleur au format #RRGGBB"
  },
  nl: {
    dialog: "Kleurkiezer",
    openPicker: "Kies een kleur",
    pickColor: "Kies een kleur",
    resetColor: "Kleur resetten",
    palette: "Kleuren",
    saturation: "Verzadiging",
    brightness: "Helderheid",
    hue: "Tint",
    hex: "Hex",
    red: "Rood",
    green: "Groen",
    blue: "Blauw",
    lightness: "Lichtheid",
    eyedropper: "Kleur van het scherm kiezen",
    switchToHsl: "Wisselen naar HSL",
    switchToRgb: "Wisselen naar RGB",
    invalidHex: "Voer een kleur in als #RRGGBB"
  }
}, kg = {
  en: {
    indigo: "Indigo",
    green: "Green",
    yellow: "Yellow",
    red: "Red",
    orange: "Orange",
    violet: "Violet",
    purple: "Purple",
    pink: "Pink",
    cyan: "Cyan",
    gray: "Gray",
    slate: "Slate"
  },
  fr: {
    indigo: "Indigo",
    green: "Vert",
    yellow: "Jaune",
    red: "Rouge",
    orange: "Orange",
    violet: "Violet",
    purple: "Pourpre",
    pink: "Rose",
    cyan: "Cyan",
    gray: "Gris",
    slate: "Ardoise"
  },
  nl: {
    indigo: "Indigo",
    green: "Groen",
    yellow: "Geel",
    red: "Rood",
    orange: "Oranje",
    violet: "Violet",
    purple: "Paars",
    pink: "Roze",
    cyan: "Cyaan",
    gray: "Grijs",
    slate: "Leisteen"
  }
}, gq = [
  { hex: "#0A27FF", family: "indigo", shade: 700 },
  { hex: "#00A870", family: "green", shade: 500 },
  { hex: "#EECC01", family: "yellow", shade: 500 },
  { hex: "#F04438", family: "red", shade: 500 },
  { hex: "#FF881E", family: "orange", shade: 500 },
  { hex: "#00D492", family: "green", shade: 400 },
  { hex: "#615FFF", family: "indigo", shade: 400 },
  { hex: "#C4B4FF", family: "violet", shade: 300 },
  { hex: "#4542FF", family: "indigo", shade: 500 },
  { hex: "#FF993E", family: "orange", shade: 400 },
  { hex: "#FFDDC1", family: "orange", shade: 100 },
  { hex: "#DA9DFF", family: "purple", shade: 400 },
  { hex: "#C4B4FF", family: "violet", shade: 300 },
  { hex: "#D9D6FE", family: "violet", shade: 200 },
  { hex: "#FECDCA", family: "red", shade: 200 },
  { hex: "#FDA5D5", family: "pink", shade: 300 },
  { hex: "#FCD9BD", family: "orange", shade: 200 },
  { hex: "#E1FAFF", family: "cyan", shade: 100 },
  { hex: "#007595", family: "cyan", shade: 700 },
  { hex: "#BE5900", family: "orange", shade: 700 },
  { hex: "#FFF085", family: "yellow", shade: 200 },
  { hex: "#0A27FF", family: "indigo", shade: 700 },
  { hex: "#1430FF", family: "indigo", shade: 600 },
  { hex: "#52DBF5", family: "cyan", shade: 300 },
  { hex: "#E1FAFF", family: "cyan", shade: 100 },
  { hex: "#5EE9B5", family: "green", shade: 300 },
  { hex: "#F6339A", family: "pink", shade: 500 },
  { hex: "#E1FAFF", family: "cyan", shade: 100 },
  { hex: "#007A55", family: "green", shade: 700 },
  { hex: "#1E2939", family: "gray", shade: 800 },
  { hex: "#006045", family: "green", shade: 800 },
  { hex: "#6C3A8A", family: "purple", shade: 800 },
  { hex: "#CAD5E2", family: "slate", shade: 300 },
  { hex: "#F1F5F9", family: "slate", shade: 100 },
  { hex: "#F8FAFC", family: "slate", shade: 50 }
];
function mq(e) {
  const a = kg[e] ?? kg.en;
  return gq.map(({ hex: t, family: n, shade: l }) => ({
    hex: t,
    name: `${a[n]} ${l}`
  }));
}
const vq = ["disabled", "aria-label", "aria-expanded", "aria-controls"], pq = ["aria-label"], cK = /* @__PURE__ */ ke({
  __name: "ColorPicker",
  props: {
    modelValue: { default: null },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 },
    placeholder: { default: void 0 },
    id: { default: void 0 },
    name: { default: void 0 },
    width: { default: "384px" },
    fullWidth: { type: Boolean, default: !1 },
    language: { default: "en" },
    labels: { default: void 0 },
    swatches: { default: void 0 },
    showReset: { type: Boolean, default: !0 },
    resetValue: { default: null }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = m(() => t.language.slice(0, 2).toLowerCase()), o = m(() => ({
      ...bq[l.value] ?? hq,
      ...t.labels
    })), r = m(
      () => (t.swatches ?? mq(l.value)).map((oe) => ({
        ...oe,
        hex: An(oe.hex) ?? oe.hex
      }))
    ), i = m(() => t.modelValue ? An(t.modelValue) : null), s = Ye(), d = m(() => t.id ?? `${s}-input`), c = `${s}-panel`, f = m(
      () => t.label ? `${o.value.openPicker}, ${t.label}` : o.value.openPicker
    ), g = R(null), h = R(null), v = R(null), p = R(null), y = R(null), k = R(!1), $ = R("palette"), S = Symbol("color-picker");
    let I = null;
    const T = R(i.value ?? t.modelValue ?? ""), A = R(!1);
    let E = null, z = null;
    $e(
      () => t.modelValue,
      (oe) => {
        const re = oe ? An(oe) : null;
        T.value = re ?? oe ?? "", A.value = !1, re !== E && (E = null, z = re);
      }
    );
    const B = m(
      () => t.error ?? (A.value ? o.value.invalidHex : void 0)
    );
    function W(oe, re) {
      T.value = oe ?? "", A.value = !1, oe !== i.value && (n("update:modelValue", oe), re && n("change", oe));
    }
    function _() {
      const oe = T.value.trim();
      if (oe === "") {
        W(null, !0);
        return;
      }
      const re = An(oe);
      re ? W(re, !0) : A.value = !0;
    }
    async function Z() {
      var oe;
      t.disabled || k.value || ($.value = "palette", E = null, k.value = !0, xn(S), await Ze(), !(!k.value || I || !h.value || !v.value) && (I = fl(h.value, v.value, {
        strategy: "fixed",
        placement: "bottom-start",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          // altAxis keeps the panel inside a short viewport (200 % zoom) when neither side fits.
          { name: "preventOverflow", options: { padding: 8, altAxis: !0 } }
        ]
      }), (oe = p.value) == null || oe.focusInitial()));
    }
    function le(oe) {
      k.value && ($.value === "spectrum" && ve(), k.value = !1, _a(S), I == null || I.destroy(), I = null, oe && Ze(() => {
        var re;
        return (re = h.value) == null ? void 0 : re.focus();
      }));
    }
    function D() {
      k.value ? le(!1) : Z();
    }
    async function O() {
      var oe;
      $.value = "spectrum", z = i.value, await Ze(), await (I == null ? void 0 : I.update()), (oe = y.value) == null || oe.focusInitial();
    }
    function N(oe) {
      oe.key !== "Escape" || !k.value || !On(S) || (oe.stopPropagation(), oe.preventDefault(), le(!0));
    }
    function V() {
      return v.value ? Array.from(
        v.value.querySelectorAll(
          "button:not([disabled]), input:not([disabled]), [tabindex]"
        )
      ).filter((oe) => {
        var re;
        return !((re = oe.getAttribute("tabindex")) != null && re.startsWith("-"));
      }) : [];
    }
    function M(oe, re) {
      re && (oe.preventDefault(), oe.stopPropagation(), re.focus());
    }
    function Q(oe) {
      oe.key === "Tab" && !oe.shiftKey && k.value && M(oe, V()[0]);
    }
    function q(oe) {
      if (oe.key !== "Tab") {
        N(oe);
        return;
      }
      const re = V();
      oe.shiftKey && document.activeElement === re[0] ? M(oe, h.value) : !oe.shiftKey && document.activeElement === re.at(-1) && M(oe, document.getElementById(d.value));
    }
    function K(oe) {
      var ge;
      const re = oe.relatedTarget;
      re && !((ge = v.value) != null && ge.contains(re)) && re !== h.value && le(!1);
    }
    Ds(g, () => le(!1), {
      isActive: () => k.value,
      ignoreElements: () => [v.value]
    }), $e(
      () => t.disabled,
      (oe) => {
        oe && le(!1);
      }
    ), Tt(() => le(!1));
    function G(oe) {
      W(oe, !0), le(!0);
    }
    function te(oe) {
      E = oe, W(oe, !1);
    }
    function ve() {
      const oe = E ?? i.value;
      oe !== z && (z = oe, n("change", oe));
    }
    function Se() {
      W(t.resetValue ? An(t.resetValue) : null, !0);
    }
    return (oe, re) => (u(), b("div", {
      ref_key: "rootRef",
      ref: g,
      class: C(["relative flex min-w-0 items-start gap-(--spacing-1\\.5)", { "w-full": e.fullWidth }]),
      style: Ge(e.fullWidth ? void 0 : { width: e.width }),
      "data-testid": "color-picker",
      onKeydown: N
    }, [
      x("button", {
        ref_key: "triggerRef",
        ref: h,
        type: "button",
        disabled: e.disabled,
        "aria-label": f.value,
        "aria-haspopup": "dialog",
        "aria-expanded": k.value ? "true" : "false",
        "aria-controls": k.value ? c : void 0,
        class: C([
          // Figma strokes sit inside the box: the padding gives back the 1px border.
          "flex size-(--spacing-9) shrink-0 rounded-(--border-border-radius-rounded-xs) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-[calc(var(--spacing-1)-1px)] focus-visible:outline-none focus-visible:border-(--border-border-accent) focus-visible:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
          // Aligns the swatch with the input row: TextInput's label line (20px) + its 2px gap.
          e.label && "mt-[calc(var(--line-height-l)+2px)]",
          e.disabled ? "cursor-not-allowed" : "cursor-pointer"
        ]),
        "data-testid": "color-picker-trigger",
        onClick: D,
        onKeydown: Q
      }, [
        x("span", {
          class: "size-full rounded-(--border-border-radius-rounded-xs)",
          style: Ge({ backgroundColor: i.value ?? "transparent" }),
          "data-testid": "color-picker-trigger-preview"
        }, null, 4)
      ], 42, vq),
      (u(), P(Fa, { to: "body" }, [
        k.value ? (u(), b("div", {
          key: 0,
          id: c,
          ref_key: "panelRef",
          ref: v,
          role: "dialog",
          tabindex: "-1",
          "aria-label": o.value.dialog,
          "data-focus-trap-allow-outside": "",
          class: C([
            "fixed z-[350] flex flex-col rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-[calc(var(--spacing-3)-1px)] shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] outline-none",
            $.value === "palette" ? "w-(--color-picker-width-palette)" : "w-(--color-picker-width-spectrum)"
          ]),
          "data-testid": "color-picker-panel",
          onFocusout: K,
          onKeydown: q
        }, [
          $.value === "palette" ? (u(), P(JW, {
            key: 0,
            ref_key: "paletteRef",
            ref: p,
            swatches: r.value,
            "model-value": i.value,
            labels: o.value,
            "show-reset": e.showReset,
            onSelect: G,
            onReset: Se,
            onCustom: O
          }, null, 8, ["swatches", "model-value", "labels", "show-reset"])) : (u(), P(fq, {
            key: 1,
            ref_key: "spectrumRef",
            ref: y,
            "model-value": i.value,
            labels: o.value,
            onUpdate: te,
            onCommit: ve
          }, null, 8, ["model-value", "labels"]))
        ], 42, pq)) : w("", !0)
      ])),
      U(Qt, {
        id: d.value,
        modelValue: T.value,
        "onUpdate:modelValue": re[0] || (re[0] = (ge) => T.value = ge),
        class: "min-w-0 flex-1",
        "full-width": "",
        size: "md",
        name: e.name,
        label: e.label,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        disabled: e.disabled,
        error: B.value,
        hint: e.hint,
        placeholder: e.placeholder,
        onBlur: _,
        onKeydown: St(_, ["enter"])
      }, {
        iconRight: me(() => [...re[1] || (re[1] = [
          x("i", {
            class: "ri-search-line text-(length:--icon-size-sm) text-(--icons-icon-disabled-strong)",
            "aria-hidden": "true"
          }, null, -1)
        ])]),
        _: 1
      }, 8, ["id", "modelValue", "name", "label", "required", "required-indicator", "disabled", "error", "hint", "placeholder"])
    ], 38));
  }
}), xq = ["aria-label"], yq = {
  key: 1,
  role: "list",
  class: "stepper-navigation-scroll flex items-center gap-2 sm:gap-(--spacing-5) overflow-x-auto"
}, kq = ["aria-label"], wq = {
  key: 0,
  "aria-hidden": "true",
  class: "flex-1 border-t-(length:--border-border-width-border-base) border-(--border-border-base-soft)"
}, Cq = {
  key: 2,
  role: "list",
  class: "stepper-navigation-scroll overflow-x-auto"
}, Sq = { class: "relative flex w-max min-w-full items-center justify-between gap-2" }, $q = ["aria-label"], Iq = ["aria-label"], Lq = { class: "flex flex-col items-start gap-(--spacing-0.5)" }, Tq = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) whitespace-nowrap"
}, Eq = {
  key: 4,
  role: "list",
  class: "flex flex-col items-start"
}, Aq = ["aria-label"], Rq = { class: "flex items-center gap-(--spacing-3)" }, zq = { class: "flex flex-col items-start gap-(--spacing-0.5)" }, Dq = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) whitespace-nowrap"
}, Bq = {
  key: 5,
  role: "list",
  class: "stepper-navigation-scroll flex flex-col items-start gap-(--spacing-4) w-full overflow-x-auto"
}, Mq = ["aria-label"], Oq = {
  "aria-hidden": "true",
  class: "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap"
}, Pq = {
  "aria-hidden": "true",
  class: "flex-1 font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl)"
}, Fq = /* @__PURE__ */ ke({
  __name: "StepperNavigation",
  props: {
    steps: {},
    type: { default: "default" },
    labels: {},
    breakpoint: { default: "auto" }
  },
  emits: ["step-click"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = /* @__PURE__ */ new Set([
      "completed",
      "active",
      "error"
    ]);
    function o(O) {
      return l.has(O);
    }
    function r(O, N, V) {
      const M = t.labels.state[O.state];
      return `${O.label}, ${t.labels.step} ${N + 1} ${t.labels.of} ${V}, ${M}`;
    }
    function i(O) {
      n("step-click", O.id);
    }
    function s(O, N) {
      const V = o(O.state);
      return {
        type: V ? "button" : void 0,
        "data-testid": `stepper-navigation-step-${O.id}`,
        "aria-current": O.state === "active" ? "step" : void 0,
        "aria-disabled": V ? void 0 : "true",
        "aria-label": r(O, N, t.steps.length),
        onClick: V ? () => i(O) : void 0
      };
    }
    function d(O) {
      return o(O) ? "cursor-pointer focus:outline-none focus-visible:shadow-[0_0_2px_2px_var(--background-background-hover)]" : "";
    }
    const c = {
      upcoming: { variant: "outlined", color: "text" },
      active: { variant: "outlined", color: "gradient" },
      completed: { variant: "filled", color: "success" },
      error: { variant: "filled", color: "error" },
      disabled: { variant: "outlined", color: "disabled" }
    }, f = {
      completed: "ri-check-line",
      error: "ri-close-line"
    };
    function g(O, N) {
      const V = c[O.state], M = f[O.state];
      return M ? { ...V, icon: M } : { ...V, label: String(N + 1) };
    }
    function h(O, N) {
      const V = c[O.state], M = f[O.state];
      return M ? { ...V, icon: M } : O.icon ? { ...V, icon: O.icon, ...O.state === "upcoming" && { color: "white" } } : { ...V, label: String(N + 1) };
    }
    const v = {
      auto: "gap-2 sm:gap-(--spacing-4)",
      mobile: "gap-2",
      desktop: "gap-(--spacing-4)"
    }, p = {
      auto: "gap-1.5 sm:gap-(--spacing-2)",
      mobile: "gap-1.5",
      desktop: "gap-(--spacing-2)"
    }, y = {
      auto: "text-(length:--size-m) sm:text-(length:--size-l) leading-(--line-height-l) sm:leading-(--line-height-xxl)",
      mobile: "text-(length:--size-m) leading-(--line-height-l)",
      desktop: "text-(length:--size-l) leading-(--line-height-xxl)"
    }, k = m(() => t.type === "defaultVertical" ? "flex-col" : ""), $ = m(() => t.breakpoint !== "mobile"), S = m(() => t.breakpoint !== "desktop"), I = {
      auto: "flex-col gap-(--spacing-5) w-fit sm:w-auto sm:flex-row sm:items-center sm:gap-(--spacing-5) sm:overflow-x-auto",
      mobile: "flex-col gap-(--spacing-5) w-fit",
      desktop: "flex-row items-center gap-(--spacing-5) overflow-x-auto"
    }, T = {
      auto: "sm:w-36",
      mobile: "",
      desktop: "w-36"
    }, A = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-body)",
      error: "text-(--text-text-body)",
      disabled: "text-(--text-text-disabled-light)"
    }, E = {
      upcoming: "bg-(--background-background-white) border border-(--border-border-base-soft)",
      active: "bg-(--background-background-white) stepper-navigation-gradient-border",
      completed: "bg-(--background-background-white) border border-(--border-border-success-strong)",
      error: "bg-(--background-background-white) border border-(--border-border-error-strong)",
      disabled: "bg-(--background-background-white) border border-(--border-border-disabled-subtle)"
    }, z = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-success)",
      error: "text-(--text-text-error-strong)",
      disabled: "text-(--text-text-disabled-light)"
    }, B = {
      upcoming: "text-(--text-text-black-default)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-body)",
      error: "text-(--text-text-body)",
      disabled: "text-(--text-text-disabled-light)"
    }, W = {
      auto: "h-14 sm:h-10",
      mobile: "h-14",
      desktop: "h-10"
    }, _ = {
      auto: "top-9 sm:top-11",
      mobile: "top-9",
      desktop: "top-11"
    }, Z = {
      upcoming: "bg-(--background-background-white-secondary-soft) border-(--border-border-base-soft)",
      active: "bg-(--background-background-white) stepper-navigation-gradient-border",
      completed: "bg-(--background-background-success) border-(--border-border-success)",
      error: "bg-(--background-background-error) border-(--border-border-error-strong)",
      disabled: "bg-(--background-background-white-secondary-soft) border-(--border-border-base-soft)"
    }, le = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-success)",
      error: "text-(--text-text-error-strong)",
      disabled: "text-(--text-text-body)"
    }, D = {
      active: "ri-arrow-right-line",
      completed: "ri-check-line",
      error: "ri-close-line"
    };
    return (O, N) => e.type === "default" || e.type === "defaultVertical" ? (u(), b("div", {
      key: 0,
      role: "list",
      class: C(["stepper-navigation-scroll flex items-center overflow-x-auto", v[e.breakpoint]])
    }, [
      (u(!0), b(ie, null, Oe(e.steps, (V, M) => (u(), b(ie, {
        key: V.id
      }, [
        x("span", {
          role: "listitem",
          "aria-label": r(V, M, e.steps.length),
          class: "contents"
        }, [
          (u(), P(gt(o(V.state) ? "button" : "span"), Ve({ ref_for: !0 }, s(V, M), {
            class: [
              "flex items-center shrink-0",
              k.value,
              p[e.breakpoint],
              d(V.state)
            ]
          }), {
            default: me(() => [
              U(aa, Ve({
                type: "circle",
                size: "sm"
              }, { ref_for: !0 }, g(V, M)), null, 16),
              x("span", {
                "aria-hidden": "true",
                class: C([
                  "font-(--weight-medium) whitespace-nowrap",
                  y[e.breakpoint],
                  A[V.state]
                ])
              }, H(V.label), 3)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, xq),
        M < e.steps.length - 1 && $.value ? (u(), b("span", {
          key: 0,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "hidden sm:block" : "",
            "flex-1 border-t border-(--border-border-base-soft)"
          ])
        }, null, 2)) : w("", !0),
        M < e.steps.length - 1 && S.value ? (u(), b("span", {
          key: 1,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "sm:hidden" : "",
            "flex h-4 w-[3.5px] shrink-0 items-center justify-center"
          ])
        }, [...N[0] || (N[0] = [
          x("span", { class: "h-4 w-px rotate-[10.98deg] skew-x-[1.87deg] bg-(--border-border-base-soft)" }, null, -1)
        ])], 2)) : w("", !0)
      ], 64))), 128))
    ], 2)) : e.type === "onlyIcons" ? (u(), b("div", yq, [
      (u(!0), b(ie, null, Oe(e.steps, (V, M) => (u(), b(ie, {
        key: V.id
      }, [
        x("span", {
          role: "listitem",
          "aria-label": r(V, M, e.steps.length),
          class: "contents"
        }, [
          (u(), P(gt(o(V.state) ? "button" : "span"), Ve({ ref_for: !0 }, s(V, M), {
            class: ["flex items-center shrink-0", d(V.state)]
          }), {
            default: me(() => [
              U(aa, Ve({
                type: "circle",
                size: "md"
              }, { ref_for: !0 }, h(V, M)), null, 16)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, kq),
        M < e.steps.length - 1 ? (u(), b("span", wq)) : w("", !0)
      ], 64))), 128))
    ])) : e.type === "withDots" ? (u(), b("div", Cq, [
      x("div", Sq, [
        x("span", {
          "aria-hidden": "true",
          class: C([
            "absolute inset-x-0 h-0 border-t-(length:--border-border-width-border-base) border-(--border-border-base-soft)",
            _[e.breakpoint]
          ])
        }, null, 2),
        (u(!0), b(ie, null, Oe(e.steps, (V, M) => (u(), b("span", {
          key: V.id,
          role: "listitem",
          "aria-label": r(V, M, e.steps.length),
          class: "contents"
        }, [
          (u(), P(gt(o(V.state) ? "button" : "span"), Ve({ ref_for: !0 }, s(V, M), {
            class: [
              "relative flex flex-col items-center gap-(--spacing-3)",
              d(V.state)
            ]
          }), {
            default: me(() => [
              x("span", {
                "aria-hidden": "true",
                class: C([
                  "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                  z[V.state]
                ])
              }, H(V.label), 3),
              x("span", {
                "aria-hidden": "true",
                class: C(["h-4 w-4 rounded-full", E[V.state]])
              }, null, 2)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, $q))), 128))
      ])
    ])) : e.type === "iconsAndText" ? (u(), b("div", {
      key: 3,
      role: "list",
      class: C(["stepper-navigation-scroll flex", I[e.breakpoint]])
    }, [
      (u(!0), b(ie, null, Oe(e.steps, (V, M) => (u(), b(ie, {
        key: V.id
      }, [
        x("span", {
          role: "listitem",
          "aria-label": r(V, M, e.steps.length),
          class: "contents"
        }, [
          (u(), P(gt(o(V.state) ? "button" : "span"), Ve({ ref_for: !0 }, s(V, M), {
            class: [
              "flex items-center gap-(--spacing-3) text-left shrink-0",
              M === 0 ? "" : T[e.breakpoint],
              d(V.state)
            ]
          }), {
            default: me(() => [
              x("span", {
                class: C(e.breakpoint === "auto" ? "hidden sm:contents" : "contents")
              }, [
                $.value ? (u(), P(aa, Ve({
                  key: 0,
                  type: "circle",
                  size: "sm"
                }, { ref_for: !0 }, h(V, M)), null, 16)) : w("", !0)
              ], 2),
              x("span", {
                class: C(e.breakpoint === "auto" ? "contents sm:hidden" : "contents")
              }, [
                S.value ? (u(), P(aa, Ve({
                  key: 0,
                  type: "circle",
                  size: "md"
                }, { ref_for: !0 }, h(V, M)), null, 16)) : w("", !0)
              ], 2),
              x("span", Lq, [
                x("span", {
                  "aria-hidden": "true",
                  class: C([
                    "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                    A[V.state]
                  ])
                }, H(V.label), 3),
                V.helperText ? (u(), b("span", Tq, H(V.helperText), 1)) : w("", !0)
              ])
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Iq),
        M < e.steps.length - 1 && $.value ? (u(), b("span", {
          key: 0,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "hidden sm:block" : "",
            "flex-1 border-t-(length:--border-border-width-border-base) border-(--border-border-base-soft)"
          ])
        }, null, 2)) : w("", !0),
        M < e.steps.length - 1 && S.value ? (u(), b("span", {
          key: 1,
          "aria-hidden": "true",
          class: C([
            e.breakpoint === "auto" ? "block sm:hidden" : "",
            "self-center h-6 w-(--border-border-width-border-base) bg-(--border-border-base-soft)"
          ])
        }, null, 2)) : w("", !0)
      ], 64))), 128))
    ], 2)) : e.type === "vertical" ? (u(), b("div", Eq, [
      (u(!0), b(ie, null, Oe(e.steps, (V, M) => (u(), b(ie, {
        key: V.id
      }, [
        x("span", {
          role: "listitem",
          "aria-label": r(V, M, e.steps.length),
          class: "contents"
        }, [
          (u(), P(gt(o(V.state) ? "button" : "span"), Ve({ ref_for: !0 }, s(V, M), {
            class: ["flex items-center justify-between w-full text-left", d(V.state)]
          }), {
            default: me(() => [
              x("span", Rq, [
                U(aa, Ve({
                  type: "circle",
                  size: "md"
                }, { ref_for: !0 }, g(V, M)), null, 16),
                x("span", zq, [
                  x("span", {
                    "aria-hidden": "true",
                    class: C([
                      "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                      B[V.state]
                    ])
                  }, H(V.label), 3),
                  V.helperText ? (u(), b("span", Dq, H(V.helperText), 1)) : w("", !0)
                ])
              ]),
              $.value ? (u(), b("i", {
                key: 0,
                "aria-hidden": "true",
                class: C([e.breakpoint === "auto" ? "hidden sm:block" : "", "ri-arrow-right-s-line text-base shrink-0"])
              }, null, 2)) : w("", !0)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Aq),
        M < e.steps.length - 1 ? (u(), b("span", {
          key: 0,
          "aria-hidden": "true",
          class: C(["ml-[17.5px] w-px bg-(--border-border-base-soft)", W[e.breakpoint]])
        }, null, 2)) : w("", !0)
      ], 64))), 128))
    ])) : e.type === "cards" ? (u(), b("div", Bq, [
      (u(!0), b(ie, null, Oe(e.steps, (V, M) => (u(), b("span", {
        key: V.id,
        role: "listitem",
        "aria-label": r(V, M, e.steps.length),
        class: "contents"
      }, [
        (u(), P(gt(o(V.state) ? "button" : "span"), Ve({ ref_for: !0 }, s(V, M), {
          class: [
            "flex items-center gap-(--spacing-2) w-full min-w-40 p-(--spacing-4) rounded-(--border-border-radius-rounded-l) border border-solid text-left",
            Z[V.state],
            le[V.state],
            d(V.state)
          ]
        }), {
          default: me(() => [
            x("span", Oq, H(M + 1), 1),
            x("span", Pq, H(V.label), 1),
            D[V.state] ? (u(), b("i", {
              key: 0,
              "aria-hidden": "true",
              class: C([D[V.state], "text-xl leading-none shrink-0"])
            }, null, 2)) : w("", !0)
          ]),
          _: 2
        }, 1040, ["class"]))
      ], 8, Mq))), 128))
    ])) : w("", !0);
  }
}), fK = /* @__PURE__ */ Ct(Fq, [["__scopeId", "data-v-4839e094"]]);
function Xx(e) {
  return "conditions" in e;
}
function $f(e) {
  return e.kind === "group";
}
const Nq = /* @__PURE__ */ new Set(["isNull", "isNotNull"]), Vq = /* @__PURE__ */ new Set(["in", "notIn", "between"]);
function Tr(e) {
  return Nq.has(e);
}
function If(e) {
  return Vq.has(e);
}
function Hq(e) {
  return !e.field || !e.op ? !1 : Tr(e.op) ? !0 : If(e.op) ? e.op === "between" ? e.values.length === 2 && e.values.every((a) => a !== "") : e.values.length > 0 : e.value !== null && e.value !== "";
}
function gi(e) {
  return Zx(e);
}
function Zx(e) {
  const a = [];
  for (const t of e.children)
    if ($f(t)) {
      const n = Zx(t);
      n.conditions.length > 0 && a.push(n);
    } else Hq(t) && a.push(jq(t));
  return { operator: e.operator, conditions: a };
}
function jq(e) {
  const a = {
    field: e.field,
    op: e.op
  };
  return Tr(e.op) || (If(e.op) ? a.values = [...e.values] : a.value = e.value), a;
}
function wg(e, a) {
  return Xx(e) ? {
    _id: a(),
    kind: "group",
    operator: e.operator,
    children: e.conditions.map((t) => lc(t, a))
  } : {
    _id: a(),
    kind: "group",
    operator: "and",
    children: [lc(e, a)]
  };
}
function lc(e, a) {
  return Xx(e) ? {
    _id: a(),
    kind: "group",
    operator: e.operator,
    children: e.conditions.map((t) => lc(t, a))
  } : {
    _id: a(),
    kind: "criterion",
    field: e.field,
    op: e.op,
    value: e.value ?? null,
    values: e.values ? [...e.values] : []
  };
}
const Wq = /* @__PURE__ */ new Set(["lastNDays", "nextNDays"]);
function qq(e) {
  return e.field === null && e.op === null;
}
function Uq(e, a) {
  if (e === "DateTime") {
    const l = Date.parse(String(a[0])), o = Date.parse(String(a[1]));
    return Number.isNaN(l) || Number.isNaN(o) ? null : [l, o];
  }
  const t = Number(a[0]), n = Number(a[1]);
  return Number.isNaN(t) || Number.isNaN(n) ? null : [t, n];
}
function Gq(e, a) {
  if (qq(e))
    return [];
  const t = e.field ? a.find((l) => l.path === e.field) : void 0;
  if (e.field && !t)
    return ["fieldOrphan"];
  if (!e.field || !e.op || !t)
    return ["valueRequired"];
  const n = [];
  if (t.operators.includes(e.op) || n.push("operatorIllegal"), Tr(e.op))
    return n;
  if (Wq.has(e.op)) {
    const l = Number(e.value);
    return (e.value === null || e.value === "" || !Number.isInteger(l) || l < 1) && n.push("daysInvalid"), n;
  }
  if (e.op === "between") {
    if (e.values.length !== 2 || e.values.some((o) => o === ""))
      return n.push("valueRequired"), n;
    const l = Uq(t.type, e.values);
    return (l === null || l[0] > l[1]) && n.push("rangeInvalid"), n;
  }
  return If(e.op) ? (e.values.length === 0 && n.push("valueRequired"), n) : e.value === null || e.value === "" ? (n.push("valueRequired"), n) : (t.type === "Number" || t.type === "Decimal" ? (typeof e.value != "number" || Number.isNaN(e.value)) && n.push("valueInvalid") : t.type === "DateTime" && Number.isNaN(Date.parse(String(e.value))) && n.push("valueInvalid"), n);
}
function Cg(e, a) {
  const t = /* @__PURE__ */ new Map(), n = (l) => {
    for (const o of l.children)
      if ($f(o))
        n(o);
      else {
        const r = Gq(o, a);
        r.length > 0 && t.set(o._id, r);
      }
  };
  return n(e), t;
}
let Sg = 0;
function ao() {
  return Sg += 1, `afb-${Sg}`;
}
function $g() {
  return { _id: ao(), kind: "group", operator: "and", children: [] };
}
function Ig() {
  return { _id: ao(), kind: "criterion", field: null, op: null, value: null, values: [] };
}
function mi(e) {
  const a = (t) => t.kind === "group" ? {
    _id: t._id,
    kind: "group",
    operator: t.operator,
    children: t.children.map(a)
  } : {
    _id: t._id,
    kind: "criterion",
    field: t.field,
    op: t.op,
    value: t.value,
    values: [...t.values]
  };
  return a(e);
}
function Qx(e, a) {
  if (e.kind !== a.kind)
    return !1;
  if (e.kind === "group" && a.kind === "group")
    return e.operator === a.operator && e.children.length === a.children.length && e.children.every((l, o) => Qx(l, a.children[o]));
  const t = e, n = a;
  return t.field === n.field && t.op === n.op && t.value === n.value && t.values.length === n.values.length && t.values.every((l, o) => l === n.values[o]);
}
function Kq(e, a) {
  const t = R(e ? wg(e, ao) : $g()), n = R(mi(t.value)), l = R(/* @__PURE__ */ new Map()), o = m(() => l.value.size > 0), r = m(() => Xt(a) ?? []), i = m(
    () => Cg(t.value, r.value).size === 0
  ), s = m(
    () => !Qx(t.value, n.value)
  );
  function d(A) {
    A.children.push(Ig());
  }
  function c(A) {
    A.children.push({ _id: ao(), kind: "group", operator: "and", children: [Ig()] });
  }
  function f(A) {
    const E = [A._id];
    if (A.kind === "group")
      for (const z of A.children)
        E.push(...f(z));
    return E;
  }
  function g(A, E) {
    const z = A.children.find((W) => W._id === E), B = z ? f(z) : [E];
    A.children = A.children.filter((W) => W._id !== E);
    for (const W of B)
      $(W);
  }
  function h(A, E) {
    A.operator = E;
  }
  function v(A) {
    return A.children.length >= 2;
  }
  function p(A) {
    const E = (z, B) => {
      if (z._id === A._id)
        return B;
      if (z.kind === "group")
        for (const W of z.children) {
          const _ = E(W, B + 1);
          if (_ !== null)
            return _;
        }
      return null;
    };
    return E(t.value, 1) ?? 1;
  }
  function y(A, E) {
    return p(A) < E;
  }
  function k(A) {
    return l.value = Cg(t.value, A), l.value.size === 0;
  }
  function $(A) {
    if (l.value.has(A)) {
      const E = new Map(l.value);
      E.delete(A), l.value = E;
    }
  }
  function S() {
    n.value = mi(t.value);
  }
  function I() {
    t.value = mi(n.value), l.value = /* @__PURE__ */ new Map();
  }
  function T(A) {
    t.value = A ? wg(A, ao) : $g(), n.value = mi(t.value), l.value = /* @__PURE__ */ new Map();
  }
  return {
    root: t,
    addCriterion: d,
    addGroup: c,
    removeNode: g,
    setConjunction: h,
    showConjunction: v,
    depthOf: p,
    canNest: y,
    snapshot: S,
    reset: I,
    reseed: T,
    newId: ao,
    errors: l,
    hasErrors: o,
    isValidLive: i,
    isDirty: s,
    validate: k,
    clearNodeErrors: $
  };
}
function _x(e) {
  const a = Kq(e.modelValue(), e.fields);
  function t() {
    a.root.value.children.length === 0 && (a.addCriterion(a.root.value), a.snapshot());
  }
  t(), kt(() => {
    a.snapshot();
  });
  function n(c) {
    a.reseed(c), t();
  }
  $e(
    a.root,
    () => {
      e.emitUpdate(gi(a.root.value));
    },
    { deep: !0 }
  );
  const l = m(
    () => gi(a.root.value).conditions.length > 0
  ), o = m(
    () => !e.busy() && l.value && a.isValidLive.value
  ), r = m(() => o.value || e.busy() ? null : l.value ? e.labels().saveDisabledInvalid ?? null : e.labels().saveDisabledEmpty ?? null);
  function i() {
    e.busy() || a.validate(e.fields()) && e.emitApply(gi(a.root.value));
  }
  function s() {
    e.busy() || (a.reset(), e.emitReset());
  }
  function d() {
    o.value && e.emitSave(gi(a.root.value));
  }
  return {
    builder: a,
    hasCompleteCriterion: l,
    canSave: o,
    saveDisabledReason: r,
    onApply: i,
    onReset: s,
    onSave: d,
    reseedFrom: n
  };
}
const e0 = '[data-testid="filter-field-select-panel"]', Yq = ["disabled", "aria-expanded"], Jq = {
  key: 0,
  "data-testid": "filter-field-select-trigger-label",
  class: "sr-only"
}, Xq = { class: "flex min-w-0 flex-1" }, Zq = {
  key: 0,
  class: "flex min-h-4.5 items-center gap-1 text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, Qq = ["aria-label"], _q = /* @__PURE__ */ ke({
  __name: "FilterFieldSelect",
  props: {
    fields: {},
    groups: { default: () => [] },
    modelValue: { default: "" },
    placeholder: {},
    searchPlaceholder: {},
    searchClearLabel: { default: "Clear search" },
    groupsLabel: {},
    noResultsLabel: {},
    resultsCountLabel: {},
    noFieldsLabel: {},
    emptyGroupLabel: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    error: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = R(null), o = R(null), r = R(""), i = R(""), { isOpen: s, dropdownRef: d, toggleDropdown: c, closeDropdown: f } = So({
      onClose: g,
      // The panel is teleported to <body>, so every click inside it reads as an
      // "outside" click to useDropdown unless it is explicitly ignored. The selector is
      // shared with the consumers that must ignore it too.
      ignoreSelectors: [e0]
    });
    function g() {
      r.value = "", i.value = "";
    }
    const h = R({}), v = 4, p = 8, y = 540, k = 240;
    function $() {
      var ne;
      const te = (ne = l.value) == null ? void 0 : ne.getBoundingClientRect();
      if (!te) return;
      const ve = typeof window < "u" ? window.innerWidth : te.right, Se = typeof window < "u" ? window.innerHeight : te.bottom, ge = te.left + te.width / 2 > ve / 2 ? { right: `${ve - te.right}px` } : { left: `${te.left}px` }, de = Se - te.bottom - v - p, Ee = te.top - v - p, j = de < k && Ee > de, J = j ? { bottom: `${Se - te.top + v}px` } : { top: `${te.bottom + v}px` };
      h.value = {
        position: "fixed",
        ...ge,
        ...J,
        maxHeight: `${Math.min(y, Math.max(j ? Ee : de, 0))}px`,
        zIndex: "350"
      };
    }
    function S() {
      typeof window > "u" || (window.addEventListener("scroll", $, !0), window.addEventListener("resize", $));
    }
    function I() {
      typeof window > "u" || (window.removeEventListener("scroll", $, !0), window.removeEventListener("resize", $));
    }
    $e(s, (te) => {
      te ? Ze(() => {
        var ve;
        $(), S(), (ve = o.value) == null || ve.focusSearch();
      }) : I();
    }), Tt(I);
    const T = m(
      () => t.modelValue ? t.fields.find((te) => te.path === t.modelValue) ?? null : null
    ), A = m(
      () => t.fields.map((te) => ({ key: te.path, label: te.label, icon: te.icon, group: te.group }))
    );
    function E() {
      var ve, Se;
      const te = (ve = T.value) == null ? void 0 : ve.group;
      return te && t.groups.some((oe) => oe.value === te) ? te : ((Se = t.groups[0]) == null ? void 0 : Se.value) ?? "";
    }
    function z() {
      r.value = "", i.value = E(), c();
    }
    function B() {
      if (!t.disabled) {
        if (s.value) {
          f();
          return;
        }
        z();
      }
    }
    const W = R(null), _ = R(!1), Z = R(!1), le = m(() => Z.value || s.value ? !1 : _.value ? !0 : void 0);
    function D(te) {
      try {
        _.value = te.target.matches(":focus-visible");
      } catch {
        _.value = !0;
      }
    }
    function O() {
      _.value = !1, Z.value = !1;
    }
    function N(te) {
      var ve;
      if (te.key === "Escape" && !s.value && !Z.value && _.value && ((ve = W.value) != null && ve.isTruncated)) {
        te.stopPropagation(), te.preventDefault(), Z.value = !0;
        return;
      }
      t.disabled || s.value || te.key !== "ArrowDown" && te.key !== "ArrowUp" || (te.preventDefault(), z());
    }
    function V(te) {
      n("update:modelValue", te), f(), Ze(() => {
        var ve;
        return (ve = l.value) == null ? void 0 : ve.focus();
      });
    }
    function M(te) {
      s.value && (te.stopPropagation(), te.preventDefault(), f(), Ze(() => {
        var ve;
        return (ve = l.value) == null ? void 0 : ve.focus();
      }));
    }
    const Q = {
      sm: {
        container: "h-[32px] px-[calc(--spacing(2)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      md: {
        container: "h-[36px] px-[calc(--spacing(3)-1px)] gap-2",
        text: "text-(length:--size-m) leading-(--line-height-l)",
        icon: "text-(length:--icon-size-sm) leading-(--icon-size-sm)"
      },
      lg: {
        container: "h-[48px] px-[calc(--spacing(3.5)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)",
        icon: "text-(length:--icon-size-md) leading-(--icon-size-md)"
      },
      xl: {
        container: "h-[52px] px-[calc(--spacing(4)-1px)] gap-2",
        text: "text-(length:--size-l) leading-(--line-height-xxl)",
        icon: "text-(length:--icon-size-md) leading-(--icon-size-md)"
      }
    }, q = m(() => Q[t.size]), K = m(() => !!t.error), G = m(() => {
      const te = "relative flex min-w-0 items-center w-full rounded-(--border-border-radius-rounded-l) border border-solid box-border text-left font-inter transition-colors select-none focus-visible:outline-hidden focus-visible:shadow-(--shadow-focus-l)";
      return t.disabled ? `${te} cursor-not-allowed bg-gainsboro-200 border-border-disabled-subtle text-text-disabled dark:bg-(--colors-background-disabled) dark:border-(--colors-border-disabled-subtle) dark:text-(--colors-text-disabled)` : K.value ? `${te} cursor-pointer bg-white border-(--border-border-error-strong) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--border-border-error) dark:text-(--colors-text-white-default)` : s.value ? `${te} cursor-pointer bg-(--background-background-selected) border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)] text-text-black-default dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)` : `${te} cursor-pointer bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-accent) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--colors-border-base) dark:text-(--colors-text-white-default)`;
    });
    return (te, ve) => {
      var Se;
      return u(), b("div", {
        ref_key: "dropdownRef",
        ref: d,
        class: C(["relative min-w-0 text-left", e.fullWidth ? "w-full" : "inline-block max-w-full"]),
        onKeydown: St(M, ["escape"])
      }, [
        x("button", {
          ref_key: "triggerRef",
          ref: l,
          type: "button",
          "data-testid": "filter-field-select-trigger",
          class: C([G.value, q.value.container]),
          disabled: e.disabled,
          "aria-expanded": L(s),
          "aria-haspopup": "dialog",
          onClick: B,
          onKeydown: N,
          onFocus: D,
          onBlur: O
        }, [
          T.value ? (u(), b("span", Jq, H(e.placeholder), 1)) : w("", !0),
          x("span", Xq, [
            U(it, {
              ref_key: "labelRef",
              ref: W,
              text: ((Se = T.value) == null ? void 0 : Se.label) ?? e.placeholder,
              focusable: !1,
              open: le.value,
              "text-class": [
                q.value.text,
                e.disabled ? "" : T.value ? "text-text-black-default dark:text-(--colors-text-white-default)" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
              ].join(" ")
            }, null, 8, ["text", "open", "text-class"])
          ]),
          x("i", {
            class: C(["ri-arrow-down-s-line shrink-0 transition-transform duration-200 ease-in-out", [
              q.value.icon,
              e.disabled ? "text-text-disabled" : "text-(--text-text-body-subtle)",
              L(s) ? "rotate-180" : "rotate-0"
            ]]),
            "aria-hidden": "true"
          }, null, 2)
        ], 42, Yq),
        e.error ? (u(), b("p", Zq, [
          ve[2] || (ve[2] = x("i", {
            class: "ri-error-warning-fill",
            "aria-hidden": "true"
          }, null, -1)),
          x("span", null, H(e.error), 1)
        ])) : w("", !0),
        (u(), P(Fa, { to: "body" }, [
          U(Wt, {
            "enter-active-class": "transition duration-100 ease-out motion-reduce:transition-none",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out motion-reduce:transition-none",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: me(() => [
              L(s) ? (u(), b("div", {
                key: 0,
                role: "dialog",
                "aria-label": e.placeholder,
                "data-testid": "filter-field-select-panel",
                "data-focus-trap-allow-outside": "",
                style: Ge([{ width: L(Ic).l }, h.value]),
                class: C(["flex max-w-[calc(100vw-2rem)] flex-col overflow-hidden", L(hl)]),
                onKeydown: St(M, ["escape"])
              }, [
                U(Px, {
                  ref_key: "pickerRef",
                  ref: o,
                  "active-group": i.value,
                  "onUpdate:activeGroup": ve[0] || (ve[0] = (oe) => i.value = oe),
                  "search-query": r.value,
                  "onUpdate:searchQuery": ve[1] || (ve[1] = (oe) => r.value = oe),
                  fields: A.value,
                  groups: e.groups,
                  "strict-groups": "",
                  "groups-label": e.groupsLabel,
                  "search-placeholder": e.searchPlaceholder,
                  "search-clear-label": e.searchClearLabel,
                  "list-label": e.searchPlaceholder,
                  "selected-key": e.modelValue || void 0,
                  "no-results-label": e.noResultsLabel,
                  "results-count-label": e.resultsCountLabel,
                  "no-fields-label": e.noFieldsLabel,
                  "empty-group-label": e.emptyGroupLabel,
                  onSelect: V
                }, null, 8, ["active-group", "search-query", "fields", "groups", "groups-label", "search-placeholder", "search-clear-label", "list-label", "selected-key", "no-results-label", "results-count-label", "no-fields-label", "empty-group-label"])
              ], 46, Qq)) : w("", !0)
            ]),
            _: 1
          })
        ]))
      ], 34);
    };
  }
});
function t0(e, a, t, n) {
  return [...new Set(e)].filter((l) => Ss(l, a) === l && !a.some((o) => o.value === l)).map((l) => ({ value: l, label: eU(l, t, n) }));
}
function Ss(e, a) {
  var n;
  if (a.some((l) => l.value === e)) return e;
  const t = e.toLowerCase();
  return ((n = a.find((l) => l.value.toLowerCase() === t)) == null ? void 0 : n.value) ?? e;
}
function eU(e, a, t) {
  if (!a) return t.valueUnknown;
  const n = a.labelOf(e);
  return n === void 0 ? t.valueLoading : n ?? t.valueUnknown;
}
const tU = /* @__PURE__ */ ke({
  __name: "CriterionValueChoice",
  props: {
    kind: {},
    criterion: {},
    field: {},
    labels: {}
  },
  emits: ["update:values", "update:value"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = R([]), o = R(), r = R(!1), i = Bn(/* @__PURE__ */ new Map());
    let s = 0, d = !1;
    async function c(k) {
      const $ = t.field.optionSource;
      if (!$) return;
      d = !0;
      const S = ++s;
      r.value = !0;
      try {
        const I = await $.search(k);
        if (S !== s) return;
        for (const T of I.options) i.set(T.value, T.label);
        l.value = I.options, o.value = I.totalCount;
      } catch {
        if (S !== s) return;
        k === "" && (d = !1), l.value = [], o.value = 0;
      } finally {
        S === s && (r.value = !1);
      }
    }
    function f() {
      d || c("");
    }
    const g = m(() => {
      const k = t.criterion;
      return t.kind === "multiSelect" ? k.values.map(String) : k.value === null || k.value === "" ? [] : [String(k.value)];
    }), h = m(() => {
      const k = t.field.optionSource, $ = k ? l.value : t.field.options ?? [], S = [...i].map(([A, E]) => ({ value: A, label: E })), I = [...new Set(g.value)].map((A) => Ss(A, S)).filter((A) => i.has(A) && !$.some((E) => E.value.toLowerCase() === A.toLowerCase())).map((A) => ({ value: A, label: i.get(A) })), T = [...$, ...I];
      return [...T, ...t0(g.value, T, k, t.labels)];
    }), v = m(() => [...new Set(g.value.map((k) => Ss(k, h.value)))]), p = m(() => h.value.map((k) => ({ id: k.value, label: k.label }))), y = m(() => {
      const k = o.value;
      if (!(!t.field.optionSource || r.value || k === void 0 || k <= l.value.length))
        return Rs(t.labels.valueMoreResults, k);
    });
    return (k, $) => e.kind === "multiSelect" ? (u(), P(um, {
      key: 0,
      "model-value": v.value,
      options: p.value,
      async: !!e.field.optionSource,
      loading: r.value,
      "loading-label": e.labels.valueLoading,
      "total-count": e.field.optionSource ? o.value : void 0,
      "footer-label": y.value,
      placeholder: e.labels.valuePlaceholder,
      "aria-label": e.labels.valuePlaceholder,
      "confirm-label": e.labels.valueConfirm,
      "search-placeholder": e.labels.valueSearchPlaceholder,
      "search-clear-label": e.labels.valueSearchClear,
      "select-all-label": e.labels.valueSelectAll,
      "clear-all-label": e.labels.valueClearAll,
      "remove-chip-label": e.labels.valueRemoveChip,
      "empty-label": e.labels.valueEmpty,
      "show-select-all": !e.field.optionSource,
      "freeze-on-open": "",
      onFocusin: f,
      onSearch: c,
      "onUpdate:modelValue": $[0] || ($[0] = (S) => n("update:values", S))
    }, null, 8, ["model-value", "options", "async", "loading", "loading-label", "total-count", "footer-label", "placeholder", "aria-label", "confirm-label", "search-placeholder", "search-clear-label", "select-all-label", "clear-all-label", "remove-chip-label", "empty-label", "show-select-all"])) : (u(), P(wx, {
      key: 1,
      "model-value": v.value[0] ?? "",
      options: h.value,
      loading: r.value,
      placeholder: e.labels.valuePlaceholder,
      "aria-label": e.labels.valuePlaceholder,
      "empty-label": e.labels.valueNoResults,
      "results-count-label": e.labels.valueResultsCount,
      "clear-label": e.labels.valueSearchClear,
      "results-label": e.labels.valueResultsLabel,
      "icon-left": "",
      onSearch: c,
      "onUpdate:modelValue": $[1] || ($[1] = (S) => n("update:value", S))
    }, null, 8, ["model-value", "options", "loading", "placeholder", "aria-label", "empty-label", "results-count-label", "clear-label", "results-label"]));
  }
}), aU = ["aria-label"], nU = { class: "flex flex-wrap items-start gap-3 py-1" }, lU = { class: "w-[100px] shrink-0" }, oU = ["aria-label"], rU = {
  key: 1,
  class: "flex h-[36px] w-full items-center rounded-xl border border-solid border-(--colors-border-base-medium) bg-(--background-background-white) px-2.5 text-sm font-medium text-(--colors-text-body) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)",
  "aria-hidden": "true"
}, iU = { class: "min-w-0 flex-1" }, sU = {
  key: 6,
  class: "flex items-start gap-2"
}, dU = {
  "data-testid": "afb-days-suffix",
  class: "flex h-9 shrink-0 items-center text-sm text-(--colors-text-body)"
}, uU = ["data-testid"], cU = { class: "flex items-start gap-3" }, fU = { class: "flex flex-wrap items-center gap-3 pt-1" }, hU = /* @__PURE__ */ ke({
  __name: "CriteriaGroup",
  props: {
    group: {},
    fields: {},
    labels: {},
    maxDepth: {},
    builder: {},
    depth: {},
    fieldGroups: {}
  },
  setup(e) {
    const a = e;
    function t(O) {
      return O ? a.fields.find((N) => N.path === O) : void 0;
    }
    function n(O, N) {
      const V = O.type === "DateTime" ? a.labels.dateOperatorLabels : O.type === "String" ? a.labels.stringOperatorLabels : O.type === "Enum" || O.type === "Guid" ? a.labels.listOperatorLabels : void 0;
      return (V == null ? void 0 : V[N]) ?? a.labels.operatorLabels[N] ?? N;
    }
    function l(O) {
      const N = t(O.field);
      return N ? N.operators.map((V) => ({
        value: V,
        label: n(N, V)
      })) : [];
    }
    function o(O, N) {
      if ((O === "in" || O === "notIn") && (N.options || N.optionSource)) return "multiSelect";
      if (!(O !== "eq" && O !== "neq"))
        return N.options ? "select" : N.optionSource ? "autocomplete" : void 0;
    }
    function r(O) {
      if (O.field && !t(O.field))
        return "orphan";
      if (!O.field || !O.op)
        return "placeholder";
      if (Tr(O.op))
        return "none";
      const N = t(O.field), V = o(O.op, N);
      if (V) return V;
      const M = N.type;
      return O.op === "lastNDays" || O.op === "nextNDays" ? "days" : O.op === "between" ? M === "DateTime" ? "dateRange" : "numberRange" : O.op === "in" || O.op === "notIn" ? "tags" : M === "Bool" ? "bool" : M === "Number" || M === "Decimal" ? "number" : M === "DateTime" ? "date" : "text";
    }
    function i(O) {
      const N = r(O);
      return N === "dateRange" || N === "numberRange" || N === "tags" || N === "multiSelect";
    }
    function s(O) {
      return O.value === null || O.value === "" ? [] : [String(O.value)];
    }
    function d(O) {
      const N = t(O.field);
      if (!N) return [];
      const V = N.options ?? [];
      return [...V, ...t0(s(O), V, void 0, a.labels)];
    }
    function c(O) {
      return Ss(T(O), d(O));
    }
    function f(O) {
      const N = r(O);
      return N === "multiSelect" || N === "autocomplete" ? N : void 0;
    }
    const g = m(() => [
      { value: "and", label: a.labels.and },
      { value: "or", label: a.labels.or }
    ]);
    function h(O, N) {
      a.builder.clearNodeErrors(O._id), O.field = N || null, O.op = null, O.value = null, O.values = [];
    }
    function v(O) {
      return !O || Tr(O) ? "none" : O === "between" ? "between" : O === "in" || O === "notIn" ? "set" : O === "lastNDays" || O === "nextNDays" ? "days" : "scalar";
    }
    function p(O, N) {
      a.builder.clearNodeErrors(O._id);
      const V = O.op;
      O.op = N || null, v(O.op) !== v(V) && (O.value = null, O.values = []);
    }
    function y(O, N) {
      var M;
      a.builder.clearNodeErrors(O._id);
      const V = (M = t(O.field)) == null ? void 0 : M.type;
      if (V === "Number" || V === "Decimal") {
        O.value = N === "" ? null : Number(N);
        return;
      }
      O.value = N === "" ? null : N;
    }
    function k(O, N) {
      a.builder.clearNodeErrors(O._id), O.value = N === "" ? null : Number(N);
    }
    function $(O, N, V) {
      a.builder.clearNodeErrors(O._id);
      const M = [O.values[0] ?? "", O.values[1] ?? ""];
      M[N] = V === null ? "" : V, O.values = M;
    }
    function S(O, N) {
      var M;
      a.builder.clearNodeErrors(O._id);
      const V = (M = t(O.field)) == null ? void 0 : M.type;
      if (V === "Number" || V === "Decimal") {
        O.values = N.map(Number).filter((Q) => Number.isFinite(Q));
        return;
      }
      O.values = [...N];
    }
    function I(O, N) {
      a.builder.clearNodeErrors(O._id), O.value = N === "" ? null : N === "true";
    }
    function T(O) {
      return O.value === null || O.value === void 0 ? "" : String(O.value);
    }
    function A(O) {
      return $f(O);
    }
    const E = {
      valueRequired: "errorValueRequired",
      valueInvalid: "errorValueInvalid",
      rangeInvalid: "errorRangeInvalid",
      daysInvalid: "errorDaysInvalid",
      operatorIllegal: "errorOperatorIllegal",
      fieldOrphan: "errorFieldOrphan"
    };
    function z(O) {
      const N = a.builder.errors.value.get(O._id);
      return N != null && N.length ? a.labels[E[N[0]]] : null;
    }
    function B() {
      a.builder.addCriterion(a.group);
    }
    function W() {
      a.builder.addGroup(a.group);
    }
    function _(O) {
      a.builder.removeNode(a.group, O);
    }
    function Z(O) {
      a.builder.setConjunction(a.group, O);
    }
    const le = m(() => a.builder.canNest(a.group, a.maxDepth)), D = m(
      () => a.group.operator === "or" ? a.labels.or : a.labels.and
    );
    return (O, N) => {
      const V = c0("CriteriaGroup", !0);
      return u(), b("div", {
        class: C([
          "flex flex-col gap-2",
          // The root level sits directly on the modal body (no card, per Figma);
          // only nested groups get a neutral-gray bordered card so they read as a
          // sub-scope. The lavender accent card was a divergence from the design.
          e.depth > 1 ? "rounded-xl border border-solid border-(--colors-border-base-soft) bg-(--colors-background-white-secondary) p-4 dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)" : ""
        ]),
        role: "group",
        "aria-label": e.labels.title
      }, [
        (u(!0), b(ie, null, Oe(e.group.children, (M, Q) => (u(), b(ie, {
          key: M._id
        }, [
          x("div", nU, [
            x("div", lU, [
              Q === 1 ? (u(), b("div", {
                key: 0,
                role: "group",
                "aria-label": `${e.labels.and} / ${e.labels.or}`
              }, [
                U(yl, {
                  "data-testid": "afb-conjunction",
                  "model-value": e.group.operator,
                  options: g.value,
                  placeholder: e.labels.and,
                  "aria-label": `${e.labels.and} / ${e.labels.or}`,
                  size: "sm",
                  "full-width": "",
                  "onUpdate:modelValue": Z
                }, null, 8, ["model-value", "options", "placeholder", "aria-label"])
              ], 8, oU)) : Q >= 2 ? (u(), b("span", rU, H(D.value), 1)) : w("", !0)
            ]),
            A(M) ? (u(), b(ie, { key: 0 }, [
              U(V, {
                class: "min-w-0 flex-1",
                group: M,
                fields: e.fields,
                labels: e.labels,
                "max-depth": e.maxDepth,
                builder: e.builder,
                depth: e.depth + 1,
                "field-groups": e.fieldGroups
              }, null, 8, ["group", "fields", "labels", "max-depth", "builder", "depth", "field-groups"]),
              U(Be, {
                "data-testid": `afb-remove-${Q}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (q) => _(M._id)
              }, null, 8, ["data-testid", "aria-label", "onClick"])
            ], 64)) : r(M) === "orphan" ? (u(), b(ie, { key: 1 }, [
              x("div", iU, [
                U(Qt, {
                  "model-value": M.field ?? "",
                  disabled: "",
                  "full-width": "",
                  error: e.labels.errorFieldOrphan
                }, null, 8, ["model-value", "error"])
              ]),
              U(Be, {
                "data-testid": `afb-remove-${Q}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (q) => _(M._id)
              }, null, 8, ["data-testid", "aria-label", "onClick"])
            ], 64)) : (u(), b(ie, { key: 2 }, [
              U(_q, {
                "data-testid": `afb-field-${Q}`,
                class: "min-w-0 flex-1",
                "model-value": M.field ?? "",
                fields: e.fields,
                groups: e.fieldGroups,
                placeholder: e.labels.fieldPlaceholder,
                "search-placeholder": e.labels.fieldSearchPlaceholder,
                "search-clear-label": e.labels.fieldSearchClear,
                "groups-label": e.labels.fieldGroupsLabel,
                "no-results-label": e.labels.fieldNoResults,
                "results-count-label": e.labels.fieldResultsCount,
                "no-fields-label": e.labels.fieldNoFields,
                "empty-group-label": e.labels.fieldEmptyGroup,
                "full-width": "",
                "onUpdate:modelValue": (q) => h(M, q)
              }, null, 8, ["data-testid", "model-value", "fields", "groups", "placeholder", "search-placeholder", "search-clear-label", "groups-label", "no-results-label", "results-count-label", "no-fields-label", "empty-group-label", "onUpdate:modelValue"]),
              U(yl, {
                "data-testid": `afb-operator-${Q}`,
                class: "min-w-0 flex-1",
                "model-value": M.op ?? "",
                options: l(M),
                placeholder: e.labels.operatorPlaceholder,
                "aria-label": e.labels.operatorPlaceholder,
                disabled: !M.field,
                "full-width": "",
                "onUpdate:modelValue": (q) => p(M, q)
              }, null, 8, ["data-testid", "model-value", "options", "placeholder", "aria-label", "disabled", "onUpdate:modelValue"]),
              x("div", {
                class: C(i(M) ? "order-last basis-full min-w-0 pl-[112px]" : "min-w-0 flex-1")
              }, [
                r(M) === "placeholder" ? (u(), P(Qt, {
                  key: 0,
                  "model-value": "",
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  disabled: "",
                  "full-width": ""
                }, null, 8, ["placeholder", "aria-label"])) : r(M) === "select" ? (u(), P(yl, {
                  key: 1,
                  "data-testid": `afb-value-${Q}`,
                  "model-value": c(M),
                  options: d(M),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  searchable: "",
                  "search-placeholder": e.labels.valueSearchPlaceholder,
                  "search-clear-label": e.labels.valueSearchClear,
                  "no-results-label": e.labels.valueNoResults,
                  "results-count-label": e.labels.valueResultsCount,
                  "full-width": "",
                  "onUpdate:modelValue": (q) => y(M, q)
                }, null, 8, ["data-testid", "model-value", "options", "placeholder", "aria-label", "search-placeholder", "search-clear-label", "no-results-label", "results-count-label", "onUpdate:modelValue"])) : f(M) ? (u(), P(tU, {
                  key: `${M.field}:${f(M)}`,
                  "data-testid": `afb-value-${Q}`,
                  kind: f(M),
                  criterion: M,
                  field: t(M.field),
                  labels: e.labels,
                  "onUpdate:values": (q) => S(M, q),
                  "onUpdate:value": (q) => y(M, q)
                }, null, 8, ["data-testid", "kind", "criterion", "field", "labels", "onUpdate:values", "onUpdate:value"])) : r(M) === "bool" ? (u(), P(yl, {
                  key: 3,
                  "data-testid": `afb-value-${Q}`,
                  "model-value": M.value === null ? "" : String(M.value),
                  options: [
                    { value: "true", label: e.labels.boolTrue },
                    { value: "false", label: e.labels.boolFalse }
                  ],
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (q) => I(M, q)
                }, null, 8, ["data-testid", "model-value", "options", "placeholder", "aria-label", "onUpdate:modelValue"])) : r(M) === "numberRange" ? (u(), P($x, {
                  key: 4,
                  "data-testid": `afb-value-${Q}`,
                  "min-value": M.values[0] === void 0 || M.values[0] === "" ? null : Number(M.values[0]),
                  "max-value": M.values[1] === void 0 || M.values[1] === "" ? null : Number(M.values[1]),
                  "show-slider": !1,
                  "clamp-input-to-bounds": !1,
                  "min-placeholder": e.labels.rangeFrom,
                  "max-placeholder": e.labels.rangeTo,
                  "min-aria-label": e.labels.rangeFrom,
                  "max-aria-label": e.labels.rangeTo,
                  "separator-label": e.labels.rangeTo,
                  "onUpdate:minValue": (q) => $(M, 0, q),
                  "onUpdate:maxValue": (q) => $(M, 1, q)
                }, null, 8, ["data-testid", "min-value", "max-value", "min-placeholder", "max-placeholder", "min-aria-label", "max-aria-label", "separator-label", "onUpdate:minValue", "onUpdate:maxValue"])) : r(M) === "dateRange" ? (u(), P(z3, {
                  key: 5,
                  "data-testid": `afb-value-${Q}`,
                  "start-date": String(M.values[0] ?? ""),
                  "end-date": String(M.values[1] ?? ""),
                  "start-placeholder": e.labels.rangeFrom,
                  "end-placeholder": e.labels.rangeTo,
                  "start-label": "",
                  "end-label": "",
                  language: e.labels.dateLocale ?? "en",
                  format: "yyyy-mm-dd",
                  "full-width": "",
                  "onUpdate:startDate": (q) => $(M, 0, q),
                  "onUpdate:endDate": (q) => $(M, 1, q)
                }, null, 8, ["data-testid", "start-date", "end-date", "start-placeholder", "end-placeholder", "language", "onUpdate:startDate", "onUpdate:endDate"])) : r(M) === "days" ? (u(), b("div", sU, [
                  U(ah, {
                    "data-testid": `afb-value-${Q}`,
                    "model-value": T(M),
                    placeholder: e.labels.valuePlaceholder,
                    "aria-label": e.labels.valuePlaceholder,
                    "full-width": "",
                    "onUpdate:modelValue": (q) => k(M, q)
                  }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"]),
                  x("span", dU, H(e.labels.daysSuffix), 1)
                ])) : r(M) === "tags" ? (u(), P(LO, {
                  key: 7,
                  "data-testid": `afb-value-${Q}`,
                  "model-value": M.values.map(String),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "remove-label": e.labels.removeValue,
                  "full-width": "",
                  "onUpdate:modelValue": (q) => S(M, q)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "remove-label", "onUpdate:modelValue"])) : r(M) === "number" ? (u(), P(ah, {
                  key: 8,
                  "data-testid": `afb-value-${Q}`,
                  "model-value": T(M),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (q) => y(M, q)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"])) : r(M) === "date" ? (u(), P(Ju, {
                  key: 9,
                  "data-testid": `afb-value-${Q}`,
                  "model-value": T(M),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  language: e.labels.dateLocale ?? "en",
                  format: "yyyy-mm-dd",
                  "full-width": "",
                  "onUpdate:modelValue": (q) => y(M, q)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "language", "onUpdate:modelValue"])) : r(M) === "text" ? (u(), P(Qt, {
                  key: 10,
                  "data-testid": `afb-value-${Q}`,
                  "model-value": T(M),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (q) => y(M, q)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"])) : w("", !0)
              ], 2),
              U(Be, {
                "data-testid": `afb-remove-${Q}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (q) => _(M._id)
              }, null, 8, ["data-testid", "aria-label", "onClick"])
            ], 64))
          ]),
          !A(M) && z(M) ? (u(), b("p", {
            key: 0,
            "data-testid": `afb-error-${Q}`,
            class: "ml-[112px] -mt-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
            role: "status"
          }, H(z(M)), 9, uU)) : w("", !0)
        ], 64))), 128)),
        x("div", cU, [
          N[0] || (N[0] = x("div", {
            class: "w-[100px] shrink-0",
            "aria-hidden": "true"
          }, null, -1)),
          x("div", fU, [
            U(pa, {
              "data-testid": "afb-add-criterion",
              "icon-left": "ri-add-line",
              size: "l",
              onClick: B
            }, {
              default: me(() => [
                st(H(e.labels.addCriterion), 1)
              ]),
              _: 1
            }),
            le.value ? (u(), P(pa, {
              key: 0,
              "data-testid": "afb-add-group",
              "icon-left": "ri-add-line",
              size: "l",
              onClick: W
            }, {
              default: me(() => [
                st(H(e.labels.addGroup), 1)
              ]),
              _: 1
            })) : w("", !0)
          ])
        ])
      ], 10, aU);
    };
  }
}), bU = /* @__PURE__ */ Ct(hU, [["__scopeId", "data-v-4dadbb9e"]]), gU = {
  "data-testid": "afb-body",
  class: "flex flex-col gap-6"
}, a0 = /* @__PURE__ */ ke({
  __name: "AdvancedFilterBody",
  props: {
    builder: {},
    fields: {},
    labels: {},
    maxDepth: { default: 2 },
    fieldGroups: {},
    showInfoAlert: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (a, t) => (u(), b(ie, null, [
      e.builder.hasErrors.value ? (u(), P(yo, {
        key: 0,
        "data-testid": "afb-error-alert",
        color: "danger",
        surface: "card",
        layout: "inline",
        heading: e.labels.errorAlert
      }, null, 8, ["heading"])) : w("", !0),
      e.showInfoAlert ? (u(), P(yo, {
        key: 1,
        color: "info",
        surface: "card",
        layout: "inline",
        heading: e.labels.alert
      }, null, 8, ["heading"])) : w("", !0),
      x("div", gU, [
        U(bU, {
          group: e.builder.root.value,
          fields: e.fields,
          labels: e.labels,
          "max-depth": e.maxDepth,
          builder: e.builder,
          depth: 1,
          "field-groups": e.fieldGroups
        }, null, 8, ["group", "fields", "labels", "max-depth", "builder", "field-groups"])
      ])
    ], 64));
  }
}), mU = {
  "data-testid": "afb-footer-actions",
  class: "ms-auto flex flex-wrap items-center justify-end gap-4"
}, n0 = /* @__PURE__ */ ke({
  __name: "AdvancedFilterFooter",
  props: {
    labels: {},
    busy: { type: Boolean, default: !1 },
    showCancel: { type: Boolean, default: !0 },
    showSave: { type: Boolean, default: !1 },
    canSave: { type: Boolean },
    saveDisabledReason: {}
  },
  emits: ["reset", "cancel", "save", "apply"],
  setup(e, { emit: a }) {
    const t = a;
    return (n, l) => (u(), b(ie, null, [
      U(Be, {
        "data-testid": "afb-reset",
        variant: "secondary",
        size: "md",
        label: e.labels.reset,
        disabled: e.busy,
        "icon-left": "ri-refresh-line",
        onClick: l[0] || (l[0] = (o) => t("reset"))
      }, null, 8, ["label", "disabled"]),
      x("div", mU, [
        e.showCancel ? (u(), P(Be, {
          key: 0,
          "data-testid": "afb-cancel",
          variant: "secondary",
          size: "md",
          label: e.labels.cancel,
          disabled: e.busy,
          onClick: l[1] || (l[1] = (o) => t("cancel"))
        }, null, 8, ["label", "disabled"])) : w("", !0),
        e.showSave ? (u(), P($t, {
          key: 1,
          text: e.saveDisabledReason ?? "",
          disabled: e.saveDisabledReason === null,
          tabindex: e.saveDisabledReason ? 0 : void 0,
          "data-testid": "afb-save-tooltip",
          position: "top"
        }, {
          default: me(() => [
            U(Be, {
              "data-testid": "afb-save",
              variant: "secondary",
              size: "md",
              label: e.labels.save,
              disabled: !e.canSave,
              "icon-left": "ri-save-3-fill",
              onClick: l[2] || (l[2] = (o) => t("save"))
            }, null, 8, ["label", "disabled"])
          ]),
          _: 1
        }, 8, ["text", "disabled", "tabindex"])) : w("", !0),
        U(Be, {
          "data-testid": "afb-apply",
          variant: "primary",
          size: "md",
          label: e.labels.apply,
          disabled: e.busy,
          loading: e.busy,
          "icon-left": "ri-check-fill",
          onClick: l[3] || (l[3] = (o) => t("apply"))
        }, null, 8, ["label", "disabled", "loading"])
      ])
    ], 64));
  }
}), hK = /* @__PURE__ */ ke({
  __name: "AdvancedFilterBuilder",
  props: {
    modelValue: {},
    fields: {},
    fieldGroups: { default: void 0 },
    maxDepth: { default: 2 },
    busy: { type: Boolean, default: !1 },
    labels: {},
    showSave: { type: Boolean, default: !1 },
    showCancel: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "apply", "reset", "cancel", "close", "save"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = _x({
      modelValue: () => t.modelValue,
      fields: () => t.fields,
      busy: () => t.busy,
      labels: () => t.labels,
      emitUpdate: (s) => n("update:modelValue", s),
      emitApply: (s) => n("apply", s),
      emitReset: () => n("reset"),
      emitSave: (s) => n("save", s)
    }), o = R(!0);
    function r() {
      t.busy || n("cancel");
    }
    function i() {
      o.value = !1, n("close");
    }
    return (s, d) => (u(), P(dl, {
      modelValue: o.value,
      "onUpdate:modelValue": d[0] || (d[0] = (c) => o.value = c),
      size: "lg",
      "footer-position": "split",
      title: e.labels.title,
      icon: "ri-shuffle-line",
      "header-align": "middle-stacked",
      "show-header-border": !1,
      onClose: i
    }, {
      footer: me(() => [
        U(n0, {
          labels: e.labels,
          busy: e.busy,
          "show-cancel": e.showCancel,
          "show-save": e.showSave,
          "can-save": L(l).canSave.value,
          "save-disabled-reason": L(l).saveDisabledReason.value,
          onReset: L(l).onReset,
          onCancel: r,
          onSave: L(l).onSave,
          onApply: L(l).onApply
        }, null, 8, ["labels", "busy", "show-cancel", "show-save", "can-save", "save-disabled-reason", "onReset", "onSave", "onApply"])
      ]),
      default: me(() => [
        U(a0, {
          builder: L(l).builder,
          fields: e.fields,
          labels: e.labels,
          "max-depth": e.maxDepth,
          "field-groups": e.fieldGroups,
          "show-info-alert": ""
        }, null, 8, ["builder", "fields", "labels", "max-depth", "field-groups"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]));
  }
}), vU = ["aria-labelledby"], pU = {
  "data-testid": "afp-header",
  class: "flex min-w-0 shrink-0 items-center justify-between gap-2 max-sm:flex-wrap"
}, xU = ["aria-labelledby"], yU = {
  "data-testid": "afp-scroll",
  class: "flex min-h-0 min-w-0 flex-1 flex-col gap-4 overflow-y-auto px-6 py-5"
}, kU = {
  "data-testid": "afp-footer",
  class: "flex min-w-0 shrink-0 flex-wrap items-center justify-between gap-3 px-6"
}, bK = /* @__PURE__ */ ke({
  __name: "AdvancedFilterPopover",
  props: {
    open: { type: Boolean },
    anchorEl: {},
    modelValue: {},
    fields: {},
    fieldGroups: { default: void 0 },
    maxDepth: { default: 2 },
    busy: { type: Boolean, default: !1 },
    showSave: { type: Boolean, default: !1 },
    labels: {}
  },
  emits: ["update:open", "update:modelValue", "apply", "reset", "save", "view-all"],
  setup(e, { expose: a, emit: t }) {
    const n = e, l = t, o = _x({
      modelValue: () => n.modelValue,
      fields: () => n.fields,
      busy: () => n.busy,
      labels: () => n.labels,
      emitUpdate: (D) => l("update:modelValue", D),
      emitApply: (D) => l("apply", D),
      emitReset: () => l("reset"),
      emitSave: (D) => l("save", D)
    }), r = Ye(), i = R(null);
    Is({
      active: Ua(n, "open"),
      container: i,
      containFocus: !0,
      // AC 10 — restore focus to the STABLE "Filtrer" trigger, not whatever had focus when the
      // panel opened: the opening click can come from a transient, self-closing control (e.g.
      // TableFilterSelector's own step-1 "Créer un filtre avancé"/"Voir tous les filtres
      // avancés" items — TableFilterSelector.vue's handleCreateAdvanced/handleViewAdvanced emit
      // then immediately closeDropdown(), unmounting the very button that was just clicked).
      // useFocusTrap's default previousActive-based restore captures that transient node's live
      // reference at open time, but by close time it's detached from the document — `.focus()`
      // on a detached node is a silent no-op, so focus fell back to `<body>`. `anchorEl` is
      // already the stable anchor this popover receives for positioning; reusing it here covers
      // both the direct-anchorEl-click case and the transient-control case identically.
      restoreFocusTo: () => n.anchorEl
    });
    const s = [
      e0,
      '[data-testid="dropdown-menu"]',
      '[data-testid="datepicker-dropdown-menu"]',
      '[data-testid="autocomplete-panel"]',
      '[role="tooltip"]',
      '[role="dialog"]',
      '[data-testid="modal-backdrop"]'
    ], d = 996, c = 588, f = 8, g = 4, h = R({});
    function v() {
      var K;
      const D = (K = n.anchorEl) == null ? void 0 : K.getBoundingClientRect();
      if (!D) return;
      const O = window.innerWidth, N = window.innerHeight, V = Math.min(d, O - 2 * f), M = D.bottom + g, Q = Math.min(
        Math.max(f, D.left),
        Math.max(f, O - V - f)
      ), q = Math.min(c, N - M - f);
      h.value = {
        position: "fixed",
        top: `${M}px`,
        left: `${Q}px`,
        width: `${V}px`,
        maxHeight: `${q}px`,
        // Page-level only: stays under the elevated save modal (z-300) that opens over it.
        zIndex: "50"
      };
    }
    function p() {
      window.addEventListener("scroll", v, !0), window.addEventListener("resize", v);
    }
    function y() {
      window.removeEventListener("scroll", v, !0), window.removeEventListener("resize", v);
    }
    let k = n.modelValue;
    $e(
      () => n.open,
      (D) => {
        if (D) {
          const O = n.modelValue !== k, N = o.builder.isDirty.value;
          (O || N) && (o.reseedFrom(n.modelValue), k = n.modelValue), Ze(() => {
            v(), p();
          });
        } else
          y();
      },
      { immediate: !0 }
    );
    const $ = Symbol("advanced-filter-popover");
    $e(
      () => n.open,
      (D) => {
        D ? xn($) : _a($);
      },
      { immediate: !0 }
    ), Tt(() => {
      y(), _a($);
    });
    const S = R(!1), I = R(null);
    let T = !1;
    function A() {
      if (!o.builder.isDirty.value) {
        W();
        return;
      }
      S.value = !0;
    }
    function E() {
      I.value = () => l("view-all"), A();
    }
    function z(D) {
      I.value = D, A();
    }
    function B() {
      Ze(() => {
        var D;
        return (D = n.anchorEl) == null ? void 0 : D.focus();
      });
    }
    function W() {
      if (S.value = !1, o.builder.reset(), l("update:open", !1), I.value) {
        T = !0;
        const D = I.value;
        I.value = null, D();
      } else
        B();
    }
    function _() {
      S.value = !1, I.value = null;
    }
    function Z() {
      if (o.builder.reset(), T) {
        T = !1;
        return;
      }
      B();
    }
    a({ requestCloseThen: z, discard: Z });
    function le(D) {
      n.open && On($) && (D.defaultPrevented || (D.stopPropagation(), D.preventDefault(), A()));
    }
    return Ds(i, A, {
      isActive: () => n.open,
      ignoreSelectors: s
    }), (D, O) => (u(), P(Fa, { to: "body" }, [
      e.open ? (u(), b("div", {
        key: 0,
        ref_key: "panelRef",
        ref: i,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": L(r),
        "data-testid": "afp-panel",
        style: Ge(h.value),
        class: "flex flex-col gap-2 rounded-(--border-border-radius-rounded-l) bg-(--background-background-white) px-3 py-4 shadow-(--blur-shadow-m) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
        onKeydown: St(le, ["escape"])
      }, [
        x("div", pU, [
          x("h2", {
            "data-testid": "afp-title",
            class: "flex min-w-0",
            "aria-labelledby": L(r)
          }, [
            U(br, {
              id: L(r),
              type: "h5",
              "icon-left": "ri-shuffle-line",
              label: e.labels.title,
              "info-right": e.labels.titleInfo,
              "data-testid": "afp-heading"
            }, null, 8, ["id", "label", "info-right"])
          ], 8, xU),
          U(pa, {
            "data-testid": "afp-view-all",
            size: "l",
            class: "max-w-full shrink-0 text-left",
            onClick: E
          }, {
            default: me(() => [
              st(H(e.labels.viewAllFilters), 1)
            ]),
            _: 1
          })
        ]),
        x("div", yU, [
          U(a0, {
            builder: L(o).builder,
            fields: e.fields,
            labels: e.labels,
            "max-depth": e.maxDepth,
            "field-groups": e.fieldGroups,
            "show-info-alert": !1
          }, null, 8, ["builder", "fields", "labels", "max-depth", "field-groups"])
        ]),
        x("div", kU, [
          U(n0, {
            labels: e.labels,
            busy: e.busy,
            "show-cancel": !1,
            "show-save": e.showSave,
            "can-save": L(o).canSave.value,
            "save-disabled-reason": L(o).saveDisabledReason.value,
            onReset: L(o).onReset,
            onSave: L(o).onSave,
            onApply: L(o).onApply
          }, null, 8, ["labels", "busy", "show-save", "can-save", "save-disabled-reason", "onReset", "onSave", "onApply"])
        ]),
        S.value ? (u(), P(PV, {
          key: 0,
          "model-value": S.value,
          title: e.labels.confirmCloseTitle,
          message: e.labels.confirmCloseMessage,
          "stay-label": e.labels.confirmCloseStay,
          "leave-label": e.labels.confirmCloseLeave,
          "onUpdate:modelValue": O[0] || (O[0] = (N) => S.value = N),
          onStay: _,
          onLeave: W
        }, null, 8, ["model-value", "title", "message", "stay-label", "leave-label"])) : w("", !0)
      ], 44, vU)) : w("", !0)
    ]));
  }
}), wU = {
  key: 0,
  "data-testid": "banner",
  class: "@container/banner w-full min-w-0"
}, CU = {
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "sr-only",
  "data-testid": "banner-live"
}, SU = {
  key: 0,
  "data-testid": "banner-content",
  class: "flex min-w-0 flex-1 items-center justify-center gap-2.5"
}, $U = {
  key: 0,
  "data-testid": "banner-text",
  class: "min-w-0 wrap-break-word text-center text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, IU = {
  key: 1,
  "data-testid": "banner-content",
  class: "flex min-w-0 flex-1 flex-col gap-4 @5xl/banner:flex-row @5xl/banner:items-center @5xl/banner:justify-between @5xl/banner:gap-0"
}, LU = {
  key: 0,
  "data-testid": "banner-text-group",
  class: "flex min-w-0 flex-1 flex-col gap-1"
}, TU = {
  key: 1,
  "data-testid": "banner-description",
  class: "wrap-break-word text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-body) dark:text-(--text-text-white-secondary)"
}, EU = {
  key: 1,
  "data-testid": "banner-text-group",
  class: "flex min-w-0 flex-1 items-center gap-4"
}, AU = {
  key: 0,
  "data-testid": "banner-logo",
  class: "flex shrink-0 items-center"
}, RU = {
  "data-testid": "banner-text",
  class: "min-w-0 wrap-break-word text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-regular) text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, zU = 150, DU = 5e3, gK = /* @__PURE__ */ ke({
  __name: "Banner",
  props: {
    type: { default: "default" },
    text: { default: void 0 },
    heading: { default: void 0 },
    description: { default: void 0 },
    headingLevel: { default: 2 },
    icon: { default: "ri-notification-4-line" },
    link: { default: void 0 },
    primaryAction: { default: void 0 },
    secondaryAction: { default: void 0 },
    closeLabel: {}
  },
  emits: ["close", "link", "primary", "secondary"],
  setup(e, { emit: a }) {
    const t = e, n = a, l = R(!1), o = R("");
    let r;
    const i = m(
      () => (t.type === "heading" ? [t.heading, t.description] : [t.text]).filter(Boolean).join(" ")
    );
    function s() {
      clearTimeout(r), o.value = "", r = setTimeout(() => {
        o.value = i.value, r = setTimeout(() => o.value = "", DU);
      }, zU);
    }
    kt(s), $e(i, () => Ze(s)), Tt(() => clearTimeout(r));
    const d = m(() => [
      "flex w-full min-w-0 p-4 bg-(--background-background-white) rounded-(--border-border-radius-rounded-l) dark:bg-(--background-background-black-default)",
      t.type === "logo" ? "items-start border border-(--border-border-base-soft) shadow-(--blur-shadow-s) dark:border-(--border-border-base) dark:shadow-(--blur-shadow-m-dark) @5xl/banner:items-center @5xl/banner:justify-between" : "border-b border-(--border-border-base-soft) dark:border-(--border-border-base)",
      t.type === "heading" ? "items-start @5xl/banner:items-center" : "",
      t.type === "default" ? "items-center" : ""
    ]);
    function c() {
      n("close"), l.value = !0;
    }
    return (f, g) => l.value ? w("", !0) : (u(), b("div", wU, [
      x("div", CU, H(o.value), 1),
      x("div", {
        "data-testid": "banner-surface",
        class: C(d.value)
      }, [
        e.type === "default" ? (u(), b("div", SU, [
          U(aa, {
            icon: e.icon,
            color: "gradient",
            size: "sm",
            type: "circle",
            variant: "filled",
            class: "shrink-0"
          }, null, 8, ["icon"]),
          e.text ? (u(), b("p", $U, H(e.text), 1)) : w("", !0),
          e.link ? (u(), P(pa, {
            key: 1,
            "data-testid": "banner-link",
            as: e.link.href ? "a" : "button",
            href: e.link.href,
            "aria-label": e.link.ariaLabel,
            size: "s",
            "icon-right": "ri-arrow-right-line",
            class: "shrink-0",
            onClick: g[0] || (g[0] = (h) => e.link.href || n("link"))
          }, {
            default: me(() => [
              st(H(e.link.label), 1)
            ]),
            _: 1
          }, 8, ["as", "href", "aria-label"])) : w("", !0)
        ])) : (u(), b("div", IU, [
          e.type === "heading" ? (u(), b("div", LU, [
            e.heading ? (u(), P(gt(`h${e.headingLevel}`), {
              key: 0,
              "data-testid": "banner-heading",
              class: "wrap-break-word text-(length:--size-xl) leading-(--line-height-xl) font-(--weight-semi-bold) text-(--text-text-heading) dark:text-(--text-text-white-default)"
            }, {
              default: me(() => [
                st(H(e.heading), 1)
              ]),
              _: 1
            })) : w("", !0),
            e.description ? (u(), b("p", TU, H(e.description), 1)) : w("", !0)
          ])) : (u(), b("div", EU, [
            f.$slots.logo ? (u(), b("div", AU, [
              Me(f.$slots, "logo")
            ])) : w("", !0),
            e.text ? (u(), b("div", {
              key: 1,
              "data-testid": "banner-text-frame",
              class: C(["flex min-w-0 flex-1 items-center", f.$slots.logo ? "border-l border-(--border-border-base-soft) pl-[calc(--spacing(4)-1px)] dark:border-(--border-border-base)" : ""])
            }, [
              x("p", RU, H(e.text), 1)
            ], 2)) : w("", !0)
          ])),
          e.secondaryAction || e.primaryAction ? (u(), b("div", {
            key: 2,
            "data-testid": "banner-actions",
            class: C(["flex shrink-0 flex-wrap items-center gap-3", e.type === "logo" ? "justify-end" : ""])
          }, [
            e.type === "heading" && e.secondaryAction ? (u(), P(Be, {
              key: 0,
              "data-testid": "banner-secondary",
              variant: "secondary",
              size: "xs",
              "icon-left": "ri-arrow-left-line",
              label: e.secondaryAction.label,
              onClick: g[1] || (g[1] = (h) => n("secondary"))
            }, null, 8, ["label"])) : w("", !0),
            e.primaryAction ? (u(), P(Be, {
              key: 1,
              "data-testid": "banner-primary",
              variant: "primary",
              size: "xs",
              "icon-right": e.type === "heading" ? "ri-arrow-right-line" : void 0,
              label: e.primaryAction.label,
              onClick: g[2] || (g[2] = (h) => n("primary"))
            }, null, 8, ["icon-right", "label"])) : w("", !0)
          ], 2)) : w("", !0)
        ])),
        U(Be, {
          "data-testid": "banner-close",
          variant: "tertiary",
          size: "xs",
          "icon-only": "",
          "icon-left": "ri-close-fill",
          "aria-label": e.closeLabel,
          class: C(["shrink-0", e.type === "default" ? "" : "@5xl/banner:ml-3"]),
          onClick: c
        }, null, 8, ["aria-label", "class"])
      ], 2)
    ]));
  }
}), mK = {
  "Background-background-black-default": "{Colors.Primary.800-base}",
  "Background-background-white": "{white}",
  "Background-background-white-secondary": "{Colors.Neutral.100}",
  "Background-background-white-secondary-soft": "{Colors.Neutral.050}",
  "Background-background-white-tertiary": "{Colors.Gray.100}",
  "Background-background-selected": "{Colors.Gray.050}",
  "Background-background-info": "{Colors.Violet.50}",
  "Background-background-success": "{Colors.Success.50}",
  "Background-background-warning": "{Colors.Warning.50}",
  "Background-background-error": "{Colors.Error.50}",
  "Background-background-hover": "{Colors.Indigo.50}",
  "Background-background-accent": "{Colors.Violet.50}",
  "Background-background-accent-strong": "{Colors.Indigo.600}",
  "Background-background-disabled": "{Colors.Gray.100}",
  "Background-background-disabled-strong": "{Colors.Gray.300}",
  "Background-background-disabled-opacity": "{Colors.Gray.200-opacity-medium}",
  "Background-background-disabled-subtle": "{Colors.Gray.050}",
  "Background-background-gray": "{Colors.Gray.200}",
  "Background-background-ia": "{Colors.Purple.50}",
  "Text-text-white-default": "{Colors.Neutral.050}",
  "Text-text-white-secondary": "{Colors.Neutral.100}",
  "Text-text-black-default": "{Colors.Primary.800-base}",
  "Text-text-brand-bold": "{Colors.Primary.800-opacity-bold}",
  "Text-text-heading": "{Colors.Primary.800-base}",
  "Text-text-body": "{Colors.Gray.700}",
  "Text-text-body-subtle": "{Colors.Gray.500}",
  "Text-text-disabled-strong": "{Colors.Gray.500}",
  "Text-text-disabled-light": "{Colors.Gray.400}",
  "Text-text-success-strong": "{Colors.Success.700}",
  "Text-text-success": "{Colors.Success.600}",
  "Text-text-success-subtle": "{Colors.Success.500}",
  "Text-text-warning": "{Colors.Warning.600}",
  "Text-Text-error": "{Colors.Error.600}",
  "Text-Text-error-strong": "{Colors.Error.700}",
  "Text-Text-error-subtle": "{Colors.Error.500}",
  "Text-Text-link": "{Colors.Violet.500}",
  "Text-Text-hover": "{Colors.Violet.800}",
  "Text-Text-info": "{Colors.Indigo.700}",
  "Text-Text-accent": "{Colors.Indigo.500}",
  "Icons-icon-black": "{black}",
  "Icons-icon-white": "{white}",
  "Icons-icon-dark-default": "{Colors.Primary.800-base}",
  "Icons-icon-white-default": "{Colors.Neutral.100}",
  "Icons-icon-disabled-strong": "{Colors.Gray.500}",
  "Icons-icon-disabled-light": "{Colors.Gray.400}",
  "Icons-icon-base": "{Colors.Gray.500}",
  "Icons-icon-base-strong": "{Colors.Gray.700}",
  "Icons-icon-link": "{Colors.Violet.500}",
  "Icons-icon-success": "{Colors.Success.500}",
  "Icons-icon-success-subtle": "{Colors.Success.400}",
  "Icons-icon-warning": "{Colors.Warning.600}",
  "Icons-icon-error": "{Colors.Error.700}",
  "Icons-icon-info": "{Colors.Indigo.700}",
  "Icons-icon-hover": "{Colors.Violet.800}",
  "Icons-icon-accent": "{Colors.Indigo.500}",
  "Icons-icon-accent-strong": "{Colors.Indigo.600}",
  "Icons-icon-ia": "{Colors.Purple.600}",
  "Icons-icon-cyan": "{Colors.Cyan.500}",
  "Icons-icon-color-default": "{Colors.Cyan.600}",
  "Components-Button-button-disabled": "{Colors.Gray.200-opacity-bold}",
  "Components-Button-Primary-button-primary": "{Colors.Primary.800-base}",
  "Components-Button-Primary-button-primary-hover": "{Colors.Gray.500}",
  "Components-Button-Secondary-button-secondary": "{white}",
  "Components-Button-Secondary-button-secondary-hover": "{Colors.Primary.800-opacity-bold}",
  "Components-Button-Secondary-button-secondary-focused": "{Colors.Indigo.400}",
  "Components-Button-Tertiary-button-tertiary-hover": "{Colors.Indigo.50}",
  "Components-Button-Tertiary-button-tertiary-focused": "{Colors.Indigo.50}",
  "Components-Button-Tab-button-tab-default": "{Colors.Gray.100}",
  "Components-Button-Tab-button-tab": "{white}",
  "Components-Button-Tab-button-tab-hover": "{Colors.Indigo.400}",
  "Components-Button-Tab-button-tab-active": "{white}",
  "Components-Button-Text-button-text": "{Colors.Primary.800-base}",
  "Components-Button-Text-button-text-hover": "{Colors.Indigo.700}",
  "Components-Button-Ghost-button-ghost-hover": "{Colors.Indigo.50}",
  "Components-Button-Functional-Success-button-success": "{Colors.Success.700}",
  "Components-Button-Functional-Success-button-success-hover": "{Colors.Success.800}",
  "Components-Button-Functional-Success-button-success-focused": "{Colors.Success.800}",
  "Components-Button-Functional-Desctructive error-Background-button-error": "{Colors.Error.600}",
  "Components-Button-Functional-Desctructive error-Background-button-error-hover": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Background-button-error-focused": "{Colors.Error.900}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-icon": "{Colors.Error.600}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-hover-icon": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-focused-icon": "{Colors.Error.900}",
  "Components-Badge-Background-badge-disabled-bg": "{Colors.Gray.300}",
  "Components-Badge-Background-badge-gray-bg": "{Colors.Gray.500}",
  "Components-Badge-Background-badge-error-bg": "{Colors.Error.200}",
  "Components-Badge-Background-badge-error-strong-bg": "{Colors.Error.500}",
  "Components-Badge-Background-badge-orange-bg": "{Colors.Warning.100}",
  "Components-Badge-Background-badge-orange-strong-bg": "{Colors.Warning.500}",
  "Components-Badge-Background-badge-yellow-bg": "{Colors.Yellow.100}",
  "Components-Badge-Background-badge-yellow-strong-bg": "{Colors.Yellow.300}",
  "Components-Badge-Background-badge-green-bg": "{Colors.Success.100}",
  "Components-Badge-Background-badge-green-strong-bg": "{Colors.Success.500}",
  "Components-Badge-Background-badge-indigo-soft-bg": "{Colors.Indigo.100}",
  "Components-Badge-Background-badge-indigo-medium-bg": "{Colors.Indigo.300}",
  "Components-Badge-Background-badge-indigo-strong-bg": "{Colors.Indigo.500}",
  "Components-Badge-Background-badge-accent-bg": "{Colors.Indigo.80-opacity}",
  "Components-Badge-Background-badge-violet-bg": "{Colors.Violet.200}",
  "Components-Badge-Background-badge-violet-strong-bg": "{Colors.Violet.400}",
  "Components-Badge-Background-badge-purple-bg": "{Colors.Purple.100}",
  "Components-Badge-Background-badge-purple-strong-bg": "{Colors.Purple.400}",
  "Components-Badge-Background-badge-neutral-bg": "{Colors.Neutral.200}",
  "Components-Badge-Background-badge-neutral-strong-bg": "{Colors.Neutral.400}",
  "Components-Badge-Background-badge-cyan-bg": "{Colors.Cyan.100}",
  "Components-Badge-Background-badge-cyan-strong-bg": "{Colors.Cyan.400}",
  "Components-Badge-Background-badge-white-bg": "{white}",
  "Components-Badge-Background-badge-dark-bg": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-disabled-icon": "{Colors.Gray.500}",
  "Components-Badge-Icon-badge-black-icon": "{black}",
  "Components-Badge-Icon-badge-white-icon": "{white}",
  "Components-Badge-Icon-badge-white-default-icon": "{Colors.Neutral.100}",
  "Components-Badge-Icon-badge-dark-icon": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-black-default-icon": "{Colors.Primary.800-base}",
  "Components-Badge-Text-badge-disabled-strong-text": "{Colors.Gray.500}",
  "Components-Badge-Text-badge-white-text": "{white}",
  "Components-Badge-Text-badge-white-default-text": "{Colors.Neutral.050}",
  "Components-Badge-Text-badge-black-text": "{black}",
  "Components-Badge-Text-badge-black-default-text": "{Colors.Primary.800-base}",
  "Components-Badge-Text-badge-body-text": "{Colors.Gray.700}",
  "Components-Badge-Border-badge-disabled-border": "{Colors.Gray.300}",
  "Components-Badge-Border-badge-white-border": "{white}",
  "Components-Badge-Border-badge-white-default-border": "{Colors.Neutral.400}",
  "Components-Badge-Border-badge-base-soft-border": "{Colors.Gray.200}",
  "Components-Badge-Border-badge-black-border": "{black}",
  "Components-Badge-Border-badge-dark-default-border": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Background-iconshape-red-bg": "{Colors.Error.100}",
  "Components-Icon shape-Background-iconshape-orange-bg": "{Colors.Warning.100}",
  "Components-Icon shape-Background-iconshape-yellow-bg": "{Colors.Yellow.100}",
  "Components-Icon shape-Background-iconshape-green-bg": "{Colors.Success.100}",
  "Components-Icon shape-Background-iconshape-indigo-bg": "{Colors.Indigo.100}",
  "Components-Icon shape-Background-iconshape-violet-bg": "{Colors.Violet.200}",
  "Components-Icon shape-Background-iconshape-purple-bg": "{Colors.Purple.100}",
  "Components-Icon shape-Background-iconshape-neutral-bg": "{Colors.Neutral.200}",
  "Components-Icon shape-Background-iconshape-cyan-bg": "{Colors.Cyan.100}",
  "Components-Icon shape-Background-iconshape-black-bg": "{black}",
  "Components-Icon shape-Background-iconshape-black-default-bg": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-white-bg": "{white}",
  "Components-Icon shape-Background-iconshape-success-bg": "{Colors.Success.600}",
  "Components-Icon shape-Background-iconshape-error-bg": "{Colors.Error.500}",
  "Components-Icon shape-Background-iconshape-accent-bg": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-black-icon": "{black}",
  "Components-Icon shape-Icon-iconshape-white-icon": "{white}",
  "Components-Icon shape-Icon-iconshape-white-default-icon": "{Colors.Neutral.100}",
  "Components-Icon shape-Icon-iconshape-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-disabled-strong-icon": "{Colors.Gray.500}",
  "Components-Icon shape-Icon-iconshape-success-icon": "{Colors.Success.600}",
  "Components-Icon shape-Icon-iconshape-red-icon": "{Colors.Error.700}",
  "Components-Icon shape-Icon-iconshape-error-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-brand-icon": "{Colors.Primary.800-base}",
  "Components-Icon shape-Icon-iconshape-accent-gradient-icon": "{Colors.Primary.800-opacity-bold}",
  "Components-Icon shape-Icon-iconshape-orange-icon": "{Colors.Warning.600}",
  "Components-Icon shape-Icon-iconshape-yellow-icon": "{Colors.Yellow.600}",
  "Components-Icon shape-Icon-iconshape-green-icon": "{Colors.Success.500}",
  "Components-Icon shape-Icon-iconshape-indigo-icon": "{Colors.Indigo.400}",
  "Components-Icon shape-Icon-iconshape-violet-icon": "{Colors.Violet.700}",
  "Components-Icon shape-Icon-iconshape-purple-icon": "{Colors.Purple.700}",
  "Components-Icon shape-Icon-iconshape-neutral-icon": "{Colors.Neutral.200}",
  "Components-Icon shape-Icon-iconshape-default-icon": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-disabled-border": "{Colors.Gray.300}",
  "Components-Icon shape-Border-iconshape-default-border": "{Colors.Neutral.200}",
  "Components-Icon shape-Border-iconshape-accent-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-error-border": "{Colors.Error.600}",
  "Components-Icon shape-Border-iconshape-success-border": "{Colors.Success.500}",
  "Components-Icon shape-Text-iconshape-disabled-text": "{Colors.Gray.500}",
  "Components-Icon shape-Text-iconshape-black-default-text": "{Colors.Primary.800-base}",
  "Components-Icon shape-Text-iconshape-default-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-accent-gradient-text": "{Colors.Primary.800-opacity-bold}",
  "Components-Icon shape-Text-iconshape-error-text": "{Colors.Error.600}",
  "Components-Icon shape-Text-iconshape-success-text": "{Colors.Success.500}",
  "Components-Icon shape-Text-iconshape-white-default-text": "{Colors.Neutral.050}",
  "Components-Toggle-Background-toggle-active": "{Colors.Indigo.400}",
  "Components-Toggle-Background-toggle-unactive": "{Colors.Neutral.050}",
  "Components-Toggle-Background-toggle-disabled": "{Colors.Gray.300}",
  "Components-Toggle-Background-toggle-active-switch": "{Background.background-white}",
  "Components-Toggle-Background-toggle-disabled-switch": "{Colors.Gray.500}",
  "Components-Toggle-Icon-toggle-icon": "{Colors.Indigo.400}",
  "Components-Toggle-Icon-toggle-icon-disabled": "{Colors.Gray.200}",
  "Components-Toggle-Border-toggle-active-border": "{Colors.Indigo.300}",
  "Components-Toggle-Border-toggle-unactive-border": "{Colors.Neutral.500}",
  "Components-Toggle-Border-toggle-disabled-border": "{Colors.Gray.400}",
  "Border-border-black-default": "{Colors.Primary.800-base}",
  "Border-border-white-default": "{Colors.Neutral.400}",
  "Border-border-base": "{Colors.Gray.500}",
  "Border-border-base-medium": "{Colors.Gray.300}",
  "Border-border-base-soft": "{Colors.Gray.200}",
  "Border-border-disabled": "{Colors.Gray.300}",
  "Border-border-disabled-subtle": "{Colors.Gray.200}",
  "Border-border-primary-button": "{Colors.Gray.500}",
  "Border-border-primary-button-hover": "{Colors.Indigo.100}",
  "Border-border-secondary-button": "{Colors.Neutral.400}",
  "Border-border-secondary-button-hover": "{Colors.Indigo.400}",
  "Border-border-secondary-button-focus": "{Colors.Cyan.500}",
  "Border-border-tertiary-hover": "{Colors.White opacity.50-opacity}",
  "Border-border-tab": "{white}",
  "Border-border-tab-hover": "{Colors.Indigo.400}",
  "Border-border-tab-hover 2": "{Colors.Indigo.400}",
  "Border-border-accent": "{Colors.Indigo.500}",
  "Border-border-accent-subtle": "{Colors.Indigo.200}",
  "Border-border-hover": "{Colors.Violet.800}",
  "Border-border-info": "{Colors.Indigo.500}",
  "Border-border-info-strong": "{Colors.Indigo.700}",
  "Border-border-info-subtle": "{Colors.Indigo.200}",
  "Border-border-success-strong": "{Colors.Success.700}",
  "Border-border-success": "{Colors.Success.500}",
  "Border-border-error-strong": "{Colors.Error.700}",
  "Border-border-error": "{Colors.Error.600}",
  "Border-border-error-subtle": "{Colors.Error.200}",
  "Border-border-warning": "{Colors.Warning.500}",
  "Border-border-warning-subtle": "{Colors.Warning.200}",
  "Border-border-ia": "{Colors.Purple.200}",
  "Border-border-accessibility": "{Colors.Neutral.400}",
  "Border-border-white-full": "{white}"
}, vK = {
  "Background-background-black-default": "{Colors.Primary.800-base}",
  "Background-background-white": "{white}",
  "Background-background-white-secondary": "{Colors.Neutral.100}",
  "Background-background-white-secondary-soft": "{Colors.Neutral.050}",
  "Background-background-white-tertiary": "{Colors.Gray.100}",
  "Background-background-selected": "{Colors.Gray.050}",
  "Background-background-info": "{Colors.Indigo.50}",
  "Background-background-success": "{Colors.Success.50}",
  "Background-background-warning": "{Colors.Warning.50}",
  "Background-background-error": "{Colors.Error.50}",
  "Background-background-hover": "{Colors.Indigo.50}",
  "Background-background-accent": "{Colors.Indigo.50}",
  "Background-background-accent-strong": "{Colors.Indigo.50}",
  "Background-background-disabled": "{Colors.Gray.100}",
  "Background-background-disabled-strong": "{Colors.Gray.400}",
  "Background-background-disabled-opacity": "{Colors.Gray.200-opacity-medium}",
  "Background-background-disabled-subtle": "{Colors.Gray.050}",
  "Background-background-gray": "{Colors.Gray.200}",
  "Background-background-ia": "{Colors.Purple.50}",
  "Text-text-white-default": "{Colors.Neutral.050}",
  "Text-text-white-secondary": "{Colors.Neutral.050}",
  "Text-text-black-default": "{Colors.Primary.800-base}",
  "Text-text-brand-bold": "{Colors.Gray.700}",
  "Text-text-heading": "{Colors.Primary.800-base}",
  "Text-text-body": "{Colors.Gray.700}",
  "Text-text-body-subtle": "{Colors.Gray.600}",
  "Text-text-disabled-strong": "{Colors.Gray.800}",
  "Text-text-disabled-light": "{Colors.Gray.300}",
  "Text-text-success-strong": "{Colors.Success.700}",
  "Text-text-success": "{Colors.Success.600}",
  "Text-text-success-subtle": "{Colors.Success.500}",
  "Text-text-warning": "{Colors.Warning.600}",
  "Text-Text-error": "{Colors.Error.600}",
  "Text-Text-error-strong": "{Colors.Error.700}",
  "Text-Text-error-subtle": "{Colors.Error.500}",
  "Text-Text-link": "{Colors.Indigo.400}",
  "Text-Text-hover": "{Colors.Indigo.300}",
  "Text-Text-info": "{Colors.Indigo.600}",
  "Text-Text-accent": "{Colors.Indigo.400}",
  "Icons-icon-black": "{Colors.Primary.800-base}",
  "Icons-icon-white": "{Colors.Primary.800-base}",
  "Icons-icon-dark-default": "{Colors.Primary.800-base}",
  "Icons-icon-white-default": "{Colors.Neutral.050}",
  "Icons-icon-disabled-strong": "{Colors.Gray.800}",
  "Icons-icon-disabled-light": "{Colors.Gray.300}",
  "Icons-icon-base": "{Colors.Gray.500}",
  "Icons-icon-base-strong": "{Colors.Gray.700}",
  "Icons-icon-link": "{Colors.Indigo.400}",
  "Icons-icon-success": "{Colors.Success.500}",
  "Icons-icon-success-subtle": "{Colors.Success.300}",
  "Icons-icon-warning": "{Colors.Warning.300}",
  "Icons-icon-error": "{Colors.Error.500}",
  "Icons-icon-info": "{Colors.Indigo.400}",
  "Icons-icon-hover": "{Colors.Indigo.300}",
  "Icons-icon-accent": "{Colors.Indigo.400}",
  "Icons-icon-accent-strong": "{Colors.Indigo.600}",
  "Icons-icon-ia": "{Colors.Purple.600}",
  "Icons-icon-cyan": "{Colors.Cyan.600}",
  "Icons-icon-color-default": "{Colors.Cyan.700}",
  "Components-Button-button-disabled": "{Colors.Gray.400}",
  "Components-Button-Primary-button-primary": "{Colors.Black opacity.50-opacity-bold}",
  "Components-Button-Primary-button-primary-hover": "{Colors.Gray.500}",
  "Components-Button-Secondary-button-secondary": "{Colors.Neutral.050}",
  "Components-Button-Secondary-button-secondary-hover": "{Colors.Primary.800-opacity-bold}",
  "Components-Button-Secondary-button-secondary-focused": "{Colors.Indigo.500}",
  "Components-Button-Tertiary-button-tertiary-hover": "{Colors.Indigo.400}",
  "Components-Button-Tertiary-button-tertiary-focused": "{Colors.Primary.800-base}",
  "Components-Button-Tab-button-tab-default": "{Colors.Gray.200-opacity-medium}",
  "Components-Button-Tab-button-tab": "{Colors.Neutral.050}",
  "Components-Button-Tab-button-tab-hover": "{Colors.Indigo.400}",
  "Components-Button-Tab-button-tab-active": "{Colors.Gray.050}",
  "Components-Button-Text-button-text": "{Colors.Primary.800-base}",
  "Components-Button-Text-button-text-hover": "{Colors.Indigo.700}",
  "Components-Button-Ghost-button-ghost-hover": "{Colors.Indigo.400}",
  "Components-Button-Functional-Success-button-success": "{Colors.Success.200}",
  "Components-Button-Functional-Success-button-success-hover": "{Colors.Success.500}",
  "Components-Button-Functional-Success-button-success-focused": "{Colors.Success.600}",
  "Components-Button-Functional-Desctructive error-Background-button-error": "{Colors.Error.400}",
  "Components-Button-Functional-Desctructive error-Background-button-error-hover": "{Colors.Error.300}",
  "Components-Button-Functional-Desctructive error-Background-button-error-focused": "{Colors.Error.400}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-icon": "{Colors.Error.500}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-hover-icon": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-focused-icon": "{Colors.Error.700}",
  "Components-Badge-Background-badge-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Background-badge-gray-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Background-badge-error-bg": "{Colors.Error.200}",
  "Components-Badge-Background-badge-error-strong-bg": "{Colors.Error.200}",
  "Components-Badge-Background-badge-orange-bg": "{Colors.Warning.100}",
  "Components-Badge-Background-badge-orange-strong-bg": "{Colors.Warning.100}",
  "Components-Badge-Background-badge-yellow-bg": "{Colors.Yellow.100}",
  "Components-Badge-Background-badge-yellow-strong-bg": "{Colors.Yellow.100}",
  "Components-Badge-Background-badge-green-bg": "{Colors.Success.100}",
  "Components-Badge-Background-badge-green-strong-bg": "{Colors.Success.100}",
  "Components-Badge-Background-badge-indigo-soft-bg": "{Colors.Indigo.100}",
  "Components-Badge-Background-badge-indigo-medium-bg": "{Colors.Indigo.100}",
  "Components-Badge-Background-badge-indigo-strong-bg": "{Colors.Indigo.600}",
  "Components-Badge-Background-badge-accent-bg": "{Colors.Indigo.80-opacity}",
  "Components-Badge-Background-badge-violet-bg": "{Colors.Violet.200}",
  "Components-Badge-Background-badge-violet-strong-bg": "{Colors.Violet.200}",
  "Components-Badge-Background-badge-purple-bg": "{Colors.Purple.100}",
  "Components-Badge-Background-badge-purple-strong-bg": "{Colors.Purple.100}",
  "Components-Badge-Background-badge-neutral-bg": "{Colors.Neutral.200}",
  "Components-Badge-Background-badge-neutral-strong-bg": "{Colors.Neutral.200}",
  "Components-Badge-Background-badge-cyan-bg": "{Colors.Cyan.100}",
  "Components-Badge-Background-badge-cyan-strong-bg": "{Colors.Cyan.100}",
  "Components-Badge-Background-badge-white-bg": "{white}",
  "Components-Badge-Background-badge-dark-bg": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Icon-badge-black-icon": "{black}",
  "Components-Badge-Icon-badge-white-icon": "{white}",
  "Components-Badge-Icon-badge-white-default-icon": "{Colors.Neutral.100}",
  "Components-Badge-Icon-badge-dark-icon": "{Colors.Neutral.700}",
  "Components-Badge-Icon-badge-black-default-icon": "{Colors.Primary.800-base}",
  "Components-Badge-Text-badge-disabled-strong-text": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Text-badge-white-text": "{white}",
  "Components-Badge-Text-badge-white-default-text": "{white}",
  "Components-Badge-Text-badge-black-text": "{Colors.Neutral.700}",
  "Components-Badge-Text-badge-black-default-text": "{Colors.Neutral.700}",
  "Components-Badge-Text-badge-body-text": "{Colors.Neutral.700}",
  "Components-Badge-Border-badge-disabled-border": "{Colors.Gray.200-opacity-medium}",
  "Components-Badge-Border-badge-white-border": "{white}",
  "Components-Badge-Border-badge-white-default-border": "{white}",
  "Components-Badge-Border-badge-base-soft-border": "{white}",
  "Components-Badge-Border-badge-black-border": "{Colors.Neutral.700}",
  "Components-Badge-Border-badge-dark-default-border": "{Colors.Neutral.700}",
  "Components-Icon shape-Background-iconshape-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Background-iconshape-red-bg": "{Colors.Error.100}",
  "Components-Icon shape-Background-iconshape-orange-bg": "{Colors.Warning.100}",
  "Components-Icon shape-Background-iconshape-yellow-bg": "{Colors.Yellow.100}",
  "Components-Icon shape-Background-iconshape-green-bg": "{Colors.Success.100}",
  "Components-Icon shape-Background-iconshape-indigo-bg": "{Colors.Indigo.100}",
  "Components-Icon shape-Background-iconshape-violet-bg": "{Colors.Violet.200}",
  "Components-Icon shape-Background-iconshape-purple-bg": "{Colors.Purple.100}",
  "Components-Icon shape-Background-iconshape-neutral-bg": "{Colors.Neutral.200}",
  "Components-Icon shape-Background-iconshape-cyan-bg": "{Colors.Cyan.100}",
  "Components-Icon shape-Background-iconshape-black-bg": "{black}",
  "Components-Icon shape-Background-iconshape-black-default-bg": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-white-bg": "{white}",
  "Components-Icon shape-Background-iconshape-success-bg": "{Colors.Success.600}",
  "Components-Icon shape-Background-iconshape-error-bg": "{Colors.Error.500}",
  "Components-Icon shape-Background-iconshape-accent-bg": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-black-icon": "{black}",
  "Components-Icon shape-Icon-iconshape-white-icon": "{white}",
  "Components-Icon shape-Icon-iconshape-white-default-icon": "{Colors.Neutral.100}",
  "Components-Icon shape-Icon-iconshape-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-disabled-strong-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-success-icon": "{Colors.Success.600}",
  "Components-Icon shape-Icon-iconshape-red-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-error-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-brand-icon": "{Colors.Primary.800-base}",
  "Components-Icon shape-Icon-iconshape-accent-gradient-icon": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-orange-icon": "{Colors.Warning.100}",
  "Components-Icon shape-Icon-iconshape-yellow-icon": "{Colors.Yellow.100}",
  "Components-Icon shape-Icon-iconshape-green-icon": "{Colors.Success.100}",
  "Components-Icon shape-Icon-iconshape-indigo-icon": "{Colors.Indigo.100}",
  "Components-Icon shape-Icon-iconshape-violet-icon": "{Colors.Violet.100}",
  "Components-Icon shape-Icon-iconshape-purple-icon": "{Colors.Purple.700}",
  "Components-Icon shape-Icon-iconshape-neutral-icon": "{Colors.Neutral.200}",
  "Components-Icon shape-Icon-iconshape-default-icon": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-disabled-border": "{Colors.Gray.300}",
  "Components-Icon shape-Border-iconshape-default-border": "{Colors.Gray.500}",
  "Components-Icon shape-Border-iconshape-accent-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-error-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Border-iconshape-success-border": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-disabled-text": "{Colors.Gray.300}",
  "Components-Icon shape-Text-iconshape-black-default-text": "{Colors.Gray.300}",
  "Components-Icon shape-Text-iconshape-default-text": "{Colors.Gray.300}",
  "Components-Icon shape-Text-iconshape-accent-gradient-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-error-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-success-text": "{Colors.Cyan.600}",
  "Components-Icon shape-Text-iconshape-white-default-text": "{Colors.Cyan.600}",
  "Components-Toggle-Background-toggle-active": "{Colors.Indigo.500}",
  "Components-Toggle-Background-toggle-unactive": "{Colors.Neutral.050}",
  "Components-Toggle-Background-toggle-disabled": "{Colors.Gray.300}",
  "Components-Toggle-Background-toggle-active-switch": "{Background.background-white}",
  "Components-Toggle-Background-toggle-disabled-switch": "{Colors.Gray.500}",
  "Components-Toggle-Icon-toggle-icon": "{Colors.Indigo.500}",
  "Components-Toggle-Icon-toggle-icon-disabled": "{Colors.Gray.200}",
  "Components-Toggle-Border-toggle-active-border": "{Colors.Indigo.400}",
  "Components-Toggle-Border-toggle-unactive-border": "{Colors.Neutral.500}",
  "Components-Toggle-Border-toggle-disabled-border": "{Colors.Gray.400}",
  "Border-border-black-default": "{Colors.Primary.800-base}",
  "Border-border-white-default": "{Colors.Neutral.400}",
  "Border-border-base": "{Colors.Gray.500}",
  "Border-border-base-medium": "{Colors.Gray.300}",
  "Border-border-base-soft": "{Colors.Gray.200}",
  "Border-border-disabled": "{Colors.Gray.200}",
  "Border-border-disabled-subtle": "{Colors.Gray.200}",
  "Border-border-primary-button": "{Colors.Gray.400}",
  "Border-border-primary-button-hover": "{Colors.Indigo.100}",
  "Border-border-secondary-button": "{Colors.Neutral.400}",
  "Border-border-secondary-button-hover": "{Colors.Indigo.400}",
  "Border-border-secondary-button-focus": "{Colors.Cyan.500}",
  "Border-border-tertiary-hover": "{Colors.White opacity.50-opacity-medium}",
  "Border-border-tab": "{white}",
  "Border-border-tab-hover": "{Colors.Indigo.400}",
  "Border-border-tab-hover 2": "{Colors.Indigo.300}",
  "Border-border-accent": "{Colors.Indigo.400}",
  "Border-border-accent-subtle": "{Colors.Indigo.200}",
  "Border-border-hover": "{Colors.Indigo.400}",
  "Border-border-info": "{Colors.Indigo.400}",
  "Border-border-info-strong": "{Colors.Indigo.700}",
  "Border-border-info-subtle": "{Colors.Indigo.200}",
  "Border-border-success-strong": "{Colors.Success.600}",
  "Border-border-success": "{Colors.Success.400}",
  "Border-border-error-strong": "{Colors.Error.700}",
  "Border-border-error": "{Colors.Error.500}",
  "Border-border-error-subtle": "{Colors.Error.300}",
  "Border-border-warning": "{Colors.Warning.500}",
  "Border-border-warning-subtle": "{Colors.Warning.200}",
  "Border-border-ia": "{Colors.Purple.200}",
  "Border-border-accessibility": "{Colors.Neutral.400}",
  "Border-border-white-full": "{white}"
}, pK = {
  "spacing-0": "{number.0}",
  "spacing-1": "{number.1}",
  "spacing-2": "{number.2}",
  "spacing-3": "{number.3}",
  "spacing-4": "{number.4}",
  "spacing-5": "{number.5}",
  "spacing-6": "{number.6}",
  "spacing-8": "{number.8}",
  "spacing-9": "{number.9}",
  "spacing-10": "{number.10}",
  "spacing-12": "{number.12}",
  "spacing-14": "{number.14}",
  "spacing-16": "{number.16}",
  "spacing-20": "{number.20}",
  "spacing-24": "{number.24}",
  "spacing-px": "{number.px}",
  "spacing-0.5": "{number.0.5}",
  "spacing-1.5": "{number.1.5}",
  "spacing-3.5": "{number.3.5}",
  "icon-size-xs": "{number.3.5}",
  "icon-size-sm": "{number.4}",
  "icon-size-md": "{number.5}",
  "icon-size-lg": "{number.6}",
  "border-border-radius-rounded-0": "{border.border-radius.rounded-0}",
  "border-border-radius-rounded-xxs": "{border.border-radius.rounded-xxs}",
  "border-border-radius-rounded-xs": "{border.border-radius.rounded-xs}",
  "border-border-radius-rounded-sm": "{border.border-radius.rounded-sm}",
  "border-border-radius-rounded-l": "{border.border-radius.rounded-l}",
  "border-border-radius-rounded-base": "{border.border-radius.rounded-base}",
  "border-border-radius-rounded-xl": "{border.border-radius.rounded-xl}",
  "border-border-radius-rounded-xxl": "{border.border-radius.rounded-xxl}",
  "border-border-radius-rounded-full": "{border.border-radius.rounded-full}",
  "border-border-width-border-0": "{border.border-width.border-0}",
  "border-border-width-border": "{border.border-width.border}",
  "border-border-width-border-sm": "{border.border-width.border-sm}",
  "border-border-width-border-base": "{border.border-width.border-2}",
  "border-border-width-border-md": "{border.border-width.border-3}",
  "border-border-width-border-lg": "{border.border-width.border-4}",
  "border-border-width-border-xl": "{border.border-width.border-8}"
}, xK = {
  "Family-heading": "inter",
  "Family-text": "inter",
  "Size-xs": 10,
  "Size-sm": 12,
  "Size-m": 14,
  "Size-l": 16,
  "Size-xl": 18,
  "Size-xxl": 20,
  "Size-3xl": 22,
  "Size-4xl": 24,
  "Size-5xl": 28,
  "Size-6xl": 36,
  "Size-7xl": 40,
  "Size-8xl": 48,
  "Size-9xl": 52,
  "Weight-thin": 100,
  "Weight-extra-light": 200,
  "Weight-light": 300,
  "Weight-regular": 400,
  "Weight-medium": 500,
  "Weight-semi-bold": 600,
  "Weight-bold": 700,
  "Weight-extra-bold": 800,
  "Weight-black": 900,
  "Line-height-xs": 12,
  "Line-height-s": 14,
  "Line-height-m": 18,
  "Line-height-l": 20,
  "Line-height-xl": 22,
  "Line-height-xxl": 24,
  "Line-height-3xl": 26,
  "Line-height-4xl": 29,
  "Line-height-5xl": 34,
  "Line-height-6xl": 43,
  "Letter-spacing-Letter-spacing": 0,
  "Letter-case-case-original": "none",
  "Letter-case-case-upper": "uppercase",
  "Letter-case-case-lower": "lowercase",
  "Letter-case-case-title": "capitalize",
  "Letter-case-case-smallcaps": "smallcaps"
}, yK = {
  "Grid-grid-columns-l": "{number.2}",
  "Grid-grid-columns-m": "{number.1}",
  "Grid-grid-columns-xs": "{number.px}",
  "Grid-margin-4xl": "{number.24}",
  "Grid-margin-l": "{number.24}",
  "Grid-gutter": "{number.5}",
  "Grid-Sidebar-sidebar-open": 317,
  "Grid-Sidebar-sidebar-close": 158,
  "Grid-Sidebar-sidebar-toolbox": 279,
  "Grid-Container-cont-size": 1563,
  "Grid-Container-cont-size-navclosed": 1762,
  "Grid-Container-cont-size-toolbox": 1664,
  "Grid-Navbar-navbar-size": 1601,
  "Grid-Navbar-navbarclosed-size": 1762,
  "Breakpoints-width-XL": 1440,
  "Breakpoints-width-XXL": 1920
};
export {
  Rg as ACCORDION_CONTEXT_KEY,
  zg as ACCORDION_ITEM_CONTEXT_KEY,
  NU as AccessSettings,
  OU as Accordion,
  PU as AccordionItem,
  vG as AddressInput,
  a0 as AdvancedFilterBody,
  hK as AdvancedFilterBuilder,
  n0 as AdvancedFilterFooter,
  bK as AdvancedFilterPopover,
  yo as Alert,
  wx as AutoComplete,
  xG as AutoCompleteAllResultsModal,
  Jt as Avatar,
  vf as AvatarGroup,
  Sx as AvatarLabel,
  yt as Badge,
  gK as Banner,
  zF as Breadcrumb,
  Be as Button,
  Ri as ButtonGroup,
  O1 as ButtonLink,
  JG as Card,
  XG as CardSelectable,
  va as Checkbox,
  _U as CheckboxForm,
  QU as CheckboxGroup,
  $O as CollapsibleSearch,
  lK as CollapsibleSection,
  cK as ColorPicker,
  dP as CompactPager,
  HG as ConfirmDeleteModal,
  JU as CopyInput,
  bU as CriteriaGroup,
  aK as CtaWidget,
  dH as DATA_TABLE_CELL_FIGMA_TYPE,
  Db as DEFAULT_COUNTRY,
  eo as DEFAULT_PHONE_FORMAT,
  cP as DEFAULT_TABLE_HEADER_LABELS,
  Cs as DEFAULT_TABLE_LABELS,
  UG as DataTable,
  NV as DataTableBody,
  jG as DataTableCaption,
  Li as DataTableCell,
  FV as DataTableContainer,
  WG as DataTableEmpty,
  qG as DataTableFooter,
  t9 as DataTableHead,
  a9 as DataTableHeader,
  Go as DataTableRow,
  a7 as DataTableTypedCell,
  YG as DataTableWrapper,
  dG as DateGroupHeader,
  Ju as DatePickerInput,
  z3 as DateRangePickerInput,
  sr as DatepickerCell,
  f3 as DatepickerControls,
  d3 as DatepickerDobPicker,
  yf as DatepickerDropdownMenu,
  vx as DatepickerPanel,
  vM as DraggableListItem,
  UF as Drawer,
  Ra as Dropdown,
  Xf as DropdownItemButton,
  fa as DropdownListItem,
  Dl as DropdownPanelFooter,
  Bl as DropdownPanelHeader,
  VG as DynamicFormField,
  mf as EditableTitle,
  YD as EmailInput,
  e0 as FILTER_FIELD_SELECT_PANEL_SELECTOR,
  ro as FROZEN_COLUMN_LIMIT,
  w6 as FacetedSearchDrawer,
  YU as FieldGroup,
  Pt as FieldHelper,
  Ft as FieldLabel,
  WW as FieldSkeleton,
  $$ as FileUploadInput,
  Lc as FilterDropdown,
  Px as FilterFieldPicker,
  _q as FilterFieldSelect,
  PP as FilterPill,
  sK as FloatActionBar,
  NG as FormErrorSummary,
  MN as FormSaveButton,
  uK as FormSkeleton,
  aa as IconShape,
  eG as ImageInput,
  bG as ImageUploadInput,
  QG as InlineLink,
  uG as InteractionListItem,
  br as LabelDropdown,
  s5 as ListItem,
  fG as ListItemAccordion,
  hG as ListItemAccordionRow,
  mM as ListItemCard,
  UB as ListItemGroup,
  CG as LookupInput,
  IG as MainDrawer,
  sG as MaskedInput,
  ZG as Masonry,
  cG as MeetingListItem,
  KU as MetricCardAction,
  GU as MetricCardProgress,
  HU as MetricCardSimple,
  qU as MetricCardWithBadge,
  UU as MetricCardWithChart,
  jU as MetricCardWithIcon,
  WU as MetricCardWithTrend,
  dl as Modal,
  um as MultipleSelect,
  OG as NavHeader,
  u8 as NavTabs,
  MG as Navbar,
  ah as NumberInput,
  $x as NumberRangeInput,
  wG as OtpInput,
  bn as PHONE_FORMATS,
  QD as PHONE_FORMATS_BY_DIAL_CODE,
  tP as Pager,
  lG as PasswordInput,
  iG as PhoneDisplay,
  dB as PhoneInput,
  Cx as Popover,
  oK as ProfileCard,
  Dr as ProgressBar,
  KC as RadioButton,
  XU as RadioForm,
  ZU as RadioFormGroup,
  pG as RelationInput,
  nG as RichTextEditor,
  zs as SearchInput,
  BG as SecondarySidebar,
  KN as SegmentedPager,
  yl as SelectInput,
  DG as Sidebar,
  FU as SortDropdown,
  PG as SpeedDial,
  gc as Spinner,
  JF as SplitButton,
  nK as StatsWidget,
  fK as StepperNavigation,
  iK as StepperWizardSidenav,
  uP as TABLE_COLUMN_SETTINGS_KEY,
  Bx as TABLE_LABELS_KEY,
  Dx as TABLE_PERMISSIONS_KEY,
  Hl as TABLE_QUERY_KEY,
  Vr as TABLE_SEARCH_DEBOUNCE_MS,
  Js as TABLE_VIEWS_KEY,
  zP as TableControls,
  NP as TableFilterBar,
  eF as TableFilterSelector,
  zG as TablePanel,
  TG as TableShell,
  jP as TableSkeleton,
  LP as TableTopbar,
  LO as TagInput,
  Qt as TextInput,
  pa as TextLink,
  tG as Textarea,
  yG as TimePickerInput,
  rK as Timeline,
  FG as ToastContainer,
  wV as ToastItem,
  kG as ToggleGroup,
  kO as ToggleInput,
  Un as ToggleSwitch,
  $t as Tooltip,
  it as TruncatedText,
  PV as UnsavedChangesModal,
  mG as UrlInput,
  VU as WeekNavigator,
  eK as WidgetBlock,
  tK as WidgetSection,
  _G as WidgetShell,
  gG as YearMonthPickerInput,
  sm as attachedPartClasses,
  pc as buttonGroupTabId,
  vK as colorsDark,
  mK as colorsLight,
  GG as createPhoneValidator,
  fx as datePatternFromFormat,
  bx as deleteAcrossSeparator,
  XD as digitMaskFromPattern,
  ol as fieldButtonSize,
  cH as formatCellDate,
  Rs as formatCountLabel,
  Lr as formatGroupedDigits,
  _D as formatPhoneForDisplay,
  Uu as groupMaskFromPlaceholder,
  Oo as groupPreservingTrunkZero,
  $f as isDraftGroup,
  Xx as isGroupNode,
  If as isMultiValue,
  Tr as isValueless,
  SG as mapApiPaginated,
  zb as maskGroupedInput,
  hx as maskLiveInput,
  wg as parse,
  yK as semanticBreakpoints,
  pK as semanticSpacing,
  xK as semanticTypography,
  gi as serialize,
  gf as significantDigitCount,
  Bb as stripTrunkZero,
  rG as toE164,
  _x as useAdvancedFilterActions,
  RG as useColumnSettings,
  Kq as useCriteriaBuilder,
  A7 as useDirtyState,
  Dg as useDisclosure,
  LG as useDrawer,
  So as useDropdown,
  dK as useFloatActionBarActions,
  Is as useFocusTrap,
  KG as useForm,
  E7 as useFormSubmit,
  T7 as useFormValidation,
  Ia as useHasSlot,
  mx as useListRowSurface,
  R7 as useMediaQuery,
  AG as useResponsivePageSize,
  Mr as useRovingListbox,
  P1 as useSortable,
  Lo as useTableLabels,
  $G as useTableQuery,
  EG as useTableViews,
  iV as useToast,
  $y as useTruncationDetector,
  oG as withHeuristicTrunkZero
};
